var S4 = Object.defineProperty;
var C4 = (t, e, n) => e in t ? S4(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var je = (t, e, n) => C4(t, typeof e != "symbol" ? e + "" : e, n);
import { createElementBlock as b, openBlock as h, createCommentVNode as E, createElementVNode as k, Fragment as me, renderList as Ee, normalizeClass as se, toDisplayString as ae, createStaticVNode as ri, inject as wn, resolveComponent as ot, createBlock as Z, withCtx as ce, renderSlot as xe, defineAsyncComponent as ge, computed as I, resolveDynamicComponent as ut, defineComponent as Ae, ref as J, normalizeStyle as bn, reactive as La, watch as at, onMounted as ht, unref as O, withModifiers as Ba, createVNode as Q, createTextVNode as Ye, withDirectives as kt, vModelRadio as Nc, vModelText as Wo, mergeProps as $t, vModelCheckbox as Nh, vModelSelect as A4, vShow as ga, createSlots as rn, useTemplateRef as E4, onUnmounted as Xs, resolveDirective as L4, withKeys as $r, watchEffect as Xb, nextTick as Dn, getCurrentInstance as Zb, getCurrentScope as Kb, onScopeDispose as Qb, toRef as As, readonly as D4, customRef as I4, useSlots as nr, isRef as wm, normalizeProps as ln, guardReactiveProps as Un, Teleport as M4, Transition as Fr, h as _r, render as km, onBeforeUpdate as O4, mergeModels as Sm, useModel as P4, provide as ma, cloneVNode as Cm, toRefs as $h, markRaw as Am, useAttrs as B4, onBeforeUnmount as R4 } from "vue";
import { useRoute as $a, useRouter as Ru } from "vue-router";
import { defineStore as N4, mapState as $4, storeToRefs as F4 } from "pinia";
const be = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [a, i] of e)
    n[a] = i;
  return n;
}, z4 = {
  name: "AlphabeticalBrowseBy",
  inject: ["theme"],
  props: {
    selectedLetterProp: {
      type: String,
      default: "All"
    },
    displayAll: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["selectedLetter"],
  data() {
    return {
      alphabet: [
        {
          letter: "All"
        },
        {
          letter: "A"
        },
        {
          letter: "B"
        },
        {
          letter: "C"
        },
        {
          letter: "D"
        },
        {
          letter: "E"
        },
        {
          letter: "F"
        },
        {
          letter: "G"
        },
        {
          letter: "H"
        },
        {
          letter: "I"
        },
        {
          letter: "J"
        },
        {
          letter: "K"
        },
        {
          letter: "L"
        },
        {
          letter: "M"
        },
        {
          letter: "N"
        },
        {
          letter: "O"
        },
        {
          letter: "P"
        },
        {
          letter: "Q"
        },
        {
          letter: "R"
        },
        {
          letter: "S"
        },
        {
          letter: "T"
        },
        {
          letter: "U"
        },
        {
          letter: "V"
        },
        {
          letter: "W"
        },
        {
          letter: "X"
        },
        {
          letter: "Y"
        },
        {
          letter: "Z"
        }
      ],
      selectedLetter: ""
    };
  },
  computed: {
    parsedAlphabet: {
      get() {
        return this.alphabet.filter((t) => t.letter !== "All" || t.letter === "All" && this.displayAll).map((t) => {
          let e = "letter";
          return this.selectedLetterProp === "" && (this.selectedLetter = ""), t.letter === this.selectedLetterProp && this.selectedLetter === "" && (e = `${e} is-selected`), t.letter === this.selectedLetter && (e = `${e} is-selected`), {
            ...t,
            class: e
          };
        });
      },
      set(t) {
        this.alphabet = t;
      }
    }
  },
  methods: {
    checkIfLetterIsSelected() {
      this.parsedAlphabet = this.alphabet.map((t) => {
        let e = "letter";
        return this.selectedLetter === t.letter && (e = `${e} is-selected`), {
          ...t,
          class: e
        };
      });
    },
    handleSelectedLetter(t) {
      this.selectedLetter = t.letter, this.checkIfLetterIsSelected(), this.$emit("selectedLetter", this.selectedLetter);
    }
  }
}, U4 = { class: "alphabetical-browse-by" }, H4 = {
  key: 0,
  class: "title"
}, Y4 = { class: "alphabet-list" }, j4 = ["onClick"];
function V4(t, e, n, a, i, r) {
  return h(), b("div", U4, [
    r.theme === "" ? (h(), b("h2", H4, " Browse by Last Name ")) : E("", !0),
    k("ul", Y4, [
      (h(!0), b(me, null, Ee(r.parsedAlphabet, (s) => (h(), b("li", {
        key: s.letter,
        class: se(s.class),
        onClick: (o) => r.handleSelectedLetter(s)
      }, [
        k("a", null, ae(s.letter), 1)
      ], 10, j4))), 128))
    ])
  ]);
}
const R0e = /* @__PURE__ */ be(z4, [["render", V4], ["__scopeId", "data-v-d0889265"]]);
function qc(t) {
  "@babel/helpers - typeof";
  return qc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qc(t);
}
function Yn(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function q4(t) {
  return Yn(1, arguments), t instanceof Date || qc(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function si(t) {
  Yn(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || qc(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function W4(t) {
  if (Yn(1, arguments), !q4(t) && typeof t != "number")
    return !1;
  var e = si(t);
  return !isNaN(Number(e));
}
function Mr(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function G4(t, e) {
  Yn(2, arguments);
  var n = si(t).getTime(), a = Mr(e);
  return new Date(n + a);
}
function X4(t, e) {
  Yn(2, arguments);
  var n = Mr(e);
  return G4(t, -n);
}
var Z4 = 864e5;
function K4(t) {
  Yn(1, arguments);
  var e = si(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var a = e.getTime(), i = n - a;
  return Math.floor(i / Z4) + 1;
}
function Wc(t) {
  Yn(1, arguments);
  var e = 1, n = si(t), a = n.getUTCDay(), i = (a < e ? 7 : 0) + a - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function Jb(t) {
  Yn(1, arguments);
  var e = si(t), n = e.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = Wc(a), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var s = Wc(r);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Q4(t) {
  Yn(1, arguments);
  var e = Jb(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = Wc(n);
  return a;
}
var J4 = 6048e5;
function e8(t) {
  Yn(1, arguments);
  var e = si(t), n = Wc(e).getTime() - Q4(e).getTime();
  return Math.round(n / J4) + 1;
}
var t8 = {};
function Nu() {
  return t8;
}
function Gc(t, e) {
  var n, a, i, r, s, o, l, c;
  Yn(1, arguments);
  var d = Nu(), f = Mr((n = (a = (i = (r = e == null ? void 0 : e.weekStartsOn) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && a !== void 0 ? a : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = si(t), _ = g.getUTCDay(), x = (_ < f ? 7 : 0) + _ - f;
  return g.setUTCDate(g.getUTCDate() - x), g.setUTCHours(0, 0, 0, 0), g;
}
function e2(t, e) {
  var n, a, i, r, s, o, l, c;
  Yn(1, arguments);
  var d = si(t), f = d.getUTCFullYear(), g = Nu(), _ = Mr((n = (a = (i = (r = e == null ? void 0 : e.firstWeekContainsDate) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : g.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = g.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var x = /* @__PURE__ */ new Date(0);
  x.setUTCFullYear(f + 1, 0, _), x.setUTCHours(0, 0, 0, 0);
  var p = Gc(x, e), w = /* @__PURE__ */ new Date(0);
  w.setUTCFullYear(f, 0, _), w.setUTCHours(0, 0, 0, 0);
  var C = Gc(w, e);
  return d.getTime() >= p.getTime() ? f + 1 : d.getTime() >= C.getTime() ? f : f - 1;
}
function n8(t, e) {
  var n, a, i, r, s, o, l, c;
  Yn(1, arguments);
  var d = Nu(), f = Mr((n = (a = (i = (r = e == null ? void 0 : e.firstWeekContainsDate) !== null && r !== void 0 ? r : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), g = e2(t, e), _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(g, 0, f), _.setUTCHours(0, 0, 0, 0);
  var x = Gc(_, e);
  return x;
}
var a8 = 6048e5;
function i8(t, e) {
  Yn(1, arguments);
  var n = si(t), a = Gc(n, e).getTime() - n8(n, e).getTime();
  return Math.round(a / a8) + 1;
}
function yt(t, e) {
  for (var n = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < e; )
    a = "0" + a;
  return n + a;
}
var Bi = {
  // Year
  y: function(e, n) {
    var a = e.getUTCFullYear(), i = a > 0 ? a : 1 - a;
    return yt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var a = e.getUTCMonth();
    return n === "M" ? String(a + 1) : yt(a + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return yt(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var a = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return yt(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return yt(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return yt(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return yt(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var a = n.length, i = e.getUTCMilliseconds(), r = Math.floor(i * Math.pow(10, a - 3));
    return yt(r, n.length);
  }
}, Kr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, r8 = {
  // Era
  G: function(e, n, a) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, a) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), r = i > 0 ? i : 1 - i;
      return a.ordinalNumber(r, {
        unit: "year"
      });
    }
    return Bi.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, a, i) {
    var r = e2(e, i), s = r > 0 ? r : 1 - r;
    if (n === "YY") {
      var o = s % 100;
      return yt(o, 2);
    }
    return n === "Yo" ? a.ordinalNumber(s, {
      unit: "year"
    }) : yt(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var a = Jb(e);
    return yt(a, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var a = e.getUTCFullYear();
    return yt(a, n.length);
  },
  // Quarter
  Q: function(e, n, a) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return yt(i, 2);
      case "Qo":
        return a.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, a) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return yt(i, 2);
      case "qo":
        return a.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, a) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Bi.M(e, n);
      case "Mo":
        return a.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, a) {
    var i = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return yt(i + 1, 2);
      case "Lo":
        return a.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, a, i) {
    var r = i8(e, i);
    return n === "wo" ? a.ordinalNumber(r, {
      unit: "week"
    }) : yt(r, n.length);
  },
  // ISO week of year
  I: function(e, n, a) {
    var i = e8(e);
    return n === "Io" ? a.ordinalNumber(i, {
      unit: "week"
    }) : yt(i, n.length);
  },
  // Day of the month
  d: function(e, n, a) {
    return n === "do" ? a.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Bi.d(e, n);
  },
  // Day of year
  D: function(e, n, a) {
    var i = K4(e);
    return n === "Do" ? a.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : yt(i, n.length);
  },
  // Day of week
  E: function(e, n, a) {
    var i = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, a, i) {
    var r = e.getUTCDay(), s = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return yt(s, 2);
      case "eo":
        return a.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, a, i) {
    var r = e.getUTCDay(), s = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return yt(s, n.length);
      case "co":
        return a.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, a) {
    var i = e.getUTCDay(), r = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(r);
      case "ii":
        return yt(r, n.length);
      case "io":
        return a.ordinalNumber(r, {
          unit: "day"
        });
      case "iii":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, a) {
    var i = e.getUTCHours(), r = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, a) {
    var i = e.getUTCHours(), r;
    switch (i === 12 ? r = Kr.noon : i === 0 ? r = Kr.midnight : r = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, a) {
    var i = e.getUTCHours(), r;
    switch (i >= 17 ? r = Kr.evening : i >= 12 ? r = Kr.afternoon : i >= 4 ? r = Kr.morning : r = Kr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, a) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), a.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Bi.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, a) {
    return n === "Ho" ? a.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Bi.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, a) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? a.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, a) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? a.ordinalNumber(i, {
      unit: "hour"
    }) : yt(i, n.length);
  },
  // Minute
  m: function(e, n, a) {
    return n === "mo" ? a.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Bi.m(e, n);
  },
  // Second
  s: function(e, n, a) {
    return n === "so" ? a.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Bi.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Bi.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      case "X":
        return Lm(s);
      case "XXXX":
      case "XX":
        return pr(s);
      case "XXXXX":
      case "XXX":
      default:
        return pr(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "x":
        return Lm(s);
      case "xxxx":
      case "xx":
        return pr(s);
      case "xxxxx":
      case "xxx":
      default:
        return pr(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Em(s, ":");
      case "OOOO":
      default:
        return "GMT" + pr(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Em(s, ":");
      case "zzzz":
      default:
        return "GMT" + pr(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, a, i) {
    var r = i._originalDate || e, s = Math.floor(r.getTime() / 1e3);
    return yt(s, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, a, i) {
    var r = i._originalDate || e, s = r.getTime();
    return yt(s, n.length);
  }
};
function Em(t, e) {
  var n = t > 0 ? "-" : "+", a = Math.abs(t), i = Math.floor(a / 60), r = a % 60;
  if (r === 0)
    return n + String(i);
  var s = e;
  return n + String(i) + s + yt(r, 2);
}
function Lm(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + yt(Math.abs(t) / 60, 2);
  }
  return pr(t, e);
}
function pr(t, e) {
  var n = e || "", a = t > 0 ? "-" : "+", i = Math.abs(t), r = yt(Math.floor(i / 60), 2), s = yt(i % 60, 2);
  return a + r + n + s;
}
var Dm = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, t2 = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, s8 = function(e, n) {
  var a = e.match(/(P+)(p+)?/) || [], i = a[1], r = a[2];
  if (!r)
    return Dm(e, n);
  var s;
  switch (i) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", Dm(i, n)).replace("{{time}}", t2(r, n));
}, o8 = {
  p: t2,
  P: s8
};
function l8(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var c8 = ["D", "DD"], u8 = ["YY", "YYYY"];
function d8(t) {
  return c8.indexOf(t) !== -1;
}
function h8(t) {
  return u8.indexOf(t) !== -1;
}
function Im(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var f8 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, p8 = function(e, n, a) {
  var i, r = f8[e];
  return typeof r == "string" ? i = r : n === 1 ? i = r.one : i = r.other.replace("{{count}}", n.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Wd(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, a = t.formats[n] || t.formats[t.defaultWidth];
    return a;
  };
}
var m8 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, g8 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, b8 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, v8 = {
  date: Wd({
    formats: m8,
    defaultWidth: "full"
  }),
  time: Wd({
    formats: g8,
    defaultWidth: "full"
  }),
  dateTime: Wd({
    formats: b8,
    defaultWidth: "full"
  })
}, y8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, _8 = function(e, n, a, i) {
  return y8[e];
};
function Po(t) {
  return function(e, n) {
    var a = n != null && n.context ? String(n.context) : "standalone", i;
    if (a === "formatting" && t.formattingValues) {
      var r = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : r;
      i = t.formattingValues[s] || t.formattingValues[r];
    } else {
      var o = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[l] || t.values[o];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[c];
  };
}
var x8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, T8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, w8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, k8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, S8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, C8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, A8 = function(e, n) {
  var a = Number(e), i = a % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, E8 = {
  ordinalNumber: A8,
  era: Po({
    values: x8,
    defaultWidth: "wide"
  }),
  quarter: Po({
    values: T8,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Po({
    values: w8,
    defaultWidth: "wide"
  }),
  day: Po({
    values: k8,
    defaultWidth: "wide"
  }),
  dayPeriod: Po({
    values: S8,
    defaultWidth: "wide",
    formattingValues: C8,
    defaultFormattingWidth: "wide"
  })
};
function Bo(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.width, i = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], r = e.match(i);
    if (!r)
      return null;
    var s = r[0], o = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? D8(o, function(f) {
      return f.test(s);
    }) : L8(o, function(f) {
      return f.test(s);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var d = e.slice(s.length);
    return {
      value: c,
      rest: d
    };
  };
}
function L8(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function D8(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function I8(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = e.match(t.matchPattern);
    if (!a) return null;
    var i = a[0], r = e.match(t.parsePattern);
    if (!r) return null;
    var s = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var o = e.slice(i.length);
    return {
      value: s,
      rest: o
    };
  };
}
var M8 = /^(\d+)(th|st|nd|rd)?/i, O8 = /\d+/i, P8 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, B8 = {
  any: [/^b/i, /^(a|c)/i]
}, R8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, N8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, F8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, z8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, U8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, H8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Y8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, j8 = {
  ordinalNumber: I8({
    matchPattern: M8,
    parsePattern: O8,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Bo({
    matchPatterns: P8,
    defaultMatchWidth: "wide",
    parsePatterns: B8,
    defaultParseWidth: "any"
  }),
  quarter: Bo({
    matchPatterns: R8,
    defaultMatchWidth: "wide",
    parsePatterns: N8,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Bo({
    matchPatterns: $8,
    defaultMatchWidth: "wide",
    parsePatterns: F8,
    defaultParseWidth: "any"
  }),
  day: Bo({
    matchPatterns: z8,
    defaultMatchWidth: "wide",
    parsePatterns: U8,
    defaultParseWidth: "any"
  }),
  dayPeriod: Bo({
    matchPatterns: H8,
    defaultMatchWidth: "any",
    parsePatterns: Y8,
    defaultParseWidth: "any"
  })
}, V8 = {
  code: "en-US",
  formatDistance: p8,
  formatLong: v8,
  formatRelative: _8,
  localize: E8,
  match: j8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, q8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, W8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, G8 = /^'([^]*?)'?$/, X8 = /''/g, Z8 = /[a-zA-Z]/;
function Nt(t, e, n) {
  var a, i, r, s, o, l, c, d, f, g, _, x, p, w;
  Yn(2, arguments);
  var C = String(e), M = Nu(), A = (a = (i = void 0) !== null && i !== void 0 ? i : M.locale) !== null && a !== void 0 ? a : V8, L = Mr((r = (s = (o = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && o !== void 0 ? o : M.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = M.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(L >= 1 && L <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var D = Mr((f = (g = (_ = (x = void 0) !== null && x !== void 0 ? x : void 0) !== null && _ !== void 0 ? _ : M.weekStartsOn) !== null && g !== void 0 ? g : (p = M.locale) === null || p === void 0 || (w = p.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(D >= 0 && D <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!A.localize)
    throw new RangeError("locale must contain localize property");
  if (!A.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var B = si(t);
  if (!W4(B))
    throw new RangeError("Invalid time value");
  var P = l8(B), z = X4(B, P), W = {
    firstWeekContainsDate: L,
    weekStartsOn: D,
    locale: A,
    _originalDate: B
  }, q = C.match(W8).map(function(V) {
    var re = V[0];
    if (re === "p" || re === "P") {
      var ie = o8[re];
      return ie(V, A.formatLong);
    }
    return V;
  }).join("").match(q8).map(function(V) {
    if (V === "''")
      return "'";
    var re = V[0];
    if (re === "'")
      return K8(V);
    var ie = r8[re];
    if (ie)
      return h8(V) && Im(V, e, String(t)), d8(V) && Im(V, e, String(t)), ie(z, V, A.localize, W);
    if (re.match(Z8))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + re + "`");
    return V;
  }).join("");
  return q;
}
function K8(t) {
  var e = t.match(G8);
  return e ? e[1].replace(X8, "'") : t;
}
const Q8 = {
  width: "225",
  height: "496",
  viewBox: "0 0 225 496",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function J8(t, e) {
  return h(), b("svg", Q8, e[0] || (e[0] = [
    k("g", null, [
      k("path", {
        opacity: "0.25",
        d: "M71.1732 72.8843L243 0.393311V49.8933L105.538 107.886L48.6001 247.893L105.538 387.9L243 445.893V495.393L71.1732 422.902L0 247.893L71.1732 72.8843Z",
        fill: "#F2F2F2"
      })
    ], -1)
  ]));
}
const n2 = { render: J8 }, ew = {
  width: "900",
  height: "300",
  viewBox: "0 0 900 300",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-hatch-lines"
};
function tw(t, e) {
  return h(), b("svg", ew, e[0] || (e[0] = [
    ri('<path d="M144.445 318.242L12.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M160.445 318.242L28.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M176.445 318.242L44.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M192.445 318.242L60.7009 0.182617" stroke="#C099FF" stroke-width="1.5" class="svg__stroke--wayfinder"></path><path d="M208.445 318.242L76.7009 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M224.445 318.242L92.7009 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M240.445 318.242L108.701 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M256.445 318.242L124.701 0.182617" stroke="#C099FF" stroke-width="2" class="svg__stroke--wayfinder"></path><path d="M272.445 318.242L140.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M288.445 318.242L156.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M304.445 318.242L172.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M320.445 318.242L188.701 0.182617" stroke="#C099FF" stroke-width="2.5" class="svg__stroke--wayfinder"></path><path d="M336.445 318.242L204.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M352.445 318.242L220.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M368.445 318.242L236.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M384.445 318.242L252.701 0.182617" stroke="#C099FF" stroke-width="3" class="svg__stroke--wayfinder"></path><path d="M400.445 318.242L268.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M416.445 318.242L284.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M432.445 318.242L300.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M448.445 318.242L316.701 0.182617" stroke="#C099FF" stroke-width="3.5" class="svg__stroke--wayfinder"></path><path d="M464.445 318.242L332.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M480.445 318.242L348.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M496.445 318.242L364.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M512.445 318.242L380.701 0.182617" stroke="#C099FF" stroke-width="4" class="svg__stroke--wayfinder"></path><path d="M528.445 318.242L396.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M544.445 318.242L412.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M560.445 318.242L428.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M576.445 318.242L444.701 0.182617" stroke="#C099FF" stroke-width="4.5" class="svg__stroke--wayfinder"></path><path d="M592.445 318.242L460.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M608.445 318.242L476.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M624.445 318.242L492.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M640.445 318.242L508.701 0.182617" stroke="#C099FF" stroke-width="5" class="svg__stroke--wayfinder"></path><path d="M656.445 318.242L524.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M672.445 318.242L540.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M688.445 318.242L556.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M704.445 318.242L572.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M720.445 318.242L588.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M736.445 318.242L604.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M752.445 318.242L620.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M768.445 318.242L636.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M784.445 318.242L654.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M800.445 318.242L670.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M816.445 318.242L686.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M832.445 318.242L702.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M848.445 318.242L718.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M864.445 318.242L734.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path><path d="M880.445 318.242L750.701 0.182617" stroke="#C099FF" stroke-width="5.5" class="svg__stroke--wayfinder"></path>', 47)
  ]));
}
const a2 = { render: tw }, nw = {
  width: "42",
  height: "100",
  viewBox: "0 0 42 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-category-slash"
};
function i2(t, e) {
  return h(), b("svg", nw, e[0] || (e[0] = [
    k("path", {
      d: "M40.8666 1L20.4532 51.5248L7.48442 83.6237L1.00001 99.6732",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const r2 = { render: i2 }, s2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r2,
  render: i2
}, Symbol.toStringTag, { value: "Module" }));
function Ge() {
  return wn("theme");
}
function Fh(t = "") {
  let e = !1;
  return (t == null || String(t).indexOf("/") === 0 || !t.includes(".") && t.length !== 0) && (e = !0), e;
}
const aw = ["1", "_blank", "blank"], iw = ["", null];
function o2(t = "", e = "") {
  let n = "";
  return aw.includes(t) || iw.includes(t) && !Fh(e) ? n = "_blank" : n = "", n;
}
function rw(t = "") {
  let e = !1;
  switch (!0) {
    case String(t).indexOf("/") === 0:
      e = !0;
      break;
  }
  return e;
}
const sw = {
  name: "SmartLink",
  props: {
    to: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: ""
    },
    isDownload: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    parsedTarget() {
      return o2(this.linkTarget, this.to);
    },
    isRelative() {
      return !!rw(this.to);
    },
    parsedTo() {
      return this.isRelative && !this.isDownload && !this.parsedTarget ? this.to !== "/" && !this.to.endsWith("/") && !this.to.includes("q=") && !this.to.includes("&filters=") ? `${this.to}/` : this.to : this.to;
    }
  }
}, ow = ["href"], lw = ["href", "target"], cw = {
  key: 3,
  class: "smart-link is-link"
};
function uw(t, e, n, a, i, r) {
  const s = ot("router-link");
  return r.isRelative && !n.isDownload && !r.parsedTarget ? (h(), Z(s, {
    key: 0,
    class: "smart-link is-router-link",
    to: r.parsedTo
  }, {
    default: ce(() => [
      xe(t.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["to"])) : n.isDownload ? (h(), b("a", {
    key: 1,
    href: n.to,
    class: "smart-link is-link",
    download: ""
  }, [
    xe(t.$slots, "default", {}, void 0, !0)
  ], 8, ow)) : n.to ? (h(), b("a", {
    key: 2,
    href: n.to,
    target: r.parsedTarget,
    class: "smart-link is-link"
  }, [
    xe(t.$slots, "default", {}, void 0, !0)
  ], 8, lw)) : (h(), b("button", cw, [
    xe(t.$slots, "default", {}, void 0, !0)
  ]));
}
const Ke = /* @__PURE__ */ be(sw, [["render", uw], ["__scopeId", "data-v-7181ea4e"]]), dw = { class: "label" }, hw = { class: "hover" }, fw = { class: "label" }, pw = {
  __name: "ButtonLink",
  props: {
    to: {
      type: String,
      default: ""
    },
    /**
     * Determines what text the button should have.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Determines what icon should be used in button.
     * Do not include this prop if it is an internal link.
     */
    iconName: {
      type: String,
      default: ""
    },
    isSecondary: {
      type: Boolean,
      default: !1
    },
    isTertiary: {
      type: Boolean,
      default: !1
    },
    isQuaternary: {
      type: Boolean,
      default: !1
    },
    isDownload: {
      type: Boolean,
      default: !1
    },
    linkTarget: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ge(
      () => Promise.resolve().then(() => q2)
    ), a = ge(
      () => Promise.resolve().then(() => qM)
    ), i = ge(
      () => import("./icon-download-Dp9VXiET.js")
    ), r = ge(
      () => Promise.resolve().then(() => d2)
    ), s = Ge(), o = I(() => [
      "button-link",
      (s == null ? void 0 : s.value) || "",
      e.isSecondary ? "is-secondary" : e.isTertiary ? "is-tertiary" : e.isQuaternary ? "is-quaternary" : ""
    ]), l = I(() => {
      switch (!0) {
        case e.isDownload:
          return i;
        case e.iconName === "none":
          return "";
        case Fh(e.to):
          return a;
        case (e.linkTarget === "_blank" || e.iconName === "svg-external-link"):
          return n;
        case e.iconName === "icon-close":
          return r;
        default:
          return n;
      }
    });
    return (c, d) => (h(), Z(Ke, {
      to: t.to,
      class: se(o.value),
      "is-download": t.isDownload,
      "link-target": t.linkTarget
    }, {
      default: ce(() => [
        k("span", dw, ae(t.label), 1),
        xe(c.$slots, "default", {}, void 0, !0),
        l.value !== "" ? (h(), Z(ut(l.value), {
          key: 0,
          class: "arrow",
          "aria-hidden": "true"
        })) : E("", !0),
        k("div", hw, [
          k("span", fw, ae(t.label), 1),
          l.value !== "" ? (h(), Z(ut(l.value), {
            key: 0,
            class: "arrow",
            "aria-hidden": "true"
          })) : E("", !0)
        ])
      ]),
      _: 3
    }, 8, ["to", "class", "is-download", "link-target"]));
  }
}, cn = /* @__PURE__ */ be(pw, [["__scopeId", "data-v-f4120164"]]), Dl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cn
}, Symbol.toStringTag, { value: "Module" })), mw = {
  name: "IconWithLink",
  components: {
    SmartLink: Ke,
    SvgIconConsultation: ge(
      () => import("./icon-chat-DCvwPwHu.js")
    ),
    SvgIconList: ge(
      () => Promise.resolve().then(() => Lx)
    ),
    SvgIconLocation: ge(
      () => import("./icon-location-DNog__Cl.js")
    ),
    SvgIconPhone: ge(
      () => import("./icon-phone-DPv-PoqA.js")
    ),
    SvgIconSearch: ge(
      () => Promise.resolve().then(() => Nce)
    ),
    SvgIconVirtual: ge(
      () => import("./icon-virtual-CwZieS3s.js")
    ),
    SvgIconHeadphones: ge(
      () => import("./icon-headphones-Vk0iXmnu.js")
    ),
    SvgIconVideo: ge(
      () => import("./icon-video-Tda9BGRR.js")
    ),
    SvgIconImageStack: ge(
      () => Promise.resolve().then(() => gQ)
    ),
    SvgIconMoney: ge(
      () => import("./icon-money-BxPRObPA.js")
    ),
    SvgIconMessage: ge(
      () => import("./icon-message-CyHSPUb-.js")
    ),
    SvgIconPlay: ge(
      () => import("./icon-play-BaMxYNFG.js")
    ),
    SvgIconPlayFilled: ge(
      () => import("./icon-play-filled-Dvcf_yQh.js")
    ),
    SvgIconEye: ge(
      () => import("./icon-eye-L7brvvQ3.js")
    ),
    SvgIconCheck: ge(
      () => import("./icon-check-CKGDA7ua.js")
    ),
    SvgIconEmail: ge(
      () => import("./icon-email-d9JGcdKa.js")
    ),
    SvgIconCard: ge(
      () => Promise.resolve().then(() => Que)
    ),
    SvgIconCalendar: ge(
      () => Promise.resolve().then(() => Mp)
    ),
    SvgIconLaptop: ge(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ),
    SvgIconBook: ge(
      () => import("./icon-book-Dhs3bbZ0.js")
    ),
    SvgIconLocker: ge(
      () => import("./icon-locker-BBQPsbYg.js")
    ),
    SvgIconPerson: ge(
      () => import("./icon-person-BPUoRkt6.js")
    ),
    SvgIconAccessible: ge(
      () => import("./icon-accessible-C8Gup1rK.js")
    ),
    SvgIconClock: ge(
      () => import("./icon-clock-CG3EE-5W.js")
    ),
    SvgIconChair: ge(
      () => import("./icon-chair-D8fW8Dnx.js")
    ),
    SvgIconLight: ge(
      () => import("./icon-light-wkkuRssP.js")
    ),
    SvgIconLocationFilled: ge(
      () => import("./icon-location-filled-Cyf_QfPI.js")
    ),
    SvgIconAlert: ge(
      () => Promise.resolve().then(() => e0e)
    ),
    SvgIconShareEmail: ge(
      () => import("./icon-share-email-ds0LMlnf.js")
    ),
    SvgIconSharePrinter: ge(
      () => Promise.resolve().then(() => w2)
    ),
    SvgIconShareFacebook: ge(
      () => import("./icon-share-facebook-jNsnyfWc.js")
    ),
    SvgIconShareInstagram: ge(
      () => import("./icon-share-instagram-CHpDcj4d.js")
    ),
    SvgIconShareLinkedin: ge(
      () => import("./icon-share-linkedin-D_WCf0Fz.js")
    ),
    SvgIconShareTwitter: ge(
      () => import("./icon-share-twitter-CS2kovPG.js")
    ),
    SvgIconShareWhatsapp: ge(
      () => import("./icon-share-whatsapp-B2hhPPEt.js")
    ),
    // FTVA Icons
    SvgIconFtvaAppleinc: ge(
      () => import("./icon-ftva-appleinc-D6O1BYI_.js")
    ),
    SvgIconFtvaDownload: ge(
      () => import("./icon-ftva-download-CfgJu8GR.js")
    ),
    SvgIconFtvaEmail: ge(
      () => import("./icon-ftva-email-BVoSQQla.js")
    ),
    SvgIconFtvaGcal: ge(
      () => import("./icon-ftva-gcal-C7UpU-sa.js")
    ),
    SvgIconFtvaHours: ge(
      () => import("./icon-ftva-hours-C6XjS6oB.js")
    ),
    SvgIconFtvaLocationOutline: ge(
      () => import("./icon-ftva-location-outline--K6kAmAp.js")
    ),
    SvgIconFtvaOutlook: ge(
      () => import("./icon-ftva-outlook-D01ntAYf.js")
    ),
    SvgIconFtvaPhone: ge(
      () => import("./icon-ftva-phone-CwJ6dpNs.js")
    ),
    SvgIconFtvaShare: ge(
      () => Promise.resolve().then(() => AB)
    ),
    SvgIconFtvaSocialConfirm: ge(
      () => Promise.resolve().then(() => LB)
    ),
    SvgIconFtvaSocialEmail: ge(
      () => import("./icon-ftva-social_email-C1L_bljr.js")
    ),
    SvgIconFtvaSocialFacebook: ge(
      () => import("./icon-ftva-social_facebook-BgnF7yg7.js")
    ),
    SvgIconFtvaSocialLink: ge(
      () => import("./icon-ftva-social_link-BZIDORpF.js")
    ),
    SvgIconFtvaSocialX: ge(
      () => import("./icon-ftva-social_x-7x5Xoj9-.js")
    )
  },
  props: {
    text: {
      type: String,
      required: !0
    },
    iconName: {
      type: String,
      required: !0
    },
    to: {
      // URL to link to
      type: String,
      default: ""
    }
  }
}, gw = { class: "icon-with-link" }, bw = ["textContent"], vw = {
  key: 1,
  class: "icon-with-link-container"
}, yw = ["textContent"];
function _w(t, e, n, a, i, r) {
  const s = ot("SmartLink");
  return h(), b("div", gw, [
    n.to ? (h(), Z(s, {
      key: 0,
      to: n.to,
      class: "icon-with-link-container link"
    }, {
      default: ce(() => [
        (h(), Z(ut(n.iconName), {
          class: "icon",
          "aria-hidden": "true"
        })),
        k("div", {
          class: "text",
          textContent: ae(n.text)
        }, null, 8, bw)
      ]),
      _: 1
    }, 8, ["to"])) : (h(), b("div", vw, [
      (h(), Z(ut(n.iconName), {
        class: "icon",
        "aria-hidden": "true"
      })),
      k("div", {
        class: "text",
        textContent: ae(n.text)
      }, null, 8, yw)
    ]))
  ]);
}
const en = /* @__PURE__ */ be(mw, [["render", _w], ["__scopeId", "data-v-569e4c2f"]]), l2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: en
}, Symbol.toStringTag, { value: "Module" }));
function xw(t = "") {
  return t == null ? t : t.includes("https://test-craft.library.ucla.edu") ? t.replaceAll("https://test-craft.library.ucla.edu", "") : t.includes("https://stage-craft.library.ucla.edu") ? t.replaceAll("https://stage-craft.library.ucla.edu", "") : t.replaceAll("https://craft.library.ucla.edu", "");
}
function Tw(t = "") {
  if (t == null)
    return t;
  const e = /<a\s+(?:[^>]*?\s+)?target=(["_blank'])(.*?)\1*>(.*?)<\/a>/g;
  return t.replace(e, (n) => `${n.replace("</a>", "")}<span class="visually-hidden">(opens in a new tab)</span></a>`);
}
const ww = ["innerHTML"], kw = /* @__PURE__ */ Ae({
  __name: "RichText",
  props: {
    richTextContent: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = Ge(), a = I(() => ["rich-text", (n == null ? void 0 : n.value) || ""]), i = I(() => {
      const r = xw(e.richTextContent);
      return Tw(r);
    });
    return (r, s) => (h(), b("div", {
      class: se(a.value)
    }, [
      k("div", {
        class: "parsed-content",
        innerHTML: i.value
      }, null, 8, ww),
      xe(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), un = /* @__PURE__ */ be(kw, [["__scopeId", "data-v-04307b17"]]), c2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: un
}, Symbol.toStringTag, { value: "Module" })), Sw = ["src", "height", "width", "alt", "srcset", "sizes", "object-fit"], Cw = ["innerHTML"], Aw = {
  key: 1,
  class: "toptext"
}, Ew = { class: "image-top-text" }, Lw = {
  key: 2,
  class: "credit"
}, Dw = { class: "credit-text" }, Iw = /* @__PURE__ */ Ae({
  __name: "ResponsiveImage",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    src: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    alt: {
      type: String,
      default: ""
    },
    srcset: {
      type: String,
      default: ""
    },
    sizes: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    objectFit: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = J(!1), a = J(!1);
    function i() {
      n.value = !0;
    }
    function r() {
      a.value = !0;
    }
    const s = I(() => {
      let d = "";
      return e.media.focalPoint && e.media.focalPoint.length > 0 && (d = `object-position:${e.media.focalPoint.map((g) => `${g * 100}%`).join(" ")}`), d;
    }), o = I(() => {
      const d = e.media.height || e.height, f = e.media.width || e.width;
      return e.aspectRatio || d / f * 100;
    }), l = I(() => ({
      paddingBottom: `${o.value}%`
    })), c = I(() => [
      "responsive-image",
      `object-fit-${e.objectFit}`,
      { "has-loaded": n },
      { "has-errored": a }
    ]);
    return (d, f) => e.media && e.media.src ? (h(), b("figure", {
      key: 0,
      class: se(c.value)
    }, [
      k("img", {
        src: e.media.src || e.src,
        height: e.media.width || e.width,
        width: e.media.height || e.height,
        alt: e.media.alt || e.alt,
        srcset: e.media.srcset || e.srcset,
        sizes: e.media.sizes || e.sizes,
        "object-fit": e.objectFit,
        style: bn(s.value),
        class: "media",
        onLoad: i,
        onError: r
      }, null, 44, Sw),
      e.media.caption || e.caption ? (h(), b("figcaption", {
        key: 0,
        class: "caption",
        innerHTML: e.media.caption || e.caption
      }, null, 8, Cw)) : E("", !0),
      k("div", {
        class: "sizer",
        style: bn(l.value)
      }, null, 4),
      xe(d.$slots, "default", {}, void 0, !0),
      d.$slots.toptext ? (h(), b("div", Aw, [
        k("div", Ew, [
          xe(d.$slots, "toptext", {}, void 0, !0)
        ])
      ])) : E("", !0),
      d.$slots.credit ? (h(), b("div", Lw, [
        k("div", Dw, [
          xe(d.$slots, "credit", {}, void 0, !0)
        ])
      ])) : E("", !0)
    ], 2)) : E("", !0);
  }
}), dn = /* @__PURE__ */ be(Iw, [["__scopeId", "data-v-0cc7cdea"]]), Mw = ["src", "alt", "controls", "autoplay", "muted", "loop", "playsinline"], Ow = /* @__PURE__ */ Ae({
  __name: "ResponsiveVideo",
  props: {
    media: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "intrinsic-ratio"
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    objectFit: {
      type: String,
      default: "cover"
    },
    playsinline: {
      type: Boolean,
      default: !0
    },
    autoplay: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !1
    },
    muted: {
      type: Boolean,
      default: !0
    },
    controls: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["ended", "error", "error-image", "error-video", "loaded", "loaded-image", "loaded-video", "playing"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J(null), r = La({
      video: !1
    }), s = J({
      video: !1
    }), o = I(() => Object.values(s.value).includes(!0)), l = I(() => Object.values(r).every(Boolean)), c = I(() => n.media.src), d = I(() => {
      const P = n.media.height;
      return P && typeof P == "string" ? Number.parseInt(P) : P;
    }), f = I(() => {
      const P = n.media.width;
      return P && typeof P == "string" ? Number.parseInt(P) : P;
    }), g = I(() => {
      let P = "landscape";
      switch (!0) {
        case d.value > f.value:
          P = "portrait";
          break;
        case d.value === f.value:
          P = "square";
          break;
      }
      return P;
    }), _ = I(() => [
      "responsive-video",
      `mode-${n.mode}`,
      { "has-loaded": l.value },
      { "has-error": o.value },
      { "has-video-error": s.value.video },
      `is-orientation-${g.value}`,
      `object-fit-${n.objectFit}`
    ]), x = I(() => {
      let P = n.aspectRatio || d.value / f.value * 100;
      return P || (P = 0), P;
    }), p = I(() => n.media.focalPoint.length > 0 ? {
      x: n.media.focalPoint[0],
      y: n.media.focalPoint[1]
    } : {
      x: "0.5",
      y: "0.5"
    }), w = I(() => n.media.alt), C = I(() => {
      const P = {};
      return n.mode === "intrinsic-ratio" && (P.paddingBottom = `${x.value}%`), P;
    }), M = I(() => {
      const P = {};
      return p.value.x !== "" && p.value.y !== "" && (P.objectPosition = `${p.value.x}% ${p.value.y}%`), P;
    });
    at(c, (P) => {
      P && (r.video = !1, s.value.video = !1);
    }), ht(() => {
      c.value && (r.video = i.value.readyState >= 3);
    });
    function A(P) {
      r[P] = !0, a("loaded", P), a(`loaded-${P}`);
    }
    function L(P) {
      s.value[P] = !0, a("error", P), a(`error-${P}`);
    }
    function D(P) {
      a("ended", P);
    }
    function B() {
      a("playing");
    }
    return (P, z) => (h(), b("figure", {
      class: se(_.value)
    }, [
      c.value ? (h(), b("video", {
        key: 0,
        ref_key: "videoRef",
        ref: i,
        class: "media media-video",
        src: c.value,
        alt: w.value,
        style: bn(M.value),
        controls: t.controls,
        autoplay: t.autoplay,
        muted: t.muted,
        loop: t.loop,
        playsinline: t.playsinline,
        onLoadeddata: z[0] || (z[0] = (W) => A("video")),
        onError: z[1] || (z[1] = (W) => L("video")),
        onEnded: D,
        onPlaying: B
      }, null, 44, Mw)) : E("", !0),
      k("div", {
        class: "sizer",
        style: bn(C.value)
      }, null, 4),
      z[2] || (z[2] = k("div", { class: "background-color" }, null, -1)),
      xe(P.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), zh = /* @__PURE__ */ be(Ow, [["__scopeId", "data-v-b6bc161d"]]), Pw = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-close"
};
function u2(t, e) {
  return h(), b("svg", Pw, e[0] || (e[0] = [
    k("circle", {
      cx: "16",
      cy: "15.8645",
      r: "12",
      fill: "#F2F2F2",
      class: "svg__fill--secondary-grey-01"
    }, null, -1),
    k("path", {
      d: "M22 21.8088 10 9.91943",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m10.0497 21.8645 11.9017-12",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Or = { render: u2 }, d2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Or,
  render: u2
}, Symbol.toStringTag, { value: "Module" })), Bw = {
  key: 0,
  class: "success-message"
}, Rw = {
  key: 1,
  id: "app",
  method: "post",
  class: "form"
}, Nw = { class: "formTitleWrapper" }, $w = {
  key: 0,
  class: "form-errors"
}, Fw = { key: 1 }, zw = {
  key: 2,
  class: "input-wrapper input-radio"
}, Uw = { for: "in-person" }, Hw = { for: "online" }, Yw = { class: "input-wrapper" }, jw = { class: "input-container" }, Vw = {
  key: 3,
  class: "input-wrapper"
}, qw = { for: "email" }, Ww = { key: 0 }, Gw = { key: 1 }, Xw = ["required"], Zw = ["for"], Kw = {
  key: 0,
  class: "required"
}, Qw = {
  key: 1,
  class: "textareaWrapper"
}, Jw = ["for"], ek = {
  key: 0,
  class: "required"
}, tk = ["onUpdate:modelValue"], nk = {
  key: 2,
  class: "radio-wrapper"
}, ak = ["for"], ik = ["id", "onUpdate:modelValue", "value", "name"], rk = {
  key: 3,
  class: "checkbox-wrapper"
}, sk = ["id", "onUpdate:modelValue", "true-value", "value"], ok = ["for"], lk = ["id", "onUpdate:modelValue", "name"], ck = ["value"], uk = {
  __name: "BlockForm",
  setup(t) {
    const e = ge(() => Promise.resolve().then(() => Dl)), n = wn("eventId"), a = wn("blockFormData"), i = wn("registrationType"), r = wn("libcalWaitlist"), s = wn("libcalEndpoint");
    console.log("BlockForm eventId", n.value), console.log("BlockForm blockFormData", a.value), console.log("BlockForm registrationType", i.value), console.log("BlockForm libcalWaitlist", r.value), console.log("BlockForm libcalEndpoint", s);
    const o = J([]), l = J(""), c = J(""), d = J(""), f = J({}), g = J({}), _ = J(null), x = J(!1), p = J(!1), w = J({}), C = J(!1), M = J(""), A = I(() => a.value.questions ? a.value.questions.map((W) => (W.type === "string" || W.type === "radio" || W.type === "dropdown" ? g.value[W.id] = "" : g.value[W.id] = [], f.value[W.id] = W.required, {
      ...W,
      classes: `input-${W.type}`
    })) : []);
    function L() {
      console.log("registrationTypeInput", M.value, i.value && i === "both");
      const W = {
        form: {
          first_name: l.value,
          last_name: c.value,
          email: d.value,
          questions: []
        },
        registration_type: i && i.value !== "both" && i.value !== "" ? i.value : i.value && i.value === "both" ? M.value : "",
        is_waitlist: r.value && r.value !== "" ? r.value : "0"
      };
      W.form.questions = a.value.questions.map((V) => ({
        id: V.id,
        answer: g.value[V.id]
      })), console.log("data submitting", JSON.stringify(W));
      let q = "";
      console.log("eventId", n), s ? q = `${s}api/1.1/events/${n.value}/register` : q = `${process.env.VUE_APP_CALENDAR_LIBRARY_URL}${n}/register`, fetch(q, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: JSON.stringify(W)
      }).then(() => {
        p.value = !0, w.value = {
          code: "success",
          text: "One seat is sent to LibCal to be registered or will be on wait list"
        };
      }).catch((V) => {
        console.error(V), p.value = !0, w.value = {
          code: "error",
          text: V
        };
      });
    }
    function D() {
      let W = !1, q = !1, V = !1;
      l.value && c.value && (W = !0), a.value.emailMethod.status === "required" && d.value && (q = !0), i && i.value === "both" && M.value === "" ? V = !1 : (i && i.value, V = !0), o.value = [], W || o.value.push("Full Name 1 required."), q || o.value.push("Email 2 required."), V || o.value.push("Registration Type 3 required.");
      for (const re of a.value.questions)
        f.value[re.id] && !g.value[re.id] ? re.type === "string" ? o.value.push(
          `${a.value.questions.label} 4a required.`
        ) : o.value.push(`${re.label} 4b required.`) : f.value[re.id] && re.type === "checkbox" && g.value[re.id].length === 0 && o.value.push(`${re.label} 4c required.`);
      o.value.length === 0 ? L() : window.scrollTo(0, 0);
    }
    function B() {
      C.value = !0;
    }
    function P() {
      C.value = !1;
    }
    function z() {
      clearTimeout(_.value), x.value = !1, C.value = !1;
    }
    return at(w, () => {
      x.value = !0, _.value = setTimeout(z, 113e3);
    }), (W, q) => C.value ? (h(), b("div", {
      key: 1,
      class: se(["block-form", {
        "form-error": o.value.length,
        "form-success": x.value
      }])
    }, [
      x.value ? (h(), b("div", Bw, [
        q[8] || (q[8] = k("h3", null, "Registration complete", -1)),
        q[9] || (q[9] = k("p", null, "Please check your email to view your booking.", -1)),
        k("button", {
          type: "button",
          class: "notification--remove",
          onClick: q[1] || (q[1] = (V) => z())
        }, [
          Q(O(Or), { class: "svg-glyph-close" })
        ])
      ])) : (h(), b("form", Rw, [
        k("div", Nw, [
          q[10] || (q[10] = k("h3", { class: "formTitle" }, " Registration ", -1)),
          k("button", {
            type: "button",
            onClick: q[2] || (q[2] = (V) => P())
          }, [
            Q(O(Or), { class: "svg-glyph-close" })
          ])
        ]),
        o.value.length ? (h(), b("div", $w, q[11] || (q[11] = [
          k("p", null, " Please complete the required fields to complete registration ", -1)
        ]))) : E("", !0),
        o.value.length ? (h(), b("br", Fw)) : E("", !0),
        q[18] || (q[18] = k("div", { class: "registrationInfo" }, [
          k("p", null, "Registration is required for this event.")
        ], -1)),
        O(i) === "both" ? (h(), b("div", zw, [
          q[14] || (q[14] = k("legend", null, [
            Ye(" Registration Type "),
            k("span", { class: "required" }, "(required)")
          ], -1)),
          k("label", Uw, [
            kt(k("input", {
              id: "in-person",
              "onUpdate:modelValue": q[3] || (q[3] = (V) => M.value = V),
              type: "radio",
              value: "in-person",
              required: ""
            }, null, 512), [
              [Nc, M.value]
            ]),
            q[12] || (q[12] = Ye("in-person"))
          ]),
          k("label", Hw, [
            kt(k("input", {
              id: "online",
              "onUpdate:modelValue": q[4] || (q[4] = (V) => M.value = V),
              type: "radio",
              value: "online"
            }, null, 512), [
              [Nc, M.value]
            ]),
            q[13] || (q[13] = Ye(" online"))
          ])
        ])) : E("", !0),
        k("div", Yw, [
          q[15] || (q[15] = k("label", null, [
            Ye("Full Name "),
            k("span", { class: "required" }, "(required)")
          ], -1)),
          k("div", jw, [
            kt(k("input", {
              id: "firstName",
              "onUpdate:modelValue": q[5] || (q[5] = (V) => l.value = V),
              type: "text",
              name: "firstName",
              required: "",
              placeholder: "First Name"
            }, null, 512), [
              [Wo, l.value]
            ]),
            kt(k("input", {
              id: "lastName",
              "onUpdate:modelValue": q[6] || (q[6] = (V) => c.value = V),
              type: "text",
              name: "lastName",
              required: "",
              placeholder: "Last Name"
            }, null, 512), [
              [Wo, c.value]
            ])
          ])
        ]),
        O(a).emailMethod ? (h(), b("div", Vw, [
          k("label", qw, [
            O(a).emailMethod.status === "required" ? (h(), b("span", Ww, q[16] || (q[16] = [
              Ye(" Email "),
              k("span", { class: "required" }, "(required)", -1)
            ]))) : (h(), b("span", Gw, "Email"))
          ]),
          kt(k("input", $t({
            id: "email",
            "onUpdate:modelValue": q[7] || (q[7] = (V) => d.value = V),
            type: "email",
            name: "email",
            required: O(a).emailMethod.status
          }, {}), null, 16, Xw), [
            [Wo, d.value]
          ])
        ])) : E("", !0),
        (h(!0), b(me, null, Ee(A.value, (V) => (h(), b("div", {
          key: V.id,
          class: "input-wrapper parsedQuestionsLabelWrapper"
        }, [
          V.type !== "string" ? (h(), b("label", {
            key: 0,
            for: V.id,
            class: se(V.required ? "questionRequired" : "")
          }, [
            Ye(ae(V.label) + " ", 1),
            V.required ? (h(), b("span", Kw, " (required) ")) : E("", !0)
          ], 10, Zw)) : E("", !0),
          V.type === "string" ? (h(), b("div", Qw, [
            k("label", {
              for: V.id,
              class: se(V.required ? "questionRequired" : "")
            }, [
              Ye(ae(V.label) + " ", 1),
              V.required ? (h(), b("span", ek, "(required)")) : E("", !0)
            ], 10, Jw),
            kt(k("textarea", {
              "onUpdate:modelValue": (re) => g.value[V.id] = re,
              placeholder: "Add multiple lines"
            }, null, 8, tk), [
              [Wo, g.value[V.id]]
            ])
          ])) : E("", !0),
          V.type === "radio" ? (h(), b("div", nk, [
            (h(!0), b(me, null, Ee(V.options, (re, ie) => (h(), b("div", {
              key: ie,
              class: "radioWrapper"
            }, [
              k("label", { for: re }, [
                kt(k("input", {
                  id: re,
                  "onUpdate:modelValue": (K) => g.value[V.id] = K,
                  type: "radio",
                  value: re,
                  name: V.id
                }, null, 8, ik), [
                  [Nc, g.value[V.id]]
                ]),
                Ye(" " + ae(re), 1)
              ], 8, ak)
            ]))), 128))
          ])) : E("", !0),
          V.type === "checkbox" ? (h(), b("div", rk, [
            (h(!0), b(me, null, Ee(V.options, (re, ie) => (h(), b("div", {
              key: ie,
              class: "checkboxWrapper"
            }, [
              kt(k("input", {
                id: re,
                "onUpdate:modelValue": (K) => g.value[V.id] = K,
                type: "checkbox",
                "true-value": re,
                value: re
              }, null, 8, sk), [
                [Nh, g.value[V.id]]
              ]),
              k("label", { for: re }, ae(re), 9, ok)
            ]))), 128))
          ])) : E("", !0),
          V.type === "dropdown" ? kt((h(), b("select", {
            key: 4,
            id: V.id,
            "onUpdate:modelValue": (re) => g.value[V.id] = re,
            name: V.id,
            class: se(["input-dropdown", V.classes])
          }, [
            q[17] || (q[17] = k("option", {
              disabled: "",
              value: ""
            }, " Please select one ", -1)),
            (h(!0), b(me, null, Ee(V.options, (re, ie) => (h(), b("option", {
              key: ie,
              value: re
            }, ae(re), 9, ck))), 128))
          ], 10, lk)), [
            [A4, g.value[V.id]]
          ]) : E("", !0)
        ]))), 128)),
        Q(O(e), {
          type: "submit",
          label: "Register",
          "icon-name": "none",
          "is-secondary": !0,
          onClick: Ba(D, ["prevent"])
        })
      ]))
    ], 2)) : (h(), Z(O(e), {
      key: 0,
      label: "Register",
      "icon-name": "none",
      "is-secondary": !0,
      class: "register-button",
      onClick: q[0] || (q[0] = Ba((V) => B(), ["prevent"]))
    }));
  }
}, Uh = /* @__PURE__ */ be(uk, [["__scopeId", "data-v-a5726d35"]]);
function Wi(t = "", e = "") {
  const n = Nt(new Date(t), "h:mm aaa"), a = Nt(new Date(e), "h:mm aaa");
  let i = `${n} - ${a}`;
  return n === a && (i = Nt(new Date(t), "h:mm aaa")), e || (i = n), i;
}
function Da(t = "", e = "", n = "long") {
  const a = Nt(new Date(t), "MMMM d, Y"), i = Nt(new Date(e), "MMMM d, Y");
  let r = `${a} - ${i}`;
  if (a === i && (r = Nt(new Date(t), "MMMM d, Y")), e || (r = a), n === "short" || n === "shortWithYear") {
    const s = r.slice(0, 3), o = r.split(" ").slice(1).join(" ");
    if (e && e !== t) {
      const l = Nt(new Date(t), "MMM d"), c = Nt(new Date(e), "MMM d");
      if (n === "shortWithYear") {
        const d = Nt(new Date(e), "MMM d, Y");
        return `${l} - ${d}`;
      }
      return `${l} - ${c}`;
    }
    return `${s} ${o}`;
  }
  return r;
}
function ha(t = "") {
  let e = "default";
  if (t == null)
    return e;
  switch (!0) {
    case t.includes("/help/"):
    case t.includes("/projects/"):
      e = "help";
      break;
    case t.includes("/about/"):
    case t.includes("/impact/"):
    case t.includes("/applicants/"):
      e = "about";
      break;
    case t.includes("/visit/"):
    case t.includes("/events-exhibits/"):
    case t.includes("/who-we-are/"):
      e = "visit";
      break;
  }
  return e;
}
function Hh(t = "") {
  return t === null || t.match(/^(http|https):\/\//) || t.startsWith("/") || (t = `/${t}`), t;
}
const dk = { class: "slot" }, hk = {
  key: 0,
  class: "breadcrumb"
}, fk = { class: "text" }, pk = {
  key: 0,
  class: "gradient"
}, mk = { class: "hatch-box" }, gk = { class: "clipped-box" }, bk = ["innerHTML"], vk = { class: "hatch" }, yk = { class: "meta" }, _k = ["innerHTML"], xk = { key: 1 }, Tk = { key: 2 }, wk = ["innerHTML"], kk = { class: "meta-text" }, Sk = {
  key: 0,
  class: "date-created"
}, Ck = ["innerHTML"], Ak = {
  key: 1,
  class: "byline"
}, Ek = ["innerHTML"], Lk = {
  key: 3,
  class: "schedule"
}, Dk = ["innerHTML"], Ik = ["innerHTML"], Mk = {
  key: 4,
  class: "location-group"
}, Ok = {
  key: 0,
  class: "block-form-container"
}, Pk = /* @__PURE__ */ Ae({
  __name: "BannerFeatured",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    dateCreated: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    byline: {
      type: Array,
      default: () => []
    },
    to: {
      // URL to link to, if blank won't link
      type: String,
      default: ""
    },
    breadcrumb: {
      type: String,
      default: ""
    },
    prompt: {
      // text that displays on blue button, e.g. "View exhibit". Links to `props.to`
      type: String,
      default: ""
    },
    alignRight: {
      type: Boolean,
      default: !0
    },
    ratio: {
      type: Number,
      default: 56.25
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    titleLink: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => {
      if (e.media && e.media.src) {
        const p = e.media.src.toLowerCase().split(".").pop();
        return p === "mp4" || p === "m4a" || p === "f4v" || p === "m4b" || p === "mov";
      } else
        return !1;
    }), a = I(() => n.value ? zh : dn), i = I(() => n.value ? null : e.media), r = I(() => {
      if (!n.value)
        return null;
      const x = e.media;
      return {
        src: x.src,
        focalPoint: x.focalPoint,
        sizes: x.sizes,
        height: x.height,
        width: x.width,
        alt: x.alt,
        caption: x.caption,
        poster: x.poster
      };
    }), s = I(() => n.value ? r.value : i.value), o = I(() => e.ratio), l = I(() => e.locations.map((x) => ({
      ...x,
      svg: x.title === "Online" ? "svg-icon-virtual" : "svg-icon-location",
      class: x.title === "Online" ? "location-online" : "location-link",
      to: x.to != null ? Hh(x.to) : ""
    }))), c = I(() => Da(e.startDate, e.endDate)), d = I(() => Nt(new Date(e.dateCreated), "MMMM d, Y")), f = I(() => e.startDate && e.sectionHandle === "event" ? Wi(e.startDate, e.endDate) : ""), g = I(() => ha(e.to)), _ = I(() => [
      "banner-featured",
      { "hatch-left": !e.alignRight },
      `color-${g.value}`
    ]);
    return (x, p) => (h(), b("div", {
      class: se(_.value)
    }, [
      k("div", dk, [
        xe(x.$slots, "default", {}, () => [
          t.breadcrumb ? (h(), b("div", hk, [
            Q(O(r2), {
              class: "heading-line",
              "aria-hidden": "true"
            }),
            k("h2", fk, ae(t.breadcrumb), 1)
          ])) : E("", !0)
        ], !0)
      ]),
      (h(), Z(ut(a.value), {
        class: "media",
        media: s.value,
        "aspect-ratio": o.value
      }, {
        default: ce(() => [
          n.value ? E("", !0) : (h(), b("div", pk)),
          Q(O(n2), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["media", "aspect-ratio"])),
      k("div", mk, [
        k("div", gk, [
          t.category ? (h(), b("h2", {
            key: 0,
            class: "category category-mobile",
            innerHTML: t.category
          }, null, 8, bk)) : E("", !0)
        ]),
        k("div", vk, [
          Q(O(a2), {
            class: "svg",
            "aria-hidden": "true"
          })
        ])
      ]),
      k("div", yk, [
        t.category ? (h(), b("div", {
          key: 0,
          class: "category category-desktop",
          innerHTML: t.category
        }, null, 8, _k)) : E("", !0),
        t.titleLink.length > 0 ? (h(), b("div", xk, [
          Q(Ke, {
            id: "banner-featured",
            to: t.titleLink,
            class: "title title-linked"
          }, {
            default: ce(() => [
              Ye(ae(t.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])) : (h(), b("div", Tk, [
          k("h3", {
            id: "banner-featured",
            class: "title",
            innerHTML: t.title
          }, null, 8, wk)
        ])),
        k("div", kk, [
          t.dateCreated ? (h(), b("div", Sk, [
            t.dateCreated ? (h(), b("time", {
              key: 0,
              class: "date-created",
              innerHTML: d.value
            }, null, 8, Ck)) : E("", !0)
          ])) : E("", !0),
          t.byline.length ? (h(), b("div", Ak, [
            (h(!0), b(me, null, Ee(t.byline, (w, C) => (h(), b("div", {
              key: `external-${C}`,
              class: "byline-item",
              innerHTML: w
            }, null, 8, Ek))), 128))
          ])) : E("", !0),
          t.description ? (h(), Z(un, {
            key: 2,
            class: "description",
            "rich-text-content": t.description
          }, null, 8, ["rich-text-content"])) : E("", !0),
          t.startDate || t.endDate ? (h(), b("div", Lk, [
            t.startDate ? (h(), b("time", {
              key: 0,
              class: "schedule-item",
              innerHTML: c.value
            }, null, 8, Dk)) : E("", !0),
            f.value ? (h(), b("time", {
              key: 1,
              class: "schedule-item",
              innerHTML: f.value
            }, null, 8, Ik)) : E("", !0)
          ])) : E("", !0),
          t.locations.length ? (h(), b("div", Mk, [
            (h(!0), b(me, null, Ee(l.value, (w) => (h(), Z(en, {
              key: `location-${w.id}`,
              text: w.title,
              "icon-name": w.svg,
              to: w.to,
              class: se(w.class)
            }, null, 8, ["text", "icon-name", "to", "class"]))), 128))
          ])) : E("", !0)
        ]),
        t.to ? (h(), Z(cn, {
          key: 3,
          id: "banner-featured-button",
          label: t.prompt,
          to: t.to,
          "aria-labelledby": "banner-featured-button banner-featured",
          class: "button"
        }, null, 8, ["label", "to"])) : E("", !0)
      ]),
      !t.to && t.registerEvent ? (h(), b("div", Ok, [
        Q(Uh)
      ])) : E("", !0)
    ], 2));
  }
}), Mm = /* @__PURE__ */ be(Pk, [["__scopeId", "data-v-22c151a4"]]), Bk = {
  key: 0,
  class: "category"
}, Rk = ["innerHTML"], Nk = { class: "hatch-box" }, $k = { class: "hatch" }, Fk = { class: "meta" }, zk = ["innerHTML"], Uk = { class: "meta-text" }, Hk = { class: "meta-block" }, Yk = {
  key: 0,
  class: "byline-item"
}, jk = {
  key: 1,
  class: "subject-areas"
}, Vk = ["innerHTML"], qk = ["innerHTML"], Wk = ["innerHTML"], Gk = {
  key: 0,
  class: "contact-info-group"
}, Xk = {
  key: 1,
  class: "location-group"
}, Zk = {
  key: 1,
  class: "block-form-container"
}, Kk = /* @__PURE__ */ Ae({
  __name: "BannerHeader",
  props: {
    media: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    byline: {
      type: Array,
      default: () => []
    },
    contributors: {
      type: Array,
      default: () => []
    },
    subjectAreas: {
      type: Array,
      default: () => []
    },
    dateCreated: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    to: {
      // URL to link to, if blank won't link
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    prompt: {
      // text that displays on blue button, e.g. "View exhibit". Links to `props.to`
      type: String,
      default: ""
    },
    alignRight: {
      type: Boolean,
      default: !0
    },
    ratio: {
      type: Number,
      default: 56.25
    },
    // contact info for Location Detail Page
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    staffDirectoryLink: {
      type: String,
      default: ""
    },
    isEvent: {
      type: Boolean,
      default: !1
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ge(() => Promise.resolve().then(() => Dl)), a = ge(() => Promise.resolve().then(() => c2)), i = ge(() => Promise.resolve().then(() => l2)), r = ge(() => Promise.resolve().then(() => s2)), s = I(() => ha(e.to)), o = I(() => [
      "banner-header",
      { "hatch-left": !e.alignRight },
      `color-${s.value}`
    ]), l = I(() => {
      if (e.media && e.media.src) {
        const L = e.media.src.toLowerCase().split(".").pop();
        return L === "mp4" || L === "m4a" || L === "f4v" || L === "m4b" || L === "mov";
      } else
        return !1;
    }), c = I(() => l.value ? zh : dn), d = I(() => l.value ? null : e.media), f = I(() => {
      if (!l.value)
        return null;
      const A = e.media;
      return {
        src: A.src,
        focalPoint: A.focalPoint,
        sizes: A.sizes,
        height: A.height,
        width: A.width,
        alt: A.alt,
        caption: A.caption,
        poster: A.poster
      };
    }), g = I(() => l.value ? f.value : d.value), _ = I(() => Nt(new Date(e.dateCreated), "MMMM d, Y")), x = I(() => Da(e.startDate, e.endDate)), p = I(() => e.startDate && e.sectionHandle === "event" ? Wi(e.startDate, e.endDate) : ""), w = I(() => e.ratio), C = I(() => e.category ? "gradient" : "gradient-no-category"), M = I(() => e.locations.map((A) => {
      let L = "svg-icon-location";
      return A.title === "Online" && (L = "svg-icon-virtual"), {
        ...A,
        svg: L,
        to: A.to != null ? Hh(A.to) : ""
      };
    }));
    return (A, L) => (h(), b("div", {
      class: se(o.value)
    }, [
      t.category ? (h(), b("div", Bk, [
        Q(O(r), {
          class: "heading-line",
          "aria-hidden": "true"
        }),
        k("div", {
          class: "text",
          innerHTML: t.category
        }, null, 8, Rk)
      ])) : E("", !0),
      (h(), Z(ut(c.value), {
        class: "media",
        media: g.value,
        "aspect-ratio": w.value
      }, {
        default: ce(() => [
          l.value ? E("", !0) : (h(), b("div", {
            key: 0,
            class: se(C.value)
          }, null, 2)),
          Q(O(n2), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["media", "aspect-ratio"])),
      k("div", Nk, [
        L[0] || (L[0] = k("div", { class: "clipped-box" }, null, -1)),
        k("div", $k, [
          Q(O(a2), {
            class: "svg",
            "aria-hidden": "true"
          })
        ])
      ]),
      k("div", Fk, [
        k("h1", {
          class: "title",
          innerHTML: t.title
        }, null, 8, zk),
        t.text ? (h(), Z(O(a), {
          key: 0,
          class: "snippet",
          "rich-text-content": t.text
        }, null, 8, ["rich-text-content"])) : E("", !0),
        kt(k("div", Uk, [
          kt(k("div", Hk, [
            t.byline.length ? (h(), b("div", Yk, [
              (h(!0), b(me, null, Ee(t.byline, (D, B) => (h(), b("div", {
                key: `${D}-${B}`,
                class: "byline-item"
              }, ae(D), 1))), 128))
            ])) : E("", !0),
            t.subjectAreas.length ? (h(), b("div", jk, [
              (h(!0), b(me, null, Ee(t.subjectAreas, (D, B) => (h(), b("div", {
                key: `${D.title}-${B}`
              }, ae(D.title), 1))), 128))
            ])) : E("", !0),
            t.dateCreated ? (h(), b("time", {
              key: 2,
              class: "date-created",
              innerHTML: _.value
            }, null, 8, Vk)) : E("", !0),
            t.startDate ? (h(), b("time", {
              key: 3,
              class: "schedule-item",
              innerHTML: x.value
            }, null, 8, qk)) : E("", !0),
            p.value ? (h(), b("time", {
              key: 4,
              class: "schedule-item",
              innerHTML: p.value
            }, null, 8, Wk)) : E("", !0)
          ], 512), [
            [
              ga,
              t.byline.length || t.subjectAreas.length || t.dateCreated || t.startDate
            ]
          ]),
          t.email || t.phone || t.staffDirectoryLink || t.addressLink ? (h(), b("div", Gk, [
            t.email ? (h(), Z(O(i), {
              key: 0,
              text: t.email,
              "icon-name": "svg-icon-email",
              to: `mailto:${t.email}`
            }, null, 8, ["text", "to"])) : E("", !0),
            t.phone ? (h(), Z(O(i), {
              key: 1,
              text: t.phone,
              "icon-name": "svg-icon-phone",
              to: `tel:${t.phone}`
            }, null, 8, ["text", "to"])) : E("", !0),
            t.staffDirectoryLink ? (h(), Z(O(i), {
              key: 2,
              text: "View staff directory",
              "icon-name": "svg-icon-person",
              to: t.staffDirectoryLink
            }, null, 8, ["to"])) : E("", !0),
            t.addressLink ? (h(), Z(O(i), {
              key: 3,
              text: t.address,
              "icon-name": "svg-icon-location",
              to: t.addressLink
            }, null, 8, ["text", "to"])) : E("", !0)
          ])) : E("", !0),
          t.locations.length ? (h(), b("div", Xk, [
            (h(!0), b(me, null, Ee(M.value, (D) => (h(), Z(O(i), {
              key: `location-${D.id}`,
              text: D.title,
              "icon-name": D.svg,
              to: D.to
            }, null, 8, ["text", "icon-name", "to"]))), 128))
          ])) : E("", !0)
        ], 512), [
          [
            ga,
            t.byline.length || t.subjectAreas.length || t.dateCreated || t.startDate || t.email || t.phone || t.staffDirectoryLink || t.addressLink
          ]
        ]),
        t.to ? (h(), Z(O(n), {
          key: 1,
          label: t.prompt,
          "is-secondary": !0,
          class: "button",
          to: t.to
        }, null, 8, ["label", "to"])) : E("", !0)
      ]),
      !t.to && t.registerEvent ? (h(), b("div", Zk, [
        Q(Uh)
      ])) : E("", !0)
    ], 2));
  }
}), N0e = /* @__PURE__ */ be(Kk, [["__scopeId", "data-v-3a64bf88"]]), Qk = { class: "banner-text" }, Jk = { class: "banner-text-content-container" }, e9 = {
  key: 0,
  class: "category"
}, t9 = ["innerHTML"], n9 = { class: "content" }, a9 = { class: "title" }, i9 = ["lang", "innerHTML"], r9 = {
  key: 1,
  class: "meta-block"
}, s9 = {
  key: 0,
  class: "byline-item"
}, o9 = {
  key: 1,
  class: "subject-areas"
}, l9 = {
  key: 2,
  class: "contact-info"
}, c9 = {
  key: 3,
  class: "contact-info"
}, u9 = {
  key: 4,
  class: "contact-info"
}, d9 = {
  key: 5,
  class: "contact-info"
}, h9 = {
  key: 6,
  class: "schedule"
}, f9 = ["innerHTML"], p9 = ["innerHTML"], m9 = ["innerHTML"], g9 = {
  key: 3,
  class: "schedule-item"
}, b9 = {
  key: 2,
  class: "location-group"
}, v9 = {
  key: 0,
  class: "block-form-container"
}, y9 = /* @__PURE__ */ Ae({
  __name: "BannerText",
  props: {
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "",
      required: !0
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    dateCreated: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isDarkBlue: {
      type: Boolean,
      default: !1
    },
    // contact info for Location Detail Page
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    staffDirectoryLink: {
      type: String,
      default: ""
    },
    articleType: {
      type: String,
      default: ""
    },
    byline: {
      type: Array,
      default: () => []
    },
    subjectAreas: {
      type: Array,
      default: () => []
    },
    registerEvent: {
      type: Boolean,
      default: !1
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ge(() => Promise.resolve().then(() => Dl)), a = ge(() => Promise.resolve().then(() => c2)), i = ge(() => Promise.resolve().then(() => l2)), r = ge(() => Promise.resolve().then(() => s2)), s = I(() => {
      let _ = ["banner-text-container", "theme-light"];
      return e.isDarkBlue && (_ = ["banner-text-container", "theme-dark"]), _;
    }), o = I(() => ha(e.to)), l = I(() => ["text", `color-${o.value}`]), c = I(() => Nt(new Date(e.dateCreated), "MMMM d, Y")), d = I(() => Da(e.startDate, e.endDate)), f = I(() => e.startDate && e.sectionHandle === "event" ? Wi(e.startDate, e.endDate) : ""), g = I(() => e.locations.map((_) => {
      let x = "svg-icon-location";
      return _.title === "Online" && (x = "svg-icon-virtual"), {
        ..._,
        svg: x,
        to: _.to != null ? Hh(_.to) : ""
      };
    }));
    return (_, x) => (h(), b("div", Qk, [
      k("div", {
        class: se(s.value)
      }, [
        k("div", Jk, [
          t.category ? (h(), b("div", e9, [
            Q(O(r), {
              class: "heading-line",
              "aria-hidden": "true"
            }),
            k("div", {
              class: se(l.value),
              innerHTML: t.category
            }, null, 10, t9)
          ])) : E("", !0),
          k("div", n9, [
            k("h1", a9, [
              Ye(ae(t.title) + " ", 1),
              t.alternativeFullName ? (h(), b("span", {
                key: 0,
                lang: t.language,
                class: "translation",
                innerHTML: t.alternativeFullName
              }, null, 8, i9)) : E("", !0)
            ]),
            t.text ? (h(), Z(O(a), {
              key: 0,
              class: "text",
              "rich-text-content": t.text
            }, null, 8, ["rich-text-content"])) : E("", !0),
            t.byline || t.subjectAreas || t.startDate || t.phone || t.email || t.addressLink || t.staffDirectoryLink ? (h(), b("div", r9, [
              t.byline ? (h(), b("div", s9, [
                (h(!0), b(me, null, Ee(t.byline, (p, w) => (h(), b("div", {
                  key: `${p}-${w}`
                }, ae(p), 1))), 128))
              ])) : E("", !0),
              t.subjectAreas ? (h(), b("div", o9, [
                (h(!0), b(me, null, Ee(t.subjectAreas, (p, w) => (h(), b("div", {
                  key: `${p.title}-${w}`
                }, ae(p.title), 1))), 128))
              ])) : E("", !0),
              t.email ? (h(), b("div", l9, [
                Q(O(i), {
                  text: t.email,
                  "icon-name": "svg-icon-email",
                  to: `mailto:${t.email}`
                }, null, 8, ["text", "to"])
              ])) : E("", !0),
              t.phone ? (h(), b("div", c9, [
                Q(O(i), {
                  text: t.phone,
                  "icon-name": "svg-icon-phone",
                  to: `tel:${t.phone}`
                }, null, 8, ["text", "to"])
              ])) : E("", !0),
              t.staffDirectoryLink ? (h(), b("div", u9, [
                Q(O(i), {
                  text: "View staff directory",
                  "icon-name": "svg-icon-person",
                  to: t.staffDirectoryLink
                }, null, 8, ["to"])
              ])) : E("", !0),
              t.addressLink ? (h(), b("div", d9, [
                Q(O(i), {
                  text: t.address,
                  "icon-name": "svg-icon-location",
                  to: t.addressLink
                }, null, 8, ["text", "to"])
              ])) : E("", !0),
              t.startDate || t.dateCreated ? (h(), b("div", h9, [
                t.dateCreated ? (h(), b("time", {
                  key: 0,
                  class: "date-created",
                  innerHTML: c.value
                }, null, 8, f9)) : E("", !0),
                t.startDate ? (h(), b("time", {
                  key: 1,
                  class: "schedule-item",
                  innerHTML: d.value
                }, null, 8, p9)) : E("", !0),
                f.value ? (h(), b("time", {
                  key: 2,
                  class: "schedule-item",
                  innerHTML: f.value
                }, null, 8, m9)) : E("", !0),
                t.isOnline ? (h(), b("div", g9, " Online ")) : E("", !0)
              ])) : E("", !0)
            ])) : E("", !0),
            t.locations.length ? (h(), b("div", b9, [
              (h(!0), b(me, null, Ee(g.value, (p) => (h(), Z(O(i), {
                key: `location-${p.id}`,
                text: p.title,
                "icon-name": p.svg,
                to: p.to
              }, null, 8, ["text", "icon-name", "to"]))), 128))
            ])) : E("", !0),
            t.to && !t.isDarkBlue ? (h(), Z(O(n), {
              key: 3,
              label: t.buttonText,
              to: t.to,
              "is-secondary": !0
            }, null, 8, ["label", "to"])) : E("", !0),
            t.to && t.isDarkBlue ? (h(), Z(O(n), {
              key: 4,
              label: t.buttonText,
              to: t.to,
              "is-tertiary": !0
            }, null, 8, ["label", "to"])) : E("", !0)
          ])
        ])
      ], 2),
      !t.to && t.registerEvent ? (h(), b("div", v9, [
        Q(Uh)
      ])) : E("", !0)
    ]));
  }
}), $0e = /* @__PURE__ */ be(y9, [["__scopeId", "data-v-2a3390cd"]]), _9 = {
  width: "1000",
  height: "480",
  viewBox: "0 0 1000 480",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-placeholder"
};
function x9(t, e) {
  return h(), b("svg", _9, e[0] || (e[0] = [
    ri('<g><path d="M0.343468 256.541L86.6725 221.246L86.8143 220.911M0.343468 256.541L-88.3703 221.246M0.343468 256.541L67.1173 201.214M0.343468 256.541L-67.8612 201.214M124.829 131.101L86.6725 44.7721M124.829 131.101L86.8143 220.911M124.829 131.101L0.343468 62.4195M124.829 131.101L67.1173 201.214M86.6725 44.7721L0.343468 4.23083M86.6725 44.7721L0.343468 62.4195M0.343468 4.23083L-88.3703 44.7721M0.343468 4.23083V62.4195M-88.3703 44.7721L-125.096 131.101M-88.3703 44.7721L0.343468 62.4195M-125.096 131.101L-88.3703 221.246M-125.096 131.101L-67.8612 201.214M-125.096 131.101L0.343468 62.4195M-88.3703 221.246L-67.8612 201.214M-67.8612 201.214H67.1173M-67.8612 201.214L0.343468 62.4195M67.1173 201.214L86.8143 220.911M67.1173 201.214L0.343468 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M250.268 256.541L336.597 221.246L336.739 220.911M250.268 256.541L161.555 221.246M250.268 256.541L317.042 201.214M250.268 256.541L182.064 201.214M374.754 131.101L336.597 44.7721M374.754 131.101L336.739 220.911M374.754 131.101L250.268 62.4194M374.754 131.101L317.042 201.214M336.597 44.7721L250.268 4.23081M336.597 44.7721L250.268 62.4194M250.268 4.23081L161.555 44.7721M250.268 4.23081V62.4194M161.555 44.7721L124.829 131.101M161.555 44.7721L250.268 62.4194M124.829 131.101L161.555 221.246M124.829 131.101L182.064 201.214M124.829 131.101L250.268 62.4194M161.555 221.246L182.064 201.214M182.064 201.214H317.042M182.064 201.214L250.268 62.4194M317.042 201.214L336.739 220.911M317.042 201.214L250.268 62.4194" stroke="#5CD9FF" stroke-width="1.15119" class="svg__stroke--default-cyan-02"></path><path d="M500.193 256.541L586.522 221.246L586.664 220.911M500.193 256.541L411.48 221.246M500.193 256.541L566.967 201.214M500.193 256.541L431.989 201.214M624.679 131.101L586.522 44.7721M624.679 131.101L586.664 220.911M624.679 131.101L500.193 62.4195M624.679 131.101L566.967 201.214M586.522 44.7721L500.193 4.23083M586.522 44.7721L500.193 62.4195M500.193 4.23083L411.48 44.7721M500.193 4.23083V62.4195M411.48 44.7721L374.754 131.101M411.48 44.7721L500.193 62.4195M374.754 131.101L411.48 221.246M374.754 131.101L431.989 201.214M374.754 131.101L500.193 62.4195M411.48 221.246L431.989 201.214M431.989 201.214H566.967M431.989 201.214L500.193 62.4195M566.967 201.214L586.664 220.911M566.967 201.214L500.193 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M750.118 256.541L836.447 221.246L836.589 220.911M750.118 256.541L661.404 221.246M750.118 256.541L816.892 201.214M750.118 256.541L681.914 201.214M874.604 131.101L836.447 44.7721M874.604 131.101L836.589 220.911M874.604 131.101L750.118 62.4195M874.604 131.101L816.892 201.214M836.447 44.7721L750.118 4.23083M836.447 44.7721L750.118 62.4195M750.118 4.23083L661.404 44.7721M750.118 4.23083V62.4195M661.404 44.7721L624.679 131.101M661.404 44.7721L750.118 62.4195M624.679 131.101L661.404 221.246M624.679 131.101L681.914 201.214M624.679 131.101L750.118 62.4195M661.404 221.246L681.914 201.214M681.914 201.214H816.892M681.914 201.214L750.118 62.4195M816.892 201.214L836.589 220.911M816.892 201.214L750.118 62.4195" stroke="#5CD9FF" stroke-width="1.15119" class="svg__stroke--default-cyan-02"></path><path d="M1000.04 256.541L1086.37 221.246L1086.51 220.911M1000.04 256.541L911.329 221.246M1000.04 256.541L1066.82 201.214M1000.04 256.541L931.838 201.214M1124.53 131.101L1086.37 44.7721M1124.53 131.101L1086.51 220.911M1124.53 131.101L1000.04 62.4195M1124.53 131.101L1066.82 201.214M1086.37 44.7721L1000.04 4.23083M1086.37 44.7721L1000.04 62.4195M1000.04 4.23083L911.329 44.7721M1000.04 4.23083V62.4195M911.329 44.7721L874.604 131.101M911.329 44.7721L1000.04 62.4195M874.604 131.101L911.329 221.246M874.604 131.101L931.838 201.214M874.604 131.101L1000.04 62.4195M911.329 221.246L931.838 201.214M931.838 201.214H1066.82M931.838 201.214L1000.04 62.4195M1066.82 201.214L1086.51 220.911M1066.82 201.214L1000.04 62.4195" stroke="#87FBE8" stroke-width="1.15119" class="svg__stroke--help-green-02"></path><path d="M125.439 478.919L211.768 443.625L211.91 443.289M125.439 478.919L36.7256 443.625M125.439 478.919L192.213 423.592M125.439 478.919L57.2347 423.592M249.925 353.48L211.768 267.151M249.925 353.48L211.91 443.289M249.925 353.48L125.439 284.798M249.925 353.48L192.213 423.592M211.768 267.151L125.439 226.61M211.768 267.151L125.439 284.798M125.439 226.61L36.7256 267.151M125.439 226.61V284.798M36.7256 267.151L0 353.48M36.7256 267.151L125.439 284.798M0 353.48L36.7256 443.625M0 353.48L57.2347 423.592M0 353.48L125.439 284.798M36.7256 443.625L57.2347 423.592M57.2347 423.592H192.213M57.2347 423.592L125.439 284.798M192.213 423.592L211.91 443.289M192.213 423.592L125.439 284.798" stroke="#E7DBFF" stroke-width="1.15119" class="svg__stroke--about-purple-02"></path><path d="M375.364 478.919L461.693 443.625L461.835 443.289M375.364 478.919L286.65 443.625M375.364 478.919L442.138 423.592M375.364 478.919L307.16 423.592M499.85 353.48L461.693 267.151M499.85 353.48L461.835 443.289M499.85 353.48L375.364 284.798M499.85 353.48L442.138 423.592M461.693 267.151L375.364 226.61M461.693 267.151L375.364 284.798M375.364 226.61L286.65 267.151M375.364 226.61V284.798M286.65 267.151L249.925 353.48M286.65 267.151L375.364 284.798M249.925 353.48L286.65 443.625M249.925 353.48L307.16 423.592M249.925 353.48L375.364 284.798M286.65 443.625L307.16 423.592M307.16 423.592H442.138M307.16 423.592L375.364 284.798M442.138 423.592L461.835 443.289M442.138 423.592L375.364 284.798" stroke="#FFBDF4" stroke-width="1.15119" class="svg__stroke--visit-fushia-02"></path><path d="M625.289 478.919L711.618 443.625L711.76 443.289M625.289 478.919L536.575 443.625M625.289 478.919L692.063 423.592M625.289 478.919L557.085 423.592M749.775 353.48L711.618 267.151M749.775 353.48L711.76 443.289M749.775 353.48L625.289 284.798M749.775 353.48L692.063 423.592M711.618 267.151L625.289 226.61M711.618 267.151L625.289 284.798M625.289 226.61L536.575 267.151M625.289 226.61V284.798M536.575 267.151L499.85 353.48M536.575 267.151L625.289 284.798M499.85 353.48L536.575 443.625M499.85 353.48L557.085 423.592M499.85 353.48L625.289 284.798M536.575 443.625L557.085 423.592M557.085 423.592H692.063M557.085 423.592L625.289 284.798M692.063 423.592L711.76 443.289M692.063 423.592L625.289 284.798" stroke="#E7DBFF" stroke-width="1.15119" class="svg__stroke--about-purple-02"></path><path d="M875.214 478.919L961.543 443.625L961.685 443.289M875.214 478.919L786.5 443.625M875.214 478.919L941.988 423.592M875.214 478.919L807.009 423.592M999.7 353.48L961.543 267.151M999.7 353.48L961.685 443.289M999.7 353.48L875.214 284.798M999.7 353.48L941.988 423.592M961.543 267.151L875.214 226.61M961.543 267.151L875.214 284.798M875.214 226.61L786.5 267.151M875.214 226.61V284.798M786.5 267.151L749.775 353.48M786.5 267.151L875.214 284.798M749.775 353.48L786.5 443.625M749.775 353.48L807.009 423.592M749.775 353.48L875.214 284.798M786.5 443.625L807.009 423.592M807.009 423.592H941.988M807.009 423.592L875.214 284.798M941.988 423.592L961.685 443.289M941.988 423.592L875.214 284.798" stroke="#FFBDF4" stroke-width="1.15119" class="svg__stroke--visit-fushia-02"></path></g>', 1)
  ]));
}
const Zs = { render: x9 }, T9 = {
  key: 0,
  class: "linked-category"
}, w9 = ["innerHTML"], k9 = {
  key: 2,
  class: "custom-title"
}, S9 = ["lang", "innerHTML"], C9 = ["innerHTML"], A9 = {
  key: 5,
  class: "custom-description"
}, E9 = {
  key: 7,
  class: "byline-group"
}, L9 = ["innerHTML"], D9 = ["innerHTML"], I9 = {
  key: 2,
  class: "schedule-item date-created"
}, M9 = {
  key: 8,
  class: "date-time"
}, O9 = {
  key: 0,
  class: "ongoing-item"
}, P9 = ["innerHTML"], B9 = ["innerHTML"], R9 = {
  key: 9,
  class: "location-group"
}, N9 = {
  key: 10,
  class: "block-tags"
}, $9 = { class: "sharebutton-slot" }, F9 = { class: "floating-slot" }, z9 = /* @__PURE__ */ Ae({
  __name: "CardMeta",
  props: {
    to: {
      type: String,
      default: ""
    },
    // the data is often an array that needs to be combined on the page into one string
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    // often used to display date article was published
    // will be styled or formatted differently than startDate & endDate
    dateCreated: {
      type: String,
      required: !1
    },
    // long single date = 'Febuary 1, 2022', short = 'Feb 1, 2022
    // long date range =  'Febuary 1, 2022 - Febuary 2, 2022', short = 'Feb 1 - Feb 2'
    dateFormat: {
      type: String,
      default: "long"
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    },
    introduction: {
      type: String,
      default: ""
    },
    guestSpeaker: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ge(() => Promise.resolve().then(() => h2)), a = $a(), i = Ge(), r = I(() => !!(a !== void 0 && a.path.includes("impact"))), s = I(() => r.value ? "_blank" : ""), o = I(() => e.startDate ? e.sectionHandle === "ftvaEvent" ? Da(e.startDate, e.startDate, e.dateFormat) : e.endDate ? Da(e.startDate, e.endDate, e.dateFormat) : Da(e.startDate, e.startDate, e.dateFormat) : ""), l = I(() => e.dateCreated ? Nt(new Date(e.dateCreated), "MMMM d, yyyy") : ""), c = I(() => e.startDate && e.sectionHandle === "event" ? Wi(e.startDate, e.endDate) : e.startDate && e.sectionHandle !== "ftvaEventSeries" && (i == null ? void 0 : i.value) === "ftva" ? e.endDate ? Wi(e.startDate, e.endDate) : Wi(e.startDate, e.startDate) : e.startDate && e.sectionHandle === "ftvaEventSeries" ? Nt(new Date(e.startDate), "h:mm aaa") : ""), d = I(() => e.locations.map((g) => {
      let _ = "svg-icon-location";
      return g.title === "Online" && (_ = "svg-icon-virtual"), {
        ...g,
        svg: _,
        to: g.to != null ? `/${g.to}` : ""
      };
    })), f = I(() => ["card-meta", (i == null ? void 0 : i.value) || "", e.sectionHandle]);
    return (g, _) => (h(), b("div", {
      class: se(f.value)
    }, [
      g.$slots.linkedcategoryslot ? (h(), b("div", T9, [
        xe(g.$slots, "linkedcategoryslot", {}, void 0, !0)
      ])) : E("", !0),
      t.category ? (h(), b("div", {
        key: 1,
        class: "category",
        innerHTML: t.category
      }, null, 8, w9)) : E("", !0),
      g.$slots.customTitle ? (h(), b("h3", k9, [
        xe(g.$slots, "customTitle", {}, void 0, !0)
      ])) : E("", !0),
      t.to ? (h(), Z(Ke, {
        key: 3,
        "link-target": s.value,
        to: t.to,
        class: "title"
      }, {
        default: ce(() => [
          Ye(ae(t.title) + " ", 1),
          t.alternativeFullName ? (h(), b("span", {
            key: 0,
            lang: t.language,
            class: "translation",
            innerHTML: t.alternativeFullName
          }, null, 8, S9)) : E("", !0)
        ]),
        _: 1
      }, 8, ["link-target", "to"])) : (h(), b("h3", {
        key: 4,
        class: "title-no-link",
        innerHTML: t.title
      }, null, 8, C9)),
      g.$slots.customDescription ? (h(), b("p", A9, [
        xe(g.$slots, "customDescription", {}, void 0, !0)
      ])) : E("", !0),
      t.guestSpeaker ? (h(), Z(un, {
        key: 6,
        class: "guestSpeaker",
        "rich-text-content": t.guestSpeaker
      }, null, 8, ["rich-text-content"])) : E("", !0),
      t.bylineOne || t.bylineTwo || t.dateCreated ? (h(), b("div", E9, [
        t.bylineOne ? (h(), b("div", {
          key: 0,
          class: "schedule-item",
          innerHTML: t.bylineOne
        }, null, 8, L9)) : E("", !0),
        t.bylineTwo ? (h(), b("div", {
          key: 1,
          class: "schedule-item",
          innerHTML: t.bylineTwo
        }, null, 8, D9)) : E("", !0),
        t.dateCreated ? (h(), b("div", I9, ae(l.value), 1)) : E("", !0)
      ])) : E("", !0),
      t.startDate || t.ongoing ? (h(), b("div", M9, [
        t.ongoing ? (h(), b("div", O9, " Ongoing ")) : E("", !0),
        t.startDate ? (h(), b("time", {
          key: 1,
          class: "schedule-item start-date",
          innerHTML: o.value
        }, null, 8, P9)) : E("", !0),
        t.startDate && t.sectionHandle !== "ftvaEventSeries" ? (h(), b("time", {
          key: 2,
          class: "schedule-item parsed-time",
          innerHTML: c.value
        }, null, 8, B9)) : E("", !0)
      ])) : E("", !0),
      t.locations.length ? (h(), b("div", R9, [
        (h(!0), b(me, null, Ee(d.value, (x, p) => (h(), Z(en, {
          key: `location-card-meta${p}`,
          text: x.title,
          "icon-name": x.svg,
          to: x.to
        }, null, 8, ["text", "icon-name", "to"]))), 128))
      ])) : E("", !0),
      t.tagLabels && t.tagLabels.length > 0 ? (h(), b("div", N9, [
        (h(!0), b(me, null, Ee(t.tagLabels, (x) => (h(), Z(O(n), {
          key: `tag-${x.title}`,
          label: x.title,
          class: "tag-label"
        }, null, 8, ["label"]))), 128))
      ])) : E("", !0),
      t.introduction ? (h(), Z(un, {
        key: 11,
        class: "introduction",
        "rich-text-content": t.introduction
      }, null, 8, ["rich-text-content"])) : E("", !0),
      k("div", $9, [
        xe(g.$slots, "sharebutton", {}, void 0, !0)
      ]),
      k("div", F9, [
        xe(g.$slots, "floatingslot", {}, void 0, !0)
      ]),
      t.text ? (h(), Z(un, {
        key: 12,
        class: "text",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : E("", !0)
    ], 2));
  }
}), $u = /* @__PURE__ */ be(z9, [["__scopeId", "data-v-c4720861"]]), U9 = { class: "image-container" }, H9 = {
  key: 1,
  class: "molecule-no-image"
}, Y9 = /* @__PURE__ */ Ae({
  __name: "BlockCardWithImage",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    isVertical: {
      type: Boolean,
      default: !0
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
      // This will be "visit", "about", "help".
    },
    sectionHandle: {
      type: String,
      default: ""
    },
    cardIsLink: {
      type: Boolean,
      default: !1
      // If this is true, make entire card clickable instead of just title
    },
    dateCreated: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = Ru();
    function a() {
      e.cardIsLink && e.to && n.push({
        path: e.to
      });
    }
    const i = Ge(), r = I(() => [
      "block-highlight",
      // legacy name already used in library-website-nuxt and MEAP styles, do not change
      { "is-vertical": e.isVertical },
      (i == null ? void 0 : i.value) || ""
    ]), s = I(() => (i == null ? void 0 : i.value) === "ftva" ? "short" : "long");
    return (o, l) => (h(), b("li", {
      class: se(r.value),
      onClick: a
    }, [
      k("div", U9, [
        t.image ? (h(), Z(dn, {
          key: 0,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, rn({ _: 2 }, [
          o.$slots.toptext ? {
            name: "toptext",
            fn: ce(() => [
              xe(o.$slots, "toptext", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["media", "aspect-ratio"])) : (h(), b("div", H9, [
          Q(O(Zs), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      Q($u, {
        class: "card-meta-items",
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        "date-format": s.value,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle,
        "date-created": t.dateCreated
      }, rn({ _: 2 }, [
        o.$slots.customTitle ? {
          name: "customTitle",
          fn: ce(() => [
            xe(o.$slots, "customTitle", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        o.$slots.customDescription ? {
          name: "customDescription",
          fn: ce(() => [
            xe(o.$slots, "customDescription", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["to", "category", "title", "start-date", "end-date", "date-format", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle", "date-created"])
    ], 2));
  }
}), Yh = /* @__PURE__ */ be(Y9, [["__scopeId", "data-v-6c571344"]]), j9 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-calendar"
};
function V9(t, e) {
  return h(), b("svg", j9, e[0] || (e[0] = [
    k("path", {
      d: "M7 0.5V2.5H13V0.5H15V2.5H19C19.2652 2.5 19.5196 2.60536 19.7071 2.79289C19.8946 2.98043 20 3.23478 20 3.5V19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H1C0.734784 20.5 0.48043 20.3946 0.292893 20.2071C0.105357 20.0196 0 19.7652 0 19.5V3.5C0 3.23478 0.105357 2.98043 0.292893 2.79289C0.48043 2.60536 0.734784 2.5 1 2.5H5V0.5H7ZM18 10.5H2V18.5H18V10.5ZM5 4.5H2V8.5H18V4.5H15V6.5H13V4.5H7V6.5H5V4.5Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const $c = { render: V9 }, q9 = {
  width: "16",
  height: "22",
  viewBox: "0 0 16 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-location"
};
function W9(t, e) {
  return h(), b("svg", q9, e[0] || (e[0] = [
    k("path", {
      d: "M8.00005 10.45C7.2707 10.45 6.57123 10.1603 6.05551 9.64454C5.53978 9.12882 5.25005 8.42935 5.25005 7.7C5.25005 6.97065 5.53978 6.27118 6.05551 5.75546C6.57123 5.23973 7.2707 4.95 8.00005 4.95C8.72939 4.95 9.42887 5.23973 9.94459 5.75546C10.4603 6.27118 10.75 6.97065 10.75 7.7C10.75 8.06114 10.6789 8.41873 10.5407 8.75238C10.4025 9.08603 10.2 9.38918 9.94459 9.64454C9.68923 9.89991 9.38607 10.1025 9.05243 10.2407C8.71878 10.3789 8.36118 10.45 8.00005 10.45ZM8.00005 0C5.95788 0 3.99936 0.811248 2.55533 2.25528C1.1113 3.69931 0.300049 5.65783 0.300049 7.7C0.300049 13.475 8.00005 22 8.00005 22C8.00005 22 15.7 13.475 15.7 7.7C15.7 5.65783 14.8888 3.69931 13.4448 2.25528C12.0007 0.811248 10.0422 0 8.00005 0Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const G9 = { render: W9 }, X9 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-clock"
};
function Z9(t, e) {
  return h(), b("svg", X9, e[0] || (e[0] = [
    k("path", {
      d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM10 4C10.2449 4.00003 10.4813 4.08996 10.6644 4.25272C10.8474 4.41547 10.9643 4.63975 10.993 4.883L11 5V9.586L13.707 12.293C13.8863 12.473 13.9905 12.7144 13.9982 12.9684C14.006 13.2223 13.9168 13.4697 13.7488 13.6603C13.5807 13.8508 13.3464 13.9703 13.0935 13.9944C12.8406 14.0185 12.588 13.9454 12.387 13.79L12.293 13.707L9.293 10.707C9.13758 10.5514 9.03776 10.349 9.009 10.131L9 10V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const K9 = { render: Z9 }, Q9 = { class: "event-list date" }, J9 = {
  key: 0,
  class: "event-list time"
}, e6 = {
  key: 1,
  class: "event-list location"
}, t6 = { key: 0 }, n6 = { key: 1 }, a6 = {
  key: 2,
  class: "locations-wrapper"
}, i6 = /* @__PURE__ */ Ae({
  __name: "BlockEventDetail",
  props: {
    startDate: {
      type: String,
      required: !1
    },
    endDate: {
      type: String,
      required: !1
    },
    // Implied this is the start time
    time: {
      type: String,
      required: !1
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    locations: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["block-event-detail", (e == null ? void 0 : e.value) || ""]), a = I(() => {
      switch (e == null ? void 0 : e.value) {
        case "ftva":
          return {
            multiLocationMsgDisplay: !0
          };
        default:
          return {
            multiLocationMsgDisplay: !1
          };
      }
    }), i = I(() => (e == null ? void 0 : e.value) === "ftva" ? "_blank" : ""), r = I(() => t.ongoing ? "Ongoing" : t.endDate ? Da(t.startDate, t.endDate, "shortWithYear") : t.startDate ? Da(t.startDate, t.startDate) : null);
    return (s, o) => {
      var l, c;
      return h(), b("div", {
        class: se(n.value)
      }, [
        k("div", Q9, [
          k("span", null, [
            t.startDate ? (h(), Z(O($c), {
              key: 0,
              class: "row-icon"
            })) : E("", !0),
            Ye(" " + ae(r.value), 1)
          ])
        ]),
        t.time ? (h(), b("div", J9, [
          k("span", null, [
            Q(O(K9), { class: "row-icon" }),
            Ye(" " + ae(O(Wi)(t.time, t.time)), 1)
          ])
        ])) : E("", !0),
        t.locations && t.locations.length > 0 ? (h(), b("div", e6, [
          k("span", null, [
            Q(O(G9), { class: "row-icon" }),
            (l = a.value) != null && l.multiLocationMsgDisplay && t.locations.length > 1 ? (h(), b("span", t6, " Multiple Locations ")) : (c = a.value) != null && c.multiLocationMsgDisplay && t.locations.length === 1 ? (h(), b("span", n6, [
              Q(Ke, {
                to: t.locations[0].publicUrl,
                "link-target": i.value
              }, {
                default: ce(() => [
                  Ye(ae(t.locations[0].title), 1)
                ]),
                _: 1
              }, 8, ["to", "link-target"])
            ])) : (h(), b("span", a6, [
              (h(!0), b(me, null, Ee(t.locations, (d, f) => (h(), b("span", {
                key: d.title,
                class: "location-link"
              }, [
                Q(Ke, {
                  to: d.url,
                  "link-target": i.value
                }, {
                  default: ce(() => [
                    Ye(ae(d.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"]),
                Ye(" " + ae(f < t.locations.length - 1 ? ", " : ""), 1)
              ]))), 128))
            ]))
          ])
        ])) : E("", !0),
        xe(s.$slots, "default", {}, void 0, !0)
      ], 2);
    };
  }
}), r6 = /* @__PURE__ */ be(i6, [["__scopeId", "data-v-fed1c998"]]), s6 = ["innerHTML"], o6 = /* @__PURE__ */ Ae({
  __name: "BlockTag",
  props: {
    label: {
      type: String,
      default: ""
      // Text displayed on the tag or pill.
    },
    iconName: {
      type: String,
      required: !1
    },
    isSecondary: {
      type: Boolean,
      default: !1
    },
    isHighlighted: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = Ge(), n = ge(
      () => import("./icon-ftva-guest-BuhDVhJD.js")
    ), a = ge(
      () => import("./icon-ftva-film-DEEfKF7_.js")
    ), i = ge(
      () => import("./icon-ftva-tv-Bij4Z7mQ.js")
    ), r = ge(
      () => import("./icon-ftva-filmreel-D6Tayg6b.js")
    ), s = ge(
      () => import("./icon-ftva-digitalformat-BOpmYHa_.js")
    ), o = ge(
      () => import("./icon-ftva-online-BghTAXGW.js")
    ), l = ge(
      () => import("./icon-ftva-familyfriendly-c2muBjxC.js")
    ), c = {
      SvgIconGuest: n,
      SvgIconFilm: a,
      SvgIconTV: i,
      SvgIconFilmreel: r,
      SvgIconDigital: s,
      SvgIconOnline: o,
      SvgIconFamilyFriendly: l
    }, d = I(() => ["block-tag", (e == null ? void 0 : e.value) || "", t.isSecondary ? "" : "primary", t.isHighlighted ? "highlighted" : ""]);
    return (f, g) => (h(), b("span", {
      class: se(d.value)
    }, [
      t.iconName ? (h(), Z(ut(c[t.iconName]), {
        key: 0,
        class: "svg",
        "aria-hidden": "true"
      })) : E("", !0),
      k("div", {
        class: "label",
        innerHTML: t.label
      }, null, 8, s6),
      xe(f.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Ks = /* @__PURE__ */ be(o6, [["__scopeId", "data-v-19e50dad"]]), h2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ks
}, Symbol.toStringTag, { value: "Module" })), l6 = { class: "calendar-wrapper" }, c6 = ["onClick"], u6 = { class: "calendar-event-title" }, d6 = { class: "calendar-event-time" }, h6 = {
  key: 0,
  class: "calendar-event-popup-wrapper"
}, f6 = { class: "block-tag-wrapper" }, p6 = {
  key: 1,
  class: "calendar-slot-wrapper"
}, F0e = /* @__PURE__ */ Ae({
  __name: "BaseCalendar",
  props: {
    defaultEventCalendar: {
      type: Boolean,
      default: !0
      // True: Default calendar with fixed components
      // False: Minimal calendar or with custom components
    },
    events: {
      type: Array,
      default: () => []
    },
    firstEventMonth: {
      type: Array,
      default: () => [/* @__PURE__ */ new Date()]
      // Sets calendar to month of earliest event
      // Default: Calendar opens to month of current date
    }
  },
  setup(t) {
    const e = E4("calendar"), n = J(t.firstEventMonth), a = J({}), i = J({}), r = J(null);
    ht(() => {
      s(), window.addEventListener("click", o);
    });
    function s() {
      var w, C;
      const _ = (w = e.value) == null ? void 0 : w.querySelectorAll(".v-calendar-weekly__head-weekday-with-weeknumber"), x = (C = e.value) == null ? void 0 : C.querySelector(".v-calendar-header__today .v-btn__content"), p = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      _ == null || _.forEach((M, A) => M.innerText = p[A]), x.innerText = "This Month";
    }
    function o() {
      r.value && r.value.classList.remove("selected-event");
    }
    const l = I(() => t.events.length === 0 ? [] : t.events.map((x) => {
      var w, C;
      const p = x.startDateWithTime;
      return {
        // Required object keys for Vuetify calendar
        title: x.title,
        start: new Date(p),
        end: new Date(p),
        time: c(p),
        // All other event data
        id: x.id,
        startDateWithTime: x.startDateWithTime,
        tagLabels: (w = x.ftvaEventScreeningDetails[0]) == null ? void 0 : w.tagLabels,
        image: (C = x.imageCarousel[0]) == null ? void 0 : C.image[0],
        location: x.location,
        to: x.to
      };
    }));
    function c(_) {
      return Nt(new Date(_), "h:mm aaa").toUpperCase();
    }
    function d(_) {
      var p;
      o(), i.value = _;
      const x = a.value[`item-${_.id}`];
      r.value = x, (p = r.value) == null || p.classList.add("selected-event");
    }
    Xs(() => {
      window.removeEventListener("click", o);
    });
    const f = Ge(), g = I(() => ["base-calendar", (f == null ? void 0 : f.value) || ""]);
    return (_, x) => {
      const p = ot("v-list-item"), w = ot("v-list"), C = ot("v-card"), M = ot("v-menu"), A = ot("v-calendar"), L = ot("v-sheet"), D = L4("ripple");
      return h(), b("div", {
        ref: "calendar",
        class: se(g.value)
      }, [
        k("div", l6, [
          Q(L, { class: "calendar-body" }, {
            default: ce(() => [
              Q(A, {
                modelValue: n.value,
                "onUpdate:modelValue": x[0] || (x[0] = (B) => n.value = B),
                events: l.value,
                "view-mode": "month"
              }, {
                event: ce((B) => [
                  k("button", {
                    ref: (P) => {
                      a.value[`item-${B.event.id}`] = P;
                    },
                    class: "calendar-event-item",
                    onClick: (P) => d(B.event)
                  }, [
                    k("span", u6, ae(B.event.title), 1),
                    k("span", d6, ae(B.event.time), 1),
                    Q(M, {
                      activator: "parent",
                      "open-on-click": !0,
                      "close-on-content-click": !1,
                      location: "start bottom",
                      origin: "auto",
                      offset: "10",
                      opacity: "0"
                    }, {
                      default: ce(() => [
                        kt((h(), Z(C, {
                          width: "320",
                          style: { overflow: "hidden", "z-index": "initial" },
                          hover: !1,
                          link: !0,
                          to: i.value.to,
                          variant: "text"
                        }, {
                          default: ce(() => [
                            t.defaultEventCalendar ? (h(), b("div", h6, [
                              Q(Yh, {
                                image: i.value.image,
                                title: i.value.title
                              }, null, 8, ["image", "title"]),
                              k("div", f6, [
                                (h(!0), b(me, null, Ee(i.value.tagLabels, (P) => (h(), Z(Ks, {
                                  key: `tag-${P.title}`,
                                  label: P.title,
                                  "is-secondary": !0,
                                  "is-highlighted": P.isHighlighted ? P.isHighlighted : !1,
                                  class: se({ highlighted: P.isHighlighted })
                                }, null, 8, ["label", "is-highlighted", "class"]))), 128))
                              ]),
                              Q(r6, {
                                "start-date": i.value.startDateWithTime,
                                time: i.value.startDateWithTime,
                                locations: i.value.location
                              }, null, 8, ["start-date", "time", "locations"])
                            ])) : _.$slots.calendarSlotComponent ? (h(), b("div", p6, [
                              xe(_.$slots, "calendarSlotComponent", { event: i.value })
                            ])) : (h(), Z(w, { key: 2 }, {
                              default: ce(() => [
                                Q(p, {
                                  title: i.value.title
                                }, null, 8, ["title"])
                              ]),
                              _: 1
                            }))
                          ]),
                          _: 3
                        }, 8, ["to"])), [
                          [D, !1]
                        ])
                      ]),
                      _: 3
                    })
                  ], 8, c6)
                ]),
                _: 3
              }, 8, ["modelValue", "events"])
            ]),
            _: 3
          })
        ])
      ], 2);
    };
  }
});
var Vi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xa(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function m6(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(a) {
    var i = Object.getOwnPropertyDescriptor(t, a);
    Object.defineProperty(n, a, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[a];
      }
    });
  }), n;
}
var g6 = typeof Vi == "object" && Vi && Vi.Object === Object && Vi, f2 = g6, b6 = f2, v6 = typeof self == "object" && self && self.Object === Object && self, y6 = b6 || v6 || Function("return this")(), oi = y6, _6 = oi, x6 = _6.Symbol, Il = x6, Om = Il, p2 = Object.prototype, T6 = p2.hasOwnProperty, w6 = p2.toString, Ro = Om ? Om.toStringTag : void 0;
function k6(t) {
  var e = T6.call(t, Ro), n = t[Ro];
  try {
    t[Ro] = void 0;
    var a = !0;
  } catch {
  }
  var i = w6.call(t);
  return a && (e ? t[Ro] = n : delete t[Ro]), i;
}
var S6 = k6, C6 = Object.prototype, A6 = C6.toString;
function E6(t) {
  return A6.call(t);
}
var L6 = E6, Pm = Il, D6 = S6, I6 = L6, M6 = "[object Null]", O6 = "[object Undefined]", Bm = Pm ? Pm.toStringTag : void 0;
function P6(t) {
  return t == null ? t === void 0 ? O6 : M6 : Bm && Bm in Object(t) ? D6(t) : I6(t);
}
var zr = P6;
function B6(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Ur = B6, R6 = zr, N6 = Ur, $6 = "[object AsyncFunction]", F6 = "[object Function]", z6 = "[object GeneratorFunction]", U6 = "[object Proxy]";
function H6(t) {
  if (!N6(t))
    return !1;
  var e = R6(t);
  return e == F6 || e == z6 || e == $6 || e == U6;
}
var m2 = H6, Y6 = oi, j6 = Y6["__core-js_shared__"], V6 = j6, Gd = V6, Rm = function() {
  var t = /[^.]+$/.exec(Gd && Gd.keys && Gd.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function q6(t) {
  return !!Rm && Rm in t;
}
var W6 = q6, G6 = Function.prototype, X6 = G6.toString;
function Z6(t) {
  if (t != null) {
    try {
      return X6.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var g2 = Z6, K6 = m2, Q6 = W6, J6 = Ur, e7 = g2, t7 = /[\\^$.*+?()[\]{}|]/g, n7 = /^\[object .+?Constructor\]$/, a7 = Function.prototype, i7 = Object.prototype, r7 = a7.toString, s7 = i7.hasOwnProperty, o7 = RegExp(
  "^" + r7.call(s7).replace(t7, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function l7(t) {
  if (!J6(t) || Q6(t))
    return !1;
  var e = K6(t) ? o7 : n7;
  return e.test(e7(t));
}
var c7 = l7;
function u7(t, e) {
  return t == null ? void 0 : t[e];
}
var d7 = u7, h7 = c7, f7 = d7;
function p7(t, e) {
  var n = f7(t, e);
  return h7(n) ? n : void 0;
}
var Hr = p7, m7 = Hr, g7 = m7(Object, "create"), Fu = g7, Nm = Fu;
function b7() {
  this.__data__ = Nm ? Nm(null) : {}, this.size = 0;
}
var v7 = b7;
function y7(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var _7 = y7, x7 = Fu, T7 = "__lodash_hash_undefined__", w7 = Object.prototype, k7 = w7.hasOwnProperty;
function S7(t) {
  var e = this.__data__;
  if (x7) {
    var n = e[t];
    return n === T7 ? void 0 : n;
  }
  return k7.call(e, t) ? e[t] : void 0;
}
var C7 = S7, A7 = Fu, E7 = Object.prototype, L7 = E7.hasOwnProperty;
function D7(t) {
  var e = this.__data__;
  return A7 ? e[t] !== void 0 : L7.call(e, t);
}
var I7 = D7, M7 = Fu, O7 = "__lodash_hash_undefined__";
function P7(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = M7 && e === void 0 ? O7 : e, this;
}
var B7 = P7, R7 = v7, N7 = _7, $7 = C7, F7 = I7, z7 = B7;
function Qs(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
Qs.prototype.clear = R7;
Qs.prototype.delete = N7;
Qs.prototype.get = $7;
Qs.prototype.has = F7;
Qs.prototype.set = z7;
var U7 = Qs;
function H7() {
  this.__data__ = [], this.size = 0;
}
var Y7 = H7;
function j7(t, e) {
  return t === e || t !== t && e !== e;
}
var b2 = j7, V7 = b2;
function q7(t, e) {
  for (var n = t.length; n--; )
    if (V7(t[n][0], e))
      return n;
  return -1;
}
var zu = q7, W7 = zu, G7 = Array.prototype, X7 = G7.splice;
function Z7(t) {
  var e = this.__data__, n = W7(e, t);
  if (n < 0)
    return !1;
  var a = e.length - 1;
  return n == a ? e.pop() : X7.call(e, n, 1), --this.size, !0;
}
var K7 = Z7, Q7 = zu;
function J7(t) {
  var e = this.__data__, n = Q7(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var eS = J7, tS = zu;
function nS(t) {
  return tS(this.__data__, t) > -1;
}
var aS = nS, iS = zu;
function rS(t, e) {
  var n = this.__data__, a = iS(n, t);
  return a < 0 ? (++this.size, n.push([t, e])) : n[a][1] = e, this;
}
var sS = rS, oS = Y7, lS = K7, cS = eS, uS = aS, dS = sS;
function Js(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
Js.prototype.clear = oS;
Js.prototype.delete = lS;
Js.prototype.get = cS;
Js.prototype.has = uS;
Js.prototype.set = dS;
var Uu = Js, hS = Hr, fS = oi, pS = hS(fS, "Map"), jh = pS, $m = U7, mS = Uu, gS = jh;
function bS() {
  this.size = 0, this.__data__ = {
    hash: new $m(),
    map: new (gS || mS)(),
    string: new $m()
  };
}
var vS = bS;
function yS(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var _S = yS, xS = _S;
function TS(t, e) {
  var n = t.__data__;
  return xS(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Hu = TS, wS = Hu;
function kS(t) {
  var e = wS(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var SS = kS, CS = Hu;
function AS(t) {
  return CS(this, t).get(t);
}
var ES = AS, LS = Hu;
function DS(t) {
  return LS(this, t).has(t);
}
var IS = DS, MS = Hu;
function OS(t, e) {
  var n = MS(this, t), a = n.size;
  return n.set(t, e), this.size += n.size == a ? 0 : 1, this;
}
var PS = OS, BS = vS, RS = SS, NS = ES, $S = IS, FS = PS;
function eo(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
eo.prototype.clear = BS;
eo.prototype.delete = RS;
eo.prototype.get = NS;
eo.prototype.has = $S;
eo.prototype.set = FS;
var Vh = eo, zS = "__lodash_hash_undefined__";
function US(t) {
  return this.__data__.set(t, zS), this;
}
var HS = US;
function YS(t) {
  return this.__data__.has(t);
}
var jS = YS, VS = Vh, qS = HS, WS = jS;
function Xc(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new VS(); ++e < n; )
    this.add(t[e]);
}
Xc.prototype.add = Xc.prototype.push = qS;
Xc.prototype.has = WS;
var GS = Xc;
function XS(t, e, n, a) {
  for (var i = t.length, r = n + (a ? 1 : -1); a ? r-- : ++r < i; )
    if (e(t[r], r, t))
      return r;
  return -1;
}
var ZS = XS;
function KS(t) {
  return t !== t;
}
var QS = KS;
function JS(t, e, n) {
  for (var a = n - 1, i = t.length; ++a < i; )
    if (t[a] === e)
      return a;
  return -1;
}
var eC = JS, tC = ZS, nC = QS, aC = eC;
function iC(t, e, n) {
  return e === e ? aC(t, e, n) : tC(t, nC, n);
}
var rC = iC, sC = rC;
function oC(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && sC(t, e, 0) > -1;
}
var lC = oC;
function cC(t, e, n) {
  for (var a = -1, i = t == null ? 0 : t.length; ++a < i; )
    if (n(e, t[a]))
      return !0;
  return !1;
}
var uC = cC;
function dC(t, e) {
  return t.has(e);
}
var hC = dC, fC = Hr, pC = oi, mC = fC(pC, "Set"), v2 = mC;
function gC() {
}
var bC = gC;
function vC(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(a) {
    n[++e] = a;
  }), n;
}
var y2 = vC, Xd = v2, yC = bC, _C = y2, xC = 1 / 0, TC = Xd && 1 / _C(new Xd([, -0]))[1] == xC ? function(t) {
  return new Xd(t);
} : yC, wC = TC, kC = GS, SC = lC, CC = uC, AC = hC, EC = wC, LC = y2, DC = 200;
function IC(t, e, n) {
  var a = -1, i = SC, r = t.length, s = !0, o = [], l = o;
  if (n)
    s = !1, i = CC;
  else if (r >= DC) {
    var c = e ? null : EC(t);
    if (c)
      return LC(c);
    s = !1, i = AC, l = new kC();
  } else
    l = e ? [] : o;
  e:
    for (; ++a < r; ) {
      var d = t[a], f = e ? e(d) : d;
      if (d = n || d !== 0 ? d : 0, s && f === f) {
        for (var g = l.length; g--; )
          if (l[g] === f)
            continue e;
        e && l.push(f), o.push(d);
      } else i(l, f, n) || (l !== o && l.push(f), o.push(d));
    }
  return o;
}
var MC = IC, OC = MC;
function PC(t) {
  return t && t.length ? OC(t) : [];
}
var BC = PC;
const RC = /* @__PURE__ */ xa(BC), NC = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-checkbox"
};
function $C(t, e) {
  return h(), b("svg", NC, e[0] || (e[0] = [
    k("path", {
      d: "M5 6.5v20c0 .2761.22386.5.5.5h20c.2761 0 .5-.2239.5-.5v-20c0-.27614-.2239-.5-.5-.5h-20c-.27614 0-.5.22386-.5.5Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m9.5 17.5722 3.1522 3.1523L21.3767 12",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const _2 = { render: $C }, FC = { class: "base-checkbox-group" }, zC = { class: "list" }, UC = { class: "label" }, HC = ["value", "checked", "onChange"], YC = /* @__PURE__ */ Ae({
  __name: "BaseCheckboxGroup",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J(RC([...n.selected]));
    function r(s) {
      const o = i.value.indexOf(s);
      o > -1 ? i.value.splice(o, 1) : i.value.push(s), a("update:selected", i.value), a("input-selected");
    }
    return (s, o) => (h(), b("fieldset", FC, [
      k("ul", zC, [
        (h(!0), b(me, null, Ee(t.items, (l, c) => (h(), b("li", {
          key: `BaseCheckboxGroup${c}`,
          class: "list-item"
        }, [
          k("label", UC, [
            k("input", {
              type: "checkbox",
              value: l.name,
              checked: i.value.includes(l.name),
              class: "input",
              onChange: (d) => r(l.name)
            }, null, 40, HC),
            Q(O(_2), { class: "svg" }),
            Ye(" " + ae(l.name), 1)
          ])
        ]))), 128))
      ])
    ]));
  }
}), Fm = /* @__PURE__ */ be(YC, [["__scopeId", "data-v-72c6c3f9"]]), jC = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-radio-button"
};
function VC(t, e) {
  return h(), b("svg", jC, e[0] || (e[0] = [
    k("path", {
      d: "M15.9998 9.8645L20.1701 11.6219L21.8975 15.8645L20.1701 20.1071L15.9998 21.8645L11.8295 20.1071L10.1021 15.8645L11.8295 11.6219L15.9998 9.8645Z",
      fill: "#0AA5FF",
      class: "svg__fill--default-cyan-03"
    }, null, -1),
    k("path", {
      d: "M10.5626 10.3216L15.9998 8.03037L21.437 10.3216L23.6938 15.8644L21.437 21.4072L15.9998 23.6985L10.5626 21.4072L8.30585 15.8644L10.5626 10.3216Z",
      stroke: "#0B6AB7",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const qC = { render: VC }, WC = { class: "base-radio-group" }, GC = { class: "list" }, XC = { class: "list-item" }, ZC = ["value", "onChange"], KC = /* @__PURE__ */ Ae({
  __name: "BaseRadioGroup",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = e, a = J(t.selected && t.selected.length > 0 ? t.selected[0] : "");
    function i(r) {
      console.log("what is slected", r), n("update:selected", [r]), n("input-selected");
    }
    return (r, s) => (h(), b("fieldset", WC, [
      k("ul", GC, [
        k("li", XC, [
          (h(!0), b(me, null, Ee(t.items, (o, l) => (h(), b("label", {
            key: `BaseRadioGroup${l}`,
            class: "label"
          }, [
            kt(k("input", {
              "onUpdate:modelValue": s[0] || (s[0] = (c) => a.value = c),
              type: "radio",
              value: o.name,
              class: "input",
              onChange: (c) => i(o.name)
            }, null, 40, ZC), [
              [Nc, a.value]
            ]),
            Q(O(qC), { class: "svg" }),
            Ye(" " + ae(o.name), 1)
          ]))), 128))
        ])
      ])
    ]));
  }
}), QC = /* @__PURE__ */ be(KC, [["__scopeId", "data-v-bef475e2"]]), JC = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-share-printer"
};
function x2(t, e) {
  return h(), b("svg", JC, e[0] || (e[0] = [
    ri('<circle cx="16" cy="16" r="16" fill="#F2F2F2" class="svg__fill--secondary-grey-01"></circle><path d="M7 21.1984h-.75c0 .4142.33579.75.75.75v-.75Zm0-8.1205v-.75c-.41421 0-.75.3358-.75.75H7Zm18 0h.75c0-.4142-.3358-.75-.75-.75v.75Zm0 8.1205v.75c.4142 0 .75-.3358.75-.75H25Zm-16.29837.75h.75v-1.5h-.75v1.5Zm14.57147-1.5h-.75v1.5h.75v-1.5Zm-15.5231.75v-8.1205h-1.5v8.1205h1.5ZM7 13.8279h18v-1.5H7v1.5Zm17.25-.75v8.1205h1.5v-8.1205h-1.5ZM8.70163 20.4484H7v1.5h1.70163v-1.5Zm16.29837 0h-1.7269v1.5H25v-1.5Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M11.4482 18.7737v6.5454h9.0013v-6.5454h-9.0013Z" stroke="#0F0F0F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--black"></path><path d="M13.5213 21.0669h4.8821" stroke="#0F0F0F" class="svg__stroke--black"></path><path d="M13.5213 22.812h2.99" stroke="#0F0F0F" class="svg__stroke--black"></path><path d="M10.6306 16.4412h1.6243" stroke="#0F0F0F" stroke-width="1.25" class="svg__stroke--black"></path><path d="M9.86359 8.68115v4.41055H22.5071V8.68115H9.86359Z" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--black"></path>', 7)
  ]));
}
const T2 = { render: x2 }, w2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T2,
  render: x2
}, Symbol.toStringTag, { value: "Module" })), eA = { class: "block-amenities" }, tA = { class: "amenity-column" }, nA = { class: "amenities-list" }, aA = { class: "amenity-name" }, iA = /* @__PURE__ */ Ae({
  __name: "BlockAmenities",
  props: {
    amenities: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = ge(
      () => import("./icon-clock-CG3EE-5W.js")
    ), a = ge(
      () => import("./icon-accessible-C8Gup1rK.js")
    ), i = ge(
      () => import("./icon-chair-D8fW8Dnx.js")
    ), r = ge(
      () => import("./icon-virtual-CwZieS3s.js")
    ), s = ge(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ), o = ge(
      () => import("./icon-locker-BBQPsbYg.js")
    ), l = ge(
      () => import("./icon-light-wkkuRssP.js")
    ), c = ge(
      () => import("./icon-book-Dhs3bbZ0.js")
    ), d = {
      "icon-clock": {
        icon: n,
        label: "24 Hour Study Space"
      },
      "icon-accessible": {
        icon: a,
        label: "ADA Stations"
      },
      "icon-chair": {
        icon: i,
        label: "Cafe"
      },
      "icon-virtual": {
        icon: r,
        label: "Computer/Laptop Access"
      },
      "icon-laptop": {
        icon: s,
        label: "Laptop Lending"
      },
      "icon-locker": {
        icon: o,
        label: "Locker"
      },
      "icon-light": {
        icon: l,
        label: "Makerspace"
      },
      "icon-share-printer": {
        icon: T2,
        label: "Print, Copy and Scan"
      },
      "icon-book": {
        icon: c,
        label: "Research Help"
      }
    }, f = I(() => e.amenities.map((g) => {
      const _ = d[g];
      return {
        svgIcon: _.icon,
        svgLabel: _.label
      };
    }));
    return (g, _) => (h(), b("div", eA, [
      _[0] || (_[0] = k("h3", { class: "amenities-title" }, " At This Location ", -1)),
      k("div", tA, [
        k("ul", nA, [
          (h(!0), b(me, null, Ee(f.value, (x, p) => (h(), b("li", {
            key: `${x.svgLabel}-${p}`,
            class: "amenitiy-row"
          }, [
            x.svgIcon ? (h(), Z(ut(x.svgIcon), { key: 0 })) : E("", !0),
            k("span", aA, ae(x.svgLabel), 1)
          ]))), 128))
        ])
      ])
    ]));
  }
}), z0e = /* @__PURE__ */ be(iA, [["__scopeId", "data-v-41576e56"]]), rA = {
  name: "ModalGeneric",
  components: {
    SvgGlyphClose: Or
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    }
  }
}, sA = { class: "content" };
function oA(t, e, n, a, i, r) {
  const s = ot("SvgGlyphClose");
  return h(), b("div", {
    class: "modal",
    onClick: e[1] || (e[1] = (...o) => r.close && r.close(...o))
  }, [
    k("button", {
      class: "svg-glyph-close",
      onClick: e[0] || (e[0] = (...o) => r.close && r.close(...o))
    }, [
      Q(s)
    ]),
    k("div", sA, [
      xe(t.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const lA = /* @__PURE__ */ be(rA, [["render", oA], ["__scopeId", "data-v-9eea23da"]]), cA = {
  name: "BlockCampusMap",
  components: {
    ModalGeneric: lA,
    RichText: un
  },
  props: {
    campusLocationId: {
      type: String,
      default: ""
    },
    locationName: {
      type: String,
      default: ""
    },
    buildingAccess: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isModalVisible: !1
    };
  },
  computed: {
    parsedSrc() {
      return `https://map.ucla.edu/?id=${this.campusLocationId}&e=true`;
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = !0;
    },
    closeModal() {
      this.isModalVisible = !1;
    }
  }
}, uA = { class: "block-campus-map" }, dA = { class: "modal-content" }, hA = ["src"], fA = { class: "content" }, pA = { class: "iframe-hover" }, mA = { class: "iframe-container" }, gA = ["src"], bA = {
  key: 0,
  class: "text-grouping"
};
function vA(t, e, n, a, i, r) {
  const s = ot("ModalGeneric"), o = ot("RichText");
  return h(), b("div", uA, [
    kt(Q(s, {
      class: "modal",
      onClose: r.closeModal
    }, {
      default: ce(() => [
        k("div", dA, [
          k("iframe", {
            src: r.parsedSrc,
            class: "iframe-modal",
            allowfullscreen: ""
          }, null, 8, hA)
        ])
      ]),
      _: 1
    }, 8, ["onClose"]), [
      [ga, i.isModalVisible]
    ]),
    k("button", {
      class: "title",
      onClick: e[0] || (e[0] = (...l) => r.showModal && r.showModal(...l))
    }),
    k("div", fA, [
      k("div", pA, [
        k("div", mA, [
          k("iframe", {
            src: r.parsedSrc,
            class: "iframe",
            allowfullscreen: ""
          }, null, 8, gA),
          k("div", {
            class: "iframe-click",
            onClick: e[1] || (e[1] = (...l) => r.showModal && r.showModal(...l))
          })
        ])
      ]),
      n.buildingAccess ? (h(), b("div", bA, [
        e[2] || (e[2] = k("h4", { class: "subheading-small" }, " Building Access ", -1)),
        Q(o, {
          class: "building-access-text",
          "rich-text-content": n.buildingAccess
        }, null, 8, ["rich-text-content"])
      ])) : E("", !0)
    ])
  ]);
}
const U0e = /* @__PURE__ */ be(cA, [["render", vA], ["__scopeId", "data-v-a75f1f8c"]]), yA = [
  {
    id: "843",
    name: "Locations & Hours",
    to: "/locations",
    classes: "",
    target: ""
  },
  {
    id: "844",
    name: "Ask a Librarian",
    to: "/research-teaching-support/research-help",
    classes: null,
    target: ""
  },
  {
    id: "845",
    name: "My Account",
    to: "https://catalog.library.ucla.edu/vwebv/login;jsessionid=9D14C6523970C30728D965F6BD6B914D",
    classes: null,
    target: "1"
  }
], _A = [
  {
    id: "835",
    name: "Get help with...",
    to: null,
    classes: "",
    target: "",
    children: [
      {
        id: "833",
        name: "Borrowing Books and Equipment",
        to: "/help/services-resources/borrowing-books-and-equipment",
        classes: "",
        target: ""
      },
      {
        id: "840",
        name: "All Services & Resources",
        to: "/help/services-resources",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "834",
    name: "Visit",
    to: "/events-exhibits",
    classes: null,
    target: "",
    children: [
      {
        id: "841",
        name: "Locations & Hours",
        to: "/visit/locations",
        classes: "",
        target: ""
      },
      {
        id: "837",
        name: "Events & Exhibitions",
        to: "/visit/events-exhibits",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "836",
    name: "About",
    to: null,
    classes: null,
    target: "",
    children: [
      {
        id: "842",
        name: "Library News",
        to: "/about/news",
        classes: "",
        target: ""
      },
      {
        id: "838",
        name: "Staff Directory",
        to: "/about/staff",
        classes: "",
        target: ""
      }
    ]
  },
  {
    id: "839",
    name: "Support us",
    to: "https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=463",
    classes: null,
    target: "1",
    children: []
  }
], zm = {
  socialItems: [
    {
      id: "11777",
      name: "Twitter",
      to: "https://twitter.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11778",
      name: "Facebook",
      to: "https://www.facebook.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11779",
      name: "Instagram",
      to: "https://www.instagram.com/",
      classes: null,
      target: "1"
    },
    {
      id: "11780",
      name: "YouTube",
      to: "https://www.youtube.com/",
      classes: null,
      target: "1"
    }
  ],
  pressItems: [
    {
      id: "11781",
      name: "Dress Doom",
      to: "https://test-craft.library.ucla.edu/press-room",
      classes: null,
      target: ""
    },
    {
      id: "11782",
      name: "Careers at USC",
      to: "https://test-craft.library.ucla.edu/careers-at-ucla",
      classes: null,
      target: ""
    }
  ]
}, xA = {
  nodes: [
    {
      id: "1628",
      name: "EEEmergency",
      to: "/emergency",
      classes: null
    },
    {
      id: "1627",
      name: "AAAccessibility",
      to: "https://external.url/accessibility",
      classes: null
    },
    {
      id: "1629",
      name: "PPPrivacy & Terms of Use",
      to: "https://test-craft.library.ucla.edu/privacy-terms-of-use",
      classes: null,
      target: "0"
    },
    {
      id: "9511",
      name: "CCCreative Commons Attribution 4.0",
      to: "https://creativecommons.org/licenses/by/4.0/",
      classes: null,
      target: "1"
    }
  ]
}, TA = {
  funders: [
    {
      id: "28231",
      funderLogo: [
        {
          id: "28636",
          src: "https://static.library.ucla.edu/craftassetstest/logo-arcadia1.svg",
          height: 569,
          width: 2560,
          srcset: "https://static.library.ucla.edu/craftassetstest/_375xAUTO_crop_center-center_none/logo-arcadia1.svg 375w, https://static.library.ucla.edu/craftassetstest/_960xAUTO_crop_center-center_none/logo-arcadia1.svg 960w, https://static.library.ucla.edu/craftassetstest/_1280xAUTO_crop_center-center_none/logo-arcadia1.svg 1280w, https://static.library.ucla.edu/craftassetstest/_1920xAUTO_crop_center-center_none/logo-arcadia1.svg 1920w, https://static.library.ucla.edu/craftassetstest/_2560xAUTO_crop_center-center_none/logo-arcadia1.svg 2560w",
          alt: "Logo arcadia1",
          focalPoint: [0.5, 0.5]
        }
      ],
      funderName: "Arcadiaaaaaa",
      funderUrl: "https://www.hostesscakes.com/produ        colate/"
    },
    {
      id: "28259",
      funderLogo: [
        {
          id: "28637",
          src: "https://static.library.ucla.edu/craftassetstest/logo-library.svg",
          height: 490,
          width: 2560,
          srcset: "https://static.library.ucla.edu/craftassetstest/_375xAUTO_crop_center-center_none/logo-library.svg 375w, https://static.library.ucla.edu/craftassetstest/_960xAUTO_crop_center-center_none/logo-library.svg 960w, https://static.library.ucla.edu/craftassetstest/_1280xAUTO_crop_center-center_none/logo-library.svg 1280w, https://static.library.ucla.edu/craftassetstest/_1920xAUTO_crop_center-center_none/logo-library.svg 1920w, https://static.library.ucla.edu/craftassetstest/_2560xAUTO_crop_center-center_none/logo-library.svg 2560w",
          alt: "Logo library",
          focalPoint: [0.5, 0.5]
        }
      ],
      funderName: "Etch A Sketch",
      funderUrl: "https://en.wikipedia.org/wiki/Etch_A_Sketch"
    }
  ]
}, Tc = {
  // links: [
  //   { title: 'About', links: mockFooterLinks.aboutLinks },
  // ]
  aboutLinks: [
    {
      id: "1623",
      name: "About the Library",
      to: "/about",
      classes: null
    },
    {
      id: "1624",
      name: "Library News",
      to: "/about/news",
      classes: null
    },
    {
      id: "1625",
      name: "Staff Directory",
      to: "/about/staff",
      classes: null
    },
    {
      id: "1626",
      name: "Jobs",
      to: "/about/jobs",
      classes: null
    }
  ],
  contactLinks: [
    {
      id: "1620",
      name: "Contact Us",
      to: "/help",
      classes: null
    },
    {
      id: "1621",
      name: "Ask a Librarian",
      to: "/research-teaching-support/research-help",
      classes: null
    },
    {
      id: "1622",
      name: "Locations & Hours",
      to: "/locations",
      classes: null
    }
  ],
  contributeLinks: [
    {
      id: "1617",
      name: "Support the Library",
      to: "https://giving.ucla.edu/Standard/NetDonate.aspx?SiteNum=463",
      classes: null
    },
    {
      id: "1618",
      name: "Volunteer",
      to: "/about/jobs/volunteer",
      classes: null
    },
    {
      id: "1619",
      name: "Give Feedback",
      to: "/help/feedback",
      classes: null
    }
  ],
  resourcesLinks: [
    {
      id: "1614",
      name: "Services & Resources",
      to: "/help/services-resources",
      classes: null
    },
    {
      id: "1615",
      name: "Research Guides",
      to: "/research-teaching-support/research-guides",
      classes: null
    },
    {
      id: "1616",
      name: "Digital Collections",
      to: "/collections/digital-collections",
      classes: null
    }
  ]
}, to = N4("GlobalStore", {
  state: () => ({
    winHeight: 0,
    winWidth: 824,
    sTop: 0,
    globals: {
      askALibrarian: {
        id: "7322",
        askALibrarianTitle: "Have further questions?",
        askALibrarianText: "<p>We're here to help. Chat with a librarian 24/7, schedule a research consultation or email us your quick questions.</p>",
        buttonUrl: [
          {
            buttonText: "Contact us",
            buttonUrl: "/help/"
          }
        ]
      },
      meapCallToAction: {
        id: "28646",
        name: "MEAP Call to Action",
        titleGeneral: "Get in Touch",
        summary: "<p>Have further questions?</p>",
        button: [
          {
            buttonText: "Contact Us",
            buttonUrl: "mailto:meap@library.ucla.edu"
          }
        ]
      },
      ftvaViewingInformation: {
        title: "View information",
        text: '<p>For more information, or to arrange on-site research viewing, please contact the <a href="https://www.cinema.ucla.edu/archive-research-study-center" target="_blank" rel="noreferrer noopener">Archive Research and Study Center (ARSC)</a></p>'
      }
    },
    header: {
      primary: _A,
      secondary: yA
    },
    footerPrimary: {
      nodes: [
        {
          children: zm.socialItems
        },
        {
          children: zm.pressItems
        }
      ]
    },
    footerSock: {
      nodes: xA.nodes
    },
    footerSponsor: {
      funders: TA.funders
    },
    footerLinks: {
      nodes: [
        {
          category: "About",
          children: Tc.aboutLinks
        },
        {
          category: "Contact",
          children: Tc.contactLinks
        },
        {
          category: "Contribute",
          children: Tc.contributeLinks
        },
        {
          category: "Resources",
          children: Tc.resourcesLinks
        }
      ]
    }
  }),
  getters: {}
}), wA = {
  key: 0,
  class: "title"
}, kA = { key: 0 }, SA = /* @__PURE__ */ Ae({
  __name: "BlockCallToAction",
  props: {
    svgName: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isDark: {
      type: Boolean,
      default: !1
    },
    isSmallSize: {
      type: Boolean,
      default: !1
    },
    isCentered: {
      type: Boolean,
      default: !0
    },
    isGlobal: {
      type: Boolean,
      default: !1
    },
    isMeapGlobal: {
      type: Boolean,
      default: !1
    },
    useGlobalData: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = ge(
      () => import("./call-to-action-chat-wKFtbg67.js")
    ), a = ge(
      () => import("./call-to-action-find-DePPosGW.js")
    ), i = ge(
      () => import("./call-to-action-mail-jFaR-5w7.js")
    ), r = ge(
      () => import("./call-to-action-money-s0xuiara.js")
    ), s = ge(
      () => import("./icon-ftva-external-link-dark-B_Y0Do4N.js")
    ), o = ge(
      () => import("./icon-ftva-info-BFnfBdSM.js")
    ), l = ge(
      () => import("./icon-ftva-pdf-D_o__FZL.js")
    ), c = {
      "svg-call-to-action-chat": {
        icon: n,
        label: "CTA Chat"
      },
      "svg-call-to-action-find": {
        icon: a,
        label: "CTA Find"
      },
      "svg-call-to-action-ftva-external-link-dark": {
        icon: s,
        label: "CTA FTVA External Link"
      },
      "svg-call-to-action-ftva-info": {
        icon: o,
        label: "CTA FTVA Info"
      },
      "svg-call-to-action-ftva-pdf": {
        icon: l,
        label: "CTA FTVA PDF"
      },
      "svg-call-to-action-mail": {
        icon: i,
        label: "CTA Mail"
      },
      "svg-call-to-action-money": {
        icon: r,
        label: "CTA Money"
      }
    }, d = to(), f = I(() => d.globals.askALibrarian), g = I(() => d.globals.meapCallToAction), _ = I(() => d.globals.ftvaViewingInformation), x = Ge(), p = I(() => {
      var C;
      return e.isGlobal ? {
        to: f.value.buttonUrl[0].buttonUrl,
        title: f.value.askALibrarianTitle,
        text: f.value.askALibrarianText,
        label: f.value.buttonUrl[0].buttonText,
        svgName: c["svg-call-to-action-chat"].icon
      } : e.isMeapGlobal ? {
        to: g.value.button[0].buttonUrl,
        title: g.value.titleGeneral,
        text: g.value.summary,
        label: g.value.button[0].buttonText,
        svgName: c["svg-call-to-action-chat"].icon
      } : e.useGlobalData && (x == null ? void 0 : x.value) === "ftva" ? {
        title: _.value.title,
        text: _.value.text,
        svgName: c["svg-call-to-action-ftva-info"].icon
      } : {
        to: e.to,
        title: e.title,
        text: e.text,
        label: e.name,
        svgName: e.svgName ? (C = c[e.svgName]) == null ? void 0 : C.icon : void 0
        // Allow undefined
      };
    }), w = I(() => [
      "block-call-to-action",
      { "full-width": !e.isSmallSize },
      { "half-width": e.isSmallSize },
      { "theme-light": !e.isDark },
      { "theme-dark": e.isDark },
      { "slim-left-align": !e.isCentered },
      // For FTVA SlimCTA
      (x == null ? void 0 : x.value) || ""
    ]);
    return (C, M) => (h(), b("div", {
      class: se(w.value)
    }, [
      (h(), Z(ut(p.value.svgName), {
        class: "svg",
        "aria-hidden": "true"
      })),
      k("div", null, [
        e.title || p.value.title ? (h(), b("h2", wA, ae(p.value.title), 1)) : E("", !0),
        Q(un, {
          class: se([{ "ftva-global-data": e.useGlobalData && O(x) === "ftva" }, "text"]),
          "rich-text-content": p.value.text
        }, null, 8, ["class", "rich-text-content"])
      ]),
      p.value.to && p.value.label ? (h(), b("div", kA, [
        !e.isDark && O(x) !== "ftva" ? (h(), Z(cn, {
          key: 0,
          label: p.value.label,
          to: p.value.to,
          "is-secondary": !0,
          class: "button-link"
        }, null, 8, ["label", "to"])) : E("", !0),
        e.isDark && O(x) !== "ftva" ? (h(), Z(cn, {
          key: 1,
          label: p.value.label,
          to: p.value.to,
          "is-tertiary": !0,
          class: "button-link"
        }, null, 8, ["label", "to"])) : E("", !0),
        !e.isDark && O(x) === "ftva" ? (h(), Z(cn, {
          key: 2,
          label: p.value.label,
          to: p.value.to,
          "icon-name": "none",
          class: "button-link"
        }, null, 8, ["label", "to"])) : E("", !0),
        e.isDark && O(x) === "ftva" ? (h(), Z(cn, {
          key: 3,
          label: p.value.label,
          to: p.value.to,
          "is-tertiary": !0,
          "icon-name": "none",
          class: "button-link"
        }, null, 8, ["label", "to"])) : E("", !0)
      ])) : E("", !0)
    ], 2));
  }
}), qh = /* @__PURE__ */ be(SA, [["__scopeId", "data-v-8568fb2b"]]), CA = { class: "block-call-to-action-two-up" }, AA = /* @__PURE__ */ Ae({
  __name: "BlockCallToActionTwoUp",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", CA, [
      (h(!0), b(me, null, Ee(t.items, (a, i) => (h(), Z(qh, {
        key: `BlockCallToActionTwoUpKey${i}`,
        "svg-name": a.svgName,
        title: a.title,
        text: a.text,
        name: a.name,
        to: a.to,
        "is-dark": a.isDark,
        "is-small-size": !0
      }, null, 8, ["svg-name", "title", "text", "name", "to", "is-dark"]))), 128))
    ]));
  }
}), H0e = /* @__PURE__ */ be(AA, [["__scopeId", "data-v-5f23f2ae"]]);
function EA(t = "") {
  return new Date(t).toLocaleDateString("en-us", { weekday: "long" });
}
function k2(t = "") {
  return Nt(new Date(t), "MMM");
}
const LA = { class: "day-month-date" }, DA = ["innerHTML"], IA = { class: "month-date" }, MA = ["innerHTML"], OA = ["innerHTML"], PA = { class: "image-block" }, BA = {
  key: 1,
  class: "molecule-no-image"
}, RA = { class: "meta" }, NA = /* @__PURE__ */ Ae({
  __name: "BlockCardThreeColumn",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    to: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = Ge(), a = I(() => ["block-card-three-column", (n == null ? void 0 : n.value) || ""]), i = I(() => e.startDate ? EA(e.startDate) : ""), r = I(() => e.startDate ? k2(e.startDate) : ""), s = I(() => e.startDate ? Nt(new Date(e.startDate), "d") : ""), o = I(() => (n == null ? void 0 : n.value) === "ftva" ? "short" : "long");
    return (l, c) => (h(), b("li", {
      class: se(a.value)
    }, [
      k("div", LA, [
        t.startDate ? (h(), b("time", {
          key: 0,
          class: "day",
          innerHTML: i.value
        }, null, 8, DA)) : E("", !0),
        k("div", IA, [
          t.startDate ? (h(), b("time", {
            key: 0,
            class: "month",
            innerHTML: r.value
          }, null, 8, MA)) : E("", !0),
          t.startDate ? (h(), b("time", {
            key: 1,
            innerHTML: s.value
          }, null, 8, OA)) : E("", !0)
        ])
      ]),
      k("div", PA, [
        t.image ? (h(), Z(dn, {
          key: 0,
          media: t.image,
          class: "image"
        }, null, 8, ["media"])) : (h(), b("div", BA, [
          Q(O(Zs), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      k("div", RA, [
        Q($u, {
          class: "card-meta-items",
          to: t.to,
          title: t.title,
          "start-date": t.startDate,
          "end-date": t.endDate,
          "date-format": o.value
        }, {
          floatingslot: ce(() => [
            (h(!0), b(me, null, Ee(t.tagLabels, (d, f) => (h(), b("div", {
              key: `${d.title}-${f}`
            }, [
              Q(Ks, {
                label: d.title,
                "is-secondary": !0,
                "is-highlighted": d.isHighlighted
              }, null, 8, ["label", "is-highlighted"])
            ]))), 128))
          ]),
          _: 1
        }, 8, ["to", "title", "start-date", "end-date", "date-format"])
      ])
    ], 2));
  }
}), $A = /* @__PURE__ */ be(NA, [["__scopeId", "data-v-b83d1b57"]]), FA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $A
}, Symbol.toStringTag, { value: "Module" })), zA = {
  width: "200",
  height: "160",
  viewBox: "0 0 200 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__illustration-digitized-resources"
};
function UA(t, e) {
  return h(), b("svg", zA, e[0] || (e[0] = [
    ri('<path d="M9.08984 113.223H190.91V131.489C190.91 135.493 187.664 138.739 183.66 138.739H115.956H83.8441H16.3398C12.3358 138.739 9.08984 135.493 9.08984 131.489V113.223Z" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M83.791 139.489V155M116.002 139.489V155M116.002 155H135.066M116.002 155H83.791M83.791 155H65.3848" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M14.3398 5.75H185.66C188.56 5.75 190.91 8.10051 190.91 11V113.253H9.08984V11C9.08984 8.10051 11.4403 5.75 14.3398 5.75Z" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></path><path d="M185.176 19.3555L157.085 30.991L145.45 59.0816L157.085 87.1723L185.176 98.8078" stroke="#FFD600" stroke-width="1.5" class="svg__stroke--secondary-yellow-03"></path><path d="M17.7856 10.9407H182.213C184.008 10.9407 185.463 12.3957 185.463 14.1907V103.971C185.463 105.766 184.008 107.221 182.213 107.221H17.7856C15.9907 107.221 14.5356 105.766 14.5356 103.971V14.1907C14.5356 12.3957 15.9907 10.9407 17.7856 10.9407Z" stroke="#0AA5FF" stroke-width="1.5" class="svg__stroke--default-cyan-03"></path><path d="M99.9953 131.954L104.221 130.204L105.971 125.979L104.221 121.754L99.9953 120.003L95.7701 121.754L94.02 125.979L95.7701 130.204L99.9953 131.954Z" fill="#0AA5FF" class="svg__fill--default-cyan-03"></path><path d="M44.4458 35.502H84.4458" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 41.502H84.4458" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 47.502L84.4458 47.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 53.502L84.4458 53.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 59.502L75.4405 59.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 71.502L84.4458 71.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 77.502L84.4458 77.5019" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M44.4458 83.502L68.388 83.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 41.502H116.446" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 35.502H116.446" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 47.502H105.364" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 59.502L116.446 59.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 65.502L116.446 65.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 71.502L116.446 71.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 77.502L116.446 77.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path><path d="M92.4458 83.502L112.79 83.502" stroke="#00E0E0" stroke-width="1.5" class="svg__stroke--help-green-03"></path>', 22)
  ]));
}
const HA = { render: UA }, YA = {
  width: "200",
  height: "160",
  viewBox: "0 0 200 160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__illustration-teaching"
};
function jA(t, e) {
  return h(), b("svg", YA, e[0] || (e[0] = [
    ri('<path d="M98.6874 4.74365L99.414 4.55781C99.3291 4.22585 99.03 3.99364 98.6874 3.99365C98.3447 3.99366 98.0457 4.22589 97.9608 4.55785L98.6874 4.74365ZM97.9608 4.92949L132.152 138.616L133.606 138.244L99.414 4.55781L97.9608 4.92949ZM132.158 138.635L136.786 154.948L138.229 154.539L133.601 138.225L132.158 138.635ZM97.9608 4.55785L63.7763 138.244L65.2295 138.616L99.414 4.92945L97.9608 4.55785ZM63.7814 138.225L59.1535 154.539L60.5965 154.948L65.2244 138.635L63.7814 138.225ZM132.879 137.68H64.5029V139.18H132.879V137.68Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><rect x="91.8477" y="16.0012" width="13.6887" height="8.52157" fill="white" class="svg__fill--white"></rect><rect x="15.6284" y="24.1885" width="168.77" height="101.715" rx="1.25" fill="white" stroke="#0B6AB7" stroke-width="1.5" class="svg__fill--white svg__stroke--primary-blue-03"></rect><rect x="15.6284" y="16.5989" width="168.77" height="7.17405" rx="1.25" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="18.8344" y="19.5251" width="162.503" height="1.35532" rx="0.67766" stroke="#0AA5FF" stroke-width="1.35532" class="svg__stroke--default-cyan-03"></rect><path d="M118.251 50.2215H120.732C121.642 50.2215 122.379 50.9586 122.379 51.8678V99.3356C122.379 100.245 121.642 100.982 120.732 100.982H116.912H82.5513C82.5513 100.982 77.6423 100.982 77.6426 95.5711M118.251 50.2215V89.9373C118.251 89.9373 90.4163 89.9373 82.5513 89.9373C82.5513 89.9373 77.6428 90.1604 77.6426 95.5711M118.251 50.2215V46.0938H85.8739C81.3279 46.0938 77.6426 49.779 77.6426 54.3251V95.5711" stroke="#0B6AB7" stroke-width="1.25" class="svg__stroke--primary-blue-03"></path><path d="M98.7616 58.0586L106.301 61.1814L109.424 68.7206L106.301 76.2598L98.7616 79.3826L91.2224 76.2598L88.0996 68.7206L91.2224 61.1814L98.7616 58.0586Z" stroke="#FFD600" stroke-width="1.25" class="svg__stroke--secondary-yellow-03"></path><path d="M84.665 96.2986L106.396 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M108.205 96.2986L112.156 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M113.8 96.2986L115.117 96.2986" stroke="#00E0E0" stroke-width="1.25" class="svg__stroke--help-green-03"></path><path d="M94.3551 101.378L98.6348 104.292C98.6591 104.309 98.6921 104.291 98.6921 104.262V95.6572H90.0181V104.262C90.0181 104.291 90.051 104.309 90.0754 104.292L94.3551 101.378Z" fill="#0AA5FF" class="svg__fill--default-cyan-03"></path>', 11)
  ]));
}
const VA = { render: jA };
function qA(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
    i[n] = e(t[n], n, t);
  return i;
}
var S2 = qA, WA = Array.isArray, ar = WA;
function GA(t) {
  return t != null && typeof t == "object";
}
var ir = GA, XA = zr, ZA = ir, KA = "[object Symbol]";
function QA(t) {
  return typeof t == "symbol" || ZA(t) && XA(t) == KA;
}
var Yu = QA, Um = Il, JA = S2, eE = ar, tE = Yu, Hm = Um ? Um.prototype : void 0, Ym = Hm ? Hm.toString : void 0;
function C2(t) {
  if (typeof t == "string")
    return t;
  if (eE(t))
    return JA(t, C2) + "";
  if (tE(t))
    return Ym ? Ym.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var A2 = C2;
function nE(t, e, n) {
  var a = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), n = n > i ? i : n, n < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var r = Array(i); ++a < i; )
    r[a] = t[a + e];
  return r;
}
var E2 = nE, aE = E2;
function iE(t, e, n) {
  var a = t.length;
  return n = n === void 0 ? a : n, !e && n >= a ? t : aE(t, e, n);
}
var rE = iE, sE = "\\ud800-\\udfff", oE = "\\u0300-\\u036f", lE = "\\ufe20-\\ufe2f", cE = "\\u20d0-\\u20ff", uE = oE + lE + cE, dE = "\\ufe0e\\ufe0f", hE = "\\u200d", fE = RegExp("[" + hE + sE + uE + dE + "]");
function pE(t) {
  return fE.test(t);
}
var Wh = pE, mE = zr, gE = ir, bE = "[object RegExp]";
function vE(t) {
  return gE(t) && mE(t) == bE;
}
var yE = vE;
function _E(t) {
  return function(e) {
    return t(e);
  };
}
var ju = _E, Zc = { exports: {} };
Zc.exports;
(function(t, e) {
  var n = f2, a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, r = i && i.exports === a, s = r && n.process, o = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = o;
})(Zc, Zc.exports);
var Vu = Zc.exports, xE = yE, TE = ju, jm = Vu, Vm = jm && jm.isRegExp, wE = Vm ? TE(Vm) : xE, kE = wE;
function SE(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var CE = SE, AE = CE, EE = AE("length"), LE = EE, L2 = "\\ud800-\\udfff", DE = "\\u0300-\\u036f", IE = "\\ufe20-\\ufe2f", ME = "\\u20d0-\\u20ff", OE = DE + IE + ME, PE = "\\ufe0e\\ufe0f", BE = "[" + L2 + "]", z0 = "[" + OE + "]", U0 = "\\ud83c[\\udffb-\\udfff]", RE = "(?:" + z0 + "|" + U0 + ")", D2 = "[^" + L2 + "]", I2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", M2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", NE = "\\u200d", O2 = RE + "?", P2 = "[" + PE + "]?", $E = "(?:" + NE + "(?:" + [D2, I2, M2].join("|") + ")" + P2 + O2 + ")*", FE = P2 + O2 + $E, zE = "(?:" + [D2 + z0 + "?", z0, I2, M2, BE].join("|") + ")", qm = RegExp(U0 + "(?=" + U0 + ")|" + zE + FE, "g");
function UE(t) {
  for (var e = qm.lastIndex = 0; qm.test(t); )
    ++e;
  return e;
}
var HE = UE, YE = LE, jE = Wh, VE = HE;
function qE(t) {
  return jE(t) ? VE(t) : YE(t);
}
var WE = qE;
function GE(t) {
  return t.split("");
}
var XE = GE, B2 = "\\ud800-\\udfff", ZE = "\\u0300-\\u036f", KE = "\\ufe20-\\ufe2f", QE = "\\u20d0-\\u20ff", JE = ZE + KE + QE, eL = "\\ufe0e\\ufe0f", tL = "[" + B2 + "]", H0 = "[" + JE + "]", Y0 = "\\ud83c[\\udffb-\\udfff]", nL = "(?:" + H0 + "|" + Y0 + ")", R2 = "[^" + B2 + "]", N2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", $2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", aL = "\\u200d", F2 = nL + "?", z2 = "[" + eL + "]?", iL = "(?:" + aL + "(?:" + [R2, N2, $2].join("|") + ")" + z2 + F2 + ")*", rL = z2 + F2 + iL, sL = "(?:" + [R2 + H0 + "?", H0, N2, $2, tL].join("|") + ")", oL = RegExp(Y0 + "(?=" + Y0 + ")|" + sL + rL, "g");
function lL(t) {
  return t.match(oL) || [];
}
var cL = lL, uL = XE, dL = Wh, hL = cL;
function fL(t) {
  return dL(t) ? hL(t) : uL(t);
}
var pL = fL, mL = /\s/;
function gL(t) {
  for (var e = t.length; e-- && mL.test(t.charAt(e)); )
    ;
  return e;
}
var bL = gL, vL = bL, yL = /^\s+/;
function _L(t) {
  return t && t.slice(0, vL(t) + 1).replace(yL, "");
}
var xL = _L, TL = xL, Wm = Ur, wL = Yu, Gm = NaN, kL = /^[-+]0x[0-9a-f]+$/i, SL = /^0b[01]+$/i, CL = /^0o[0-7]+$/i, AL = parseInt;
function EL(t) {
  if (typeof t == "number")
    return t;
  if (wL(t))
    return Gm;
  if (Wm(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Wm(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = TL(t);
  var n = SL.test(t);
  return n || CL.test(t) ? AL(t.slice(2), n ? 2 : 8) : kL.test(t) ? Gm : +t;
}
var LL = EL, DL = LL, IL = 1 / 0, ML = 17976931348623157e292;
function OL(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = DL(t), t === IL || t === -1 / 0) {
    var e = t < 0 ? -1 : 1;
    return e * ML;
  }
  return t === t ? t : 0;
}
var PL = OL, BL = PL;
function RL(t) {
  var e = BL(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var NL = RL, $L = A2;
function FL(t) {
  return t == null ? "" : $L(t);
}
var Ml = FL, Xm = A2, zL = rE, UL = Wh, HL = Ur, YL = kE, jL = WE, VL = pL, qL = NL, Zm = Ml, WL = 30, GL = "...", XL = /\w*$/;
function ZL(t, e) {
  var n = WL, a = GL;
  if (HL(e)) {
    var i = "separator" in e ? e.separator : i;
    n = "length" in e ? qL(e.length) : n, a = "omission" in e ? Xm(e.omission) : a;
  }
  t = Zm(t);
  var r = t.length;
  if (UL(t)) {
    var s = VL(t);
    r = s.length;
  }
  if (n >= r)
    return t;
  var o = n - jL(a);
  if (o < 1)
    return a;
  var l = s ? zL(s, 0, o).join("") : t.slice(0, o);
  if (i === void 0)
    return l + a;
  if (s && (o += l.length - o), YL(i)) {
    if (t.slice(o).search(i)) {
      var c, d = l;
      for (i.global || (i = RegExp(i.source, Zm(XL.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(d); )
        var f = c.index;
      l = l.slice(0, f === void 0 ? o : f);
    }
  } else if (t.indexOf(Xm(i), o) != o) {
    var g = l.lastIndexOf(i);
    g > -1 && (l = l.slice(0, g));
  }
  return l + a;
}
var KL = ZL;
const QL = /* @__PURE__ */ xa(KL);
function JL(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var U2 = JL, eD = U2, tD = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, nD = eD(tD), aD = nD, iD = Ml, rD = aD, H2 = /&(?:amp|lt|gt|quot|#39);/g, sD = RegExp(H2.source);
function oD(t) {
  return t = iD(t), t && sD.test(t) ? t.replace(H2, rD) : t;
}
var lD = oD;
const cD = /* @__PURE__ */ xa(lD);
function Ki(t = "", e = Number.POSITIVE_INFINITY) {
  if (t == null)
    return t;
  const n = cD(
    t.replace(/(<([^>]+)>)/gi, "").replace(/"/gi, "")
  );
  return QL(n, {
    length: e,
    omission: "…",
    separator: /\s/
  });
}
const uD = {
  name: "BlockCardWithIllustration",
  components: {
    SmartLink: Ke,
    IllustrationBookBinding: ge(() => import("./illustration-book-binding-CgZ-Lhg2.js")),
    IllustrationBorrowingBooks: ge(() => import("./illustration-borrowing-books-B8qR2SUi.js")),
    IllustrationDatabases: ge(() => import("./illustration-databases-D85yQ2d_.js")),
    IllustrationDigitizedResources: HA,
    /* : defineAsyncComponent(() =>
      import(
        'ucla-library-design-tokens/assets/svgs/illustration-digitized-resources.svg'
      )), */
    IllustrationFindSpace: ge(() => import("./illustration-find-space-Cp5L5B6y.js")),
    IllustrationRemoteAccess: ge(() => import("./illustration-remote-access-B1gfhv8X.js")),
    IllustrationResearch: ge(() => import("./illustration-research-BET8HhYT.js")),
    IllustrationTeaching: VA
    /* : defineAsyncComponent(() =>
      import(
        'ucla-library-design-tokens/assets/svgs/illustration-teaching.svg'
      )), */
  },
  props: {
    iconName: {
      type: String,
      default: "illustration-remote-access"
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    isHorizontal: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classes() {
      return [
        "block-card-with-illustration",
        `color-${this.sectionName}`,
        { "is-horizontal": this.isHorizontal }
      ];
    },
    sectionName() {
      return ha(this.to);
    },
    parsedSvgName() {
      return `${this.iconName}`;
    },
    isExternalLink() {
      return !!this.to.includes("http");
    },
    parsedTextHorizontal() {
      return this.text ? Ki(this.text, 250) : "";
    },
    parsedTextVertical() {
      return this.text ? Ki(this.text) : "";
    }
  }
}, dD = { class: "meta" }, hD = ["innerHTML"], fD = ["innerHTML"], pD = {
  key: 2,
  class: "text"
}, mD = {
  key: 3,
  class: "text"
};
function gD(t, e, n, a, i, r) {
  const s = ot("SmartLink");
  return h(), b("li", {
    class: se(r.classes)
  }, [
    (h(), Z(ut(r.parsedSvgName), {
      class: "svg",
      "aria-hidden": "true"
    })),
    k("div", dD, [
      n.category ? (h(), b("div", {
        key: 0,
        class: "category",
        innerHTML: n.category
      }, null, 8, hD)) : E("", !0),
      n.to ? (h(), Z(s, {
        key: 1,
        to: n.to
      }, {
        default: ce(() => [
          k("h3", {
            class: "title",
            innerHTML: n.title
          }, null, 8, fD)
        ]),
        _: 1
      }, 8, ["to"])) : E("", !0),
      n.isHorizontal ? (h(), b("div", pD, ae(r.parsedTextHorizontal), 1)) : (h(), b("div", mD, ae(r.parsedTextVertical), 1))
    ])
  ], 2);
}
const bD = /* @__PURE__ */ be(uD, [["render", gD], ["__scopeId", "data-v-73a377ce"]]);
function vD(t = "") {
  return Nt(new Date(t), "dd");
}
const yD = { class: "image-container" }, _D = {
  key: 0,
  class: "floating-highlight"
}, xD = {
  key: 1,
  class: "clipped-date"
}, TD = ["innerHTML"], wD = ["innerHTML"], kD = {
  key: 3,
  class: "molecule-no-image"
}, SD = /* @__PURE__ */ Ae({
  __name: "BlockClippedDate",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
      // This will be "visit", "about", "help".
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = $a(), a = I(() => e.color || (n !== void 0 && n.path ? ha(n.path) : "default")), i = I(() => ["block-clipped-date", `color-${a.value}`]), r = I(() => e.startDate ? vD(e.startDate) : ""), s = I(() => e.startDate ? k2(e.startDate) : "");
    return (o, l) => (h(), b("li", {
      class: se(i.value)
    }, [
      k("div", yD, [
        t.startDate ? (h(), b("div", _D)) : E("", !0),
        t.startDate ? (h(), b("div", xD, [
          t.startDate ? (h(), b("time", {
            key: 0,
            class: "month",
            innerHTML: s.value
          }, null, 8, TD)) : E("", !0),
          t.startDate ? (h(), b("time", {
            key: 1,
            class: "day",
            innerHTML: r.value
          }, null, 8, wD)) : E("", !0)
        ])) : E("", !0),
        t.image ? (h(), Z(dn, {
          key: 2,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", kD, [
          Q(O(Zs), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ]))
      ]),
      Q($u, {
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle
      }, null, 8, ["to", "category", "title", "start-date", "end-date", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle"])
    ], 2));
  }
}), CD = /* @__PURE__ */ be(SD, [["__scopeId", "data-v-3b7fb1a0"]]), AD = {
  width: "81",
  height: "80",
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__graphic-chevron-right"
};
function ED(t, e) {
  return h(), b("svg", AD, e[0] || (e[0] = [
    k("path", {
      d: "M8.934 79.601 24.819 41.251M24.817 79.601 40.702 41.251M40.702 79.601 56.587 41.251M56.585 79.601 72.471 41.251",
      stroke: "#0AA5FF",
      "stroke-width": "1.5"
    }, null, -1),
    k("path", {
      d: "M24.819 39.35 8.934 1M40.702 39.35 24.817 1M56.587 39.35 40.702 1M72.471 39.35 56.585 1",
      stroke: "#00E0E0",
      "stroke-width": "1.5",
      class: "svg__stroke--wayfinder"
    }, null, -1)
  ]));
}
const Ol = { render: ED }, LD = {
  name: "BlockDate",
  components: {
    SvgArrowDown: Ol
  },
  // TODO See ticket in internal system for notes on this. TLDR: Use JS date objects
  // Then have date-fns format function as computed to show date and day
  props: {
    date: {
      type: String,
      default: ""
    },
    day: {
      type: String,
      default: ""
    }
  }
}, DD = { class: "block-date" }, ID = { class: "date" }, MD = { class: "day" };
function OD(t, e, n, a, i, r) {
  const s = ot("SvgArrowDown");
  return h(), b("div", DD, [
    Q(s, { class: "svg" }),
    k("div", ID, ae(n.date), 1),
    k("div", MD, ae(n.day), 1)
  ]);
}
const Y0e = /* @__PURE__ */ be(LD, [["render", OD], ["__scopeId", "data-v-8c66c801"]]), PD = {
  name: "BlockEvent",
  components: { SmartLink: Ke },
  props: {
    title: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    prompt: {
      type: String,
      default: "View"
    },
    to: {
      type: String,
      default: ""
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  computed: {
    classes() {
      return ["block-event", `button color-${this.sectionName}`];
    },
    sectionName() {
      return ha(this.to);
    },
    parsedDate() {
      return Da(this.startDate, this.endDate);
    },
    parsedSingledDate() {
      return Nt(new Date(this.startDate), "MMMM d, Y");
    },
    parsedTime() {
      return this.startDate && this.sectionHandle === "event" ? Wi(this.startDate, this.endDate) : "";
    }
  }
}, BD = { class: "text row" }, RD = { class: "category" }, ND = ["textContent"], $D = { class: "date-time" }, FD = ["textContent"], zD = ["textContent"];
function UD(t, e, n, a, i, r) {
  const s = ot("SmartLink");
  return h(), b("div", {
    class: se(r.classes)
  }, [
    e[0] || (e[0] = k("div", { class: "molecule row" }, null, -1)),
    k("div", BD, [
      k("span", RD, ae(n.category), 1),
      k("h2", {
        class: "title",
        textContent: ae(n.title)
      }, null, 8, ND),
      k("div", $D, [
        n.startDate ? (h(), b("time", {
          key: 0,
          class: "dates",
          textContent: ae(r.parsedDate)
        }, null, 8, FD)) : E("", !0),
        r.parsedTime ? (h(), b("time", {
          key: 1,
          class: "time",
          textContent: ae(r.parsedTime)
        }, null, 8, zD)) : E("", !0)
      ]),
      Q(s, {
        class: se(r.classes),
        to: n.to,
        textContent: ae(n.prompt)
      }, null, 8, ["class", "to", "textContent"])
    ]),
    e[1] || (e[1] = k("div", { class: "sizer" }, null, -1))
  ], 2);
}
const HD = /* @__PURE__ */ be(PD, [["render", UD], ["__scopeId", "data-v-39052f8d"]]), YD = { class: "image-container" }, jD = {
  key: 1,
  class: "molecule-no-image"
}, VD = {
  key: 2,
  class: "clipped"
}, qD = /* @__PURE__ */ Ae({
  __name: "BlockFloatingHighlight",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    ongoing: {
      type: Boolean,
      default: !1
    },
    hasTriangle: {
      type: Boolean,
      default: !0
    },
    isVertical: {
      type: Boolean,
      default: !0
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    locations: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    bylineOne: {
      type: String,
      default: ""
    },
    bylineTwo: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
      // This will be "visit", "about", "help".
    },
    sectionHandle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = $a(), a = I(() => e.color || (n !== void 0 && n.path ? ha(n.path) : "default")), i = I(() => [
      "block-floating-highlight",
      { "is-vertical": e.isVertical },
      { "has-triangle": e.hasTriangle },
      `color-${a.value}`
    ]);
    return (r, s) => (h(), b("li", {
      class: se(i.value)
    }, [
      k("div", YD, [
        t.image ? (h(), Z(dn, {
          key: 0,
          media: t.image,
          "aspect-ratio": t.imageAspectRatio,
          class: "image"
        }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", jD, [
          Q(O(Zs), {
            class: "molecule",
            "aria-hidden": "true"
          })
        ])),
        t.hasTriangle ? (h(), b("div", VD, s[0] || (s[0] = [
          k("div", { class: "floating-highlight" }, null, -1),
          k("div", { class: "clipped-box" }, null, -1)
        ]))) : E("", !0)
      ]),
      Q($u, {
        to: t.to,
        category: t.category,
        title: t.title,
        "start-date": t.startDate,
        "end-date": t.endDate,
        ongoing: t.ongoing,
        text: t.text,
        "byline-one": t.bylineOne,
        "byline-two": t.bylineTwo,
        locations: t.locations,
        "alternative-full-name": t.alternativeFullName,
        language: t.language,
        "section-handle": t.sectionHandle
      }, null, 8, ["to", "category", "title", "start-date", "end-date", "ongoing", "text", "byline-one", "byline-two", "locations", "alternative-full-name", "language", "section-handle"])
    ], 2));
  }
}), Y2 = /* @__PURE__ */ be(qD, [["__scopeId", "data-v-b22f8d83"]]), WD = { class: "block-generic-list" }, GD = {
  key: 0,
  class: "category"
}, XD = ["lang"], ZD = {
  key: 2,
  class: "title-no-link"
}, KD = {
  key: 3,
  class: "byline-group"
}, QD = {
  key: 0,
  class: "schedule-item"
}, JD = {
  key: 0,
  class: "schedule-item"
}, eI = {
  key: 4,
  class: "location-group"
}, tI = {
  key: 5,
  class: "text"
}, nI = /* @__PURE__ */ Ae({
  __name: "BlockGenericList",
  props: {
    title: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    jobRequisitionNumber: {
      type: String,
      default: ""
    },
    jobPostingURL: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    associatedLocations: {
      type: Array,
      default: () => []
    },
    payRate: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => e.text ? Ki(e.text, 250) : "");
    return (a, i) => (h(), b("li", WD, [
      t.jobRequisitionNumber ? (h(), b("div", GD, " JOB #" + ae(t.jobRequisitionNumber), 1)) : E("", !0),
      t.jobPostingURL ? (h(), Z(Ke, {
        key: 1,
        to: t.jobPostingURL,
        class: "title"
      }, {
        default: ce(() => [
          Ye(ae(t.title) + " ", 1),
          t.alternativeFullName ? (h(), b("span", {
            key: 0,
            lang: t.language,
            class: "translation"
          }, ae(t.alternativeFullName), 9, XD)) : E("", !0)
        ]),
        _: 1
      }, 8, ["to"])) : (h(), b("h3", ZD, ae(t.title), 1)),
      t.departments.length || t.payRate ? (h(), b("div", KD, [
        t.departments.length || t.payRate ? (h(), b("div", QD, [
          (h(!0), b(me, null, Ee(t.departments, (r, s) => (h(), b("div", {
            key: `block-generic-${r.title}-${s}`,
            class: "schedule-item"
          }, ae(r.title), 1))), 128)),
          t.payRate ? (h(), b("div", JD, ae(t.payRate), 1)) : E("", !0)
        ])) : E("", !0)
      ])) : E("", !0),
      t.associatedLocations.length > 0 ? (h(), b("div", eI, [
        (h(!0), b(me, null, Ee(t.associatedLocations, (r, s) => (h(), Z(en, {
          key: `block-generic-${r.title}-${s}`,
          text: r.title,
          "icon-name": "svg-icon-location",
          to: r.to
        }, null, 8, ["text", "to"]))), 128))
      ])) : E("", !0),
      t.text ? (h(), b("div", tI, ae(n.value), 1)) : E("", !0)
    ]));
  }
}), aI = /* @__PURE__ */ be(nI, [["__scopeId", "data-v-36828094"]]), iI = { class: "block-hours" }, rI = { class: "content" }, sI = ["src"], oI = /* @__PURE__ */ Ae({
  __name: "BlockHours",
  props: {
    lid: {
      type: String,
      default: ""
    },
    isClicc: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = J(null), a = I(() => e.isClicc ? "https://www.library.ucla.edu/blockCliccHours.html?lid=0" : `https://www.library.ucla.edu/blockHours.html?lid=${e.lid}`);
    return ht(() => {
      window.addEventListener(
        "message",
        (i) => {
          const r = i.data[0], s = i.data[1];
          r === "setHeight" && n.value && (n.value.style.height = `${s + 20}px`);
        },
        !1
      );
    }), (i, r) => (h(), b("div", iI, [
      r[0] || (r[0] = k("h3", { class: "title" }, " Hours ", -1)),
      k("div", rI, [
        k("iframe", {
          id: "the-iframe",
          ref_key: "iframeRef",
          ref: n,
          title: "Hours for location",
          class: "iframe",
          src: a.value,
          frameBorder: "0",
          width: "100%",
          height: "100%"
        }, null, 8, sI),
        Q(cn, {
          label: "All Library Hours",
          "is-secondary": !0,
          to: "https://calendar.library.ucla.edu/hours",
          class: "btn-lnk"
        })
      ])
    ]));
  }
}), j0e = /* @__PURE__ */ be(oI, [["__scopeId", "data-v-7fde24c0"]]), lI = {
  key: 0,
  class: "block-info-top-wrapper"
}, cI = {
  key: 1,
  class: "block-info-mid-wrapper"
}, uI = {
  key: 2,
  class: "block-info-end-wrapper"
}, dI = {
  __name: "BlockInfo",
  props: {
    colorScheme: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["block-info", t.colorScheme, (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: se(n.value)
    }, [
      a.$slots["block-info-top"] ? (h(), b("div", lI, [
        xe(a.$slots, "block-info-top", {}, void 0, !0)
      ])) : E("", !0),
      a.$slots["block-info-mid"] ? (h(), b("div", cI, [
        xe(a.$slots, "block-info-mid", {}, void 0, !0)
      ])) : E("", !0),
      a.$slots["block-info-end"] ? (h(), b("div", uI, [
        xe(a.$slots, "block-info-end", {}, void 0, !0)
      ])) : E("", !0)
    ], 2));
  }
}, hI = /* @__PURE__ */ be(dI, [["__scopeId", "data-v-84e90e59"]]), fI = { class: "card-container" }, pI = { class: "image-container" }, mI = {
  key: 1,
  class: "molecule-no-image"
}, gI = { class: "library" }, bI = { class: "text" }, vI = {
  key: 0,
  class: "time"
}, yI = { key: 0 }, _I = {
  key: 1,
  class: "hour"
}, xI = {
  key: 2,
  class: "amenities"
}, TI = { class: "tooltiptext" }, wI = /* @__PURE__ */ Ae({
  __name: "BlockLocationListItem",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    addressLink: {
      type: String,
      default: ""
    },
    amenities: {
      type: Array,
      default: () => []
    },
    reserveSeat: {
      type: String,
      default: ""
    },
    isUclaLibrary: {
      type: Boolean,
      default: !0
    },
    affiliateLibraryUrl: {
      type: String,
      default: ""
    },
    locationType: {
      type: String,
      default: ""
    },
    campusMapId: {
      type: String,
      default: ""
    },
    libcalSpacesUrl: {
      type: String,
      default: ""
    },
    libcalLocationIdForHours: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = ge(
      () => import("./icon-phone-DPv-PoqA.js")
    ), a = ge(
      () => Promise.resolve().then(() => Mp)
    ), i = ge(
      () => import("./icon-location-DNog__Cl.js")
    ), r = ge(
      () => import("./icon-clock-CG3EE-5W.js")
    ), s = ge(
      () => import("./icon-accessible-C8Gup1rK.js")
    ), o = ge(
      () => import("./icon-chair-D8fW8Dnx.js")
    ), l = ge(
      () => import("./icon-virtual-CwZieS3s.js")
    ), c = ge(
      () => import("./icon-laptop-Bmg8PSn7.js")
    ), d = ge(
      () => import("./icon-locker-BBQPsbYg.js")
    ), f = ge(
      () => import("./icon-light-wkkuRssP.js")
    ), g = ge(
      () => Promise.resolve().then(() => w2)
    ), _ = ge(
      () => import("./icon-book-Dhs3bbZ0.js")
    ), x = {
      IconPhone: n,
      IconCalendar: a,
      IconLocation: i,
      IconClock: r,
      IconAccessible: s,
      IconChair: o,
      IconVirtual: l,
      IconLaptop: c,
      IconLocker: d,
      IconLight: f,
      IconShare: g,
      IconBook: _
    }, p = J(null);
    function w() {
      const D = `https://calendar.library.ucla.edu/api_hours_today.php?iid=3244&lid=${e.libcalLocationIdForHours}&format=json&systemTime=0`;
      fetch(D).then((B) => B.json()).then((B) => {
        p.value = {
          ...B.locations[0],
          ...B.locations[0].times
        };
      }).catch((B) => {
        console.error(B);
      });
    }
    const C = I(() => e.isUclaLibrary ? "ucla" : "affiliate"), M = I(() => ["block-location-list-item", `color-${C.value}`]), A = I(() => {
      var D, B, P;
      return ((D = p == null ? void 0 : p.value) == null ? void 0 : D.status) === "open" ? `${p.value.hours[0].from} -  ${p.value.hours[0].to}` : ((B = p == null ? void 0 : p.value) == null ? void 0 : B.status) === "text" ? p.value.text : (P = p == null ? void 0 : p.value) == null ? void 0 : P.status;
    }), L = I(() => !!(e.image && Object.keys(e.image).length !== 0));
    return ht(() => {
      w();
    }), (D, B) => (h(), b("div", {
      class: se(M.value)
    }, [
      k("div", fI, [
        k("div", pI, [
          L.value ? (h(), Z(dn, {
            key: 0,
            class: "image",
            media: e.image
          }, null, 8, ["media"])) : (h(), b("div", mI, [
            Q(O(Zs), {
              class: "molecule",
              "aria-hidden": "true"
            })
          ]))
        ]),
        k("div", gI, [
          k("div", null, [
            e.to ? (h(), Z(Ke, {
              key: 0,
              to: e.to,
              class: "title"
            }, {
              default: ce(() => [
                Ye(ae(e.title), 1)
              ]),
              _: 1
            }, 8, ["to"])) : (h(), Z(Ke, {
              key: 1,
              to: e.affiliateLibraryUrl,
              class: "title"
            }, {
              default: ce(() => [
                Ye(ae(e.title), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          ]),
          k("div", bI, [
            p.value && e.isUclaLibrary ? (h(), b("div", vI, [
              Q(O(r)),
              p.value.day ? (h(), b("span", yI, ae("Today"))) : E("", !0),
              p.value.status !== "not-set" ? (h(), b("div", _I, [
                k("span", null, ae(A.value), 1)
              ])) : E("", !0)
            ])) : E("", !0),
            e.reserveSeat ? (h(), Z(en, {
              key: 1,
              text: "Reserve a Seat",
              "icon-name": "svg-icon-calendar",
              to: e.reserveSeat,
              class: "reserve"
            }, null, 8, ["to"])) : E("", !0),
            Q(en, {
              text: e.address,
              "icon-name": "svg-icon-location",
              to: e.addressLink,
              class: "location"
            }, null, 8, ["text", "to"]),
            e.amenities ? (h(), b("div", xI, [
              (h(!0), b(me, null, Ee(t.amenities, (P) => (h(), b("div", {
                key: `amenity-${P.title}`,
                class: "tooltip"
              }, [
                k("span", TI, ae(P.title), 1),
                (h(), Z(ut(x[P.icon]), { class: "svg" }))
              ]))), 128))
            ])) : E("", !0)
          ])
        ])
      ])
    ], 2));
  }
}), kI = /* @__PURE__ */ be(wI, [["__scopeId", "data-v-fd39eb52"]]), SI = {
  width: "81",
  height: "80",
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-headphones"
};
function CI(t, e) {
  return h(), b("svg", SI, e[0] || (e[0] = [
    ri('<path d="M40.5 0L68.7843 11.7157L80.5 40L68.7843 68.2843L40.5 80L12.2158 68.2843L0.5 40L12.2158 11.7157L40.5 0Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><rect x="24.5566" y="40.8452" width="5.15" height="16.5937" rx="0.655858" stroke="white" stroke-width="1.25" class="svg__stroke--white"></rect><rect x="-0.625" y="0.625" width="5.14976" height="16.5937" rx="0.655858" transform="matrix(-1 0 0 1 55.8071 40.2202)" stroke="white" stroke-width="1.25" class="svg__stroke--white"></rect><path d="M60 51.25L59.9368 41.3155C59.8688 30.628 51.1858 22 40.4981 22V22C29.8075 22 21.1233 30.6325 21.0593 41.3229L21 51.25" stroke="white" stroke-width="1.25" class="svg__stroke--white"></path><path d="M24 54.9702L24.079 55.5902L24.625 55.5206V54.9702H24ZM21.75 54.5292L21.3181 54.981L21.75 54.5292ZM21.0015 52.5255L21.6218 52.4491L21.0015 52.5255ZM23.375 44.5V54.9702H24.625V44.5H23.375ZM21.625 52.4999V44.5H20.375V52.4999H21.625ZM24 54.9702C23.921 54.3502 23.9211 54.3502 23.9213 54.3502C23.9213 54.3502 23.9214 54.3501 23.9215 54.3501C23.9216 54.3501 23.9217 54.3501 23.9218 54.3501C23.922 54.3501 23.9221 54.3501 23.9221 54.3501C23.9221 54.3501 23.9217 54.3501 23.921 54.3502C23.9195 54.3504 23.9166 54.3507 23.9124 54.3512C23.9039 54.3521 23.8901 54.3536 23.8715 54.3554C23.8342 54.3589 23.7782 54.3636 23.7082 54.3675C23.567 54.3754 23.3743 54.3797 23.166 54.3667C22.7039 54.3377 22.3445 54.2328 22.1819 54.0774L21.3181 54.981C21.8273 55.4676 22.5928 55.5832 23.0878 55.6142C23.358 55.6312 23.6019 55.6254 23.7776 55.6156C23.866 55.6107 23.9386 55.6047 23.9903 55.5997C24.0161 55.5973 24.0369 55.5951 24.0518 55.5934C24.0593 55.5925 24.0654 55.5918 24.0699 55.5913C24.0722 55.591 24.0741 55.5908 24.0756 55.5906C24.0764 55.5905 24.077 55.5904 24.0776 55.5903C24.0779 55.5903 24.0781 55.5903 24.0784 55.5902C24.0785 55.5902 24.0786 55.5902 24.0787 55.5902C24.0788 55.5902 24.079 55.5902 24 54.9702ZM22.1819 54.0774C22.0372 53.9391 21.8896 53.6214 21.7768 53.2149C21.6728 52.8401 21.6288 52.5057 21.6218 52.4491L20.3811 52.6018C20.3917 52.6872 20.4449 53.0899 20.5723 53.5491C20.6909 53.9766 20.9088 54.5897 21.3181 54.981L22.1819 54.0774ZM20.375 52.4999C20.375 52.5295 20.3764 52.5635 20.3811 52.6018L21.6218 52.4491C21.623 52.4588 21.6238 52.4684 21.6244 52.4779C21.6249 52.4872 21.625 52.4948 21.625 52.4999H20.375ZM22.5 43.625C22.9832 43.625 23.375 44.0168 23.375 44.5H24.625C24.625 43.3264 23.6736 42.375 22.5 42.375V43.625ZM22.5 42.375C21.3264 42.375 20.375 43.3264 20.375 44.5H21.625C21.625 44.0168 22.0167 43.625 22.5 43.625V42.375Z" fill="white" class="svg__fill--white"></path><path d="M57 54.9702L56.921 55.5902L56.375 55.5206V54.9702H57ZM59.25 54.5292L58.8181 54.0774L58.8181 54.0774L59.25 54.5292ZM59.9985 52.5255L60.6189 52.6018L59.9985 52.5255ZM57.625 44.5V54.9702H56.375V44.5H57.625ZM59.375 52.4999V44.5H60.625V52.4999H59.375ZM57 54.9702C57.079 54.3502 57.0789 54.3502 57.0787 54.3502C57.0787 54.3502 57.0786 54.3501 57.0785 54.3501C57.0784 54.3501 57.0783 54.3501 57.0782 54.3501C57.078 54.3501 57.0779 54.3501 57.0779 54.3501C57.0779 54.3501 57.0783 54.3501 57.079 54.3502C57.0805 54.3504 57.0834 54.3507 57.0876 54.3512C57.0961 54.3521 57.1099 54.3536 57.1285 54.3554C57.1658 54.3589 57.2218 54.3636 57.2918 54.3675C57.433 54.3754 57.6257 54.3797 57.834 54.3667C58.2961 54.3377 58.6555 54.2328 58.8181 54.0774L59.6819 54.981C59.1727 55.4676 58.4072 55.5832 57.9122 55.6142C57.642 55.6312 57.3981 55.6254 57.2224 55.6156C57.134 55.6107 57.0614 55.6047 57.0097 55.5997C56.9839 55.5973 56.9631 55.5951 56.9482 55.5934C56.9407 55.5925 56.9346 55.5918 56.9301 55.5913C56.9278 55.591 56.9259 55.5908 56.9244 55.5906C56.9236 55.5905 56.923 55.5904 56.9224 55.5903C56.9221 55.5903 56.9219 55.5903 56.9216 55.5902C56.9215 55.5902 56.9214 55.5902 56.9213 55.5902C56.9212 55.5902 56.921 55.5902 57 54.9702ZM58.8181 54.0774C58.9628 53.9391 59.1104 53.6214 59.2232 53.2149C59.3272 52.8401 59.3712 52.5057 59.3782 52.4491L60.6189 52.6018C60.6083 52.6872 60.5551 53.0899 60.4277 53.5491C60.3091 53.9766 60.0912 54.5897 59.6819 54.981L58.8181 54.0774ZM60.625 52.4999C60.625 52.5295 60.6236 52.5635 60.6189 52.6018L59.3782 52.4491C59.377 52.4588 59.3762 52.4684 59.3756 52.4779C59.3751 52.4872 59.375 52.4948 59.375 52.4999H60.625ZM58.5 43.625C58.0168 43.625 57.625 44.0168 57.625 44.5H56.375C56.375 43.3264 57.3264 42.375 58.5 42.375V43.625ZM58.5 42.375C59.6736 42.375 60.625 43.3264 60.625 44.5H59.375C59.375 44.0168 58.9833 43.625 58.5 43.625V42.375Z" fill="white" class="svg__fill--white"></path>', 6)
  ]));
}
const Zd = { render: CI }, AI = { class: "media-with-text" }, EI = { class: "text-grouping" }, LI = ["innerHTML"], DI = { class: "meta-mobile" }, II = {
  key: 1,
  class: "no-media-mobile"
}, MI = { class: "clippy" }, OI = {
  key: 0,
  class: "floating-highlight-mobile"
}, PI = {
  key: 1,
  class: "clipped-play-mobile"
}, BI = ["innerHTML"], RI = { class: "clippy" }, NI = {
  key: 0,
  class: "floating-highlight"
}, $I = {
  key: 1,
  class: "clipped-play"
}, FI = {
  key: 1,
  class: "no-media"
}, zI = /* @__PURE__ */ Ae({
  __name: "BlockMediaWithText",
  props: {
    sectionHeader: {
      type: String,
      default: ""
    },
    shortDescription: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonUrl: {
      type: String,
      default: ""
    },
    embedCode: {
      type: String,
      default: ""
    },
    typeMedia: {
      type: String,
      default: ""
    },
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = ge(() => import("./icon-play-filled-Dvcf_yQh.js")), a = ge(() => Promise.resolve().then(() => Dl)), i = ge(() => Promise.resolve().then(() => Ure)), r = ge(() => Promise.resolve().then(() => kse)), s = J(!1), o = I(() => e.typeMedia === "audio" || e.item && e.item[0] && e.item[0].kind === "audio"), l = I(() => e.typeMedia === "video" || e.item && e.item[0] && e.item[0].kind === "video"), c = I(() => [
      {
        item: e.item,
        coverImage: e.coverImage,
        embedCode: e.embedCode,
        captionTitle: e.sectionHeader,
        captionText: e.shortDescription
      }
    ]), d = I(() => !!(e.buttonUrl && e.typeMedia === "other"));
    return (f, g) => (h(), b("div", AI, [
      k("div", EI, [
        k("h3", {
          class: "section-header",
          innerHTML: t.sectionHeader
        }, null, 8, LI),
        k("div", DI, [
          t.item || t.coverImage ? (h(), Z(O(i), {
            key: 0,
            item: t.item,
            "cover-image": t.coverImage,
            "cover-only": !0,
            class: "media-mobile",
            onClick: g[0] || (g[0] = (_) => s.value = !0)
          }, null, 8, ["item", "cover-image"])) : E("", !0),
          t.item || t.coverImage ? E("", !0) : (h(), b("div", II)),
          k("div", MI, [
            l.value || o.value ? (h(), b("div", OI)) : E("", !0),
            l.value || o.value ? (h(), b("div", PI)) : E("", !0),
            l.value || o.value ? (h(), Z(O(n), {
              key: 2,
              class: "icon-play-filled-mobile"
            })) : E("", !0)
          ]),
          o.value ? (h(), Z(O(Zd), {
            key: 2,
            class: "icon-headphones-mobile"
          })) : E("", !0)
        ]),
        t.shortDescription ? (h(), b("div", {
          key: 0,
          class: "short-description",
          innerHTML: t.shortDescription
        }, null, 8, BI)) : E("", !0),
        t.buttonUrl ? (h(), Z(O(a), {
          key: 1,
          class: "button",
          to: t.buttonUrl,
          label: t.buttonText,
          "is-secondary": !0,
          "is-download": d.value
        }, null, 8, ["to", "label", "is-download"])) : E("", !0)
      ]),
      t.item || t.coverImage ? (h(), Z(O(i), {
        key: 0,
        item: t.item,
        "cover-image": t.coverImage,
        "cover-only": !0,
        class: "meta media",
        onClick: g[1] || (g[1] = (_) => o.value || l.value ? s.value = !0 : s.value = !1)
      }, {
        default: ce(() => [
          k("div", RI, [
            l.value || o.value ? (h(), b("div", NI)) : E("", !0),
            l.value || o.value ? (h(), b("div", $I)) : E("", !0),
            l.value || o.value ? (h(), Z(O(n), {
              key: 2,
              class: "icon-play-filled"
            })) : E("", !0)
          ]),
          o.value ? (h(), Z(O(Zd), {
            key: 0,
            class: "icon-headphones"
          })) : E("", !0),
          o.value ? (h(), Z(O(Zd), {
            key: 1,
            class: "icon-headphones"
          })) : E("", !0)
        ]),
        _: 1
      }, 8, ["item", "cover-image"])) : E("", !0),
      t.item || t.coverImage ? E("", !0) : (h(), b("div", FI)),
      s.value ? (h(), Z(O(r), {
        key: 2,
        items: c.value,
        onCloseModal: g[2] || (g[2] = (_) => s.value = !1),
        onKeydown: g[3] || (g[3] = $r((_) => s.value = !1, ["esc"]))
      }, null, 8, ["items"])) : E("", !0)
    ]));
  }
}), UI = /* @__PURE__ */ be(zI, [["__scopeId", "data-v-a37a7554"]]), HI = { class: "meta" }, YI = ["innerHTML"], jI = ["innerHTML"], VI = ["innerHTML"], qI = /* @__PURE__ */ Ae({
  __name: "BlockPostSmall",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    categoryName: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    author: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => ha(e.to)), a = I(() => ["block-post-small", `color-${n.value}`]), i = I(() => `By ${e.author}`);
    return (r, s) => {
      const o = ot("smart-link");
      return h(), b("div", null, [
        Q(o, {
          to: t.to,
          class: se(a.value)
        }, {
          default: ce(() => [
            t.image ? (h(), Z(dn, {
              key: 0,
              media: t.image,
              "aspect-ratio": 100,
              class: "image"
            }, null, 8, ["media"])) : E("", !0),
            k("div", HI, [
              k("div", {
                class: "category",
                innerHTML: t.categoryName
              }, null, 8, YI),
              k("h3", {
                class: "title",
                innerHTML: t.title
              }, null, 8, jI),
              k("div", {
                class: "author",
                innerHTML: i.value
              }, null, 8, VI)
            ])
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]);
    };
  }
}), WI = /* @__PURE__ */ be(qI, [["__scopeId", "data-v-e23267ae"]]), GI = {
  __name: "BlockRemoveSearchFilter",
  props: {
    title: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      required: !1
    },
    isSelected: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["removeBlockFilter"],
  setup(t, { emit: e }) {
    const n = e, a = ge(
      () => Promise.resolve().then(() => d2)
    ), i = ge(
      () => Promise.resolve().then(() => tU)
    ), r = {
      SvgGlyphClose: a,
      SvgGlyphX: i
    }, s = $a(), o = Ge(), l = I(() => s !== void 0 && s.path ? ha(s.path) : "default"), c = I(() => ["block-remove-search-filter", (o == null ? void 0 : o.value) || "", `color-${l.value}`, t.isSelected && (o != null && o.value) ? "selected" : ""]), d = I(() => {
      switch (o == null ? void 0 : o.value) {
        case "ftva":
          return "SvgGlyphX";
        default:
          return "SvgGlyphClose";
      }
    });
    function f() {
      n("removeBlockFilter");
    }
    return (g, _) => (h(), b("button", {
      type: "button",
      class: se(c.value),
      onClick: f
    }, [
      Q(Ks, {
        label: t.title,
        "icon-name": t.iconName,
        theme: O(o),
        "is-secondary": !0
      }, {
        default: ce(() => [
          k("span", {
            class: se(["button-close", { "button-selected": t.isSelected && O(o) === "ftva" }])
          }, [
            (h(), Z(ut(r[d.value])))
          ], 2)
        ]),
        _: 1
      }, 8, ["label", "icon-name", "theme"])
    ], 2));
  }
}, XI = /* @__PURE__ */ be(GI, [["__scopeId", "data-v-29306f32"]]), ZI = {
  width: "42",
  height: "48",
  viewBox: "0 0 42 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-playvideo"
};
function KI(t, e) {
  return h(), b("svg", ZI, e[0] || (e[0] = [
    k("path", {
      d: "M42 24L0.749998 47.8157L0.75 0.1843L42 24Z",
      fill: "white",
      class: "svg__fill--pure-white"
    }, null, -1)
  ]));
}
const QI = { render: KI }, JI = {
  class: "cover-container",
  onclick: "this.nextElementSibling.style.display='block'; this.style.display='none'"
}, eM = ["src"], tM = {
  key: 0,
  class: "video-container"
}, nM = ["src"], aM = /* @__PURE__ */ Ae({
  __name: "VideoEmbed",
  props: {
    trailer: {
      type: String,
      required: !0
    },
    posterImage: {
      type: Object,
      required: !1
    }
  },
  setup(t) {
    const e = I(() => {
      var i;
      return ["video-embed", ((i = t.posterImage) == null ? void 0 : i.src) ? "has-poster" : "no-poster"];
    }), n = I(() => t.trailer.split('src="')[1].split('"')[0]);
    return (a, i) => {
      var r;
      return t.trailer ? (h(), b("div", {
        key: 0,
        class: se(e.value)
      }, [
        k("div", JI, [
          (r = t.posterImage) != null && r.src ? (h(), b("img", {
            key: 0,
            src: t.posterImage.src,
            class: "cover"
          }, null, 8, eM)) : E("", !0),
          Q(O(QI), { class: "play-button" })
        ]),
        n.value ? (h(), b("div", tM, [
          k("iframe", {
            src: n.value,
            title: "YouTube video player",
            class: "responsive-iframe",
            frameborder: "0",
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            referrerpolicy: "strict-origin-when-cross-origin",
            allowfullscreen: "",
            loading: "lazy"
          }, null, 8, nM)
        ])) : E("", !0)
      ], 2)) : E("", !0);
    };
  }
}), iM = /* @__PURE__ */ be(aM, [["__scopeId", "data-v-f2badd07"]]), rM = {
  key: 0,
  class: "count"
}, sM = { class: "event-title" }, oM = {
  key: 0,
  class: "title"
}, lM = {
  key: 1,
  class: "alternate-title"
}, cM = ["lang"], uM = { key: 0 }, dM = { key: 1 }, hM = { key: 2 }, fM = { key: 3 }, pM = { key: 4 }, mM = { key: 5 }, gM = { key: 6 }, bM = { key: 7 }, vM = {
  key: 1,
  class: "block-tags"
}, yM = { key: 3 }, _M = /* @__PURE__ */ Ae({
  __name: "BlockScreeningDetail",
  props: {
    screeningCount: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    alternateTitle: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    year: {
      type: String,
      default: ""
    },
    country: {
      type: String,
      default: ""
    },
    languageInfo: {
      type: String,
      default: ""
    },
    runtime: {
      type: String,
      default: ""
    },
    tagLabels: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ""
    },
    trailer: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = ge(() => Promise.resolve().then(() => h2)), n = Ge(), a = I(() => ["block-screening-detail", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: se(a.value)
    }, [
      t.count > 1 ? (h(), b("div", rM, ae(t.screeningCount), 1)) : E("", !0),
      k("div", sM, [
        t.title && t.title !== null ? (h(), b("h3", oM, ae(t.title), 1)) : E("", !0),
        t.alternateTitle && t.alternateTitle !== null ? (h(), b("h4", lM, [
          Ye(ae(t.alternateTitle) + " ", 1),
          t.alternateTitle && t.language && t.language !== null ? (h(), b("span", {
            key: 0,
            lang: t.language
          }, null, 8, cM)) : E("", !0)
        ])) : E("", !0)
      ]),
      k("dl", null, [
        t.year && t.year !== null ? (h(), b("dt", uM, " Year ")) : E("", !0),
        t.year && t.year !== null ? (h(), b("dd", dM, ae(t.year), 1)) : E("", !0),
        t.country && t.country !== null ? (h(), b("dt", hM, " Country ")) : E("", !0),
        t.country && t.country !== null ? (h(), b("dd", fM, ae(t.country), 1)) : E("", !0),
        t.languageInfo && t.languageInfo !== null ? (h(), b("dt", pM, " Language ")) : E("", !0),
        t.languageInfo && t.languageInfo !== null ? (h(), b("dd", mM, ae(t.languageInfo), 1)) : E("", !0),
        t.runtime && t.runtime !== null ? (h(), b("dt", gM, " Runtime ")) : E("", !0),
        t.runtime && t.runtime !== null ? (h(), b("dd", bM, ae(t.runtime), 1)) : E("", !0)
      ]),
      t.tagLabels && t.tagLabels.length > 0 ? (h(), b("div", vM, [
        (h(!0), b(me, null, Ee(t.tagLabels, (s) => (h(), Z(O(e), {
          key: `tag-${s.title}`,
          label: s.title,
          "is-secondary": !0,
          class: "tag-label"
        }, null, 8, ["label"]))), 128))
      ])) : E("", !0),
      t.text && t.text !== null ? (h(), Z(un, {
        key: 2,
        class: "text",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : E("", !0),
      t.trailer && t.trailer !== null ? (h(), b("div", yM, [
        t.trailer || t.image ? (h(), Z(zh, {
          key: 0,
          "aspect-ratio": 56.9,
          controls: !0
        }, {
          default: ce(() => [
            t.trailer || t.image ? (h(), Z(iM, {
              key: 0,
              trailer: t.trailer,
              "poster-image": t.image
            }, null, 8, ["trailer", "poster-image"])) : E("", !0)
          ]),
          _: 1
        })) : E("", !0)
      ])) : E("", !0)
    ], 2));
  }
}), xM = /* @__PURE__ */ be(_M, [["__scopeId", "data-v-373c8d55"]]), TM = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-collapse"
};
function wM(t, e) {
  return h(), b("svg", TM, e[0] || (e[0] = [
    k("path", {
      d: "M8.00014 16.0314 24 15.9656",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const kM = { render: wM }, SM = {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-stroke"
};
function CM(t, e) {
  return h(), b("svg", SM, e[0] || (e[0] = [
    k("path", {
      d: "M12.2898 12.2897L40 0.811795L67.7103 12.2897L79.1882 40L67.7103 67.7103L40 79.1882L12.2898 67.7103L0.811795 40L12.2898 12.2897Z",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const Gh = { render: CM }, AM = {
  name: "ButtonHide",
  components: {
    IconCollapse: kM,
    MoleculeStroke: Gh
  },
  props: {
    text: {
      type: String,
      default: "See Less"
    }
  }
}, EM = { class: "button-hide" }, LM = {
  class: "icon",
  "aria-hidden": "true"
}, DM = { class: "text" };
function IM(t, e, n, a, i, r) {
  const s = ot("MoleculeStroke"), o = ot("IconCollapse");
  return h(), b("button", EM, [
    k("div", LM, [
      Q(s, { class: "molecule-stroke" }),
      Q(o, { class: "icon-collapse" })
    ]),
    k("div", DM, ae(n.text), 1)
  ]);
}
const MM = /* @__PURE__ */ be(AM, [["render", IM], ["__scopeId", "data-v-799177e1"]]), OM = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-expand"
};
function PM(t, e) {
  return h(), b("svg", OM, e[0] || (e[0] = [
    k("path", {
      d: "m16.0333 23.0381-.0652-14.07692",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "m8.95828 16.0291 14.08422-.0579",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const BM = { render: PM }, RM = {
  name: "ButtonShow",
  components: {
    IconExpand: BM,
    MoleculeStroke: Gh
  },
  props: {
    text: {
      type: String,
      default: "See More"
    }
  }
}, NM = { class: "button-show" }, $M = {
  class: "icon",
  "aria-hidden": "true"
}, FM = { class: "text" };
function zM(t, e, n, a, i, r) {
  const s = ot("MoleculeStroke"), o = ot("IconExpand");
  return h(), b("button", NM, [
    k("div", $M, [
      Q(s, { class: "molecule-stroke" }),
      Q(o, { class: "icon-expand" })
    ]),
    k("div", FM, ae(n.text), 1)
  ]);
}
const UM = /* @__PURE__ */ be(RM, [["render", zM], ["__scopeId", "data-v-ae8c2342"]]), HM = {
  name: "BlockShowHide",
  components: { ButtonShow: UM, ButtonHide: MM },
  props: {
    disable: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return { shown: !1 };
  },
  computed: {
    classes() {
      return ["block-show-hide", this.shown ? "shown" : "hidden"];
    }
  }
};
function YM(t, e, n, a, i, r) {
  const s = ot("ButtonHide"), o = ot("ButtonShow");
  return h(), Z(ut(n.tag), {
    class: se(r.classes)
  }, {
    default: ce(() => [
      xe(t.$slots, "default", {}, void 0, !0),
      !n.disable && i.shown ? (h(), Z(s, {
        key: 0,
        class: "button-toggle",
        onClick: e[0] || (e[0] = (l) => i.shown = !1)
      })) : n.disable ? E("", !0) : (h(), Z(o, {
        key: 1,
        class: "button-toggle",
        onClick: e[1] || (e[1] = (l) => i.shown = !0)
      }))
    ]),
    _: 3
  }, 8, ["class"]);
}
const j2 = /* @__PURE__ */ be(HM, [["render", YM], ["__scopeId", "data-v-37bd57a5"]]), jM = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-external-link"
};
function V2(t, e) {
  return h(), b("svg", jM, e[0] || (e[0] = [
    k("g", { "clip-path": "url(#a)" }, [
      k("path", {
        d: "m11.878 19.5671 9.5414-9.5415",
        stroke: "#0B6AB7",
        "stroke-width": "1.5",
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        class: "svg__stroke--primary-blue-03"
      }),
      k("path", {
        d: "M22.7092 19.5667v.75h-1.5v-.75h1.5Zm-.75-10.08159v-.75h.75v.75h-.75Zm-10.0815.74999h-.75V8.73511h.75v1.49999Zm9.3315 9.3316V9.48511h1.5V19.5667h-1.5Zm.75-9.3316H11.8777V8.73511h10.0815v1.49999Z",
        fill: "#0B6AB7",
        class: "svg__fill--primary-blue-03"
      }),
      k("path", {
        d: "M7 25.4744h14.2857",
        stroke: "#0AA5FF",
        "stroke-width": "1.5",
        class: "svg__stroke--default-cyan-03"
      })
    ], -1)
  ]));
}
const qu = { render: V2 }, q2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qu,
  render: V2
}, Symbol.toStringTag, { value: "Module" })), VM = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-arrow-right"
};
function W2(t, e) {
  return h(), b("svg", VM, e[0] || (e[0] = [
    k("g", {
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, [
      k("path", { d: "M9 16.729h13.25" }),
      k("path", { d: "m16 23.729 7-7-7-7" })
    ], -1)
  ]));
}
const bi = { render: W2 }, qM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bi,
  render: W2
}, Symbol.toStringTag, { value: "Module" })), WM = { class: "section" }, GM = { class: "title2" }, XM = {
  key: 0,
  class: "text"
}, ZM = {
  class: "svg-meta",
  "aria-hidden": "true"
}, KM = {
  __name: "BlockSimpleCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ha(t.to)), a = I(() => ["block-simple-card", `color-${n.value}`, (e == null ? void 0 : e.value) || ""]), i = I(() => Fh(t.to) ? bi : qu), r = I(() => t.text ? Ki(t.text, 250) : "");
    return (s, o) => (h(), b("li", {
      class: se(a.value)
    }, [
      k("span", WM, ae(n.value), 1),
      k("h3", GM, [
        t.title ? (h(), Z(O(Ke), {
          key: 0,
          to: t.to,
          class: "title"
        }, {
          default: ce(() => [
            Ye(ae(t.title), 1)
          ]),
          _: 1
        }, 8, ["to"])) : E("", !0)
      ]),
      t.text ? (h(), b("div", XM, ae(r.value), 1)) : E("", !0),
      o[0] || (o[0] = k("div", { class: "spacer" }, null, -1)),
      k("div", ZM, [
        (h(), Z(ut(i.value), { class: "svg" }))
      ])
    ], 2));
  }
}, QM = /* @__PURE__ */ be(KM, [["__scopeId", "data-v-e01b3892"]]), JM = {
  name: "BlockSpaces",
  components: {
    SvgHeadingArrow: Ol,
    SmartLink: Ke,
    ButtonLink: cn,
    RichText: un
  },
  props: {
    to: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: "Reserve"
    }
  }
}, eO = { class: "block-spaces" }, tO = { class: "arrow-and-title" }, nO = {
  key: 0,
  class: "space-title"
}, aO = ["innerHTML"], iO = { class: "meta" };
function rO(t, e, n, a, i, r) {
  const s = ot("SvgHeadingArrow"), o = ot("SmartLink"), l = ot("RichText"), c = ot("ButtonLink");
  return h(), b("li", eO, [
    (h(), Z(ut(n.to ? "SmartLink" : "div"), {
      to: n.to,
      class: "container"
    }, {
      default: ce(() => [
        k("div", tO, [
          Q(s, { class: "heading-arrow" }),
          n.to ? (h(), b("h3", nO, [
            Q(o, { to: n.to }, {
              default: ce(() => [
                Ye(ae(n.title), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])) : (h(), b("h3", {
            key: 1,
            class: "space-title-no-link",
            innerHTML: n.title
          }, null, 8, aO))
        ]),
        k("div", iO, [
          n.text ? (h(), Z(l, {
            key: 0,
            class: "text",
            "rich-text-content": n.text
          }, null, 8, ["rich-text-content"])) : E("", !0),
          n.to ? (h(), Z(c, {
            key: 1,
            class: "button",
            "button-url": n.to,
            label: n.buttonText,
            "is-secondary": !0,
            to: n.to,
            "link-target": "_blank"
          }, null, 8, ["button-url", "label", "to"])) : E("", !0)
        ])
      ]),
      _: 1
    }, 8, ["to"]))
  ]);
}
const sO = /* @__PURE__ */ be(JM, [["render", rO], ["__scopeId", "data-v-ceb4a4c3"]]), oO = {
  name: "BlockSponsor",
  components: {
    SmartLink: Ke
  },
  props: {
    funderLogo: {
      type: Array,
      default: () => []
    },
    funderName: {
      type: String,
      default: ""
    },
    funderUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    parsedFunderLogo() {
      return this.funderLogo[0];
    }
  }
}, lO = ["src", "alt"];
function cO(t, e, n, a, i, r) {
  const s = ot("SmartLink");
  return h(), Z(s, {
    to: n.funderUrl,
    "link-target": "_blank"
  }, {
    default: ce(() => [
      k("img", {
        src: r.parsedFunderLogo.src,
        alt: n.funderName,
        class: "block-sponsor"
      }, null, 8, lO)
    ]),
    _: 1
  }, 8, ["to"]);
}
const uO = /* @__PURE__ */ be(oO, [["render", cO], ["__scopeId", "data-v-7f3e4b64"]]);
function dO(t = "", e = "", n = "long") {
  const a = (c, d) => c ? Nt(new Date(c), d) : "", i = "MMMM d, Y", r = "MMM d", s = "MMM d, Y", o = a(t, i), l = e ? a(e, i) : "";
  if (!e || o === l)
    switch (n) {
      case "long":
        return a(t, i);
      case "short":
        return a(t, r);
      case "shortWithYear":
        return a(t, s);
    }
  if (n === "short") {
    const c = a(t, r), d = a(e, r);
    return `${c} - ${d}`;
  } else if (n === "shortWithYear") {
    const c = a(t, s), d = a(e, s);
    return `${c} - ${d}`;
  }
  return `${o} - ${l}`;
}
const hO = {
  key: 1,
  class: "molecule-no-image"
}, fO = { class: "meta" }, pO = ["innerHTML"], mO = { key: 1 }, gO = {
  key: 0,
  class: "description-summary-only"
}, bO = {
  key: 1,
  class: "date"
}, vO = { key: 2 }, yO = {
  key: 0,
  class: "byline"
}, _O = ["innerHTML"], xO = ["innerHTML"], TO = {
  key: 1,
  class: "description"
}, wO = /* @__PURE__ */ Ae({
  __name: "BlockStaffArticleList",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    authors: {
      type: Array,
      default: () => []
    },
    date: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    imageAspectRatio: {
      type: Number,
      default: 0
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    ongoing: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = Ge(), a = I(() => ["block-staff-article-item", (n == null ? void 0 : n.value) || ""]), i = I(() => Nt(new Date(e.date), "MMMM d, Y")), r = I(() => !!(e.image && Object.keys(e.image).length !== 0)), s = I(() => e.description ? Ki(e.description, 130) : ""), o = I(() => e.description ? Ki(e.description, 250) : ""), l = I(() => (n == null ? void 0 : n.value) !== "ftva" ? null : e.ongoing ? "Ongoing" : e.startDate && e.endDate ? dO(e.startDate, e.endDate, "shortWithYear") : null);
    return (c, d) => (h(), b("li", {
      class: se(a.value)
    }, [
      r.value ? (h(), Z(dn, {
        key: 0,
        media: e.image,
        "aspect-ratio": e.imageAspectRatio,
        "object-fit": "cover",
        class: "image"
      }, null, 8, ["media", "aspect-ratio"])) : (h(), b("div", hO, [
        Q(O(Zs), {
          class: "molecule",
          "aria-hidden": "true"
        })
      ])),
      k("div", fO, [
        e.category ? (h(), b("div", {
          key: 0,
          class: "category",
          innerHTML: e.category
        }, null, 8, pO)) : E("", !0),
        Q(Ke, {
          class: "title",
          to: e.to,
          innerHTML: e.title
        }, null, 8, ["to", "innerHTML"]),
        e.authors.length < 1 || !e.date ? (h(), b("div", mO, [
          e.description ? (h(), b("div", gO, ae(o.value), 1)) : E("", !0),
          l.value ? (h(), b("div", bO, ae(l.value), 1)) : E("", !0)
        ])) : (h(), b("div", vO, [
          e.authors || e.date ? (h(), b("div", yO, [
            (h(!0), b(me, null, Ee(e.authors, (f) => (h(), b("div", {
              key: f.id,
              class: "author",
              innerHTML: f.title
            }, null, 8, _O))), 128)),
            e.date ? (h(), b("div", {
              key: 0,
              class: "date",
              innerHTML: i.value
            }, null, 8, xO)) : E("", !0)
          ])) : E("", !0),
          e.description ? (h(), b("div", TO, ae(s.value), 1)) : E("", !0)
        ]))
      ])
    ], 2));
  }
}), kO = /* @__PURE__ */ be(wO, [["__scopeId", "data-v-88191923"]]), SO = /* @__PURE__ */ Ae({
  __name: "DividerWayFinder",
  props: {
    color: {
      type: String,
      default: ""
      // "visit", "about", "help", "ftva"
    }
  },
  setup(t) {
    const e = $a(), n = Ge(), a = J((e == null ? void 0 : e.path) || ""), i = I(() => t.color || (a.value !== "" ? ha(a.value) : "default")), r = I(() => [
      "divider-way-finder",
      `color-${i.value}`,
      (n == null ? void 0 : n.value) || ""
    ]);
    return Xb(() => {
      a.value = (e == null ? void 0 : e.path) || "";
    }), ht(() => {
      a.value = (e == null ? void 0 : e.path) || "";
    }), (s, o) => (h(), b("div", {
      class: se(r.value)
    }, o[0] || (o[0] = [
      k("div", { class: "solid" }, null, -1),
      k("div", { class: "dotted" }, null, -1)
    ]), 2));
  }
}), pl = /* @__PURE__ */ be(SO, [["__scopeId", "data-v-5a6618eb"]]), CO = { class: "block-staff-detail" }, AO = { class: "heading-staff" }, EO = { class: "header" }, LO = { class: "staffName" }, DO = ["lang"], IO = {
  key: 0,
  class: "pronouns"
}, MO = { class: "section-staff-bio" }, OO = { class: "info-container" }, PO = { class: "staff-info" }, BO = ["innerHTML"], RO = {
  key: 0,
  class: "departments"
}, NO = {
  key: 1,
  class: "location-group"
}, $O = { class: "contact-info-list" }, FO = { class: "contact-info" }, zO = {
  key: 0,
  class: "contact-info"
}, UO = {
  key: 1,
  class: "contact-info"
}, HO = { class: "body-bio" }, YO = {
  key: 1,
  class: "ask-me-about"
}, jO = { class: "list topics" }, VO = ["innerHTML"], qO = {
  key: 3,
  class: "biography"
}, WO = /* @__PURE__ */ Ae({
  __name: "BlockStaffDetail",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    to: {
      type: String,
      default: ""
    },
    staffName: {
      type: String,
      default: ""
    },
    nameLast: {
      type: String,
      default: ""
    },
    nameFirst: {
      type: String,
      default: ""
    },
    alternativeName: {
      type: Array,
      default: () => []
    },
    jobTitle: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    // merge this with ask-me-about data and then sort it
    academicDepartments: {
      type: Array,
      default: () => []
    },
    // topics is the ask-me-about data
    topics: {
      // ask-me-about
      type: Array,
      default: () => []
    },
    locations: {
      type: Array,
      default: () => []
    },
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    consultation: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    pronouns: {
      type: String,
      default: ""
    },
    biography: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => `Pronouns: ${e.pronouns}`), a = I(() => `${e.nameFirst} ${e.nameLast}`), i = I(() => e.alternativeName[0].fullName), r = I(() => e.alternativeName[0].languageAltName), s = I(() => e.topics.concat(e.academicDepartments).sort(
      (o, l) => o.title.toUpperCase() > l.title.toUpperCase() ? 1 : l.title.toUpperCase() > o.title.toUpperCase() ? -1 : 0
    ));
    return (o, l) => (h(), b("div", CO, [
      k("div", AO, [
        Q(O(Ol)),
        k("div", EO, [
          k("h1", LO, [
            Ye(ae(a.value) + " ", 1),
            t.alternativeName.length ? (h(), b("span", {
              key: 0,
              lang: r.value
            }, ae(i.value), 9, DO)) : E("", !0)
          ]),
          t.pronouns ? (h(), b("div", IO, ae(n.value), 1)) : E("", !0)
        ])
      ]),
      k("div", MO, [
        k("div", {
          class: se(t.image ? "body-contact" : "body-contact no-image")
        }, [
          t.image ? (h(), Z(dn, {
            key: 0,
            media: t.image,
            "aspect-ratio": 100,
            class: "image"
          }, null, 8, ["media"])) : E("", !0),
          k("div", OO, [
            k("div", PO, [
              k("div", {
                class: "job-title",
                innerHTML: t.jobTitle
              }, null, 8, BO),
              t.departments.length ? (h(), b("ul", RO, [
                (h(!0), b(me, null, Ee(t.departments, (c, d) => (h(), b("li", {
                  key: d,
                  class: "department"
                }, ae(c.title), 1))), 128))
              ])) : E("", !0),
              t.locations.length ? (h(), b("ul", NO, [
                (h(!0), b(me, null, Ee(t.locations, (c, d) => (h(), b("li", {
                  key: `location-${d}`,
                  class: "location"
                }, [
                  Q(en, {
                    text: c.title ?? "",
                    "icon-name": "svg-icon-location",
                    to: `/${c.to}`
                  }, null, 8, ["text", "to"])
                ]))), 128))
              ])) : E("", !0)
            ]),
            k("div", $O, [
              k("div", FO, [
                Q(en, {
                  text: t.email,
                  "icon-name": "svg-icon-email",
                  to: `mailto:${t.email}`
                }, null, 8, ["text", "to"])
              ]),
              t.phone ? (h(), b("div", zO, [
                Q(en, {
                  text: t.phone,
                  "icon-name": "svg-icon-phone",
                  to: `tel:${t.phone}`
                }, null, 8, ["text", "to"])
              ])) : E("", !0),
              t.consultation ? (h(), b("div", UO, [
                Q(en, {
                  text: "Book a consultation",
                  "icon-name": "svg-icon-consultation",
                  to: t.consultation
                }, null, 8, ["to"])
              ])) : E("", !0)
            ])
          ])
        ], 2),
        k("div", HO, [
          t.topics.length || t.academicDepartments.length ? (h(), Z(pl, {
            key: 0,
            class: "divider divider-first",
            color: "about"
          })) : E("", !0),
          t.topics.length || t.academicDepartments.length ? (h(), b("div", YO, [
            l[0] || (l[0] = k("h2", { class: "section-title" }, " Ask Me About ", -1)),
            Q(un, null, {
              default: ce(() => [
                k("ul", jO, [
                  (h(!0), b(me, null, Ee(s.value, (c) => (h(), b("li", {
                    key: c.id,
                    innerHTML: c.title
                  }, null, 8, VO))), 128))
                ])
              ]),
              _: 1
            })
          ])) : E("", !0),
          t.biography ? (h(), Z(pl, {
            key: 2,
            class: "divider divider-first",
            color: "about"
          })) : E("", !0),
          t.biography ? (h(), b("div", qO, [
            l[1] || (l[1] = k("h2", { class: "section-title" }, " Biography ", -1)),
            Q(un, { "rich-text-content": t.biography }, null, 8, ["rich-text-content"])
          ])) : E("", !0)
        ])
      ])
    ]));
  }
}), V0e = /* @__PURE__ */ be(WO, [["__scopeId", "data-v-e8d5d235"]]), GO = { class: "block-staff-list" }, XO = {
  key: 0,
  class: "no-image"
}, ZO = { class: "meta" }, KO = { class: "name-title" }, QO = { class: "staff-name" }, JO = ["lang"], eP = ["innerHTML"], tP = {
  key: 0,
  class: "departments"
}, nP = { class: "department" }, aP = { class: "contact-info" }, iP = { class: "email" }, rP = {
  key: 0,
  class: "phone"
}, sP = {
  key: 1,
  class: "consultation"
}, oP = {
  key: 2,
  class: "locations"
}, lP = /* @__PURE__ */ Ae({
  __name: "BlockStaffList",
  props: {
    to: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {
      }
    },
    staffName: {
      type: String,
      default: ""
    },
    alternativeFullName: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: ""
    },
    jobTitle: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    departments: {
      type: Array,
      default: () => []
    },
    consultation: {
      type: String,
      default: ""
    },
    locations: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = I(() => e.departments[e.departments.length - 1].title);
    return (a, i) => (h(), b("li", GO, [
      Q(dn, {
        media: t.image,
        "aspect-ratio": 100,
        sizes: "300px",
        class: "image"
      }, null, 8, ["media"]),
      t.image ? E("", !0) : (h(), b("div", XO, [
        Q(O(Ol), { class: "icon-heading-arrow" })
      ])),
      k("div", ZO, [
        k("div", KO, [
          k("h3", QO, [
            Q(Ke, { to: t.to }, {
              default: ce(() => [
                Ye(ae(t.staffName) + " ", 1),
                t.alternativeFullName ? (h(), b("span", {
                  key: 0,
                  lang: t.language
                }, ae(t.alternativeFullName), 9, JO)) : E("", !0)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          k("div", {
            class: "job-title",
            innerHTML: t.jobTitle
          }, null, 8, eP),
          t.departments.length ? (h(), b("ul", tP, [
            k("li", nP, ae(n.value), 1)
          ])) : E("", !0)
        ]),
        k("div", aP, [
          k("div", iP, [
            Q(en, {
              text: t.email,
              "icon-name": "svg-icon-email",
              to: `mailto:${t.email}`
            }, null, 8, ["text", "to"])
          ]),
          t.phone ? (h(), b("div", rP, [
            Q(en, {
              text: t.phone,
              "icon-name": "svg-icon-phone",
              to: `tel:${t.phone}`
            }, null, 8, ["text", "to"])
          ])) : E("", !0),
          t.consultation ? (h(), b("div", sP, [
            Q(en, {
              text: "Book a consultation",
              "icon-name": "svg-icon-consultation",
              to: t.consultation
            }, null, 8, ["to"])
          ])) : E("", !0),
          t.locations.length ? (h(), b("div", oP, [
            (h(!0), b(me, null, Ee(t.locations, (r, s) => (h(), Z(en, {
              key: `${s}`,
              text: r.title ?? "",
              "icon-name": "svg-icon-location",
              to: r.uri
            }, null, 8, ["text", "to"]))), 128))
          ])) : E("", !0)
        ])
      ])
    ]));
  }
}), cP = /* @__PURE__ */ be(lP, [["__scopeId", "data-v-32f4be86"]]);
/*!
 *  @preserve
 *
 * ++++++++++++++++++++++++++++++++++++++
 * Add to Calendar TimeZones iCal Library
 * ++++++++++++++++++++++++++++++++++++++
 *
 * Version: 1.9.1
 * Creator: Jens Kuerschner (https://jenskuerschner.de)
 * Project: https://github.com/add2cal/timezones-ical-library
 * License: Apache-2.0
 *
 */
const sa = { Zulu: ["Etc/UTC", 0], WET: ["Europe/Lisbon", 1], "W-SU": ["Europe/Moscow", 2], Universal: ["Etc/UTC", 0], UTC: ["Etc/UTC", 0], UCT: ["Etc/UTC", 0], Turkey: ["Europe/Istanbul", 3], Singapore: ["Asia/Singapore", 4], ROK: ["Asia/Seoul", 5], ROC: ["Asia/Taipei", 6], Portugal: ["Europe/Lisbon", 1], Poland: ["Europe/Warsaw", 7], PST8PDT: ["America/Los_Angeles", 8], PRC: ["Asia/Shanghai", 9], Navajo: ["America/Denver", 10], NZ: ["Pacific/Auckland", 11], "NZ-CHAT": ["Pacific/Chatham", 12], MST7MDT: ["America/Denver", 10], MST: ["America/Phoenix", 13], MET: ["Europe/Brussels", 14], Libya: ["Africa/Tripoli", 15], Kwajalein: ["Pacific/Kwajalein", 16], Japan: ["Asia/Tokyo", 17], Jamaica: ["America/Jamaica", 18], Israel: ["Asia/Jerusalem", 19], Iran: ["Asia/Tehran", 20], Iceland: ["Africa/Abidjan", 21], Hongkong: ["Asia/Hong_Kong", 22], HST: ["Pacific/Honolulu", 23], Greenwich: ["Etc/GMT", 24], GMT0: ["Etc/GMT", 24], GMT: ["Etc/GMT", 24], "GMT-0": ["Etc/GMT", 24], "GMT+0": ["Etc/GMT", 24], GB: ["Europe/London", 25], "GB-Eire": ["Europe/London", 25], Eire: ["Europe/Dublin", 26], Egypt: ["Africa/Cairo", 27], EST5EDT: ["America/New_York", 28], EST: ["America/Panama", 29], EET: ["Europe/Athens", 30], Cuba: ["America/Havana", 31], CST6CDT: ["America/Chicago", 32], CET: ["Europe/Brussels", 14], US: { Samoa: ["Pacific/Pago_Pago", 33], Pacific: ["America/Los_Angeles", 8], Mountain: ["America/Denver", 10], Michigan: ["America/Detroit", 34], "Indiana-Starke": ["America/Indiana/Knox", 35], Hawaii: ["Pacific/Honolulu", 23], Eastern: ["America/New_York", 28], "East-Indiana": ["America/Indiana/Indianapolis", 36], Central: ["America/Chicago", 32], Arizona: ["America/Phoenix", 13], Aleutian: ["America/Adak", 37], Alaska: ["America/Anchorage", 38] }, Pacific: { Yap: ["Pacific/Port_Moresby", 39], Wallis: ["Pacific/Tarawa", 40], Wake: ["Pacific/Tarawa", 40], Truk: ["Pacific/Port_Moresby", 39], Tongatapu: ["", 41], Tarawa: ["", 40], Tahiti: ["", 42], Samoa: ["Pacific/Pago_Pago", 33], Saipan: ["Pacific/Guam", 43], Rarotonga: ["", 44], Port_Moresby: ["", 39], Ponape: ["Pacific/Guadalcanal", 45], Pohnpei: ["Pacific/Guadalcanal", 45], Pitcairn: ["", 46], Palau: ["", 47], Pago_Pago: ["", 33], Noumea: ["", 48], Norfolk: ["", 49], Niue: ["", 50], Nauru: ["", 51], Midway: ["Pacific/Pago_Pago", 33], Marquesas: ["", 52], Majuro: ["Pacific/Tarawa", 40], Kwajalein: ["", 16], Kosrae: ["", 53], Kiritimati: ["", 54], Kanton: ["", 55], Johnston: ["Pacific/Honolulu", 23], Honolulu: ["", 23], Guam: ["", 43], Guadalcanal: ["", 45], Gambier: ["", 56], Galapagos: ["", 57], Funafuti: ["Pacific/Tarawa", 40], Fiji: ["", 58], Fakaofo: ["", 59], Enderbury: ["Pacific/Kanton", 55], Efate: ["", 60], Easter: ["", 61], Chuuk: ["Pacific/Port_Moresby", 39], Chatham: ["", 12], Bougainville: ["", 62], Auckland: ["", 11], Apia: ["", 63] }, Mexico: { General: ["America/Mexico_City", 64], BajaSur: ["America/Mazatlan", 65], BajaNorte: ["America/Tijuana", 66] }, Indian: { Reunion: ["Asia/Dubai", 67], Mayotte: ["Africa/Nairobi", 68], Mauritius: ["", 69], Maldives: ["", 70], Mahe: ["Asia/Dubai", 67], Kerguelen: ["Indian/Maldives", 70], Comoro: ["Africa/Nairobi", 68], Cocos: ["Asia/Yangon", 71], Christmas: ["Asia/Bangkok", 72], Chagos: ["", 73], Antananarivo: ["Africa/Nairobi", 68] }, Europe: { Zurich: ["", 74], Zaporozhye: ["Europe/Kyiv", 75], Zagreb: ["Europe/Belgrade", 76], Warsaw: ["", 7], Volgograd: ["", 77], Vilnius: ["", 78], Vienna: ["", 79], Vatican: ["Europe/Rome", 80], Vaduz: ["Europe/Zurich", 74], Uzhgorod: ["Europe/Kyiv", 75], Ulyanovsk: ["", 81], Tiraspol: ["Europe/Chisinau", 82], Tirane: ["", 83], Tallinn: ["", 84], Stockholm: ["Europe/Berlin", 85], Sofia: ["", 86], Skopje: ["Europe/Belgrade", 76], Simferopol: ["", 87], Saratov: ["", 88], Sarajevo: ["Europe/Belgrade", 76], San_Marino: ["Europe/Rome", 80], Samara: ["", 89], Rome: ["", 80], Riga: ["", 90], Prague: ["", 91], Podgorica: ["Europe/Belgrade", 76], Paris: ["", 92], Oslo: ["Europe/Berlin", 85], Nicosia: ["Asia/Nicosia", 93], Moscow: ["", 2], Monaco: ["Europe/Paris", 92], Minsk: ["", 94], Mariehamn: ["Europe/Helsinki", 95], Malta: ["", 96], Madrid: ["", 97], Luxembourg: ["Europe/Brussels", 14], London: ["", 25], Ljubljana: ["Europe/Belgrade", 76], Lisbon: ["", 1], Kyiv: ["", 75], Kirov: ["", 98], Kiev: ["Europe/Kyiv", 75], Kaliningrad: ["", 99], Jersey: ["Europe/London", 25], Istanbul: ["", 3], Isle_of_Man: ["Europe/London", 25], Helsinki: ["", 95], Guernsey: ["Europe/London", 25], Gibraltar: ["", 100], Dublin: ["", 26], Copenhagen: ["Europe/Berlin", 85], Chisinau: ["", 82], Busingen: ["Europe/Zurich", 74], Budapest: ["", 101], Bucharest: ["", 102], Brussels: ["", 14], Bratislava: ["Europe/Prague", 91], Berlin: ["", 85], Belgrade: ["", 76], Belfast: ["Europe/London", 25], Athens: ["", 30], Astrakhan: ["", 103], Andorra: ["", 104], Amsterdam: ["Europe/Brussels", 14] }, Etc: { Zulu: ["Etc/UTC", 0], Universal: ["Etc/UTC", 0], UTC: ["", 0], UCT: ["Etc/UTC", 0], Greenwich: ["Etc/GMT", 24], GMT0: ["Etc/GMT", 24], GMT: ["", 24], "GMT-9": ["", 105], "GMT-8": ["", 106], "GMT-7": ["", 107], "GMT-6": ["", 108], "GMT-5": ["", 109], "GMT-4": ["", 110], "GMT-3": ["", 111], "GMT-2": ["", 112], "GMT-14": ["", 113], "GMT-13": ["", 114], "GMT-12": ["", 115], "GMT-11": ["", 116], "GMT-10": ["", 117], "GMT-1": ["", 118], "GMT-0": ["Etc/GMT", 24], "GMT+9": ["", 119], "GMT+8": ["", 120], "GMT+7": ["", 121], "GMT+6": ["", 122], "GMT+5": ["", 123], "GMT+4": ["", 124], "GMT+3": ["", 125], "GMT+2": ["", 126], "GMT+12": ["", 127], "GMT+11": ["", 128], "GMT+10": ["", 129], "GMT+1": ["", 130], "GMT+0": ["Etc/GMT", 24] }, Chile: { EasterIsland: ["Pacific/Easter", 61], Continental: ["America/Santiago", 131] }, Canada: { Yukon: ["America/Whitehorse", 132], Saskatchewan: ["America/Regina", 133], Pacific: ["America/Vancouver", 134], Newfoundland: ["America/St_Johns", 135], Mountain: ["America/Edmonton", 136], Eastern: ["America/Toronto", 137], Central: ["America/Winnipeg", 138], Atlantic: ["America/Halifax", 139] }, Brazil: { West: ["America/Manaus", 140], East: ["America/Sao_Paulo", 141], DeNoronha: ["America/Noronha", 142], Acre: ["America/Rio_Branco", 143] }, Australia: { Yancowinna: ["Australia/Broken_Hill", 144], West: ["Australia/Perth", 145], Victoria: ["Australia/Melbourne", 146], Tasmania: ["Australia/Hobart", 147], Sydney: ["", 148], South: ["Australia/Adelaide", 149], Queensland: ["Australia/Brisbane", 150], Perth: ["", 145], North: ["Australia/Darwin", 151], NSW: ["Australia/Sydney", 148], Melbourne: ["", 146], Lord_Howe: ["", 152], Lindeman: ["", 153], LHI: ["Australia/Lord_Howe", 152], Hobart: ["", 147], Eucla: ["", 154], Darwin: ["", 151], Currie: ["Australia/Hobart", 147], Canberra: ["Australia/Sydney", 148], Broken_Hill: ["", 144], Brisbane: ["", 150], Adelaide: ["", 149], ACT: ["Australia/Sydney", 148] }, Atlantic: { Stanley: ["", 155], St_Helena: ["Africa/Abidjan", 21], South_Georgia: ["", 156], Reykjavik: ["Africa/Abidjan", 21], Madeira: ["", 157], Jan_Mayen: ["Europe/Berlin", 85], Faroe: ["", 158], Faeroe: ["Atlantic/Faroe", 158], Cape_Verde: ["", 159], Canary: ["", 160], Bermuda: ["", 161], Azores: ["", 162] }, Asia: { Yerevan: ["", 163], Yekaterinburg: ["", 164], Yangon: ["", 71], Yakutsk: ["", 165], Vladivostok: ["", 166], Vientiane: ["Asia/Bangkok", 72], "Ust-Nera": ["", 167], Urumqi: ["", 168], Ulan_Bator: ["Asia/Ulaanbaatar", 169], Ulaanbaatar: ["", 169], Ujung_Pandang: ["Asia/Makassar", 170], Tomsk: ["", 171], Tokyo: ["", 17], Thimphu: ["", 172], Thimbu: ["Asia/Thimphu", 172], Tel_Aviv: ["Asia/Jerusalem", 19], Tehran: ["", 20], Tbilisi: ["", 173], Tashkent: ["", 174], Taipei: ["", 6], Srednekolymsk: ["", 175], Singapore: ["", 4], Shanghai: ["", 9], Seoul: ["", 5], Samarkand: ["", 176], Sakhalin: ["", 177], Saigon: ["Asia/Ho_Chi_Minh", 178], Riyadh: ["", 179], Rangoon: ["Asia/Yangon", 71], Qyzylorda: ["", 180], Qostanay: ["", 181], Qatar: ["", 182], Pyongyang: ["", 183], Pontianak: ["", 184], Phnom_Penh: ["Asia/Bangkok", 72], Oral: ["", 185], Omsk: ["", 186], Novosibirsk: ["", 187], Novokuznetsk: ["", 188], Nicosia: ["", 93], Muscat: ["Asia/Dubai", 67], Manila: ["", 189], Makassar: ["", 170], Magadan: ["", 190], Macau: ["", 191], Macao: ["Asia/Macau", 191], Kuwait: ["Asia/Riyadh", 179], Kuching: ["", 192], Kuala_Lumpur: ["Asia/Singapore", 4], Krasnoyarsk: ["", 193], Kolkata: ["", 194], Khandyga: ["", 195], Katmandu: ["Asia/Kathmandu", 196], Kathmandu: ["", 196], Kashgar: ["Asia/Urumqi", 168], Karachi: ["", 197], Kamchatka: ["", 198], Kabul: ["", 199], Jerusalem: ["", 19], Jayapura: ["", 200], Jakarta: ["", 201], Istanbul: ["Europe/Istanbul", 3], Irkutsk: ["", 202], Hovd: ["", 203], Hong_Kong: ["", 22], Ho_Chi_Minh: ["", 178], Hebron: ["", 204], Harbin: ["Asia/Shanghai", 9], Gaza: ["", 205], Famagusta: ["", 206], Dushanbe: ["", 207], Dubai: ["", 67], Dili: ["", 208], Dhaka: ["", 209], Damascus: ["", 210], Dacca: ["Asia/Dhaka", 209], Colombo: ["", 211], Chungking: ["Asia/Shanghai", 9], Chongqing: ["Asia/Shanghai", 9], Choibalsan: ["Asia/Ulaanbaatar", 169], Chita: ["", 212], Calcutta: ["Asia/Kolkata", 194], Brunei: ["Asia/Kuching", 192], Bishkek: ["", 213], Beirut: ["", 214], Barnaul: ["", 215], Bangkok: ["", 72], Baku: ["", 216], Bahrain: ["Asia/Qatar", 182], Baghdad: ["", 217], Atyrau: ["", 218], Ashkhabad: ["Asia/Ashgabat", 219], Ashgabat: ["", 219], Aqtobe: ["", 220], Aqtau: ["", 221], Anadyr: ["", 222], Amman: ["", 223], Almaty: ["", 224], Aden: ["Asia/Riyadh", 179] }, Arctic: { Longyearbyen: ["Europe/Berlin", 85] }, Antarctica: { Vostok: ["", 225], Troll: ["", 226], Syowa: ["Asia/Riyadh", 179], South_Pole: ["Pacific/Auckland", 11], Rothera: ["", 227], Palmer: ["", 228], McMurdo: ["Pacific/Auckland", 11], Mawson: ["", 229], Macquarie: ["", 230], DumontDUrville: ["Pacific/Port_Moresby", 39], Davis: ["", 231], Casey: ["", 232] }, America: { Yellowknife: ["America/Edmonton", 136], Yakutat: ["", 233], Winnipeg: ["", 138], Whitehorse: ["", 132], Virgin: ["America/Puerto_Rico", 234], Vancouver: ["", 134], Tortola: ["America/Puerto_Rico", 234], Toronto: ["", 137], Tijuana: ["", 66], Thunder_Bay: ["America/Toronto", 137], Thule: ["", 235], Tegucigalpa: ["", 236], Swift_Current: ["", 237], St_Vincent: ["America/Puerto_Rico", 234], St_Thomas: ["America/Puerto_Rico", 234], St_Lucia: ["America/Puerto_Rico", 234], St_Kitts: ["America/Puerto_Rico", 234], St_Johns: ["", 135], St_Barthelemy: ["America/Puerto_Rico", 234], Sitka: ["", 238], Shiprock: ["America/Denver", 10], Scoresbysund: ["", 239], Sao_Paulo: ["", 141], Santo_Domingo: ["", 240], Santiago: ["", 131], Santarem: ["", 241], Santa_Isabel: ["America/Tijuana", 66], Rosario: ["America/Argentina/Cordoba", 242], Rio_Branco: ["", 143], Resolute: ["", 243], Regina: ["", 133], Recife: ["", 244], Rankin_Inlet: ["", 245], Rainy_River: ["America/Winnipeg", 138], Punta_Arenas: ["", 246], Puerto_Rico: ["", 234], Porto_Velho: ["", 247], Porto_Acre: ["America/Rio_Branco", 143], Port_of_Spain: ["America/Puerto_Rico", 234], "Port-au-Prince": ["", 248], Phoenix: ["", 13], Paramaribo: ["", 249], Pangnirtung: ["America/Iqaluit", 250], Panama: ["", 29], Ojinaga: ["", 251], Nuuk: ["", 252], Noronha: ["", 142], Nome: ["", 253], Nipigon: ["America/Toronto", 137], New_York: ["", 28], Nassau: ["America/Toronto", 137], Montserrat: ["America/Puerto_Rico", 234], Montreal: ["America/Toronto", 137], Montevideo: ["", 254], Monterrey: ["", 255], Moncton: ["", 256], Miquelon: ["", 257], Mexico_City: ["", 64], Metlakatla: ["", 258], Merida: ["", 259], Menominee: ["", 260], Mendoza: ["America/Argentina/Mendoza", 261], Mazatlan: ["", 65], Matamoros: ["", 262], Martinique: ["", 263], Marigot: ["America/Puerto_Rico", 234], Manaus: ["", 140], Managua: ["", 264], Maceio: ["", 265], Lower_Princes: ["America/Puerto_Rico", 234], Louisville: ["America/Kentucky/Louisville", 266], Los_Angeles: ["", 8], Lima: ["", 267], La_Paz: ["", 268], Kralendijk: ["America/Puerto_Rico", 234], Knox_IN: ["America/Indiana/Knox", 35], Juneau: ["", 269], Jujuy: ["America/Argentina/Jujuy", 270], Jamaica: ["", 18], Iqaluit: ["", 250], Inuvik: ["", 271], Indianapolis: ["America/Indiana/Indianapolis", 36], Hermosillo: ["", 272], Havana: ["", 31], Halifax: ["", 139], Guyana: ["", 273], Guayaquil: ["", 274], Guatemala: ["", 275], Guadeloupe: ["America/Puerto_Rico", 234], Grenada: ["America/Puerto_Rico", 234], Grand_Turk: ["", 276], Goose_Bay: ["", 277], Godthab: ["America/Nuuk", 252], Glace_Bay: ["", 278], Fortaleza: ["", 279], Fort_Wayne: ["America/Indiana/Indianapolis", 36], Fort_Nelson: ["", 280], Ensenada: ["America/Tijuana", 66], El_Salvador: ["", 281], Eirunepe: ["", 282], Edmonton: ["", 136], Dominica: ["America/Puerto_Rico", 234], Detroit: ["", 34], Denver: ["", 10], Dawson_Creek: ["", 283], Dawson: ["", 284], Danmarkshavn: ["", 285], Curacao: ["America/Puerto_Rico", 234], Cuiaba: ["", 286], Creston: ["America/Phoenix", 13], Costa_Rica: ["", 287], Cordoba: ["America/Argentina/Cordoba", 242], Coral_Harbour: ["America/Panama", 29], Ciudad_Juarez: ["", 288], Chihuahua: ["", 289], Chicago: ["", 32], Cayman: ["America/Panama", 29], Cayenne: ["", 290], Catamarca: ["America/Argentina/Catamarca", 291], Caracas: ["", 292], Cancun: ["", 293], Campo_Grande: ["", 294], Cambridge_Bay: ["", 295], Buenos_Aires: ["America/Argentina/Buenos_Aires", 296], Boise: ["", 297], Bogota: ["", 298], Boa_Vista: ["", 299], "Blanc-Sablon": ["America/Puerto_Rico", 234], Belize: ["", 300], Belem: ["", 301], Barbados: ["", 302], Bahia_Banderas: ["", 303], Bahia: ["", 304], Atka: ["America/Adak", 37], Atikokan: ["America/Panama", 29], Asuncion: ["", 305], Aruba: ["America/Puerto_Rico", 234], Araguaina: ["", 306], Antigua: ["America/Puerto_Rico", 234], Anguilla: ["America/Puerto_Rico", 234], Anchorage: ["", 38], Adak: ["", 37], North_Dakota: { New_Salem: ["", 307], Center: ["", 308], Beulah: ["", 309] }, Kentucky: { Monticello: ["", 310], Louisville: ["", 266] }, Indiana: { Winamac: ["", 311], Vincennes: ["", 312], Vevay: ["", 313], Tell_City: ["", 314], Petersburg: ["", 315], Marengo: ["", 316], Knox: ["", 35], Indianapolis: ["", 36] }, Argentina: { Ushuaia: ["", 317], Tucuman: ["", 318], San_Luis: ["", 319], San_Juan: ["", 320], Salta: ["", 321], Rio_Gallegos: ["", 322], Mendoza: ["", 261], La_Rioja: ["", 323], Jujuy: ["", 270], Cordoba: ["", 242], ComodRivadavia: ["America/Argentina/Catamarca", 291], Catamarca: ["", 291], Buenos_Aires: ["", 296] } }, Africa: { Windhoek: ["", 324], Tunis: ["", 325], Tripoli: ["", 15], Timbuktu: ["Africa/Abidjan", 21], Sao_Tome: ["", 326], "Porto-Novo": ["Africa/Lagos", 327], Ouagadougou: ["Africa/Abidjan", 21], Nouakchott: ["Africa/Abidjan", 21], Niamey: ["Africa/Lagos", 327], Ndjamena: ["", 328], Nairobi: ["", 68], Monrovia: ["", 329], Mogadishu: ["Africa/Nairobi", 68], Mbabane: ["Africa/Johannesburg", 330], Maseru: ["Africa/Johannesburg", 330], Maputo: ["", 331], Malabo: ["Africa/Lagos", 327], Lusaka: ["Africa/Maputo", 331], Lubumbashi: ["Africa/Maputo", 331], Luanda: ["Africa/Lagos", 327], Lome: ["Africa/Abidjan", 21], Libreville: ["Africa/Lagos", 327], Lagos: ["", 327], Kinshasa: ["Africa/Lagos", 327], Kigali: ["Africa/Maputo", 331], Khartoum: ["", 332], Kampala: ["Africa/Nairobi", 68], Juba: ["", 333], Johannesburg: ["", 330], Harare: ["Africa/Maputo", 331], Gaborone: ["Africa/Maputo", 331], Freetown: ["Africa/Abidjan", 21], El_Aaiun: ["", 334], Douala: ["Africa/Lagos", 327], Djibouti: ["Africa/Nairobi", 68], Dar_es_Salaam: ["Africa/Nairobi", 68], Dakar: ["Africa/Abidjan", 21], Conakry: ["Africa/Abidjan", 21], Ceuta: ["", 335], Casablanca: ["", 336], Cairo: ["", 27], Bujumbura: ["Africa/Maputo", 331], Brazzaville: ["Africa/Lagos", 327], Blantyre: ["Africa/Maputo", 331], Bissau: ["", 337], Banjul: ["Africa/Abidjan", 21], Bangui: ["Africa/Lagos", 327], Bamako: ["Africa/Abidjan", 21], Asmera: ["Africa/Nairobi", 68], Asmara: ["Africa/Nairobi", 68], Algiers: ["", 338], Addis_Ababa: ["Africa/Nairobi", 68], Accra: ["Africa/Abidjan", 21], Abidjan: ["", 21] } }, Kd = ["20250101T220159Z<n>X-LIC-LOCATION:Etc/UTC<n><bs><n><tz>UTC<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Lisbon<n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Moscow<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Istanbul<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Singapore<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Seoul<n><bs><n><tz>KST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Taipei<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Warsaw<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Los_Angeles<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Shanghai<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Denver<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Auckland<n><bd><n><tz>NZDT<n><of>+1200<n><ot>+1300<n><s>19700927T020000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU<n><ed><n><bs><n><tz>NZST<n><of>+1300<n><ot>+1200<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Chatham<n><bd><n><tz>%z<n><of>+1245<n><ot>+1345<n><s>19700927T024500<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=-1SU<n><ed><n><bs><n><tz>%z<n><of>+1345<n><ot>+1245<n><s>19700405T034500<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Phoenix<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Brussels<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Tripoli<n><bs><n><tz>EET<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kwajalein<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tokyo<n><bs><n><tz>JST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Jamaica<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jerusalem<n><bd><n><tz>IDT<n><of>+0200<n><ot>+0300<n><s>19700327T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1FR<n><ed><n><bs><n><tz>IST<n><of>+0300<n><ot>+0200<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tehran<n><bs><n><tz>%z<n><of>+0330<n><ot>+0330<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Abidjan<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hong_Kong<n><bs><n><tz>HKT<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Honolulu<n><bs><n><tz>HST<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/London<n><bd><n><tz>BST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>GMT<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Dublin<n><bs><n><tz>IST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><es><n><bd><n><tz>GMT<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Cairo<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700424T000000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=-1FR<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701030T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1FR<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/New_York<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Panama<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Athens<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Havana<n><bs><n><tz>CST<n><of>-0400<n><ot>-0500<n><s>19701101T010000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>CDT<n><of>-0500<n><ot>-0400<n><s>19700308T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Chicago<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Pago_Pago<n><bs><n><tz>SST<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Detroit<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Knox<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Indianapolis<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Adak<n><bd><n><tz>HDT<n><of>-1000<n><ot>-0900<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>HST<n><of>-0900<n><ot>-1000<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Anchorage<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Port_Moresby<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tarawa<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tongatapu<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Tahiti<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Guam<n><bs><n><tz>ChST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Rarotonga<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Guadalcanal<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Pitcairn<n><bs><n><tz>%z<n><of>-0800<n><ot>-0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Palau<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Noumea<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Norfolk<n><bd><n><tz>%z<n><of>+1100<n><ot>+1200<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>%z<n><of>+1200<n><ot>+1100<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Niue<n><bs><n><tz>%z<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Nauru<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Marquesas<n><bs><n><tz>%z<n><of>-0930<n><ot>-0930<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kosrae<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kiritimati<n><bs><n><tz>%z<n><of>+1400<n><ot>+1400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Kanton<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Gambier<n><bs><n><tz>%z<n><of>-0900<n><ot>-0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Galapagos<n><bs><n><tz>%z<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Fiji<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Fakaofo<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Efate<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Easter<n><bs><n><tz>%z<n><of>-0500<n><ot>-0600<n><s>19700404T220000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SA<n><es><n><bd><n><tz>%z<n><of>-0600<n><ot>-0500<n><s>19700905T220000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=1SA<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Bougainville<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Pacific/Apia<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Mexico_City<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Mazatlan<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Tijuana<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dubai<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Nairobi<n><bs><n><tz>EAT<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Mauritius<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Maldives<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yangon<n><bs><n><tz>%z<n><of>+0630<n><ot>+0630<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Bangkok<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Indian/Chagos<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Zurich<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kyiv<n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Belgrade<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Volgograd<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Vilnius<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Vienna<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Rome<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Ulyanovsk<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Chisinau<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Tirane<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Tallinn<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Berlin<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Sofia<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Simferopol<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Saratov<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Samara<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Riga<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Prague<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Paris<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Nicosia<n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Minsk<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Helsinki<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Malta<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Madrid<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kirov<n><bs><n><tz>MSK<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Kaliningrad<n><bs><n><tz>EET<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Gibraltar<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Budapest<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Bucharest<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Astrakhan<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Europe/Andorra<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-9<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-8<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-7<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-6<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-5<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-4<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-3<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-2<n><bs><n><tz>%z<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-14<n><bs><n><tz>%z<n><of>+1400<n><ot>+1400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-13<n><bs><n><tz>%z<n><of>+1300<n><ot>+1300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-12<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-11<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-10<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT-1<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+9<n><bs><n><tz>%z<n><of>-0900<n><ot>-0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+8<n><bs><n><tz>%z<n><of>-0800<n><ot>-0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+7<n><bs><n><tz>%z<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+6<n><bs><n><tz>%z<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+5<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+4<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+3<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+2<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+12<n><bs><n><tz>%z<n><of>-1200<n><ot>-1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+11<n><bs><n><tz>%z<n><of>-1100<n><ot>-1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+10<n><bs><n><tz>%z<n><of>-1000<n><ot>-1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Etc/GMT+1<n><bs><n><tz>%z<n><of>-0100<n><ot>-0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santiago<n><bs><n><tz>%z<n><of>-0300<n><ot>-0400<n><s>19700405T000000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>%z<n><of>-0400<n><ot>-0300<n><s>19700906T000000<n><r>FREQ=YEARLY;BYMONTH=9;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Whitehorse<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Regina<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Vancouver<n><bd><n><tz>PDT<n><of>-0800<n><ot>-0700<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>PST<n><of>-0700<n><ot>-0800<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/St_Johns<n><bs><n><tz>NST<n><of>-0230<n><ot>-0330<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>NDT<n><of>-0330<n><ot>-0230<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Edmonton<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Toronto<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Winnipeg<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Halifax<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Manaus<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Sao_Paulo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Noronha<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Rio_Branco<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Broken_Hill<n><bs><n><tz>ACST<n><of>+1030<n><ot>+0930<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>ACDT<n><of>+0930<n><ot>+1030<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Perth<n><bs><n><tz>AWST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Melbourne<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Hobart<n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Sydney<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Adelaide<n><bs><n><tz>ACST<n><of>+1030<n><ot>+0930<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>ACDT<n><of>+0930<n><ot>+1030<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Brisbane<n><bs><n><tz>AEST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Darwin<n><bs><n><tz>ACST<n><of>+0930<n><ot>+0930<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Lord_Howe<n><bs><n><tz>%z<n><of>+1100<n><ot>+1030<n><s>19700405T020000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>%z<n><of>+1030<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Lindeman<n><bs><n><tz>AEST<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Australia/Eucla<n><bs><n><tz>%z<n><of>+0845<n><ot>+0845<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Stanley<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/South_Georgia<n><bs><n><tz>%z<n><of>-0200<n><ot>-0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Madeira<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Faroe<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Cape_Verde<n><bs><n><tz>%z<n><of>-0100<n><ot>-0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Canary<n><bd><n><tz>WEST<n><of>+0000<n><ot>+0100<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>WET<n><of>+0100<n><ot>+0000<n><s>19701025T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Bermuda<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Atlantic/Azores<n><bd><n><tz>%z<n><of>-0100<n><ot>+0000<n><s>19700329T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>%z<n><of>+0000<n><ot>-0100<n><s>19701025T010000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yerevan<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yekaterinburg<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Yakutsk<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Vladivostok<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ust-Nera<n><bs><n><tz>%z<n><of>+1000<n><ot>+1000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Urumqi<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ulaanbaatar<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Makassar<n><bs><n><tz>WITA<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tomsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Thimphu<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tbilisi<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Tashkent<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Srednekolymsk<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Samarkand<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Sakhalin<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ho_Chi_Minh<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Riyadh<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qyzylorda<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qostanay<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Qatar<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Pyongyang<n><bs><n><tz>KST<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Pontianak<n><bs><n><tz>WIB<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Oral<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Omsk<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Novosibirsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Novokuznetsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Manila<n><bs><n><tz>PST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Magadan<n><bs><n><tz>%z<n><of>+1100<n><ot>+1100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Macau<n><bs><n><tz>CST<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kuching<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Krasnoyarsk<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kolkata<n><bs><n><tz>IST<n><of>+0530<n><ot>+0530<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Khandyga<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kathmandu<n><bs><n><tz>%z<n><of>+0545<n><ot>+0545<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Karachi<n><bs><n><tz>PKT<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kamchatka<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Kabul<n><bs><n><tz>%z<n><of>+0430<n><ot>+0430<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jayapura<n><bs><n><tz>WIT<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Jakarta<n><bs><n><tz>WIB<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Irkutsk<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hovd<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Hebron<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700328T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701024T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Gaza<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700328T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701024T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SA<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Famagusta<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T030000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T040000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dushanbe<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dili<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Dhaka<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Damascus<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Colombo<n><bs><n><tz>%z<n><of>+0530<n><ot>+0530<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Chita<n><bs><n><tz>%z<n><of>+0900<n><ot>+0900<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Bishkek<n><bs><n><tz>%z<n><of>+0600<n><ot>+0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Beirut<n><bd><n><tz>EEST<n><of>+0200<n><ot>+0300<n><s>19700329T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>EET<n><of>+0300<n><ot>+0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Barnaul<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Baku<n><bs><n><tz>%z<n><of>+0400<n><ot>+0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Baghdad<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Atyrau<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Ashgabat<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Aqtobe<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Aqtau<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Anadyr<n><bs><n><tz>%z<n><of>+1200<n><ot>+1200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Amman<n><bs><n><tz>%z<n><of>+0300<n><ot>+0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Asia/Almaty<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Vostok<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Troll<n><bd><n><tz>+02<n><of>+0000<n><ot>+0200<n><s>19700329T010000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>+00<n><of>+0200<n><ot>+0000<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Rothera<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Palmer<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Mawson<n><bs><n><tz>%z<n><of>+0500<n><ot>+0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Macquarie<n><bs><n><tz>AEST<n><of>+1100<n><ot>+1000<n><s>19700405T030000<n><r>FREQ=YEARLY;BYMONTH=4;BYDAY=1SU<n><es><n><bd><n><tz>AEDT<n><of>+1000<n><ot>+1100<n><s>19701004T020000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Davis<n><bs><n><tz>%z<n><of>+0700<n><ot>+0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Antarctica/Casey<n><bs><n><tz>%z<n><of>+0800<n><ot>+0800<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Yakutat<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Puerto_Rico<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Thule<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Tegucigalpa<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Swift_Current<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Sitka<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Scoresbysund<n><bs><n><tz>%z<n><of>-0100<n><ot>-0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n><bd><n><tz>%z<n><of>-0200<n><ot>-0100<n><s>19700328T230000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santo_Domingo<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Santarem<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Cordoba<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Resolute<n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Recife<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Rankin_Inlet<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Punta_Arenas<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Porto_Velho<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Port-au-Prince<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Paramaribo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Iqaluit<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Ojinaga<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Nuuk<n><bd><n><tz>%z<n><of>-0200<n><ot>-0100<n><s>19700328T230000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SA<n><ed><n><bs><n><tz>%z<n><of>-0100<n><ot>-0200<n><s>19701025T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Nome<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Montevideo<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Monterrey<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Moncton<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Miquelon<n><bd><n><tz>%z<n><of>-0300<n><ot>-0200<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>%z<n><of>-0200<n><ot>-0300<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Metlakatla<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Merida<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Menominee<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Mendoza<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Matamoros<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Martinique<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Managua<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Maceio<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Kentucky/Louisville<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Lima<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/La_Paz<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Juneau<n><bd><n><tz>AKDT<n><of>-0900<n><ot>-0800<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AKST<n><of>-0800<n><ot>-0900<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Jujuy<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Inuvik<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Hermosillo<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guyana<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guayaquil<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Guatemala<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Grand_Turk<n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Goose_Bay<n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Glace_Bay<n><bd><n><tz>ADT<n><of>-0400<n><ot>-0300<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>AST<n><of>-0300<n><ot>-0400<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Fortaleza<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Fort_Nelson<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/El_Salvador<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Eirunepe<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Dawson_Creek<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Dawson<n><bs><n><tz>MST<n><of>-0700<n><ot>-0700<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Danmarkshavn<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cuiaba<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Costa_Rica<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Ciudad_Juarez<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Chihuahua<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cayenne<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Catamarca<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Caracas<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cancun<n><bs><n><tz>EST<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Campo_Grande<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Cambridge_Bay<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Buenos_Aires<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Boise<n><bd><n><tz>MDT<n><of>-0700<n><ot>-0600<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>MST<n><of>-0600<n><ot>-0700<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bogota<n><bs><n><tz>%z<n><of>-0500<n><ot>-0500<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Boa_Vista<n><bs><n><tz>%z<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Belize<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Belem<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Barbados<n><bs><n><tz>AST<n><of>-0400<n><ot>-0400<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bahia_Banderas<n><bs><n><tz>CST<n><of>-0600<n><ot>-0600<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Bahia<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Asuncion<n><bd><n><tz>%z<n><of>-0400<n><ot>-0300<n><s>19701004T000000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=1SU<n><ed><n><bs><n><tz>%z<n><of>-0300<n><ot>-0400<n><s>19700322T000000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=4SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Araguaina<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/New_Salem<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/Center<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/North_Dakota/Beulah<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Kentucky/Monticello<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Winamac<n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Vincennes<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Vevay<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Tell_City<n><bd><n><tz>CDT<n><of>-0600<n><ot>-0500<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>CST<n><of>-0500<n><ot>-0600<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Petersburg<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Indiana/Marengo<n><bd><n><tz>EDT<n><of>-0500<n><ot>-0400<n><s>19700308T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=2SU<n><ed><n><bs><n><tz>EST<n><of>-0400<n><ot>-0500<n><s>19701101T020000<n><r>FREQ=YEARLY;BYMONTH=11;BYDAY=1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Ushuaia<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Tucuman<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/San_Luis<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/San_Juan<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Salta<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/Rio_Gallegos<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:America/Argentina/La_Rioja<n><bs><n><tz>%z<n><of>-0300<n><ot>-0300<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Windhoek<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Tunis<n><bs><n><tz>CET<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Sao_Tome<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Lagos<n><bs><n><tz>WAT<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Ndjamena<n><bs><n><tz>WAT<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Monrovia<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Johannesburg<n><bs><n><tz>SAST<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Maputo<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Khartoum<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Juba<n><bs><n><tz>CAT<n><of>+0200<n><ot>+0200<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/El_Aaiun<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Ceuta<n><bd><n><tz>CEST<n><of>+0100<n><ot>+0200<n><s>19700329T020000<n><r>FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU<n><ed><n><bs><n><tz>CET<n><of>+0200<n><ot>+0100<n><s>19701025T030000<n><r>FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Casablanca<n><bs><n><tz>%z<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Bissau<n><bs><n><tz>GMT<n><of>+0000<n><ot>+0000<n><s>19700101T000000<n><es><n>", "20250101T220159Z<n>X-LIC-LOCATION:Africa/Algiers<n><bs><n><tz>CET<n><of>+0100<n><ot>+0100<n><s>19700101T000000<n><es><n>"];
function G2(t) {
  const e = t.split("/");
  return e.length === 3 && (!sa[`${e[0]}`] || !sa[`${e[0]}`][`${e[1]}`] || !sa[`${e[0]}`][`${e[1]}`][`${e[2]}`]) || e.length === 2 && (!sa[`${e[0]}`] || !sa[`${e[0]}`][`${e[1]}`]) || e.length === 1 && !sa[`${e[0]}`] ? (console.error("Given timezone not valid."), "") : e.length === 3 ? [
    sa[`${e[0]}`][`${e[1]}`][`${e[2]}`][0],
    Qd(
      Kd[sa[`${e[0]}`][`${e[1]}`][`${e[2]}`][1]]
    )
  ] : e.length === 2 ? [
    sa[`${e[0]}`][`${e[1]}`][0],
    Qd(Kd[sa[`${e[0]}`][`${e[1]}`][1]])
  ] : [
    sa[`${e[0]}`][0],
    Qd(Kd[sa[`${e[0]}`][1]])
  ];
}
function Qd(t) {
  const e = {
    "<br>": "<n>",
    "TZNAME:": "<tz>",
    "TZOFFSETFROM:": "<of>",
    "TZOFFSETTO:": "<ot>",
    "DTSTART:": "<s>",
    "RRULE:": "<r>",
    "BEGIN:DAYLIGHT": "<bd>",
    "END:DAYLIGHT": "<ed>",
    "BEGIN:STANDARD": "<bs>",
    "END:STANDARD": "<es>"
  };
  for (const [n, a] of Object.entries(e))
    t = t.replaceAll(a, n);
  return t;
}
function uP(t, e = !1) {
  const n = G2(t);
  if (n[1] == null || n[1] == "")
    return "";
  const a = function() {
    return n[0] == "" ? t : n[0];
  }(), i = "TZID=" + a, r = [
    `BEGIN:VTIMEZONE\r
TZID:` + a + `\r
X-LIC-LOCATION:` + a + `\r
LAST-MODIFIED:` + n[1].replace(/[^\w_\-:,;=+/<br>]/g, "").replace(/<br>/g, `\r
`) + "END:VTIMEZONE",
    i
  ];
  return e ? JSON.stringify(r) : r;
}
function Kc(t, e, n) {
  const a = G2(t);
  if (a[1] == null || a[1] == "")
    return "";
  if (!e.match(/^\d{4}-\d{2}-\d{2}$/))
    return console.error("offset calculation failed: date misspelled [-> YYYY-MM-DD]"), "";
  if (!n.match(/^\d{2}:\d{2}$/))
    return console.error("offset calculation failed: time misspelled [-> hh:mm]"), "";
  if (!a[1].match(/BEGIN:DAYLIGHT/i))
    return a[1].match(/TZOFFSETTO:([+|-]\d{4})/i)[1];
  const i = e + "T" + n + ":00", r = new Date(i), s = r.getFullYear(), o = r.getMonth() + 1, l = r.getDate(), c = r.getHours(), d = a[1].replace(/[^\w_\-:,;=+/<br>]/g, "").split("<br>"), f = { 1: {}, 2: {} };
  let g = 0;
  for (let L = 0; L < d.length; L++)
    if (d[`${L}`].startsWith("TZOFFSETTO") && (g++, f[`${g}`].offset = d[`${L}`].split(":")[1]), d[`${L}`].startsWith("DTSTART") && (f[`${g}`].hour = parseInt(d[`${L}`].substr(17, 2))), d[`${L}`].startsWith("RRULE")) {
      let D = d[`${L}`].split(";"), B = parseInt(D[1].split("=")[1]);
      f[`${g}`].month = parseInt(B), f[`${g}`].day = D[2].split("=")[1];
    }
  if (f[1].month > f[2].month && ([f[1], f[2]] = [f[2], f[1]]), o != f[1].month && o != f[2].month)
    return o < f[1].month || o > f[2].month ? f[2].offset : f[1].offset;
  const _ = function() {
    return Object.keys(f).find((L) => f[`${L}`].month == o);
  }(), x = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"], p = new Date(s, o, 0).getDate();
  let w = new Date(s, o - 1, 1).getDay();
  const C = { SU: {}, MO: {}, TU: {}, WE: {}, TH: {}, FR: {}, SA: {} };
  for (let L = 1; L <= p; L++) {
    const D = Object.keys(C[x[`${w}`]]).length + 1;
    C[x[`${w}`]][`${D}`] = L, w++, w == 7 && (w = 0);
  }
  const M = function() {
    if (f[`${_}`].day[0] == "-") {
      const L = f[`${_}`].day.substr(2, 2), D = Object.keys(C[`${L}`]).length + 1 - parseInt(f[`${_}`].day[1]);
      return C[`${L}`][`${D}`];
    } else {
      const L = f[`${_}`].day.substr(1, 2);
      return C[`${L}`][f[`${_}`].day[0]];
    }
  }();
  if (l > M || l == M && c >= f[`${_}`].hour)
    return f[`${_}`].offset;
  const A = function() {
    return _ == 1 ? 2 : 1;
  }();
  return f[`${A}`].offset;
}
let wc = [];
function dP(t = !1) {
  return wc.length == 0 && (wc = function() {
    let e = [];
    for (const [n, a] of Object.entries(sa))
      if (typeof a == "object" && !Array.isArray(a))
        for (const [i, r] of Object.entries(a))
          if (typeof r == "object" && !Array.isArray(r))
            for (const [s] of Object.entries(r))
              e.push(n + "/" + i + "/" + s);
          else
            e.push(n + "/" + i);
      else
        e.push(n);
    return e;
  }()), t ? JSON.stringify(wc) : wc;
}
/*!
 *  @preserve
 *
 *  ++++++++++++++++++++++
 *  Add to Calendar Button
 *  ++++++++++++++++++++++
 *
 *  Version: 2.8.6
 *  Creator: Jens Kuerschner (https://jekuer.com)
 *  Project: https://github.com/add2cal/add-to-calendar-button
 *  License: Elastic License 2.0 (ELv2) (https://github.com/add2cal/add-to-calendar-button/blob/main/LICENSE.txt)
 *  Note:    DO NOT REMOVE THE COPYRIGHT NOTICE ABOVE!
 *
 */
const X2 = "2.8.6", Km = {
  default: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:1px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:6px;--btn-padding-x:1em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 30%) 0 6px 13px -2px,rgba(0 0 0 / 25%) 0 4px 5px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:6px;--list-padding:.8em;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:6px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#3d3d3d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:.13em;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-no-text.atcb-active,.atcb-button.atcb-no-text:focus,.atcb-button.atcb-no-text:hover{height:3.26em;width:3.26em;padding:0!important}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:4px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 4px;position:absolute;z-index:14000090}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000;max-width:max-content}.atcb-list{background-color:var(--list-background);border-radius:0 0 var(--list-border-radius) var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:calc(var(--list-padding) + .45em)}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:calc(var(--list-padding) + .45em)}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:var(--list-padding)}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button.atcb-single:focus .atcb-checkmark,.atcb-button.atcb-single:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  "3d": `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:6px;--btn-padding-x:1em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 40%) 0 8px 13px -2px,rgba(0 0 0 / 30%) 0 5px 5px -3px;--btn-active-shadow-up:rgba(0 0 0 / 30%) 0 6px 13px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px,rgba(0 0 0 / 25%) 0 -3px 10px -1px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:6px;--list-padding:.8em;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:6px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow-up:rgba(0 0 0 / 80%) 2px 4px 20px -4px,rgba(0 0 0 / 30%) 1px 1px 3px -1px,rgba(0 0 0 / 45%) 0 -3px 10px -1px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--modal-btn-hover-shadow:none;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--date-btn-hover-shadow:none;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;transform:translate3d(0,0,-12px);user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){background-color:var(--btn-hover-background);z-index:15000000}.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropup,.atcb-dropoverlay){box-shadow:var(--btn-active-shadow);transform:perspective(100px) rotateX(12deg) translate3d(0,0,2px);transition:transform .1s linear}.atcb-button.atcb-active.atcb-dropup:not(.atcb-modal-style,.atcb-dropoverlay){box-shadow:var(--btn-active-shadow-up);transform:perspective(100px) rotateX(348deg) translate3d(0,0,2px);transition:transform .1s linear}.atcb-button.atcb-active.atcb-dropoverlay{transform:translate3d(0,0,0);z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:6px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;padding:0 4px;position:absolute;transform:translate3d(0,0,0);z-index:14000090}.atcb-list{background-color:var(--list-background);border-radius:0 0 var(--list-border-radius) var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-wrapper.atcb-dropdown:not(.atcb-dropup,.atcb-dropoverlay){animation:atcb-list-slide-down .4s ease 50ms 1 normal both;opacity:0}.atcb-list-wrapper.atcb-dropup:not(.atcb-dropoverlay){animation:atcb-list-slide-up .4s ease 50ms 1 normal both;opacity:0}.atcb-list-wrapper.atcb-dropoverlay{transform:translate3d(0,0,2px);z-index:15000000;animation:atcb-list-slide-center .3s ease 0s 1 normal both;opacity:0}@keyframes atcb-list-slide-down{0%{opacity:0;transform:rotateX(70deg);transform-origin:top}100%{opacity:1;transform:rotateX(0);transform-origin:top}}@keyframes atcb-list-slide-up{0%{opacity:0;transform:rotateX(70deg);transform-origin:bottom}100%{opacity:1;transform:rotateX(0);transform-origin:bottom}}@keyframes atcb-list-slide-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:calc(var(--list-padding) + .7em)}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:calc(var(--list-padding) + .7em)}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:var(--list-padding)}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  flat: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:8px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#545454;--btn-padding-x:1.2em;--btn-padding-y:.8em;--btn-shadow:#333;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--list-background:#f5f5f5;--list-hover-background:#fff;--list-border:#545454;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#545454;--list-close-text:#b0b0b0;--list-close-text-hover:#777;--list-padding:.8em;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-btn-bar:#bababa;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#545454;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#676767;--modal-headline-text-align:center;--modal-headline-text-transform:uppercase;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#414141;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--overlay-background:rgba(20 20 20 / 40%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#222;--btn-hover-background:#373737;--btn-border:#515151;--btn-shadow:#000;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--list-background:#222;--list-hover-background:#373737;--list-border:#515151;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#111;--list-close-text:#777;--list-close-text-hover:#f1f1f1;--modal-text:#f1f1f1;--modal-background:#242424;--modal-btn-bar:#313131;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#414141;--date-btn-cal-background:#c7c7cd;--date-btn-background:#2d2d2d;--date-btn-hover-background:#474747;--overlay-background:rgba(20 20 20 / 75%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:.2em solid var(--btn-border);box-sizing:content-box;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:300px;padding:var(--btn-padding-y) var(--btn-padding-x);top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button:not(.atcb-no-text,.atcb-modal-style,.atcb-dropoverlay,.atcb-single){min-width:calc(11.6em - 2 * var(--btn-padding-x))}.atcb-button.atcb-no-text{display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-button.atcb-click:not([disabled]){top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);top:-5px;left:-5px;box-shadow:5px 5px 0 0 var(--btn-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:.9em;line-height:1em;margin-right:.8em;width:.9em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:1em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-icon-trigger svg{display:none}.atcb-button .atcb-icon-trigger::after{content:"+";font-family:Arial,Helvetica,sans-serif;font-size:1.5em}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:0;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 2px 0 6px;position:absolute;z-index:16000090}.atcb-list-wrapper.atcb-no-text.atcb-dropdown{padding:0}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(150px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-150px)}100%{opacity:1;transform:translateY(0)}}.atcb-list{background:var(--list-background);box-sizing:border-box;border:.15em solid var(--list-border);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-dropup .atcb-list-item:last-child{border-bottom-width:0}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{border-top-width:0}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{border-top-width:.15em}.atcb-list-item .atcb-icon{margin:0 auto;height:1em;width:1em}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item.atcb-list-item-close:hover{color:var(--list-close-text-hover)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{border:.15em solid var(--btn-border);background-color:var(--modal-background);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{padding-top:0}.atcb-modal-content{font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{padding-top:0}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{border:.2em solid var(--btn-border);background-color:var(--modal-btn-secondary-background);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow)}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);color:var(--modal-btn-hover-text);text-decoration:none;top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-subevent-btn{border:.15em solid var(--btn-border);display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;background-color:var(--date-btn-background);padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;top:0;left:0;box-shadow:0 0 0 0 var(--btn-shadow);width:100%}.atcb-subevent-btn:hover{align-items:center;top:-3px;left:-3px;box-shadow:3px 3px 0 0 var(--btn-shadow)}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-2.1em;right:-2em;padding:.5em;border-radius:100%;height:1.5em}.atcb-checkmark svg{height:100%;width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{background-color:transparent;border:0;filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:2px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:2px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:2px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:2px solid var(--modal-btn-text);border-radius:var(--input-border-radius);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);color:var(--status-active-text);opacity:1;transform:scale(1.1)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);font-size:.8em;padding-top:1em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;padding:.5em .5em 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:.2em solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-5px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  round: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:1px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:500px;--btn-padding-x:1.3em;--btn-padding-y:.65em;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 15%) 0 4px 10px -2px,rgba(0 0 0 / 20%) 0 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 30%) 0 5px 15px -3px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--btn-active-shadow:rgba(0 0 0 / 35%) 0 6px 15px -3px,rgba(0 0 0 / 25%) 0 4px 6px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:.8em 1.2em;--list-min-width:100%;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 2px 3px 10px -3px,rgba(0 0 0 / 25%) 1px 1px 8px -4px;--modal-btn-hover-shadow:rgba(0 0 0 / 35%) 3px 5px 15px -2px,rgba(0 0 0 / 20%) 2px 4px 25px -6px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(255 255 255 / 5%) -3px -3px 30px -1px,rgba(0 0 0 / 40%) 2px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--btn-active-shadow:rgba(0 0 0 / 90%) 2px 5px 20px -4px,rgba(0 0 0 / 50%) 1px 2px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:1px solid var(--btn-border);border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:.13em;max-width:350px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button.atcb-no-text{min-width:0;border-radius:100%;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-no-text.atcb-active,.atcb-button.atcb-no-text:focus,.atcb-button.atcb-no-text:hover{height:3.26em;width:3.26em;padding:0}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-no-text),.atcb-button.atcb-single:not(.atcb-no-text,[disabled]):focus,.atcb-button.atcb-single:not(.atcb-no-text,[disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .13em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-active.atcb-no-text:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single.atcb-no-text:not([disabled]):focus,.atcb-button.atcb-single.atcb-no-text:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text);margin:0;padding:calc(var(--btn-padding-y) + .28em) calc(var(--btn-padding-x) + .13em)}.atcb-button.atcb-dropup::after,.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{content:"";width:0;height:0;position:absolute;left:0;right:0;margin:0 auto}.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{top:100%;border:0 solid transparent;border-bottom:none;border-top-color:var(--btn-border)}.atcb-button.atcb-dropup::after{bottom:100%;border:0 solid transparent;border-top:none;border-bottom-color:var(--btn-border)}.atcb-button.atcb-active.atcb-dropup::after,.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{border-width:.35em;transition:border-width .1s linear .1s}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;z-index:14000090;width:auto}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{animation:list-entrance-center .2s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content-subevents{margin:auto;width:fit-content}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button:focus .atcb-checkmark,.atcb-button:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  neumorphism: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-font-weight:600;--btn-text:#444;--btn-hover-text:#111;--btn-border-radius:15px;--btn-padding-x:1.2em;--btn-padding-y:1em;--btn-shadow:rgba(40 40 40 / 30%) 0.3em 0.3em 0.6em,rgba(255 255 255 / 70%) -0.1em -0.1em 0.3em;--btn-hover-shadow:rgba(40 40 40 / 50%) 0.4em 0.4em 0.8em,rgba(255 255 255 / 90%) -0.2em -0.2em 0.5em;--btn-active-shadow:inset rgba(40 40 40 / 40%) 0.15em 0.15em 0.3em,inset rgba(255 255 255 / 90%) -0.2em -0.2em 0.5em;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#444;--list-font-weight:400;--list-hover-text:#111;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:1em;--list-min-width:100%;--list-shadow:rgba(40 40 40 / 30%) 0.4em 0.4em 0.8em,rgba(255 255 255 / 80%) -0.2em -0.2em 0.5em;--modal-text:#111;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(5px 8px 30px rgba(0 0 0 / 70%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#222;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(40 40 40 / 15%) 0.2em 0.2em 0.4em,rgba(255 255 255 / 30%) -0.1em -0.1em 0.3em;--modal-btn-hover-shadow:rgba(40 40 40 / 40%) 0.4em 0.4em 0.7em,rgba(255 255 255 / 70%) -0.2em -0.2em 0.5em;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#e3e5ea;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:#dcdcdc;--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(0 0 0 / 70%) 0.3em 0.3em 0.6em,rgba(230 230 230 / 20%) -0.05em -0.05em 0.4em;--btn-hover-shadow:rgba(0 0 0 / 90%) 0.4em 0.4em 0.9em,rgba(230 230 230 / 25%) -0.08em -0.08em 0.6em -0.1em;--btn-active-shadow:inset rgba(0 0 0 / 80%) 0.15em 0.15em 0.25em,inset rgba(230 230 230 / 10%) -0.2em -0.2em 0.7em -0.1em;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0) 0.3em 0.3em 1em,rgba(230 230 230 / 40%) -0.08em -0.08em 0.6em;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(5px 8px 35px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(0 0 0 / 60%) 0.2em 0.2em 0.6em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.4em;--modal-btn-hover-shadow:rgba(0 0 0 / 80%) 0.3em 0.3em 0.8em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.6em;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 70%) 0.2em 0.2em 0.8em,rgba(230 230 230 / 15%) -0.1em -0.1em 0.5em;--date-btn-hover-shadow:rgba(0 0 0) 0.3em 0.4em 1em,rgba(230 230 230 / 15%) -0.2em -0.2em 0.8em;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:#141414;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{align-items:center;background-color:var(--btn-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--btn-shadow);color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.5em;margin:0;max-width:350px;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:center;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;transition:box-shadow .1s ease-in-out,background-color .1s ease-in-out;z-index:1}.atcb-button.atcb-no-text{min-width:0;border-radius:100%;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay),.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-active-shadow);color:var(--btn-hover-text)}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;width:auto;animation:list-entrance .6s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance{0%{opacity:0}100%{opacity:1}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{box-shadow:none;align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent;transition:box-shadow .15s ease-in-out,padding .15s ease-in-out,margin .15s ease-in-out}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{box-shadow:var(--btn-shadow);background-color:var(--list-hover-background);color:var(--list-hover-text);padding:calc(var(--list-padding) + .2em);margin:-.2em;position:relative;z-index:15000010}.atcb-list-item:focus-visible{box-shadow:var(--btn-shadow);background-color:var(--list-hover-background);color:var(--accent-color);padding:calc(var(--list-padding) + .2em);margin:-.2em;position:relative;z-index:15000010;outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{animation:list-entrance .6s ease 0s 1 normal forwards;filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay) .atcb-checkmark,.atcb-button.atcb-single:focus .atcb-checkmark,.atcb-button.atcb-single:hover .atcb-checkmark{top:-.77em;right:-.37em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .1s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-trigger{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;box-shadow:var(--btn-shadow);caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input:not([disabled],[type=checkbox],[type=radio]):hover{box-shadow:var(--btn-active-shadow)}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{box-shadow:var(--btn-active-shadow)}.pro-field input[type=email]:focus-visible,.pro-field input[type=number]:focus-visible,.pro-field input[type=text]:focus-visible{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;background-color:var(--input-background);border-radius:var(--input-border-radius);box-shadow:var(--btn-shadow);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{color:var(--form-success)}#rsvp-status-group label.status-declined{color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{background-color:var(--btn-hover-background);display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  text: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-underline:#a9ceff;--btn-border:#a8a8a8;--btn-padding-x:.75em;--btn-padding-y:.75em;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-font-weight:600;--btn-text:#333;--btn-hover-text:#000;--btn-hover-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 2px -1px;--btn-text-shadow:#fff;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-border-radius:11px;--list-padding:.8em 1.2em;--list-min-width:100%;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-border-radius:9px;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:6px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(200 200 200 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-underline:#336db9;--btn-border:#888;--btn-background:#2e2e2e;--btn-hover-background:#373737;--btn-text:#dedede;--btn-hover-text:#fff;--btn-text-shadow:#000;--list-background:#2e2e2e;--list-hover-background:#373737;--list-text:#dedede;--list-hover-text:#fff;--list-close-background:#282828;--list-shadow:rgba(255 255 255 / 5%) -12px -5px 20px -8px,rgba(255 255 255 / 6%) -7px -5px 15px -3px,rgba(0 0 0 / 50%) 2px 5px 18px -1px,rgba(0 0 0 / 40%) 3px 3px 20px -3px;--list-modal-shadow:rgba(255 255 255 / 8%) -12px -5px 30px -8px,rgba(255 255 255 / 8%) -7px -5px 15px -3px,rgba(0 0 0 / 60%) 4px 6px 50px -4px,rgba(0 0 0 / 90%) 8px 12px 40px -2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(0.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-initialized.atcb-buttons-list{gap:var(--buttonslist-gap)}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button{background-image:linear-gradient(120deg,var(--btn-underline) 0,var(--btn-underline) 100%);background-repeat:no-repeat;background-size:100% 8%;background-position:0 100%;background-color:transparent;border:0;border-radius:0;transition:background-size .1s ease-in,border-radius .2s ease-in,box-shadow .1s ease-in;align-items:center;color:var(--btn-text);cursor:pointer;display:flex;font-family:var(--font);font-size:1em;font-weight:var(--btn-font-weight);justify-content:center;line-height:1.2em;margin:0 .2em;padding:var(--btn-padding-y) var(--btn-padding-x);position:relative;text-align:left;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:auto;z-index:1}.atcb-button.atcb-no-text{min-width:0;display:flex;place-content:center center;align-items:center;height:3em;width:3em;padding:0}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not([disabled]):focus,.atcb-button:not([disabled]):hover{background-size:100% 100%;box-shadow:var(--btn-hover-shadow);color:var(--btn-hover-text);text-shadow:0 0 .7em var(--btn-text-shadow);border-radius:21px}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){background-size:100% 10%;border-radius:3px 3px 11px 11px;background-position:0 0;background-color:var(--btn-background);color:var(--btn-text);text-shadow:none;z-index:15000000}.atcb-button.atcb-single:not([disabled]):focus,.atcb-button.atcb-single:not([disabled]):hover{background-size:100% 10%;background-position:0 100%;border-radius:11px 11px 3px 3px;background-color:var(--btn-background);color:var(--btn-text);text-shadow:none}.atcb-button.atcb-active.atcb-dropup{background-position:0 100%;border-radius:11px 11px 3px 3px}.atcb-button.atcb-dropup::after,.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{content:"";width:0;height:0;position:absolute;left:0;right:0;margin:0 auto}.atcb-button:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{top:100%;border:0 solid transparent;border-bottom:none;border-top-color:var(--btn-background)}.atcb-button.atcb-dropup::after{bottom:100%;border:0 solid transparent;border-top:none;border-bottom-color:var(--btn-background)}.atcb-button.atcb-active.atcb-dropup::after,.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay,.atcb-dropup)::before{border-width:.35em;transition:border-width .1s linear .1s}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:.9em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:1em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-icon-trigger svg{display:none}.atcb-button .atcb-icon-trigger::after{content:"+";font-family:Arial,Helvetica,sans-serif;font-size:1.5em}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:-15px;height:0;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);position:absolute;z-index:14000090;width:auto}.atcb-list-wrapper:not(.atcb-dropup,.atcb-dropoverlay){animation:list-entrance-bottom .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropup{animation:list-entrance-top .2s ease 0s 1 normal forwards}.atcb-list-wrapper.atcb-dropoverlay{animation:list-entrance-center .2s ease 0s 1 normal forwards;z-index:15000000}@keyframes list-entrance-bottom{0%{opacity:0;transform:translateY(250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-top{0%{opacity:0;transform:translateY(-250px)}100%{opacity:1;transform:translateY(0)}}@keyframes list-entrance-center{0%{opacity:0;transform:scaleY(1)}1%{opacity:1;transform:scaleY(0)}100%{opacity:1;transform:scaleY(1)}}.atcb-list{background-color:var(--list-background);border-radius:var(--list-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:var(--list-min-width);position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:var(--list-padding);text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--list-border-radius) var(--list-border-radius)}.atcb-list-item:first-child{border-radius:var(--list-border-radius) var(--list-border-radius) 0 0}.atcb-list-item:only-child{border-radius:var(--list-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto;height:1em;width:1em}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--modal-border-radius) var(--modal-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:21px;box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:7px 4px 4px 7px;padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:100%}.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:4px 0 0 4px;align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 4px 4px 0}.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-rsvp{height:1.5em;width:1.5em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.rsvp-inline-wrapper{filter:none;min-width:100%;margin-bottom:0}.atcb-modal-content.no-headline{border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;padding-top:1.8em}.rsvp-inline-wrapper .atcb-modal-content,.rsvp-inline-wrapper .atcb-modal-headline,.rsvp-inline-wrapper.atcb-modal-box{background-color:transparent;border-radius:0;box-sizing:border-box;padding:0;width:100%}.rsvp-inline-wrapper .atcb-modal-headline{padding-bottom:1.5em}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro #rsvp-atcb{display:flex;flex-wrap:wrap;gap:.4em;justify-content:center}.pro-form{text-align:left}.pro-form:not(.no-intro){border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em}.pro-form.no-intro:not(.no-headline){padding-top:.5em}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#rsvp-status-group{border-bottom:1px solid var(--modal-btn-border);font-weight:700;margin-bottom:1.5em;padding-bottom:2em;text-align:center}#rsvp-status-group .pro-field{align-items:center;display:flex;flex-wrap:wrap;gap:3%;justify-content:center;margin-top:1em}@media (width <= 575px){#rsvp-status-group .pro-field{flex-direction:column;gap:1.2em}#rsvp-status-group .pro-field div{width:80%}}#rsvp-status-group .pro-field div{min-width:28%;position:relative}#rsvp-status-group input{opacity:0;position:absolute;top:0;left:0;height:100%;width:100%;margin:0;cursor:pointer}#rsvp-status-group label{align-items:center;border:1px solid var(--modal-btn-text);border-radius:var(--input-border-radius);color:var(--modal-btn-text);display:flex;flex-direction:column;font-weight:700;text-transform:uppercase;justify-content:center;opacity:.6;padding:.8em;transition:all .1s ease-in-out;width:100%}#rsvp-status-group label.status-confirmed{border-color:var(--form-success);color:var(--form-success)}#rsvp-status-group label.status-declined{border-color:var(--form-error);color:var(--form-error)}#rsvp-status-group input:checked+label{background-color:var(--modal-text);box-shadow:var(--btn-hover-shadow);color:var(--status-active-text);opacity:1;transform:scale(1.08)}#rsvp-status-group input:focus-visible+label{outline:2px solid var(--accent-color);outline-offset:2px}#rsvp-status-group input:not([disabled])+label:hover,#rsvp-status-group input:not([disabled]):hover+label{box-shadow:var(--btn-hover-shadow);opacity:1;transform:scale(1.08)}#rsvp-status-group input:checked+label.status-confirmed{background-color:var(--form-success)}#rsvp-status-group input:checked+label.status-declined{background-color:var(--form-error)}#rsvp-success-msg,#rsvp-success-msg-demo,#rsvp-success-msg-doi,#rsvp-success-msg-email,#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding-top:.5em;text-align:center}#rsvp-success-msg,#rsvp-success-msg-demo,#ty-success-msg{padding:1.5em 0}#rsvp-success-msg-demo,#rsvp-success-msg-email{color:var(--form-success)}#rsvp-success-msg-doi{color:var(--form-error);padding-top:1em;font-size:.8em}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.pro #rsvp-sent-content{align-items:center;display:flex;flex-direction:column;gap:1.5em}#rsvp-status-group span{color:inherit}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`,
  date: `:host{width:fit-content;--base-font-size-l:16px;--base-font-size-m:16px;--base-font-size-s:16px;--font:arial,helvetica,"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","EmojiOne Color","Android Emoji",sans-serif;--accent-color:#1e90ff;--wrapper-padding:0px;--buttonslist-gap:5px;--btn-background:#f5f5f5;--btn-hover-background:#fff;--btn-border:#d2d2d2;--btn-border-radius:4px;--btn-text:#333;--btn-hover-text:#000;--btn-shadow:rgba(0 0 0 / 13%) 0 4px 10px -2px,rgba(0 0 0 / 18%) 0 2px 3px -1px;--btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 12px -2px,rgba(0 0 0 / 25%) 0 3px 5px -2px;--list-background:#f5f5f5;--list-hover-background:#fff;--list-text:#333;--list-font-weight:400;--list-hover-text:#000;--list-close-background:#e5e5e5;--list-close-text:#777;--list-shadow:rgba(0 0 0 / 20%) 0 4px 13px -2px,rgba(0 0 0 / 23%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 50%) 0 4px 30px -3px,rgba(0 0 0 / 30%) 0 2px 8px -2px;--modal-text:#000;--modal-text-align:left;--modal-text-align-rtl:right;--modal-background:#f5f5f5;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 65%));--modal-btn-bar:#c6c8cd;--modal-btn-background:#f5f5f5;--modal-btn-secondary-background:#e2e1e6;--modal-btn-hover-background:#fff;--modal-btn-border:#d2d2d2;--modal-btn-font-weight:600;--modal-btn-text:#2e2e2e;--modal-btn-hover-text:#161616;--modal-btn-secondary-text:#666567;--modal-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 10%) 0 2px 3px -1px;--modal-btn-hover-shadow:rgba(0 0 0 / 25%) 0 5px 13px -2px,rgba(0 0 0 / 20%) 0 3px 5px -2px;--modal-headline-text-align:center;--modal-headline-text-transform:none;--input-border-radius:3px;--input-background:#fff;--status-active-text:#fff;--form-error:#c5372c;--form-success:#338a36;--date-btn-text:#1d1d1e;--date-btn-text-secondary:#3a3a3f;--date-btn-cal-day-text:#fff;--date-btn-cal-month-text:#d3d2d7;--date-btn-cal-background:#313132;--date-btn-background:#eae9ed;--date-btn-hover-background:#fff;--date-btn-headline-line-clamp:1;--date-btn-shadow:rgba(0 0 0 / 10%) 0 4px 10px -2px,rgba(0 0 0 / 15%) 0 2px 3px -1px;--date-btn-hover-shadow:rgba(0 0 0 / 20%) 0 5px 12px -2px,rgba(0 0 0 / 20%) 0 3px 4px -2px;--checkmark-background:drop-shadow(0 0 3px #fff);--overlay-background:rgba(20 20 20 / 25%);--overlay-cursor:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23777' width='16' height='16' viewBox='0 0 122.878 122.88'%3E%3Cpath d='M1.426 8.313a4.87 4.87 0 0 1 0-6.886 4.87 4.87 0 0 1 6.886 0l53.127 53.127 53.127-53.127a4.87 4.87 0 0 1 6.887 0 4.87 4.87 0 0 1 0 6.886L68.324 61.439l53.128 53.128a4.87 4.87 0 0 1-6.887 6.886L61.438 68.326 8.312 121.453a4.87 4.87 0 0 1-6.886 0 4.87 4.87 0 0 1 0-6.886l53.127-53.128L1.426 8.313h0z'/%3E%3C/svg%3E") 16 16,crosshair;--icon-ms365-color:#ea3e23;--icon-yahoo-color:#5f01d1;--icon-filter:none}:host(.atcb-dark){--btn-background:#2e2e2e;--btn-hover-background:#474747;--btn-border:#4d4d4d;--btn-text:#dedede;--btn-hover-text:#f1f1f1;--btn-shadow:rgba(0 0 0 / 70%) 0 0 25px -2px,rgba(0 0 0 / 40%) 1px 2px 4px -1px;--btn-hover-shadow:rgba(0 0 0 / 90%) 2px 3px 25px -3px,rgba(0 0 0 / 50%) 1px 4px 6px -2px;--list-background:#2e2e2e;--list-hover-background:#474747;--list-text:#dedede;--list-hover-text:#f1f1f1;--list-close-background:#282828;--list-shadow:rgba(0 0 0 / 60%) 0 4px 20px -2px,rgba(0 0 0 / 40%) 0 2px 4px -1px;--list-modal-shadow:rgba(0 0 0 / 40%) -1px 3px 30px 2px;--modal-text:#f1f1f1;--modal-background:#242424;--modal-shadow:drop-shadow(3px 6px 25px rgba(0 0 0 / 90%));--modal-btn-bar:#38383a;--modal-btn-background:#181819;--modal-btn-secondary-background:#2e2d30;--modal-btn-hover-background:#434246;--modal-btn-border:#434246;--modal-btn-text:#dbdbdb;--modal-btn-hover-text:#fff;--modal-btn-secondary-text:#b8b8b8;--modal-btn-shadow:rgba(255 255 255 / 5%) -2px -2px 10px,rgba(0 0 0 / 40%) 3px 3px 10px -2px,rgba(0 0 0 / 40%) 1px 2px 5px -1px;--input-background:#434246;--status-active-text:#000;--form-error:#db8680;--form-success:#99de9c;--date-btn-text:#ebebf0;--date-btn-text-secondary:#b5b5bd;--date-btn-cal-day-text:#101010;--date-btn-cal-month-text:#3e3e3f;--date-btn-cal-background:#c7c7cd;--date-btn-background:#363636;--date-btn-hover-background:#474747;--date-btn-shadow:rgba(0 0 0 / 60%) 0 0 20px -2px,rgba(0 0 0 / 30%) 1px 2px 3px -1px;--checkmark-background:drop-shadow(0 0 3px #0a0a0a);--overlay-background:rgba(20 20 20 / 60%);--icon-ms365-color:#ea3e23;--icon-yahoo-color:#bebebe;--icon-filter:grayscale(.2)}.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-l)}@media (width <= 991px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-m)}}@media (width <= 575px){.atcb-button-wrapper,.atcb-list,.atcb-modal-box{font-size:var(--base-font-size-s)}}.atcb-button-wrapper{display:block;padding:var(--wrapper-padding);position:relative}.atcb-button,.atcb-subevent-btn{display:flex;align-items:flex-start;cursor:pointer;font-family:var(--font);font-size:1em;box-shadow:var(--date-btn-shadow);background-color:var(--date-btn-background);border:0;border-radius:var(--btn-border-radius);padding:0;margin:0;touch-action:manipulation;position:relative;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}.atcb-subevent-btn{width:100%}.atcb-button{box-shadow:var(--btn-shadow);min-width:16em;max-width:18em;position:relative;z-index:1}.atcb-rtl .atcb-button{direction:rtl;text-align:right}.atcb-button:focus,.atcb-button:hover{background-color:var(--btn-hover-background);box-shadow:var(--btn-hover-shadow)}.atcb-button:focus-visible,.atcb-subevent-btn:focus-visible{outline:2px solid var(--accent-color)}.atcb-button:not(.atcb-active):hover,.atcb-subevent-btn:hover{align-items:center}.atcb-subevent-btn:focus,.atcb-subevent-btn:hover{background-color:var(--date-btn-hover-background);box-shadow:var(--date-btn-hover-shadow)}.atcb-button.atcb-active:not(.atcb-modal-style,.atcb-dropoverlay){z-index:15000000}.atcb-button.atcb-active.atcb-dropoverlay{z-index:14000090}.atcb-subevent-btn+.atcb-subevent-btn{margin-top:30px}.atcb-date-btn-left{border-radius:var(--btn-border-radius) 0 0 var(--btn-border-radius);align-self:stretch;background-color:var(--date-btn-cal-background);color:var(--date-btn-hover-background);padding:.7em .8em .8em;width:2.7em;align-items:center;display:flex;flex-direction:column;flex-shrink:0}.atcb-rtl .atcb-date-btn-left{border-radius:0 var(--btn-border-radius) var(--btn-border-radius) 0}.atcb-button:hover .atcb-date-btn-left,.atcb-subevent-btn:hover .atcb-date-btn-left{opacity:.8}.atcb-date-btn-day{color:var(--date-btn-cal-day-text);font-weight:400;font-size:2em;word-break:keep-all;padding-bottom:.1em}.atcb-initialized[lang=ja] .atcb-date-btn-day,.atcb-initialized[lang=ko] .atcb-date-btn-day,.atcb-initialized[lang=zh] .atcb-date-btn-day{font-size:1.3em}.atcb-date-btn-month{color:var(--date-btn-cal-month-text);font-weight:600;font-size:1em}.atcb-date-btn-right{position:relative;color:var(--date-btn-text);min-width:13.5em;overflow-wrap:anywhere}.atcb-subevent-btn .atcb-date-btn-right{width:100%}.atcb-date-btn-details{opacity:1;padding:.7em .8em;text-align:left}.atcb-rtl .atcb-date-btn-details{text-align:right}.atcb-date-btn-hover{position:absolute;top:0;left:0;width:100%;opacity:0;height:100%;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:1em;padding:.4em .7em;box-sizing:border-box}.atcb-button:not(.atcb-active):hover .atcb-date-btn-hover,.atcb-subevent-btn:hover .atcb-date-btn-hover{opacity:1}.atcb-button:not(.atcb-active):hover .atcb-date-btn-details,.atcb-subevent-btn:hover .atcb-date-btn-details{opacity:0}.atcb-date-btn-headline{font-weight:600;font-size:.9em;margin-bottom:.5em;overflow:hidden;display:-webkit-box;-webkit-line-clamp:var(--date-btn-headline-line-clamp);line-clamp:var(--date-btn-headline-line-clamp);-webkit-box-orient:vertical}.atcb-date-btn-content{display:flex;align-items:flex-start;font-size:.8em;color:var(--date-btn-text-secondary)}.atcb-date-btn-content.atcb-date-btn-cancelled{color:var(--form-error);font-weight:700}.atcb-date-btn-content-location{overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical;word-break:break-all}.atcb-date-btn-content-icon{display:inline-block;height:.8em;margin-right:.4em;margin-left:0;width:.9em;flex-shrink:0}.atcb-rtl .atcb-date-btn-content-icon{margin-right:0;margin-left:.4em}.atcb-initialized[lang=ja] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=ko] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon,.atcb-initialized[lang=zh] .atcb-date-btn-content:not(.atcb-date-btn-content-location) .atcb-date-btn-content-icon{margin-top:.15em}.atcb-date-btn-content-icon svg{height:100%;fill:currentcolor;width:100%}.atcb-date-btn-content+.atcb-date-btn-content{margin-top:.3em}.atcb-date-btn-content-text span:not(.atcb-icon-ical){padding-right:.3em;display:inline-block}.atcb-icon{flex-grow:0;flex-shrink:0;height:1em;line-height:1em;margin-right:.8em;width:1em}.atcb-rtl .atcb-icon{margin-right:0;margin-left:.8em}.atcb-no-text .atcb-icon{margin-right:0;margin-left:0}.atcb-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-text{overflow-wrap:anywhere}.atcb-dropdown-anchor{bottom:4px;height:1px;width:100%;opacity:0;position:absolute}.atcb-list-wrapper{box-sizing:border-box;font-weight:var(--list-font-weight);padding:0 4px;position:absolute;z-index:14000090}.atcb-list-wrapper.atcb-dropoverlay{z-index:15000000}.atcb-list{border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius);box-sizing:border-box;box-shadow:var(--list-shadow);color:var(--list-text);display:block;font-family:var(--font);min-width:100%;position:relative;user-select:none;-webkit-user-select:none;width:fit-content}.atcb-list-item{align-items:center;background-color:var(--list-background);box-sizing:border-box;cursor:pointer;display:flex;font-size:1em;line-height:1.75em;padding:.8em;text-align:left;touch-action:manipulation;-webkit-tap-highlight-color:transparent}.atcb-rtl .atcb-list-item{direction:rtl;text-align:right}.atcb-list-item:hover{background-color:var(--list-hover-background);color:var(--list-hover-text)}.atcb-list-item:focus-visible{background-color:var(--list-hover-background);color:var(--accent-color);outline:0}.atcb-list-item:last-child{border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius)}.atcb-dropup .atcb-list-item:last-child{border-radius:0;padding-bottom:1.25em}.atcb-dropoverlay .atcb-list .atcb-list-item:first-child,.atcb-dropup .atcb-list-item:first-child,.atcb-list.atcb-modal .atcb-list-item:first-child{border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0}.atcb-dropoverlay .atcb-list .atcb-list-item:only-child,.atcb-list.atcb-modal .atcb-list-item:only-child{border-radius:var(--btn-border-radius)}.atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:1.25em}.atcb-dropoverlay .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child,.atcb-dropup .atcb-list.atcb-generated-button:not(.atcb-modal) .atcb-list-item:first-child{padding-top:.8em}.atcb-dropoverlay .atcb-list,.atcb-list.atcb-modal{border-radius:var(--btn-border-radius)}.atcb-list.atcb-modal{box-shadow:var(--list-modal-shadow)}.atcb-list-item .atcb-icon{margin:0 auto}.atcb-list-item .atcb-icon+.atcb-text{margin-left:.7em;width:100%}.atcb-rtl .atcb-list-item .atcb-icon+.atcb-text{margin-left:0;margin-right:.7em}.atcb-list-item-close{background-color:var(--list-close-background)}.atcb-list-item.atcb-list-item-close:not(:focus-visible){color:var(--list-close-text)}.atcb-list-item-close svg{fill:currentcolor}.atcb-modal{display:block;margin:auto;width:auto;min-width:auto;position:relative;z-index:14000090}.atcb-modal-box{filter:var(--modal-shadow);color:var(--modal-text);cursor:default;box-sizing:border-box;font-family:var(--font);line-height:1.5em;text-align:var(--modal-text-align);user-select:none;-webkit-user-select:none;touch-action:manipulation;width:100%;margin-bottom:20px;-webkit-tap-highlight-color:transparent}@media (width > 575px){.atcb-modal-box{width:32em}}.atcb-modal-box.atcb-rtl{text-align:var(--modal-text-align-rtl);direction:rtl;padding:1.25em 1em 1.25em 2em}.atcb-modal-icon{height:2.5em;width:2.5em;border-radius:100%;background-color:var(--modal-background);padding:1.75em;margin:auto}.atcb-modal-icon svg{fill:currentcolor;height:100%;width:100%}.atcb-modal-headline{background-color:var(--modal-background);border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0;font-size:1.3em;font-weight:600;line-height:1.5em;padding:1.8em 1.5em 1.3em;text-transform:var(--modal-headline-text-transform);text-align:var(--modal-headline-text-align)}.atcb-modal-icon+.atcb-modal-headline{margin-top:-2.6em;padding-top:2.6em}.atcb-modal-content{background-color:var(--modal-background);font-size:1em;padding:.3em 2em 2.2em}.atcb-modal-content-subevents{margin:auto;width:fit-content}.atcb-modal-icon+.atcb-modal-content{border-radius:var(--btn-border-radius) var(--btn-border-radius) 0 0;margin-top:-2.6em;padding-top:2.6em}@media (width <= 575px){.atcb-modal-headline{padding:1.8em 1em 1em}.atcb-modal-content{padding:.3em 1.5em 1.5em}.atcb-modal-icon+.atcb-modal-content{padding-top:1.8em}}.atcb-modal-buttons{background-color:var(--modal-btn-bar);border-radius:0 0 var(--btn-border-radius) var(--btn-border-radius);box-sizing:border-box;padding:.6em;text-align:center;width:100%;display:flex;justify-content:center;flex-flow:row-reverse wrap;align-items:center}a.atcb-modal-btn,button.atcb-modal-btn{background-color:var(--modal-btn-secondary-background);border:0;border-radius:var(--btn-border-radius);box-shadow:var(--modal-btn-shadow);color:var(--modal-btn-secondary-text);cursor:pointer;display:inline-block;font-family:var(--font);font-size:.9em;font-weight:var(--modal-btn-font-weight);line-height:1em;margin:.625em;padding:1em 1.25em;position:relative;text-align:center;text-decoration:none;touch-action:manipulation;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}a.atcb-modal-btn.btn-small,button.atcb-modal-btn.btn-small{padding:.6em .8em}a.atcb-modal-btn.atcb-modal-btn-primary,button.atcb-modal-btn.atcb-modal-btn-primary{background-color:var(--modal-btn-background);color:var(--modal-btn-text)}a.atcb-modal-btn.atcb-modal-btn-border,button.atcb-modal-btn.atcb-modal-btn-border{border:1px solid var(--modal-btn-border)}a.atcb-modal-btn:focus-visible,button.atcb-modal-btn:focus-visible{background-color:var(--modal-btn-hover-background);outline:2px solid var(--accent-color)}a.atcb-modal-btn:disabled,button.atcb-button:disabled,button.atcb-modal-btn:disabled,button.atcb-subevent-btn:disabled{cursor:not-allowed;opacity:.75;filter:brightness(95%);border-style:dashed;box-shadow:none}a.atcb-modal-btn:not([disabled]):hover,button.atcb-modal-btn:not([disabled]):hover{background-color:var(--modal-btn-hover-background);box-shadow:var(--modal-btn-hover-shadow);color:var(--modal-btn-hover-text);text-decoration:none}.atcb-checkmark{display:none}.atcb-saved .atcb-checkmark{box-sizing:content-box;color:var(--btn-text);display:block;position:absolute;top:-.9em;right:-.5em;padding:.5em;border-radius:100%;height:1.2em}.atcb-checkmark svg{height:100%;filter:var(--checkmark-background);width:auto}#atcb-bgoverlay{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);background-color:var(--overlay-background);border:0;box-sizing:border-box;display:flex;height:calc(100vh + 100px);inset-inline:0;left:0;right:0;top:0;min-height:100%;min-width:100%;overflow-y:auto;padding:20px 20px 130px;position:fixed;width:100vw;z-index:14000000}#atcb-bgoverlay:not(dialog){animation:atcb-bgoverlay-animate .2s ease 0s 1 normal forwards;opacity:0}#atcb-bgoverlay.atcb-no-bg{animation:none;backdrop-filter:none;-webkit-backdrop-filter:none;opacity:1;background-color:transparent}@keyframes atcb-bgoverlay-animate{0%{opacity:0}100%{opacity:1}}#atcb-bgoverlay.atcb-click:hover{cursor:var(--overlay-cursor)}.atcb-icon-outlookcom,.atcb-icon.atcb-icon-ms365{padding-bottom:.05em}.atcb-icon.atcb-icon-apple,.atcb-icon.atcb-icon-ical{padding-bottom:.15em}.atcb-icon.atcb-icon-apple svg{fill:currentcolor}.atcb-icon.atcb-icon-ical svg{fill:currentcolor}.atcb-icon.atcb-icon-ms365 svg{fill:var(--icon-ms365-color)}.atcb-icon.atcb-icon-yahoo svg{fill:var(--icon-yahoo-color)}.atcb-icon.atcb-icon-google svg,.atcb-icon.atcb-icon-msteams svg,.atcb-icon.atcb-icon-outlookcom svg{filter:var(--icon-filter)}.pro{text-align:center}.pro ol,.pro ul{margin:auto;text-align:left;width:fit-content}.pro a:not(.atcb-modal-btn),.pro a:not(.atcb-modal-btn):active,.pro a:not(.atcb-modal-btn):visited{color:var(--modal-btn-text);text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:var(--accent-color)}.pro a:not(.atcb-modal-btn):hover{color:var(--accent-color);text-decoration:none}.pro .pro-share-buttons{display:flex;flex-wrap:wrap;justify-content:center}.pro-form{border-top:1px solid var(--modal-btn-border);margin-top:1.5em;padding-top:1.5em;text-align:left}.pro-field+.pro-field{padding-top:1.3em}.pro-field-type-label+.pro-field-type-radio{padding-top:0}.pro-field-type-checkbox,.pro-field-type-radio div{align-items:center;display:flex}.pro-field-type-checkbox input,.pro-field-type-radio input{cursor:pointer}.pro-field label{display:block;font-size:.9em;opacity:.7}.pro-field-type-checkbox label,.pro-field-type-radio label{cursor:pointer;opacity:.8;padding-left:.3em}.pro-field input[type=email],.pro-field input[type=number],.pro-field input[type=text]{background-color:var(--input-background);border:1px solid var(--modal-btn-border);border-radius:var(--input-border-radius);box-sizing:border-box;caret-color:var(--accent-color);color:var(--modal-text);font-size:.9em;opacity:.8;padding:.7em;transition:all .1s ease-in-out;width:100%}.pro-field input[type=checkbox],.pro-field input[type=radio]{accent-color:var(--accent-color);height:1.2rem;opacity:.8;transition:all .1s ease-in-out;width:1.2em}.pro-field input:disabled,.pro-field input:disabled+label{cursor:not-allowed;opacity:.75;filter:brightness(95%)}.pro-field input:not([disabled]):hover{opacity:1}.pro-field input[type=email]:focus,.pro-field input[type=number]:focus,.pro-field input[type=text]:focus{border-color:var(--accent-color);outline:1px solid var(--accent-color)}.pro-field input[type=checkbox]:focus,.pro-field input[type=radio]:focus{outline-color:var(--accent-color);outline-width:2px}#submit-error{color:var(--form-error);display:none;font-weight:700;padding-top:1.5em;text-align:center}.pro-form.form-error #submit-error{display:block}.pro-field input.error{accent-color:var(--form-error);border:2px solid var(--form-error)}.pro-field input.error+label,.pro-field:has(input.error) label{color:var(--form-error);opacity:1}#ty-success-msg{display:none;font-weight:700;line-height:1.6em;padding:1.5em 0;text-align:center}#pro-form-submit{display:block;margin:auto;min-width:150px}.pro-form-fine{font-size:.8em;margin:.5em auto 1em;opacity:.5;text-align:center}.pro-form.form-error .pro-form-fine{opacity:0}.pro-waiting{background-color:var(--modal-btn-background);border:1px solid var(--modal-btn-border);border-radius:var(--btn-border-radius);box-sizing:border-box;color:var(--modal-btn-text);cursor:wait;display:none;line-height:.5em;margin:auto;min-width:150px;padding:.5em 1.25em 1.2em;text-align:center;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;width:fit-content}@media (width > 575px){#pro-form-submit,.pro-waiting{min-width:200px}}.pro-waiting span:not(.atcb-icon-ical){animation-name:blink;animation-duration:1s;animation-iteration-count:infinite;animation-fill-mode:both;font-size:2.5em}.pro-field label span:not(.atcb-icon-ical){color:var(--form-error);font-weight:700;padding-left:2px}.pro-waiting span:not(.atcb-icon-ical):nth-child(2){animation-delay:.15s}.pro-waiting span:not(.atcb-icon-ical):nth-child(3){animation-delay:.3s}@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.atcb-modal-content .pro p:not(.pro-form-fine){margin:0}.atcb-modal-content .pro p.pro-pt{margin-top:1.5em}.atcb-modal-content .pro .pro-field p{font-size:.9em}.pro .btn-flex{align-items:center;display:flex}.pro .atcb-modal-btn svg{fill:none;height:1.5em;margin-right:.5em;stroke:currentcolor;width:auto}#atcb-reference{box-sizing:border-box;filter:drop-shadow(0 0 3px rgba(255 255 255 / 80%));height:auto;padding:8px 0;text-align:center;transform:translate3d(0,0,0);width:100%;z-index:15000000}#atcb-reference.fixed-ref{position:fixed;bottom:10px;right:40px;width:auto}#atcb-reference.atcb-dropup{position:absolute;margin-top:-1px}.atcb-modal-host-initialized #atcb-reference.atcb-dropup{text-align:left}:host(.atcb-dark) #atcb-reference{filter:drop-shadow(0 0 5px #000)}#atcb-reference a,#atcb-reference a:active,#atcb-reference a:visited{opacity:.4;width:150px;max-width:100%;margin:auto;display:inline-block;text-decoration:none}#atcb-reference.fixed-ref a{opacity:.6}#atcb-reference a:hover{opacity:.9;text-decoration:none}#atcb-reference svg{fill:var(--list-text)}`
}, Ai = () => !(typeof window > "u"), Nn = Ai() ? () => !!(/iPad|iPhone|iPod/i.test(navigator.userAgent) && !/MSStream/i.test(navigator.userAgent)) : () => !1, Gi = Ai() ? () => !!(/android/i.test(navigator.userAgent) && !/MSStream/i.test(navigator.userAgent)) : () => !1, Pl = Ai() ? () => !!/^(?:(?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) : () => !1, Pr = () => !!(Gi() || Nn()), j0 = Ai() ? () => !!/; ?wv|(?:iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) : () => !1, hP = Ai() ? () => !!/Instagram/i.test(navigator.userAgent) : () => !1, Xh = j0() ? "_system" : "_blank", fP = ["apple", "google", "ical", "ms365", "outlookcom", "msteams", "yahoo"], pP = ["apple", "google", "ical"], mP = ["msteams"], gP = ["ical"], bP = ["apple"], Ft = [], Qc = [
  "debug",
  "proOverride",
  "cspnonce",
  "identifier",
  "name",
  "dates",
  "description",
  "startDate",
  "startTime",
  "endDate",
  "endTime",
  "timeZone",
  "useUserTZ",
  "location",
  "status",
  "uid",
  "organizer",
  "attendee",
  "icsFile",
  "images",
  "recurrence",
  "recurrence_until",
  "recurrence_byDay",
  "recurrence_byMonth",
  "recurrence_byMonthDay",
  "recurrence_weekstart",
  "sequence",
  "recurrence_interval",
  "recurrence_count",
  "availability",
  "created",
  "updated",
  "subscribe",
  "options",
  "optionsMobile",
  "optionsIOS",
  "iCalFileName",
  "listStyle",
  "buttonStyle",
  "trigger",
  "hideIconButton",
  "hideIconList",
  "hideIconModal",
  "hideTextLabelButton",
  "hideTextLabelList",
  "buttonsList",
  "hideBackground",
  "hideCheckmark",
  "hideBranding",
  "size",
  "label",
  "inline",
  "inlineRsvp",
  "customLabels",
  "customCss",
  "lightMode",
  "language",
  "hideRichData",
  "bypassWebViewCheck",
  "blockInteraction",
  "styleLight",
  "styleDark",
  "disabled",
  "hidden",
  "hideButton",
  "pastDateHandling",
  "proxy",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "rsvp",
  "ty",
  "customVar",
  "domain",
  "dev"
], V0 = [
  "debug",
  "proOverride",
  "cspnonce",
  "attendee",
  "images",
  "size",
  "inline",
  "inlineRsvp",
  "customLabels",
  "customCss",
  "lightMode",
  "language",
  "bypassWebViewCheck",
  "blockInteraction",
  "styleLight",
  "styleDark",
  "disabled",
  "hidden",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "customVar",
  "proxy",
  "domain",
  "dev"
], q0 = [
  "debug",
  "proOverride",
  "useUserTZ",
  "hideIconButton",
  "hideIconList",
  "hideIconModal",
  "hideTextLabelButton",
  "hideTextLabelList",
  "subscribe",
  "hideBackground",
  "hideCheckmark",
  "hideBranding",
  "inlineRsvp",
  "hideRichData",
  "buttonsList",
  "inline",
  "bypassWebViewCheck",
  "blockInteraction",
  "disabled",
  "hidden",
  "hideButton",
  "proxy",
  "fakeMobile",
  "fakeIOS",
  "fakeAndroid",
  "forceOverlay",
  "dev"
], vP = ["customLabels", "ty", "rsvp", "customVar"], yP = ["dates"], _P = ["images", "options", "optionsMobile", "optionsIOS"], xP = ["sequence", "recurrence_interval", "recurrence_count"], gs = {
  trigger: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200.016"><path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-5.941 123.747c2.979 0 5.404 2.425 5.404 5.404s-2.425 5.404-5.404 5.404l-21.077-.065-.065 21.045c0 2.979-2.425 5.404-5.404 5.404s-5.404-2.425-5.404-5.404l.065-21.061-21.045-.081c-2.979 0-5.404-2.425-5.404-5.404s2.425-5.404 5.404-5.404l21.061.065.065-21.045c0-2.979 2.425-5.404 5.404-5.404s5.404 2.425 5.404 5.404l-.065 21.077 21.061.065zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.167V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.171c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.988 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"/></svg>',
  apple: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 245.657"><path d="M167.084 130.514c-.308-31.099 25.364-46.022 26.511-46.761-14.429-21.107-36.91-24.008-44.921-24.335-19.13-1.931-37.323 11.27-47.042 11.27-9.692 0-24.67-10.98-40.532-10.689-20.849.308-40.07 12.126-50.818 30.799-21.661 37.581-5.54 93.281 15.572 123.754 10.313 14.923 22.612 31.688 38.764 31.089 15.549-.612 21.433-10.073 40.242-10.073s24.086 10.073 40.546 9.751c16.737-.308 27.34-15.214 37.585-30.187 11.855-17.318 16.714-34.064 17.009-34.925-.372-.168-32.635-12.525-32.962-49.68l.045-.013zm-30.917-91.287C144.735 28.832 150.524 14.402 148.942 0c-12.344.503-27.313 8.228-36.176 18.609-7.956 9.216-14.906 23.904-13.047 38.011 13.786 1.075 27.862-7.004 36.434-17.376z"/></svg>',
  google: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M152.637 47.363H47.363v105.273h105.273z" fill="#fff"/><path d="M152.637 200L200 152.637h-47.363z" fill="#f72a25"/><path d="M200 47.363h-47.363v105.273H200z" fill="#fbbc04"/><path d="M152.637 152.637H47.363V200h105.273z" fill="#34a853"/><path d="M0 152.637v31.576A15.788 15.788 0 0 0 15.788 200h31.576v-47.363z" fill="#188038"/><path d="M200 47.363V15.788A15.79 15.79 0 0 0 184.212 0h-31.575v47.363z" fill="#1967d2"/><path d="M15.788 0A15.79 15.79 0 0 0 0 15.788v136.849h47.363V47.363h105.274V0z" fill="#4285f4"/><path d="M68.962 129.02c-3.939-2.653-6.657-6.543-8.138-11.67l9.131-3.76c.83 3.158 2.279 5.599 4.346 7.341 2.051 1.742 4.557 2.588 7.471 2.588 2.995 0 5.55-.911 7.699-2.718 2.148-1.823 3.223-4.134 3.223-6.934 0-2.865-1.139-5.208-3.402-7.031s-5.111-2.718-8.496-2.718h-5.273v-9.033h4.736c2.913 0 5.387-.781 7.389-2.376 2.002-1.579 2.995-3.743 2.995-6.494 0-2.441-.895-4.395-2.686-5.859s-4.053-2.197-6.803-2.197c-2.686 0-4.818.716-6.396 2.148s-2.767 3.255-3.451 5.273l-9.033-3.76c1.204-3.402 3.402-6.396 6.624-8.984s7.34-3.89 12.337-3.89c3.695 0 7.031.716 9.977 2.148s5.257 3.418 6.934 5.941c1.676 2.539 2.507 5.387 2.507 8.545 0 3.223-.781 5.941-2.327 8.187-1.546 2.23-3.467 3.955-5.729 5.143v.537a17.39 17.39 0 0 1 7.34 5.729c1.904 2.572 2.865 5.632 2.865 9.212s-.911 6.771-2.718 9.57c-1.823 2.799-4.329 5.013-7.52 6.624s-6.787 2.425-10.775 2.425c-4.622 0-8.887-1.318-12.826-3.988zm56.087-45.312l-10.026 7.243-5.013-7.601 17.985-12.972h6.901v61.198h-9.847z" fill="#1a73e8"/></svg>',
  ical: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200.016"><path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-25.228 161.263c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm-81.803-59.766c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.918 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM25.798 139.079c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.918 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM25.798 168.962c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zm40.902 0c-.553 0-.993-2.327-.993-5.208s.439-5.208.993-5.208h25.7c.553 0 .993 2.327.993 5.208s-.439 5.208-.993 5.208zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.15V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.155c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.971 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z"/></svg>',
  msteams: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 200 186.047"><path d="M195.349 39.535a20.93 20.93 0 1 1-41.86 0 20.93 20.93 0 1 1 41.86 0zm-55.847 30.233h51.66A8.84 8.84 0 0 1 200 78.605v47.056c0 17.938-14.541 32.479-32.479 32.479h0-.154c-17.938.003-32.481-14.537-32.484-32.474v-.005-51.274a4.62 4.62 0 0 1 4.619-4.619z" fill="#5059c9"/><path d="M149.614 69.767H64.34c-4.823.119-8.637 4.122-8.526 8.944v53.67c-.673 28.941 22.223 52.957 51.163 53.665 28.94-.708 51.836-24.725 51.163-53.665v-53.67c.112-4.823-3.703-8.825-8.526-8.944zm-10.079-39.535a30.233 30.233 0 0 1-60.465 0 30.233 30.233 0 0 1 60.465 0z" fill="#7b83eb"/><path opacity=".1" d="M111.628 69.767v75.209c-.023 3.449-2.113 6.547-5.302 7.86-1.015.43-2.107.651-3.209.651H59.907l-1.628-4.651c-1.628-5.337-2.459-10.885-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".2" d="M106.977 69.767v79.86a8.241 8.241 0 0 1-.651 3.209c-1.313 3.189-4.412 5.279-7.86 5.302H62.093l-2.186-4.651a46.13 46.13 0 0 1-1.628-4.651 56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".2" d="M102.326 69.767v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z"/><path opacity=".1" d="M111.628 45.721v14.651l-2.326.093c-.791 0-1.535-.046-2.326-.093-1.57-.104-3.127-.353-4.651-.744a30.233 30.233 0 0 1-20.93-17.767 25.845 25.845 0 0 1-1.488-4.651h23.209c4.693.018 8.494 3.818 8.512 8.512z"/><use xlink:href="#B" opacity=".2" transform="scale(.08973306)"/><path d="M106.977 50.372v10c-1.57-.104-3.127-.353-4.651-.744a30.233 30.233 0 0 1-20.93-17.767h17.07c4.693.018 8.494 3.818 8.512 8.512zm0 19.395v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698c-.112-4.815 3.697-8.811 8.512-8.93z" opacity=".2"/><path opacity=".2" d="M102.326 50.372v9.256a30.233 30.233 0 0 1-20.93-17.767h12.419c4.693.018 8.494 3.818 8.512 8.512z"/><linearGradient id="A" gradientUnits="userSpaceOnUse" x1="17.776" y1="35.199" x2="84.55" y2="150.848"><stop offset="0" stop-color="#5a62c3"/><stop offset=".5" stop-color="#4d55bd"/><stop offset="1" stop-color="#3940ab"/></linearGradient><path fill="url(#A)" d="M8.526 41.86H93.8a8.53 8.53 0 0 1 8.526 8.526v85.274a8.53 8.53 0 0 1-8.526 8.526H8.526A8.53 8.53 0 0 1 0 135.66V50.386a8.53 8.53 0 0 1 8.526-8.526z"/><path fill="#fff" d="M73.6 74.316H56.553v46.419h-10.86V74.316H28.726v-9.005H73.6z"/><defs><path id="B" d="M1192.167 561.355v111.442c-17.496-1.161-34.848-3.937-51.833-8.293a336.92 336.92 0 0 1-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z"/></defs></svg>',
  ms365: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 239.766"><path d="M200 219.785l-.021-.012V20.591L128.615 0 .322 48.172 0 48.234.016 192.257l43.78-17.134V57.943l84.819-20.279-.012 172.285L.088 192.257l128.515 47.456v.053l71.376-19.753v-.227z"/></svg>',
  outlookcom: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 175"><path d="M178.725 0H71.275A8.775 8.775 0 0 0 62.5 8.775v9.975l60.563 18.75L187.5 18.75V8.775A8.775 8.775 0 0 0 178.725 0z" fill="#0364b8"/><path d="M197.813 96.281c.915-2.878 2.187-5.855 2.187-8.781-.002-1.485-.795-2.857-1.491-3.26l-68.434-38.99a9.37 9.37 0 0 0-9.244-.519c-.312.154-.614.325-.906.512l-67.737 38.6-.025.013-.075.044a4.16 4.16 0 0 0-2.088 3.6c.541 2.971 1.272 5.904 2.188 8.781l71.825 52.532z" fill="#0a2767"/><path d="M150 18.75h-43.75L93.619 37.5l12.631 18.75L150 93.75h37.5v-37.5z" fill="#28a8ea"/><path d="M150 18.75h37.5v37.5H150z" fill="#50d9ff"/><path d="M150 93.75l-43.75-37.5H62.5v37.5l43.75 37.5 67.7 11.05z" fill="#0364b8"/><path d="M106.25 56.25v37.5H150v-37.5zM150 93.75v37.5h37.5v-37.5zm-87.5-75h43.75v37.5H62.5z" fill="#0078d4"/><path d="M62.5 93.75h43.75v37.5H62.5z" fill="#064a8c"/><path d="M126.188 145.113l-73.706-53.75 3.094-5.438 68.181 38.825a3.3 3.3 0 0 0 2.625-.075l68.331-38.937 3.1 5.431z" fill="#0a2767" opacity=".5"/><path d="M197.919 91.106l-.088.05-.019.013-67.738 38.588c-2.736 1.764-6.192 1.979-9.125.569l23.588 31.631 51.588 11.257v-.001c2.434-1.761 3.876-4.583 3.875-7.587V87.5c.001 1.488-.793 2.862-2.081 3.606z" fill="#1490df"/><path d="M200 165.625v-4.613l-62.394-35.55-7.531 4.294a9.356 9.356 0 0 1-9.125.569l23.588 31.631 51.588 11.231v.025a9.362 9.362 0 0 0 3.875-7.588z" opacity=".05"/><path d="M199.688 168.019l-68.394-38.956-1.219.688c-2.734 1.766-6.19 1.984-9.125.575l23.588 31.631 51.587 11.256v.001a9.38 9.38 0 0 0 3.562-5.187z" opacity=".1"/><path d="M51.455 90.721c-.733-.467-1.468-1.795-1.455-3.221v78.125c-.007 5.181 4.194 9.382 9.375 9.375h131.25c1.395-.015 2.614-.366 3.813-.813.638-.258 1.252-.652 1.687-.974z" fill="#28a8ea"/><path d="M112.5 141.669V39.581a8.356 8.356 0 0 0-8.331-8.331H62.687v46.6l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031V150h54.169a8.356 8.356 0 0 0 8.331-8.331z" opacity=".1"/><path d="M106.25 147.919V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 68.75h47.919a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M106.25 135.419V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 56.25h47.919a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M100 135.419V45.831a8.356 8.356 0 0 0-8.331-8.331H62.687v40.35l-10.5 5.987-.031.012-.075.044A4.162 4.162 0 0 0 50 87.5v.031-.031 56.25h41.669a8.356 8.356 0 0 0 8.331-8.331z" opacity=".2"/><path d="M8.331 37.5h83.337A8.331 8.331 0 0 1 100 45.831v83.338a8.331 8.331 0 0 1-8.331 8.331H8.331A8.331 8.331 0 0 1 0 129.169V45.831A8.331 8.331 0 0 1 8.331 37.5z" fill="#0078d4"/><path d="M24.169 71.675a26.131 26.131 0 0 1 10.263-11.337 31.031 31.031 0 0 1 16.313-4.087 28.856 28.856 0 0 1 15.081 3.875 25.875 25.875 0 0 1 9.988 10.831 34.981 34.981 0 0 1 3.5 15.938 36.881 36.881 0 0 1-3.606 16.662 26.494 26.494 0 0 1-10.281 11.213 30 30 0 0 1-15.656 3.981 29.556 29.556 0 0 1-15.425-3.919 26.275 26.275 0 0 1-10.112-10.85 34.119 34.119 0 0 1-3.544-15.744 37.844 37.844 0 0 1 3.481-16.563zm10.938 26.613a16.975 16.975 0 0 0 5.769 7.463 15.069 15.069 0 0 0 9.019 2.719 15.831 15.831 0 0 0 9.631-2.806 16.269 16.269 0 0 0 5.606-7.481 28.913 28.913 0 0 0 1.787-10.406 31.644 31.644 0 0 0-1.687-10.538 16.681 16.681 0 0 0-5.413-7.75 14.919 14.919 0 0 0-9.544-2.956 15.581 15.581 0 0 0-9.231 2.744 17.131 17.131 0 0 0-5.9 7.519 29.85 29.85 0 0 0-.044 21.5z" fill="#fff"/></svg>',
  yahoo: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 177.803"><path d="M0 43.284h38.144l22.211 56.822 22.5-56.822h37.135L64.071 177.803H26.694l15.308-35.645L.001 43.284zm163.235 45.403H121.64L158.558 0 200 .002zm-30.699 8.488c12.762 0 23.108 10.346 23.108 23.106s-10.345 23.106-23.108 23.106a23.11 23.11 0 0 1-23.104-23.106 23.11 23.11 0 0 1 23.104-23.106z"/></svg>',
  close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M2.321 13.529a7.927 7.927 0 0 1 0-11.208 7.927 7.927 0 0 1 11.208 0l86.471 86.471L186.47 2.321a7.927 7.927 0 0 1 11.209 0 7.927 7.927 0 0 1 0 11.208l-86.474 86.469 86.472 86.473a7.927 7.927 0 0 1-11.209 11.208l-86.471-86.471-86.469 86.471a7.927 7.927 0 0 1-11.208-11.208l86.471-86.473z"/></svg>',
  location: '<svg viewBox="0 0 200 266.42" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m148.54 230.43c-12.12 13.291-26.234 25.193-42.083 34.82-1.9513 1.431-4.5964 1.6044-6.7645 0.21681-23.416-14.895-43.08-32.782-58.539-52.23-21.334-26.755-34.755-56.414-39.351-84.99-4.6831-28.966-0.30354-56.848 14.114-79.505 5.6805-8.9543 12.944-17.106 21.79-24.153 20.337-16.196 43.557-24.76 66.713-24.586 22.288 0.17345 44.295 8.4773 63.309 25.844 6.6778 6.0707 12.293 13.03 16.89 20.575 15.502 25.54 18.841 58.105 12.033 91.104-6.7212 32.608-23.416 65.737-48.11 92.839zm-48.544-178.91c27.492 0 49.758 22.288 49.758 49.758 0 27.492-22.288 49.758-49.758 49.758-27.492 0-49.758-22.267-49.758-49.758-0.02168-27.492 22.267-49.758 49.758-49.758z" stroke-width="2.1681"/></svg>',
  warning: '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"><path d="m100 0c27.613 0 52.613 11.195 70.711 29.293 18.094 18.094 29.289 43.098 29.289 70.707 0 27.613-11.195 52.613-29.289 70.711-18.098 18.094-43.098 29.289-70.711 29.289-27.609 0-52.613-11.195-70.707-29.289-18.098-18.098-29.293-43.098-29.293-70.711 0-27.609 11.195-52.613 29.293-70.707 18.094-18.098 43.098-29.293 70.707-29.293zm57.66 42.34c-14.758-14.754-35.145-23.883-57.66-23.883-22.516 0-42.902 9.1289-57.66 23.883-14.754 14.758-23.883 35.145-23.883 57.66 0 22.516 9.1289 42.902 23.883 57.66 14.758 14.754 35.145 23.883 57.66 23.883 22.516 0 42.902-9.1289 57.66-23.883 14.754-14.758 23.883-35.145 23.883-57.66 0-22.516-9.1289-42.902-23.883-57.66z" fill="#f44336" fill-rule="nonzero" stroke-width=".39062"/><g transform="matrix(3.8384 0 0 3.8384 2277.8 -576.85)" style="shape-inside:url(#rect7396);white-space:pre" aria-label="!"><path d="m-563.8 161.59-0.65341 20.185h-5.8381l-0.65341-20.185zm-3.5796 29.503q-1.5199 0-2.6136-1.0795-1.0796-1.0796-1.0796-2.6136 0-1.5057 1.0796-2.571 1.0938-1.0796 2.6136-1.0796 1.4631 0 2.571 1.0796 1.1222 1.0653 1.1222 2.571 0 1.0227-0.52557 1.8608-0.51137 0.83807-1.3494 1.3352-0.82387 0.49715-1.8182 0.49715z"/></g></svg>',
  checkmark: '<svg version="1.1" viewBox="0 0 87.41 79.72" xmlns="http://www.w3.org/2000/svg"><path d="m2.076 33.666s6.0748-0.59297 17.413 4.2983c9.3883 4.5751 11.891 8.3955 11.891 8.3955 5.38-8.65 11.11-16.6 17.16-23.9 10.412-12.578 24.613-22.448 24.613-22.448l14.257-0.012228s-19.308 19.294-32.483 38.51-22.877 41.21-22.877 41.21-9.3948-18.164-14.53-24.53-10.77-11.59-17.52-16.22z" fill="#45b555"/></svg>',
  rsvp: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 104.31 122.88"><g><path d="M25.85,63.15c-0.04-0.12-0.08-0.28-0.1-0.42c-0.22-1.89-0.43-3.98-0.62-5.78c-0.26-2.64-0.55-5.69-0.76-7.83 c-0.14-1.45-0.6-2.83-1.27-3.86c-0.45-0.66-0.95-1.15-1.51-1.39c-0.45-0.18-1-0.2-1.57,0.02c-0.78,0.3-1.65,0.93-2.62,2.03 c-0.86,0.98-1.53,2.29-2.09,3.68c-0.79,2.03-1.26,4.19-1.45,5.67c-0.02,0.1-0.02,0.18-0.06,0.26L8.42,86.07 c-0.08,0.4-0.24,0.76-0.48,1.04c-1.81,2.33-2.95,4.33-3.28,5.95c-0.24,1.19,0,2.15,0.79,2.9l19.8,19.8 c1.26,1.21,2.72,1.97,4.47,2.29c1.91,0.36,4.14,0.16,6.7-0.54c0.04,0,0.1-0.02,0.14-0.02c0.97-0.26,2.24-0.57,3.46-0.88 c5.31-1.29,9.94-2.43,14.23-6.33l5.52-5.76c0.05-0.1,0.14-0.18,0.22-0.26s0.62-0.62,1.35-1.31c3.78-3.69,8.45-8.25,5.61-12.24 l-2.21-2.21c-1.07,1.04-2.21,2.05-3.3,3.02c-1,0.88-1.93,1.69-2.78,2.55c-0.91,0.91-2.38,0.91-3.3,0c-0.91-0.92-0.91-2.38,0-3.3 c0.86-0.86,1.91-1.79,3-2.76c3.74-3.3,8.03-7.07,5.73-10.38l-2.19-2.19c-0.12-0.12-0.22-0.26-0.31-0.4c-1.26,1.29-2.64,2.52-4,3.72 c-1,0.88-1.93,1.69-2.78,2.55c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3c0.86-0.86,1.91-1.79,3-2.76 c3.74-3.3,8.03-7.07,5.73-10.38l-2.19-2.19c-0.16-0.16-0.28-0.31-0.38-0.5l-6.42,6.42c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3 l17.22-17.25c2.88-2.88,3.54-5.88,2.78-8.15c-0.28-0.83-0.74-1.57-1.31-2.14s-1.31-1.03-2.14-1.31c-2.24-0.74-5.23-0.06-8.19,2.9 l-30.2,30.2c-0.91,0.91-2.38,0.91-3.3,0s-0.91-2.38,0-3.3l3.07-3.07L25.85,63.15L25.85,63.15L25.85,63.15z M83.23,24.31 c-1.22,1.3-3.24,1.34-4.52,0.14c-1.3-1.22-1.34-3.24-0.14-4.52l8.82-9.39c1.22-1.3,3.25-1.34,4.52-0.14 c1.3,1.22,1.34,3.24,0.14,4.52L83.23,24.31L83.23,24.31L83.23,24.31L83.23,24.31z M43.96,23.65c1.3,1.22,1.34,3.25,0.14,4.52 c-1.22,1.3-3.25,1.34-4.52,0.14l-9.4-8.82c-1.29-1.23-1.33-3.25-0.14-4.52c1.22-1.3,3.25-1.34,4.52-0.14L43.96,23.65L43.96,23.65 L43.96,23.65z M63.69,15.96c0.05,1.76-1.34,3.24-3.09,3.3s-3.24-1.34-3.3-3.09L56.91,3.3c-0.06-1.75,1.34-3.24,3.09-3.3 c1.76-0.05,3.24,1.34,3.29,3.09L63.69,15.96L63.69,15.96L63.69,15.96z M76.88,63.31c-1.3-1.22-1.34-3.25-0.14-4.52 c1.22-1.3,3.24-1.34,4.52-0.14l9.39,8.82c1.3,1.22,1.34,3.24,0.14,4.52c-1.22,1.3-3.24,1.34-4.52,0.14L76.88,63.31L76.88,63.31 L76.88,63.31z M88.36,44.35c-1.75,0.06-3.24-1.34-3.3-3.09c-0.05-1.75,1.34-3.24,3.09-3.3l12.86-0.43c1.75-0.06,3.24,1.34,3.3,3.09 s-1.34,3.24-3.09,3.3L88.36,44.35L88.36,44.35L88.36,44.35z M60.88,58.97c0.17,0.1,0.34,0.22,0.5,0.38l2.29,2.29 c0.12,0.12,0.24,0.28,0.34,0.42c2.57,3.52,2.17,6.66,0.42,9.52c0.31,0.12,0.62,0.29,0.86,0.54l2.29,2.29 c0.12,0.12,0.24,0.28,0.34,0.42c2.76,3.8,2.07,7.12,0,10.14c0.1,0.05,0.17,0.14,0.28,0.24l2.29,2.29c0.12,0.12,0.24,0.28,0.34,0.42 c5.31,7.26-1.02,13.42-6.1,18.39l-1.31,1.31l-5.67,5.95l-0.18,0.17c-5.19,4.71-10.33,5.97-16.28,7.42c-1,0.24-2,0.5-3.4,0.86 c-0.04,0-0.06,0.02-0.1,0.02c-3.22,0.88-6.14,1.09-8.76,0.62c-2.66-0.48-4.97-1.67-6.9-3.56L2.31,99.29 c-2-1.93-2.69-4.31-2.12-7.14c0.43-2.26,1.75-4.77,3.81-7.47L9.3,54.74v-0.12c0.24-1.71,0.78-4.24,1.71-6.68 c0.71-1.83,1.67-3.62,2.92-5.07c1.51-1.71,3-2.76,4.47-3.32c1.81-0.69,3.54-0.6,5.07,0.06c1.43,0.6,2.64,1.69,3.56,3.08 c1.12,1.67,1.85,3.8,2.05,6.02c0.16,1.83,0.48,4.85,0.78,7.81l0.24,2.47L53,36.07c4.4-4.4,9.16-5.27,12.97-4.02 c1.53,0.5,2.88,1.33,4,2.45s1.95,2.47,2.45,4c1.26,3.8,0.4,8.63-3.92,12.95l-7.59,7.59L60.88,58.97L60.88,58.97L60.88,58.97z"/></g></svg>'
};
async function Z2(t) {
  return t = TP(t), t.timeZone = K2(t.timeZone), t = wP(t), t = kP(t), t = SP(t), t.sizes = CP(t.size), t.lightMode = AP(t.lightMode), t = EP(t), t = Q2(t), t = LP(t), t = IP(t), t = OP(t), t = await PP(t), t;
}
function TP(t) {
  for (let e = 0; e < q0.length; e++) {
    const n = q0[`${e}`];
    if (t[`${n}`]) {
      if (typeof t[`${n}`] != "boolean") {
        const a = t[`${n}`].toString().trim().toLowerCase() || "";
        t[`${n}`] = a === "" || a === "true";
      }
    } else
      t[`${n}`] = !1;
  }
  return t;
}
function K2(t = null) {
  return !t || t === "" ? "GMT" : t;
}
function wP(t) {
  if (t.recurrence && t.recurrence !== "")
    if (t.recurrence = t.recurrence.replace(/\s+/g, "").toUpperCase(), !/^(?:RRULE:[\w=;,:+\-/\\]+|daily|weekly|monthly|yearly)$/im.test(t.recurrence))
      t.recurrence = "!wrong rrule format!";
    else if (/^RRULE:/i.test(t.recurrence)) {
      t.recurrence_simplyfied = !1;
      const e = t.recurrence.substring(6).split(";"), n = new Object();
      e.forEach(function(a) {
        n[a.split("=")[0]] = a.split("=")[1];
      }), t.recurrence_until = n.UNTIL ? n.UNTIL : "", t.recurrence_count = n.COUNT ? n.COUNT : "", t.recurrence_byDay = n.BYDAY ? n.BYDAY : "", t.recurrence_byMonth = n.BYMONTH ? n.BYMONTH : "", t.recurrence_byMonthDay = n.BYMONTHDAY ? n.BYMONTHDAY : "", t.recurrence_interval = n.INTERVAL ? n.INTERVAL : 1, t.recurrence_frequency = n.FREQ ? n.FREQ : "";
    } else
      t.recurrence_simplyfied = !0, (!t.recurrence_interval || t.recurrence_interval === "") && (t.recurrence_interval = 1), (!t.recurrence_weekstart || t.recurrence_weekstart === "" | t.recurrence_weekstart.length > 2) && (t.recurrence_weekstart = "MO"), t.recurrence_frequency = t.recurrence, t.recurrence = "RRULE:FREQ=" + t.recurrence + ";WKST=" + t.recurrence_weekstart + ";INTERVAL=" + t.recurrence_interval, t.recurrence_until && t.recurrence_until !== "" && (t.endTime && t.endTime !== "" ? t.recurrence = t.recurrence + ";UNTIL=" + t.recurrence_until.replace(/-/g, "").slice(0, 8) + "T" + t.endTime.replace(":", "") + "00" : t.recurrence = t.recurrence + ";UNTIL=" + t.recurrence_until.replace(/-/g, "").slice(0, 8)), t.recurrence_count && t.recurrence_count !== "" && (t.recurrence = t.recurrence + ";COUNT=" + t.recurrence_count), t.recurrence_byDay && t.recurrence_byDay !== "" && (t.recurrence = t.recurrence + ";BYDAY=" + t.recurrence_byDay), t.recurrence_byMonth && t.recurrence_byMonth !== "" && (t.recurrence = t.recurrence + ";BYMONTH=" + t.recurrence_byMonth), t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "" && (t.recurrence = t.recurrence + ";BYMONTHDAY=" + t.recurrence_byMonthDay);
  return t;
}
function kP(t) {
  const e = function() {
    if (Nn() || t.fakeIOS) {
      if (t.optionsIOS && t.optionsIOS.length > 0)
        return t.optionsIOS;
      if (t.optionsMobile && t.optionsMobile.length > 0)
        return t.optionsMobile;
    }
    return (Gi() || t.fakeMobile || t.fakeAndroid) && t.optionsMobile && t.optionsMobile.length > 0 ? t.optionsMobile : t.options || ["ical"];
  }();
  let n = [], a = !1, i = !1;
  for (let r = 0; r < e.length; r++) {
    const o = e[`${r}`].split("|")[0].toLowerCase().replace("microsoft", "ms").replace(/\./, "");
    o === "apple" && (i = !0), o === "ical" && (a = !0), !((Nn() || t.fakeIOS) && gP.includes(o) || (Gi() || t.fakeAndroid) && bP.includes(o) || t.recurrence && t.recurrence !== "" && (!pP.includes(o) || t.recurrence_until && t.recurrence_until !== "" && (o === "apple" || o === "ical") || (Nn() || t.fakeIOS) && o === "google") || t.subscribe && mP.includes(o)) && ((Pr() || t.fakeMobile) && t.subscribe && (o === "ms365" || o === "outlookcom") || n.push(o));
  }
  return t.subscribe && t.icsFile && t.icsFile.startsWith("https://calendar.google.com/calendar/") && !t.icsFile.endsWith(".ics") && (n = ["google"]), n.length === 0 && (!Nn() && !t.fakeIOS && n.push("ical"), a = !0), (Nn() || t.fakeIOS) && a && !i && n.push("apple"), (Gi() || t.fakeAndroid) && i && !a && n.push("ical"), t.options = n, t;
}
function SP(t) {
  return t.inlineRSVP && (t.inline = !0), (!t.listStyle || t.listStyle === "") && (t.listStyle = "dropdown"), t.listStyle === "modal" && (t.trigger = "click"), t.buttonStyle && t.buttonStyle !== "" && t.buttonStyle != "default" ? (t.buttonStyle == "round" || t.buttonStyle == "text" || t.buttonStyle == "date" || t.buttonStyle == "neumorphism") && (t.trigger = "click") : t.buttonStyle = "default", (t.buttonStyle == "default" || t.buttonStyle == "3d" || t.buttonStyle == "flat") && !t.hideTextLabelList && t.hideTextLabelButton && (t.listStyle == "dropdown" || t.listStyle == "dropdown-static" || t.listStyle == "dropup-static") && (t.listStyle = "overlay"), t.buttonsList && t.buttonStyle == "date" && (t.buttonsList = !1), t;
}
function CP(t) {
  const e = [];
  if (e.l = e.m = e.s = 16, t && t !== "") {
    const n = t.split("|");
    for (let a = 0; a < n.length; a++)
      n[`${a}`] = parseInt(n[`${a}`]);
    n[0] >= 0 && n[0] < 11 && (e.l = e.m = e.s = 10 + n[0]), n.length > 2 ? (n[1] >= 0 && n[1] < 11 && (e.m = 10 + n[1]), n[2] >= 0 && n[2] < 11 && (e.s = 10 + n[2])) : n.length == 2 && n[1] >= 0 && n[1] < 11 && (e.m = e.s = 10 + n[1]);
  }
  return e;
}
function AP(t = "") {
  return t == "system" && Ai() ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : t != "bodyScheme" && t != "dark" ? "light" : t;
}
function EP(t) {
  return (!t.language || t.language === "" || !bB.includes(t.language)) && (t.language = "en"), t.language.length > 2 && (t.language = t.language.substring(0, 2)), gB.includes(t.language) ? t.rtl = !0 : t.rtl = !1, t;
}
function Q2(t) {
  if (t.dates && t.dates.length > 0)
    for (let n = 0; n < t.dates.length; n++) {
      !t.dates[`${n}`].timeZone && t.timeZone && (t.dates[`${n}`].timeZone = t.timeZone), !t.dates[`${n}`].useUserTZ && t.useUserTZ && (t.dates[`${n}`].useUserTZ = t.useUserTZ);
      const a = Qm(t.dates[`${n}`]);
      t.dates[`${n}`].startDate = a.startDate, t.dates[`${n}`].endDate = a.endDate, t.dates[`${n}`].startTime = a.startTime, t.dates[`${n}`].endTime = a.endTime, t.dates[`${n}`].timeZone = a.timeZone, t.dates[`${n}`].timestamp = Jd("timestamp", t.dates[`${n}`].startDate, t.dates[`${n}`].startTime, t.dates[`${n}`].timeZone), t.dates[`${n}`].overdue = Jd("overdue", t.dates[`${n}`].endDate, t.dates[`${n}`].endTime, t.dates[`${n}`].timeZone);
    }
  else {
    t.dates = [], t.dates[0] = new Object(), t.useUserTZ && (t.dates[0].useUserTZ = t.useUserTZ);
    const n = Qm(t);
    t.startDate = t.dates[0].startDate = n.startDate, t.endDate = t.dates[0].endDate = n.endDate, t.startTime = t.dates[0].startTime = n.startTime, t.endTime = t.dates[0].endTime = n.endTime, t.timeZone = t.dates[0].timeZone = n.timeZone, t.recurrence ? t.dates[0].overdue = !1 : t.dates[0].overdue = Jd("overdue", t.endDate, t.endTime, t.timeZone);
  }
  const e = /* @__PURE__ */ new Date();
  return (!t.created || t.created === "") && (t.created = oa(e, "clean", !0)), (!t.updated || t.updated === "") && (t.updated = oa(e, "clean", !0)), t;
}
function LP(t) {
  return (!t.status || t.status === "") && (t.status = "CONFIRMED"), (!t.sequence || t.sequence === "") && (t.sequence = 0), t;
}
function DP(t, e) {
  const n = (i) => i.replace(/(\\r\\n|\\n|\\r|<br(\s*\/?)>)/g, "");
  let a = t.dates[`${e}`].description || t.description || "";
  if (a) {
    if (a = n(a), t.customVar)
      for (const s in t.customVar) {
        const o = "%%" + s.replace(/[^\w\-.]/g, "") + "%%";
        a = a.replace(new RegExp(o, "gi"), t.customVar[`${s}`]);
      }
    const i = vs(a, !0), r = vs(a, !0, !0);
    a = vs(a), t.dates[`${e}`] = { ...t.dates[`${e}`], description: a, descriptionHtmlFree: i, descriptionHtmlFreeICal: r };
  } else
    t.dates[`${e}`].descriptionHtmlFree = t.dates[`${e}`].descriptionHtmlFreeICal = t.dates[`${e}`].description = "";
  return t;
}
function IP(t) {
  for (let e = 0; e < t.dates.length; e++)
    if (t = DP(t, e), (!t.dates[`${e}`].name || t.dates[`${e}`].name === "") && (t.dates[`${e}`].name = t.name), t.dates[`${e}`].status ? t.dates[`${e}`].status = t.dates[`${e}`].status.toUpperCase() : t.dates[`${e}`].status = t.status.toUpperCase(), t.dates[`${e}`].sequence || (t.dates[`${e}`].sequence = t.sequence), !t.dates[`${e}`].organizer && t.organizer && (t.dates[`${e}`].organizer = t.organizer), !t.dates[`${e}`].attendee && t.attendee && (t.dates[`${e}`].attendee = t.attendee), !t.dates[`${e}`].availability && t.availability ? t.dates[`${e}`].availability = t.availability.toLowerCase() : t.dates[`${e}`].availability && (t.dates[`${e}`].availability = t.dates[`${e}`].availability.toLowerCase()), !t.dates[`${e}`].location && t.location && (t.dates[`${e}`].location = t.location), t.dates[`${e}`].location && t.dates[`${e}`].location.startsWith("http") ? t.dates[`${e}`].onlineEvent = !0 : t.dates[`${e}`].onlineEvent = !1, t.dates[`${e}`].uid || (e === 0 && t.uid && t.uid !== "" ? t.dates[0].uid = t.uid : t.uid && t.uid !== "" ? t.dates[`${e}`].uid = t.uid + "-" + (e + 1) : t.dates[`${e}`].uid = cv()), t.customVar)
      for (const n in t.customVar) {
        const a = "%%" + n.replace(/[^\w\-.]/g, "") + "%%";
        t.dates[`${e}`].name = t.dates[`${e}`].name.replace(new RegExp(a, "gi"), t.customVar[`${n}`]), t.dates[`${e}`].location = t.dates[`${e}`].location.replace(new RegExp(a, "gi"), t.customVar[`${n}`]);
      }
  return t.recurrence && t.recurrence !== "" && (t.dates[0].recurrence = t.recurrence), t.dates.length > 1 && t.dates.sort((e, n) => e.timestamp - n.timestamp), t;
}
function Qm(t) {
  function e(i) {
    return /^\d\d\d\d-\d\d-\d\d(?:T\d\d:\d\d)?(?::\d\d)?(?:.\d\d\d)?Z?$/i.test(i);
  }
  function n(i) {
    return /^today(?:\+(?:\d|\d\d|\d\d\d|\d\d\d\d))?$/i.test(i);
  }
  if ((!t.endDate || t.endDate === "") && (t.endDate = t.startDate), ["start", "end"].forEach(function(i) {
    const r = t[i + "Date"];
    if (!e(r) && !n(r))
      t[i + "Date"] = "badly-formed";
    else {
      if (n(r) && (t[i + "Date"] = MP(r)), t[i + "Date"]) {
        const s = t[i + "Date"].split("T");
        s[1] && (t[i + "Date"] = s[0], t[i + "Time"] = s[1]);
      }
      t[i + "Time"] && t[i + "Time"].length > 5 && (t[i + "Time"] = t[i + "Time"].substring(0, 5));
    }
  }), t.timeZone === "currentBrowser" || t.useUserTZ) {
    const i = Intl.DateTimeFormat().resolvedOptions().timeZone || "GMT";
    if (t.useUserTZ && t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "") {
      const r = l1(t.startDate, t.startTime, t.timeZone, i), s = l1(t.endDate, t.endTime, t.timeZone, i);
      t.startDate = r[0], t.startTime = r[1], t.endDate = s[0], t.endTime = s[1];
    }
    t.timeZone = i;
  }
  return t;
}
function Jd(t, e, n = null, a) {
  try {
    const i = function() {
      if (n) {
        const s = Kc(a, e, n);
        return /* @__PURE__ */ new Date(e + " " + n + ":00 GMT" + s);
      }
      return new Date(e);
    }();
    if (t === "timestamp")
      return i.getTime();
    n || i.setDate(i.getDate() + 1);
    const r = (/* @__PURE__ */ new Date()).toISOString();
    return i.getTime() < new Date(r).getTime();
  } catch {
    return !1;
  }
}
function MP(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getUTCFullYear() + "-" + (e.getUTCMonth() + 1) + "-" + e.getUTCDate();
  t = t.replace(/today/gi, n);
  const a = t.split("+"), i = a[0].split("-"), r = new Date(Date.UTC(i[0], i[1] - 1, i[2].substring(0, 2)));
  a[1] && a[1] > 0 && r.setDate(r.getDate() + parseInt(a[1]));
  try {
    return r.toISOString().replace(/T(\d{2}:\d{2}:\d{2}\.\d{3})Z/g, "");
  } catch {
    return !1;
  }
}
function OP(t) {
  return (!t.pastDateHandling || t.pastDateHandling != "disable" && t.pastDateHandling != "hide") && (t.pastDateHandling = "none"), t.allOverdue = function() {
    for (let e = 0; e < t.dates.length; e++)
      if (!t.dates[`${e}`].overdue)
        return !1;
    return !0;
  }(), t.allOverdue && (t.pastDateHandling == "disable" ? t.disabled = !0 : t.pastDateHandling == "hide" && (t.hidden = !0)), t.allCancelled = function() {
    for (let e = 0; e < t.dates.length; e++)
      if (!t.dates[`${e}`].status || t.dates[`${e}`].status.toLowerCase() !== "cancelled")
        return !1;
    return !0;
  }(), (t.disabled || t.hidden) && (t.blockInteraction = !0), t;
}
async function PP(t) {
  if (typeof n1 != "function" || !t.rsvp || !t.proKey || Object.keys(t.rsvp).length === 0) return t;
  if (t.rsvp.expired = function() {
    return !!(t.rsvp && t.rsvp.expires && new Date(t.rsvp.expires) < /* @__PURE__ */ new Date());
  }(), t.rsvp.max) {
    const e = await n1(t.proKey, t.dev);
    t.rsvp.seatsLeft = t.rsvp.max - e, t.rsvp.seatsLeft < 1 && (t.rsvp.bookedOut = !0), (t.rsvp.expired || t.rsvp.bookedOut) && (t.blockInteraction = !0), t.blockInteraction && (t.disabled = !0);
  }
  return t;
}
async function Jm(t) {
  if (!t.name || t.name === "")
    throw new Error("Add to Calendar Button generation failed: required name information missing");
  if (t.dates != null && t.dates.length > 0) {
    if (t.subscribe === !0 && t.dates.length > 1)
      throw new Error("Add to Calendar Button generation failed: a subscription calendar cannot be a multi-date setup");
    const e = ["name", "startDate"], n = ["name"];
    return e.every(function(a) {
      for (let i = 0; i < t.dates.length; i++)
        if (!n.includes(`${a}`) && (!t.dates[`${i}`][`${a}`] || t.dates[`${i}`][`${a}`] === "") || n.includes(`${a}`) && (!t.dates[`${i}`][`${a}`] || t.dates[`${i}`][`${a}`] === "") && (!t[`${a}`] || t[`${a}`] === "")) {
          if (!t.subscribe || a !== "startDate")
            throw new Error("Add to Calendar Button generation failed: required setting missing [dates array object #" + (i + 1) + "/" + t.dates.length + "] => [" + a + "]");
          t.dates[`${i}`].startDate = "today";
        }
      return !0;
    });
  } else
    return ["startDate"].every(function(n) {
      if (!t[`${n}`] || t[`${n}`] === "") {
        if (!t.subscribe || n !== "startDate")
          throw new Error("Add to Calendar Button generation failed: required setting missing [" + n + "]");
        t.startDate = "today";
      }
      return !0;
    });
}
async function BP(t) {
  const e = "Add to Calendar Button generation (" + t.identifier + ")";
  try {
    return await J2(t, e), await RP(t, e), await NP(t, e), await $P(t, e), await FP(t, e), await zP(t, e), await UP(t, e), await ZP(t, e), t.recurrence_simplyfied && await KP(t, e), !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
async function J2(t, e, n = "", a = "") {
  const i = function() {
    return n !== "" && t.dates[`${n}`].icsFile ? t.dates[`${n}`].icsFile : n === "" && t.icsFile ? t.icsFile : "";
  }();
  if (i !== "" && (!Es(i, !1) || !t.icsFile.startsWith("https://") && !t.icsFile.startsWith("http://")))
    throw new Error(e + " failed: explicit ics file path not valid" + a);
  return !0;
}
async function RP(t, e) {
  if (!["default", "3d", "flat", "round", "neumorphism", "text", "date", "custom", "none"].includes(t.buttonStyle))
    throw new Error(e + " failed: provided buttonStyle invalid");
  if (t.customCss && t.customCss !== "" && (!Es(t.customCss, !1) || !/\.css(?:$|\?)/.test(t.customCss)))
    throw new Error(e + " failed: customCss provided, but no valid url");
  if ((!t.customCss || t.customCss === "") && t.buttonStyle === "custom")
    throw new Error(e + ' failed: buttonStyle "custom" selected, but no customCss file provided');
  if (t.rsvp && (t.buttonStyle === "date" || t.buttonStyle === "none"))
    throw new Error(e + " failed: buttonStyle " + t.buttonStyle + " is not compatible with the RSVP functionality");
  return !0;
}
async function NP(t, e) {
  if (t.subscribe === !0 && (!t.icsFile || t.icsFile === ""))
    throw new Error(e + " failed: a subscription calendar requires a valid explicit ics file as well");
  return !0;
}
async function $P(t, e) {
  if (!/^\d{8}T\d{6}Z$/.test(t.created))
    throw new Error(e + " failed: created date format not valid. Needs to be a full ISO-8601 UTC date and time string, formatted YYYYMMDDTHHMMSSZ");
  return !0;
}
async function FP(t, e) {
  if (!/^\d{8}T\d{6}Z$/.test(t.updated))
    throw new Error(e + " failed: updated date format not valid. Needs to be a full ISO-8601 UTC date and time string, formatted YYYYMMDDTHHMMSSZ");
  return !0;
}
async function zP(t, e) {
  return t.options.every((a) => {
    if (!fP.includes(a))
      throw new Error(`${e} failed: invalid option [${a}]`);
    return !0;
  });
}
async function UP(t, e) {
  try {
    for (let n = 0; n < t.dates.length; n++) {
      const a = function() {
        return t.dates.length === 1 ? "" : " [dates array object #" + (n + 1) + "/" + t.dates.length + "] ";
      }();
      await J2(t, e, n, a), await HP(t, e, n, a), await YP(t, e, n, a), await jP(t, e, n, a), await VP(t, e, n, a), await qP(t, e, n, a), await WP(t, e, n, a), await GP(t, e, n, a), await XP(t, e, n, a);
    }
    return !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
async function HP(t, e, n, a) {
  if (!["tentative", "confirmed", "cancelled"].includes(t.dates[`${n}`].status.toLowerCase()))
    throw new Error(e + " failed: event status needs to be TENTATIVE, CONFIRMED, or CANCELLED" + a);
  return !0;
}
async function YP(t, e, n, a) {
  if (t.dates[`${n}`].availability && t.dates[`${n}`].availability !== "" && t.dates[`${n}`].availability !== "free" && t.dates[`${n}`].availability !== "busy")
    throw new Error(e + ' failed: event availability needs to be "free" or "busy"' + a);
  return !0;
}
async function jP(t, e, n, a) {
  if (t.dates[`${n}`].organizer && t.dates[`${n}`].organizer !== "") {
    const i = t.dates[`${n}`].organizer.split("|");
    if (i.length !== 2 || i[0].length > 50 || i[1].length > 100 || !Jc(i[1]))
      throw new Error(e + ' failed: organizer needs to match the schema "NAME|EMAIL" with a valid email address' + a);
  }
  return !0;
}
async function VP(t, e, n, a) {
  if (t.dates[`${n}`].attendee && t.dates[`${n}`].attendee !== "") {
    if (!t.dates[`${n}`].organizer || t.dates[`${n}`].organizer === "")
      throw new Error(e + " failed: if an attendee is set, you also need to set the organizer" + a);
    const i = t.dates[`${n}`].attendee.split("|");
    if (i.length === 1 && Jc(i[0]))
      return !0;
    if (i.length !== 2 || i[0].length > 50 || i[1].length > 100 || !Jc(i[1]))
      throw new Error(e + ' failed: attendee needs to be a valid email address or match the schema "NAME|EMAIL" with EMAIL being a valid email address' + a);
  }
  return !0;
}
async function qP(t, e, n, a) {
  return /^(?:\w|-){1,254}$/.test(t.dates[`${n}`].uid) || (t.debug && console.warn(e + ": UID not valid. May only contain alpha, digits, and dashes; and be less than 255 characters. Falling back to an automated value!" + a), t.dates[`${n}`].uid = cv()), !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t.dates[`${n}`].uid) && t.debug && console.warn(e + ": UID is highly recommended to be a hex-encoded random Universally Unique Identifier (UUID)!" + a), !0;
}
async function WP(t, e, n, a) {
  return t.dates[`${n}`].sequence && (t.dates[`${n}`].sequence < 0 || t.dates[`${n}`].sequence % 1 !== 0) && (t.debug && console.log(e + ": sequence needs to be a full number >= 0. Used the default 0 instead" + a), t.dates[`${n}`].sequence = 0), !0;
}
async function GP(t, e, n, a) {
  if (!dP().includes(t.dates[`${n}`].timeZone))
    throw new Error(e + " failed: invalid time zone given" + a);
  return !0;
}
async function XP(t, e, n, a) {
  const i = t.dates[`${n}`], r = ["startDate", "endDate"], s = {};
  if (r.forEach((l) => {
    const c = i[`${l}`];
    if (c.length !== 10)
      throw new Error(`${e} failed: date misspelled [-> YYYY-MM-DD]${a}`);
    const d = c.split("-");
    if (d.length !== 3)
      throw new Error(`${e} failed: date misspelled [${l}: ${c}]${a}`);
    s[`${l}`] = new Date(d[0], d[1] - 1, d[2]);
  }), ["startTime", "endTime"].forEach((l) => {
    const c = i[`${l}`];
    if (c) {
      if (c.length !== 5)
        throw new Error(`${e} failed: time misspelled [-> HH:MM]${a}`);
      const d = c.split(":");
      if (d.length !== 2 || d[0] > 23 || d[1] > 59)
        throw new Error(`${e} failed: time misspelled [${l}: ${c}]${a}`);
      const f = l === "startTime" ? "startDate" : "endDate";
      s[`${f}`] = new Date(s[`${f}`].getTime() + parseInt(d[0], 10) * 36e5 + parseInt(d[1], 10) * 6e4);
    }
  }), i.startTime && !i.endTime || !i.startTime && i.endTime)
    throw new Error(`${e} failed: if you set a starting or end time, the respective other one also needs to be defined${a}`);
  if (s.endDate < s.startDate)
    throw new Error(`${e} failed: end date before start date${a}`);
  return !0;
}
async function ZP(t, e) {
  if (t.recurrence && t.recurrence !== "" && t.dates.length > 1)
    throw new Error(e + " failed: RRULE and multi-date set at the same time");
  if (t.recurrence && t.recurrence !== "" && !/^RRULE:[\w=;,:+\-/\\]+$/i.test(t.recurrence))
    throw new Error(e + " failed: RRULE data misspelled");
  return !0;
}
async function KP(t, e) {
  if (t.recurrence_interval && (t.recurrence_interval < 1 || t.recurrence_interval % 1 !== 0))
    throw new Error(e + " failed: recurrence data (interval) misspelled");
  if (t.recurrence_until && t.recurrence_until !== "" && !/^[\d\-:]+$/.test(t.recurrence_until))
    throw new Error(e + " failed: recurrence data (until) misspelled");
  if (t.recurrence_count && (t.recurrence_count < 1 || t.recurrence_count % 1 !== 0))
    throw new Error(e + " failed: recurrence data (interval) misspelled");
  if (t.recurrence_byMonth && t.recurrence_byMonth !== "" && !/^[\d,]+$/.test(t.recurrence_byMonth))
    throw new Error(e + " failed: recurrence data (byMonth) misspelled");
  if (t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "" && !/^[\d,]+$/.test(t.recurrence_byMonthDay))
    throw new Error(e + " failed: recurrence data (byMonthDay) misspelled");
  if (t.recurrence_byDay && t.recurrence_byDay !== "" && !/^(?:[\d,-]|MO|TU|WE|TH|FR|SA|SU)+$/im.test(t.recurrence_byDay))
    throw new Error(e + " failed: recurrence data (byDay) misspelled");
  if (t.recurrence_weekstart && t.recurrence_weekstart !== "" && !/^(?:MO|TU|WE|TH|FR|SA|SU)$/im.test(t.recurrence_weekstart))
    throw new Error(e + " failed: recurrence data (weekstart) misspelled");
  return !0;
}
function Sn(t, e, n = "", a = null, i = !1, r = !1) {
  e == "open" ? e1(t, n, a, i, r) : e == "close" || a.classList.contains("atcb-active") || t.querySelector(".atcb-active-modal") ? nl(t, i) : e1(t, n, a, i, r);
}
async function e1(t, e, n = null, a = !1, i = !1) {
  if (t.querySelector(".atcb-list") || t.querySelector(".atcb-modal")) return;
  sn("openList", e.identifier, e.identifier), Ft.active = e.identifier;
  const r = tB(t, e), s = document.createElement("div");
  s.classList.add("atcb-list-wrapper"), s.setAttribute("part", "atcb-list-wrapper"), e.hideTextLabelList && s.classList.add("atcb-no-text"), n ? (n.classList.add("atcb-active"), n.setAttribute("aria-expanded", !0), e.listStyle === "modal" ? (n.classList.add("atcb-modal-style"), r.classList.add("atcb-modal")) : (s.append(r), s.classList.add("atcb-dropdown"), e.listStyle === "overlay" && s.classList.add("atcb-dropoverlay")), i && r.classList.add("atcb-generated-button")) : r.classList.add("atcb-modal");
  const o = iv(t, e.trigger, e.listStyle === "modal", !e.hideBackground);
  if (e.listStyle === "modal") {
    const c = await Bl(t, e);
    c.querySelector(".atcb-modal-host-initialized").append(o), o.append(r), e.hideBranding || gl(c, !1), vl(r, e.sizes), Zh(c), Br(o);
  } else
    e.forceOverlay && (t = await nB(t, e), n = t.querySelector("button.atcb-button")), t.querySelector(".atcb-initialized").append(s), s.append(r), e.buttonStyle != "default" && s.classList.add("atcb-style-" + e.buttonStyle), e.hideBranding || gl(t), t.append(o), vl(r, e.sizes), s.style.display = "none", setTimeout(function() {
      s.style.display = "block", e.listStyle === "dropdown-static" ? e0(t, n, s, !0) : e.listStyle === "dropup-static" ? e0(t, n, s, !1, !0) : e0(t, n, s);
    }, 5), Br(o);
  const l = function() {
    const c = t.querySelector(".atcb-list-item");
    if (c)
      return c;
    const d = document.getElementById(e.identifier + "-modal-host");
    if (d)
      return d.shadowRoot.querySelector(".atcb-list-item");
  }();
  l && (a ? l.focus() : (l.focus({ preventScroll: !0 }), l.blur()));
}
function nl(t, e = !1) {
  const n = document.getElementById(t.host.getAttribute("atcb-button-id") + "-modal-host"), a = function() {
    return !n || n.length === 0 ? [] : n.shadowRoot.querySelectorAll(".atcb-modal[data-modal-nr]");
  }();
  if (a.length > 1) {
    n.shadowRoot.querySelectorAll('.atcb-modal[data-modal-nr="' + a.length + '"]')[0].remove();
    const i = n.shadowRoot.querySelectorAll('.atcb-modal[data-modal-nr="' + (a.length - 1) + '"]')[0];
    i.classList.remove("atcb-hidden");
    let r = i;
    const s = i.getElementsByTagName("button");
    s.length > 0 && (r = s[0]), r.focus(), e || r.blur();
  } else {
    const i = function() {
      const s = t.querySelector(".atcb-active, .atcb-active-modal");
      return s || document.querySelector(".atcb-active, .atcb-active-modal");
    }();
    i && (i.focus({ preventScroll: !0 }), e || i.blur()), Array.from(t.querySelectorAll(".atcb-active")).forEach((s) => {
      s.classList.remove("atcb-active"), s.setAttribute("aria-expanded", !1);
    }), Array.from(t.querySelectorAll(".atcb-active-modal")).forEach((s) => {
      s.classList.remove("atcb-active-modal");
    }), Array.from(document.querySelectorAll(".atcb-active")).forEach((s) => {
      s.classList.remove("atcb-active"), s.setAttribute("aria-expanded", !1);
    }), Array.from(document.querySelectorAll(".atcb-active-modal")).forEach((s) => {
      s.classList.remove("atcb-active-modal");
    }), n && n.remove(), document.body.classList.remove("atcb-modal-no-scroll"), document.documentElement.classList.remove("atcb-modal-no-scroll"), Array.from(t.querySelectorAll(".atcb-list-wrapper")).concat(Array.from(t.querySelectorAll(".atcb-list"))).concat(Array.from(t.querySelectorAll("#atcb-reference"))).concat(Array.from(t.querySelectorAll("#atcb-bgoverlay"))).forEach((s) => s.remove());
    const r = document.querySelector(".atcb-shadow-hide");
    r && (r.shadowRoot.querySelector(".atcb-initialized").style.opacity = "1", r.classList.remove("atcb-shadow-hide"), window.removeEventListener("scroll", eu), window.removeEventListener("resize", eu)), Ft.active = "";
  }
}
async function t1(t, e) {
  let n = t, a = e;
  t.host || (n = n.shadowRoot, a = await Z2(a));
  const i = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z" /></svg>', r = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" /></svg>', s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>';
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  if ((!a.proKey || a.proKey === "") && !window.location.hostname.match(/^(localhost|.*\.add-to-calendar-pro.com)$/))
    return;
  const o = await Bl(n, a);
  Br(o.querySelector(".atcb-modal-host-initialized"));
  const l = a.ty;
  (l.type === "link" || l.type === "form") && (!l.url || l.url === "" || !l.url.startsWith("http")) && (l.type = "text"), (!l.headline || l.headline === "") && (l.headline = $e("thankyou", a) + "!");
  let c = '<div class="pro"><p id="ty-success-msg">' + $e("form.success", a) + '</p><div id="ty-content">';
  l.text && l.text !== "" && (c += vs(l.text)), l.type === "share" && (c += `<p class="pro-pt pro-share-buttons">
    <a href="mailto:?subject=${encodeURIComponent($e("label.share.email.subject", a))}&body=%0A&#10142;%20${encodeURIComponent(l.url)}%0A%0A" target="_blank" rel="noopener" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border btn-flex">
      ${s}
      ${$e("label.share.email", a)}
    </a>
    <button id="atcb-ty-share-copy" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border btn-flex">
      ${i}
      ${$e("label.share.copy", a)}
    </button>
    </p>`);
  let d = {};
  if (l.type === "form") {
    const f = !l.text || l.text === "" || l.text === void 0, g = function() {
      return l.button_label && l.button_label !== "" ? l.button_label : $e("submit", a);
    }();
    if (c += '<form id="' + a.identifier + '-ty-form" class="pro-form' + (f ? " no-intro" : "") + '">', l.fields && l.fields.length > 0) {
      const _ = l.fields.find((p) => p.name === "header" && p.type === "hidden");
      if (_ && _.default && _.default !== "" && _.default.startsWith("{"))
        try {
          d = JSON.parse(_.default), Object.keys(d).length === 0 && (d.atcb = !0), l.fields = l.fields.filter((p) => p.name !== "header");
        } catch {
        }
      const x = ev(l.fields, a.identifier + "-ty");
      l.fields = x.fields, c += x.html;
    }
    c += '<p id="submit-error"></p>', c += '<p class="pro-pt"><button type="submit" id="pro-form-submit" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + g + '</button><span id="pro-form-submitting" class="pro-waiting"><span>.</span><span>.</span><span>.</span></span></p>', c += "</form>";
  }
  if (l.type === "link") {
    const f = function() {
      return l.button_label && l.button_label !== "" ? l.button_label : $e("continue", a);
    }();
    c += '<p class="pro-pt"><a href="' + l.url + '" target="_blank" rel="noopener" class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + f + "</a></p>";
  }
  if (c += "</div></div>", await Qi(o, a, "checkmark", l.headline, c), l.type === "share") {
    const f = o.getElementById("atcb-ty-share-copy");
    f.addEventListener("click", function() {
      tu(l.url), f.innerHTML = r + $e("label.share.copied", a) + "!", setTimeout(function() {
        f.innerHTML = i + $e("label.share.copy", a);
      }, 3e3);
    }), f.addEventListener("keyup", function(g) {
      g.key === "Enter" && (g.preventDefault(), f.click());
    });
  }
  if (l.type === "form") {
    const f = o.getElementById(a.identifier + "-ty-form"), g = o.getElementById("submit-error"), _ = o.getElementById("pro-form-submit"), x = o.getElementById("pro-form-submitting");
    _.addEventListener("click", async function(p) {
      p.preventDefault(), x.style.display = "block", _.style.display = "none";
      let w = tv(o, l.fields);
      if (w || (g.textContent = $e("form.error.required", a) + "."), w) {
        const C = [];
        let M = !1;
        if (l.fields.forEach((L) => {
          L.type !== "label" && (L.type === "radio" ? M || (o.querySelectorAll('[name="' + L.name + '"]').forEach(function(B) {
            B.checked && C.push({ name: L.name, value: B.value });
          }), M = !0) : L.type === "checkbox" ? (C.push({ name: L.name, value: o.getElementById(L.fieldId).checked }), M = !1) : (C.push({ name: L.name, value: o.getElementById(L.fieldId).value }), M = !1));
        }), await nv(l.url, C, d) === !0) {
          o.getElementById("ty-success-msg").style.display = "block", o.getElementById("ty-content").style.display = "none";
          return;
        }
        g.textContent = $e("form.error.sending", a) + ".";
      }
      f.classList.add("form-error"), x.style.display = "none", _.style.display = "block";
    }), _.addEventListener("keyup", function(p) {
      p.key === "Enter" && (p.preventDefault(), _.click());
    });
  }
}
async function fi(t, e, n, a = !1) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  var P;
  const i = e.rsvp, r = !i.text || i.text === "" || i.text === void 0, s = !i.headline || i.headline === "" || i.headline === void 0;
  let o = "", l = '<div class="pro">';
  const c = localStorage.getItem(e.proKey + "-rsvp-sent") === "true" || null;
  c && (l += '<div id="rsvp-sent-content">', l += "<p>" + $e("form.success.already", e) + "</p>", e.hideButton || (l += '<div id="rsvp-atcb"></div>'), e.inlineRsvp && (l += '<button id="pro-form-restart" ' + (e.disabled && "disabled") + ' class="atcb-modal-btn atcb-modal-btn btn-small atcb-modal-btn-border">' + $e("label.rsvp.restart", e) + "</button>"), l += "</div>"), l += '<div id="rsvp-success-msg"><p>' + $e("form.success.sent", e) + '</p><p id="rsvp-success-msg-email">' + $e("form.success.email", e) + '</p><p id="rsvp-success-msg-doi">' + $e("form.success.doi", e) + "</p></div>", l += '<div id="rsvp-success-msg-demo">' + $e("form.success.demo", e) + "</div>", l += '<div id="rsvp-content">', i.text && i.text !== "" && (l += vs(i.text)), l += '<form id="' + e.identifier + '-rsvp-form" class="pro-form' + (r ? " no-intro" : "") + (s ? " no-headline" : "") + '">';
  const d = e.proKey || "demo-rsvp";
  i.initial_confirmation === !1 ? (l += '<div id="rsvp-status-group">', l += "<p>" + $e("form.status", e) + "</p>", l += '<div class="pro-field pro-field-type-radio"><div><input type="radio" name="' + d + '-status" id="' + e.identifier + '-rsvp-status-confirmed" aria-label="' + $e("form.status.confirmed", e) + '" checked value="confirmed" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-confirmed" class="status-confirmed"><span>' + $e("form.status.confirmed", e) + "</span></label></div>", i.maybe_option === !0 && (l += '<div><input type="radio" name="' + d + '-status" id="' + e.identifier + '-rsvp-status-undecided" aria-label="' + $e("form.status.undecided", e) + '" value="undecided" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-undecided" class="status-undecided"><span>' + $e("form.status.undecided", e) + "</span></label></div>"), l += '<div><input type="radio" name="' + d + '-status" id="' + e.identifier + '-rsvp-status-declined" aria-label="' + $e("form.status.declined", e) + '" value="declined" ' + (e.disabled && "disabled") + ' /><label for="' + e.identifier + '-rsvp-status-declined" class="status-declined"><span>' + $e("form.status.declined", e) + "</span></label></div></div>", l += "</div>") : o += '<input type="hidden" name="' + d + '-status" id="' + e.identifier + '-rsvp-status-confirmed" value="confirmed" />';
  const f = i.maxpp || 1;
  f === 1 ? o += '<input type="hidden" name="' + d + '-amount" id="' + e.identifier + '-rsvp-amount" value="1" />' : (l += '<div class="pro-field"><label for="' + e.identifier + '-rsvp-amount">' + $e("form.amount", e) + " (" + $e("form.max", e) + " " + f + ")<span>*</span></label>", l += '<input type="number" name="' + d + '-amount" min="1" max="' + f + '" id="' + e.identifier + '-rsvp-amount" ' + (e.disabled && "disabled") + ' aria-label="' + $e("form.amount", e) + '" value="1" /></div>');
  const g = function() {
    if (e.attendee && e.attendee !== "") {
      const z = e.attendee.split("|");
      return z.length > 1 ? z[1] : z[0];
    }
    return null;
  }(), _ = (P = i.fields) == null ? void 0 : P.find((z) => z.name === "email");
  if (_ ? i.fields = i.fields.map((z) => z.name === "email" ? { ...z, required: !0, type: "email", default: g !== "" ? g : z.default } : z) : g ? o += '<input type="hidden" name="email" id="' + e.identifier + '-rsvp-email" value="' + g + '" />' : (l += '<div class="pro-field"><label for="' + e.identifier + '-rsvp-email">' + $e("form.email", e) + "<span>*</span></label>", l += '<input type="email" name="email" id="' + e.identifier + '-rsvp-email" ' + (e.disabled && "disabled") + ' aria-label="' + $e("form.email", e) + '" value="" /></div>'), i.fields && i.fields.length > 0) {
    const z = ev(i.fields, e.identifier + "-rsvp", e.disabled);
    i.fields = z.fields, l += z.html;
  }
  l += o, l += '<p id="submit-error"></p>', l += '<p class="pro-pt"><button type="submit" id="pro-form-submit" ' + (e.disabled && "disabled") + ' class="atcb-modal-btn atcb-modal-btn-primary atcb-modal-btn-border">' + $e("submit", e) + '</button><span id="pro-form-submitting" class="pro-waiting"><span>.</span><span>.</span><span>.</span></span></p>', i.seatsLeft && i.seatsLeft > 0 && (l += '<p class="pro-form-fine">' + $e("form.seatsleft", e) + ": <b>" + i.seatsLeft + "</b></p>"), l += "</form>", l += "</div></div>";
  let x = null;
  if (!e.inlineRsvp)
    x = await Bl(t, e), Br(x.querySelector(".atcb-modal-host-initialized")), await Qi(
      x,
      e,
      void 0,
      i.headline,
      l,
      [
        { type: "none", label: $e("label.rsvp.restart", e), small: !0, primary: !0, id: "pro-form-restart" },
        { type: "close", label: $e("close", e), small: !0, id: "modal-btn-close" },
        { type: "close", label: $e("cancel", e), small: !0, id: "modal-btn-cancel" }
      ],
      [],
      a,
      {},
      !1
    );
  else {
    x = t;
    const z = document.createElement("div");
    if (z.classList.add("atcb-modal-box", "rsvp-inline-wrapper"), z.setAttribute("part", "atcb-modal-box"), e.rtl && z.classList.add("atcb-rtl"), n.append(z), i.headline) {
      const q = document.createElement("div");
      q.classList.add("atcb-modal-headline"), z.append(q), q.innerHTML = i.headline;
    }
    const W = document.createElement("div");
    if (W.classList.add("atcb-modal-content"), z.append(W), !e.hideBranding) {
      const q = gl(x, !1, !0);
      z.append(q);
    }
    if (i.expired) {
      W.innerHTML = '<div class="pro"><p>' + $e("label.rsvp.expired", e) + "</p></div>";
      return;
    } else if (i.bookedOut) {
      W.innerHTML = '<div class="pro"><p>' + $e("label.rsvp.bookedout", e) + "</p></div>";
      return;
    } else
      W.innerHTML = l;
  }
  c && (x.getElementById("rsvp-content").style.display = "none");
  const p = x.getElementById("modal-btn-close"), w = x.getElementById("modal-btn-cancel"), C = x.getElementById("pro-form-restart");
  if (sn("openRSVP", e.identifier, e.identifier), e.debug && console.log('RSVP form for "' + e.identifier + '" created'), c) {
    w && (w.style.display = "none");
    const z = x.getElementById("rsvp-atcb");
    if (z && !e.hideButton) {
      const W = JSON.parse(JSON.stringify(e));
      W.hideTextLabelButton = !0, W.hideIconButton = !1, W.buttonsList = !0, av(t, z, W);
    }
  } else
    p && (p.style.display = "none"), C && (C.style.display = "none");
  const M = x.getElementById(e.identifier + "-rsvp-form"), A = x.getElementById("submit-error"), L = x.getElementById("pro-form-submit"), D = x.getElementById("pro-form-submitting"), B = x.getElementById("pro-form-restart");
  L && (L.addEventListener("click", async function(z) {
    var ie;
    z.preventDefault(), D.style.display = "block", L.style.display = "none";
    const W = [{ type: "number", name: e.proKey + "-amount", fieldId: e.identifier + "-rsvp-amount", required: !0 }];
    _ || W.push({ type: "email", name: "email", fieldId: e.identifier + "-rsvp-email", required: !0 });
    let q = tv(x, [...W, ...i.fields]);
    const V = x.getElementById(e.identifier + "-rsvp-amount"), re = parseInt(V.value) || 1;
    if (i.maxpp && i.maxpp > 0 && re > i.maxpp && (V.classList.add("error"), q = !1), q || (A.textContent = $e("form.error.required", e) + "."), q) {
      if (!e.proKey || e.proKey === "") {
        x.getElementById("rsvp-success-msg-demo").style.display = "block", x.getElementById("rsvp-content").style.display = "none", sn("successRSVP", e.identifier, e.identifier), w && (w.style.display = "none"), p && (p.style.display = "block");
        return;
      }
      let K = JSON.parse(JSON.stringify(i.fields));
      const $ = [];
      $.push({ name: "prokey", value: e.proKey }), $.push({ name: "language", value: e.language });
      const X = x.querySelector('[name="' + e.proKey + '-status"]:checked');
      if ($.push({ name: "status", value: X ? X.value : "confirmed" }), $.push({ name: "amount", value: re }), !_)
        $.push({ name: "email", value: x.getElementById(e.identifier + "-rsvp-email").value });
      else {
        const Ie = (ie = K.find((Ve) => Ve.name === "email")) == null ? void 0 : ie.fieldId;
        $.push({ name: "email", value: x.getElementById(Ie).value }), K = K.filter((Ve) => Ve.fieldId !== Ie);
      }
      const R = {};
      let de = !1;
      K.forEach((Ie) => {
        Ie.type !== "label" && (Ie.type === "radio" ? de || (x.querySelectorAll('[name="' + Ie.name + '"]').forEach(function(te) {
          te.checked && (R[Ie.name] = te.value);
        }), de = !0) : Ie.type === "checkbox" ? (R[Ie.name] = x.getElementById(Ie.fieldId).checked, de = !1) : (R[Ie.name] = x.getElementById(Ie.fieldId).value, de = !1));
      }), Object.keys(R).length > 0 && $.push({ name: "payload", value: R });
      const Le = await nv(`https://api${e.dev ? "-dev" : ""}.add-to-calendar-pro.com/24586219-9910-41fe-9b59-df53de9db7af`, $, { rsvp: !0 });
      if (Le === "doi" || Le === !0) {
        x.getElementById("rsvp-success-msg").style.display = "block", Le === "doi" ? x.getElementById("rsvp-success-msg-doi").style.display = "block" : x.getElementById("rsvp-success-msg-email").style.display = "block", x.getElementById("rsvp-content").style.display = "none", w && (w.style.display = "none"), p && (p.style.display = "block"), sn("successRSVP", e.identifier, e.identifier), localStorage.setItem(e.proKey + "-rsvp-sent", !0);
        return;
      }
      Le.error && Le.error === 2 ? A.textContent = $e("form.error.email", e) + "." : Le.error && Le.error === 5 ? A.textContent = $e("label.rsvp.expired", e) + "." : Le.error && Le.error === 6 ? re > 1 ? A.textContent = $e("form.error.bookedoutmany", e) + "." : A.textContent = $e("label.rsvp.bookedout", e) + "." : A.textContent = $e("form.error.sending", e) + ".";
    }
    M.classList.add("form-error"), D.style.display = "none", L.style.display = "block";
  }), L.addEventListener("keyup", function(z) {
    z.key === "Enter" && (z.preventDefault(), L.click());
  })), B && (B.addEventListener("click", function(z) {
    z.preventDefault(), x.getElementById("rsvp-sent-content").style.display = "none", x.getElementById("rsvp-content").style.display = "block", p && (p.style.display = "none"), C && (C.style.display = "none"), w && (w.style.display = "block");
  }), B.addEventListener("keyup", function(z) {
    z.key === "Enter" && (z.preventDefault(), B.click());
  }));
}
async function QP(t, e) {
  const n = t.querySelector(".atcb-initialized"), a = document.createElement("div");
  a.classList.add("atcb-button-wrapper"), e.rtl && a.classList.add("atcb-rtl"), n.append(a), vl(a, e.sizes);
  const i = document.createElement("button");
  i.classList.add("atcb-button", "atcb-click", "atcb-single"), e.disabled && i.setAttribute("disabled", !0), e.hideTextLabelButton && i.classList.add("atcb-no-text"), i.type = "button", i.setAttribute("aria-expanded", !1), a.append(i);
  const r = function() {
    return e.rsvp.expired ? $e("label.rsvp.expired", e) : e.rsvp.bookedOut ? $e("label.rsvp.bookedout", e) : $e("label.rsvp", e);
  }();
  return ml(t, e, i, "rsvp", !e.hideIconButton, r, !0), e.debug && console.log('Add to Calendar RSVP Button "' + e.identifier + '" created'), !0;
}
async function n1(t, e = !1) {
  try {
    const n = await fetch(`https://api${e ? "-dev" : ""}.add-to-calendar-pro.com/dffb8bbd-ee5e-4a4f-a7ea-503af98ca468?prokey=${t}`, {
      method: "GET"
    });
    if (!n.ok)
      throw new Error("Network response was not ok");
    const a = await n.json();
    return parseInt(a.total);
  } catch (n) {
    console.error("Error:", n);
  }
  return 0;
}
function ev(t, e = "", n = !1) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let a = "", i = "", r = 0, s = "", o = !1;
  for (let l = 1; l <= t.length; l++) {
    o = !1;
    const c = t[l - 1];
    if (c.type !== "label" && (!c.name || c.name === "")) {
      o = !0;
      continue;
    }
    (s === "radio" && c.type !== "radio" || s !== "radio") && (r = l), t[l - 1].fieldId = e + "-" + l;
    const d = c.type === "radio" ? c.placeholder || "" : c.default || "", f = c.label || "", g = c.type === "radio" ? "" : c.placeholder || "";
    let _ = "";
    s !== "hidden" && l === r && l !== 1 && !o && (_ += "</div>"), c.type !== "hidden" && l === r && (_ += '<div class="pro-field pro-field-type-' + c.type + '">'), c.type === "label" ? _ += "<p>" + f + "</p>" : (c.type === "radio" && (_ += "<div>"), c.type === "hidden" ? i += '<input type="hidden" name="' + c.name + '" id="' + c.fieldId + '" value="' + d + '" />' : _ += JP(c.type, c.name, f, c.fieldId, c.required, d, c.default, g, n), c.type === "radio" && (_ += "</div>")), a += _, s = c.type;
  }
  return s !== "hidden" && (a += "</div>"), a += i, { html: a, fields: t };
}
function JP(t, e, n, a, i = !1, r, s = null, o = "", l = !1) {
  let c = "";
  return (t === "text" || t === "email" || t === "number") && n !== "" && (c += '<label for="' + a + '">' + n + (i ? "<span>*</span>" : "") + "</label>"), c += '<input type="' + t + '"' + (t === "number" ? ' min="0"' : "") + ((t === "checkbox" || t === "radio") && s && (s === "true" || s === !0) ? " checked" : "") + ' name="' + e + '" id="' + a + '" placeholder="' + o + '" ' + (l && "disabled") + ' aria-label="' + n + '" value="' + r + '" />', (t === "checkbox" || t === "radio") && (n !== "" || i) && (c += '<label for="' + a + '">' + n + (i ? "<span>*</span>" : "") + "</label>"), c;
}
function tv(t, e) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let n = !0;
  return e.forEach(function(a) {
    if (a.type !== "label" && a.type !== "radio") {
      const i = t.getElementById(a.fieldId);
      if (a.type !== "checkbox") {
        if (i.value = bl(i.value.trim()), a.type === "number" && (i.value = i.value.replace(/\D/g, "")), a.type === "email" && i.value !== "" && !Jc(i.value)) {
          i.classList.add("error"), n = !1;
          return;
        }
        if (a.required && i.value === "") {
          i.classList.add("error"), n = !1;
          return;
        } else
          i.classList.remove("error");
      } else if (a.required && i.checked === !1) {
        i.classList.add("error"), n = !1;
        return;
      } else
        i.classList.remove("error");
    }
    if (a.type === "radio") {
      const i = t.querySelectorAll('[name="' + a.name + '"]');
      let r = !1;
      if (i.forEach(function(s) {
        s.checked && (r = !0);
      }), r === !1) {
        i[0].classList.add("error"), n = !1;
        return;
      } else
        i[0].classList.remove("error");
    }
  }), n;
}
async function nv(t, e, n = {}) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  let a = new FormData(), i = {}, r = {};
  Object.keys(n).length === 0 ? (e.forEach((s) => {
    a.append(s.name, s.value);
  }), r = { method: "POST", body: a }) : (n["Cache-Control"] = "no-cache", n["Content-Type"] = "application/json", n.Accept = "*/*", e.forEach((s) => {
    i[s.name] = s.value;
  }), r = { method: "POST", headers: n, body: JSON.stringify(i) });
  try {
    const s = await fetch(t, r), o = await s.json();
    return s.ok ? o.status && o.status === "doi" ? "doi" : !0 : (console.error("Network response was not ok"), o.error ? o : !1);
  } catch (s) {
    return console.error("Error:", s), !1;
  }
}
function ml(t, e, n, a, i = !1, r = "", s = !1) {
  switch (a) {
    case "trigger":
    case "rsvp":
    default:
      n.id = e.identifier, e.blockInteraction || (n.addEventListener("keyup", function(o) {
        (o.key === "Enter" || o.code == "Space" || o.key === "Alt" && o.key === "Control" && o.code === "Space") && (o.preventDefault(), a === "rsvp" && typeof fi == "function" ? fi(t, e, n, !0) : Sn(t, "auto", e, n, !0, !0));
      }), n.addEventListener(
        "touchend",
        xr((o) => {
          o.preventDefault(), a === "rsvp" && typeof fi == "function" ? fi(t, e, n) : Sn(t, "auto", e, n, !1, !0);
        })
      ), e.trigger === "click" || a === "rsvp" && typeof fi == "function" ? n.addEventListener(
        "mouseup",
        xr((o) => {
          o.preventDefault(), a === "rsvp" && typeof fi == "function" ? fi(t, e, n) : Sn(t, "auto", e, n, !1, !0);
        })
      ) : n.addEventListener("mouseenter", function() {
        Sn(t, "open", e, n, !1, !0);
      }));
      break;
    case "apple":
    case "google":
    case "ical":
    case "msteams":
    case "ms365":
    case "outlookcom":
    case "yahoo":
      n.id = e.identifier + "-" + a, e.blockInteraction || (n.addEventListener(
        "click",
        xr(() => {
          var o;
          s ? ((o = t.querySelector("#" + n.id)) == null || o.blur(), sn("openSingletonLink", n.id, e.identifier)) : (Sn(t, "close"), sn("openCalendarLink", n.id, e.identifier)), bs(t, a, e);
        })
      ), n.addEventListener("keyup", function(o) {
        var l;
        o.key === "Enter" && (o.preventDefault(), s ? ((l = t.querySelector("#" + n.id)) == null || l.blur(), sn("openSingletonLink", n.id, e.identifier)) : (Sn(t, "close"), sn("openCalendarLink", n.id, e.identifier)), bs(t, a, e, "all", !0));
      }));
      break;
    case "close":
      n.id = e.identifier + "-close", n.addEventListener(
        "click",
        us(() => {
          sn("closeList", "List Close Button", Ft.active), Sn(t, "close");
        })
      ), n.addEventListener("keyup", function(o) {
        o.key === "Enter" && (o.preventDefault(), sn("closeList", "List Close Button", Ft.active), Sn(t, "close", e, "all", !0));
      });
      break;
  }
  eB(e, n, a, i, r, s);
}
function eB(t, e, n, a, i, r) {
  const s = function() {
    if (t.pastDateHandling != "none") {
      let o = !0;
      for (let l = 0; l < t.dates.length; l++)
        if (!t.dates[`${l}`].overdue) {
          o = !1;
          break;
        }
      if (o)
        return $e("expired", t);
    }
    return $e("label.addtocalendar", t);
  }();
  if (i === "" && (t.options.length === 1 || n === "trigger" ? i = s : n === "close" ? i = $e("close", t) : i = $e(n, t)), !(t.buttonStyle === "date" && (n === "trigger" || r))) {
    if (e.setAttribute("aria-label", r ? $e("label.addtocalendar", t) + " (" + $e(n, t) + "): " + t.name : n === "trigger" ? i + ": " + t.name : i), a) {
      const o = document.createElement("div");
      o.classList.add("atcb-icon"), o.setAttribute("part", n === "trigger" ? "atcb-button-icon" : "atcb-list-icon"), o.classList.add(`atcb-icon-${n}`), o.innerHTML = gs[`${n}`], e.append(o);
    }
    if ((n === "trigger" || r) && !t.hideTextLabelButton || !r && n !== "trigger" && !t.hideTextLabelList) {
      const o = document.createElement("span");
      o.classList.add("atcb-text"), o.setAttribute("part", n === "trigger" ? "atcb-button-text" : "atcb-list-text"), o.textContent = i, e.append(o);
    }
  }
}
function av(t, e, n) {
  const a = function() {
    return !!(n.options.length === 1 || n.buttonsList && n.buttonStyle != "date");
  }();
  (a ? n.options : ["default"]).forEach(function(r, s) {
    const o = document.createElement("div");
    o.classList.add("atcb-button-wrapper"), o.setAttribute("part", "atcb-button-wrapper"), n.rtl && o.classList.add("atcb-rtl"), e.append(o), vl(o, n.sizes);
    const l = document.createElement("button");
    if (l.classList.add("atcb-button"), l.setAttribute("part", "atcb-button"), n.disabled && l.setAttribute("disabled", !0), n.hideTextLabelButton && l.classList.add("atcb-no-text"), n.trigger === "click" && l.classList.add("atcb-click"), n.listStyle === "overlay" && l.classList.add("atcb-dropoverlay"), l.type = "button", l.setAttribute("aria-expanded", !1), o.append(l), n.buttonStyle === "date" && rv(n, l, "all", a), a) {
      l.classList.add("atcb-single");
      const c = function() {
        return n.buttonsList && n.options.length > 1 ? $e(`${n.options[`${s}`]}`, n) : n.label;
      }();
      ml(t, n, l, r, !n.hideIconButton, c, !0), l.id = n.identifier, n.buttonsList && (l.id = n.identifier + "-" + r);
    } else {
      ml(t, n, l, "trigger", !n.hideIconButton, n.label);
      const c = document.createElement("div");
      c.classList.add("atcb-dropdown-anchor"), l.append(c);
    }
    if (!n.hideCheckmark && !n.hideTextLabelButton && !n.buttonsList && !n.disabled && !n.allCancelled) {
      const c = document.createElement("div");
      c.classList.add("atcb-checkmark"), c.innerHTML = gs.checkmark, l.append(c);
    }
  }), n.debug && console.log('Add to Calendar Button "' + n.identifier + '" created');
}
function tB(t, e) {
  const n = document.createElement("div");
  n.classList.add("atcb-list"), n.setAttribute("part", "atcb-list"), n.role = "list", e.rtl && n.classList.add("atcb-rtl");
  let a = 0;
  if (e.options.forEach(function(i) {
    const r = document.createElement("div");
    r.classList.add("atcb-list-item"), r.setAttribute("part", "atcb-list-item"), r.role = "link", r.tabIndex = 0, a++, r.dataset.optionNumber = a, n.append(r), ml(t, e, r, i, !e.hideIconList);
  }), e.listStyle === "modal") {
    const i = document.createElement("div");
    i.classList.add("atcb-list-item", "atcb-list-item-close"), i.setAttribute("part", "atcb-list-item-close"), i.role = "button", i.tabIndex = 0, a++, i.dataset.optionNumber = a, n.append(i), ml(t, e, i, "close", !e.hideIconList);
  }
  return n;
}
function iv(t, e = "", n = !1, a = !0, i = !0) {
  const r = function() {
    return n ? document.createElement("dialog") : document.createElement("div");
  }();
  if (n && r.setAttribute("open", !0), r.id = "atcb-bgoverlay", a || r.classList.add("atcb-no-bg"), r.role = "button", r.tabIndex = 0, i) {
    r.addEventListener(
      "mouseup",
      xr((o) => {
        o.target === o.currentTarget && (sn("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      })
    );
    let s = !1;
    r.addEventListener(
      "touchstart",
      xr(() => s = !1),
      { passive: !0 }
    ), r.addEventListener(
      "touchmove",
      xr(() => s = !0),
      { passive: !0 }
    ), r.addEventListener(
      "touchend",
      us((o) => {
        s !== !1 || o.target !== o.currentTarget || (sn("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      }),
      { passive: !0 }
    ), e !== "click" ? r.addEventListener(
      "mousemove",
      xr((o) => {
        o.target === o.currentTarget && (sn("closeList", "Background Hit", Ft.active), Sn(t, "close"));
      })
    ) : r.classList.add("atcb-click");
  }
  return r;
}
/*!
 *  @preserve
 *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
 */
function gl(t, e = !0, n = !1, a = !1) {
  const i = document.createElement("div");
  if (i.id = "atcb-reference", a)
    i.innerHTML = 'Using the <a href="https://add-to-calendar-pro.com" target="_blank" rel="noopener referrer">Add to Calendar Button</a>, licensed under the Elastic License 2.0 (ELv2).', i.style.display = "none !important", i.classList.add("atcb-attribution"), t.append(i);
  else if (setTimeout(() => {
    const r = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.916 2.8305"><path d="M51.446 1.2565c.0708-.2518.293-.4511.5555-.4783.2211-.042.4641.0128.622.18.2474.2472.3045.6146.2916.9503v.8594h-.8307l-.0027-1.0447c-.0079-.1547-.1075-.343-.2868-.3238-.2049.0128-.3115.2421-.295.4257v.9428h-.823l-.0027-1.0435c-.0076-.1569-.1131-.3412-.2918-.3252-.2069.008-.311.2351-.2939.4188v.9499h-.8307V.8237h.8307v.4019c.0906-.2264.2876-.4188.5368-.449.2878-.0533.6071.0705.7509.3331.0279.0465.0509.0959.0699.1468zm-3.9843.5228c-.0102.1874.107.3914.3024.424.1869.0419.3799-.0941.4215-.2776.0535-.1967-.0023-.4493-.2015-.5411-.1767-.0892-.4107.0032-.483.1865-.0297.0649-.0391.1374-.0392.2082zm-.7691 0c.0037-.2984.1395-.5957.3792-.7774.3035-.2327.7168-.2798 1.0829-.2005.3299.0729.6352.3018.7481.6275.1337.3797.0441.8526-.2795 1.1099-.3184.2561-.7624.3092-1.152.2184-.3379-.0788-.6426-.3312-.7369-.6717a1.092 1.092 0 0 1-.0417-.3063zm-.2351-.3308c-.1638-.0482-.3406-.0889-.5104-.0492s-.2742.2154-.2664.3837c-.0082.1705.0998.3468.2712.3876.1657.0389.3389.0016.4979-.0492l.0769.5499c-.2369.1272-.5165.1434-.7791.1149-.3236-.0401-.6353-.2311-.7805-.529-.1237-.2511-.139-.5539-.0485-.8181.108-.3075.3782-.5432.6902-.6287.2064-.058.4286-.0585.6371-.0119.1027.0253.198.0732.2884.1269l-.0769.523zm-2.6877.9806c-.003-.1221.066-.2371.1643-.3062.1303-.0934.3092-.1186.4572-.0533.132.054.2426.1752.2607.3197s-.0575.2836-.1746.3603c-.1633.1093-.3947.1063-.5517-.0135-.0951-.0715-.1577-.187-.1559-.307zm-3.046-1.0111c-.0091-.4276.1794-.8577.5181-1.1231.3714-.2958.8865-.3488 1.3384-.2477.4065.0946.7695.3811.9242.7731.2302.553.1173 1.2562-.3406 1.6606-.4021.3563-.9997.4264-1.5018.273-.4407-.1312-.7876-.5106-.8926-.9564a1.565 1.565 0 0 1-.0458-.3795zm1.4499.6961c.2631.014.4813-.2093.5326-.4557.0785-.3033.0224-.6834-.2491-.8753-.2182-.159-.5514-.1019-.704.1211-.1692.2437-.1902.5756-.088.8501.0775.2087.2816.3661.5085.3597zm-1.631.6458c-.1978.0602-.4078.0938-.6123.0464-.2697-.0443-.5044-.2371-.6009-.4927-.0701-.1852-.1026-.3819-.154-.5728h-.1846v1.0268h-.8614V.0601l1.3192.0034c.3398.0217.7177.1323.9118.434.152.2456.127.584-.0389.8163-.0979.1284-.2387.2162-.3846.2807.0316.1513.0475.3167.1461.4418.1193.1187.3064.1031.4596.0812v.6422zm-.871-1.8651c.0103-.138-.1243-.231-.25-.2384-.1427-.0193-.2871-.0088-.4307-.0115v.5422c.1905-.0038.3947.0138.5678-.0796a.234.234 0 0 0 .1128-.2126zM35.573.0603l1.1424.0047c.3439.0209.7218.1098.9446.3944.2252.2934.2163.7545-.0512 1.0195-.279.2859-.698.3701-1.0838.362-.0329.0105-.1126-.0258-.102.0281v.8987h-.8499V.0603zm1.0192 1.2345c.1672.0054.3805-.0562.4233-.2409.0425-.1434-.0225-.3102-.1619-.3724-.1328-.0705-.2859-.0537-.4306-.0559v.6615c.0561.0073.1128.0073.1692.0077zm-2.5176.2226h1.0576v.4653h-1.0576zM32.3311.8234h.8307v.4019q.0942-.2384.25-.348.1577-.1115.3615-.1115l.1154.6442q-.375 0-.5519.0808-.175.0788-.175.2538v1.023h-.8307zm-1.2257 1.5791c-.0937.2116-.2986.3716-.5319.3897-.3887.0533-.7844-.1743-.9578-.5217-.2044-.381-.1519-.892.1543-1.2049.2461-.2614.6627-.389.9973-.2285.1574.0799.2779.2236.3381.3886V.7662h.8268v2.0017h-.8268v-.3653zm0-.6345c-.0052-.2449-.2747-.4425-.5088-.3585-.217.0615-.3402.3271-.243.5316.0896.2161.3875.3078.5783.1678.1106-.0747.179-.2073.1735-.3408zM27.7118.7662c.2401-.008.4923.1021.6064.3222.0351.0816.045.0806.0397.0023V.1721l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.412-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3309.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM24.139.8233h.7922v.4019c.1006-.2169.2949-.397.5347-.4408.2696-.0572.58.0085.76.2293.2045.2403.2438.5692.2358.8734v.8802h-.8268l-.0022-1.1213c-.004-.1252-.0677-.2748-.2066-.2939-.2045-.0306-.3739.1457-.4412.3226-.0292.0785-.0098.1646-.0154.2467v.8459h-.8306V.8233zm-1.0416 1.4236c.2011-.0002.3981-.0574.5807-.1384l.0961.5288c-.3198.1421-.6806.1894-1.027.145-.3369-.0473-.6587-.2545-.8007-.5699-.1588-.3469-.1132-.7886.1413-1.0788.2741-.3191.7406-.4335 1.1413-.3308.2768.0734.5008.3019.5751.5779.0429.146.0624.3015.043.453l-1.1806.1538c.0368.134.158.2311.2944.2482.0449.0082.0907.0114.1363.0114zm.1461-.7557c-.0268-.1234-.1257-.237-.2578-.244-.143-.0241-.2868.0725-.325.2111-.0103.0527-.0737.2029.0271.1552l.5558-.1223zm-1.4939 1.1721c-.2463.1208-.5356.1686-.805.1092-.227-.0527-.3993-.2481-.4518-.4712-.0545-.2125-.0296-.4333-.0353-.6502V.1714l.8307-.1231.0011 1.9292c.002.1378.1537.1938.2711.1813.0651.0169.1819-.1.162.0152l.0274.4893zm-2.5115-.2609c-.0937.2116-.2986.3716-.5319.3897-.3887.0533-.7844-.1743-.9578-.5217-.2044-.381-.1519-.892.1543-1.2049.2461-.2614.6627-.389.9973-.2285.1574.0799.2779.2236.3381.3886V.7661h.8268v2.0017h-.8268v-.3653zm0-.6345c-.0052-.2449-.2747-.4425-.5088-.3585-.217.0615-.3402.3271-.243.5316.0896.2161.3875.3078.5783.1678.1106-.0747.179-.2073.1735-.3408zm-2.3726.35c.1696.0054.3334-.0479.4884-.1115l.1077.6249c-.5137.3026-1.2229.2625-1.6732-.1399-.2959-.2444-.4693-.6191-.4819-1.0009-.0323-.4791.181-.9792.5853-1.2496.4565-.3128 1.0898-.3142 1.5659-.0438l-.1038.6115c-.2721-.1029-.5957-.168-.8667-.0274-.2291.1239-.3077.4039-.2984.6481-.0043.2465.1061.5161.3427.6212.1037.0495.2198.0676.3339.0676zm-2.923-.6005h1.0576v.4653h-1.0576zm-1.7829.2619c-.0102.1874.107.3914.3024.424.1869.0419.3799-.0941.4215-.2776.0535-.1967-.0023-.4493-.2015-.5411-.1767-.0892-.4107.0032-.4831.1865-.0297.0649-.0391.1374-.0392.2082zm-.7691 0c.0037-.2984.1395-.5957.3792-.7774.3035-.2327.7168-.2798 1.0829-.2005.33.0729.6352.3018.7481.6275.1337.3797.0441.8526-.2795 1.1099-.3184.2561-.7624.3092-1.152.2184-.3379-.0788-.6426-.3312-.7369-.6717a1.092 1.092 0 0 1-.0417-.3063zm-.1976.8841c-.2463.1208-.5356.1686-.805.1092-.227-.0527-.3993-.2481-.4518-.4712-.0557-.2169-.0286-.4422-.0334-.6635l.0019-.3551h-.25V.7943h.3115l.3653-.7461h.4v.7461h.4538v.4884h-.4538l.0011.6943c.0034.1365.1541.1943.2715.1818.0768.006.1848-.0959.1624.0301l.0265.4744zm-2.7861-1.146h1.0575v.4653H8.4068zM6.5412.7662c.2401-.008.4923.1021.6064.3223.0351.0816.045.0806.0397.0023V.172l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.412-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3308.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM3.7956.7662c.2401-.008.4923.1021.6064.3222.0351.0816.045.0806.0397.0023V.172l.8307-.1231v2.7189h-.8307v-.3653c-.0907.2158-.3003.3744-.5356.39-.3605.0507-.7279-.1432-.9123-.4525-.2569-.3983-.1992-.9693.1456-1.2985.173-.1702.4119-.2772.6563-.2754zm.6461 1.0018c-.0048-.2526-.2909-.4519-.5276-.3518-.2324.0782-.3308.3933-.1843.5898.1239.1938.425.2285.5871.0636.0811-.0768.1287-.1897.1248-.3015zM.7498.0603h1.196l.7845 2.7074h-.9268l-.1038-.5192H.9997l-.1115.5192h-.8883zm.8576 1.7037L1.3497.5795 1.0843 1.764z"/></svg>';
    i.innerHTML = '<a href="https://add-to-calendar-pro.com" target="_blank" rel="noopener">' + r + "</a>";
  }, 500), e)
    t.querySelector(".atcb-initialized .atcb-list-wrapper").append(i);
  else {
    if (n)
      return i;
    (window.innerHeight > 1e3 || window.innerWidth > 1e3) && (t.append(i), i.classList.add("fixed-ref"));
  }
  if (n) return null;
}
async function Qi(t, e, n = "", a, i = "", r = [], s = [], o = !1, l = {}, c = !0) {
  Ft.active = e.identifier;
  const d = !a || a === "" || a === void 0, f = await Bl(t, e, !1), g = function() {
    const M = f.getElementById("atcb-bgoverlay");
    if (!M) {
      const A = iv(t, "click", !0, !e.hideBackground, c);
      return f.querySelector(".atcb-modal-host-initialized").append(A), A;
    }
    return M;
  }(), _ = document.createElement("div");
  _.classList.add("atcb-modal"), g.append(_);
  const x = f.querySelectorAll(".atcb-modal").length;
  _.dataset.modalNr = x, _.tabIndex = 0, _.focus({ preventScroll: !0 }), _.blur();
  const p = function() {
    const M = t.getElementById(e.identifier);
    return M || document.getElementById(e.identifier);
  }();
  p && p.classList.add("atcb-active-modal");
  const w = document.createElement("div");
  if (w.classList.add("atcb-modal-box"), w.setAttribute("part", "atcb-modal-box"), e.rtl && w.classList.add("atcb-rtl"), _.append(w), vl(w, e.sizes), Br(g), n !== "" && !e.hideIconModal) {
    const M = document.createElement("div");
    M.classList.add("atcb-modal-icon"), M.innerHTML = gs[`${n}`], w.append(M);
  }
  if (!d) {
    const M = document.createElement("div");
    M.classList.add("atcb-modal-headline"), M.textContent = a, w.append(M);
  }
  if (i !== "") {
    const M = document.createElement("div");
    M.classList.add("atcb-modal-content"), d && M.classList.add("no-headline"), M.innerHTML = i, w.append(M);
  }
  if (e.hideBranding || gl(f, !1), s.length > 1) {
    const M = document.createElement("div");
    M.classList.add("atcb-modal-content"), w.append(M);
    const A = document.createElement("div");
    A.classList.add("atcb-modal-content-subevents"), M.append(A);
    for (let L = 1; L < s.length; L++) {
      const D = document.createElement("button");
      D.type = "button", D.id = e.identifier + "-" + s[0] + "-" + L, Ft[`${e.identifier}`][`${s[0]}`][L - 1] > 0 && D.classList.add("atcb-saved"), D.classList.add("atcb-subevent-btn"), A.append(D), rv(e, D, L), !e.dates[L - 1].overdue || e.pastDateHandling === "none" ? (L === 1 && o && D.focus(), D.addEventListener(
        "click",
        us(() => {
          sn("openSubEventLink", D.id, e.identifier), D.blur(), bs(t, s[0], e, s[`${L}`], o, !0);
        })
      )) : D.setAttribute("disabled", !0);
    }
  }
  r.length === 0 && r.push({ type: "close", label: $e("close", e), small: !0 });
  const C = document.createElement("div");
  C.classList.add("atcb-modal-buttons"), w.append(C), r.forEach((M, A) => {
    let L;
    switch (M.href && M.href !== "" ? (L = document.createElement("a"), L.setAttribute("target", Xh), L.setAttribute("href", M.href), L.setAttribute("rel", "noopener")) : (L = document.createElement("button"), L.type = "button"), M.id && M.id !== "" && (L.id = M.id), L.classList.add("atcb-modal-btn"), M.primary && L.classList.add("atcb-modal-btn-primary"), M.small && L.classList.add("btn-small"), (!M.label || M.label === "") && (M.label = $e("modal.button.default", e)), L.textContent = M.label, C.append(L), A === 0 && s.length < 2 && o && L.focus(), M.type) {
      default:
      case "close":
        L.addEventListener(
          "click",
          us(() => {
            sn("closeList", "Modal Close Button", Ft.active), nl(t);
          })
        ), L.addEventListener("keyup", function(D) {
          (D.key === "Enter" || D.code == "Space" || D.key === "Alt" && D.key === "Control" && D.code === "Space") && (sn("closeList", "Modal Close Button", Ft.active), Sn(t, "close", "", "", !0));
        });
        break;
      case "yahoo2nd":
        L.addEventListener(
          "click",
          us(() => {
            nl(t), a1(t, e);
          })
        ), L.addEventListener("keyup", function(D) {
          (D.key === "Enter" || D.code == "Space" || D.key === "Alt" && D.key === "Control" && D.code === "Space") && (Sn(t, "close", "", "", !0), a1(t, e, o));
        });
        break;
      case "2timeslink":
        L.addEventListener(
          "click",
          us(() => {
            nl(t), bs(t, l.type, e, l.id, o, !1, !0);
          })
        ), L.addEventListener("keyup", function(D) {
          (D.key === "Enter" || D.code == "Space" || D.key === "Alt" && D.key === "Control" && D.code === "Space") && (Sn(t, "close", "", "", !0), bs(t, l.type, e, l.id, o, !1, !0));
        });
        break;
      case "none":
        break;
    }
  }), x > 1 && f.querySelector('.atcb-modal[data-modal-nr="' + (x - 1) + '"]').classList.add("atcb-hidden"), Zh(f, _);
}
function a1(t, e, n) {
  Wu(t, e), bs(t, "yahoo2nd", e, "all", n);
}
function rv(t, e, n = "all", a = !1) {
  n != "all" ? n = parseInt(n) - 1 : t.dates.length == 1 && (n = 0);
  const i = pB(t.dates, t.language, n), r = function() {
    return n !== "all" && t.dates[`${n}`].status.toLowerCase() === "cancelled" || n === "all" && t.allCancelled ? $e("date.status.cancelled", t) + "<br>" + $e("date.status.cancelled.cta", t) : t.pastDateHandling != "none" && (n === "all" && t.allOverdue || n != "all" && t.dates[`${n}`].overdue) ? $e("expired", t) : t.label && t.label != "" ? t.label : "+ " + $e("label.addtocalendar", t);
  }(), s = function() {
    return n !== "all" && t.dates[`${n}`].status.toLowerCase() === "cancelled" || n === "all" && t.allCancelled ? $e("date.status.cancelled", t) : "";
  }(), o = function() {
    return i.length == 0 ? $e("recurring", t) + " &#x27F3;" : "&#x27F3;";
  }();
  let l = !1;
  n === "all" && (n = 0, l = !0);
  const c = new Date(ba(t.dates[`${n}`]).start), d = ba(t.dates[`${n}`]).allday, f = t.dates[`${n}`].timeZone, g = document.createElement("div");
  g.classList.add("atcb-date-btn-left"), e.append(g);
  const _ = document.createElement("div");
  _.classList.add("atcb-date-btn-day"), g.append(_);
  const x = document.createElement("div");
  x.classList.add("atcb-date-btn-month"), _.textContent = c.toLocaleString(t.language, { day: "numeric", timeZone: d ? "UTC" : f }), x.textContent = c.toLocaleString(t.language, { month: "short", timeZone: d ? "UTC" : f }), g.append(x);
  const p = document.createElement("div");
  p.classList.add("atcb-date-btn-right"), e.append(p);
  const w = document.createElement("div");
  w.classList.add("atcb-date-btn-details"), p.append(w);
  const C = document.createElement("div");
  C.classList.add("atcb-date-btn-headline");
  const M = t.dates.length > 1 && l ? t.name : t.dates[`${n}`].name;
  if (C.textContent = M, w.append(C), t.dates[`${n}`].location && t.dates[`${n}`].location !== "" && !t.dates[`${n}`].onlineEvent || s !== "") {
    const D = document.createElement("div");
    if (D.classList.add("atcb-date-btn-content"), w.append(D), s != "")
      D.classList.add("atcb-date-btn-cancelled"), D.textContent = s;
    else {
      const B = document.createElement("span");
      B.classList.add("atcb-date-btn-content-icon"), B.innerHTML = gs.location, D.append(B);
      const P = document.createElement("span");
      P.classList.add("atcb-date-btn-content-location"), P.textContent = t.dates[`${n}`].location, D.append(P);
    }
  } else if (t.dates[`${n}`].description !== "" && i.length === 0 && (!t.recurrence || t.recurrence === "")) {
    const D = document.createElement("div");
    D.classList.add("atcb-date-btn-content"), D.textContent = t.dates[`${n}`].descriptionHtmlFree, D.style.overflow = "hidden", D.style.display = "-webkit-box", D.style.lineClamp = "2", D.style.boxOrient = "vertical", w.append(D);
  } else
    C.style.lineClamp = "2", i.length == 0 && (t.recurrence == null || t.recurrence == "") && (p.style.alignSelf = "center", C.style.textAlign = "center", C.style.lineClamp = "2");
  if (i.length > 0 || t.recurrence != null && t.recurrence != "") {
    const D = document.createElement("div");
    D.classList.add("atcb-date-btn-content"), w.append(D);
    const B = document.createElement("span");
    B.classList.add("atcb-date-btn-content-icon"), B.innerHTML = gs.ical, D.append(B);
    const P = document.createElement("span");
    if (P.classList.add("atcb-date-btn-content-text"), D.append(P), i.forEach(function(z) {
      const W = document.createElement("span");
      W.textContent = z, P.append(W);
    }), t.recurrence != null && t.recurrence != "") {
      const z = document.createElement("span");
      z.innerHTML = o, P.append(z);
    }
  }
  const A = document.createElement("div");
  if (A.classList.add("atcb-date-btn-hover"), A.innerHTML = r, p.append(A), !t.hideCheckmark && t.dates[`${n}`].status.toLowerCase() !== "cancelled") {
    const D = document.createElement("div");
    D.classList.add("atcb-checkmark"), D.innerHTML = gs.checkmark, e.append(D);
  }
  const L = r.replace(/<br>/g, " ").replace(/\+\s/g, "") + (a ? " (" + $e(t.options[0], t) + ")" : "") + ": " + M + (t.dates[`${n}`].location && t.dates[`${n}`].location !== "" ? ", " + t.dates[`${n}`].location : "") + ", " + i.join(" ");
  e.setAttribute("aria-label", L);
}
async function Bl(t, e, n = !0) {
  const a = document.getElementById(e.identifier + "-modal-host");
  if (a) {
    if (!n)
      return a.shadowRoot;
    a.remove();
  }
  let i = document.createElement("div");
  i.id = e.identifier + "-modal-host", t.host.hasAttribute("cspnonce") && i.setAttribute("cspnonce", t.host.getAttribute("cspnonce")), i.setAttribute("atcb-button-id", e.identifier), i.classList.add("add-to-calendar"), i.style.transform = "translate3D(0, 0, 0)", i.style.visibility = "visible", i.style.opacity = "1", i.style.position = "fixed", i.style.top = "0", i.style.left = "0", i.style.width = "100%", i.style.height = "100%", i.style.display = "flex", i.style.zIndex = "13999998", document.body.append(i), i.attachShadow({ mode: "open", delegateFocus: !0 });
  const r = document.createElement("template");
  return r.innerHTML = '<div class="atcb-modal-host-initialized" style="transform:translate3D(0, 0, 0);visibility:visible;opacity:1;position:fixed;top:0;left:0;width:100%;height:100%;display:flex;z-index:13999999;"></div>', i.shadowRoot.append(r.content.cloneNode(!0)), Kh(i.shadowRoot, e), await fv(i.shadowRoot, null, e), i.shadowRoot;
}
async function nB(t, e) {
  const n = await Bl(t, e);
  return Br(n.querySelector(".atcb-modal-host-initialized")), Array.from(t.children).forEach((i) => {
    i.tagName != "STYLE" && n.querySelector(".atcb-modal-host-initialized").append(i.cloneNode(!0));
  }), n.querySelector("button.atcb-button").removeAttribute("id"), t.host.classList.add("atcb-shadow-hide"), t.querySelector(".atcb-initialized").style.opacity = "0", lv(t, n), window.addEventListener("scroll", eu), window.addEventListener("resize", eu), n.querySelector(".atcb-modal-host-initialized");
}
function aB(t, e) {
  const n = document.createElement("script");
  if (n.id = "atcb-schema-" + t.identifier, e.hasAttribute("cspnonce")) {
    if (/[`'"()[\]{}<>\s]/.test(e.getAttribute("cspnonce")))
      throw new Error("cspnonce input contains forbidden characters.");
    n.setAttribute("nonce", e.getAttribute("cspnonce"));
  }
  n.type = "application/ld+json";
  const a = t.name.replace(/\s/g, ""), i = [];
  if (t.dates.length > 1) {
    const s = [];
    s.push('"@context":"https://schema.org"'), s.push('"@type":"EventSeries"'), s.push('"@id":"' + a + '"'), s.push('"name":"' + t.name + '",'), i.push(`{\r
` + s.join(`,\r
`) + `\r
`);
  }
  const r = [];
  for (let s = 0; s < t.dates.length; s++) {
    const o = [];
    o.push('"@context":"https://schema.org"'), o.push('"@type":"Event"'), t.dates.length > 1 && o.push('"@id":"' + a + "-" + (s + 1) + '"'), t.dates[`${s}`].status.toLowerCase() === "cancelled" ? o.push('"eventStatus":"https://schema.org/EventCancelled"') : o.push('"eventStatus":"https://schema.org/EventScheduled"'), o.push('"name":"' + t.dates[`${s}`].name + '"'), t.dates[`${s}`].descriptionHtmlFree && o.push('"description":"' + t.dates[`${s}`].descriptionHtmlFree + '"');
    const l = ba(t.dates[`${s}`], "delimiters", "general", !0);
    if (o.push('"startDate":"' + l.start + '"'), l.duration && o.push('"duration":"' + l.duration + '"'), o.push(t.dates[`${s}`].onlineEvent ? `"eventAttendanceMode":"https://schema.org/OnlineEventAttendanceMode",\r
"location": {\r
"@type":"VirtualLocation",\r
"url":"` + t.dates[`${s}`].location + `"\r
}` : '"location":"' + t.dates[`${s}`].location + '"'), t.recurrence && t.recurrence !== "" ? o.push(...iB(t, l)) : o.push('"endDate":"' + l.end + '"'), t.dates[`${s}`].organizer && t.dates[`${s}`].organizer !== "") {
      const d = t.dates[`${s}`].organizer.split("|");
      o.push(`"organizer":{\r
"@type":"Person",\r
"name":"` + d[0] + `",\r
"email":"` + d[1] + `"\r
}`);
    }
    const c = [];
    if (t.images && Array.isArray(t.images))
      for (let d = 0; d < t.images.length; d++)
        Es(t.images[`${d}`], t.debug) && t.images[`${d}`].startsWith("http") && c.push('"' + t.images[`${d}`] + '"');
    c.length > 0 && o.push(`"image":[\r
` + c.join(`,\r
`) + "]"), r.push(`{\r
` + o.join(`,\r
`) + `\r
}`);
  }
  t.dates.length > 1 ? n.textContent = i.join(`,\r
`) + `"subEvents":[\r
` + r.join(`,\r
`) + `\r
]\r
}` : n.textContent = r[0], document.body.insertBefore(n, document.body.firstChild);
}
function iB(t, e) {
  const n = [];
  if (n.push('"eventSchedule": { "@type": "Schedule"'), n.push('"scheduleTimezone":"' + t.dates[0].timeZone + '"'), t.recurrence_interval && t.recurrence_interval !== "" && t.recurrence_frequency && t.recurrence_frequency !== "") {
    const a = "P" + t.recurrence_interval + t.recurrence_frequency.substring(0, 1);
    n.push('"repeatFrequency":"' + a + '"');
  }
  if (t.recurrence_byDay && t.recurrence_byDay !== "") {
    const a = function() {
      if (/\d/.test(t.recurrence_byDay))
        return '"' + t.recurrence_byDay + '"';
      {
        const i = t.recurrence_byDay.split(","), r = {
          MO: "https://schema.org/Monday",
          TU: "https://schema.org/Tuesday",
          WE: "https://schema.org/Wednesday",
          TH: "https://schema.org/Thursday",
          FR: "https://schema.org/Friday",
          SA: "https://schema.org/Saturday",
          SU: "https://schema.org/Sunday"
        }, s = [];
        for (let o = 0; o < i.length; o++)
          s.push('"' + r[i[`${o}`]] + '"');
        return "[" + s.join(",") + "]";
      }
    }();
    n.push('"byDay":' + a);
  }
  if (t.recurrence_byMonth && t.recurrence_byMonth !== "") {
    const a = t.recurrence_byMonth.includes(",") ? "[" + t.recurrence_byMonth + "]" : t.recurrence_byMonth;
    n.push('"byMonth":"' + a + '"');
  }
  if (t.recurrence_byMonthDay && t.recurrence_byMonthDay !== "") {
    const a = t.recurrence_byMonthDay.includes(",") ? "[" + t.recurrence_byMonthDay + "]" : t.recurrence_byMonthDay;
    n.push('"byMonthDay":"' + a + '"');
  }
  return t.recurrence_count && t.recurrence_count !== "" && n.push('"repeatCount":"' + t.recurrence_count + '"'), t.recurrence_until && t.recurrence_until !== "" && n.push('"endDate":"' + t.recurrence_until + '"'), t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "" && (n.push('"startTime":"' + t.startTime + ':00"'), n.push('"endTime":"' + t.endTime + ':00"'), n.push('"duration":"' + e.duration + '"')), n.push('"startDate":"' + t.startDate + '" }'), n;
}
function bs(t, e, n, a = "all", i = !1, r = !1, s = !1) {
  let o = e;
  if (e === "apple" && (o = "ical"), a !== "all" ? a = parseInt(a) - 1 : n.dates.length == 1 && (a = 0), n.subscribe) {
    sB(t, e, o, n, i);
    return;
  }
  if (a !== "all") {
    if (n.dates[`${a}`].status.toLowerCase() === "cancelled" && o !== "ical")
      Qi(t, n, "warning", $e("date.status.cancelled", n), $e("date.status.cancelled.cta", n), [], [], i);
    else {
      switch (o) {
        case "ical":
          sv(t, n, e, a, i);
          break;
        case "google":
          lB(n, n.dates[`${a}`], a);
          break;
        case "msteams":
          uB(n, n.dates[`${a}`], a);
          break;
        case "ms365":
          s1(n, n.dates[`${a}`], a);
          break;
        case "outlookcom":
          s1(n, n.dates[`${a}`], a, "outlookcom");
          break;
        case "yahoo":
          cB(n, n.dates[`${a}`], a);
          break;
      }
      const l = document.getElementById(n.identifier + "-modal-host");
      if (l) {
        const d = l.shadowRoot.getElementById(n.identifier + "-" + e + "-" + (a + 1));
        d && d.classList.add("atcb-saved");
      }
      n.dates[`${a}`].status.toLowerCase() !== "cancelled" && Ft[`${n.identifier}`][`${e}`][`${a}`]++, Ft[`${n.identifier}`][`${e}`].filter(function(d) {
        return d < 1;
      }).length == 0 && Wu(t, n, r);
    }
    return;
  }
  rB(t, e, o, n, i, r);
}
function rB(t, e, n, a, i, r) {
  if (n === "ical" && a.dates.every(function(s) {
    return !(s.status.toLowerCase() == "cancelled" || s.organizer != null && s.organizer != "");
  })) {
    sv(t, a, e, "all", i);
    for (let s = 0; s < Ft[`${a.identifier}`][`${e}`].length; s++)
      Ft[`${a.identifier}`][`${e}`][`${s}`]++;
    Wu(t, a, r);
    return;
  }
  if (!r) {
    const s = [e];
    for (let o = 0; o < a.dates.length; o++)
      s.push(o + 1);
    Qi(t, a, e, $e("modal.multidate.h", a), $e("modal.multidate.text", a), [], s, i);
  }
}
function sB(t, e, n, a, i) {
  const r = a.icsFile.replace("https://", "webcal://");
  switch (n) {
    case "ical":
      if (Gi() || a.fakeAndroid) {
        i1(a, a.icsFile, e);
        break;
      }
      i1(a, r, e, t, i);
      break;
    case "google":
      oB(a, r);
      break;
    case "ms365":
      r1(a, r, a.name);
      break;
    case "outlookcom":
      r1(a, r, a.name, "outlookcom");
      break;
    case "yahoo":
      if (a.proxy) {
        Ia(a, "yahoo", "", !0);
        return;
      }
      tu(a.icsFile), Qi(
        t,
        a,
        "yahoo",
        $e("modal.subscribe.yahoo.h", a),
        $e("modal.clipboard.text", a) + "<br>" + $e("modal.subscribe.yahoo.text", a),
        [
          {
            label: $e("modal.subscribe.yahoo.button", a),
            primary: !0,
            type: "yahoo2nd",
            href: "https://www.yahoo.com/calendar"
          },
          { label: $e("cancel", a) }
        ],
        [],
        i
      );
      return;
    case "yahoo2nd":
      tu(a.icsFile), Qi(
        t,
        a,
        "yahoo",
        $e("modal.subscribe.yahoo.h", a),
        $e("modal.clipboard.text", a) + "<br>" + $e("modal.subscribe.yahoo.text", a),
        [
          {
            label: $e("modal.subscribe.yahoo.button", a),
            type: "none",
            href: "https://www.yahoo.com/calendar"
          },
          { label: $e("cancel", a) }
        ],
        [],
        i
      );
      return;
  }
  Wu(t, a);
}
function Wu(t, e, n = !1) {
  const a = t.getElementById(e.identifier);
  a && a.classList.add("atcb-saved"), hB(t, e), n && t.querySelectorAll(".atcb-modal[data-modal-nr]").length < 2 && Sn(t, "close");
}
function i1(t, e, n, a = null, i = !1) {
  if (Nn() && !Pl()) {
    ov(a, e, t, i);
    return;
  }
  Ia(t, n, e, !0);
}
function oB(t, e) {
  const n = "https://calendar.google.com/calendar/u/0/r?cid=", a = "calendar.google.com/calendar?cid=";
  let i = !1;
  const r = function() {
    return /^(?:webcal:\/\/|\/\/)calendar\.google\.com\/.*\?cid=/.test(e) ? (i = !0, e.replace(/^(.)*\?cid=/, "")) : encodeURIComponent(e);
  }();
  if ((Gi() || t.fakeAndroid) && i) {
    Ia(t, "google", "intent://" + a + r + "#Intent;scheme=https;package=com.google.android.calendar;end", !0);
    return;
  }
  if ((Nn() && Pl() || t.fakeIOS) && i) {
    Ia(t, "google", "googlecalendar://" + a + r, !0);
    return;
  }
  Ia(t, "google", n + r, !0);
}
function r1(t, e, n, a = "ms365") {
  const i = [], r = function() {
    return a == "outlookcom" ? "https://outlook.live.com/calendar/0/addfromweb/?" : "https://outlook.office.com/calendar/0/addfromweb/?";
  }();
  i.push("url=" + encodeURIComponent(e)), i.push("name=" + encodeURIComponent(n)), Ia(t, a, r + i.join("&"), !0);
}
function lB(t, e, n = "all") {
  const a = [];
  Pr() || t.fakeMobile ? a.push("https://calendar.google.com/calendar/render?action=TEMPLATE&") : a.push("https://calendar.google.com/calendar/r/eventedit?");
  const i = ba(e, "clean", "google");
  a.push("dates=" + encodeURIComponent(i.start) + "%2F" + encodeURIComponent(i.end)), e.timeZone && e.timeZone !== "" && !/GMT[+|-]\d{1,2}|Etc\/U|Etc\/Zulu|CET|CST6CDT|EET|EST|MET|MST|PST8PDT|WET/i.test(e.timeZone) && !i.allday && a.push("ctz=" + e.timeZone), e.name && e.name !== "" && a.push("text=" + encodeURIComponent(e.name));
  const r = [];
  if (e.description && e.description !== "" && r.push(e.description), e.location && e.location !== "" && (a.push("location=" + encodeURIComponent(e.location)), (Nn() || t.fakeIOS) && (r.length > 0 && r.push("<br><br>"), r.push("&#128205;: " + e.location))), r.length > 0 && a.push("details=" + encodeURIComponent(r.join(""))), e.recurrence && e.recurrence !== "" && a.push("recur=" + encodeURIComponent(e.recurrence)), e.availability && e.availability !== "") {
    const o = function() {
      return e.availability == "free" ? "crm=AVAILABLE&trp=false" : "crm=BUSY&trp=true";
    }();
    a.push(o);
  }
  let s = a.join("&");
  Gi() || t.fakeAndroid ? s = "intent://" + s.slice(8) + "#Intent;scheme=https;package=com.google.android.calendar;end" : (Nn() && Pl() || t.fakeIOS) && (s = "googlecalendar://" + s.slice(8)), Ia(t, "google", s, !1, n);
}
function cB(t, e, n = "all") {
  const a = [];
  a.push("https://calendar.yahoo.com/?v=60");
  const i = ba(e, "clean");
  if (i.allday)
    if (i.start === i.end)
      a.push("dur=allday&st=" + encodeURIComponent(i.start));
    else {
      const r = JSON.parse(JSON.stringify(e));
      r.startTime = "00:00", r.endTime = "23:59", r.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const s = ba(r, "clean");
      a.push("st=" + encodeURIComponent(s.start) + "&et=" + encodeURIComponent(s.end));
    }
  else
    a.push("st=" + encodeURIComponent(i.start) + "&et=" + encodeURIComponent(i.end));
  e.name && e.name !== "" && a.push("title=" + encodeURIComponent(e.name)), e.location && e.location !== "" && a.push("in_loc=" + encodeURIComponent(e.location)), e.descriptionHtmlFree && e.descriptionHtmlFree !== "" && a.push("desc=" + encodeURIComponent(e.descriptionHtmlFree)), Ia(t, "yahoo", a.join("&"), !1, n);
}
function s1(t, e, n = "all", a = "ms365") {
  const i = [], r = function() {
    return Pr() || t.fakeMobile ? "/calendar/0/deeplink/compose?path=%2Fcalendar%2Faction%2Fcompose&rru=addevent" : "/calendar/action/compose?rru=addevent";
  }(), s = function() {
    return a == "outlookcom" ? "https://outlook.live.com" + r : "https://outlook.office.com" + r;
  }();
  i.push(s);
  const o = ba(e, "delimiters", "microsoft");
  i.push("startdt=" + o.start), i.push("enddt=" + o.end), o.allday && i.push("allday=true"), e.name && e.name !== "" && i.push("subject=" + encodeURIComponent(e.name.replace(/&/g, "&#xFF06;"))), e.location && e.location !== "" && i.push("location=" + encodeURIComponent(e.location)), e.description && e.description !== "" && i.push("body=" + encodeURIComponent(e.description)), Ia(t, a, i.join("&"), !1, n);
}
function uB(t, e, n = "all") {
  const a = [], i = "https://teams.microsoft.com/l/meeting/new?", r = ba(e, "delimiters", "msteams", !0);
  !r.allday || Pr() || t.fakeMobile ? (a.push("startTime=" + encodeURIComponent(r.start)), a.push("endTime=" + encodeURIComponent(r.end))) : (a.push("startTime=" + r.start), a.push("endTime=" + r.end)), e.name && e.name !== "" && a.push("subject=" + encodeURIComponent(e.name));
  let s = "";
  e.location && e.location !== "" && (s = e.location, s += " // ", a.push("location=" + encodeURIComponent(s))), e.descriptionHtmlFree && e.descriptionHtmlFree != "" && a.push("content=" + s + encodeURIComponent(e.descriptionHtmlFree)), Ia(t, "msteams", i + a.join("&"), !1, n);
}
function Ia(t, e, n = "", a = !1, i = null, r = "") {
  if (r === "" && (r = Xh), t.proxy && t.proKey && t.proKey !== "") {
    const s = a ? "s" : "o", o = function() {
      const c = [];
      return t.attendee && t.attendee !== "" && c.push("attendee=" + encodeURIComponent(t.attendee)), t.customVar && typeof t.customVar == "object" && Object.keys(t.customVar).length > 0 && c.push("customvar=" + encodeURIComponent(JSON.stringify(t.customVar))), t.dates && t.dates.length > 1 && i !== null && i !== "all" && c.push("sub-event=" + i), c.length > 0 ? "?" + c.join("&") : "";
    }();
    if (n = `https://${t.domain ? t.domain : t.dev ? "dev.caldn.net" : "caldn.net"}/${t.proKey}/${s}/${e}${o}`, !Es(n))
      return;
  }
  if (Es(n)) {
    const s = window.open(n, r);
    s && s.focus();
  }
}
function sv(t, e, n, a = "all", i = !1) {
  a !== "all" && (a = parseInt(a));
  const r = dB(e, a), s = function() {
    const _ = t.host.getAttribute("attendee") || "", x = t.host.getAttribute("customVar") || "";
    return e.attendee && e.attendee !== "" && _ !== "" || e.customVar && e.customVar !== "" && x !== "" ? "" : a !== "all" && e.dates[`${a}`].icsFile && e.dates[`${a}`].icsFile !== "" ? e.dates[`${a}`].icsFile : e.icsFile && e.icsFile !== "" ? e.icsFile : "";
  }();
  if (e.proxy) {
    Ia(e, n, "", !1, a);
    return;
  }
  if (s !== "" && (!Nn() && !e.fakeIOS || !j0() || e.bypassWebViewCheck)) {
    o1(s, r);
    return;
  }
  const o = /* @__PURE__ */ new Date(), l = ["BEGIN:VCALENDAR", "VERSION:2.0"];
  l.push("PRODID:-// https://add-to-calendar-pro.com // button v" + X2 + " //EN"), l.push("CALSCALE:GREGORIAN"), a == "all" ? l.push("METHOD:PUBLISH") : e.dates[`${a}`].status && e.dates[`${a}`].status.toLowerCase() === "cancelled" ? l.push("METHOD:CANCEL") : e.dates[`${a}`].organizer && e.dates[`${a}`].organizer != "" ? l.push("METHOD:REQUEST") : l.push("METHOD:PUBLISH");
  const c = [], d = function() {
    return a != "all" ? a : 0;
  }(), f = function() {
    return a != "all" ? a : e.dates.length - 1;
  }();
  for (let _ = d; _ <= f; _++) {
    const x = ba(e.dates[`${_}`], "clean", "ical"), p = function() {
      if (x.allday)
        return ";VALUE=DATE";
      if (e.dates[`${_}`].timeZone && e.dates[`${_}`].timeZone !== "") {
        const w = uP(e.dates[`${_}`].timeZone);
        return c.includes(e.dates[`${_}`].timeZone) || l.push(w[0]), c.push(e.dates[`${_}`].timeZone), ";" + w[1];
      }
    }();
    if (l.push("BEGIN:VEVENT"), e.dates[`${_}`].uid && e.dates[`${_}`].uid !== "" && l.push("UID:" + e.dates[`${_}`].uid), l.push("DTSTAMP:" + oa(o, "clean", !0)), l.push("DTSTART" + p + ":" + x.start), l.push("DTEND" + p + ":" + x.end), l.push("SUMMARY:" + Qr(e.dates[`${_}`].name, !0)), e.dates[`${_}`].descriptionHtmlFreeICal && e.dates[`${_}`].descriptionHtmlFreeICal !== "" && l.push("DESCRIPTION:" + Qr(e.dates[`${_}`].descriptionHtmlFreeICal, !0)), e.dates[`${_}`].description && e.dates[`${_}`].description !== "" && l.push(`X-ALT-DESC;FMTTYPE=text/html:\r
 <!DOCTYPE HTML PUBLIC ""-//W3C//DTD HTML 3.2//EN"">\r
 <HTML><BODY>\r
 ` + Qr(e.dates[`${_}`].description, !0) + `\r
 </BODY></HTML>`), e.dates[`${_}`].location && e.dates[`${_}`].location !== "" && l.push("LOCATION:" + Qr(e.dates[`${_}`].location, !0)), e.dates[`${_}`].organizer && e.dates[`${_}`].organizer !== "") {
      const w = e.dates[`${_}`].organizer.split("|");
      l.push("ORGANIZER;CN=" + Qr(w[0], !1, !0) + ":MAILTO:" + w[1]);
    }
    if (e.dates[`${_}`].attendee && e.dates[`${_}`].attendee !== "") {
      const w = e.dates[`${_}`].attendee.split("|");
      w.length === 2 ? l.push("ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=" + Qr(w[0], !1, !0) + ";X-NUM-GUESTS=0:mailto:" + w[1]) : l.push("ATTENDEE;CUTYPE=INDIVIDUAL;ROLE=REQ-PARTICIPANT;PARTSTAT=ACCEPTED;CN=" + w[0] + ";X-NUM-GUESTS=0:mailto:" + w[0]);
    }
    if (e.recurrence && e.recurrence !== "" && l.push(e.recurrence), e.dates[`${_}`].availability && e.dates[`${_}`].availability !== "") {
      const w = function() {
        return e.dates[`${_}`].availability == "free" ? "TRANSPARENT" : "OPAQUE";
      }();
      l.push("TRANSP:" + w);
    }
    l.push("SEQUENCE:" + e.dates[`${_}`].sequence), l.push("STATUS:" + e.dates[`${_}`].status), l.push("CREATED:" + e.created), l.push("LAST-MODIFIED:" + e.updated), l.push("END:VEVENT");
  }
  l.push("END:VCALENDAR");
  const g = function() {
    return s != "" ? s : "data:text/calendar;charset=utf-8," + encodeURIComponent(l.join(`\r
`));
  }();
  if (Nn() && !Pl() || j0() && (Nn() || Gi() && hP())) {
    ov(t, g, e, i);
    return;
  }
  o1(g, r);
}
function dB(t, e) {
  const n = function() {
    return e != "all" && e != 0 ? "-" + parseInt(e) + 1 : "";
  }();
  if (t.iCalFileName != null && t.iCalFileName != "")
    return t.iCalFileName + n;
  if (t.icsFile != null && t.icsFile != "") {
    const a = t.icsFile.split("/").pop().split(".")[0];
    if (a != "")
      return a + n;
  }
  return "event-to-save-in-my-calendar" + n;
}
function ov(t, e, n, a) {
  if (tu(e), Nn() && !Pl()) {
    Qi(
      t,
      n,
      "warning",
      $e("modal.opensafari.ical.h", n),
      $e("modal.opensafari.ical.text", n) + "<br>" + $e("modal.clipboard.text", n) + "<br>" + $e("modal.opensafari.ical.steps", n),
      [],
      [],
      a
    );
    return;
  }
  Qi(t, n, "warning", $e("modal.webview.ical.h", n), $e("modal.webview.ical.text", n) + "<br>" + $e("modal.clipboard.text", n) + "<br>" + $e("modal.webview.ical.steps", n), [], [], a);
}
function hB(t, e) {
  sn("success", e.identifier, e.identifier), e.ty && typeof t1 == "function" && setTimeout(() => {
    t1(t, e);
  }, 1e3);
}
function o1(t, e) {
  try {
    const n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
    n.rel = "noopener", n.href = t, Pr() ? n.target = "_self" : n.target = "_blank", n.download = e + ".ics";
    const a = new MouseEvent("click", {
      view: window,
      button: 0,
      bubbles: !0,
      cancelable: !1
    });
    n.dispatchEvent(a), (window.URL || window.webkitURL).revokeObjectURL(n.href);
  } catch (n) {
    console.error(n);
  }
}
function ba(t, e = "delimiters", n = "general", a = !1) {
  if (t.startTime && t.startTime !== "" && t.endTime && t.endTime !== "") {
    const i = /* @__PURE__ */ new Date(t.startDate + "T" + t.startTime + ":00.000+00:00");
    t.endDate || (t.endDate = t.startDate);
    const r = /* @__PURE__ */ new Date(t.endDate + "T" + t.endTime + ":00.000+00:00"), s = r - i, o = Math.floor(s / 1e3 / 60 / 60), l = Math.floor((s - o * 60 * 60 * 1e3) / 1e3 / 60 % 60), c = function() {
      return o < 10 ? "0" + o + ":" + ("0" + l).slice(-2) : o + ":" + ("0" + l).slice(-2);
    }();
    if (n == "ical" || n == "google" && !/GMT[+|-]\d{1,2}|Etc\/U|Etc\/Zulu|CET|CST6CDT|EET|EST|MET|MST|PST8PDT|WET/i.test(t.timeZone))
      return {
        start: oa(i, "clean", !0, !0),
        end: oa(r, "clean", !0, !0),
        duration: c,
        allday: !1
      };
    const d = Kc(t.timeZone, t.startDate, t.startTime), f = Kc(t.timeZone, t.endDate, t.endTime);
    if (a) {
      const x = d.slice(0, 3) + ":" + d.slice(3), p = f.slice(0, 3) + ":" + f.slice(3);
      return {
        start: i.toISOString().replace(".000Z", x),
        end: r.toISOString().replace(".000Z", p),
        duration: c,
        allday: !1
      };
    }
    const g = parseInt(d[0] + 1) * -1 * ((parseInt(d.substring(1, 3)) * 60 + parseInt(d.substring(3, 5))) * 60 * 1e3), _ = parseInt(f[0] + 1) * -1 * ((parseInt(f.substring(1, 3)) * 60 + parseInt(f.substring(3, 5))) * 60 * 1e3);
    return i.setTime(i.getTime() + g), r.setTime(r.getTime() + _), {
      start: oa(i, e),
      end: oa(r, e),
      duration: c,
      allday: !1
    };
  } else {
    const i = t.startDate.split("-"), r = t.endDate ? t.endDate.split("-") : i, s = new Date(Date.UTC(i[0], i[1] - 1, i[2], 12, 0, 0)), o = new Date(Date.UTC(r[0], r[1] - 1, r[2], 12, 0, 0));
    if ((n === "google" || n === "microsoft" && !Pr() || n === "msteams" || n === "ical") && o.setDate(o.getDate() + 1), n === "msteams") {
      if (Pr()) {
        const l = s.getTimezoneOffset(), c = function() {
          return l < 0 ? "+" + ("0" + Math.abs(l / 60)).slice(-2) + ":" + ("0" + Math.abs(l % 60)).slice(-2) : "-" + ("0" + Math.abs(l / 60)).slice(-2) + ":" + ("0" + Math.abs(l % 60)).slice(-2);
        }();
        return {
          start: oa(s, e, !1, !0) + "T00:00:00" + c,
          end: oa(o, e, !1, !0) + "T00:00:00" + c,
          allday: !0
        };
      }
      return {
        start: oa(s, e, !1, !0) + "+00:00",
        end: oa(o, e, !1, !0) + "+00:00",
        allday: !0
      };
    }
    return {
      start: oa(s, e, !1),
      end: oa(o, e, !1),
      allday: !0
    };
  }
}
function oa(t, e = "delimiters", n = !0, a = !1) {
  const i = function() {
    return n ? e == "clean" ? /(-|:|(\.\d{3}))/g : /(\.\d{3})/g : e == "clean" ? /(-|T(\d{2}:\d{2}:\d{2}\.\d{3})Z)/g : /T(\d{2}:\d{2}:\d{2}\.\d{3})Z/g;
  }();
  return a ? t.toISOString().replace(i, "").replace("Z", "") : t.toISOString().replace(i, "");
}
function fB(t) {
  const e = t[0] === "+" ? 1 : -1, n = parseInt(t.substring(1, 3), 10), a = parseInt(t.substring(3, 5), 10);
  return (n * 60 + a) * e * 6e4;
}
function l1(t, e, n, a) {
  const i = /* @__PURE__ */ new Date(`${t}T${e}:00Z`), r = Kc(n, t, e), s = new Date(i.getTime() - fB(r));
  return [t, e] = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: a,
    hourCycle: "h23"
  }).format(s).split(", ");
}
function pB(t, e = "en", n = "all", a = !1, i = !1, r = !1, s = !1) {
  if (a) {
    const z = K2();
    t = Q2({ dates: t, timeZone: z }).dates;
  }
  let o, l, c, d, f = {}, g = {}, _ = [], x = "", p = "";
  const w = Intl.DateTimeFormat().resolvedOptions().timeZone;
  n === "all" ? (f = ba(t[0]), g = ba(t[t.length - 1]), c = i ? w : t[0].timeZone, d = i ? w : t[t.length - 1].timeZone) : (f = ba(t[`${n}`]), g = f, c = i ? w : t[`${n}`].timeZone, d = c), o = new Date(f.start), l = new Date(g.end), f.allday && (c = "GMT"), g.allday && (d = "GMT");
  const C = ["global", "world-wide", "worldwide", "online"];
  (function() {
    let z = 0, W = t.length - 1;
    for (n != "all" && (z = W = n), z; z <= W; z++)
      if (!function() {
        return !!(t[`${z}`].location && t[`${z}`].location !== "" && C.includes(t[`${z}`].location.toLowerCase()));
      }() && !t[`${z}`].onlineEvent)
        return !1;
    return !0;
  })() ? c = d = w : (!f.allday && w !== c && c !== d && (x = "(" + c + ")"), (!g.allday && w !== d || c !== d) && (p = "(" + d + ")"));
  const A = /* @__PURE__ */ new Date(), L = function() {
    return !r && o.getFullYear() === A.getFullYear();
  }(), D = function() {
    return !r && l.getFullYear() === A.getFullYear();
  }(), B = c1(c, L, e), P = c1(d, D, e);
  if (o.toLocaleDateString(e, P.DateLong) === l.toLocaleDateString(e, P.DateLong))
    if (f.allday)
      L || _.push(o.toLocaleDateString(e, B.DateLong));
    else {
      let z = "";
      L ? z = o.toLocaleString(e, B.Time) : z = o.toLocaleString(e, B.DateTimeLong), e === "en" && (z = z.replace(/:00/, "")), _.push(z), x !== "" && !s && _.push(x), _.push("-"), z = l.toLocaleTimeString(e, P.Time), e === "en" && (z = z.replace(/:00/, "")), _.push(z), p !== "" && !s && _.push(p);
    }
  else {
    if (f.allday)
      _.push(o.toLocaleDateString(e, B.DateLong));
    else {
      let z = "";
      L ? z = o.toLocaleString(e, B.Time) : z = o.toLocaleString(e, B.DateTimeLong), e === "en" && (z = z.replace(/:00/, "")), _.push(z);
    }
    if (x !== "" && !s && _.push(x), _.push("-"), g.allday)
      _.push(l.toLocaleDateString(e, P.DateLong));
    else {
      let z = l.toLocaleString(e, P.DateTimeLong);
      e === "en" && (z = z.replace(/:00/, "")), _.push(z);
    }
    p !== "" && !s && _.push(p);
  }
  return _;
}
function c1(t, e = !1, n = "en") {
  const a = /* @__PURE__ */ function() {
    return n === "en" ? "h12" : "h23";
  }();
  return e ? {
    DateLong: {
      timeZone: t,
      month: "short",
      day: "numeric"
    },
    DateTimeLong: {
      timeZone: t,
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    },
    Time: {
      timeZone: t,
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    }
  } : {
    DateLong: {
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    DateTimeLong: {
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    },
    Time: {
      timeZone: t,
      hour: "numeric",
      minute: "2-digit",
      hourCycle: a
    }
  };
}
function bl(t, e = !0) {
  const a = (e ? JSON.stringify(t) : t.toString()).replace(/(<(?!br)([^>]+)>)/gi, "");
  return e ? JSON.parse(a) : a;
}
function Es(t, e = !0) {
  return t && t.match(/((\.\.\/)|(\.\.\\)|(%2e%2e%2f)|(%252e%252e%252f)|(%2e%2e\/)|(%252e%252e\/)|(\.\.%2f)|(\.\.%252f)|(%2e%2e%5c)|(%252e%252e%255c)|(%2e%2e\\)|(%252e%252e\\)|(\.\.%5c)|(\.\.%255c)|(\.\.%c0%af)|(\.\.%25c0%25af)|(\.\.%c1%9c)|(\.\.%25c1%259c))/gi) ? (e && console.error("Seems like the generated URL includes at least one security issue and got blocked. Please check the calendar button parameters!"), !1) : !0;
}
function Jc(t) {
  return !!/^.{0,70}@.{1,30}\.[a-z]{2,9}$/i.test(t);
}
function vs(t, e = !1, n = !1) {
  return e ? (n ? t = t.replace(/(\[br\s?\/?\]|\{br\s?\/?\}|(\[\/p\](?=.))|(\{\/p\}(?=.)))/gi, "\\n") : t = t.replace(/(\[br\s?\/?\]|\{br\s?\/?\}|(\[\/p\](?=.))|(\{\/p\}(?=.)))/gi, " "), t = t.replace(/\[url\](.+?)\[\/url\]/gi, (a, i) => i.split("|")[0]), t = t.replace(/\{url\}(.+?)\{\/url\}/gi, (a, i) => i.split("|")[0]), t = t.replace(/\[\/?(hr|[pbui]|strong|em|li|ul|ol|h\d)\]/gi, ""), t = t.replace(/\{\/?(hr|[pbui]|strong|em|li|ul|ol|h\d)\}/gi, ""), t = t.replace(/&[#a-z0-9]{1,9};/gi, "")) : (t = t.replace(/\[url\]((?:(?!\[\/url\]).)*)\[\/url\]/gi, function(a, i) {
    return u1(i);
  }), t = t.replace(/\{url\}((?:(?!\[\/url\]).)*)\{\/url\}/gi, function(a, i) {
    return u1(i);
  }), t = t.replace(/\[(\/)?(br|hr|[pbui]|strong|em|li|ul|ol|h\d)(\s?\/?)\]/gi, "<$1$2$3>"), t = t.replace(/\{(\/)?(br|hr|[pbui]|strong|em|li|ul|ol|h\d)(\s?\/?)\}/gi, "<$1$2$3>")), t;
}
function u1(t) {
  const e = t.split("|"), n = function() {
    return e.length > 1 && e[1] != "" ? e[1] : e[0];
  }();
  return '<a href="' + e[0] + '" target="' + Xh + '" rel="noopener">' + n + "</a>";
}
function Qr(t, e = !0, n = !1) {
  return n ? t = t.replace(/"/g, "") : t = t.replace(/\\/g, "\\\\").replace(/(,|;)/g, "\\$1").replace(/\\\\n/g, "\\n"), e && (t = t.replace(/.{60}/g, `$&\r
 `)), t;
}
function e0(t, e, n, a = !1, i = !1) {
  let r = !1;
  const s = e;
  e.querySelector(".atcb-dropdown-anchor") !== null && (e = e.querySelector(".atcb-dropdown-anchor"), r = !0), n.style.position = "relative", n.style.display = "inline-block";
  let o = e.getBoundingClientRect();
  const l = s.getBoundingClientRect(), c = s.parentNode.getBoundingClientRect(), d = document.documentElement.clientHeight;
  if (r === !0 && !n.classList.contains("atcb-dropoverlay")) {
    let g = n.getBoundingClientRect();
    n.style.width = g.width + "px", n.classList.contains("atcb-dropup") || !a && o.top + g.height > d - 20 && 2 * l.top + l.height - o.top - g.height > 20 || i ? (s.classList.add("atcb-dropup"), n.classList.add("atcb-dropup"), n.style.bottom = c.bottom - l.bottom + (o.top - l.top) + "px") : (n.style.top = l.top - c.top + (o.top - l.top) + "px", s.classList.contains("atcb-dropup") && s.classList.remove("atcb-dropup")), o = e.getBoundingClientRect(), !n.classList.contains("atcb-style-round") && !n.classList.contains("atcb-style-text") && !n.classList.contains("atcb-style-neumorphism") && (n.style.minWidth = o.width + "px", n.classList.contains("atcb-dropdown") && (n.style.maxWidth = o.width + "px")), g = n.getBoundingClientRect(), n.style.left = Math.round(o.left - c.left - (g.width - o.width) / 2) + "px";
  } else {
    n.style.minWidth = l.width + 20 + "px";
    const g = n.getBoundingClientRect();
    n.style.width = g.width + "px";
    const _ = Math.round((l.width - g.width) / 2);
    n.style.margin = -Math.round((g.height + l.height) / 2) + "px " + _ + "px 0 " + _ + "px";
  }
  n.style.position = "absolute", n.style.display = "block";
  const f = t.querySelector("#atcb-reference");
  f && s.classList.contains("atcb-dropup") && (s.parentNode.after(f), f.classList.add("atcb-dropup"));
}
function lv(t, e) {
  const n = t.querySelector(".atcb-initialized ").getBoundingClientRect(), a = e.querySelector(".atcb-initialized");
  let i = n.width;
  n.width < 250 && (i = 250), a.style.width = i + "px", a.style.height = n.height + "px", a.style.top = n.top + "px", a.style.left = n.left + "px";
}
function eu() {
  const t = Ft.active;
  if (t !== null && t !== "") {
    const e = document.querySelector("add-to-calendar-button[atcb-button-id=" + t + "]").shadowRoot, n = document.querySelector("div[atcb-button-id=" + t + "]").shadowRoot;
    lv(e, n);
  }
}
function Zh(t, e = null) {
  const n = function() {
    if (e != null)
      return e;
    {
      const i = t.querySelectorAll(".atcb-modal");
      return i.length === 0 ? null : i[i.length - 1];
    }
  }();
  if (n == null)
    return;
  n.getBoundingClientRect().height + 150 > window.innerHeight ? (document.body.classList.add("atcb-modal-no-scroll"), document.documentElement.classList.add("atcb-modal-no-scroll")) : (document.body.classList.remove("atcb-modal-no-scroll"), document.documentElement.classList.remove("atcb-modal-no-scroll"));
}
function Br(t) {
  t.style.width = window.innerWidth + "px", t.style.height = window.innerHeight + 100 + "px";
}
function vl(t, e) {
  t.style.setProperty("--base-font-size-l", e.l + "px"), t.style.setProperty("--base-font-size-m", e.m + "px"), t.style.setProperty("--base-font-size-s", e.s + "px");
}
function cv() {
  return ("10000000-1000-4000-8000" + -1e11).replace(/[018]/g, (e) => (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16));
}
function tu(t) {
  const e = document.createElement("input");
  document.body.append(e);
  const n = e.contentEditable, a = e.readOnly;
  if (e.contentEditable = !0, e.readOnly = !1, e.value = t, Nn()) {
    var i = document.createRange();
    i.selectNodeContents(e);
    var r = window.getSelection();
    r.removeAllRanges(), r.addRange(i), e.setSelectionRange(0, 999999);
  } else
    e.select();
  e.contentEditable = n, e.readOnly = a, document.execCommand("copy"), e.remove();
}
function us(t, e = 200) {
  let n;
  return (...a) => {
    clearTimeout(n), n = setTimeout(() => {
      t.apply(this, a);
    }, e);
  };
}
function xr(t, e = 300) {
  let n;
  return (...a) => {
    n || t.apply(this, a), clearTimeout(n), n = setTimeout(() => {
      n = void 0;
    }, e);
  };
}
function sn(t, e, n) {
  const a = function() {
    const i = document.getElementById(n);
    return i || document.querySelector('[atcb-button-id="' + n + '"]');
  }();
  a && a.setAttribute("atcb-last-event", t + ":" + e), Ai() && mB(t, e);
}
function mB(t, e) {
  let n = "";
  switch (t) {
    case "initialization":
      n = "Initialized";
      break;
    case "openList":
      n = "Opened";
      break;
    case "closeList":
      n = "Closed";
      break;
    case "openCalendarLink":
      n = "Opened";
      break;
    case "openSingletonLink":
      n = "Opened";
      break;
    case "openSubEventLink":
      n = "Opened";
      break;
    case "openRSVP":
      n = "Opened";
      break;
    case "success":
      n = "Saved";
      break;
    case "successRSVP":
      n = "Saved";
      break;
  }
  const a = t === "openRSVP" || t === "successRSVP" ? "Add-to-Calendar-RSVP" : "Add-to-Calendar-Button";
  (window.dataLayer = window.dataLayer || []).push({
    eventCategory: a,
    eventAction: n,
    eventLabel: e,
    event: t
  });
}
const gB = ["ar", "fa"], Pt = {
  apple: "Apple",
  google: "Google",
  ms365: "Microsoft 365",
  msteams: "Microsoft Teams",
  outlookcom: "Outlook.com",
  yahoo: "Yahoo"
}, W0 = {
  en: {
    "label.addtocalendar": "Add to Calendar",
    ical: "iCal File",
    ...Pt,
    "modal.button.default": "Click me",
    "modal.webview.ical.h": "Open your browser",
    "modal.webview.ical.text": "Unfortunately, in-app browsers have problems with the way we generate the calendar file.",
    "modal.clipboard.text": "We automatically copied a magical URL into your clipboard.",
    "modal.webview.ical.steps": "<ol><li><strong>Open another browser</strong> on your phone, ...</li><li><strong>Paste</strong> the clipboard content and go.</li></ol>",
    "modal.opensafari.ical.h": "Open Safari",
    "modal.opensafari.ical.text": "Unfortunately, iOS has some problems generating and opening the calendar file outside of Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Open Safari</strong>, ...</li><li><strong>Paste</strong> the clipboard content and go.</li></ol>",
    "modal.multidate.h": "This is an event series",
    "modal.multidate.text": "Add the individual events one by one:",
    "date.status.cancelled": "This date got cancelled.",
    "date.status.cancelled.cta": "Please update your calendar!",
    "modal.subscribe.yahoo.h": "Add Calendar to Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Open now the Yahoo Calendar.</li><li>Click the "Actions" tab.</li><li>Hit "Follow Other Calendars".</li><li>Set a name and paste the clipboard content into the url field.</li></ol>',
    "modal.subscribe.yahoo.button": "Open Yahoo Calendar",
    close: "Close",
    continue: "Continue",
    cancel: "Cancel",
    expired: "Expired",
    recurring: "Recurring",
    thankyou: "Thank you",
    submit: "Submit",
    "label.rsvp": "RSVP",
    "label.share.email": "Share via Email",
    "label.share.copy": "Copy Link",
    "label.share.copied": "Copied",
    "label.share.email.subject": "Save this event",
    "form.error.required": "You did not properly fill all required fields",
    "form.error.sending": "There was a problem sending your response. Please try again later",
    "form.success": "Sent successfully!"
  },
  de: {
    "label.addtocalendar": "Im Kalender speichern",
    ical: "iCal-Datei",
    ...Pt,
    "modal.button.default": "Klick mich",
    "modal.webview.ical.h": "Öffne deinen Browser",
    "modal.webview.ical.text": "Leider haben In-App-Browser Probleme mit der Art, wie wir Kalender-Dateien erzeugen.",
    "modal.clipboard.text": "Wir haben automatisch eine magische URL in deine Zwischenablage kopiert.",
    "modal.webview.ical.steps": "<ol><li><strong>Öffne einen anderen Browser</strong> auf deinem Smartphone, ...</li><li>Nutze die <strong>Einfügen</strong>-Funktion, um fortzufahren.</li></ol>",
    "modal.opensafari.ical.h": "Öffne Safari",
    "modal.opensafari.ical.text": "Leider hat iOS einige Probleme beim Generieren und Öffnen der Kalenderdatei außerhalb von Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Öffne Safari</strong>, ...</li><li>Nutze die <strong>Einfügen</strong>-Funktion, um fortzufahren.</li></ol>",
    "modal.multidate.h": "Dies ist eine Termin-Reihe",
    "modal.multidate.text": "Füge die einzelnen Termine der Reihe nach deinem Kalender hinzu:",
    "date.status.cancelled": "Dieser Termin wurde abgesagt.",
    "date.status.cancelled.cta": "Bitte aktualisiere deinen Kalender!",
    "modal.subscribe.yahoo.h": "Kalender zu Yahoo hinzufügen",
    "modal.subscribe.yahoo.text": '<ol><li>Öffne den Yahoo-Kalender.</li><li>Klicke auf den "Aktionen"-Tab.</li><li>Wähle "Weiteren Kalendern folgen".</li><li>Wähle einen Namen und füge die URL aus deiner Zwischenablage in das URL-Feld ein.</li></ol>',
    "modal.subscribe.yahoo.button": "Yahoo-Kalender öffnen",
    close: "Schließen",
    continue: "Weiter",
    cancel: "Abbrechen",
    expired: "Abgelaufen",
    recurring: "Wiederkehrend",
    thankyou: "Danke",
    submit: "Absenden",
    "label.share.email": "Per E-Mail teilen",
    "label.share.copy": "Link kopieren",
    "label.share.copied": "Kopiert",
    "label.share.email.subject": "Merke dir diesen Termin",
    "form.error.required": "Du hast nicht alle erforderlichen Felder korrekt ausgefüllt",
    "form.error.sending": "Es gab ein Problem beim Senden deiner Antwort. Bitte versuche es später noch einmal",
    "form.success": "Erfolgreich gesendet!"
  },
  es: {
    "label.addtocalendar": "Añadir al Calendario",
    ical: "iCal Ficha",
    ...Pt,
    "modal.button.default": "Haz clic mí",
    "modal.webview.ical.h": "Abra su browser",
    "modal.webview.ical.text": "Lamentablemente, los browsers in-app tienen problemas con la forma en que generamos el archivo del calendario.",
    "modal.clipboard.text": "Hemos copiado automáticamente una URL mágica en su portapapeles.",
    "modal.webview.ical.steps": "<ol><li><strong>Abre otro browser</strong> en tu smartphone, ...</li><li>Utilice la función de <strong>pegar</strong> para continuar.</li></ol>",
    "modal.opensafari.ical.h": "Abrir Safari",
    "modal.opensafari.ical.text": "Desafortunadamente, iOS tiene algunos problemas para generar y abrir el archivo de calendario fuera de Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Abrir Safari</strong>, ...</li><li>Utilice la función de <strong>pegar</strong> para continuar.</li></ol>",
    "modal.multidate.h": "Esta es una serie de fechas",
    "modal.multidate.text": "Añada las fechas individuales a su calendario en orden:",
    "date.status.cancelled": "Esta fecha fue cancelada.",
    "date.status.cancelled.cta": "Actualice su calendario!",
    "modal.subscribe.yahoo.h": "Añadir calendario a Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Abra el calendario de Yahoo.</li><li>Haga clic en la pestaña "Acciones".</li><li>Seleccione "Seguir otros calendarios".</li><li>Elige un nombre y pega la URL de tu portapapeles en el campo URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Abrir calendario de Yahoo",
    close: "Ciérralo",
    continue: "Continuar",
    cancel: "Cancelar",
    expired: "Caducada",
    recurring: "Periódica",
    thankyou: "Gracias",
    submit: "Enviar",
    "label.share.email": "Compartir por E-mail",
    "label.share.copy": "Copiar enlace",
    "label.share.copied": "Copiado",
    "label.share.email.subject": "Recuerda esta fecha",
    "form.error.required": "No has completado correctamente todos los campos requeridos",
    "form.error.sending": "Hubo un problema al enviar tu respuesta. Por favor, inténtalo de nuevo más tarde",
    "form.success": "Enviado con éxito!"
  },
  pt: {
    "label.addtocalendar": "Incluir no Calendário",
    ical: "Ficheiro iCal",
    ...Pt,
    "modal.button.default": "Clicar-me",
    "modal.webview.ical.h": "Abra o seu browser",
    "modal.webview.ical.text": "Infelizmente, os navegadores em tampas têm problemas com a forma como geramos o ficheiro de calendário.",
    "modal.clipboard.text": "Copiámos automaticamente um URL mágico para a sua área de transferência.",
    "modal.webview.ical.steps": "<ol><li><strong>Abrir outro browser</strong> en tu smartphone, ...</li><li>Use a função <forte>colar</strong> para continuar.</li></ol>",
    "modal.opensafari.ical.h": "Safari aberto",
    "modal.opensafari.ical.text": "Infelizmente, o iOS tem alguns problemas para gerar e abrir o arquivo de calendário fora do Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Safari aberto</strong>, ...</li><li>Use a função <forte>colar</strong> para continuar.</li></ol>",
    "modal.multidate.h": "Esta é uma série de datas",
    "modal.multidate.text": "Adicione as datas individuais ao seu calendário, por ordem:",
    "date.status.cancelled": "Esta data foi cancelada.",
    "date.status.cancelled.cta": "Actualize o seu calendário!",
    "modal.subscribe.yahoo.h": "Adicionar calendário ao Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Abrir o calendário do Yahoo.</li><li>Clique no separador "Acções".</li><li>Seleccione "Seguir outros calendários".</li><li>Escolha um nome e cole o URL da sua área de transferência no campo URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Abra o Calendário do Yahoo",
    close: "Fechar",
    continue: "Continuar",
    cancel: "Cancelar",
    expired: "Expirada",
    recurring: "Recorrente",
    thankyou: "Obrigado",
    submit: "Enviar",
    "label.share.email": "Compartilhar por e-mail",
    "label.share.copy": "Copiar link",
    "label.share.copied": "Copiado",
    "label.share.email.subject": "Lembre-se desta data",
    "form.error.required": "Você não preencheu todos os campos obrigatórios corretamente",
    "form.error.sending": "Houve um problema ao enviar sua resposta. Por favor, tente novamente mais tarde",
    "form.success": "Enviado com sucesso!"
  },
  fr: {
    "label.addtocalendar": "Ajouter à l'Agenda",
    ical: "Fichier iCal",
    ...Pt,
    "modal.button.default": "Cliquez-moi",
    "modal.webview.ical.h": "Ouvrez votre navigateur",
    "modal.webview.ical.text": "Malheureusement, les navigateurs intégrés aux applications ont des problèmes avec la manière dont nous créons les fichiers de calendrier.",
    "modal.clipboard.text": "Nous avons automatiquement copié une URL magique dans votre presse-papier.",
    "modal.webview.ical.steps": "<ol><li><strong>Ouvrez un autre navigateur</strong> sur votre smartphone ;</li><li><strong>Collez</strong> le contenu du presse-papier et continuez.</li></ol>",
    "modal.opensafari.ical.h": "Ouvrir Safari",
    "modal.opensafari.ical.text": "Malheureusement, iOS rencontre des problèmes pour générer et ouvrir le fichier de calendrier en dehors de Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Ouvrez Safari</strong> ;</li><li><strong>Collez</strong> le contenu du presse-papier et continuez.</li></ol>",
    "modal.multidate.h": "Ceci est une liste d’évènements",
    "modal.multidate.text": "Ajouter les évènements un par un :",
    "date.status.cancelled": "Cet évènement est annulé.",
    "date.status.cancelled.cta": "Actualisez votre agenda !",
    "modal.subscribe.yahoo.h": "Ajouter un agenda à Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Ouvrez l’Agenda Yahoo ;</li><li>Cliquez sur l’onglet « Actions » ;</li><li>Sélectionnez « Suivre d’autres agendas » ;</li><li>Choisissez un nom et collez le contenu de votre presse-papier dans le champ URL.</li></ol>",
    "modal.subscribe.yahoo.button": "Ouvrir le calendrier Yahoo",
    close: "Fermer",
    continue: "Continuer",
    cancel: "Annuler",
    expired: "Expiré",
    recurring: "Récurrent",
    thankyou: "Merci",
    submit: "Envoyer",
    "label.share.email": "Partager par E-mail",
    "label.share.copy": "Copier le lien",
    "label.share.copied": "Copié",
    "label.share.email.subject": "Retenez cette date",
    "form.error.required": "Tu n'as pas correctement rempli tous les champs requis",
    "form.error.sending": "Il y a eu un problème lors de l'envoi de ta réponse. Veuillez réessayer plus tard",
    "form.success": "Envoyé avec succès!"
  },
  nl: {
    "label.addtocalendar": "Opslaan in Agenda",
    ical: "iCal File",
    ...Pt,
    "modal.button.default": "Klik me",
    "modal.webview.ical.h": "Open uw browser",
    "modal.webview.ical.text": "Helaas hebben in-app browsers problemen met de manier waarop wij kalenderbestanden maken.",
    "modal.clipboard.text": "We hebben automatisch een magische URL naar je klembord gekopieerd.",
    "modal.webview.ical.steps": "<ol><li><strong>Open een andere browser</strong> op uw smartphone, ...</li><li>Gebruik de <strong>insert</strong> functie om verder te gaan.</li></ol>",
    "modal.opensafari.ical.h": "Open Safari",
    "modal.opensafari.ical.text": "Helaas heeft iOS enkele problemen met het genereren en openen van het agendabestand buiten Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Open Safari</strong>, ...</li><li>Gebruik de <strong>insert</strong> functie om verder te gaan.</li></ol>",
    "modal.multidate.h": "Dit is een reeks data",
    "modal.multidate.text": "Voeg de afzonderlijke delen één voor één toe:",
    "date.status.cancelled": "Deze datum is geannuleerd.",
    "date.status.cancelled.cta": "Uw agenda bijwerken!",
    "modal.subscribe.yahoo.h": "Toevoegen aan Yahoo",
    "modal.subscribe.yahoo.text": `<ol><li>Open de Yahoo calendar.</li><li>Klik op de "Acties" tab.</li><li>Selecteer "Volg Andere Agenda's".</li><li>Kies een naam en plak de URL van uw klembord in het URL-veld.</li></ol>`,
    "modal.subscribe.yahoo.button": "Open Yahoo Agenda",
    close: "Sluiten",
    continue: "Doorgaan",
    cancel: "Annuleren",
    expired: "Verlopen",
    recurring: "Terugkerend",
    thankyou: "Bedankt",
    submit: "Versturen",
    "label.share.email": "Delen via E-mail",
    "label.share.copy": "Link kopiëren",
    "label.share.copied": "Gekopieerd",
    "label.share.email.subject": "Onthoud deze datum",
    "form.error.required": "Je hebt niet alle vereiste velden correct ingevuld",
    "form.error.sending": "Er was een probleem met het versturen van je antwoord. Probeer het later opnieuw",
    "form.success": "Succesvol verstuurd!"
  },
  tr: {
    "label.addtocalendar": "Takvime Ekle",
    ical: "iCal Dosyası",
    ...Pt,
    "modal.button.default": "Beni tıklayın",
    "modal.webview.ical.h": "Tarayıcınızı açın",
    "modal.webview.ical.text": "Ne yazık ki, uygulama içi tarayıcılar takvim dosyalarını oluşturma şeklimizle ilgili sorunlar yaşıyor.",
    "modal.clipboard.text": "Panonuza otomatik olarak sihirli bir URL kopyaladık.",
    "modal.webview.ical.steps": "<ol><li><strong>Akıllı telefonunuzda başka bir tarayıcı açın</strong>, ...</li><li>Devam etmek için <strong>insert</strong> fonksiyonunu kullanın.</li></ol>",
    "modal.opensafari.ical.h": "Açık Safari",
    "modal.opensafari.ical.text": "Ne yazık ki iOS, takvim dosyasını Safari dışında oluştururken ve açarken bazı sorunlar yaşıyor.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Açık Safari</strong>, ...</li><li>Devam etmek için <strong>insert</strong> fonksiyonunu kullanın.</li></ol>",
    "modal.multidate.h": "Bu bir etkinlik serisidir",
    "modal.multidate.text": "Parçaları teker teker ekleyin:",
    "date.status.cancelled": "Bu tarih iptal edildi.",
    "date.status.cancelled.cta": "Lütfen takviminizi güncelleyin!",
    "modal.subscribe.yahoo.h": "Yahoo'ya takvim ekleme",
    "modal.subscribe.yahoo.text": `<ol><li>Yahoo takvimini açın.</li><li>"Eylemler" sekmesine tıklayın.</li><li>"Diğer Takvimleri Takip Et" öğesini seçin.</li><li>Bir ad seçin ve URL'yi panonuzdan URL alanına yapıştırın.</li></ol>`,
    "modal.subscribe.yahoo.button": "Yahoo Takvimini aç",
    close: "Kapat",
    continue: "Devam etmek",
    cancel: "İptal",
    expired: "Günü geçmiş",
    recurring: "Yinelenen",
    thankyou: "Teşekkürler",
    submit: "Gönder",
    "label.share.email": "E-posta ile Paylaş",
    "label.share.copy": "Bağlantıyı Kopyala",
    "label.share.copied": "Kopyalandı",
    "label.share.email.subject": "Bu Tarihi Unutma",
    "form.error.required": "Gerekli tüm alanları doğru şekilde doldurmadınız",
    "form.error.sending": "Yanıtınızı gönderirken bir sorun oluştu. Lütfen daha sonra tekrar deneyin",
    "form.success": "Başarıyla gönderildi!"
  },
  zh: {
    "label.addtocalendar": "添加到日历",
    ical: "iCal 文件",
    ...Pt,
    "modal.button.default": "点我",
    "modal.webview.ical.h": "打开浏览器",
    "modal.webview.ical.text": "不幸的是，应用内浏览器在我们生成日历文件的方式上存在问题。",
    "modal.clipboard.text": "我们自动将魔术 URL 复制到您的剪贴板。",
    "modal.webview.ical.steps": "<ol><li>打开手机上的任何其他浏览器, ...</li><li>粘贴剪贴板内容并开始。</li></ol>",
    "modal.opensafari.ical.h": "打开 Safari",
    "modal.opensafari.ical.text": "不幸的是，iOS 在 Safari 之外生成和打开日历文件时遇到一些问题。",
    "modal.opensafari.ical.steps": "<ol><li><strong>打开 Safari</strong>, ...</li><li>粘贴剪贴板内容并开始。</li></ol>",
    "modal.multidate.h": "这是一个活动系列",
    "modal.multidate.text": "逐个添加各个部分:",
    "date.status.cancelled": "此日期已取消。",
    "date.status.cancelled.cta": "请更新您的日历!",
    "modal.subscribe.yahoo.h": "将日历添加到 Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>打开 Yahoo 日历。</li><li>点击“操作”标签。</li><li>选择“关注其他日历”。</li><li>选择一个名称并将剪贴板中的 URL 粘贴到 URL 字段中。</li></ol>",
    "modal.subscribe.yahoo.button": "打开雅虎日历",
    close: "关",
    continue: "继续",
    cancel: "中止",
    expired: "已到期",
    recurring: "再次发生的",
    thankyou: "谢谢",
    submit: "提交",
    "label.share.email": "通过电子邮件分享",
    "label.share.copy": "复制链接",
    "label.share.copied": "已复制",
    "label.share.email.subject": "记住这个日期",
    "form.error.required": "你没有正确填写所有必填字段",
    "form.error.sending": "发送你的回复时出现问题。请稍后再试",
    "form.success": "成功发送！"
  },
  ar: {
    "label.addtocalendar": "إضافة إلى التقويم",
    ical: "ملف iCal",
    ...Pt,
    "modal.button.default": "انقر فوق لي",
    "modal.webview.ical.h": "افتح المستعرض الخاص بك",
    "modal.webview.ical.text": "لسوء الحظ ، تواجه المتصفحات داخل التطبيق مشاكل في طريقة إنشاء ملف التقويم.",
    "modal.clipboard.text": "قمنا تلقائيًا بنسخ عنوان URL سحري إلى الحافظة الخاصة بك.",
    "modal.webview.ical.steps": "<ol><li>افتح أي متصفح آخر على هاتفك الذكي, ...</li><li>.الصق محتوى الحافظة واذهب</li></ol>",
    "modal.opensafari.ical.h": "افتح Safari",
    "modal.opensafari.ical.text": "لسوء الحظ ، يواجه iOS بعض المشكلات في إنشاء ملف التقويم وفتحه خارج Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>افتح Safari</strong>, ...</li><li>الصق محتوى الحافظة واذهب.</li></ol>",
    "modal.multidate.h": "هذه سلسلة أحداث",
    "modal.multidate.text": "أضف الأجزاء الفردية واحدة تلو الأخرى:",
    "date.status.cancelled": "تم إلغاء هذا التاريخ.",
    "date.status.cancelled.cta": "الرجاء تحديث التقويم الخاص بك!",
    "modal.subscribe.yahoo.h": "أضف التقويم إلى Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>افتح تقويم Yahoo.</li><li>انقر فوق علامة التبويب "الإجراءات".</li><li>حدد "متابعة تقويمات أخرى".</li><li>اختر اسمًا والصق عنوان URL من الحافظة الخاصة بك في حقل URL.</li></ol>',
    "modal.subscribe.yahoo.button": "افتح تقويم ياهو",
    close: "قريب",
    continue: "استمر",
    cancel: "إحباط",
    expired: "منتهي الصلاحية",
    recurring: "يتكرر",
    thankyou: "شكرا",
    submit: "إرسال",
    "label.share.email": "مشاركة عبر البريد الإلكتروني",
    "label.share.copy": "نسخ الرابط",
    "label.share.copied": "تم النسخ",
    "label.share.email.subject": "تذكر هذا الموعد",
    "form.error.required": "لم تقم بملء جميع الحقول المطلوبة بشكل صحيح",
    "form.error.sending": "حدثت مشكلة أثناء إرسال ردك. الرجاء المحاولة لاحقاً",
    "form.success": "تم الإرسال بنجاح!"
  },
  hi: {
    "label.addtocalendar": "कैलेंडर में जोड़ें",
    ical: "iCal फ़ाइल",
    ...Pt,
    "modal.button.default": "मुझे क्लिक करें",
    "modal.webview.ical.h": "अपना ब्राउज़र खोलें",
    "modal.webview.ical.text": "दुर्भाग्य से, इन-ऐप ब्राउज़र में कैलेंडर फ़ाइल बनाने के तरीके में समस्याएँ हैं।",
    "modal.clipboard.text": "हमने आपके क्लिपबोर्ड पर स्वचालित रूप से एक जादुई URL कॉपी कर लिया है।",
    "modal.webview.ical.steps": "<ol><li>अपने फ़ोन पर <strong>दूसरा ब्राउज़र खोलें</strong>, ...</li><li>क्लिपबोर्ड सामग्री <strong>चिपकाएं</strong> और जाएं।</li></ol>",
    "modal.opensafari.ical.h": "सफारी खोलें",
    "modal.opensafari.ical.text": "दुर्भाग्य से, iOS में सफ़ारी के बाहर कैलेंडर फ़ाइल बनाने और खोलने में कुछ समस्याएँ हैं।",
    "modal.opensafari.ical.steps": "<ol><li><strong>सफारी खोलें</strong>, ...</li><li>क्लिपबोर्ड सामग्री <strong>चिपकाएं</strong> और जाएं।</li></ol>",
    "modal.multidate.h": "यह एक इवेंट सीरीज़ है",
    "modal.multidate.text": "अलग-अलग हिस्सों को एक-एक करके जोड़ें:",
    "date.status.cancelled": "यह तिथि रद्द हो गई।",
    "date.status.cancelled.cta": "कृपया अपना कैलेंडर अपडेट करें!",
    "modal.subscribe.yahoo.h": "Yahoo . में कैलेंडर जोड़ें",
    "modal.subscribe.yahoo.text": '<ol><li>Yahoo कैलेंडर खोलें।</li><li>"कृती" टैब पर क्लिक करें।</li><li>"इतर कॅलेंडर्सचे अनुसरण करा" चुनें।</li><li>एक नाम चुनें और अपने क्लिपबोर्ड से URL को URL फ़ील्ड में पेस्ट करें।</li></ol>',
    "modal.subscribe.yahoo.button": "याहू कैलेंडर खोलें",
    close: "बंद करना",
    continue: "जारी रखें",
    cancel: "रद्द करना",
    expired: "खत्म हो चुका",
    recurring: "पुनरावर्ती",
    thankyou: "धन्यवाद",
    submit: "जमा करें",
    "label.share.email": "ईमेल के माध्यम से साझा करें",
    "label.share.copy": "लिंक कॉपी करें",
    "label.share.copied": "कॉपी हो गया",
    "label.share.email.subject": "इस तारीख को याद रखें",
    "form.error.required": "आपने सभी आवश्यक फ़ील्ड सही ढंग से नहीं भरी हैं",
    "form.error.sending": "आपका जवाब भेजते समय एक समस्या हुई। कृपया बाद में पुनः प्रयास करें",
    "form.success": "सफलतापूर्वक भेजा गया!"
  },
  pl: {
    "label.addtocalendar": "Dodaj do kalendarza",
    ical: "Plik iCal",
    ...Pt,
    "modal.button.default": "Kliknij mnie",
    "modal.webview.ical.h": "Otwórz przeglądarkę",
    "modal.webview.ical.text": "Niestety, przeglądarki in-app mają problemy ze sposobem, w jaki generujemy plik kalendarza.",
    "modal.clipboard.text": "Automatycznie skopiowaliśmy magiczny adres URL do schowka.",
    "modal.webview.ical.steps": "<ol><li><strong>Otwórz inną przeglądarkę</strong> w swoim telefonie, ...</li><li><strong>Wklej</strong> zawartość schowka i ruszaj.</li></ol>",
    "modal.opensafari.ical.h": "Otwórz Safari",
    "modal.opensafari.ical.text": "Niestety iOS ma pewne problemy z generowaniem i otwieraniem pliku kalendarza poza Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Otwórz Safari</strong>, ...</li><li><strong>Wklej</strong> zawartość schowka i ruszaj.</li></ol>",
    "modal.multidate.h": "To jest cykl imprez",
    "modal.multidate.text": "Dodawać po kolei poszczególne części:",
    "date.status.cancelled": "Ta data została odwołana.",
    "date.status.cancelled.cta": "Zaktualizuj swój kalendarz!",
    "modal.subscribe.yahoo.h": "Dodaj kalendarz do Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Otwórz kalendarz Yahoo.</li><li>Kliknij na zakładkę "Czynności".</li><li>Wybierz "Obserwuj inne kalendarze".</li><li>Wybierz nazwę i wklej adres URL ze schowka w polu URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Otwórz kalendarz Yahoo",
    close: "Zamknij",
    continue: "Kontynuować",
    cancel: "Anuluj",
    expired: "Wygasły",
    recurring: "Powtarzający się",
    thankyou: "Dziękuję",
    submit: "Wyślij",
    "label.share.email": "Udostępnij przez e-mail",
    "label.share.copy": "Kopiuj link",
    "label.share.copied": "Skopiowane",
    "label.share.email.subject": "Zapamiętaj tę datę",
    "form.error.required": "Nie wypełniłeś wszystkich wymaganych pól poprawnie",
    "form.error.sending": "Wystąpił problem z wysłaniem twojej odpowiedzi. Spróbuj ponownie później",
    "form.success": "Wysłano pomyślnie!"
  },
  id: {
    "label.addtocalendar": "Tambahkan ke Kalender",
    ical: "File iCal",
    ...Pt,
    "modal.button.default": "Klik saya",
    "modal.webview.ical.h": "Buka browser Anda",
    "modal.webview.ical.text": "Sayangnya, browser dalam aplikasi memiliki masalah dengan cara kami menghasilkan file kalender.",
    "modal.clipboard.text": "Kami telah secara otomatis menyalin URL ajaib ke clipboard Anda.",
    "modal.webview.ical.steps": "<ol><li><strong>Buka peramban lain</strong> pada ponsel Anda, ...</li><li>Tempelkan konten clipboard dan pergi.</li></ol>",
    "modal.opensafari.ical.h": "Buka Safari",
    "modal.opensafari.ical.text": "Sayangnya, iOS memiliki beberapa masalah dalam membuat dan membuka file kalender di luar Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Buka Safari</strong>, ...</li><li>Tempelkan konten clipboard dan pergi.</li></ol>",
    "modal.multidate.h": "Ini adalah rangkaian acara",
    "modal.multidate.text": "Tambahkan masing-masing bagian satu per satu:",
    "date.status.cancelled": "Tanggal ini dibatalkan.",
    "date.status.cancelled.cta": "Perbarui kalender Anda!",
    "modal.subscribe.yahoo.h": "Tambahkan kalender ke Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Buka kalender Yahoo.</li><li>Klik pada tab "Tindakan".</li><li>Pilih "Ikuti Kalender Lain".</li><li>Pilih nama dan tempelkan URL dari clipboard Anda ke bidang URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Buka kalender Yahoo",
    close: "Tutup",
    continue: "Lanjutkan",
    cancel: "Batal",
    expired: "Kedaluwarsa",
    recurring: "Berulang",
    thankyou: "Terima kasih",
    submit: "Kirim",
    "label.share.email": "Bagikan via email",
    "label.share.copy": "Salin tautan",
    "label.share.copied": "Tersalin",
    "label.share.email.subject": "Ingat tanggal ini",
    "form.error.required": "Kamu belum mengisi semua kolom yang diperlukan dengan benar",
    "form.error.sending": "Ada masalah saat mengirim jawabanmu. Coba lagi nanti",
    "form.success": "Berhasil terkirim!"
  },
  no: {
    "label.addtocalendar": "Legg til i kalenderen",
    ical: "iCal-fil",
    ...Pt,
    "modal.button.default": "Klikk på meg",
    "modal.webview.ical.h": "Åpne nettleseren din",
    "modal.webview.ical.text": "Dessverre har nettlesere i appen problemer med måten vi genererer kalenderfilen på.",
    "modal.clipboard.text": "Vi kopierte automatisk en magisk URL til utklippstavlen din.",
    "modal.webview.ical.steps": "<ol><li><strong>Åpne en annen nettleser</strong> på telefonen, ...</li><li><strong>Lim inn</strong> innholdet på utklippstavlen og gå.</li></ol>",
    "modal.opensafari.ical.h": "Åpne Safari",
    "modal.opensafari.ical.text": "Dessverre har iOS noen problemer med å generere og åpne kalenderfilen utenfor Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Åpne Safari</strong>, ...</li><li><strong>Lim inn</strong> innholdet på utklippstavlen og gå.</li></ol>",
    "modal.multidate.h": "Dette er en avtaleserie",
    "modal.multidate.text": "Legg til de enkelte datoene i kalenderen din i rekkefølge:",
    "date.status.cancelled": "Denne datoen ble avlyst.",
    "date.status.cancelled.cta": "Oppdater kalenderen din!",
    "modal.subscribe.yahoo.h": "Legg til kalender til Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Åpne Yahoo-kalenderen.</li><li>Klikk på «Handlinger»-fanen.</li><li>Velg «Følg andre kalendere».</li><li>Velg et navn og lim inn URL-en fra utklippstavlen i URL-feltet.</li></ol>",
    "modal.subscribe.yahoo.button": "Åpne Yahoo-kalenderen",
    close: "Lukk",
    continue: "Fortsette",
    cancel: "Avbryt",
    expired: "Utløpt",
    recurring: "Tilbakevendende",
    thankyou: "Takk",
    submit: "Send inn",
    "label.share.email": "Del via e-post",
    "label.share.copy": "Kopier lenke",
    "label.share.copied": "Kopiert",
    "label.share.email.subject": "Husk denne datoen",
    "form.error.required": "Du har ikke fylt ut alle de nødvendige feltene riktig",
    "form.error.sending": "Det oppsto et problem med å sende svaret ditt. Vennligst prøv igjen senere",
    "form.success": "Sendt suksessfullt!"
  },
  fi: {
    "label.addtocalendar": "Lisää kalenteriin",
    ical: "iCal-tiedosto",
    ...Pt,
    "modal.button.default": "Klikkaa minua",
    "modal.webview.ical.h": "Avaa selain",
    "modal.webview.ical.text": "Valitettavasti sovelluksen sisäisillä selaimilla on ongelmia kalenteritiedoston luomisessa.",
    "modal.clipboard.text": "Olemme automaattisesti kopioineet maagisen URL-osoitteen leikepöydällesi.",
    "modal.webview.ical.steps": "<ol><li><strong>Avaa toinen selain</strong> puhelimessasi., ...</li><li><strong>liitä</strong> leikepöydän sisältö ja lähde.</li></ol>",
    "modal.opensafari.ical.h": "Avaa Safari",
    "modal.opensafari.ical.text": "Valitettavasti iOS:llä on ongelmia kalenteritiedoston luomisessa ja avaamisessa Safarin ulkopuolella.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Avaa Safari</strong>, ...</li><li><strong>liitä</strong> leikepöydän sisältö ja lähde.</li></ol>",
    "modal.multidate.h": "Tämä on tapahtumasarja",
    "modal.multidate.text": "Lisää yksittäiset osat yksi kerrallaan:",
    "date.status.cancelled": "Tämä päivämäärä peruttiin.",
    "date.status.cancelled.cta": "Päivitä kalenterisi!",
    "modal.subscribe.yahoo.h": "Lisää kalenteri Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Avaa Yahoo-kalenteri.</li><li>Napsauta "Toiminnot"-välilehteä.</li><li>Valitse "Seuraa muiden kalentereita".</li><li>Valitse nimi ja liitä URL-osoite leikepöydältäsi URL-kenttään.</li></ol>',
    "modal.subscribe.yahoo.button": "Avaa Yahoo-kalenteri",
    close: "Sulje",
    continue: "Jatkaa",
    cancel: "Peruuta",
    expired: "Vanhentunut",
    recurring: "Toistuva",
    thankyou: "Kiitos",
    submit: "Lähetä",
    "label.share.email": "Jaa sähköpostitse",
    "label.share.copy": "Kopioi linkki",
    "label.share.copied": "Kopioitu",
    "label.share.email.subject": "Muista tämä päivämäärä",
    "form.error.required": "Et täyttänyt kaikkia vaadittuja kenttiä oikein",
    "form.error.sending": "Vastauksen lähettämisessä ilmeni ongelma. Yritä myöhemmin uudelleen",
    "form.success": "Lähetetty onnistuneesti!"
  },
  sv: {
    "label.addtocalendar": "Lägg till i kalender",
    ical: "iCal-fil",
    ...Pt,
    "modal.button.default": "Klicka på mig",
    "modal.webview.ical.h": "Öppna din webbläsare",
    "modal.webview.ical.text": "Tyvärr har webbläsare i appen problem med hur vi genererar kalenderfilen.",
    "modal.clipboard.text": "Vi har automatiskt kopierat en magisk URL till ditt klippblock.",
    "modal.webview.ical.steps": "<ol><li><strong>Öppna en annan webbläsare</strong> på telefonen, ...</li><li><strong>Insätt</strong> innehållet i klippbordet och kör.</li></ol>",
    "modal.opensafari.ical.h": "Öppna Safari",
    "modal.opensafari.ical.text": "Tyvärr har iOS vissa problem med att generera och öppna kalenderfilen utanför Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Öppna Safari</strong>, ...</li><li><strong>Insätt</strong> innehållet i klippbordet och kör.</li></ol>",
    "modal.multidate.h": "Detta är en evenemangsserie",
    "modal.multidate.text": "Lägg till de enskilda delarna en efter en:",
    "date.status.cancelled": "Detta datum har ställts in.",
    "date.status.cancelled.cta": "Uppdatera din kalender!",
    "modal.subscribe.yahoo.h": "Lägg till kalender i Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Öppna Yahoo-kalendern.</li><li>Klicka på fliken "Åtgärder".</li><li>Välj "Följ andra kalendrar".</li><li>Välj ett namn och klistra in URL:en från klippbordet i URL-fältet.</li></ol>',
    "modal.subscribe.yahoo.button": "Öppna Yahoo-kalendern",
    close: "Stäng",
    continue: "Fortsätta",
    cancel: "Avbryt",
    expired: "Utgånget",
    recurring: "Återkommande",
    thankyou: "Tack",
    submit: "Skicka",
    "label.share.email": "Dela via e-post",
    "label.share.copy": "Kopiera länk",
    "label.share.copied": "Kopierat",
    "label.share.email.subject": "Kom ihåg detta datum",
    "form.error.required": "Du har inte fyllt i alla nödvändiga fält korrekt",
    "form.error.sending": "Det uppstod ett problem när ditt svar skickades. Försök igen senare",
    "form.success": "Skickat framgångsrikt!"
  },
  cs: {
    "label.addtocalendar": "Přidat do kalendáře",
    ical: "Soubor iCal",
    ...Pt,
    "modal.button.default": "Klikněte na mě",
    "modal.webview.ical.h": "Otevřete prohlížeč",
    "modal.webview.ical.text": "Prohlížeče v aplikacích mají bohužel problémy se způsobem generování souboru kalendáře.",
    "modal.clipboard.text": "Do schránky jsme automaticky zkopírovali kouzelnou adresu URL.",
    "modal.webview.ical.steps": "<ol><li><strong>Otevření jiného prohlížeče</strong> v telefonu, ...</li><li><strong>Vložte</strong> obsah schránky a přejděte.</li></ol>",
    "modal.opensafari.ical.h": "Otevřít Safari",
    "modal.opensafari.ical.text": "Bohužel má iOS nějaké problémy s generováním a otevíráním souboru kalendáře mimo Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Otevřít Safari</strong>, ...</li><li><strong>Vložte</strong> obsah schránky a přejděte.</li></ol>",
    "modal.multidate.h": "Jedná se o sérii událostí",
    "modal.multidate.text": "Přidávejte jednotlivé díly jeden po druhém:",
    "date.status.cancelled": "Toto datum bylo zrušeno.",
    "date.status.cancelled.cta": "Aktualizujte svůj kalendář!",
    "modal.subscribe.yahoo.h": "Přidat kalendář do Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Otevřete kalendář Yahoo.</li><li>Klikněte na kartu "Akce".</li><li>Vyberte možnost "Sledovat další kalendáře".</li><li>Vyberte název a vložte adresu URL ze schránky do pole URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Otevřete kalendář Yahoo",
    close: "Zavřít",
    continue: "Pokračovat",
    cancel: "Storno",
    expired: "Platnost vypršela",
    recurring: "Opakující se",
    thankyou: "Děkuji",
    submit: "Odeslat",
    "label.share.email": "Sdílet e-mailem",
    "label.share.copy": "Kopírovat odkaz",
    "label.share.copied": "Zkopírováno",
    "label.share.email.subject": "Zapamatuj si tento termín",
    "form.error.required": "Nevyplnil jsi správně všechna požadovaná pole",
    "form.error.sending": "Při odesílání tvé odpovědi došlo k problému. Zkus to prosím později znovu",
    "form.success": "Úspěšně odesláno!"
  },
  ja: {
    "label.addtocalendar": "カレンダーに追加",
    ical: "iCalファイル",
    ...Pt,
    "modal.button.default": "クリックしてください",
    "modal.webview.ical.h": "ブラウザを起動する",
    "modal.webview.ical.text": "残念ながら、アプリ内ブラウザは、カレンダーファイルの生成方法に問題があります。",
    "modal.clipboard.text": "魔法のURLを自動的にクリップボードにコピーしています。",
    "modal.webview.ical.steps": "<ol><li>スマートフォンで別のブラウザを起動する, ...</li><li>クリップボードの内容を貼り付けて行く。</li></ol>",
    "modal.opensafari.ical.h": "オープンSafari",
    "modal.opensafari.ical.text": "残念ながら、iOS では、Safari の外でカレンダー ファイルを生成したり開いたりする際にいくつかの問題があります。",
    "modal.opensafari.ical.steps": "<ol><li><strong>オープンSafari</strong>, ...</li><li>クリップボードの内容を貼り付けて行く。</li></ol>",
    "modal.multidate.h": "イベントシリーズです",
    "modal.multidate.text": "個々のパーツを一つずつ追加していく:",
    "date.status.cancelled": "この日はキャンセルになりました。",
    "date.status.cancelled.cta": "カレンダーを更新する!",
    "modal.subscribe.yahoo.h": "Yahooにカレンダーを追加する",
    "modal.subscribe.yahoo.text": "<ol><li>Yahooカレンダーを開く。</li><li>[実行] タブをクリックします。</li><li>[その他のカレンダーのフォロー] を選択します。</li><li>名前を決めて、クリップボードにあるURLをURL欄に貼り付けます。</li></ol>",
    "modal.subscribe.yahoo.button": "Yahooカレンダーを開く",
    close: "閉じる",
    continue: "続ける",
    cancel: "キャンセル",
    expired: "期限切れ",
    recurring: "繰り返し",
    thankyou: "ありがとう",
    submit: "送信",
    "label.share.email": "メールで共有",
    "label.share.copy": "リンクをコピー",
    "label.share.copied": "コピー済み",
    "label.share.email.subject": "この日付を覚えておいて",
    "form.error.required": "必要なフィールドをすべて正しく入力していません",
    "form.error.sending": "あなたの回答を送信する際に問題が発生しました。後で再試行してください",
    "form.success": "正常に送信されました！"
  },
  it: {
    "label.addtocalendar": "Aggiungi al calendario",
    ical: "File iCal",
    ...Pt,
    "modal.button.default": "Clicca su di me",
    "modal.webview.ical.h": "Aprire il browser",
    "modal.webview.ical.text": "Purtroppo i browser in-app hanno problemi con il modo in cui generiamo il file del calendario.",
    "modal.clipboard.text": "Abbiamo copiato automaticamente un URL magico negli appunti.",
    "modal.webview.ical.steps": "<ol><li><strong>Aprire un altro browser</strong> sul cellulare, ...</li><li><strong>Incollare</strong> il contenuto degli appunti e partire.</li></ol>",
    "modal.opensafari.ical.h": "Aprire Safari",
    "modal.opensafari.ical.text": "Sfortunatamente, iOS ha alcuni problemi nella generazione e nell'apertura del file del calendario al di fuori di Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Aprire Safari</strong>, ...</li><li><strong>Incollare</strong> il contenuto degli appunti e partire.</li></ol>",
    "modal.multidate.h": "Questa è una serie di eventi",
    "modal.multidate.text": "Aggiungere le singole parti una per una:",
    "date.status.cancelled": "La data è stata annullata.",
    "date.status.cancelled.cta": "Aggiornare il calendario!",
    "modal.subscribe.yahoo.h": "Aggiungi il calendario a Yahoo",
    "modal.subscribe.yahoo.text": `<ol><li>Aprire il calendario di Yahoo.</li><li>Fare clic sulla scheda "Azioni".</li><li>Selezionare "Segui altri calendari".</li><li>Scegliere un nome e incollare l'URL dagli appunti nel campo URL.</li></ol>`,
    "modal.subscribe.yahoo.button": "Apri il calendario di Yahoo",
    close: "Chiudere",
    continue: "Continuare",
    cancel: "Annulla",
    expired: "Scaduta",
    recurring: "Ricorrente",
    thankyou: "Grazie",
    submit: "Invia",
    "label.share.email": "Condividi via Email",
    "label.share.copy": "Copia il link",
    "label.share.copied": "Copiato",
    "label.share.email.subject": "Ricorda questa data",
    "form.error.required": "Non hai compilato correttamente tutti i campi richiesti",
    "form.error.sending": "C'è stato un problema nell'invio della tua risposta. Prova di nuovo più tardi",
    "form.success": "Inviato con successo!"
  },
  ko: {
    "label.addtocalendar": "캘린더에 추가",
    ical: "iCal 파일",
    ...Pt,
    "modal.button.default": "클릭 해주세요",
    "modal.webview.ical.h": "브라우저 열기",
    "modal.webview.ical.text": "불행히도 인앱 브라우저는 캘린더 파일을 생성하는 방식에 문제가 있습니다.",
    "modal.clipboard.text": "매직 URL을 클립보드에 자동으로 복사했습니다.",
    "modal.webview.ical.steps": "<ol><li>휴대전화에서 다른 브라우저 열기, ...</li><li>클립보드 내용을 붙여넣고 이동합니다.</li></ol>",
    "modal.opensafari.ical.h": "Safari 열기",
    "modal.opensafari.ical.text": "안타깝게도 iOS에는 Safari 외부에서 캘린더 파일을 생성하고 여는 데 몇 가지 문제가 있습니다.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Safari 열기</strong>, ...</li><li>클립보드 내용을 붙여넣고 이동합니다.</li></ol>",
    "modal.multidate.h": "이벤트 시리즈입니다",
    "modal.multidate.text": "개별 부품을 하나씩 추가:",
    "date.status.cancelled": "이 날짜는 취소되었습니다.",
    "date.status.cancelled.cta": "캘린더를 업데이트하세요!",
    "modal.subscribe.yahoo.h": "Yahoo에 캘린더 추가",
    "modal.subscribe.yahoo.text": '<ol><li>Yahoo 캘린더를 엽니다.</li><li>"동작" 탭을 클릭합니다.</li><li>"다른 일정관리 팔로우"를 선택합니다.</li><li>이름을 선택하고 클립보드의 URL을 URL 필드에 붙여넣습니다.</li></ol>',
    "modal.subscribe.yahoo.button": "야후 캘린더 열기",
    close: "닫다",
    continue: "계속하다",
    cancel: "취소",
    expired: "만료됨",
    recurring: "되풀이",
    thankyou: "감사합니다",
    submit: "제출하기",
    "label.share.email": "이메일로 공유하기",
    "label.share.copy": "링크 복사하기",
    "label.share.copied": "복사됨",
    "label.share.email.subject": "이 날짜를 기억하세요",
    "form.error.required": "필수 필드를 모두 올바르게 채우지 않았습니다",
    "form.error.sending": "응답을 보내는 데 문제가 발생했습니다. 나중에 다시 시도해주세요",
    "form.success": "성공적으로 전송됨!"
  },
  vi: {
    "label.addtocalendar": "Thêm vào Lịch",
    ical: "Tệp iCal",
    ...Pt,
    "modal.button.default": "Nhấp vào đây",
    "modal.webview.ical.h": "Mở trình duyệt của bạn",
    "modal.webview.ical.text": "Rất tiếc, các trình duyệt trong ứng dụng gặp sự cố với cách chúng tôi tạo tệp lịch.",
    "modal.clipboard.text": "Chúng tôi đã tự động sao chép một URL ma thuật vào khay nhớ tạm của bạn.",
    "modal.webview.ical.steps": "<ol><li><strong> Mở trình duyệt khác </strong> trên điện thoại của bạn, ...</li><li><strong> Dán </strong> nội dung khay nhớ tạm và bắt đầu.</li></ol>",
    "modal.opensafari.ical.h": "Mở Safari",
    "modal.opensafari.ical.text": "Rất tiếc, iOS gặp một số sự cố khi tạo và mở tệp lịch bên ngoài Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Mở Safari</strong>, ...</li><li><strong> Dán </strong> nội dung khay nhớ tạm và bắt đầu.</li></ol>",
    "modal.multidate.h": "Đây là một chuỗi sự kiện",
    "modal.multidate.text": "Thêm từng phần riêng lẻ một:",
    "date.status.cancelled": "Ngày này đã bị hủy.",
    "date.status.cancelled.cta": "Cập nhật lịch của bạn!",
    "modal.subscribe.yahoo.h": "Thêm lịch vào Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Mở Lịch Yahoo.</li><li>Nhấp vào tab "Hành động".</li><li>Chọn "Theo dõi các Lịch khác".</li><li>Chọn tên và dán URL từ khay nhớ tạm của bạn vào trường URL.</li></ol>',
    "modal.subscribe.yahoo.button": "Mở lịch Yahoo",
    close: "Đóng",
    continue: "Tiếp tục",
    cancel: "Hủy bỏ",
    expired: "Hết hạn",
    recurring: "Định kỳ",
    thankyou: "Cảm ơn",
    submit: "Gửi",
    "label.share.email": "Chia sẻ qua Email",
    "label.share.copy": "Sao chép liên kết",
    "label.share.copied": "Đã sao chép",
    "label.share.email.subject": "Ghi nhớ ngày này",
    "form.error.required": "Bạn chưa điền đúng tất cả các trường bắt buộc",
    "form.error.sending": "Có sự cố khi gửi phản hồi của bạn. Vui lòng thử lại sau",
    "form.success": "Gửi thành công!"
  },
  ro: {
    "label.addtocalendar": "Adauga In Calendar",
    ical: "Fisier iCal",
    ...Pt,
    "modal.button.default": "Apasa-ma",
    "modal.webview.ical.h": "Deschide browserul",
    "modal.webview.ical.text": "Din pacate, browserele din aplicatie au probleme cu generarea de fisiere pentru calendar.",
    "modal.clipboard.text": "Ti-am copiat automat un URL magic in clipboard",
    "modal.webview.ical.steps": "<ol><li><strong>Deschide un alt browser</strong> pe telefonul tau, ...</li><li><strong>Lipeste</strong> continutul din clipboard si continua.</li></ol>",
    "modal.opensafari.ical.h": "Deschide Safari",
    "modal.opensafari.ical.text": "Din păcate, iOS are unele probleme la generarea și deschiderea fișierului calendar în afara Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Deschides Safari</strong>, ...</li><li><strong>Lipeste</strong> continutul din clipboard si continua.</li></ol>",
    "modal.multidate.h": "Aceasta este o serie de evenimente",
    "modal.multidate.text": "Adauga evenimentele individuale una cate una:",
    "date.status.cancelled": "Aceasta data a fost anulata.",
    "date.status.cancelled.cta": "Te rugam sa-ti updatezi calendarul!",
    "modal.subscribe.yahoo.h": "Adauga Calendar in Yahoo",
    "modal.subscribe.yahoo.text": '<ol><li>Deschide acum calendarul Yahoo.</li><li>Apasa pe tab-ul de "Actiuni".</li><li>Apasa "Urmareste alte calendare".</li><li>Seteaza un nume si lipeste continutul din clipboard in casuta cu url.</li></ol>',
    "modal.subscribe.yahoo.button": "Deschideți calendarul Yahoo",
    close: "Inchide",
    continue: "Continua",
    cancel: "Anuleaza",
    expired: "Expirat",
    recurring: "Recurente",
    thankyou: "Mulțumesc",
    submit: "Trimite",
    "label.share.email": "Distribuie prin e-mail",
    "label.share.copy": "Copiază linkul",
    "label.share.copied": "Copiat",
    "label.share.email.subject": "Ține minte această dată",
    "form.error.required": "Nu ai completat corect toate câmpurile necesare",
    "form.error.sending": "A apărut o problemă la trimiterea răspunsului tău. Încearcă din nou mai târziu",
    "form.success": "Trimis cu succes!"
  },
  fa: {
    "label.addtocalendar": "افزودن به تقویم",
    ical: "پرونده iCal",
    ...Pt,
    "modal.button.default": "اینجا کلیک کنید",
    "modal.webview.ical.h": "مرورگر خود را باز کنید",
    "modal.webview.ical.text": "متاسفانه، مرورگرهای درون برنامه‌ای با نحوه تولید پرونده تقویم مشکل دارند.",
    "modal.clipboard.text": "ما به طور خودکار یک نشانی اینترنتی جادویی را در کلیپ‌بورد شما کپی کردیم.",
    "modal.webview.ical.steps": "<ol><li><strong>مرورگر دیگری را </strong> در گوشی خود باز کنید، ...</li><li>محتوای کلیپ‌بورد را <strong>Paste</strong> کنید و Go را بزنید که آدرس باز شود.</li></ol>",
    "modal.opensafari.ical.h": "سافاری را باز کنید",
    "modal.opensafari.ical.text": "متأسفانه iOS در تولید و باز کردن فایل تقویم خارج از سافاری مشکلاتی دارد.",
    "modal.opensafari.ical.steps": "<ol><li><strong>سافاری را باز کنید</strong>، ...</li><li>محتوای کلیپ‌بورد را <strong>Paste</strong> کنید و Go را بزنید که آدرس باز شود.</li></ol>",
    "modal.multidate.h": "این یک سری رویداد است",
    "modal.multidate.text": "رویدادهای شخصی را یکی یکی اضافه کنید:",
    "date.status.cancelled": "این تاریخ لغو شد",
    "date.status.cancelled.cta": "لطفا تقویم خود را به‌روز کنید!",
    "modal.subscribe.yahoo.h": "افزودن تقویم به یاهو",
    "modal.subscribe.yahoo.text": "<ol><li>اکنون تقویم یاهو را باز کنید.</li><li>روی زبانه «Actions» کلیک کنید.</li><li>روی «Follow Other Calendars» ضربه بزنید.</li><li>یک نام وارد کنید و محتوای کلیپ‌بورد را در قسمت url قرار دهید.</li></ol>",
    "modal.subscribe.yahoo.button": "تقویم یاهو را باز کنید",
    close: "بستن",
    continue: "ادامه دادن",
    cancel: "لغو",
    expired: "منقضی شده",
    thankyou: "ممنون",
    submit: "ارسال",
    "label.share.email": "اشتراک‌گذاری از طریق ایمیل",
    "label.share.copy": "کپی لینک",
    "label.share.copied": "کپی شد",
    "label.share.email.subject": "این تاریخ را به یاد داشته باشید",
    "form.error.required": "شما همه فیلدهای لازم را به درستی پر نکرده‌اید",
    "form.error.sending": "مشکلی در ارسال پاسخ شما وجود داشت. لطفا بعدا دوباره تلاش کنید",
    "form.success": "با موفقیت ارسال شد!"
  },
  et: {
    "label.addtocalendar": "Lisa kalendrisse",
    ical: "iCal fail",
    ...Pt,
    "modal.button.default": "Kliki siia",
    "modal.webview.ical.h": "Ava oma veebilehitseja",
    "modal.webview.ical.text": "Kahjuks on rakendusesisestel veebilehitsejatel probleeme kalendrifailide loomisega.",
    "modal.clipboard.text": "Kalendri veebi aadress on automaatselt kopeeritud sinu lõikelauale.",
    "modal.webview.ical.steps": "<ol><li><strong>Ava teine veebilehitseja</strong> oma telefonis, ...</li><li><strong>Kleebi</strong> lõikelaua sisu ning mine sellele lehele.</li></ol>",
    "modal.opensafari.ical.h": "Ava Safari",
    "modal.opensafari.ical.text": "Kahjuks on iOS-il probleeme kalendrifaili genereerimise ja avamisega väljaspool Safarit.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Ava Safari</strong>, ...</li><li><strong>Kleebi</strong> lõikelaua sisu ning mine sellele lehele.</li></ol>",
    "modal.multidate.h": "See on sündmuste seeria",
    "modal.multidate.text": "Ava üksikud sündmused ükshaaval:",
    "date.status.cancelled": "See kuupäev on tühistatud.",
    "date.status.cancelled.cta": "Palun uuenda oma kalendrit!",
    "modal.subscribe.yahoo.h": "Lisa kalender Yahoo-sse",
    "modal.subscribe.yahoo.text": '<ol><li>Ava oma Yahoo kalender.</li><li>Kliki "Actions" vahelehte.</li><li>Vajuta "Follow Other Calendars".</li><li>Määra nimi ning lisa lõikelaua sisu URL (veebi aadressi) väljale.</li></ol>',
    "modal.subscribe.yahoo.button": "Avage Yahoo kalender",
    close: "Sulge",
    continue: "Jätkama",
    cancel: "Tühista",
    expired: "Aegunud",
    thankyou: "Aitäh",
    submit: "Saada",
    "label.share.email": "Jaga e-posti teel",
    "label.share.copy": "Kopeeri link",
    "label.share.copied": "Kopeeritud",
    "label.share.email.subject": "Pane see kuupäev kirja",
    "form.error.required": "Sa pole kõiki nõutavaid välju korrektselt täitnud",
    "form.error.sending": "Sinu vastuse saatmisel tekkis probleem. Palun proovi hiljem uuesti",
    "form.success": "Edukalt saadetud!"
  },
  uk: {
    "label.addtocalendar": "Додати до календаря",
    ical: "Файл iCal",
    ...Pt,
    "modal.button.default": "Натисни мене",
    "modal.webview.ical.h": "Відкрийте ваш браузер",
    "modal.webview.ical.text": "На жаль, браузери у додатках мають проблеми з обробкою файлу календаря, який ми створюємо.",
    "modal.clipboard.text": "Ми автоматично скопіювали магічний URL у ваш буфер обміну.",
    "modal.webview.ical.steps": "<ol><li><strong>Відкрийте інший браузер</strong> на своєму телефоні, ...</li><li><strong>Вставте</strong> скопійований вміст і перейдіть.</li></ol>",
    "modal.opensafari.ical.h": "Відкрити Safari",
    "modal.opensafari.ical.text": "На жаль, iOS має проблеми з генерацією та відкриттям файлу календаря поза Safari.",
    "modal.opensafari.ical.steps": "<ol><li><strong>Відкрийте Safari</strong>, ...</li><li><strong>Вставте</strong> скопійований вміст і перейдіть.</li></ol>",
    "modal.multidate.h": "Це серія подій",
    "modal.multidate.text": "Додайте окремі події по одній:",
    "date.status.cancelled": "Цю дату скасовано.",
    "date.status.cancelled.cta": "Оновіть свій календар, будь ласка!",
    "modal.subscribe.yahoo.h": "Додати календар до Yahoo",
    "modal.subscribe.yahoo.text": "<ol><li>Відкрийте зараз календар Yahoo.</li><li>Натисніть вкладку «Дії».</li><li>Натисніть «Підписатися на інші календарі».</li><li>Введіть назву та вставте вміст буфера обміну в поле URL.</li></ol>",
    "modal.subscribe.yahoo.button": "Відкрити Yahoo Календар",
    close: "Закрити",
    continue: "Продовжити",
    cancel: "Скасувати",
    expired: "Термін дії закінчився",
    recurring: "Повторюваний",
    thankyou: "Дякуємо",
    submit: "Відправити",
    "label.rsvp": "RSVP",
    "label.share.email": "Поділитися через Email",
    "label.share.copy": "Скопіювати посилання",
    "label.share.copied": "Скопійовано",
    "label.share.email.subject": "Збережіть цю подію",
    "form.error.required": "Ви не заповнили всі обов'язкові поля",
    "form.error.sending": "Сталася проблема з відправленням вашої відповіді. Спробуйте ще раз пізніше.",
    "form.success": "Успішно відправлено!"
  }
}, bB = Object.keys(W0);
function $e(t, e) {
  return e.customLabels && e.customLabels[`${t}`] && e.customLabels[`${t}`] !== "" ? vs(e.customLabels[`${t}`]) : uv(t, e.language);
}
function uv(t, e) {
  return e || (e = "en"), W0[`${e}`][`${t}`] ? W0[`${e}`][`${t}`] : e !== "en" ? uv(t, "en") : t;
}
let G0 = !1, kc = 0;
const al = [], d1 = '<div class="atcb-initialized atcb-hidden"></div>';
if (Ai()) {
  class t extends HTMLElement {
    constructor() {
      super(), this._initialized = new Promise((a) => this._initializedResolver = a);
      const n = document.createElement("template");
      n.innerHTML = d1, this.attachShadow({ mode: "open", delegateFocus: !0 }), this.shadowRoot.append(n.content.cloneNode(!0)), this.state = {
        initializing: !1,
        initialized: !1,
        ready: !1,
        updatePending: !1
      }, this.data = {}, this.error = !1;
    }
    connectedCallback() {
      this.initializing || (this.initializing = !0, setTimeout(() => this.initializeComponent(), 0));
    }
    async initializeComponent() {
      if (this.state.ready)
        return;
      this.state.initializing = !0;
      const n = this.getAttribute("debug");
      if (this.debug = !!(this.hasAttribute("debug") && (!n || n === "true" || n === "")), this.hasAttribute("proOverride") || this.hasAttribute("prooverride")) {
        let a = null;
        this.hasAttribute("proOverride") && this.getAttribute("proOverride") !== "" ? a = this.getAttribute("proOverride") : a = this.getAttribute("prooverride"), this.proOverride = !a || a === "true" || a === "";
      }
      try {
        this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" || this.hasAttribute("prokey") && this.getAttribute("prokey") !== "" ? (this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" ? this.data = await Sc(this.getAttribute("proKey"), this) : this.data = await Sc(this.getAttribute("prokey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : (this.data.proKey = "", this.data = await h1(this, this.debug));
      } catch (a) {
        this.debug && (console.error(a), t0(this.shadowRoot, a)), this.state.initializing = !1, this.state.ready = !0;
        return;
      }
      await this.initButton(), this.state.initializing = !1, this.state.initialized = !0, this.state.ready = !0, this._initializedResolver();
    }
    whenInitialized() {
      return this._initialized;
    }
    disconnectedCallback() {
      f1(this.shadowRoot, this.identifier), this.debug && console.log('Add to Calendar Button "' + this.identifier + '" destroyed'), document.querySelectorAll("add-to-calendar-button").length === 0 && (kc = 0);
    }
    static get observedAttributes() {
      const n = ["instance", "prokey", "proKey", "prooverride", "proOverride"];
      return this.proKey && this.proKey !== "" ? V0.map((a) => a.toLowerCase()).concat(n) : Qc.map((a) => a.toLowerCase()).concat(n);
    }
    attributeChangedCallback(n, a, i) {
      this.state.ready && (this.debug && this.state.initialized && console.log(`${n}'s value has been changed from ${a} to ${i}`), this.updatePending || (this.updatePending = !0, setTimeout(() => this.updateComponent(), 0)));
    }
    async updateComponent() {
      if (!this.updatePending) return;
      this.data = {}, this.shadowRoot.querySelector(".atcb-initialized").remove();
      const n = document.createElement("template");
      n.innerHTML = d1, this.shadowRoot.append(n.content.cloneNode(!0));
      try {
        this.hasAttribute("proKey") && this.getAttribute("proKey") !== "" ? (this.data = await Sc(this.getAttribute("proKey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : this.hasAttribute("prokey") && this.getAttribute("prokey") !== "" ? (this.data = await Sc(this.getAttribute("prokey"), this), this.data.proKey && (this.proKey = this.data.proKey)) : this.data = await h1(this, this.debug);
      } catch (a) {
        this.debug && (console.error(a), t0(this.shadowRoot, a)), this.updatePending = !1;
        return;
      }
      f1(this.shadowRoot, this.identifier), await this.initButton(), this.updatePending = !1;
    }
    async initButton() {
      if (this.state.initialized || (kc = kc + 1), this.identifier && this.identifier !== "")
        this.data.identifier = this.identifier;
      else {
        if (this.data.identifier && this.data.identifier !== "") {
          if (/^[\w-]+$/.test(this.data.identifier))
            this.data.identifier = "atcb-btn-" + this.data.identifier;
          else if (this.data.identifier = "", this.debug) {
            let n = "Add to Calendar Button";
            this.data.rsvp && Object.keys(this.data.rsvp).length > 0 && (n = "RSVP"), console.warn(n + " generation: identifier invalid - using auto numbers instead");
          }
        }
        (this.data.identifier == null || this.data.identifier == "") && (this.data.identifier = "atcb-btn-" + kc), this.identifier = this.data.identifier;
      }
      this.setAttribute("atcb-button-id", this.data.identifier);
      try {
        return this.style.visibility = "visible", this.style.opacity = "1", this.style.position = "relative", this.style.outline = "none !important", await vB(this.shadowRoot, this.data), !0;
      } catch (n) {
        return this.debug && (console.error(n.message ? n.message : n), t0(this.shadowRoot, n)), !1;
      }
    }
  }
  customElements.get("add-to-calendar-button") || customElements.define("add-to-calendar-button", t);
}
async function h1(t, e = !1) {
  let n;
  try {
    n = dv(t), await Jm(n);
  } catch {
    const a = t.innerHTML.trim();
    if (!a)
      throw new Error("Add to Calendar Button generation failed: No data provided.");
    try {
      const i = JSON.parse(bl(a.replace(/(\r\n|\n|\r)/g, ""), !1));
      await Jm(i), n = i;
    } catch (i) {
      throw e && console.error(i), new Error("Add to Calendar Button generation failed: no data provided or missing required fields - see console logs for details");
    }
  }
  return n;
}
function dv(t, e = Qc) {
  let n = {};
  for (let a = 0; a < e.length; a++) {
    let i = e[`${a}`];
    if (t.hasAttribute(`${i}`)) {
      let r = bl(t.getAttribute(`${i}`).replace(/(\\r\\n|\\n|\\r)/g, ""), !1), s;
      if (q0.includes(i))
        s = !r || r === "" || r.toLowerCase() === "true";
      else if (vP.includes(i)) {
        const o = function() {
          return !r || r === "" ? "{}" : r.substring(0, 1) != "{" ? "{" + r + "}" : r;
        }();
        s = JSON.parse(o);
      } else if (yP.includes(i)) {
        const o = function() {
          return !r || r === "" ? "[]" : r.substring(0, 1) != "[" ? "[" + r + "]" : r;
        }();
        s = JSON.parse(o);
      } else if (_P.includes(i)) {
        const o = function() {
          let l = r;
          return (r.includes('"') || r.includes("'")) && (r.includes("[") ? l = r.substring(2, r.length - 2) : l = r.substring(1, r.length - 1)), r.includes("|") || (l = l.replace(/\s/g, "")), l;
        }();
        o.includes("','") ? s = o.split("','") : s = o.split('","');
      } else xP.includes(i) ? s = parseInt(r) : s = r;
      if (typeof s == "object" && Object.keys(s).length === 0 || Array.isArray(s) && (s.length === 0 || s.length === 1 && s[0] === ""))
        continue;
      n[`${i}`] = s;
    }
  }
  return n;
}
async function vB(t, e) {
  try {
    t.host.classList.add("add-to-calendar"), e = await Z2(e), await BP(e);
    const n = t.querySelector(".atcb-initialized");
    return Kh(t, e), n.setAttribute("lang", e.language), fv(t, n, e), yB(e), xB(t, e), _B(e.proKey, e.debug), e.hidden || (typeof fi == "function" && e.rsvp && Object.keys(e.rsvp).length > 0 ? e.inlineRsvp ? await fi(t, e, n) : await QP(t, e) : av(t, n, e), !e.hideRichData && !e.subscribe && e.name && e.dates[0].location && e.dates[0].startDate && aB(e, t.host)), sn("initialization", e.identifier, e.identifier), !e.proKey && e.hideBranding && !document.getElementById("atcb-reference") && gl(document.body, !1, !1, !0), !0;
  } catch (n) {
    throw new Error(n.message);
  }
}
function f1(t, e) {
  nl(t), SB(e);
  const n = document.getElementById("atcb-schema-" + e);
  n && n.remove(), Array.from(t.querySelectorAll(".atcb-debug-error-msg")).concat(Array.from(t.querySelectorAll("style"))).concat(Array.from(t.querySelectorAll("link"))).concat(Array.from(t.querySelectorAll(".atcb-placeholder"))).concat(Array.from(t.querySelectorAll(".atcb-button-wrapper"))).forEach((a) => a.remove()), delete Ft[`${e}`];
}
function Kh(t, e) {
  t.host.classList.remove("atcb-dark", "atcb-light", "atcb-bodyScheme");
  const n = function() {
    return e.lightMode == "bodyScheme" ? document.body.classList.contains("atcb-dark") || document.documentElement.classList.contains("atcb-dark") || document.body.classList.contains("atcp-dark") || document.documentElement.classList.contains("atcp-dark") || document.body.classList.contains("dark") || document.documentElement.classList.contains("dark") ? "dark" : "light" : e.lightMode;
  }();
  t.host.classList.add("atcb-" + n);
}
function hv(t) {
  const e = /[`'"()[\]{}<>\s]/;
  if (!t.host.hasAttribute("cspnonce"))
    return null;
  if (e.test(t.host.getAttribute("cspnonce")))
    throw new Error("cspnonce input contains forbidden characters.");
  return t.host.getAttribute("cspnonce");
}
async function fv(t, e = null, n) {
  const a = hv(t);
  if (!document.getElementById("atcb-global-style")) {
    const l = document.createElement("style");
    l.id = "atcb-global-style";
    const c = window.innerWidth - document.documentElement.clientWidth;
    l.innerText = ".atcb-modal-no-scroll{overflow-y:hidden !important;-webkit-overflow-scrolling:touch;} body.atcb-modal-no-scroll{padding-right:" + c + "px;}.atcb-attribution{display:none;}", a && l.setAttribute("nonce", a), document.head.append(l);
  }
  const i = document.createElement("style"), r = n.inlineRsvp && n.rsvp && Object.keys(n.rsvp).length > 0 ? "100%" : "fit-content";
  i.innerText = `.atcb-initialized { display: block; position: relative; width: ${r}; }.atcb-initialized.atcb-inline { display: inline-block; }.atcb-initialized.atcb-buttons-list { display: flex; flex-wrap: wrap; justify-content: center; gap: var(--buttonslist-gap); }.atcb-hidden { display: none; }`, a && i.setAttribute("nonce", a), t.prepend(i);
  const s = function() {
    return n.styleLight ? ":host{" + bl(n.styleLight.replace(/(\\r\\n|\\n|\\r)/g, ""), !1) + "}" : "";
  }(), o = function() {
    return n.styleDark ? ":host(.atcb-dark){" + bl(n.styleDark.replace(/(\\r\\n|\\n|\\r)/g, ""), !1) + "}" : "";
  }();
  if (n.customCss && n.customCss !== "") {
    const l = document.createElement("link");
    if (l.setAttribute("rel", "stylesheet"), l.setAttribute("type", "text/css"), l.setAttribute("href", n.customCss), a && l.setAttribute("nonce", a), !e)
      await p1(l, t, null, a, null, !1, !1, s + o);
    else {
      const c = document.createElement("div");
      c.classList.add("atcb-placeholder"), t.prepend(c);
      const d = document.createElement("style");
      d.innerText = ".atcb-placeholder { background-color: #777; border-radius: 200px; height: 40px; opacity: .3; width: 150px; }", a && d.setAttribute("nonce", a), t.prepend(d), p1(l, t, e, a, c, n.inline, n.buttonsList, s + o);
    }
    return;
  }
  if (n.buttonStyle !== "none" && Km[`${n.buttonStyle}`]) {
    const l = document.createElement("style");
    a && l.setAttribute("nonce", a), l.innerText = Km[`${n.buttonStyle}`] + s + o, t.prepend(l);
  }
  e && (n.inline ? (e.style.display = "inline-block", e.classList.add("atcb-inline")) : n.buttonsList && e.classList.add("atcb-buttons-list"), e.classList.remove("atcb-hidden"));
}
async function p1(t, e, n = null, a = null, i = null, r = !1, s = !1, o = "") {
  if (o !== "") {
    const l = document.createElement("style");
    l.innerText = o, a && l.setAttribute("nonce", a), e.prepend(l);
  }
  try {
    e.prepend(t), await new Promise((l) => {
      t.onload = l;
    }), n && (i && i.remove(), r ? (n.style.display = "inline-block", n.classList.add("atcb-inline")) : s && n.classList.add("atcb-buttons-list"), n.classList.remove("atcb-hidden"));
  } catch (l) {
    console.log(l);
  }
}
function t0(t, e) {
  if (t.querySelector(".atcb-debug-error-msg")) return;
  const n = hv(t), a = document.createElement("div");
  a.classList.add("atcb-debug-error-msg");
  const i = document.createElement("style");
  i.innerText = ".atcb-debug-error-msg { color: #bf2e2e; font-size: 12px; font-weight: bold; padding: 12px 15px; border: 2px solid #bf2e2e; max-width: 180px; border-radius: 13px; }", n && i.setAttribute("nonce", n), t.prepend(i), a.textContent = e, t.append(a);
}
function yB(t) {
  const e = [];
  for (let n = 0; n < t.options.length; n++) {
    e[t.options[`${n}`]] = [];
    for (let a = 1; a <= t.dates.length; a++)
      t.dates[a - 1].status.toLowerCase() === "cancelled" ? e[t.options[`${n}`]].push(1) : e[t.options[`${n}`]].push(0);
  }
  Ft[t.identifier] = e;
}
function _B(t = "", e = !1) {
  if (!G0) {
    const n = function() {
      return e ? " (version " + X2 + ")" : "";
    }();
    t != "" ? console.log("Add to Calendar PRO script initialized" + n + " | https://add-to-calendar-pro.com") : (console.log(`%c
Add to Calendar Button script initialized` + n + `
see https://add-to-calendar-button.com for details.
`, "font-weight: bold;"), console.log("✨ %cPRO version available at https://add-to-calendar-pro.com ← check it out!", "font-weight: bold; line-height: 60px;")), G0 = !0;
  }
}
async function Sc(t, e = null, n = {}) {
  /*!
   *  @preserve
   *  PER LICENSE AGREEMENT, YOU ARE NOT ALLOWED TO REMOVE OR CHANGE THIS FUNCTION!
   */
  if (t && t !== "")
    try {
      const a = e ? e.proOverride : n.proOverride, i = e ? dv(e, a ? Qc : V0) : n, r = await fetch(`https://${i.dev ? "event-dev.caldn.net" : "event.caldn.net"}/${t}/config.json`);
      if (r.ok) {
        const s = await r.json();
        if (a ? Qc.forEach((o) => {
          Object.prototype.hasOwnProperty.call(i, o) && ["hideBranding", "hidebranding", "ty", "rsvp"].indexOf(o) === -1 && (s[`${o}`] = i[`${o}`]);
        }) : V0.forEach((o) => {
          Object.prototype.hasOwnProperty.call(i, o) && (s[`${o}`] = i[`${o}`]);
        }), i.rsvp && Object.prototype.hasOwnProperty.call(i.rsvp, "none") && delete s.rsvp, !s.name || s.name === "")
          throw new Error("Not possible to read proKey config from server...");
        return s.landingpage.domain && s.landingpage.domain !== "" && Es(s.landingpage.domain) && (s.domain = s.landingpage.domain, delete s.landingpage), s.proKey = t, s.identifier = t, s;
      }
      throw new Error("Not possible to read proKey config from server...");
    } catch {
      throw new Error("Add to Calendar Button proKey invalid or server not responding!");
    }
  return {};
}
function xB(t, e) {
  Ai() && (e.lightMode == "bodyScheme" && (al[e.identifier] = new MutationObserver(function(n) {
    n.forEach((a) => {
      a.attributeName === "class" && Kh(t, e);
    });
  }), al[e.identifier].observe(document.documentElement, { attributes: !0 }), al[e.identifier].observe(document.body, { attributes: !0 })), G0 || (document.addEventListener("keyup", TB), document.addEventListener("keydown", wB), window.addEventListener("resize", kB)));
}
function TB(t) {
  const e = function() {
    const n = document.querySelector('[atcb-button-id="' + Ft.active + '"]');
    return n ? n.shadowRoot : null;
  }();
  e && t.key === "Escape" && (sn("closeList", "Ecs Hit", Ft.active), Sn(e, "close", "", "", !0));
}
function wB(t) {
  const e = function() {
    const n = document.querySelector('[atcb-button-id="' + Ft.active + '"]'), a = document.getElementById(Ft.active + "-modal-host");
    return a ? a.shadowRoot : n ? n.shadowRoot : null;
  }();
  if (e && e.querySelector(".atcb-list") && (t.key === "ArrowDown" || t.key === "ArrowUp" || t.key === "Tab")) {
    t.preventDefault();
    let n = 0, a = e.activeElement;
    const i = e.querySelectorAll(".atcb-list-item").length;
    if (a && a.classList.contains("atcb-list-item"))
      t.key === "ArrowDown" && a.dataset.optionNumber < i ? n = parseInt(a.dataset.optionNumber) + 1 : t.key === "Tab" ? a.dataset.optionNumber < i ? n = parseInt(a.dataset.optionNumber) + 1 : n = 1 : t.key === "ArrowUp" && a.dataset.optionNumber >= 1 && (n = parseInt(a.dataset.optionNumber) - 1), n > 0 && e.querySelector('.atcb-list-item[data-option-number="' + n + '"]').focus();
    else
      switch (t.key) {
        default:
          e.querySelector('.atcb-list-item[data-option-number="1"]').focus();
          break;
        case "ArrowUp":
          e.querySelector('.atcb-list-item[data-option-number="' + i + '"]').focus();
          break;
      }
  }
}
function kB() {
  const t = function() {
    const e = document.querySelector('[atcb-button-id="' + Ft.active + '"]'), n = document.getElementById(Ft.active + "-modal-host");
    return n ? n.shadowRoot : e ? e.shadowRoot : null;
  }();
  if (t) {
    const e = t.querySelector("#atcb-bgoverlay");
    e && (Br(e), Zh(t));
  }
}
function SB(t) {
  typeof al[`${t}`] < "u" && al[`${t}`].disconnect();
}
const CB = {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-share"
};
function pv(t, e) {
  return h(), b("svg", CB, e[0] || (e[0] = [
    k("path", {
      d: "M6.43456 0.734232C6.58458 0.584253 6.78803 0.5 7.00017 0.5C7.2123 0.5 7.41575 0.584253 7.56577 0.734232L9.9658 3.13426C10.1115 3.28514 10.1922 3.48722 10.1903 3.69698C10.1885 3.90674 10.1044 4.1074 9.95605 4.25572C9.80772 4.40405 9.60707 4.48819 9.39731 4.49001C9.18755 4.49183 8.98547 4.4112 8.83459 4.26547L7.80017 3.23106V10.8999C7.80017 11.1121 7.71589 11.3156 7.56586 11.4656C7.41583 11.6157 7.21234 11.6999 7.00017 11.6999C6.78799 11.6999 6.58451 11.6157 6.43447 11.4656C6.28444 11.3156 6.20016 11.1121 6.20016 10.8999V3.23106L5.16575 4.26547C5.01486 4.4112 4.81278 4.49183 4.60302 4.49001C4.39326 4.48819 4.19261 4.40405 4.04428 4.25572C3.89595 4.1074 3.81182 3.90674 3.80999 3.69698C3.80817 3.48722 3.88881 3.28514 4.03453 3.13426L6.43456 0.734232ZM0.600098 7.69991C0.600098 7.27555 0.76867 6.86858 1.06873 6.56852C1.36879 6.26846 1.77576 6.09989 2.20011 6.09989H3.80013C4.01231 6.09989 4.21579 6.18418 4.36582 6.33421C4.51585 6.48424 4.60014 6.68772 4.60014 6.8999C4.60014 7.11207 4.51585 7.31556 4.36582 7.46559C4.21579 7.61562 4.01231 7.69991 3.80013 7.69991H2.20011V14.9H11.8002V7.69991H10.2002C9.98802 7.69991 9.78454 7.61562 9.63451 7.46559C9.48448 7.31556 9.40019 7.11207 9.40019 6.8999C9.40019 6.68772 9.48448 6.48424 9.63451 6.33421C9.78454 6.18418 9.98802 6.09989 10.2002 6.09989H11.8002C12.2246 6.09989 12.6315 6.26846 12.9316 6.56852C13.2317 6.86858 13.4002 7.27555 13.4002 7.69991V14.9C13.4002 15.3243 13.2317 15.7313 12.9316 16.0314C12.6315 16.3314 12.2246 16.5 11.8002 16.5H2.20011C1.77576 16.5 1.36879 16.3314 1.06873 16.0314C0.76867 15.7313 0.600098 15.3243 0.600098 14.9V7.69991Z",
      fill: "#555555",
      class: "svg__fill--medium-grey"
    }, null, -1)
  ]));
}
const mv = { render: pv }, AB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mv,
  render: pv
}, Symbol.toStringTag, { value: "Module" })), EB = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-social_confirm"
};
function gv(t, e) {
  return h(), b("svg", EB, e[0] || (e[0] = [
    k("rect", {
      y: "3.8147e-06",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M9.5 16.7225L12.6849 19.9075L21.5 11.0925",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const bv = { render: gv }, LB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bv,
  render: gv
}, Symbol.toStringTag, { value: "Module" }));
function Gu(t) {
  return Kb() ? (Qb(t), !0) : !1;
}
function Qn(t) {
  return typeof t == "function" ? t() : O(t);
}
const m1 = {
  mounted: "mounted",
  unmounted: "unmounted"
}, Qh = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const DB = Object.prototype.toString, vv = (t) => DB.call(t) === "[object Object]", yi = () => {
}, nu = /* @__PURE__ */ IB();
function IB() {
  var t, e;
  return Qh && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function MB(t) {
  return Zb();
}
function OB(...t) {
  if (t.length !== 1)
    return As(...t);
  const e = t[0];
  return typeof e == "function" ? D4(I4(() => ({ get: e, set: yi }))) : J(e);
}
function PB(t, e = !0, n) {
  MB() ? ht(t, n) : e ? t() : Dn(t);
}
const Xu = Qh ? window : void 0;
function Go(t) {
  var e;
  const n = Qn(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function Fc(...t) {
  let e, n, a, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, a, i] = t, e = Xu) : [e, n, a, i] = t, !e)
    return yi;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], s = () => {
    r.forEach((d) => d()), r.length = 0;
  }, o = (d, f, g, _) => (d.addEventListener(f, g, _), () => d.removeEventListener(f, g, _)), l = at(
    () => [Go(e), Qn(i)],
    ([d, f]) => {
      if (s(), !d)
        return;
      const g = vv(f) ? { ...f } : f;
      r.push(
        ...n.flatMap((_) => a.map((x) => o(d, _, x, g)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), s();
  };
  return Gu(c), c;
}
let g1 = !1;
function BB(t, e, n = {}) {
  const { window: a = Xu, ignore: i = [], capture: r = !0, detectIframe: s = !1 } = n;
  if (!a)
    return yi;
  nu && !g1 && (g1 = !0, Array.from(a.document.body.children).forEach((p) => p.addEventListener("click", yi)), a.document.documentElement.addEventListener("click", yi));
  let o = !0;
  const l = (p) => Qn(i).some((w) => {
    if (typeof w == "string")
      return Array.from(a.document.querySelectorAll(w)).some((C) => C === p.target || p.composedPath().includes(C));
    {
      const C = Go(w);
      return C && (p.target === C || p.composedPath().includes(C));
    }
  });
  function c(p) {
    const w = Qn(p);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function d(p, w) {
    const C = Qn(p), M = C.$.subTree && C.$.subTree.children;
    return M == null || !Array.isArray(M) ? !1 : M.some((A) => A.el === w.target || w.composedPath().includes(A.el));
  }
  const f = (p) => {
    const w = Go(t);
    if (p.target != null && !(!(w instanceof Element) && c(t) && d(t, p)) && !(!w || w === p.target || p.composedPath().includes(w))) {
      if (p.detail === 0 && (o = !l(p)), !o) {
        o = !0;
        return;
      }
      e(p);
    }
  };
  let g = !1;
  const _ = [
    Fc(a, "click", (p) => {
      g || (g = !0, setTimeout(() => {
        g = !1;
      }, 0), f(p));
    }, { passive: !0, capture: r }),
    Fc(a, "pointerdown", (p) => {
      const w = Go(t);
      o = !l(p) && !!(w && !p.composedPath().includes(w));
    }, { passive: !0 }),
    s && Fc(a, "blur", (p) => {
      setTimeout(() => {
        var w;
        const C = Go(t);
        ((w = a.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(C != null && C.contains(a.document.activeElement)) && e(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => _.forEach((p) => p());
}
function RB() {
  const t = J(!1), e = Zb();
  return e && ht(() => {
    t.value = !0;
  }, e), t;
}
function NB(t) {
  const e = RB();
  return I(() => (e.value, !!t()));
}
function $B(t, e = {}) {
  const { window: n = Xu } = e, a = NB(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const r = J(!1), s = (c) => {
    r.value = c.matches;
  }, o = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", s) : i.removeListener(s));
  }, l = Xb(() => {
    a.value && (o(), i = n.matchMedia(Qn(t)), "addEventListener" in i ? i.addEventListener("change", s) : i.addListener(s), r.value = i.matches);
  });
  return Gu(() => {
    l(), o(), i = void 0;
  }), r;
}
function Ei(t = {}) {
  const {
    window: e = Xu,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: r = !0,
    type: s = "inner"
  } = t, o = J(n), l = J(a), c = () => {
    e && (s === "outer" ? (o.value = e.outerWidth, l.value = e.outerHeight) : r ? (o.value = e.innerWidth, l.value = e.innerHeight) : (o.value = e.document.documentElement.clientWidth, l.value = e.document.documentElement.clientHeight));
  };
  if (c(), PB(c), Fc("resize", c, { passive: !0 }), i) {
    const d = $B("(orientation: portrait)");
    at(d, () => c());
  }
  return { width: o, height: l };
}
const yv = Qh ? window : void 0;
function Xo(t) {
  var e;
  const n = Qn(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function zc(...t) {
  let e, n, a, i;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([n, a, i] = t, e = yv) : [e, n, a, i] = t, !e)
    return yi;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], s = () => {
    r.forEach((d) => d()), r.length = 0;
  }, o = (d, f, g, _) => (d.addEventListener(f, g, _), () => d.removeEventListener(f, g, _)), l = at(
    () => [Xo(e), Qn(i)],
    ([d, f]) => {
      if (s(), !d)
        return;
      const g = vv(f) ? { ...f } : f;
      r.push(
        ...n.flatMap((_) => a.map((x) => o(d, _, x, g)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), s();
  };
  return Gu(c), c;
}
let b1 = !1;
function v1(t, e, n = {}) {
  const { window: a = yv, ignore: i = [], capture: r = !0, detectIframe: s = !1 } = n;
  if (!a)
    return yi;
  nu && !b1 && (b1 = !0, Array.from(a.document.body.children).forEach((p) => p.addEventListener("click", yi)), a.document.documentElement.addEventListener("click", yi));
  let o = !0;
  const l = (p) => Qn(i).some((w) => {
    if (typeof w == "string")
      return Array.from(a.document.querySelectorAll(w)).some((C) => C === p.target || p.composedPath().includes(C));
    {
      const C = Xo(w);
      return C && (p.target === C || p.composedPath().includes(C));
    }
  });
  function c(p) {
    const w = Qn(p);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function d(p, w) {
    const C = Qn(p), M = C.$.subTree && C.$.subTree.children;
    return M == null || !Array.isArray(M) ? !1 : M.some((A) => A.el === w.target || w.composedPath().includes(A.el));
  }
  const f = (p) => {
    const w = Xo(t);
    if (p.target != null && !(!(w instanceof Element) && c(t) && d(t, p)) && !(!w || w === p.target || p.composedPath().includes(w))) {
      if (p.detail === 0 && (o = !l(p)), !o) {
        o = !0;
        return;
      }
      e(p);
    }
  };
  let g = !1;
  const _ = [
    zc(a, "click", (p) => {
      g || (g = !0, setTimeout(() => {
        g = !1;
      }, 0), f(p));
    }, { passive: !0, capture: r }),
    zc(a, "pointerdown", (p) => {
      const w = Xo(t);
      o = !l(p) && !!(w && !p.composedPath().includes(w));
    }, { passive: !0 }),
    s && zc(a, "blur", (p) => {
      setTimeout(() => {
        var w;
        const C = Xo(t);
        ((w = a.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(C != null && C.contains(a.document.activeElement)) && e(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => _.forEach((p) => p());
}
const FB = {
  [m1.mounted](t, e) {
    const n = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t.__onClickOutside_stop = v1(t, e.value, { capture: n });
    else {
      const [a, i] = e.value;
      t.__onClickOutside_stop = v1(t, a, Object.assign({ capture: n }, i));
    }
  },
  [m1.unmounted](t) {
    t.__onClickOutside_stop();
  }
};
function n0(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
function _v(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const n = t.parentNode;
    return !n || n.tagName === "BODY" ? !1 : _v(n);
  }
}
function zB(t) {
  const e = t || window.event, n = e.target;
  return _v(n) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const a0 = /* @__PURE__ */ new WeakMap();
function UB(t, e = !1) {
  const n = J(e);
  let a = null, i = "";
  at(OB(t), (o) => {
    const l = n0(Qn(o));
    if (l) {
      const c = l;
      if (a0.get(c) || a0.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const o = n0(Qn(t));
    !o || n.value || (nu && (a = zc(
      o,
      "touchmove",
      (l) => {
        zB(l);
      },
      { passive: !1 }
    )), o.style.overflow = "hidden", n.value = !0);
  }, s = () => {
    const o = n0(Qn(t));
    !o || !n.value || (nu && (a == null || a()), o.style.overflow = i, a0.delete(o), n.value = !1);
  };
  return Gu(s), I({
    get() {
      return n.value;
    },
    set(o) {
      o ? r() : s();
    }
  });
}
function HB() {
  let t = !1;
  const e = J(!1);
  return (n, a) => {
    if (e.value = a.value, t)
      return;
    t = !0;
    const i = UB(n, a.value);
    at(e, (r) => i.value = r);
  };
}
HB();
const YB = {
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-drop-triangle"
};
function jB(t, e) {
  return h(), b("svg", YB, e[0] || (e[0] = [
    k("path", {
      d: "M5 7.5L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 7.5Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const Jh = { render: jB }, VB = { class: "dropdown-wrapper" }, qB = { class: "button-inner-wrapper" }, WB = {
  key: 0,
  class: "button-dropdown-modal"
}, GB = /* @__PURE__ */ Ae({
  __name: "MobileDrawer",
  setup(t) {
    const e = J(!1), n = J(!1), a = I(() => [
      { "is-expanded": e.value }
    ]);
    function i() {
      return e.value = !e.value;
    }
    function r() {
      e.value = !1;
    }
    function s() {
      e.value = !1;
    }
    const o = Ge(), l = I(() => ["mobile-drawer", (o == null ? void 0 : o.value) || "", { "is-expanded": e.value }]);
    return ht(() => {
      const { width: c } = Ei();
      at(c, (d) => {
        n.value = d <= 750;
      }, { immediate: !0 });
    }), (c, d) => (h(), b("div", {
      class: se(l.value)
    }, [
      kt((h(), b("div", VB, [
        k("div", {
          class: se(["dropdown-overlay", a.value])
        }, null, 2),
        k("button", {
          class: se(["mobile-button", a.value]),
          onClick: i
        }, [
          k("span", qB, [
            xe(c.$slots, "buttonLabel", {}, void 0, !0)
          ]),
          k("span", {
            class: se([a.value, "toggle-triangle-icon"])
          }, [
            Q(O(Jh))
          ], 2)
        ], 2),
        e.value ? (h(), b("div", WB, [
          n.value ? (h(), Z(O(Or), {
            key: 0,
            class: "svg-glyph-close",
            onClick: s
          })) : E("", !0),
          k("div", {
            class: se(["button-dropdown-modal-wrapper", a.value])
          }, [
            xe(c.$slots, "dropdownItems", { removeOverlay: s }, void 0, !0)
          ], 2)
        ])) : E("", !0)
      ])), [
        [O(FB), r]
      ])
    ], 2));
  }
}), ef = /* @__PURE__ */ be(GB, [["__scopeId", "data-v-a1a6e280"]]);
function XB(t) {
  return t ? t.replace(/(<([^>]+)>)/ig, "").replace(/[\n]/g, "").replace(/"/ig, "") : "";
}
const ZB = { key: 0 }, KB = ["name", "startDate", "startTime", "endTime", "location", "description", "debug"], QB = {
  key: 0,
  class: "icon-svg"
}, JB = { class: "button-text" }, eR = { key: 0 }, tR = ["href"], nR = { key: 1 }, aR = {
  __name: "ButtonDropdown",
  props: {
    // Event props for Dropdown Calendar
    title: {
      type: String,
      default: ""
    },
    eventDescription: {
      type: String,
      default: ""
    },
    startDateWithTime: {
      type: String,
      default: ""
    },
    endTime: {
      type: String,
      default: ""
    },
    location: {
      type: Array,
      default: () => []
    },
    isEvent: {
      type: Boolean,
      default: !1
    },
    debugModeEnabled: {
      type: Boolean,
      default: !1
    },
    // Dropdown props
    dropdownList: {
      type: Array,
      default: () => []
    },
    buttonTitle: {
      type: String,
      default: ""
    },
    hasIcon: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = $a(), n = J(!1), a = I(() => [
      { "is-link-copied": n.value }
    ]), i = I(() => {
      var p, w;
      const _ = (p = t.location[0]) == null ? void 0 : p.publicUrl, x = (w = t.location[0]) == null ? void 0 : w.title;
      return _ || x || "";
    }), r = I(() => {
      if (t.startDateWithTime) {
        const _ = Nt(new Date(t.startDateWithTime), "yyyy-MM-dd"), x = Nt(new Date(t.startDateWithTime), "HH:mm");
        return { startDate: _, startTime: x };
      }
      return "";
    }), s = I(() => t.endTime ? d(t.endTime) : r.value.startTime), o = I(() => t.eventDescription ? XB(t.eventDescription) : "");
    function l(_) {
      const x = document.createElement("style");
      x.innerHTML = ".atcb-button.atcb-click.atcb-active { border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important; } .atcb-active .atcb-text::after { transform: rotate(180deg); } #atcb-bgoverlay.atcb-click:hover {  cursor: unset; }", _.target.shadowRoot.appendChild(x);
    }
    function c() {
      navigator.clipboard.writeText(e.fullPath), n.value = !0, setTimeout(() => {
        n.value = !1;
      }, 4e3);
    }
    function d(_) {
      const x = /[0-9][0-9]:[0-9][0-9]/;
      return _.match(x)[0];
    }
    const f = Ge(), g = I(() => ["button-dropdown", (f == null ? void 0 : f.value) || ""]);
    return (_, x) => (h(), b("div", {
      class: se(g.value)
    }, [
      t.isEvent ? (h(), b("div", ZB, [
        k("add-to-calendar-button", {
          name: t.title,
          startDate: r.value.startDate,
          startTime: r.value.startTime,
          endTime: s.value,
          timeZone: "America/Los_Angeles",
          location: i.value,
          description: o.value,
          options: "'Google','Apple','Microsoft365','Outlook.com','iCal'",
          trigger: "click",
          hideBranding: "true",
          hideCheckmark: "true",
          hideBackground: "true",
          hideIconButton: "true",
          listStyle: "dropdown-static",
          debug: t.debugModeEnabled,
          onClick: l
        }, null, 8, KB)
      ])) : (h(), Z(ef, { key: 1 }, {
        buttonLabel: ce(() => [
          t.hasIcon ? (h(), b("span", QB, [
            (h(), Z(ut(O(mv)), {
              class: "button-svg",
              "aria-hidden": "true"
            }))
          ])) : E("", !0),
          k("span", JB, ae(t.buttonTitle), 1)
        ]),
        dropdownItems: ce(() => [
          (h(!0), b(me, null, Ee(t.dropdownList, (p) => (h(), b("div", {
            key: p.dropdownItemTitle,
            class: "dropdown-modal-item"
          }, [
            p.dropdownItemTitle === "Email" ? (h(), b("span", eR, [
              k("a", {
                href: `mailto:?&body=${O(e).fullPath}`,
                class: "email-icon"
              }, [
                Q(en, {
                  text: p.dropdownItemTitle,
                  "icon-name": p.iconName,
                  class: "not-smart-link"
                }, null, 8, ["text", "icon-name"])
              ], 8, tR)
            ])) : p.dropdownItemTitle === "Copy Link" ? (h(), b("span", nR, [
              n.value ? (h(), Z(en, {
                key: 1,
                text: "Link Copied!",
                class: se(a.value),
                "icon-name": O(bv)
              }, null, 8, ["class", "icon-name"])) : (h(), Z(en, {
                key: 0,
                text: p.dropdownItemTitle,
                "icon-name": p.iconName,
                class: "not-smart-link",
                onClick: x[0] || (x[0] = (w) => c(O(e).fullPath))
              }, null, 8, ["text", "icon-name"]))
            ])) : (h(), Z(en, {
              key: 2,
              text: p.dropdownItemTitle,
              "icon-name": p.iconName,
              to: `${p.dropdownItemUrl}${O(e).fullPath}`
            }, null, 8, ["text", "icon-name", "to"]))
          ]))), 128))
        ]),
        _: 1
      }))
    ], 2));
  }
}, q0e = /* @__PURE__ */ be(aR, [["__scopeId", "data-v-31080c8c"]]), iR = {
  name: "ButtonMore",
  components: {
    ArrowRight: bi,
    MoleculeStroke: Gh,
    SmartLink: Ke
  },
  props: {
    text: {
      type: String,
      default: "See More"
    },
    to: {
      type: String,
      default: ""
    }
  }
}, rR = {
  class: "icon",
  "aria-hidden": "true"
}, sR = { class: "text" };
function oR(t, e, n, a, i, r) {
  const s = ot("MoleculeStroke"), o = ot("ArrowRight"), l = ot("SmartLink");
  return h(), Z(l, {
    to: n.to,
    class: "button-more"
  }, {
    default: ce(() => [
      k("div", rR, [
        Q(s, { class: "molecule-stroke" }),
        Q(o, { class: "arrow-right" })
      ]),
      k("div", sR, ae(n.text), 1)
    ]),
    _: 1
  }, 8, ["to"]);
}
const tf = /* @__PURE__ */ be(iR, [["render", oR], ["__scopeId", "data-v-0bcf47c2"]]);
function qe(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function pt(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Aa(t, e) {
  const n = qe(t);
  return isNaN(e) ? pt(t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function Ma(t, e) {
  const n = qe(t);
  if (isNaN(e)) return pt(t, NaN);
  if (!e)
    return n;
  const a = n.getDate(), i = pt(t, n.getTime());
  i.setMonth(n.getMonth() + e + 1, 0);
  const r = i.getDate();
  return a >= r ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), n);
}
function xv(t, e) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: l = 0
  } = e, c = qe(t), d = a || n ? Ma(c, a + n * 12) : c, f = r || i ? Aa(d, r + i * 7) : d, g = o + s * 60, x = (l + g * 60) * 1e3;
  return pt(t, f.getTime() + x);
}
function lR(t, e) {
  const n = +qe(t);
  return pt(t, n + e);
}
const Tv = 6048e5, cR = 864e5, uR = 6e4, wv = 36e5, dR = 1e3;
function hR(t, e) {
  return lR(t, e * wv);
}
let fR = {};
function Yr() {
  return fR;
}
function Ra(t, e) {
  var o, l, c, d;
  const n = Yr(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = qe(t), r = i.getDay(), s = (r < a ? 7 : 0) + r - a;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function Ls(t) {
  return Ra(t, { weekStartsOn: 1 });
}
function kv(t) {
  const e = qe(t), n = e.getFullYear(), a = pt(t, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Ls(a), r = pt(t, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const s = Ls(r);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function y1(t) {
  const e = qe(t);
  return e.setHours(0, 0, 0, 0), e;
}
function au(t) {
  const e = qe(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Sv(t, e) {
  const n = y1(t), a = y1(e), i = +n - au(n), r = +a - au(a);
  return Math.round((i - r) / cR);
}
function pR(t) {
  const e = kv(t), n = pt(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), Ls(n);
}
function mR(t, e) {
  const n = e * 3;
  return Ma(t, n);
}
function nf(t, e) {
  return Ma(t, e * 12);
}
function _1(t, e) {
  const n = qe(t), a = qe(e), i = n.getTime() - a.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function Cv(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function il(t) {
  if (!Cv(t) && typeof t != "number")
    return !1;
  const e = qe(t);
  return !isNaN(Number(e));
}
function x1(t) {
  const e = qe(t);
  return Math.trunc(e.getMonth() / 3) + 1;
}
function gR(t, e) {
  const n = qe(t), a = qe(e);
  return n.getFullYear() - a.getFullYear();
}
function bR(t, e) {
  const n = qe(t), a = qe(e), i = _1(n, a), r = Math.abs(gR(n, a));
  n.setFullYear(1584), a.setFullYear(1584);
  const s = _1(n, a) === -i, o = i * (r - +s);
  return o === 0 ? 0 : o;
}
function Av(t, e) {
  const n = qe(t.start), a = qe(t.end);
  let i = +n > +a;
  const r = i ? +n : +a, s = i ? a : n;
  s.setHours(0, 0, 0, 0);
  let o = 1;
  const l = [];
  for (; +s <= r; )
    l.push(qe(s)), s.setDate(s.getDate() + o), s.setHours(0, 0, 0, 0);
  return i ? l.reverse() : l;
}
function Tr(t) {
  const e = qe(t), n = e.getMonth(), a = n - n % 3;
  return e.setMonth(a, 1), e.setHours(0, 0, 0, 0), e;
}
function vR(t, e) {
  const n = qe(t.start), a = qe(t.end);
  let i = +n > +a;
  const r = i ? +Tr(n) : +Tr(a);
  let s = Tr(i ? a : n), o = 1;
  const l = [];
  for (; +s <= r; )
    l.push(qe(s)), s = mR(s, o);
  return i ? l.reverse() : l;
}
function yR(t) {
  const e = qe(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Ev(t) {
  const e = qe(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function yl(t) {
  const e = qe(t), n = pt(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Lv(t, e) {
  var o, l, c, d;
  const n = Yr(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = qe(t), r = i.getDay(), s = (r < a ? -7 : 0) + 6 - (r - a);
  return i.setDate(i.getDate() + s), i.setHours(23, 59, 59, 999), i;
}
function T1(t) {
  const e = qe(t), n = e.getMonth(), a = n - n % 3 + 3;
  return e.setMonth(a, 0), e.setHours(23, 59, 59, 999), e;
}
const _R = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, xR = (t, e, n) => {
  let a;
  const i = _R[t];
  return typeof i == "string" ? a = i : e === 1 ? a = i.one : a = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function i0(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const TR = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, wR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, kR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, SR = {
  date: i0({
    formats: TR,
    defaultWidth: "full"
  }),
  time: i0({
    formats: wR,
    defaultWidth: "full"
  }),
  dateTime: i0({
    formats: kR,
    defaultWidth: "full"
  })
}, CR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, AR = (t, e, n, a) => CR[t];
function No(t) {
  return (e, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (a === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : s;
      i = t.formattingValues[o] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, o = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[o] || t.values[s];
    }
    const r = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[r];
  };
}
const ER = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, LR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, DR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, IR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, MR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, OR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, PR = (t, e) => {
  const n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, BR = {
  ordinalNumber: PR,
  era: No({
    values: ER,
    defaultWidth: "wide"
  }),
  quarter: No({
    values: LR,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: No({
    values: DR,
    defaultWidth: "wide"
  }),
  day: No({
    values: IR,
    defaultWidth: "wide"
  }),
  dayPeriod: No({
    values: MR,
    defaultWidth: "wide",
    formattingValues: OR,
    defaultFormattingWidth: "wide"
  })
};
function $o(t) {
  return (e, n = {}) => {
    const a = n.width, i = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], r = e.match(i);
    if (!r)
      return null;
    const s = r[0], o = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? NR(o, (f) => f.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      RR(o, (f) => f.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const d = e.slice(s.length);
    return { value: c, rest: d };
  };
}
function RR(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function NR(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function $R(t) {
  return (e, n = {}) => {
    const a = e.match(t.matchPattern);
    if (!a) return null;
    const i = a[0], r = e.match(t.parsePattern);
    if (!r) return null;
    let s = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const o = e.slice(i.length);
    return { value: s, rest: o };
  };
}
const FR = /^(\d+)(th|st|nd|rd)?/i, zR = /\d+/i, UR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, HR = {
  any: [/^b/i, /^(a|c)/i]
}, YR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, jR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, VR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, qR = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, WR = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, GR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, XR = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ZR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, KR = {
  ordinalNumber: $R({
    matchPattern: FR,
    parsePattern: zR,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: $o({
    matchPatterns: UR,
    defaultMatchWidth: "wide",
    parsePatterns: HR,
    defaultParseWidth: "any"
  }),
  quarter: $o({
    matchPatterns: YR,
    defaultMatchWidth: "wide",
    parsePatterns: jR,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: $o({
    matchPatterns: VR,
    defaultMatchWidth: "wide",
    parsePatterns: qR,
    defaultParseWidth: "any"
  }),
  day: $o({
    matchPatterns: WR,
    defaultMatchWidth: "wide",
    parsePatterns: GR,
    defaultParseWidth: "any"
  }),
  dayPeriod: $o({
    matchPatterns: XR,
    defaultMatchWidth: "any",
    parsePatterns: ZR,
    defaultParseWidth: "any"
  })
}, Dv = {
  code: "en-US",
  formatDistance: xR,
  formatLong: SR,
  formatRelative: AR,
  localize: BR,
  match: KR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function QR(t) {
  const e = qe(t);
  return Sv(e, yl(e)) + 1;
}
function af(t) {
  const e = qe(t), n = +Ls(e) - +pR(e);
  return Math.round(n / Tv) + 1;
}
function rf(t, e) {
  var d, f, g, _;
  const n = qe(t), a = n.getFullYear(), i = Yr(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((_ = (g = i.locale) == null ? void 0 : g.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, s = pt(t, 0);
  s.setFullYear(a + 1, 0, r), s.setHours(0, 0, 0, 0);
  const o = Ra(s, e), l = pt(t, 0);
  l.setFullYear(a, 0, r), l.setHours(0, 0, 0, 0);
  const c = Ra(l, e);
  return n.getTime() >= o.getTime() ? a + 1 : n.getTime() >= c.getTime() ? a : a - 1;
}
function JR(t, e) {
  var o, l, c, d;
  const n = Yr(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, i = rf(t, e), r = pt(t, 0);
  return r.setFullYear(i, 0, a), r.setHours(0, 0, 0, 0), Ra(r, e);
}
function sf(t, e) {
  const n = qe(t), a = +Ra(n, e) - +JR(n, e);
  return Math.round(a / Tv) + 1;
}
function _t(t, e) {
  const n = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return n + a;
}
const Ri = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
    return _t(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : _t(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return _t(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return _t(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return _t(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return _t(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return _t(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, a = t.getMilliseconds(), i = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return _t(i, e.length);
  }
}, Jr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, w1 = {
  // Era
  G: function(t, e, n) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const a = t.getFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Ri.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, a) {
    const i = rf(t, a), r = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const s = r % 100;
      return _t(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : _t(r, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = kv(t);
    return _t(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return _t(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return _t(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return _t(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ri.M(t, e);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return _t(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, a) {
    const i = sf(t, a);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : _t(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const a = af(t);
    return e === "Io" ? n.ordinalNumber(a, { unit: "week" }) : _t(a, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Ri.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const a = QR(t);
    return e === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : _t(a, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, a) {
    const i = t.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(r);
      case "ee":
        return _t(r, 2);
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, a) {
    const i = t.getDay(), r = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(r);
      case "cc":
        return _t(r, e.length);
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const a = t.getDay(), i = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return _t(i, e.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const a = t.getHours();
    let i;
    switch (a === 12 ? i = Jr.noon : a === 0 ? i = Jr.midnight : i = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const a = t.getHours();
    let i;
    switch (a >= 17 ? i = Jr.evening : a >= 12 ? i = Jr.afternoon : a >= 4 ? i = Jr.morning : i = Jr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return Ri.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Ri.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const a = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : _t(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : _t(a, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Ri.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Ri.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Ri.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return S1(a);
      case "XXXX":
      case "XX":
        return mr(a);
      case "XXXXX":
      case "XXX":
      default:
        return mr(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return S1(a);
      case "xxxx":
      case "xx":
        return mr(a);
      case "xxxxx":
      case "xxx":
      default:
        return mr(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + k1(a, ":");
      case "OOOO":
      default:
        return "GMT" + mr(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + k1(a, ":");
      case "zzzz":
      default:
        return "GMT" + mr(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const a = Math.trunc(t.getTime() / 1e3);
    return _t(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const a = t.getTime();
    return _t(a, e.length);
  }
};
function k1(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), i = Math.trunc(a / 60), r = a % 60;
  return r === 0 ? n + String(i) : n + String(i) + e + _t(r, 2);
}
function S1(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + _t(Math.abs(t) / 60, 2) : mr(t, e);
}
function mr(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), i = _t(Math.trunc(a / 60), 2), r = _t(a % 60, 2);
  return n + i + e + r;
}
const C1 = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Iv = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, eN = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return C1(t, e);
  let r;
  switch (a) {
    case "P":
      r = e.dateTime({ width: "short" });
      break;
    case "PP":
      r = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = e.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", C1(a, e)).replace("{{time}}", Iv(i, e));
}, X0 = {
  p: Iv,
  P: eN
}, tN = /^D+$/, nN = /^Y+$/, aN = ["D", "DD", "YY", "YYYY"];
function Mv(t) {
  return tN.test(t);
}
function Ov(t) {
  return nN.test(t);
}
function Z0(t, e, n) {
  const a = iN(t, e, n);
  if (console.warn(a), aN.includes(t)) throw new RangeError(a);
}
function iN(t, e, n) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const rN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oN = /^'([^]*?)'?$/, lN = /''/g, cN = /[a-zA-Z]/;
function Ja(t, e, n) {
  var d, f, g, _, x, p, w, C;
  const a = Yr(), i = (n == null ? void 0 : n.locale) ?? a.locale ?? Dv, r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((_ = (g = a.locale) == null ? void 0 : g.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((p = (x = n == null ? void 0 : n.locale) == null ? void 0 : x.options) == null ? void 0 : p.weekStartsOn) ?? a.weekStartsOn ?? ((C = (w = a.locale) == null ? void 0 : w.options) == null ? void 0 : C.weekStartsOn) ?? 0, o = qe(t);
  if (!il(o))
    throw new RangeError("Invalid time value");
  let l = e.match(sN).map((M) => {
    const A = M[0];
    if (A === "p" || A === "P") {
      const L = X0[A];
      return L(M, i.formatLong);
    }
    return M;
  }).join("").match(rN).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const A = M[0];
    if (A === "'")
      return { isToken: !1, value: uN(M) };
    if (w1[A])
      return { isToken: !0, value: M };
    if (A.match(cN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + A + "`"
      );
    return { isToken: !1, value: M };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(o, l));
  const c = {
    firstWeekContainsDate: r,
    weekStartsOn: s,
    locale: i
  };
  return l.map((M) => {
    if (!M.isToken) return M.value;
    const A = M.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Ov(A) || !(n != null && n.useAdditionalDayOfYearTokens) && Mv(A)) && Z0(A, e, String(t));
    const L = w1[A[0]];
    return L(o, A, i.localize, c);
  }).join("");
}
function uN(t) {
  const e = t.match(oN);
  return e ? e[1].replace(lN, "'") : t;
}
function dN(t) {
  return qe(t).getDay();
}
function hN(t) {
  const e = qe(t), n = e.getFullYear(), a = e.getMonth(), i = pt(t, 0);
  return i.setFullYear(n, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function fN() {
  return Object.assign({}, Yr());
}
function Ti(t) {
  return qe(t).getHours();
}
function pN(t) {
  let n = qe(t).getDay();
  return n === 0 && (n = 7), n;
}
function Ji(t) {
  return qe(t).getMinutes();
}
function dt(t) {
  return qe(t).getMonth();
}
function Ds(t) {
  return qe(t).getSeconds();
}
function nt(t) {
  return qe(t).getFullYear();
}
function Is(t, e) {
  const n = qe(t), a = qe(e);
  return n.getTime() > a.getTime();
}
function _l(t, e) {
  const n = qe(t), a = qe(e);
  return +n < +a;
}
function ds(t, e) {
  const n = qe(t), a = qe(e);
  return +n == +a;
}
function mN(t, e) {
  const n = e instanceof Date ? pt(e, 0) : new e(0);
  return n.setFullYear(
    t.getFullYear(),
    t.getMonth(),
    t.getDate()
  ), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
const gN = 10;
class Pv {
  constructor() {
    je(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class bN extends Pv {
  constructor(e, n, a, i, r) {
    super(), this.value = e, this.validateValue = n, this.setValue = a, this.priority = i, r && (this.subPriority = r);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, a) {
    return this.setValue(e, n, this.value, a);
  }
}
class vN extends Pv {
  constructor() {
    super(...arguments);
    je(this, "priority", gN);
    je(this, "subPriority", -1);
  }
  set(n, a) {
    return a.timestampIsSet ? n : pt(n, mN(n, Date));
  }
}
let mt = class {
  run(e, n, a, i) {
    const r = this.parse(e, n, a, i);
    return r ? {
      setter: new bN(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(e, n, a) {
    return !0;
  }
};
class yN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 140);
    je(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, a, i) {
    return a.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const tn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, qa = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function nn(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ut(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Wa(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const a = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, r = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (i * wv + r * uR + s * dR),
    rest: e.slice(n[0].length)
  };
}
function Bv(t) {
  return Ut(tn.anyDigitsSigned, t);
}
function Wt(t, e) {
  switch (t) {
    case 1:
      return Ut(tn.singleDigit, e);
    case 2:
      return Ut(tn.twoDigits, e);
    case 3:
      return Ut(tn.threeDigits, e);
    case 4:
      return Ut(tn.fourDigits, e);
    default:
      return Ut(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function iu(t, e) {
  switch (t) {
    case 1:
      return Ut(tn.singleDigitSigned, e);
    case 2:
      return Ut(tn.twoDigitsSigned, e);
    case 3:
      return Ut(tn.threeDigitsSigned, e);
    case 4:
      return Ut(tn.fourDigitsSigned, e);
    default:
      return Ut(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function of(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Rv(t, e) {
  const n = e > 0, a = n ? e : 1 - e;
  let i;
  if (a <= 50)
    i = t || 100;
  else {
    const r = a + 50, s = Math.trunc(r / 100) * 100, o = t >= r % 100;
    i = t + s - (o ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function Nv(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class _N extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 130);
    je(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    const r = (s) => ({
      year: s,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return nn(Wt(4, n), r);
      case "yo":
        return nn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return nn(Wt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i) {
    const r = n.getFullYear();
    if (i.isTwoDigitYear) {
      const o = Rv(
        i.year,
        r
      );
      return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const s = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class xN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 130);
    je(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => ({
      year: s,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return nn(Wt(4, n), r);
      case "Yo":
        return nn(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return nn(Wt(a.length, n), r);
    }
  }
  validate(n, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(n, a, i, r) {
    const s = rf(n, r);
    if (i.isTwoDigitYear) {
      const l = Rv(
        i.year,
        s
      );
      return n.setFullYear(
        l,
        0,
        r.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Ra(n, r);
    }
    const o = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(o, 0, r.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Ra(n, r);
  }
}
class TN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 130);
    je(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a) {
    return iu(a === "R" ? 4 : a.length, n);
  }
  set(n, a, i) {
    const r = pt(n, 0);
    return r.setFullYear(i, 0, 4), r.setHours(0, 0, 0, 0), Ls(r);
  }
}
class wN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 130);
    je(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, a) {
    return iu(a === "u" ? 4 : a.length, n);
  }
  set(n, a, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class kN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 120);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "Q":
      case "QQ":
        return Wt(a.length, n);
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class SN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 120);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "q":
      case "qq":
        return Wt(a.length, n);
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 4;
  }
  set(n, a, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class CN extends mt {
  constructor() {
    super(...arguments);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    je(this, "priority", 110);
  }
  parse(n, a, i) {
    const r = (s) => s - 1;
    switch (a) {
      case "M":
        return nn(
          Ut(tn.month, n),
          r
        );
      case "MM":
        return nn(Wt(2, n), r);
      case "Mo":
        return nn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class AN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 110);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => s - 1;
    switch (a) {
      case "L":
        return nn(
          Ut(tn.month, n),
          r
        );
      case "LL":
        return nn(Wt(2, n), r);
      case "Lo":
        return nn(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function EN(t, e, n) {
  const a = qe(t), i = sf(a, n) - e;
  return a.setDate(a.getDate() - i * 7), a;
}
class LN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 100);
    je(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "w":
        return Ut(tn.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i, r) {
    return Ra(EN(n, i, r), r);
  }
}
function DN(t, e) {
  const n = qe(t), a = af(n) - e;
  return n.setDate(n.getDate() - a * 7), n;
}
class IN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 100);
    je(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "I":
        return Ut(tn.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 53;
  }
  set(n, a, i) {
    return Ls(DN(n, i));
  }
}
const MN = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ON = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class PN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "subPriority", 1);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "d":
        return Ut(tn.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear(), r = Nv(i), s = n.getMonth();
    return r ? a >= 1 && a <= ON[s] : a >= 1 && a <= MN[s];
  }
  set(n, a, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
}
class BN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "subpriority", 1);
    je(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    switch (a) {
      case "D":
      case "DD":
        return Ut(tn.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    const i = n.getFullYear();
    return Nv(i) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(n, a, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
}
function lf(t, e, n) {
  var f, g, _, x;
  const a = Yr(), i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((x = (_ = a.locale) == null ? void 0 : _.options) == null ? void 0 : x.weekStartsOn) ?? 0, r = qe(t), s = r.getDay(), l = (e % 7 + 7) % 7, c = 7 - i, d = e < 0 || e > 6 ? e - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return Aa(r, d);
}
class RN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = lf(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class NN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const s = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (a) {
      case "e":
      case "ee":
        return nn(Wt(a.length, n), s);
      case "eo":
        return nn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = lf(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
class $N extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, a, i, r) {
    const s = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (a) {
      case "c":
      case "cc":
        return nn(Wt(a.length, n), s);
      case "co":
        return nn(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 6;
  }
  set(n, a, i, r) {
    return n = lf(n, i, r), n.setHours(0, 0, 0, 0), n;
  }
}
function FN(t, e) {
  const n = qe(t), a = pN(n), i = e - a;
  return Aa(n, i);
}
class zN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 90);
    je(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, a, i) {
    const r = (s) => s === 0 ? 7 : s;
    switch (a) {
      case "i":
      case "ii":
        return Wt(a.length, n);
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      case "iii":
        return nn(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiii":
        return nn(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiiii":
        return nn(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiii":
      default:
        return nn(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 7;
  }
  set(n, a, i) {
    return n = FN(n, i), n.setHours(0, 0, 0, 0), n;
  }
}
class UN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 80);
    je(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(of(i), 0, 0, 0), n;
  }
}
class HN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 80);
    je(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(of(i), 0, 0, 0), n;
  }
}
class YN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 80);
    je(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, a, i) {
    return n.setHours(of(i), 0, 0, 0), n;
  }
}
class jN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 70);
    je(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "h":
        return Ut(tn.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 12;
  }
  set(n, a, i) {
    const r = n.getHours() >= 12;
    return r && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !r && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class VN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 70);
    je(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "H":
        return Ut(tn.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 23;
  }
  set(n, a, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
}
class qN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 70);
    je(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "K":
        return Ut(tn.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 11;
  }
  set(n, a, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class WN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 70);
    je(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "k":
        return Ut(tn.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 1 && a <= 24;
  }
  set(n, a, i) {
    const r = i <= 24 ? i % 24 : i;
    return n.setHours(r, 0, 0, 0), n;
  }
}
class GN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 60);
    je(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "m":
        return Ut(tn.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setMinutes(i, 0, 0), n;
  }
}
class XN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 50);
    je(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a, i) {
    switch (a) {
      case "s":
        return Ut(tn.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return Wt(a.length, n);
    }
  }
  validate(n, a) {
    return a >= 0 && a <= 59;
  }
  set(n, a, i) {
    return n.setSeconds(i, 0), n;
  }
}
class ZN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 30);
    je(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, a) {
    const i = (r) => Math.trunc(r * Math.pow(10, -a.length + 3));
    return nn(Wt(a.length, n), i);
  }
  set(n, a, i) {
    return n.setMilliseconds(i), n;
  }
}
class KN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 10);
    je(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, a) {
    switch (a) {
      case "X":
        return Wa(
          qa.basicOptionalMinutes,
          n
        );
      case "XX":
        return Wa(qa.basic, n);
      case "XXXX":
        return Wa(
          qa.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Wa(
          qa.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Wa(qa.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : pt(
      n,
      n.getTime() - au(n) - i
    );
  }
}
class QN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 10);
    je(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, a) {
    switch (a) {
      case "x":
        return Wa(
          qa.basicOptionalMinutes,
          n
        );
      case "xx":
        return Wa(qa.basic, n);
      case "xxxx":
        return Wa(
          qa.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Wa(
          qa.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Wa(qa.extended, n);
    }
  }
  set(n, a, i) {
    return a.timestampIsSet ? n : pt(
      n,
      n.getTime() - au(n) - i
    );
  }
}
class JN extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 40);
    je(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Bv(n);
  }
  set(n, a, i) {
    return [pt(n, i * 1e3), { timestampIsSet: !0 }];
  }
}
class e$ extends mt {
  constructor() {
    super(...arguments);
    je(this, "priority", 20);
    je(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Bv(n);
  }
  set(n, a, i) {
    return [pt(n, i), { timestampIsSet: !0 }];
  }
}
const t$ = {
  G: new yN(),
  y: new _N(),
  Y: new xN(),
  R: new TN(),
  u: new wN(),
  Q: new kN(),
  q: new SN(),
  M: new CN(),
  L: new AN(),
  w: new LN(),
  I: new IN(),
  d: new PN(),
  D: new BN(),
  E: new RN(),
  e: new NN(),
  c: new $N(),
  i: new zN(),
  a: new UN(),
  b: new HN(),
  B: new YN(),
  h: new jN(),
  H: new VN(),
  K: new qN(),
  k: new WN(),
  m: new GN(),
  s: new XN(),
  S: new ZN(),
  X: new KN(),
  x: new QN(),
  t: new JN(),
  T: new e$()
}, n$ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, a$ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, i$ = /^'([^]*?)'?$/, r$ = /''/g, s$ = /\S/, o$ = /[a-zA-Z]/;
function K0(t, e, n, a) {
  var p, w, C, M, A, L, D, B;
  const i = fN(), r = (a == null ? void 0 : a.locale) ?? i.locale ?? Dv, s = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((w = (p = a == null ? void 0 : a.locale) == null ? void 0 : p.options) == null ? void 0 : w.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((M = (C = i.locale) == null ? void 0 : C.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((L = (A = a == null ? void 0 : a.locale) == null ? void 0 : A.options) == null ? void 0 : L.weekStartsOn) ?? i.weekStartsOn ?? ((B = (D = i.locale) == null ? void 0 : D.options) == null ? void 0 : B.weekStartsOn) ?? 0;
  if (e === "")
    return t === "" ? qe(n) : pt(n, NaN);
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: r
  }, c = [new vN()], d = e.match(a$).map((P) => {
    const z = P[0];
    if (z in X0) {
      const W = X0[z];
      return W(P, r.formatLong);
    }
    return P;
  }).join("").match(n$), f = [];
  for (let P of d) {
    !(a != null && a.useAdditionalWeekYearTokens) && Ov(P) && Z0(P, e, t), !(a != null && a.useAdditionalDayOfYearTokens) && Mv(P) && Z0(P, e, t);
    const z = P[0], W = t$[z];
    if (W) {
      const { incompatibleTokens: q } = W;
      if (Array.isArray(q)) {
        const re = f.find(
          (ie) => q.includes(ie.token) || ie.token === z
        );
        if (re)
          throw new RangeError(
            `The format string mustn't contain \`${re.fullToken}\` and \`${P}\` at the same time`
          );
      } else if (W.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${P}\` and any other token at the same time`
        );
      f.push({ token: z, fullToken: P });
      const V = W.run(
        t,
        P,
        r.match,
        l
      );
      if (!V)
        return pt(n, NaN);
      c.push(V.setter), t = V.rest;
    } else {
      if (z.match(o$))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + z + "`"
        );
      if (P === "''" ? P = "'" : z === "'" && (P = l$(P)), t.indexOf(P) === 0)
        t = t.slice(P.length);
      else
        return pt(n, NaN);
    }
  }
  if (t.length > 0 && s$.test(t))
    return pt(n, NaN);
  const g = c.map((P) => P.priority).sort((P, z) => z - P).filter((P, z, W) => W.indexOf(P) === z).map(
    (P) => c.filter((z) => z.priority === P).sort((z, W) => W.subPriority - z.subPriority)
  ).map((P) => P[0]);
  let _ = qe(n);
  if (isNaN(_.getTime()))
    return pt(n, NaN);
  const x = {};
  for (const P of g) {
    if (!P.validate(_, l))
      return pt(n, NaN);
    const z = P.set(_, x, l);
    Array.isArray(z) ? (_ = z[0], Object.assign(x, z[1])) : _ = z;
  }
  return pt(n, _);
}
function l$(t) {
  return t.match(i$)[1].replace(r$, "'");
}
function A1(t, e) {
  const n = Tr(t), a = Tr(e);
  return +n == +a;
}
function c$(t, e) {
  return Aa(t, -e);
}
function $v(t, e) {
  const n = qe(t), a = n.getFullYear(), i = n.getDate(), r = pt(t, 0);
  r.setFullYear(a, e, 15), r.setHours(0, 0, 0, 0);
  const s = hN(r);
  return n.setMonth(e, Math.min(i, s)), n;
}
function St(t, e) {
  let n = qe(t);
  return isNaN(+n) ? pt(t, NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = $v(n, e.month)), e.date != null && n.setDate(e.date), e.hours != null && n.setHours(e.hours), e.minutes != null && n.setMinutes(e.minutes), e.seconds != null && n.setSeconds(e.seconds), e.milliseconds != null && n.setMilliseconds(e.milliseconds), n);
}
function u$(t, e) {
  const n = qe(t);
  return n.setHours(e), n;
}
function Fv(t, e) {
  const n = qe(t);
  return n.setMilliseconds(e), n;
}
function d$(t, e) {
  const n = qe(t);
  return n.setMinutes(e), n;
}
function zv(t, e) {
  const n = qe(t);
  return n.setSeconds(e), n;
}
function Ga(t, e) {
  const n = qe(t);
  return isNaN(+n) ? pt(t, NaN) : (n.setFullYear(e), n);
}
function Ms(t, e) {
  return Ma(t, -e);
}
function h$(t, e) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: r = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: l = 0
  } = e, c = Ms(t, a + n * 12), d = c$(c, r + i * 7), f = o + s * 60, _ = (l + f * 60) * 1e3;
  return pt(t, d.getTime() - _);
}
function Uv(t, e) {
  return nf(t, -e);
}
function no() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      k("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      k("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
no.compatConfig = {
  MODE: 3
};
function Hv() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      k("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Hv.compatConfig = {
  MODE: 3
};
function cf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
cf.compatConfig = {
  MODE: 3
};
function uf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
uf.compatConfig = {
  MODE: 3
};
function df() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      k("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
df.compatConfig = {
  MODE: 3
};
function hf() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
hf.compatConfig = {
  MODE: 3
};
function ff() {
  return h(), b(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      k("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
ff.compatConfig = {
  MODE: 3
};
const Jn = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), pf = (t, e, n) => Q0(t, e, n) || De(), f$ = (t, e, n) => {
  const a = e.dateInTz ? Jn(new Date(t), e.dateInTz) : De(t);
  return n ? Hn(a, !0) : a;
}, Q0 = (t, e, n) => {
  if (!t) return null;
  const a = n ? Hn(De(t), !0) : De(t);
  return e ? e.exactMatch ? f$(t, e, n) : Jn(a, e.timezone) : a;
}, p$ = (t) => {
  if (!t) return 0;
  const e = /* @__PURE__ */ new Date(), n = new Date(e.toLocaleString("en-US", { timeZone: "UTC" })), a = new Date(e.toLocaleString("en-US", { timeZone: t })), i = a.getTimezoneOffset() / 60;
  return (+n - +a) / (1e3 * 60 * 60) - i;
};
var Ca = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(Ca || {}), gr = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(gr || {}), Sr = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Sr || {}), Cn = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(Cn || {});
const m$ = ["timestamp", "date", "iso"];
var Bn = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(Bn || {}), zt = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(zt || {});
function E1(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function g$(t) {
  return (e) => Ja(Jn(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const b$ = (t, e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let i;
  if (t !== null)
    try {
      i = a.map(g$(t));
    } catch {
      i = a.map(E1(e));
    }
  else
    i = a.map(E1(e));
  const r = i.slice(0, n), s = i.slice(n + 1, i.length);
  return [i[n]].concat(...s).concat(...r);
}, mf = (t, e, n) => {
  const a = [];
  for (let i = +t[0]; i <= +t[1]; i++)
    a.push({ value: +i, text: qv(i, e) });
  return n ? a.reverse() : a;
}, Yv = (t, e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const s = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${s}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const r = n === "long" ? "LLLL" : "LLL";
      return a.map((s, o) => {
        const l = Ja(Jn(s, "UTC"), r, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const i = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return a.map((r, s) => {
    const o = i.format(r);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: s
    };
  });
}, v$ = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], on = (t) => {
  const e = O(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, y$ = (t) => ({ type: "dot", ...t ?? {} }), jv = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, gf = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, pn = (t) => t, L1 = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, D1 = (t) => t === null, Vv = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, _$ = (t) => {
  const e = [], n = (a) => a.filter((i) => i);
  for (let a = 0; a < t.length; a += 3) {
    const i = [t[a], t[a + 1], t[a + 2]];
    e.push(n(i));
  }
  return e;
}, xl = (t, e, n) => {
  const a = n != null, i = e != null;
  if (!a && !i) return !1;
  const r = +n, s = +e;
  return a && i ? +t > r || +t < s : a ? +t > r : i ? +t < s : !1;
}, Os = (t, e) => _$(t).map((n) => n.map((a) => {
  const { active: i, disabled: r, isBetween: s, highlighted: o } = e(a);
  return {
    ...a,
    active: i,
    disabled: r,
    className: {
      dp__overlay_cell_active: i,
      dp__overlay_cell: !i,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && i,
      dp__cell_in_between: s,
      "dp--highlighted": o
    }
  };
})), Xi = (t, e, n = !1) => {
  t && e.allowStopPropagation && (n && t.stopImmediatePropagation(), t.stopPropagation());
}, x$ = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function T$(t, e) {
  let n = [...document.querySelectorAll(x$())];
  n = n.filter((i) => !t.contains(i) || i.hasAttribute("data-datepicker-instance"));
  const a = n.indexOf(t);
  if (a >= 0 && (e ? a - 1 >= 0 : a + 1 <= n.length))
    return n[a + (e ? -1 : 1)];
}
const w$ = (t, e) => t == null ? void 0 : t.querySelector(`[data-dp-element="${e}"]`), qv = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), bf = (t) => Ja(t, "dd-MM-yyyy"), r0 = (t) => Array.isArray(t), ru = (t, e) => e.get(bf(t)), k$ = (t, e) => t ? e ? e instanceof Map ? !!ru(t, e) : e(De(t)) : !1 : !0, Kn = (t, e, n = !1) => {
  if (t.key === zt.enter || t.key === zt.space)
    return n && t.preventDefault(), e();
}, I1 = (t, e, n, a, i, r) => {
  const s = K0(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: r });
  return il(s) && Cv(s) ? a || i ? s : St(s, {
    hours: +n.hours,
    minutes: +(n == null ? void 0 : n.minutes),
    seconds: +(n == null ? void 0 : n.seconds),
    milliseconds: 0
  }) : null;
}, S$ = (t, e, n, a, i, r) => {
  const s = Array.isArray(n) ? n[0] : n;
  if (typeof e == "string")
    return I1(t, e, s, a, i, r);
  if (Array.isArray(e)) {
    let o = null;
    for (const l of e)
      if (o = I1(t, l, s, a, i, r), o)
        break;
    return o;
  }
  return typeof e == "function" ? e(t) : null;
}, De = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), C$ = (t, e, n) => {
  if (e) {
    const i = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), s = t.getHours().toString().padStart(2, "0"), o = t.getMinutes().toString().padStart(2, "0"), l = n ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${i}-${r}T${s}:${o}:${l}.000Z`;
  }
  const a = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Hn = (t, e) => {
  const n = De(JSON.parse(JSON.stringify(t))), a = St(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? yR(a) : a;
}, Zi = (t, e, n, a) => {
  let i = t ? De(t) : De();
  return (e || e === 0) && (i = u$(i, +e)), (n || n === 0) && (i = d$(i, +n)), (a || a === 0) && (i = zv(i, +a)), Fv(i, 0);
}, Vt = (t, e) => !t || !e ? !1 : _l(Hn(t), Hn(e)), ft = (t, e) => !t || !e ? !1 : ds(Hn(t), Hn(e)), Kt = (t, e) => !t || !e ? !1 : Is(Hn(t), Hn(e)), Zu = (t, e, n) => t != null && t[0] && t != null && t[1] ? Kt(n, t[0]) && Vt(n, t[1]) : t != null && t[0] && e ? Kt(n, t[0]) && Vt(n, e) || Vt(n, t[0]) && Kt(n, e) : !1, Ea = (t) => {
  const e = St(new Date(t), { date: 1 });
  return Hn(e);
}, s0 = (t, e, n) => e && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === e ? [a, n] : [a, isNaN(+t[a]) ? void 0 : +t[a]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Cr = (t) => ({
  hours: Ti(t),
  minutes: Ji(t),
  seconds: Ds(t)
}), Wv = (t, e) => {
  if (e) {
    const n = nt(De(e));
    if (n > t) return 12;
    if (n === t) return dt(De(e));
  }
}, Gv = (t, e) => {
  if (e) {
    const n = nt(De(e));
    return n < t ? -1 : n === t ? dt(De(e)) : void 0;
  }
}, Ps = (t) => {
  if (t) return nt(De(t));
}, Xv = (t, e) => {
  const n = Kt(t, e) ? e : t, a = Kt(e, t) ? e : t;
  return Av({ start: n, end: a });
}, A$ = (t) => {
  const e = Ma(t, 1);
  return { month: dt(e), year: nt(e) };
}, pi = (t, e) => {
  const n = Ra(t, { weekStartsOn: +e }), a = Lv(t, { weekStartsOn: +e });
  return [n, a];
}, Zv = (t, e) => {
  const n = {
    hours: Ti(De()),
    minutes: Ji(De()),
    seconds: e ? Ds(De()) : 0
  };
  return Object.assign(n, t);
}, qi = (t, e, n) => [St(De(t), { date: 1 }), St(De(), { month: e, year: n, date: 1 })], vi = (t, e, n) => {
  let a = t ? De(t) : De();
  return (e || e === 0) && (a = $v(a, e)), n && (a = Ga(a, n)), a;
}, Kv = (t, e, n, a, i) => {
  if (!a || i && !e || !i && !n) return !1;
  const r = i ? Ma(t, 1) : Ms(t, 1), s = [dt(r), nt(r)];
  return i ? !L$(...s, e) : !E$(...s, n);
}, E$ = (t, e, n) => Vt(...qi(n, t, e)) || ft(...qi(n, t, e)), L$ = (t, e, n) => Kt(...qi(n, t, e)) || ft(...qi(n, t, e)), Qv = (t, e, n, a, i, r, s) => {
  if (typeof e == "function" && !s) return e(t);
  const o = n ? { locale: n } : void 0;
  return Array.isArray(t) ? `${Ja(t[0], r, o)}${i && !t[1] ? "" : a}${t[1] ? Ja(t[1], r, o) : ""}` : Ja(t, r, o);
}, es = (t) => {
  if (t) return null;
  throw new Error(gf.prop("partial-range"));
}, Cc = (t, e) => {
  if (e) return t();
  throw new Error(gf.prop("range"));
}, J0 = (t) => Array.isArray(t) ? il(t[0]) && (t[1] ? il(t[1]) : !0) : t ? il(t) : !1, D$ = (t, e) => St(e ?? De(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), o0 = (t, e, n, a) => {
  if (!t) return !0;
  if (a) {
    const i = n === "max" ? _l(t, e) : Is(t, e), r = { seconds: 0, milliseconds: 0 };
    return i || ds(St(t, r), St(e, r));
  }
  return n === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, l0 = (t, e, n) => t ? D$(t, e) : De(n ?? e), M1 = (t, e, n, a, i) => {
  if (Array.isArray(a)) {
    const s = l0(t, a[0], e), o = l0(t, a[1], e);
    return o0(a[0], s, n, !!e) && o0(a[1], o, n, !!e) && i;
  }
  const r = l0(t, a, e);
  return o0(a, r, n, !!e) && i;
}, c0 = (t) => St(De(), Cr(t)), I$ = (t, e) => t instanceof Map ? Array.from(t.values()).filter((n) => nt(De(n)) === e).map((n) => dt(n)) : [], Jv = (t, e, n) => typeof t == "function" ? t({ month: e, year: n }) : !!t.months.find((a) => a.month === e && a.year === n), vf = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), ey = (t) => Ja(t, "yyyy-MM-dd"), Fo = La({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), ty = () => {
  const t = (n) => {
    Fo.menuFocused = n;
  }, e = (n) => {
    Fo.shiftKeyInMenu !== n && (Fo.shiftKeyInMenu = n);
  };
  return {
    control: I(() => ({ shiftKeyInMenu: Fo.shiftKeyInMenu, menuFocused: Fo.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, Lt = La({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), u0 = J(null), Ac = J(!1), d0 = J(!1), h0 = J(!1), f0 = J(!1), kn = J(0), Xt = J(0), rr = () => {
  const t = I(() => Ac.value ? [...Lt.selectionGrid, Lt.actionRow].filter((f) => f.length) : d0.value ? [
    ...Lt.timePicker[0],
    ...Lt.timePicker[1],
    f0.value ? [] : [u0.value],
    Lt.actionRow
  ].filter((f) => f.length) : h0.value ? [...Lt.monthPicker, Lt.actionRow] : [Lt.monthYear, ...Lt.calendar, Lt.time, Lt.actionRow].filter((f) => f.length)), e = (f) => {
    kn.value = f ? kn.value + 1 : kn.value - 1;
    let g = null;
    t.value[Xt.value] && (g = t.value[Xt.value][kn.value]), !g && t.value[Xt.value + (f ? 1 : -1)] ? (Xt.value = Xt.value + (f ? 1 : -1), kn.value = f ? 0 : t.value[Xt.value].length - 1) : g || (kn.value = f ? kn.value - 1 : kn.value + 1);
  }, n = (f) => {
    Xt.value === 0 && !f || Xt.value === t.value.length && f || (Xt.value = f ? Xt.value + 1 : Xt.value - 1, t.value[Xt.value] ? t.value[Xt.value] && !t.value[Xt.value][kn.value] && kn.value !== 0 && (kn.value = t.value[Xt.value].length - 1) : Xt.value = f ? Xt.value - 1 : Xt.value + 1);
  }, a = (f) => {
    let g = null;
    t.value[Xt.value] && (g = t.value[Xt.value][kn.value]), g ? g.focus({ preventScroll: !Ac.value }) : kn.value = f ? kn.value - 1 : kn.value + 1;
  }, i = () => {
    e(!0), a(!0);
  }, r = () => {
    e(!1), a(!1);
  }, s = () => {
    n(!1), a(!0);
  }, o = () => {
    n(!0), a(!0);
  }, l = (f, g) => {
    Lt[g] = f;
  }, c = (f, g) => {
    Lt[g] = f;
  }, d = () => {
    kn.value = 0, Xt.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: c,
    setTimePickerBackRef: (f) => {
      u0.value = f;
    },
    setSelectionGrid: (f) => {
      Ac.value = f, d(), f || (Lt.selectionGrid = []);
    },
    setTimePicker: (f, g = !1) => {
      d0.value = f, f0.value = g, d(), f || (Lt.timePicker[0] = [], Lt.timePicker[1] = []);
    },
    setTimePickerElements: (f, g = 0) => {
      Lt.timePicker[g] = f;
    },
    arrowRight: i,
    arrowLeft: r,
    arrowUp: s,
    arrowDown: o,
    clearArrowNav: () => {
      Lt.monthYear = [], Lt.calendar = [], Lt.time = [], Lt.actionRow = [], Lt.selectionGrid = [], Lt.timePicker[0] = [], Lt.timePicker[1] = [], Ac.value = !1, d0.value = !1, f0.value = !1, h0.value = !1, d(), u0.value = null;
    },
    setMonthPicker: (f) => {
      h0.value = f, d();
    },
    refSets: Lt
    // exposed for testing
  };
}, O1 = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), M$ = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...t ?? {}
}), P1 = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, O$ = (t) => {
  const e = typeof t == "object" && t, n = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...n, count: P1(!1) };
  const a = e ? t : {}, i = e ? a.count ?? !0 : t, r = P1(i);
  return Object.assign(n, a, { count: r });
}, P$ = (t, e, n) => t || (typeof n == "string" ? n : e), B$ = (t) => typeof t == "boolean" ? t ? O1({}) : !1 : O1(t), R$ = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, N$ = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), $$ = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), F$ = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, z$ = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, ...t ?? {} }), U$ = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((n) => De(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, H$ = (t) => typeof t == "object" ? {
  type: (t == null ? void 0 : t.type) ?? "local",
  hideOnOffsetDates: (t == null ? void 0 : t.hideOnOffsetDates) ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, Y$ = (t, e) => typeof t == "object" ? { enabled: !0, ...{
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1
}, ...t } : {
  enabled: t,
  noDisabledRange: e.noDisabledRange,
  showLastInRange: e.showLastInRange,
  minMaxRawRange: e.minMaxRawRange,
  partialRange: e.partialRange,
  disableTimeRangeValidation: e.disableTimeRangeValidation,
  maxRange: e.maxRange,
  minRange: e.minRange,
  autoRange: e.autoRange,
  fixedStart: e.fixedStart,
  fixedEnd: e.fixedEnd
}, j$ = (t, e) => t ? typeof t == "string" ? { timezone: t, exactMatch: !1, dateInTz: void 0, emitTimezone: e, convertModel: !0 } : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: e ?? t.emitTimezone,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: e }, p0 = (t, e, n) => new Map(
  t.map((a) => {
    const i = pf(a, e, n);
    return [bf(i), i];
  })
), V$ = (t, e) => t.length ? new Map(
  t.map((n) => {
    const a = pf(n.date, e);
    return [bf(a), n];
  })
) : null, q$ = (t) => {
  var e;
  return {
    minDate: Q0(t.minDate, t.timezone, t.isSpecific),
    maxDate: Q0(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: r0(t.disabledDates) ? p0(t.disabledDates, t.timezone, t.isSpecific) : t.disabledDates,
    allowedDates: r0(t.allowedDates) ? p0(t.allowedDates, t.timezone, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && r0((e = t.highlight) == null ? void 0 : e.dates) ? p0(t.highlight.dates, t.timezone) : t.highlight,
    markers: V$(t.markers, t.timezone)
  };
}, W$ = (t, e) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: +e } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, G$ = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const n = e, a = t[n], i = typeof t[n] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((r) => [r, !0]));
      return [e, i];
    })
  )
}), jt = (t) => {
  const e = () => {
    const B = t.enableSeconds ? ":ss" : "", P = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${P}${B}` : `hh${P}${B} aa`;
  }, n = () => {
    var B;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((B = w.value) == null ? void 0 : B.type) === "iso" ? "RR" : "ww"}-yyyy` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, a = (B) => Zv(B, t.enableSeconds), i = () => L.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [a(t.startTime[0]), a(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? a(t.startTime) : null, r = I(() => O$(t.multiCalendars)), s = I(() => i()), o = I(() => M$(t.ariaLabels)), l = I(() => N$(t.filters)), c = I(() => B$(t.transitions)), d = I(() => $$(t.actionRow)), f = I(
    () => P$(t.previewFormat, t.format, n())
  ), g = I(() => R$(t.textInput)), _ = I(() => F$(t.inline)), x = I(() => z$(t.config)), p = I(() => U$(t.highlight)), w = I(() => H$(t.weekNumbers)), C = I(() => j$(t.timezone, t.emitTimezone)), M = I(() => W$(t.multiDates, t.multiDatesLimit)), A = I(
    () => q$({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: p.value,
      markers: t.markers,
      timezone: C.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker
    })
  ), L = I(
    () => Y$(t.range, {
      minMaxRawRange: !1,
      maxRange: t.maxRange,
      minRange: t.minRange,
      noDisabledRange: t.noDisabledRange,
      showLastInRange: t.showLastInRange,
      partialRange: t.partialRange,
      disableTimeRangeValidation: t.disableTimeRangeValidation,
      autoRange: t.autoRange,
      fixedStart: t.fixedStart,
      fixedEnd: t.fixedEnd
    })
  ), D = I(() => G$(t.ui));
  return {
    defaultedTransitions: c,
    defaultedMultiCalendars: r,
    defaultedStartTime: s,
    defaultedAriaLabels: o,
    defaultedFilters: l,
    defaultedActionRow: d,
    defaultedPreviewFormat: f,
    defaultedTextInput: g,
    defaultedInline: _,
    defaultedConfig: x,
    defaultedHighlight: p,
    defaultedWeekNumbers: w,
    defaultedRange: L,
    propDates: A,
    defaultedTz: C,
    defaultedMultiDates: M,
    defaultedUI: D,
    getDefaultPattern: n,
    getDefaultStartTime: i
  };
}, X$ = (t, e, n) => {
  const a = J(), { defaultedTextInput: i, defaultedRange: r, defaultedTz: s, defaultedMultiDates: o, getDefaultPattern: l } = jt(e), c = J(""), d = As(e, "format"), f = As(e, "formatLocale");
  at(
    a,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", a.value, Ne(!0));
    },
    { deep: !0 }
  ), at(r, (ee, ze) => {
    ee.enabled !== ze.enabled && (a.value = null);
  }), at(d, () => {
    de();
  });
  const g = (ee) => s.value.timezone && s.value.convertModel ? Jn(ee, s.value.timezone) : ee, _ = (ee) => {
    if (s.value.timezone && s.value.convertModel) {
      const ze = p$(s.value.timezone);
      return hR(ee, ze);
    }
    return ee;
  }, x = (ee, ze, et = !1) => Qv(
    ee,
    e.format,
    e.formatLocale,
    i.value.rangeSeparator,
    e.modelAuto,
    ze ?? l(),
    et
  ), p = (ee) => ee ? e.modelType ? Ie(ee) : {
    hours: Ti(ee),
    minutes: Ji(ee),
    seconds: e.enableSeconds ? Ds(ee) : 0
  } : null, w = (ee) => e.modelType ? Ie(ee) : { month: dt(ee), year: nt(ee) }, C = (ee) => Array.isArray(ee) ? o.value.enabled ? ee.map((ze) => M(ze, Ga(De(), ze))) : Cc(
    () => [
      Ga(De(), ee[0]),
      ee[1] ? Ga(De(), ee[1]) : es(r.value.partialRange)
    ],
    r.value.enabled
  ) : Ga(De(), +ee), M = (ee, ze) => (typeof ee == "string" || typeof ee == "number") && e.modelType ? Le(ee) : ze, A = (ee) => Array.isArray(ee) ? [
    M(
      ee[0],
      Zi(null, +ee[0].hours, +ee[0].minutes, ee[0].seconds)
    ),
    M(
      ee[1],
      Zi(null, +ee[1].hours, +ee[1].minutes, ee[1].seconds)
    )
  ] : M(ee, Zi(null, ee.hours, ee.minutes, ee.seconds)), L = (ee) => {
    const ze = St(De(), { date: 1 });
    return Array.isArray(ee) ? o.value.enabled ? ee.map((et) => M(et, vi(ze, +et.month, +et.year))) : Cc(
      () => [
        M(ee[0], vi(ze, +ee[0].month, +ee[0].year)),
        M(
          ee[1],
          ee[1] ? vi(ze, +ee[1].month, +ee[1].year) : es(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : M(ee, vi(ze, +ee.month, +ee.year));
  }, D = (ee) => {
    if (Array.isArray(ee))
      return ee.map((ze) => Le(ze));
    throw new Error(gf.dateArr("multi-dates"));
  }, B = (ee) => {
    if (Array.isArray(ee) && r.value.enabled) {
      const ze = ee[0], et = ee[1];
      return [
        De(Array.isArray(ze) ? ze[0] : null),
        De(Array.isArray(et) ? et[0] : null)
      ];
    }
    return De(ee[0]);
  }, P = (ee) => e.modelAuto ? Array.isArray(ee) ? [Le(ee[0]), Le(ee[1])] : e.autoApply ? [Le(ee)] : [Le(ee), null] : Array.isArray(ee) ? Cc(
    () => ee[1] ? [
      Le(ee[0]),
      ee[1] ? Le(ee[1]) : es(r.value.partialRange)
    ] : [Le(ee[0])],
    r.value.enabled
  ) : Le(ee), z = () => {
    Array.isArray(a.value) && r.value.enabled && a.value.length === 1 && a.value.push(es(r.value.partialRange));
  }, W = () => {
    const ee = a.value;
    return [
      Ie(ee[0]),
      ee[1] ? Ie(ee[1]) : es(r.value.partialRange)
    ];
  }, q = () => a.value[1] ? W() : Ie(pn(a.value[0])), V = () => (a.value || []).map((ee) => Ie(ee)), re = (ee = !1) => (ee || z(), e.modelAuto ? q() : o.value.enabled ? V() : Array.isArray(a.value) ? Cc(() => W(), r.value.enabled) : Ie(pn(a.value))), ie = (ee) => !ee || Array.isArray(ee) && !ee.length ? null : e.timePicker ? A(pn(ee)) : e.monthPicker ? L(pn(ee)) : e.yearPicker ? C(pn(ee)) : o.value.enabled ? D(pn(ee)) : e.weekPicker ? B(pn(ee)) : P(pn(ee)), K = (ee) => {
    const ze = ie(ee);
    J0(pn(ze)) ? (a.value = pn(ze), de()) : (a.value = null, c.value = "");
  }, $ = () => {
    const ee = (ze) => Ja(ze, i.value.format);
    return `${ee(a.value[0])} ${i.value.rangeSeparator} ${a.value[1] ? ee(a.value[1]) : ""}`;
  }, X = () => n.value && a.value ? Array.isArray(a.value) ? $() : Ja(a.value, i.value.format) : x(a.value), R = () => a.value ? o.value.enabled ? a.value.map((ee) => x(ee)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? X() : x(a.value) : "", de = () => {
    !e.format || typeof e.format == "string" || i.value.enabled && typeof i.value.format == "string" ? c.value = R() : c.value = e.format(a.value);
  }, Le = (ee) => {
    if (e.utc) {
      const ze = new Date(ee);
      return e.utc === "preserve" ? new Date(ze.getTime() + ze.getTimezoneOffset() * 6e4) : ze;
    }
    return e.modelType ? m$.includes(e.modelType) ? g(new Date(ee)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? g(
      K0(ee, l(), /* @__PURE__ */ new Date(), { locale: f.value })
    ) : g(
      K0(ee, e.modelType, /* @__PURE__ */ new Date(), { locale: f.value })
    ) : g(new Date(ee));
  }, Ie = (ee) => ee ? e.utc ? C$(ee, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +_(ee) : e.modelType === "iso" ? _(ee).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? x(_(ee)) : x(_(ee), e.modelType, !0) : _(ee) : "", Ve = (ee, ze = !1, et = !1) => {
    if (et) return ee;
    if (t("update:model-value", ee), s.value.emitTimezone && ze) {
      const Te = Array.isArray(ee) ? ee.map((Qe) => Jn(pn(Qe), s.value.emitTimezone)) : Jn(pn(ee), s.value.emitTimezone);
      t("update:model-timezone-value", Te);
    }
  }, te = (ee) => Array.isArray(a.value) ? o.value.enabled ? a.value.map((ze) => ee(ze)) : [
    ee(a.value[0]),
    a.value[1] ? ee(a.value[1]) : es(r.value.partialRange)
  ] : ee(pn(a.value)), we = () => {
    if (Array.isArray(a.value)) {
      const ee = pi(a.value[0], e.weekStart), ze = a.value[1] ? pi(a.value[1], e.weekStart) : [];
      return [ee.map((et) => De(et)), ze.map((et) => De(et))];
    }
    return pi(a.value, e.weekStart).map((ee) => De(ee));
  }, H = (ee, ze) => Ve(pn(te(ee)), !1, ze), pe = (ee) => {
    const ze = we();
    return ee ? ze : t("update:model-value", we());
  }, Ne = (ee = !1) => (ee || de(), e.monthPicker ? H(w, ee) : e.timePicker ? H(p, ee) : e.yearPicker ? H(nt, ee) : e.weekPicker ? pe(ee) : Ve(re(ee), !0, ee));
  return {
    inputValue: c,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? r.value.enabled ? r.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: K,
    formatInputValue: de,
    emitModelValue: Ne
  };
}, Z$ = (t, e) => {
  const { defaultedFilters: n, propDates: a } = jt(t), { validateMonthYearInRange: i } = sr(t), r = (d, f) => {
    let g = d;
    return n.value.months.includes(dt(g)) ? (g = f ? Ma(d, 1) : Ms(d, 1), r(g, f)) : g;
  }, s = (d, f) => {
    let g = d;
    return n.value.years.includes(nt(g)) ? (g = f ? nf(d, 1) : Uv(d, 1), s(g, f)) : g;
  }, o = (d, f = !1) => {
    const g = St(De(), { month: t.month, year: t.year });
    let _ = d ? Ma(g, 1) : Ms(g, 1);
    t.disableYearSelect && (_ = Ga(_, t.year));
    let x = dt(_), p = nt(_);
    n.value.months.includes(x) && (_ = r(_, d), x = dt(_), p = nt(_)), n.value.years.includes(p) && (_ = s(_, d), p = nt(_)), i(x, p, d, t.preventMinMaxNavigation) && l(x, p, f);
  }, l = (d, f, g) => {
    e("update-month-year", { month: d, year: f, fromNav: g });
  }, c = I(() => (d) => Kv(
    St(De(), { month: t.month, year: t.year }),
    a.value.maxDate,
    a.value.minDate,
    t.preventMinMaxNavigation,
    d
  ));
  return { handleMonthYearChange: o, isDisabled: c, updateMonthYear: l };
}, Ku = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Fa = {
  ...Ku,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 }
}, K$ = ["title"], Q$ = ["disabled"], J$ = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Fa
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const n = e, a = t, {
      defaultedActionRow: i,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: s,
      defaultedTextInput: o,
      defaultedInline: l,
      defaultedRange: c,
      defaultedMultiDates: d,
      getDefaultPattern: f
    } = jt(a), { isTimeValid: g, isMonthValid: _ } = sr(a), { buildMatrix: x } = rr(), p = J(null), w = J(null), C = J(!1), M = J({}), A = J(null), L = J(null);
    ht(() => {
      a.arrowNavigation && x([on(p), on(w)], "actionRow"), D(), window.addEventListener("resize", D);
    }), Xs(() => {
      window.removeEventListener("resize", D);
    });
    const D = () => {
      C.value = !1, setTimeout(() => {
        var $, X;
        const R = ($ = A.value) == null ? void 0 : $.getBoundingClientRect(), de = (X = L.value) == null ? void 0 : X.getBoundingClientRect();
        R && de && (M.value.maxWidth = `${de.width - R.width - 20}px`), C.value = !0;
      }, 0);
    }, B = I(() => c.value.enabled && !c.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), P = I(
      () => !g.value(a.internalModelValue) || !_.value(a.internalModelValue) || !B.value
    ), z = () => {
      const $ = r.value;
      return a.timePicker || a.monthPicker, $(pn(a.internalModelValue));
    }, W = () => {
      const $ = a.internalModelValue;
      return s.value.count > 0 ? `${q($[0])} - ${q($[1])}` : [q($[0]), q($[1])];
    }, q = ($) => Qv(
      $,
      r.value,
      a.formatLocale,
      o.value.rangeSeparator,
      a.modelAuto,
      f()
    ), V = I(() => !a.internalModelValue || !a.menuMount ? "" : typeof r.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? W() : d.value.enabled ? a.internalModelValue.map(($) => `${q($)}`) : a.modelAuto ? `${q(a.internalModelValue[0])}` : `${q(a.internalModelValue[0])} -` : q(a.internalModelValue) : z()), re = () => d.value.enabled ? "; " : " - ", ie = I(
      () => Array.isArray(V.value) ? V.value.join(re()) : V.value
    ), K = () => {
      g.value(a.internalModelValue) && _.value(a.internalModelValue) && B.value ? n("select-date") : n("invalid-select");
    };
    return ($, X) => (h(), b("div", {
      ref_key: "actionRowRef",
      ref: L,
      class: "dp__action_row"
    }, [
      $.$slots["action-row"] ? xe($.$slots, "action-row", ln($t({ key: 0 }, {
        internalModelValue: $.internalModelValue,
        disabled: P.value,
        selectDate: () => $.$emit("select-date"),
        closePicker: () => $.$emit("close-picker")
      }))) : (h(), b(me, { key: 1 }, [
        O(i).showPreview ? (h(), b("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ie.value,
          style: bn(M.value)
        }, [
          $.$slots["action-preview"] && C.value ? xe($.$slots, "action-preview", {
            key: 0,
            value: $.internalModelValue
          }) : E("", !0),
          !$.$slots["action-preview"] && C.value ? (h(), b(me, { key: 1 }, [
            Ye(ae(ie.value), 1)
          ], 64)) : E("", !0)
        ], 12, K$)) : E("", !0),
        k("div", {
          ref_key: "actionBtnContainer",
          ref: A,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          $.$slots["action-buttons"] ? xe($.$slots, "action-buttons", {
            key: 0,
            value: $.internalModelValue
          }) : E("", !0),
          $.$slots["action-buttons"] ? E("", !0) : (h(), b(me, { key: 1 }, [
            !O(l).enabled && O(i).showCancel ? (h(), b("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: X[0] || (X[0] = (R) => $.$emit("close-picker")),
              onKeydown: X[1] || (X[1] = (R) => O(Kn)(R, () => $.$emit("close-picker")))
            }, ae($.cancelText), 545)) : E("", !0),
            O(i).showNow ? (h(), b("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: X[2] || (X[2] = (R) => $.$emit("select-now")),
              onKeydown: X[3] || (X[3] = (R) => O(Kn)(R, () => $.$emit("select-now")))
            }, ae($.nowButtonLabel), 33)) : E("", !0),
            O(i).showSelect ? (h(), b("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: w,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: P.value,
              "data-test": "select-button",
              onKeydown: X[4] || (X[4] = (R) => O(Kn)(R, () => K())),
              onClick: K
            }, ae($.selectText), 41, Q$)) : E("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), eF = { class: "dp__selection_grid_header" }, tF = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], nF = ["aria-label"], Rl = /* @__PURE__ */ Ae({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: n }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: i, setMonthPicker: r } = rr(), s = n, o = t, { defaultedAriaLabels: l, defaultedTextInput: c, defaultedConfig: d } = jt(
      o
    ), { hideNavigationButtons: f } = ed(), g = J(!1), _ = J(null), x = J(null), p = J([]), w = J(), C = J(null), M = J(0), A = J(null);
    O4(() => {
      _.value = null;
    }), ht(() => {
      Dn().then(() => V()), o.noOverlayFocus || D(), L(!0);
    }), Xs(() => L(!1));
    const L = (te) => {
      var we;
      o.arrowNavigation && ((we = o.headerRefs) != null && we.length ? r(te) : a(te));
    }, D = () => {
      var te;
      const we = on(x);
      we && (c.value.enabled || (_.value ? (te = _.value) == null || te.focus({ preventScroll: !0 }) : we.focus({ preventScroll: !0 })), g.value = we.clientHeight < we.scrollHeight);
    }, B = I(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !o.useRelative,
        "dp--overlay-relative": o.useRelative
      })
    ), P = I(
      () => o.useRelative ? { height: `${o.height}px`, width: "260px" } : void 0
    ), z = I(() => ({
      dp__overlay_col: !0
    })), W = I(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: g.value,
        dp__button_bottom: o.isLast
      })
    ), q = I(() => {
      var te, we;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((te = o.items) == null ? void 0 : te.length) <= 6,
        dp__container_block: ((we = o.items) == null ? void 0 : we.length) > 6
      };
    });
    at(
      () => o.items,
      () => V(!1),
      { deep: !0 }
    );
    const V = (te = !0) => {
      Dn().then(() => {
        const we = on(_), H = on(x), pe = on(C), Ne = on(A), ee = pe ? pe.getBoundingClientRect().height : 0;
        H && (H.getBoundingClientRect().height ? M.value = H.getBoundingClientRect().height - ee : M.value = d.value.modeHeight - ee), we && Ne && te && (Ne.scrollTop = we.offsetTop - Ne.offsetTop - (M.value / 2 - we.getBoundingClientRect().height) - ee);
      });
    }, re = (te) => {
      te.disabled || s("selected", te.value);
    }, ie = () => {
      s("toggle"), s("reset-flow");
    }, K = () => {
      o.escClose && ie();
    }, $ = (te, we, H, pe) => {
      te && ((we.active || we.value === o.focusValue) && (_.value = te), o.arrowNavigation && (Array.isArray(p.value[H]) ? p.value[H][pe] = te : p.value[H] = [te], X()));
    }, X = () => {
      var te, we;
      const H = (te = o.headerRefs) != null && te.length ? [o.headerRefs].concat(p.value) : p.value.concat([o.skipButtonRef ? [] : [C.value]]);
      i(pn(H), (we = o.headerRefs) != null && we.length ? "monthPicker" : "selectionGrid");
    }, R = (te) => {
      o.arrowNavigation || Xi(te, d.value, !0);
    }, de = (te) => {
      w.value = te, s("hover-value", te);
    }, Le = () => {
      if (ie(), !o.isLast) {
        const te = w$(o.menuWrapRef ?? null, "action-row");
        if (te) {
          const we = Vv(te);
          we == null || we.focus();
        }
      }
    }, Ie = (te) => {
      switch (te.key) {
        case zt.esc:
          return K();
        case zt.arrowLeft:
          return R(te);
        case zt.arrowRight:
          return R(te);
        case zt.arrowUp:
          return R(te);
        case zt.arrowDown:
          return R(te);
        default:
          return;
      }
    }, Ve = (te) => {
      if (te.key === zt.enter) return ie();
      if (te.key === zt.tab) return Le();
    };
    return e({ focusGrid: D }), (te, we) => {
      var H;
      return h(), b("div", {
        ref_key: "gridWrapRef",
        ref: x,
        class: se(B.value),
        style: bn(P.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: Ie,
        onClick: we[0] || (we[0] = Ba(() => {
        }, ["prevent"]))
      }, [
        k("div", {
          ref_key: "containerRef",
          ref: A,
          class: se(q.value),
          role: "grid",
          style: bn({ "--dp-overlay-height": `${M.value}px` })
        }, [
          k("div", eF, [
            xe(te.$slots, "header")
          ]),
          te.$slots.overlay ? xe(te.$slots, "overlay", { key: 0 }) : (h(!0), b(me, { key: 1 }, Ee(te.items, (pe, Ne) => (h(), b("div", {
            key: Ne,
            class: se(["dp__overlay_row", { dp__flex_row: te.items.length >= 3 }]),
            role: "row"
          }, [
            (h(!0), b(me, null, Ee(pe, (ee, ze) => (h(), b("div", {
              key: ee.value,
              ref_for: !0,
              ref: (et) => $(et, ee, Ne, ze),
              role: "gridcell",
              class: se(z.value),
              "aria-selected": ee.active || void 0,
              "aria-disabled": ee.disabled || void 0,
              tabindex: "0",
              "data-test": ee.text,
              onClick: Ba((et) => re(ee), ["prevent"]),
              onKeydown: (et) => O(Kn)(et, () => re(ee), !0),
              onMouseover: (et) => de(ee.value)
            }, [
              k("div", {
                class: se(ee.className)
              }, [
                te.$slots.item ? xe(te.$slots, "item", {
                  key: 0,
                  item: ee
                }) : E("", !0),
                te.$slots.item ? E("", !0) : (h(), b(me, { key: 1 }, [
                  Ye(ae(ee.text), 1)
                ], 64))
              ], 2)
            ], 42, tF))), 128))
          ], 2))), 128))
        ], 6),
        te.$slots["button-icon"] ? kt((h(), b("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: C,
          type: "button",
          "aria-label": (H = O(l)) == null ? void 0 : H.toggleOverlay,
          class: se(W.value),
          tabindex: "0",
          onClick: ie,
          onKeydown: Ve
        }, [
          xe(te.$slots, "button-icon")
        ], 42, nF)), [
          [ga, !O(f)(te.hideNavigation, te.type)]
        ]) : E("", !0)
      ], 38);
    };
  }
}), Qu = /* @__PURE__ */ Ae({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(t) {
    const e = t, n = I(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), a = I(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (i, r) => (h(), b("div", {
      class: se({
        dp__menu_inner: !i.stretch,
        "dp--menu--inner-stretched": i.stretch,
        dp__flex_display: i.multiCalendars > 0,
        "dp--flex-display-collapsed": i.collapse
      })
    }, [
      (h(!0), b(me, null, Ee(n.value, (s, o) => (h(), b("div", {
        key: s,
        class: se(a.value)
      }, [
        xe(i.$slots, "default", {
          instance: s,
          index: o
        })
      ], 2))), 128))
    ], 2));
  }
}), aF = ["aria-label", "aria-disabled"], rl = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const n = e, a = J(null);
    return ht(() => n("set-ref", a)), (i, r) => (h(), b("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": i.ariaLabel,
      "aria-disabled": i.disabled || void 0,
      onClick: r[0] || (r[0] = (s) => i.$emit("activate")),
      onKeydown: r[1] || (r[1] = (s) => O(Kn)(s, () => i.$emit("activate"), !0))
    }, [
      k("span", {
        class: se(["dp__inner_nav", { dp__inner_nav_disabled: i.disabled }])
      }, [
        xe(i.$slots, "default")
      ], 2)
    ], 40, aF));
  }
}), iF = { class: "dp--year-mode-picker" }, rF = ["aria-label", "data-test"], ny = /* @__PURE__ */ Ae({
  __name: "YearModePicker",
  props: {
    ...Fa,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const n = e, a = t, { showRightIcon: i, showLeftIcon: r } = ed(), { defaultedConfig: s, defaultedMultiCalendars: o, defaultedAriaLabels: l, defaultedTransitions: c, defaultedUI: d } = jt(a), { showTransition: f, transitionName: g } = Nl(c), _ = (w = !1, C) => {
      n("toggle-year-picker", { flow: w, show: C });
    }, x = (w) => {
      n("year-select", w);
    }, p = (w = !1) => {
      n("handle-year", w);
    };
    return (w, C) => {
      var M, A, L, D, B;
      return h(), b("div", iF, [
        O(r)(O(o), t.instance) ? (h(), Z(rl, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (M = O(l)) == null ? void 0 : M.prevYear,
          disabled: t.isDisabled(!1),
          class: se((A = O(d)) == null ? void 0 : A.navBtnPrev),
          onActivate: C[0] || (C[0] = (P) => p(!1))
        }, {
          default: ce(() => [
            w.$slots["arrow-left"] ? xe(w.$slots, "arrow-left", { key: 0 }) : E("", !0),
            w.$slots["arrow-left"] ? E("", !0) : (h(), Z(O(cf), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : E("", !0),
        k("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (L = O(l)) == null ? void 0 : L.openYearsOverlay,
          "data-test": `year-mode-btn-${t.instance}`,
          onClick: C[1] || (C[1] = () => _(!1)),
          onKeydown: C[2] || (C[2] = $r(() => _(!1), ["enter"]))
        }, [
          w.$slots.year ? xe(w.$slots, "year", {
            key: 0,
            year: t.year
          }) : E("", !0),
          w.$slots.year ? E("", !0) : (h(), b(me, { key: 1 }, [
            Ye(ae(t.year), 1)
          ], 64))
        ], 40, rF),
        O(i)(O(o), t.instance) ? (h(), Z(rl, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (D = O(l)) == null ? void 0 : D.nextYear,
          disabled: t.isDisabled(!0),
          class: se((B = O(d)) == null ? void 0 : B.navBtnNext),
          onActivate: C[3] || (C[3] = (P) => p(!0))
        }, {
          default: ce(() => [
            w.$slots["arrow-right"] ? xe(w.$slots, "arrow-right", { key: 0 }) : E("", !0),
            w.$slots["arrow-right"] ? E("", !0) : (h(), Z(O(uf), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : E("", !0),
        Q(Fr, {
          name: O(g)(t.showYearPicker),
          css: O(f)
        }, {
          default: ce(() => [
            t.showYearPicker ? (h(), Z(Rl, {
              key: 0,
              items: t.items,
              "text-input": w.textInput,
              "esc-close": w.escClose,
              config: w.config,
              "is-last": w.autoApply && !O(s).keepActionRow,
              "hide-navigation": w.hideNavigation,
              "aria-labels": w.ariaLabels,
              type: "year",
              onToggle: _,
              onSelected: C[4] || (C[4] = (P) => x(P))
            }, rn({
              "button-icon": ce(() => [
                w.$slots["calendar-icon"] ? xe(w.$slots, "calendar-icon", { key: 0 }) : E("", !0),
                w.$slots["calendar-icon"] ? E("", !0) : (h(), Z(O(no), { key: 1 }))
              ]),
              _: 2
            }, [
              w.$slots["year-overlay-value"] ? {
                name: "item",
                fn: ce(({ item: P }) => [
                  xe(w.$slots, "year-overlay-value", {
                    text: P.text,
                    value: P.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : E("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), yf = (t, e, n) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((a) => ft(t, a))) {
      const a = e.value.filter((i) => !ft(i, t));
      e.value = a.length ? a : null;
    } else (n && +n > e.value.length || !n) && e.value.push(t);
  else
    e.value = [t];
}, _f = (t, e, n) => {
  let a = t.value ? t.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? Vt(e, a[0]) ? (a.unshift(e), n("range-start", a[0]), n("range-start", a[1])) : (a[1] = e, n("range-end", e)) : (a = [e], n("range-start", e)), a;
}, Ju = (t, e, n, a) => {
  t && (t[0] && t[1] && n && e("auto-apply"), t[0] && !t[1] && a && n && e("auto-apply"));
}, ay = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => Jn(De(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = Jn(De(t.value), t.timezone));
}, iy = (t, e, n, a) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (Kt(t, e.value[0]) || ft(t, e.value[0])) ? [e.value[0], t] : a.value.fixedEnd && (Vt(t, e.value[1]) || ft(t, e.value[1])) ? [t, e.value[1]] : (n("invalid-fixed-range", t), e.value) : [], ry = ({
  multiCalendars: t,
  range: e,
  highlight: n,
  propDates: a,
  calendars: i,
  modelValue: r,
  props: s,
  filters: o,
  year: l,
  month: c,
  emit: d
}) => {
  const f = I(() => mf(s.yearRange, s.locale, s.reverseYears)), g = J([!1]), _ = I(() => (q, V) => {
    const re = St(Ea(/* @__PURE__ */ new Date()), {
      month: c.value(q),
      year: l.value(q)
    }), ie = V ? Ev(re) : yl(re);
    return Kv(
      ie,
      a.value.maxDate,
      a.value.minDate,
      s.preventMinMaxNavigation,
      V
    );
  }), x = () => Array.isArray(r.value) && t.value.solo && r.value[1], p = () => {
    for (let q = 0; q < t.value.count; q++)
      if (q === 0)
        i.value[q] = i.value[0];
      else if (q === t.value.count - 1 && x())
        i.value[q] = {
          month: dt(r.value[1]),
          year: nt(r.value[1])
        };
      else {
        const V = St(De(), i.value[q - 1]);
        i.value[q] = { month: dt(V), year: nt(nf(V, 1)) };
      }
  }, w = (q) => {
    if (!q) return p();
    const V = St(De(), i.value[q]);
    return i.value[0].year = nt(Uv(V, t.value.count - 1)), p();
  }, C = (q, V) => {
    const re = bR(V, q);
    return e.value.showLastInRange && re > 1 ? V : q;
  }, M = (q) => s.focusStartDate || t.value.solo ? q[0] : q[1] ? C(q[0], q[1]) : q[0], A = () => {
    if (r.value) {
      const q = Array.isArray(r.value) ? M(r.value) : r.value;
      i.value[0] = { month: dt(q), year: nt(q) };
    }
  }, L = () => {
    A(), t.value.count && p();
  };
  at(r, (q, V) => {
    s.isTextInputDate && JSON.stringify(q ?? {}) !== JSON.stringify(V ?? {}) && L();
  }), ht(() => {
    L();
  });
  const D = (q, V) => {
    i.value[V].year = q, d("update-month-year", { instance: V, year: q, month: i.value[V].month }), t.value.count && !t.value.solo && w(V);
  }, B = I(() => (q) => Os(f.value, (V) => {
    var re;
    const ie = l.value(q) === V.value, K = xl(
      V.value,
      Ps(a.value.minDate),
      Ps(a.value.maxDate)
    ) || ((re = o.value.years) == null ? void 0 : re.includes(l.value(q))), $ = vf(n.value, V.value);
    return { active: ie, disabled: K, highlighted: $ };
  })), P = (q, V) => {
    D(q, V), W(V);
  }, z = (q, V = !1) => {
    if (!_.value(q, V)) {
      const re = V ? l.value(q) + 1 : l.value(q) - 1;
      D(re, q);
    }
  }, W = (q, V = !1, re) => {
    V || d("reset-flow"), re !== void 0 ? g.value[q] = re : g.value[q] = !g.value[q], g.value[q] ? d("overlay-toggle", { open: !0, overlay: Cn.year }) : (d("overlay-closed"), d("overlay-toggle", { open: !1, overlay: Cn.year }));
  };
  return {
    isDisabled: _,
    groupedYears: B,
    showYearPicker: g,
    selectYear: D,
    toggleYearPicker: W,
    handleYearSelect: P,
    handleYear: z
  };
}, sF = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    defaultedRange: s,
    defaultedHighlight: o,
    propDates: l,
    defaultedTz: c,
    defaultedFilters: d,
    defaultedMultiDates: f
  } = jt(t), g = () => {
    t.isTextInputDate && L(nt(De(t.startDate)), 0);
  }, { modelValue: _, year: x, month: p, calendars: w } = $l(t, e, g), C = I(() => Yv(t.formatLocale, t.locale, t.monthNameFormat)), M = J(null), { checkMinMaxRange: A } = sr(t), {
    selectYear: L,
    groupedYears: D,
    showYearPicker: B,
    toggleYearPicker: P,
    handleYearSelect: z,
    handleYear: W,
    isDisabled: q
  } = ry({
    modelValue: _,
    multiCalendars: n,
    range: s,
    highlight: o,
    calendars: w,
    year: x,
    propDates: l,
    month: p,
    filters: d,
    props: t,
    emit: e
  });
  ht(() => {
    t.startDate && (_.value && t.focusStartDate || !_.value) && L(nt(De(t.startDate)), 0);
  });
  const V = (H) => H ? { month: dt(H), year: nt(H) } : { month: null, year: null }, re = () => _.value ? Array.isArray(_.value) ? _.value.map((H) => V(H)) : V(_.value) : V(), ie = (H, pe) => {
    const Ne = w.value[H], ee = re();
    return Array.isArray(ee) ? ee.some((ze) => ze.year === (Ne == null ? void 0 : Ne.year) && ze.month === pe) : (Ne == null ? void 0 : Ne.year) === ee.year && pe === ee.month;
  }, K = (H, pe, Ne) => {
    var ee, ze;
    const et = re();
    return Array.isArray(et) ? x.value(pe) === ((ee = et[Ne]) == null ? void 0 : ee.year) && H === ((ze = et[Ne]) == null ? void 0 : ze.month) : !1;
  }, $ = (H, pe) => {
    if (s.value.enabled) {
      const Ne = re();
      if (Array.isArray(_.value) && Array.isArray(Ne)) {
        const ee = K(H, pe, 0) || K(H, pe, 1), ze = vi(Ea(De()), H, x.value(pe));
        return Zu(_.value, M.value, ze) && !ee;
      }
      return !1;
    }
    return !1;
  }, X = I(() => (H) => Os(C.value, (pe) => {
    var Ne;
    const ee = ie(H, pe.value), ze = xl(
      pe.value,
      Wv(x.value(H), l.value.minDate),
      Gv(x.value(H), l.value.maxDate)
    ) || I$(l.value.disabledDates, x.value(H)).includes(pe.value) || ((Ne = d.value.months) == null ? void 0 : Ne.includes(pe.value)), et = $(pe.value, H), Te = Jv(o.value, pe.value, x.value(H));
    return { active: ee, disabled: ze, isBetween: et, highlighted: Te };
  })), R = (H, pe) => vi(Ea(De()), H, x.value(pe)), de = (H, pe) => {
    const Ne = _.value ? _.value : Ea(/* @__PURE__ */ new Date());
    _.value = vi(Ne, H, x.value(pe)), e("auto-apply"), e("update-flow-step");
  }, Le = (H, pe) => {
    const Ne = R(H, pe);
    s.value.fixedEnd || s.value.fixedStart ? _.value = iy(Ne, _, e, s) : _.value ? A(Ne, _.value) && (_.value = _f(_, R(H, pe), e)) : _.value = [R(H, pe)], Dn().then(() => {
      Ju(_.value, e, t.autoApply, t.modelAuto);
    });
  }, Ie = (H, pe) => {
    yf(R(H, pe), _, f.value.limit), e("auto-apply", !0);
  }, Ve = (H, pe) => (w.value[pe].month = H, we(pe, w.value[pe].year, H), f.value.enabled ? Ie(H, pe) : s.value.enabled ? Le(H, pe) : de(H, pe)), te = (H, pe) => {
    L(H, pe), we(pe, H, null);
  }, we = (H, pe, Ne) => {
    let ee = Ne;
    if (!ee && ee !== 0) {
      const ze = re();
      ee = Array.isArray(ze) ? ze[H].month : ze.month;
    }
    e("update-month-year", { instance: H, year: pe, month: ee });
  };
  return {
    groupedMonths: X,
    groupedYears: D,
    year: x,
    isDisabled: q,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: i,
    defaultedConfig: r,
    showYearPicker: B,
    modelValue: _,
    presetDate: (H, pe) => {
      ay({
        value: H,
        modelValue: _,
        range: s.value.enabled,
        timezone: pe ? void 0 : c.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (H, pe) => {
      M.value = R(H, pe);
    },
    selectMonth: Ve,
    selectYear: te,
    toggleYearPicker: P,
    handleYearSelect: z,
    handleYear: W,
    getModelMonthYear: re
  };
}, oF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = nr(), r = ca(i, "yearMode"), s = t;
    ht(() => {
      s.shadow || a("mount", null);
    });
    const {
      groupedMonths: o,
      groupedYears: l,
      year: c,
      isDisabled: d,
      defaultedMultiCalendars: f,
      defaultedConfig: g,
      showYearPicker: _,
      modelValue: x,
      presetDate: p,
      setHoverDate: w,
      selectMonth: C,
      selectYear: M,
      toggleYearPicker: A,
      handleYearSelect: L,
      handleYear: D,
      getModelMonthYear: B
    } = sF(s, a);
    return e({ getSidebarProps: () => ({
      modelValue: x,
      year: c,
      getModelMonthYear: B,
      selectMonth: C,
      selectYear: M,
      handleYear: D
    }), presetDate: p, toggleYearPicker: (P) => A(0, P) }), (P, z) => (h(), Z(Qu, {
      "multi-calendars": O(f).count,
      collapse: P.collapse,
      stretch: ""
    }, {
      default: ce(({ instance: W }) => [
        P.$slots["top-extra"] ? xe(P.$slots, "top-extra", {
          key: 0,
          value: P.internalModelValue
        }) : E("", !0),
        P.$slots["month-year"] ? xe(P.$slots, "month-year", ln($t({ key: 1 }, {
          year: O(c),
          months: O(o)(W),
          years: O(l)(W),
          selectMonth: O(C),
          selectYear: O(M),
          instance: W
        }))) : (h(), Z(Rl, {
          key: 2,
          items: O(o)(W),
          "arrow-navigation": P.arrowNavigation,
          "is-last": P.autoApply && !O(g).keepActionRow,
          "esc-close": P.escClose,
          height: O(g).modeHeight,
          config: P.config,
          "no-overlay-focus": !!(P.noOverlayFocus || P.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (q) => O(C)(q, W),
          onHoverValue: (q) => O(w)(q, W)
        }, rn({
          header: ce(() => [
            Q(ny, $t(P.$props, {
              items: O(l)(W),
              instance: W,
              "show-year-picker": O(_)[W],
              year: O(c)(W),
              "is-disabled": (q) => O(d)(W, q),
              onHandleYear: (q) => O(D)(W, q),
              onYearSelect: (q) => O(L)(q, W),
              onToggleYearPicker: (q) => O(A)(W, q == null ? void 0 : q.flow, q == null ? void 0 : q.show)
            }), rn({ _: 2 }, [
              Ee(O(r), (q, V) => ({
                name: q,
                fn: ce((re) => [
                  xe(P.$slots, q, ln(Un(re)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          P.$slots["month-overlay-value"] ? {
            name: "item",
            fn: ce(({ item: q }) => [
              xe(P.$slots, "month-overlay-value", {
                text: q.text,
                value: q.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), lF = (t, e) => {
  const n = () => {
    t.isTextInputDate && (d.value = nt(De(t.startDate)));
  }, { modelValue: a } = $l(t, e, n), i = J(null), { defaultedHighlight: r, defaultedMultiDates: s, defaultedFilters: o, defaultedRange: l, propDates: c } = jt(t), d = J();
  ht(() => {
    t.startDate && (a.value && t.focusStartDate || !a.value) && (d.value = nt(De(t.startDate)));
  });
  const f = (p) => Array.isArray(a.value) ? a.value.some((w) => nt(w) === p) : a.value ? nt(a.value) === p : !1, g = (p) => l.value.enabled && Array.isArray(a.value) ? Zu(a.value, i.value, x(p)) : !1, _ = I(() => Os(mf(t.yearRange, t.locale, t.reverseYears), (p) => {
    const w = f(p.value), C = xl(
      p.value,
      Ps(c.value.minDate),
      Ps(c.value.maxDate)
    ) || o.value.years.includes(p.value), M = g(p.value) && !w, A = vf(r.value, p.value);
    return { active: w, disabled: C, isBetween: M, highlighted: A };
  })), x = (p) => Ga(Ea(yl(/* @__PURE__ */ new Date())), p);
  return {
    groupedYears: _,
    modelValue: a,
    focusYear: d,
    setHoverValue: (p) => {
      i.value = Ga(Ea(/* @__PURE__ */ new Date()), p);
    },
    selectYear: (p) => {
      var w;
      if (e("update-month-year", { instance: 0, year: p }), s.value.enabled)
        return a.value ? Array.isArray(a.value) && (((w = a.value) == null ? void 0 : w.map((C) => nt(C))).includes(p) ? a.value = a.value.filter((C) => nt(C) !== p) : a.value.push(Ga(Hn(De()), p))) : a.value = [Ga(Hn(yl(De())), p)], e("auto-apply", !0);
      l.value.enabled ? (a.value = _f(a, x(p), e), Dn().then(() => {
        Ju(a.value, e, t.autoApply, t.modelAuto);
      })) : (a.value = x(p), e("auto-apply"));
    }
  };
}, cF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { groupedYears: r, modelValue: s, focusYear: o, selectYear: l, setHoverValue: c } = lF(i, a), { defaultedConfig: d } = jt(i);
    return e({ getSidebarProps: () => ({
      modelValue: s,
      selectYear: l
    }) }), (f, g) => (h(), b("div", null, [
      f.$slots["top-extra"] ? xe(f.$slots, "top-extra", {
        key: 0,
        value: f.internalModelValue
      }) : E("", !0),
      f.$slots["month-year"] ? xe(f.$slots, "month-year", ln($t({ key: 1 }, {
        years: O(r),
        selectYear: O(l)
      }))) : (h(), Z(Rl, {
        key: 2,
        items: O(r),
        "is-last": f.autoApply && !O(d).keepActionRow,
        height: O(d).modeHeight,
        config: f.config,
        "no-overlay-focus": !!(f.noOverlayFocus || f.textInput),
        "focus-value": O(o),
        type: "year",
        "use-relative": "",
        onSelected: O(l),
        onHoverValue: O(c)
      }, rn({ _: 2 }, [
        f.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ce(({ item: _ }) => [
            xe(f.$slots, "year-overlay-value", {
              text: _.text,
              value: _.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), uF = {
  key: 0,
  class: "dp__time_input"
}, dF = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], hF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), fF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), pF = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], mF = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], gF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), bF = /* @__PURE__ */ k("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), vF = { key: 0 }, yF = ["aria-label"], _F = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Fa
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { setTimePickerElements: r, setTimePickerBackRef: s } = rr(), { defaultedAriaLabels: o, defaultedTransitions: l, defaultedFilters: c, defaultedConfig: d, defaultedRange: f } = jt(i), { transitionName: g, showTransition: _ } = Nl(l), x = La({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), p = J("AM"), w = J(null), C = J([]), M = J();
    ht(() => {
      a("mounted");
    });
    const A = (G) => St(/* @__PURE__ */ new Date(), {
      hours: G.hours,
      minutes: G.minutes,
      seconds: i.enableSeconds ? G.seconds : 0,
      milliseconds: 0
    }), L = I(
      () => (G) => X(G, i[G]) || B(G, i[G])
    ), D = I(() => ({ hours: i.hours, minutes: i.minutes, seconds: i.seconds })), B = (G, Se) => f.value.enabled && !f.value.disableTimeRangeValidation ? !i.validateTime(G, Se) : !1, P = (G, Se) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const he = Se ? +i[`${G}Increment`] : -+i[`${G}Increment`], Ce = i[G] + he;
        return !i.validateTime(G, Ce);
      }
      return !1;
    }, z = I(() => (G) => !Ve(+i[G] + +i[`${G}Increment`], G) || P(G, !0)), W = I(() => (G) => !Ve(+i[G] - +i[`${G}Increment`], G) || P(G, !1)), q = (G, Se) => xv(St(De(), G), Se), V = (G, Se) => h$(St(De(), G), Se), re = I(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !i.timePickerInline,
        dp__time_col_reg_block: !i.enableSeconds && i.is24 && !i.timePickerInline,
        dp__time_col_reg_inline: !i.enableSeconds && i.is24 && i.timePickerInline,
        dp__time_col_reg_with_button: !i.enableSeconds && !i.is24,
        dp__time_col_sec: i.enableSeconds && i.is24,
        dp__time_col_sec_with_button: i.enableSeconds && !i.is24
      })
    ), ie = I(() => {
      const G = [{ type: "hours" }];
      return i.enableMinutes && G.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), i.enableSeconds && G.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), G;
    }), K = I(() => ie.value.filter((G) => !G.separator)), $ = I(() => (G) => {
      if (G === "hours") {
        const Se = ee(+i.hours);
        return { text: Se < 10 ? `0${Se}` : `${Se}`, value: Se };
      }
      return { text: i[G] < 10 ? `0${i[G]}` : `${i[G]}`, value: i[G] };
    }), X = (G, Se) => {
      var he;
      if (!i.disabledTimesConfig) return !1;
      const Ce = i.disabledTimesConfig(i.order, G === "hours" ? Se : void 0);
      return Ce[G] ? !!((he = Ce[G]) != null && he.includes(Se)) : !0;
    }, R = (G, Se) => Se !== "hours" || p.value === "AM" ? G : G + 12, de = (G) => {
      const Se = i.is24 ? 24 : 12, he = G === "hours" ? Se : 60, Ce = +i[`${G}GridIncrement`], _e = G === "hours" && !i.is24 ? Ce : 0, tt = [];
      for (let oe = _e; oe < he; oe += Ce)
        tt.push({ value: i.is24 ? oe : R(oe, G), text: oe < 10 ? `0${oe}` : `${oe}` });
      return G === "hours" && !i.is24 && tt.unshift({ value: p.value === "PM" ? 12 : 0, text: "12" }), Os(tt, (oe) => ({ active: !1, disabled: c.value.times[G].includes(oe.value) || !Ve(oe.value, G) || X(G, oe.value) || B(G, oe.value) }));
    }, Le = (G) => G >= 0 ? G : 59, Ie = (G) => G >= 0 ? G : 23, Ve = (G, Se) => {
      const he = i.minTime ? A(s0(i.minTime)) : null, Ce = i.maxTime ? A(s0(i.maxTime)) : null, _e = A(
        s0(
          D.value,
          Se,
          Se === "minutes" || Se === "seconds" ? Le(G) : Ie(G)
        )
      );
      return he && Ce ? (_l(_e, Ce) || ds(_e, Ce)) && (Is(_e, he) || ds(_e, he)) : he ? Is(_e, he) || ds(_e, he) : Ce ? _l(_e, Ce) || ds(_e, Ce) : !0;
    }, te = (G) => i[`no${G[0].toUpperCase() + G.slice(1)}Overlay`], we = (G) => {
      te(G) || (x[G] = !x[G], x[G] ? a("overlay-opened", G) : a("overlay-closed", G));
    }, H = (G) => G === "hours" ? Ti : G === "minutes" ? Ji : Ds, pe = () => {
      M.value && clearTimeout(M.value);
    }, Ne = (G, Se = !0, he) => {
      const Ce = Se ? q : V, _e = Se ? +i[`${G}Increment`] : -+i[`${G}Increment`];
      Ve(+i[G] + _e, G) && a(
        `update:${G}`,
        H(G)(Ce({ [G]: +i[G] }, { [G]: +i[`${G}Increment`] }))
      ), !(he != null && he.keyboard) && d.value.timeArrowHoldThreshold && (M.value = setTimeout(() => {
        Ne(G, Se);
      }, d.value.timeArrowHoldThreshold));
    }, ee = (G) => i.is24 ? G : (G >= 12 ? p.value = "PM" : p.value = "AM", v$(G)), ze = () => {
      p.value === "PM" ? (p.value = "AM", a("update:hours", i.hours - 12)) : (p.value = "PM", a("update:hours", i.hours + 12)), a("am-pm-change", p.value);
    }, et = (G) => {
      x[G] = !0;
    }, Te = (G, Se, he) => {
      if (G && i.arrowNavigation) {
        Array.isArray(C.value[Se]) ? C.value[Se][he] = G : C.value[Se] = [G];
        const Ce = C.value.reduce(
          (_e, tt) => tt.map((oe, Oe) => [..._e[Oe] || [], tt[Oe]]),
          []
        );
        s(i.closeTimePickerBtn), w.value && (Ce[1] = Ce[1].concat(w.value)), r(Ce, i.order);
      }
    }, Qe = (G, Se) => (we(G), a(`update:${G}`, Se));
    return e({ openChildCmp: et }), (G, Se) => {
      var he;
      return G.disabled ? E("", !0) : (h(), b("div", uF, [
        (h(!0), b(me, null, Ee(ie.value, (Ce, _e) => {
          var tt, oe, Oe;
          return h(), b("div", {
            key: _e,
            class: se(re.value)
          }, [
            Ce.separator ? (h(), b(me, { key: 0 }, [
              Ye(" : ")
            ], 64)) : (h(), b(me, { key: 1 }, [
              k("button", {
                ref_for: !0,
                ref: (Re) => Te(Re, _e, 0),
                type: "button",
                class: se({
                  dp__btn: !0,
                  dp__inc_dec_button: !G.timePickerInline,
                  dp__inc_dec_button_inline: G.timePickerInline,
                  dp__tp_inline_btn_top: G.timePickerInline,
                  dp__inc_dec_button_disabled: z.value(Ce.type)
                }),
                "data-test": `${Ce.type}-time-inc-btn-${i.order}`,
                "aria-label": (tt = O(o)) == null ? void 0 : tt.incrementValue(Ce.type),
                tabindex: "0",
                onKeydown: (Re) => O(Kn)(Re, () => Ne(Ce.type, !0, { keyboard: !0 }), !0),
                onClick: (Re) => O(d).timeArrowHoldThreshold ? void 0 : Ne(Ce.type, !0),
                onMousedown: (Re) => O(d).timeArrowHoldThreshold ? Ne(Ce.type, !0) : void 0,
                onMouseup: pe
              }, [
                i.timePickerInline ? (h(), b(me, { key: 1 }, [
                  G.$slots["tp-inline-arrow-up"] ? xe(G.$slots, "tp-inline-arrow-up", { key: 0 }) : (h(), b(me, { key: 1 }, [
                    hF,
                    fF
                  ], 64))
                ], 64)) : (h(), b(me, { key: 0 }, [
                  G.$slots["arrow-up"] ? xe(G.$slots, "arrow-up", { key: 0 }) : E("", !0),
                  G.$slots["arrow-up"] ? E("", !0) : (h(), Z(O(hf), { key: 1 }))
                ], 64))
              ], 42, dF),
              k("button", {
                ref_for: !0,
                ref: (Re) => Te(Re, _e, 1),
                type: "button",
                "aria-label": (oe = O(o)) == null ? void 0 : oe.openTpOverlay(Ce.type),
                class: se({
                  dp__time_display: !0,
                  dp__time_display_block: !G.timePickerInline,
                  dp__time_display_inline: G.timePickerInline,
                  "dp--time-invalid": L.value(Ce.type),
                  "dp--time-overlay-btn": !L.value(Ce.type)
                }),
                disabled: te(Ce.type),
                tabindex: "0",
                "data-test": `${Ce.type}-toggle-overlay-btn-${i.order}`,
                onKeydown: (Re) => O(Kn)(Re, () => we(Ce.type), !0),
                onClick: (Re) => we(Ce.type)
              }, [
                G.$slots[Ce.type] ? xe(G.$slots, Ce.type, {
                  key: 0,
                  text: $.value(Ce.type).text,
                  value: $.value(Ce.type).value
                }) : E("", !0),
                G.$slots[Ce.type] ? E("", !0) : (h(), b(me, { key: 1 }, [
                  Ye(ae($.value(Ce.type).text), 1)
                ], 64))
              ], 42, pF),
              k("button", {
                ref_for: !0,
                ref: (Re) => Te(Re, _e, 2),
                type: "button",
                class: se({
                  dp__btn: !0,
                  dp__inc_dec_button: !G.timePickerInline,
                  dp__inc_dec_button_inline: G.timePickerInline,
                  dp__tp_inline_btn_bottom: G.timePickerInline,
                  dp__inc_dec_button_disabled: W.value(Ce.type)
                }),
                "data-test": `${Ce.type}-time-dec-btn-${i.order}`,
                "aria-label": (Oe = O(o)) == null ? void 0 : Oe.decrementValue(Ce.type),
                tabindex: "0",
                onKeydown: (Re) => O(Kn)(Re, () => Ne(Ce.type, !1, { keyboard: !0 }), !0),
                onClick: (Re) => O(d).timeArrowHoldThreshold ? void 0 : Ne(Ce.type, !1),
                onMousedown: (Re) => O(d).timeArrowHoldThreshold ? Ne(Ce.type, !1) : void 0,
                onMouseup: pe
              }, [
                i.timePickerInline ? (h(), b(me, { key: 1 }, [
                  G.$slots["tp-inline-arrow-down"] ? xe(G.$slots, "tp-inline-arrow-down", { key: 0 }) : (h(), b(me, { key: 1 }, [
                    gF,
                    bF
                  ], 64))
                ], 64)) : (h(), b(me, { key: 0 }, [
                  G.$slots["arrow-down"] ? xe(G.$slots, "arrow-down", { key: 0 }) : E("", !0),
                  G.$slots["arrow-down"] ? E("", !0) : (h(), Z(O(ff), { key: 1 }))
                ], 64))
              ], 42, mF)
            ], 64))
          ], 2);
        }), 128)),
        G.is24 ? E("", !0) : (h(), b("div", vF, [
          G.$slots["am-pm-button"] ? xe(G.$slots, "am-pm-button", {
            key: 0,
            toggle: ze,
            value: p.value
          }) : E("", !0),
          G.$slots["am-pm-button"] ? E("", !0) : (h(), b("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: w,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (he = O(o)) == null ? void 0 : he.amPmButton,
            tabindex: "0",
            onClick: ze,
            onKeydown: Se[0] || (Se[0] = (Ce) => O(Kn)(Ce, () => ze(), !0))
          }, ae(p.value), 41, yF))
        ])),
        (h(!0), b(me, null, Ee(K.value, (Ce, _e) => (h(), Z(Fr, {
          key: _e,
          name: O(g)(x[Ce.type]),
          css: O(_)
        }, {
          default: ce(() => [
            x[Ce.type] ? (h(), Z(Rl, {
              key: 0,
              items: de(Ce.type),
              "is-last": G.autoApply && !O(d).keepActionRow,
              "esc-close": G.escClose,
              type: Ce.type,
              "text-input": G.textInput,
              config: G.config,
              "arrow-navigation": G.arrowNavigation,
              "aria-labels": G.ariaLabels,
              onSelected: (tt) => Qe(Ce.type, tt),
              onToggle: (tt) => we(Ce.type),
              onResetFlow: Se[1] || (Se[1] = (tt) => G.$emit("reset-flow"))
            }, rn({
              "button-icon": ce(() => [
                G.$slots["clock-icon"] ? xe(G.$slots, "clock-icon", { key: 0 }) : E("", !0),
                G.$slots["clock-icon"] ? E("", !0) : (h(), Z(ut(G.timePickerInline ? O(no) : O(df)), { key: 1 }))
              ]),
              _: 2
            }, [
              G.$slots[`${Ce.type}-overlay-value`] ? {
                name: "item",
                fn: ce(({ item: tt }) => [
                  xe(G.$slots, `${Ce.type}-overlay-value`, {
                    text: tt.text,
                    value: tt.value
                  })
                ]),
                key: "0"
              } : void 0,
              G.$slots[`${Ce.type}-overlay-header`] ? {
                name: "header",
                fn: ce(() => [
                  xe(G.$slots, `${Ce.type}-overlay-header`, {
                    toggle: () => we(Ce.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : E("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), xF = { class: "dp--tp-wrap" }, TF = ["aria-label", "tabindex"], wF = ["tabindex"], kF = ["aria-label"], sy = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Fa
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { buildMatrix: r, setTimePicker: s } = rr(), o = nr(), { defaultedTransitions: l, defaultedAriaLabels: c, defaultedTextInput: d, defaultedConfig: f, defaultedRange: g } = jt(i), { transitionName: _, showTransition: x } = Nl(l), { hideNavigationButtons: p } = ed(), w = J(null), C = J(null), M = J([]), A = J(null);
    ht(() => {
      a("mount"), !i.timePicker && i.arrowNavigation ? r([on(w.value)], "time") : s(!0, i.timePicker);
    });
    const L = I(() => g.value.enabled && i.modelAuto ? jv(i.internalModelValue) : !0), D = J(!1), B = (R) => ({
      hours: Array.isArray(i.hours) ? i.hours[R] : i.hours,
      minutes: Array.isArray(i.minutes) ? i.minutes[R] : i.minutes,
      seconds: Array.isArray(i.seconds) ? i.seconds[R] : i.seconds
    }), P = I(() => {
      const R = [];
      if (g.value.enabled)
        for (let de = 0; de < 2; de++)
          R.push(B(de));
      else
        R.push(B(0));
      return R;
    }), z = (R, de = !1, Le = "") => {
      de || a("reset-flow"), D.value = R, a(R ? "overlay-opened" : "overlay-closed", Cn.time), i.arrowNavigation && s(R), Dn(() => {
        Le !== "" && M.value[0] && M.value[0].openChildCmp(Le);
      });
    }, W = I(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: i.autoApply && !f.value.keepActionRow
    })), q = ca(o, "timePicker"), V = (R, de, Le) => g.value.enabled ? de === 0 ? [R, P.value[1][Le]] : [P.value[0][Le], R] : R, re = (R) => {
      a("update:hours", R);
    }, ie = (R) => {
      a("update:minutes", R);
    }, K = (R) => {
      a("update:seconds", R);
    }, $ = () => {
      if (A.value && !d.value.enabled && !i.noOverlayFocus) {
        const R = Vv(A.value);
        R && R.focus({ preventScroll: !0 });
      }
    }, X = (R) => {
      a("overlay-closed", R);
    };
    return e({ toggleTimePicker: z }), (R, de) => {
      var Le;
      return h(), b("div", xF, [
        !R.timePicker && !R.timePickerInline ? kt((h(), b("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: w,
          type: "button",
          class: se(W.value),
          "aria-label": (Le = O(c)) == null ? void 0 : Le.openTimePicker,
          tabindex: R.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: de[0] || (de[0] = (Ie) => O(Kn)(Ie, () => z(!0))),
          onClick: de[1] || (de[1] = (Ie) => z(!0))
        }, [
          R.$slots["clock-icon"] ? xe(R.$slots, "clock-icon", { key: 0 }) : E("", !0),
          R.$slots["clock-icon"] ? E("", !0) : (h(), Z(O(df), { key: 1 }))
        ], 42, TF)), [
          [ga, !O(p)(R.hideNavigation, "time")]
        ]) : E("", !0),
        Q(Fr, {
          name: O(_)(D.value),
          css: O(x) && !R.timePickerInline
        }, {
          default: ce(() => {
            var Ie;
            return [
              D.value || R.timePicker || R.timePickerInline ? (h(), b("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: A,
                class: se({
                  dp__overlay: !R.timePickerInline,
                  "dp--overlay-absolute": !i.timePicker && !R.timePickerInline,
                  "dp--overlay-relative": i.timePicker
                }),
                style: bn(R.timePicker ? { height: `${O(f).modeHeight}px` } : void 0),
                tabindex: R.timePickerInline ? void 0 : 0
              }, [
                k("div", {
                  class: se(
                    R.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  R.$slots["time-picker-overlay"] ? xe(R.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: re,
                    setMinutes: ie,
                    setSeconds: K
                  }) : E("", !0),
                  R.$slots["time-picker-overlay"] ? E("", !0) : (h(), b("div", {
                    key: 1,
                    class: se(R.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (h(!0), b(me, null, Ee(P.value, (Ve, te) => kt((h(), Z(_F, $t({
                      key: te,
                      ref_for: !0
                    }, {
                      ...R.$props,
                      order: te,
                      hours: Ve.hours,
                      minutes: Ve.minutes,
                      seconds: Ve.seconds,
                      closeTimePickerBtn: C.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: te === 0 ? R.fixedStart : R.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: M,
                      "validate-time": (we, H) => t.validateTime(we, V(H, te, we)),
                      "onUpdate:hours": (we) => re(V(we, te, "hours")),
                      "onUpdate:minutes": (we) => ie(V(we, te, "minutes")),
                      "onUpdate:seconds": (we) => K(V(we, te, "seconds")),
                      onMounted: $,
                      onOverlayClosed: X,
                      onOverlayOpened: de[2] || (de[2] = (we) => R.$emit("overlay-opened", we)),
                      onAmPmChange: de[3] || (de[3] = (we) => R.$emit("am-pm-change", we))
                    }), rn({ _: 2 }, [
                      Ee(O(q), (we, H) => ({
                        name: we,
                        fn: ce((pe) => [
                          xe(R.$slots, we, $t({ ref_for: !0 }, pe))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [ga, te === 0 ? !0 : L.value]
                    ])), 128))
                  ], 2)),
                  !R.timePicker && !R.timePickerInline ? kt((h(), b("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: C,
                    type: "button",
                    class: se(W.value),
                    "aria-label": (Ie = O(c)) == null ? void 0 : Ie.closeTimePicker,
                    tabindex: "0",
                    onKeydown: de[4] || (de[4] = (Ve) => O(Kn)(Ve, () => z(!1))),
                    onClick: de[5] || (de[5] = (Ve) => z(!1))
                  }, [
                    R.$slots["calendar-icon"] ? xe(R.$slots, "calendar-icon", { key: 0 }) : E("", !0),
                    R.$slots["calendar-icon"] ? E("", !0) : (h(), Z(O(no), { key: 1 }))
                  ], 42, kF)), [
                    [ga, !O(p)(R.hideNavigation, "time")]
                  ]) : E("", !0)
                ], 2)
              ], 14, wF)) : E("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), oy = (t, e, n, a) => {
  const { defaultedRange: i } = jt(t), r = (A, L) => Array.isArray(e[A]) ? e[A][L] : e[A], s = (A) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[A] : e.seconds : 0, o = (A, L) => A ? L !== void 0 ? Zi(A, r("hours", L), r("minutes", L), s(L)) : Zi(A, e.hours, e.minutes, s()) : zv(De(), s(L)), l = (A, L) => {
    e[A] = L;
  }, c = I(() => t.modelAuto && i.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : i.value.enabled), d = (A, L) => {
    const D = Object.fromEntries(
      Object.keys(e).map((B) => B === A ? [B, L] : [B, e[B]].slice())
    );
    if (c.value && !i.value.disableTimeRangeValidation) {
      const B = (z) => n.value ? Zi(
        n.value[z],
        D.hours[z],
        D.minutes[z],
        D.seconds[z]
      ) : null, P = (z) => Fv(n.value[z], 0);
      return !(ft(B(0), B(1)) && (Is(B(0), P(1)) || _l(B(1), P(0))));
    }
    return !0;
  }, f = (A, L) => {
    d(A, L) && (l(A, L), a && a());
  }, g = (A) => {
    f("hours", A);
  }, _ = (A) => {
    f("minutes", A);
  }, x = (A) => {
    f("seconds", A);
  }, p = (A, L, D, B) => {
    L && g(A), !L && !D && _(A), D && x(A), n.value && B(n.value);
  }, w = (A) => {
    if (A) {
      const L = Array.isArray(A), D = L ? [+A[0].hours, +A[1].hours] : +A.hours, B = L ? [+A[0].minutes, +A[1].minutes] : +A.minutes, P = L ? [+A[0].seconds, +A[1].seconds] : +A.seconds;
      l("hours", D), l("minutes", B), t.enableSeconds && l("seconds", P);
    }
  }, C = (A, L) => {
    const D = {
      hours: Array.isArray(e.hours) ? e.hours[A] : e.hours,
      disabledArr: []
    };
    return (L || L === 0) && (D.hours = L), Array.isArray(t.disabledTimes) && (D.disabledArr = i.value.enabled && Array.isArray(t.disabledTimes[A]) ? t.disabledTimes[A] : t.disabledTimes), D;
  }, M = I(() => (A, L) => {
    var D;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: B, hours: P } = C(A, L), z = B.filter((W) => +W.hours === P);
      return ((D = z[0]) == null ? void 0 : D.minutes) === "*" ? { hours: [P], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (z == null ? void 0 : z.map((W) => +W.minutes)) ?? [],
        seconds: (z == null ? void 0 : z.map((W) => W.seconds ? +W.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: g,
    updateMinutes: _,
    updateSeconds: x,
    getSetDateTime: o,
    updateTimeValues: p,
    getSecondsValue: s,
    assignStartTime: w,
    validateTime: d,
    disabledTimesConfig: M
  };
}, SF = (t, e) => {
  const n = () => {
    t.isTextInputDate && L();
  }, { modelValue: a, time: i } = $l(t, e, n), { defaultedStartTime: r, defaultedRange: s, defaultedTz: o } = jt(t), { updateTimeValues: l, getSetDateTime: c, setTime: d, assignStartTime: f, disabledTimesConfig: g, validateTime: _ } = oy(t, i, a, x);
  function x() {
    e("update-flow-step");
  }
  const p = (B) => {
    const { hours: P, minutes: z, seconds: W } = B;
    return { hours: +P, minutes: +z, seconds: W ? +W : 0 };
  }, w = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const P = p(t.startTime[0]), z = p(t.startTime[1]);
        return [St(De(), P), St(De(), z)];
      }
      const B = p(t.startTime);
      return St(De(), B);
    }
    return s.value.enabled ? [null, null] : null;
  }, C = () => {
    if (s.value.enabled) {
      const [B, P] = w();
      a.value = [
        Jn(c(B, 0), o.value.timezone),
        Jn(c(P, 1), o.value.timezone)
      ];
    } else
      a.value = Jn(c(w()), o.value.timezone);
  }, M = (B) => Array.isArray(B) ? [Cr(De(B[0])), Cr(De(B[1]))] : [Cr(B ?? De())], A = (B, P, z) => {
    d("hours", B), d("minutes", P), d("seconds", t.enableSeconds ? z : 0);
  }, L = () => {
    const [B, P] = M(a.value);
    return s.value.enabled ? A(
      [B.hours, P.hours],
      [B.minutes, P.minutes],
      [B.seconds, P.seconds]
    ) : A(B.hours, B.minutes, B.seconds);
  };
  ht(() => {
    if (!t.shadow)
      return f(r.value), a.value ? L() : C();
  });
  const D = () => {
    Array.isArray(a.value) ? a.value = a.value.map((B, P) => B && c(B, P)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: i,
    disabledTimesConfig: g,
    updateTime: (B, P = !0, z = !1) => {
      l(B, P, z, D);
    },
    validateTime: _
  };
}, CF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = nr(), s = ca(r, "timePicker"), o = J(null), { time: l, modelValue: c, disabledTimesConfig: d, updateTime: f, validateTime: g } = SF(i, a);
    return ht(() => {
      i.shadow || a("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: c,
      time: l,
      updateTime: f
    }), toggleTimePicker: (_, x = !1, p = "") => {
      var w;
      (w = o.value) == null || w.toggleTimePicker(_, x, p);
    } }), (_, x) => (h(), Z(Qu, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ce(() => [
        Q(sy, $t({
          ref_key: "tpRef",
          ref: o
        }, _.$props, {
          hours: O(l).hours,
          minutes: O(l).minutes,
          seconds: O(l).seconds,
          "internal-model-value": _.internalModelValue,
          "disabled-times-config": O(d),
          "validate-time": O(g),
          "onUpdate:hours": x[0] || (x[0] = (p) => O(f)(p)),
          "onUpdate:minutes": x[1] || (x[1] = (p) => O(f)(p, !1)),
          "onUpdate:seconds": x[2] || (x[2] = (p) => O(f)(p, !1, !0)),
          onAmPmChange: x[3] || (x[3] = (p) => _.$emit("am-pm-change", p)),
          onResetFlow: x[4] || (x[4] = (p) => _.$emit("reset-flow")),
          onOverlayClosed: x[5] || (x[5] = (p) => _.$emit("overlay-toggle", { open: !1, overlay: p })),
          onOverlayOpened: x[6] || (x[6] = (p) => _.$emit("overlay-toggle", { open: !0, overlay: p }))
        }), rn({ _: 2 }, [
          Ee(O(s), (p, w) => ({
            name: p,
            fn: ce((C) => [
              xe(_.$slots, p, ln(Un(C)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), AF = { class: "dp--header-wrap" }, EF = {
  key: 0,
  class: "dp__month_year_wrap"
}, LF = { key: 0 }, DF = { class: "dp__month_year_wrap" }, IF = ["aria-label", "data-test", "onClick", "onKeydown"], MF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Fa
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      defaultedTransitions: r,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: o,
      defaultedFilters: l,
      defaultedConfig: c,
      defaultedHighlight: d,
      propDates: f,
      defaultedUI: g
    } = jt(i), { transitionName: _, showTransition: x } = Nl(r), { buildMatrix: p } = rr(), { handleMonthYearChange: w, isDisabled: C, updateMonthYear: M } = Z$(i, a), { showLeftIcon: A, showRightIcon: L } = ed(), D = J(!1), B = J(!1), P = J([null, null, null, null]);
    ht(() => {
      a("mount");
    });
    const z = (te) => ({
      get: () => i[te],
      set: (we) => {
        const H = te === Ca.month ? Ca.year : Ca.month;
        a("update-month-year", { [te]: we, [H]: i[H] }), te === Ca.month ? X(!0) : R(!0);
      }
    }), W = I(z(Ca.month)), q = I(z(Ca.year)), V = I(() => (te) => ({
      month: i.month,
      year: i.year,
      items: te === Ca.month ? i.months : i.years,
      instance: i.instance,
      updateMonthYear: M,
      toggle: te === Ca.month ? X : R
    })), re = I(() => i.months.find((we) => we.value === i.month) || { text: "", value: 0 }), ie = I(() => Os(i.months, (te) => {
      const we = i.month === te.value, H = xl(
        te.value,
        Wv(i.year, f.value.minDate),
        Gv(i.year, f.value.maxDate)
      ) || l.value.months.includes(te.value), pe = Jv(d.value, te.value, i.year);
      return { active: we, disabled: H, highlighted: pe };
    })), K = I(() => Os(i.years, (te) => {
      const we = i.year === te.value, H = xl(
        te.value,
        Ps(f.value.minDate),
        Ps(f.value.maxDate)
      ) || l.value.years.includes(te.value), pe = vf(d.value, te.value);
      return { active: we, disabled: H, highlighted: pe };
    })), $ = (te, we, H) => {
      H !== void 0 ? te.value = H : te.value = !te.value, te.value ? a("overlay-opened", we) : a("overlay-closed", we);
    }, X = (te = !1, we) => {
      de(te), $(D, Cn.month, we);
    }, R = (te = !1, we) => {
      de(te), $(B, Cn.year, we);
    }, de = (te) => {
      te || a("reset-flow");
    }, Le = (te, we) => {
      i.arrowNavigation && (P.value[we] = on(te), p(P.value, "monthYear"));
    }, Ie = I(() => {
      var te, we;
      return [
        {
          type: Ca.month,
          index: 1,
          toggle: X,
          modelValue: W.value,
          updateModelValue: (H) => W.value = H,
          text: re.value.text,
          showSelectionGrid: D.value,
          items: ie.value,
          ariaLabel: (te = s.value) == null ? void 0 : te.openMonthsOverlay
        },
        {
          type: Ca.year,
          index: 2,
          toggle: R,
          modelValue: q.value,
          updateModelValue: (H) => q.value = H,
          text: qv(i.year, i.locale),
          showSelectionGrid: B.value,
          items: K.value,
          ariaLabel: (we = s.value) == null ? void 0 : we.openYearsOverlay
        }
      ];
    }), Ve = I(() => i.disableYearSelect ? [Ie.value[0]] : i.yearFirst ? [...Ie.value].reverse() : Ie.value);
    return e({
      toggleMonthPicker: X,
      toggleYearPicker: R,
      handleMonthYearChange: w
    }), (te, we) => {
      var H, pe, Ne, ee, ze, et;
      return h(), b("div", AF, [
        te.$slots["month-year"] ? (h(), b("div", EF, [
          xe(te.$slots, "month-year", ln(Un({ month: t.month, year: t.year, months: t.months, years: t.years, updateMonthYear: O(M), handleMonthYearChange: O(w), instance: t.instance })))
        ])) : (h(), b(me, { key: 1 }, [
          te.$slots["top-extra"] ? (h(), b("div", LF, [
            xe(te.$slots, "top-extra", { value: te.internalModelValue })
          ])) : E("", !0),
          k("div", DF, [
            O(A)(O(o), t.instance) && !te.vertical ? (h(), Z(rl, {
              key: 0,
              "aria-label": (H = O(s)) == null ? void 0 : H.prevMonth,
              disabled: O(C)(!1),
              class: se((pe = O(g)) == null ? void 0 : pe.navBtnPrev),
              onActivate: we[0] || (we[0] = (Te) => O(w)(!1, !0)),
              onSetRef: we[1] || (we[1] = (Te) => Le(Te, 0))
            }, {
              default: ce(() => [
                te.$slots["arrow-left"] ? xe(te.$slots, "arrow-left", { key: 0 }) : E("", !0),
                te.$slots["arrow-left"] ? E("", !0) : (h(), Z(O(cf), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : E("", !0),
            k("div", {
              class: se(["dp__month_year_wrap", {
                dp__year_disable_select: te.disableYearSelect
              }])
            }, [
              (h(!0), b(me, null, Ee(Ve.value, (Te, Qe) => (h(), b(me, {
                key: Te.type
              }, [
                k("button", {
                  ref_for: !0,
                  ref: (G) => Le(G, Qe + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": Te.ariaLabel,
                  "data-test": `${Te.type}-toggle-overlay-${t.instance}`,
                  onClick: Te.toggle,
                  onKeydown: (G) => O(Kn)(G, () => Te.toggle(), !0)
                }, [
                  te.$slots[Te.type] ? xe(te.$slots, Te.type, {
                    key: 0,
                    text: Te.text,
                    value: i[Te.type]
                  }) : E("", !0),
                  te.$slots[Te.type] ? E("", !0) : (h(), b(me, { key: 1 }, [
                    Ye(ae(Te.text), 1)
                  ], 64))
                ], 40, IF),
                Q(Fr, {
                  name: O(_)(Te.showSelectionGrid),
                  css: O(x)
                }, {
                  default: ce(() => [
                    Te.showSelectionGrid ? (h(), Z(Rl, {
                      key: 0,
                      items: Te.items,
                      "arrow-navigation": te.arrowNavigation,
                      "hide-navigation": te.hideNavigation,
                      "is-last": te.autoApply && !O(c).keepActionRow,
                      "skip-button-ref": !1,
                      config: te.config,
                      type: Te.type,
                      "header-refs": [],
                      "esc-close": te.escClose,
                      "menu-wrap-ref": te.menuWrapRef,
                      "text-input": te.textInput,
                      "aria-labels": te.ariaLabels,
                      onSelected: Te.updateModelValue,
                      onToggle: Te.toggle
                    }, rn({
                      "button-icon": ce(() => [
                        te.$slots["calendar-icon"] ? xe(te.$slots, "calendar-icon", { key: 0 }) : E("", !0),
                        te.$slots["calendar-icon"] ? E("", !0) : (h(), Z(O(no), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      te.$slots[`${Te.type}-overlay-value`] ? {
                        name: "item",
                        fn: ce(({ item: G }) => [
                          xe(te.$slots, `${Te.type}-overlay-value`, {
                            text: G.text,
                            value: G.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      te.$slots[`${Te.type}-overlay`] ? {
                        name: "overlay",
                        fn: ce(() => [
                          xe(te.$slots, `${Te.type}-overlay`, $t({ ref_for: !0 }, V.value(Te.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      te.$slots[`${Te.type}-overlay-header`] ? {
                        name: "header",
                        fn: ce(() => [
                          xe(te.$slots, `${Te.type}-overlay-header`, {
                            toggle: Te.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : E("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            O(A)(O(o), t.instance) && te.vertical ? (h(), Z(rl, {
              key: 1,
              "aria-label": (Ne = O(s)) == null ? void 0 : Ne.prevMonth,
              disabled: O(C)(!1),
              class: se((ee = O(g)) == null ? void 0 : ee.navBtnPrev),
              onActivate: we[2] || (we[2] = (Te) => O(w)(!1, !0))
            }, {
              default: ce(() => [
                te.$slots["arrow-up"] ? xe(te.$slots, "arrow-up", { key: 0 }) : E("", !0),
                te.$slots["arrow-up"] ? E("", !0) : (h(), Z(O(hf), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : E("", !0),
            O(L)(O(o), t.instance) ? (h(), Z(rl, {
              key: 2,
              ref: "rightIcon",
              disabled: O(C)(!0),
              "aria-label": (ze = O(s)) == null ? void 0 : ze.nextMonth,
              class: se((et = O(g)) == null ? void 0 : et.navBtnNext),
              onActivate: we[3] || (we[3] = (Te) => O(w)(!0, !0)),
              onSetRef: we[4] || (we[4] = (Te) => Le(Te, te.disableYearSelect ? 2 : 3))
            }, {
              default: ce(() => [
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? xe(te.$slots, te.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : E("", !0),
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? E("", !0) : (h(), Z(ut(te.vertical ? O(ff) : O(uf)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : E("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), OF = ["aria-label"], PF = {
  class: "dp__calendar_header",
  role: "row"
}, BF = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, RF = ["aria-label"], NF = /* @__PURE__ */ k("div", { class: "dp__calendar_header_separator" }, null, -1), $F = ["aria-label"], FF = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, zF = { class: "dp__cell_inner" }, UF = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], HF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Fa
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, { buildMultiLevelMatrix: r } = rr(), {
      defaultedTransitions: s,
      defaultedConfig: o,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: c,
      defaultedWeekNumbers: d,
      defaultedMultiDates: f,
      defaultedUI: g
    } = jt(i), _ = J(null), x = J({
      bottom: "",
      left: "",
      transform: ""
    }), p = J([]), w = J(null), C = J(!0), M = J(""), A = J({ startX: 0, endX: 0, startY: 0, endY: 0 }), L = J([]), D = J({ left: "50%" }), B = J(!1), P = I(() => i.calendar ? i.calendar(i.mappedDates) : i.mappedDates), z = I(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames(i.locale, +i.weekStart) : b$(i.formatLocale, i.locale, +i.weekStart));
    ht(() => {
      a("mount", { cmp: "calendar", refs: p }), o.value.noSwipe || w.value && (w.value.addEventListener("touchstart", Le, { passive: !1 }), w.value.addEventListener("touchend", Ie, { passive: !1 }), w.value.addEventListener("touchmove", Ve, { passive: !1 })), i.monthChangeOnScroll && w.value && w.value.addEventListener("wheel", H, { passive: !1 });
    });
    const W = (Te) => Te ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", q = (Te, Qe) => {
      if (i.transitions) {
        const G = Hn(vi(De(), i.month, i.year));
        M.value = Kt(Hn(vi(De(), Te, Qe)), G) ? s.value[W(!0)] : s.value[W(!1)], C.value = !1, Dn(() => {
          C.value = !0;
        });
      }
    }, V = I(
      () => ({
        [i.calendarClassName]: !!i.calendarClassName,
        ...g.value.calendar ?? {}
      })
    ), re = I(() => (Te) => {
      const Qe = y$(Te);
      return {
        dp__marker_dot: Qe.type === "dot",
        dp__marker_line: Qe.type === "line"
      };
    }), ie = I(() => (Te) => ft(Te, _.value)), K = I(() => ({
      dp__calendar: !0,
      dp__calendar_next: c.value.count > 0 && i.instance !== 0
    })), $ = I(() => (Te) => i.hideOffsetDates ? Te.current : !0), X = async (Te, Qe, G) => {
      const Se = on(p.value[Qe][G]);
      if (Se) {
        const { width: he, height: Ce } = Se.getBoundingClientRect();
        _.value = Te.value;
        let _e = { left: `${he / 2}px` }, tt = -50;
        if (await Dn(), L.value[0]) {
          const { left: oe, width: Oe } = L.value[0].getBoundingClientRect();
          oe < 0 && (_e = { left: "0" }, tt = 0, D.value.left = `${he / 2}px`), window.innerWidth < oe + Oe && (_e = { right: "0" }, tt = 0, D.value.left = `${Oe - he / 2}px`);
        }
        x.value = {
          bottom: `${Ce}px`,
          ..._e,
          transform: `translateX(${tt}%)`
        }, a("tooltip-open", Te.marker);
      }
    }, R = async (Te, Qe, G) => {
      var Se, he;
      if (B.value && f.value.enabled && f.value.dragSelect)
        return a("select-date", Te);
      a("set-hover-date", Te), (he = (Se = Te.marker) == null ? void 0 : Se.tooltip) != null && he.length && await X(Te, Qe, G);
    }, de = (Te) => {
      _.value && (_.value = null, x.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", Te.marker));
    }, Le = (Te) => {
      A.value.startX = Te.changedTouches[0].screenX, A.value.startY = Te.changedTouches[0].screenY;
    }, Ie = (Te) => {
      A.value.endX = Te.changedTouches[0].screenX, A.value.endY = Te.changedTouches[0].screenY, te();
    }, Ve = (Te) => {
      i.vertical && !i.inline && Te.preventDefault();
    }, te = () => {
      const Te = i.vertical ? "Y" : "X";
      Math.abs(A.value[`start${Te}`] - A.value[`end${Te}`]) > 10 && a("handle-swipe", A.value[`start${Te}`] > A.value[`end${Te}`] ? "right" : "left");
    }, we = (Te, Qe, G) => {
      Te && (Array.isArray(p.value[Qe]) ? p.value[Qe][G] = Te : p.value[Qe] = [Te]), i.arrowNavigation && r(p.value, "calendar");
    }, H = (Te) => {
      i.monthChangeOnScroll && (Te.preventDefault(), a("handle-scroll", Te));
    }, pe = (Te) => d.value.type === "local" ? sf(Te.value, { weekStartsOn: +i.weekStart }) : d.value.type === "iso" ? af(Te.value) : typeof d.value.type == "function" ? d.value.type(Te.value) : "", Ne = (Te) => {
      const Qe = Te[0];
      return d.value.hideOnOffsetDates ? Te.some((G) => G.current) ? pe(Qe) : "" : pe(Qe);
    }, ee = (Te, Qe) => {
      f.value.enabled || (Xi(Te, o.value), a("select-date", Qe));
    }, ze = (Te) => {
      Xi(Te, o.value);
    }, et = (Te) => {
      f.value.enabled && f.value.dragSelect ? (B.value = !0, a("select-date", Te)) : f.value.enabled && a("select-date", Te);
    };
    return e({ triggerTransition: q }), (Te, Qe) => {
      var G;
      return h(), b("div", {
        class: se(K.value)
      }, [
        k("div", {
          ref_key: "calendarWrapRef",
          ref: w,
          role: "grid",
          class: se(V.value),
          "aria-label": (G = O(l)) == null ? void 0 : G.calendarWrap
        }, [
          k("div", PF, [
            Te.weekNumbers ? (h(), b("div", BF, ae(Te.weekNumName), 1)) : E("", !0),
            (h(!0), b(me, null, Ee(z.value, (Se, he) => {
              var Ce, _e;
              return h(), b("div", {
                key: he,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (_e = (Ce = O(l)) == null ? void 0 : Ce.weekDay) == null ? void 0 : _e.call(Ce, he)
              }, [
                Te.$slots["calendar-header"] ? xe(Te.$slots, "calendar-header", {
                  key: 0,
                  day: Se,
                  index: he
                }) : E("", !0),
                Te.$slots["calendar-header"] ? E("", !0) : (h(), b(me, { key: 1 }, [
                  Ye(ae(Se), 1)
                ], 64))
              ], 8, RF);
            }), 128))
          ]),
          NF,
          Q(Fr, {
            name: M.value,
            css: !!Te.transitions
          }, {
            default: ce(() => {
              var Se;
              return [
                C.value ? (h(), b("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((Se = O(l)) == null ? void 0 : Se.calendarDays) || void 0,
                  onMouseleave: Qe[1] || (Qe[1] = (he) => B.value = !1)
                }, [
                  (h(!0), b(me, null, Ee(P.value, (he, Ce) => (h(), b("div", {
                    key: Ce,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    Te.weekNumbers ? (h(), b("div", FF, [
                      k("div", zF, ae(Ne(he.days)), 1)
                    ])) : E("", !0),
                    (h(!0), b(me, null, Ee(he.days, (_e, tt) => {
                      var oe, Oe, Re;
                      return h(), b("div", {
                        id: O(ey)(_e.value),
                        ref_for: !0,
                        ref: (lt) => we(lt, Ce, tt),
                        key: tt + Ce,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (_e.classData.dp__active_date || _e.classData.dp__range_start || _e.classData.dp__range_start) ?? void 0,
                        "aria-disabled": _e.classData.dp__cell_disabled || void 0,
                        "aria-label": (Oe = (oe = O(l)) == null ? void 0 : oe.day) == null ? void 0 : Oe.call(oe, _e),
                        tabindex: "0",
                        "data-test": _e.value,
                        onClick: Ba((lt) => ee(lt, _e), ["prevent"]),
                        onKeydown: (lt) => O(Kn)(lt, () => Te.$emit("select-date", _e)),
                        onMouseenter: (lt) => R(_e, Ce, tt),
                        onMouseleave: (lt) => de(_e),
                        onMousedown: (lt) => et(_e),
                        onMouseup: Qe[0] || (Qe[0] = (lt) => B.value = !1)
                      }, [
                        k("div", {
                          class: se(["dp__cell_inner", _e.classData])
                        }, [
                          Te.$slots.day && $.value(_e) ? xe(Te.$slots, "day", {
                            key: 0,
                            day: +_e.text,
                            date: _e.value
                          }) : E("", !0),
                          Te.$slots.day ? E("", !0) : (h(), b(me, { key: 1 }, [
                            Ye(ae(_e.text), 1)
                          ], 64)),
                          _e.marker && $.value(_e) ? (h(), b(me, { key: 2 }, [
                            Te.$slots.marker ? xe(Te.$slots, "marker", {
                              key: 0,
                              marker: _e.marker,
                              day: +_e.text,
                              date: _e.value
                            }) : (h(), b("div", {
                              key: 1,
                              class: se(re.value(_e.marker)),
                              style: bn(_e.marker.color ? { backgroundColor: _e.marker.color } : {})
                            }, null, 6))
                          ], 64)) : E("", !0),
                          ie.value(_e.value) ? (h(), b("div", {
                            key: 3,
                            ref_for: !0,
                            ref_key: "activeTooltip",
                            ref: L,
                            class: "dp__marker_tooltip",
                            style: bn(x.value)
                          }, [
                            (Re = _e.marker) != null && Re.tooltip ? (h(), b("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: ze
                            }, [
                              (h(!0), b(me, null, Ee(_e.marker.tooltip, (lt, Mt) => (h(), b("div", {
                                key: Mt,
                                class: "dp__tooltip_text"
                              }, [
                                Te.$slots["marker-tooltip"] ? xe(Te.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: lt,
                                  day: _e.value
                                }) : E("", !0),
                                Te.$slots["marker-tooltip"] ? E("", !0) : (h(), b(me, { key: 1 }, [
                                  k("div", {
                                    class: "dp__tooltip_mark",
                                    style: bn(lt.color ? { backgroundColor: lt.color } : {})
                                  }, null, 4),
                                  k("div", null, ae(lt.text), 1)
                                ], 64))
                              ]))), 128)),
                              k("div", {
                                class: "dp__arrow_bottom_tp",
                                style: bn(D.value)
                              }, null, 4)
                            ])) : E("", !0)
                          ], 4)) : E("", !0)
                        ], 2)
                      ], 40, UF);
                    }), 128))
                  ]))), 128))
                ], 40, $F)) : E("", !0)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, OF)
      ], 2);
    };
  }
}), B1 = (t) => Array.isArray(t), YF = (t, e, n, a) => {
  const i = J([]), r = J(/* @__PURE__ */ new Date()), s = J(), o = () => Ie(t.isTextInputDate), { modelValue: l, calendars: c, time: d, today: f } = $l(t, e, o), {
    defaultedMultiCalendars: g,
    defaultedStartTime: _,
    defaultedRange: x,
    defaultedConfig: p,
    defaultedTz: w,
    propDates: C,
    defaultedMultiDates: M
  } = jt(t), { validateMonthYearInRange: A, isDisabled: L, isDateRangeAllowed: D, checkMinMaxRange: B } = sr(t), { updateTimeValues: P, getSetDateTime: z, setTime: W, assignStartTime: q, validateTime: V, disabledTimesConfig: re } = oy(t, d, l, a), ie = I(
    () => (ue) => c.value[ue] ? c.value[ue].month : 0
  ), K = I(
    () => (ue) => c.value[ue] ? c.value[ue].year : 0
  ), $ = (ue) => !p.value.keepViewOnOffsetClick || ue ? !0 : !s.value, X = (ue, Pe, ye, Be = !1) => {
    var Ue, _n;
    $(Be) && (c.value[ue] || (c.value[ue] = { month: 0, year: 0 }), c.value[ue].month = D1(Pe) ? (Ue = c.value[ue]) == null ? void 0 : Ue.month : Pe, c.value[ue].year = D1(ye) ? (_n = c.value[ue]) == null ? void 0 : _n.year : ye);
  }, R = () => {
    t.autoApply && e("select-date");
  };
  ht(() => {
    t.shadow || (l.value || (Qe(), _.value && q(_.value)), Ie(!0), t.focusStartDate && t.startDate && Qe());
  });
  const de = I(() => {
    var ue;
    return (ue = t.flow) != null && ue.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), Le = () => {
    t.autoApply && de.value && e("auto-apply");
  }, Ie = (ue = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (i.value = l.value, ee(ue)) : we(l.value, ue);
    if (g.value.count && ue && !t.startDate)
      return te(De(), ue);
  }, Ve = () => Array.isArray(l.value) && x.value.enabled ? dt(l.value[0]) === dt(l.value[1] ?? l.value[0]) : !1, te = (ue = /* @__PURE__ */ new Date(), Pe = !1) => {
    if ((!g.value.count || !g.value.static || Pe) && X(0, dt(ue), nt(ue)), g.value.count && (!g.value.solo || !l.value || Ve()))
      for (let ye = 1; ye < g.value.count; ye++) {
        const Be = St(De(), { month: ie.value(ye - 1), year: K.value(ye - 1) }), Ue = xv(Be, { months: 1 });
        c.value[ye] = { month: dt(Ue), year: nt(Ue) };
      }
  }, we = (ue, Pe) => {
    te(ue), W("hours", Ti(ue)), W("minutes", Ji(ue)), W("seconds", Ds(ue)), g.value.count && Pe && Te();
  }, H = (ue) => {
    if (g.value.count) {
      if (g.value.solo) return 0;
      const Pe = dt(ue[0]), ye = dt(ue[1]);
      return Math.abs(ye - Pe) < g.value.count ? 0 : 1;
    }
    return 1;
  }, pe = (ue, Pe) => {
    ue[1] && x.value.showLastInRange ? te(ue[H(ue)], Pe) : te(ue[0], Pe);
    const ye = (Be, Ue) => [
      Be(ue[0]),
      ue[1] ? Be(ue[1]) : d[Ue][1]
    ];
    W("hours", ye(Ti, "hours")), W("minutes", ye(Ji, "minutes")), W("seconds", ye(Ds, "seconds"));
  }, Ne = (ue, Pe) => {
    if ((x.value.enabled || t.weekPicker) && !M.value.enabled)
      return pe(ue, Pe);
    if (M.value.enabled && Pe) {
      const ye = ue[ue.length - 1];
      return we(ye, Pe);
    }
  }, ee = (ue) => {
    const Pe = l.value;
    Ne(Pe, ue), g.value.count && g.value.solo && Te();
  }, ze = (ue, Pe) => {
    const ye = St(De(), { month: ie.value(Pe), year: K.value(Pe) }), Be = ue < 0 ? Ma(ye, 1) : Ms(ye, 1);
    A(dt(Be), nt(Be), ue < 0, t.preventMinMaxNavigation) && (X(Pe, dt(Be), nt(Be)), e("update-month-year", { instance: Pe, month: dt(Be), year: nt(Be) }), g.value.count && !g.value.solo && et(Pe), n());
  }, et = (ue) => {
    for (let Pe = ue - 1; Pe >= 0; Pe--) {
      const ye = Ms(St(De(), { month: ie.value(Pe + 1), year: K.value(Pe + 1) }), 1);
      X(Pe, dt(ye), nt(ye));
    }
    for (let Pe = ue + 1; Pe <= g.value.count - 1; Pe++) {
      const ye = Ma(St(De(), { month: ie.value(Pe - 1), year: K.value(Pe - 1) }), 1);
      X(Pe, dt(ye), nt(ye));
    }
  }, Te = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const ue = De(
        De(l.value[1] ? l.value[1] : Ma(l.value[0], 1))
      ), [Pe, ye] = [dt(l.value[0]), nt(l.value[0])], [Be, Ue] = [dt(l.value[1]), nt(l.value[1])];
      (Pe !== Be || Pe === Be && ye !== Ue) && g.value.solo && X(1, dt(ue), nt(ue));
    } else l.value && !Array.isArray(l.value) && (X(0, dt(l.value), nt(l.value)), te(De()));
  }, Qe = () => {
    t.startDate && (X(0, dt(De(t.startDate)), nt(De(t.startDate))), g.value.count && et(0));
  }, G = (ue, Pe) => {
    if (t.monthChangeOnScroll) {
      const ye = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), Be = Math.abs(ue.deltaY);
      let Ue = 500;
      Be > 1 && (Ue = 100), Be > 100 && (Ue = 0), ye > Ue && (r.value = /* @__PURE__ */ new Date(), ze(t.monthChangeOnScroll !== "inverse" ? -ue.deltaY : ue.deltaY, Pe));
    }
  }, Se = (ue, Pe, ye = !1) => {
    t.monthChangeOnArrows && t.vertical === ye && he(ue, Pe);
  }, he = (ue, Pe) => {
    ze(ue === "right" ? -1 : 1, Pe);
  }, Ce = (ue) => {
    if (C.value.markers)
      return ru(ue.value, C.value.markers);
  }, _e = (ue, Pe) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [ue == 0, !0];
      case "fair":
        return [ue == 0 || Pe > ue, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, tt = (ue, Pe, ye, Be) => {
    if (t.sixWeeks && ue.length < 6) {
      const Ue = 6 - ue.length, _n = (Pe.getDay() + 7 - Be) % 7, Vn = 6 - (ye.getDay() + 7 - Be) % 7, [ui, Wr] = _e(_n, Vn);
      for (let Ii = 1; Ii <= Ue; Ii++)
        if (Wr ? !!(Ii % 2) == ui : ui) {
          const Ua = ue[0].days[0], bo = oe(Aa(Ua.value, -7), dt(Pe));
          ue.unshift({ days: bo });
        } else {
          const Ua = ue[ue.length - 1], bo = Ua.days[Ua.days.length - 1], Dd = oe(Aa(bo.value, 1), dt(Pe));
          ue.push({ days: Dd });
        }
    }
    return ue;
  }, oe = (ue, Pe) => {
    const ye = De(ue), Be = [];
    for (let Ue = 0; Ue < 7; Ue++) {
      const _n = Aa(ye, Ue), Vn = dt(_n) !== Pe;
      Be.push({
        text: t.hideOffsetDates && Vn ? "" : _n.getDate(),
        value: _n,
        current: !Vn,
        classData: {}
      });
    }
    return Be;
  }, Oe = (ue, Pe) => {
    const ye = [], Be = new Date(Pe, ue), Ue = new Date(Pe, ue + 1, 0), _n = t.weekStart, Vn = Ra(Be, { weekStartsOn: _n }), ui = (Wr) => {
      const Ii = oe(Wr, ue);
      if (ye.push({ days: Ii }), !ye[ye.length - 1].days.some(
        (Ua) => ft(Hn(Ua.value), Hn(Ue))
      )) {
        const Ua = Aa(Wr, 7);
        ui(Ua);
      }
    };
    return ui(Vn), tt(ye, Be, Ue, _n);
  }, Re = (ue) => {
    const Pe = Zi(De(ue.value), d.hours, d.minutes, hn());
    e("date-update", Pe), M.value.enabled ? yf(Pe, l, M.value.limit) : l.value = Pe, a(), Dn().then(() => {
      Le();
    });
  }, lt = (ue) => x.value.noDisabledRange ? Xv(i.value[0], ue).some((Pe) => L(Pe)) : !1, Mt = () => {
    i.value = l.value ? l.value.slice() : [], i.value.length === 2 && !(x.value.fixedStart || x.value.fixedEnd) && (i.value = []);
  }, We = (ue, Pe) => {
    const ye = [
      De(ue.value),
      Aa(De(ue.value), +x.value.autoRange)
    ];
    D(ye) ? (Pe && fa(ue.value), i.value = ye) : e("invalid-date", ue.value);
  }, fa = (ue) => {
    const Pe = dt(De(ue)), ye = nt(De(ue));
    if (X(0, Pe, ye), g.value.count > 0)
      for (let Be = 1; Be < g.value.count; Be++) {
        const Ue = A$(
          St(De(ue), { year: ie.value(Be - 1), month: K.value(Be - 1) })
        );
        X(Be, Ue.month, Ue.year);
      }
  }, jn = (ue) => {
    if (lt(ue.value) || !B(ue.value, l.value, x.value.fixedStart ? 0 : 1))
      return e("invalid-date", ue.value);
    i.value = iy(De(ue.value), l, e, x);
  }, li = (ue, Pe) => {
    if (Mt(), x.value.autoRange) return We(ue, Pe);
    if (x.value.fixedStart || x.value.fixedEnd) return jn(ue);
    i.value[0] ? B(De(ue.value), l.value) && !lt(ue.value) ? Vt(De(ue.value), De(i.value[0])) ? (i.value.unshift(De(ue.value)), e("range-end", i.value[0])) : (i.value[1] = De(ue.value), e("range-end", i.value[1])) : (t.autoApply && e("auto-apply-invalid", ue.value), e("invalid-date", ue.value)) : (i.value[0] = De(ue.value), e("range-start", i.value[0]));
  }, hn = (ue = !0) => t.enableSeconds ? Array.isArray(d.seconds) ? ue ? d.seconds[0] : d.seconds[1] : d.seconds : 0, ci = (ue) => {
    i.value[ue] = Zi(
      i.value[ue],
      d.hours[ue],
      d.minutes[ue],
      hn(ue !== 1)
    );
  }, Vr = () => {
    var ue, Pe;
    i.value[0] && i.value[1] && +((ue = i.value) == null ? void 0 : ue[0]) > +((Pe = i.value) == null ? void 0 : Pe[1]) && (i.value.reverse(), e("range-start", i.value[0]), e("range-end", i.value[1]));
  }, cr = () => {
    i.value.length && (i.value[0] && !i.value[1] ? ci(0) : (ci(0), ci(1), a()), Vr(), l.value = i.value.slice(), Ju(i.value, e, t.autoApply, t.modelAuto));
  }, qr = (ue, Pe = !1) => {
    if (L(ue.value) || !ue.current && t.hideOffsetDates) return e("invalid-date", ue.value);
    if (s.value = JSON.parse(JSON.stringify(ue)), !x.value.enabled) return Re(ue);
    B1(d.hours) && B1(d.minutes) && !M.value.enabled && (li(ue, Pe), cr());
  }, bt = (ue, Pe) => {
    var ye;
    X(ue, Pe.month, Pe.year, !0), g.value.count && !g.value.solo && et(ue), e("update-month-year", { instance: ue, month: Pe.month, year: Pe.year }), n(g.value.solo ? ue : void 0);
    const Be = (ye = t.flow) != null && ye.length ? t.flow[t.flowStep] : void 0;
    !Pe.fromNav && (Be === Cn.month || Be === Cn.year) && a();
  }, po = (ue, Pe) => {
    ay({
      value: ue,
      modelValue: l,
      range: x.value.enabled,
      timezone: Pe ? void 0 : w.value.timezone
    }), R(), t.multiCalendars && Dn().then(() => Ie(!0));
  }, Di = () => {
    const ue = pf(De(), w.value);
    x.value.enabled ? l.value && Array.isArray(l.value) && l.value[0] ? l.value = Vt(ue, l.value[0]) ? [ue, l.value[0]] : [l.value[0], ue] : l.value = [ue] : l.value = ue, R();
  }, mo = () => {
    if (Array.isArray(l.value))
      if (M.value.enabled) {
        const ue = go();
        l.value[l.value.length - 1] = z(ue);
      } else
        l.value = l.value.map((ue, Pe) => ue && z(ue, Pe));
    else
      l.value = z(l.value);
    e("time-update");
  }, go = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: c,
    modelValue: l,
    month: ie,
    year: K,
    time: d,
    disabledTimesConfig: re,
    today: f,
    validateTime: V,
    getCalendarDays: Oe,
    getMarker: Ce,
    handleScroll: G,
    handleSwipe: he,
    handleArrow: Se,
    selectDate: qr,
    updateMonthYear: bt,
    presetDate: po,
    selectCurrentDate: Di,
    updateTime: (ue, Pe = !0, ye = !1) => {
      P(ue, Pe, ye, mo);
    },
    assignMonthAndYear: te
  };
}, jF = { key: 0 }, VF = /* @__PURE__ */ Ae({
  __name: "DatePicker",
  props: {
    ...Fa
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      calendars: r,
      month: s,
      year: o,
      modelValue: l,
      time: c,
      disabledTimesConfig: d,
      today: f,
      validateTime: g,
      getCalendarDays: _,
      getMarker: x,
      handleArrow: p,
      handleScroll: w,
      handleSwipe: C,
      selectDate: M,
      updateMonthYear: A,
      presetDate: L,
      selectCurrentDate: D,
      updateTime: B,
      assignMonthAndYear: P
    } = YF(i, a, Ve, te), z = nr(), { setHoverDate: W, getDayClassData: q, clearHoverDate: V } = oz(l, i), { defaultedMultiCalendars: re } = jt(i), ie = J([]), K = J([]), $ = J(null), X = ca(z, "calendar"), R = ca(z, "monthYear"), de = ca(z, "timePicker"), Le = (G) => {
      i.shadow || a("mount", G);
    };
    at(
      r,
      () => {
        i.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), at(
      re,
      (G, Se) => {
        G.count - Se.count > 0 && P();
      },
      { deep: !0 }
    );
    const Ie = I(() => (G) => _(s.value(G), o.value(G)).map((Se) => ({
      ...Se,
      days: Se.days.map((he) => (he.marker = x(he), he.classData = q(he), he))
    })));
    function Ve(G) {
      var Se;
      G || G === 0 ? (Se = K.value[G]) == null || Se.triggerTransition(s.value(G), o.value(G)) : K.value.forEach((he, Ce) => he.triggerTransition(s.value(Ce), o.value(Ce)));
    }
    function te() {
      a("update-flow-step");
    }
    const we = (G, Se = !1) => {
      M(G, Se), i.spaceConfirm && a("select-date");
    }, H = (G, Se, he = 0) => {
      var Ce;
      (Ce = ie.value[he]) == null || Ce.toggleMonthPicker(G, Se);
    }, pe = (G, Se, he = 0) => {
      var Ce;
      (Ce = ie.value[he]) == null || Ce.toggleYearPicker(G, Se);
    }, Ne = (G, Se, he) => {
      var Ce;
      (Ce = $.value) == null || Ce.toggleTimePicker(G, Se, he);
    }, ee = (G, Se) => {
      var he;
      if (!i.range) {
        const Ce = l.value ? l.value : f, _e = Se ? new Date(Se) : Ce, tt = G ? Ra(_e, { weekStartsOn: 1 }) : Lv(_e, { weekStartsOn: 1 });
        M({
          value: tt,
          current: dt(_e) === s.value(0),
          text: "",
          classData: {}
        }), (he = document.getElementById(ey(tt))) == null || he.focus();
      }
    }, ze = (G) => {
      var Se;
      (Se = ie.value[0]) == null || Se.handleMonthYearChange(G, !0);
    }, et = (G) => {
      A(0, { month: s.value(0), year: o.value(0) + (G ? 1 : -1), fromNav: !0 });
    }, Te = (G, Se) => {
      G === Cn.time && a(`time-picker-${Se ? "open" : "close"}`), a("overlay-toggle", { open: Se, overlay: G });
    }, Qe = (G) => {
      a("overlay-toggle", { open: !1, overlay: G }), a("focus-menu");
    };
    return e({
      clearHoverDate: V,
      presetDate: L,
      selectCurrentDate: D,
      toggleMonthPicker: H,
      toggleYearPicker: pe,
      toggleTimePicker: Ne,
      handleArrow: p,
      updateMonthYear: A,
      getSidebarProps: () => ({
        modelValue: l,
        month: s,
        year: o,
        time: c,
        updateTime: B,
        updateMonthYear: A,
        selectDate: M,
        presetDate: L
      }),
      changeMonth: ze,
      changeYear: et,
      selectWeekDate: ee
    }), (G, Se) => (h(), b(me, null, [
      Q(Qu, {
        "multi-calendars": O(re).count,
        collapse: G.collapse
      }, {
        default: ce(({ instance: he, index: Ce }) => [
          G.disableMonthYearSelect ? E("", !0) : (h(), Z(MF, $t({
            key: 0,
            ref: (_e) => {
              _e && (ie.value[Ce] = _e);
            },
            months: O(Yv)(G.formatLocale, G.locale, G.monthNameFormat),
            years: O(mf)(G.yearRange, G.locale, G.reverseYears),
            month: O(s)(he),
            year: O(o)(he),
            instance: he
          }, G.$props, {
            onMount: Se[0] || (Se[0] = (_e) => Le(O(Sr).header)),
            onResetFlow: Se[1] || (Se[1] = (_e) => G.$emit("reset-flow")),
            onUpdateMonthYear: (_e) => O(A)(he, _e),
            onOverlayClosed: Qe,
            onOverlayOpened: Se[2] || (Se[2] = (_e) => G.$emit("overlay-toggle", { open: !0, overlay: _e }))
          }), rn({ _: 2 }, [
            Ee(O(R), (_e, tt) => ({
              name: _e,
              fn: ce((oe) => [
                xe(G.$slots, _e, ln(Un(oe)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Q(HF, $t({
            ref: (_e) => {
              _e && (K.value[Ce] = _e);
            },
            "mapped-dates": Ie.value(he),
            month: O(s)(he),
            year: O(o)(he),
            instance: he
          }, G.$props, {
            onSelectDate: (_e) => O(M)(_e, he !== 1),
            onHandleSpace: (_e) => we(_e, he !== 1),
            onSetHoverDate: Se[3] || (Se[3] = (_e) => O(W)(_e)),
            onHandleScroll: (_e) => O(w)(_e, he),
            onHandleSwipe: (_e) => O(C)(_e, he),
            onMount: Se[4] || (Se[4] = (_e) => Le(O(Sr).calendar)),
            onResetFlow: Se[5] || (Se[5] = (_e) => G.$emit("reset-flow")),
            onTooltipOpen: Se[6] || (Se[6] = (_e) => G.$emit("tooltip-open", _e)),
            onTooltipClose: Se[7] || (Se[7] = (_e) => G.$emit("tooltip-close", _e))
          }), rn({ _: 2 }, [
            Ee(O(X), (_e, tt) => ({
              name: _e,
              fn: ce((oe) => [
                xe(G.$slots, _e, ln(Un({ ...oe })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      G.enableTimePicker ? (h(), b("div", jF, [
        G.$slots["time-picker"] ? xe(G.$slots, "time-picker", ln($t({ key: 0 }, { time: O(c), updateTime: O(B) }))) : (h(), Z(sy, $t({
          key: 1,
          ref_key: "timePickerRef",
          ref: $
        }, G.$props, {
          hours: O(c).hours,
          minutes: O(c).minutes,
          seconds: O(c).seconds,
          "internal-model-value": G.internalModelValue,
          "disabled-times-config": O(d),
          "validate-time": O(g),
          onMount: Se[8] || (Se[8] = (he) => Le(O(Sr).timePicker)),
          "onUpdate:hours": Se[9] || (Se[9] = (he) => O(B)(he)),
          "onUpdate:minutes": Se[10] || (Se[10] = (he) => O(B)(he, !1)),
          "onUpdate:seconds": Se[11] || (Se[11] = (he) => O(B)(he, !1, !0)),
          onResetFlow: Se[12] || (Se[12] = (he) => G.$emit("reset-flow")),
          onOverlayClosed: Se[13] || (Se[13] = (he) => Te(he, !1)),
          onOverlayOpened: Se[14] || (Se[14] = (he) => Te(he, !0)),
          onAmPmChange: Se[15] || (Se[15] = (he) => G.$emit("am-pm-change", he))
        }), rn({ _: 2 }, [
          Ee(O(de), (he, Ce) => ({
            name: he,
            fn: ce((_e) => [
              xe(G.$slots, he, ln(Un(_e)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : E("", !0)
    ], 64));
  }
}), qF = (t, e) => {
  const n = J(), {
    defaultedMultiCalendars: a,
    defaultedConfig: i,
    defaultedHighlight: r,
    defaultedRange: s,
    propDates: o,
    defaultedFilters: l,
    defaultedMultiDates: c
  } = jt(t), { modelValue: d, year: f, month: g, calendars: _ } = $l(t, e), { isDisabled: x } = sr(t), { selectYear: p, groupedYears: w, showYearPicker: C, isDisabled: M, toggleYearPicker: A, handleYearSelect: L, handleYear: D } = ry({
    modelValue: d,
    multiCalendars: a,
    range: s,
    highlight: r,
    calendars: _,
    propDates: o,
    month: g,
    year: f,
    filters: l,
    props: t,
    emit: e
  }), B = ($, X) => [$, X].map((R) => Ja(R, "MMMM", { locale: t.formatLocale })).join("-"), P = I(() => ($) => d.value ? Array.isArray(d.value) ? d.value.some((X) => A1($, X)) : A1(d.value, $) : !1), z = ($) => {
    if (s.value.enabled) {
      if (Array.isArray(d.value)) {
        const X = ft($, d.value[0]) || ft($, d.value[1]);
        return Zu(d.value, n.value, $) && !X;
      }
      return !1;
    }
    return !1;
  }, W = ($, X) => $.quarter === x1(X) && $.year === nt(X), q = ($) => typeof r.value == "function" ? r.value({ quarter: x1($), year: nt($) }) : !!r.value.quarters.find((X) => W(X, $)), V = I(() => ($) => {
    const X = St(/* @__PURE__ */ new Date(), { year: f.value($) });
    return vR({
      start: yl(X),
      end: Ev(X)
    }).map((R) => {
      const de = Tr(R), Le = T1(R), Ie = x(R), Ve = z(de), te = q(de);
      return {
        text: B(de, Le),
        value: de,
        active: P.value(de),
        highlighted: te,
        disabled: Ie,
        isBetween: Ve
      };
    });
  }), re = ($) => {
    yf($, d, c.value.limit), e("auto-apply", !0);
  }, ie = ($) => {
    d.value = _f(d, $, e), Ju(d.value, e, t.autoApply, t.modelAuto);
  }, K = ($) => {
    d.value = $, e("auto-apply");
  };
  return {
    defaultedConfig: i,
    defaultedMultiCalendars: a,
    groupedYears: w,
    year: f,
    isDisabled: M,
    quarters: V,
    showYearPicker: C,
    modelValue: d,
    setHoverDate: ($) => {
      n.value = $;
    },
    selectYear: p,
    selectQuarter: ($, X, R) => {
      if (!R)
        return _.value[X].month = dt(T1($)), c.value.enabled ? re($) : s.value.enabled ? ie($) : K($);
    },
    toggleYearPicker: A,
    handleYearSelect: L,
    handleYear: D
  };
}, WF = { class: "dp--quarter-items" }, GF = ["data-test", "disabled", "onClick", "onMouseover"], XF = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Fa
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = nr(), s = ca(r, "yearMode"), {
      defaultedMultiCalendars: o,
      defaultedConfig: l,
      groupedYears: c,
      year: d,
      isDisabled: f,
      quarters: g,
      modelValue: _,
      showYearPicker: x,
      setHoverDate: p,
      selectQuarter: w,
      toggleYearPicker: C,
      handleYearSelect: M,
      handleYear: A
    } = qF(i, a);
    return e({ getSidebarProps: () => ({
      modelValue: _,
      year: d,
      selectQuarter: w,
      handleYearSelect: M,
      handleYear: A
    }) }), (L, D) => (h(), Z(Qu, {
      "multi-calendars": O(o).count,
      collapse: L.collapse,
      stretch: ""
    }, {
      default: ce(({ instance: B }) => [
        k("div", {
          class: "dp-quarter-picker-wrap",
          style: bn({ minHeight: `${O(l).modeHeight}px` })
        }, [
          L.$slots["top-extra"] ? xe(L.$slots, "top-extra", {
            key: 0,
            value: L.internalModelValue
          }) : E("", !0),
          k("div", null, [
            Q(ny, $t(L.$props, {
              items: O(c)(B),
              instance: B,
              "show-year-picker": O(x)[B],
              year: O(d)(B),
              "is-disabled": (P) => O(f)(B, P),
              onHandleYear: (P) => O(A)(B, P),
              onYearSelect: (P) => O(M)(P, B),
              onToggleYearPicker: (P) => O(C)(B, P == null ? void 0 : P.flow, P == null ? void 0 : P.show)
            }), rn({ _: 2 }, [
              Ee(O(s), (P, z) => ({
                name: P,
                fn: ce((W) => [
                  xe(L.$slots, P, ln(Un(W)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          k("div", WF, [
            (h(!0), b(me, null, Ee(O(g)(B), (P, z) => (h(), b("div", { key: z }, [
              k("button", {
                type: "button",
                class: se(["dp--qr-btn", {
                  "dp--qr-btn-active": P.active,
                  "dp--qr-btn-between": P.isBetween,
                  "dp--qr-btn-disabled": P.disabled,
                  "dp--highlighted": P.highlighted
                }]),
                "data-test": P.value,
                disabled: P.disabled,
                onClick: (W) => O(w)(P.value, B, P.disabled),
                onMouseover: (W) => O(p)(P.value)
              }, [
                L.$slots.quarter ? xe(L.$slots, "quarter", {
                  key: 0,
                  value: P.value,
                  text: P.text
                }) : (h(), b(me, { key: 1 }, [
                  Ye(ae(P.text), 1)
                ], 64))
              ], 42, GF)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), ZF = ["id", "aria-label"], KF = {
  key: 0,
  class: "dp--menu-load-container"
}, QF = /* @__PURE__ */ k("span", { class: "dp--menu-loader" }, null, -1), JF = [
  QF
], ez = {
  key: 0,
  class: "dp__sidebar_left"
}, tz = ["data-test", "onClick", "onKeydown"], nz = {
  key: 2,
  class: "dp__sidebar_right"
}, az = {
  key: 3,
  class: "dp__action_extra"
}, R1 = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Ku,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = J(null), s = I(() => {
      const { openOnTop: oe, ...Oe } = i;
      return {
        ...Oe,
        flowStep: W.value,
        collapse: i.collapse,
        noOverlayFocus: i.noOverlayFocus,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: o, setShiftKey: l, control: c } = ty(), d = nr(), { defaultedTextInput: f, defaultedInline: g, defaultedConfig: _, defaultedUI: x } = jt(i), p = J(null), w = J(0), C = J(null), M = J(!1), A = J(null);
    ht(() => {
      if (!i.shadow) {
        M.value = !0, L(), window.addEventListener("resize", L);
        const oe = on(r);
        if (oe && !f.value.enabled && !g.value.enabled && (o(!0), X()), oe) {
          const Oe = (Re) => {
            _.value.allowPreventDefault && Re.preventDefault(), Xi(Re, _.value, !0);
          };
          oe.addEventListener("pointerdown", Oe), oe.addEventListener("mousedown", Oe);
        }
      }
    }), Xs(() => {
      window.removeEventListener("resize", L);
    });
    const L = () => {
      const oe = on(C);
      oe && (w.value = oe.getBoundingClientRect().width);
    }, { arrowRight: D, arrowLeft: B, arrowDown: P, arrowUp: z } = rr(), { flowStep: W, updateFlowStep: q, childMount: V, resetFlow: re, handleFlow: ie } = lz(i, a, A), K = I(() => i.monthPicker ? oF : i.yearPicker ? cF : i.timePicker ? CF : i.quarterPicker ? XF : VF), $ = I(() => {
      var oe;
      if (_.value.arrowLeft) return _.value.arrowLeft;
      const Oe = (oe = r.value) == null ? void 0 : oe.getBoundingClientRect(), Re = i.getInputRect();
      return (Re == null ? void 0 : Re.width) < (w == null ? void 0 : w.value) && (Re == null ? void 0 : Re.left) <= ((Oe == null ? void 0 : Oe.left) ?? 0) ? `${(Re == null ? void 0 : Re.width) / 2}px` : (Re == null ? void 0 : Re.right) >= ((Oe == null ? void 0 : Oe.right) ?? 0) && (Re == null ? void 0 : Re.width) < (w == null ? void 0 : w.value) ? `${(w == null ? void 0 : w.value) - (Re == null ? void 0 : Re.width) / 2}px` : "50%";
    }), X = () => {
      const oe = on(r);
      oe && oe.focus({ preventScroll: !0 });
    }, R = I(() => {
      var oe;
      return ((oe = A.value) == null ? void 0 : oe.getSidebarProps()) || {};
    }), de = () => {
      i.openOnTop && a("recalculate-position");
    }, Le = ca(d, "action"), Ie = I(() => i.monthPicker || i.yearPicker ? ca(d, "monthYear") : i.timePicker ? ca(d, "timePicker") : ca(d, "shared")), Ve = I(() => i.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), te = I(() => ({
      dp__menu_disabled: i.disabled,
      dp__menu_readonly: i.readonly,
      "dp-menu-loading": i.loading
    })), we = I(
      () => ({
        dp__menu: !0,
        dp__menu_index: !g.value.enabled,
        dp__relative: g.value.enabled,
        [i.menuClassName]: !!i.menuClassName,
        ...x.value.menu ?? {}
      })
    ), H = (oe) => {
      Xi(oe, _.value, !0);
    }, pe = () => {
      i.escClose && a("close-picker");
    }, Ne = (oe) => {
      if (i.arrowNavigation) {
        if (oe === Bn.up) return z();
        if (oe === Bn.down) return P();
        if (oe === Bn.left) return B();
        if (oe === Bn.right) return D();
      } else oe === Bn.left || oe === Bn.up ? Qe("handleArrow", Bn.left, 0, oe === Bn.up) : Qe("handleArrow", Bn.right, 0, oe === Bn.down);
    }, ee = (oe) => {
      l(oe.shiftKey), !i.disableMonthYearSelect && oe.code === zt.tab && oe.target.classList.contains("dp__menu") && c.value.shiftKeyInMenu && (oe.preventDefault(), Xi(oe, _.value, !0), a("close-picker"));
    }, ze = () => {
      X(), a("time-picker-close");
    }, et = (oe) => {
      var Oe, Re, lt;
      (Oe = A.value) == null || Oe.toggleTimePicker(!1, !1), (Re = A.value) == null || Re.toggleMonthPicker(!1, !1, oe), (lt = A.value) == null || lt.toggleYearPicker(!1, !1, oe);
    }, Te = (oe, Oe = 0) => {
      var Re, lt, Mt;
      return oe === "month" ? (Re = A.value) == null ? void 0 : Re.toggleMonthPicker(!1, !0, Oe) : oe === "year" ? (lt = A.value) == null ? void 0 : lt.toggleYearPicker(!1, !0, Oe) : oe === "time" ? (Mt = A.value) == null ? void 0 : Mt.toggleTimePicker(!0, !1) : et(Oe);
    }, Qe = (oe, ...Oe) => {
      var Re, lt;
      (Re = A.value) != null && Re[oe] && ((lt = A.value) == null || lt[oe](...Oe));
    }, G = () => {
      Qe("selectCurrentDate");
    }, Se = (oe, Oe) => {
      Qe("presetDate", oe, Oe);
    }, he = () => {
      Qe("clearHoverDate");
    }, Ce = (oe, Oe) => {
      Qe("updateMonthYear", oe, Oe);
    }, _e = (oe, Oe) => {
      oe.preventDefault(), Ne(Oe);
    }, tt = (oe) => {
      var Oe;
      if (ee(oe), oe.key === zt.home || oe.key === zt.end)
        return Qe(
          "selectWeekDate",
          oe.key === zt.home,
          oe.target.getAttribute("id")
        );
      switch ((oe.key === zt.pageUp || oe.key === zt.pageDown) && (oe.shiftKey ? Qe("changeYear", oe.key === zt.pageUp) : Qe("changeMonth", oe.key === zt.pageUp), oe.target.getAttribute("id") && ((Oe = r.value) == null || Oe.focus({ preventScroll: !0 }))), oe.key) {
        case zt.esc:
          return pe();
        case zt.arrowLeft:
          return _e(oe, Bn.left);
        case zt.arrowRight:
          return _e(oe, Bn.right);
        case zt.arrowUp:
          return _e(oe, Bn.up);
        case zt.arrowDown:
          return _e(oe, Bn.down);
        default:
          return;
      }
    };
    return e({
      updateMonthYear: Ce,
      switchView: Te,
      handleFlow: ie
    }), (oe, Oe) => {
      var Re, lt, Mt;
      return h(), b("div", {
        id: oe.uid ? `dp-menu-${oe.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: "0",
        role: "dialog",
        "aria-label": (Re = oe.ariaLabels) == null ? void 0 : Re.menu,
        class: se(we.value),
        style: bn({ "--dp-arrow-left": $.value }),
        onMouseleave: he,
        onClick: H,
        onKeydown: tt
      }, [
        (oe.disabled || oe.readonly) && O(g).enabled || oe.loading ? (h(), b("div", {
          key: 0,
          class: se(te.value)
        }, [
          oe.loading ? (h(), b("div", KF, JF)) : E("", !0)
        ], 2)) : E("", !0),
        !O(g).enabled && !oe.teleportCenter ? (h(), b("div", {
          key: 1,
          class: se(Ve.value)
        }, null, 2)) : E("", !0),
        k("div", {
          ref_key: "innerMenuRef",
          ref: C,
          class: se({
            dp__menu_content_wrapper: ((lt = oe.presetDates) == null ? void 0 : lt.length) || !!oe.$slots["left-sidebar"] || !!oe.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((Mt = oe.presetDates) == null ? void 0 : Mt.length) || !!oe.$slots["left-sidebar"] || !!oe.$slots["right-sidebar"])
          }),
          style: bn({ "--dp-menu-width": `${w.value}px` })
        }, [
          oe.$slots["left-sidebar"] ? (h(), b("div", ez, [
            xe(oe.$slots, "left-sidebar", ln(Un(R.value)))
          ])) : E("", !0),
          oe.presetDates.length ? (h(), b("div", {
            key: 1,
            class: se({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 })
          }, [
            (h(!0), b(me, null, Ee(oe.presetDates, (We, fa) => (h(), b(me, { key: fa }, [
              We.slot ? xe(oe.$slots, We.slot, {
                key: 0,
                presetDate: Se,
                label: We.label,
                value: We.value
              }) : (h(), b("button", {
                key: 1,
                type: "button",
                style: bn(We.style || {}),
                class: se(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test": We.testId ?? void 0,
                onClick: Ba((jn) => Se(We.value, We.noTz), ["prevent"]),
                onKeydown: (jn) => O(Kn)(jn, () => Se(We.value, We.noTz), !0)
              }, ae(We.label), 47, tz))
            ], 64))), 128))
          ], 2)) : E("", !0),
          k("div", {
            ref_key: "calendarWrapperRef",
            ref: p,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (h(), Z(ut(K.value), $t({
              ref_key: "dynCmpRef",
              ref: A
            }, s.value, {
              "flow-step": O(W),
              onMount: O(V),
              onUpdateFlowStep: O(q),
              onResetFlow: O(re),
              onFocusMenu: X,
              onSelectDate: Oe[0] || (Oe[0] = (We) => oe.$emit("select-date")),
              onDateUpdate: Oe[1] || (Oe[1] = (We) => oe.$emit("date-update", We)),
              onTooltipOpen: Oe[2] || (Oe[2] = (We) => oe.$emit("tooltip-open", We)),
              onTooltipClose: Oe[3] || (Oe[3] = (We) => oe.$emit("tooltip-close", We)),
              onAutoApply: Oe[4] || (Oe[4] = (We) => oe.$emit("auto-apply", We)),
              onRangeStart: Oe[5] || (Oe[5] = (We) => oe.$emit("range-start", We)),
              onRangeEnd: Oe[6] || (Oe[6] = (We) => oe.$emit("range-end", We)),
              onInvalidFixedRange: Oe[7] || (Oe[7] = (We) => oe.$emit("invalid-fixed-range", We)),
              onTimeUpdate: Oe[8] || (Oe[8] = (We) => oe.$emit("time-update")),
              onAmPmChange: Oe[9] || (Oe[9] = (We) => oe.$emit("am-pm-change", We)),
              onTimePickerOpen: Oe[10] || (Oe[10] = (We) => oe.$emit("time-picker-open", We)),
              onTimePickerClose: ze,
              onRecalculatePosition: de,
              onUpdateMonthYear: Oe[11] || (Oe[11] = (We) => oe.$emit("update-month-year", We)),
              onAutoApplyInvalid: Oe[12] || (Oe[12] = (We) => oe.$emit("auto-apply-invalid", We)),
              onInvalidDate: Oe[13] || (Oe[13] = (We) => oe.$emit("invalid-date", We)),
              onOverlayToggle: Oe[14] || (Oe[14] = (We) => oe.$emit("overlay-toggle", We)),
              "onUpdate:internalModelValue": Oe[15] || (Oe[15] = (We) => oe.$emit("update:internal-model-value", We))
            }), rn({ _: 2 }, [
              Ee(Ie.value, (We, fa) => ({
                name: We,
                fn: ce((jn) => [
                  xe(oe.$slots, We, ln(Un({ ...jn })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          oe.$slots["right-sidebar"] ? (h(), b("div", nz, [
            xe(oe.$slots, "right-sidebar", ln(Un(R.value)))
          ])) : E("", !0),
          oe.$slots["action-extra"] ? (h(), b("div", az, [
            oe.$slots["action-extra"] ? xe(oe.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: G
            }) : E("", !0)
          ])) : E("", !0)
        ], 6),
        !oe.autoApply || O(_).keepActionRow ? (h(), Z(J$, $t({
          key: 2,
          "menu-mount": M.value
        }, s.value, {
          "calendar-width": w.value,
          onClosePicker: Oe[16] || (Oe[16] = (We) => oe.$emit("close-picker")),
          onSelectDate: Oe[17] || (Oe[17] = (We) => oe.$emit("select-date")),
          onInvalidSelect: Oe[18] || (Oe[18] = (We) => oe.$emit("invalid-select")),
          onSelectNow: G
        }), rn({ _: 2 }, [
          Ee(O(Le), (We, fa) => ({
            name: We,
            fn: ce((jn) => [
              xe(oe.$slots, We, ln(Un({ ...jn })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : E("", !0)
      ], 46, ZF);
    };
  }
});
var ls = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(ls || {});
const iz = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: n,
  pickerWrapperRef: a,
  inline: i,
  emit: r,
  props: s,
  slots: o
}) => {
  const l = J({}), c = J(!1), d = J({
    top: "0",
    left: "0"
  }), f = J(!1), g = As(s, "teleportCenter");
  at(g, () => {
    d.value = JSON.parse(JSON.stringify({})), L();
  });
  const _ = ($) => {
    if (s.teleport) {
      const X = $.getBoundingClientRect();
      return {
        left: X.left + window.scrollX,
        top: X.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, x = ($, X) => {
    d.value.left = `${$ + X - l.value.width}px`;
  }, p = ($) => {
    d.value.left = `${$}px`;
  }, w = ($, X) => {
    s.position === ls.left && p($), s.position === ls.right && x($, X), s.position === ls.center && (d.value.left = `${$ + X / 2 - l.value.width / 2}px`);
  }, C = ($) => {
    const { width: X, height: R } = $.getBoundingClientRect(), { top: de, left: Le } = s.altPosition ? s.altPosition($) : _($);
    return { top: +de, left: +Le, width: X, height: R };
  }, M = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, A = () => {
    const $ = on(n), { top: X, left: R, transform: de } = s.altPosition($);
    d.value = { top: `${X}px`, left: `${R}px`, transform: de ?? "" };
  }, L = ($ = !0) => {
    var X;
    if (!i.value.enabled) {
      if (g.value) return M();
      if (s.altPosition !== null) return A();
      if ($) {
        const R = s.teleport ? (X = e.value) == null ? void 0 : X.$el : t.value;
        R && (l.value = R.getBoundingClientRect()), r("recalculate-position");
      }
      return V();
    }
  }, D = ({ inputEl: $, left: X, width: R }) => {
    window.screen.width > 768 && !c.value && w(X, R), z($);
  }, B = ($) => {
    const { top: X, left: R, height: de, width: Le } = C($);
    d.value.top = `${de + X + +s.offset}px`, f.value = !1, c.value || (d.value.left = `${R + Le / 2 - l.value.width / 2}px`), D({ inputEl: $, left: R, width: Le });
  }, P = ($) => {
    const { top: X, left: R, width: de } = C($);
    d.value.top = `${X - +s.offset - l.value.height}px`, f.value = !0, D({ inputEl: $, left: R, width: de });
  }, z = ($) => {
    if (s.autoPosition) {
      const { left: X, width: R } = C($), { left: de, right: Le } = l.value;
      if (!c.value) {
        if (Math.abs(de) !== Math.abs(Le)) {
          if (de <= 0)
            return c.value = !0, p(X);
          if (Le >= document.documentElement.clientWidth)
            return c.value = !0, x(X, R);
        }
        return w(X, R);
      }
    }
  }, W = () => {
    const $ = on(n);
    if ($) {
      const { height: X } = l.value, { top: R, height: de } = $.getBoundingClientRect(), Le = window.innerHeight - R - de, Ie = R;
      return X <= Le ? gr.bottom : X > Le && X <= Ie ? gr.top : Le >= Ie ? gr.bottom : gr.top;
    }
    return gr.bottom;
  }, q = ($) => W() === gr.bottom ? B($) : P($), V = () => {
    const $ = on(n);
    if ($)
      return s.autoPosition ? q($) : B($);
  }, re = function($) {
    if ($) {
      const X = $.scrollHeight > $.clientHeight, R = window.getComputedStyle($).overflowY.indexOf("hidden") !== -1;
      return X && !R;
    }
    return !0;
  }, ie = function($) {
    return !$ || $ === document.body || $.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : re($) ? $ : ie($.assignedSlot ? $.assignedSlot.parentNode : $.parentNode);
  }, K = ($) => {
    if ($)
      switch (s.position) {
        case ls.left:
          return { left: 0, transform: "translateX(0)" };
        case ls.right:
          return { left: `${$.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${$.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: d,
    xCorrect: c,
    setMenuPosition: L,
    getScrollableParent: ie,
    shadowRender: ($, X) => {
      var R, de, Le;
      const Ie = document.createElement("div"), Ve = (R = on(n)) == null ? void 0 : R.getBoundingClientRect();
      Ie.setAttribute("id", "dp--temp-container");
      const te = (de = a.value) != null && de.clientWidth ? a.value : document.body;
      te.append(Ie);
      const we = K(Ve), H = _r(
        $,
        {
          ...X,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...we }
        },
        Object.fromEntries(
          Object.keys(o).filter((pe) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(pe)).map((pe) => [pe, o[pe]])
        )
      );
      km(H, Ie), l.value = (Le = H.el) == null ? void 0 : Le.getBoundingClientRect(), km(null, Ie), te.removeChild(Ie);
    }
  };
}, Ni = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] }
], rz = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], sz = {
  all: () => Ni,
  monthYear: () => Ni.filter((t) => t.use.includes("month-year")),
  input: () => rz,
  timePicker: () => Ni.filter((t) => t.use.includes("time")),
  action: () => Ni.filter((t) => t.use.includes("action")),
  calendar: () => Ni.filter((t) => t.use.includes("calendar")),
  menu: () => Ni.filter((t) => t.use.includes("menu")),
  shared: () => Ni.filter((t) => t.use.includes("shared")),
  yearMode: () => Ni.filter((t) => t.use.includes("year-mode"))
}, ca = (t, e, n) => {
  const a = [];
  return sz[e]().forEach((i) => {
    t[i.name] && a.push(i.name);
  }), n != null && n.length && n.forEach((i) => {
    i.slot && a.push(i.slot);
  }), a;
}, Nl = (t) => {
  const e = I(() => (a) => t.value ? a ? t.value.open : t.value.close : ""), n = I(() => (a) => t.value ? a ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: n };
}, $l = (t, e, n) => {
  const { defaultedRange: a, defaultedTz: i } = jt(t), r = De(Jn(De(), i.value.timezone)), s = J([{ month: dt(r), year: nt(r) }]), o = (g) => {
    const _ = {
      hours: Ti(r),
      minutes: Ji(r),
      seconds: 0
    };
    return a.value.enabled ? [_[g], _[g]] : _[g];
  }, l = La({
    hours: o("hours"),
    minutes: o("minutes"),
    seconds: o("seconds")
  });
  at(
    a,
    (g, _) => {
      g.enabled !== _.enabled && (l.hours = o("hours"), l.minutes = o("minutes"), l.seconds = o("seconds"));
    },
    { deep: !0 }
  );
  const c = I({
    get: () => t.internalModelValue,
    set: (g) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", g);
    }
  }), d = I(
    () => (g) => s.value[g] ? s.value[g].month : 0
  ), f = I(
    () => (g) => s.value[g] ? s.value[g].year : 0
  );
  return at(
    c,
    (g, _) => {
      n && JSON.stringify(g ?? {}) !== JSON.stringify(_ ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: s,
    time: l,
    modelValue: c,
    month: d,
    year: f,
    today: r
  };
}, oz = (t, e) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: a,
    defaultedUI: i,
    defaultedHighlight: r,
    defaultedTz: s,
    propDates: o,
    defaultedRange: l
  } = jt(e), { isDisabled: c } = sr(e), d = J(null), f = J(Jn(/* @__PURE__ */ new Date(), s.value.timezone)), g = (H) => {
    !H.current && e.hideOffsetDates || (d.value = H.value);
  }, _ = () => {
    d.value = null;
  }, x = (H) => Array.isArray(t.value) && l.value.enabled && t.value[0] && d.value ? H ? Kt(d.value, t.value[0]) : Vt(d.value, t.value[0]) : !0, p = (H, pe) => {
    const Ne = () => t.value ? pe ? t.value[0] || null : t.value[1] : null, ee = t.value && Array.isArray(t.value) ? Ne() : null;
    return ft(De(H.value), ee);
  }, w = (H) => {
    const pe = Array.isArray(t.value) ? t.value[0] : null;
    return H ? !Vt(d.value ?? null, pe) : !0;
  }, C = (H, pe = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !H.current ? !1 : ft(De(H.value), t.value[pe ? 0 : 1]) : l.value.enabled ? p(H, pe) && w(pe) || ft(H.value, Array.isArray(t.value) ? t.value[0] : null) && x(pe) : !1, M = (H, pe) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const Ne = ft(H.value, d.value);
      return pe ? Kt(t.value[0], H.value) && Ne : Vt(t.value[0], H.value) && Ne;
    }
    return !1;
  }, A = (H) => !t.value || e.hideOffsetDates && !H.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? ft(H.value, t.value[0] ? t.value[0] : f.value) : !1 : a.value.enabled && Array.isArray(t.value) ? t.value.some((pe) => ft(pe, H.value)) : ft(H.value, t.value ? t.value : f.value), L = (H) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        if (e.hideOffsetDates && !H.current) return !1;
        const pe = Aa(d.value, +l.value.autoRange), Ne = pi(De(d.value), e.weekStart);
        return e.weekPicker ? ft(Ne[1], De(H.value)) : ft(pe, De(H.value));
      }
      return !1;
    }
    return !1;
  }, D = (H) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        const pe = Aa(d.value, +l.value.autoRange);
        if (e.hideOffsetDates && !H.current) return !1;
        const Ne = pi(De(d.value), e.weekStart);
        return e.weekPicker ? Kt(H.value, Ne[0]) && Vt(H.value, Ne[1]) : Kt(H.value, d.value) && Vt(H.value, pe);
      }
      return !1;
    }
    return !1;
  }, B = (H) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        if (e.hideOffsetDates && !H.current) return !1;
        const pe = pi(De(d.value), e.weekStart);
        return e.weekPicker ? ft(pe[0], H.value) : ft(d.value, H.value);
      }
      return !1;
    }
    return !1;
  }, P = (H) => Zu(t.value, d.value, H.value), z = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, W = () => e.modelAuto ? jv(e.internalModelValue) : !0, q = (H) => {
    if (e.weekPicker) return !1;
    const pe = l.value.enabled ? !C(H) && !C(H, !1) : !0;
    return !c(H.value) && !A(H) && !(!H.current && e.hideOffsetDates) && pe;
  }, V = (H) => l.value.enabled ? e.modelAuto ? z() && A(H) : !1 : A(H), re = (H) => r.value ? k$(H.value, o.value.highlight) : !1, ie = (H) => {
    const pe = c(H.value);
    return pe && (typeof r.value == "function" ? !r.value(H.value, pe) : !r.value.options.highlightDisabled);
  }, K = (H) => {
    var pe;
    return typeof r.value == "function" ? r.value(H.value) : (pe = r.value.weekdays) == null ? void 0 : pe.includes(H.value.getDay());
  }, $ = (H) => (l.value.enabled || e.weekPicker) && (!(n.value.count > 0) || H.current) && W() && !(!H.current && e.hideOffsetDates) && !A(H) ? P(H) : !1, X = (H) => {
    const { isRangeStart: pe, isRangeEnd: Ne } = Ie(H), ee = l.value.enabled ? pe || Ne : !1;
    return {
      dp__cell_offset: !H.current,
      dp__pointer: !e.disabled && !(!H.current && e.hideOffsetDates) && !c(H.value),
      dp__cell_disabled: c(H.value),
      dp__cell_highlight: !ie(H) && (re(H) || K(H)) && !V(H) && !ee && !B(H) && !($(H) && e.weekPicker) && !Ne,
      dp__cell_highlight_active: !ie(H) && (re(H) || K(H)) && V(H),
      dp__today: !e.noToday && ft(H.value, f.value) && H.current,
      "dp--past": Vt(H.value, f.value),
      "dp--future": Kt(H.value, f.value)
    };
  }, R = (H) => ({
    dp__active_date: V(H),
    dp__date_hover: q(H)
  }), de = (H) => {
    if (t.value && !Array.isArray(t.value)) {
      const pe = pi(t.value, e.weekStart);
      return {
        ...te(H),
        dp__range_start: ft(pe[0], H.value),
        dp__range_end: ft(pe[1], H.value),
        dp__range_between_week: Kt(H.value, pe[0]) && Vt(H.value, pe[1])
      };
    }
    return {
      ...te(H)
    };
  }, Le = (H) => {
    if (t.value && Array.isArray(t.value)) {
      const pe = pi(t.value[0], e.weekStart), Ne = t.value[1] ? pi(t.value[1], e.weekStart) : [];
      return {
        ...te(H),
        dp__range_start: ft(pe[0], H.value) || ft(Ne[0], H.value),
        dp__range_end: ft(pe[1], H.value) || ft(Ne[1], H.value),
        dp__range_between_week: Kt(H.value, pe[0]) && Vt(H.value, pe[1]) || Kt(H.value, Ne[0]) && Vt(H.value, Ne[1]),
        dp__range_between: Kt(H.value, pe[1]) && Vt(H.value, Ne[0])
      };
    }
    return {
      ...te(H)
    };
  }, Ie = (H) => {
    const pe = n.value.count > 0 ? H.current && C(H) && W() : C(H) && W(), Ne = n.value.count > 0 ? H.current && C(H, !1) && W() : C(H, !1) && W();
    return { isRangeStart: pe, isRangeEnd: Ne };
  }, Ve = (H) => {
    const { isRangeStart: pe, isRangeEnd: Ne } = Ie(H);
    return {
      dp__range_start: pe,
      dp__range_end: Ne,
      dp__range_between: $(H),
      dp__date_hover: ft(H.value, d.value) && !pe && !Ne && !e.weekPicker,
      dp__date_hover_start: M(H, !0),
      dp__date_hover_end: M(H, !1)
    };
  }, te = (H) => ({
    ...Ve(H),
    dp__cell_auto_range: D(H),
    dp__cell_auto_range_start: B(H),
    dp__cell_auto_range_end: L(H)
  }), we = (H) => l.value.enabled ? l.value.autoRange ? te(H) : e.modelAuto ? { ...R(H), ...Ve(H) } : e.weekPicker ? Le(H) : Ve(H) : e.weekPicker ? de(H) : R(H);
  return {
    setHoverDate: g,
    clearHoverDate: _,
    getDayClassData: (H) => e.hideOffsetDates && !H.current ? {} : {
      ...X(H),
      ...we(H),
      [e.dayClass ? e.dayClass(H.value, e.internalModelValue) : ""]: !0,
      [e.calendarCellClassName]: !!e.calendarCellClassName,
      ...i.value.calendarCell ?? {}
    }
  };
}, sr = (t) => {
  const { defaultedFilters: e, defaultedRange: n, propDates: a, defaultedMultiDates: i } = jt(t), r = (K) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(De(K)) : !!ru(K, a.value.disabledDates) : !1, s = (K) => a.value.maxDate ? t.yearPicker ? nt(K) > nt(a.value.maxDate) : Kt(K, a.value.maxDate) : !1, o = (K) => a.value.minDate ? t.yearPicker ? nt(K) < nt(a.value.minDate) : Vt(K, a.value.minDate) : !1, l = (K) => {
    const $ = s(K), X = o(K), R = r(K), de = e.value.months.map((we) => +we).includes(dt(K)), Le = t.disabledWeekDays.length ? t.disabledWeekDays.some((we) => +we === dN(K)) : !1, Ie = _(K), Ve = nt(K), te = Ve < +t.yearRange[0] || Ve > +t.yearRange[1];
    return !($ || X || R || de || te || Le || Ie);
  }, c = (K, $) => Vt(...qi(a.value.minDate, K, $)) || ft(...qi(a.value.minDate, K, $)), d = (K, $) => Kt(...qi(a.value.maxDate, K, $)) || ft(...qi(a.value.maxDate, K, $)), f = (K, $, X) => {
    let R = !1;
    return a.value.maxDate && X && d(K, $) && (R = !0), a.value.minDate && !X && c(K, $) && (R = !0), R;
  }, g = (K, $, X, R) => {
    let de = !1;
    return R ? a.value.minDate && a.value.maxDate ? de = f(K, $, X) : (a.value.minDate && c(K, $) || a.value.maxDate && d(K, $)) && (de = !0) : de = !0, de;
  }, _ = (K) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !ru(K, a.value.allowedDates) : !1, x = (K) => !l(K), p = (K) => n.value.noDisabledRange ? !Av({ start: K[0], end: K[1] }).some(($) => x($)) : !0, w = (K) => {
    if (K) {
      const $ = nt(K);
      return $ >= +t.yearRange[0] && $ <= t.yearRange[1];
    }
    return !0;
  }, C = (K, $) => !!(Array.isArray(K) && K[$] && (n.value.maxRange || n.value.minRange) && w(K[$])), M = (K, $, X = 0) => {
    if (C($, X) && w(K)) {
      const R = Sv(K, $[X]), de = Xv($[X], K), Le = de.length === 1 ? 0 : de.filter((Ve) => x(Ve)).length, Ie = Math.abs(R) - (n.value.minMaxRawRange ? 0 : Le);
      if (n.value.minRange && n.value.maxRange)
        return Ie >= +n.value.minRange && Ie <= +n.value.maxRange;
      if (n.value.minRange) return Ie >= +n.value.minRange;
      if (n.value.maxRange) return Ie <= +n.value.maxRange;
    }
    return !0;
  }, A = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, L = (K) => Array.isArray(K) ? [K[0] ? c0(K[0]) : null, K[1] ? c0(K[1]) : null] : c0(K), D = (K, $, X) => K.find(
    (R) => +R.hours === Ti($) && R.minutes === "*" ? !0 : +R.minutes === Ji($) && +R.hours === Ti($)
  ) && X, B = (K, $, X) => {
    const [R, de] = K, [Le, Ie] = $;
    return !D(R, Le, X) && !D(de, Ie, X) && X;
  }, P = (K, $) => {
    const X = Array.isArray($) ? $ : [$];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? B(t.disabledTimes, X, K) : !X.some((R) => D(t.disabledTimes, R, K)) : K;
  }, z = (K, $) => {
    const X = Array.isArray($) ? [Cr($[0]), $[1] ? Cr($[1]) : void 0] : Cr($), R = !t.disabledTimes(X);
    return K && R;
  }, W = (K, $) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? P($, K) : z($, K) : $, q = (K) => {
    let $ = !0;
    if (!K || A()) return !0;
    const X = !a.value.minDate && !a.value.maxDate ? L(K) : K;
    return (t.maxTime || a.value.maxDate) && ($ = M1(
      t.maxTime,
      a.value.maxDate,
      "max",
      pn(X),
      $
    )), (t.minTime || a.value.minDate) && ($ = M1(
      t.minTime,
      a.value.minDate,
      "min",
      pn(X),
      $
    )), W(K, $);
  }, V = (K) => {
    if (!t.monthPicker) return !0;
    let $ = !0;
    const X = De(Ea(K));
    if (a.value.minDate && a.value.maxDate) {
      const R = De(Ea(a.value.minDate)), de = De(Ea(a.value.maxDate));
      return Kt(X, R) && Vt(X, de) || ft(X, R) || ft(X, de);
    }
    if (a.value.minDate) {
      const R = De(Ea(a.value.minDate));
      $ = Kt(X, R) || ft(X, R);
    }
    if (a.value.maxDate) {
      const R = De(Ea(a.value.maxDate));
      $ = Vt(X, R) || ft(X, R);
    }
    return $;
  }, re = I(() => (K) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : q(K)), ie = I(() => (K) => t.monthPicker ? Array.isArray(K) && (n.value.enabled || i.value.enabled) ? !K.filter(($) => !V($)).length : V(K) : !0);
  return {
    isDisabled: x,
    validateDate: l,
    validateMonthYearInRange: g,
    isDateRangeAllowed: p,
    checkMinMaxRange: M,
    isValidTime: q,
    isTimeValid: re,
    isMonthValid: ie
  };
}, ed = () => {
  const t = I(() => (a, i) => a == null ? void 0 : a.includes(i)), e = I(() => (a, i) => a.count ? a.solo ? !0 : i === 0 : !0), n = I(() => (a, i) => a.count ? a.solo ? !0 : i === a.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: n };
}, lz = (t, e, n) => {
  const a = J(0), i = La({
    [Sr.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Sr.calendar]: !1,
    [Sr.header]: !1
  }), r = I(() => t.monthPicker || t.timePicker), s = (f) => {
    var g;
    if ((g = t.flow) != null && g.length) {
      if (!f && r.value) return d();
      i[f] = !0, Object.keys(i).filter((_) => !i[_]).length || d();
    }
  }, o = () => {
    var f, g;
    (f = t.flow) != null && f.length && a.value !== -1 && (a.value += 1, e("flow-step", a.value), d()), ((g = t.flow) == null ? void 0 : g.length) === a.value && Dn().then(() => l());
  }, l = () => {
    a.value = -1;
  }, c = (f, g, ..._) => {
    var x, p;
    t.flow[a.value] === f && n.value && ((p = (x = n.value)[g]) == null || p.call(x, ..._));
  }, d = (f = 0) => {
    f && (a.value += f), c(Cn.month, "toggleMonthPicker", !0), c(Cn.year, "toggleYearPicker", !0), c(Cn.calendar, "toggleTimePicker", !1, !0), c(Cn.time, "toggleTimePicker", !0, !0);
    const g = t.flow[a.value];
    (g === Cn.hours || g === Cn.minutes || g === Cn.seconds) && c(g, "toggleTimePicker", !0, !0, g);
  };
  return { childMount: s, updateFlowStep: o, resetFlow: l, handleFlow: d, flowStep: a };
}, cz = {
  key: 1,
  class: "dp__input_wrap"
}, uz = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], dz = {
  key: 2,
  class: "dp__clear_icon"
}, hz = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Ku
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, {
      defaultedTextInput: r,
      defaultedAriaLabels: s,
      defaultedInline: o,
      defaultedConfig: l,
      defaultedRange: c,
      defaultedMultiDates: d,
      defaultedUI: f,
      getDefaultPattern: g,
      getDefaultStartTime: _
    } = jt(i), { checkMinMaxRange: x } = sr(i), p = J(), w = J(null), C = J(!1), M = J(!1), A = I(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !r.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !i.hideInputIcon,
        dp__input_valid: !!i.state,
        dp__input_invalid: i.state === !1,
        dp__input_focus: C.value || i.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        [i.inputClassName]: !!i.inputClassName,
        ...f.value.input ?? {}
      })
    ), L = () => {
      a("set-input-date", null), i.clearable && i.autoApply && (a("set-empty-date"), p.value = null);
    }, D = (R) => {
      const de = _();
      return S$(
        R,
        r.value.format ?? g(),
        de ?? Zv({}, i.enableSeconds),
        i.inputValue,
        M.value,
        i.formatLocale
      );
    }, B = (R) => {
      const { rangeSeparator: de } = r.value, [Le, Ie] = R.split(`${de}`);
      if (Le) {
        const Ve = D(Le.trim()), te = Ie ? D(Ie.trim()) : null;
        if (Is(Ve, te)) return;
        const we = Ve && te ? [Ve, te] : [Ve];
        x(te, we, 0) && (p.value = Ve ? we : null);
      }
    }, P = () => {
      M.value = !0;
    }, z = (R) => {
      if (c.value.enabled)
        B(R);
      else if (d.value.enabled) {
        const de = R.split(";");
        p.value = de.map((Le) => D(Le.trim())).filter((Le) => Le);
      } else
        p.value = D(R);
    }, W = (R) => {
      var de;
      const Le = typeof R == "string" ? R : (de = R.target) == null ? void 0 : de.value;
      Le !== "" ? (r.value.openMenu && !i.isMenuOpen && a("open"), z(Le), a("set-input-date", p.value)) : L(), M.value = !1, a("update:input-value", Le);
    }, q = (R) => {
      r.value.enabled ? (z(R.target.value), r.value.enterSubmit && J0(p.value) && i.inputValue !== "" ? (a("set-input-date", p.value, !0), p.value = null) : r.value.enterSubmit && i.inputValue === "" && (p.value = null, a("clear"))) : ie(R);
    }, V = (R) => {
      r.value.enabled && r.value.tabSubmit && z(R.target.value), r.value.tabSubmit && J0(p.value) && i.inputValue !== "" ? (a("set-input-date", p.value, !0, !0), p.value = null) : r.value.tabSubmit && i.inputValue === "" && (p.value = null, a("clear", !0));
    }, re = () => {
      C.value = !0, a("focus"), Dn().then(() => {
        var R;
        r.value.enabled && r.value.selectOnFocus && ((R = w.value) == null || R.select());
      });
    }, ie = (R) => {
      R.preventDefault(), Xi(R, l.value, !0), r.value.enabled && r.value.openMenu && !o.value.input && !i.isMenuOpen ? a("open") : r.value.enabled || a("toggle");
    }, K = () => {
      a("real-blur"), C.value = !1, (!i.isMenuOpen || o.value.enabled && o.value.input) && a("blur"), i.autoApply && r.value.enabled && p.value && !i.isMenuOpen && (a("set-input-date", p.value), a("select-date"), p.value = null);
    }, $ = (R) => {
      Xi(R, l.value, !0), a("clear");
    }, X = (R) => {
      if (R.key === "Tab" && V(R), R.key === "Enter" && q(R), !r.value.enabled) {
        if (R.code === "Tab") return;
        R.preventDefault();
      }
    };
    return e({
      focusInput: () => {
        var R;
        (R = w.value) == null || R.focus({ preventScroll: !0 });
      },
      setParsedDate: (R) => {
        p.value = R;
      }
    }), (R, de) => {
      var Le;
      return h(), b("div", { onClick: ie }, [
        R.$slots.trigger && !R.$slots["dp-input"] && !O(o).enabled ? xe(R.$slots, "trigger", { key: 0 }) : E("", !0),
        !R.$slots.trigger && (!O(o).enabled || O(o).input) ? (h(), b("div", cz, [
          R.$slots["dp-input"] && !R.$slots.trigger && (!O(o).enabled || O(o).enabled && O(o).input) ? xe(R.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: W,
            onEnter: q,
            onTab: V,
            onClear: $,
            onBlur: K,
            onKeypress: X,
            onPaste: P,
            onFocus: re,
            openMenu: () => R.$emit("open"),
            closeMenu: () => R.$emit("close"),
            toggleMenu: () => R.$emit("toggle")
          }) : E("", !0),
          R.$slots["dp-input"] ? E("", !0) : (h(), b("input", {
            key: 1,
            id: R.uid ? `dp-input-${R.uid}` : void 0,
            ref_key: "inputRef",
            ref: w,
            "data-test": "dp-input",
            name: R.name,
            class: se(A.value),
            inputmode: O(r).enabled ? "text" : "none",
            placeholder: R.placeholder,
            disabled: R.disabled,
            readonly: R.readonly,
            required: R.required,
            value: t.inputValue,
            autocomplete: R.autocomplete,
            "aria-label": (Le = O(s)) == null ? void 0 : Le.input,
            "aria-disabled": R.disabled || void 0,
            "aria-invalid": R.state === !1 ? !0 : void 0,
            onInput: W,
            onBlur: K,
            onFocus: re,
            onKeypress: X,
            onKeydown: X,
            onPaste: P
          }, null, 42, uz)),
          k("div", {
            onClick: de[2] || (de[2] = (Ie) => a("toggle"))
          }, [
            R.$slots["input-icon"] && !R.hideInputIcon ? (h(), b("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: de[0] || (de[0] = (Ie) => a("toggle"))
            }, [
              xe(R.$slots, "input-icon")
            ])) : E("", !0),
            !R.$slots["input-icon"] && !R.hideInputIcon && !R.$slots["dp-input"] ? (h(), Z(O(no), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: de[1] || (de[1] = (Ie) => a("toggle"))
            })) : E("", !0)
          ]),
          R.$slots["clear-icon"] && t.inputValue && R.clearable && !R.disabled && !R.readonly ? (h(), b("span", dz, [
            xe(R.$slots, "clear-icon", { clear: $ })
          ])) : E("", !0),
          R.clearable && !R.$slots["clear-icon"] && t.inputValue && !R.disabled && !R.readonly ? (h(), Z(O(Hv), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: de[3] || (de[3] = Ba((Ie) => $(Ie), ["prevent"]))
          })) : E("", !0)
        ])) : E("", !0)
      ]);
    };
  }
}), fz = typeof window < "u" ? window : void 0, m0 = () => {
}, pz = (t) => Kb() ? (Qb(t), !0) : !1, mz = (t, e, n, a) => {
  if (!t) return m0;
  let i = m0;
  const r = at(
    () => O(t),
    (o) => {
      i(), o && (o.addEventListener(e, n, a), i = () => {
        o.removeEventListener(e, n, a), i = m0;
      });
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    r(), i();
  };
  return pz(s), s;
}, gz = (t, e, n, a = {}) => {
  const { window: i = fz, event: r = "pointerdown" } = a;
  return i ? mz(i, r, (s) => {
    const o = on(t), l = on(e);
    !o || !l || o === s.target || s.composedPath().includes(o) || s.composedPath().includes(l) || n(s);
  }, { passive: !0 }) : void 0;
}, bz = /* @__PURE__ */ Ae({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Ku
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = t, r = nr(), s = J(!1), o = As(i, "modelValue"), l = As(i, "timezone"), c = J(null), d = J(null), f = J(null), g = J(!1), _ = J(null), x = J(!1), p = J(!1), w = J(!1), C = J(!1), { setMenuFocused: M, setShiftKey: A } = ty(), { clearArrowNav: L } = rr(), { validateDate: D, isValidTime: B } = sr(i), {
      defaultedTransitions: P,
      defaultedTextInput: z,
      defaultedInline: W,
      defaultedConfig: q,
      defaultedRange: V,
      defaultedMultiDates: re
    } = jt(i), { menuTransition: ie, showTransition: K } = Nl(P);
    ht(() => {
      pe(i.modelValue), Dn().then(() => {
        if (!W.value.enabled) {
          const ye = Ve(_.value);
          ye == null || ye.addEventListener("scroll", Ce), window == null || window.addEventListener("resize", _e);
        }
      }), W.value.enabled && (s.value = !0), window == null || window.addEventListener("keyup", tt), window == null || window.addEventListener("keydown", oe);
    }), Xs(() => {
      if (!W.value.enabled) {
        const ye = Ve(_.value);
        ye == null || ye.removeEventListener("scroll", Ce), window == null || window.removeEventListener("resize", _e);
      }
      window == null || window.removeEventListener("keyup", tt), window == null || window.removeEventListener("keydown", oe);
    });
    const $ = ca(r, "all", i.presetDates), X = ca(r, "input");
    at(
      [o, l],
      () => {
        pe(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: R, menuStyle: de, xCorrect: Le, setMenuPosition: Ie, getScrollableParent: Ve, shadowRender: te } = iz({
      menuRef: c,
      menuRefInner: d,
      inputRef: f,
      pickerWrapperRef: _,
      inline: W,
      emit: a,
      props: i,
      slots: r
    }), {
      inputValue: we,
      internalModelValue: H,
      parseExternalModelValue: pe,
      emitModelValue: Ne,
      formatInputValue: ee,
      checkBeforeEmit: ze
    } = X$(a, i, g), et = I(
      () => ({
        dp__main: !0,
        dp__theme_dark: i.dark,
        dp__theme_light: !i.dark,
        dp__flex_display: W.value.enabled,
        "dp--flex-display-collapsed": w.value,
        dp__flex_display_with_input: W.value.input
      })
    ), Te = I(() => i.dark ? "dp__theme_dark" : "dp__theme_light"), Qe = I(() => i.teleport ? {
      to: typeof i.teleport == "boolean" ? "body" : i.teleport,
      disabled: !i.teleport || W.value.enabled
    } : {}), G = I(() => ({ class: "dp__outer_menu_wrap" })), Se = I(() => W.value.enabled && (i.timePicker || i.monthPicker || i.yearPicker || i.quarterPicker)), he = () => {
      var ye, Be;
      return (Be = (ye = f.value) == null ? void 0 : ye.$el) == null ? void 0 : Be.getBoundingClientRect();
    }, Ce = () => {
      s.value && (q.value.closeOnScroll ? hn() : Ie());
    }, _e = () => {
      var ye;
      s.value && Ie();
      const Be = (ye = d.value) == null ? void 0 : ye.$el.getBoundingClientRect().width;
      w.value = document.body.offsetWidth <= Be;
    }, tt = (ye) => {
      ye.key === "Tab" && !W.value.enabled && !i.teleport && q.value.tabOutClosesMenu && (_.value.contains(document.activeElement) || hn()), p.value = ye.shiftKey;
    }, oe = (ye) => {
      p.value = ye.shiftKey;
    }, Oe = () => {
      !i.disabled && !i.readonly && (te(R1, i), Ie(!1), s.value = !0, s.value && a("open"), s.value || li(), pe(i.modelValue));
    }, Re = () => {
      var ye;
      we.value = "", li(), (ye = f.value) == null || ye.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), q.value.closeOnClearValue && hn();
    }, lt = () => {
      const ye = H.value;
      return !ye || !Array.isArray(ye) && D(ye) ? !0 : Array.isArray(ye) ? re.value.enabled || ye.length === 2 && D(ye[0]) && D(ye[1]) ? !0 : V.value.partialRange && !i.timePicker ? D(ye[0]) : !1 : !1;
    }, Mt = () => {
      ze() && lt() ? (Ne(), hn()) : a("invalid-select", H.value);
    }, We = (ye) => {
      fa(), Ne(), q.value.closeOnAutoApply && !ye && hn();
    }, fa = () => {
      f.value && z.value.enabled && f.value.setParsedDate(H.value);
    }, jn = (ye = !1) => {
      i.autoApply && B(H.value) && lt() && (V.value.enabled && Array.isArray(H.value) ? (V.value.partialRange || H.value.length === 2) && We(ye) : We(ye));
    }, li = () => {
      z.value.enabled || (H.value = null);
    }, hn = () => {
      W.value.enabled || (s.value && (s.value = !1, Le.value = !1, M(!1), A(!1), L(), a("closed"), we.value && pe(o.value)), li(), a("blur"));
    }, ci = (ye, Be, Ue = !1) => {
      if (!ye) {
        H.value = null;
        return;
      }
      const _n = Array.isArray(ye) ? !ye.some((ui) => !D(ui)) : D(ye), Vn = B(ye);
      _n && Vn && (C.value = !0, H.value = ye, Be && (x.value = Ue, Mt(), a("text-submit")), Dn().then(() => {
        C.value = !1;
      }));
    }, Vr = () => {
      i.autoApply && B(H.value) && Ne(), fa();
    }, cr = () => s.value ? hn() : Oe(), qr = (ye) => {
      H.value = ye;
    }, bt = () => {
      z.value.enabled && (g.value = !0, ee()), a("focus");
    }, po = () => {
      if (z.value.enabled && (g.value = !1, pe(i.modelValue), x.value)) {
        const ye = T$(_.value, p.value);
        ye == null || ye.focus();
      }
      a("blur");
    }, Di = (ye) => {
      d.value && d.value.updateMonthYear(0, {
        month: L1(ye.month),
        year: L1(ye.year)
      });
    }, mo = (ye) => {
      pe(ye ?? i.modelValue);
    }, go = (ye, Be) => {
      var Ue;
      (Ue = d.value) == null || Ue.switchView(ye, Be);
    }, ue = (ye) => q.value.onClickOutside ? q.value.onClickOutside(ye) : hn(), Pe = (ye = 0) => {
      var Be;
      (Be = d.value) == null || Be.handleFlow(ye);
    };
    return gz(c, f, () => ue(lt)), e({
      closeMenu: hn,
      selectDate: Mt,
      clearValue: Re,
      openMenu: Oe,
      onScroll: Ce,
      formatInputValue: ee,
      // exposed for testing purposes
      updateInternalModelValue: qr,
      // modify internal modelValue
      setMonthYear: Di,
      parseModel: mo,
      switchView: go,
      toggleMenu: cr,
      handleFlow: Pe
    }), (ye, Be) => (h(), b("div", {
      ref_key: "pickerWrapperRef",
      ref: _,
      class: se(et.value),
      "data-datepicker-instance": ""
    }, [
      Q(hz, $t({
        ref_key: "inputRef",
        ref: f,
        "input-value": O(we),
        "onUpdate:inputValue": Be[0] || (Be[0] = (Ue) => wm(we) ? we.value = Ue : null),
        "is-menu-open": s.value
      }, ye.$props, {
        onClear: Re,
        onOpen: Oe,
        onSetInputDate: ci,
        onSetEmptyDate: O(Ne),
        onSelectDate: Mt,
        onToggle: cr,
        onClose: hn,
        onFocus: bt,
        onBlur: po,
        onRealBlur: Be[1] || (Be[1] = (Ue) => g.value = !1)
      }), rn({ _: 2 }, [
        Ee(O(X), (Ue, _n) => ({
          name: Ue,
          fn: ce((Vn) => [
            xe(ye.$slots, Ue, ln(Un(Vn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (h(), Z(ut(ye.teleport ? M4 : "div"), ln(Un(Qe.value)), {
        default: ce(() => [
          Q(Fr, {
            name: O(ie)(O(R)),
            css: O(K) && !O(W).enabled
          }, {
            default: ce(() => [
              s.value ? (h(), b("div", $t({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: c
              }, G.value, {
                class: { "dp--menu-wrapper": !O(W).enabled },
                style: O(W).enabled ? void 0 : O(de)
              }), [
                Q(R1, $t({
                  ref_key: "dpMenuRef",
                  ref: d
                }, ye.$props, {
                  "internal-model-value": O(H),
                  "onUpdate:internalModelValue": Be[2] || (Be[2] = (Ue) => wm(H) ? H.value = Ue : null),
                  class: { [Te.value]: !0, "dp--menu-wrapper": ye.teleport },
                  "open-on-top": O(R),
                  "no-overlay-focus": Se.value,
                  collapse: w.value,
                  "get-input-rect": he,
                  "is-text-input-date": C.value,
                  onClosePicker: hn,
                  onSelectDate: Mt,
                  onAutoApply: jn,
                  onTimeUpdate: Vr,
                  onFlowStep: Be[3] || (Be[3] = (Ue) => ye.$emit("flow-step", Ue)),
                  onUpdateMonthYear: Be[4] || (Be[4] = (Ue) => ye.$emit("update-month-year", Ue)),
                  onInvalidSelect: Be[5] || (Be[5] = (Ue) => ye.$emit("invalid-select", O(H))),
                  onAutoApplyInvalid: Be[6] || (Be[6] = (Ue) => ye.$emit("invalid-select", Ue)),
                  onInvalidFixedRange: Be[7] || (Be[7] = (Ue) => ye.$emit("invalid-fixed-range", Ue)),
                  onRecalculatePosition: O(Ie),
                  onTooltipOpen: Be[8] || (Be[8] = (Ue) => ye.$emit("tooltip-open", Ue)),
                  onTooltipClose: Be[9] || (Be[9] = (Ue) => ye.$emit("tooltip-close", Ue)),
                  onTimePickerOpen: Be[10] || (Be[10] = (Ue) => ye.$emit("time-picker-open", Ue)),
                  onTimePickerClose: Be[11] || (Be[11] = (Ue) => ye.$emit("time-picker-close", Ue)),
                  onAmPmChange: Be[12] || (Be[12] = (Ue) => ye.$emit("am-pm-change", Ue)),
                  onRangeStart: Be[13] || (Be[13] = (Ue) => ye.$emit("range-start", Ue)),
                  onRangeEnd: Be[14] || (Be[14] = (Ue) => ye.$emit("range-end", Ue)),
                  onDateUpdate: Be[15] || (Be[15] = (Ue) => ye.$emit("date-update", Ue)),
                  onInvalidDate: Be[16] || (Be[16] = (Ue) => ye.$emit("invalid-date", Ue)),
                  onOverlayToggle: Be[17] || (Be[17] = (Ue) => ye.$emit("overlay-toggle", Ue))
                }), rn({ _: 2 }, [
                  Ee(O($), (Ue, _n) => ({
                    name: Ue,
                    fn: ce((Vn) => [
                      xe(ye.$slots, Ue, ln(Un({ ...Vn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : E("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), su = /* @__PURE__ */ (() => {
  const t = bz;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), vz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: su
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(vz).forEach(([t, e]) => {
  t !== "default" && (su[t] = e);
});
const yz = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-left"
};
function _z(t, e) {
  return h(), b("svg", yz, e[0] || (e[0] = [
    k("path", {
      d: "m18 21-4-4 4-4",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const N1 = { render: _z }, xz = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-right"
};
function Tz(t, e) {
  return h(), b("svg", xz, e[0] || (e[0] = [
    k("path", {
      d: "m14 13 4 4-4 4",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Tl = { render: Tz }, wz = { class: "date-filter" }, kz = { class: "custom-header" }, Sz = { class: "custom-month-year-component" }, Cz = { class: "custom-nav-buttons" }, Az = ["onClick"], Ez = ["onClick"], Lz = { class: "day-header" }, Dz = { class: "day-content" }, Iz = {
  key: 0,
  class: "event-dots"
}, Mz = {
  key: 0,
  class: "dot"
}, Oz = { class: "action-row" }, Pz = { class: "button-text" }, Bz = { class: "custom-header" }, Rz = { class: "custom-month-year-component" }, Nz = { class: "custom-nav-buttons" }, $z = ["onClick"], Fz = ["onClick"], zz = { class: "day-header" }, Uz = { class: "day-content" }, Hz = {
  key: 0,
  class: "event-dots"
}, Yz = {
  key: 0,
  class: "dot"
}, jz = { class: "action-row" }, Vz = /* @__PURE__ */ Ae({
  __name: "DateFilter",
  props: {
    eventDates: {
      type: Array,
      default: () => []
    },
    initialDates: {
      type: Object,
      default: () => ({ startDate: null, endDate: null })
    },
    // if true, the datepicker will be shown in 'inline' mode all the time, event on desktop
    // this option is not currently used on the ftva site
    // https://vue3datepicker.com/props/modes/#inline
    hideInput: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input-selected"],
  setup(t, { expose: e, emit: n }) {
    const a = n, i = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], r = {
      closeOnAutoApply: !1,
      keepActionRow: !0
    }, s = J([]), o = J(null), l = J(!1), c = J(!1), d = J(!1), f = J(!1), g = J({
      rangeSeparator: " — "
    }), _ = I(() => s.value && "length" in s.value ? {
      startDate: s.value[0],
      endDate: s.value[1]
    } : s.value ? {
      startDate: s.value,
      endDate: null
    } : {
      startDate: null,
      endDate: null
    });
    t.initialDates.startDate && t.initialDates.endDate ? s.value = [t.initialDates.startDate, t.initialDates.endDate] : t.initialDates.startDate && (s.value = [t.initialDates.startDate, t.initialDates.startDate]);
    function x(ie) {
      const K = {};
      for (let $ = 0; $ < ie.length; $++)
        K[ie[$]] === void 0 ? K[ie[$]] = 1 : K[ie[$]]++;
      return K;
    }
    const p = x(t.eventDates);
    function w() {
      var ie, K;
      f.value === !0 ? ((ie = o.value) == null || ie.updateInternalModelValue(null), f.value = !1, (K = document == null ? void 0 : document.activeElement) == null || K.blur()) : (d.value ? s.value = /* @__PURE__ */ new Date() : s.value = [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()], f.value = !0);
    }
    function C() {
      var ie, K, $;
      (ie = o.value) == null || ie.updateInternalModelValue(null), f.value = !1, (K = o.value) == null || K.clearValue(), ($ = o.value) == null || $.openMenu(), a("input-selected", _.value);
    }
    function M() {
      var ie;
      a("input-selected", _.value), (ie = o.value) == null || ie.closeMenu();
    }
    function A(ie) {
      ie && "length" in ie && ie.length.valueOf() === 1 ? l.value = !0 : l.value = !1;
    }
    function L() {
      d.value && s.value && "length" in s.value && (s.value = s.value[0]);
    }
    function D() {
      f.value = !1;
    }
    function B() {
      c.value = !c.value;
    }
    function P() {
      var ie;
      (ie = o.value) == null || ie.openMenu();
    }
    function z() {
      var ie;
      (ie = o.value) == null || ie.closeMenu();
    }
    e({
      openDatepicker: P,
      closeDatepicker: z
    });
    const W = I(() => ["vue-date-picker", { "is-selecting": l.value }]), q = I(() => ["toggle-triangle-icon", { "is-open": c.value }]), V = I(() => ["today-button", { "is-active-selection": f.value }]), re = ge(() => Promise.resolve().then(() => Dl));
    return at(s, async (ie, K) => {
      ie !== K && (ie && "length" in ie && ie[1] === null ? g.value = {
        rangeSeparator: " "
      } : g.value = {
        rangeSeparator: " — "
      });
    }), ht(() => {
      const { width: ie } = Ei();
      at(ie, (K) => {
        d.value = K <= 750, L();
      }, { immediate: !0 });
    }), (ie, K) => (h(), b("div", wz, [
      d.value ? (h(), Z(ef, { key: 1 }, {
        buttonLabel: ce(() => [
          k("span", Pz, [
            Q(O($c)),
            K[2] || (K[2] = Ye("Calendar "))
          ])
        ]),
        dropdownItems: ce(({ removeOverlay: $ }) => [
          Q(O(su), {
            ref_key: "datepicker",
            ref: o,
            modelValue: s.value,
            "onUpdate:modelValue": K[1] || (K[1] = (X) => s.value = X),
            config: r,
            range: !d.value,
            "week-start": 0,
            "month-name-format": "long",
            "enable-time-picker": !1,
            "auto-position": !1,
            "auto-apply": !0,
            "text-input": g.value,
            "no-today": "",
            inline: !0,
            class: se(W.value),
            placeholder: d.value ? "Select a date" : "All upcoming",
            onInternalModelChange: A,
            onRangeStart: D,
            onOpen: B,
            onClosed: B
          }, {
            "input-icon": ce(() => [
              Q(O($c)),
              k("span", {
                class: se(q.value)
              }, [
                Q(O(Jh))
              ], 2)
            ]),
            "clear-icon": ce(({ clear: X }) => [
              Q(O(Or), { onClick: X }, null, 8, ["onClick"])
            ]),
            "month-year": ce(({
              month: X,
              year: R,
              months: de,
              handleMonthYearChange: Le
            }) => [
              k("div", Bz, [
                k("div", Rz, ae(de[X].text) + " " + ae(R), 1),
                k("div", Nz, [
                  k("button", {
                    class: "nav-arrow-button",
                    onClick: (Ie) => {
                      D(), Le(!1);
                    }
                  }, [
                    Q(O(N1))
                  ], 8, $z),
                  k("button", {
                    class: se(V.value),
                    onClick: w
                  }, " TODAY ", 2),
                  k("button", {
                    class: "nav-arrow-button",
                    onClick: (Ie) => {
                      D(), Le(!0);
                    }
                  }, [
                    Q(O(Tl))
                  ], 8, Fz)
                ])
              ])
            ]),
            "calendar-header": ce(({ index: X }) => [
              k("div", zz, ae(i[X]), 1)
            ]),
            day: ce(({ day: X, date: R }) => [
              k("div", Uz, [
                Ye(ae(X) + " ", 1),
                O(p).hasOwnProperty(R.toLocaleDateString()) ? (h(), b("div", Hz, [
                  (h(!0), b(me, null, Ee(O(p)[R.toLocaleDateString()], (de) => (h(), b(me, { key: de }, [
                    de <= 3 ? (h(), b("span", Yz)) : E("", !0)
                  ], 64))), 128))
                ])) : E("", !0)
              ])
            ]),
            "action-row": ce(({ selectDate: X }) => [
              k("div", jz, [
                Q(O(re), {
                  class: "action-row-button select-button",
                  label: "Done",
                  "icon-name": "none",
                  onClick: (R) => {
                    X(), M(), $();
                  }
                }, null, 8, ["onClick"]),
                Q(O(re), {
                  class: "action-row-button clear-button",
                  label: "Clear",
                  "icon-name": "icon-close",
                  onClick: C
                })
              ])
            ]),
            _: 2
          }, 1032, ["modelValue", "range", "text-input", "class", "placeholder"])
        ]),
        _: 1
      })) : (h(), Z(O(su), {
        key: 0,
        ref_key: "datepicker",
        ref: o,
        modelValue: s.value,
        "onUpdate:modelValue": K[0] || (K[0] = ($) => s.value = $),
        config: r,
        range: !d.value,
        "week-start": 0,
        "month-name-format": "long",
        "enable-time-picker": !1,
        "auto-position": !1,
        "auto-apply": !0,
        "text-input": g.value,
        "no-today": "",
        inline: t.hideInput,
        class: se(W.value),
        placeholder: d.value ? "Select a date" : "All upcoming",
        onInternalModelChange: A,
        onRangeStart: D,
        onOpen: B,
        onClosed: B
      }, {
        "input-icon": ce(() => [
          Q(O($c))
        ]),
        "clear-icon": ce(({ clear: $ }) => [
          Q(O(Or), { onClick: $ }, null, 8, ["onClick"])
        ]),
        "month-year": ce(({
          month: $,
          year: X,
          months: R,
          handleMonthYearChange: de
        }) => [
          k("div", kz, [
            k("div", Sz, ae(R[$].text) + " " + ae(X), 1),
            k("div", Cz, [
              k("button", {
                class: "nav-arrow-button",
                onClick: (Le) => {
                  D(), de(!1);
                }
              }, [
                Q(O(N1))
              ], 8, Az),
              k("button", {
                class: se(V.value),
                onClick: w
              }, " TODAY ", 2),
              k("button", {
                class: "nav-arrow-button",
                onClick: (Le) => {
                  D(), de(!0);
                }
              }, [
                Q(O(Tl))
              ], 8, Ez)
            ])
          ])
        ]),
        "calendar-header": ce(({ index: $ }) => [
          k("div", Lz, ae(i[$]), 1)
        ]),
        day: ce(({ day: $, date: X }) => [
          k("div", Dz, [
            Ye(ae($) + " ", 1),
            O(p).hasOwnProperty(X.toLocaleDateString()) ? (h(), b("div", Iz, [
              (h(!0), b(me, null, Ee(O(p)[X.toLocaleDateString()], (R) => (h(), b(me, { key: R }, [
                R <= 3 ? (h(), b("span", Mz)) : E("", !0)
              ], 64))), 128))
            ])) : E("", !0)
          ])
        ]),
        "action-row": ce(({ selectDate: $ }) => [
          k("div", Oz, [
            Q(O(re), {
              class: "action-row-button select-button",
              label: "Done",
              "icon-name": "none",
              onClick: (X) => {
                $(), M();
              }
            }, null, 8, ["onClick"]),
            Q(O(re), {
              class: "action-row-button clear-button",
              label: "Clear",
              "icon-name": "icon-close",
              onClick: C
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "range", "text-input", "inline", "class", "placeholder"]))
    ]));
  }
}), G0e = /* @__PURE__ */ be(Vz, [["__scopeId", "data-v-a2fcc450"]]), qz = {
  key: 0,
  class: "list-top-wrapper"
}, Wz = { class: "definition-list-wrapper" }, Gz = { key: 0 }, Xz = {
  key: 1,
  class: "white-space-wrap"
}, Zz = {
  key: 1,
  class: "list-bottom-wrapper"
}, Kz = /* @__PURE__ */ Ae({
  __name: "DefinitionList",
  props: {
    metaDataObject: {
      type: Object,
      default: () => {
      }
    },
    // switch CSS styling between vertical or horizontal layout
    orientation: {
      type: String,
      default: "vertical"
    }
  },
  setup(t) {
    function e(r) {
      return typeof r == "string" ? r : Array.isArray(r) ? r.map((s) => e(s)).join(", ").replace(/(, ){2,}/g, ", ") : typeof r == "object" ? r == null ? void 0 : Object.keys(r).map((s) => typeof r[s] == "string" ? `${s}: ${r[s]}` : e(r[s])).join(", ").replace(/,\s*$/, "") : r;
    }
    const n = [null, void 0, "", [], {}], a = Ge(), i = I(() => ["definition-list", (a == null ? void 0 : a.value) || ""]);
    return (r, s) => (h(), b("div", {
      class: se(i.value)
    }, [
      r.$slots["list-top"] ? (h(), b("div", qz, [
        xe(r.$slots, "list-top", {}, void 0, !0)
      ])) : E("", !0),
      k("dl", Wz, [
        (h(!0), b(me, null, Ee(t.metaDataObject, (o, l) => (h(), b("div", {
          key: l,
          class: se(["definition-list-item-wrapper", t.orientation])
        }, [
          n.includes(e(o)) ? E("", !0) : (h(), b("dt", Gz, [
            xe(r.$slots, `term-${l}`, {}, () => [
              Ye(ae(l.replace(/([A-Z])/g, " $1").trim()), 1)
            ], !0)
          ])),
          n.includes(e(o)) ? E("", !0) : (h(), b("dd", Xz, [
            xe(r.$slots, `definition-${l}`, {}, () => [
              Ye(ae(e(o)), 1)
            ], !0)
          ]))
        ], 2))), 128))
      ]),
      r.$slots["list-bottom"] ? (h(), b("div", Zz, [
        xe(r.$slots, "list-bottom", {}, void 0, !0)
      ])) : E("", !0)
    ], 2));
  }
}), X0e = /* @__PURE__ */ be(Kz, [["__scopeId", "data-v-32d0d7c1"]]), Qz = {
  name: "DividerGeneral",
  // vue component name
  props: {
    isBold: {
      type: Boolean,
      default: !1
    },
    isTertiary: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classes() {
      return ["divider-general", { "is-bold": this.isBold }, { "is-tertiary": this.isTertiary }];
    }
  }
};
function Jz(t, e, n, a, i, r) {
  return h(), b("div", {
    class: se(r.classes)
  }, null, 2);
}
const eh = /* @__PURE__ */ be(Qz, [["render", Jz], ["__scopeId", "data-v-d8e8ef90"]]), eU = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-xtag"
};
function ly(t, e) {
  return h(), b("svg", eU, e[0] || (e[0] = [
    k("path", {
      d: "M8.95349 8.2461L8.95349 8.2461L5.7069 5L8.95349 1.7539L8.95349 1.75389C9.0473 1.66009 9.1 1.53286 9.1 1.4002C9.1 1.26754 9.0473 1.14031 8.95349 1.04651C8.85969 0.952699 8.73246 0.9 8.5998 0.9C8.46714 0.9 8.33991 0.9527 8.2461 1.04651L8.2461 1.04651L5 4.2931L1.7539 1.04651L1.75389 1.04651C1.66009 0.952699 1.53286 0.9 1.4002 0.9C1.26754 0.9 1.14031 0.952699 1.04651 1.04651C0.952699 1.14031 0.9 1.26754 0.9 1.4002C0.9 1.53286 0.952699 1.66009 1.04651 1.75389L1.04651 1.7539L4.2931 5L1.04651 8.2461L1.04651 8.2461C0.9527 8.33991 0.9 8.46714 0.9 8.5998C0.9 8.73246 0.952699 8.85969 1.04651 8.95349C1.14031 9.0473 1.26754 9.1 1.4002 9.1C1.53286 9.1 1.66009 9.0473 1.75389 8.95349L1.7539 8.95349L5 5.7069L8.2461 8.95349L8.2461 8.95349C8.29255 8.99994 8.34769 9.03679 8.40838 9.06192C8.46907 9.08706 8.53411 9.1 8.5998 9.1C8.66549 9.1 8.73053 9.08706 8.79122 9.06192C8.8519 9.03679 8.90705 8.99994 8.95349 8.9535L8.88278 8.88278L8.9535 8.95349C8.99994 8.90705 9.03679 8.8519 9.06192 8.79122C9.08706 8.73053 9.1 8.66549 9.1 8.5998C9.1 8.53411 9.08706 8.46907 9.06192 8.40838C9.03679 8.34769 8.99994 8.29255 8.95349 8.2461Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.2",
      class: "svg__stroke--pure-white svg__fill--pure-white"
    }, null, -1)
  ]));
}
const cy = { render: ly }, tU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cy,
  render: ly
}, Symbol.toStringTag, { value: "Module" })), nU = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-filter"
};
function aU(t, e) {
  return h(), b("svg", nU, e[0] || (e[0] = [
    k("path", {
      d: "M6.25 2.33556C5.91848 2.33556 5.60054 2.45844 5.36612 2.67717C5.1317 2.89591 5 3.19257 5 3.50191C5 3.81124 5.1317 4.10791 5.36612 4.32664C5.60054 4.54537 5.91848 4.66825 6.25 4.66825C6.58152 4.66825 6.89946 4.54537 7.13388 4.32664C7.3683 4.10791 7.5 3.81124 7.5 3.50191C7.5 3.19257 7.3683 2.89591 7.13388 2.67717C6.89946 2.45844 6.58152 2.33556 6.25 2.33556ZM2.7125 2.33556C2.97075 1.65262 3.44967 1.06124 4.08325 0.642938C4.71683 0.224634 5.47386 0 6.25 0C7.02614 0 7.78317 0.224634 8.41675 0.642938C9.05033 1.06124 9.52925 1.65262 9.7875 2.33556H18.75C19.0815 2.33556 19.3995 2.45844 19.6339 2.67717C19.8683 2.89591 20 3.19257 20 3.50191C20 3.81124 19.8683 4.10791 19.6339 4.32664C19.3995 4.54537 19.0815 4.66825 18.75 4.66825H9.7875C9.52925 5.35119 9.05033 5.94257 8.41675 6.36087C7.78317 6.77918 7.02614 7.00381 6.25 7.00381C5.47386 7.00381 4.71683 6.77918 4.08325 6.36087C3.44967 5.94257 2.97075 5.35119 2.7125 4.66825H1.25C0.918479 4.66825 0.600537 4.54537 0.366117 4.32664C0.131696 4.10791 0 3.81124 0 3.50191C0 3.19257 0.131696 2.89591 0.366117 2.67717C0.600537 2.45844 0.918479 2.33556 1.25 2.33556H2.7125ZM13.75 9.33365C13.4185 9.33365 13.1005 9.45653 12.8661 9.67527C12.6317 9.894 12.5 10.1907 12.5 10.5C12.5 10.8093 12.6317 11.106 12.8661 11.3247C13.1005 11.5435 13.4185 11.6663 13.75 11.6663C14.0815 11.6663 14.3995 11.5435 14.6339 11.3247C14.8683 11.106 15 10.8093 15 10.5C15 10.1907 14.8683 9.894 14.6339 9.67527C14.3995 9.45653 14.0815 9.33365 13.75 9.33365ZM10.2125 9.33365C10.4708 8.65071 10.9497 8.05934 11.5833 7.64103C12.2168 7.22273 12.9739 6.99809 13.75 6.99809C14.5261 6.99809 15.2832 7.22273 15.9167 7.64103C16.5503 8.05934 17.0292 8.65071 17.2875 9.33365H18.75C19.0815 9.33365 19.3995 9.45653 19.6339 9.67527C19.8683 9.894 20 10.1907 20 10.5C20 10.8093 19.8683 11.106 19.6339 11.3247C19.3995 11.5435 19.0815 11.6663 18.75 11.6663H17.2875C17.0292 12.3493 16.5503 12.9407 15.9167 13.359C15.2832 13.7773 14.5261 14.0019 13.75 14.0019C12.9739 14.0019 12.2168 13.7773 11.5833 13.359C10.9497 12.9407 10.4708 12.3493 10.2125 11.6663H1.25C0.918479 11.6663 0.600537 11.5435 0.366117 11.3247C0.131696 11.106 0 10.8093 0 10.5C0 10.1907 0.131696 9.894 0.366117 9.67527C0.600537 9.45653 0.918479 9.33365 1.25 9.33365H10.2125ZM6.25 16.3317C5.91848 16.3317 5.60054 16.4546 5.36612 16.6734C5.1317 16.8921 5 17.1888 5 17.4981C5 17.8074 5.1317 18.1041 5.36612 18.3228C5.60054 18.5416 5.91848 18.6644 6.25 18.6644C6.58152 18.6644 6.89946 18.5416 7.13388 18.3228C7.3683 18.1041 7.5 17.8074 7.5 17.4981C7.5 17.1888 7.3683 16.8921 7.13388 16.6734C6.89946 16.4546 6.58152 16.3317 6.25 16.3317ZM2.7125 16.3317C2.97075 15.6488 3.44967 15.0574 4.08325 14.6391C4.71683 14.2208 5.47386 13.9962 6.25 13.9962C7.02614 13.9962 7.78317 14.2208 8.41675 14.6391C9.05033 15.0574 9.52925 15.6488 9.7875 16.3317H18.75C19.0815 16.3317 19.3995 16.4546 19.6339 16.6734C19.8683 16.8921 20 17.1888 20 17.4981C20 17.8074 19.8683 18.1041 19.6339 18.3228C19.3995 18.5416 19.0815 18.6644 18.75 18.6644H9.7875C9.52925 19.3474 9.05033 19.9388 8.41675 20.3571C7.78317 20.7754 7.02614 21 6.25 21C5.47386 21 4.71683 20.7754 4.08325 20.3571C3.44967 19.9388 2.97075 19.3474 2.7125 18.6644H1.25C0.918479 18.6644 0.600537 18.5416 0.366117 18.3228C0.131696 18.1041 0 17.8074 0 17.4981C0 17.1888 0.131696 16.8921 0.366117 16.6734C0.600537 16.4546 0.918479 16.3317 1.25 16.3317H2.7125Z",
      fill: "#115DAF",
      class: "svg__fill--accent-blue"
    }, null, -1)
  ]));
}
const iU = { render: aU }, rU = { class: "filter-summary" }, sU = { class: "icon-svg" }, oU = { class: "dropdown-filter" }, lU = { class: "pills" }, cU = ["id", "onUpdate:modelValue", "name", "value"], uU = { class: "action-row" }, dU = /* @__PURE__ */ Ae({
  __name: "FiltersDropdown",
  props: /* @__PURE__ */ Sm({
    filterGroups: {
      type: Array,
      default: () => []
    }
  }, {
    selectedFilters: { type: Object, required: !0, default: {} },
    selectedFiltersModifiers: {}
  }),
  emits: /* @__PURE__ */ Sm(["update-display"], ["update:selectedFilters"]),
  setup(t, { emit: e }) {
    const n = e, a = P4(t, "selectedFilters"), i = I(() => {
      let f = 0;
      for (const g in a.value)
        f += a.value[g].length;
      return f;
    });
    function r(f, g) {
      return Object.keys(a.value).length ? a.value[f].includes(g) : null;
    }
    function s() {
      for (const f of t.filterGroups)
        a.value[f.searchField] = [];
    }
    function o() {
      n("update-display", a.value);
    }
    const l = Ge(), c = J(!1), d = I(() => ["filters-dropdown", (l == null ? void 0 : l.value) || ""]);
    return ht(() => {
      const { width: f } = Ei();
      at(f, (g) => {
        c.value = g <= 750;
      }, { immediate: !0 });
    }), (f, g) => (h(), b("div", {
      class: se(d.value)
    }, [
      Q(ef, null, {
        buttonLabel: ce(() => [
          k("div", rU, [
            c.value ? (h(), b(me, { key: 1 }, [
              Ye(" Filters ")
            ], 64)) : (h(), b(me, { key: 0 }, [
              Ye(" Filters (" + ae(i.value) + " selected ) ", 1)
            ], 64))
          ]),
          k("span", sU, [
            Q(O(iU), { "aria-hidden": "true" })
          ])
        ]),
        dropdownItems: ce(({ removeOverlay: _ }) => [
          k("div", oU, [
            (h(!0), b(me, null, Ee(t.filterGroups, (x) => (h(), b("div", {
              key: x.name,
              class: "filter-group"
            }, [
              k("h3", null, ae(x.name), 1),
              k("div", lU, [
                (h(!0), b(me, null, Ee(x.options, (p) => (h(), b("label", {
                  key: p,
                  class: "pill-label"
                }, [
                  kt(k("input", {
                    id: p,
                    "onUpdate:modelValue": (w) => a.value[x.searchField] = w,
                    type: "checkbox",
                    class: "pill-checkbox",
                    name: p,
                    value: p
                  }, null, 8, cU), [
                    [Nh, a.value[x.searchField]]
                  ]),
                  Q(Ks, {
                    label: p,
                    "is-secondary": !0
                  }, {
                    default: ce(() => [
                      r(x.searchField, p) ? (h(), Z(O(cy), {
                        key: 0,
                        class: "close-icon"
                      })) : E("", !0)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))), 128))
              ])
            ]))), 128)),
            k("div", uU, [
              Q(cn, {
                class: "action-row-button select-button",
                label: "Done",
                "icon-name": "none",
                onClick: (x) => {
                  o(), _();
                }
              }, null, 8, ["onClick"]),
              Q(cn, {
                class: "action-row-button clear-button",
                label: "Clear",
                "icon-name": "icon-close",
                onClick: s
              })
            ])
          ])
        ]),
        _: 1
      })
    ], 2));
  }
}), Z0e = /* @__PURE__ */ be(dU, [["__scopeId", "data-v-2d5454fd"]]);
function hU(t, e, n, a) {
  var i = -1, r = t == null ? 0 : t.length;
  for (a && r && (n = t[++i]); ++i < r; )
    n = e(n, t[i], i, t);
  return n;
}
var fU = hU, pU = U2, mU = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, gU = pU(mU), bU = gU, vU = bU, yU = Ml, _U = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, xU = "\\u0300-\\u036f", TU = "\\ufe20-\\ufe2f", wU = "\\u20d0-\\u20ff", kU = xU + TU + wU, SU = "[" + kU + "]", CU = RegExp(SU, "g");
function AU(t) {
  return t = yU(t), t && t.replace(_U, vU).replace(CU, "");
}
var EU = AU, LU = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function DU(t) {
  return t.match(LU) || [];
}
var IU = DU, MU = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function OU(t) {
  return MU.test(t);
}
var PU = OU, uy = "\\ud800-\\udfff", BU = "\\u0300-\\u036f", RU = "\\ufe20-\\ufe2f", NU = "\\u20d0-\\u20ff", $U = BU + RU + NU, dy = "\\u2700-\\u27bf", hy = "a-z\\xdf-\\xf6\\xf8-\\xff", FU = "\\xac\\xb1\\xd7\\xf7", zU = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", UU = "\\u2000-\\u206f", HU = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", fy = "A-Z\\xc0-\\xd6\\xd8-\\xde", YU = "\\ufe0e\\ufe0f", py = FU + zU + UU + HU, my = "['’]", $1 = "[" + py + "]", jU = "[" + $U + "]", gy = "\\d+", VU = "[" + dy + "]", by = "[" + hy + "]", vy = "[^" + uy + py + gy + dy + hy + fy + "]", qU = "\\ud83c[\\udffb-\\udfff]", WU = "(?:" + jU + "|" + qU + ")", GU = "[^" + uy + "]", yy = "(?:\\ud83c[\\udde6-\\uddff]){2}", _y = "[\\ud800-\\udbff][\\udc00-\\udfff]", cs = "[" + fy + "]", XU = "\\u200d", F1 = "(?:" + by + "|" + vy + ")", ZU = "(?:" + cs + "|" + vy + ")", z1 = "(?:" + my + "(?:d|ll|m|re|s|t|ve))?", U1 = "(?:" + my + "(?:D|LL|M|RE|S|T|VE))?", xy = WU + "?", Ty = "[" + YU + "]?", KU = "(?:" + XU + "(?:" + [GU, yy, _y].join("|") + ")" + Ty + xy + ")*", QU = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", JU = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", eH = Ty + xy + KU, tH = "(?:" + [VU, yy, _y].join("|") + ")" + eH, nH = RegExp([
  cs + "?" + by + "+" + z1 + "(?=" + [$1, cs, "$"].join("|") + ")",
  ZU + "+" + U1 + "(?=" + [$1, cs + F1, "$"].join("|") + ")",
  cs + "?" + F1 + "+" + z1,
  cs + "+" + U1,
  JU,
  QU,
  gy,
  tH
].join("|"), "g");
function aH(t) {
  return t.match(nH) || [];
}
var iH = aH, rH = IU, sH = PU, oH = Ml, lH = iH;
function cH(t, e, n) {
  return t = oH(t), e = n ? void 0 : e, e === void 0 ? sH(t) ? lH(t) : rH(t) : t.match(e) || [];
}
var uH = cH, dH = fU, hH = EU, fH = uH, pH = "['’]", mH = RegExp(pH, "g");
function gH(t) {
  return function(e) {
    return dH(fH(hH(e).replace(mH, "")), t, "");
  };
}
var bH = gH, vH = bH, yH = vH(function(t, e, n) {
  return t + (n ? "-" : "") + e.toLowerCase();
}), _H = yH;
const wy = /* @__PURE__ */ xa(_H), xH = ["data-cy"], TH = {
  key: 0,
  class: "section-header"
}, wH = ["innerHTML"], kH = ["innerHTML"], SH = { class: "cards" }, CH = /* @__PURE__ */ Ae({
  __name: "SectionCardsWithIllustrations",
  props: {
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    isHorizontal: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = I(() => [
      "section-cards-with-illustrations",
      { "is-horizontal": e.isHorizontal }
    ]), a = I(() => `section-cards-with-illustrations-${wy(e.sectionTitle) || "untitled"}`);
    return (i, r) => (h(), b("section", {
      class: se(n.value),
      "data-cy": a.value
    }, [
      t.sectionTitle || t.sectionSummary ? (h(), b("div", TH, [
        t.sectionTitle ? (h(), b("h2", {
          key: 0,
          id: "cards-with-illustration-title",
          class: "section-title",
          innerHTML: t.sectionTitle
        }, null, 8, wH)) : E("", !0),
        t.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, kH)) : E("", !0)
      ])) : E("", !0),
      k("ul", SH, [
        (h(!0), b(me, null, Ee(t.items, (s) => (h(), Z(bD, {
          key: s.to,
          "icon-name": s.iconName,
          to: s.to,
          title: s.title,
          text: s.text,
          category: s.category,
          "is-horizontal": t.isHorizontal
        }, null, 8, ["icon-name", "to", "title", "text", "category", "is-horizontal"]))), 128)),
        t.to ? (h(), Z(Ke, {
          key: 0,
          class: "card card-more",
          to: t.to
        }, {
          default: ce(() => [
            Q(tf, {
              id: "card-more-button",
              class: "button",
              text: t.buttonText,
              "aria-labelledby": "card-more-button cards-with-illustration-title"
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["to"])) : E("", !0)
      ])
    ], 10, xH));
  }
}), AH = /* @__PURE__ */ be(CH, [["__scopeId", "data-v-06b1ab58"]]);
function $n(t = "") {
  return t === null || t.match(/^(http|https):\/\//) ? t : (t.startsWith("/") || (t = `/${t}`), t.replace("meap/", ""));
}
const EH = /* @__PURE__ */ Ae({
  __name: "AssociatedTopicCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.associatedTopicsFlexiblePageBlock[0].topics.map(
      (n) => ({
        ...n,
        to: n.externalResourceUrl ? n.externalResourceUrl : $n(n.uri)
      })
    ));
    return (n, a) => t.block && t.block.associatedTopicsFlexiblePageBlock ? (h(), Z(AH, {
      key: 0,
      items: e.value,
      "section-title": t.block.sectionTitle,
      "section-summary": t.block.sectionSummary,
      "is-horizontal": !1,
      class: "associated-topic-cards"
    }, null, 8, ["items", "section-title", "section-summary"])) : E("", !0);
  }
}), LH = /* @__PURE__ */ be(EH, [["__scopeId", "data-v-17750fc2"]]), DH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LH
}, Symbol.toStringTag, { value: "Module" }));
function H1(t = "") {
  let e = "";
  const n = t.toLowerCase();
  switch (!0) {
    case n.includes("article"):
      e = "Read more";
      break;
    case n.includes("project"):
      e = "View project";
      break;
    case n.includes("event"):
      e = "View event";
      break;
    case n.includes("exhibition"):
      e = "View exhibition";
      break;
    case n.includes("collection"):
      e = "View collection";
      break;
    case n.includes("impactreportstory"):
      e = "Read full story";
      break;
  }
  return e;
}
const IH = { key: 0 }, MH = /* @__PURE__ */ Ae({
  __name: "BannerFeatured",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => {
      let f = {};
      return t.block.content[0].contentLink && t.block.content[0].contentLink.length > 0 && t.block.content[0].contentLink[0].heroImage && t.block.content[0].contentLink[0].heroImage.length > 0 ? f = t.block.content[0].contentLink[0].heroImage[0].image[0] : t.block.content[0].image && (f = t.block.content[0].image[0]), f;
    }), n = I(() => t.block.content[0].alignment === "right"), a = I(() => {
      let f = "";
      return t.block.content[0].contentType ? f = H1(t.block.content[0].contentType) : f = H1(t.block.content[0].contentLink[0].contentType), f;
    }), i = I(() => {
      let f = [];
      if (t.block.content && t.block.content[0].contentLink) {
        const g = t.block.content[0].contentLink[0].contentType.toLowerCase();
        switch (!0) {
          case g.includes("article"):
            f = t.block.content[0].contentLink[0].articleLocations;
            break;
          case g.includes("project"):
            f = t.block.content[0].contentLink[0].projectLocations;
            break;
          case g.includes("event"):
            f = t.block.content[0].contentLink[0].articleLocations;
            break;
        }
      }
      return t.block.content && t.block.content[0].location && f.push(t.block.content[0].location), f;
    }), r = I(() => {
      let f = "";
      if (t.block.content && t.block.content[0].category)
        return t.block.content[0].category;
      if (t.block.content && t.block.content[0].contentLink) {
        const g = t.block.content[0].contentLink[0].contentType, _ = t.block.content[0].contentLink[0].workshopOrEventSeriesType;
        switch (!0) {
          case g.includes("article"):
            f = t.block.content[0].contentLink[0].articleCategory.map((x) => x.title).toString();
            break;
          case g.includes("collection"):
            f = t.block.content[0].contentLink[0].physicalDigital[0];
            break;
          case g.includes("project"):
          case g.includes("event"):
          case g.includes("exhibition"):
          case g.includes("endowment"):
            f = g;
            break;
          case g.includes("impactReportStory"):
            f = "Spotlight";
            break;
          case g.includes("meapProject"):
            f = "Meap Project";
            break;
          case g.includes("meapArticle"):
            f = "Meap Article";
            break;
          case _.includes("help/services-resources"):
            f = "Workshop";
            break;
          case _.includes("visit/events-exhibitions"):
            f = "Event Series";
            break;
        }
      }
      return f;
    }), s = I(() => t.block.sectionTitle ? t.block.sectionTitle : r.value), o = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].startDateWithTime ? f = t.block.content[0].contentLink[0].startDateWithTime : t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].startDate && (f = t.block.content[0].contentLink[0].startDate), f;
    }), l = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].endDateWithTime ? f = t.block.content[0].contentLink[0].endDateWithTime : t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].endDate && (f = t.block.content[0].contentLink[0].endDate), f;
    }), c = I(() => {
      const f = [];
      if (t.block.content && t.block.content[0].contentLink) {
        const g = t.block.content[0].contentLink[0].contentType.toLowerCase(), _ = t.block.content[0].contentLink[0].articleByline1, x = t.block.content[0].contentLink[0].projectByline1, p = Nt(
          new Date(t.block.content[0].contentLink[0].articleByline2),
          "MMMM d, Y"
        );
        switch (!0) {
          case g.includes("article"):
            _ && _.forEach((w) => f.push(w.title)), f.push(p);
            break;
          case g.includes("project"):
            x && f.push(x[0].title);
            break;
        }
      }
      return t.block.content && (t.block.content[0].byline1 || t.block.content[0].byline2) && (f.push(t.block.content[0].byline1), f.push(t.block.content[0].byline2)), f;
    }), d = I(() => {
      let f = "";
      return t.block.content && t.block.content[0].contentLink && t.block.content[0].contentLink[0].contentType === "event" ? f = t.block.content[0].contentLink[0].eventDescription : f = t.block.content[0].contentLink[0].summary, f;
    });
    return (f, g) => t.block && t.block.content ? (h(), b("div", IH, [
      t.block && t.block.content && t.block.content[0].contentLink ? (h(), Z(Mm, {
        key: 0,
        class: "flexible-banner-featured",
        media: e.value,
        to: O($n)(t.block.content[0].contentLink[0].to),
        title: t.block.content[0].contentLink[0].title,
        breadcrumb: s.value,
        byline: c.value,
        description: d.value,
        prompt: a.value,
        locations: i.value,
        category: r.value,
        "start-date": o.value,
        "end-date": l.value,
        "section-handle": t.block.content[0].contentLink[0].contentType
      }, null, 8, ["media", "to", "title", "breadcrumb", "byline", "description", "prompt", "locations", "category", "start-date", "end-date", "section-handle"])) : E("", !0),
      t.block && t.block.content && !t.block.content[0].contentLink ? (h(), Z(Mm, {
        key: 1,
        class: "flexible-banner-featured",
        media: e.value,
        to: O($n)(t.block.content[0].to),
        title: t.block.content[0].title,
        breadcrumb: s.value,
        byline: c.value,
        description: t.block.content[0].summary,
        prompt: a.value,
        locations: i.value,
        category: r.value,
        "align-right": n.value,
        "section-handle": t.block.content[0].sectionHandle
      }, null, 8, ["media", "to", "title", "breadcrumb", "byline", "description", "prompt", "locations", "category", "align-right", "section-handle"])) : E("", !0)
    ])) : E("", !0);
  }
}), OH = /* @__PURE__ */ be(MH, [["__scopeId", "data-v-046e78ae"]]), PH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OH
}, Symbol.toStringTag, { value: "Module" }));
var BH = Uu;
function RH() {
  this.__data__ = new BH(), this.size = 0;
}
var NH = RH;
function $H(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var FH = $H;
function zH(t) {
  return this.__data__.get(t);
}
var UH = zH;
function HH(t) {
  return this.__data__.has(t);
}
var YH = HH, jH = Uu, VH = jh, qH = Vh, WH = 200;
function GH(t, e) {
  var n = this.__data__;
  if (n instanceof jH) {
    var a = n.__data__;
    if (!VH || a.length < WH - 1)
      return a.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new qH(a);
  }
  return n.set(t, e), this.size = n.size, this;
}
var XH = GH, ZH = Uu, KH = NH, QH = FH, JH = UH, eY = YH, tY = XH;
function ao(t) {
  var e = this.__data__ = new ZH(t);
  this.size = e.size;
}
ao.prototype.clear = KH;
ao.prototype.delete = QH;
ao.prototype.get = JH;
ao.prototype.has = eY;
ao.prototype.set = tY;
var nY = ao;
function aY(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length; ++n < a && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var iY = aY, rY = Hr, sY = function() {
  try {
    var t = rY(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), ky = sY, Y1 = ky;
function oY(t, e, n) {
  e == "__proto__" && Y1 ? Y1(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var Sy = oY, lY = Sy, cY = b2, uY = Object.prototype, dY = uY.hasOwnProperty;
function hY(t, e, n) {
  var a = t[e];
  (!(dY.call(t, e) && cY(a, n)) || n === void 0 && !(e in t)) && lY(t, e, n);
}
var Cy = hY, fY = Cy, pY = Sy;
function mY(t, e, n, a) {
  var i = !n;
  n || (n = {});
  for (var r = -1, s = e.length; ++r < s; ) {
    var o = e[r], l = a ? a(n[o], t[o], o, n, t) : void 0;
    l === void 0 && (l = t[o]), i ? pY(n, o, l) : fY(n, o, l);
  }
  return n;
}
var Fl = mY;
function gY(t, e) {
  for (var n = -1, a = Array(t); ++n < t; )
    a[n] = e(n);
  return a;
}
var bY = gY, vY = zr, yY = ir, _Y = "[object Arguments]";
function xY(t) {
  return yY(t) && vY(t) == _Y;
}
var TY = xY, j1 = TY, wY = ir, Ay = Object.prototype, kY = Ay.hasOwnProperty, SY = Ay.propertyIsEnumerable, CY = j1(/* @__PURE__ */ function() {
  return arguments;
}()) ? j1 : function(t) {
  return wY(t) && kY.call(t, "callee") && !SY.call(t, "callee");
}, xf = CY, ou = { exports: {} };
function AY() {
  return !1;
}
var EY = AY;
ou.exports;
(function(t, e) {
  var n = oi, a = EY, i = e && !e.nodeType && e, r = i && !0 && t && !t.nodeType && t, s = r && r.exports === i, o = s ? n.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || a;
  t.exports = c;
})(ou, ou.exports);
var Tf = ou.exports, LY = 9007199254740991, DY = /^(?:0|[1-9]\d*)$/;
function IY(t, e) {
  var n = typeof t;
  return e = e ?? LY, !!e && (n == "number" || n != "symbol" && DY.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var MY = IY, OY = 9007199254740991;
function PY(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= OY;
}
var Ey = PY, BY = zr, RY = Ey, NY = ir, $Y = "[object Arguments]", FY = "[object Array]", zY = "[object Boolean]", UY = "[object Date]", HY = "[object Error]", YY = "[object Function]", jY = "[object Map]", VY = "[object Number]", qY = "[object Object]", WY = "[object RegExp]", GY = "[object Set]", XY = "[object String]", ZY = "[object WeakMap]", KY = "[object ArrayBuffer]", QY = "[object DataView]", JY = "[object Float32Array]", ej = "[object Float64Array]", tj = "[object Int8Array]", nj = "[object Int16Array]", aj = "[object Int32Array]", ij = "[object Uint8Array]", rj = "[object Uint8ClampedArray]", sj = "[object Uint16Array]", oj = "[object Uint32Array]", Dt = {};
Dt[JY] = Dt[ej] = Dt[tj] = Dt[nj] = Dt[aj] = Dt[ij] = Dt[rj] = Dt[sj] = Dt[oj] = !0;
Dt[$Y] = Dt[FY] = Dt[KY] = Dt[zY] = Dt[QY] = Dt[UY] = Dt[HY] = Dt[YY] = Dt[jY] = Dt[VY] = Dt[qY] = Dt[WY] = Dt[GY] = Dt[XY] = Dt[ZY] = !1;
function lj(t) {
  return NY(t) && RY(t.length) && !!Dt[BY(t)];
}
var cj = lj, uj = cj, dj = ju, V1 = Vu, q1 = V1 && V1.isTypedArray, hj = q1 ? dj(q1) : uj, Ly = hj, fj = bY, pj = xf, mj = ar, gj = Tf, bj = MY, vj = Ly, yj = Object.prototype, _j = yj.hasOwnProperty;
function xj(t, e) {
  var n = mj(t), a = !n && pj(t), i = !n && !a && gj(t), r = !n && !a && !i && vj(t), s = n || a || i || r, o = s ? fj(t.length, String) : [], l = o.length;
  for (var c in t)
    (e || _j.call(t, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    bj(c, l))) && o.push(c);
  return o;
}
var Dy = xj, Tj = Object.prototype;
function wj(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || Tj;
  return t === n;
}
var td = wj;
function kj(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var Iy = kj, Sj = Iy, Cj = Sj(Object.keys, Object), Aj = Cj, Ej = td, Lj = Aj, Dj = Object.prototype, Ij = Dj.hasOwnProperty;
function Mj(t) {
  if (!Ej(t))
    return Lj(t);
  var e = [];
  for (var n in Object(t))
    Ij.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var My = Mj, Oj = m2, Pj = Ey;
function Bj(t) {
  return t != null && Pj(t.length) && !Oj(t);
}
var wf = Bj, Rj = Dy, Nj = My, $j = wf;
function Fj(t) {
  return $j(t) ? Rj(t) : Nj(t);
}
var kf = Fj, zj = Fl, Uj = kf;
function Hj(t, e) {
  return t && zj(e, Uj(e), t);
}
var Yj = Hj;
function jj(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var Vj = jj, qj = Ur, Wj = td, Gj = Vj, Xj = Object.prototype, Zj = Xj.hasOwnProperty;
function Kj(t) {
  if (!qj(t))
    return Gj(t);
  var e = Wj(t), n = [];
  for (var a in t)
    a == "constructor" && (e || !Zj.call(t, a)) || n.push(a);
  return n;
}
var Qj = Kj, Jj = Dy, eV = Qj, tV = wf;
function nV(t) {
  return tV(t) ? Jj(t, !0) : eV(t);
}
var Sf = nV, aV = Fl, iV = Sf;
function rV(t, e) {
  return t && aV(e, iV(e), t);
}
var sV = rV, lu = { exports: {} };
lu.exports;
(function(t, e) {
  var n = oi, a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, r = i && i.exports === a, s = r ? n.Buffer : void 0, o = s ? s.allocUnsafe : void 0;
  function l(c, d) {
    if (d)
      return c.slice();
    var f = c.length, g = o ? o(f) : new c.constructor(f);
    return c.copy(g), g;
  }
  t.exports = l;
})(lu, lu.exports);
var oV = lu.exports;
function lV(t, e) {
  var n = -1, a = t.length;
  for (e || (e = Array(a)); ++n < a; )
    e[n] = t[n];
  return e;
}
var cV = lV;
function uV(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length, i = 0, r = []; ++n < a; ) {
    var s = t[n];
    e(s, n, t) && (r[i++] = s);
  }
  return r;
}
var dV = uV;
function hV() {
  return [];
}
var Oy = hV, fV = dV, pV = Oy, mV = Object.prototype, gV = mV.propertyIsEnumerable, W1 = Object.getOwnPropertySymbols, bV = W1 ? function(t) {
  return t == null ? [] : (t = Object(t), fV(W1(t), function(e) {
    return gV.call(t, e);
  }));
} : pV, Cf = bV, vV = Fl, yV = Cf;
function _V(t, e) {
  return vV(t, yV(t), e);
}
var xV = _V;
function TV(t, e) {
  for (var n = -1, a = e.length, i = t.length; ++n < a; )
    t[i + n] = e[n];
  return t;
}
var Af = TV, wV = Iy, kV = wV(Object.getPrototypeOf, Object), Ef = kV, SV = Af, CV = Ef, AV = Cf, EV = Oy, LV = Object.getOwnPropertySymbols, DV = LV ? function(t) {
  for (var e = []; t; )
    SV(e, AV(t)), t = CV(t);
  return e;
} : EV, Py = DV, IV = Fl, MV = Py;
function OV(t, e) {
  return IV(t, MV(t), e);
}
var PV = OV, BV = Af, RV = ar;
function NV(t, e, n) {
  var a = e(t);
  return RV(t) ? a : BV(a, n(t));
}
var By = NV, $V = By, FV = Cf, zV = kf;
function UV(t) {
  return $V(t, zV, FV);
}
var HV = UV, YV = By, jV = Py, VV = Sf;
function qV(t) {
  return YV(t, VV, jV);
}
var Ry = qV, WV = Hr, GV = oi, XV = WV(GV, "DataView"), ZV = XV, KV = Hr, QV = oi, JV = KV(QV, "Promise"), eq = JV, tq = Hr, nq = oi, aq = tq(nq, "WeakMap"), iq = aq, th = ZV, nh = jh, ah = eq, ih = v2, rh = iq, Ny = zr, io = g2, G1 = "[object Map]", rq = "[object Object]", X1 = "[object Promise]", Z1 = "[object Set]", K1 = "[object WeakMap]", Q1 = "[object DataView]", sq = io(th), oq = io(nh), lq = io(ah), cq = io(ih), uq = io(rh), br = Ny;
(th && br(new th(new ArrayBuffer(1))) != Q1 || nh && br(new nh()) != G1 || ah && br(ah.resolve()) != X1 || ih && br(new ih()) != Z1 || rh && br(new rh()) != K1) && (br = function(t) {
  var e = Ny(t), n = e == rq ? t.constructor : void 0, a = n ? io(n) : "";
  if (a)
    switch (a) {
      case sq:
        return Q1;
      case oq:
        return G1;
      case lq:
        return X1;
      case cq:
        return Z1;
      case uq:
        return K1;
    }
  return e;
});
var nd = br, dq = Object.prototype, hq = dq.hasOwnProperty;
function fq(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && hq.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var pq = fq, mq = oi, gq = mq.Uint8Array, bq = gq, J1 = bq;
function vq(t) {
  var e = new t.constructor(t.byteLength);
  return new J1(e).set(new J1(t)), e;
}
var Lf = vq, yq = Lf;
function _q(t, e) {
  var n = e ? yq(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var xq = _q, Tq = /\w*$/;
function wq(t) {
  var e = new t.constructor(t.source, Tq.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var kq = wq, eg = Il, tg = eg ? eg.prototype : void 0, ng = tg ? tg.valueOf : void 0;
function Sq(t) {
  return ng ? Object(ng.call(t)) : {};
}
var Cq = Sq, Aq = Lf;
function Eq(t, e) {
  var n = e ? Aq(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var Lq = Eq, Dq = Lf, Iq = xq, Mq = kq, Oq = Cq, Pq = Lq, Bq = "[object Boolean]", Rq = "[object Date]", Nq = "[object Map]", $q = "[object Number]", Fq = "[object RegExp]", zq = "[object Set]", Uq = "[object String]", Hq = "[object Symbol]", Yq = "[object ArrayBuffer]", jq = "[object DataView]", Vq = "[object Float32Array]", qq = "[object Float64Array]", Wq = "[object Int8Array]", Gq = "[object Int16Array]", Xq = "[object Int32Array]", Zq = "[object Uint8Array]", Kq = "[object Uint8ClampedArray]", Qq = "[object Uint16Array]", Jq = "[object Uint32Array]";
function eW(t, e, n) {
  var a = t.constructor;
  switch (e) {
    case Yq:
      return Dq(t);
    case Bq:
    case Rq:
      return new a(+t);
    case jq:
      return Iq(t, n);
    case Vq:
    case qq:
    case Wq:
    case Gq:
    case Xq:
    case Zq:
    case Kq:
    case Qq:
    case Jq:
      return Pq(t, n);
    case Nq:
      return new a();
    case $q:
    case Uq:
      return new a(t);
    case Fq:
      return Mq(t);
    case zq:
      return new a();
    case Hq:
      return Oq(t);
  }
}
var tW = eW, nW = Ur, ag = Object.create, aW = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!nW(e))
      return {};
    if (ag)
      return ag(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), iW = aW, rW = iW, sW = Ef, oW = td;
function lW(t) {
  return typeof t.constructor == "function" && !oW(t) ? rW(sW(t)) : {};
}
var cW = lW, uW = nd, dW = ir, hW = "[object Map]";
function fW(t) {
  return dW(t) && uW(t) == hW;
}
var pW = fW, mW = pW, gW = ju, ig = Vu, rg = ig && ig.isMap, bW = rg ? gW(rg) : mW, vW = bW, yW = nd, _W = ir, xW = "[object Set]";
function TW(t) {
  return _W(t) && yW(t) == xW;
}
var wW = TW, kW = wW, SW = ju, sg = Vu, og = sg && sg.isSet, CW = og ? SW(og) : kW, AW = CW, EW = nY, LW = iY, DW = Cy, IW = Yj, MW = sV, OW = oV, PW = cV, BW = xV, RW = PV, NW = HV, $W = Ry, FW = nd, zW = pq, UW = tW, HW = cW, YW = ar, jW = Tf, VW = vW, qW = Ur, WW = AW, GW = kf, XW = Sf, ZW = 1, KW = 2, QW = 4, $y = "[object Arguments]", JW = "[object Array]", eG = "[object Boolean]", tG = "[object Date]", nG = "[object Error]", Fy = "[object Function]", aG = "[object GeneratorFunction]", iG = "[object Map]", rG = "[object Number]", zy = "[object Object]", sG = "[object RegExp]", oG = "[object Set]", lG = "[object String]", cG = "[object Symbol]", uG = "[object WeakMap]", dG = "[object ArrayBuffer]", hG = "[object DataView]", fG = "[object Float32Array]", pG = "[object Float64Array]", mG = "[object Int8Array]", gG = "[object Int16Array]", bG = "[object Int32Array]", vG = "[object Uint8Array]", yG = "[object Uint8ClampedArray]", _G = "[object Uint16Array]", xG = "[object Uint32Array]", Ct = {};
Ct[$y] = Ct[JW] = Ct[dG] = Ct[hG] = Ct[eG] = Ct[tG] = Ct[fG] = Ct[pG] = Ct[mG] = Ct[gG] = Ct[bG] = Ct[iG] = Ct[rG] = Ct[zy] = Ct[sG] = Ct[oG] = Ct[lG] = Ct[cG] = Ct[vG] = Ct[yG] = Ct[_G] = Ct[xG] = !0;
Ct[nG] = Ct[Fy] = Ct[uG] = !1;
function Uc(t, e, n, a, i, r) {
  var s, o = e & ZW, l = e & KW, c = e & QW;
  if (n && (s = i ? n(t, a, i, r) : n(t)), s !== void 0)
    return s;
  if (!qW(t))
    return t;
  var d = YW(t);
  if (d) {
    if (s = zW(t), !o)
      return PW(t, s);
  } else {
    var f = FW(t), g = f == Fy || f == aG;
    if (jW(t))
      return OW(t, o);
    if (f == zy || f == $y || g && !i) {
      if (s = l || g ? {} : HW(t), !o)
        return l ? RW(t, MW(s, t)) : BW(t, IW(s, t));
    } else {
      if (!Ct[f])
        return i ? t : {};
      s = UW(t, f, o);
    }
  }
  r || (r = new EW());
  var _ = r.get(t);
  if (_)
    return _;
  r.set(t, s), WW(t) ? t.forEach(function(w) {
    s.add(Uc(w, e, n, w, t, r));
  }) : VW(t) && t.forEach(function(w, C) {
    s.set(C, Uc(w, e, n, C, t, r));
  });
  var x = c ? l ? $W : NW : l ? XW : GW, p = d ? void 0 : x(t);
  return LW(p || t, function(w, C) {
    p && (C = w, w = t[C]), DW(s, C, Uc(w, e, n, C, t, r));
  }), s;
}
var TG = Uc, wG = ar, kG = Yu, SG = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, CG = /^\w*$/;
function AG(t, e) {
  if (wG(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || kG(t) ? !0 : CG.test(t) || !SG.test(t) || e != null && t in Object(e);
}
var EG = AG, Uy = Vh, LG = "Expected a function";
function Df(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(LG);
  var n = function() {
    var a = arguments, i = e ? e.apply(this, a) : a[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var s = t.apply(this, a);
    return n.cache = r.set(i, s) || r, s;
  };
  return n.cache = new (Df.Cache || Uy)(), n;
}
Df.Cache = Uy;
var DG = Df, IG = DG, MG = 500;
function OG(t) {
  var e = IG(t, function(a) {
    return n.size === MG && n.clear(), a;
  }), n = e.cache;
  return e;
}
var PG = OG, BG = PG, RG = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, NG = /\\(\\)?/g, $G = BG(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(RG, function(n, a, i, r) {
    e.push(i ? r.replace(NG, "$1") : a || n);
  }), e;
}), FG = $G, zG = ar, UG = EG, HG = FG, YG = Ml;
function jG(t, e) {
  return zG(t) ? t : UG(t, e) ? [t] : HG(YG(t));
}
var If = jG;
function VG(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var qG = VG, WG = Yu;
function GG(t) {
  if (typeof t == "string" || WG(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
var Hy = GG, XG = If, ZG = Hy;
function KG(t, e) {
  e = XG(e, t);
  for (var n = 0, a = e.length; t != null && n < a; )
    t = t[ZG(e[n++])];
  return n && n == a ? t : void 0;
}
var Yy = KG, QG = Yy, JG = E2;
function eX(t, e) {
  return e.length < 2 ? t : QG(t, JG(e, 0, -1));
}
var tX = eX, nX = If, aX = qG, iX = tX, rX = Hy;
function sX(t, e) {
  return e = nX(e, t), t = iX(t, e), t == null || delete t[rX(aX(e))];
}
var oX = sX, lX = zr, cX = Ef, uX = ir, dX = "[object Object]", hX = Function.prototype, fX = Object.prototype, jy = hX.toString, pX = fX.hasOwnProperty, mX = jy.call(Object);
function gX(t) {
  if (!uX(t) || lX(t) != dX)
    return !1;
  var e = cX(t);
  if (e === null)
    return !0;
  var n = pX.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && jy.call(n) == mX;
}
var bX = gX, vX = bX;
function yX(t) {
  return vX(t) ? void 0 : t;
}
var _X = yX, lg = Il, xX = xf, TX = ar, cg = lg ? lg.isConcatSpreadable : void 0;
function wX(t) {
  return TX(t) || xX(t) || !!(cg && t && t[cg]);
}
var kX = wX, SX = Af, CX = kX;
function Vy(t, e, n, a, i) {
  var r = -1, s = t.length;
  for (n || (n = CX), i || (i = []); ++r < s; ) {
    var o = t[r];
    e > 0 && n(o) ? e > 1 ? Vy(o, e - 1, n, a, i) : SX(i, o) : a || (i[i.length] = o);
  }
  return i;
}
var AX = Vy, EX = AX;
function LX(t) {
  var e = t == null ? 0 : t.length;
  return e ? EX(t, 1) : [];
}
var DX = LX;
function IX(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var MX = IX, OX = MX, ug = Math.max;
function PX(t, e, n) {
  return e = ug(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var a = arguments, i = -1, r = ug(a.length - e, 0), s = Array(r); ++i < r; )
      s[i] = a[e + i];
    i = -1;
    for (var o = Array(e + 1); ++i < e; )
      o[i] = a[i];
    return o[e] = n(s), OX(t, this, o);
  };
}
var BX = PX;
function RX(t) {
  return function() {
    return t;
  };
}
var NX = RX;
function $X(t) {
  return t;
}
var FX = $X, zX = NX, dg = ky, UX = FX, HX = dg ? function(t, e) {
  return dg(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: zX(e),
    writable: !0
  });
} : UX, YX = HX, jX = 800, VX = 16, qX = Date.now;
function WX(t) {
  var e = 0, n = 0;
  return function() {
    var a = qX(), i = VX - (a - n);
    if (n = a, i > 0) {
      if (++e >= jX)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var GX = WX, XX = YX, ZX = GX, KX = ZX(XX), QX = KX, JX = DX, eZ = BX, tZ = QX;
function nZ(t) {
  return tZ(eZ(t, void 0, JX), t + "");
}
var aZ = nZ, iZ = S2, rZ = TG, sZ = oX, oZ = If, lZ = Fl, cZ = _X, uZ = aZ, dZ = Ry, hZ = 1, fZ = 2, pZ = 4, mZ = uZ(function(t, e) {
  var n = {};
  if (t == null)
    return n;
  var a = !1;
  e = iZ(e, function(r) {
    return r = oZ(r, t), a || (a = r.length > 1), r;
  }), lZ(t, dZ(t), n), a && (n = rZ(n, hZ | fZ | pZ, cZ));
  for (var i = e.length; i--; )
    sZ(n, e[i]);
  return n;
}), gZ = mZ;
const bZ = /* @__PURE__ */ xa(gZ), vZ = {
  __name: "SectionHeader",
  props: {
    theme: {
      type: String,
      default: "white"
    },
    level: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    const e = t, n = wn("sectionLevel", 1), a = I(() => Number(e.level || n)), i = I(() => ["section-header", `section-header${a.value}`]), r = I(() => a.value >= 1 && a.value <= 6 ? `h${a.value}` : "h6");
    return (s, o) => (h(), Z(ut(r.value), {
      class: se(i.value)
    }, {
      default: ce(() => [
        xe(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, Mf = /* @__PURE__ */ be(vZ, [["__scopeId", "data-v-543c1eb7"]]);
function yZ(t) {
  return t.replace("&", "").replace(/\s+/g, " ").trim().toLowerCase().replace(/ /g, "-");
}
const _Z = ["id"], xZ = {
  key: 1,
  class: "section-header"
}, TZ = { class: "section-link" }, wZ = /* @__PURE__ */ Ae({
  __name: "SectionWrapper",
  props: {
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "white"
    },
    level: {
      type: Number,
      default: 0
    },
    noMargins: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = wn("sectionLevel", 1), a = wn("ancestorSetMargins", !1), i = Ge(), r = I(() => Number(e.level || n + 1)), s = I(() => !(e.noMargins || a));
    ma("sectionLevel", r.value), ma("ancestorSetMargins", a || s.value);
    const o = I(() => [
      "section-wrapper",
      `section-wrapper${r.value}`,
      `theme-${e.theme}`,
      { "top-level": s.value },
      (i == null ? void 0 : i.value) || ""
    ]), l = I(() => yZ(e.sectionTitle));
    return (c, d) => (h(), b("section", {
      class: se(o.value)
    }, [
      t.sectionTitle ? (h(), b("a", {
        key: 0,
        id: l.value
      }, null, 8, _Z)) : E("", !0),
      t.sectionTitle ? (h(), b("div", xZ, [
        t.sectionTitle ? (h(), Z(Mf, {
          key: 0,
          class: "section-title",
          textContent: ae(t.sectionTitle)
        }, null, 8, ["textContent"])) : E("", !0),
        k("div", TZ, [
          xe(c.$slots, "top-right", { class: "" }, void 0, !0)
        ]),
        t.sectionSummary ? (h(), Z(un, {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, ["innerHTML"])) : E("", !0)
      ])) : E("", !0),
      xe(c.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), sl = /* @__PURE__ */ be(wZ, [["__scopeId", "data-v-9d45978a"]]), kZ = {};
function SZ(t, e) {
  return xe(t.$slots, "default");
}
const hg = /* @__PURE__ */ be(kZ, [["render", SZ]]), CZ = {
  __name: "FlexibleBlocks",
  props: {
    blocks: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, n = Ge(), a = ge(
      () => Promise.resolve().then(() => DH)
    ), i = ge(
      () => Promise.resolve().then(() => PH)
    ), r = ge(
      () => import("./CallToAction-Cb2zpD6U.js")
    ), s = ge(
      () => Promise.resolve().then(() => NZ)
    ), o = ge(
      () => Promise.resolve().then(() => VZ)
    ), l = ge(
      () => Promise.resolve().then(() => lK)
    ), c = ge(
      () => Promise.resolve().then(() => gK)
    ), d = ge(
      () => import("./HorizontalDivider-CtIVLQXd.js")
    ), f = ge(
      () => Promise.resolve().then(() => LK)
    ), g = ge(
      () => Promise.resolve().then(() => sQ)
    ), _ = ge(
      () => Promise.resolve().then(() => dQ)
    ), x = ge(
      () => Promise.resolve().then(() => Bse)
    ), p = ge(
      () => Promise.resolve().then(() => Yse)
    ), w = ge(
      () => Promise.resolve().then(() => Xse)
    ), C = ge(
      () => Promise.resolve().then(() => eoe)
    ), M = ge(
      () => import("./SimpleCards-CeA2ajsC.js")
    ), A = ge(
      () => Promise.resolve().then(() => Iue)
    ), L = {
      "flexible-associated-topic-cards": a,
      "flexible-banner-featured": i,
      "flexible-call-to-action": r,
      "flexible-card-with-image": s,
      "flexible-form": o,
      "flexible-grid-gallery-cards": l,
      "flexible-highlight": c,
      "flexible-horizontal-divider": d,
      "flexible-impact-number-cards": f,
      "flexible-impact-numbers-carousel": g,
      "flexible-info-block": _,
      "flexible-media-gallery": x,
      "flexible-media-with-text": p,
      "flexible-pull-quote": w,
      "flexible-rich-text": C,
      "flexible-simple-cards": M
      // Add other components here if needed
    }, D = [
      "flexible-associated-topic-cards",
      "flexible-banner-featured",
      "flexible-divider-general",
      "flexible-form",
      "flexible-impact-numbers-carousel",
      "flexible-pull-quote",
      "flexible-simple-cards",
      "flexible-call-to-action",
      "flexible-cta-block2-up",
      "flexible-impact-number-cards",
      "flexible-grid-gallery-cards"
    ], B = I(() => ["flexible-blocks", (n == null ? void 0 : n.value) || ""]), P = I(() => {
      const K = e.blocks.map(($) => ({
        ...$,
        componentName: z($.typeHandle),
        theme: "white",
        // Default theme to white
        needsDivider: !1
        // Default no divider
      }));
      return K.forEach(($, X, R) => {
        (n == null ? void 0 : n.value) === "ftva" ? ($.theme = "white", $.needsDivider = !1) : (X > 0 && R[X - 1].theme === "white" && !D.includes($.componentName) && X < R.length - 1 && ($.theme = "gray"), X > 0 && $.theme === "white" && R[X - 1].theme === "white" && ($.needsDivider = !0));
      }), K.filter(
        ($) => Object.keys(L).includes($.componentName)
      );
    });
    function z(K) {
      return wy(`flexible-${K}`);
    }
    function W(K) {
      return K.mediaGalleryStyle !== void 0;
    }
    function q(K) {
      return W(K) && K.mediaGalleryStyle === "halfWidth" ? "" : K.sectionTitle;
    }
    function V(K) {
      return K.mediaGalleryStyle === "halfWidth" ? "" : K.sectionSummary || K.richTextSimplified;
    }
    function re(K) {
      return L[K];
    }
    function ie(K) {
      return (n == null ? void 0 : n.value) !== "ftva" ? hg : K === "flexible-card-with-image" ? A : hg;
    }
    return (K, $) => (h(), Z(sl, {
      class: se(B.value),
      "no-margins": !0
    }, {
      default: ce(() => [
        Q(Mf, { class: "more-information" }, {
          default: ce(() => $[0] || ($[0] = [
            Ye(" More Information ")
          ])),
          _: 1
        }),
        (h(!0), b(me, null, Ee(P.value, (X, R) => (h(), b("div", {
          key: `flexibleblocks-${R}`
        }, [
          X.needsDivider ? (h(), Z(sl, {
            key: 0,
            theme: "divider"
          }, {
            default: ce(() => [
              Q(pl)
            ]),
            _: 1
          })) : E("", !0),
          Q(sl, {
            theme: X.theme,
            "section-title": q(X),
            "section-summary": V(X),
            class: "flexible-block-section-wrapper"
          }, {
            default: ce(() => [
              (h(), Z(ut(ie(X.componentName)), null, {
                default: ce(() => [
                  (h(), Z(ut(re(X.componentName)), {
                    block: X.mediaGalleryStyle === "halfWidth" ? X : O(bZ)(X, ["sectionTitle", "sectionSummary"]),
                    class: "flexible-block"
                  }, null, 8, ["block"]))
                ]),
                _: 2
              }, 1024))
            ]),
            _: 2
          }, 1032, ["theme", "section-title", "section-summary"])
        ]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}, K0e = /* @__PURE__ */ be(CZ, [["__scopeId", "data-v-d35d7bc2"]]), Q0e = /* @__PURE__ */ Ae({
  __name: "CallToAction",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.callToAction[0]), n = Ge(), a = I(() => ["flexible-block-call-to-action", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), Z(qh, {
      class: se(a.value),
      to: e.value.buttonUrl,
      name: e.value.buttonText,
      title: e.value.titleCta,
      text: e.value.summary,
      "svg-name": e.value.icon,
      "is-dark": e.value.backgroundColor === "true"
    }, null, 8, ["class", "to", "name", "title", "text", "svg-name", "is-dark"]));
  }
});
var AZ = Yy;
function EZ(t, e, n) {
  var a = t == null ? void 0 : AZ(t, e);
  return a === void 0 ? n : a;
}
var LZ = EZ;
const it = /* @__PURE__ */ xa(LZ), DZ = {
  key: 0,
  class: "card-with-image"
}, IZ = { class: "section-header" }, MZ = {
  key: 0,
  class: "section-title"
}, OZ = ["innerHTML"], PZ = { class: "block-group" }, BZ = /* @__PURE__ */ Ae({
  __name: "CardWithImage",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => {
      const a = [];
      for (const i in t.block.cardWithImage)
        t.block.cardWithImage[i].typeHandle === "internalContent" && t.block.cardWithImage[i].contentLink && t.block.cardWithImage[i].contentLink.length > 0 ? a.push(t.block.cardWithImage[i].contentLink[0]) : t.block.cardWithImage[i].typeHandle !== "internalContent" && a.push(t.block.cardWithImage[i]);
      return a;
    }), n = I(() => e.value.filter((a) => a !== null).map((a) => a.typeHandle !== "externalContent" && a.contentType.includes("article") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        a,
        "associatedLocations",
        []
      ),
      parsedCategory: it(
        a,
        "articleCategory[0].title",
        ""
      ),
      byline1: it(a, "articleByline1[0].title", ""),
      byline2: a.articleByline2 !== null ? Da(
        a.articleByline2,
        a.articleByline2
      ) : ""
    } : a.typeHandle !== "externalContent" && a.contentType.includes("meapProject") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(a, "projectLocations", []),
      parsedCategory: it(a, "projectCategory", ""),
      byline1: it(a, "projectByline1[0].title", "")
    } : a.typeHandle !== "externalContent" && a.contentType === "event" ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        a,
        "associatedLocations",
        []
      ),
      parsedCategory: it(a, "eventType.title", ""),
      startDate: it(a, "startDateWithTime", ""),
      endDate: it(a, "endDateWithTime", ""),
      text: it(a, "eventDescription", "")
    } : a.typeHandle !== "externalContent" && (a.contentType === "exhibition" || !0) ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      parsedLocation: it(
        a,
        "associatedLocations",
        []
      ),
      startDate: it(a, "startDate", ""),
      endDate: it(a, "endDate", "")
    } : a.typeHandle === "externalContent" ? {
      ...a,
      parsedImage: it(a, "image[0]", void 0),
      // parsedLocation:  obj.location !== null ? [obj.location] : [],
      parsedCategory: it(a, "category", "")
    } : {
      ...a,
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      to: $n(a.to)
    }));
    return (a, i) => t.block.cardWithImage ? (h(), b("div", DZ, [
      k("div", IZ, [
        t.block.sectionTitle ? (h(), b("h2", MZ, ae(t.block.sectionTitle), 1)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, OZ)) : E("", !0)
      ]),
      k("ul", PZ, [
        (h(!0), b(me, null, Ee(n.value, (r, s) => (h(), Z(Yh, {
          key: `FlexibleCardWithImage${s}`,
          to: r.to,
          image: r.parsedImage,
          category: r.parsedCategory,
          "byline-one": r.byline1,
          "byline-two": r.byline2,
          title: r.title,
          text: r.text,
          locations: r.parsedLocation,
          "image-aspect-ratio": 60,
          "is-vertical": !0,
          "start-date": r.startDate,
          "end-date": r.endDate,
          "section-handle": r.contentType,
          ongoing: r.ongoing,
          class: "block"
        }, null, 8, ["to", "image", "category", "byline-one", "byline-two", "title", "text", "locations", "start-date", "end-date", "section-handle", "ongoing"]))), 128))
      ])
    ])) : E("", !0);
  }
}), RZ = /* @__PURE__ */ be(BZ, [["__scopeId", "data-v-869faadf"]]), NZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: RZ
}, Symbol.toStringTag, { value: "Module" })), $Z = { class: "section-header" }, FZ = ["innerHTML"], zZ = ["innerHTML"], UZ = { class: "content" }, HZ = ["srcdoc"], YZ = /* @__PURE__ */ Ae({
  __name: "Form",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.form), n = Ge(), a = I(() => ["form", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: se(a.value)
    }, [
      k("div", $Z, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, FZ)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, zZ)) : E("", !0)
      ]),
      k("div", UZ, [
        k("iframe", {
          id: "the-iframe",
          title: "Form",
          refs: "form_iframe",
          class: "iframe",
          srcdoc: e.value,
          frameBorder: "0",
          width: "100%",
          height: "100%",
          onload: "this.width=screen.width;this.height=screen.height;"
        }, null, 8, HZ)
      ])
    ], 2));
  }
}), jZ = /* @__PURE__ */ be(YZ, [["__scopeId", "data-v-e5f44e8b"]]), VZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jZ
}, Symbol.toStringTag, { value: "Module" })), qZ = { class: "grid-gallery" }, WZ = { class: "cards" }, GZ = {
  key: 0,
  class: "title"
}, XZ = ["innerHTML"], ZZ = {
  key: 2,
  class: "section-text"
}, KZ = { class: "text" }, QZ = {
  key: 0,
  class: "title"
}, JZ = ["innerHTML"], eK = /* @__PURE__ */ Ae({
  __name: "GridGallery",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = I(() => t.items.map((n) => {
      let a = "card ";
      return n.featured && n.snippet ? a = `${a}card-featured` : n.featured && !n.snippet ? a = `${a}card-4up` : a = `${a}card-small`, {
        ...n,
        classes: a
      };
    }));
    return (n, a) => (h(), b("div", qZ, [
      k("ul", WZ, [
        (h(!0), b(me, null, Ee(e.value, (i) => (h(), b("li", {
          key: i.to,
          class: se(i.classes)
        }, [
          Q(dn, {
            media: i.image,
            "aspect-ratio": 60,
            "object-fit": "cover"
          }, null, 8, ["media"]),
          i.headlineText && (i.featured && !i.snippet || !i.featured) ? (h(), b("h5", GZ, [
            Q(Ke, {
              to: i.to,
              "link-target": "_blank",
              class: "link"
            }, {
              default: ce(() => [
                Ye(ae(i.headlineText), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])) : E("", !0),
          !i.featured && i.snippet ? (h(), b("div", {
            key: 1,
            class: "snippet",
            innerHTML: i.snippet
          }, null, 8, XZ)) : E("", !0),
          i.featured && i.snippet ? (h(), b("div", ZZ, [
            k("div", KZ, [
              i.headlineText ? (h(), b("h5", QZ, [
                Q(Ke, {
                  to: i.to,
                  "link-target": "_blank",
                  class: "link"
                }, {
                  default: ce(() => [
                    Ye(ae(i.headlineText), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])) : E("", !0),
              k("div", {
                class: "snippet",
                innerHTML: i.snippet
              }, null, 8, JZ)
            ])
          ])) : E("", !0)
        ], 2))), 128))
      ])
    ]));
  }
}), tK = /* @__PURE__ */ be(eK, [["__scopeId", "data-v-a055b0cb"]]), nK = { class: "grid-gallery-cards" }, aK = {
  key: 0,
  class: "section-header"
}, iK = ["innerHTML"], rK = ["innerHTML"], sK = /* @__PURE__ */ Ae({
  __name: "GridGalleryCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    function e(a) {
      const i = [];
      for (const r of a.gridGalleryCards) {
        const s = {};
        s.headlineText = r.contentLink && r.contentLink[0] ? r.contentLink[0].headlineText : r.headlineText, s.snippet = r.contentLink && r.contentLink[0] ? r.contentLink[0].snippet : r.snippet, s.featured = r.featured === "true", s.to = $n(
          r.contentLink && r.contentLink[0] ? r.contentLink[0].to : r.to
        ), s.image = r.contentLink && r.contentLink[0] && r.contentLink[0].heroImage ? r.contentLink[0].heroImage[0].image[0] : r.image ? r.image[0] : {}, i.push(s);
      }
      return i;
    }
    const n = I(() => e(t.block));
    return (a, i) => (h(), b("div", nK, [
      t.block.gridGalleryCards && t.block.gridGalleryCards.length > 0 || t.block.sectionTitle ? (h(), b("div", aK, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, iK)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, rK)) : E("", !0)
      ])) : E("", !0),
      t.block.gridGalleryCards && t.block.gridGalleryCards.length > 0 ? (h(), Z(tK, {
        key: 1,
        class: "section-summary",
        items: n.value
      }, null, 8, ["items"])) : E("", !0)
    ]));
  }
}), oK = /* @__PURE__ */ be(sK, [["__scopeId", "data-v-13926fda"]]), lK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oK
}, Symbol.toStringTag, { value: "Module" })), cK = { class: "section-teaser-highlight" }, uK = { class: "section-header" }, dK = ["innerHTML"], hK = ["innerHTML"], fK = { class: "block-group" }, pK = /* @__PURE__ */ Ae({
  __name: "Highlight",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => {
      const a = [];
      for (const i in t.block.highlight)
        t.block.highlight[i].typeHandle === "internalContent" ? a.push(t.block.highlight[i].contentLink[0]) : a.push(t.block.highlight[i]);
      return a;
    }), n = I(() => e.value.filter((a) => a !== null).map((a) => a.typeHandle !== "externalContent" && a.contentType.includes("article") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      category: it(
        a,
        "articleCategory[0].title",
        ""
      ),
      byline1: it(a, "articleByline1[0].title", ""),
      byline2: a.articleByline2 != null ? Da(
        a.articleByline2,
        a.articleByline2
      ) : ""
    } : a.typeHandle !== "externalContent" && a.contentType.includes("meapProject") ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(a, "projectLocations", void 0),
      category: it(a, "projectCategory", ""),
      byline1: it(a, "projectByline1[0].title", "")
    } : a.typeHandle !== "externalContent" && a.contentType === "event" ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      category: it(a, "eventType.title", ""),
      startDate: it(a, "startDateWithTime", ""),
      endDate: it(a, "endDateWithTime", ""),
      text: it(a, "eventDescription", "")
    } : a.typeHandle !== "externalContent" && (a.contentType === "exhibition" || !0) ? {
      ...a,
      to: $n(a.to),
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      locations: it(
        a,
        "associatedLocations",
        void 0
      ),
      startDate: it(a, "startDate", ""),
      endDate: it(a, "endDate", "")
    } : a.typeHandle === "externalContent" ? {
      ...a,
      parsedImage: it(a, "image[0]", void 0),
      // TODO: FIX BlockHighlight gql fragment to add locations in nuxt repo
      /* locations:
        obj.locations != null ? [obj.locations] : undefined, */
      category: it(a, "category", "")
    } : {
      ...a,
      parsedImage: it(
        a,
        "heroImage[0].image[0]",
        void 0
      ),
      to: $n(a.to)
    }));
    return (a, i) => (h(), b("section", cK, [
      k("div", uK, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, dK)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, hK)) : E("", !0)
      ]),
      k("ul", fK, [
        (h(!0), b(me, null, Ee(n.value, (r, s) => (h(), Z(Y2, {
          key: `FlexibleHighlight${s}`,
          to: r.to,
          image: r.parsedImage,
          category: r.category,
          "byline-one": r.byline1,
          "byline-two": r.byline2,
          title: r.title,
          text: r.text,
          locations: r.locations,
          "start-date": r.startDate,
          "end-date": r.endDate,
          "section-handle": r.contentType,
          ongoing: r.ongoing,
          "has-triangle": !0,
          "is-vertical": !0,
          class: "block"
        }, null, 8, ["to", "image", "category", "byline-one", "byline-two", "title", "text", "locations", "start-date", "end-date", "section-handle", "ongoing"]))), 128))
      ])
    ]));
  }
}), mK = /* @__PURE__ */ be(pK, [["__scopeId", "data-v-fc808ff2"]]), gK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mK
}, Symbol.toStringTag, { value: "Module" })), J0e = /* @__PURE__ */ Ae({
  __name: "HorizontalDivider",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block.horizontalDivider ? (h(), Z(pl, { key: 0 })) : E("", !0);
  }
}), bK = { class: "card" }, vK = ["innerHTML"], yK = ["innerHTML"], _K = ["innerHTML"], xK = /* @__PURE__ */ Ae({
  __name: "ImpactNumberCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    impactNumber: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["impact-number-card", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("li", {
      class: se(n.value)
    }, [
      k("div", bK, [
        t.impactNumber ? (h(), b("div", {
          key: 0,
          class: "impact-number",
          innerHTML: t.impactNumber
        }, null, 8, vK)) : E("", !0),
        t.title ? (h(), b("div", {
          key: 1,
          class: "title",
          innerHTML: t.title
        }, null, 8, yK)) : E("", !0)
      ]),
      t.text ? (h(), b("div", {
        key: 0,
        class: "text",
        innerHTML: t.text
      }, null, 8, _K)) : E("", !0)
    ], 2));
  }
}), TK = /* @__PURE__ */ be(xK, [["__scopeId", "data-v-a21f2ee4"]]), wK = { class: "section-header" }, kK = ["innerHTML"], SK = ["innerHTML"], CK = { class: "impact-number-cards-list" }, AK = /* @__PURE__ */ Ae({
  __name: "ImpactNumberCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["impact-number-cards", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: se(n.value)
    }, [
      k("div", wK, [
        t.block.sectionTitle ? (h(), b("h3", {
          key: 0,
          class: "section-title",
          innerHTML: t.block.sectionTitle
        }, null, 8, kK)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, SK)) : E("", !0)
      ]),
      k("ul", CK, [
        (h(!0), b(me, null, Ee(t.block.impactNumberCards, (r, s) => (h(), Z(TK, {
          key: `impactNumberCards${s}`,
          title: r.title,
          text: r.text,
          "impact-number": r.impactNumber,
          class: "flexible-impact-number-card"
        }, null, 8, ["title", "text", "impact-number"]))), 128))
      ])
    ], 2));
  }
}), EK = /* @__PURE__ */ be(AK, [["__scopeId", "data-v-a12f6094"]]), LK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EK
}, Symbol.toStringTag, { value: "Module" }));
/**
 * Vue 3 Carousel 0.3.4
 * (c) 2024
 * @license MIT
 */
const xn = {
  itemsToShow: 1,
  itemsToScroll: 1,
  modelValue: 0,
  transition: 300,
  autoplay: 0,
  snapAlign: "center",
  wrapAround: !1,
  throttle: 16,
  pauseAutoplayOnHover: !1,
  mouseDrag: !0,
  touchDrag: !0,
  dir: "ltr",
  breakpoints: void 0,
  i18n: {
    ariaNextSlide: "Navigate to next slide",
    ariaPreviousSlide: "Navigate to previous slide",
    ariaNavigateToSlide: "Navigate to slide {slideNumber}",
    ariaGallery: "Gallery",
    itemXofY: "Item {currentSlide} of {slidesCount}",
    iconArrowUp: "Arrow pointing upwards",
    iconArrowDown: "Arrow pointing downwards",
    iconArrowRight: "Arrow pointing to the right",
    iconArrowLeft: "Arrow pointing to the left"
  }
}, fg = {
  // count of items to showed per view
  itemsToShow: {
    default: xn.itemsToShow,
    type: Number
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: xn.itemsToScroll,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: xn.wrapAround,
    type: Boolean
  },
  // control max drag
  throttle: {
    default: xn.throttle,
    type: Number
  },
  // control snap position alignment
  snapAlign: {
    default: xn.snapAlign,
    validator(t) {
      return ["start", "end", "center", "center-even", "center-odd"].includes(t);
    }
  },
  // sliding transition time in ms
  transition: {
    default: xn.transition,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: xn.breakpoints,
    type: Object
  },
  // time to auto advance slides in ms
  autoplay: {
    default: xn.autoplay,
    type: Number
  },
  // pause autoplay when mouse hover over the carousel
  pauseAutoplayOnHover: {
    default: xn.pauseAutoplayOnHover,
    type: Boolean
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging.
  mouseDrag: {
    default: xn.mouseDrag,
    type: Boolean
  },
  // toggle mouse dragging.
  touchDrag: {
    default: xn.touchDrag,
    type: Boolean
  },
  // control snap position alignment
  dir: {
    default: xn.dir,
    validator(t) {
      return ["rtl", "ltr"].includes(t);
    }
  },
  // aria-labels and additional text labels
  i18n: {
    default: xn.i18n,
    type: Object
  },
  // an object to pass all settings
  settings: {
    default() {
      return {};
    },
    type: Object
  }
};
function DK({ config: t, slidesCount: e }) {
  const { snapAlign: n, wrapAround: a, itemsToShow: i = 1 } = t;
  if (a)
    return Math.max(e - 1, 0);
  let r;
  switch (n) {
    case "start":
      r = e - i;
      break;
    case "end":
      r = e - 1;
      break;
    case "center":
    case "center-odd":
      r = e - Math.ceil((i - 0.5) / 2);
      break;
    case "center-even":
      r = e - Math.ceil(i / 2);
      break;
    default:
      r = 0;
      break;
  }
  return Math.max(r, 0);
}
function IK({ config: t, slidesCount: e }) {
  const { wrapAround: n, snapAlign: a, itemsToShow: i = 1 } = t;
  let r = 0;
  if (n || i > e)
    return r;
  switch (a) {
    case "start":
      r = 0;
      break;
    case "end":
      r = i - 1;
      break;
    case "center":
    case "center-odd":
      r = Math.floor((i - 1) / 2);
      break;
    case "center-even":
      r = Math.floor((i - 2) / 2);
      break;
    default:
      r = 0;
      break;
  }
  return r;
}
function sh({ val: t, max: e, min: n }) {
  return e < n ? t : Math.min(Math.max(t, n), e);
}
function MK({ config: t, currentSlide: e, slidesCount: n }) {
  const { snapAlign: a, wrapAround: i, itemsToShow: r = 1 } = t;
  let s = e;
  switch (a) {
    case "center":
    case "center-odd":
      s -= (r - 1) / 2;
      break;
    case "center-even":
      s -= (r - 2) / 2;
      break;
    case "end":
      s -= r - 1;
      break;
  }
  return i ? s : sh({
    val: s,
    max: n - r,
    min: 0
  });
}
function qy(t) {
  return t ? t.reduce((e, n) => {
    var a;
    return n.type === me ? [...e, ...qy(n.children)] : ((a = n.type) === null || a === void 0 ? void 0 : a.name) === "CarouselSlide" ? [...e, n] : e;
  }, []) : [];
}
function oh({ val: t, max: e, min: n = 0 }) {
  return t > e ? oh({ val: t - (e + 1), max: e, min: n }) : t < n ? oh({ val: t + (e + 1), max: e, min: n }) : t;
}
function OK(t, e) {
  let n;
  return e ? function(...a) {
    const i = this;
    n || (t.apply(i, a), n = !0, setTimeout(() => n = !1, e));
  } : t;
}
function PK(t, e) {
  let n;
  return function(...a) {
    n && clearTimeout(n), n = setTimeout(() => {
      t(...a), n = null;
    }, e);
  };
}
function BK(t = "", e = {}) {
  return Object.entries(e).reduce((n, [a, i]) => n.replace(`{${a}}`, String(i)), t);
}
var RK = Ae({
  name: "ARIA",
  setup() {
    const t = wn("config", La(Object.assign({}, xn))), e = wn("currentSlide", J(0)), n = wn("slidesCount", J(0));
    return () => _r("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, BK(t.i18n.itemXofY, {
      currentSlide: e.value + 1,
      slidesCount: n.value
    }));
  }
}), Wy = Ae({
  name: "Carousel",
  props: fg,
  setup(t, { slots: e, emit: n, expose: a }) {
    var i;
    const r = J(null), s = J([]), o = J(0), l = J(0), c = La(Object.assign({}, xn));
    let d = Object.assign({}, xn), f;
    const g = J((i = t.modelValue) !== null && i !== void 0 ? i : 0), _ = J(0), x = J(0), p = J(0), w = J(0);
    let C, M;
    ma("config", c), ma("slidesCount", l), ma("currentSlide", g), ma("maxSlide", p), ma("minSlide", w), ma("slideWidth", o);
    function A() {
      f = Object.assign({}, t.breakpoints), d = Object.assign(Object.assign(Object.assign({}, d), t), { i18n: Object.assign(Object.assign({}, d.i18n), t.i18n), breakpoints: void 0 }), D(d);
    }
    function L() {
      if (!f || !Object.keys(f).length)
        return;
      const he = Object.keys(f).map((_e) => Number(_e)).sort((_e, tt) => +tt - +_e);
      let Ce = Object.assign({}, d);
      he.some((_e) => {
        const tt = window.matchMedia(`(min-width: ${_e}px)`).matches;
        return tt && (Ce = Object.assign(Object.assign({}, Ce), f[_e])), tt;
      }), D(Ce);
    }
    function D(he) {
      Object.entries(he).forEach(([Ce, _e]) => c[Ce] = _e);
    }
    const B = PK(() => {
      L(), z(), P();
    }, 16);
    function P() {
      if (!r.value)
        return;
      const he = r.value.getBoundingClientRect();
      o.value = he.width / c.itemsToShow;
    }
    function z() {
      l.value <= 0 || (x.value = Math.ceil((l.value - 1) / 2), p.value = DK({ config: c, slidesCount: l.value }), w.value = IK({ config: c, slidesCount: l.value }), c.wrapAround || (g.value = sh({
        val: g.value,
        max: p.value,
        min: w.value
      })));
    }
    ht(() => {
      Dn(() => P()), setTimeout(() => P(), 1e3), L(), Ie(), window.addEventListener("resize", B, { passive: !0 }), n("init");
    }), Xs(() => {
      M && clearTimeout(M), C && clearInterval(C), window.removeEventListener("resize", B, {
        passive: !0
      });
    });
    let W = !1;
    const q = { x: 0, y: 0 }, V = { x: 0, y: 0 }, re = La({ x: 0, y: 0 }), ie = J(!1), K = J(!1), $ = () => {
      ie.value = !0;
    }, X = () => {
      ie.value = !1;
    };
    function R(he) {
      ["INPUT", "TEXTAREA", "SELECT"].includes(he.target.tagName) || (W = he.type === "touchstart", W || he.preventDefault(), !(!W && he.button !== 0 || te.value) && (q.x = W ? he.touches[0].clientX : he.clientX, q.y = W ? he.touches[0].clientY : he.clientY, document.addEventListener(W ? "touchmove" : "mousemove", de, !0), document.addEventListener(W ? "touchend" : "mouseup", Le, !0)));
    }
    const de = OK((he) => {
      K.value = !0, V.x = W ? he.touches[0].clientX : he.clientX, V.y = W ? he.touches[0].clientY : he.clientY;
      const Ce = V.x - q.x, _e = V.y - q.y;
      re.y = _e, re.x = Ce;
    }, c.throttle);
    function Le() {
      const he = c.dir === "rtl" ? -1 : 1, Ce = Math.sign(re.x) * 0.4, _e = Math.round(re.x / o.value + Ce) * he;
      if (_e && !W) {
        const tt = (oe) => {
          window.removeEventListener("click", tt, !0);
        };
        window.addEventListener("click", tt, !0);
      }
      we(g.value - _e), re.x = 0, re.y = 0, K.value = !1, document.removeEventListener(W ? "touchmove" : "mousemove", de, !0), document.removeEventListener(W ? "touchend" : "mouseup", Le, !0);
    }
    function Ie() {
      !c.autoplay || c.autoplay <= 0 || (C = setInterval(() => {
        c.pauseAutoplayOnHover && ie.value || H();
      }, c.autoplay));
    }
    function Ve() {
      C && (clearInterval(C), C = null), Ie();
    }
    const te = J(!1);
    function we(he) {
      const Ce = c.wrapAround ? he : sh({
        val: he,
        max: p.value,
        min: w.value
      });
      g.value === Ce || te.value || (n("slide-start", {
        slidingToIndex: he,
        currentSlideIndex: g.value,
        prevSlideIndex: _.value,
        slidesCount: l.value
      }), te.value = !0, _.value = g.value, g.value = Ce, M = setTimeout(() => {
        if (c.wrapAround) {
          const _e = oh({
            val: Ce,
            max: p.value,
            min: 0
          });
          _e !== g.value && (g.value = _e, n("loop", {
            currentSlideIndex: g.value,
            slidingToIndex: he
          }));
        }
        n("update:modelValue", g.value), n("slide-end", {
          currentSlideIndex: g.value,
          prevSlideIndex: _.value,
          slidesCount: l.value
        }), te.value = !1, Ve();
      }, c.transition));
    }
    function H() {
      we(g.value + c.itemsToScroll);
    }
    function pe() {
      we(g.value - c.itemsToScroll);
    }
    const Ne = { slideTo: we, next: H, prev: pe };
    ma("nav", Ne), ma("isSliding", te);
    const ee = I(() => MK({
      config: c,
      currentSlide: g.value,
      slidesCount: l.value
    }));
    ma("slidesToScroll", ee);
    const ze = I(() => {
      const he = c.dir === "rtl" ? -1 : 1, Ce = ee.value * o.value * he;
      return {
        transform: `translateX(${re.x - Ce}px)`,
        transition: `${te.value ? c.transition : 0}ms`,
        margin: c.wrapAround ? `0 -${l.value * o.value}px` : "",
        width: "100%"
      };
    });
    function et() {
      A(), L(), z(), P(), Ve();
    }
    Object.keys(fg).forEach((he) => {
      ["modelValue"].includes(he) || at(() => t[he], et);
    }), at(() => t.modelValue, (he) => {
      he !== g.value && we(Number(he));
    }), at(l, z), n("before-init"), A();
    const Te = {
      config: c,
      slidesCount: l,
      slideWidth: o,
      next: H,
      prev: pe,
      slideTo: we,
      currentSlide: g,
      maxSlide: p,
      minSlide: w,
      middleSlide: x
    };
    a({
      updateBreakpointsConfigs: L,
      updateSlidesData: z,
      updateSlideWidth: P,
      initDefaultConfigs: A,
      restartCarousel: et,
      slideTo: we,
      next: H,
      prev: pe,
      nav: Ne,
      data: Te
    });
    const Qe = e.default || e.slides, G = e.addons, Se = La(Te);
    return () => {
      const he = qy(Qe == null ? void 0 : Qe(Se)), Ce = (G == null ? void 0 : G(Se)) || [];
      he.forEach((Oe, Re) => Oe.props.index = Re);
      let _e = he;
      if (c.wrapAround) {
        const Oe = he.map((lt, Mt) => Cm(lt, {
          index: -he.length + Mt,
          isClone: !0,
          key: `clone-before-${Mt}`
        })), Re = he.map((lt, Mt) => Cm(lt, {
          index: he.length + Mt,
          isClone: !0,
          key: `clone-after-${Mt}`
        }));
        _e = [...Oe, ...he, ...Re];
      }
      s.value = he, l.value = Math.max(he.length, 1);
      const tt = _r("ol", {
        class: "carousel__track",
        style: ze.value,
        onMousedownCapture: c.mouseDrag ? R : null,
        onTouchstartPassiveCapture: c.touchDrag ? R : null
      }, _e), oe = _r("div", { class: "carousel__viewport" }, tt);
      return _r("section", {
        ref: r,
        class: {
          carousel: !0,
          "is-sliding": te.value,
          "is-dragging": K.value,
          "is-hover": ie.value,
          "carousel--rtl": c.dir === "rtl"
        },
        dir: c.dir,
        "aria-label": c.i18n.ariaGallery,
        tabindex: "0",
        onMouseenter: $,
        onMouseleave: X
      }, [oe, Ce, _r(RK)]);
    };
  }
}), pg;
(function(t) {
  t.arrowUp = "arrowUp", t.arrowDown = "arrowDown", t.arrowRight = "arrowRight", t.arrowLeft = "arrowLeft";
})(pg || (pg = {}));
var Gy = Ae({
  name: "CarouselSlide",
  props: {
    index: {
      type: Number,
      default: 1
    },
    isClone: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { slots: e }) {
    const n = wn("config", La(Object.assign({}, xn))), a = wn("currentSlide", J(0)), i = wn("slidesToScroll", J(0)), r = wn("isSliding", J(!1)), s = I(() => t.index === a.value), o = I(() => t.index === a.value - 1), l = I(() => t.index === a.value + 1), c = I(() => {
      const d = Math.floor(i.value), f = Math.ceil(i.value + n.itemsToShow - 1);
      return t.index >= d && t.index <= f;
    });
    return () => {
      var d;
      return _r("li", {
        style: { width: `${100 / n.itemsToShow}%` },
        class: {
          carousel__slide: !0,
          "carousel__slide--clone": t.isClone,
          "carousel__slide--visible": c.value,
          "carousel__slide--active": s.value,
          "carousel__slide--prev": o.value,
          "carousel__slide--next": l.value,
          "carousel__slide--sliding": r.value
        },
        "aria-hidden": !c.value
      }, (d = e.default) === null || d === void 0 ? void 0 : d.call(e, {
        isActive: s.value,
        isClone: t.isClone,
        isPrev: o.value,
        isNext: l.value,
        isSliding: r.value,
        isVisible: c.value
      }));
    };
  }
});
const NK = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-arrow-left"
};
function $K(t, e) {
  return h(), b("svg", NK, e[0] || (e[0] = [
    k("g", {
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, [
      k("path", { d: "M23 16.8645H9.75" }),
      k("path", { d: "m16 23.8645-7-7 7-7" })
    ], -1)
  ]));
}
const FK = { render: $K }, zK = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg_icon-molecule-bullet"
};
function UK(t, e) {
  return h(), b("svg", zK, e[0] || (e[0] = [
    k("path", {
      d: "M15.8977 10L20.068 11.7574L21.7954 16L20.068 20.2426L15.8977 22L11.7274 20.2426L10 16L11.7274 11.7574L15.8977 10Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M12.1124 12.1377L15.8977 10.5426L19.683 12.1377L21.2556 16L19.683 19.8623L15.8977 21.4574L12.1124 19.8623L10.5399 16L12.1124 12.1377Z",
      stroke: "#0B6AB7",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Xy = { render: UK }, HK = { class: "impact-numbers-carousel" }, YK = { class: "slide-indicator" }, jK = { class: "slide-image" }, VK = { class: "impact-numbers-text-container" }, qK = { class: "impactNumber" }, WK = { class: "impactText" }, GK = { class: "small-descriptor" }, XK = { class: "controls" }, ZK = ["disabled"], KK = ["disabled"], QK = /* @__PURE__ */ Ae({
  __name: "ImpactNumbersCarousel",
  props: {
    blocks: {
      type: Array,
      default: () => [],
      required: !0
    }
  },
  setup(t) {
    const e = J(0);
    function n(i) {
      if (i === e.value)
        return "current-slide";
    }
    function a(i) {
      e.value = i;
    }
    return (i, r) => (h(), b("div", HK, [
      k("div", YK, [
        (h(!0), b(me, null, Ee(t.blocks, (s, o) => (h(), Z(O(Xy), {
          key: s.largeText,
          class: se(n(o)),
          onClick: (l) => a(o)
        }, null, 8, ["class", "onClick"]))), 128))
      ]),
      Q(O(Wy), {
        modelValue: e.value,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => e.value = s)
      }, {
        default: ce(() => [
          (h(!0), b(me, null, Ee(t.blocks, (s) => (h(), Z(O(Gy), {
            key: s.largeText
          }, {
            default: ce(() => [
              k("div", jK, [
                Q(dn, {
                  media: s.image[0]
                }, null, 8, ["media"])
              ]),
              k("div", VK, [
                k("span", qK, ae(s.largeText), 1),
                k("span", WK, ae(s.mediumText), 1)
              ]),
              k("div", GK, ae(s.smallDescriptor), 1)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      k("div", XK, [
        k("button", {
          "data-glide-dir": "<",
          disabled: e.value <= 0,
          onClick: r[1] || (r[1] = (s) => e.value -= 1)
        }, [
          Q(O(FK), {
            "aria-label": "Go to previous item",
            class: "prev-control"
          })
        ], 8, ZK),
        k("button", {
          "data-glide-dir": ">",
          disabled: e.value >= t.blocks.length - 1,
          onClick: r[2] || (r[2] = (s) => e.value += 1)
        }, [
          Q(O(bi), { "aria-label": "Go to next item" })
        ], 8, KK)
      ]),
      r[3] || (r[3] = k("div", {
        role: "tablist",
        class: "dots"
      }, null, -1))
    ]));
  }
}), JK = /* @__PURE__ */ be(QK, [["__scopeId", "data-v-0c60395c"]]), eQ = {
  key: 0,
  class: "impact-numbers-carousel"
}, tQ = { class: "section-header" }, nQ = ["textContent"], aQ = ["innerHTML"], iQ = /* @__PURE__ */ Ae({
  __name: "ImpactNumbersCarousel",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block ? (h(), b("div", eQ, [
      k("div", tQ, [
        t.block.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          textContent: ae(t.block.sectionTitle)
        }, null, 8, nQ)) : E("", !0),
        t.block.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.block.sectionSummary
        }, null, 8, aQ)) : E("", !0)
      ]),
      Q(JK, {
        blocks: t.block.blocks
      }, null, 8, ["blocks"])
    ])) : E("", !0);
  }
}), rQ = /* @__PURE__ */ be(iQ, [["__scopeId", "data-v-257824af"]]), sQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rQ
}, Symbol.toStringTag, { value: "Module" })), oQ = { class: "contact-info" }, lQ = { class: "info-address" }, cQ = /* @__PURE__ */ Ae({
  __name: "Info",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.infoBlock[0]), n = Ge(), a = I(() => ["flexible-info", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: se(a.value)
    }, [
      e.value.typeHandle === "infoBlock" ? (h(), Z(qh, {
        key: 0,
        title: e.value.heading,
        text: e.value.text,
        "svg-name": e.value.icon,
        "is-centered": !1
      }, null, 8, ["title", "text", "svg-name"])) : e.value.typeHandle === "contactInfoBlock" ? (h(), Z(hI, {
        key: 1,
        "color-scheme": "paleblue"
      }, {
        "block-info-mid": ce(() => [
          k("ul", oQ, [
            k("li", null, [
              Q(en, {
                text: e.value.phone || "",
                "icon-name": "svg-icon-ftva-phone",
                to: e.value.phone
              }, null, 8, ["text", "to"])
            ]),
            k("li", null, [
              Q(en, {
                text: e.value.email || "",
                "icon-name": "svg-icon-ftva-email",
                to: e.value.email
              }, null, 8, ["text", "to"])
            ]),
            k("li", lQ, [
              Q(en, {
                "icon-name": "svg-icon-ftva-location-outline",
                text: ""
              }),
              Q(un, {
                "rich-text-content": e.value.address
              }, null, 8, ["rich-text-content"])
            ])
          ])
        ]),
        _: 1
      })) : E("", !0)
    ], 2));
  }
}), uQ = /* @__PURE__ */ be(cQ, [["__scopeId", "data-v-96cc72ed"]]), dQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uQ
}, Symbol.toStringTag, { value: "Module" })), hQ = {
  width: "128",
  height: "128",
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-image-stack"
};
function fQ(t, e) {
  return h(), b("svg", hQ, e[0] || (e[0] = [
    k("path", {
      d: "m64 0 45.255 18.745L128 64l-18.745 45.255L64 128l-45.255-18.745L0 64l18.745-45.255L64 0Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M40.97 51.901v-2.93h46.058v30.705h-2.85",
      stroke: "#fff",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1),
    k("path", {
      d: "M43.943 48.992V46h46.058v30.705h-2.788",
      stroke: "#fff",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1),
    k("path", {
      d: "M84.057 82.648H38V51.943h46.057v30.705Z",
      stroke: "#fff",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--white"
    }, null, -1)
  ]));
}
const pQ = { render: fQ }, mQ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-image-stack"
};
function Zy(t, e) {
  return h(), b("svg", mQ, e[0] || (e[0] = [
    k("path", {
      d: "M4.4856 9.95076V8.48584H27.5142V23.8382H26.0894",
      stroke: "#0B6AB7",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M5.97156 8.49587V7H29.0001V22.3524H27.6063",
      stroke: "#0B6AB7",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M26.0286 25.3238C18.3524 25.3238 10.6762 25.3238 3 25.3238V9.97144H26.0286V25.3238Z",
      stroke: "#0B6AB7",
      "stroke-width": "0.742857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M12.2856 14.3049L17.4856 17.6478L12.2856 20.9906V14.3049Z",
      stroke: "#0AA5FF",
      "stroke-width": "0.619048",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const Ky = { render: Zy }, gQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ky,
  render: Zy
}, Symbol.toStringTag, { value: "Module" }));
var Zo;
typeof window < "u" ? Zo = window : typeof Vi < "u" ? Zo = Vi : typeof self < "u" ? Zo = self : Zo = {};
var ad = Zo;
const Y = /* @__PURE__ */ xa(ad), bQ = {}, vQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bQ
}, Symbol.toStringTag, { value: "Module" })), yQ = /* @__PURE__ */ m6(vQ);
var mg = typeof Vi < "u" ? Vi : typeof window < "u" ? window : {}, _Q = yQ, Ko;
typeof document < "u" ? Ko = document : (Ko = mg["__GLOBAL_DOCUMENT_CACHE@4"], Ko || (Ko = mg["__GLOBAL_DOCUMENT_CACHE@4"] = _Q));
var Qy = Ko;
const Me = /* @__PURE__ */ xa(Qy);
var Of = { exports: {} }, Jy = { exports: {} };
(function(t) {
  function e() {
    return t.exports = e = Object.assign ? Object.assign.bind() : function(n) {
      for (var a = 1; a < arguments.length; a++) {
        var i = arguments[a];
        for (var r in i) ({}).hasOwnProperty.call(i, r) && (n[r] = i[r]);
      }
      return n;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(null, arguments);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Jy);
var xQ = Jy.exports, TQ = kQ, wQ = Object.prototype.toString;
function kQ(t) {
  if (!t)
    return !1;
  var e = wQ.call(t);
  return e === "[object Function]" || typeof t == "function" && e !== "[object RegExp]" || typeof window < "u" && // IE8 and below
  (t === window.setTimeout || t === window.alert || t === window.confirm || t === window.prompt);
}
function SQ(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = CQ(t)) || e) {
    n && (t = n);
    var a = 0;
    return function() {
      return a >= t.length ? { done: !0 } : { done: !1, value: t[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CQ(t, e) {
  if (t) {
    if (typeof t == "string") return gg(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gg(t, e);
  }
}
function gg(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, a = new Array(e); n < e; n++)
    a[n] = t[n];
  return a;
}
var AQ = /* @__PURE__ */ function() {
  function t() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }
  var e = t.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }, e.addInterceptor = function(a, i) {
    this.typeToInterceptorsMap_.has(a) || this.typeToInterceptorsMap_.set(a, /* @__PURE__ */ new Set());
    var r = this.typeToInterceptorsMap_.get(a);
    return r.has(i) ? !1 : (r.add(i), !0);
  }, e.removeInterceptor = function(a, i) {
    var r = this.typeToInterceptorsMap_.get(a);
    return r && r.has(i) ? (r.delete(i), !0) : !1;
  }, e.clearInterceptorsByType = function(a) {
    var i = this.typeToInterceptorsMap_.get(a);
    return i ? (this.typeToInterceptorsMap_.delete(a), this.typeToInterceptorsMap_.set(a, /* @__PURE__ */ new Set()), !0) : !1;
  }, e.clear = function() {
    return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
  }, e.getForType = function(a) {
    return this.typeToInterceptorsMap_.get(a) || /* @__PURE__ */ new Set();
  }, e.execute = function(a, i) {
    for (var r = this.getForType(a), s = SQ(r), o; !(o = s()).done; ) {
      var l = o.value;
      try {
        i = l(i);
      } catch {
      }
    }
    return i;
  }, t;
}(), EQ = AQ, LQ = /* @__PURE__ */ function() {
  function t() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }
  var e = t.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }, e.getMaxAttempts = function() {
    return this.maxAttempts_;
  }, e.setMaxAttempts = function(a) {
    this.maxAttempts_ = a;
  }, e.getDelayFactor = function() {
    return this.delayFactor_;
  }, e.setDelayFactor = function(a) {
    this.delayFactor_ = a;
  }, e.getFuzzFactor = function() {
    return this.fuzzFactor_;
  }, e.setFuzzFactor = function(a) {
    this.fuzzFactor_ = a;
  }, e.getInitialDelay = function() {
    return this.initialDelay_;
  }, e.setInitialDelay = function(a) {
    this.initialDelay_ = a;
  }, e.createRetry = function(a) {
    var i = a === void 0 ? {} : a, r = i.maxAttempts, s = i.delayFactor, o = i.fuzzFactor, l = i.initialDelay;
    return new DQ({
      maxAttempts: r || this.maxAttempts_,
      delayFactor: s || this.delayFactor_,
      fuzzFactor: o || this.fuzzFactor_,
      initialDelay: l || this.initialDelay_
    });
  }, t;
}(), DQ = /* @__PURE__ */ function() {
  function t(n) {
    this.maxAttempts_ = n.maxAttempts, this.delayFactor_ = n.delayFactor, this.fuzzFactor_ = n.fuzzFactor, this.currentDelay_ = n.initialDelay, this.currentAttempt_ = 1;
  }
  var e = t.prototype;
  return e.moveToNextAttempt = function() {
    this.currentAttempt_++;
    var a = this.currentDelay_ * this.delayFactor_;
    this.currentDelay_ = this.currentDelay_ + a;
  }, e.shouldRetry = function() {
    return this.currentAttempt_ < this.maxAttempts_;
  }, e.getCurrentDelay = function() {
    return this.currentDelay_;
  }, e.getCurrentMinPossibleDelay = function() {
    return (1 - this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentMaxPossibleDelay = function() {
    return (1 + this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentFuzzedDelay = function() {
    var a = this.getCurrentMinPossibleDelay(), i = this.getCurrentMaxPossibleDelay();
    return a + Math.random() * (i - a);
  }, t;
}(), IQ = LQ, MQ = ad, OQ = function(e, n) {
  return n === void 0 && (n = !1), function(a, i, r) {
    if (a) {
      e(a);
      return;
    }
    if (i.statusCode >= 400 && i.statusCode <= 599) {
      var s = r;
      if (n)
        if (MQ.TextDecoder) {
          var o = PQ(i.headers && i.headers["content-type"]);
          try {
            s = new TextDecoder(o).decode(r);
          } catch {
          }
        } else
          s = String.fromCharCode.apply(null, new Uint8Array(r));
      e({
        cause: s
      });
      return;
    }
    e(null, r);
  };
};
function PQ(t) {
  return t === void 0 && (t = ""), t.toLowerCase().split(";").reduce(function(e, n) {
    var a = n.split("="), i = a[0], r = a[1];
    return i.trim() === "charset" ? r.trim() : e;
  }, "utf-8");
}
var BQ = OQ, e5 = ad, RQ = xQ, NQ = TQ, t5 = EQ, $Q = IQ;
Zt.httpHandler = BQ;
Zt.requestInterceptorsStorage = new t5();
Zt.responseInterceptorsStorage = new t5();
Zt.retryManager = new $Q();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var FQ = function(e) {
  var n = {};
  return e && e.trim().split(`
`).forEach(function(a) {
    var i = a.indexOf(":"), r = a.slice(0, i).trim().toLowerCase(), s = a.slice(i + 1).trim();
    typeof n[r] > "u" ? n[r] = s : Array.isArray(n[r]) ? n[r].push(s) : n[r] = [n[r], s];
  }), n;
};
Of.exports = Zt;
Of.exports.default = Zt;
Zt.XMLHttpRequest = e5.XMLHttpRequest || YQ;
Zt.XDomainRequest = "withCredentials" in new Zt.XMLHttpRequest() ? Zt.XMLHttpRequest : e5.XDomainRequest;
zQ(["get", "put", "post", "patch", "head", "delete"], function(t) {
  Zt[t === "delete" ? "del" : t] = function(e, n, a) {
    return n = n5(e, n, a), n.method = t.toUpperCase(), Pf(n);
  };
});
function zQ(t, e) {
  for (var n = 0; n < t.length; n++)
    e(t[n]);
}
function UQ(t) {
  for (var e in t)
    if (t.hasOwnProperty(e)) return !1;
  return !0;
}
function n5(t, e, n) {
  var a = t;
  return NQ(e) ? (n = e, typeof t == "string" && (a = {
    uri: t
  })) : a = RQ({}, e, {
    uri: t
  }), a.callback = n, a;
}
function Zt(t, e, n) {
  return e = n5(t, e, n), Pf(e);
}
function Pf(t) {
  if (typeof t.callback > "u")
    throw new Error("callback argument missing");
  if (t.requestType && Zt.requestInterceptorsStorage.getIsEnabled()) {
    var e = {
      uri: t.uri || t.url,
      headers: t.headers || {},
      body: t.body,
      metadata: t.metadata || {},
      retry: t.retry,
      timeout: t.timeout
    }, n = Zt.requestInterceptorsStorage.execute(t.requestType, e);
    t.uri = n.uri, t.headers = n.headers, t.body = n.body, t.metadata = n.metadata, t.retry = n.retry, t.timeout = n.timeout;
  }
  var a = !1, i = function(D, B, P) {
    a || (a = !0, t.callback(D, B, P));
  };
  function r() {
    c.readyState === 4 && !Zt.responseInterceptorsStorage.getIsEnabled() && setTimeout(l, 0);
  }
  function s() {
    var L = void 0;
    if (c.response ? L = c.response : L = c.responseText || HQ(c), C)
      try {
        L = JSON.parse(L);
      } catch {
      }
    return L;
  }
  function o(L) {
    if (clearTimeout(M), clearTimeout(t.retryTimeout), L instanceof Error || (L = new Error("" + (L || "Unknown XMLHttpRequest Error"))), L.statusCode = 0, !f && Zt.retryManager.getIsEnabled() && t.retry && t.retry.shouldRetry()) {
      t.retryTimeout = setTimeout(function() {
        t.retry.moveToNextAttempt(), t.xhr = c, Pf(t);
      }, t.retry.getCurrentFuzzedDelay());
      return;
    }
    if (t.requestType && Zt.responseInterceptorsStorage.getIsEnabled()) {
      var D = {
        headers: A.headers || {},
        body: A.body,
        responseUrl: c.responseURL,
        responseType: c.responseType
      }, B = Zt.responseInterceptorsStorage.execute(t.requestType, D);
      A.body = B.body, A.headers = B.headers;
    }
    return i(L, A);
  }
  function l() {
    if (!f) {
      var L;
      clearTimeout(M), clearTimeout(t.retryTimeout), t.useXDR && c.status === void 0 ? L = 200 : L = c.status === 1223 ? 204 : c.status;
      var D = A, B = null;
      if (L !== 0 ? (D = {
        body: s(),
        statusCode: L,
        method: _,
        headers: {},
        url: g,
        rawRequest: c
      }, c.getAllResponseHeaders && (D.headers = FQ(c.getAllResponseHeaders()))) : B = new Error("Internal XMLHttpRequest Error"), t.requestType && Zt.responseInterceptorsStorage.getIsEnabled()) {
        var P = {
          headers: D.headers || {},
          body: D.body,
          responseUrl: c.responseURL,
          responseType: c.responseType
        }, z = Zt.responseInterceptorsStorage.execute(t.requestType, P);
        D.body = z.body, D.headers = z.headers;
      }
      return i(B, D, D.body);
    }
  }
  var c = t.xhr || null;
  c || (t.cors || t.useXDR ? c = new Zt.XDomainRequest() : c = new Zt.XMLHttpRequest());
  var d, f, g = c.url = t.uri || t.url, _ = c.method = t.method || "GET", x = t.body || t.data, p = c.headers = t.headers || {}, w = !!t.sync, C = !1, M, A = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: _,
    url: g,
    rawRequest: c
  };
  if ("json" in t && t.json !== !1 && (C = !0, p.accept || p.Accept || (p.Accept = "application/json"), _ !== "GET" && _ !== "HEAD" && (p["content-type"] || p["Content-Type"] || (p["Content-Type"] = "application/json"), x = JSON.stringify(t.json === !0 ? x : t.json))), c.onreadystatechange = r, c.onload = l, c.onerror = o, c.onprogress = function() {
  }, c.onabort = function() {
    f = !0, clearTimeout(t.retryTimeout);
  }, c.ontimeout = o, c.open(_, g, !w, t.username, t.password), w || (c.withCredentials = !!t.withCredentials), !w && t.timeout > 0 && (M = setTimeout(function() {
    if (!f) {
      f = !0, c.abort("timeout");
      var L = new Error("XMLHttpRequest timeout");
      L.code = "ETIMEDOUT", o(L);
    }
  }, t.timeout)), c.setRequestHeader)
    for (d in p)
      p.hasOwnProperty(d) && c.setRequestHeader(d, p[d]);
  else if (t.headers && !UQ(t.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in t && (c.responseType = t.responseType), "beforeSend" in t && typeof t.beforeSend == "function" && t.beforeSend(c), c.send(x || null), c;
}
function HQ(t) {
  try {
    if (t.responseType === "document")
      return t.responseXML;
    var e = t.responseXML && t.responseXML.documentElement.nodeName === "parsererror";
    if (t.responseType === "" && !e)
      return t.responseXML;
  } catch {
  }
  return null;
}
function YQ() {
}
var jQ = Of.exports;
const a5 = /* @__PURE__ */ xa(jQ);
var i5 = { exports: {} }, bg = Qy, Bf = Object.create || /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return t.prototype = e, new t();
  };
}();
function la(t, e) {
  this.name = "ParsingError", this.code = t.code, this.message = e || t.message;
}
la.prototype = Bf(Error.prototype);
la.prototype.constructor = la;
la.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function Rf(t) {
  function e(a, i, r, s) {
    return (a | 0) * 3600 + (i | 0) * 60 + (r | 0) + (s | 0) / 1e3;
  }
  var n = t.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return n ? n[3] ? e(n[1], n[2], n[3].replace(":", ""), n[4]) : n[1] > 59 ? e(n[1], n[2], 0, n[4]) : e(0, n[1], n[2], n[4]) : null;
}
function ol() {
  this.values = Bf(null);
}
ol.prototype = {
  // Only accept the first assignment to any key.
  set: function(t, e) {
    !this.get(t) && e !== "" && (this.values[t] = e);
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(t, e, n) {
    return n ? this.has(t) ? this.values[t] : e[n] : this.has(t) ? this.values[t] : e;
  },
  // Check whether we have a value for a key.
  has: function(t) {
    return t in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(t, e, n) {
    for (var a = 0; a < n.length; ++a)
      if (e === n[a]) {
        this.set(t, e);
        break;
      }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(t, e) {
    /^-?\d+$/.test(e) && this.set(t, parseInt(e, 10));
  },
  // Accept a setting if its a valid percentage.
  percent: function(t, e) {
    return e.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (e = parseFloat(e), e >= 0 && e <= 100) ? (this.set(t, e), !0) : !1;
  }
};
function Qo(t, e, n, a) {
  var i = a ? t.split(a) : [t];
  for (var r in i)
    if (typeof i[r] == "string") {
      var s = i[r].split(n);
      if (s.length === 2) {
        var o = s[0].trim(), l = s[1].trim();
        e(o, l);
      }
    }
}
function VQ(t, e, n) {
  var a = t;
  function i() {
    var o = Rf(t);
    if (o === null)
      throw new la(
        la.Errors.BadTimeStamp,
        "Malformed timestamp: " + a
      );
    return t = t.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function r(o, l) {
    var c = new ol();
    Qo(o, function(d, f) {
      switch (d) {
        case "region":
          for (var g = n.length - 1; g >= 0; g--)
            if (n[g].id === f) {
              c.set(d, n[g].region);
              break;
            }
          break;
        case "vertical":
          c.alt(d, f, ["rl", "lr"]);
          break;
        case "line":
          var _ = f.split(","), x = _[0];
          c.integer(d, x), c.percent(d, x) && c.set("snapToLines", !1), c.alt(d, x, ["auto"]), _.length === 2 && c.alt("lineAlign", _[1], ["start", "center", "end"]);
          break;
        case "position":
          _ = f.split(","), c.percent(d, _[0]), _.length === 2 && c.alt("positionAlign", _[1], ["start", "center", "end"]);
          break;
        case "size":
          c.percent(d, f);
          break;
        case "align":
          c.alt(d, f, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    try {
      l.line = c.get("line", "auto");
    } catch {
    }
    l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100);
    try {
      l.align = c.get("align", "center");
    } catch {
      l.align = c.get("align", "middle");
    }
    try {
      l.position = c.get("position", "auto");
    } catch {
      l.position = c.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, l.align);
    }
    l.positionAlign = c.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, l.align);
  }
  function s() {
    t = t.replace(/^\s+/, "");
  }
  if (s(), e.startTime = i(), s(), t.substr(0, 3) !== "-->")
    throw new la(
      la.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + a
    );
  t = t.substr(3), s(), e.endTime = i(), s(), r(t, e);
}
var g0 = bg.createElement && bg.createElement("textarea"), qQ = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, vg = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, WQ = {
  v: "title",
  lang: "lang"
}, yg = {
  rt: "ruby"
};
function r5(t, e) {
  function n() {
    if (!e)
      return null;
    function x(w) {
      return e = e.substr(w.length), w;
    }
    var p = e.match(/^([^<]*)(<[^>]*>?)?/);
    return x(p[1] ? p[1] : p[2]);
  }
  function a(x) {
    return g0.innerHTML = x, x = g0.textContent, g0.textContent = "", x;
  }
  function i(x, p) {
    return !yg[p.localName] || yg[p.localName] === x.localName;
  }
  function r(x, p) {
    var w = qQ[x];
    if (!w)
      return null;
    var C = t.document.createElement(w), M = WQ[x];
    return M && p && (C[M] = p.trim()), C;
  }
  for (var s = t.document.createElement("div"), o = s, l, c = []; (l = n()) !== null; ) {
    if (l[0] === "<") {
      if (l[1] === "/") {
        c.length && c[c.length - 1] === l.substr(2).replace(">", "") && (c.pop(), o = o.parentNode);
        continue;
      }
      var d = Rf(l.substr(1, l.length - 2)), f;
      if (d) {
        f = t.document.createProcessingInstruction("timestamp", d), o.appendChild(f);
        continue;
      }
      var g = l.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!g || (f = r(g[1], g[3]), !f) || !i(o, f))
        continue;
      if (g[2]) {
        var _ = g[2].split(".");
        _.forEach(function(x) {
          var p = /^bg_/.test(x), w = p ? x.slice(3) : x;
          if (vg.hasOwnProperty(w)) {
            var C = p ? "background-color" : "color", M = vg[w];
            f.style[C] = M;
          }
        }), f.className = _.join(" ");
      }
      c.push(g[1]), o.appendChild(f), o = f;
      continue;
    }
    o.appendChild(t.document.createTextNode(a(l)));
  }
  return s;
}
var _g = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function GQ(t) {
  for (var e = 0; e < _g.length; e++) {
    var n = _g[e];
    if (t >= n[0] && t <= n[1])
      return !0;
  }
  return !1;
}
function XQ(t) {
  var e = [], n = "", a;
  if (!t || !t.childNodes)
    return "ltr";
  function i(o, l) {
    for (var c = l.childNodes.length - 1; c >= 0; c--)
      o.push(l.childNodes[c]);
  }
  function r(o) {
    if (!o || !o.length)
      return null;
    var l = o.pop(), c = l.textContent || l.innerText;
    if (c) {
      var d = c.match(/^.*(\n|\r)/);
      return d ? (o.length = 0, d[0]) : c;
    }
    if (l.tagName === "ruby")
      return r(o);
    if (l.childNodes)
      return i(o, l), r(o);
  }
  for (i(e, t); n = r(e); )
    for (var s = 0; s < n.length; s++)
      if (a = n.charCodeAt(s), GQ(a))
        return "rtl";
  return "ltr";
}
function ZQ(t) {
  if (typeof t.line == "number" && (t.snapToLines || t.line >= 0 && t.line <= 100))
    return t.line;
  if (!t.track || !t.track.textTrackList || !t.track.textTrackList.mediaElement)
    return -1;
  for (var e = t.track, n = e.textTrackList, a = 0, i = 0; i < n.length && n[i] !== e; i++)
    n[i].mode === "showing" && a++;
  return ++a * -1;
}
function id() {
}
id.prototype.applyStyles = function(t, e) {
  e = e || this.div;
  for (var n in t)
    t.hasOwnProperty(n) && (e.style[n] = t[n]);
};
id.prototype.formatStyle = function(t, e) {
  return t === 0 ? 0 : t + e;
};
function cu(t, e, n) {
  id.call(this), this.cue = e, this.cueDiv = r5(t, e.text);
  var a = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(a, this.cueDiv), this.div = t.document.createElement("div"), a = {
    direction: XQ(this.cueDiv),
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: e.align === "middle" ? "center" : e.align,
    font: n.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(a), this.div.appendChild(this.cueDiv);
  var i = 0;
  switch (e.positionAlign) {
    case "start":
    case "line-left":
      i = e.position;
      break;
    case "center":
      i = e.position - e.size / 2;
      break;
    case "end":
    case "line-right":
      i = e.position - e.size;
      break;
  }
  e.vertical === "" ? this.applyStyles({
    left: this.formatStyle(i, "%"),
    width: this.formatStyle(e.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(i, "%"),
    height: this.formatStyle(e.size, "%")
  }), this.move = function(r) {
    this.applyStyles({
      top: this.formatStyle(r.top, "px"),
      bottom: this.formatStyle(r.bottom, "px"),
      left: this.formatStyle(r.left, "px"),
      right: this.formatStyle(r.right, "px"),
      height: this.formatStyle(r.height, "px"),
      width: this.formatStyle(r.width, "px")
    });
  };
}
cu.prototype = Bf(id.prototype);
cu.prototype.constructor = cu;
function Fn(t) {
  var e, n, a, i;
  if (t.div) {
    n = t.div.offsetHeight, a = t.div.offsetWidth, i = t.div.offsetTop;
    var r = (r = t.div.childNodes) && (r = r[0]) && r.getClientRects && r.getClientRects();
    t = t.div.getBoundingClientRect(), e = r ? Math.max(r[0] && r[0].height || 0, t.height / r.length) : 0;
  }
  this.left = t.left, this.right = t.right, this.top = t.top || i, this.height = t.height || n, this.bottom = t.bottom || i + (t.height || n), this.width = t.width || a, this.lineHeight = e !== void 0 ? e : t.lineHeight;
}
Fn.prototype.move = function(t, e) {
  switch (e = e !== void 0 ? e : this.lineHeight, t) {
    case "+x":
      this.left += e, this.right += e;
      break;
    case "-x":
      this.left -= e, this.right -= e;
      break;
    case "+y":
      this.top += e, this.bottom += e;
      break;
    case "-y":
      this.top -= e, this.bottom -= e;
      break;
  }
};
Fn.prototype.overlaps = function(t) {
  return this.left < t.right && this.right > t.left && this.top < t.bottom && this.bottom > t.top;
};
Fn.prototype.overlapsAny = function(t) {
  for (var e = 0; e < t.length; e++)
    if (this.overlaps(t[e]))
      return !0;
  return !1;
};
Fn.prototype.within = function(t) {
  return this.top >= t.top && this.bottom <= t.bottom && this.left >= t.left && this.right <= t.right;
};
Fn.prototype.overlapsOppositeAxis = function(t, e) {
  switch (e) {
    case "+x":
      return this.left < t.left;
    case "-x":
      return this.right > t.right;
    case "+y":
      return this.top < t.top;
    case "-y":
      return this.bottom > t.bottom;
  }
};
Fn.prototype.intersectPercentage = function(t) {
  var e = Math.max(0, Math.min(this.right, t.right) - Math.max(this.left, t.left)), n = Math.max(0, Math.min(this.bottom, t.bottom) - Math.max(this.top, t.top)), a = e * n;
  return a / (this.height * this.width);
};
Fn.prototype.toCSSCompatValues = function(t) {
  return {
    top: this.top - t.top,
    bottom: t.bottom - this.bottom,
    left: this.left - t.left,
    right: t.right - this.right,
    height: this.height,
    width: this.width
  };
};
Fn.getSimpleBoxPosition = function(t) {
  var e = t.div ? t.div.offsetHeight : t.tagName ? t.offsetHeight : 0, n = t.div ? t.div.offsetWidth : t.tagName ? t.offsetWidth : 0, a = t.div ? t.div.offsetTop : t.tagName ? t.offsetTop : 0;
  t = t.div ? t.div.getBoundingClientRect() : t.tagName ? t.getBoundingClientRect() : t;
  var i = {
    left: t.left,
    right: t.right,
    top: t.top || a,
    height: t.height || e,
    bottom: t.bottom || a + (t.height || e),
    width: t.width || n
  };
  return i;
};
function KQ(t, e, n, a) {
  function i(w, C) {
    for (var M, A = new Fn(w), L = 1, D = 0; D < C.length; D++) {
      for (; w.overlapsOppositeAxis(n, C[D]) || w.within(n) && w.overlapsAny(a); )
        w.move(C[D]);
      if (w.within(n))
        return w;
      var B = w.intersectPercentage(n);
      L > B && (M = new Fn(w), L = B), w = new Fn(A);
    }
    return M || A;
  }
  var r = new Fn(e), s = e.cue, o = ZQ(s), l = [];
  if (s.snapToLines) {
    var c;
    switch (s.vertical) {
      case "":
        l = ["+y", "-y"], c = "height";
        break;
      case "rl":
        l = ["+x", "-x"], c = "width";
        break;
      case "lr":
        l = ["-x", "+x"], c = "width";
        break;
    }
    var d = r.lineHeight, f = d * Math.round(o), g = n[c] + d, _ = l[0];
    Math.abs(f) > g && (f = f < 0 ? -1 : 1, f *= Math.ceil(g / d) * d), o < 0 && (f += s.vertical === "" ? n.height : n.width, l = l.reverse()), r.move(_, f);
  } else {
    var x = r.lineHeight / n.height * 100;
    switch (s.lineAlign) {
      case "center":
        o -= x / 2;
        break;
      case "end":
        o -= x;
        break;
    }
    switch (s.vertical) {
      case "":
        e.applyStyles({
          top: e.formatStyle(o, "%")
        });
        break;
      case "rl":
        e.applyStyles({
          left: e.formatStyle(o, "%")
        });
        break;
      case "lr":
        e.applyStyles({
          right: e.formatStyle(o, "%")
        });
        break;
    }
    l = ["+y", "-x", "+x", "-y"], r = new Fn(e);
  }
  var p = i(r, l);
  e.move(p.toCSSCompatValues(n));
}
function ro() {
}
ro.StringDecoder = function() {
  return {
    decode: function(t) {
      if (!t)
        return "";
      if (typeof t != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(t));
    }
  };
};
ro.convertCueToDOMTree = function(t, e) {
  return !t || !e ? null : r5(t, e);
};
var QQ = 0.05, JQ = "sans-serif", eJ = "1.5%";
ro.processCues = function(t, e, n) {
  if (!t || !e || !n)
    return null;
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
  var a = t.document.createElement("div");
  a.style.position = "absolute", a.style.left = "0", a.style.right = "0", a.style.top = "0", a.style.bottom = "0", a.style.margin = eJ, n.appendChild(a);
  function i(d) {
    for (var f = 0; f < d.length; f++)
      if (d[f].hasBeenReset || !d[f].displayState)
        return !0;
    return !1;
  }
  if (!i(e)) {
    for (var r = 0; r < e.length; r++)
      a.appendChild(e[r].displayState);
    return;
  }
  var s = [], o = Fn.getSimpleBoxPosition(a), l = Math.round(o.height * QQ * 100) / 100, c = {
    font: l + "px " + JQ
  };
  (function() {
    for (var d, f, g = 0; g < e.length; g++)
      f = e[g], d = new cu(t, f, c), a.appendChild(d.div), KQ(t, d, o, s), f.displayState = d.div, s.push(Fn.getSimpleBoxPosition(d));
  })();
};
ro.Parser = function(t, e, n) {
  n || (n = e, e = {}), e || (e = {}), this.window = t, this.vttjs = e, this.state = "INITIAL", this.buffer = "", this.decoder = n || new TextDecoder("utf8"), this.regionList = [];
};
ro.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(t) {
    if (t instanceof la)
      this.onparsingerror && this.onparsingerror(t);
    else
      throw t;
  },
  parse: function(t) {
    var e = this;
    t && (e.buffer += e.decoder.decode(t, { stream: !0 }));
    function n() {
      for (var d = e.buffer, f = 0; f < d.length && d[f] !== "\r" && d[f] !== `
`; )
        ++f;
      var g = d.substr(0, f);
      return d[f] === "\r" && ++f, d[f] === `
` && ++f, e.buffer = d.substr(f), g;
    }
    function a(d) {
      var f = new ol();
      if (Qo(d, function(_, x) {
        switch (_) {
          case "id":
            f.set(_, x);
            break;
          case "width":
            f.percent(_, x);
            break;
          case "lines":
            f.integer(_, x);
            break;
          case "regionanchor":
          case "viewportanchor":
            var p = x.split(",");
            if (p.length !== 2)
              break;
            var w = new ol();
            if (w.percent("x", p[0]), w.percent("y", p[1]), !w.has("x") || !w.has("y"))
              break;
            f.set(_ + "X", w.get("x")), f.set(_ + "Y", w.get("y"));
            break;
          case "scroll":
            f.alt(_, x, ["up"]);
            break;
        }
      }, /=/, /\s/), f.has("id")) {
        var g = new (e.vttjs.VTTRegion || e.window.VTTRegion)();
        g.width = f.get("width", 100), g.lines = f.get("lines", 3), g.regionAnchorX = f.get("regionanchorX", 0), g.regionAnchorY = f.get("regionanchorY", 100), g.viewportAnchorX = f.get("viewportanchorX", 0), g.viewportAnchorY = f.get("viewportanchorY", 100), g.scroll = f.get("scroll", ""), e.onregion && e.onregion(g), e.regionList.push({
          id: f.get("id"),
          region: g
        });
      }
    }
    function i(d) {
      var f = new ol();
      Qo(d, function(g, _) {
        switch (g) {
          case "MPEGT":
            f.integer(g + "S", _);
            break;
          case "LOCA":
            f.set(g + "L", Rf(_));
            break;
        }
      }, /[^\d]:/, /,/), e.ontimestampmap && e.ontimestampmap({
        MPEGTS: f.get("MPEGTS"),
        LOCAL: f.get("LOCAL")
      });
    }
    function r(d) {
      d.match(/X-TIMESTAMP-MAP/) ? Qo(d, function(f, g) {
        switch (f) {
          case "X-TIMESTAMP-MAP":
            i(g);
            break;
        }
      }, /=/) : Qo(d, function(f, g) {
        switch (f) {
          case "Region":
            a(g);
            break;
        }
      }, /:/);
    }
    try {
      var s;
      if (e.state === "INITIAL") {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        s = n();
        var o = s.match(/^WEBVTT([ \t].*)?$/);
        if (!o || !o[0])
          throw new la(la.Errors.BadSignature);
        e.state = "HEADER";
      }
      for (var l = !1; e.buffer; ) {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        switch (l ? l = !1 : s = n(), e.state) {
          case "HEADER":
            /:/.test(s) ? r(s) : s || (e.state = "ID");
            continue;
          case "NOTE":
            s || (e.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(s)) {
              e.state = "NOTE";
              break;
            }
            if (!s)
              continue;
            e.cue = new (e.vttjs.VTTCue || e.window.VTTCue)(0, 0, "");
            try {
              e.cue.align = "center";
            } catch {
              e.cue.align = "middle";
            }
            if (e.state = "CUE", s.indexOf("-->") === -1) {
              e.cue.id = s;
              continue;
            }
          case "CUE":
            try {
              VQ(s, e.cue, e.regionList);
            } catch (d) {
              e.reportOrThrowError(d), e.cue = null, e.state = "BADCUE";
              continue;
            }
            e.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var c = s.indexOf("-->") !== -1;
            if (!s || c && (l = !0)) {
              e.oncue && e.oncue(e.cue), e.cue = null, e.state = "ID";
              continue;
            }
            e.cue.text && (e.cue.text += `
`), e.cue.text += s.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            s || (e.state = "ID");
            continue;
        }
      }
    } catch (d) {
      e.reportOrThrowError(d), e.state === "CUETEXT" && e.cue && e.oncue && e.oncue(e.cue), e.cue = null, e.state = e.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var t = this;
    try {
      if (t.buffer += t.decoder.decode(), (t.cue || t.state === "HEADER") && (t.buffer += `

`, t.parse()), t.state === "INITIAL")
        throw new la(la.Errors.BadSignature);
    } catch (e) {
      t.reportOrThrowError(e);
    }
    return t.onflush && t.onflush(), this;
  }
};
var tJ = ro, nJ = "auto", aJ = {
  "": 1,
  lr: 1,
  rl: 1
}, iJ = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function rJ(t) {
  if (typeof t != "string")
    return !1;
  var e = aJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function b0(t) {
  if (typeof t != "string")
    return !1;
  var e = iJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function s5(t, e, n) {
  this.hasBeenReset = !1;
  var a = "", i = !1, r = t, s = e, o = n, l = null, c = "", d = !0, f = "auto", g = "start", _ = "auto", x = "auto", p = 100, w = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(C) {
        a = "" + C;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(C) {
        i = !!C;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(C) {
        if (typeof C != "number")
          throw new TypeError("Start time must be set to a number.");
        r = C, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(C) {
        if (typeof C != "number")
          throw new TypeError("End time must be set to a number.");
        s = C, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(C) {
        o = "" + C, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(C) {
        l = C, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return c;
      },
      set: function(C) {
        var M = rJ(C);
        if (M === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        c = M, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return d;
      },
      set: function(C) {
        d = !!C, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return f;
      },
      set: function(C) {
        if (typeof C != "number" && C !== nJ)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        f = C, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return g;
      },
      set: function(C) {
        var M = b0(C);
        M ? (g = M, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return _;
      },
      set: function(C) {
        if (C < 0 || C > 100)
          throw new Error("Position must be between 0 and 100.");
        _ = C, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return x;
      },
      set: function(C) {
        var M = b0(C);
        M ? (x = M, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return p;
      },
      set: function(C) {
        if (C < 0 || C > 100)
          throw new Error("Size must be between 0 and 100.");
        p = C, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return w;
      },
      set: function(C) {
        var M = b0(C);
        if (!M)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        w = M, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
s5.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var sJ = s5, oJ = {
  "": !0,
  up: !0
};
function lJ(t) {
  if (typeof t != "string")
    return !1;
  var e = oJ[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function zo(t) {
  return typeof t == "number" && t >= 0 && t <= 100;
}
function cJ() {
  var t = 100, e = 3, n = 0, a = 100, i = 0, r = 100, s = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(o) {
        if (!zo(o))
          throw new Error("Width must be between 0 and 100.");
        t = o;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(o) {
        if (typeof o != "number")
          throw new TypeError("Lines must be set to a number.");
        e = o;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(o) {
        if (!zo(o))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        a = o;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(o) {
        if (!zo(o))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        n = o;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(o) {
        if (!zo(o))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        r = o;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(o) {
        if (!zo(o))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        i = o;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(o) {
        var l = lJ(o);
        l === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : s = l;
      }
    }
  });
}
var uJ = cJ, wi = ad, jr = i5.exports = {
  WebVTT: tJ,
  VTTCue: sJ,
  VTTRegion: uJ
};
wi.vttjs = jr;
wi.WebVTT = jr.WebVTT;
var dJ = jr.VTTCue, hJ = jr.VTTRegion, fJ = wi.VTTCue, pJ = wi.VTTRegion;
jr.shim = function() {
  wi.VTTCue = dJ, wi.VTTRegion = hJ;
};
jr.restore = function() {
  wi.VTTCue = fJ, wi.VTTRegion = pJ;
};
wi.VTTCue || jr.shim();
var mJ = i5.exports;
const xg = /* @__PURE__ */ xa(mJ);
function Jt() {
  return Jt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Jt.apply(null, arguments);
}
var Tg = "https://example.com", rd = function(e, n) {
  if (/^[a-z]+:/i.test(n))
    return n;
  /^data:/.test(e) && (e = Y.location && Y.location.href || "");
  var a = /^\/\//.test(e), i = !Y.location && !/\/\//i.test(e);
  e = new Y.URL(e, Y.location || Tg);
  var r = new URL(n, e);
  return i ? r.href.slice(Tg.length) : a ? r.href.slice(r.protocol.length) : r.href;
}, Nf = /* @__PURE__ */ function() {
  function t() {
    this.listeners = {};
  }
  var e = t.prototype;
  return e.on = function(a, i) {
    this.listeners[a] || (this.listeners[a] = []), this.listeners[a].push(i);
  }, e.off = function(a, i) {
    if (!this.listeners[a])
      return !1;
    var r = this.listeners[a].indexOf(i);
    return this.listeners[a] = this.listeners[a].slice(0), this.listeners[a].splice(r, 1), r > -1;
  }, e.trigger = function(a) {
    var i = this.listeners[a];
    if (i)
      if (arguments.length === 2)
        for (var r = i.length, s = 0; s < r; ++s)
          i[s].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = i.length, c = 0; c < l; ++c)
          i[c].apply(this, o);
  }, e.dispose = function() {
    this.listeners = {};
  }, e.pipe = function(a) {
    this.on("data", function(i) {
      a.push(i);
    });
  }, t;
}(), gJ = function(e) {
  return Y.atob ? Y.atob(e) : Buffer.from(e, "base64").toString("binary");
};
function o5(t) {
  for (var e = gJ(t), n = new Uint8Array(e.length), a = 0; a < e.length; a++)
    n[a] = e.charCodeAt(a);
  return n;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class bJ extends Nf {
  constructor() {
    super(), this.buffer = "";
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */
  push(e) {
    let n;
    for (this.buffer += e, n = this.buffer.indexOf(`
`); n > -1; n = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, n)), this.buffer = this.buffer.substring(n + 1);
  }
}
const vJ = "	", v0 = function(t) {
  const e = /([0-9.]*)?@?([0-9.]*)?/.exec(t || ""), n = {};
  return e[1] && (n.length = parseInt(e[1], 10)), e[2] && (n.offset = parseInt(e[2], 10)), n;
}, yJ = function() {
  const n = "(?:" + "[^=]*" + ")=(?:" + '"[^"]*"|[^,]*' + ")";
  return new RegExp("(?:^|,)(" + n + ")");
}, On = function(t) {
  const e = {};
  if (!t)
    return e;
  const n = t.split(yJ());
  let a = n.length, i;
  for (; a--; )
    n[a] !== "" && (i = /([^=]*)=(.*)/.exec(n[a]).slice(1), i[0] = i[0].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^\s+|\s+$/g, ""), i[1] = i[1].replace(/^['"](.*)['"]$/g, "$1"), e[i[0]] = i[1]);
  return e;
}, wg = (t) => {
  const e = t.split("x"), n = {};
  return e[0] && (n.width = parseInt(e[0], 10)), e[1] && (n.height = parseInt(e[1], 10)), n;
};
class _J extends Nf {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */
  push(e) {
    let n, a;
    if (e = e.trim(), e.length === 0)
      return;
    if (e[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: e
      });
      return;
    }
    this.tagMappers.reduce((r, s) => {
      const o = s(e);
      return o === e ? r : r.concat([o]);
    }, [e]).forEach((r) => {
      for (let s = 0; s < this.customParsers.length; s++)
        if (this.customParsers[s].call(this, r))
          return;
      if (r.indexOf("#EXT") !== 0) {
        this.trigger("data", {
          type: "comment",
          text: r.slice(1)
        });
        return;
      }
      if (r = r.replace("\r", ""), n = /^#EXTM3U/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      if (n = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "inf"
        }, n[1] && (a.duration = parseFloat(n[1])), n[2] && (a.title = n[2]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "targetduration"
        }, n[1] && (a.duration = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-VERSION:([0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "version"
        }, n[1] && (a.version = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "media-sequence"
        }, n[1] && (a.number = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "discontinuity-sequence"
        }, n[1] && (a.number = parseInt(n[1], 10)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "playlist-type"
        }, n[1] && (a.playlistType = n[1]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-BYTERANGE:(.*)?$/.exec(r), n) {
        a = Jt(v0(n[1]), {
          type: "tag",
          tagType: "byterange"
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "allow-cache"
        }, n[1] && (a.allowed = !/NO/.test(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MAP:(.*)$/.exec(r), n) {
        if (a = {
          type: "tag",
          tagType: "map"
        }, n[1]) {
          const s = On(n[1]);
          s.URI && (a.uri = s.URI), s.BYTERANGE && (a.byterange = v0(s.BYTERANGE));
        }
        this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-STREAM-INF:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "stream-inf"
        }, n[1] && (a.attributes = On(n[1]), a.attributes.RESOLUTION && (a.attributes.RESOLUTION = wg(a.attributes.RESOLUTION)), a.attributes.BANDWIDTH && (a.attributes.BANDWIDTH = parseInt(a.attributes.BANDWIDTH, 10)), a.attributes["FRAME-RATE"] && (a.attributes["FRAME-RATE"] = parseFloat(a.attributes["FRAME-RATE"])), a.attributes["PROGRAM-ID"] && (a.attributes["PROGRAM-ID"] = parseInt(a.attributes["PROGRAM-ID"], 10))), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-MEDIA:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "media"
        }, n[1] && (a.attributes = On(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-ENDLIST/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      if (n = /^#EXT-X-DISCONTINUITY/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      if (n = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "program-date-time"
        }, n[1] && (a.dateTimeString = n[1], a.dateTimeObject = new Date(n[1])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-KEY:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "key"
        }, n[1] && (a.attributes = On(n[1]), a.attributes.IV && (a.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (a.attributes.IV = a.attributes.IV.substring(2)), a.attributes.IV = a.attributes.IV.match(/.{8}/g), a.attributes.IV[0] = parseInt(a.attributes.IV[0], 16), a.attributes.IV[1] = parseInt(a.attributes.IV[1], 16), a.attributes.IV[2] = parseInt(a.attributes.IV[2], 16), a.attributes.IV[3] = parseInt(a.attributes.IV[3], 16), a.attributes.IV = new Uint32Array(a.attributes.IV))), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-START:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "start"
        }, n[1] && (a.attributes = On(n[1]), a.attributes["TIME-OFFSET"] = parseFloat(a.attributes["TIME-OFFSET"]), a.attributes.PRECISE = /YES/.test(a.attributes.PRECISE)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-out-cont"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-OUT:(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-out"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-CUE-IN:?(.*)?$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "cue-in"
        }, n[1] ? a.data = n[1] : a.data = "", this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-SKIP:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "skip"
        }, a.attributes = On(n[1]), a.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (a.attributes["SKIPPED-SEGMENTS"] = parseInt(a.attributes["SKIPPED-SEGMENTS"], 10)), a.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (a.attributes["RECENTLY-REMOVED-DATERANGES"] = a.attributes["RECENTLY-REMOVED-DATERANGES"].split(vJ)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PART:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "part"
        }, a.attributes = On(n[1]), ["DURATION"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), ["INDEPENDENT", "GAP"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = /YES/.test(a.attributes[s]));
        }), a.attributes.hasOwnProperty("BYTERANGE") && (a.attributes.byterange = v0(a.attributes.BYTERANGE)), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "server-control"
        }, a.attributes = On(n[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = /YES/.test(a.attributes[s]));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PART-INF:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "part-inf"
        }, a.attributes = On(n[1]), ["PART-TARGET"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseFloat(a.attributes[s]));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "preload-hint"
        }, a.attributes = On(n[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(s) {
          if (a.attributes.hasOwnProperty(s)) {
            a.attributes[s] = parseInt(a.attributes[s], 10);
            const o = s === "BYTERANGE-LENGTH" ? "length" : "offset";
            a.attributes.byterange = a.attributes.byterange || {}, a.attributes.byterange[o] = a.attributes[s], delete a.attributes[s];
          }
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "rendition-report"
        }, a.attributes = On(n[1]), ["LAST-MSN", "LAST-PART"].forEach(function(s) {
          a.attributes.hasOwnProperty(s) && (a.attributes[s] = parseInt(a.attributes[s], 10));
        }), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DATERANGE:(.*)$/.exec(r), n && n[1]) {
        a = {
          type: "tag",
          tagType: "daterange"
        }, a.attributes = On(n[1]), ["ID", "CLASS"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = String(a.attributes[o]));
        }), ["START-DATE", "END-DATE"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = new Date(a.attributes[o]));
        }), ["DURATION", "PLANNED-DURATION"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = parseFloat(a.attributes[o]));
        }), ["END-ON-NEXT"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = /YES/i.test(a.attributes[o]));
        }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(o) {
          a.attributes.hasOwnProperty(o) && (a.attributes[o] = a.attributes[o].toString(16));
        });
        const s = /^X-([A-Z]+-)+[A-Z]+$/;
        for (const o in a.attributes) {
          if (!s.test(o))
            continue;
          const l = /[0-9A-Fa-f]{6}/g.test(a.attributes[o]), c = /^\d+(\.\d+)?$/.test(a.attributes[o]);
          a.attributes[o] = l ? a.attributes[o].toString(16) : c ? parseFloat(a.attributes[o]) : String(a.attributes[o]);
        }
        this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "independent-segments"
        });
        return;
      }
      if (n = /^#EXT-X-I-FRAMES-ONLY/.exec(r), n) {
        this.trigger("data", {
          type: "tag",
          tagType: "i-frames-only"
        });
        return;
      }
      if (n = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "content-steering"
        }, a.attributes = On(n[1]), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "i-frame-playlist"
        }, a.attributes = On(n[1]), a.attributes.URI && (a.uri = a.attributes.URI), a.attributes.BANDWIDTH && (a.attributes.BANDWIDTH = parseInt(a.attributes.BANDWIDTH, 10)), a.attributes.RESOLUTION && (a.attributes.RESOLUTION = wg(a.attributes.RESOLUTION)), a.attributes["AVERAGE-BANDWIDTH"] && (a.attributes["AVERAGE-BANDWIDTH"] = parseInt(a.attributes["AVERAGE-BANDWIDTH"], 10)), a.attributes["FRAME-RATE"] && (a.attributes["FRAME-RATE"] = parseFloat(a.attributes["FRAME-RATE"])), this.trigger("data", a);
        return;
      }
      if (n = /^#EXT-X-DEFINE:(.*)$/.exec(r), n) {
        a = {
          type: "tag",
          tagType: "define"
        }, a.attributes = On(n[1]), this.trigger("data", a);
        return;
      }
      this.trigger("data", {
        type: "tag",
        data: r.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser({
    expression: e,
    customType: n,
    dataParser: a,
    segment: i
  }) {
    typeof a != "function" && (a = (r) => r), this.customParsers.push((r) => {
      if (e.exec(r))
        return this.trigger("data", {
          type: "custom",
          data: a(r),
          customType: n,
          segment: i
        }), !0;
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper({
    expression: e,
    map: n
  }) {
    const a = (i) => e.test(i) ? n(i) : i;
    this.tagMappers.push(a);
  }
}
const xJ = (t) => t.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), $i = function(t) {
  const e = {};
  return Object.keys(t).forEach(function(n) {
    e[xJ(n)] = t[n];
  }), e;
}, y0 = function(t) {
  const {
    serverControl: e,
    targetDuration: n,
    partTargetDuration: a
  } = t;
  if (!e)
    return;
  const i = "#EXT-X-SERVER-CONTROL", r = "holdBack", s = "partHoldBack", o = n && n * 3, l = a && a * 2;
  n && !e.hasOwnProperty(r) && (e[r] = o, this.trigger("info", {
    message: `${i} defaulting HOLD-BACK to targetDuration * 3 (${o}).`
  })), o && e[r] < o && (this.trigger("warn", {
    message: `${i} clamping HOLD-BACK (${e[r]}) to targetDuration * 3 (${o})`
  }), e[r] = o), a && !e.hasOwnProperty(s) && (e[s] = a * 3, this.trigger("info", {
    message: `${i} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${e[s]}).`
  })), a && e[s] < l && (this.trigger("warn", {
    message: `${i} clamping PART-HOLD-BACK (${e[s]}) to partTargetDuration * 2 (${l}).`
  }), e[s] = l);
};
class TJ extends Nf {
  constructor(e = {}) {
    super(), this.lineStream = new bJ(), this.parseStream = new _J(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const n = this, a = [];
    let i = {}, r, s, o = !1;
    const l = function() {
    }, c = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, d = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let f = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let g = 0, _ = 0;
    const x = {};
    this.on("end", () => {
      i.uri || !i.parts && !i.preloadHints || (!i.map && r && (i.map = r), !i.key && s && (i.key = s), !i.timeline && typeof f == "number" && (i.timeline = f), this.manifest.preloadSegment = i);
    }), this.parseStream.on("data", function(p) {
      let w, C;
      if (n.manifest.definitions) {
        for (const M in n.manifest.definitions)
          if (p.uri && (p.uri = p.uri.replace(`{$${M}}`, n.manifest.definitions[M])), p.attributes)
            for (const A in p.attributes)
              typeof p.attributes[A] == "string" && (p.attributes[A] = p.attributes[A].replace(`{$${M}}`, n.manifest.definitions[M]));
      }
      ({
        tag() {
          ({
            version() {
              p.version && (this.manifest.version = p.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = p.allowed, "allowed" in p || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const M = {};
              "length" in p && (i.byterange = M, M.length = p.length, "offset" in p || (p.offset = g)), "offset" in p && (i.byterange = M, M.offset = p.offset), g = M.offset + M.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), p.title && (i.title = p.title), p.duration > 0 && (i.duration = p.duration), p.duration === 0 && (i.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = a;
            },
            key() {
              if (!p.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (p.attributes.METHOD === "NONE") {
                s = null;
                return;
              }
              if (!p.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (p.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: p.attributes
                };
                return;
              }
              if (p.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: p.attributes.URI
                };
                return;
              }
              if (p.attributes.KEYFORMAT === d) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(p.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (p.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), p.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(p.attributes.KEYID && p.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: p.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: p.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: o5(p.attributes.URI.split(",")[1])
                };
                return;
              }
              p.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), s = {
                method: p.attributes.METHOD || "AES-128",
                uri: p.attributes.URI
              }, typeof p.attributes.IV < "u" && (s.iv = p.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(p.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + p.number
                });
                return;
              }
              this.manifest.mediaSequence = p.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(p.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + p.number
                });
                return;
              }
              this.manifest.discontinuitySequence = p.number, f = p.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(p.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + p.playlist
                });
                return;
              }
              this.manifest.playlistType = p.playlistType;
            },
            map() {
              r = {}, p.uri && (r.uri = p.uri), p.byterange && (r.byterange = p.byterange), s && (r.key = s);
            },
            "stream-inf"() {
              if (this.manifest.playlists = a, this.manifest.mediaGroups = this.manifest.mediaGroups || c, !p.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              i.attributes || (i.attributes = {}), Jt(i.attributes, p.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || c, !(p.attributes && p.attributes.TYPE && p.attributes["GROUP-ID"] && p.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const M = this.manifest.mediaGroups[p.attributes.TYPE];
              M[p.attributes["GROUP-ID"]] = M[p.attributes["GROUP-ID"]] || {}, w = M[p.attributes["GROUP-ID"]], C = {
                default: /yes/i.test(p.attributes.DEFAULT)
              }, C.default ? C.autoselect = !0 : C.autoselect = /yes/i.test(p.attributes.AUTOSELECT), p.attributes.LANGUAGE && (C.language = p.attributes.LANGUAGE), p.attributes.URI && (C.uri = p.attributes.URI), p.attributes["INSTREAM-ID"] && (C.instreamId = p.attributes["INSTREAM-ID"]), p.attributes.CHARACTERISTICS && (C.characteristics = p.attributes.CHARACTERISTICS), p.attributes.FORCED && (C.forced = /yes/i.test(p.attributes.FORCED)), w[p.attributes.NAME] = C;
            },
            discontinuity() {
              f += 1, i.discontinuity = !0, this.manifest.discontinuityStarts.push(a.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = p.dateTimeString, this.manifest.dateTimeObject = p.dateTimeObject), i.dateTimeString = p.dateTimeString, i.dateTimeObject = p.dateTimeObject;
              const {
                lastProgramDateTime: M
              } = this;
              this.lastProgramDateTime = new Date(p.dateTimeString).getTime(), M === null && this.manifest.segments.reduceRight((A, L) => (L.programDateTime = A - L.duration * 1e3, L.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(p.duration) || p.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + p.duration
                });
                return;
              }
              this.manifest.targetDuration = p.duration, y0.call(this, this.manifest);
            },
            start() {
              if (!p.attributes || isNaN(p.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: p.attributes["TIME-OFFSET"],
                precise: p.attributes.PRECISE
              };
            },
            "cue-out"() {
              i.cueOut = p.data;
            },
            "cue-out-cont"() {
              i.cueOutCont = p.data;
            },
            "cue-in"() {
              i.cueIn = p.data;
            },
            skip() {
              this.manifest.skip = $i(p.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", p.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              o = !0;
              const M = this.manifest.segments.length, A = $i(p.attributes);
              i.parts = i.parts || [], i.parts.push(A), A.byterange && (A.byterange.hasOwnProperty("offset") || (A.byterange.offset = _), _ = A.byterange.offset + A.byterange.length);
              const L = i.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${L} for segment #${M}`, p.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((D, B) => {
                D.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${B} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const M = this.manifest.serverControl = $i(p.attributes);
              M.hasOwnProperty("canBlockReload") || (M.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), y0.call(this, this.manifest), M.canSkipDateranges && !M.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const M = this.manifest.segments.length, A = $i(p.attributes), L = A.type && A.type === "PART";
              i.preloadHints = i.preloadHints || [], i.preloadHints.push(A), A.byterange && (A.byterange.hasOwnProperty("offset") || (A.byterange.offset = L ? _ : 0, L && (_ = A.byterange.offset + A.byterange.length)));
              const D = i.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${D} for segment #${M}`, p.attributes, ["TYPE", "URI"]), !!A.type)
                for (let B = 0; B < i.preloadHints.length - 1; B++) {
                  const P = i.preloadHints[B];
                  P.type && P.type === A.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${D} for segment #${M} has the same TYPE ${A.type} as preload hint #${B}`
                  });
                }
            },
            "rendition-report"() {
              const M = $i(p.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(M);
              const A = this.manifest.renditionReports.length - 1, L = ["LAST-MSN", "URI"];
              o && L.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${A}`, p.attributes, L);
            },
            "part-inf"() {
              this.manifest.partInf = $i(p.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", p.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), y0.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push($i(p.attributes));
              const M = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${M}`, p.attributes, ["ID", "START-DATE"]);
              const A = this.manifest.dateRanges[M];
              A.endDate && A.startDate && new Date(A.endDate) < new Date(A.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), A.duration && A.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), A.plannedDuration && A.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const L = !!A.endOnNext;
              if (L && !A.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), L && (A.duration || A.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), A.duration && A.endDate) {
                const B = A.startDate.getTime() + A.duration * 1e3;
                this.manifest.dateRanges[M].endDate = new Date(B);
              }
              if (!x[A.id])
                x[A.id] = A;
              else {
                for (const B in x[A.id])
                  if (A[B] && JSON.stringify(x[A.id][B]) !== JSON.stringify(A[B])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const D = this.manifest.dateRanges.findIndex((B) => B.id === A.id);
                this.manifest.dateRanges[D] = Jt(this.manifest.dateRanges[D], A), x[A.id] = Jt(x[A.id], A), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = $i(p.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", p.attributes, ["SERVER-URI"]);
            },
            /** @this {Parser} */
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const M = (A, L) => {
                if (A in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${A}`
                  });
                  return;
                }
                this.manifest.definitions[A] = L;
              };
              if ("QUERYPARAM" in p.attributes) {
                if ("NAME" in p.attributes || "IMPORT" in p.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const A = this.params.get(p.attributes.QUERYPARAM);
                if (!A) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${p.attributes.QUERYPARAM}`
                  });
                  return;
                }
                M(p.attributes.QUERYPARAM, decodeURIComponent(A));
                return;
              }
              if ("NAME" in p.attributes) {
                if ("IMPORT" in p.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in p.attributes) || typeof p.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${p.attributes.NAME}`
                  });
                  return;
                }
                M(p.attributes.NAME, p.attributes.VALUE);
                return;
              }
              if ("IMPORT" in p.attributes) {
                if (!this.mainDefinitions[p.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${p.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                M(p.attributes.IMPORT, this.mainDefinitions[p.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: p.attributes,
                uri: p.uri,
                timeline: f
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", p.attributes, ["BANDWIDTH", "URI"]);
            }
          }[p.tagType] || l).call(n);
        },
        uri() {
          i.uri = p.uri, a.push(i), this.manifest.targetDuration && !("duration" in i) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), i.duration = this.manifest.targetDuration), s && (i.key = s), i.timeline = f, r && (i.map = r), _ = 0, this.lastProgramDateTime !== null && (i.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += i.duration * 1e3), i = {};
        },
        comment() {
        },
        custom() {
          p.segment ? (i.custom = i.custom || {}, i.custom[p.customType] = p.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[p.customType] = p.data);
        }
      })[p.type].call(n);
    });
  }
  requiredCompatibilityversion(e, n) {
    (e < n || !e) && this.trigger("warn", {
      message: `manifest must be at least version ${n}`
    });
  }
  warnOnMissingAttributes_(e, n, a) {
    const i = [];
    a.forEach(function(r) {
      n.hasOwnProperty(r) || i.push(r);
    }), i.length && this.trigger("warn", {
      message: `${e} lacks required attribute(s): ${i.join(", ")}`
    });
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */
  push(e) {
    this.lineStream.push(e);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser(e) {
    this.parseStream.addParser(e);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper(e) {
    this.parseStream.addTagMapper(e);
  }
}
var Ar = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, wJ = ["video", "audio", "text"], kg = ["Video", "Audio", "Text"], l5 = function(e) {
  return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(n, a, i) {
    var r = ("00" + Number(a).toString(16)).slice(-2), s = ("00" + Number(i).toString(16)).slice(-2);
    return "avc1." + r + "00" + s;
  });
}, ja = function(e) {
  e === void 0 && (e = "");
  var n = e.split(","), a = [];
  return n.forEach(function(i) {
    i = i.trim();
    var r;
    wJ.forEach(function(s) {
      var o = Ar[s].exec(i.toLowerCase());
      if (!(!o || o.length <= 1)) {
        r = s;
        var l = i.substring(0, o[1].length), c = i.replace(l, "");
        a.push({
          type: l,
          details: c,
          mediaType: s
        });
      }
    }), r || a.push({
      type: i,
      details: "",
      mediaType: "unknown"
    });
  }), a;
}, kJ = function(e, n) {
  if (!e.mediaGroups.AUDIO || !n)
    return null;
  var a = e.mediaGroups.AUDIO[n];
  if (!a)
    return null;
  for (var i in a) {
    var r = a[i];
    if (r.default && r.playlists)
      return ja(r.playlists[0].attributes.CODECS);
  }
  return null;
}, c5 = function(e) {
  return e === void 0 && (e = ""), Ar.audio.test(e.trim().toLowerCase());
}, SJ = function(e) {
  return e === void 0 && (e = ""), Ar.text.test(e.trim().toLowerCase());
}, Bs = function(e) {
  if (!(!e || typeof e != "string")) {
    var n = e.toLowerCase().split(",").map(function(r) {
      return l5(r.trim());
    }), a = "video";
    n.length === 1 && c5(n[0]) ? a = "audio" : n.length === 1 && SJ(n[0]) && (a = "application");
    var i = "mp4";
    return n.every(function(r) {
      return Ar.mp4.test(r);
    }) ? i = "mp4" : n.every(function(r) {
      return Ar.webm.test(r);
    }) ? i = "webm" : n.every(function(r) {
      return Ar.ogg.test(r);
    }) && (i = "ogg"), a + "/" + i + ';codecs="' + e + '"';
  }
}, ll = function(e, n) {
  return e === void 0 && (e = ""), n === void 0 && (n = !1), Y.MediaSource && Y.MediaSource.isTypeSupported && Y.MediaSource.isTypeSupported(Bs(e)) || n && Y.ManagedMediaSource && Y.ManagedMediaSource.isTypeSupported && Y.ManagedMediaSource.isTypeSupported(Bs(e)) || !1;
}, _0 = function(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(n) {
    n = n.trim();
    for (var a = 0; a < kg.length; a++) {
      var i = kg[a];
      if (Ar["muxer" + i].test(n))
        return !0;
    }
    return !1;
  });
}, Sg = "mp4a.40.2", CJ = "avc1.4d400d", AJ = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, EJ = /^application\/dash\+xml/i, u5 = function(e) {
  return AJ.test(e) ? "hls" : EJ.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, LJ = function(e) {
  return e.toString(2).length;
}, DJ = function(e) {
  return Math.ceil(LJ(e) / 8);
}, d5 = function(e) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
}, IJ = function(e) {
  return d5(e);
}, Ze = function(e) {
  return e instanceof Uint8Array ? e : (!Array.isArray(e) && !IJ(e) && !(e instanceof ArrayBuffer) && (typeof e != "number" || typeof e == "number" && e !== e ? e = 0 : e = [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
}, Tn = Y.BigInt || Number, lh = [Tn("0x1"), Tn("0x100"), Tn("0x10000"), Tn("0x1000000"), Tn("0x100000000"), Tn("0x10000000000"), Tn("0x1000000000000"), Tn("0x100000000000000"), Tn("0x10000000000000000")];
(function() {
  var t = new Uint16Array([65484]), e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  return e[0] === 255 ? "big" : e[0] === 204 ? "little" : "unknown";
})();
var MJ = function(e, n) {
  var a = n === void 0 ? {} : n, i = a.signed, r = i === void 0 ? !1 : i, s = a.le, o = s === void 0 ? !1 : s;
  e = Ze(e);
  var l = o ? "reduce" : "reduceRight", c = e[l] ? e[l] : Array.prototype[l], d = c.call(e, function(g, _, x) {
    var p = o ? x : Math.abs(x + 1 - e.length);
    return g + Tn(_) * lh[p];
  }, Tn(0));
  if (r) {
    var f = lh[e.length] / Tn(2) - Tn(1);
    d = Tn(d), d > f && (d -= f, d -= f, d -= Tn(2));
  }
  return Number(d);
}, OJ = function(e, n) {
  var a = {}, i = a.le, r = i === void 0 ? !1 : i;
  (typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = Tn(e);
  for (var s = DJ(e), o = new Uint8Array(new ArrayBuffer(s)), l = 0; l < s; l++) {
    var c = r ? l : Math.abs(l + 1 - o.length);
    o[c] = Number(e / lh[l] & Tn(255)), e < 0 && (o[c] = Math.abs(~o[c]), o[c] -= l === 0 ? 1 : 2);
  }
  return o;
}, h5 = function(e, n) {
  if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string")
    return new Uint8Array();
  n || (e = unescape(encodeURIComponent(e)));
  for (var a = new Uint8Array(e.length), i = 0; i < e.length; i++)
    a[i] = e.charCodeAt(i);
  return a;
}, PJ = function() {
  for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++)
    n[a] = arguments[a];
  if (n = n.filter(function(o) {
    return o && (o.byteLength || o.length) && typeof o != "string";
  }), n.length <= 1)
    return Ze(n[0]);
  var i = n.reduce(function(o, l, c) {
    return o + (l.byteLength || l.length);
  }, 0), r = new Uint8Array(i), s = 0;
  return n.forEach(function(o) {
    o = Ze(o), r.set(o, s), s += o.byteLength;
  }), r;
}, Bt = function(e, n, a) {
  var i = a === void 0 ? {} : a, r = i.offset, s = r === void 0 ? 0 : r, o = i.mask, l = o === void 0 ? [] : o;
  e = Ze(e), n = Ze(n);
  var c = n.every ? n.every : Array.prototype.every;
  return n.length && e.length - s >= n.length && // ie 11 doesn't support every on uin8
  c.call(n, function(d, f) {
    var g = l[f] ? l[f] & e[s + f] : e[s + f];
    return d === g;
  });
}, BJ = function(e, n, a) {
  n.forEach(function(i) {
    for (var r in e.mediaGroups[i])
      for (var s in e.mediaGroups[i][r]) {
        var o = e.mediaGroups[i][r][s];
        a(o, i, r, s);
      }
  });
}, or = {}, Li = {};
function RJ(t, e, n) {
  if (n === void 0 && (n = Array.prototype), t && typeof n.find == "function")
    return n.find.call(t, e);
  for (var a = 0; a < t.length; a++)
    if (Object.prototype.hasOwnProperty.call(t, a)) {
      var i = t[a];
      if (e.call(void 0, i, a, t))
        return i;
    }
}
function $f(t, e) {
  return e === void 0 && (e = Object), e && typeof e.freeze == "function" ? e.freeze(t) : t;
}
function NJ(t, e) {
  if (t === null || typeof t != "object")
    throw new TypeError("target is not an object");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
var f5 = $f({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(t) {
    return t === f5.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), p5 = $f({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(t) {
    return t === p5.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
Li.assign = NJ;
Li.find = RJ;
Li.freeze = $f;
Li.MIME_TYPE = f5;
Li.NAMESPACE = p5;
var m5 = Li, ei = m5.find, wl = m5.NAMESPACE;
function $J(t) {
  return t !== "";
}
function FJ(t) {
  return t ? t.split(/[\t\n\f\r ]+/).filter($J) : [];
}
function zJ(t, e) {
  return t.hasOwnProperty(e) || (t[e] = !0), t;
}
function Cg(t) {
  if (!t) return [];
  var e = FJ(t);
  return Object.keys(e.reduce(zJ, {}));
}
function UJ(t) {
  return function(e) {
    return t && t.indexOf(e) !== -1;
  };
}
function zl(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function ta(t, e) {
  var n = t.prototype;
  if (!(n instanceof e)) {
    let a = function() {
    };
    a.prototype = e.prototype, a = new a(), zl(n, a), t.prototype = n = a;
  }
  n.constructor != t && (typeof t != "function" && console.error("unknown Class:" + t), n.constructor = t);
}
var na = {}, Oa = na.ELEMENT_NODE = 1, Rs = na.ATTRIBUTE_NODE = 2, uu = na.TEXT_NODE = 3, g5 = na.CDATA_SECTION_NODE = 4, b5 = na.ENTITY_REFERENCE_NODE = 5, HJ = na.ENTITY_NODE = 6, v5 = na.PROCESSING_INSTRUCTION_NODE = 7, y5 = na.COMMENT_NODE = 8, _5 = na.DOCUMENT_NODE = 9, x5 = na.DOCUMENT_TYPE_NODE = 10, ki = na.DOCUMENT_FRAGMENT_NODE = 11, YJ = na.NOTATION_NODE = 12, In = {}, yn = {};
In.INDEX_SIZE_ERR = (yn[1] = "Index size error", 1);
In.DOMSTRING_SIZE_ERR = (yn[2] = "DOMString size error", 2);
var Gn = In.HIERARCHY_REQUEST_ERR = (yn[3] = "Hierarchy request error", 3);
In.WRONG_DOCUMENT_ERR = (yn[4] = "Wrong document", 4);
In.INVALID_CHARACTER_ERR = (yn[5] = "Invalid character", 5);
In.NO_DATA_ALLOWED_ERR = (yn[6] = "No data allowed", 6);
In.NO_MODIFICATION_ALLOWED_ERR = (yn[7] = "No modification allowed", 7);
var T5 = In.NOT_FOUND_ERR = (yn[8] = "Not found", 8);
In.NOT_SUPPORTED_ERR = (yn[9] = "Not supported", 9);
var Ag = In.INUSE_ATTRIBUTE_ERR = (yn[10] = "Attribute in use", 10);
In.INVALID_STATE_ERR = (yn[11] = "Invalid state", 11);
In.SYNTAX_ERR = (yn[12] = "Syntax error", 12);
In.INVALID_MODIFICATION_ERR = (yn[13] = "Invalid modification", 13);
In.NAMESPACE_ERR = (yn[14] = "Invalid namespace", 14);
In.INVALID_ACCESS_ERR = (yn[15] = "Invalid access", 15);
function Qt(t, e) {
  if (e instanceof Error)
    var n = e;
  else
    n = this, Error.call(this, yn[t]), this.message = yn[t], Error.captureStackTrace && Error.captureStackTrace(this, Qt);
  return n.code = t, e && (this.message = this.message + ": " + e), n;
}
Qt.prototype = Error.prototype;
zl(In, Qt);
function _i() {
}
_i.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(t) {
    return t >= 0 && t < this.length ? this[t] : null;
  },
  toString: function(t, e) {
    for (var n = [], a = 0; a < this.length; a++)
      hs(this[a], n, t, e);
    return n.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(t) {
    return Array.prototype.filter.call(this, t);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(t) {
    return Array.prototype.indexOf.call(this, t);
  }
};
function Ns(t, e) {
  this._node = t, this._refresh = e, Ff(this);
}
function Ff(t) {
  var e = t._node._inc || t._node.ownerDocument._inc;
  if (t._inc !== e) {
    var n = t._refresh(t._node);
    if (P5(t, "length", n.length), !t.$$length || n.length < t.$$length)
      for (var a = n.length; a in t; a++)
        Object.prototype.hasOwnProperty.call(t, a) && delete t[a];
    zl(n, t), t._inc = e;
  }
}
Ns.prototype.item = function(t) {
  return Ff(this), this[t] || null;
};
ta(Ns, _i);
function du() {
}
function w5(t, e) {
  for (var n = t.length; n--; )
    if (t[n] === e)
      return n;
}
function Eg(t, e, n, a) {
  if (a ? e[w5(e, a)] = n : e[e.length++] = n, t) {
    n.ownerElement = t;
    var i = t.ownerDocument;
    i && (a && C5(i, t, a), jJ(i, t, n));
  }
}
function Lg(t, e, n) {
  var a = w5(e, n);
  if (a >= 0) {
    for (var i = e.length - 1; a < i; )
      e[a] = e[++a];
    if (e.length = i, t) {
      var r = t.ownerDocument;
      r && (C5(r, t, n), n.ownerElement = null);
    }
  } else
    throw new Qt(T5, new Error(t.tagName + "@" + n));
}
du.prototype = {
  length: 0,
  item: _i.prototype.item,
  getNamedItem: function(t) {
    for (var e = this.length; e--; ) {
      var n = this[e];
      if (n.nodeName == t)
        return n;
    }
  },
  setNamedItem: function(t) {
    var e = t.ownerElement;
    if (e && e != this._ownerElement)
      throw new Qt(Ag);
    var n = this.getNamedItem(t.nodeName);
    return Eg(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  setNamedItemNS: function(t) {
    var e = t.ownerElement, n;
    if (e && e != this._ownerElement)
      throw new Qt(Ag);
    return n = this.getNamedItemNS(t.namespaceURI, t.localName), Eg(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  removeNamedItem: function(t) {
    var e = this.getNamedItem(t);
    return Lg(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(t, e) {
    var n = this.getNamedItemNS(t, e);
    return Lg(this._ownerElement, this, n), n;
  },
  getNamedItemNS: function(t, e) {
    for (var n = this.length; n--; ) {
      var a = this[n];
      if (a.localName == e && a.namespaceURI == t)
        return a;
    }
    return null;
  }
};
function k5() {
}
k5.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(t, e) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(t, e, n) {
    var a = new Ul();
    if (a.implementation = this, a.childNodes = new _i(), a.doctype = n || null, n && a.appendChild(n), e) {
      var i = a.createElementNS(t, e);
      a.appendChild(i);
    }
    return a;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(t, e, n) {
    var a = new sd();
    return a.name = t, a.nodeName = t, a.publicId = e || "", a.systemId = n || "", a;
  }
};
function xt() {
}
xt.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(t, e) {
    return hu(this, t, e);
  },
  replaceChild: function(t, e) {
    hu(this, t, e, E5), e && this.removeChild(e);
  },
  removeChild: function(t) {
    return A5(this, t);
  },
  appendChild: function(t) {
    return this.insertBefore(t, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(t) {
    return ch(this.ownerDocument || this, this, t);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var t = this.firstChild; t; ) {
      var e = t.nextSibling;
      e && e.nodeType == uu && t.nodeType == uu ? (this.removeChild(e), t.appendData(e.data)) : (t.normalize(), t = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(t, e) {
    return this.ownerDocument.implementation.hasFeature(t, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n) {
        for (var a in n)
          if (Object.prototype.hasOwnProperty.call(n, a) && n[a] === t)
            return a;
      }
      e = e.nodeType == Rs ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n && Object.prototype.hasOwnProperty.call(n, t))
        return n[t];
      e = e.nodeType == Rs ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(t) {
    var e = this.lookupPrefix(t);
    return e == null;
  }
};
function S5(t) {
  return t == "<" && "&lt;" || t == ">" && "&gt;" || t == "&" && "&amp;" || t == '"' && "&quot;" || "&#" + t.charCodeAt() + ";";
}
zl(na, xt);
zl(na, xt.prototype);
function kl(t, e) {
  if (e(t))
    return !0;
  if (t = t.firstChild)
    do
      if (kl(t, e))
        return !0;
    while (t = t.nextSibling);
}
function Ul() {
  this.ownerDocument = this;
}
function jJ(t, e, n) {
  t && t._inc++;
  var a = n.namespaceURI;
  a === wl.XMLNS && (e._nsMap[n.prefix ? n.localName : ""] = n.value);
}
function C5(t, e, n, a) {
  t && t._inc++;
  var i = n.namespaceURI;
  i === wl.XMLNS && delete e._nsMap[n.prefix ? n.localName : ""];
}
function zf(t, e, n) {
  if (t && t._inc) {
    t._inc++;
    var a = e.childNodes;
    if (n)
      a[a.length++] = n;
    else {
      for (var i = e.firstChild, r = 0; i; )
        a[r++] = i, i = i.nextSibling;
      a.length = r, delete a[a.length];
    }
  }
}
function A5(t, e) {
  var n = e.previousSibling, a = e.nextSibling;
  return n ? n.nextSibling = a : t.firstChild = a, a ? a.previousSibling = n : t.lastChild = n, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, zf(t.ownerDocument, t), e;
}
function VJ(t) {
  return t && (t.nodeType === xt.DOCUMENT_NODE || t.nodeType === xt.DOCUMENT_FRAGMENT_NODE || t.nodeType === xt.ELEMENT_NODE);
}
function qJ(t) {
  return t && (ti(t) || Uf(t) || Si(t) || t.nodeType === xt.DOCUMENT_FRAGMENT_NODE || t.nodeType === xt.COMMENT_NODE || t.nodeType === xt.PROCESSING_INSTRUCTION_NODE);
}
function Si(t) {
  return t && t.nodeType === xt.DOCUMENT_TYPE_NODE;
}
function ti(t) {
  return t && t.nodeType === xt.ELEMENT_NODE;
}
function Uf(t) {
  return t && t.nodeType === xt.TEXT_NODE;
}
function Dg(t, e) {
  var n = t.childNodes || [];
  if (ei(n, ti) || Si(e))
    return !1;
  var a = ei(n, Si);
  return !(e && a && n.indexOf(a) > n.indexOf(e));
}
function Ig(t, e) {
  var n = t.childNodes || [];
  function a(r) {
    return ti(r) && r !== e;
  }
  if (ei(n, a))
    return !1;
  var i = ei(n, Si);
  return !(e && i && n.indexOf(i) > n.indexOf(e));
}
function WJ(t, e, n) {
  if (!VJ(t))
    throw new Qt(Gn, "Unexpected parent node type " + t.nodeType);
  if (n && n.parentNode !== t)
    throw new Qt(T5, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !qJ(e) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    Si(e) && t.nodeType !== xt.DOCUMENT_NODE
  )
    throw new Qt(
      Gn,
      "Unexpected node type " + e.nodeType + " for parent node type " + t.nodeType
    );
}
function GJ(t, e, n) {
  var a = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === xt.DOCUMENT_FRAGMENT_NODE) {
    var r = i.filter(ti);
    if (r.length > 1 || ei(i, Uf))
      throw new Qt(Gn, "More than one element or text in fragment");
    if (r.length === 1 && !Dg(t, n))
      throw new Qt(Gn, "Element in fragment can not be inserted before doctype");
  }
  if (ti(e) && !Dg(t, n))
    throw new Qt(Gn, "Only one element can be added and only after doctype");
  if (Si(e)) {
    if (ei(a, Si))
      throw new Qt(Gn, "Only one doctype is allowed");
    var s = ei(a, ti);
    if (n && a.indexOf(s) < a.indexOf(n))
      throw new Qt(Gn, "Doctype can only be inserted before an element");
    if (!n && s)
      throw new Qt(Gn, "Doctype can not be appended since element is present");
  }
}
function E5(t, e, n) {
  var a = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === xt.DOCUMENT_FRAGMENT_NODE) {
    var r = i.filter(ti);
    if (r.length > 1 || ei(i, Uf))
      throw new Qt(Gn, "More than one element or text in fragment");
    if (r.length === 1 && !Ig(t, n))
      throw new Qt(Gn, "Element in fragment can not be inserted before doctype");
  }
  if (ti(e) && !Ig(t, n))
    throw new Qt(Gn, "Only one element can be added and only after doctype");
  if (Si(e)) {
    if (ei(a, function(l) {
      return Si(l) && l !== n;
    }))
      throw new Qt(Gn, "Only one doctype is allowed");
    var s = ei(a, ti);
    if (n && a.indexOf(s) < a.indexOf(n))
      throw new Qt(Gn, "Doctype can only be inserted before an element");
  }
}
function hu(t, e, n, a) {
  WJ(t, e, n), t.nodeType === xt.DOCUMENT_NODE && (a || GJ)(t, e, n);
  var i = e.parentNode;
  if (i && i.removeChild(e), e.nodeType === ki) {
    var r = e.firstChild;
    if (r == null)
      return e;
    var s = e.lastChild;
  } else
    r = s = e;
  var o = n ? n.previousSibling : t.lastChild;
  r.previousSibling = o, s.nextSibling = n, o ? o.nextSibling = r : t.firstChild = r, n == null ? t.lastChild = s : n.previousSibling = s;
  do
    r.parentNode = t;
  while (r !== s && (r = r.nextSibling));
  return zf(t.ownerDocument || t, t), e.nodeType == ki && (e.firstChild = e.lastChild = null), e;
}
function XJ(t, e) {
  return e.parentNode && e.parentNode.removeChild(e), e.parentNode = t, e.previousSibling = t.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : t.firstChild = e, t.lastChild = e, zf(t.ownerDocument, t, e), e;
}
Ul.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: _5,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(t, e) {
    if (t.nodeType == ki) {
      for (var n = t.firstChild; n; ) {
        var a = n.nextSibling;
        this.insertBefore(n, e), n = a;
      }
      return t;
    }
    return hu(this, t, e), t.ownerDocument = this, this.documentElement === null && t.nodeType === Oa && (this.documentElement = t), t;
  },
  removeChild: function(t) {
    return this.documentElement == t && (this.documentElement = null), A5(this, t);
  },
  replaceChild: function(t, e) {
    hu(this, t, e, E5), t.ownerDocument = this, e && this.removeChild(e), ti(t) && (this.documentElement = t);
  },
  // Introduced in DOM Level 2:
  importNode: function(t, e) {
    return O5(this, t, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(t) {
    var e = null;
    return kl(this.documentElement, function(n) {
      if (n.nodeType == Oa && n.getAttribute("id") == t)
        return e = n, !0;
    }), e;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(t) {
    var e = Cg(t);
    return new Ns(this, function(n) {
      var a = [];
      return e.length > 0 && kl(n.documentElement, function(i) {
        if (i !== n && i.nodeType === Oa) {
          var r = i.getAttribute("class");
          if (r) {
            var s = t === r;
            if (!s) {
              var o = Cg(r);
              s = e.every(UJ(o));
            }
            s && a.push(i);
          }
        }
      }), a;
    });
  },
  //document factory method:
  createElement: function(t) {
    var e = new Rr();
    e.ownerDocument = this, e.nodeName = t, e.tagName = t, e.localName = t, e.childNodes = new _i();
    var n = e.attributes = new du();
    return n._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var t = new od();
    return t.ownerDocument = this, t.childNodes = new _i(), t;
  },
  createTextNode: function(t) {
    var e = new Hf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createComment: function(t) {
    var e = new Yf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createCDATASection: function(t) {
    var e = new jf();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createProcessingInstruction: function(t, e) {
    var n = new qf();
    return n.ownerDocument = this, n.tagName = n.nodeName = n.target = t, n.nodeValue = n.data = e, n;
  },
  createAttribute: function(t) {
    var e = new fu();
    return e.ownerDocument = this, e.name = t, e.nodeName = t, e.localName = t, e.specified = !0, e;
  },
  createEntityReference: function(t) {
    var e = new Vf();
    return e.ownerDocument = this, e.nodeName = t, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(t, e) {
    var n = new Rr(), a = e.split(":"), i = n.attributes = new du();
    return n.childNodes = new _i(), n.ownerDocument = this, n.nodeName = e, n.tagName = e, n.namespaceURI = t, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, i._ownerElement = n, n;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(t, e) {
    var n = new fu(), a = e.split(":");
    return n.ownerDocument = this, n.nodeName = e, n.name = e, n.namespaceURI = t, n.specified = !0, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, n;
  }
};
ta(Ul, xt);
function Rr() {
  this._nsMap = {};
}
Rr.prototype = {
  nodeType: Oa,
  hasAttribute: function(t) {
    return this.getAttributeNode(t) != null;
  },
  getAttribute: function(t) {
    var e = this.getAttributeNode(t);
    return e && e.value || "";
  },
  getAttributeNode: function(t) {
    return this.attributes.getNamedItem(t);
  },
  setAttribute: function(t, e) {
    var n = this.ownerDocument.createAttribute(t);
    n.value = n.nodeValue = "" + e, this.setAttributeNode(n);
  },
  removeAttribute: function(t) {
    var e = this.getAttributeNode(t);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(t) {
    return t.nodeType === ki ? this.insertBefore(t, null) : XJ(this, t);
  },
  setAttributeNode: function(t) {
    return this.attributes.setNamedItem(t);
  },
  setAttributeNodeNS: function(t) {
    return this.attributes.setNamedItemNS(t);
  },
  removeAttributeNode: function(t) {
    return this.attributes.removeNamedItem(t.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    n && this.removeAttributeNode(n);
  },
  hasAttributeNS: function(t, e) {
    return this.getAttributeNodeNS(t, e) != null;
  },
  getAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    return n && n.value || "";
  },
  setAttributeNS: function(t, e, n) {
    var a = this.ownerDocument.createAttributeNS(t, e);
    a.value = a.nodeValue = "" + n, this.setAttributeNode(a);
  },
  getAttributeNodeNS: function(t, e) {
    return this.attributes.getNamedItemNS(t, e);
  },
  getElementsByTagName: function(t) {
    return new Ns(this, function(e) {
      var n = [];
      return kl(e, function(a) {
        a !== e && a.nodeType == Oa && (t === "*" || a.tagName == t) && n.push(a);
      }), n;
    });
  },
  getElementsByTagNameNS: function(t, e) {
    return new Ns(this, function(n) {
      var a = [];
      return kl(n, function(i) {
        i !== n && i.nodeType === Oa && (t === "*" || i.namespaceURI === t) && (e === "*" || i.localName == e) && a.push(i);
      }), a;
    });
  }
};
Ul.prototype.getElementsByTagName = Rr.prototype.getElementsByTagName;
Ul.prototype.getElementsByTagNameNS = Rr.prototype.getElementsByTagNameNS;
ta(Rr, xt);
function fu() {
}
fu.prototype.nodeType = Rs;
ta(fu, xt);
function Hl() {
}
Hl.prototype = {
  data: "",
  substringData: function(t, e) {
    return this.data.substring(t, t + e);
  },
  appendData: function(t) {
    t = this.data + t, this.nodeValue = this.data = t, this.length = t.length;
  },
  insertData: function(t, e) {
    this.replaceData(t, 0, e);
  },
  appendChild: function(t) {
    throw new Error(yn[Gn]);
  },
  deleteData: function(t, e) {
    this.replaceData(t, e, "");
  },
  replaceData: function(t, e, n) {
    var a = this.data.substring(0, t), i = this.data.substring(t + e);
    n = a + n + i, this.nodeValue = this.data = n, this.length = n.length;
  }
};
ta(Hl, xt);
function Hf() {
}
Hf.prototype = {
  nodeName: "#text",
  nodeType: uu,
  splitText: function(t) {
    var e = this.data, n = e.substring(t);
    e = e.substring(0, t), this.data = this.nodeValue = e, this.length = e.length;
    var a = this.ownerDocument.createTextNode(n);
    return this.parentNode && this.parentNode.insertBefore(a, this.nextSibling), a;
  }
};
ta(Hf, Hl);
function Yf() {
}
Yf.prototype = {
  nodeName: "#comment",
  nodeType: y5
};
ta(Yf, Hl);
function jf() {
}
jf.prototype = {
  nodeName: "#cdata-section",
  nodeType: g5
};
ta(jf, Hl);
function sd() {
}
sd.prototype.nodeType = x5;
ta(sd, xt);
function L5() {
}
L5.prototype.nodeType = YJ;
ta(L5, xt);
function D5() {
}
D5.prototype.nodeType = HJ;
ta(D5, xt);
function Vf() {
}
Vf.prototype.nodeType = b5;
ta(Vf, xt);
function od() {
}
od.prototype.nodeName = "#document-fragment";
od.prototype.nodeType = ki;
ta(od, xt);
function qf() {
}
qf.prototype.nodeType = v5;
ta(qf, xt);
function I5() {
}
I5.prototype.serializeToString = function(t, e, n) {
  return M5.call(t, e, n);
};
xt.prototype.toString = M5;
function M5(t, e) {
  var n = [], a = this.nodeType == 9 && this.documentElement || this, i = a.prefix, r = a.namespaceURI;
  if (r && i == null) {
    var i = a.lookupPrefix(r);
    if (i == null)
      var s = [
        { namespace: r, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return hs(this, n, t, e, s), n.join("");
}
function Mg(t, e, n) {
  var a = t.prefix || "", i = t.namespaceURI;
  if (!i || a === "xml" && i === wl.XML || i === wl.XMLNS)
    return !1;
  for (var r = n.length; r--; ) {
    var s = n[r];
    if (s.prefix === a)
      return s.namespace !== i;
  }
  return !0;
}
function x0(t, e, n) {
  t.push(" ", e, '="', n.replace(/[<>&"\t\n\r]/g, S5), '"');
}
function hs(t, e, n, a, i) {
  if (i || (i = []), a)
    if (t = a(t), t) {
      if (typeof t == "string") {
        e.push(t);
        return;
      }
    } else
      return;
  switch (t.nodeType) {
    case Oa:
      var r = t.attributes, s = r.length, C = t.firstChild, o = t.tagName;
      n = wl.isHTML(t.namespaceURI) || n;
      var l = o;
      if (!n && !t.prefix && t.namespaceURI) {
        for (var c, d = 0; d < r.length; d++)
          if (r.item(d).name === "xmlns") {
            c = r.item(d).value;
            break;
          }
        if (!c)
          for (var f = i.length - 1; f >= 0; f--) {
            var g = i[f];
            if (g.prefix === "" && g.namespace === t.namespaceURI) {
              c = g.namespace;
              break;
            }
          }
        if (c !== t.namespaceURI)
          for (var f = i.length - 1; f >= 0; f--) {
            var g = i[f];
            if (g.namespace === t.namespaceURI) {
              g.prefix && (l = g.prefix + ":" + o);
              break;
            }
          }
      }
      e.push("<", l);
      for (var _ = 0; _ < s; _++) {
        var x = r.item(_);
        x.prefix == "xmlns" ? i.push({ prefix: x.localName, namespace: x.value }) : x.nodeName == "xmlns" && i.push({ prefix: "", namespace: x.value });
      }
      for (var _ = 0; _ < s; _++) {
        var x = r.item(_);
        if (Mg(x, n, i)) {
          var p = x.prefix || "", w = x.namespaceURI;
          x0(e, p ? "xmlns:" + p : "xmlns", w), i.push({ prefix: p, namespace: w });
        }
        hs(x, e, n, a, i);
      }
      if (o === l && Mg(t, n, i)) {
        var p = t.prefix || "", w = t.namespaceURI;
        x0(e, p ? "xmlns:" + p : "xmlns", w), i.push({ prefix: p, namespace: w });
      }
      if (C || n && !/^(?:meta|link|img|br|hr|input)$/i.test(o)) {
        if (e.push(">"), n && /^script$/i.test(o))
          for (; C; )
            C.data ? e.push(C.data) : hs(C, e, n, a, i.slice()), C = C.nextSibling;
        else
          for (; C; )
            hs(C, e, n, a, i.slice()), C = C.nextSibling;
        e.push("</", l, ">");
      } else
        e.push("/>");
      return;
    case _5:
    case ki:
      for (var C = t.firstChild; C; )
        hs(C, e, n, a, i.slice()), C = C.nextSibling;
      return;
    case Rs:
      return x0(e, t.name, t.value);
    case uu:
      return e.push(
        t.data.replace(/[<&>]/g, S5)
      );
    case g5:
      return e.push("<![CDATA[", t.data, "]]>");
    case y5:
      return e.push("<!--", t.data, "-->");
    case x5:
      var M = t.publicId, A = t.systemId;
      if (e.push("<!DOCTYPE ", t.name), M)
        e.push(" PUBLIC ", M), A && A != "." && e.push(" ", A), e.push(">");
      else if (A && A != ".")
        e.push(" SYSTEM ", A, ">");
      else {
        var L = t.internalSubset;
        L && e.push(" [", L, "]"), e.push(">");
      }
      return;
    case v5:
      return e.push("<?", t.target, " ", t.data, "?>");
    case b5:
      return e.push("&", t.nodeName, ";");
    default:
      e.push("??", t.nodeName);
  }
}
function O5(t, e, n) {
  var a;
  switch (e.nodeType) {
    case Oa:
      a = e.cloneNode(!1), a.ownerDocument = t;
    case ki:
      break;
    case Rs:
      n = !0;
      break;
  }
  if (a || (a = e.cloneNode(!1)), a.ownerDocument = t, a.parentNode = null, n)
    for (var i = e.firstChild; i; )
      a.appendChild(O5(t, i, n)), i = i.nextSibling;
  return a;
}
function ch(t, e, n) {
  var a = new e.constructor();
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var r = e[i];
      typeof r != "object" && r != a[i] && (a[i] = r);
    }
  switch (e.childNodes && (a.childNodes = new _i()), a.ownerDocument = t, a.nodeType) {
    case Oa:
      var s = e.attributes, o = a.attributes = new du(), l = s.length;
      o._ownerElement = a;
      for (var c = 0; c < l; c++)
        a.setAttributeNode(ch(t, s.item(c), !0));
      break;
    case Rs:
      n = !0;
  }
  if (n)
    for (var d = e.firstChild; d; )
      a.appendChild(ch(t, d, n)), d = d.nextSibling;
  return a;
}
function P5(t, e, n) {
  t[e] = n;
}
try {
  if (Object.defineProperty) {
    let t = function(e) {
      switch (e.nodeType) {
        case Oa:
        case ki:
          var n = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && n.push(t(e)), e = e.nextSibling;
          return n.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(Ns.prototype, "length", {
      get: function() {
        return Ff(this), this.$$length;
      }
    }), Object.defineProperty(xt.prototype, "textContent", {
      get: function() {
        return t(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case Oa:
          case ki:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), P5 = function(e, n, a) {
      e["$$" + n] = a;
    };
  }
} catch {
}
or.DocumentType = sd;
or.DOMException = Qt;
or.DOMImplementation = k5;
or.Element = Rr;
or.Node = xt;
or.NodeList = _i;
or.XMLSerializer = I5;
var ld = {}, B5 = {};
(function(t) {
  var e = Li.freeze;
  t.XML_ENTITIES = e({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), t.HTML_ENTITIES = e({
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    AMP: "&",
    amp: "&",
    And: "⩓",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    ap: "≈",
    apacir: "⩯",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    Barwed: "⌆",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    Because: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxDL: "╗",
    boxDl: "╖",
    boxdL: "╕",
    boxdl: "┐",
    boxDR: "╔",
    boxDr: "╓",
    boxdR: "╒",
    boxdr: "┌",
    boxH: "═",
    boxh: "─",
    boxHD: "╦",
    boxHd: "╤",
    boxhD: "╥",
    boxhd: "┬",
    boxHU: "╩",
    boxHu: "╧",
    boxhU: "╨",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxUL: "╝",
    boxUl: "╜",
    boxuL: "╛",
    boxul: "┘",
    boxUR: "╚",
    boxUr: "╙",
    boxuR: "╘",
    boxur: "└",
    boxV: "║",
    boxv: "│",
    boxVH: "╬",
    boxVh: "╫",
    boxvH: "╪",
    boxvh: "┼",
    boxVL: "╣",
    boxVl: "╢",
    boxvL: "╡",
    boxvl: "┤",
    boxVR: "╠",
    boxVr: "╟",
    boxvR: "╞",
    boxvr: "├",
    bprime: "‵",
    Breve: "˘",
    breve: "˘",
    brvbar: "¦",
    Bscr: "ℬ",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    Cap: "⋒",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    CenterDot: "·",
    centerdot: "·",
    Cfr: "ℭ",
    cfr: "𝔠",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    cir: "○",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    Colon: "∷",
    colon: ":",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    Conint: "∯",
    conint: "∮",
    ContourIntegral: "∮",
    Copf: "ℂ",
    copf: "𝕔",
    coprod: "∐",
    Coproduct: "∐",
    COPY: "©",
    copy: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    Cross: "⨯",
    cross: "✗",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    Cup: "⋓",
    cup: "∪",
    cupbrcap: "⩈",
    CupCap: "≍",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    Dagger: "‡",
    dagger: "†",
    daleth: "ℸ",
    Darr: "↡",
    dArr: "⇓",
    darr: "↓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    DD: "ⅅ",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    Diamond: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    Downarrow: "⇓",
    downarrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    ecir: "≖",
    Ecirc: "Ê",
    ecirc: "ê",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    eDot: "≑",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp: " ",
    emsp13: " ",
    emsp14: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    Escr: "ℰ",
    escr: "ℯ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    ExponentialE: "ⅇ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    ForAll: "∀",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    Fscr: "ℱ",
    fscr: "𝒻",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    gE: "≧",
    ge: "≥",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    Gg: "⋙",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gl: "≷",
    gla: "⪥",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gnE: "≩",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    Gt: "≫",
    GT: ">",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    hArr: "⇔",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    Hfr: "ℌ",
    hfr: "𝔥",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    Hopf: "ℍ",
    hopf: "𝕙",
    horbar: "―",
    HorizontalLine: "─",
    Hscr: "ℋ",
    hscr: "𝒽",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    Ifr: "ℑ",
    ifr: "𝔦",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Im: "ℑ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    Int: "∬",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    Iscr: "ℐ",
    iscr: "𝒾",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    Lang: "⟪",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    Larr: "↞",
    lArr: "⇐",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    lAtail: "⤛",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lBarr: "⤎",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    lE: "≦",
    le: "≤",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    Leftarrow: "⇐",
    leftarrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    Ll: "⋘",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lnE: "≨",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftarrow: "⟵",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    Lscr: "ℒ",
    lscr: "𝓁",
    Lsh: "↰",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    Lt: "≪",
    LT: "<",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    Mscr: "ℳ",
    mscr: "𝓂",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    nearhk: "⤤",
    neArr: "⇗",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlArr: "⇍",
    nlarr: "↚",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nLeftarrow: "⇍",
    nleftarrow: "↚",
    nLeftrightarrow: "⇎",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    nopf: "𝕟",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nRightarrow: "⇏",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nVDash: "⊯",
    nVdash: "⊮",
    nvDash: "⊭",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwArr: "⇖",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    Ocirc: "Ô",
    ocirc: "ô",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    Or: "⩔",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    Otimes: "⨷",
    otimes: "⊗",
    otimesas: "⨶",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    Popf: "ℙ",
    popf: "𝕡",
    pound: "£",
    Pr: "⪻",
    pr: "≺",
    prap: "⪷",
    prcue: "≼",
    prE: "⪳",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    Prime: "″",
    prime: "′",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportion: "∷",
    Proportional: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    Qopf: "ℚ",
    qopf: "𝕢",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    QUOT: '"',
    quot: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    Rang: "⟫",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    Rarr: "↠",
    rArr: "⇒",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    rAtail: "⤜",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    RBarr: "⤐",
    rBarr: "⤏",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    Re: "ℜ",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    REG: "®",
    reg: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    Rfr: "ℜ",
    rfr: "𝔯",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    Rightarrow: "⇒",
    rightarrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    Ropf: "ℝ",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    Rscr: "ℛ",
    rscr: "𝓇",
    Rsh: "↱",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    Sc: "⪼",
    sc: "≻",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    sccue: "≽",
    scE: "⪴",
    sce: "⪰",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    searhk: "⤥",
    seArr: "⇘",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    Square: "□",
    square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    Sub: "⋐",
    sub: "⊂",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    Subset: "⋐",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    Sum: "∑",
    sum: "∑",
    sung: "♪",
    Sup: "⋑",
    sup: "⊃",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    Supset: "⋑",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swArr: "⇙",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    Therefore: "∴",
    therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    thinsp: " ",
    ThinSpace: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    Tilde: "∼",
    tilde: "˜",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    TRADE: "™",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    Uarr: "↟",
    uArr: "⇑",
    uarr: "↑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrow: "↑",
    Uparrow: "⇑",
    uparrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    updownarrow: "↕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    upsi: "υ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    vArr: "⇕",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    Vbar: "⫫",
    vBar: "⫨",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    VDash: "⊫",
    Vdash: "⊩",
    vDash: "⊨",
    vdash: "⊢",
    Vdashl: "⫦",
    Vee: "⋁",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    Verbar: "‖",
    verbar: "|",
    Vert: "‖",
    vert: "|",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    Wedge: "⋀",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    Xi: "Ξ",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    Yuml: "Ÿ",
    yuml: "ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    Zfr: "ℨ",
    zfr: "𝔷",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    Zopf: "ℤ",
    zopf: "𝕫",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  }), t.entityMap = t.HTML_ENTITIES;
})(B5);
var Wf = {}, Sl = Li.NAMESPACE, uh = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, Og = new RegExp("[\\-\\.0-9" + uh.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), Pg = new RegExp("^" + uh.source + Og.source + "*(?::" + uh.source + Og.source + "*)?$"), Uo = 0, Fi = 1, ts = 2, Ho = 3, ns = 4, as = 5, Yo = 6, Ec = 7;
function $s(t, e) {
  this.message = t, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, $s);
}
$s.prototype = new Error();
$s.prototype.name = $s.name;
function R5() {
}
R5.prototype = {
  parse: function(t, e, n) {
    var a = this.domBuilder;
    a.startDocument(), N5(e, e = {}), ZJ(
      t,
      e,
      n,
      a,
      this.errorHandler
    ), a.endDocument();
  }
};
function ZJ(t, e, n, a, i) {
  function r(X) {
    if (X > 65535) {
      X -= 65536;
      var R = 55296 + (X >> 10), de = 56320 + (X & 1023);
      return String.fromCharCode(R, de);
    } else
      return String.fromCharCode(X);
  }
  function s(X) {
    var R = X.slice(1, -1);
    return Object.hasOwnProperty.call(n, R) ? n[R] : R.charAt(0) === "#" ? r(parseInt(R.substr(1).replace("x", "0x"))) : (i.error("entity not found:" + X), X);
  }
  function o(X) {
    if (X > p) {
      var R = t.substring(p, X).replace(/&#?\w+;/g, s);
      g && l(p), a.characters(R, 0, X - p), p = X;
    }
  }
  function l(X, R) {
    for (; X >= d && (R = f.exec(t)); )
      c = R.index, d = c + R[0].length, g.lineNumber++;
    g.columnNumber = X - c + 1;
  }
  for (var c = 0, d = 0, f = /.*(?:\r\n?|\n)|.*$/g, g = a.locator, _ = [{ currentNSMap: e }], x = {}, p = 0; ; ) {
    try {
      var w = t.indexOf("<", p);
      if (w < 0) {
        if (!t.substr(p).match(/^\s*$/)) {
          var C = a.doc, M = C.createTextNode(t.substr(p));
          C.appendChild(M), a.currentElement = M;
        }
        return;
      }
      switch (w > p && o(w), t.charAt(w + 1)) {
        case "/":
          var V = t.indexOf(">", w + 3), A = t.substring(w + 2, V).replace(/[ \t\n\r]+$/g, ""), L = _.pop();
          V < 0 ? (A = t.substring(w + 2).replace(/[\s<].*/, ""), i.error("end tag name: " + A + " is not complete:" + L.tagName), V = w + 1 + A.length) : A.match(/\s</) && (A = A.replace(/[\s<].*/, ""), i.error("end tag name: " + A + " maybe not complete"), V = w + 1 + A.length);
          var D = L.localNSMap, B = L.tagName == A, P = B || L.tagName && L.tagName.toLowerCase() == A.toLowerCase();
          if (P) {
            if (a.endElement(L.uri, L.localName, A), D)
              for (var z in D)
                Object.prototype.hasOwnProperty.call(D, z) && a.endPrefixMapping(z);
            B || i.fatalError("end tag name: " + A + " is not match the current start tagName:" + L.tagName);
          } else
            _.push(L);
          V++;
          break;
        case "?":
          g && l(w), V = tee(t, w, a);
          break;
        case "!":
          g && l(w), V = eee(t, w, a, i);
          break;
        default:
          g && l(w);
          var W = new $5(), q = _[_.length - 1].currentNSMap, V = KJ(t, w, W, q, s, i), re = W.length;
          if (!W.closed && JJ(t, V, W.tagName, x) && (W.closed = !0, n.nbsp || i.warning("unclosed xml attribute")), g && re) {
            for (var ie = Bg(g, {}), K = 0; K < re; K++) {
              var $ = W[K];
              l($.offset), $.locator = Bg(g, {});
            }
            a.locator = ie, Rg(W, a, q) && _.push(W), a.locator = g;
          } else
            Rg(W, a, q) && _.push(W);
          Sl.isHTML(W.uri) && !W.closed ? V = QJ(t, V, W.tagName, s, a) : V++;
      }
    } catch (X) {
      if (X instanceof $s)
        throw X;
      i.error("element parse error: " + X), V = -1;
    }
    V > p ? p = V : o(Math.max(w, p) + 1);
  }
}
function Bg(t, e) {
  return e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber, e;
}
function KJ(t, e, n, a, i, r) {
  function s(g, _, x) {
    n.attributeNames.hasOwnProperty(g) && r.fatalError("Attribute " + g + " redefined"), n.addValue(
      g,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      _.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, i),
      x
    );
  }
  for (var o, l, c = ++e, d = Uo; ; ) {
    var f = t.charAt(c);
    switch (f) {
      case "=":
        if (d === Fi)
          o = t.slice(e, c), d = Ho;
        else if (d === ts)
          d = Ho;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (d === Ho || d === Fi)
          if (d === Fi && (r.warning('attribute value must after "="'), o = t.slice(e, c)), e = c + 1, c = t.indexOf(f, e), c > 0)
            l = t.slice(e, c), s(o, l, e - 1), d = as;
          else
            throw new Error("attribute value no end '" + f + "' match");
        else if (d == ns)
          l = t.slice(e, c), s(o, l, e), r.warning('attribute "' + o + '" missed start quot(' + f + ")!!"), e = c + 1, d = as;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (d) {
          case Uo:
            n.setTagName(t.slice(e, c));
          case as:
          case Yo:
          case Ec:
            d = Ec, n.closed = !0;
          case ns:
          case Fi:
            break;
          case ts:
            n.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return r.error("unexpected end of input"), d == Uo && n.setTagName(t.slice(e, c)), c;
      case ">":
        switch (d) {
          case Uo:
            n.setTagName(t.slice(e, c));
          case as:
          case Yo:
          case Ec:
            break;
          case ns:
          case Fi:
            l = t.slice(e, c), l.slice(-1) === "/" && (n.closed = !0, l = l.slice(0, -1));
          case ts:
            d === ts && (l = o), d == ns ? (r.warning('attribute "' + l + '" missed quot(")!'), s(o, l, e)) : ((!Sl.isHTML(a[""]) || !l.match(/^(?:disabled|checked|selected)$/i)) && r.warning('attribute "' + l + '" missed value!! "' + l + '" instead!!'), s(l, l, e));
            break;
          case Ho:
            throw new Error("attribute value missed!!");
        }
        return c;
      case "":
        f = " ";
      default:
        if (f <= " ")
          switch (d) {
            case Uo:
              n.setTagName(t.slice(e, c)), d = Yo;
              break;
            case Fi:
              o = t.slice(e, c), d = ts;
              break;
            case ns:
              var l = t.slice(e, c);
              r.warning('attribute "' + l + '" missed quot(")!!'), s(o, l, e);
            case as:
              d = Yo;
              break;
          }
        else
          switch (d) {
            case ts:
              n.tagName, (!Sl.isHTML(a[""]) || !o.match(/^(?:disabled|checked|selected)$/i)) && r.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), s(o, o, e), e = c, d = Fi;
              break;
            case as:
              r.warning('attribute space is required"' + o + '"!!');
            case Yo:
              d = Fi, e = c;
              break;
            case Ho:
              d = ns, e = c;
              break;
            case Ec:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    c++;
  }
}
function Rg(t, e, n) {
  for (var a = t.tagName, i = null, f = t.length; f--; ) {
    var r = t[f], s = r.qName, o = r.value, g = s.indexOf(":");
    if (g > 0)
      var l = r.prefix = s.slice(0, g), c = s.slice(g + 1), d = l === "xmlns" && c;
    else
      c = s, l = null, d = s === "xmlns" && "";
    r.localName = c, d !== !1 && (i == null && (i = {}, N5(n, n = {})), n[d] = i[d] = o, r.uri = Sl.XMLNS, e.startPrefixMapping(d, o));
  }
  for (var f = t.length; f--; ) {
    r = t[f];
    var l = r.prefix;
    l && (l === "xml" && (r.uri = Sl.XML), l !== "xmlns" && (r.uri = n[l || ""]));
  }
  var g = a.indexOf(":");
  g > 0 ? (l = t.prefix = a.slice(0, g), c = t.localName = a.slice(g + 1)) : (l = null, c = t.localName = a);
  var _ = t.uri = n[l || ""];
  if (e.startElement(_, c, a, t), t.closed) {
    if (e.endElement(_, c, a), i)
      for (l in i)
        Object.prototype.hasOwnProperty.call(i, l) && e.endPrefixMapping(l);
  } else
    return t.currentNSMap = n, t.localNSMap = i, !0;
}
function QJ(t, e, n, a, i) {
  if (/^(?:script|textarea)$/i.test(n)) {
    var r = t.indexOf("</" + n + ">", e), s = t.substring(e + 1, r);
    if (/[&<]/.test(s))
      return /^script$/i.test(n) ? (i.characters(s, 0, s.length), r) : (s = s.replace(/&#?\w+;/g, a), i.characters(s, 0, s.length), r);
  }
  return e + 1;
}
function JJ(t, e, n, a) {
  var i = a[n];
  return i == null && (i = t.lastIndexOf("</" + n + ">"), i < e && (i = t.lastIndexOf("</" + n)), a[n] = i), i < e;
}
function N5(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function eee(t, e, n, a) {
  var i = t.charAt(e + 2);
  switch (i) {
    case "-":
      if (t.charAt(e + 3) === "-") {
        var r = t.indexOf("-->", e + 4);
        return r > e ? (n.comment(t, e + 4, r - e - 4), r + 3) : (a.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (t.substr(e + 3, 6) == "CDATA[") {
        var r = t.indexOf("]]>", e + 9);
        return n.startCDATA(), n.characters(t, e + 9, r - e - 9), n.endCDATA(), r + 3;
      }
      var s = nee(t, e), o = s.length;
      if (o > 1 && /!doctype/i.test(s[0][0])) {
        var l = s[1][0], c = !1, d = !1;
        o > 3 && (/^public$/i.test(s[2][0]) ? (c = s[3][0], d = o > 4 && s[4][0]) : /^system$/i.test(s[2][0]) && (d = s[3][0]));
        var f = s[o - 1];
        return n.startDTD(l, c, d), n.endDTD(), f.index + f[0].length;
      }
  }
  return -1;
}
function tee(t, e, n) {
  var a = t.indexOf("?>", e);
  if (a) {
    var i = t.substring(e, a).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return i ? (i[0].length, n.processingInstruction(i[1], i[2]), a + 2) : -1;
  }
  return -1;
}
function $5() {
  this.attributeNames = {};
}
$5.prototype = {
  setTagName: function(t) {
    if (!Pg.test(t))
      throw new Error("invalid tagName:" + t);
    this.tagName = t;
  },
  addValue: function(t, e, n) {
    if (!Pg.test(t))
      throw new Error("invalid attribute:" + t);
    this.attributeNames[t] = this.length, this[this.length++] = { qName: t, value: e, offset: n };
  },
  length: 0,
  getLocalName: function(t) {
    return this[t].localName;
  },
  getLocator: function(t) {
    return this[t].locator;
  },
  getQName: function(t) {
    return this[t].qName;
  },
  getURI: function(t) {
    return this[t].uri;
  },
  getValue: function(t) {
    return this[t].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function nee(t, e) {
  var n, a = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (i.lastIndex = e, i.exec(t); n = i.exec(t); )
    if (a.push(n), n[1]) return a;
}
Wf.XMLReader = R5;
Wf.ParseError = $s;
var aee = Li, iee = or, Ng = B5, F5 = Wf, ree = iee.DOMImplementation, $g = aee.NAMESPACE, see = F5.ParseError, oee = F5.XMLReader;
function z5(t) {
  return t.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function U5(t) {
  this.options = t || { locator: {} };
}
U5.prototype.parseFromString = function(t, e) {
  var n = this.options, a = new oee(), i = n.domBuilder || new Yl(), r = n.errorHandler, s = n.locator, o = n.xmlns || {}, l = /\/x?html?$/.test(e), c = l ? Ng.HTML_ENTITIES : Ng.XML_ENTITIES;
  s && i.setDocumentLocator(s), a.errorHandler = lee(r, i, s), a.domBuilder = n.domBuilder || i, l && (o[""] = $g.HTML), o.xml = o.xml || $g.XML;
  var d = n.normalizeLineEndings || z5;
  return t && typeof t == "string" ? a.parse(
    d(t),
    o,
    c
  ) : a.errorHandler.error("invalid doc source"), i.doc;
};
function lee(t, e, n) {
  if (!t) {
    if (e instanceof Yl)
      return e;
    t = e;
  }
  var a = {}, i = t instanceof Function;
  n = n || {};
  function r(s) {
    var o = t[s];
    !o && i && (o = t.length == 2 ? function(l) {
      t(s, l);
    } : t), a[s] = o && function(l) {
      o("[xmldom " + s + "]	" + l + dh(n));
    } || function() {
    };
  }
  return r("warning"), r("error"), r("fatalError"), a;
}
function Yl() {
  this.cdata = !1;
}
function is(t, e) {
  e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber;
}
Yl.prototype = {
  startDocument: function() {
    this.doc = new ree().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(t, e, n, a) {
    var i = this.doc, r = i.createElementNS(t, n || e), s = a.length;
    Lc(this, r), this.currentElement = r, this.locator && is(this.locator, r);
    for (var o = 0; o < s; o++) {
      var t = a.getURI(o), l = a.getValue(o), n = a.getQName(o), c = i.createAttributeNS(t, n);
      this.locator && is(a.getLocator(o), c), c.value = c.nodeValue = l, r.setAttributeNode(c);
    }
  },
  endElement: function(t, e, n) {
    var a = this.currentElement;
    a.tagName, this.currentElement = a.parentNode;
  },
  startPrefixMapping: function(t, e) {
  },
  endPrefixMapping: function(t) {
  },
  processingInstruction: function(t, e) {
    var n = this.doc.createProcessingInstruction(t, e);
    this.locator && is(this.locator, n), Lc(this, n);
  },
  ignorableWhitespace: function(t, e, n) {
  },
  characters: function(t, e, n) {
    if (t = Fg.apply(this, arguments), t) {
      if (this.cdata)
        var a = this.doc.createCDATASection(t);
      else
        var a = this.doc.createTextNode(t);
      this.currentElement ? this.currentElement.appendChild(a) : /^\s*$/.test(t) && this.doc.appendChild(a), this.locator && is(this.locator, a);
    }
  },
  skippedEntity: function(t) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(t) {
    (this.locator = t) && (t.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(t, e, n) {
    t = Fg.apply(this, arguments);
    var a = this.doc.createComment(t);
    this.locator && is(this.locator, a), Lc(this, a);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(t, e, n) {
    var a = this.doc.implementation;
    if (a && a.createDocumentType) {
      var i = a.createDocumentType(t, e, n);
      this.locator && is(this.locator, i), Lc(this, i), this.doc.doctype = i;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(t) {
    console.warn("[xmldom warning]	" + t, dh(this.locator));
  },
  error: function(t) {
    console.error("[xmldom error]	" + t, dh(this.locator));
  },
  fatalError: function(t) {
    throw new see(t, this.locator);
  }
};
function dh(t) {
  if (t)
    return `
@` + (t.systemId || "") + "#[line:" + t.lineNumber + ",col:" + t.columnNumber + "]";
}
function Fg(t, e, n) {
  return typeof t == "string" ? t.substr(e, n) : t.length >= e + n || e ? new java.lang.String(t, e, n) + "" : t;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(t) {
  Yl.prototype[t] = function() {
    return null;
  };
});
function Lc(t, e) {
  t.currentElement ? t.currentElement.appendChild(e) : t.doc.appendChild(e);
}
ld.__DOMHandler = Yl;
ld.normalizeLineEndings = z5;
ld.DOMParser = U5;
var cee = ld.DOMParser;
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */
const zg = (t) => !!t && typeof t == "object", gn = (...t) => t.reduce((e, n) => (typeof n != "object" || Object.keys(n).forEach((a) => {
  Array.isArray(e[a]) && Array.isArray(n[a]) ? e[a] = e[a].concat(n[a]) : zg(e[a]) && zg(n[a]) ? e[a] = gn(e[a], n[a]) : e[a] = n[a];
}), e), {}), H5 = (t) => Object.keys(t).map((e) => t[e]), uee = (t, e) => {
  const n = [];
  for (let a = t; a < e; a++)
    n.push(a);
  return n;
}, Fs = (t) => t.reduce((e, n) => e.concat(n), []), Y5 = (t) => {
  if (!t.length)
    return [];
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push(t[n]);
  return e;
}, dee = (t, e) => t.reduce((n, a, i) => (a[e] && n.push(i), n), []), hee = (t, e) => H5(t.reduce((n, a) => (a.forEach((i) => {
  n[e(i)] = i;
}), n), {}));
var zs = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
const Cl = ({
  baseUrl: t = "",
  source: e = "",
  range: n = "",
  indexRange: a = ""
}) => {
  const i = {
    uri: e,
    resolvedUri: rd(t || "", e)
  };
  if (n || a) {
    const s = (n || a).split("-");
    let o = Y.BigInt ? Y.BigInt(s[0]) : parseInt(s[0], 10), l = Y.BigInt ? Y.BigInt(s[1]) : parseInt(s[1], 10);
    o < Number.MAX_SAFE_INTEGER && typeof o == "bigint" && (o = Number(o)), l < Number.MAX_SAFE_INTEGER && typeof l == "bigint" && (l = Number(l));
    let c;
    typeof l == "bigint" || typeof o == "bigint" ? c = Y.BigInt(l) - Y.BigInt(o) + Y.BigInt(1) : c = l - o + 1, typeof c == "bigint" && c < Number.MAX_SAFE_INTEGER && (c = Number(c)), i.byterange = {
      length: c,
      offset: o
    };
  }
  return i;
}, fee = (t) => {
  let e;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = Y.BigInt(t.offset) + Y.BigInt(t.length) - Y.BigInt(1) : e = t.offset + t.length - 1, `${t.offset}-${e}`;
}, Ug = (t) => (t && typeof t != "number" && (t = parseInt(t, 10)), isNaN(t) ? null : t), pee = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static(t) {
    const {
      duration: e,
      timescale: n = 1,
      sourceDuration: a,
      periodDuration: i
    } = t, r = Ug(t.endNumber), s = e / n;
    return typeof r == "number" ? {
      start: 0,
      end: r
    } : typeof i == "number" ? {
      start: 0,
      end: i / s
    } : {
      start: 0,
      end: a / s
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic(t) {
    const {
      NOW: e,
      clientOffset: n,
      availabilityStartTime: a,
      timescale: i = 1,
      duration: r,
      periodStart: s = 0,
      minimumUpdatePeriod: o = 0,
      timeShiftBufferDepth: l = 1 / 0
    } = t, c = Ug(t.endNumber), d = (e + n) / 1e3, f = a + s, _ = d + o - f, x = Math.ceil(_ * i / r), p = Math.floor((d - f - l) * i / r), w = Math.floor((d - f) * i / r);
    return {
      start: Math.max(0, p),
      end: typeof c == "number" ? c : Math.min(x, w)
    };
  }
}, mee = (t) => (e) => {
  const {
    duration: n,
    timescale: a = 1,
    periodStart: i,
    startNumber: r = 1
  } = t;
  return {
    number: r + e,
    duration: n / a,
    timeline: i,
    time: e * n
  };
}, Gf = (t) => {
  const {
    type: e,
    duration: n,
    timescale: a = 1,
    periodDuration: i,
    sourceDuration: r
  } = t, {
    start: s,
    end: o
  } = pee[e](t), l = uee(s, o).map(mee(t));
  if (e === "static") {
    const c = l.length - 1, d = typeof i == "number" ? i : r;
    l[c].duration = d - n / a * c;
  }
  return l;
}, j5 = (t) => {
  const {
    baseUrl: e,
    initialization: n = {},
    sourceDuration: a,
    indexRange: i = "",
    periodStart: r,
    presentationTime: s,
    number: o = 0,
    duration: l
  } = t;
  if (!e)
    throw new Error(zs.NO_BASE_URL);
  const c = Cl({
    baseUrl: e,
    source: n.sourceURL,
    range: n.range
  }), d = Cl({
    baseUrl: e,
    source: e,
    indexRange: i
  });
  if (d.map = c, l) {
    const f = Gf(t);
    f.length && (d.duration = f[0].duration, d.timeline = f[0].timeline);
  } else a && (d.duration = a, d.timeline = r);
  return d.presentationTime = s || r, d.number = o, [d];
}, Xf = (t, e, n) => {
  const a = t.sidx.map ? t.sidx.map : null, i = t.sidx.duration, r = t.timeline || 0, s = t.sidx.byterange, o = s.offset + s.length, l = e.timescale, c = e.references.filter((w) => w.referenceType !== 1), d = [], f = t.endList ? "static" : "dynamic", g = t.sidx.timeline;
  let _ = g, x = t.mediaSequence || 0, p;
  typeof e.firstOffset == "bigint" ? p = Y.BigInt(o) + e.firstOffset : p = o + e.firstOffset;
  for (let w = 0; w < c.length; w++) {
    const C = e.references[w], M = C.referencedSize, A = C.subsegmentDuration;
    let L;
    typeof p == "bigint" ? L = p + Y.BigInt(M) - Y.BigInt(1) : L = p + M - 1;
    const D = `${p}-${L}`, P = j5({
      baseUrl: n,
      timescale: l,
      timeline: r,
      periodStart: g,
      presentationTime: _,
      number: x,
      duration: A,
      sourceDuration: i,
      indexRange: D,
      type: f
    })[0];
    a && (P.map = a), d.push(P), typeof p == "bigint" ? p += Y.BigInt(M) : p += M, _ += A / l, x++;
  }
  return t.segments = d, t;
}, gee = ["AUDIO", "SUBTITLES"], bee = 1 / 60, V5 = (t) => hee(t, ({
  timeline: e
}) => e).sort((e, n) => e.timeline > n.timeline ? 1 : -1), vee = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (t[n].attributes.NAME === e)
      return t[n];
  return null;
}, Hg = (t) => {
  let e = [];
  return BJ(t, gee, (n, a, i, r) => {
    e = e.concat(n.playlists || []);
  }), e;
}, Yg = ({
  playlist: t,
  mediaSequence: e
}) => {
  t.mediaSequence = e, t.segments.forEach((n, a) => {
    n.number = t.mediaSequence + a;
  });
}, yee = ({
  oldPlaylists: t,
  newPlaylists: e,
  timelineStarts: n
}) => {
  e.forEach((a) => {
    a.discontinuitySequence = n.findIndex(function({
      timeline: l
    }) {
      return l === a.timeline;
    });
    const i = vee(t, a.attributes.NAME);
    if (!i || a.sidx)
      return;
    const r = a.segments[0], s = i.segments.findIndex(function(l) {
      return Math.abs(l.presentationTime - r.presentationTime) < bee;
    });
    if (s === -1) {
      Yg({
        playlist: a,
        mediaSequence: i.mediaSequence + i.segments.length
      }), a.segments[0].discontinuity = !0, a.discontinuityStarts.unshift(0), (!i.segments.length && a.timeline > i.timeline || i.segments.length && a.timeline > i.segments[i.segments.length - 1].timeline) && a.discontinuitySequence--;
      return;
    }
    i.segments[s].discontinuity && !r.discontinuity && (r.discontinuity = !0, a.discontinuityStarts.unshift(0), a.discontinuitySequence--), Yg({
      playlist: a,
      mediaSequence: i.segments[s].number
    });
  });
}, _ee = ({
  oldManifest: t,
  newManifest: e
}) => {
  const n = t.playlists.concat(Hg(t)), a = e.playlists.concat(Hg(e));
  return e.timelineStarts = V5([t.timelineStarts, e.timelineStarts]), yee({
    oldPlaylists: n,
    newPlaylists: a,
    timelineStarts: e.timelineStarts
  }), e;
}, cd = (t) => t && t.uri + "-" + fee(t.byterange), T0 = (t) => {
  const e = t.reduce(function(a, i) {
    return a[i.attributes.baseUrl] || (a[i.attributes.baseUrl] = []), a[i.attributes.baseUrl].push(i), a;
  }, {});
  let n = [];
  return Object.values(e).forEach((a) => {
    const i = H5(a.reduce((r, s) => {
      const o = s.attributes.id + (s.attributes.lang || "");
      return r[o] ? (s.segments && (s.segments[0] && (s.segments[0].discontinuity = !0), r[o].segments.push(...s.segments)), s.attributes.contentProtection && (r[o].attributes.contentProtection = s.attributes.contentProtection)) : (r[o] = s, r[o].attributes.timelineStarts = []), r[o].attributes.timelineStarts.push({
        // Although they represent the same number, it's important to have both to make it
        // compatible with HLS potentially having a similar attribute.
        start: s.attributes.periodStart,
        timeline: s.attributes.periodStart
      }), r;
    }, {}));
    n = n.concat(i);
  }), n.map((a) => (a.discontinuityStarts = dee(a.segments || [], "discontinuity"), a));
}, Zf = (t, e) => {
  const n = cd(t.sidx), a = n && e[n] && e[n].sidx;
  return a && Xf(t, a, t.sidx.resolvedUri), t;
}, xee = (t, e = {}) => {
  if (!Object.keys(e).length)
    return t;
  for (const n in t)
    t[n] = Zf(t[n], e);
  return t;
}, Tee = ({
  attributes: t,
  segments: e,
  sidx: n,
  mediaSequence: a,
  discontinuitySequence: i,
  discontinuityStarts: r
}, s) => {
  const o = {
    attributes: {
      NAME: t.id,
      BANDWIDTH: t.bandwidth,
      CODECS: t.codecs,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuitySequence: i,
    discontinuityStarts: r,
    timelineStarts: t.timelineStarts,
    mediaSequence: a,
    segments: e
  };
  return t.contentProtection && (o.contentProtection = t.contentProtection), t.serviceLocation && (o.attributes.serviceLocation = t.serviceLocation), n && (o.sidx = n), s && (o.attributes.AUDIO = "audio", o.attributes.SUBTITLES = "subs"), o;
}, wee = ({
  attributes: t,
  segments: e,
  mediaSequence: n,
  discontinuityStarts: a,
  discontinuitySequence: i
}) => {
  typeof e > "u" && (e = [{
    uri: t.baseUrl,
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    duration: t.sourceDuration,
    number: 0
  }], t.duration = t.sourceDuration);
  const r = {
    NAME: t.id,
    BANDWIDTH: t.bandwidth,
    "PROGRAM-ID": 1
  };
  t.codecs && (r.CODECS = t.codecs);
  const s = {
    attributes: r,
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    timelineStarts: t.timelineStarts,
    discontinuityStarts: a,
    discontinuitySequence: i,
    mediaSequence: n,
    segments: e
  };
  return t.serviceLocation && (s.attributes.serviceLocation = t.serviceLocation), s;
}, kee = (t, e = {}, n = !1) => {
  let a;
  const i = t.reduce((r, s) => {
    const o = s.attributes.role && s.attributes.role.value || "", l = s.attributes.lang || "";
    let c = s.attributes.label || "main";
    if (l && !s.attributes.label) {
      const f = o ? ` (${o})` : "";
      c = `${s.attributes.lang}${f}`;
    }
    r[c] || (r[c] = {
      language: l,
      autoselect: !0,
      default: o === "main",
      playlists: [],
      uri: ""
    });
    const d = Zf(Tee(s, n), e);
    return r[c].playlists.push(d), typeof a > "u" && o === "main" && (a = s, a.default = !0), r;
  }, {});
  if (!a) {
    const r = Object.keys(i)[0];
    i[r].default = !0;
  }
  return i;
}, See = (t, e = {}) => t.reduce((n, a) => {
  const i = a.attributes.label || a.attributes.lang || "text", r = a.attributes.lang || "und";
  return n[i] || (n[i] = {
    language: r,
    default: !1,
    autoselect: !1,
    playlists: [],
    uri: ""
  }), n[i].playlists.push(Zf(wee(a), e)), n;
}, {}), Cee = (t) => t.reduce((e, n) => (n && n.forEach((a) => {
  const {
    channel: i,
    language: r
  } = a;
  e[r] = {
    autoselect: !1,
    default: !1,
    instreamId: i,
    language: r
  }, a.hasOwnProperty("aspectRatio") && (e[r].aspectRatio = a.aspectRatio), a.hasOwnProperty("easyReader") && (e[r].easyReader = a.easyReader), a.hasOwnProperty("3D") && (e[r]["3D"] = a["3D"]);
}), e), {}), Aee = ({
  attributes: t,
  segments: e,
  sidx: n,
  discontinuityStarts: a
}) => {
  const i = {
    attributes: {
      NAME: t.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: t.width,
        height: t.height
      },
      CODECS: t.codecs,
      BANDWIDTH: t.bandwidth,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuityStarts: a,
    timelineStarts: t.timelineStarts,
    segments: e
  };
  return t.frameRate && (i.attributes["FRAME-RATE"] = t.frameRate), t.contentProtection && (i.contentProtection = t.contentProtection), t.serviceLocation && (i.attributes.serviceLocation = t.serviceLocation), n && (i.sidx = n), i;
}, Eee = ({
  attributes: t
}) => t.mimeType === "video/mp4" || t.mimeType === "video/webm" || t.contentType === "video", Lee = ({
  attributes: t
}) => t.mimeType === "audio/mp4" || t.mimeType === "audio/webm" || t.contentType === "audio", Dee = ({
  attributes: t
}) => t.mimeType === "text/vtt" || t.contentType === "text", Iee = (t, e) => {
  t.forEach((n) => {
    n.mediaSequence = 0, n.discontinuitySequence = e.findIndex(function({
      timeline: a
    }) {
      return a === n.timeline;
    }), n.segments && n.segments.forEach((a, i) => {
      a.number = i;
    });
  });
}, jg = (t) => t ? Object.keys(t).reduce((e, n) => {
  const a = t[n];
  return e.concat(a.playlists);
}, []) : [], Mee = ({
  dashPlaylists: t,
  locations: e,
  contentSteering: n,
  sidxMapping: a = {},
  previousManifest: i,
  eventStream: r
}) => {
  if (!t.length)
    return {};
  const {
    sourceDuration: s,
    type: o,
    suggestedPresentationDelay: l,
    minimumUpdatePeriod: c
  } = t[0].attributes, d = T0(t.filter(Eee)).map(Aee), f = T0(t.filter(Lee)), g = T0(t.filter(Dee)), _ = t.map((L) => L.attributes.captionServices).filter(Boolean), x = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: "",
    duration: s,
    playlists: xee(d, a)
  };
  c >= 0 && (x.minimumUpdatePeriod = c * 1e3), e && (x.locations = e), n && (x.contentSteering = n), o === "dynamic" && (x.suggestedPresentationDelay = l), r && r.length > 0 && (x.eventStream = r);
  const p = x.playlists.length === 0, w = f.length ? kee(f, a, p) : null, C = g.length ? See(g, a) : null, M = d.concat(jg(w), jg(C)), A = M.map(({
    timelineStarts: L
  }) => L);
  return x.timelineStarts = V5(A), Iee(M, x.timelineStarts), w && (x.mediaGroups.AUDIO.audio = w), C && (x.mediaGroups.SUBTITLES.subs = C), _.length && (x.mediaGroups["CLOSED-CAPTIONS"].cc = Cee(_)), i ? _ee({
    oldManifest: i,
    newManifest: x
  }) : x;
}, Oee = (t, e, n) => {
  const {
    NOW: a,
    clientOffset: i,
    availabilityStartTime: r,
    timescale: s = 1,
    periodStart: o = 0,
    minimumUpdatePeriod: l = 0
  } = t, c = (a + i) / 1e3, d = r + o, g = c + l - d;
  return Math.ceil((g * s - e) / n);
}, q5 = (t, e) => {
  const {
    type: n,
    minimumUpdatePeriod: a = 0,
    media: i = "",
    sourceDuration: r,
    timescale: s = 1,
    startNumber: o = 1,
    periodStart: l
  } = t, c = [];
  let d = -1;
  for (let f = 0; f < e.length; f++) {
    const g = e[f], _ = g.d, x = g.r || 0, p = g.t || 0;
    d < 0 && (d = p), p && p > d && (d = p);
    let w;
    if (x < 0) {
      const A = f + 1;
      A === e.length ? n === "dynamic" && a > 0 && i.indexOf("$Number$") > 0 ? w = Oee(t, d, _) : w = (r * s - d) / _ : w = (e[A].t - d) / _;
    } else
      w = x + 1;
    const C = o + c.length + w;
    let M = o + c.length;
    for (; M < C; )
      c.push({
        number: M,
        duration: _ / s,
        time: d,
        timeline: l
      }), d += _, M++;
  }
  return c;
}, Pee = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, Bee = (t) => (e, n, a, i) => {
  if (e === "$$")
    return "$";
  if (typeof t[n] > "u")
    return e;
  const r = "" + t[n];
  return n === "RepresentationID" || (a ? i = parseInt(i, 10) : i = 1, r.length >= i) ? r : `${new Array(i - r.length + 1).join("0")}${r}`;
}, Vg = (t, e) => t.replace(Pee, Bee(e)), Ree = (t, e) => !t.duration && !e ? [{
  number: t.startNumber || 1,
  duration: t.sourceDuration,
  time: 0,
  timeline: t.periodStart
}] : t.duration ? Gf(t) : q5(t, e), Nee = (t, e) => {
  const n = {
    RepresentationID: t.id,
    Bandwidth: t.bandwidth || 0
  }, {
    initialization: a = {
      sourceURL: "",
      range: ""
    }
  } = t, i = Cl({
    baseUrl: t.baseUrl,
    source: Vg(a.sourceURL, n),
    range: a.range
  });
  return Ree(t, e).map((s) => {
    n.Number = s.number, n.Time = s.time;
    const o = Vg(t.media || "", n), l = t.timescale || 1, c = t.presentationTimeOffset || 0, d = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      t.periodStart + (s.time - c) / l
    );
    return {
      uri: o,
      timeline: s.timeline,
      duration: s.duration,
      resolvedUri: rd(t.baseUrl || "", o),
      map: i,
      number: s.number,
      presentationTime: d
    };
  });
}, $ee = (t, e) => {
  const {
    baseUrl: n,
    initialization: a = {}
  } = t, i = Cl({
    baseUrl: n,
    source: a.sourceURL,
    range: a.range
  }), r = Cl({
    baseUrl: n,
    source: e.media,
    range: e.mediaRange
  });
  return r.map = i, r;
}, Fee = (t, e) => {
  const {
    duration: n,
    segmentUrls: a = [],
    periodStart: i
  } = t;
  if (!n && !e || n && e)
    throw new Error(zs.SEGMENT_TIME_UNSPECIFIED);
  const r = a.map((l) => $ee(t, l));
  let s;
  return n && (s = Gf(t)), e && (s = q5(t, e)), s.map((l, c) => {
    if (r[c]) {
      const d = r[c], f = t.timescale || 1, g = t.presentationTimeOffset || 0;
      return d.timeline = l.timeline, d.duration = l.duration, d.number = l.number, d.presentationTime = i + (l.time - g) / f, d;
    }
  }).filter((l) => l);
}, zee = ({
  attributes: t,
  segmentInfo: e
}) => {
  let n, a;
  e.template ? (a = Nee, n = gn(t, e.template)) : e.base ? (a = j5, n = gn(t, e.base)) : e.list && (a = Fee, n = gn(t, e.list));
  const i = {
    attributes: t
  };
  if (!a)
    return i;
  const r = a(n, e.segmentTimeline);
  if (n.duration) {
    const {
      duration: s,
      timescale: o = 1
    } = n;
    n.duration = s / o;
  } else r.length ? n.duration = r.reduce((s, o) => Math.max(s, Math.ceil(o.duration)), 0) : n.duration = 0;
  return i.attributes = n, i.segments = r, e.base && n.indexRange && (i.sidx = r[0], i.segments = []), i;
}, Uee = (t) => t.map(zee), Rt = (t, e) => Y5(t.childNodes).filter(({
  tagName: n
}) => n === e), jl = (t) => t.textContent.trim(), Hee = (t) => parseFloat(t.split("/").reduce((e, n) => e / n)), rs = (t) => {
  const o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(t);
  if (!o)
    return 0;
  const [l, c, d, f, g, _] = o.slice(1);
  return parseFloat(l || 0) * 31536e3 + parseFloat(c || 0) * 2592e3 + parseFloat(d || 0) * 86400 + parseFloat(f || 0) * 3600 + parseFloat(g || 0) * 60 + parseFloat(_ || 0);
}, Yee = (t) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(t) && (t += "Z"), Date.parse(t)), qg = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration(t) {
    return rs(t);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime(t) {
    return Yee(t) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod(t) {
    return rs(t);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay(t) {
    return rs(t);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type(t) {
    return t;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth(t) {
    return rs(t);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start(t) {
    return rs(t);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate(t) {
    return Hee(t);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration(t) {
    const e = parseInt(t, 10);
    return isNaN(e) ? rs(t) : e;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */
  presentationTime(t) {
    return parseInt(t, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT(t) {
    return t;
  }
}, an = (t) => t && t.attributes ? Y5(t.attributes).reduce((e, n) => {
  const a = qg[n.name] || qg.DEFAULT;
  return e[n.name] = a(n.value), e;
}, {}) : {}, jee = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
  // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
  "urn:mpeg:dash:mp4protection:2011": "mp4protection"
}, ud = (t, e) => e.length ? Fs(t.map(function(n) {
  return e.map(function(a) {
    const i = jl(a), r = rd(n.baseUrl, i), s = gn(an(a), {
      baseUrl: r
    });
    return r !== i && !s.serviceLocation && n.serviceLocation && (s.serviceLocation = n.serviceLocation), s;
  });
})) : t, Kf = (t) => {
  const e = Rt(t, "SegmentTemplate")[0], n = Rt(t, "SegmentList")[0], a = n && Rt(n, "SegmentURL").map((f) => gn({
    tag: "SegmentURL"
  }, an(f))), i = Rt(t, "SegmentBase")[0], r = n || e, s = r && Rt(r, "SegmentTimeline")[0], o = n || i || e, l = o && Rt(o, "Initialization")[0], c = e && an(e);
  c && l ? c.initialization = l && an(l) : c && c.initialization && (c.initialization = {
    sourceURL: c.initialization
  });
  const d = {
    template: c,
    segmentTimeline: s && Rt(s, "S").map((f) => an(f)),
    list: n && gn(an(n), {
      segmentUrls: a,
      initialization: an(l)
    }),
    base: i && gn(an(i), {
      initialization: an(l)
    })
  };
  return Object.keys(d).forEach((f) => {
    d[f] || delete d[f];
  }), d;
}, Vee = (t, e, n) => (a) => {
  const i = Rt(a, "BaseURL"), r = ud(e, i), s = gn(t, an(a)), o = Kf(a);
  return r.map((l) => ({
    segmentInfo: gn(n, o),
    attributes: gn(s, l)
  }));
}, qee = (t) => t.reduce((e, n) => {
  const a = an(n);
  a.schemeIdUri && (a.schemeIdUri = a.schemeIdUri.toLowerCase());
  const i = jee[a.schemeIdUri];
  if (i) {
    e[i] = {
      attributes: a
    };
    const r = Rt(n, "cenc:pssh")[0];
    if (r) {
      const s = jl(r);
      e[i].pssh = s && o5(s);
    }
  }
  return e;
}, {}), Wee = (t) => {
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-608:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((n) => {
      let a, i;
      return i = n, /^CC\d=/.test(n) ? [a, i] = n.split("=") : /^CC\d$/.test(n) && (a = n), {
        channel: a,
        language: i
      };
    });
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-708:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((n) => {
      const a = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(n)) {
        const [i, r = ""] = n.split("=");
        a.channel = i, a.language = n, r.split(",").forEach((s) => {
          const [o, l] = s.split(":");
          o === "lang" ? a.language = l : o === "er" ? a.easyReader = Number(l) : o === "war" ? a.aspectRatio = Number(l) : o === "3D" && (a["3D"] = Number(l));
        });
      } else
        a.language = n;
      return a.channel && (a.channel = "SERVICE" + a.channel), a;
    });
}, Gee = (t) => Fs(Rt(t.node, "EventStream").map((e) => {
  const n = an(e), a = n.schemeIdUri;
  return Rt(e, "Event").map((i) => {
    const r = an(i), s = r.presentationTime || 0, o = n.timescale || 1, l = r.duration || 0, c = s / o + t.attributes.start;
    return {
      schemeIdUri: a,
      value: n.value,
      id: r.id,
      start: c,
      end: c + l / o,
      messageData: jl(i) || r.messageData,
      contentEncoding: n.contentEncoding,
      presentationTimeOffset: n.presentationTimeOffset || 0
    };
  });
})), Xee = (t, e, n) => (a) => {
  const i = an(a), r = ud(e, Rt(a, "BaseURL")), s = Rt(a, "Role")[0], o = {
    role: an(s)
  };
  let l = gn(t, i, o);
  const c = Rt(a, "Accessibility")[0], d = Wee(an(c));
  d && (l = gn(l, {
    captionServices: d
  }));
  const f = Rt(a, "Label")[0];
  if (f && f.childNodes.length) {
    const w = f.childNodes[0].nodeValue.trim();
    l = gn(l, {
      label: w
    });
  }
  const g = qee(Rt(a, "ContentProtection"));
  Object.keys(g).length && (l = gn(l, {
    contentProtection: g
  }));
  const _ = Kf(a), x = Rt(a, "Representation"), p = gn(n, _);
  return Fs(x.map(Vee(l, r, p)));
}, Zee = (t, e) => (n, a) => {
  const i = ud(e, Rt(n.node, "BaseURL")), r = gn(t, {
    periodStart: n.attributes.start
  });
  typeof n.attributes.duration == "number" && (r.periodDuration = n.attributes.duration);
  const s = Rt(n.node, "AdaptationSet"), o = Kf(n.node);
  return Fs(s.map(Xee(r, i, o)));
}, Kee = (t, e) => {
  if (t.length > 1 && e({
    type: "warn",
    message: "The MPD manifest should contain no more than one ContentSteering tag"
  }), !t.length)
    return null;
  const n = gn({
    serverURL: jl(t[0])
  }, an(t[0]));
  return n.queryBeforeStart = n.queryBeforeStart === "true", n;
}, Qee = ({
  attributes: t,
  priorPeriodAttributes: e,
  mpdType: n
}) => typeof t.start == "number" ? t.start : e && typeof e.start == "number" && typeof e.duration == "number" ? e.start + e.duration : !e && n === "static" ? 0 : null, Jee = (t, e = {}) => {
  const {
    manifestUri: n = "",
    NOW: a = Date.now(),
    clientOffset: i = 0,
    // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler: r = function() {
    }
  } = e, s = Rt(t, "Period");
  if (!s.length)
    throw new Error(zs.INVALID_NUMBER_OF_PERIOD);
  const o = Rt(t, "Location"), l = an(t), c = ud([{
    baseUrl: n
  }], Rt(t, "BaseURL")), d = Rt(t, "ContentSteering");
  l.type = l.type || "static", l.sourceDuration = l.mediaPresentationDuration || 0, l.NOW = a, l.clientOffset = i, o.length && (l.locations = o.map(jl));
  const f = [];
  return s.forEach((g, _) => {
    const x = an(g), p = f[_ - 1];
    x.start = Qee({
      attributes: x,
      priorPeriodAttributes: p ? p.attributes : null,
      mpdType: l.type
    }), f.push({
      node: g,
      attributes: x
    });
  }), {
    locations: l.locations,
    contentSteeringInfo: Kee(d, r),
    // TODO: There are occurences where this `representationInfo` array contains undesired
    // duplicates. This generally occurs when there are multiple BaseURL nodes that are
    // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
    // parent BaseURL and a child BaseURL, and the value does not resolve,
    // we end up returning the child BaseURL multiple times.
    // We need to determine a way to remove these duplicates in a safe way.
    // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
    representationInfo: Fs(f.map(Zee(l, c))),
    eventStream: Fs(f.map(Gee))
  };
}, W5 = (t) => {
  if (t === "")
    throw new Error(zs.DASH_EMPTY_MANIFEST);
  const e = new cee();
  let n, a;
  try {
    n = e.parseFromString(t, "application/xml"), a = n && n.documentElement.tagName === "MPD" ? n.documentElement : null;
  } catch {
  }
  if (!a || a && a.getElementsByTagName("parsererror").length > 0)
    throw new Error(zs.DASH_INVALID_XML);
  return a;
}, ete = (t) => {
  const e = Rt(t, "UTCTiming")[0];
  if (!e)
    return null;
  const n = an(e);
  switch (n.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      n.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      n.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      n.method = "DIRECT", n.value = Date.parse(n.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(zs.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return n;
}, tte = (t, e = {}) => {
  const n = Jee(W5(t), e), a = Uee(n.representationInfo);
  return Mee({
    dashPlaylists: a,
    locations: n.locations,
    contentSteering: n.contentSteeringInfo,
    sidxMapping: e.sidxMapping,
    previousManifest: e.previousManifest,
    eventStream: n.eventStream
  });
}, nte = (t) => ete(W5(t));
var ate = Math.pow(2, 32), ite = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), n;
  return e.getBigUint64 ? (n = e.getBigUint64(0), n < Number.MAX_SAFE_INTEGER ? Number(n) : n) : e.getUint32(0) * ate + e.getUint32(4);
}, rte = {
  getUint64: ite
}, Wg = rte.getUint64, ste = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), n = {
    version: t[0],
    flags: new Uint8Array(t.subarray(1, 4)),
    references: [],
    referenceId: e.getUint32(4),
    timescale: e.getUint32(8)
  }, a = 12;
  n.version === 0 ? (n.earliestPresentationTime = e.getUint32(a), n.firstOffset = e.getUint32(a + 4), a += 8) : (n.earliestPresentationTime = Wg(t.subarray(a)), n.firstOffset = Wg(t.subarray(a + 8)), a += 16), a += 2;
  var i = e.getUint16(a);
  for (a += 2; i > 0; a += 12, i--)
    n.references.push({
      referenceType: (t[a] & 128) >>> 7,
      referencedSize: e.getUint32(a) & 2147483647,
      subsegmentDuration: e.getUint32(a + 4),
      startsWithSap: !!(t[a + 8] & 128),
      sapType: (t[a + 8] & 112) >>> 4,
      sapDeltaTime: e.getUint32(a + 8) & 268435455
    });
  return n;
}, ote = ste;
const lte = /* @__PURE__ */ xa(ote);
var cte = Ze([73, 68, 51]), ute = function(e, n) {
  n === void 0 && (n = 0), e = Ze(e);
  var a = e[n + 5], i = e[n + 6] << 21 | e[n + 7] << 14 | e[n + 8] << 7 | e[n + 9], r = (a & 16) >> 4;
  return r ? i + 20 : i + 10;
}, Jo = function t(e, n) {
  return n === void 0 && (n = 0), e = Ze(e), e.length - n < 10 || !Bt(e, cte, {
    offset: n
  }) ? n : (n += ute(e, n), t(e, n));
}, Gg = function(e) {
  return typeof e == "string" ? h5(e) : e;
}, dte = function(e) {
  return Array.isArray(e) ? e.map(function(n) {
    return Gg(n);
  }) : [Gg(e)];
}, hte = function t(e, n, a) {
  a === void 0 && (a = !1), n = dte(n), e = Ze(e);
  var i = [];
  if (!n.length)
    return i;
  for (var r = 0; r < e.length; ) {
    var s = (e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]) >>> 0, o = e.subarray(r + 4, r + 8);
    if (s === 0)
      break;
    var l = r + s;
    if (l > e.length) {
      if (a)
        break;
      l = e.length;
    }
    var c = e.subarray(r + 8, l);
    Bt(o, n[0]) && (n.length === 1 ? i.push(c) : i.push.apply(i, t(c, n.slice(1), a))), r = l;
  }
  return i;
}, Dc = {
  EBML: Ze([26, 69, 223, 163]),
  DocType: Ze([66, 130]),
  Segment: Ze([24, 83, 128, 103]),
  SegmentInfo: Ze([21, 73, 169, 102]),
  Tracks: Ze([22, 84, 174, 107]),
  Track: Ze([174]),
  TrackNumber: Ze([215]),
  DefaultDuration: Ze([35, 227, 131]),
  TrackEntry: Ze([174]),
  TrackType: Ze([131]),
  FlagDefault: Ze([136]),
  CodecID: Ze([134]),
  CodecPrivate: Ze([99, 162]),
  VideoTrack: Ze([224]),
  AudioTrack: Ze([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: Ze([31, 67, 182, 117]),
  Timestamp: Ze([231]),
  TimestampScale: Ze([42, 215, 177]),
  BlockGroup: Ze([160]),
  BlockDuration: Ze([155]),
  Block: Ze([161]),
  SimpleBlock: Ze([163])
}, hh = [128, 64, 32, 16, 8, 4, 2, 1], fte = function(e) {
  for (var n = 1, a = 0; a < hh.length && !(e & hh[a]); a++)
    n++;
  return n;
}, pu = function(e, n, a, i) {
  a === void 0 && (a = !0), i === void 0 && (i = !1);
  var r = fte(e[n]), s = e.subarray(n, n + r);
  return a && (s = Array.prototype.slice.call(e, n, n + r), s[0] ^= hh[r - 1]), {
    length: r,
    value: MJ(s, {
      signed: i
    }),
    bytes: s
  };
}, Xg = function t(e) {
  return typeof e == "string" ? e.match(/.{1,2}/g).map(function(n) {
    return t(n);
  }) : typeof e == "number" ? OJ(e) : e;
}, pte = function(e) {
  return Array.isArray(e) ? e.map(function(n) {
    return Xg(n);
  }) : [Xg(e)];
}, mte = function t(e, n, a) {
  if (a >= n.length)
    return n.length;
  var i = pu(n, a, !1);
  if (Bt(e.bytes, i.bytes))
    return a;
  var r = pu(n, a + i.length);
  return t(e, n, a + r.length + r.value + i.length);
}, Zg = function t(e, n) {
  n = pte(n), e = Ze(e);
  var a = [];
  if (!n.length)
    return a;
  for (var i = 0; i < e.length; ) {
    var r = pu(e, i, !1), s = pu(e, i + r.length), o = i + r.length + s.length;
    s.value === 127 && (s.value = mte(r, e, o), s.value !== e.length && (s.value -= o));
    var l = o + s.value > e.length ? e.length : o + s.value, c = e.subarray(o, l);
    Bt(n[0], r.bytes) && (n.length === 1 ? a.push(c) : a = a.concat(t(c, n.slice(1))));
    var d = r.length + s.length + c.length;
    i += d;
  }
  return a;
}, gte = Ze([0, 0, 0, 1]), bte = Ze([0, 0, 1]), vte = Ze([0, 0, 3]), yte = function(e) {
  for (var n = [], a = 1; a < e.length - 2; )
    Bt(e.subarray(a, a + 3), vte) && (n.push(a + 2), a++), a++;
  if (n.length === 0)
    return e;
  var i = e.length - n.length, r = new Uint8Array(i), s = 0;
  for (a = 0; a < i; s++, a++)
    s === n[0] && (s++, n.shift()), r[a] = e[s];
  return r;
}, G5 = function(e, n, a, i) {
  e = Ze(e), a = [].concat(a);
  for (var r = 0, s, o = 0; r < e.length && (o < i || s); ) {
    var l = void 0;
    if (Bt(e.subarray(r), gte) ? l = 4 : Bt(e.subarray(r), bte) && (l = 3), !l) {
      r++;
      continue;
    }
    if (o++, s)
      return yte(e.subarray(s, r));
    var c = void 0;
    n === "h264" ? c = e[r + l] & 31 : n === "h265" && (c = e[r + l] >> 1 & 63), a.indexOf(c) !== -1 && (s = r + l), r += l + (n === "h264" ? 1 : 2);
  }
  return e.subarray(0, 0);
}, _te = function(e, n, a) {
  return G5(e, "h264", n, a);
}, xte = function(e, n, a) {
  return G5(e, "h265", n, a);
}, Pn = {
  // "webm" string literal in hex
  webm: Ze([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: Ze([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: Ze([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: Ze([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: Ze([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: Ze([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: Ze([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: Ze([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": Ze([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: Ze([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: Ze([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: Ze([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: Ze([109, 111, 111, 118]),
  // moof string literal in hex
  moof: Ze([109, 111, 111, 102])
}, Us = {
  aac: function(e) {
    var n = Jo(e);
    return Bt(e, [255, 16], {
      offset: n,
      mask: [255, 22]
    });
  },
  mp3: function(e) {
    var n = Jo(e);
    return Bt(e, [255, 2], {
      offset: n,
      mask: [255, 6]
    });
  },
  webm: function(e) {
    var n = Zg(e, [Dc.EBML, Dc.DocType])[0];
    return Bt(n, Pn.webm);
  },
  mkv: function(e) {
    var n = Zg(e, [Dc.EBML, Dc.DocType])[0];
    return Bt(n, Pn.matroska);
  },
  mp4: function(e) {
    if (Us["3gp"](e) || Us.mov(e))
      return !1;
    if (Bt(e, Pn.mp4, {
      offset: 4
    }) || Bt(e, Pn.fmp4, {
      offset: 4
    }) || Bt(e, Pn.moof, {
      offset: 4
    }) || Bt(e, Pn.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(e) {
    return Bt(e, Pn.mov, {
      offset: 4
    });
  },
  "3gp": function(e) {
    return Bt(e, Pn["3gp"], {
      offset: 4
    });
  },
  ac3: function(e) {
    var n = Jo(e);
    return Bt(e, Pn.ac3, {
      offset: n
    });
  },
  ts: function(e) {
    if (e.length < 189 && e.length >= 1)
      return e[0] === 71;
    for (var n = 0; n + 188 < e.length && n < 188; ) {
      if (e[n] === 71 && e[n + 188] === 71)
        return !0;
      n += 1;
    }
    return !1;
  },
  flac: function(e) {
    var n = Jo(e);
    return Bt(e, Pn.flac, {
      offset: n
    });
  },
  ogg: function(e) {
    return Bt(e, Pn.ogg);
  },
  avi: function(e) {
    return Bt(e, Pn.riff) && Bt(e, Pn.avi, {
      offset: 8
    });
  },
  wav: function(e) {
    return Bt(e, Pn.riff) && Bt(e, Pn.wav, {
      offset: 8
    });
  },
  h264: function(e) {
    return _te(e, 7, 3).length;
  },
  h265: function(e) {
    return xte(e, [32, 33], 3).length;
  }
}, fh = Object.keys(Us).filter(function(t) {
  return t !== "ts" && t !== "h264" && t !== "h265";
}).concat(["ts", "h264", "h265"]);
fh.forEach(function(t) {
  var e = Us[t];
  Us[t] = function(n) {
    return e(Ze(n));
  };
});
var Tte = Us, Qf = function(e) {
  e = Ze(e);
  for (var n = 0; n < fh.length; n++) {
    var a = fh[n];
    if (Tte[a](e))
      return a;
  }
  return "";
}, wte = function(e) {
  return hte(e, ["moof"]).length > 0;
}, wr = {};
/**
 * @license
 * Video.js 8.21.0 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var ph = "8.21.0";
const mi = {}, er = function(t, e) {
  return mi[t] = mi[t] || [], e && (mi[t] = mi[t].concat(e)), mi[t];
}, kte = function(t, e) {
  er(t, e);
}, X5 = function(t, e) {
  const n = er(t).indexOf(e);
  return n <= -1 ? !1 : (mi[t] = mi[t].slice(), mi[t].splice(n, 1), !0);
}, Ste = function(t, e) {
  er(t, [].concat(e).map((n) => {
    const a = (...i) => (X5(t, a), n(...i));
    return a;
  }));
}, mu = {
  prefixed: !0
}, Hc = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"]
], Kg = Hc[0];
let el;
for (let t = 0; t < Hc.length; t++)
  if (Hc[t][1] in Me) {
    el = Hc[t];
    break;
  }
if (el) {
  for (let t = 0; t < el.length; t++)
    mu[Kg[t]] = el[t];
  mu.prefixed = el[0] !== Kg[0];
}
let Wn = [];
const Cte = (t, e, n) => (a, i, r) => {
  const s = e.levels[i], o = new RegExp(`^(${s})$`);
  let l = t;
  if (a !== "log" && r.unshift(a.toUpperCase() + ":"), n && (l = `%c${t}`, r.unshift(n)), r.unshift(l + ":"), Wn) {
    Wn.push([].concat(r));
    const d = Wn.length - 1e3;
    Wn.splice(0, d > 0 ? d : 0);
  }
  if (!Y.console)
    return;
  let c = Y.console[a];
  !c && a === "debug" && (c = Y.console.info || Y.console.log), !(!c || !s || !o.test(a)) && c[Array.isArray(r) ? "apply" : "call"](Y.console, r);
};
function mh(t, e = ":", n = "") {
  let a = "info", i;
  function r(...s) {
    i("log", a, s);
  }
  return i = Cte(t, r, n), r.createLogger = (s, o, l) => {
    const c = o !== void 0 ? o : e, d = l !== void 0 ? l : n, f = `${t} ${c} ${s}`;
    return mh(f, c, d);
  }, r.createNewLogger = (s, o, l) => mh(s, o, l), r.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: a
  }, r.level = (s) => {
    if (typeof s == "string") {
      if (!r.levels.hasOwnProperty(s))
        throw new Error(`"${s}" in not a valid log level`);
      a = s;
    }
    return a;
  }, r.history = () => Wn ? [].concat(Wn) : [], r.history.filter = (s) => (Wn || []).filter((o) => new RegExp(`.*${s}.*`).test(o[0])), r.history.clear = () => {
    Wn && (Wn.length = 0);
  }, r.history.disable = () => {
    Wn !== null && (Wn.length = 0, Wn = null);
  }, r.history.enable = () => {
    Wn === null && (Wn = []);
  }, r.error = (...s) => i("error", a, s), r.warn = (...s) => i("warn", a, s), r.debug = (...s) => i("debug", a, s), r;
}
const ct = mh("VIDEOJS"), Z5 = ct.createLogger, Ate = Object.prototype.toString, K5 = function(t) {
  return ni(t) ? Object.keys(t) : [];
};
function ys(t, e) {
  K5(t).forEach((n) => e(t[n], n));
}
function Q5(t, e, n = 0) {
  return K5(t).reduce((a, i) => e(a, t[i], i), n);
}
function ni(t) {
  return !!t && typeof t == "object";
}
function Hs(t) {
  return ni(t) && Ate.call(t) === "[object Object]" && t.constructor === Object;
}
function Tt(...t) {
  const e = {};
  return t.forEach((n) => {
    n && ys(n, (a, i) => {
      if (!Hs(a)) {
        e[i] = a;
        return;
      }
      Hs(e[i]) || (e[i] = {}), e[i] = Tt(e[i], a);
    });
  }), e;
}
function J5(t = {}) {
  const e = [];
  for (const n in t)
    if (t.hasOwnProperty(n)) {
      const a = t[n];
      e.push(a);
    }
  return e;
}
function dd(t, e, n, a = !0) {
  const i = (s) => Object.defineProperty(t, e, {
    value: s,
    enumerable: !0,
    writable: !0
  }), r = {
    configurable: !0,
    enumerable: !0,
    get() {
      const s = n();
      return i(s), s;
    }
  };
  return a && (r.set = i), Object.defineProperty(t, e, r);
}
var Ete = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  each: ys,
  reduce: Q5,
  isObject: ni,
  isPlain: Hs,
  merge: Tt,
  values: J5,
  defineLazyProperty: dd
});
let Jf = !1, e3 = null, Na = !1, t3, n3 = !1, _s = !1, xs = !1, ai = !1, ep = null, hd = null;
const Lte = !!(Y.cast && Y.cast.framework && Y.cast.framework.CastReceiverContext);
let a3 = null, gu = !1, fd = !1, bu = !1, pd = !1, vu = !1, yu = !1, _u = !1;
const Al = !!(so() && ("ontouchstart" in Y || Y.navigator.maxTouchPoints || Y.DocumentTouch && Y.document instanceof Y.DocumentTouch)), zi = Y.navigator && Y.navigator.userAgentData;
zi && zi.platform && zi.brands && (Na = zi.platform === "Android", _s = !!zi.brands.find((t) => t.brand === "Microsoft Edge"), xs = !!zi.brands.find((t) => t.brand === "Chromium"), ai = !_s && xs, ep = hd = (zi.brands.find((t) => t.brand === "Chromium") || {}).version || null, fd = zi.platform === "Windows");
if (!xs) {
  const t = Y.navigator && Y.navigator.userAgent || "";
  Jf = /iPod/i.test(t), e3 = function() {
    const e = t.match(/OS (\d+)_/i);
    return e && e[1] ? e[1] : null;
  }(), Na = /Android/i.test(t), t3 = function() {
    const e = t.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
    if (!e)
      return null;
    const n = e[1] && parseFloat(e[1]), a = e[2] && parseFloat(e[2]);
    return n && a ? parseFloat(e[1] + "." + e[2]) : n || null;
  }(), n3 = /Firefox/i.test(t), _s = /Edg/i.test(t), xs = /Chrome/i.test(t) || /CriOS/i.test(t), ai = !_s && xs, ep = hd = function() {
    const e = t.match(/(Chrome|CriOS)\/(\d+)/);
    return e && e[2] ? parseFloat(e[2]) : null;
  }(), a3 = function() {
    const e = /MSIE\s(\d+)\.\d/.exec(t);
    let n = e && parseFloat(e[1]);
    return !n && /Trident\/7.0/i.test(t) && /rv:11.0/.test(t) && (n = 11), n;
  }(), vu = /Tizen/i.test(t), yu = /Web0S/i.test(t), _u = vu || yu, gu = /Safari/i.test(t) && !ai && !Na && !_s && !_u, fd = /Windows/i.test(t), bu = /iPad/i.test(t) || gu && Al && !/iPhone/i.test(t), pd = /iPhone/i.test(t) && !bu;
}
const An = pd || bu || Jf, md = (gu || An) && !ai;
var i3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get IS_IPOD() {
    return Jf;
  },
  get IOS_VERSION() {
    return e3;
  },
  get IS_ANDROID() {
    return Na;
  },
  get ANDROID_VERSION() {
    return t3;
  },
  get IS_FIREFOX() {
    return n3;
  },
  get IS_EDGE() {
    return _s;
  },
  get IS_CHROMIUM() {
    return xs;
  },
  get IS_CHROME() {
    return ai;
  },
  get CHROMIUM_VERSION() {
    return ep;
  },
  get CHROME_VERSION() {
    return hd;
  },
  IS_CHROMECAST_RECEIVER: Lte,
  get IE_VERSION() {
    return a3;
  },
  get IS_SAFARI() {
    return gu;
  },
  get IS_WINDOWS() {
    return fd;
  },
  get IS_IPAD() {
    return bu;
  },
  get IS_IPHONE() {
    return pd;
  },
  get IS_TIZEN() {
    return vu;
  },
  get IS_WEBOS() {
    return yu;
  },
  get IS_SMART_TV() {
    return _u;
  },
  TOUCH_ENABLED: Al,
  IS_IOS: An,
  IS_ANY_SAFARI: md
});
function Qg(t) {
  return typeof t == "string" && !!t.trim();
}
function Dte(t) {
  if (t.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function so() {
  return Me === Y.document;
}
function oo(t) {
  return ni(t) && t.nodeType === 1;
}
function r3() {
  try {
    return Y.parent !== Y.self;
  } catch {
    return !0;
  }
}
function s3(t) {
  return function(e, n) {
    if (!Qg(e))
      return Me[t](null);
    Qg(n) && (n = Me.querySelector(n));
    const a = oo(n) ? n : Me;
    return a[t] && a[t](e);
  };
}
function Je(t = "div", e = {}, n = {}, a) {
  const i = Me.createElement(t);
  return Object.getOwnPropertyNames(e).forEach(function(r) {
    const s = e[r];
    r === "textContent" ? lr(i, s) : (i[r] !== s || r === "tabIndex") && (i[r] = s);
  }), Object.getOwnPropertyNames(n).forEach(function(r) {
    i.setAttribute(r, n[r]);
  }), a && tp(i, a), i;
}
function lr(t, e) {
  return typeof t.textContent > "u" ? t.innerText = e : t.textContent = e, t;
}
function gh(t, e) {
  e.firstChild ? e.insertBefore(t, e.firstChild) : e.appendChild(t);
}
function cl(t, e) {
  return Dte(e), t.classList.contains(e);
}
function Er(t, ...e) {
  return t.classList.add(...e.reduce((n, a) => n.concat(a.split(/\s+/)), [])), t;
}
function gd(t, ...e) {
  return t ? (t.classList.remove(...e.reduce((n, a) => n.concat(a.split(/\s+/)), [])), t) : (ct.warn("removeClass was called with an element that doesn't exist"), null);
}
function o3(t, e, n) {
  return typeof n == "function" && (n = n(t, e)), typeof n != "boolean" && (n = void 0), e.split(/\s+/).forEach((a) => t.classList.toggle(a, n)), t;
}
function l3(t, e) {
  Object.getOwnPropertyNames(e).forEach(function(n) {
    const a = e[n];
    a === null || typeof a > "u" || a === !1 ? t.removeAttribute(n) : t.setAttribute(n, a === !0 ? "" : a);
  });
}
function Yi(t) {
  const e = {}, n = ["autoplay", "controls", "playsinline", "loop", "muted", "default", "defaultMuted"];
  if (t && t.attributes && t.attributes.length > 0) {
    const a = t.attributes;
    for (let i = a.length - 1; i >= 0; i--) {
      const r = a[i].name;
      let s = a[i].value;
      n.includes(r) && (s = s !== null), e[r] = s;
    }
  }
  return e;
}
function c3(t, e) {
  return t.getAttribute(e);
}
function Ys(t, e, n) {
  t.setAttribute(e, n);
}
function bd(t, e) {
  t.removeAttribute(e);
}
function u3() {
  Me.body.focus(), Me.onselectstart = function() {
    return !1;
  };
}
function d3() {
  Me.onselectstart = function() {
    return !0;
  };
}
function js(t) {
  if (t && t.getBoundingClientRect && t.parentNode) {
    const e = t.getBoundingClientRect(), n = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach((a) => {
      e[a] !== void 0 && (n[a] = e[a]);
    }), n.height || (n.height = parseFloat(Vs(t, "height"))), n.width || (n.width = parseFloat(Vs(t, "width"))), n;
  }
}
function El(t) {
  if (!t || t && !t.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  const e = t.offsetWidth, n = t.offsetHeight;
  let a = 0, i = 0;
  for (; t.offsetParent && t !== Me[mu.fullscreenElement]; )
    a += t.offsetLeft, i += t.offsetTop, t = t.offsetParent;
  return {
    left: a,
    top: i,
    width: e,
    height: n
  };
}
function vd(t, e) {
  const n = {
    x: 0,
    y: 0
  };
  if (An) {
    let d = t;
    for (; d && d.nodeName.toLowerCase() !== "html"; ) {
      const f = Vs(d, "transform");
      if (/^matrix/.test(f)) {
        const g = f.slice(7, -1).split(/,\s/).map(Number);
        n.x += g[4], n.y += g[5];
      } else if (/^matrix3d/.test(f)) {
        const g = f.slice(9, -1).split(/,\s/).map(Number);
        n.x += g[12], n.y += g[13];
      }
      if (d.assignedSlot && d.assignedSlot.parentElement && Y.WebKitCSSMatrix) {
        const g = Y.getComputedStyle(d.assignedSlot.parentElement).transform, _ = new Y.WebKitCSSMatrix(g);
        n.x += _.m41, n.y += _.m42;
      }
      d = d.parentNode || d.host;
    }
  }
  const a = {}, i = El(e.target), r = El(t), s = r.width, o = r.height;
  let l = e.offsetY - (r.top - i.top), c = e.offsetX - (r.left - i.left);
  return e.changedTouches && (c = e.changedTouches[0].pageX - r.left, l = e.changedTouches[0].pageY + r.top, An && (c -= n.x, l -= n.y)), a.y = 1 - Math.max(0, Math.min(1, l / o)), a.x = Math.max(0, Math.min(1, c / s)), a;
}
function h3(t) {
  return ni(t) && t.nodeType === 3;
}
function yd(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  return t;
}
function f3(t) {
  return typeof t == "function" && (t = t()), (Array.isArray(t) ? t : [t]).map((e) => {
    if (typeof e == "function" && (e = e()), oo(e) || h3(e))
      return e;
    if (typeof e == "string" && /\S/.test(e))
      return Me.createTextNode(e);
  }).filter((e) => e);
}
function tp(t, e) {
  return f3(e).forEach((n) => t.appendChild(n)), t;
}
function p3(t, e) {
  return tp(yd(t), e);
}
function Ll(t) {
  return t.button === void 0 && t.buttons === void 0 || t.button === 0 && t.buttons === void 0 || t.type === "mouseup" && t.button === 0 && t.buttons === 0 || t.type === "mousedown" && t.button === 0 && t.buttons === 0 ? !0 : !(t.button !== 0 || t.buttons !== 1);
}
const tr = s3("querySelector"), m3 = s3("querySelectorAll");
function Vs(t, e) {
  if (!t || !e)
    return "";
  if (typeof Y.getComputedStyle == "function") {
    let n;
    try {
      n = Y.getComputedStyle(t);
    } catch {
      return "";
    }
    return n ? n.getPropertyValue(e) || n[e] : "";
  }
  return "";
}
function g3(t) {
  [...Me.styleSheets].forEach((e) => {
    try {
      const n = [...e.cssRules].map((i) => i.cssText).join(""), a = Me.createElement("style");
      a.textContent = n, t.document.head.appendChild(a);
    } catch {
      const a = Me.createElement("link");
      a.rel = "stylesheet", a.type = e.type, a.media = e.media.mediaText, a.href = e.href, t.document.head.appendChild(a);
    }
  });
}
var b3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: so,
  isEl: oo,
  isInFrame: r3,
  createEl: Je,
  textContent: lr,
  prependTo: gh,
  hasClass: cl,
  addClass: Er,
  removeClass: gd,
  toggleClass: o3,
  setAttributes: l3,
  getAttributes: Yi,
  getAttribute: c3,
  setAttribute: Ys,
  removeAttribute: bd,
  blockTextSelection: u3,
  unblockTextSelection: d3,
  getBoundingClientRect: js,
  findPosition: El,
  getPointerPosition: vd,
  isTextNode: h3,
  emptyEl: yd,
  normalizeContent: f3,
  appendContent: tp,
  insertContent: p3,
  isSingleLeftClick: Ll,
  $: tr,
  $$: m3,
  computedStyle: Vs,
  copyStyleSheetsToWindow: g3
});
let v3 = !1, bh;
const Ite = function() {
  if (bh.options.autoSetup === !1)
    return;
  const t = Array.prototype.slice.call(Me.getElementsByTagName("video")), e = Array.prototype.slice.call(Me.getElementsByTagName("audio")), n = Array.prototype.slice.call(Me.getElementsByTagName("video-js")), a = t.concat(e, n);
  if (a && a.length > 0)
    for (let i = 0, r = a.length; i < r; i++) {
      const s = a[i];
      if (s && s.getAttribute)
        s.player === void 0 && s.getAttribute("data-setup") !== null && bh(s);
      else {
        vh(1);
        break;
      }
    }
  else v3 || vh(1);
};
function vh(t, e) {
  so() && (e && (bh = e), Y.setTimeout(Ite, t));
}
function yh() {
  v3 = !0, Y.removeEventListener("load", yh);
}
so() && (Me.readyState === "complete" ? yh() : Y.addEventListener("load", yh));
const y3 = function(t) {
  const e = Me.createElement("style");
  return e.className = t, e;
}, _3 = function(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.textContent = e;
};
var zn = /* @__PURE__ */ new WeakMap();
const Mte = 3;
let Ote = Mte;
function ya() {
  return Ote++;
}
function Jg(t, e) {
  if (!zn.has(t))
    return;
  const n = zn.get(t);
  n.handlers[e].length === 0 && (delete n.handlers[e], t.removeEventListener ? t.removeEventListener(e, n.dispatcher, !1) : t.detachEvent && t.detachEvent("on" + e, n.dispatcher)), Object.getOwnPropertyNames(n.handlers).length <= 0 && (delete n.handlers, delete n.dispatcher, delete n.disabled), Object.getOwnPropertyNames(n).length === 0 && zn.delete(t);
}
function np(t, e, n, a) {
  n.forEach(function(i) {
    t(e, i, a);
  });
}
function _d(t) {
  if (t.fixed_)
    return t;
  function e() {
    return !0;
  }
  function n() {
    return !1;
  }
  if (!t || !t.isPropagationStopped || !t.isImmediatePropagationStopped) {
    const a = t || Y.event;
    t = {};
    const i = ["layerX", "layerY", "keyLocation", "path", "webkitMovementX", "webkitMovementY", "mozPressure", "mozInputSource"];
    for (const r in a)
      i.includes(r) || r === "returnValue" && a.preventDefault || (t[r] = a[r]);
    if (t.target || (t.target = t.srcElement || Me), t.relatedTarget || (t.relatedTarget = t.fromElement === t.target ? t.toElement : t.fromElement), t.preventDefault = function() {
      a.preventDefault && a.preventDefault(), t.returnValue = !1, a.returnValue = !1, t.defaultPrevented = !0;
    }, t.defaultPrevented = !1, t.stopPropagation = function() {
      a.stopPropagation && a.stopPropagation(), t.cancelBubble = !0, a.cancelBubble = !0, t.isPropagationStopped = e;
    }, t.isPropagationStopped = n, t.stopImmediatePropagation = function() {
      a.stopImmediatePropagation && a.stopImmediatePropagation(), t.isImmediatePropagationStopped = e, t.stopPropagation();
    }, t.isImmediatePropagationStopped = n, t.clientX !== null && t.clientX !== void 0) {
      const r = Me.documentElement, s = Me.body;
      t.pageX = t.clientX + (r && r.scrollLeft || s && s.scrollLeft || 0) - (r && r.clientLeft || s && s.clientLeft || 0), t.pageY = t.clientY + (r && r.scrollTop || s && s.scrollTop || 0) - (r && r.clientTop || s && s.clientTop || 0);
    }
    t.which = t.charCode || t.keyCode, t.button !== null && t.button !== void 0 && (t.button = t.button & 1 ? 0 : t.button & 4 ? 1 : t.button & 2 ? 2 : 0);
  }
  return t.fixed_ = !0, t;
}
let Ic;
const Pte = function() {
  if (typeof Ic != "boolean") {
    Ic = !1;
    try {
      const t = Object.defineProperty({}, "passive", {
        get() {
          Ic = !0;
        }
      });
      Y.addEventListener("test", null, t), Y.removeEventListener("test", null, t);
    } catch {
    }
  }
  return Ic;
}, Bte = ["touchstart", "touchmove"];
function ua(t, e, n) {
  if (Array.isArray(e))
    return np(ua, t, e, n);
  zn.has(t) || zn.set(t, {});
  const a = zn.get(t);
  if (a.handlers || (a.handlers = {}), a.handlers[e] || (a.handlers[e] = []), n.guid || (n.guid = ya()), a.handlers[e].push(n), a.dispatcher || (a.disabled = !1, a.dispatcher = function(i, r) {
    if (a.disabled)
      return;
    i = _d(i);
    const s = a.handlers[i.type];
    if (s) {
      const o = s.slice(0);
      for (let l = 0, c = o.length; l < c && !i.isImmediatePropagationStopped(); l++)
        try {
          o[l].call(t, i, r);
        } catch (d) {
          ct.error(d);
        }
    }
  }), a.handlers[e].length === 1)
    if (t.addEventListener) {
      let i = !1;
      Pte() && Bte.indexOf(e) > -1 && (i = {
        passive: !0
      }), t.addEventListener(e, a.dispatcher, i);
    } else t.attachEvent && t.attachEvent("on" + e, a.dispatcher);
}
function En(t, e, n) {
  if (!zn.has(t))
    return;
  const a = zn.get(t);
  if (!a.handlers)
    return;
  if (Array.isArray(e))
    return np(En, t, e, n);
  const i = function(s, o) {
    a.handlers[o] = [], Jg(s, o);
  };
  if (e === void 0) {
    for (const s in a.handlers)
      Object.prototype.hasOwnProperty.call(a.handlers || {}, s) && i(t, s);
    return;
  }
  const r = a.handlers[e];
  if (r) {
    if (!n) {
      i(t, e);
      return;
    }
    if (n.guid)
      for (let s = 0; s < r.length; s++)
        r[s].guid === n.guid && r.splice(s--, 1);
    Jg(t, e);
  }
}
function lo(t, e, n) {
  const a = zn.has(t) ? zn.get(t) : {}, i = t.parentNode || t.ownerDocument;
  if (typeof e == "string" ? e = {
    type: e,
    target: t
  } : e.target || (e.target = t), e = _d(e), a.dispatcher && a.dispatcher.call(t, e, n), i && !e.isPropagationStopped() && e.bubbles === !0)
    lo.call(null, i, e, n);
  else if (!i && !e.defaultPrevented && e.target && e.target[e.type]) {
    zn.has(e.target) || zn.set(e.target, {});
    const r = zn.get(e.target);
    e.target[e.type] && (r.disabled = !0, typeof e.target[e.type] == "function" && e.target[e.type](), r.disabled = !1);
  }
  return !e.defaultPrevented;
}
function xd(t, e, n) {
  if (Array.isArray(e))
    return np(xd, t, e, n);
  const a = function() {
    En(t, e, a), n.apply(this, arguments);
  };
  a.guid = n.guid = n.guid || ya(), ua(t, e, a);
}
function ap(t, e, n) {
  const a = function() {
    En(t, e, a), n.apply(this, arguments);
  };
  a.guid = n.guid = n.guid || ya(), ua(t, e, a);
}
var Rte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: _d,
  on: ua,
  off: En,
  trigger: lo,
  one: xd,
  any: ap
});
const _a = 30, At = function(t, e, n) {
  e.guid || (e.guid = ya());
  const a = e.bind(t);
  return a.guid = n ? n + "_" + e.guid : e.guid, a;
}, ii = function(t, e) {
  let n = Y.performance.now();
  return function(...i) {
    const r = Y.performance.now();
    r - n >= e && (t(...i), n = r);
  };
}, x3 = function(t, e, n, a = Y) {
  let i;
  const r = () => {
    a.clearTimeout(i), i = null;
  }, s = function() {
    const o = this, l = arguments;
    let c = function() {
      i = null, c = null, n || t.apply(o, l);
    };
    !i && n && t.apply(o, l), a.clearTimeout(i), i = a.setTimeout(c, e);
  };
  return s.cancel = r, s;
};
var Nte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  UPDATE_REFRESH_INTERVAL: _a,
  bind_: At,
  throttle: ii,
  debounce: x3
});
let jo;
class da {
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  on(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, ua(this, e, n), this.addEventListener = a;
  }
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */
  off(e, n) {
    En(this, e, n);
  }
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  one(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, xd(this, e, n), this.addEventListener = a;
  }
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  any(e, n) {
    const a = this.addEventListener;
    this.addEventListener = () => {
    }, ap(this, e, n), this.addEventListener = a;
  }
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */
  trigger(e) {
    const n = e.type || e;
    typeof e == "string" && (e = {
      type: n
    }), e = _d(e), this.allowedEvents_[n] && this["on" + n] && this["on" + n](e), lo(this, e);
  }
  queueTrigger(e) {
    jo || (jo = /* @__PURE__ */ new Map());
    const n = e.type || e;
    let a = jo.get(this);
    a || (a = /* @__PURE__ */ new Map(), jo.set(this, a));
    const i = a.get(n);
    a.delete(n), Y.clearTimeout(i);
    const r = Y.setTimeout(() => {
      a.delete(n), a.size === 0 && (a = null, jo.delete(this)), this.trigger(e);
    }, 0);
    a.set(n, r);
  }
}
da.prototype.allowedEvents_ = {};
da.prototype.addEventListener = da.prototype.on;
da.prototype.removeEventListener = da.prototype.off;
da.prototype.dispatchEvent = da.prototype.trigger;
const Td = (t) => typeof t.name == "function" ? t.name() : typeof t.name == "string" ? t.name : t.name_ ? t.name_ : t.constructor && t.constructor.name ? t.constructor.name : typeof t, xi = (t) => t instanceof da || !!t.eventBusEl_ && ["on", "one", "off", "trigger"].every((e) => typeof t[e] == "function"), $te = (t, e) => {
  xi(t) ? e() : (t.eventedCallbacks || (t.eventedCallbacks = []), t.eventedCallbacks.push(e));
}, _h = (t) => (
  // The regex here verifies that the `type` contains at least one non-
  // whitespace character.
  typeof t == "string" && /\S/.test(t) || Array.isArray(t) && !!t.length
), xu = (t, e, n) => {
  if (!t || !t.nodeName && !xi(t))
    throw new Error(`Invalid target for ${Td(e)}#${n}; must be a DOM node or evented object.`);
}, T3 = (t, e, n) => {
  if (!_h(t))
    throw new Error(`Invalid event type for ${Td(e)}#${n}; must be a non-empty string or array.`);
}, w3 = (t, e, n) => {
  if (typeof t != "function")
    throw new Error(`Invalid listener for ${Td(e)}#${n}; must be a function.`);
}, w0 = (t, e, n) => {
  const a = e.length < 3 || e[0] === t || e[0] === t.eventBusEl_;
  let i, r, s;
  return a ? (i = t.eventBusEl_, e.length >= 3 && e.shift(), [r, s] = e) : (i = e[0], r = e[1], s = e[2]), xu(i, t, n), T3(r, t, n), w3(s, t, n), s = At(t, s), {
    isTargetingSelf: a,
    target: i,
    type: r,
    listener: s
  };
}, fr = (t, e, n, a) => {
  xu(t, t, e), t.nodeName ? Rte[e](t, n, a) : t[e](n, a);
}, Fte = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = w0(this, t, "on");
    if (fr(n, "on", a, i), !e) {
      const r = () => this.off(n, a, i);
      r.guid = i.guid;
      const s = () => this.off("dispose", r);
      s.guid = i.guid, fr(this, "on", "dispose", r), fr(n, "on", "dispose", s);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = w0(this, t, "one");
    if (e)
      fr(n, "one", a, i);
    else {
      const r = (...s) => {
        this.off(n, a, r), i.apply(null, s);
      };
      r.guid = i.guid, fr(n, "one", a, r);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any(...t) {
    const {
      isTargetingSelf: e,
      target: n,
      type: a,
      listener: i
    } = w0(this, t, "any");
    if (e)
      fr(n, "any", a, i);
    else {
      const r = (...s) => {
        this.off(n, a, r), i.apply(null, s);
      };
      r.guid = i.guid, fr(n, "any", a, r);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off(t, e, n) {
    if (!t || _h(t))
      En(this.eventBusEl_, t, e);
    else {
      const a = t, i = e;
      xu(a, this, "off"), T3(i, this, "off"), w3(n, this, "off"), n = At(this, n), this.off("dispose", n), a.nodeName ? (En(a, i, n), En(a, "dispose", n)) : xi(a) && (a.off(i, n), a.off("dispose", n));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger(t, e) {
    xu(this.eventBusEl_, this, "trigger");
    const n = t && typeof t != "string" ? t.type : t;
    if (!_h(n))
      throw new Error(`Invalid event type for ${Td(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
    return lo(this.eventBusEl_, t, e);
  }
};
function ip(t, e = {}) {
  const {
    eventBusKey: n
  } = e;
  if (n) {
    if (!t[n].nodeName)
      throw new Error(`The eventBusKey "${n}" does not refer to an element.`);
    t.eventBusEl_ = t[n];
  } else
    t.eventBusEl_ = Je("span", {
      className: "vjs-event-bus"
    });
  return Object.assign(t, Fte), t.eventedCallbacks && t.eventedCallbacks.forEach((a) => {
    a();
  }), t.on("dispose", () => {
    t.off(), [t, t.el_, t.eventBusEl_].forEach(function(a) {
      a && zn.has(a) && zn.delete(a);
    }), Y.setTimeout(() => {
      t.eventBusEl_ = null;
    }, 0);
  }), t;
}
const zte = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState(t) {
    typeof t == "function" && (t = t());
    let e;
    return ys(t, (n, a) => {
      this.state[a] !== n && (e = e || {}, e[a] = {
        from: this.state[a],
        to: n
      }), this.state[a] = n;
    }), e && xi(this) && this.trigger({
      changes: e,
      type: "statechanged"
    }), e;
  }
};
function k3(t, e) {
  return Object.assign(t, zte), t.state = Object.assign({}, t.state, e), typeof t.handleStateChanged == "function" && xi(t) && t.on("statechanged", t.handleStateChanged), t;
}
const ul = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toLowerCase());
}, qt = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, S3 = function(t, e) {
  return qt(t) === qt(e);
};
var Ute = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toLowerCase: ul,
  toTitleCase: qt,
  titleCaseEquals: S3
});
class ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  constructor(e, n, a) {
    if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = Tt({}, this.options_), n = this.options_ = Tt(this.options_, n), this.id_ = n.id || n.el && n.el.id, !this.id_) {
      const i = e && e.id && e.id() || "no_player";
      this.id_ = `${i}_component_${ya()}`;
    }
    this.name_ = n.name || null, n.el ? this.el_ = n.el : n.createEl !== !1 && (this.el_ = this.createEl()), n.className && this.el_ && n.className.split(" ").forEach((i) => this.addClass(i)), ["on", "off", "one", "any", "trigger"].forEach((i) => {
      this[i] = void 0;
    }), n.evented !== !1 && (ip(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), k3(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, n.initChildren !== !1 && this.initChildren(), this.ready(a), n.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
  // They are replaced or removed in the constructor
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */
  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */
  dispose(e = {}) {
    if (!this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (let n = this.children_.length - 1; n >= 0; n--)
          this.children_[n].dispose && this.children_[n].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }
  /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */
  isDisposed() {
    return !!this.isDisposed_;
  }
  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */
  player() {
    return this.player_;
  }
  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */
  options(e) {
    return e ? (this.options_ = Tt(this.options_, e), this.options_) : this.options_;
  }
  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */
  el() {
    return this.el_;
  }
  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n, a) {
    return Je(e, n, a);
  }
  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */
  localize(e, n, a = e) {
    const i = this.player_.language && this.player_.language(), r = this.player_.languages && this.player_.languages(), s = r && r[i], o = i && i.split("-")[0], l = r && r[o];
    let c = a;
    return s && s[e] ? c = s[e] : l && l[e] && (c = l[e]), n && (c = c.replace(/\{(\d+)\}/g, function(d, f) {
      const g = n[f - 1];
      let _ = g;
      return typeof g > "u" && (_ = d), _;
    })), c;
  }
  /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */
  handleLanguagechange() {
  }
  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */
  contentEl() {
    return this.contentEl_ || this.el_;
  }
  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */
  id() {
    return this.id_;
  }
  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */
  name() {
    return this.name_;
  }
  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */
  children() {
    return this.children_;
  }
  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */
  getChildById(e) {
    return this.childIndex_[e];
  }
  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */
  getChild(e) {
    if (e)
      return this.childNameIndex_[e];
  }
  /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */
  getDescendant(...e) {
    e = e.reduce((a, i) => a.concat(i), []);
    let n = this;
    for (let a = 0; a < e.length; a++)
      if (n = n.getChild(e[a]), !n || !n.getChild)
        return;
    return n;
  }
  /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */
  setIcon(e, n = this.el()) {
    if (!this.player_.options_.experimentalSvgIcons)
      return;
    const a = "http://www.w3.org/2000/svg", i = Je("span", {
      className: "vjs-icon-placeholder vjs-svg-icon"
    }, {
      "aria-hidden": "true"
    }), r = Me.createElementNS(a, "svg");
    r.setAttributeNS(null, "viewBox", "0 0 512 512");
    const s = Me.createElementNS(a, "use");
    return r.appendChild(s), s.setAttributeNS(null, "href", `#vjs-icon-${e}`), i.appendChild(r), this.iconIsSet_ ? n.replaceChild(i, n.querySelector(".vjs-icon-placeholder")) : n.appendChild(i), this.iconIsSet_ = !0, i;
  }
  /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */
  addChild(e, n = {}, a = this.children_.length) {
    let i, r;
    if (typeof e == "string") {
      r = qt(e);
      const s = n.componentClass || r;
      n.name = r;
      const o = ve.getComponent(s);
      if (!o)
        throw new Error(`Component ${s} does not exist`);
      if (typeof o != "function")
        return null;
      i = new o(this.player_ || this, n);
    } else
      i = e;
    if (i.parentComponent_ && i.parentComponent_.removeChild(i), this.children_.splice(a, 0, i), i.parentComponent_ = this, typeof i.id == "function" && (this.childIndex_[i.id()] = i), r = r || i.name && qt(i.name()), r && (this.childNameIndex_[r] = i, this.childNameIndex_[ul(r)] = i), typeof i.el == "function" && i.el()) {
      let s = null;
      this.children_[a + 1] && (this.children_[a + 1].el_ ? s = this.children_[a + 1].el_ : oo(this.children_[a + 1]) && (s = this.children_[a + 1])), this.contentEl().insertBefore(i.el(), s);
    }
    return i;
  }
  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */
  removeChild(e) {
    if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_)
      return;
    let n = !1;
    for (let i = this.children_.length - 1; i >= 0; i--)
      if (this.children_[i] === e) {
        n = !0, this.children_.splice(i, 1);
        break;
      }
    if (!n)
      return;
    e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[qt(e.name())] = null, this.childNameIndex_[ul(e.name())] = null;
    const a = e.el();
    a && a.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
  }
  /**
   * Add and initialize default child `Component`s based upon options.
   */
  initChildren() {
    const e = this.options_.children;
    if (e) {
      const n = this.options_, a = (s) => {
        const o = s.name;
        let l = s.opts;
        if (n[o] !== void 0 && (l = n[o]), l === !1)
          return;
        l === !0 && (l = {}), l.playerOptions = this.options_.playerOptions;
        const c = this.addChild(o, l);
        c && (this[o] = c);
      };
      let i;
      const r = ve.getComponent("Tech");
      Array.isArray(e) ? i = e : i = Object.keys(e), i.concat(Object.keys(this.options_).filter(function(s) {
        return !i.some(function(o) {
          return typeof o == "string" ? s === o : s === o.name;
        });
      })).map((s) => {
        let o, l;
        return typeof s == "string" ? (o = s, l = e[o] || this.options_[o] || {}) : (o = s.name, l = s), {
          name: o,
          opts: l
        };
      }).filter((s) => {
        const o = ve.getComponent(s.opts.componentClass || qt(s.name));
        return o && !r.isTech(o);
      }).forEach(a);
    }
  }
  /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */
  buildCSSClass() {
    return "";
  }
  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */
  ready(e, n = !1) {
    if (e) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
        return;
      }
      n ? e.call(this) : this.setTimeout(e, 1);
    }
  }
  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */
  triggerReady() {
    this.isReady_ = !0, this.setTimeout(function() {
      const e = this.readyQueue_;
      this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(n) {
        n.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }
  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $(e, n) {
    return tr(e, n || this.contentEl());
  }
  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $$(e, n) {
    return m3(e, n || this.contentEl());
  }
  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */
  hasClass(e) {
    return cl(this.el_, e);
  }
  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */
  addClass(...e) {
    Er(this.el_, ...e);
  }
  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */
  removeClass(...e) {
    gd(this.el_, ...e);
  }
  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */
  toggleClass(e, n) {
    o3(this.el_, e, n);
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    this.removeClass("vjs-hidden");
  }
  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */
  hide() {
    this.addClass("vjs-hidden");
  }
  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  lockShowing() {
    this.addClass("vjs-lock-showing");
  }
  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  unlockShowing() {
    this.removeClass("vjs-lock-showing");
  }
  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */
  getAttribute(e) {
    return c3(this.el_, e);
  }
  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */
  setAttribute(e, n) {
    Ys(this.el_, e, n);
  }
  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */
  removeAttribute(e) {
    bd(this.el_, e);
  }
  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */
  width(e, n) {
    return this.dimension("width", e, n);
  }
  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */
  height(e, n) {
    return this.dimension("height", e, n);
  }
  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */
  dimensions(e, n) {
    this.width(e, !0), this.height(n);
  }
  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */
  dimension(e, n, a) {
    if (n !== void 0) {
      (n === null || n !== n) && (n = 0), ("" + n).indexOf("%") !== -1 || ("" + n).indexOf("px") !== -1 ? this.el_.style[e] = n : n === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = n + "px", a || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    const i = this.el_.style[e], r = i.indexOf("px");
    return parseInt(r !== -1 ? i.slice(0, r) : this.el_["offset" + qt(e)], 10);
  }
  /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */
  currentDimension(e) {
    let n = 0;
    if (e !== "width" && e !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (n = Vs(this.el_, e), n = parseFloat(n), n === 0 || isNaN(n)) {
      const a = `offset${qt(e)}`;
      n = this.el_[a];
    }
    return n;
  }
  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */
  /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */
  currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }
  /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */
  currentWidth() {
    return this.currentDimension("width");
  }
  /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */
  currentHeight() {
    return this.currentDimension("height");
  }
  /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */
  getPositions() {
    const e = this.el_.getBoundingClientRect(), n = {
      x: e.x,
      y: e.y,
      width: e.width,
      height: e.height,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left
    }, a = {
      x: e.left + e.width / 2,
      y: e.top + e.height / 2,
      width: 0,
      height: 0,
      top: e.top + e.height / 2,
      right: e.left + e.width / 2,
      bottom: e.top + e.height / 2,
      left: e.left + e.width / 2
    };
    return {
      boundingClientRect: n,
      center: a
    };
  }
  /**
   * Set the focus to this component
   */
  focus() {
    this.el_.focus();
  }
  /**
   * Remove the focus from this component
   */
  blur() {
    this.el_.blur();
  }
  /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */
  handleKeyDown(e) {
    this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
  }
  /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */
  handleKeyPress(e) {
    this.handleKeyDown(e);
  }
  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */
  emitTapEvents() {
    let e = 0, n = null;
    const a = 10, i = 200;
    let r;
    this.on("touchstart", function(o) {
      o.touches.length === 1 && (n = {
        pageX: o.touches[0].pageX,
        pageY: o.touches[0].pageY
      }, e = Y.performance.now(), r = !0);
    }), this.on("touchmove", function(o) {
      if (o.touches.length > 1)
        r = !1;
      else if (n) {
        const l = o.touches[0].pageX - n.pageX, c = o.touches[0].pageY - n.pageY;
        Math.sqrt(l * l + c * c) > a && (r = !1);
      }
    });
    const s = function() {
      r = !1;
    };
    this.on("touchleave", s), this.on("touchcancel", s), this.on("touchend", function(o) {
      n = null, r === !0 && Y.performance.now() - e < i && (o.preventDefault(), this.trigger("tap"));
    });
  }
  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */
  enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity)
      return;
    const e = At(this.player(), this.player().reportUserActivity);
    let n;
    this.on("touchstart", function() {
      e(), this.clearInterval(n), n = this.setInterval(e, 250);
    });
    const a = function(i) {
      e(), this.clearInterval(n);
    };
    this.on("touchmove", e), this.on("touchend", a), this.on("touchcancel", a);
  }
  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */
  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */
  setTimeout(e, n) {
    var a;
    return e = At(this, e), this.clearTimersOnDispose_(), a = Y.setTimeout(() => {
      this.setTimeoutIds_.has(a) && this.setTimeoutIds_.delete(a), e();
    }, n), this.setTimeoutIds_.add(a), a;
  }
  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */
  clearTimeout(e) {
    return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), Y.clearTimeout(e)), e;
  }
  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */
  setInterval(e, n) {
    e = At(this, e), this.clearTimersOnDispose_();
    const a = Y.setInterval(e, n);
    return this.setIntervalIds_.add(a), a;
  }
  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */
  clearInterval(e) {
    return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), Y.clearInterval(e)), e;
  }
  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */
  requestAnimationFrame(e) {
    this.clearTimersOnDispose_();
    var n;
    return e = At(this, e), n = Y.requestAnimationFrame(() => {
      this.rafIds_.has(n) && this.rafIds_.delete(n), e();
    }), this.rafIds_.add(n), n;
  }
  /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */
  requestNamedAnimationFrame(e, n) {
    this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), n = At(this, n);
    const a = this.requestAnimationFrame(() => {
      n(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
    });
    return this.namedRafs_.set(e, a), e;
  }
  /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */
  cancelNamedAnimationFrame(e) {
    this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
  }
  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */
  cancelAnimationFrame(e) {
    return this.rafIds_.has(e) && (this.rafIds_.delete(e), Y.cancelAnimationFrame(e)), e;
  }
  /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */
  clearTimersOnDispose_() {
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(([e, n]) => {
        this[e].forEach((a, i) => this[n](i));
      }), this.clearingTimersOnDispose_ = !1;
    }));
  }
  /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */
  getIsDisabled() {
    return !!this.el_.disabled;
  }
  /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */
  getIsExpresslyInert() {
    return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
  }
  /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */
  getIsFocusable(e) {
    return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
  }
  /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */
  getIsAvailableToBeFocused(e) {
    function n(r) {
      const s = Y.getComputedStyle(r, null), o = s.getPropertyValue("visibility");
      return s.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(o);
    }
    function a(r) {
      return !(!n(r.parentElement) || !n(r) || r.style.opacity === "0" || Y.getComputedStyle(r).height === "0px" || Y.getComputedStyle(r).width === "0px");
    }
    function i(r) {
      if (r.offsetWidth + r.offsetHeight + r.getBoundingClientRect().height + r.getBoundingClientRect().width === 0)
        return !1;
      const s = {
        x: r.getBoundingClientRect().left + r.offsetWidth / 2,
        y: r.getBoundingClientRect().top + r.offsetHeight / 2
      };
      if (s.x < 0 || s.x > (Me.documentElement.clientWidth || Y.innerWidth) || s.y < 0 || s.y > (Me.documentElement.clientHeight || Y.innerHeight))
        return !1;
      let o = Me.elementFromPoint(s.x, s.y);
      for (; o; ) {
        if (o === r)
          return !0;
        if (o.parentNode)
          o = o.parentNode;
        else
          return !1;
      }
    }
    return e || (e = this.el()), !!(i(e) && a(e) && (!e.parentElement || e.tabIndex >= 0));
  }
  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */
  static registerComponent(e, n) {
    if (typeof e != "string" || !e)
      throw new Error(`Illegal component name, "${e}"; must be a non-empty string.`);
    const a = ve.getComponent("Tech"), i = a && a.isTech(n), r = ve === n || ve.prototype.isPrototypeOf(n.prototype);
    if (i || !r) {
      let o;
      throw i ? o = "techs must be registered using Tech.registerTech()" : o = "must be a Component subclass", new Error(`Illegal component, "${e}"; ${o}.`);
    }
    e = qt(e), ve.components_ || (ve.components_ = {});
    const s = ve.getComponent("Player");
    if (e === "Player" && s && s.players) {
      const o = s.players, l = Object.keys(o);
      if (o && l.length > 0 && l.map((c) => o[c]).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return ve.components_[e] = n, ve.components_[ul(e)] = n, n;
  }
  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */
  static getComponent(e) {
    if (!(!e || !ve.components_))
      return ve.components_[e];
  }
}
ve.registerComponent("Component", ve);
function Hte(t, e, n) {
  if (typeof e != "number" || e < 0 || e > n)
    throw new Error(`Failed to execute '${t}' on 'TimeRanges': The index provided (${e}) is non-numeric or out of bounds (0-${n}).`);
}
function eb(t, e, n, a) {
  return Hte(t, a, n.length - 1), n[a][e];
}
function k0(t) {
  let e;
  return t === void 0 || t.length === 0 ? e = {
    length: 0,
    start() {
      throw new Error("This TimeRanges object is empty");
    },
    end() {
      throw new Error("This TimeRanges object is empty");
    }
  } : e = {
    length: t.length,
    start: eb.bind(null, "start", 0, t),
    end: eb.bind(null, "end", 1, t)
  }, Y.Symbol && Y.Symbol.iterator && (e[Y.Symbol.iterator] = () => (t || []).values()), e;
}
function Pa(t, e) {
  return Array.isArray(t) ? k0(t) : t === void 0 || e === void 0 ? k0() : k0([[t, e]]);
}
const C3 = function(t, e) {
  t = t < 0 ? 0 : t;
  let n = Math.floor(t % 60), a = Math.floor(t / 60 % 60), i = Math.floor(t / 3600);
  const r = Math.floor(e / 60 % 60), s = Math.floor(e / 3600);
  return (isNaN(t) || t === 1 / 0) && (i = a = n = "-"), i = i > 0 || s > 0 ? i + ":" : "", a = ((i || r >= 10) && a < 10 ? "0" + a : a) + ":", n = n < 10 ? "0" + n : n, i + a + n;
};
let rp = C3;
function A3(t) {
  rp = t;
}
function E3() {
  rp = C3;
}
function Nr(t, e = t) {
  return rp(t, e);
}
var Yte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTimeRanges: Pa,
  createTimeRange: Pa,
  setFormatTime: A3,
  resetFormatTime: E3,
  formatTime: Nr
});
function L3(t, e) {
  let n = 0, a, i;
  if (!e)
    return 0;
  (!t || !t.length) && (t = Pa(0, 0));
  for (let r = 0; r < t.length; r++)
    a = t.start(r), i = t.end(r), i > e && (i = e), n += i - a;
  return n / e;
}
function Yt(t) {
  if (t instanceof Yt)
    return t;
  typeof t == "number" ? this.code = t : typeof t == "string" ? this.message = t : ni(t) && (typeof t.code == "number" && (this.code = t.code), Object.assign(this, t)), this.message || (this.message = Yt.defaultMessages[this.code] || "");
}
Yt.prototype.code = 0;
Yt.prototype.message = "";
Yt.prototype.status = null;
Yt.prototype.metadata = null;
Yt.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
Yt.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
Yt.MEDIA_ERR_CUSTOM = 0;
Yt.prototype.MEDIA_ERR_CUSTOM = 0;
Yt.MEDIA_ERR_ABORTED = 1;
Yt.prototype.MEDIA_ERR_ABORTED = 1;
Yt.MEDIA_ERR_NETWORK = 2;
Yt.prototype.MEDIA_ERR_NETWORK = 2;
Yt.MEDIA_ERR_DECODE = 3;
Yt.prototype.MEDIA_ERR_DECODE = 3;
Yt.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Yt.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
Yt.MEDIA_ERR_ENCRYPTED = 5;
Yt.prototype.MEDIA_ERR_ENCRYPTED = 5;
function dl(t) {
  return t != null && typeof t.then == "function";
}
function Xa(t) {
  dl(t) && t.then(null, (e) => {
  });
}
const xh = function(t) {
  return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce((n, a, i) => (t[a] && (n[a] = t[a]), n), {
    cues: t.cues && Array.prototype.map.call(t.cues, function(n) {
      return {
        startTime: n.startTime,
        endTime: n.endTime,
        text: n.text,
        id: n.id
      };
    })
  });
}, jte = function(t) {
  const e = t.$$("track"), n = Array.prototype.map.call(e, (i) => i.track);
  return Array.prototype.map.call(e, function(i) {
    const r = xh(i.track);
    return i.src && (r.src = i.src), r;
  }).concat(Array.prototype.filter.call(t.textTracks(), function(i) {
    return n.indexOf(i) === -1;
  }).map(xh));
}, Vte = function(t, e) {
  return t.forEach(function(n) {
    const a = e.addRemoteTextTrack(n).track;
    !n.src && n.cues && n.cues.forEach((i) => a.addCue(i));
  }), e.textTracks();
};
var tb = {
  textTracksToJson: jte,
  jsonToTextTracks: Vte,
  trackToJson_: xh
};
const S0 = "vjs-modal-dialog";
class co extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  constructor(e, n) {
    super(e, n), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.close_ = (a) => this.close(a), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = Je("div", {
      className: `${S0}-content`
    }, {
      role: "document"
    }), this.descEl_ = Je("p", {
      className: `${S0}-description vjs-control-text`,
      id: this.el().getAttribute("aria-describedby")
    }), lr(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
  }
  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": `${this.id()}_description`,
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog",
      "aria-live": "polite"
    });
  }
  dispose() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `${S0} vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */
  label() {
    return this.localize(this.options_.label || "Modal Window");
  }
  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */
  description() {
    let e = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
  }
  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */
  open() {
    if (this.opened_) {
      this.options_.fillAlways && this.fill();
      return;
    }
    const e = this.player();
    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
  }
  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */
  opened(e) {
    return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
  }
  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */
  close() {
    if (!this.opened_)
      return;
    const e = this.player();
    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
      type: "modalclose",
      bubbles: !0
    }), this.conditionalBlur_(), this.options_.temporary && this.dispose();
  }
  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */
  closeable(e) {
    if (typeof e == "boolean") {
      const n = this.closeable_ = !!e;
      let a = this.getChild("closeButton");
      if (n && !a) {
        const i = this.contentEl_;
        this.contentEl_ = this.el_, a = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = i, this.on(a, "close", this.close_);
      }
      !n && a && (this.off(a, "close", this.close_), this.removeChild(a), a.dispose());
    }
    return this.closeable_;
  }
  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */
  fill() {
    this.fillWith(this.content());
  }
  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */
  fillWith(e) {
    const n = this.contentEl(), a = n.parentNode, i = n.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, a.removeChild(n), this.empty(), p3(n, e), this.trigger("modalfill"), i ? a.insertBefore(n, i) : a.appendChild(n);
    const r = this.getChild("closeButton");
    r && a.appendChild(r.el_), this.trigger("aftermodalfill");
  }
  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */
  empty() {
    this.trigger("beforemodalempty"), yd(this.contentEl()), this.trigger("modalempty");
  }
  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */
  content(e) {
    return typeof e < "u" && (this.content_ = e), this.content_;
  }
  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */
  conditionalFocus_() {
    const e = Me.activeElement, n = this.player_.el_;
    this.previouslyActiveEl_ = null, (n.contains(e) || n === e) && (this.previouslyActiveEl_ = e, this.focus());
  }
  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */
  conditionalBlur_() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }
  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (this.trigger({
      type: "modalKeydown",
      originalEvent: e,
      target: this,
      bubbles: !0
    }), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
      e.preventDefault(), this.close();
      return;
    }
    if (e.key !== "Tab")
      return;
    const n = this.focusableEls_(), a = this.el_.querySelector(":focus");
    let i;
    for (let r = 0; r < n.length; r++)
      if (a === n[r]) {
        i = r;
        break;
      }
    Me.activeElement === this.el_ && (i = 0), e.shiftKey && i === 0 ? (n[n.length - 1].focus(), e.preventDefault()) : !e.shiftKey && i === n.length - 1 && (n[0].focus(), e.preventDefault());
  }
  /**
   * get all focusable elements
   *
   * @private
   */
  focusableEls_() {
    const e = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(e, (n) => (n instanceof Y.HTMLAnchorElement || n instanceof Y.HTMLAreaElement) && n.hasAttribute("href") || (n instanceof Y.HTMLInputElement || n instanceof Y.HTMLSelectElement || n instanceof Y.HTMLTextAreaElement || n instanceof Y.HTMLButtonElement) && !n.hasAttribute("disabled") || n instanceof Y.HTMLIFrameElement || n instanceof Y.HTMLObjectElement || n instanceof Y.HTMLEmbedElement || n.hasAttribute("tabindex") && n.getAttribute("tabindex") !== -1 || n.hasAttribute("contenteditable"));
  }
}
co.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
ve.registerComponent("ModalDialog", co);
class qs extends da {
  /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */
  constructor(e = []) {
    super(), this.tracks_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.tracks_.length;
      }
    });
    for (let n = 0; n < e.length; n++)
      this.addTrack(e[n]);
  }
  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    const n = this.tracks_.length;
    "" + n in this || Object.defineProperty(this, n, {
      get() {
        return this.tracks_[n];
      }
    }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
      track: e,
      type: "addtrack",
      target: this
    })), e.labelchange_ = () => {
      this.trigger({
        track: e,
        type: "labelchange",
        target: this
      });
    }, xi(e) && e.addEventListener("labelchange", e.labelchange_);
  }
  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */
  removeTrack(e) {
    let n;
    for (let a = 0, i = this.length; a < i; a++)
      if (this[a] === e) {
        n = this[a], n.off && n.off(), this.tracks_.splice(a, 1);
        break;
      }
    n && this.trigger({
      track: n,
      type: "removetrack",
      target: this
    });
  }
  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */
  getTrackById(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++) {
      const r = this[a];
      if (r.id === e) {
        n = r;
        break;
      }
    }
    return n;
  }
}
qs.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (const t in qs.prototype.allowedEvents_)
  qs.prototype["on" + t] = null;
const C0 = function(t, e) {
  for (let n = 0; n < t.length; n++)
    !Object.keys(t[n]).length || e.id === t[n].id || (t[n].enabled = !1);
};
class qte extends qs {
  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let n = e.length - 1; n >= 0; n--)
      if (e[n].enabled) {
        C0(e, e[n]);
        break;
      }
    super(e), this.changing_ = !1;
  }
  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.enabled && C0(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
      this.changing_ || (this.changing_ = !0, C0(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("enabledchange", e.enabledChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
  }
}
const A0 = function(t, e) {
  for (let n = 0; n < t.length; n++)
    !Object.keys(t[n]).length || e.id === t[n].id || (t[n].selected = !1);
};
class Wte extends qs {
  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let n = e.length - 1; n >= 0; n--)
      if (e[n].selected) {
        A0(e, e[n]);
        break;
      }
    super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
      get() {
        for (let n = 0; n < this.length; n++)
          if (this[n].selected)
            return n;
        return -1;
      },
      set() {
      }
    });
  }
  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.selected && A0(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
      this.changing_ || (this.changing_ = !0, A0(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("selectedchange", e.selectedChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
  }
}
class D3 extends qs {
  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    super.addTrack(e), this.queueChange_ || (this.queueChange_ = () => this.queueTrigger("change")), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }
}
class Gte {
  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  constructor(e = []) {
    this.trackElements_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.trackElements_.length;
      }
    });
    for (let n = 0, a = e.length; n < a; n++)
      this.addTrackElement_(e[n]);
  }
  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */
  addTrackElement_(e) {
    const n = this.trackElements_.length;
    "" + n in this || Object.defineProperty(this, n, {
      get() {
        return this.trackElements_[n];
      }
    }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
  }
  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */
  getTrackElementByTrack_(e) {
    let n;
    for (let a = 0, i = this.trackElements_.length; a < i; a++)
      if (e === this.trackElements_[a].track) {
        n = this.trackElements_[a];
        break;
      }
    return n;
  }
  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */
  removeTrackElement_(e) {
    for (let n = 0, a = this.trackElements_.length; n < a; n++)
      if (e === this.trackElements_[n]) {
        this.trackElements_[n].track && typeof this.trackElements_[n].track.off == "function" && this.trackElements_[n].track.off(), typeof this.trackElements_[n].off == "function" && this.trackElements_[n].off(), this.trackElements_.splice(n, 1);
        break;
      }
  }
}
class Tu {
  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  constructor(e) {
    Tu.prototype.setCues_.call(this, e), Object.defineProperty(this, "length", {
      get() {
        return this.length_;
      }
    });
  }
  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */
  setCues_(e) {
    const n = this.length || 0;
    let a = 0;
    const i = e.length;
    this.cues_ = e, this.length_ = e.length;
    const r = function(s) {
      "" + s in this || Object.defineProperty(this, "" + s, {
        get() {
          return this.cues_[s];
        }
      });
    };
    if (n < i)
      for (a = n; a < i; a++)
        r.call(this, a);
  }
  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */
  getCueById(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++) {
      const r = this[a];
      if (r.id === e) {
        n = r;
        break;
      }
    }
    return n;
  }
}
const Xte = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, Zte = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, Kte = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, nb = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
class sp extends da {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  constructor(e = {}) {
    super();
    const n = {
      id: e.id || "vjs_track_" + ya(),
      kind: e.kind || "",
      language: e.language || ""
    };
    let a = e.label || "";
    for (const i in n)
      Object.defineProperty(this, i, {
        get() {
          return n[i];
        },
        set() {
        }
      });
    Object.defineProperty(this, "label", {
      get() {
        return a;
      },
      set(i) {
        i !== a && (a = i, this.trigger("labelchange"));
      }
    });
  }
}
const op = function(t) {
  return new URL(t, Me.baseURI);
}, I3 = function(t) {
  return new URL(t, Me.baseURI).href;
}, lp = function(t) {
  if (typeof t == "string") {
    const n = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/.exec(t);
    if (n)
      return n.pop().toLowerCase();
  }
  return "";
}, wd = function(t, e = Y.location) {
  return op(t).origin !== e.origin;
};
var Qte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: op,
  getAbsoluteURL: I3,
  getFileExtension: lp,
  isCrossOrigin: wd
});
const ab = function(t, e) {
  const n = new Y.WebVTT.Parser(Y, Y.vttjs, Y.WebVTT.StringDecoder()), a = [];
  n.oncue = function(i) {
    e.addCue(i);
  }, n.onparsingerror = function(i) {
    a.push(i);
  }, n.onflush = function() {
    e.trigger({
      type: "loadeddata",
      target: e
    });
  }, n.parse(t), a.length > 0 && (Y.console && Y.console.groupCollapsed && Y.console.groupCollapsed(`Text Track parsing errors for ${e.src}`), a.forEach((i) => ct.error(i)), Y.console && Y.console.groupEnd && Y.console.groupEnd()), n.flush();
}, ib = function(t, e) {
  const n = {
    uri: t
  }, a = wd(t);
  a && (n.cors = a);
  const i = e.tech_.crossOrigin() === "use-credentials";
  i && (n.withCredentials = i), a5(n, At(this, function(r, s, o) {
    if (r)
      return ct.error(r, s);
    e.loaded_ = !0, typeof Y.WebVTT != "function" ? e.tech_ && e.tech_.any(["vttjsloaded", "vttjserror"], (l) => {
      if (l.type === "vttjserror") {
        ct.error(`vttjs failed to load, stopping trying to process ${e.src}`);
        return;
      }
      return ab(o, e);
    }) : ab(o, e);
  }));
};
class Vl extends sp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    if (!e.tech)
      throw new Error("A tech was not provided.");
    const n = Tt(e, {
      kind: Kte[e.kind] || "subtitles",
      language: e.language || e.srclang || ""
    });
    let a = nb[n.mode] || "disabled";
    const i = n.default;
    (n.kind === "metadata" || n.kind === "chapters") && (a = "hidden"), super(n), this.tech_ = n.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
    const r = new Tu(this.cues_), s = new Tu(this.activeCues_);
    let o = !1;
    this.timeupdateHandler = At(this, function(c = {}) {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          c.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, o && (this.trigger("cuechange"), o = !1), c.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    const l = () => {
      this.stopTracking();
    };
    this.tech_.one("dispose", l), a !== "disabled" && this.startTracking(), Object.defineProperties(this, {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get() {
          return i;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get() {
          return a;
        },
        set(c) {
          nb[c] && a !== c && (a = c, !this.preload_ && a !== "disabled" && this.cues.length === 0 && ib(this.src, this), this.stopTracking(), a !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get() {
          return this.loaded_ ? r : null;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return s;
          const c = this.tech_.currentTime(), d = [];
          for (let f = 0, g = this.cues.length; f < g; f++) {
            const _ = this.cues[f];
            _.startTime <= c && _.endTime >= c && d.push(_);
          }
          if (o = !1, d.length !== this.activeCues_.length)
            o = !0;
          else
            for (let f = 0; f < d.length; f++)
              this.activeCues_.indexOf(d[f]) === -1 && (o = !0);
          return this.activeCues_ = d, s.setCues_(this.activeCues_), s;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set() {
        }
      }
    }), n.src ? (this.src = n.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || n.kind !== "subtitles" && n.kind !== "captions") && ib(this.src, this)) : this.loaded_ = !0;
  }
  startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }
  stopTracking() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }
  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */
  addCue(e) {
    let n = e;
    if (!("getCueAsHTML" in n)) {
      n = new Y.vttjs.VTTCue(e.startTime, e.endTime, e.text);
      for (const i in e)
        i in n || (n[i] = e[i]);
      n.id = e.id, n.originalCue_ = e;
    }
    const a = this.tech_.textTracks();
    for (let i = 0; i < a.length; i++)
      a[i] !== this && a[i].removeCue(n);
    this.cues_.push(n), this.cues.setCues_(this.cues_);
  }
  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */
  removeCue(e) {
    let n = this.cues_.length;
    for (; n--; ) {
      const a = this.cues_[n];
      if (a === e || a.originalCue_ && a.originalCue_ === e) {
        this.cues_.splice(n, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }
}
Vl.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
class M3 extends sp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  constructor(e = {}) {
    const n = Tt(e, {
      kind: Zte[e.kind] || ""
    });
    super(n);
    let a = !1;
    Object.defineProperty(this, "enabled", {
      get() {
        return a;
      },
      set(i) {
        typeof i != "boolean" || i === a || (a = i, this.trigger("enabledchange"));
      }
    }), n.enabled && (this.enabled = n.enabled), this.loaded_ = !0;
  }
}
class O3 extends sp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  constructor(e = {}) {
    const n = Tt(e, {
      kind: Xte[e.kind] || ""
    });
    super(n);
    let a = !1;
    Object.defineProperty(this, "selected", {
      get() {
        return a;
      },
      set(i) {
        typeof i != "boolean" || i === a || (a = i, this.trigger("selectedchange"));
      }
    }), n.selected && (this.selected = n.selected);
  }
}
class Ci extends da {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    super();
    let n;
    const a = new Vl(e);
    this.kind = a.kind, this.src = a.src, this.srclang = a.language, this.label = a.label, this.default = a.default, Object.defineProperties(this, {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get() {
          return n;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get() {
          return a;
        }
      }
    }), n = Ci.NONE, a.addEventListener("loadeddata", () => {
      n = Ci.LOADED, this.trigger({
        type: "load",
        target: this
      });
    });
  }
}
Ci.prototype.allowedEvents_ = {
  load: "load"
};
Ci.NONE = 0;
Ci.LOADING = 1;
Ci.LOADED = 2;
Ci.ERROR = 3;
const va = {
  audio: {
    ListClass: qte,
    TrackClass: M3,
    capitalName: "Audio"
  },
  video: {
    ListClass: Wte,
    TrackClass: O3,
    capitalName: "Video"
  },
  text: {
    ListClass: D3,
    TrackClass: Vl,
    capitalName: "Text"
  }
};
Object.keys(va).forEach(function(t) {
  va[t].getterName = `${t}Tracks`, va[t].privateName = `${t}Tracks_`;
});
const Ws = {
  remoteText: {
    ListClass: D3,
    TrackClass: Vl,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: Gte,
    TrackClass: Ci,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, Rn = Object.assign({}, va, Ws);
Ws.names = Object.keys(Ws);
va.names = Object.keys(va);
Rn.names = [].concat(Ws.names).concat(va.names);
function Jte(t, e, n, a, i = {}) {
  const r = t.textTracks();
  i.kind = e, n && (i.label = n), a && (i.language = a), i.tech = t;
  const s = new Rn.text.TrackClass(i);
  return r.addTrack(s), s;
}
class rt extends ve {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e = {}, n = function() {
  }) {
    e.reportTouchActivity = !1, super(null, e, n), this.onDurationChange_ = (a) => this.onDurationChange(a), this.trackProgress_ = (a) => this.trackProgress(a), this.trackCurrentTime_ = (a) => this.trackCurrentTime(a), this.stopTrackingCurrentTime_ = (a) => this.stopTrackingCurrentTime(a), this.disposeSourceHandler_ = (a) => this.disposeSourceHandler(a), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
      this.hasStarted_ = !0;
    }), this.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), Rn.names.forEach((a) => {
      const i = Rn[a];
      e && e[i.getterName] && (this[i.privateName] = e[i.getterName]);
    }), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach((a) => {
      e[`native${a}Tracks`] === !1 && (this[`featuresNative${a}Tracks`] = !1);
    }), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new Rn.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
  }
  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */
  triggerSourceset(e) {
    this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
      src: e,
      type: "sourceset"
    });
  }
  /* Fallbacks for unsupported event types
  ================================================================================ */
  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */
  manualProgressOn() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */
  manualProgressOff() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }
  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */
  trackProgress(e) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(At(this, function() {
      const n = this.bufferedPercent();
      this.bufferedPercent_ !== n && this.trigger("progress"), this.bufferedPercent_ = n, n === 1 && this.stopTrackingProgress();
    }), 500);
  }
  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */
  onDurationChange(e) {
    this.duration_ = this.duration();
  }
  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */
  buffered() {
    return Pa(0, 0);
  }
  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */
  bufferedPercent() {
    return L3(this.buffered(), this.duration_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */
  stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  }
  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */
  manualTimeUpdatesOn() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */
  manualTimeUpdatesOff() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */
  trackCurrentTime() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }
  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */
  stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */
  dispose() {
    this.clearTracks(va.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
  }
  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */
  clearTracks(e) {
    e = [].concat(e), e.forEach((n) => {
      const a = this[`${n}Tracks`]() || [];
      let i = a.length;
      for (; i--; ) {
        const r = a[i];
        n === "text" && this.removeRemoteTextTrack(r), a.removeTrack(r);
      }
    });
  }
  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */
  cleanupAutoTextTracks() {
    const e = this.autoRemoteTextTracks_ || [];
    let n = e.length;
    for (; n--; ) {
      const a = e[n];
      this.removeRemoteTextTrack(a);
    }
  }
  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */
  reset() {
  }
  /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */
  crossOrigin() {
  }
  /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */
  setCrossOrigin() {
  }
  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */
  error(e) {
    return e !== void 0 && (this.error_ = new Yt(e), this.trigger("error")), this.error_;
  }
  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */
  played() {
    return this.hasStarted_ ? Pa(0, 0) : Pa();
  }
  /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */
  play() {
  }
  /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */
  setScrubbing(e) {
  }
  /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */
  scrubbing() {
  }
  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */
  setCurrentTime(e) {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */
  initTrackListeners() {
    va.names.forEach((e) => {
      const n = va[e], a = () => {
        this.trigger(`${e}trackchange`);
      }, i = this[n.getterName]();
      i.addEventListener("removetrack", a), i.addEventListener("addtrack", a), this.on("dispose", () => {
        i.removeEventListener("removetrack", a), i.removeEventListener("addtrack", a);
      });
    });
  }
  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */
  addWebVttScript_() {
    if (!Y.WebVTT)
      if (Me.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && Hs(xg) && Object.keys(xg).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        const e = Me.createElement("script");
        e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
          this.trigger("vttjsloaded");
        }, e.onerror = () => {
          this.trigger("vttjserror");
        }, this.on("dispose", () => {
          e.onload = null, e.onerror = null;
        }), Y.WebVTT = !0, this.el().parentNode.appendChild(e);
      } else
        this.ready(this.addWebVttScript_);
  }
  /**
   * Emulate texttracks
   *
   */
  emulateTextTracks() {
    const e = this.textTracks(), n = this.remoteTextTracks(), a = (o) => e.addTrack(o.track), i = (o) => e.removeTrack(o.track);
    n.on("addtrack", a), n.on("removetrack", i), this.addWebVttScript_();
    const r = () => this.trigger("texttrackchange"), s = () => {
      r();
      for (let o = 0; o < e.length; o++) {
        const l = e[o];
        l.removeEventListener("cuechange", r), l.mode === "showing" && l.addEventListener("cuechange", r);
      }
    };
    s(), e.addEventListener("change", s), e.addEventListener("addtrack", s), e.addEventListener("removetrack", s), this.on("dispose", function() {
      n.off("addtrack", a), n.off("removetrack", i), e.removeEventListener("change", s), e.removeEventListener("addtrack", s), e.removeEventListener("removetrack", s);
      for (let o = 0; o < e.length; o++)
        e[o].removeEventListener("cuechange", r);
    });
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, n, a) {
    if (!e)
      throw new Error("TextTrack kind is required but was not provided");
    return Jte(this, e, n, a);
  }
  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    const n = Tt(e, {
      tech: this
    });
    return new Ws.remoteTextEl.TrackClass(n);
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */
  addRemoteTextTrack(e = {}, n) {
    const a = this.createRemoteTextTrack(e);
    return typeof n != "boolean" && (n = !1), this.remoteTextTrackEls().addTrackElement_(a), this.remoteTextTracks().addTrack(a.track), n === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(a.track)), a;
  }
  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */
  removeRemoteTextTrack(e) {
    const n = this.remoteTextTrackEls().getTrackElementByTrack_(e);
    this.remoteTextTrackEls().removeTrackElement_(n), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */
  getVideoPlaybackQuality() {
    return {};
  }
  /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */
  requestPictureInPicture() {
    return Promise.reject();
  }
  /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */
  disablePictureInPicture() {
    return !0;
  }
  /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */
  setDisablePictureInPicture() {
  }
  /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */
  requestVideoFrameCallback(e) {
    const n = ya();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(n), this.one("playing", () => {
      this.queuedHanders_.has(n) && (this.queuedHanders_.delete(n), e());
    })) : this.requestNamedAnimationFrame(n, e), n;
  }
  /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */
  cancelVideoFrameCallback(e) {
    this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
  }
  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */
  setPoster() {
  }
  /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  playsinline() {
  }
  /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  setPlaysinline() {
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */
  overrideNativeAudioTracks(e) {
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */
  overrideNativeVideoTracks(e) {
  }
  /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */
  canPlayType(e) {
    return "";
  }
  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */
  static canPlayType(e) {
    return "";
  }
  /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */
  static canPlaySource(e, n) {
    return rt.canPlayType(e.type);
  }
  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */
  static isTech(e) {
    return e.prototype instanceof rt || e instanceof rt || e === rt;
  }
  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */
  static registerTech(e, n) {
    if (rt.techs_ || (rt.techs_ = {}), !rt.isTech(n))
      throw new Error(`Tech ${e} must be a Tech`);
    if (!rt.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!rt.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return e = qt(e), rt.techs_[e] = n, rt.techs_[ul(e)] = n, e !== "Tech" && rt.defaultTechOrder_.push(e), n;
  }
  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */
  static getTech(e) {
    if (e) {
      if (rt.techs_ && rt.techs_[e])
        return rt.techs_[e];
      if (e = qt(e), Y && Y.videojs && Y.videojs[e])
        return ct.warn(`The ${e} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), Y.videojs[e];
    }
  }
}
Rn.names.forEach(function(t) {
  const e = Rn[t];
  rt.prototype[e.getterName] = function() {
    return this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName];
  };
});
rt.prototype.featuresVolumeControl = !0;
rt.prototype.featuresMuteControl = !0;
rt.prototype.featuresFullscreenResize = !1;
rt.prototype.featuresPlaybackRate = !1;
rt.prototype.featuresProgressEvents = !1;
rt.prototype.featuresSourceset = !1;
rt.prototype.featuresTimeupdateEvents = !1;
rt.prototype.featuresNativeTextTracks = !1;
rt.prototype.featuresVideoFrameCallback = !1;
rt.withSourceHandlers = function(t) {
  t.registerSourceHandler = function(n, a) {
    let i = t.sourceHandlers;
    i || (i = t.sourceHandlers = []), a === void 0 && (a = i.length), i.splice(a, 0, n);
  }, t.canPlayType = function(n) {
    const a = t.sourceHandlers || [];
    let i;
    for (let r = 0; r < a.length; r++)
      if (i = a[r].canPlayType(n), i)
        return i;
    return "";
  }, t.selectSourceHandler = function(n, a) {
    const i = t.sourceHandlers || [];
    let r;
    for (let s = 0; s < i.length; s++)
      if (r = i[s].canHandleSource(n, a), r)
        return i[s];
    return null;
  }, t.canPlaySource = function(n, a) {
    const i = t.selectSourceHandler(n, a);
    return i ? i.canHandleSource(n, a) : "";
  }, ["seekable", "seeking", "duration"].forEach(function(n) {
    const a = this[n];
    typeof a == "function" && (this[n] = function() {
      return this.sourceHandler_ && this.sourceHandler_[n] ? this.sourceHandler_[n].apply(this.sourceHandler_, arguments) : a.apply(this, arguments);
    });
  }, t.prototype), t.prototype.setSource = function(n) {
    let a = t.selectSourceHandler(n, this.options_);
    a || (t.nativeSourceHandler ? a = t.nativeSourceHandler : ct.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), a !== t.nativeSourceHandler && (this.currentSource_ = n), this.sourceHandler_ = a.handleSource(n, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, t.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
ve.registerComponent("Tech", rt);
rt.registerTech("Tech", rt);
rt.defaultTechOrder_ = [];
const Lr = {}, wu = {}, ku = {};
function ene(t, e) {
  Lr[t] = Lr[t] || [], Lr[t].push(e);
}
function tne(t, e, n) {
  t.setTimeout(() => vr(e, Lr[e.type], n, t), 1);
}
function nne(t, e) {
  t.forEach((n) => n.setTech && n.setTech(e));
}
function ane(t, e, n) {
  return t.reduceRight(cp(n), e[n]());
}
function ine(t, e, n, a) {
  return e[n](t.reduce(cp(n), a));
}
function rb(t, e, n, a = null) {
  const i = "call" + qt(n), r = t.reduce(cp(i), a), s = r === ku, o = s ? null : e[n](r);
  return one(t, n, o, s), o;
}
const rne = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, sne = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, sb = {
  play: 1,
  pause: 1
};
function cp(t) {
  return (e, n) => e === ku ? ku : n[t] ? n[t](e) : e;
}
function one(t, e, n, a) {
  for (let i = t.length - 1; i >= 0; i--) {
    const r = t[i];
    r[e] && r[e](a, n);
  }
}
function lne(t) {
  wu.hasOwnProperty(t.id()) && delete wu[t.id()];
}
function cne(t, e) {
  const n = wu[t.id()];
  let a = null;
  if (n == null)
    return a = e(t), wu[t.id()] = [[e, a]], a;
  for (let i = 0; i < n.length; i++) {
    const [r, s] = n[i];
    r === e && (a = s);
  }
  return a === null && (a = e(t), n.push([e, a])), a;
}
function vr(t = {}, e = [], n, a, i = [], r = !1) {
  const [s, ...o] = e;
  if (typeof s == "string")
    vr(t, Lr[s], n, a, i, r);
  else if (s) {
    const l = cne(a, s);
    if (!l.setSource)
      return i.push(l), vr(t, o, n, a, i, r);
    l.setSource(Object.assign({}, t), function(c, d) {
      if (c)
        return vr(t, o, n, a, i, r);
      i.push(l), vr(d, t.type === d.type ? o : Lr[d.type], n, a, i, r);
    });
  } else o.length ? vr(t, o, n, a, i, r) : r ? n(t, i) : vr(t, Lr["*"], n, a, i, !0);
}
const une = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, Su = function(t = "") {
  const e = lp(t);
  return une[e.toLowerCase()] || "";
}, dne = (t, e) => {
  if (!e)
    return "";
  if (t.cache_.source.src === e && t.cache_.source.type)
    return t.cache_.source.type;
  const n = t.cache_.sources.filter((i) => i.src === e);
  if (n.length)
    return n[0].type;
  const a = t.$$("source");
  for (let i = 0; i < a.length; i++) {
    const r = a[i];
    if (r.type && r.src && r.src === e)
      return r.type;
  }
  return Su(e);
}, P3 = function(t) {
  if (Array.isArray(t)) {
    let e = [];
    t.forEach(function(n) {
      n = P3(n), Array.isArray(n) ? e = e.concat(n) : ni(n) && e.push(n);
    }), t = e;
  } else typeof t == "string" && t.trim() ? t = [ob({
    src: t
  })] : ni(t) && typeof t.src == "string" && t.src && t.src.trim() ? t = [ob(t)] : t = [];
  return t;
};
function ob(t) {
  if (!t.type) {
    const e = Su(t.src);
    e && (t.type = e);
  }
  return t;
}
var hne = `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play">
      <path d="M16 10v28l22-14z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">
      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">
      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">
      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">
      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">
      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">
      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">
      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">
      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">
      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">
      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">
      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">
      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>
    </symbol>
    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">
      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>
    </symbol>
    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">
      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">
      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">
      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">
      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-share">
      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">
      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-square">
      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">
      <circle cx="24" cy="24" r="20"></circle>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">
      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">
      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">
      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">
      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">
      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">
      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">
      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">
      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">
      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>
    </symbol>
    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">
      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">
      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">
      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">
      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">
      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">
      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>
    </symbol>
    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">
      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>
      <path fill="none" d="M-1-3h24v24H-1z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">
      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">
      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>
    </symbol>
    <symbol viewBox="0 0 1200 1227" id="vjs-icon-twitter">
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">
      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">
      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>
    </symbol>
  </defs>
</svg>`;
const lb = vu ? 10009 : yu ? 461 : 8, ss = {
  codes: {
    play: 415,
    pause: 19,
    ff: 417,
    rw: 412,
    back: lb
  },
  names: {
    415: "play",
    19: "pause",
    417: "ff",
    412: "rw",
    [lb]: "back"
  },
  isEventKey(t, e) {
    return e = e.toLowerCase(), !!(this.names[t.keyCode] && this.names[t.keyCode] === e);
  },
  getEventName(t) {
    if (this.names[t.keyCode])
      return this.names[t.keyCode];
    if (this.codes[t.code]) {
      const e = this.codes[t.code];
      return this.names[e];
    }
    return null;
  }
}, cb = 5;
class fne extends da {
  /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */
  constructor(e) {
    super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
  }
  /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */
  start() {
    this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
      this.focus(this.updateFocusableComponents()[0]);
    }), this.player_.on("modalclose", () => {
      this.refocusComponent();
    }), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
      this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
    }));
  }
  /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */
  stop() {
    this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
  }
  /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */
  onKeyDown_(e) {
    const n = e.originalEvent ? e.originalEvent : e;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(n.key)) {
      if (this.isPaused_)
        return;
      n.preventDefault();
      const a = n.key.substring(5).toLowerCase();
      this.move(a);
    } else if (ss.isEventKey(n, "play") || ss.isEventKey(n, "pause") || ss.isEventKey(n, "ff") || ss.isEventKey(n, "rw")) {
      n.preventDefault();
      const a = ss.getEventName(n);
      this.performMediaAction_(a);
    } else ss.isEventKey(n, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (n.preventDefault(), e.target.close());
  }
  /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */
  performMediaAction_(e) {
    if (this.player_)
      switch (e) {
        case "play":
          this.player_.paused() && this.player_.play();
          break;
        case "pause":
          this.player_.paused() || this.player_.pause();
          break;
        case "ff":
          this.userSeek_(this.player_.currentTime() + cb);
          break;
        case "rw":
          this.userSeek_(this.player_.currentTime() - cb);
          break;
      }
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */
  pause() {
    this.isPaused_ = !0;
  }
  /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */
  resume() {
    this.isPaused_ = !1;
  }
  /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */
  handlePlayerBlur_(e) {
    const n = e.relatedTarget;
    let a = null;
    const i = this.getCurrentComponent(e.target);
    n && (a = !!n.closest(".video-js"), n.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !a || !n) && (i && i.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), i && i.el() && (this.lastFocusedComponent_ = i)));
  }
  /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */
  handlePlayerFocus_() {
    this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
  }
  /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */
  updateFocusableComponents() {
    const e = this.player_, n = [];
    function a(i) {
      for (const r of i)
        r.hasOwnProperty("el_") && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el()) && n.push(r), r.hasOwnProperty("children_") && r.children_.length > 0 && a(r.children_);
    }
    return e.children_.forEach((i) => {
      if (i.hasOwnProperty("el_"))
        if (i.getIsFocusable && i.getIsAvailableToBeFocused && i.getIsFocusable() && i.getIsAvailableToBeFocused(i.el())) {
          n.push(i);
          return;
        } else i.hasOwnProperty("children_") && i.children_.length > 0 ? a(i.children_) : i.hasOwnProperty("items") && i.items.length > 0 ? a(i.items) : this.findSuitableDOMChild(i) && n.push(i);
      if (i.name_ === "ErrorDisplay" && i.opened_) {
        const r = i.el_.querySelector(".vjs-errors-ok-button-container");
        r && r.querySelectorAll("button").forEach((o, l) => {
          n.push({
            name: () => "ModalButton" + (l + 1),
            el: () => o,
            getPositions: () => {
              const c = o.getBoundingClientRect(), d = {
                x: c.x,
                y: c.y,
                width: c.width,
                height: c.height,
                top: c.top,
                right: c.right,
                bottom: c.bottom,
                left: c.left
              }, f = {
                x: c.left + c.width / 2,
                y: c.top + c.height / 2,
                width: 0,
                height: 0,
                top: c.top + c.height / 2,
                right: c.left + c.width / 2,
                bottom: c.top + c.height / 2,
                left: c.left + c.width / 2
              };
              return {
                boundingClientRect: d,
                center: f
              };
            },
            // Asume that the following are always focusable
            getIsAvailableToBeFocused: () => !0,
            getIsFocusable: (c) => !0,
            focus: () => o.focus()
          });
        });
      }
    }), this.focusableComponents = n, this.focusableComponents;
  }
  /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */
  findSuitableDOMChild(e) {
    function n(a) {
      if (e.getIsFocusable(a) && e.getIsAvailableToBeFocused(a))
        return a;
      for (let i = 0; i < a.children.length; i++) {
        const r = a.children[i], s = n(r);
        if (s)
          return s;
      }
      return null;
    }
    return e.el() ? n(e.el()) : null;
  }
  /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */
  getCurrentComponent(e) {
    this.updateFocusableComponents();
    const n = e || document.activeElement;
    if (this.focusableComponents.length) {
      for (const a of this.focusableComponents)
        if (a.el() === n)
          return a;
    }
  }
  /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */
  add(e) {
    const n = [...this.focusableComponents];
    e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && n.push(e), this.focusableComponents = n, this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    });
  }
  /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */
  remove(e) {
    for (let n = 0; n < this.focusableComponents.length; n++)
      if (this.focusableComponents[n].name() === e.name()) {
        this.focusableComponents.splice(n, 1), this.trigger({
          type: "focusableComponentsChanged",
          focusableComponents: this.focusableComponents
        });
        return;
      }
  }
  /**
   * Clears array of focusable components.
   */
  clear() {
    this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    }));
  }
  /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */
  move(e) {
    const n = this.getCurrentComponent();
    if (!n)
      return;
    const a = n.getPositions(), i = this.focusableComponents.filter((s) => s !== n && this.isInDirection_(a.boundingClientRect, s.getPositions().boundingClientRect, e)), r = this.findBestCandidate_(a.center, i, e);
    r ? this.focus(r) : this.trigger({
      type: "endOfFocusableComponents",
      direction: e,
      focusedComponent: n
    });
  }
  /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */
  findBestCandidate_(e, n, a) {
    let i = 1 / 0, r = null;
    for (const s of n) {
      const o = s.getPositions().center, l = this.calculateDistance_(e, o, a);
      l < i && (i = l, r = s);
    }
    return r;
  }
  /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */
  isInDirection_(e, n, a) {
    switch (a) {
      case "right":
        return n.left >= e.right;
      case "left":
        return n.right <= e.left;
      case "down":
        return n.top >= e.bottom;
      case "up":
        return n.bottom <= e.top;
      default:
        return !1;
    }
  }
  /**
   * Focus the last focused component saved before blur on player.
   */
  refocusComponent() {
    if (this.lastFocusedComponent_) {
      this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
      for (let e = 0; e < this.focusableComponents.length; e++)
        if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
          this.focus(this.focusableComponents[e]);
          return;
        }
    } else
      this.focus(this.updateFocusableComponents()[0]);
  }
  /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */
  focus(e) {
    typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
  }
  /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */
  calculateDistance_(e, n, a) {
    const i = Math.abs(e.x - n.x), r = Math.abs(e.y - n.y);
    let s;
    switch (a) {
      case "right":
      case "left":
        s = i + r * 100;
        break;
      case "up":
        s = r * 2 + i * 0.5;
        break;
      case "down":
        s = r * 5 + i;
        break;
      default:
        s = i + r;
    }
    return s;
  }
  /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */
  searchForTrackSelect_() {
    const e = this;
    for (const n of e.updateFocusableComponents())
      if (n.constructor.name === "TextTrackSelect") {
        e.focus(n);
        break;
      }
  }
}
class pne extends ve {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */
  constructor(e, n, a) {
    const i = Tt({
      createEl: !1
    }, n);
    if (super(e, i, a), !n.playerOptions.sources || n.playerOptions.sources.length === 0)
      for (let r = 0, s = n.playerOptions.techOrder; r < s.length; r++) {
        const o = qt(s[r]);
        let l = rt.getTech(o);
        if (o || (l = ve.getComponent(o)), l && l.isSupported()) {
          e.loadTech_(o);
          break;
        }
      }
    else
      e.src(n.playerOptions.sources);
  }
}
ve.registerComponent("MediaLoader", pne);
class kd extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */
  constructor(e, n) {
    super(e, n), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (a) => this.handleMouseOver(a), this.handleMouseOut_ = (a) => this.handleMouseOut(a), this.handleClick_ = (a) => this.handleClick(a), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.emitTapEvents(), this.enable();
  }
  /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e = "div", n = {}, a = {}) {
    n = Object.assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, n), e === "button" && ct.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), a = Object.assign({
      role: "button"
    }, a), this.tabIndex_ = n.tabIndex;
    const i = Je(e, n, a);
    return this.player_.options_.experimentalSvgIcons || i.appendChild(Je("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(i), i;
  }
  dispose() {
    this.controlTextEl_ = null, super.dispose();
  }
  /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */
  createControlTextEl(e) {
    return this.controlTextEl_ = Je("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
  }
  /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, n = this.el()) {
    if (e === void 0)
      return this.controlText_ || "Need Text";
    const a = this.localize(e);
    this.controlText_ = e, lr(this.controlTextEl_, a), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && n.setAttribute("title", a);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-control vjs-button ${super.buildCSSClass()}`;
  }
  /**
   * Enable this `ClickableComponent`
   */
  enable() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }
  /**
   * Disable this `ClickableComponent`
   */
  disable() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }
  /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */
  handleLanguagechange() {
    this.controlText(this.controlText_);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */
  handleClick(e) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
ve.registerComponent("ClickableComponent", kd);
class Th extends kd {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update(), this.update_ = (a) => this.update(a), e.on("posterchange", this.update_);
  }
  /**
   * Clean up and dispose of the `PosterImage`.
   */
  dispose() {
    this.player().off("posterchange", this.update_), super.dispose();
  }
  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return Je("div", {
      className: "vjs-poster"
    });
  }
  /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.$("img") && (this.$("img").crossOrigin = e);
  }
  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */
  update(e) {
    const n = this.player().poster();
    this.setSrc(n), n ? this.show() : this.hide();
  }
  /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */
  setSrc(e) {
    if (!e) {
      this.el_.textContent = "";
      return;
    }
    this.$("img") || this.el_.appendChild(Je("picture", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    }, {}, Je("img", {
      loading: "lazy",
      crossOrigin: this.crossOrigin()
    }, {
      alt: ""
    }))), this.$("img").src = e;
  }
  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */
  handleClick(e) {
    this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? Xa(this.player_.play()) : this.player_.pause());
  }
}
Th.prototype.crossorigin = Th.prototype.crossOrigin;
ve.registerComponent("PosterImage", Th);
const pa = "#222", ub = "#ccc", mne = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function E0(t, e) {
  let n;
  if (t.length === 4)
    n = t[1] + t[1] + t[2] + t[2] + t[3] + t[3];
  else if (t.length === 7)
    n = t.slice(1);
  else
    throw new Error("Invalid color code provided, " + t + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(n.slice(0, 2), 16) + "," + parseInt(n.slice(2, 4), 16) + "," + parseInt(n.slice(4, 6), 16) + "," + e + ")";
}
function Ya(t, e, n) {
  try {
    t.style[e] = n;
  } catch {
    return;
  }
}
function db(t) {
  return t ? `${t}px` : "";
}
class gne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  constructor(e, n, a) {
    super(e, n, a);
    const i = (s) => this.updateDisplay(s), r = (s) => {
      this.updateDisplayOverlay(), this.updateDisplay(s);
    };
    e.on("loadstart", (s) => this.toggleDisplay(s)), e.on("texttrackchange", i), e.on("loadedmetadata", (s) => {
      this.updateDisplayOverlay(), this.preselectTrack(s);
    }), e.ready(At(this, function() {
      if (e.tech_ && e.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      e.on("fullscreenchange", r), e.on("playerresize", r);
      const s = Y.screen.orientation || Y, o = Y.screen.orientation ? "change" : "orientationchange";
      s.addEventListener(o, r), e.on("dispose", () => s.removeEventListener(o, r));
      const l = this.options_.playerOptions.tracks || [];
      for (let c = 0; c < l.length; c++)
        this.player_.addRemoteTextTrack(l[c], !0);
      this.preselectTrack();
    }));
  }
  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */
  preselectTrack() {
    const e = {
      captions: 1,
      subtitles: 1
    }, n = this.player_.textTracks(), a = this.player_.cache_.selectedLanguage;
    let i, r, s;
    for (let o = 0; o < n.length; o++) {
      const l = n[o];
      a && a.enabled && a.language && a.language === l.language && l.kind in e ? l.kind === a.kind ? s = l : s || (s = l) : a && !a.enabled ? (s = null, i = null, r = null) : l.default && (l.kind === "descriptions" && !i ? i = l : l.kind in e && !r && (r = l));
    }
    s ? s.mode = "showing" : r ? r.mode = "showing" : i && (i.mode = "showing");
  }
  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */
  toggleDisplay() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }
  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }
  /**
   * Clear all displayed {@link TextTrack}s.
   */
  clearDisplay() {
    typeof Y.WebVTT == "function" && Y.WebVTT.processCues(Y, [], this.el_);
  }
  /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */
  updateDisplay() {
    const e = this.player_.textTracks(), n = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), n) {
      const s = [];
      for (let o = 0; o < e.length; ++o) {
        const l = e[o];
        l.mode === "showing" && s.push(l);
      }
      this.updateForTrack(s);
      return;
    }
    let a = null, i = null, r = e.length;
    for (; r--; ) {
      const s = e[r];
      s.mode === "showing" && (s.kind === "descriptions" ? a = s : i = s);
    }
    if (i ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(i)) : a && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(a)), !Y.CSS.supports("inset", "10px")) {
      const s = this.el_, o = s.querySelectorAll(".vjs-text-track-cue"), l = this.player_.controlBar.el_.getBoundingClientRect().height, c = this.player_.el_.getBoundingClientRect().height;
      s.style = "", Ya(s, "position", "relative"), Ya(s, "height", c - l + "px"), Ya(s, "top", "unset"), _u ? Ya(s, "bottom", c + "px") : Ya(s, "bottom", "0px"), o.length > 0 && o.forEach((d) => {
        if (d.style.inset) {
          const f = d.style.inset.split(" ");
          f.length === 3 && Object.assign(d.style, {
            top: f[0],
            right: f[1],
            bottom: f[2],
            left: "unset"
          });
        }
      });
    }
  }
  /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */
  updateDisplayOverlay() {
    if (!this.player_.videoHeight() || !Y.CSS.supports("inset-inline: 10px"))
      return;
    const e = this.player_.currentWidth(), n = this.player_.currentHeight(), a = e / n, i = this.player_.videoWidth() / this.player_.videoHeight();
    let r = 0, s = 0;
    Math.abs(a - i) > 0.1 && (a > i ? r = Math.round((e - n * i) / 2) : s = Math.round((n - e / i) / 2)), Ya(this.el_, "insetInline", db(r)), Ya(this.el_, "insetBlock", db(s));
  }
  /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */
  updateDisplayState(e) {
    const n = this.player_.textTrackSettings.getValues(), a = e.activeCues;
    let i = a.length;
    for (; i--; ) {
      const r = a[i];
      if (!r)
        continue;
      const s = r.displayState;
      if (n.color && (s.firstChild.style.color = n.color), n.textOpacity && Ya(s.firstChild, "color", E0(n.color || "#fff", n.textOpacity)), n.backgroundColor && (s.firstChild.style.backgroundColor = n.backgroundColor), n.backgroundOpacity && Ya(s.firstChild, "backgroundColor", E0(n.backgroundColor || "#000", n.backgroundOpacity)), n.windowColor && (n.windowOpacity ? Ya(s, "backgroundColor", E0(n.windowColor, n.windowOpacity)) : s.style.backgroundColor = n.windowColor), n.edgeStyle && (n.edgeStyle === "dropshadow" ? s.firstChild.style.textShadow = `2px 2px 3px ${pa}, 2px 2px 4px ${pa}, 2px 2px 5px ${pa}` : n.edgeStyle === "raised" ? s.firstChild.style.textShadow = `1px 1px ${pa}, 2px 2px ${pa}, 3px 3px ${pa}` : n.edgeStyle === "depressed" ? s.firstChild.style.textShadow = `1px 1px ${ub}, 0 1px ${ub}, -1px -1px ${pa}, 0 -1px ${pa}` : n.edgeStyle === "uniform" && (s.firstChild.style.textShadow = `0 0 4px ${pa}, 0 0 4px ${pa}, 0 0 4px ${pa}, 0 0 4px ${pa}`)), n.fontPercent && n.fontPercent !== 1) {
        const o = Y.parseFloat(s.style.fontSize);
        s.style.fontSize = o * n.fontPercent + "px", s.style.height = "auto", s.style.top = "auto";
      }
      n.fontFamily && n.fontFamily !== "default" && (n.fontFamily === "small-caps" ? s.firstChild.style.fontVariant = "small-caps" : s.firstChild.style.fontFamily = mne[n.fontFamily]);
    }
  }
  /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */
  updateForTrack(e) {
    if (Array.isArray(e) || (e = [e]), typeof Y.WebVTT != "function" || e.every((a) => !a.activeCues))
      return;
    const n = [];
    for (let a = 0; a < e.length; ++a) {
      const i = e[a];
      for (let r = 0; r < i.activeCues.length; ++r)
        n.push(i.activeCues[r]);
    }
    Y.WebVTT.processCues(Y, n, this.el_);
    for (let a = 0; a < e.length; ++a) {
      const i = e[a];
      for (let r = 0; r < i.activeCues.length; ++r) {
        const s = i.activeCues[r].displayState;
        Er(s, "vjs-text-track-cue", "vjs-text-track-cue-" + (i.language ? i.language : a)), i.language && Ys(s, "lang", i.language);
      }
      this.player_.textTrackSettings && this.updateDisplayState(i);
    }
  }
}
ve.registerComponent("TextTrackDisplay", gne);
class bne extends ve {
  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const e = this.player_.isAudio(), n = this.localize(e ? "Audio Player" : "Video Player"), a = Je("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [n])
    }), i = super.createEl("div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return i.appendChild(a), i;
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
  }
}
ve.registerComponent("LoadingSpinner", bne);
class Ln extends kd {
  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n = {}, a = {}) {
    e = "button", n = Object.assign({
      className: this.buildCSSClass()
    }, n), a = Object.assign({
      // Necessary since the default button type is "submit"
      type: "button"
    }, a);
    const i = Je(e, n, a);
    return this.player_.options_.experimentalSvgIcons || i.appendChild(Je("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(i), i;
  }
  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */
  addChild(e, n = {}) {
    const a = this.constructor.name;
    return ct.warn(`Adding an actionable (user controllable) child to a Button (${a}) is not supported; use a ClickableComponent instead.`), ve.prototype.addChild.call(this, e, n);
  }
  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */
  enable() {
    super.enable(), this.el_.removeAttribute("disabled");
  }
  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */
  disable() {
    super.disable(), this.el_.setAttribute("disabled", "disabled");
  }
  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.stopPropagation();
      return;
    }
    super.handleKeyDown(e);
  }
}
ve.registerComponent("Button", Ln);
class B3 extends Ln {
  constructor(e, n) {
    super(e, n), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (a) => this.handleMouseDown(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */
  buildCSSClass() {
    return "vjs-big-play-button";
  }
  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.player_.play();
    if (this.mouseused_ && "clientX" in e && "clientY" in e) {
      Xa(n), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    const a = this.player_.getChild("controlBar"), i = a && a.getChild("playToggle");
    if (!i) {
      this.player_.tech(!0).focus();
      return;
    }
    const r = () => i.focus();
    dl(n) ? n.then(r, () => {
    }) : this.setTimeout(r, 1);
  }
  /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    this.mouseused_ = !1, super.handleKeyDown(e);
  }
  /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    this.mouseused_ = !0;
  }
}
B3.prototype.controlText_ = "Play Video";
ve.registerComponent("BigPlayButton", B3);
class vne extends Ln {
  /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */
  constructor(e, n) {
    super(e, n), this.setIcon("cancel"), this.controlText(n && n.controlText || this.localize("Close"));
  }
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-close-button ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */
  handleClick(e) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }
  /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
ve.registerComponent("CloseButton", vne);
class R3 extends Ln {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    super(e, n), n.replay = n.replay === void 0 || n.replay, this.setIcon("play"), this.on(e, "play", (a) => this.handlePlay(a)), this.on(e, "pause", (a) => this.handlePause(a)), n.replay && this.on(e, "ended", (a) => this.handleEnded(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-play-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.paused() ? Xa(this.player_.play()) : this.player_.pause();
  }
  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */
  handleSeeked(e) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
  }
  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */
  handlePlay(e) {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
  }
  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */
  handlePause(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
  }
  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */
  handleEnded(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (n) => this.handleSeeked(n));
  }
}
R3.prototype.controlText_ = "Play";
ve.registerComponent("PlayToggle", R3);
class uo extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, ["timeupdate", "ended", "seeking"], (a) => this.update(a)), this.updateTextNode_();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = this.buildCSSClass(), n = super.createEl("div", {
      className: `${e} vjs-time-control vjs-control`
    }), a = Je("span", {
      className: "vjs-control-text",
      textContent: `${this.localize(this.labelText_)} `
    }, {
      role: "presentation"
    });
    return n.appendChild(a), this.contentEl_ = Je("span", {
      className: `${e}-display`
    }, {
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), n.appendChild(this.contentEl_), n;
  }
  dispose() {
    this.contentEl_ = null, this.textNode_ = null, super.dispose();
  }
  /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */
  update(e) {
    !this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
  }
  /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */
  updateTextNode_(e = 0) {
    e = Nr(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
      if (!this.contentEl_)
        return;
      let n = this.textNode_;
      n && this.contentEl_.firstChild !== n && (n = null, ct.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = Me.createTextNode(this.formattedTime_), this.textNode_ && (n ? this.contentEl_.replaceChild(this.textNode_, n) : this.contentEl_.appendChild(this.textNode_));
    }));
  }
  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
  }
}
uo.prototype.labelText_ = "Time";
uo.prototype.controlText_ = "Time";
ve.registerComponent("TimeDisplay", uo);
class up extends uo {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-current-time";
  }
  /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
    let n;
    this.player_.ended() ? n = this.player_.duration() : n = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(n);
  }
}
up.prototype.labelText_ = "Current Time";
up.prototype.controlText_ = "Current Time";
ve.registerComponent("CurrentTimeDisplay", up);
class dp extends uo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n);
    const a = (i) => this.updateContent(i);
    this.on(e, "durationchange", a), this.on(e, "loadstart", a), this.on(e, "loadedmetadata", a);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-duration";
  }
  /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */
  updateContent(e) {
    const n = this.player_.duration();
    this.updateTextNode_(n);
  }
}
dp.prototype.labelText_ = "Duration";
dp.prototype.controlText_ = "Duration";
ve.registerComponent("DurationDisplay", dp);
class yne extends ve {
  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), n = super.createEl("div"), a = super.createEl("span", {
      textContent: "/"
    });
    return n.appendChild(a), e.appendChild(n), e;
  }
}
ve.registerComponent("TimeDivider", yne);
class hp extends uo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, "durationchange", (a) => this.updateContent(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-remaining-time";
  }
  /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.options_.displayNegative !== !1 && e.insertBefore(Je("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), e;
  }
  /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */
  updateContent(e) {
    if (typeof this.player_.duration() != "number")
      return;
    let n;
    this.player_.ended() ? n = 0 : this.player_.remainingTimeDisplay ? n = this.player_.remainingTimeDisplay() : n = this.player_.remainingTime(), this.updateTextNode_(n);
  }
}
hp.prototype.labelText_ = "Remaining Time";
hp.prototype.controlText_ = "Remaining Time";
ve.registerComponent("RemainingTimeDisplay", hp);
class _ne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.updateShowing(), this.on(this.player(), "durationchange", (a) => this.updateShowing(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = Je("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(Je("span", {
      className: "vjs-control-text",
      textContent: `${this.localize("Stream Type")} `
    })), this.contentEl_.appendChild(Me.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
  }
  dispose() {
    this.contentEl_ = null, super.dispose();
  }
  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */
  updateShowing(e) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }
}
ve.registerComponent("LiveDisplay", _ne);
class N3 extends Ln {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (a) => this.updateLiveEdgeStatus(a), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.setIcon("circle", e), this.textEl_ = Je("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), e.appendChild(this.textEl_), e;
  }
  /**
   * Update the state of this button if we are at the live edge
   * or not
   */
  updateLiveEdgeStatus() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }
  /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */
  handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  }
  /**
   * Dispose of the element and stop tracking
   */
  dispose() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
  }
}
N3.prototype.controlText_ = "Seek to live, currently playing live";
ve.registerComponent("SeekToLive", N3);
function ql(t, e, n) {
  return t = Number(t), Math.min(n, Math.max(e, isNaN(t) ? e : t));
}
var xne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  clamp: ql
});
class fp extends ve {
  /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */
  constructor(e, n) {
    super(e, n), this.handleMouseDown_ = (a) => this.handleMouseDown(a), this.handleMouseUp_ = (a) => this.handleMouseUp(a), this.handleKeyDown_ = (a) => this.handleKeyDown(a), this.handleClick_ = (a) => this.handleClick(a), this.handleMouseMove_ = (a) => this.handleMouseMove(a), this.update_ = (a) => this.update(a), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
  }
  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Enable controls for this slider if they are disabled
   */
  enable() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }
  /**
   * Disable controls for this slider if they are enabled
   */
  disable() {
    if (!this.enabled())
      return;
    const e = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
  }
  /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n = {}, a = {}) {
    return n.className = n.className + " vjs-slider", n = Object.assign({
      tabIndex: 0
    }, n), a = Object.assign({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, a), super.createEl(e, n, a);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */
  handleMouseDown(e) {
    const n = this.bar.el_.ownerDocument;
    e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !ai && e.preventDefault(), u3(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(n, "mousemove", this.handleMouseMove_), this.on(n, "mouseup", this.handleMouseUp_), this.on(n, "touchmove", this.handleMouseMove_), this.on(n, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
  }
  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseMove(e) {
  }
  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */
  handleMouseUp(e) {
    const n = this.bar.el_.ownerDocument;
    d3(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(n, "mousemove", this.handleMouseMove_), this.off(n, "mouseup", this.handleMouseUp_), this.off(n, "touchmove", this.handleMouseMove_), this.off(n, "touchend", this.handleMouseUp_), this.update();
  }
  /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */
  update() {
    if (!this.el_ || !this.bar)
      return;
    const e = this.getProgress();
    return e === this.progress_ || (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
      const n = this.vertical() ? "height" : "width";
      this.bar.el().style[n] = (e * 100).toFixed(2) + "%";
    })), e;
  }
  /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */
  getProgress() {
    return Number(ql(this.getPercent(), 0, 1).toFixed(4));
  }
  /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */
  calculateDistance(e) {
    const n = vd(this.el_, e);
    return this.vertical() ? n.y : n.x;
  }
  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const n = this.options_.playerOptions.spatialNavigation, a = n && n.enabled, i = n && n.horizontalSeek;
    a ? i && e.key === "ArrowLeft" || !i && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : i && e.key === "ArrowRight" || !i && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
  }
  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */
  handleClick(e) {
    e.stopPropagation(), e.preventDefault();
  }
  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */
  vertical(e) {
    if (e === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }
}
ve.registerComponent("Slider", fp);
const L0 = (t, e) => ql(t / e * 100, 0, 100).toFixed(2) + "%";
class Tne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.partEls_ = [], this.on(e, "progress", (a) => this.update(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-load-progress"
    }), n = Je("span", {
      className: "vjs-control-text"
    }), a = Je("span", {
      textContent: this.localize("Loaded")
    }), i = Me.createTextNode(": ");
    return this.percentageEl_ = Je("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), e.appendChild(n), n.appendChild(a), n.appendChild(i), n.appendChild(this.percentageEl_), e;
  }
  dispose() {
    this.partEls_ = null, this.percentageEl_ = null, super.dispose();
  }
  /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */
  update(e) {
    this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
      const n = this.player_.liveTracker, a = this.player_.buffered(), i = n && n.isLive() ? n.seekableEnd() : this.player_.duration(), r = this.player_.bufferedEnd(), s = this.partEls_, o = L0(r, i);
      this.percent_ !== o && (this.el_.style.width = o, lr(this.percentageEl_, o), this.percent_ = o);
      for (let l = 0; l < a.length; l++) {
        const c = a.start(l), d = a.end(l);
        let f = s[l];
        f || (f = this.el_.appendChild(Je()), s[l] = f), !(f.dataset.start === c && f.dataset.end === d) && (f.dataset.start = c, f.dataset.end = d, f.style.left = L0(c, r), f.style.width = L0(d - c, r));
      }
      for (let l = s.length; l > a.length; l--)
        this.el_.removeChild(s[l - 1]);
      s.length = a.length;
    });
  }
}
ve.registerComponent("LoadProgressBar", Tne);
class wne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(At(this, this.update), _a);
  }
  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n, a) {
    const i = El(this.el_), r = js(this.player_.el()), s = e.width * n;
    if (!r || !i)
      return;
    let o = e.left - r.left + s, l = e.width - s + (r.right - e.right);
    l || (l = e.width - s, o = s);
    let c = i.width / 2;
    o < c ? c += c - o : l < c && (c = l), c < 0 ? c = 0 : c > i.width && (c = i.width), c = Math.round(c), this.el_.style.right = `-${c}px`, this.write(a);
  }
  /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */
  write(e) {
    lr(this.el_, e);
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateTime(e, n, a, i) {
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
      let r;
      const s = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        const o = this.player_.liveTracker.liveWindow(), l = o - n * o;
        r = (l < 1 ? "" : "-") + Nr(l, o);
      } else
        r = Nr(a, s);
      this.update(e, n, r), i && i();
    });
  }
}
ve.registerComponent("TimeTooltip", wne);
class pp extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.setIcon("circle"), this.update = ii(At(this, this.update), _a);
  }
  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n) {
    const a = this.getChild("timeTooltip");
    if (!a)
      return;
    const i = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    a.updateTime(e, n, i);
  }
}
pp.prototype.options_ = {
  children: []
};
!An && !Na && pp.prototype.options_.children.push("timeTooltip");
ve.registerComponent("PlayProgressBar", pp);
class $3 extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(At(this, this.update), _a);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, n) {
    const a = n * this.player_.duration();
    this.getChild("timeTooltip").updateTime(e, n, a, () => {
      this.el_.style.left = `${e.width * n}px`;
    });
  }
}
$3.prototype.options_ = {
  children: ["timeTooltip"]
};
ve.registerComponent("MouseTimeDisplay", $3);
const Mc = 5, hb = 12;
class Sd extends fp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n = Tt(Sd.prototype.options_, n), n.children = [...n.children];
    const a = e.options_.disableSeekWhileScrubbingOnMobile && (An || Na);
    (!An && !Na || a) && n.children.splice(1, 0, "mouseTimeDisplay"), super(e, n), this.shouldDisableSeekWhileScrubbingOnMobile_ = a, this.pendingSeekTime_ = null, this.setEventHandlers_();
  }
  /**
   * Sets the event handlers
   *
   * @private
   */
  setEventHandlers_() {
    this.update_ = At(this, this.update), this.update = ii(this.update_, _a), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Me && "visibilityState" in Me && this.on(Me, "visibilitychange", this.toggleVisibility_);
  }
  toggleVisibility_(e) {
    Me.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }
  enableInterval_() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, _a));
  }
  disableInterval_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }
  /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */
  update(e) {
    if (Me.visibilityState === "hidden")
      return;
    const n = super.update();
    return this.requestNamedAnimationFrame("SeekBar#update", () => {
      const a = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), i = this.player_.liveTracker;
      let r = this.player_.duration();
      i && i.isLive() && (r = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== n && (this.el_.setAttribute("aria-valuenow", (n * 100).toFixed(2)), this.percent_ = n), (this.currentTime_ !== a || this.duration_ !== r) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [Nr(a, r), Nr(r, r)], "{1} of {2}")), this.currentTime_ = a, this.duration_ = r), this.bar && this.bar.update(js(this.el()), this.getProgress());
    }), n;
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */
  getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }
  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */
  getPercent() {
    if (this.pendingSeekTime_)
      return this.pendingSeekTime_ / this.player_.duration();
    const e = this.getCurrentTime_();
    let n;
    const a = this.player_.liveTracker;
    return a && a.isLive() ? (n = (e - a.seekableStart()) / a.liveWindow(), a.atLiveEdge() && (n = 1)) : n = e / this.player_.duration(), n;
  }
  /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Ll(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbingOnMobile_ || this.player_.pause(), super.handleMouseDown(e));
  }
  /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */
  handleMouseMove(e, n = !1) {
    if (!Ll(e) || isNaN(this.player_.duration()))
      return;
    !n && !this.player_.scrubbing() && this.player_.scrubbing(!0);
    let a;
    const i = this.calculateDistance(e), r = this.player_.liveTracker;
    if (!r || !r.isLive())
      a = i * this.player_.duration(), a === this.player_.duration() && (a = a - 0.1);
    else {
      if (i >= 0.99) {
        r.seekToLiveEdge();
        return;
      }
      const s = r.seekableStart(), o = r.liveCurrentTime();
      if (a = s + i * r.liveWindow(), a >= o && (a = o), a <= s && (a = s + 0.1), a === 1 / 0)
        return;
    }
    this.shouldDisableSeekWhileScrubbingOnMobile_ ? this.pendingSeekTime_ = a : this.userSeek_(a), this.player_.options_.enableSmoothSeeking && this.update();
  }
  enable() {
    super.enable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.show();
  }
  disable() {
    super.disable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.hide();
  }
  /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */
  handleMouseUp(e) {
    super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime_ && (this.userSeek_(this.pendingSeekTime_), this.pendingSeekTime_ = null), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? Xa(this.player_.play()) : this.update_();
  }
  /**
   * Move more quickly fast forward for keyboard-only users
   */
  stepForward() {
    this.userSeek_(this.player_.currentTime() + Mc);
  }
  /**
   * Move more quickly rewind for keyboard-only users
   */
  stepBack() {
    this.userSeek_(this.player_.currentTime() - Mc);
  }
  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */
  handleAction(e) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }
  /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const n = this.player_.liveTracker;
    if (e.key === " " || e.key === "Enter")
      e.preventDefault(), e.stopPropagation(), this.handleAction(e);
    else if (e.key === "Home")
      e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
    else if (e.key === "End")
      e.preventDefault(), e.stopPropagation(), n && n.isLive() ? this.userSeek_(n.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault(), e.stopPropagation();
      const a = parseInt(e.key, 10) * 0.1;
      n && n.isLive() ? this.userSeek_(n.seekableStart() + n.liveWindow() * a) : this.userSeek_(this.player_.duration() * a);
    } else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - Mc * hb)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + Mc * hb)) : super.handleKeyDown(e);
  }
  dispose() {
    this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Me && "visibilityState" in Me && this.off(Me, "visibilitychange", this.toggleVisibility_), super.dispose();
  }
}
Sd.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
ve.registerComponent("SeekBar", Sd);
class F3 extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.handleMouseMove = ii(At(this, this.handleMouseMove), _a), this.throttledHandleMouseSeek = ii(At(this, this.handleMouseSeek), _a), this.handleMouseUpHandler_ = (a) => this.handleMouseUp(a), this.handleMouseDownHandler_ = (a) => this.handleMouseDown(a), this.enable();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-control vjs-control"
    });
  }
  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */
  handleMouseMove(e) {
    const n = this.getChild("seekBar");
    if (!n)
      return;
    const a = n.getChild("playProgressBar"), i = n.getChild("mouseTimeDisplay");
    if (!a && !i)
      return;
    const r = n.el(), s = El(r);
    let o = vd(r, e).x;
    o = ql(o, 0, 1), i && i.update(s, o), a && a.update(s, n.getProgress());
  }
  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */
  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseSeek(e) {
    const n = this.getChild("seekBar");
    n && n.handleMouseMove(e);
  }
  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Disable all controls on the progress control and its children
   */
  disable() {
    if (this.children().forEach((e) => e.disable && e.disable()), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      const e = this.getChild("seekBar");
      this.player_.scrubbing(!1), e.videoWasPlaying && Xa(this.player_.play());
    }
  }
  /**
   * Enable all controls on the progress control and its children
   */
  enable() {
    this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }
  /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */
  removeListenersAddedOnMousedownAndTouchstart() {
    const e = this.el_.ownerDocument;
    this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const n = this.el_.ownerDocument, a = this.getChild("seekBar");
    a && a.handleMouseDown(e), this.on(n, "mousemove", this.throttledHandleMouseSeek), this.on(n, "touchmove", this.throttledHandleMouseSeek), this.on(n, "mouseup", this.handleMouseUpHandler_), this.on(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const n = this.getChild("seekBar");
    n && n.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
  }
}
F3.prototype.options_ = {
  children: ["seekBar"]
};
ve.registerComponent("ProgressControl", F3);
class z3 extends Ln {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  constructor(e, n) {
    super(e, n), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (a) => this.handlePictureInPictureChange(a)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (a) => this.handlePictureInPictureEnabledChange(a)), this.on(e, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], () => this.handlePictureInPictureAudioModeChange()), this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */
  handlePictureInPictureAudioModeChange() {
    if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
      this.show();
      return;
    }
    this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
  }
  /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */
  handlePictureInPictureEnabledChange() {
    Me.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in Y ? this.enable() : this.disable();
  }
  /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  handlePictureInPictureChange(e) {
    this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
  }
  /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */
  show() {
    typeof Me.exitPictureInPicture == "function" && super.show();
  }
}
z3.prototype.controlText_ = "Picture-in-Picture";
ve.registerComponent("PictureInPictureToggle", z3);
class U3 extends Ln {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (a) => this.handleFullscreenChange(a)), Me[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-fullscreen-control ${super.buildCSSClass()}`;
  }
  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */
  handleFullscreenChange(e) {
    this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
  }
  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }
}
U3.prototype.controlText_ = "Fullscreen";
ve.registerComponent("FullscreenToggle", U3);
const kne = function(t, e) {
  e.tech_ && !e.tech_.featuresVolumeControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresVolumeControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class Sne extends ve {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-volume-level"
    });
    return this.setIcon("circle", e), e.appendChild(super.createEl("span", {
      className: "vjs-control-text"
    })), e;
  }
}
ve.registerComponent("VolumeLevel", Sne);
class Cne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(At(this, this.update), _a);
  }
  /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, n, a, i) {
    if (!a) {
      const r = js(this.el_), s = js(this.player_.el()), o = e.width * n;
      if (!s || !r)
        return;
      const l = e.left - s.left + o, c = e.width - o + (s.right - e.right);
      let d = r.width / 2;
      l < d ? d += d - l : c < d && (d = c), d < 0 ? d = 0 : d > r.width && (d = r.width), this.el_.style.right = `-${d}px`;
    }
    this.write(`${i}%`);
  }
  /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */
  write(e) {
    lr(this.el_, e);
  }
  /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateVolume(e, n, a, i, r) {
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
      this.update(e, n, a, i.toFixed(0)), r && r();
    });
  }
}
ve.registerComponent("VolumeLevelTooltip", Cne);
class H3 extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.update = ii(At(this, this.update), _a);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, n, a) {
    const i = 100 * n;
    this.getChild("volumeLevelTooltip").updateVolume(e, n, a, i, () => {
      a ? this.el_.style.bottom = `${e.height * n}px` : this.el_.style.left = `${e.width * n}px`;
    });
  }
}
H3.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
ve.registerComponent("MouseVolumeLevelDisplay", H3);
class Cd extends fp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on("slideractive", (a) => this.updateLastVolume_(a)), this.on(e, "volumechange", (a) => this.updateARIAAttributes(a)), e.ready(() => this.updateARIAAttributes());
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }
  /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Ll(e) && super.handleMouseDown(e);
  }
  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */
  handleMouseMove(e) {
    const n = this.getChild("mouseVolumeLevelDisplay");
    if (n) {
      const a = this.el(), i = js(a), r = this.vertical();
      let s = vd(a, e);
      s = r ? s.y : s.x, s = ql(s, 0, 1), n.update(i, s, r);
    }
    Ll(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
  }
  /**
   * If the player is muted unmute it.
   */
  checkMuted() {
    this.player_.muted() && this.player_.muted(!1);
  }
  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */
  getPercent() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }
  /**
   * Increase volume level for keyboard users
   */
  stepForward() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }
  /**
   * Decrease volume level for keyboard users
   */
  stepBack() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }
  /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */
  updateARIAAttributes(e) {
    const n = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", n), this.el_.setAttribute("aria-valuetext", n + "%");
  }
  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */
  volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  }
  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */
  updateLastVolume_() {
    const e = this.player_.volume();
    this.one("sliderinactive", () => {
      this.player_.volume() === 0 && this.player_.lastVolume_(e);
    });
  }
}
Cd.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!An && !Na && Cd.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
Cd.prototype.playerEvent = "volumechange";
ve.registerComponent("VolumeBar", Cd);
class Y3 extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.vertical = n.vertical || !1, (typeof n.volumeBar > "u" || Hs(n.volumeBar)) && (n.volumeBar = n.volumeBar || {}, n.volumeBar.vertical = n.vertical), super(e, n), kne(this, e), this.throttledHandleMouseMove = ii(At(this, this.handleMouseMove), _a), this.handleMouseUpHandler_ = (a) => this.handleMouseUp(a), this.on("mousedown", (a) => this.handleMouseDown(a)), this.on("touchstart", (a) => this.handleMouseDown(a)), this.on("mousemove", (a) => this.handleMouseMove(a)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
      this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
    }), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
      this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
    });
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-horizontal";
    return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", {
      className: `vjs-volume-control vjs-control ${e}`
    });
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const n = this.el_.ownerDocument;
    this.on(n, "mousemove", this.throttledHandleMouseMove), this.on(n, "touchmove", this.throttledHandleMouseMove), this.on(n, "mouseup", this.handleMouseUpHandler_), this.on(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const n = this.el_.ownerDocument;
    this.off(n, "mousemove", this.throttledHandleMouseMove), this.off(n, "touchmove", this.throttledHandleMouseMove), this.off(n, "mouseup", this.handleMouseUpHandler_), this.off(n, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseMove(e) {
    this.volumeBar.handleMouseMove(e);
  }
}
Y3.prototype.options_ = {
  children: ["volumeBar"]
};
ve.registerComponent("VolumeControl", Y3);
const Ane = function(t, e) {
  e.tech_ && !e.tech_.featuresMuteControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresMuteControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class j3 extends Ln {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), Ane(this, e), this.on(e, ["loadstart", "volumechange"], (a) => this.update(a));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-mute-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.player_.volume(), a = this.player_.lastVolume_();
    if (n === 0) {
      const i = a < 0.1 ? 0.1 : a;
      this.player_.volume(i), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }
  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */
  update(e) {
    this.updateIcon_(), this.updateControlText_();
  }
  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */
  updateIcon_() {
    const e = this.player_.volume();
    let n = 3;
    this.setIcon("volume-high"), An && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), n = 0) : e < 0.33 ? (this.setIcon("volume-low"), n = 1) : e < 0.67 && (this.setIcon("volume-medium"), n = 2), gd(this.el_, [0, 1, 2, 3].reduce((a, i) => a + `${i ? " " : ""}vjs-vol-${i}`, "")), Er(this.el_, `vjs-vol-${n}`);
  }
  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */
  updateControlText_() {
    const n = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
    this.controlText() !== n && this.controlText(n);
  }
}
j3.prototype.controlText_ = "Mute";
ve.registerComponent("MuteToggle", j3);
class V3 extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    typeof n.inline < "u" ? n.inline = n.inline : n.inline = !0, (typeof n.volumeControl > "u" || Hs(n.volumeControl)) && (n.volumeControl = n.volumeControl || {}, n.volumeControl.vertical = !n.inline), super(e, n), this.handleKeyPressHandler_ = (a) => this.handleKeyPress(a), this.on(e, ["loadstart"], (a) => this.volumePanelState_(a)), this.on(this.muteToggle, "keyup", (a) => this.handleKeyPress(a)), this.on(this.volumeControl, "keyup", (a) => this.handleVolumeControlKeyUp(a)), this.on("keydown", (a) => this.handleKeyPress(a)), this.on("mouseover", (a) => this.handleMouseOver(a)), this.on("mouseout", (a) => this.handleMouseOut(a)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
  }
  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */
  sliderActive_() {
    this.addClass("vjs-slider-active");
  }
  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */
  sliderInactive_() {
    this.removeClass("vjs-slider-active");
  }
  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */
  volumePanelState_() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-panel-horizontal";
    return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", {
      className: `vjs-volume-panel vjs-control ${e}`
    });
  }
  /**
   * Dispose of the `volume-panel` and all child components.
   */
  dispose() {
    this.handleMouseOut(), super.dispose();
  }
  /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */
  handleVolumeControlKeyUp(e) {
    e.key === "Escape" && this.muteToggle.focus();
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */
  handleMouseOver(e) {
    this.addClass("vjs-hover"), ua(Me, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */
  handleMouseOut(e) {
    this.removeClass("vjs-hover"), En(Me, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */
  handleKeyPress(e) {
    e.key === "Escape" && this.handleMouseOut();
  }
}
V3.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
ve.registerComponent("VolumePanel", V3);
class q3 extends Ln {
  constructor(e, n) {
    super(e, n), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipForwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
  }
  buildCSSClass() {
    return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    if (isNaN(this.player_.duration()))
      return;
    const n = this.player_.currentTime(), a = this.player_.liveTracker, i = a && a.isLive() ? a.seekableEnd() : this.player_.duration();
    let r;
    n + this.skipTime <= i ? r = n + this.skipTime : r = i, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
  }
}
q3.prototype.controlText_ = "Skip Forward";
ve.registerComponent("SkipForward", q3);
class W3 extends Ln {
  constructor(e, n) {
    super(e, n), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipBackwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
  }
  buildCSSClass() {
    return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    const n = this.player_.currentTime(), a = this.player_.liveTracker, i = a && a.isLive() && a.seekableStart();
    let r;
    i && n - this.skipTime <= i ? r = i : n >= this.skipTime ? r = n - this.skipTime : r = 0, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
  }
}
W3.prototype.controlText_ = "Skip Backward";
ve.registerComponent("SkipBackward", W3);
class G3 extends ve {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  constructor(e, n) {
    super(e, n), n && (this.menuButton_ = n.menuButton), this.focusedChild_ = -1, this.on("keydown", (a) => this.handleKeyDown(a)), this.boundHandleBlur_ = (a) => this.handleBlur(a), this.boundHandleTapClick_ = (a) => this.handleTapClick(a);
  }
  /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */
  addEventListenerForItem(e) {
    e instanceof ve && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */
  removeEventListenerForItem(e) {
    e instanceof ve && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */
  removeChild(e) {
    typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
  }
  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */
  addItem(e) {
    const n = this.addChild(e);
    n && this.addEventListenerForItem(n);
  }
  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */
  createEl() {
    const e = this.options_.contentElType || "ul";
    this.contentEl_ = Je(e, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    const n = super.createEl("div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return n.appendChild(this.contentEl_), ua(n, "click", function(a) {
      a.preventDefault(), a.stopImmediatePropagation();
    }), n;
  }
  dispose() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
  }
  /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */
  handleBlur(e) {
    const n = e.relatedTarget || Me.activeElement;
    if (!this.children().some((a) => a.el() === n)) {
      const a = this.menuButton_;
      a && a.buttonPressed_ && n !== a.el().firstChild && a.unpressButton();
    }
  }
  /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */
  handleTapClick(e) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      const n = this.children();
      if (!Array.isArray(n))
        return;
      const a = n.filter((i) => i.el() === e.target)[0];
      if (!a)
        return;
      a.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }
  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
  }
  /**
   * Move to next (lower) menu item for keyboard users.
   */
  stepForward() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
  }
  /**
   * Move to previous (higher) menu item for keyboard users.
   */
  stepBack() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
  }
  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */
  focus(e = 0) {
    const n = this.children().slice();
    n.length && n[0].hasClass("vjs-menu-title") && n.shift(), n.length > 0 && (e < 0 ? e = 0 : e >= n.length && (e = n.length - 1), this.focusedChild_ = e, n[e].el_.focus());
  }
}
ve.registerComponent("Menu", G3);
class mp extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    super(e, n), this.menuButton_ = new Ln(e, n), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    const a = Ln.prototype.buildCSSClass();
    this.menuButton_.el_.className = this.buildCSSClass() + " " + a, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
    const i = (r) => this.handleClick(r);
    this.handleMenuKeyUp_ = (r) => this.handleMenuKeyUp(r), this.on(this.menuButton_, "tap", i), this.on(this.menuButton_, "click", i), this.on(this.menuButton_, "keydown", (r) => this.handleKeyDown(r)), this.on(this.menuButton_, "mouseenter", () => {
      this.addClass("vjs-hover"), this.menu.show(), ua(Me, "keyup", this.handleMenuKeyUp_);
    }), this.on("mouseleave", (r) => this.handleMouseLeave(r)), this.on("keydown", (r) => this.handleSubmenuKeyDown(r));
  }
  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const e = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }
  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    const e = new G3(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      const n = Je("li", {
        className: "vjs-menu-title",
        textContent: qt(this.options_.title),
        tabIndex: -1
      }), a = new ve(this.player_, {
        el: n
      });
      e.addItem(a);
    }
    if (this.items = this.createItems(), this.items)
      for (let n = 0; n < this.items.length; n++)
        e.addItem(this.items[n]);
    return e;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */
  createItems() {
  }
  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }
  /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */
  setIcon(e) {
    super.setIcon(e, this.menuButton_.el_);
  }
  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    let e = "vjs-menu-button";
    this.options_.inline === !0 ? e += "-inline" : e += "-popup";
    const n = Ln.prototype.buildCSSClass();
    return `vjs-menu-button ${e} ${n} ${super.buildCSSClass()}`;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    let e = "vjs-menu-button";
    return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
  }
  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, n = this.menuButton_.el()) {
    return this.menuButton_.controlText(e, n);
  }
  /**
   * Dispose of the `menu-button` and all child components.
   */
  dispose() {
    this.handleMouseLeave(), super.dispose();
  }
  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }
  /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */
  handleMouseLeave(e) {
    this.removeClass("vjs-hover"), En(Me, "keyup", this.handleMenuKeyUp_);
  }
  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.menuButton_.focus();
  }
  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.menuButton_.blur();
  }
  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
  }
  /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */
  handleMenuKeyUp(e) {
    (e.key === "Escape" || e.key === "Tab") && this.removeClass("vjs-hover");
  }
  /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */
  handleSubmenuKeyPress(e) {
    this.handleSubmenuKeyDown(e);
  }
  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */
  handleSubmenuKeyDown(e) {
    (e.key === "Escape" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
  }
  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), An && r3())
        return;
      this.menu.focus();
    }
  }
  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }
  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  disable() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }
  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */
  enable() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }
}
ve.registerComponent("MenuButton", mp);
class gp extends mp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.tracks;
    if (super(e, n), this.items.length <= 1 && this.hide(), !a)
      return;
    const i = At(this, this.update);
    a.addEventListener("removetrack", i), a.addEventListener("addtrack", i), a.addEventListener("labelchange", i), this.player_.on("ready", i), this.player_.on("dispose", function() {
      a.removeEventListener("removetrack", i), a.removeEventListener("addtrack", i), a.removeEventListener("labelchange", i);
    });
  }
}
ve.registerComponent("TrackButton", gp);
class Wl extends kd {
  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  constructor(e, n) {
    super(e, n), this.selectable = n.selectable, this.isSelected_ = n.selected || !1, this.multiSelectable = n.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
  }
  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, n, a) {
    this.nonIconControl = !0;
    const i = super.createEl("li", Object.assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, n), a), r = Je("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    });
    return this.player_.options_.experimentalSvgIcons ? i.appendChild(r) : i.replaceChild(r, i.querySelector(".vjs-icon-placeholder")), i;
  }
  /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    ["Tab", "Escape", "ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(e.key) || super.handleKeyDown(e);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.selected(!0);
  }
  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */
  selected(e) {
    this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }
}
ve.registerComponent("MenuItem", Wl);
class Gl extends Wl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = e.textTracks();
    n.label = a.label || a.language || "Unknown", n.selected = a.mode === "showing", super(e, n), this.track = a, this.kinds = (n.kinds || [n.kind || this.track.kind]).filter(Boolean);
    const r = (...o) => {
      this.handleTracksChange.apply(this, o);
    }, s = (...o) => {
      this.handleSelectedLanguageChange.apply(this, o);
    };
    if (e.on(["loadstart", "texttrackchange"], r), i.addEventListener("change", r), i.addEventListener("selectedlanguagechange", s), this.on("dispose", function() {
      e.off(["loadstart", "texttrackchange"], r), i.removeEventListener("change", r), i.removeEventListener("selectedlanguagechange", s);
    }), i.onchange === void 0) {
      let o;
      this.on(["tap", "click"], function() {
        if (typeof Y.Event != "object")
          try {
            o = new Y.Event("change");
          } catch {
          }
        o || (o = Me.createEvent("Event"), o.initEvent("change", !0, !0)), i.dispatchEvent(o);
      });
    }
    this.handleTracksChange();
  }
  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const n = this.track, a = this.player_.textTracks();
    if (super.handleClick(e), !!a)
      for (let i = 0; i < a.length; i++) {
        const r = a[i];
        this.kinds.indexOf(r.kind) !== -1 && (r === n ? r.mode !== "showing" && (r.mode = "showing") : r.mode !== "disabled" && (r.mode = "disabled"));
      }
  }
  /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const n = this.track.mode === "showing";
    n !== this.isSelected_ && this.selected(n);
  }
  handleSelectedLanguageChange(e) {
    if (this.track.mode === "showing") {
      const n = this.player_.cache_.selectedLanguage;
      if (n && n.enabled && n.language === this.track.language && n.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }
  dispose() {
    this.track = null, super.dispose();
  }
}
ve.registerComponent("TextTrackMenuItem", Gl);
class X3 extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n.track = {
      player: e,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: n.kind,
      kinds: n.kinds,
      default: !1,
      mode: "disabled"
    }, n.kinds || (n.kinds = [n.kind]), n.label ? n.track.label = n.label : n.track.label = n.kinds.join(" and ") + " off", n.selectable = !0, n.multiSelectable = !1, super(e, n);
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */
  handleTracksChange(e) {
    const n = this.player().textTracks();
    let a = !0;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (this.options_.kinds.indexOf(s.kind) > -1 && s.mode === "showing") {
        a = !1;
        break;
      }
    }
    a !== this.isSelected_ && this.selected(a);
  }
  handleSelectedLanguageChange(e) {
    const n = this.player().textTracks();
    let a = !0;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (["captions", "descriptions", "subtitles"].indexOf(s.kind) > -1 && s.mode === "showing") {
        a = !1;
        break;
      }
    }
    a && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
  }
}
ve.registerComponent("OffTextTrackMenuItem", X3);
class ho extends gp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.tracks = e.textTracks(), super(e, n);
  }
  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */
  createItems(e = [], n = Gl) {
    let a;
    this.label_ && (a = `${this.label_} off`), e.push(new X3(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: a
    })), this.hideThreshold_ += 1;
    const i = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (let r = 0; r < i.length; r++) {
      const s = i[r];
      if (this.kinds_.indexOf(s.kind) > -1) {
        const o = new n(this.player_, {
          track: s,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        o.addClass(`vjs-${s.kind}-menu-item`), e.push(o);
      }
    }
    return e;
  }
}
ve.registerComponent("TextTrackButton", ho);
class Z3 extends Wl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = n.cue, r = e.currentTime();
    n.selectable = !0, n.multiSelectable = !1, n.label = i.text, n.selected = i.startTime <= r && r < i.endTime, super(e, n), this.track = a, this.cue = i;
  }
  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player_.currentTime(this.cue.startTime);
  }
}
ve.registerComponent("ChaptersTrackMenuItem", Z3);
class bp extends ho {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
      this.items.forEach((i) => {
        i.selected(this.track_.activeCues[0] === i.cue);
      });
    };
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-chapters-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */
  update(e) {
    if (e && e.track && e.track.kind !== "chapters")
      return;
    const n = this.findChaptersTrack();
    n !== this.track_ ? (this.setTrack(n), super.update()) : (!this.items || n && n.cues && n.cues.length !== this.items.length) && super.update();
  }
  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */
  setTrack(e) {
    if (this.track_ !== e) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        const n = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        n && n.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = e, this.track_) {
        this.track_.mode = "hidden";
        const n = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        n && n.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }
  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */
  findChaptersTrack() {
    const e = this.player_.textTracks() || [];
    for (let n = e.length - 1; n >= 0; n--) {
      const a = e[n];
      if (a.kind === this.kind_)
        return a;
    }
  }
  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */
  getMenuCaption() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(qt(this.kind_));
  }
  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */
  createMenu() {
    return this.options_.title = this.getMenuCaption(), super.createMenu();
  }
  /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */
  createItems() {
    const e = [];
    if (!this.track_)
      return e;
    const n = this.track_.cues;
    if (!n)
      return e;
    for (let a = 0, i = n.length; a < i; a++) {
      const r = n[a], s = new Z3(this.player_, {
        track: this.track_,
        cue: r
      });
      e.push(s);
    }
    return e;
  }
}
bp.prototype.kind_ = "chapters";
bp.prototype.controlText_ = "Chapters";
ve.registerComponent("ChaptersButton", bp);
class vp extends ho {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("audio-description");
    const i = e.textTracks(), r = At(this, this.handleTracksChange);
    i.addEventListener("change", r), this.on("dispose", function() {
      i.removeEventListener("change", r);
    });
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const n = this.player().textTracks();
    let a = !1;
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      if (s.kind !== this.kind_ && s.mode === "showing") {
        a = !0;
        break;
      }
    }
    a ? this.disable() : this.enable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-descriptions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
  }
}
vp.prototype.kind_ = "descriptions";
vp.prototype.controlText_ = "Descriptions";
ve.registerComponent("DescriptionsButton", vp);
class yp extends ho {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("subtitles");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subtitles-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
  }
}
yp.prototype.kind_ = "subtitles";
yp.prototype.controlText_ = "Subtitles";
ve.registerComponent("SubtitlesButton", yp);
class _p extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    n.track = {
      player: e,
      kind: n.kind,
      label: n.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, n.selectable = !1, n.name = "CaptionSettingsMenuItem", super(e, n), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + n.kind + " settings dialog");
  }
  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player().getChild("textTrackSettings").open();
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
  }
}
ve.registerComponent("CaptionSettingsMenuItem", _p);
class xp extends ho {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n, a) {
    super(e, n, a), this.setIcon("captions");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-captions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    const e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new _p(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), super.createItems(e);
  }
}
xp.prototype.kind_ = "captions";
xp.prototype.controlText_ = "Captions";
ve.registerComponent("CaptionsButton", xp);
class K3 extends Gl {
  createEl(e, n, a) {
    const i = super.createEl(e, n, a), r = i.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", i) : r.appendChild(Je("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(Je("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: ` ${this.localize("Captions")}`
    }))), i;
  }
}
ve.registerComponent("SubsCapsMenuItem", K3);
class Tp extends ho {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, n = {}) {
    super(e, n), this.label_ = "subtitles", this.setIcon("subtitles"), ["en", "en-us", "en-ca", "fr-ca"].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(qt(this.label_));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subs-caps-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    let e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new _p(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), e = super.createItems(e, K3), e;
  }
}
Tp.prototype.kinds_ = ["captions", "subtitles"];
Tp.prototype.controlText_ = "Subtitles";
ve.registerComponent("SubsCapsButton", Tp);
class Q3 extends Wl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.track, i = e.audioTracks();
    n.label = a.label || a.language || "Unknown", n.selected = a.enabled, super(e, n), this.track = a, this.addClass(`vjs-${a.kind}-menu-item`);
    const r = (...s) => {
      this.handleTracksChange.apply(this, s);
    };
    i.addEventListener("change", r), this.on("dispose", () => {
      i.removeEventListener("change", r);
    });
  }
  createEl(e, n, a) {
    const i = super.createEl(e, n, a), r = i.querySelector(".vjs-menu-item-text");
    return ["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0 && (r.appendChild(Je("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(Je("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), i;
  }
  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
      const n = this.player_.audioTracks();
      for (let a = 0; a < n.length; a++) {
        const i = n[a];
        i !== this.track && (i.enabled = i === this.track);
      }
    }
  }
  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */
  handleTracksChange(e) {
    this.selected(this.track.enabled);
  }
}
ve.registerComponent("AudioTrackMenuItem", Q3);
class J3 extends gp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, n = {}) {
    n.tracks = e.audioTracks(), super(e, n), this.setIcon("audio");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-audio-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */
  createItems(e = []) {
    this.hideThreshold_ = 1;
    const n = this.player_.audioTracks();
    for (let a = 0; a < n.length; a++) {
      const i = n[a];
      e.push(new Q3(this.player_, {
        track: i,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return e;
  }
}
J3.prototype.controlText_ = "Audio Track";
ve.registerComponent("AudioTrackButton", J3);
class wp extends Wl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    const a = n.rate, i = parseFloat(a, 10);
    n.label = a, n.selected = i === e.playbackRate(), n.selectable = !0, n.multiSelectable = !1, super(e, n), this.label = a, this.rate = i, this.on(e, "ratechange", (r) => this.update(r));
  }
  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player().playbackRate(this.rate);
  }
  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  update(e) {
    this.selected(this.player().playbackRate() === this.rate);
  }
}
wp.prototype.contentElType = "button";
ve.registerComponent("PlaybackRateMenuItem", wp);
class e_ extends mp {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (a) => this.updateVisibility(a)), this.on(e, "ratechange", (a) => this.updateLabel(a)), this.on(e, "playbackrateschange", (a) => this.handlePlaybackRateschange(a));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = Je("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), e.appendChild(this.labelEl_), e;
  }
  dispose() {
    this.labelEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-playback-rate ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   */
  createItems() {
    const e = this.playbackRates(), n = [];
    for (let a = e.length - 1; a >= 0; a--)
      n.push(new wp(this.player(), {
        rate: e[a] + "x"
      }));
    return n;
  }
  /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */
  handlePlaybackRateschange(e) {
    this.update();
  }
  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */
  playbackRates() {
    const e = this.player();
    return e.playbackRates && e.playbackRates() || [];
  }
  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */
  playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }
  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */
  updateVisibility(e) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }
  /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  updateLabel(e) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }
}
e_.prototype.controlText_ = "Playback Rate";
ve.registerComponent("PlaybackRateMenuButton", e_);
class t_ extends ve {
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl(e = "div", n = {}, a = {}) {
    return n.className || (n.className = this.buildCSSClass()), super.createEl(e, n, a);
  }
}
ve.registerComponent("Spacer", t_);
class Ene extends t_ {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }
}
ve.registerComponent("CustomControlSpacer", Ene);
class n_ extends ve {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }
}
n_.prototype.options_ = {
  children: ["playToggle", "skipBackward", "skipForward", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "pictureInPictureToggle", "fullscreenToggle"]
};
ve.registerComponent("ControlBar", n_);
class a_ extends co {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, n) {
    super(e, n), this.on(e, "error", (a) => {
      this.open(a);
    });
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */
  buildCSSClass() {
    return `vjs-error-display ${super.buildCSSClass()}`;
  }
  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */
  content() {
    const e = this.player().error();
    return e ? this.localize(e.message) : "";
  }
}
a_.prototype.options_ = Object.assign({}, co.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
ve.registerComponent("ErrorDisplay", a_);
class i_ extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */
  constructor(e, n = {}) {
    super(e, n), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
  }
  /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), Je("select", {
      id: this.options_.id
    }, {}, this.options_.SelectOptions.map((n) => {
      const a = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${ya()}`) + "-" + n[1].replace(/\W+/g, ""), i = Je("option", {
        id: a,
        value: this.localize(n[0]),
        textContent: this.localize(n[1])
      });
      return i.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${a}`), i;
    }));
  }
}
ve.registerComponent("TextTrackSelect", i_);
class Dr extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = Je("legend", {
      textContent: this.localize(this.options_.legendText),
      id: this.options_.legendId
    });
    this.el().appendChild(a);
    const i = this.options_.selects;
    for (const r of i) {
      const s = this.options_.selectConfigs[r], o = s.className, l = s.id.replace("%s", this.options_.id_);
      let c = null;
      const d = `vjs_select_${ya()}`;
      if (this.options_.type === "colors") {
        c = Je("span", {
          className: o
        });
        const g = Je("label", {
          id: l,
          className: "vjs-label",
          textContent: this.localize(s.label)
        });
        g.setAttribute("for", d), c.appendChild(g);
      }
      const f = new i_(e, {
        SelectOptions: s.options,
        legendId: this.options_.legendId,
        id: d,
        labelId: l
      });
      this.addChild(f), this.options_.type === "colors" && (c.appendChild(f.el()), this.el().appendChild(c));
    }
  }
  /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Je("fieldset", {
      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: this.options_.className
    });
  }
}
ve.registerComponent("TextTrackFieldset", Dr);
class r_ extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = this.options_.textTrackComponentid, i = new Dr(e, {
      id_: a,
      legendId: `captions-text-legend-${a}`,
      legendText: this.localize("Text"),
      className: "vjs-fg vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(i);
    const r = new Dr(e, {
      id_: a,
      legendId: `captions-background-${a}`,
      legendText: this.localize("Text Background"),
      className: "vjs-bg vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(r);
    const s = new Dr(e, {
      id_: a,
      legendId: `captions-window-${a}`,
      legendText: this.localize("Caption Area Background"),
      className: "vjs-window vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(s);
  }
  /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Je("div", {
      className: "vjs-track-settings-colors"
    });
  }
}
ve.registerComponent("TextTrackSettingsColors", r_);
class s_ extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, n = {}) {
    super(e, n);
    const a = this.options_.textTrackComponentid, i = new Dr(e, {
      id_: a,
      legendId: `captions-font-size-${a}`,
      legendText: "Font Size",
      className: "vjs-font-percent vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(i);
    const r = new Dr(e, {
      id_: a,
      legendId: `captions-edge-style-${a}`,
      legendText: this.localize("Text Edge Style"),
      className: "vjs-edge-style vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(r);
    const s = new Dr(e, {
      id_: a,
      legendId: `captions-font-family-${a}`,
      legendText: this.localize("Font Family"),
      className: "vjs-font-family vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(s);
  }
  /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Je("div", {
      className: "vjs-track-settings-font"
    });
  }
}
ve.registerComponent("TextTrackSettingsFont", s_);
class o_ extends ve {
  constructor(e, n = {}) {
    super(e, n);
    const a = this.localize("restore all settings to the default values"), i = new Ln(e, {
      controlText: a,
      className: "vjs-default-button"
    });
    i.el().classList.remove("vjs-control", "vjs-button"), i.el().textContent = this.localize("Reset"), this.addChild(i);
    const r = new Ln(e, {
      controlText: a,
      className: "vjs-done-button"
    });
    r.el().classList.remove("vjs-control", "vjs-button"), r.el().textContent = this.localize("Done"), this.addChild(r);
  }
  /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return Je("div", {
      className: "vjs-track-settings-controls"
    });
  }
}
ve.registerComponent("TrackSettingsControls", o_);
const D0 = "vjs-text-track-settings", fb = ["#000", "Black"], pb = ["#00F", "Blue"], mb = ["#0FF", "Cyan"], gb = ["#0F0", "Green"], bb = ["#F0F", "Magenta"], vb = ["#F00", "Red"], yb = ["#FFF", "White"], _b = ["#FF0", "Yellow"], I0 = ["1", "Opaque"], M0 = ["0.5", "Semi-Transparent"], xb = ["0", "Transparent"], ji = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [fb, yb, vb, gb, pb, _b, bb, mb],
    className: "vjs-bg-color"
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Opacity",
    options: [I0, M0, xb],
    className: "vjs-bg-opacity vjs-opacity"
  },
  color: {
    selector: ".vjs-text-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [yb, fb, vb, gb, pb, _b, bb, mb],
    className: "vjs-text-color"
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Drop shadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: (t) => t === "1.00" ? null : Number(t)
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Opacity",
    options: [I0, M0],
    className: "vjs-text-opacity vjs-opacity"
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color",
    className: "vjs-window-color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Opacity",
    options: [xb, M0, I0],
    className: "vjs-window-opacity vjs-opacity"
  }
};
ji.windowColor.options = ji.backgroundColor.options;
function l_(t, e) {
  if (e && (t = e(t)), t && t !== "none")
    return t;
}
function Lne(t, e) {
  const n = t.options[t.options.selectedIndex].value;
  return l_(n, e);
}
function Dne(t, e, n) {
  if (e) {
    for (let a = 0; a < t.options.length; a++)
      if (l_(t.options[a].value, n) === e) {
        t.selectedIndex = a;
        break;
      }
  }
}
class Ine extends co {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, n) {
    n.temporary = !1, super(e, n), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = Je("p", {
      className: "vjs-control-text",
      textContent: this.localize("End of dialog window.")
    }), this.el().appendChild(this.endDialog), this.setDefaults(), n.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
  }
  renderModalComponents(e) {
    const n = new r_(e, {
      textTrackComponentid: this.id_,
      selectConfigs: ji,
      fieldSets: [["color", "textOpacity"], ["backgroundColor", "backgroundOpacity"], ["windowColor", "windowOpacity"]]
    });
    this.addChild(n);
    const a = new s_(e, {
      textTrackComponentid: this.id_,
      selectConfigs: ji,
      fieldSets: [["fontPercent"], ["edgeStyle"], ["fontFamily"]]
    });
    this.addChild(a);
    const i = new o_(e);
    this.addChild(i);
  }
  bindFunctionsToSelectsAndButtons() {
    this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
      this.saveSettings(), this.close();
    }), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
      this.setDefaults(), this.updateDisplay();
    }), ys(ji, (e) => {
      this.on(this.$(e.selector), "change", this.updateDisplay);
    });
  }
  dispose() {
    this.endDialog = null, super.dispose();
  }
  label() {
    return this.localize("Caption Settings Dialog");
  }
  description() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }
  buildCSSClass() {
    return super.buildCSSClass() + " vjs-text-track-settings";
  }
  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */
  getValues() {
    return Q5(ji, (e, n, a) => {
      const i = Lne(this.$(n.selector), n.parser);
      return i !== void 0 && (e[a] = i), e;
    }, {});
  }
  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */
  setValues(e) {
    ys(ji, (n, a) => {
      Dne(this.$(n.selector), e[a], n.parser);
    });
  }
  /**
   * Sets all `<select>` elements to their default values.
   */
  setDefaults() {
    ys(ji, (e) => {
      const n = e.hasOwnProperty("default") ? e.default : 0;
      this.$(e.selector).selectedIndex = n;
    });
  }
  /**
   * Restore texttrack settings from localStorage
   */
  restoreSettings() {
    let e;
    try {
      e = JSON.parse(Y.localStorage.getItem(D0));
    } catch (n) {
      ct.warn(n);
    }
    e && this.setValues(e);
  }
  /**
   * Save text track settings to localStorage
   */
  saveSettings() {
    if (!this.options_.persistTextTrackSettings)
      return;
    const e = this.getValues();
    try {
      Object.keys(e).length ? Y.localStorage.setItem(D0, JSON.stringify(e)) : Y.localStorage.removeItem(D0);
    } catch (n) {
      ct.warn(n);
    }
  }
  /**
   * Update display of text track settings
   */
  updateDisplay() {
    const e = this.player_.getChild("textTrackDisplay");
    e && e.updateDisplay();
  }
  /**
   * Repopulate dialog with new localizations on languagechange
   */
  handleLanguagechange() {
    this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
  }
}
ve.registerComponent("TextTrackSettings", Ine);
class Mne extends ve {
  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  constructor(e, n) {
    let a = n.ResizeObserver || Y.ResizeObserver;
    n.ResizeObserver === null && (a = !1);
    const i = Tt({
      createEl: !a,
      reportTouchActivity: !1
    }, n);
    super(e, i), this.ResizeObserver = n.ResizeObserver || Y.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = x3(() => {
      this.resizeHandler();
    }, 100, !1, this), a ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
      if (!this.el_ || !this.el_.contentWindow)
        return;
      const r = this.debouncedHandler_;
      let s = this.unloadListener_ = function() {
        En(this, "resize", r), En(this, "unload", s), s = null;
      };
      ua(this.el_.contentWindow, "unload", s), ua(this.el_.contentWindow, "resize", r);
    }, this.one("load", this.loadListener_));
  }
  createEl() {
    return super.createEl("iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */
  resizeHandler() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }
  dispose() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
  }
}
ve.registerComponent("ResizeManager", Mne);
const One = {
  trackingThreshold: 20,
  liveTolerance: 15
};
class Pne extends ve {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */
  constructor(e, n) {
    const a = Tt(One, n, {
      createEl: !1
    });
    super(e, a), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (i) => this.handlePlay(i), this.handleFirstTimeupdate_ = (i) => this.handleFirstTimeupdate(i), this.handleSeeked_ = (i) => this.handleSeeked(i), this.seekToLiveEdge_ = (i) => this.seekToLiveEdge(i), this.reset_(), this.on(this.player_, "durationchange", (i) => this.handleDurationchange(i)), this.on(this.player_, "canplay", () => this.toggleTracking());
  }
  /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */
  trackLive_() {
    const e = this.player_.seekable();
    if (!e || !e.length)
      return;
    const n = Number(Y.performance.now().toFixed(4)), a = this.lastTime_ === -1 ? 0 : (n - this.lastTime_) / 1e3;
    this.lastTime_ = n, this.pastSeekEnd_ = this.pastSeekEnd() + a;
    const i = this.liveCurrentTime(), r = this.player_.currentTime();
    let s = this.player_.paused() || this.seekedBehindLive_ || Math.abs(i - r) > this.options_.liveTolerance;
    (!this.timeupdateSeen_ || i === 1 / 0) && (s = !1), s !== this.behindLiveEdge_ && (this.behindLiveEdge_ = s, this.trigger("liveedgechange"));
  }
  /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */
  handleDurationchange() {
    this.toggleTracking();
  }
  /**
   * start/stop tracking
   */
  toggleTracking() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }
  /**
   * start tracking live playback
   */
  startTracking() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, _a), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }
  /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */
  handleFirstTimeupdate() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }
  /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */
  handleSeeked() {
    const e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }
  /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */
  handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */
  reset_() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */
  nextSeekedFromUser() {
    this.nextSeekedFromUser_ = !0;
  }
  /**
   * stop tracking live playback
   */
  stopTracking() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }
  /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */
  seekableEnd() {
    const e = this.player_.seekable(), n = [];
    let a = e ? e.length : 0;
    for (; a--; )
      n.push(e.end(a));
    return n.length ? n.sort()[n.length - 1] : 1 / 0;
  }
  /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */
  seekableStart() {
    const e = this.player_.seekable(), n = [];
    let a = e ? e.length : 0;
    for (; a--; )
      n.push(e.start(a));
    return n.length ? n.sort()[0] : 0;
  }
  /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */
  liveWindow() {
    const e = this.liveCurrentTime();
    return e === 1 / 0 ? 0 : e - this.seekableStart();
  }
  /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */
  isLive() {
    return this.isTracking();
  }
  /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */
  atLiveEdge() {
    return !this.behindLiveEdge();
  }
  /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */
  liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  }
  /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */
  pastSeekEnd() {
    const e = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
  }
  /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */
  behindLiveEdge() {
    return this.behindLiveEdge_;
  }
  /**
   * Whether live tracker is currently tracking or not.
   */
  isTracking() {
    return typeof this.trackingInterval_ == "number";
  }
  /**
   * Seek to the live edge if we are behind the live edge
   */
  seekToLiveEdge() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }
  /**
   * Dispose of liveTracker
   */
  dispose() {
    this.stopTracking(), super.dispose();
  }
}
ve.registerComponent("LiveTracker", Pne);
class Bne extends ve {
  constructor(e, n) {
    super(e, n), this.on("statechanged", (a) => this.updateDom_()), this.updateDom_();
  }
  /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return this.els = {
      title: Je("div", {
        className: "vjs-title-bar-title",
        id: `vjs-title-bar-title-${ya()}`
      }),
      description: Je("div", {
        className: "vjs-title-bar-description",
        id: `vjs-title-bar-description-${ya()}`
      })
    }, Je("div", {
      className: "vjs-title-bar"
    }, {}, J5(this.els));
  }
  /**
   * Updates the DOM based on the component's state object.
   */
  updateDom_() {
    const e = this.player_.tech_, n = e && e.el_, a = {
      title: "aria-labelledby",
      description: "aria-describedby"
    };
    ["title", "description"].forEach((i) => {
      const r = this.state[i], s = this.els[i], o = a[i];
      yd(s), r && lr(s, r), n && (n.removeAttribute(o), r && n.setAttribute(o, s.id));
    }), this.state.title || this.state.description ? this.show() : this.hide();
  }
  /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */
  update(e) {
    this.setState(e);
  }
  /**
   * Dispose the component.
   */
  dispose() {
    const e = this.player_.tech_, n = e && e.el_;
    n && (n.removeAttribute("aria-labelledby"), n.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
  }
}
ve.registerComponent("TitleBar", Bne);
const Rne = {
  initialDisplay: 4e3,
  position: [],
  takeFocus: !1
};
class Nne extends Ln {
  /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */
  constructor(e, n) {
    n = Tt(Rne, n), super(e, n), this.controlText(n.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (a) => {
      this.removeClass("force-display");
    });
  }
  /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */
  buildCSSClass() {
    return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
  }
  /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */
  createEl() {
    const e = Je("button", {}, {
      type: "button",
      class: this.buildCSSClass()
    }, Je("span"));
    return this.controlTextEl_ = e.querySelector("span"), e;
  }
  /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */
  show() {
    super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({
      preventScroll: !0
    }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
      this.removeClass("force-display");
    }, this.options_.initialDisplay);
  }
  /**
   * Hide the display, even if during the `initialDisplay` time.
   */
  hide() {
    this.removeClass("force-display"), super.hide();
  }
  /**
   * Dispose the component
   */
  dispose() {
    this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
  }
}
ve.registerComponent("TransientButton", Nne);
const wh = (t) => {
  const e = t.el();
  if (e.hasAttribute("src"))
    return t.triggerSourceset(e.src), !0;
  const n = t.$$("source"), a = [];
  let i = "";
  if (!n.length)
    return !1;
  for (let r = 0; r < n.length; r++) {
    const s = n[r].src;
    s && a.indexOf(s) === -1 && a.push(s);
  }
  return a.length ? (a.length === 1 && (i = a[0]), t.triggerSourceset(i), !0) : !1;
}, $ne = Object.defineProperty({}, "innerHTML", {
  get() {
    return this.cloneNode(!0).innerHTML;
  },
  set(t) {
    const e = Me.createElement(this.nodeName.toLowerCase());
    e.innerHTML = t;
    const n = Me.createDocumentFragment();
    for (; e.childNodes.length; )
      n.appendChild(e.childNodes[0]);
    return this.innerText = "", Y.Element.prototype.appendChild.call(this, n), this.innerHTML;
  }
}), c_ = (t, e) => {
  let n = {};
  for (let a = 0; a < t.length && (n = Object.getOwnPropertyDescriptor(t[a], e), !(n && n.set && n.get)); a++)
    ;
  return n.enumerable = !0, n.configurable = !0, n;
}, Fne = (t) => c_([t.el(), Y.HTMLMediaElement.prototype, Y.Element.prototype, $ne], "innerHTML"), Tb = function(t) {
  const e = t.el();
  if (e.resetSourceWatch_)
    return;
  const n = {}, a = Fne(t), i = (r) => (...s) => {
    const o = r.apply(e, s);
    return wh(t), o;
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach((r) => {
    e[r] && (n[r] = e[r], e[r] = i(n[r]));
  }), Object.defineProperty(e, "innerHTML", Tt(a, {
    set: i(a.set)
  })), e.resetSourceWatch_ = () => {
    e.resetSourceWatch_ = null, Object.keys(n).forEach((r) => {
      e[r] = n[r];
    }), Object.defineProperty(e, "innerHTML", a);
  }, t.one("sourceset", e.resetSourceWatch_);
}, zne = Object.defineProperty({}, "src", {
  get() {
    return this.hasAttribute("src") ? I3(Y.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set(t) {
    return Y.Element.prototype.setAttribute.call(this, "src", t), t;
  }
}), Une = (t) => c_([t.el(), Y.HTMLMediaElement.prototype, zne], "src"), Hne = function(t) {
  if (!t.featuresSourceset)
    return;
  const e = t.el();
  if (e.resetSourceset_)
    return;
  const n = Une(t), a = e.setAttribute, i = e.load;
  Object.defineProperty(e, "src", Tt(n, {
    set: (r) => {
      const s = n.set.call(e, r);
      return t.triggerSourceset(e.src), s;
    }
  })), e.setAttribute = (r, s) => {
    const o = a.call(e, r, s);
    return /src/i.test(r) && t.triggerSourceset(e.src), o;
  }, e.load = () => {
    const r = i.call(e);
    return wh(t) || (t.triggerSourceset(""), Tb(t)), r;
  }, e.currentSrc ? t.triggerSourceset(e.currentSrc) : wh(t) || Tb(t), e.resetSourceset_ = () => {
    e.resetSourceset_ = null, e.load = i, e.setAttribute = a, Object.defineProperty(e, "src", n), e.resetSourceWatch_ && e.resetSourceWatch_();
  };
};
class He extends rt {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e, n) {
    super(e, n);
    const a = e.source;
    let i = !1;
    if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", a && (this.el_.currentSrc !== a.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(a) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
      const r = this.el_.childNodes;
      let s = r.length;
      const o = [];
      for (; s--; ) {
        const l = r[s];
        l.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(l), this.remoteTextTracks().addTrack(l.track), this.textTracks().addTrack(l.track), !i && !this.el_.hasAttribute("crossorigin") && wd(l.src) && (i = !0)) : o.push(l));
      }
      for (let l = 0; l < o.length; l++)
        this.el_.removeChild(o[l]);
    }
    this.proxyNativeTracks_(), this.featuresNativeTextTracks && i && ct.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), this.restoreMetadataTracksInIOSNativePlayer_(), (Al || pd) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
  }
  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */
  dispose() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), He.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
  }
  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */
  setupSourcesetHandling_() {
    Hne(this);
  }
  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */
  restoreMetadataTracksInIOSNativePlayer_() {
    const e = this.textTracks();
    let n;
    const a = () => {
      n = [];
      for (let r = 0; r < e.length; r++) {
        const s = e[r];
        s.kind === "metadata" && n.push({
          track: s,
          storedMode: s.mode
        });
      }
    };
    a(), e.addEventListener("change", a), this.on("dispose", () => e.removeEventListener("change", a));
    const i = () => {
      for (let r = 0; r < n.length; r++) {
        const s = n[r];
        s.track.mode === "disabled" && s.track.mode !== s.storedMode && (s.track.mode = s.storedMode);
      }
      e.removeEventListener("change", i);
    };
    this.on("webkitbeginfullscreen", () => {
      e.removeEventListener("change", a), e.removeEventListener("change", i), e.addEventListener("change", i);
    }), this.on("webkitendfullscreen", () => {
      e.removeEventListener("change", a), e.addEventListener("change", a), e.removeEventListener("change", i);
    });
  }
  /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */
  overrideNative_(e, n) {
    if (n !== this[`featuresNative${e}Tracks`])
      return;
    const a = e.toLowerCase();
    this[`${a}TracksListeners_`] && Object.keys(this[`${a}TracksListeners_`]).forEach((i) => {
      this.el()[`${a}Tracks`].removeEventListener(i, this[`${a}TracksListeners_`][i]);
    }), this[`featuresNative${e}Tracks`] = !n, this[`${a}TracksListeners_`] = null, this.proxyNativeTracksForType_(a);
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */
  overrideNativeAudioTracks(e) {
    this.overrideNative_("Audio", e);
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */
  overrideNativeVideoTracks(e) {
    this.overrideNative_("Video", e);
  }
  /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */
  proxyNativeTracksForType_(e) {
    const n = va[e], a = this.el()[n.getterName], i = this[n.getterName]();
    if (!this[`featuresNative${n.capitalName}Tracks`] || !a || !a.addEventListener)
      return;
    const r = {
      change: (o) => {
        const l = {
          type: "change",
          target: i,
          currentTarget: i,
          srcElement: i
        };
        i.trigger(l), e === "text" && this[Ws.remoteText.getterName]().trigger(l);
      },
      addtrack(o) {
        i.addTrack(o.track);
      },
      removetrack(o) {
        i.removeTrack(o.track);
      }
    }, s = function() {
      const o = [];
      for (let l = 0; l < i.length; l++) {
        let c = !1;
        for (let d = 0; d < a.length; d++)
          if (a[d] === i[l]) {
            c = !0;
            break;
          }
        c || o.push(i[l]);
      }
      for (; o.length; )
        i.removeTrack(o.shift());
    };
    this[n.getterName + "Listeners_"] = r, Object.keys(r).forEach((o) => {
      const l = r[o];
      a.addEventListener(o, l), this.on("dispose", (c) => a.removeEventListener(o, l));
    }), this.on("loadstart", s), this.on("dispose", (o) => this.off("loadstart", s));
  }
  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */
  proxyNativeTracks_() {
    va.names.forEach((e) => {
      this.proxyNativeTracksForType_(e);
    });
  }
  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    let e = this.options_.tag;
    if (!e || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (e) {
        const a = e.cloneNode(!0);
        e.parentNode && e.parentNode.insertBefore(a, e), He.disposeMediaElement(e), e = a;
      } else {
        e = Me.createElement("video");
        const a = this.options_.tag && Yi(this.options_.tag), i = Tt({}, a);
        (!Al || this.options_.nativeControlsForTouch !== !0) && delete i.controls, l3(e, Object.assign(i, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      e.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && Ys(e, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (e.disablePictureInPicture = this.options_.disablePictureInPicture);
    const n = ["loop", "muted", "playsinline", "autoplay"];
    for (let a = 0; a < n.length; a++) {
      const i = n[a], r = this.options_[i];
      typeof r < "u" && (r ? Ys(e, i, i) : bd(e, i), e[i] = r);
    }
    return e;
  }
  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */
  handleLateInit_(e) {
    if (e.networkState === 0 || e.networkState === 3)
      return;
    if (e.readyState === 0) {
      let a = !1;
      const i = function() {
        a = !0;
      };
      this.on("loadstart", i);
      const r = function() {
        a || this.trigger("loadstart");
      };
      this.on("loadedmetadata", r), this.ready(function() {
        this.off("loadstart", i), this.off("loadedmetadata", r), a || this.trigger("loadstart");
      });
      return;
    }
    const n = ["loadstart"];
    n.push("loadedmetadata"), e.readyState >= 2 && n.push("loadeddata"), e.readyState >= 3 && n.push("canplay"), e.readyState >= 4 && n.push("canplaythrough"), this.ready(function() {
      n.forEach(function(a) {
        this.trigger(a);
      }, this);
    });
  }
  /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  setScrubbing(e) {
    this.isScrubbing_ = e;
  }
  /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  scrubbing() {
    return this.isScrubbing_;
  }
  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */
  setCurrentTime(e) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && md ? this.el_.fastSeek(e) : this.el_.currentTime = e;
    } catch (n) {
      ct(n, "Video is not ready. (Video.js)");
    }
  }
  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */
  duration() {
    if (this.el_.duration === 1 / 0 && Na && ai && this.el_.currentTime === 0) {
      const e = () => {
        this.el_.currentTime > 0 && (this.el_.duration === 1 / 0 && this.trigger("durationchange"), this.off("timeupdate", e));
      };
      return this.on("timeupdate", e), NaN;
    }
    return this.el_.duration || NaN;
  }
  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */
  width() {
    return this.el_.offsetWidth;
  }
  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */
  height() {
    return this.el_.offsetHeight;
  }
  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */
  proxyWebkitFullscreen_() {
    if (!("webkitDisplayingFullscreen" in this.el_))
      return;
    const e = function() {
      this.trigger("fullscreenchange", {
        isFullscreen: !1
      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
    }, n = function() {
      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
        isFullscreen: !0,
        // set a flag in case another tech triggers fullscreenchange
        nativeIOSFullscreen: !0
      }));
    };
    this.on("webkitbeginfullscreen", n), this.on("dispose", () => {
      this.off("webkitbeginfullscreen", n), this.off("webkitendfullscreen", e);
    });
  }
  /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */
  supportsFullScreen() {
    return typeof this.el_.webkitEnterFullScreen == "function";
  }
  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */
  enterFullScreen() {
    const e = this.el_;
    if (e.paused && e.networkState <= e.HAVE_METADATA)
      Xa(this.el_.play()), this.setTimeout(function() {
        e.pause();
        try {
          e.webkitEnterFullScreen();
        } catch (n) {
          this.trigger("fullscreenerror", n);
        }
      }, 0);
    else
      try {
        e.webkitEnterFullScreen();
      } catch (n) {
        this.trigger("fullscreenerror", n);
      }
  }
  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */
  exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  }
  /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */
  requestVideoFrameCallback(e) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
  }
  /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */
  cancelVideoFrameCallback(e) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
  }
  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */
  src(e) {
    if (e === void 0)
      return this.el_.src;
    this.setSrc(e);
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, n) {
    if (!e)
      return ct.error("Invalid source URL."), !1;
    const a = {
      src: e
    };
    n && (a.type = n);
    const i = Je("source", {}, a);
    return this.el_.appendChild(i), !0;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    if (!e)
      return ct.error("Source URL is required to remove the source element."), !1;
    const n = this.el_.querySelectorAll("source");
    for (const a of n)
      if (a.src === e)
        return this.el_.removeChild(a), !0;
    return ct.warn(`No matching source element found with src: ${e}`), !1;
  }
  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */
  reset() {
    He.resetMediaElement(this.el_);
  }
  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */
  currentSrc() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }
  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */
  setControls(e) {
    this.el_.controls = !!e;
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, n, a) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, n, a) : super.addTextTrack(e, n, a);
  }
  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    if (!this.featuresNativeTextTracks)
      return super.createRemoteTextTrack(e);
    const n = Me.createElement("track");
    return e.kind && (n.kind = e.kind), e.label && (n.label = e.label), (e.language || e.srclang) && (n.srclang = e.language || e.srclang), e.default && (n.default = e.default), e.id && (n.id = e.id), e.src && (n.src = e.src), n;
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */
  addRemoteTextTrack(e, n) {
    const a = super.addRemoteTextTrack(e, n);
    return this.featuresNativeTextTracks && this.el().appendChild(a), a;
  }
  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */
  removeRemoteTextTrack(e) {
    if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
      const n = this.$$("track");
      let a = n.length;
      for (; a--; )
        (e === n[a] || e === n[a].track) && this.el().removeChild(n[a]);
    }
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */
  getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    const e = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), Y.performance && (e.creationTime = Y.performance.now()), e;
  }
}
dd(He, "TEST_VID", function() {
  if (!so())
    return;
  const t = Me.createElement("video"), e = Me.createElement("track");
  return e.kind = "captions", e.srclang = "en", e.label = "English", t.appendChild(e), t;
});
He.isSupported = function() {
  try {
    He.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(He.TEST_VID && He.TEST_VID.canPlayType);
};
He.canPlayType = function(t) {
  return He.TEST_VID.canPlayType(t);
};
He.canPlaySource = function(t, e) {
  return He.canPlayType(t.type);
};
He.canControlVolume = function() {
  try {
    const t = He.TEST_VID.volume;
    He.TEST_VID.volume = t / 2 + 0.1;
    const e = t !== He.TEST_VID.volume;
    return e && An ? (Y.setTimeout(() => {
      He && He.prototype && (He.prototype.featuresVolumeControl = t !== He.TEST_VID.volume);
    }), !1) : e;
  } catch {
    return !1;
  }
};
He.canMuteVolume = function() {
  try {
    const t = He.TEST_VID.muted;
    return He.TEST_VID.muted = !t, He.TEST_VID.muted ? Ys(He.TEST_VID, "muted", "muted") : bd(He.TEST_VID, "muted", "muted"), t !== He.TEST_VID.muted;
  } catch {
    return !1;
  }
};
He.canControlPlaybackRate = function() {
  if (Na && ai && hd < 58)
    return !1;
  try {
    const t = He.TEST_VID.playbackRate;
    return He.TEST_VID.playbackRate = t / 2 + 0.1, t !== He.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
He.canOverrideAttributes = function() {
  try {
    const t = () => {
    };
    Object.defineProperty(Me.createElement("video"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("audio"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("video"), "innerHTML", {
      get: t,
      set: t
    }), Object.defineProperty(Me.createElement("audio"), "innerHTML", {
      get: t,
      set: t
    });
  } catch {
    return !1;
  }
  return !0;
};
He.supportsNativeTextTracks = function() {
  return md || An && ai;
};
He.supportsNativeVideoTracks = function() {
  return !!(He.TEST_VID && He.TEST_VID.videoTracks);
};
He.supportsNativeAudioTracks = function() {
  return !!(He.TEST_VID && He.TEST_VID.audioTracks);
};
He.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function([t, e]) {
  dd(He.prototype, t, () => He[e](), !0);
});
He.prototype.featuresVolumeControl = He.canControlVolume();
He.prototype.movingMediaElementInDOM = !An;
He.prototype.featuresFullscreenResize = !0;
He.prototype.featuresProgressEvents = !0;
He.prototype.featuresTimeupdateEvents = !0;
He.prototype.featuresVideoFrameCallback = !!(He.TEST_VID && He.TEST_VID.requestVideoFrameCallback);
He.disposeMediaElement = function(t) {
  if (t) {
    for (t.parentNode && t.parentNode.removeChild(t); t.hasChildNodes(); )
      t.removeChild(t.firstChild);
    t.removeAttribute("src"), typeof t.load == "function" && function() {
      try {
        t.load();
      } catch {
      }
    }();
  }
};
He.resetMediaElement = function(t) {
  if (!t)
    return;
  const e = t.querySelectorAll("source");
  let n = e.length;
  for (; n--; )
    t.removeChild(e[n]);
  t.removeAttribute("src"), typeof t.load == "function" && function() {
    try {
      t.load();
    } catch {
    }
  }();
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  He.prototype[t] = function() {
    return this.el_[t] || this.el_.hasAttribute(t);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  He.prototype["set" + qt(t)] = function(e) {
    this.el_[t] = e, e ? this.el_.setAttribute(t, t) : this.el_.removeAttribute(t);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  He.prototype[t] = function() {
    return this.el_[t];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  He.prototype["set" + qt(t)] = function(e) {
    this.el_[t] = e;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(t) {
  He.prototype[t] = function() {
    return this.el_[t]();
  };
});
rt.withSourceHandlers(He);
He.nativeSourceHandler = {};
He.nativeSourceHandler.canPlayType = function(t) {
  try {
    return He.TEST_VID.canPlayType(t);
  } catch {
    return "";
  }
};
He.nativeSourceHandler.canHandleSource = function(t, e) {
  if (t.type)
    return He.nativeSourceHandler.canPlayType(t.type);
  if (t.src) {
    const n = lp(t.src);
    return He.nativeSourceHandler.canPlayType(`video/${n}`);
  }
  return "";
};
He.nativeSourceHandler.handleSource = function(t, e, n) {
  e.setSrc(t.src);
};
He.nativeSourceHandler.dispose = function() {
};
He.registerSourceHandler(He.nativeSourceHandler);
rt.registerTech("Html5", He);
const u_ = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], O0 = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, kh = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Yc = {};
kh.forEach((t) => {
  const e = t.charAt(0) === "x" ? `x-${t.substring(1)}` : t;
  Yc[t] = `vjs-layout-${e}`;
});
const Yne = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
};
class It extends ve {
  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */
  constructor(e, n, a) {
    if (e.id = e.id || n.id || `vjs_video_${ya()}`, n = Object.assign(It.getTagSettings(e), n), n.initChildren = !1, n.createEl = !1, n.evented = !1, n.reportTouchActivity = !1, !n.language) {
      const s = e.closest("[lang]");
      s && (n.language = s.getAttribute("lang"));
    }
    if (super(null, n, a), this.boundDocumentFullscreenChange_ = (s) => this.documentFullscreenChange_(s), this.boundFullWindowOnEscKey_ = (s) => this.fullWindowOnEscKey(s), this.boundUpdateStyleEl_ = (s) => this.updateStyleEl_(s), this.boundApplyInitTime_ = (s) => this.applyInitTime_(s), this.boundUpdateCurrentBreakpoint_ = (s) => this.updateCurrentBreakpoint_(s), this.boundHandleTechClick_ = (s) => this.handleTechClick_(s), this.boundHandleTechDoubleClick_ = (s) => this.handleTechDoubleClick_(s), this.boundHandleTechTouchStart_ = (s) => this.handleTechTouchStart_(s), this.boundHandleTechTouchMove_ = (s) => this.handleTechTouchMove_(s), this.boundHandleTechTouchEnd_ = (s) => this.handleTechTouchEnd_(s), this.boundHandleTechTap_ = (s) => this.handleTechTap_(s), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (s) => this.updatePlayerHeightOnAudioOnlyMode_(s), this.isFullscreen_ = !1, this.log = Z5(this.id_), this.fsApi_ = mu, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
      controlBarHeight: null,
      playerHeight: null,
      hiddenChildren: []
    }, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (this.tag = e, this.tagAttributes = e && Yi(e), this.language(this.options_.language), n.languages) {
      const s = {};
      Object.getOwnPropertyNames(n.languages).forEach(function(o) {
        s[o.toLowerCase()] = n.languages[o];
      }), this.languages_ = s;
    } else
      this.languages_ = It.prototype.options_.languages;
    this.resetCache_(), this.poster_ = n.poster || "", this.controls_ = !!n.controls, e.controls = !1, e.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], e.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), n.plugins && Object.keys(n.plugins).forEach((s) => {
      if (typeof this[s] != "function")
        throw new Error(`plugin "${s}" does not exist`);
    }), this.scrubbing_ = !1, this.el_ = this.createEl(), ip(this, {
      eventBusKey: "el_"
    }), this.fsApi_.requestFullscreen && (ua(Me, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    const i = Tt(this.options_);
    if (n.plugins && Object.keys(n.plugins).forEach((s) => {
      this[s](n.plugins[s]);
    }), n.debug && this.debug(!0), this.options_.playerOptions = i, this.middleware_ = [], this.playbackRates(n.playbackRates), n.experimentalSvgIcons) {
      const o = new Y.DOMParser().parseFromString(hne, "image/svg+xml");
      if (o.querySelector("parsererror"))
        ct.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
      else {
        const c = o.documentElement;
        c.style.display = "none", this.el_.appendChild(c), this.addClass("vjs-svg-icons-enabled");
      }
    }
    this.initChildren(), this.isAudio(e.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), n.spatialNavigation && n.spatialNavigation.enabled && (this.spatialNavigation = new fne(this), this.addClass("vjs-spatial-navigation-enabled")), Al && this.addClass("vjs-touch-enabled"), An || this.addClass("vjs-workinghover"), It.players[this.id_] = this;
    const r = ph.split(".")[0];
    this.addClass(`vjs-v${r}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (s) => this.listenForUserActivity_(s)), this.on("keydown", (s) => this.handleKeyDown(s)), this.on("languagechange", (s) => this.handleLanguagechange(s)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
      this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
    });
  }
  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */
  dispose() {
    this.trigger("dispose"), this.off("dispose"), En(Me, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), En(Me, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), It.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), lne(this), Rn.names.forEach((e) => {
      const n = Rn[e], a = this[n.getterName]();
      a && a.off && a.off();
    }), super.dispose({
      restoreEl: this.options_.restoreEl
    });
  }
  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    let e = this.tag, n, a = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player");
    const i = this.tag.tagName.toLowerCase() === "video-js";
    a ? n = this.el_ = e.parentNode : i || (n = this.el_ = super.createEl("div"));
    const r = Yi(e);
    if (i) {
      for (n = this.el_ = e, e = this.tag = Me.createElement("video"); n.children.length; )
        e.appendChild(n.firstChild);
      cl(n, "video-js") || Er(n, "video-js"), n.appendChild(e), a = this.playerElIngest_ = n, Object.keys(n).forEach((l) => {
        try {
          e[l] = n[l];
        } catch {
        }
      });
    }
    e.setAttribute("tabindex", "-1"), r.tabindex = "-1", ai && fd && (e.setAttribute("role", "application"), r.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in r && delete r.width, "height" in r && delete r.height, Object.getOwnPropertyNames(r).forEach(function(l) {
      i && l === "class" || n.setAttribute(l, r[l]), i && e.setAttribute(l, r[l]);
    }), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = n.player = this, this.addClass("vjs-paused");
    const s = ["IS_SMART_TV", "IS_TIZEN", "IS_WEBOS", "IS_ANDROID", "IS_IPAD", "IS_IPHONE", "IS_CHROMECAST_RECEIVER"].filter((l) => i3[l]).map((l) => "vjs-device-" + l.substring(3).toLowerCase().replace(/\_/g, "-"));
    if (this.addClass(...s), Y.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = y3("vjs-styles-dimensions");
      const l = tr(".vjs-styles-defaults"), c = tr("head");
      c.insertBefore(this.styleEl_, l ? l.nextSibling : c.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    const o = e.getElementsByTagName("a");
    for (let l = 0; l < o.length; l++) {
      const c = o.item(l);
      Er(c, "vjs-hidden"), c.setAttribute("hidden", "hidden");
    }
    return e.initNetworkState_ = e.networkState, e.parentNode && !a && e.parentNode.insertBefore(n, e), gh(e, n), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = n, n;
  }
  /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.techGet_("crossOrigin");
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      ct.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
  }
  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */
  width(e) {
    return this.dimension("width", e);
  }
  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */
  height(e) {
    return this.dimension("height", e);
  }
  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */
  dimension(e, n) {
    const a = e + "_";
    if (n === void 0)
      return this[a] || 0;
    if (n === "" || n === "auto") {
      this[a] = void 0, this.updateStyleEl_();
      return;
    }
    const i = parseFloat(n);
    if (isNaN(i)) {
      ct.error(`Improper value "${n}" supplied for for ${e}`);
      return;
    }
    this[a] = i, this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fluid(e) {
    if (e === void 0)
      return !!this.fluid_;
    this.fluid_ = !!e, xi(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), $te(this, () => {
      this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fill(e) {
    if (e === void 0)
      return !!this.fill_;
    this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }
  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */
  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */
  aspectRatio(e) {
    if (e === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(e))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
  }
  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */
  updateStyleEl_() {
    if (Y.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      const o = typeof this.width_ == "number" ? this.width_ : this.options_.width, l = typeof this.height_ == "number" ? this.height_ : this.options_.height, c = this.tech_ && this.tech_.el();
      c && (o >= 0 && (c.width = o), l >= 0 && (c.height = l));
      return;
    }
    let e, n, a, i;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? a = this.aspectRatio_ : this.videoWidth() > 0 ? a = this.videoWidth() + ":" + this.videoHeight() : a = "16:9";
    const r = a.split(":"), s = r[1] / r[0];
    this.width_ !== void 0 ? e = this.width_ : this.height_ !== void 0 ? e = this.height_ / s : e = this.videoWidth() || 300, this.height_ !== void 0 ? n = this.height_ : n = e * s, /^[^a-zA-Z]/.test(this.id()) ? i = "dimensions-" + this.id() : i = this.id() + "-dimensions", this.addClass(i), _3(this.styleEl_, `
      .${i} {
        width: ${e}px;
        height: ${n}px;
      }

      .${i}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${s * 100}%;
      }
    `);
  }
  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */
  loadTech_(e, n) {
    this.tech_ && this.unloadTech_();
    const a = qt(e), i = e.charAt(0).toLowerCase() + e.slice(1);
    a !== "Html5" && this.tag && (rt.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = a, this.isReady_ = !1;
    let r = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (r = !1);
    const s = {
      source: n,
      autoplay: r,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: `${this.id()}_${i}_api`,
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset
    };
    Rn.names.forEach((l) => {
      const c = Rn[l];
      s[c.getterName] = this[c.privateName];
    }), Object.assign(s, this.options_[a]), Object.assign(s, this.options_[i]), Object.assign(s, this.options_[e.toLowerCase()]), this.tag && (s.tag = this.tag), n && n.src === this.cache_.src && this.cache_.currentTime > 0 && (s.startTime = this.cache_.currentTime);
    const o = rt.getTech(e);
    if (!o)
      throw new Error(`No Tech named '${a}' exists! '${a}' should be registered using videojs.registerTech()'`);
    this.tech_ = new o(s), this.tech_.ready(At(this, this.handleTechReady_), !0), tb.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), u_.forEach((l) => {
      this.on(this.tech_, l, (c) => this[`handleTech${qt(l)}_`](c));
    }), Object.keys(O0).forEach((l) => {
      this.on(this.tech_, l, (c) => {
        if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
          this.queuedCallbacks_.push({
            callback: this[`handleTech${O0[l]}_`].bind(this),
            event: c
          });
          return;
        }
        this[`handleTech${O0[l]}_`](c);
      });
    }), this.on(this.tech_, "loadstart", (l) => this.handleTechLoadStart_(l)), this.on(this.tech_, "sourceset", (l) => this.handleTechSourceset_(l)), this.on(this.tech_, "waiting", (l) => this.handleTechWaiting_(l)), this.on(this.tech_, "ended", (l) => this.handleTechEnded_(l)), this.on(this.tech_, "seeking", (l) => this.handleTechSeeking_(l)), this.on(this.tech_, "play", (l) => this.handleTechPlay_(l)), this.on(this.tech_, "pause", (l) => this.handleTechPause_(l)), this.on(this.tech_, "durationchange", (l) => this.handleTechDurationChange_(l)), this.on(this.tech_, "fullscreenchange", (l, c) => this.handleTechFullscreenChange_(l, c)), this.on(this.tech_, "fullscreenerror", (l, c) => this.handleTechFullscreenError_(l, c)), this.on(this.tech_, "enterpictureinpicture", (l) => this.handleTechEnterPictureInPicture_(l)), this.on(this.tech_, "leavepictureinpicture", (l) => this.handleTechLeavePictureInPicture_(l)), this.on(this.tech_, "error", (l) => this.handleTechError_(l)), this.on(this.tech_, "posterchange", (l) => this.handleTechPosterChange_(l)), this.on(this.tech_, "textdata", (l) => this.handleTechTextData_(l)), this.on(this.tech_, "ratechange", (l) => this.handleTechRateChange_(l)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (a !== "Html5" || !this.tag) && gh(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }
  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */
  unloadTech_() {
    Rn.names.forEach((e) => {
      const n = Rn[e];
      this[n.privateName] = this[n.getterName]();
    }), this.textTracksJson_ = tb.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }
  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */
  tech(e) {
    return e === void 0 && ct.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }
  /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */
  /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */
  version() {
    return {
      "video.js": ph
    };
  }
  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */
  addTechControlsListeners_() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }
  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */
  removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }
  /**
   * Player waits for the tech to be ready
   *
   * @private
   */
  handleTechReady_() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }
  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */
  handleTechLoadStart_() {
    this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }
  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */
  manualAutoplay_(e) {
    if (!this.tech_ || typeof e != "string")
      return;
    const n = () => {
      const i = this.muted();
      this.muted(!0);
      const r = () => {
        this.muted(i);
      };
      this.playTerminatedQueue_.push(r);
      const s = this.play();
      if (dl(s))
        return s.catch((o) => {
          throw r(), new Error(`Rejection at manualAutoplay. Restoring muted value. ${o || ""}`);
        });
    };
    let a;
    if (e === "any" && !this.muted() ? (a = this.play(), dl(a) && (a = a.catch(n))) : e === "muted" && !this.muted() ? a = n() : a = this.play(), !!dl(a))
      return a.then(() => {
        this.trigger({
          type: "autoplay-success",
          autoplay: e
        });
      }).catch(() => {
        this.trigger({
          type: "autoplay-failure",
          autoplay: e
        });
      });
  }
  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */
  updateSourceCaches_(e = "") {
    let n = e, a = "";
    typeof n != "string" && (n = e.src, a = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], n && !a && (a = dne(this, n)), this.cache_.source = Tt({}, e, {
      src: n,
      type: a
    });
    const i = this.cache_.sources.filter((l) => l.src && l.src === n), r = [], s = this.$$("source"), o = [];
    for (let l = 0; l < s.length; l++) {
      const c = Yi(s[l]);
      r.push(c), c.src && c.src === n && o.push(c.src);
    }
    o.length && !i.length ? this.cache_.sources = r : i.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = n;
  }
  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */
  handleTechSourceset_(e) {
    if (!this.changingSrc_) {
      let n = (r) => this.updateSourceCaches_(r);
      const a = this.currentSource().src, i = e.src;
      a && !/^blob:/.test(a) && /^blob:/.test(i) && (!this.lastSource_ || this.lastSource_.tech !== i && this.lastSource_.player !== a) && (n = () => {
      }), n(i), e.src || this.tech_.any(["sourceset", "loadstart"], (r) => {
        if (r.type === "sourceset")
          return;
        const s = this.techGet_("currentSrc");
        this.lastSource_.tech = s, this.updateSourceCaches_(s);
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: e.src
    }, this.trigger({
      src: e.src,
      type: "sourceset"
    });
  }
  /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */
  hasStarted(e) {
    if (e === void 0)
      return this.hasStarted_;
    e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
  }
  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */
  handleTechPlay_() {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }
  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */
  handleTechRateChange_() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }
  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */
  handleTechWaiting_() {
    this.addClass("vjs-waiting"), this.trigger("waiting");
    const e = this.currentTime(), n = () => {
      e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", n));
    };
    this.on("timeupdate", n);
  }
  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */
  handleTechCanPlay_() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }
  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */
  handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }
  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */
  handleTechPlaying_() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }
  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */
  handleTechSeeking_() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }
  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */
  handleTechSeeked_() {
    this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
  }
  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */
  handleTechPause_() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }
  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */
  handleTechEnded_() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }
  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */
  handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  }
  /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */
  handleTechClick_(e) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? Xa(this.play()) : this.pause());
  }
  /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */
  handleTechDoubleClick_(e) {
    if (!this.controls_)
      return;
    Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (a) => a.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !Me.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
  }
  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */
  handleTechTap_() {
    this.userActive(!this.userActive());
  }
  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */
  handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  }
  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */
  handleTechTouchMove_() {
    this.userWasActive && this.reportUserActivity();
  }
  /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */
  handleTechTouchEnd_(e) {
    e.cancelable && e.preventDefault();
  }
  /**
   * @private
   */
  toggleFullscreenClass_() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }
  /**
   * when the document fschange event triggers it calls this
   */
  documentFullscreenChange_(e) {
    const n = e.target.player;
    if (n && n !== this)
      return;
    const a = this.el();
    let i = Me[this.fsApi_.fullscreenElement] === a;
    !i && a.matches && (i = a.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(i);
  }
  /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */
  handleTechFullscreenChange_(e, n) {
    n && (n.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
      this.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(n.isFullscreen));
  }
  handleTechFullscreenError_(e, n) {
    this.trigger("fullscreenerror", n);
  }
  /**
   * @private
   */
  togglePictureInPictureClass_() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }
  /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */
  handleTechEnterPictureInPicture_(e) {
    this.isInPictureInPicture(!0);
  }
  /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */
  handleTechLeavePictureInPicture_(e) {
    this.isInPictureInPicture(!1);
  }
  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */
  handleTechError_() {
    const e = this.tech_.error();
    e && this.error(e);
  }
  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */
  handleTechTextData_() {
    let e = null;
    arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
  }
  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */
  getCache() {
    return this.cache_;
  }
  /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */
  resetCache_() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }
  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */
  techCall_(e, n) {
    this.ready(function() {
      if (e in sne)
        return ine(this.middleware_, this.tech_, e, n);
      if (e in sb)
        return rb(this.middleware_, this.tech_, e, n);
      try {
        this.tech_ && this.tech_[e](n);
      } catch (a) {
        throw ct(a), a;
      }
    }, !0);
  }
  /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */
  techGet_(e) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (e in rne)
        return ane(this.middleware_, this.tech_, e);
      if (e in sb)
        return rb(this.middleware_, this.tech_, e);
      try {
        return this.tech_[e]();
      } catch (n) {
        throw this.tech_[e] === void 0 ? (ct(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, n), n) : n.name === "TypeError" ? (ct(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, n), this.tech_.isReady_ = !1, n) : (ct(n), n);
      }
    }
  }
  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */
  play() {
    return new Promise((e) => {
      this.play_(e);
    });
  }
  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */
  play_(e = Xa) {
    this.playCallbacks_.push(e);
    const n = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), a = !!(md || An);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !n) {
      this.waitToPlay_ = (s) => {
        this.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !n && a && this.load();
      return;
    }
    const i = this.techGet_("play");
    a && this.hasClass("vjs-ended") && this.resetProgressBar_(), i === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(i);
  }
  /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */
  runPlayTerminatedQueue_() {
    const e = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], e.forEach(function(n) {
      n();
    });
  }
  /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */
  runPlayCallbacks_(e) {
    const n = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], n.forEach(function(a) {
      a(e);
    });
  }
  /**
   * Pause the video playback
   */
  pause() {
    this.techCall_("pause");
  }
  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */
  paused() {
    return this.techGet_("paused") !== !1;
  }
  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */
  played() {
    return this.techGet_("played") || Pa(0, 0);
  }
  /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */
  scrubbing(e) {
    if (typeof e > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }
  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */
  currentTime(e) {
    if (e === void 0)
      return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
    if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
      this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
      return;
    }
    this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
  }
  /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */
  applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  }
  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */
  duration(e) {
    if (e === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    e = parseFloat(e), e < 0 && (e = 1 / 0), e !== this.cache_.duration && (this.cache_.duration = e, e === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
  }
  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */
  remainingTime() {
    return this.duration() - this.currentTime();
  }
  /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */
  remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }
  //
  // Kind of like an array of portions of the video that have been downloaded.
  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  buffered() {
    let e = this.techGet_("buffered");
    return (!e || !e.length) && (e = Pa(0, 0)), e;
  }
  /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  seekable() {
    let e = this.techGet_("seekable");
    return (!e || !e.length) && (e = Pa(0, 0)), e;
  }
  /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */
  seeking() {
    return this.techGet_("seeking");
  }
  /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */
  ended() {
    return this.techGet_("ended");
  }
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */
  networkState() {
    return this.techGet_("networkState");
  }
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */
  readyState() {
    return this.techGet_("readyState");
  }
  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */
  bufferedPercent() {
    return L3(this.buffered(), this.duration());
  }
  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */
  bufferedEnd() {
    const e = this.buffered(), n = this.duration();
    let a = e.end(e.length - 1);
    return a > n && (a = n), a;
  }
  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */
  volume(e) {
    let n;
    if (e !== void 0) {
      n = Math.max(0, Math.min(1, e)), this.cache_.volume = n, this.techCall_("setVolume", n), n > 0 && this.lastVolume_(n);
      return;
    }
    return n = parseFloat(this.techGet_("volume")), isNaN(n) ? 1 : n;
  }
  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */
  muted(e) {
    if (e !== void 0) {
      this.techCall_("setMuted", e);
      return;
    }
    return this.techGet_("muted") || !1;
  }
  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */
  defaultMuted(e) {
    return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
  }
  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */
  lastVolume_(e) {
    if (e !== void 0 && e !== 0) {
      this.cache_.lastVolume = e;
      return;
    }
    return this.cache_.lastVolume;
  }
  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */
  supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || !1;
  }
  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */
  isFullscreen(e) {
    if (e !== void 0) {
      const n = this.isFullscreen_;
      this.isFullscreen_ = !!e, this.isFullscreen_ !== n && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }
  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */
  requestFullscreen(e) {
    this.isInPictureInPicture() && this.exitPictureInPicture();
    const n = this;
    return new Promise((a, i) => {
      function r() {
        n.off("fullscreenerror", o), n.off("fullscreenchange", s);
      }
      function s() {
        r(), a();
      }
      function o(c, d) {
        r(), i(d);
      }
      n.one("fullscreenchange", s), n.one("fullscreenerror", o);
      const l = n.requestFullscreenHelper_(e);
      l && (l.then(r, r), l.then(a, i));
    });
  }
  requestFullscreenHelper_(e) {
    let n;
    if (this.fsApi_.prefixed || (n = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (n = e)), this.fsApi_.requestFullscreen) {
      const a = this.el_[this.fsApi_.requestFullscreen](n);
      return a && a.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), a;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }
  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */
  exitFullscreen() {
    const e = this;
    return new Promise((n, a) => {
      function i() {
        e.off("fullscreenerror", s), e.off("fullscreenchange", r);
      }
      function r() {
        i(), n();
      }
      function s(l, c) {
        i(), a(c);
      }
      e.one("fullscreenchange", r), e.one("fullscreenerror", s);
      const o = e.exitFullscreenHelper_();
      o && (o.then(i, i), o.then(n, a));
    });
  }
  exitFullscreenHelper_() {
    if (this.fsApi_.requestFullscreen) {
      const e = Me[this.fsApi_.exitFullscreen]();
      return e && Xa(e.then(() => this.isFullscreen(!1))), e;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }
  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */
  enterFullWindow() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = Me.documentElement.style.overflow, ua(Me, "keydown", this.boundFullWindowOnEscKey_), Me.documentElement.style.overflow = "hidden", Er(Me.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }
  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */
  fullWindowOnEscKey(e) {
    e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }
  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */
  exitFullWindow() {
    this.isFullscreen(!1), this.isFullWindow = !1, En(Me, "keydown", this.boundFullWindowOnEscKey_), Me.documentElement.style.overflow = this.docOrigOverflow, gd(Me.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }
  /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */
  disablePictureInPicture(e) {
    if (e === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
  }
  /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */
  isInPictureInPicture(e) {
    if (e !== void 0) {
      this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    if (this.options_.enableDocumentPictureInPicture && Y.documentPictureInPicture) {
      const e = Me.createElement(this.el().tagName);
      return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(Je("p", {
        className: "vjs-pip-text"
      }, {}, this.localize("Playing in picture-in-picture"))), Y.documentPictureInPicture.requestWindow({
        // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
        width: this.videoWidth(),
        height: this.videoHeight()
      }).then((n) => (g3(n), this.el_.parentNode.insertBefore(e, this.el_), n.document.body.appendChild(this.el_), n.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
        type: "enterpictureinpicture",
        pipWindow: n
      }), n.addEventListener("pagehide", (a) => {
        const i = a.target.querySelector(".video-js");
        e.parentNode.replaceChild(i, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
      }), n));
    }
    return "pictureInPictureEnabled" in Me && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
  }
  /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */
  exitPictureInPicture() {
    if (Y.documentPictureInPicture && Y.documentPictureInPicture.window)
      return Y.documentPictureInPicture.window.close(), Promise.resolve();
    if ("pictureInPictureEnabled" in Me)
      return Me.exitPictureInPicture();
  }
  /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const {
      userActions: n
    } = this.options_;
    !n || !n.hotkeys || ((i) => {
      const r = i.tagName.toLowerCase();
      if (i.isContentEditable)
        return !0;
      const s = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
      return r === "input" ? s.indexOf(i.type) === -1 : ["textarea"].indexOf(r) !== -1;
    })(this.el_.ownerDocument.activeElement) || (typeof n.hotkeys == "function" ? n.hotkeys.call(this, e) : this.handleHotkeys(e));
  }
  /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */
  handleHotkeys(e) {
    const n = this.options_.userActions ? this.options_.userActions.hotkeys : {}, {
      fullscreenKey: a = (s) => e.key.toLowerCase() === "f",
      muteKey: i = (s) => e.key.toLowerCase() === "m",
      playPauseKey: r = (s) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " "
    } = n;
    if (a.call(this, e)) {
      e.preventDefault(), e.stopPropagation();
      const s = ve.getComponent("FullscreenToggle");
      Me[this.fsApi_.fullscreenEnabled] !== !1 && s.prototype.handleClick.call(this, e);
    } else i.call(this, e) ? (e.preventDefault(), e.stopPropagation(), ve.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : r.call(this, e) && (e.preventDefault(), e.stopPropagation(), ve.getComponent("PlayToggle").prototype.handleClick.call(this, e));
  }
  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  canPlayType(e) {
    let n;
    for (let a = 0, i = this.options_.techOrder; a < i.length; a++) {
      const r = i[a];
      let s = rt.getTech(r);
      if (s || (s = ve.getComponent(r)), !s) {
        ct.error(`The "${r}" tech is undefined. Skipped browser support check for that tech.`);
        continue;
      }
      if (s.isSupported() && (n = s.canPlayType(e), n))
        return n;
    }
    return "";
  }
  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */
  selectSource(e) {
    const n = this.options_.techOrder.map((o) => [o, rt.getTech(o)]).filter(([o, l]) => l ? l.isSupported() : (ct.error(`The "${o}" tech is undefined. Skipped browser support check for that tech.`), !1)), a = function(o, l, c) {
      let d;
      return o.some((f) => l.some((g) => {
        if (d = c(f, g), d)
          return !0;
      })), d;
    };
    let i;
    const r = (o) => (l, c) => o(c, l), s = ([o, l], c) => {
      if (l.canPlaySource(c, this.options_[o.toLowerCase()]))
        return {
          source: c,
          tech: o
        };
    };
    return this.options_.sourceOrder ? i = a(e, n, r(s)) : i = a(n, e, s), i || !1;
  }
  /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  handleSrc_(e, n) {
    if (typeof e > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    const a = P3(e);
    if (!a.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, n || (this.cache_.sources = a), this.updateSourceCaches_(a[0]), tne(this, a[0], (i, r) => {
      if (this.middleware_ = r, n || (this.cache_.sources = a), this.updateSourceCaches_(i), this.src_(i)) {
        if (a.length > 1)
          return this.handleSrc_(a.slice(1));
        this.changingSrc_ = !1, this.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), this.triggerReady();
        return;
      }
      nne(r, this.tech_);
    }), a.length > 1) {
      const i = () => {
        this.error(null), this.handleSrc_(a.slice(1), !0);
      }, r = () => {
        this.off("error", i);
      };
      this.one("error", i), this.one("playing", r), this.resetRetryOnError_ = () => {
        this.off("error", i), this.off("playing", r);
      };
    }
  }
  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  src(e) {
    return this.handleSrc_(e, !1);
  }
  /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */
  src_(e) {
    const n = this.selectSource([e]);
    return n ? S3(n.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(n.tech, n.source), this.tech_.ready(() => {
      this.changingSrc_ = !1;
    }), !1) : !0;
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, n) {
    return this.tech_ ? this.tech_.addSourceElement(e, n) : !1;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
  }
  /**
   * Begin loading the src data.
   */
  load() {
    if (this.tech_ && this.tech_.vhs) {
      this.src(this.currentSource());
      return;
    }
    this.techCall_("load");
  }
  /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */
  reset() {
    if (this.paused())
      this.doReset_();
    else {
      const e = this.play();
      Xa(e.then(() => this.doReset_()));
    }
  }
  doReset_() {
    this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
      title: void 0,
      description: void 0
    }), xi(this) && this.trigger("playerreset");
  }
  /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */
  resetControlBarUI_() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }
  /**
   * Reset tech's progress so progress bar is reset in the UI
   */
  resetProgressBar_() {
    this.currentTime(0);
    const {
      currentTimeDisplay: e,
      durationDisplay: n,
      progressControl: a,
      remainingTimeDisplay: i
    } = this.controlBar || {}, {
      seekBar: r
    } = a || {};
    e && e.updateContent(), n && n.updateContent(), i && i.updateContent(), r && (r.update(), r.loadProgressBar && r.loadProgressBar.update());
  }
  /**
   * Reset Playback ratio
   */
  resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }
  /**
   * Reset Volume bar
   */
  resetVolumeBar_() {
    this.volume(1), this.trigger("volumechange");
  }
  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */
  currentSources() {
    const e = this.currentSource(), n = [];
    return Object.keys(e).length !== 0 && n.push(e), this.cache_.sources || n;
  }
  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */
  currentSource() {
    return this.cache_.source || {};
  }
  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */
  currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  }
  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */
  currentType() {
    return this.currentSource() && this.currentSource().type || "";
  }
  /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */
  preload(e) {
    if (e !== void 0) {
      this.techCall_("setPreload", e), this.options_.preload = e;
      return;
    }
    return this.techGet_("preload");
  }
  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */
  autoplay(e) {
    if (e === void 0)
      return this.options_.autoplay || !1;
    let n;
    typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), n = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, n = typeof n > "u" ? this.options_.autoplay : n, this.tech_ && this.techCall_("setAutoplay", n);
  }
  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  playsinline(e) {
    return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
  }
  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */
  loop(e) {
    if (e !== void 0) {
      this.techCall_("setLoop", e), this.options_.loop = e;
      return;
    }
    return this.techGet_("loop");
  }
  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */
  poster(e) {
    if (e === void 0)
      return this.poster_;
    e || (e = ""), e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }
  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */
  handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      const e = this.tech_.poster() || "";
      e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }
  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */
  controls(e) {
    if (e === void 0)
      return !!this.controls_;
    e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }
  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */
  usingNativeControls(e) {
    if (e === void 0)
      return !!this.usingNativeControls_;
    e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }
  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */
  error(e) {
    if (e === void 0)
      return this.error_ || null;
    if (er("beforeerror").forEach((n) => {
      const a = n(this, e);
      if (!(ni(a) && !Array.isArray(a) || typeof a == "string" || typeof a == "number" || a === null)) {
        this.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      e = a;
    }), this.options_.suppressNotSupportedError && e && e.code === 4) {
      const n = function() {
        this.error(e);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], n), this.one("loadstart", function() {
        this.off(["click", "touchstart"], n);
      });
      return;
    }
    if (e === null) {
      this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new Yt(e), this.addClass("vjs-error"), ct.error(`(CODE:${this.error_.code} ${Yt.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), er("error").forEach((n) => n(this, this.error_));
  }
  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */
  reportUserActivity(e) {
    this.userActivity_ = !0;
  }
  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */
  userActive(e) {
    if (e === void 0)
      return this.userActive_;
    if (e = !!e, e !== this.userActive_) {
      if (this.userActive_ = e, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(n) {
        n.stopPropagation(), n.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }
  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */
  listenForUserActivity_() {
    let e, n, a;
    const i = At(this, this.reportUserActivity), r = function(f) {
      (f.screenX !== n || f.screenY !== a) && (n = f.screenX, a = f.screenY, i());
    }, s = function() {
      i(), this.clearInterval(e), e = this.setInterval(i, 250);
    }, o = function(f) {
      i(), this.clearInterval(e);
    };
    this.on("mousedown", s), this.on("mousemove", r), this.on("mouseup", o), this.on("mouseleave", o);
    const l = this.getChild("controlBar");
    l && !An && !Na && (l.on("mouseenter", function(f) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), l.on("mouseleave", function(f) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", i), this.on("keyup", i);
    let c;
    const d = function() {
      if (!this.userActivity_)
        return;
      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(c);
      const f = this.options_.inactivityTimeout;
      f <= 0 || (c = this.setTimeout(function() {
        this.userActivity_ || this.userActive(!1);
      }, f));
    };
    this.setInterval(d, 250);
  }
  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */
  playbackRate(e) {
    if (e !== void 0) {
      this.techCall_("setPlaybackRate", e);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }
  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */
  defaultPlaybackRate(e) {
    return e !== void 0 ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }
  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */
  isAudio(e) {
    if (e !== void 0) {
      this.isAudio_ = !!e;
      return;
    }
    return !!this.isAudio_;
  }
  updatePlayerHeightOnAudioOnlyMode_() {
    const e = this.getChild("ControlBar");
    !e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
  }
  enableAudioOnlyUI_() {
    this.addClass("vjs-audio-only-mode");
    const e = this.children(), n = this.getChild("ControlBar"), a = n && n.currentHeight();
    e.forEach((i) => {
      i !== n && i.el_ && !i.hasClass("vjs-hidden") && (i.hide(), this.audioOnlyCache_.hiddenChildren.push(i));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = a, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(a), this.trigger("audioonlymodechange");
  }
  disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }
  /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioOnlyMode(e) {
    if (typeof e != "boolean" || e === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    if (this.audioOnlyMode_ = e, e) {
      const n = [];
      return this.isInPictureInPicture() && n.push(this.exitPictureInPicture()), this.isFullscreen() && n.push(this.exitFullscreen()), this.audioPosterMode() && n.push(this.audioPosterMode(!1)), Promise.all(n).then(() => this.enableAudioOnlyUI_());
    }
    return Promise.resolve().then(() => this.disableAudioOnlyUI_());
  }
  enablePosterModeUI_() {
    (this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  disablePosterModeUI_() {
    (this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioPosterMode(e) {
    return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.disablePosterModeUI_();
    }));
  }
  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */
  addTextTrack(e, n, a) {
    if (this.tech_)
      return this.tech_.addTextTrack(e, n, a);
  }
  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */
  addRemoteTextTrack(e, n) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(e, n);
  }
  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */
  removeRemoteTextTrack(e = {}) {
    let {
      track: n
    } = e;
    if (n || (n = e), this.tech_)
      return this.tech_.removeRemoteTextTrack(n);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */
  getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  }
  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */
  videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }
  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */
  videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }
  /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */
  language(e) {
    if (e === void 0)
      return this.language_;
    this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), xi(this) && this.trigger("languagechange"));
  }
  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */
  languages() {
    return Tt(It.prototype.options_.languages, this.languages_);
  }
  /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */
  toJSON() {
    const e = Tt(this.options_), n = e.tracks;
    e.tracks = [];
    for (let a = 0; a < n.length; a++) {
      let i = n[a];
      i = Tt(i), i.player = void 0, e.tracks[a] = i;
    }
    return e;
  }
  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */
  createModal(e, n) {
    n = n || {}, n.content = e || "";
    const a = new co(this, n);
    return this.addChild(a), a.on("dispose", () => {
      this.removeChild(a);
    }), a.open(), a;
  }
  /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */
  updateCurrentBreakpoint_() {
    if (!this.responsive())
      return;
    const e = this.currentBreakpoint(), n = this.currentWidth();
    for (let a = 0; a < kh.length; a++) {
      const i = kh[a], r = this.breakpoints_[i];
      if (n <= r) {
        if (e === i)
          return;
        e && this.removeClass(Yc[e]), this.addClass(Yc[i]), this.breakpoint_ = i;
        break;
      }
    }
  }
  /**
   * Removes the current breakpoint.
   *
   * @private
   */
  removeCurrentBreakpoint_() {
    const e = this.currentBreakpointClass();
    this.breakpoint_ = "", e && this.removeClass(e);
  }
  /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */
  breakpoints(e) {
    return e === void 0 ? Object.assign(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Object.assign({}, Yne, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
  }
  /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */
  responsive(e) {
    if (e === void 0)
      return this.responsive_;
    e = !!e;
    const n = this.responsive_;
    if (e !== n)
      return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
  }
  /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */
  currentBreakpoint() {
    return this.breakpoint_;
  }
  /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */
  currentBreakpointClass() {
    return Yc[this.breakpoint_] || "";
  }
  /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */
  /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */
  loadMedia(e, n) {
    if (!e || typeof e != "object")
      return;
    const a = this.crossOrigin();
    this.reset(), this.cache_.media = Tt(e);
    const {
      artist: i,
      artwork: r,
      description: s,
      poster: o,
      src: l,
      textTracks: c,
      title: d
    } = this.cache_.media;
    !r && o && (this.cache_.media.artwork = [{
      src: o,
      type: Su(o)
    }]), a && this.crossOrigin(a), l && this.src(l), o && this.poster(o), Array.isArray(c) && c.forEach((f) => this.addRemoteTextTrack(f, !1)), this.titleBar && this.titleBar.update({
      title: d,
      description: s || i || ""
    }), this.ready(n);
  }
  /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */
  getMedia() {
    if (!this.cache_.media) {
      const e = this.poster(), n = this.currentSources(), a = Array.prototype.map.call(this.remoteTextTracks(), (r) => ({
        kind: r.kind,
        label: r.label,
        language: r.language,
        src: r.src
      })), i = {
        src: n,
        textTracks: a
      };
      return e && (i.poster = e, i.artwork = [{
        src: i.poster,
        type: Su(i.poster)
      }]), i;
    }
    return Tt(this.cache_.media);
  }
  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */
  static getTagSettings(e) {
    const n = {
      sources: [],
      tracks: []
    }, a = Yi(e), i = a["data-setup"];
    if (cl(e, "vjs-fill") && (a.fill = !0), cl(e, "vjs-fluid") && (a.fluid = !0), i !== null)
      try {
        Object.assign(a, JSON.parse(i || "{}"));
      } catch (r) {
        ct.error("data-setup", r);
      }
    if (Object.assign(n, a), e.hasChildNodes()) {
      const r = e.childNodes;
      for (let s = 0, o = r.length; s < o; s++) {
        const l = r[s], c = l.nodeName.toLowerCase();
        c === "source" ? n.sources.push(Yi(l)) : c === "track" && n.tracks.push(Yi(l));
      }
    }
    return n;
  }
  /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */
  debug(e) {
    if (e === void 0)
      return this.debugEnabled_;
    e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }
  /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */
  playbackRates(e) {
    if (e === void 0)
      return this.cache_.playbackRates;
    Array.isArray(e) && e.every((n) => typeof n == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
  }
  /**
   * Reports whether or not a player has a plugin available.
   *
   * This does not report whether or not the plugin has ever been initialized
   * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
   *
   * @method hasPlugin
   * @param  {string}  name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player has the requested plugin available.
   */
  /**
   * Reports whether or not a player is using a plugin by name.
   *
   * For basic plugins, this only reports whether the plugin has _ever_ been
   * initialized on this player.
   *
   * @method Player#usingPlugin
   * @param  {string} name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player is using the requested plugin.
   */
}
Rn.names.forEach(function(t) {
  const e = Rn[t];
  It.prototype[e.getterName] = function() {
    return this.tech_ ? this.tech_[e.getterName]() : (this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName]);
  };
});
It.prototype.crossorigin = It.prototype.crossOrigin;
It.players = {};
const Vo = Y.navigator;
It.prototype.options_ = {
  // Default order of fallback technology
  techOrder: rt.defaultTechOrder_,
  html5: {},
  // enable sourceset by default
  enableSourceset: !0,
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "titleBar", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: Vo && (Vo.languages && Vo.languages[0] || Vo.userLanguage || Vo.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1,
  spatialNavigation: {
    enabled: !1,
    horizontalSeek: !1
  },
  // Default smooth seeking to false
  enableSmoothSeeking: !1,
  disableSeekWhileScrubbingOnMobile: !1
};
u_.forEach(function(t) {
  It.prototype[`handleTech${qt(t)}_`] = function() {
    return this.trigger(t);
  };
});
ve.registerComponent("Player", It);
const Cu = "plugin", Ts = "activePlugins_", fs = {}, Au = (t) => fs.hasOwnProperty(t), jc = (t) => Au(t) ? fs[t] : void 0, d_ = (t, e) => {
  t[Ts] = t[Ts] || {}, t[Ts][e] = !0;
}, Eu = (t, e, n) => {
  const a = (n ? "before" : "") + "pluginsetup";
  t.trigger(a, e), t.trigger(a + ":" + e.name, e);
}, jne = function(t, e) {
  const n = function() {
    Eu(this, {
      name: t,
      plugin: e,
      instance: null
    }, !0);
    const a = e.apply(this, arguments);
    return d_(this, t), Eu(this, {
      name: t,
      plugin: e,
      instance: a
    }), a;
  };
  return Object.keys(e).forEach(function(a) {
    n[a] = e[a];
  }), n;
}, wb = (t, e) => (e.prototype.name = t, function(...n) {
  Eu(this, {
    name: t,
    plugin: e,
    instance: null
  }, !0);
  const a = new e(this, ...n);
  return this[t] = () => a, Eu(this, a.getEventHash()), a;
});
class ea {
  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  constructor(e) {
    if (this.constructor === ea)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = e, this.log || (this.log = this.player.log.createLogger(this.name)), ip(this), delete this.trigger, k3(this, this.constructor.defaultState), d_(e, this.name), this.dispose = this.dispose.bind(this), e.on("dispose", this.dispose);
  }
  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */
  version() {
    return this.constructor.VERSION;
  }
  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */
  getEventHash(e = {}) {
    return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
  }
  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */
  trigger(e, n = {}) {
    return lo(this.eventBusEl_, e, this.getEventHash(n));
  }
  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */
  handleStateChanged(e) {
  }
  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */
  dispose() {
    const {
      name: e,
      player: n
    } = this;
    this.trigger("dispose"), this.off(), n.off("dispose", this.dispose), n[Ts][e] = !1, this.player = this.state = null, n[e] = wb(e, fs[e]);
  }
  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */
  static isBasic(e) {
    const n = typeof e == "string" ? jc(e) : e;
    return typeof n == "function" && !ea.prototype.isPrototypeOf(n.prototype);
  }
  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */
  static registerPlugin(e, n) {
    if (typeof e != "string")
      throw new Error(`Illegal plugin name, "${e}", must be a string, was ${typeof e}.`);
    if (Au(e))
      ct.warn(`A plugin named "${e}" already exists. You may want to avoid re-registering plugins!`);
    else if (It.prototype.hasOwnProperty(e))
      throw new Error(`Illegal plugin name, "${e}", cannot share a name with an existing player method!`);
    if (typeof n != "function")
      throw new Error(`Illegal plugin for "${e}", must be a function, was ${typeof n}.`);
    return fs[e] = n, e !== Cu && (ea.isBasic(n) ? It.prototype[e] = jne(e, n) : It.prototype[e] = wb(e, n)), n;
  }
  /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */
  static deregisterPlugin(e) {
    if (e === Cu)
      throw new Error("Cannot de-register base plugin.");
    Au(e) && (delete fs[e], delete It.prototype[e]);
  }
  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */
  static getPlugins(e = Object.keys(fs)) {
    let n;
    return e.forEach((a) => {
      const i = jc(a);
      i && (n = n || {}, n[a] = i);
    }), n;
  }
  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */
  static getPluginVersion(e) {
    const n = jc(e);
    return n && n.VERSION || "";
  }
}
ea.getPlugin = jc;
ea.BASE_PLUGIN_NAME = Cu;
ea.registerPlugin(Cu, ea);
It.prototype.usingPlugin = function(t) {
  return !!this[Ts] && this[Ts][t] === !0;
};
It.prototype.hasPlugin = function(t) {
  return !!Au(t);
};
function Vne(t, e) {
  let n = !1;
  return function(...a) {
    return n || ct.warn(t), n = !0, e.apply(this, a);
  };
}
function za(t, e, n, a) {
  return Vne(`${e} is deprecated and will be removed in ${t}.0; please use ${n} instead.`, a);
}
var qne = {
  NetworkBadStatus: "networkbadstatus",
  NetworkRequestFailed: "networkrequestfailed",
  NetworkRequestAborted: "networkrequestaborted",
  NetworkRequestTimeout: "networkrequesttimeout",
  NetworkBodyParserFailed: "networkbodyparserfailed",
  StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
  StreamingDashManifestParserError: "streamingdashmanifestparsererror",
  StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
  StreamingVttParserError: "streamingvttparsererror",
  StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
  StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
  StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
  StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
  StreamingCodecsChangeError: "streamingcodecschangeerror"
};
const h_ = (t) => t.indexOf("#") === 0 ? t.slice(1) : t;
function le(t, e, n) {
  let a = le.getPlayer(t);
  if (a)
    return e && ct.warn(`Player "${t}" is already initialised. Options will not be applied.`), n && a.ready(n), a;
  const i = typeof t == "string" ? tr("#" + h_(t)) : t;
  if (!oo(i))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  const s = ("getRootNode" in i ? i.getRootNode() instanceof Y.ShadowRoot : !1) ? i.getRootNode() : i.ownerDocument.body;
  (!i.ownerDocument.defaultView || !s.contains(i)) && ct.warn("The element supplied is not included in the DOM"), e = e || {}, e.restoreEl === !0 && (e.restoreEl = (i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), er("beforesetup").forEach((l) => {
    const c = l(i, Tt(e));
    if (!ni(c) || Array.isArray(c)) {
      ct.error("please return an object in beforesetup hooks");
      return;
    }
    e = Tt(e, c);
  });
  const o = ve.getComponent("Player");
  return a = new o(i, e, n), er("setup").forEach((l) => l(a)), a;
}
le.hooks_ = mi;
le.hooks = er;
le.hook = kte;
le.hookOnce = Ste;
le.removeHook = X5;
if (Y.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && so()) {
  let t = tr(".vjs-styles-defaults");
  if (!t) {
    t = y3("vjs-styles-defaults");
    const e = tr("head");
    e && e.insertBefore(t, e.firstChild), _3(t, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
vh(1, le);
le.VERSION = ph;
le.options = It.prototype.options_;
le.getPlayers = () => It.players;
le.getPlayer = (t) => {
  const e = It.players;
  let n;
  if (typeof t == "string") {
    const a = h_(t), i = e[a];
    if (i)
      return i;
    n = tr("#" + a);
  } else
    n = t;
  if (oo(n)) {
    const {
      player: a,
      playerId: i
    } = n;
    if (a || e[i])
      return a || e[i];
  }
};
le.getAllPlayers = () => (
  // Disposed players leave a key with a `null` value, so we need to make sure
  // we filter those out.
  Object.keys(It.players).map((t) => It.players[t]).filter(Boolean)
);
le.players = It.players;
le.getComponent = ve.getComponent;
le.registerComponent = (t, e) => (rt.isTech(e) && ct.warn(`The ${t} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), ve.registerComponent.call(ve, t, e));
le.getTech = rt.getTech;
le.registerTech = rt.registerTech;
le.use = ene;
Object.defineProperty(le, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(le.middleware, "TERMINATOR", {
  value: ku,
  writeable: !1,
  enumerable: !0
});
le.browser = i3;
le.obj = Ete;
le.mergeOptions = za(9, "videojs.mergeOptions", "videojs.obj.merge", Tt);
le.defineLazyProperty = za(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", dd);
le.bind = za(9, "videojs.bind", "native Function.prototype.bind", At);
le.registerPlugin = ea.registerPlugin;
le.deregisterPlugin = ea.deregisterPlugin;
le.plugin = (t, e) => (ct.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), ea.registerPlugin(t, e));
le.getPlugins = ea.getPlugins;
le.getPlugin = ea.getPlugin;
le.getPluginVersion = ea.getPluginVersion;
le.addLanguage = function(t, e) {
  return t = ("" + t).toLowerCase(), le.options.languages = Tt(le.options.languages, {
    [t]: e
  }), le.options.languages[t];
};
le.log = ct;
le.createLogger = Z5;
le.time = Yte;
le.createTimeRange = za(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", Pa);
le.createTimeRanges = za(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", Pa);
le.formatTime = za(9, "videojs.formatTime", "videojs.time.formatTime", Nr);
le.setFormatTime = za(9, "videojs.setFormatTime", "videojs.time.setFormatTime", A3);
le.resetFormatTime = za(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", E3);
le.parseUrl = za(9, "videojs.parseUrl", "videojs.url.parseUrl", op);
le.isCrossOrigin = za(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", wd);
le.EventTarget = da;
le.any = ap;
le.on = ua;
le.one = xd;
le.off = En;
le.trigger = lo;
le.xhr = a5;
le.TextTrack = Vl;
le.AudioTrack = M3;
le.VideoTrack = O3;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach((t) => {
  le[t] = function() {
    return ct.warn(`videojs.${t}() is deprecated; use videojs.dom.${t}() instead`), b3[t].apply(null, arguments);
  };
});
le.computedStyle = za(9, "videojs.computedStyle", "videojs.dom.computedStyle", Vs);
le.dom = b3;
le.fn = Nte;
le.num = xne;
le.str = Ute;
le.url = Qte;
le.Error = qne;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
class Wne {
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  constructor(e) {
    let n = this;
    return n.id = e.id, n.label = n.id, n.width = e.width, n.height = e.height, n.bitrate = e.bandwidth, n.frameRate = e.frameRate, n.enabled_ = e.enabled, Object.defineProperty(n, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get() {
        return n.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set(a) {
        n.enabled_(a);
      }
    }), n;
  }
}
class Lu extends le.EventTarget {
  /**
   * Creates a QualityLevelList.
   */
  constructor() {
    super();
    let e = this;
    return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", {
      get() {
        return e.selectedIndex_;
      }
    }), Object.defineProperty(e, "length", {
      get() {
        return e.levels_.length;
      }
    }), e[Symbol.iterator] = () => e.levels_.values(), e;
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */
  addQualityLevel(e) {
    let n = this.getQualityLevelById(e.id);
    if (n)
      return n;
    const a = this.levels_.length;
    return n = new Wne(e), "" + a in this || Object.defineProperty(this, a, {
      get() {
        return this.levels_[a];
      }
    }), this.levels_.push(n), this.trigger({
      qualityLevel: n,
      type: "addqualitylevel"
    }), n;
  }
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */
  removeQualityLevel(e) {
    let n = null;
    for (let a = 0, i = this.length; a < i; a++)
      if (this[a] === e) {
        n = this.levels_.splice(a, 1)[0], this.selectedIndex_ === a ? this.selectedIndex_ = -1 : this.selectedIndex_ > a && this.selectedIndex_--;
        break;
      }
    return n && this.trigger({
      qualityLevel: e,
      type: "removequalitylevel"
    }), n;
  }
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */
  getQualityLevelById(e) {
    for (let n = 0, a = this.length; n < a; n++) {
      const i = this[n];
      if (i.id === e)
        return i;
    }
    return null;
  }
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */
  dispose() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }
}
Lu.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (const t in Lu.prototype.allowedEvents_)
  Lu.prototype["on" + t] = null;
var f_ = "4.1.0";
const Gne = function(t, e) {
  const n = t.qualityLevels, a = new Lu(), i = function() {
    a.dispose(), t.qualityLevels = n, t.off("dispose", i);
  };
  return t.on("dispose", i), t.qualityLevels = () => a, t.qualityLevels.VERSION = f_, a;
}, p_ = function(t) {
  return Gne(this, le.obj.merge({}, t));
};
le.registerPlugin("qualityLevels", p_);
p_.VERSION = f_;
/*! @name @videojs/http-streaming @version 3.16.2 @license Apache-2.0 */
const Xn = rd, Du = (t, e) => e && e.responseURL && t !== e.responseURL ? e.responseURL : t, Ta = (t) => le.log.debug ? le.log.debug.bind(le, "VHS:", `${t} >`) : function() {
};
function gt(...t) {
  const e = le.obj || le;
  return (e.merge || e.mergeOptions).apply(e, t);
}
function vn(...t) {
  const e = le.time || le;
  return (e.createTimeRanges || e.createTimeRanges).apply(e, t);
}
function Xne(t) {
  if (t.length === 0)
    return "Buffered Ranges are empty";
  let e = `Buffered Ranges: 
`;
  for (let n = 0; n < t.length; n++) {
    const a = t.start(n), i = t.end(n);
    e += `${a} --> ${i}. Duration (${i - a})
`;
  }
  return e;
}
const Za = 1 / 30, Ka = Za * 3, m_ = function(t, e) {
  const n = [];
  let a;
  if (t && t.length)
    for (a = 0; a < t.length; a++)
      e(t.start(a), t.end(a)) && n.push([t.start(a), t.end(a)]);
  return vn(n);
}, ps = function(t, e) {
  return m_(t, function(n, a) {
    return n - Ka <= e && a + Ka >= e;
  });
}, Oc = function(t, e) {
  return m_(t, function(n) {
    return n - Za >= e;
  });
}, Zne = function(t) {
  if (t.length < 2)
    return vn();
  const e = [];
  for (let n = 1; n < t.length; n++) {
    const a = t.end(n - 1), i = t.start(n);
    e.push([a, i]);
  }
  return vn(e);
}, Kne = function(t, e) {
  let n = null, a = null, i = 0;
  const r = [], s = [];
  if (!t || !t.length || !e || !e.length)
    return vn();
  let o = t.length;
  for (; o--; )
    r.push({
      time: t.start(o),
      type: "start"
    }), r.push({
      time: t.end(o),
      type: "end"
    });
  for (o = e.length; o--; )
    r.push({
      time: e.start(o),
      type: "start"
    }), r.push({
      time: e.end(o),
      type: "end"
    });
  for (r.sort(function(l, c) {
    return l.time - c.time;
  }), o = 0; o < r.length; o++)
    r[o].type === "start" ? (i++, i === 2 && (n = r[o].time)) : r[o].type === "end" && (i--, i === 1 && (a = r[o].time)), n !== null && a !== null && (s.push([n, a]), n = null, a = null);
  return vn(s);
}, g_ = (t) => {
  const e = [];
  if (!t || !t.length)
    return "";
  for (let n = 0; n < t.length; n++)
    e.push(t.start(n) + " => " + t.end(n));
  return e.join(", ");
}, Qne = function(t, e, n = 1) {
  return ((t.length ? t.end(t.length - 1) : 0) - e) / n;
}, kr = (t) => {
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push({
      start: t.start(n),
      end: t.end(n)
    });
  return e;
}, Jne = function(t, e) {
  if (t === e)
    return !1;
  if (!t && e || !e && t || t.length !== e.length)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t.start(n) !== e.start(n) || t.end(n) !== e.end(n))
      return !0;
  return !1;
}, P0 = function(t) {
  if (!(!t || !t.length || !t.end))
    return t.end(t.length - 1);
}, kp = function(t, e) {
  let n = 0;
  if (!t || !t.length)
    return n;
  for (let a = 0; a < t.length; a++) {
    const i = t.start(a), r = t.end(a);
    if (!(e > r)) {
      if (e > i && e <= r) {
        n += r - e;
        continue;
      }
      n += r - i;
    }
  }
  return n;
}, Sp = (t, e) => {
  if (!e.preload)
    return e.duration;
  let n = 0;
  return (e.parts || []).forEach(function(a) {
    n += a.duration;
  }), (e.preloadHints || []).forEach(function(a) {
    a.type === "PART" && (n += t.partTargetDuration);
  }), n;
}, Sh = (t) => (t.segments || []).reduce((e, n, a) => (n.parts ? n.parts.forEach(function(i, r) {
  e.push({
    duration: i.duration,
    segmentIndex: a,
    partIndex: r,
    part: i,
    segment: n
  });
}) : e.push({
  duration: n.duration,
  segmentIndex: a,
  partIndex: null,
  segment: n,
  part: null
}), e), []), b_ = (t) => {
  const e = t.segments && t.segments.length && t.segments[t.segments.length - 1];
  return e && e.parts || [];
}, v_ = ({
  preloadSegment: t
}) => {
  if (!t)
    return;
  const {
    parts: e,
    preloadHints: n
  } = t;
  let a = (n || []).reduce((i, r) => i + (r.type === "PART" ? 1 : 0), 0);
  return a += e && e.length ? e.length : 0, a;
}, y_ = (t, e) => {
  if (e.endList)
    return 0;
  if (t && t.suggestedPresentationDelay)
    return t.suggestedPresentationDelay;
  const n = b_(e).length > 0;
  return n && e.serverControl && e.serverControl.partHoldBack ? e.serverControl.partHoldBack : n && e.partTargetDuration ? e.partTargetDuration * 3 : e.serverControl && e.serverControl.holdBack ? e.serverControl.holdBack : e.targetDuration ? e.targetDuration * 3 : 0;
}, eae = function(t, e) {
  let n = 0, a = e - t.mediaSequence, i = t.segments[a];
  if (i) {
    if (typeof i.start < "u")
      return {
        result: i.start,
        precise: !0
      };
    if (typeof i.end < "u")
      return {
        result: i.end - i.duration,
        precise: !0
      };
  }
  for (; a--; ) {
    if (i = t.segments[a], typeof i.end < "u")
      return {
        result: n + i.end,
        precise: !0
      };
    if (n += Sp(t, i), typeof i.start < "u")
      return {
        result: n + i.start,
        precise: !0
      };
  }
  return {
    result: n,
    precise: !1
  };
}, tae = function(t, e) {
  let n = 0, a, i = e - t.mediaSequence;
  for (; i < t.segments.length; i++) {
    if (a = t.segments[i], typeof a.start < "u")
      return {
        result: a.start - n,
        precise: !0
      };
    if (n += Sp(t, a), typeof a.end < "u")
      return {
        result: a.end - n,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, __ = function(t, e, n) {
  if (typeof e > "u" && (e = t.mediaSequence + t.segments.length), e < t.mediaSequence)
    return 0;
  const a = eae(t, e);
  if (a.precise)
    return a.result;
  const i = tae(t, e);
  return i.precise ? i.result : a.result + n;
}, x_ = function(t, e, n) {
  if (!t)
    return 0;
  if (typeof n != "number" && (n = 0), typeof e > "u") {
    if (t.totalDuration)
      return t.totalDuration;
    if (!t.endList)
      return Y.Infinity;
  }
  return __(t, e, n);
}, hl = function({
  defaultDuration: t,
  durationList: e,
  startIndex: n,
  endIndex: a
}) {
  let i = 0;
  if (n > a && ([n, a] = [a, n]), n < 0) {
    for (let r = n; r < Math.min(0, a); r++)
      i += t;
    n = 0;
  }
  for (let r = n; r < a; r++)
    i += e[r].duration;
  return i;
}, T_ = function(t, e, n, a) {
  if (!t || !t.segments)
    return null;
  if (t.endList)
    return x_(t);
  if (e === null)
    return null;
  e = e || 0;
  let i = __(t, t.mediaSequence + t.segments.length, e);
  return n && (a = typeof a == "number" ? a : y_(null, t), i -= a), Math.max(0, i);
}, nae = function(t, e, n) {
  const i = e || 0;
  let r = T_(t, e, !0, n);
  return r === null ? vn() : (r < i && (r = i), vn(i, r));
}, aae = function({
  playlist: t,
  currentTime: e,
  startingSegmentIndex: n,
  startingPartIndex: a,
  startTime: i,
  exactManifestTimings: r
}) {
  let s = e - i;
  const o = Sh(t);
  let l = 0;
  for (let c = 0; c < o.length; c++) {
    const d = o[c];
    if (n === d.segmentIndex && !(typeof a == "number" && typeof d.partIndex == "number" && a !== d.partIndex)) {
      l = c;
      break;
    }
  }
  if (s < 0) {
    if (l > 0)
      for (let c = l - 1; c >= 0; c--) {
        const d = o[c];
        if (s += d.duration, r) {
          if (s < 0)
            continue;
        } else if (s + Za <= 0)
          continue;
        return {
          partIndex: d.partIndex,
          segmentIndex: d.segmentIndex,
          startTime: i - hl({
            defaultDuration: t.targetDuration,
            durationList: o,
            startIndex: l,
            endIndex: c
          })
        };
      }
    return {
      partIndex: o[0] && o[0].partIndex || null,
      segmentIndex: o[0] && o[0].segmentIndex || 0,
      startTime: e
    };
  }
  if (l < 0) {
    for (let c = l; c < 0; c++)
      if (s -= t.targetDuration, s < 0)
        return {
          partIndex: o[0] && o[0].partIndex || null,
          segmentIndex: o[0] && o[0].segmentIndex || 0,
          startTime: e
        };
    l = 0;
  }
  for (let c = l; c < o.length; c++) {
    const d = o[c];
    s -= d.duration;
    const f = d.duration > Za, g = s === 0, _ = f && s + Za >= 0;
    if (!((g || _) && c !== o.length - 1)) {
      if (r) {
        if (s > 0)
          continue;
      } else if (s - Za >= 0)
        continue;
      return {
        partIndex: d.partIndex,
        segmentIndex: d.segmentIndex,
        startTime: i + hl({
          defaultDuration: t.targetDuration,
          durationList: o,
          startIndex: l,
          endIndex: c
        })
      };
    }
  }
  return {
    segmentIndex: o[o.length - 1].segmentIndex,
    partIndex: o[o.length - 1].partIndex,
    startTime: e
  };
}, w_ = function(t) {
  return t.excludeUntil && t.excludeUntil > Date.now();
}, Cp = function(t) {
  return t.excludeUntil && t.excludeUntil === 1 / 0;
}, Ad = function(t) {
  const e = w_(t);
  return !t.disabled && !e;
}, iae = function(t) {
  return t.disabled;
}, rae = function(t) {
  for (let e = 0; e < t.segments.length; e++)
    if (t.segments[e].key)
      return !0;
  return !1;
}, k_ = function(t, e) {
  return e.attributes && e.attributes[t];
}, sae = function(t, e, n, a = 0) {
  return k_("BANDWIDTH", n) ? (t * n.attributes.BANDWIDTH - a * 8) / e : NaN;
}, Ch = (t, e) => {
  if (t.playlists.length === 1)
    return !0;
  const n = e.attributes.BANDWIDTH || Number.MAX_VALUE;
  return t.playlists.filter((a) => Ad(a) ? (a.attributes.BANDWIDTH || 0) < n : !1).length === 0;
}, Ap = (t, e) => !t && !e || !t && e || t && !e ? !1 : !!(t === e || t.id && e.id && t.id === e.id || t.resolvedUri && e.resolvedUri && t.resolvedUri === e.resolvedUri || t.uri && e.uri && t.uri === e.uri), kb = function(t, e) {
  const n = t && t.mediaGroups && t.mediaGroups.AUDIO || {};
  let a = !1;
  for (const i in n) {
    for (const r in n[i])
      if (a = e(n[i][r]), a)
        break;
    if (a)
      break;
  }
  return !!a;
}, Xl = (t) => {
  if (!t || !t.playlists || !t.playlists.length)
    return kb(t, (n) => n.playlists && n.playlists.length || n.uri);
  for (let e = 0; e < t.playlists.length; e++) {
    const n = t.playlists[e], a = n.attributes && n.attributes.CODECS;
    if (!(a && a.split(",").every((r) => c5(r)) || kb(t, (r) => Ap(n, r))))
      return !1;
  }
  return !0;
};
var Zn = {
  liveEdgeDelay: y_,
  duration: x_,
  seekable: nae,
  getMediaInfoForTime: aae,
  isEnabled: Ad,
  isDisabled: iae,
  isExcluded: w_,
  isIncompatible: Cp,
  playlistEnd: T_,
  isAes: rae,
  hasAttribute: k_,
  estimateSegmentRequestTime: sae,
  isLowestEnabledRendition: Ch,
  isAudioOnly: Xl,
  playlistMatch: Ap,
  segmentDurationWithParts: Sp
};
const {
  log: S_
} = le, ws = (t, e) => `${t}-${e}`, C_ = (t, e, n) => `placeholder-uri-${t}-${e}-${n}`, oae = ({
  onwarn: t,
  oninfo: e,
  manifestString: n,
  customTagParsers: a = [],
  customTagMappers: i = [],
  llhls: r
}) => {
  const s = new TJ();
  t && s.on("warn", t), e && s.on("info", e), a.forEach((c) => s.addParser(c)), i.forEach((c) => s.addTagMapper(c)), s.push(n), s.end();
  const o = s.manifest;
  if (r || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(c) {
    o.hasOwnProperty(c) && delete o[c];
  }), o.segments && o.segments.forEach(function(c) {
    ["parts", "preloadHints"].forEach(function(d) {
      c.hasOwnProperty(d) && delete c[d];
    });
  })), !o.targetDuration) {
    let c = 10;
    o.segments && o.segments.length && (c = o.segments.reduce((d, f) => Math.max(d, f.duration), 0)), t && t({
      message: `manifest has no targetDuration defaulting to ${c}`
    }), o.targetDuration = c;
  }
  const l = b_(o);
  if (l.length && !o.partTargetDuration) {
    const c = l.reduce((d, f) => Math.max(d, f.duration), 0);
    t && (t({
      message: `manifest has no partTargetDuration defaulting to ${c}`
    }), S_.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), o.partTargetDuration = c;
  }
  return o;
}, fo = (t, e) => {
  t.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((n) => {
    if (t.mediaGroups[n])
      for (const a in t.mediaGroups[n])
        for (const i in t.mediaGroups[n][a]) {
          const r = t.mediaGroups[n][a][i];
          e(r, n, a, i);
        }
  });
}, A_ = ({
  playlist: t,
  uri: e,
  id: n
}) => {
  t.id = n, t.playlistErrors_ = 0, e && (t.uri = e), t.attributes = t.attributes || {};
}, lae = (t) => {
  let e = t.playlists.length;
  for (; e--; ) {
    const n = t.playlists[e];
    A_({
      playlist: n,
      id: ws(e, n.uri)
    }), n.resolvedUri = Xn(t.uri, n.uri), t.playlists[n.id] = n, t.playlists[n.uri] = n, n.attributes.BANDWIDTH || S_.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, cae = (t) => {
  fo(t, (e) => {
    e.uri && (e.resolvedUri = Xn(t.uri, e.uri));
  });
}, uae = (t, e) => {
  const n = ws(0, e), a = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: Y.location.href,
    resolvedUri: Y.location.href,
    playlists: [{
      uri: e,
      id: n,
      resolvedUri: e,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return a.playlists[n] = a.playlists[0], a.playlists[e] = a.playlists[0], a;
}, E_ = (t, e, n = C_) => {
  t.uri = e;
  for (let i = 0; i < t.playlists.length; i++)
    if (!t.playlists[i].uri) {
      const r = `placeholder-uri-${i}`;
      t.playlists[i].uri = r;
    }
  const a = Xl(t);
  fo(t, (i, r, s, o) => {
    if (!i.playlists || !i.playlists.length) {
      if (a && r === "AUDIO" && !i.uri)
        for (let l = 0; l < t.playlists.length; l++) {
          const c = t.playlists[l];
          if (c.attributes && c.attributes.AUDIO && c.attributes.AUDIO === s)
            return;
        }
      i.playlists = [Jt({}, i)];
    }
    i.playlists.forEach(function(l, c) {
      const d = n(r, s, o, l), f = ws(c, d);
      l.uri ? l.resolvedUri = l.resolvedUri || Xn(t.uri, l.uri) : (l.uri = c === 0 ? d : f, l.resolvedUri = l.uri), l.id = l.id || f, l.attributes = l.attributes || {}, t.playlists[l.id] = l, t.playlists[l.uri] = l;
    });
  }), lae(t), cae(t);
};
class Sb {
  constructor() {
    this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
  }
  setOffset(e = []) {
    if (this.offset_ !== null || !e.length)
      return;
    const [n] = e;
    n.programDateTime !== void 0 && (this.offset_ = n.programDateTime / 1e3);
  }
  setPendingDateRanges(e = []) {
    if (!e.length)
      return;
    const [n] = e, a = n.startDate.getTime();
    this.trimProcessedDateRanges_(a), this.pendingDateRanges_ = e.reduce((i, r) => (i.set(r.id, r), i), /* @__PURE__ */ new Map());
  }
  processDateRange(e) {
    this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
  }
  getDateRangesToProcess() {
    if (this.offset_ === null)
      return [];
    const e = {}, n = [];
    this.pendingDateRanges_.forEach((a, i) => {
      if (!this.processedDateRanges_.has(i) && (a.startTime = a.startDate.getTime() / 1e3 - this.offset_, a.processDateRange = () => this.processDateRange(a), n.push(a), !!a.class))
        if (e[a.class]) {
          const r = e[a.class].push(a);
          a.classListIndex = r - 1;
        } else
          e[a.class] = [a], a.classListIndex = 0;
    });
    for (const a of n) {
      const i = e[a.class] || [];
      a.endDate ? a.endTime = a.endDate.getTime() / 1e3 - this.offset_ : a.endOnNext && i[a.classListIndex + 1] ? a.endTime = i[a.classListIndex + 1].startTime : a.duration ? a.endTime = a.startTime + a.duration : a.plannedDuration ? a.endTime = a.startTime + a.plannedDuration : a.endTime = a.startTime;
    }
    return n;
  }
  trimProcessedDateRanges_(e) {
    new Map(this.processedDateRanges_).forEach((a, i) => {
      a.startDate.getTime() < e && this.processedDateRanges_.delete(i);
    });
  }
}
const L_ = 22, Ir = ({
  requestType: t,
  request: e,
  error: n,
  parseFailure: a
}) => {
  const i = e.status < 200 || e.status > 299, r = e.status >= 400 && e.status <= 499, s = {
    uri: e.uri,
    requestType: t
  }, o = i && !r || a;
  if (n && r)
    s.error = Jt({}, n), s.errorType = le.Error.NetworkRequestFailed;
  else if (e.aborted)
    s.errorType = le.Error.NetworkRequestAborted;
  else if (e.timedout)
    s.erroType = le.Error.NetworkRequestTimeout;
  else if (o) {
    const l = a ? le.Error.NetworkBodyParserFailed : le.Error.NetworkBadStatus;
    s.errorType = l, s.status = e.status, s.headers = e.headers;
  }
  return s;
}, {
  EventTarget: dae
} = le, hae = (t, e) => {
  if (e.endList || !e.serverControl)
    return t;
  const n = {};
  if (e.serverControl.canBlockReload) {
    const {
      preloadSegment: a
    } = e;
    let i = e.mediaSequence + e.segments.length;
    if (a) {
      const r = a.parts || [], s = v_(e) - 1;
      s > -1 && s !== r.length - 1 && (n._HLS_part = s), (s > -1 || r.length) && i--;
    }
    n._HLS_msn = i;
  }
  if (e.serverControl && e.serverControl.canSkipUntil && (n._HLS_skip = e.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(n).length) {
    const a = new Y.URL(t);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(i) {
      n.hasOwnProperty(i) && a.searchParams.set(i, n[i]);
    }), t = a.toString();
  }
  return t;
}, fae = (t, e) => {
  if (!t)
    return e;
  const n = gt(t, e);
  if (t.preloadHints && !e.preloadHints && delete n.preloadHints, t.parts && !e.parts)
    delete n.parts;
  else if (t.parts && e.parts)
    for (let a = 0; a < e.parts.length; a++)
      t.parts && t.parts[a] && (n.parts[a] = gt(t.parts[a], e.parts[a]));
  return !t.skipped && e.skipped && (n.skipped = !1), t.preload && !e.preload && (n.preload = !1), n;
}, pae = (t, e, n) => {
  const a = t.slice(), i = e.slice();
  n = n || 0;
  const r = [];
  let s;
  for (let o = 0; o < i.length; o++) {
    const l = a[o + n], c = i[o];
    l ? (s = l.map || s, r.push(fae(l, c))) : (s && !c.map && (c.map = s), r.push(c));
  }
  return r;
}, D_ = (t, e) => {
  !t.resolvedUri && t.uri && (t.resolvedUri = Xn(e, t.uri)), t.key && !t.key.resolvedUri && (t.key.resolvedUri = Xn(e, t.key.uri)), t.map && !t.map.resolvedUri && (t.map.resolvedUri = Xn(e, t.map.uri)), t.map && t.map.key && !t.map.key.resolvedUri && (t.map.key.resolvedUri = Xn(e, t.map.key.uri)), t.parts && t.parts.length && t.parts.forEach((n) => {
    n.resolvedUri || (n.resolvedUri = Xn(e, n.uri));
  }), t.preloadHints && t.preloadHints.length && t.preloadHints.forEach((n) => {
    n.resolvedUri || (n.resolvedUri = Xn(e, n.uri));
  });
}, I_ = function(t) {
  const e = t.segments || [], n = t.preloadSegment;
  if (n && n.parts && n.parts.length) {
    if (n.preloadHints) {
      for (let a = 0; a < n.preloadHints.length; a++)
        if (n.preloadHints[a].type === "MAP")
          return e;
    }
    n.duration = t.targetDuration, n.preload = !0, e.push(n);
  }
  return e;
}, M_ = (t, e) => t === e || t.segments && e.segments && t.segments.length === e.segments.length && t.endList === e.endList && t.mediaSequence === e.mediaSequence && t.preloadSegment === e.preloadSegment, Ah = (t, e, n = M_) => {
  const a = gt(t, {}), i = a.playlists[e.id];
  if (!i || n(i, e))
    return null;
  e.segments = I_(e);
  const r = gt(i, e);
  if (r.preloadSegment && !e.preloadSegment && delete r.preloadSegment, i.segments) {
    if (e.skip) {
      e.segments = e.segments || [];
      for (let s = 0; s < e.skip.skippedSegments; s++)
        e.segments.unshift({
          skipped: !0
        });
    }
    r.segments = pae(i.segments, e.segments, e.mediaSequence - i.mediaSequence);
  }
  r.segments.forEach((s) => {
    D_(s, r.resolvedUri);
  });
  for (let s = 0; s < a.playlists.length; s++)
    a.playlists[s].id === e.id && (a.playlists[s] = r);
  return a.playlists[e.id] = r, a.playlists[e.uri] = r, fo(t, (s, o, l, c) => {
    if (s.playlists)
      for (let d = 0; d < s.playlists.length; d++)
        e.id === s.playlists[d].id && (s.playlists[d] = r);
  }), a;
}, Eh = (t, e) => {
  const n = t.segments || [], a = n[n.length - 1], i = a && a.parts && a.parts[a.parts.length - 1], r = i && i.duration || a && a.duration;
  return e && r ? r * 1e3 : (t.partTargetDuration || t.targetDuration || 10) * 500;
}, Cb = (t, e, n) => {
  if (!t)
    return;
  const a = [];
  return t.forEach((i) => {
    if (!i.attributes)
      return;
    const {
      BANDWIDTH: r,
      RESOLUTION: s,
      CODECS: o
    } = i.attributes;
    a.push({
      id: i.id,
      bandwidth: r,
      resolution: s,
      codecs: o
    });
  }), {
    type: e,
    isLive: n,
    renditions: a
  };
};
class ms extends dae {
  constructor(e, n, a = {}) {
    if (super(), !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.logger_ = Ta("PlaylistLoader");
    const {
      withCredentials: i = !1
    } = a;
    this.src = e, this.vhs_ = n, this.withCredentials = i, this.addDateRangesToTextTrack_ = a.addDateRangesToTextTrack;
    const r = n.options_;
    this.customTagParsers = r && r.customTagParsers || [], this.customTagMappers = r && r.customTagMappers || [], this.llhls = r && r.llhls, this.dateRangesStorage_ = new Sb(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
  }
  handleLoadedPlaylist_() {
    const e = this.media();
    if (!e)
      return;
    this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
    const n = this.dateRangesStorage_.getDateRangesToProcess();
    !n.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(n);
  }
  handleMediaupdatetimeout_() {
    if (this.state !== "HAVE_METADATA")
      return;
    const e = this.media();
    let n = Xn(this.main.uri, e.uri);
    this.llhls && (n = hae(n, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
      uri: n,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (a, i) => {
      if (this.request) {
        if (a)
          return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
        this.haveMetadata({
          playlistString: this.request.responseText,
          url: this.media().uri,
          id: this.media().id
        });
      }
    });
  }
  playlistRequestError(e, n, a) {
    const {
      uri: i,
      id: r
    } = n;
    this.request = null, a && (this.state = a), this.error = {
      playlist: this.main.playlists[r],
      status: e.status,
      message: `HLS playlist request error at URL: ${i}.`,
      responseText: e.responseText,
      code: e.status >= 500 ? 4 : 2,
      metadata: Ir({
        requestType: e.requestType,
        request: e,
        error: e.error
      })
    }, this.trigger("error");
  }
  parseManifest_({
    url: e,
    manifestString: n
  }) {
    try {
      return oae({
        onwarn: ({
          message: a
        }) => this.logger_(`m3u8-parser warn for ${e}: ${a}`),
        oninfo: ({
          message: a
        }) => this.logger_(`m3u8-parser info for ${e}: ${a}`),
        manifestString: n,
        customTagParsers: this.customTagParsers,
        customTagMappers: this.customTagMappers,
        llhls: this.llhls
      });
    } catch (a) {
      this.error = a, this.error.metadata = {
        errorType: le.Error.StreamingHlsPlaylistParserError,
        error: a
      };
    }
  }
  /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */
  haveMetadata({
    playlistString: e,
    playlistObject: n,
    url: a,
    id: i
  }) {
    this.request = null, this.state = "HAVE_METADATA";
    const r = {
      playlistInfo: {
        type: "media",
        uri: a
      }
    };
    this.trigger({
      type: "playlistparsestart",
      metadata: r
    });
    const s = n || this.parseManifest_({
      url: a,
      manifestString: e
    });
    s.lastRequest = Date.now(), A_({
      playlist: s,
      uri: a,
      id: i
    });
    const o = Ah(this.main, s);
    this.targetDuration = s.partTargetDuration || s.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[i]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(Eh(this.media(), !!o)), r.parsedPlaylist = Cb(this.main.playlists, r.playlistInfo.type, !this.media_.endList), this.trigger({
      type: "playlistparsecomplete",
      metadata: r
    }), this.trigger("loadedplaylist");
  }
  /**
    * Abort any outstanding work and clean up.
    */
  dispose() {
    this.trigger("dispose"), this.stopRequest(), Y.clearTimeout(this.mediaUpdateTimeout), Y.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new Sb(), this.off();
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */
  media(e, n) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof e == "string") {
      if (!this.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.main.playlists[e];
    }
    if (Y.clearTimeout(this.finalRenditionTimeout), n) {
      const o = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = Y.setTimeout(this.media.bind(this, e, !1), o);
      return;
    }
    const a = this.state, i = !this.media_ || e.id !== this.media_.id, r = this.main.playlists[e.id];
    if (r && r.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    e.endList && e.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = e, i && (this.trigger("mediachanging"), a === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(Eh(e, !0)), !i)
      return;
    if (this.state = "SWITCHING_MEDIA", this.request) {
      if (e.resolvedUri === this.request.url)
        return;
      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
    }
    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
    const s = {
      playlistInfo: {
        type: "media",
        uri: e.uri
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: s
    }), this.request = this.vhs_.xhr({
      uri: e.resolvedUri,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (o, l) => {
      if (this.request) {
        if (e.lastRequest = Date.now(), e.resolvedUri = Du(e.resolvedUri, l), o)
          return this.playlistRequestError(this.request, e, a);
        this.trigger({
          type: "playlistrequestcomplete",
          metadata: s
        }), this.haveMetadata({
          playlistString: l.responseText,
          url: e.uri,
          id: e.id
        }), a === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
      }
    });
  }
  /**
   * pause loading of the playlist
   */
  pause() {
    this.mediaUpdateTimeout && (Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }
  /**
   * start loading of the playlist
   */
  load(e) {
    this.mediaUpdateTimeout && (Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    const n = this.media();
    if (e) {
      const a = n ? (n.partTargetDuration || n.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = Y.setTimeout(() => {
        this.mediaUpdateTimeout = null, this.load();
      }, a);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    n && !n.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }
  updateMediaUpdateTimeout_(e) {
    this.mediaUpdateTimeout && (Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = Y.setTimeout(() => {
      this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
    }, e));
  }
  /**
   * start loading of the playlist
   */
  start() {
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = Y.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
        this.setupInitialPlaylist(this.src);
      }, 0);
      return;
    }
    const e = {
      playlistInfo: {
        type: "multivariant",
        uri: this.src
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: e
    }), this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (n, a) => {
      if (!this.request)
        return;
      if (this.request = null, n)
        return this.error = {
          status: a.status,
          message: `HLS playlist request error at URL: ${this.src}.`,
          responseText: a.responseText,
          // MEDIA_ERR_NETWORK
          code: 2,
          metadata: Ir({
            requestType: a.requestType,
            request: a,
            error: n
          })
        }, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
      this.trigger({
        type: "playlistrequestcomplete",
        metadata: e
      }), this.src = Du(this.src, a), this.trigger({
        type: "playlistparsestart",
        metadata: e
      });
      const i = this.parseManifest_({
        manifestString: a.responseText,
        url: this.src
      });
      e.parsedPlaylist = Cb(i.playlists, e.playlistInfo.type, !1), this.trigger({
        type: "playlistparsecomplete",
        metadata: e
      }), this.setupInitialPlaylist(i);
    });
  }
  srcUri() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }
  /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */
  setupInitialPlaylist(e) {
    if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
      this.main = e, E_(this.main, this.srcUri()), e.playlists.forEach((a) => {
        a.segments = I_(a), a.segments.forEach((i) => {
          D_(i, a.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
      return;
    }
    const n = this.srcUri() || Y.location.href;
    this.main = uae(e, n), this.haveMetadata({
      playlistObject: e,
      url: n,
      id: this.main.playlists[0].id
    }), this.trigger("loadedmetadata");
  }
  /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteClone(e, n) {
    const a = this.main, i = e.ID;
    let r = a.playlists.length;
    for (; r--; ) {
      const s = a.playlists[r];
      if (s.attributes["PATHWAY-ID"] === i) {
        const o = s.resolvedUri, l = s.id;
        if (n) {
          const c = this.createCloneURI_(s.resolvedUri, e), d = ws(i, c), f = this.createCloneAttributes_(i, s.attributes), g = this.createClonePlaylist_(s, d, e, f);
          a.playlists[r] = g, a.playlists[d] = g, a.playlists[c] = g;
        } else
          a.playlists.splice(r, 1);
        delete a.playlists[l], delete a.playlists[o];
      }
    }
    this.updateOrDeleteCloneMedia(e, n);
  }
  /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteCloneMedia(e, n) {
    const a = this.main, i = e.ID;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!a.mediaGroups[r] || !a.mediaGroups[r][i])) {
        for (const s in a.mediaGroups[r])
          if (s === i) {
            for (const o in a.mediaGroups[r][s])
              a.mediaGroups[r][s][o].playlists.forEach((c, d) => {
                const f = a.playlists[c.id], g = f.id, _ = f.resolvedUri;
                delete a.playlists[g], delete a.playlists[_];
              });
            delete a.mediaGroups[r][s];
          }
      }
    }), n && this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */
  addClonePathway(e, n = {}) {
    const a = this.main, i = a.playlists.length, r = this.createCloneURI_(n.resolvedUri, e), s = ws(e.ID, r), o = this.createCloneAttributes_(e.ID, n.attributes), l = this.createClonePlaylist_(n, s, e, o);
    a.playlists[i] = l, a.playlists[s] = l, a.playlists[r] = l, this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */
  createClonedMediaGroups_(e) {
    const n = e.ID, a = e["BASE-ID"], i = this.main;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!i.mediaGroups[r] || i.mediaGroups[r][n]))
        for (const s in i.mediaGroups[r]) {
          if (s === a)
            i.mediaGroups[r][n] = {};
          else
            continue;
          for (const o in i.mediaGroups[r][s]) {
            const l = i.mediaGroups[r][s][o];
            i.mediaGroups[r][n][o] = Jt({}, l);
            const c = i.mediaGroups[r][n][o], d = this.createCloneURI_(l.resolvedUri, e);
            c.resolvedUri = d, c.uri = d, c.playlists = [], l.playlists.forEach((f, g) => {
              const _ = i.playlists[f.id], x = C_(r, n, o), p = ws(n, x);
              if (_ && !i.playlists[p]) {
                const w = this.createClonePlaylist_(_, p, e), C = w.resolvedUri;
                i.playlists[p] = w, i.playlists[C] = w;
              }
              c.playlists[g] = this.createClonePlaylist_(f, p, e);
            });
          }
        }
    });
  }
  /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */
  createClonePlaylist_(e, n, a, i) {
    const r = this.createCloneURI_(e.resolvedUri, a), s = {
      resolvedUri: r,
      uri: r,
      id: n
    };
    return e.segments && (s.segments = []), i && (s.attributes = i), gt(e, s);
  }
  /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */
  createCloneURI_(e, n) {
    const a = new URL(e);
    a.hostname = n["URI-REPLACEMENT"].HOST;
    const i = n["URI-REPLACEMENT"].PARAMS;
    for (const r of Object.keys(i))
      a.searchParams.set(r, i[r]);
    return a.href;
  }
  /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */
  createCloneAttributes_(e, n) {
    const a = {
      "PATHWAY-ID": e
    };
    return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((i) => {
      n[i] && (a[i] = e);
    }), a;
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const n = /* @__PURE__ */ new Set();
      for (const a in e.contentProtection) {
        const i = e.contentProtection[a].attributes.keyId;
        i && n.add(i.toLowerCase());
      }
      return n;
    }
  }
}
const Lh = function(t, e, n, a) {
  const i = t.responseType === "arraybuffer" ? t.response : t.responseText;
  !e && i && (t.responseTime = Date.now(), t.roundTripTime = t.responseTime - t.requestTime, t.bytesReceived = i.byteLength || i.length, t.bandwidth || (t.bandwidth = Math.floor(t.bytesReceived / t.roundTripTime * 8 * 1e3))), n.headers && (t.responseHeaders = n.headers), e && e.code === "ETIMEDOUT" && (t.timedout = !0), !e && !t.aborted && n.statusCode !== 200 && n.statusCode !== 206 && n.statusCode !== 0 && (e = new Error("XHR Failed with a response of: " + (t && (i || t.responseText)))), a(e, t);
}, mae = (t, e) => {
  if (!t || !t.size)
    return;
  let n = e;
  return t.forEach((a) => {
    n = a(n);
  }), n;
}, gae = (t, e, n, a) => {
  !t || !t.size || t.forEach((i) => {
    i(e, n, a);
  });
}, O_ = function() {
  const t = function e(n, a) {
    n = gt({
      timeout: 45e3
    }, n);
    const i = e.beforeRequest || le.Vhs.xhr.beforeRequest, r = e._requestCallbackSet || le.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), s = e._responseCallbackSet || le.Vhs.xhr._responseCallbackSet;
    i && typeof i == "function" && (le.log.warn("beforeRequest is deprecated, use onRequest instead."), r.add(i));
    const o = le.Vhs.xhr.original === !0 ? le.xhr : le.Vhs.xhr, l = mae(r, n);
    r.delete(i);
    const c = o(l || n, function(f, g) {
      return gae(s, c, f, g), Lh(c, f, g, a);
    }), d = c.abort;
    return c.abort = function() {
      return c.aborted = !0, d.apply(c, arguments);
    }, c.uri = n.uri, c.requestType = n.requestType, c.requestTime = Date.now(), c;
  };
  return t.original = !0, t;
}, bae = function(t) {
  let e;
  const n = t.offset;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = Y.BigInt(t.offset) + Y.BigInt(t.length) - Y.BigInt(1) : e = t.offset + t.length - 1, "bytes=" + n + "-" + e;
}, Dh = function(t) {
  const e = {};
  return t.byterange && (e.Range = bae(t.byterange)), e;
}, vae = function(t, e) {
  return t.start(e) + "-" + t.end(e);
}, yae = function(t, e) {
  const n = t.toString(16);
  return "00".substring(0, 2 - n.length) + n + (e % 2 ? " " : "");
}, _ae = function(t) {
  return t >= 32 && t < 126 ? String.fromCharCode(t) : ".";
}, P_ = function(t) {
  const e = {};
  return Object.keys(t).forEach((n) => {
    const a = t[n];
    d5(a) ? e[n] = {
      bytes: a.buffer,
      byteOffset: a.byteOffset,
      byteLength: a.byteLength
    } : e[n] = a;
  }), e;
}, Iu = function(t) {
  const e = t.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [e.length, e.offset, t.resolvedUri].join(",");
}, B_ = function(t) {
  return t.resolvedUri;
}, R_ = (t) => {
  const e = Array.prototype.slice.call(t), n = 16;
  let a = "", i, r;
  for (let s = 0; s < e.length / n; s++)
    i = e.slice(s * n, s * n + n).map(yae).join(""), r = e.slice(s * n, s * n + n).map(_ae).join(""), a += i + " " + r + `
`;
  return a;
}, xae = ({
  bytes: t
}) => R_(t), Tae = (t) => {
  let e = "", n;
  for (n = 0; n < t.length; n++)
    e += vae(t, n) + " ";
  return e;
};
var wae = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: P_,
  initSegmentId: Iu,
  segmentKeyId: B_,
  hexDump: R_,
  tagDump: xae,
  textRanges: Tae
});
const N_ = 0.25, kae = (t, e) => {
  if (!e.dateTimeObject)
    return null;
  const n = e.videoTimingInfo.transmuxerPrependedSeconds, i = e.videoTimingInfo.transmuxedPresentationStart + n, r = t - i;
  return new Date(e.dateTimeObject.getTime() + r * 1e3);
}, Sae = (t) => t.transmuxedPresentationEnd - t.transmuxedPresentationStart - t.transmuxerPrependedSeconds, Cae = (t, e) => {
  let n;
  try {
    n = new Date(t);
  } catch {
    return null;
  }
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let a = e.segments[0];
  if (n < new Date(a.dateTimeObject))
    return null;
  for (let l = 0; l < e.segments.length - 1; l++) {
    a = e.segments[l];
    const c = new Date(e.segments[l + 1].dateTimeObject);
    if (n < c)
      break;
  }
  const i = e.segments[e.segments.length - 1], r = i.dateTimeObject, s = i.videoTimingInfo ? Sae(i.videoTimingInfo) : i.duration + i.duration * N_, o = new Date(r.getTime() + s * 1e3);
  return n > o ? null : (n > new Date(r) && (a = i), {
    segment: a,
    estimatedStart: a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationStart : Zn.duration(e, e.mediaSequence + e.segments.indexOf(a)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: a.videoTimingInfo ? "accurate" : "estimate"
  });
}, Aae = (t, e) => {
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let n = 0, a;
  for (let r = 0; r < e.segments.length && (a = e.segments[r], n = a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationEnd : n + a.duration, !(t <= n)); r++)
    ;
  const i = e.segments[e.segments.length - 1];
  if (i.videoTimingInfo && i.videoTimingInfo.transmuxedPresentationEnd < t)
    return null;
  if (t > n) {
    if (t > n + i.duration * N_)
      return null;
    a = i;
  }
  return {
    segment: a,
    estimatedStart: a.videoTimingInfo ? a.videoTimingInfo.transmuxedPresentationStart : n - a.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: a.videoTimingInfo ? "accurate" : "estimate"
  };
}, Eae = (t, e) => {
  let n, a;
  try {
    n = new Date(t), a = new Date(e);
  } catch {
  }
  const i = n.getTime();
  return (a.getTime() - i) / 1e3;
}, Lae = (t) => {
  if (!t.segments || t.segments.length === 0)
    return !1;
  for (let e = 0; e < t.segments.length; e++)
    if (!t.segments[e].dateTimeObject)
      return !1;
  return !0;
}, Dae = ({
  playlist: t,
  time: e = void 0,
  callback: n
}) => {
  if (!n)
    throw new Error("getProgramTime: callback must be provided");
  if (!t || e === void 0)
    return n({
      message: "getProgramTime: playlist and time must be provided"
    });
  const a = Aae(e, t);
  if (!a)
    return n({
      message: "valid programTime was not found"
    });
  if (a.type === "estimate")
    return n({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: a.estimatedStart
    });
  const i = {
    mediaSeconds: e
  }, r = kae(e, a.segment);
  return r && (i.programDateTime = r.toISOString()), n(null, i);
}, $_ = ({
  programTime: t,
  playlist: e,
  retryCount: n = 2,
  seekTo: a,
  pauseAfterSeek: i = !0,
  tech: r,
  callback: s
}) => {
  if (!s)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof t > "u" || !e || !a)
    return s({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!e.endList && !r.hasStarted_)
    return s({
      message: "player must be playing a live stream to start buffering"
    });
  if (!Lae(e))
    return s({
      message: "programDateTime tags must be provided in the manifest " + e.resolvedUri
    });
  const o = Cae(t, e);
  if (!o)
    return s({
      message: `${t} was not found in the stream`
    });
  const l = o.segment, c = Eae(l.dateTimeObject, t);
  if (o.type === "estimate") {
    if (n === 0)
      return s({
        message: `${t} is not buffered yet. Try again`
      });
    a(o.estimatedStart + c), r.one("seeked", () => {
      $_({
        programTime: t,
        playlist: e,
        retryCount: n - 1,
        seekTo: a,
        pauseAfterSeek: i,
        tech: r,
        callback: s
      });
    });
    return;
  }
  const d = l.start + c, f = () => s(null, r.currentTime());
  r.one("seeked", f), i && r.pause(), a(d);
}, B0 = (t, e) => {
  if (t.readyState === 4)
    return e();
}, Iae = (t, e, n, a) => {
  let i = [], r, s = !1;
  const o = function(f, g, _, x) {
    return g.abort(), s = !0, n(f, g, _, x);
  }, l = function(f, g) {
    if (s)
      return;
    if (f)
      return f.metadata = Ir({
        requestType: a,
        request: g,
        error: f
      }), o(f, g, "", i);
    const _ = g.responseText.substring(i && i.byteLength || 0, g.responseText.length);
    if (i = PJ(i, h5(_, !0)), r = r || Jo(i), i.length < 10 || r && i.length < r + 2)
      return B0(g, () => o(f, g, "", i));
    const x = Qf(i);
    return x === "ts" && i.length < 188 ? B0(g, () => o(f, g, "", i)) : !x && i.length < 376 ? B0(g, () => o(f, g, "", i)) : o(null, g, x, i);
  }, d = e({
    uri: t,
    beforeSend(f) {
      f.overrideMimeType("text/plain; charset=x-user-defined"), f.addEventListener("progress", function({
        total: g,
        loaded: _
      }) {
        return Lh(f, null, {
          statusCode: f.status
        }, l);
      });
    }
  }, function(f, g) {
    return Lh(d, f, g, l);
  });
  return d;
}, {
  EventTarget: Mae
} = le, Ab = function(t, e) {
  if (!M_(t, e) || t.sidx && e.sidx && (t.sidx.offset !== e.sidx.offset || t.sidx.length !== e.sidx.length))
    return !1;
  if (!t.sidx && e.sidx || t.sidx && !e.sidx || t.segments && !e.segments || !t.segments && e.segments)
    return !1;
  if (!t.segments && !e.segments)
    return !0;
  for (let n = 0; n < t.segments.length; n++) {
    const a = t.segments[n], i = e.segments[n];
    if (a.uri !== i.uri)
      return !1;
    if (!a.byterange && !i.byterange)
      continue;
    const r = a.byterange, s = i.byterange;
    if (r && !s || !r && s || r.offset !== s.offset || r.length !== s.length)
      return !1;
  }
  return !0;
}, Oae = (t, e, n, a) => {
  const i = a.attributes.NAME || n;
  return `placeholder-uri-${t}-${e}-${i}`;
}, Pae = ({
  mainXml: t,
  srcUrl: e,
  clientOffset: n,
  sidxMapping: a,
  previousManifest: i
}) => {
  const r = tte(t, {
    manifestUri: e,
    clientOffset: n,
    sidxMapping: a,
    previousManifest: i
  });
  return E_(r, e, Oae), r;
}, Bae = (t, e) => {
  fo(t, (n, a, i, r) => {
    (!e.mediaGroups[a][i] || !(r in e.mediaGroups[a][i])) && delete t.mediaGroups[a][i][r];
  });
}, Rae = (t, e, n) => {
  let a = !0, i = gt(t, {
    // These are top level properties that can be updated
    duration: e.duration,
    minimumUpdatePeriod: e.minimumUpdatePeriod,
    timelineStarts: e.timelineStarts
  });
  for (let r = 0; r < e.playlists.length; r++) {
    const s = e.playlists[r];
    if (s.sidx) {
      const l = cd(s.sidx);
      n && n[l] && n[l].sidx && Xf(s, n[l].sidx, s.sidx.resolvedUri);
    }
    const o = Ah(i, s, Ab);
    o && (i = o, a = !1);
  }
  return fo(e, (r, s, o, l) => {
    if (r.playlists && r.playlists.length) {
      const c = r.playlists[0].id, d = Ah(i, r.playlists[0], Ab);
      d && (i = d, l in i.mediaGroups[s][o] || (i.mediaGroups[s][o][l] = r), i.mediaGroups[s][o][l].playlists[0] = i.playlists[c], a = !1);
    }
  }), Bae(i, e), e.minimumUpdatePeriod !== t.minimumUpdatePeriod && (a = !1), a ? null : i;
}, Nae = (t, e) => (!t.map && !e.map || !!(t.map && e.map && t.map.byterange.offset === e.map.byterange.offset && t.map.byterange.length === e.map.byterange.length)) && t.uri === e.uri && t.byterange.offset === e.byterange.offset && t.byterange.length === e.byterange.length, Eb = (t, e) => {
  const n = {};
  for (const a in t) {
    const r = t[a].sidx;
    if (r) {
      const s = cd(r);
      if (!e[s])
        break;
      const o = e[s].sidxInfo;
      Nae(o, r) && (n[s] = e[s]);
    }
  }
  return n;
}, $ae = (t, e) => {
  let a = Eb(t.playlists, e);
  return fo(t, (i, r, s, o) => {
    if (i.playlists && i.playlists.length) {
      const l = i.playlists;
      a = gt(a, Eb(l, e));
    }
  }), a;
};
class Ih extends Mae {
  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
  // playlist loader setups from media groups will expect to be able to pass a playlist
  // (since there aren't external URLs to media playlists with DASH)
  constructor(e, n, a = {}, i) {
    super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = i || this, i || (this.isMain_ = !0);
    const {
      withCredentials: r = !1
    } = a;
    if (this.vhs_ = n, this.withCredentials = r, this.addMetadataToTextTrack = a.addMetadataToTextTrack, !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.on("minimumUpdatePeriod", () => {
      this.refreshXml_();
    }), this.on("mediaupdatetimeout", () => {
      this.refreshMedia_(this.media().id);
    }), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = Ta("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
  }
  get isPaused() {
    return this.isPaused_;
  }
  requestErrored_(e, n, a) {
    if (!this.request)
      return !0;
    if (this.request = null, e)
      return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
        status: n.status,
        message: "DASH request error at URL: " + n.uri,
        response: n.response,
        // MEDIA_ERR_NETWORK
        code: 2,
        metadata: e.metadata
      }, a && (this.state = a), this.trigger("error"), !0;
  }
  /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */
  addSidxSegments_(e, n, a) {
    const i = e.sidx && cd(e.sidx);
    if (!e.sidx || !i || this.mainPlaylistLoader_.sidxMapping_[i]) {
      Y.clearTimeout(this.mediaRequest_), this.mediaRequest_ = Y.setTimeout(() => a(!1), 0);
      return;
    }
    const r = Du(e.sidx.resolvedUri), s = (l, c) => {
      if (this.requestErrored_(l, c, n))
        return;
      const d = this.mainPlaylistLoader_.sidxMapping_, {
        requestType: f
      } = c;
      let g;
      try {
        g = lte(Ze(c.response).subarray(8));
      } catch (_) {
        _.metadata = Ir({
          requestType: f,
          request: c,
          parseFailure: !0
        }), this.requestErrored_(_, c, n);
        return;
      }
      return d[i] = {
        sidxInfo: e.sidx,
        sidx: g
      }, Xf(e, g, e.sidx.resolvedUri), a(!0);
    }, o = "dash-sidx";
    this.request = Iae(r, this.vhs_.xhr, (l, c, d, f) => {
      if (l)
        return s(l, c);
      if (!d || d !== "mp4") {
        const x = d || "unknown";
        return s({
          status: c.status,
          message: `Unsupported ${x} container type for sidx segment at URL: ${r}`,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: e,
          internal: !0,
          playlistExclusionDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, c);
      }
      const {
        offset: g,
        length: _
      } = e.sidx.byterange;
      if (f.length >= _ + g)
        return s(l, {
          response: f.subarray(g, g + _),
          status: c.status,
          uri: c.uri
        });
      this.request = this.vhs_.xhr({
        uri: r,
        responseType: "arraybuffer",
        requestType: "dash-sidx",
        headers: Dh({
          byterange: e.sidx.byterange
        })
      }, s);
    }, o);
  }
  dispose() {
    this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, Y.clearTimeout(this.minimumUpdatePeriodTimeout_), Y.clearTimeout(this.mediaRequest_), Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }
  hasPendingRequest() {
    return this.request || this.mediaRequest_;
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  media(e) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    const n = this.state;
    if (typeof e == "string") {
      if (!this.mainPlaylistLoader_.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.mainPlaylistLoader_.main.playlists[e];
    }
    const a = !this.media_ || e.id !== this.media_.id;
    if (a && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = e, a && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    a && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, n, (i) => {
      this.haveMetadata({
        startingState: n,
        playlist: e
      });
    }));
  }
  haveMetadata({
    startingState: e,
    playlist: n
  }) {
    this.state = "HAVE_METADATA", this.loadedPlaylists_[n.id] = n, Y.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(n.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }
  pause() {
    this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (Y.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }
  load(e) {
    this.isPaused_ = !1, Y.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    const n = this.media();
    if (e) {
      const a = n ? n.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = Y.setTimeout(() => this.load(), a);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    n && !n.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }
  start() {
    if (this.started = !0, !this.isMain_) {
      Y.clearTimeout(this.mediaRequest_), this.mediaRequest_ = Y.setTimeout(() => this.haveMain_(), 0);
      return;
    }
    this.requestMain_((e, n) => {
      this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
    });
  }
  requestMain_(e) {
    const n = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestrequeststart",
      metadata: n
    }), this.request = this.vhs_.xhr({
      uri: this.mainPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials,
      requestType: "dash-manifest"
    }, (a, i) => {
      if (a) {
        const {
          requestType: s
        } = i;
        a.metadata = Ir({
          requestType: s,
          request: i,
          error: a
        });
      }
      if (this.requestErrored_(a, i)) {
        this.state === "HAVE_NOTHING" && (this.started = !1);
        return;
      }
      this.trigger({
        type: "manifestrequestcomplete",
        metadata: n
      });
      const r = i.responseText !== this.mainPlaylistLoader_.mainXml_;
      if (this.mainPlaylistLoader_.mainXml_ = i.responseText, i.responseHeaders && i.responseHeaders.date ? this.mainLoaded_ = Date.parse(i.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = Du(this.mainPlaylistLoader_.srcUrl, i), r) {
        this.handleMain_(), this.syncClientServerClock_(() => e(i, r));
        return;
      }
      return e(i, r);
    });
  }
  /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */
  syncClientServerClock_(e) {
    const n = nte(this.mainPlaylistLoader_.mainXml_);
    if (n === null)
      return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
    if (n.method === "DIRECT")
      return this.mainPlaylistLoader_.clientOffset_ = n.value - Date.now(), e();
    this.request = this.vhs_.xhr({
      uri: Xn(this.mainPlaylistLoader_.srcUrl, n.value),
      method: n.method,
      withCredentials: this.withCredentials,
      requestType: "dash-clock-sync"
    }, (a, i) => {
      if (!this.request)
        return;
      if (a) {
        const {
          requestType: s
        } = i;
        return this.error.metadata = Ir({
          requestType: s,
          request: i,
          error: a
        }), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
      }
      let r;
      n.method === "HEAD" ? !i.responseHeaders || !i.responseHeaders.date ? r = this.mainLoaded_ : r = Date.parse(i.responseHeaders.date) : r = Date.parse(i.responseText), this.mainPlaylistLoader_.clientOffset_ = r - Date.now(), e();
    });
  }
  haveMain_() {
    this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }
  handleMain_() {
    Y.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
    const e = this.mainPlaylistLoader_.main, n = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestparsestart",
      metadata: n
    });
    let a;
    try {
      a = Pae({
        mainXml: this.mainPlaylistLoader_.mainXml_,
        srcUrl: this.mainPlaylistLoader_.srcUrl,
        clientOffset: this.mainPlaylistLoader_.clientOffset_,
        sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
        previousManifest: e
      });
    } catch (r) {
      this.error = r, this.error.metadata = {
        errorType: le.Error.StreamingDashManifestParserError,
        error: r
      }, this.trigger("error");
    }
    e && (a = Rae(e, a, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = a || e;
    const i = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
    if (i && i !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = i), (!e || a && a.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(a), a) {
      const {
        duration: r,
        endList: s
      } = a, o = [];
      a.playlists.forEach((c) => {
        o.push({
          id: c.id,
          bandwidth: c.attributes.BANDWIDTH,
          resolution: c.attributes.RESOLUTION,
          codecs: c.attributes.CODECS
        });
      });
      const l = {
        duration: r,
        isLive: !s,
        renditions: o
      };
      n.parsedManifest = l, this.trigger({
        type: "manifestparsecomplete",
        metadata: n
      });
    }
    return !!a;
  }
  updateMinimumUpdatePeriodTimeout_() {
    const e = this.mainPlaylistLoader_;
    e.createMupOnMedia_ && (e.off("loadedmetadata", e.createMupOnMedia_), e.createMupOnMedia_ = null), e.minimumUpdatePeriodTimeout_ && (Y.clearTimeout(e.minimumUpdatePeriodTimeout_), e.minimumUpdatePeriodTimeout_ = null);
    let n = e.main && e.main.minimumUpdatePeriod;
    if (n === 0 && (e.media() ? n = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof n != "number" || n <= 0) {
      n < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${n}, not setting a timeout`);
      return;
    }
    this.createMUPTimeout_(n);
  }
  createMUPTimeout_(e) {
    const n = this.mainPlaylistLoader_;
    n.minimumUpdatePeriodTimeout_ = Y.setTimeout(() => {
      n.minimumUpdatePeriodTimeout_ = null, n.trigger("minimumUpdatePeriod"), n.createMUPTimeout_(e);
    }, e);
  }
  /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */
  refreshXml_() {
    this.requestMain_((e, n) => {
      n && (this.media_ && (this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id]), this.mainPlaylistLoader_.sidxMapping_ = $ae(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (a) => {
        this.refreshMedia_(this.media().id);
      }));
    });
  }
  /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */
  refreshMedia_(e) {
    if (!e)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMain_ && this.handleMain_();
    const n = this.mainPlaylistLoader_.main.playlists, a = !this.media_ || this.media_ !== n[e];
    if (a ? this.media_ = n[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      const i = () => {
        this.media().endList || (this.mediaUpdateTimeout = Y.setTimeout(() => {
          this.trigger("mediaupdatetimeout"), i();
        }, Eh(this.media(), !!a)));
      };
      i();
    }
    this.trigger("loadedplaylist");
  }
  /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */
  addEventStreamToMetadataTrack_(e) {
    if (e && this.mainPlaylistLoader_.main.eventStream) {
      const n = this.mainPlaylistLoader_.main.eventStream.map((a) => ({
        cueTime: a.start,
        frames: [{
          data: a.messageData
        }]
      }));
      this.addMetadataToTextTrack("EventStream", n, this.mainPlaylistLoader_.main.duration);
    }
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const n = /* @__PURE__ */ new Set();
      for (const a in e.contentProtection) {
        const i = e.contentProtection[a].attributes["cenc:default_KID"];
        i && n.add(i.replace(/-/g, "").toLowerCase());
      }
      return n;
    }
  }
}
var mn = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
};
const Fae = (t) => {
  const e = new Uint8Array(new ArrayBuffer(t.length));
  for (let n = 0; n < t.length; n++)
    e[n] = t.charCodeAt(n);
  return e.buffer;
}, F_ = function(t) {
  return t.on = t.addEventListener, t.off = t.removeEventListener, t;
}, zae = function(t) {
  try {
    return URL.createObjectURL(new Blob([t], {
      type: "application/javascript"
    }));
  } catch {
    const n = new BlobBuilder();
    return n.append(t), URL.createObjectURL(n.getBlob());
  }
}, z_ = function(t) {
  return function() {
    const e = zae(t), n = F_(new Worker(e));
    n.objURL = e;
    const a = n.terminate;
    return n.on = n.addEventListener, n.off = n.removeEventListener, n.terminate = function() {
      return URL.revokeObjectURL(e), a.call(this);
    }, n;
  };
}, U_ = function(t) {
  return `var browserWorkerPolyFill = ${F_.toString()};
browserWorkerPolyFill(self);
` + t;
}, H_ = function(t) {
  return t.toString().replace(/^function.+?{/, "").slice(0, -1);
}, Uae = U_(H_(function() {
  var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, e = function() {
    this.init = function() {
      var u = {};
      this.on = function(m, y) {
        u[m] || (u[m] = []), u[m] = u[m].concat(y);
      }, this.off = function(m, y) {
        var v;
        return u[m] ? (v = u[m].indexOf(y), u[m] = u[m].slice(), u[m].splice(v, 1), v > -1) : !1;
      }, this.trigger = function(m) {
        var y, v, T, S;
        if (y = u[m], !!y)
          if (arguments.length === 2)
            for (T = y.length, v = 0; v < T; ++v)
              y[v].call(this, arguments[1]);
          else {
            for (S = [], v = arguments.length, v = 1; v < arguments.length; ++v)
              S.push(arguments[v]);
            for (T = y.length, v = 0; v < T; ++v)
              y[v].apply(this, S);
          }
      }, this.dispose = function() {
        u = {};
      };
    };
  };
  e.prototype.pipe = function(u) {
    return this.on("data", function(m) {
      u.push(m);
    }), this.on("done", function(m) {
      u.flush(m);
    }), this.on("partialdone", function(m) {
      u.partialFlush(m);
    }), this.on("endedtimeline", function(m) {
      u.endTimeline(m);
    }), this.on("reset", function(m) {
      u.reset(m);
    }), u;
  }, e.prototype.push = function(u) {
    this.trigger("data", u);
  }, e.prototype.flush = function(u) {
    this.trigger("done", u);
  }, e.prototype.partialFlush = function(u) {
    this.trigger("partialdone", u);
  }, e.prototype.endTimeline = function(u) {
    this.trigger("endedtimeline", u);
  }, e.prototype.reset = function(u) {
    this.trigger("reset", u);
  };
  var n = e, a = Math.pow(2, 32), i = function(u) {
    var m = new DataView(u.buffer, u.byteOffset, u.byteLength), y;
    return m.getBigUint64 ? (y = m.getBigUint64(0), y < Number.MAX_SAFE_INTEGER ? Number(y) : y) : m.getUint32(0) * a + m.getUint32(4);
  }, r = {
    getUint64: i,
    MAX_UINT32: a
  }, s = r.MAX_UINT32, o, l, c, d, f, g, _, x, p, w, C, M, A, L, D, B, P, z, W, q, V, re, ie, K, $, X, R, de, Le, Ie, Ve, te, we, H, pe, Ne;
  (function() {
    var u;
    if (ie = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (u in ie)
        ie.hasOwnProperty(u) && (ie[u] = [u.charCodeAt(0), u.charCodeAt(1), u.charCodeAt(2), u.charCodeAt(3)]);
      K = new Uint8Array([105, 115, 111, 109]), X = new Uint8Array([97, 118, 99, 49]), $ = new Uint8Array([0, 0, 0, 1]), R = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), de = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), Le = {
        video: R,
        audio: de
      }, te = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), Ve = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), we = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), H = we, pe = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), Ne = we, Ie = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), o = function(u) {
    var m = [], y = 0, v, T, S;
    for (v = 1; v < arguments.length; v++)
      m.push(arguments[v]);
    for (v = m.length; v--; )
      y += m[v].byteLength;
    for (T = new Uint8Array(y + 8), S = new DataView(T.buffer, T.byteOffset, T.byteLength), S.setUint32(0, T.byteLength), T.set(u, 4), v = 0, y = 8; v < m.length; v++)
      T.set(m[v], y), y += m[v].byteLength;
    return T;
  }, l = function() {
    return o(ie.dinf, o(ie.dref, te));
  }, c = function(u) {
    return o(ie.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      u.audioobjecttype << 3 | u.samplingfrequencyindex >>> 1,
      u.samplingfrequencyindex << 7 | u.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, d = function() {
    return o(ie.ftyp, K, $, K, X);
  }, B = function(u) {
    return o(ie.hdlr, Le[u]);
  }, f = function(u) {
    return o(ie.mdat, u);
  }, D = function(u) {
    var m = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      u.duration >>> 24 & 255,
      u.duration >>> 16 & 255,
      u.duration >>> 8 & 255,
      u.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return u.samplerate && (m[12] = u.samplerate >>> 24 & 255, m[13] = u.samplerate >>> 16 & 255, m[14] = u.samplerate >>> 8 & 255, m[15] = u.samplerate & 255), o(ie.mdhd, m);
  }, L = function(u) {
    return o(ie.mdia, D(u), B(u.type), _(u));
  }, g = function(u) {
    return o(ie.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (u & 4278190080) >> 24,
      (u & 16711680) >> 16,
      (u & 65280) >> 8,
      u & 255
      // sequence_number
    ]));
  }, _ = function(u) {
    return o(ie.minf, u.type === "video" ? o(ie.vmhd, Ie) : o(ie.smhd, Ve), l(), z(u));
  }, x = function(u, m) {
    for (var y = [], v = m.length; v--; )
      y[v] = q(m[v]);
    return o.apply(null, [ie.moof, g(u)].concat(y));
  }, p = function(u) {
    for (var m = u.length, y = []; m--; )
      y[m] = M(u[m]);
    return o.apply(null, [ie.moov, C(4294967295)].concat(y).concat(w(u)));
  }, w = function(u) {
    for (var m = u.length, y = []; m--; )
      y[m] = V(u[m]);
    return o.apply(null, [ie.mvex].concat(y));
  }, C = function(u) {
    var m = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (u & 4278190080) >> 24,
      (u & 16711680) >> 16,
      (u & 65280) >> 8,
      u & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return o(ie.mvhd, m);
  }, P = function(u) {
    var m = u.samples || [], y = new Uint8Array(4 + m.length), v, T;
    for (T = 0; T < m.length; T++)
      v = m[T].flags, y[T + 4] = v.dependsOn << 4 | v.isDependedOn << 2 | v.hasRedundancy;
    return o(ie.sdtp, y);
  }, z = function(u) {
    return o(ie.stbl, W(u), o(ie.stts, Ne), o(ie.stsc, H), o(ie.stsz, pe), o(ie.stco, we));
  }, function() {
    var u, m;
    W = function(y) {
      return o(ie.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), y.type === "video" ? u(y) : m(y));
    }, u = function(y) {
      var v = y.sps || [], T = y.pps || [], S = [], N = [], F, U;
      for (F = 0; F < v.length; F++)
        S.push((v[F].byteLength & 65280) >>> 8), S.push(v[F].byteLength & 255), S = S.concat(Array.prototype.slice.call(v[F]));
      for (F = 0; F < T.length; F++)
        N.push((T[F].byteLength & 65280) >>> 8), N.push(T[F].byteLength & 255), N = N.concat(Array.prototype.slice.call(T[F]));
      if (U = [ie.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (y.width & 65280) >> 8,
        y.width & 255,
        // width
        (y.height & 65280) >> 8,
        y.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), o(ie.avcC, new Uint8Array([
        1,
        // configurationVersion
        y.profileIdc,
        // AVCProfileIndication
        y.profileCompatibility,
        // profile_compatibility
        y.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [v.length],
        // numOfSequenceParameterSets
        S,
        // "SPS"
        [T.length],
        // numOfPictureParameterSets
        N
        // "PPS"
      ))), o(ie.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], y.sarRatio) {
        var j = y.sarRatio[0], ne = y.sarRatio[1];
        U.push(o(ie.pasp, new Uint8Array([(j & 4278190080) >> 24, (j & 16711680) >> 16, (j & 65280) >> 8, j & 255, (ne & 4278190080) >> 24, (ne & 16711680) >> 16, (ne & 65280) >> 8, ne & 255])));
      }
      return o.apply(null, U);
    }, m = function(y) {
      return o(ie.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (y.channelcount & 65280) >> 8,
        y.channelcount & 255,
        // channelcount
        (y.samplesize & 65280) >> 8,
        y.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (y.samplerate & 65280) >> 8,
        y.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), c(y));
    };
  }(), A = function(u) {
    var m = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (u.duration & 4278190080) >> 24,
      (u.duration & 16711680) >> 16,
      (u.duration & 65280) >> 8,
      u.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (u.width & 65280) >> 8,
      u.width & 255,
      0,
      0,
      // width
      (u.height & 65280) >> 8,
      u.height & 255,
      0,
      0
      // height
    ]);
    return o(ie.tkhd, m);
  }, q = function(u) {
    var m, y, v, T, S, N, F;
    return m = o(ie.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), N = Math.floor(u.baseMediaDecodeTime / s), F = Math.floor(u.baseMediaDecodeTime % s), y = o(ie.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      N >>> 24 & 255,
      N >>> 16 & 255,
      N >>> 8 & 255,
      N & 255,
      F >>> 24 & 255,
      F >>> 16 & 255,
      F >>> 8 & 255,
      F & 255
    ])), S = 92, u.type === "audio" ? (v = re(u, S), o(ie.traf, m, y, v)) : (T = P(u), v = re(u, T.length + S), o(ie.traf, m, y, v, T));
  }, M = function(u) {
    return u.duration = u.duration || 4294967295, o(ie.trak, A(u), L(u));
  }, V = function(u) {
    var m = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return u.type !== "video" && (m[m.length - 1] = 0), o(ie.trex, m);
  }, function() {
    var u, m, y;
    y = function(v, T) {
      var S = 0, N = 0, F = 0, U = 0;
      return v.length && (v[0].duration !== void 0 && (S = 1), v[0].size !== void 0 && (N = 2), v[0].flags !== void 0 && (F = 4), v[0].compositionTimeOffset !== void 0 && (U = 8)), [
        0,
        // version 0
        0,
        S | N | F | U,
        1,
        // flags
        (v.length & 4278190080) >>> 24,
        (v.length & 16711680) >>> 16,
        (v.length & 65280) >>> 8,
        v.length & 255,
        // sample_count
        (T & 4278190080) >>> 24,
        (T & 16711680) >>> 16,
        (T & 65280) >>> 8,
        T & 255
        // data_offset
      ];
    }, m = function(v, T) {
      var S, N, F, U, j, ne;
      for (U = v.samples || [], T += 20 + 16 * U.length, F = y(U, T), N = new Uint8Array(F.length + U.length * 16), N.set(F), S = F.length, ne = 0; ne < U.length; ne++)
        j = U[ne], N[S++] = (j.duration & 4278190080) >>> 24, N[S++] = (j.duration & 16711680) >>> 16, N[S++] = (j.duration & 65280) >>> 8, N[S++] = j.duration & 255, N[S++] = (j.size & 4278190080) >>> 24, N[S++] = (j.size & 16711680) >>> 16, N[S++] = (j.size & 65280) >>> 8, N[S++] = j.size & 255, N[S++] = j.flags.isLeading << 2 | j.flags.dependsOn, N[S++] = j.flags.isDependedOn << 6 | j.flags.hasRedundancy << 4 | j.flags.paddingValue << 1 | j.flags.isNonSyncSample, N[S++] = j.flags.degradationPriority & 61440, N[S++] = j.flags.degradationPriority & 15, N[S++] = (j.compositionTimeOffset & 4278190080) >>> 24, N[S++] = (j.compositionTimeOffset & 16711680) >>> 16, N[S++] = (j.compositionTimeOffset & 65280) >>> 8, N[S++] = j.compositionTimeOffset & 255;
      return o(ie.trun, N);
    }, u = function(v, T) {
      var S, N, F, U, j, ne;
      for (U = v.samples || [], T += 20 + 8 * U.length, F = y(U, T), S = new Uint8Array(F.length + U.length * 8), S.set(F), N = F.length, ne = 0; ne < U.length; ne++)
        j = U[ne], S[N++] = (j.duration & 4278190080) >>> 24, S[N++] = (j.duration & 16711680) >>> 16, S[N++] = (j.duration & 65280) >>> 8, S[N++] = j.duration & 255, S[N++] = (j.size & 4278190080) >>> 24, S[N++] = (j.size & 16711680) >>> 16, S[N++] = (j.size & 65280) >>> 8, S[N++] = j.size & 255;
      return o(ie.trun, S);
    }, re = function(v, T) {
      return v.type === "audio" ? u(v, T) : m(v, T);
    };
  }();
  var ee = {
    ftyp: d,
    mdat: f,
    moof: x,
    moov: p,
    initSegment: function(u) {
      var m = d(), y = p(u), v;
      return v = new Uint8Array(m.byteLength + y.byteLength), v.set(m), v.set(y, m.byteLength), v;
    }
  }, ze = function(u) {
    var m, y, v = [], T = [];
    for (T.byteLength = 0, T.nalCount = 0, T.duration = 0, v.byteLength = 0, m = 0; m < u.length; m++)
      y = u[m], y.nalUnitType === "access_unit_delimiter_rbsp" ? (v.length && (v.duration = y.dts - v.dts, T.byteLength += v.byteLength, T.nalCount += v.length, T.duration += v.duration, T.push(v)), v = [y], v.byteLength = y.data.byteLength, v.pts = y.pts, v.dts = y.dts) : (y.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (v.keyFrame = !0), v.duration = y.dts - v.dts, v.byteLength += y.data.byteLength, v.push(y));
    return T.length && (!v.duration || v.duration <= 0) && (v.duration = T[T.length - 1].duration), T.byteLength += v.byteLength, T.nalCount += v.length, T.duration += v.duration, T.push(v), T;
  }, et = function(u) {
    var m, y, v = [], T = [];
    for (v.byteLength = 0, v.nalCount = 0, v.duration = 0, v.pts = u[0].pts, v.dts = u[0].dts, T.byteLength = 0, T.nalCount = 0, T.duration = 0, T.pts = u[0].pts, T.dts = u[0].dts, m = 0; m < u.length; m++)
      y = u[m], y.keyFrame ? (v.length && (T.push(v), T.byteLength += v.byteLength, T.nalCount += v.nalCount, T.duration += v.duration), v = [y], v.nalCount = y.length, v.byteLength = y.byteLength, v.pts = y.pts, v.dts = y.dts, v.duration = y.duration) : (v.duration += y.duration, v.nalCount += y.length, v.byteLength += y.byteLength, v.push(y));
    return T.length && v.duration <= 0 && (v.duration = T[T.length - 1].duration), T.byteLength += v.byteLength, T.nalCount += v.nalCount, T.duration += v.duration, T.push(v), T;
  }, Te = function(u) {
    var m;
    return !u[0][0].keyFrame && u.length > 1 && (m = u.shift(), u.byteLength -= m.byteLength, u.nalCount -= m.nalCount, u[0][0].dts = m.dts, u[0][0].pts = m.pts, u[0][0].duration += m.duration), u;
  }, Qe = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, G = function(u, m) {
    var y = Qe();
    return y.dataOffset = m, y.compositionTimeOffset = u.pts - u.dts, y.duration = u.duration, y.size = 4 * u.length, y.size += u.byteLength, u.keyFrame && (y.flags.dependsOn = 2, y.flags.isNonSyncSample = 0), y;
  }, Se = function(u, m) {
    var y, v, T, S, N, F = m || 0, U = [];
    for (y = 0; y < u.length; y++)
      for (S = u[y], v = 0; v < S.length; v++)
        N = S[v], T = G(N, F), F += T.size, U.push(T);
    return U;
  }, he = function(u) {
    var m, y, v, T, S, N, F = 0, U = u.byteLength, j = u.nalCount, ne = U + 4 * j, fe = new Uint8Array(ne), Fe = new DataView(fe.buffer);
    for (m = 0; m < u.length; m++)
      for (T = u[m], y = 0; y < T.length; y++)
        for (S = T[y], v = 0; v < S.length; v++)
          N = S[v], Fe.setUint32(F, N.data.byteLength), F += 4, fe.set(N.data, F), F += N.data.byteLength;
    return fe;
  }, Ce = function(u, m) {
    var y, v = m || 0, T = [];
    return y = G(u, v), T.push(y), T;
  }, _e = function(u) {
    var m, y, v = 0, T = u.byteLength, S = u.length, N = T + 4 * S, F = new Uint8Array(N), U = new DataView(F.buffer);
    for (m = 0; m < u.length; m++)
      y = u[m], U.setUint32(v, y.data.byteLength), v += 4, F.set(y.data, v), v += y.data.byteLength;
    return F;
  }, tt = {
    groupNalsIntoFrames: ze,
    groupFramesIntoGops: et,
    extendFirstKeyFrame: Te,
    generateSampleTable: Se,
    concatenateNalData: he,
    generateSampleTableForFrame: Ce,
    concatenateNalDataForFrame: _e
  }, oe = [33, 16, 5, 32, 164, 27], Oe = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], Re = function(u) {
    for (var m = []; u--; )
      m.push(0);
    return m;
  }, lt = function(u) {
    return Object.keys(u).reduce(function(m, y) {
      return m[y] = new Uint8Array(u[y].reduce(function(v, T) {
        return v.concat(T);
      }, [])), m;
    }, {});
  }, Mt, We = function() {
    if (!Mt) {
      var u = {
        96e3: [oe, [227, 64], Re(154), [56]],
        88200: [oe, [231], Re(170), [56]],
        64e3: [oe, [248, 192], Re(240), [56]],
        48e3: [oe, [255, 192], Re(268), [55, 148, 128], Re(54), [112]],
        44100: [oe, [255, 192], Re(268), [55, 163, 128], Re(84), [112]],
        32e3: [oe, [255, 192], Re(268), [55, 234], Re(226), [112]],
        24e3: [oe, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 112], Re(126), [224]],
        16e3: [oe, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 255], Re(269), [223, 108], Re(195), [1, 192]],
        12e3: [Oe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 253, 128], Re(259), [56]],
        11025: [Oe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 255, 192], Re(268), [55, 175, 128], Re(108), [112]],
        8e3: [Oe, Re(268), [3, 121, 16], Re(47), [7]]
      };
      Mt = lt(u);
    }
    return Mt;
  }, fa = 9e4, jn, li, hn, ci, Vr, cr, qr;
  jn = function(u) {
    return u * fa;
  }, li = function(u, m) {
    return u * m;
  }, hn = function(u) {
    return u / fa;
  }, ci = function(u, m) {
    return u / m;
  }, Vr = function(u, m) {
    return jn(ci(u, m));
  }, cr = function(u, m) {
    return li(hn(u), m);
  }, qr = function(u, m, y) {
    return hn(y ? u : u - m);
  };
  var bt = {
    ONE_SECOND_IN_TS: fa,
    secondsToVideoTs: jn,
    secondsToAudioTs: li,
    videoTsToSeconds: hn,
    audioTsToSeconds: ci,
    audioTsToVideoTs: Vr,
    videoTsToAudioTs: cr,
    metadataTsToSeconds: qr
  }, po = We, Di = bt, mo = function(u) {
    var m, y, v = 0;
    for (m = 0; m < u.length; m++)
      y = u[m], v += y.data.byteLength;
    return v;
  }, go = function(u, m, y, v) {
    var T, S = 0, N = 0, F = 0, U = 0, j, ne, fe;
    if (m.length && (T = Di.audioTsToVideoTs(u.baseMediaDecodeTime, u.samplerate), S = Math.ceil(Di.ONE_SECOND_IN_TS / (u.samplerate / 1024)), y && v && (N = T - Math.max(y, v), F = Math.floor(N / S), U = F * S), !(F < 1 || U > Di.ONE_SECOND_IN_TS / 2))) {
      for (j = po()[u.samplerate], j || (j = m[0].data), ne = 0; ne < F; ne++)
        fe = m[0], m.splice(0, 0, {
          data: j,
          dts: fe.dts - S,
          pts: fe.pts - S
        });
      return u.baseMediaDecodeTime -= Math.floor(Di.videoTsToAudioTs(U, u.samplerate)), U;
    }
  }, ue = function(u, m, y) {
    return m.minSegmentDts >= y ? u : (m.minSegmentDts = 1 / 0, u.filter(function(v) {
      return v.dts >= y ? (m.minSegmentDts = Math.min(m.minSegmentDts, v.dts), m.minSegmentPts = m.minSegmentDts, !0) : !1;
    }));
  }, Pe = function(u) {
    var m, y, v = [];
    for (m = 0; m < u.length; m++)
      y = u[m], v.push({
        size: y.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return v;
  }, ye = function(u) {
    var m, y, v = 0, T = new Uint8Array(mo(u));
    for (m = 0; m < u.length; m++)
      y = u[m], T.set(y.data, v), v += y.data.byteLength;
    return T;
  }, Be = {
    prefixWithSilence: go,
    trimAdtsFramesByEarliestDts: ue,
    generateSampleTable: Pe,
    concatenateFrameData: ye
  }, Ue = bt.ONE_SECOND_IN_TS, _n = function(u, m) {
    typeof m.pts == "number" && (u.timelineStartInfo.pts === void 0 && (u.timelineStartInfo.pts = m.pts), u.minSegmentPts === void 0 ? u.minSegmentPts = m.pts : u.minSegmentPts = Math.min(u.minSegmentPts, m.pts), u.maxSegmentPts === void 0 ? u.maxSegmentPts = m.pts : u.maxSegmentPts = Math.max(u.maxSegmentPts, m.pts)), typeof m.dts == "number" && (u.timelineStartInfo.dts === void 0 && (u.timelineStartInfo.dts = m.dts), u.minSegmentDts === void 0 ? u.minSegmentDts = m.dts : u.minSegmentDts = Math.min(u.minSegmentDts, m.dts), u.maxSegmentDts === void 0 ? u.maxSegmentDts = m.dts : u.maxSegmentDts = Math.max(u.maxSegmentDts, m.dts));
  }, Vn = function(u) {
    delete u.minSegmentDts, delete u.maxSegmentDts, delete u.minSegmentPts, delete u.maxSegmentPts;
  }, ui = function(u, m) {
    var y, v, T = u.minSegmentDts;
    return m || (T -= u.timelineStartInfo.dts), y = u.timelineStartInfo.baseMediaDecodeTime, y += T, y = Math.max(0, y), u.type === "audio" && (v = u.samplerate / Ue, y *= v, y = Math.floor(y)), y;
  }, Wr = {
    clearDtsInfo: Vn,
    calculateTrackBaseMediaDecodeTime: ui,
    collectDtsInfo: _n
  }, Ii = 4, Ua = 128, bo = function(u) {
    for (var m = 0, y = {
      payloadType: -1,
      payloadSize: 0
    }, v = 0, T = 0; m < u.byteLength && u[m] !== Ua; ) {
      for (; u[m] === 255; )
        v += 255, m++;
      for (v += u[m++]; u[m] === 255; )
        T += 255, m++;
      if (T += u[m++], !y.payload && v === Ii) {
        var S = String.fromCharCode(u[m + 3], u[m + 4], u[m + 5], u[m + 6]);
        if (S === "GA94") {
          y.payloadType = v, y.payloadSize = T, y.payload = u.subarray(m, m + T);
          break;
        } else
          y.payload = void 0;
      }
      m += T, v = 0, T = 0;
    }
    return y;
  }, Dd = function(u) {
    return u.payload[0] !== 181 || (u.payload[1] << 8 | u.payload[2]) !== 49 || String.fromCharCode(u.payload[3], u.payload[4], u.payload[5], u.payload[6]) !== "GA94" || u.payload[7] !== 3 ? null : u.payload.subarray(8, u.payload.length - 1);
  }, Mx = function(u, m) {
    var y = [], v, T, S, N;
    if (!(m[0] & 64))
      return y;
    for (T = m[0] & 31, v = 0; v < T; v++)
      S = v * 3, N = {
        type: m[S + 2] & 3,
        pts: u
      }, m[S + 2] & 4 && (N.ccData = m[S + 3] << 8 | m[S + 4], y.push(N));
    return y;
  }, Ox = function(u) {
    for (var m = u.byteLength, y = [], v = 1, T, S; v < m - 2; )
      u[v] === 0 && u[v + 1] === 0 && u[v + 2] === 3 ? (y.push(v + 2), v += 2) : v++;
    if (y.length === 0)
      return u;
    T = m - y.length, S = new Uint8Array(T);
    var N = 0;
    for (v = 0; v < T; N++, v++)
      N === y[0] && (N++, y.shift()), S[v] = u[N];
    return S;
  }, Op = {
    parseSei: bo,
    parseUserData: Dd,
    parseCaptionPackets: Mx,
    discardEmulationPreventionBytes: Ox,
    USER_DATA_REGISTERED_ITU_T_T35: Ii
  }, Id = n, Zl = Op, qn = function(u) {
    u = u || {}, qn.prototype.init.call(this), this.parse708captions_ = typeof u.parse708captions == "boolean" ? u.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new Ot(0, 0),
      // eslint-disable-line no-use-before-define
      new Ot(0, 1),
      // eslint-disable-line no-use-before-define
      new Ot(1, 0),
      // eslint-disable-line no-use-before-define
      new Ot(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new wt({
      captionServices: u.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(m) {
      m.on("data", this.trigger.bind(this, "data")), m.on("partialdone", this.trigger.bind(this, "partialdone")), m.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  qn.prototype = new Id(), qn.prototype.push = function(u) {
    var m, y, v;
    if (u.nalUnitType === "sei_rbsp" && (m = Zl.parseSei(u.escapedRBSP), !!m.payload && m.payloadType === Zl.USER_DATA_REGISTERED_ITU_T_T35 && (y = Zl.parseUserData(m), !!y))) {
      if (u.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (u.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      v = Zl.parseCaptionPackets(u.pts, y), this.captionPackets_ = this.captionPackets_.concat(v), this.latestDts_ !== u.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = u.dts;
    }
  }, qn.prototype.flushCCStreams = function(u) {
    this.ccStreams_.forEach(function(m) {
      return u === "flush" ? m.flush() : m.partialFlush();
    }, this);
  }, qn.prototype.flushStream = function(u) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(u);
      return;
    }
    this.captionPackets_.forEach(function(m, y) {
      m.presortIndex = y;
    }), this.captionPackets_.sort(function(m, y) {
      return m.pts === y.pts ? m.presortIndex - y.presortIndex : m.pts - y.pts;
    }), this.captionPackets_.forEach(function(m) {
      m.type < 2 ? this.dispatchCea608Packet(m) : this.dispatchCea708Packet(m);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(u);
  }, qn.prototype.flush = function() {
    return this.flushStream("flush");
  }, qn.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, qn.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(u) {
      u.reset();
    });
  }, qn.prototype.dispatchCea608Packet = function(u) {
    this.setsTextOrXDSActive(u) ? this.activeCea608Channel_[u.type] = null : this.setsChannel1Active(u) ? this.activeCea608Channel_[u.type] = 0 : this.setsChannel2Active(u) && (this.activeCea608Channel_[u.type] = 1), this.activeCea608Channel_[u.type] !== null && this.ccStreams_[(u.type << 1) + this.activeCea608Channel_[u.type]].push(u);
  }, qn.prototype.setsChannel1Active = function(u) {
    return (u.ccData & 30720) === 4096;
  }, qn.prototype.setsChannel2Active = function(u) {
    return (u.ccData & 30720) === 6144;
  }, qn.prototype.setsTextOrXDSActive = function(u) {
    return (u.ccData & 28928) === 256 || (u.ccData & 30974) === 4138 || (u.ccData & 30974) === 6186;
  }, qn.prototype.dispatchCea708Packet = function(u) {
    this.parse708captions_ && this.cc708Stream_.push(u);
  };
  var Px = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, Bx = function(u) {
    var m = Px[u] || u;
    return u & 4096 && u === m ? "" : String.fromCharCode(m);
  }, Kl = function(u) {
    return 32 <= u && u <= 127 || 160 <= u && u <= 255;
  }, di = function(u) {
    this.windowNum = u, this.reset();
  };
  di.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, di.prototype.getText = function() {
    return this.rows.join(`
`);
  }, di.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, di.prototype.newLine = function(u) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(u), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, di.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, di.prototype.addText = function(u) {
    this.rows[this.rowIdx] += u;
  }, di.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var u = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = u.substr(0, u.length - 1);
    }
  };
  var Ql = function(u, m, y) {
    this.serviceNum = u, this.text = "", this.currentWindow = new di(-1), this.windows = [], this.stream = y, typeof m == "string" && this.createTextDecoder(m);
  };
  Ql.prototype.init = function(u, m) {
    this.startPts = u;
    for (var y = 0; y < 8; y++)
      this.windows[y] = new di(y), typeof m == "function" && (this.windows[y].beforeRowOverflow = m);
  }, Ql.prototype.setCurrentWindow = function(u) {
    this.currentWindow = this.windows[u];
  }, Ql.prototype.createTextDecoder = function(u) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(u);
      } catch (m) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + u + " encoding. " + m
        });
      }
  };
  var wt = function(u) {
    u = u || {}, wt.prototype.init.call(this);
    var m = this, y = u.captionServices || {}, v = {}, T;
    Object.keys(y).forEach((S) => {
      T = y[S], /^SERVICE/.test(S) && (v[S] = T.encoding);
    }), this.serviceEncodings = v, this.current708Packet = null, this.services = {}, this.push = function(S) {
      S.type === 3 ? (m.new708Packet(), m.add708Bytes(S)) : (m.current708Packet === null && m.new708Packet(), m.add708Bytes(S));
    };
  };
  wt.prototype = new Id(), wt.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, wt.prototype.add708Bytes = function(u) {
    var m = u.ccData, y = m >>> 8, v = m & 255;
    this.current708Packet.ptsVals.push(u.pts), this.current708Packet.data.push(y), this.current708Packet.data.push(v);
  }, wt.prototype.push708Packet = function() {
    var u = this.current708Packet, m = u.data, y = null, v = null, T = 0, S = m[T++];
    for (u.seq = S >> 6, u.sizeCode = S & 63; T < m.length; T++)
      S = m[T++], y = S >> 5, v = S & 31, y === 7 && v > 0 && (S = m[T++], y = S), this.pushServiceBlock(y, T, v), v > 0 && (T += v - 1);
  }, wt.prototype.pushServiceBlock = function(u, m, y) {
    var v, T = m, S = this.current708Packet.data, N = this.services[u];
    for (N || (N = this.initService(u, T)); T < m + y && T < S.length; T++)
      v = S[T], Kl(v) ? T = this.handleText(T, N) : v === 24 ? T = this.multiByteCharacter(T, N) : v === 16 ? T = this.extendedCommands(T, N) : 128 <= v && v <= 135 ? T = this.setCurrentWindow(T, N) : 152 <= v && v <= 159 ? T = this.defineWindow(T, N) : v === 136 ? T = this.clearWindows(T, N) : v === 140 ? T = this.deleteWindows(T, N) : v === 137 ? T = this.displayWindows(T, N) : v === 138 ? T = this.hideWindows(T, N) : v === 139 ? T = this.toggleWindows(T, N) : v === 151 ? T = this.setWindowAttributes(T, N) : v === 144 ? T = this.setPenAttributes(T, N) : v === 145 ? T = this.setPenColor(T, N) : v === 146 ? T = this.setPenLocation(T, N) : v === 143 ? N = this.reset(T, N) : v === 8 ? N.currentWindow.backspace() : v === 12 ? N.currentWindow.clearText() : v === 13 ? N.currentWindow.pendingNewLine = !0 : v === 14 ? N.currentWindow.clearText() : v === 141 && T++;
  }, wt.prototype.extendedCommands = function(u, m) {
    var y = this.current708Packet.data, v = y[++u];
    return Kl(v) && (u = this.handleText(u, m, {
      isExtended: !0
    })), u;
  }, wt.prototype.getPts = function(u) {
    return this.current708Packet.ptsVals[Math.floor(u / 2)];
  }, wt.prototype.initService = function(u, m) {
    var v = "SERVICE" + u, y = this, v, T;
    return v in this.serviceEncodings && (T = this.serviceEncodings[v]), this.services[u] = new Ql(u, T, y), this.services[u].init(this.getPts(m), function(S) {
      y.flushDisplayed(S, y.services[u]);
    }), this.services[u];
  }, wt.prototype.handleText = function(u, m, y) {
    var v = y && y.isExtended, T = y && y.isMultiByte, S = this.current708Packet.data, N = v ? 4096 : 0, F = S[u], U = S[u + 1], j = m.currentWindow, ne, fe;
    function Fe(ke) {
      return ke.map((Xe) => ("0" + (Xe & 255).toString(16)).slice(-2)).join("");
    }
    if (T ? (fe = [F, U], u++) : fe = [F], m.textDecoder_ && !v)
      ne = m.textDecoder_.decode(new Uint8Array(fe));
    else if (T) {
      const ke = Fe(fe);
      ne = String.fromCharCode(parseInt(ke, 16));
    } else
      ne = Bx(N | F);
    return j.pendingNewLine && !j.isEmpty() && j.newLine(this.getPts(u)), j.pendingNewLine = !1, j.addText(ne), u;
  }, wt.prototype.multiByteCharacter = function(u, m) {
    var y = this.current708Packet.data, v = y[u + 1], T = y[u + 2];
    return Kl(v) && Kl(T) && (u = this.handleText(++u, m, {
      isMultiByte: !0
    })), u;
  }, wt.prototype.setCurrentWindow = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = v & 7;
    return m.setCurrentWindow(T), u;
  }, wt.prototype.defineWindow = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = v & 7;
    m.setCurrentWindow(T);
    var S = m.currentWindow;
    return v = y[++u], S.visible = (v & 32) >> 5, S.rowLock = (v & 16) >> 4, S.columnLock = (v & 8) >> 3, S.priority = v & 7, v = y[++u], S.relativePositioning = (v & 128) >> 7, S.anchorVertical = v & 127, v = y[++u], S.anchorHorizontal = v, v = y[++u], S.anchorPoint = (v & 240) >> 4, S.rowCount = v & 15, v = y[++u], S.columnCount = v & 63, v = y[++u], S.windowStyle = (v & 56) >> 3, S.penStyle = v & 7, S.virtualRowCount = S.rowCount + 1, u;
  }, wt.prototype.setWindowAttributes = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = m.currentWindow.winAttr;
    return v = y[++u], T.fillOpacity = (v & 192) >> 6, T.fillRed = (v & 48) >> 4, T.fillGreen = (v & 12) >> 2, T.fillBlue = v & 3, v = y[++u], T.borderType = (v & 192) >> 6, T.borderRed = (v & 48) >> 4, T.borderGreen = (v & 12) >> 2, T.borderBlue = v & 3, v = y[++u], T.borderType += (v & 128) >> 5, T.wordWrap = (v & 64) >> 6, T.printDirection = (v & 48) >> 4, T.scrollDirection = (v & 12) >> 2, T.justify = v & 3, v = y[++u], T.effectSpeed = (v & 240) >> 4, T.effectDirection = (v & 12) >> 2, T.displayEffect = v & 3, u;
  }, wt.prototype.flushDisplayed = function(u, m) {
    for (var y = [], v = 0; v < 8; v++)
      m.windows[v].visible && !m.windows[v].isEmpty() && y.push(m.windows[v].getText());
    m.endPts = u, m.text = y.join(`

`), this.pushCaption(m), m.startPts = u;
  }, wt.prototype.pushCaption = function(u) {
    u.text !== "" && (this.trigger("data", {
      startPts: u.startPts,
      endPts: u.endPts,
      text: u.text,
      stream: "cc708_" + u.serviceNum
    }), u.text = "", u.startPts = u.endPts);
  }, wt.prototype.displayWindows = function(u, m) {
    var y = this.current708Packet.data, v = y[++u], T = this.getPts(u);
    this.flushDisplayed(T, m);
    for (var S = 0; S < 8; S++)
      v & 1 << S && (m.windows[S].visible = 1);
    return u;
  }, wt.prototype.hideWindows = function(u, m) {
    var y = this.current708Packet.data, v = y[++u], T = this.getPts(u);
    this.flushDisplayed(T, m);
    for (var S = 0; S < 8; S++)
      v & 1 << S && (m.windows[S].visible = 0);
    return u;
  }, wt.prototype.toggleWindows = function(u, m) {
    var y = this.current708Packet.data, v = y[++u], T = this.getPts(u);
    this.flushDisplayed(T, m);
    for (var S = 0; S < 8; S++)
      v & 1 << S && (m.windows[S].visible ^= 1);
    return u;
  }, wt.prototype.clearWindows = function(u, m) {
    var y = this.current708Packet.data, v = y[++u], T = this.getPts(u);
    this.flushDisplayed(T, m);
    for (var S = 0; S < 8; S++)
      v & 1 << S && m.windows[S].clearText();
    return u;
  }, wt.prototype.deleteWindows = function(u, m) {
    var y = this.current708Packet.data, v = y[++u], T = this.getPts(u);
    this.flushDisplayed(T, m);
    for (var S = 0; S < 8; S++)
      v & 1 << S && m.windows[S].reset();
    return u;
  }, wt.prototype.setPenAttributes = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = m.currentWindow.penAttr;
    return v = y[++u], T.textTag = (v & 240) >> 4, T.offset = (v & 12) >> 2, T.penSize = v & 3, v = y[++u], T.italics = (v & 128) >> 7, T.underline = (v & 64) >> 6, T.edgeType = (v & 56) >> 3, T.fontStyle = v & 7, u;
  }, wt.prototype.setPenColor = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = m.currentWindow.penColor;
    return v = y[++u], T.fgOpacity = (v & 192) >> 6, T.fgRed = (v & 48) >> 4, T.fgGreen = (v & 12) >> 2, T.fgBlue = v & 3, v = y[++u], T.bgOpacity = (v & 192) >> 6, T.bgRed = (v & 48) >> 4, T.bgGreen = (v & 12) >> 2, T.bgBlue = v & 3, v = y[++u], T.edgeRed = (v & 48) >> 4, T.edgeGreen = (v & 12) >> 2, T.edgeBlue = v & 3, u;
  }, wt.prototype.setPenLocation = function(u, m) {
    var y = this.current708Packet.data, v = y[u], T = m.currentWindow.penLoc;
    return m.currentWindow.pendingNewLine = !0, v = y[++u], T.row = v & 15, v = y[++u], T.column = v & 63, u;
  }, wt.prototype.reset = function(u, m) {
    var y = this.getPts(u);
    return this.flushDisplayed(y, m), this.initService(m.serviceNum, u);
  };
  var Rx = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, Jl = function(u) {
    return u === null ? "" : (u = Rx[u] || u, String.fromCharCode(u));
  }, ec = 14, Nx = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], ur = function() {
    for (var u = [], m = ec + 1; m--; )
      u.push({
        text: "",
        indent: 0,
        offset: 0
      });
    return u;
  }, Ot = function(u, m) {
    Ot.prototype.init.call(this), this.field_ = u || 0, this.dataChannel_ = m || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(y) {
      var v, T, S, N, F;
      if (v = y.ccData & 32639, v === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((v & 61440) === 4096 ? this.lastControlCode_ = v : v !== this.PADDING_ && (this.lastControlCode_ = null), S = v >>> 8, N = v & 255, v !== this.PADDING_)
        if (v === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (v === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(y.pts), this.flushDisplayed(y.pts), T = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = T, this.startPts_ = y.pts;
        else if (v === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(y.pts);
        else if (v === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(y.pts);
        else if (v === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(y.pts);
        else if (v === this.CARRIAGE_RETURN_)
          this.clearFormatting(y.pts), this.flushDisplayed(y.pts), this.shiftRowsUp_(), this.startPts_ = y.pts;
        else if (v === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
        else if (v === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(y.pts), this.displayed_ = ur();
        else if (v === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = ur();
        else if (v === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(y.pts), this.displayed_ = ur()), this.mode_ = "paintOn", this.startPts_ = y.pts;
        else if (this.isSpecialCharacter(S, N))
          S = (S & 3) << 8, F = Jl(S | N), this[this.mode_](y.pts, F), this.column_++;
        else if (this.isExtCharacter(S, N))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), S = (S & 3) << 8, F = Jl(S | N), this[this.mode_](y.pts, F), this.column_++;
        else if (this.isMidRowCode(S, N))
          this.clearFormatting(y.pts), this[this.mode_](y.pts, " "), this.column_++, (N & 14) === 14 && this.addFormatting(y.pts, ["i"]), (N & 1) === 1 && this.addFormatting(y.pts, ["u"]);
        else if (this.isOffsetControlCode(S, N)) {
          const j = N & 3;
          this.nonDisplayed_[this.row_].offset = j, this.column_ += j;
        } else if (this.isPAC(S, N)) {
          var U = Nx.indexOf(v & 7968);
          if (this.mode_ === "rollUp" && (U - this.rollUpRows_ + 1 < 0 && (U = this.rollUpRows_ - 1), this.setRollUp(y.pts, U)), U !== this.row_ && U >= 0 && U <= 14 && (this.clearFormatting(y.pts), this.row_ = U), N & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(y.pts, ["u"]), (v & 16) === 16) {
            const j = (v & 14) >> 1;
            this.column_ = j * 4, this.nonDisplayed_[this.row_].indent += j;
          }
          this.isColorPAC(N) && (N & 14) === 14 && this.addFormatting(y.pts, ["i"]);
        } else this.isNormalChar(S) && (N === 0 && (N = null), F = Jl(S), F += Jl(N), this[this.mode_](y.pts, F), this.column_ += F.length);
    };
  };
  Ot.prototype = new Id(), Ot.prototype.flushDisplayed = function(u) {
    const m = (v) => {
      this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + v + "."
      });
    }, y = [];
    this.displayed_.forEach((v, T) => {
      if (v && v.text && v.text.length) {
        try {
          v.text = v.text.trim();
        } catch {
          m(T);
        }
        v.text.length && y.push({
          // The text to be displayed in the caption from this specific row, with whitespace removed.
          text: v.text,
          // Value between 1 and 15 representing the PAC row used to calculate line height.
          line: T + 1,
          // A number representing the indent position by percentage (CEA-608 PAC indent code).
          // The value will be a number between 10 and 80. Offset is used to add an aditional
          // value to the position if necessary.
          position: 10 + Math.min(70, v.indent * 10) + v.offset * 2.5
        });
      } else v == null && m(T);
    }), y.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: u,
      content: y,
      stream: this.name_
    });
  }, Ot.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = ur(), this.nonDisplayed_ = ur(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = ec, this.rollUpRows_ = 2, this.formatting_ = [];
  }, Ot.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, Ot.prototype.isSpecialCharacter = function(u, m) {
    return u === this.EXT_ && m >= 48 && m <= 63;
  }, Ot.prototype.isExtCharacter = function(u, m) {
    return (u === this.EXT_ + 1 || u === this.EXT_ + 2) && m >= 32 && m <= 63;
  }, Ot.prototype.isMidRowCode = function(u, m) {
    return u === this.EXT_ && m >= 32 && m <= 47;
  }, Ot.prototype.isOffsetControlCode = function(u, m) {
    return u === this.OFFSET_ && m >= 33 && m <= 35;
  }, Ot.prototype.isPAC = function(u, m) {
    return u >= this.BASE_ && u < this.BASE_ + 8 && m >= 64 && m <= 127;
  }, Ot.prototype.isColorPAC = function(u) {
    return u >= 64 && u <= 79 || u >= 96 && u <= 127;
  }, Ot.prototype.isNormalChar = function(u) {
    return u >= 32 && u <= 127;
  }, Ot.prototype.setRollUp = function(u, m) {
    if (this.mode_ !== "rollUp" && (this.row_ = ec, this.mode_ = "rollUp", this.flushDisplayed(u), this.nonDisplayed_ = ur(), this.displayed_ = ur()), m !== void 0 && m !== this.row_)
      for (var y = 0; y < this.rollUpRows_; y++)
        this.displayed_[m - y] = this.displayed_[this.row_ - y], this.displayed_[this.row_ - y] = {
          text: "",
          indent: 0,
          offset: 0
        };
    m === void 0 && (m = this.row_), this.topRow_ = m - this.rollUpRows_ + 1;
  }, Ot.prototype.addFormatting = function(u, m) {
    this.formatting_ = this.formatting_.concat(m);
    var y = m.reduce(function(v, T) {
      return v + "<" + T + ">";
    }, "");
    this[this.mode_](u, y);
  }, Ot.prototype.clearFormatting = function(u) {
    if (this.formatting_.length) {
      var m = this.formatting_.reverse().reduce(function(y, v) {
        return y + "</" + v + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](u, m);
    }
  }, Ot.prototype.popOn = function(u, m) {
    var y = this.nonDisplayed_[this.row_].text;
    y += m, this.nonDisplayed_[this.row_].text = y;
  }, Ot.prototype.rollUp = function(u, m) {
    var y = this.displayed_[this.row_].text;
    y += m, this.displayed_[this.row_].text = y;
  }, Ot.prototype.shiftRowsUp_ = function() {
    var u;
    for (u = 0; u < this.topRow_; u++)
      this.displayed_[u] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (u = this.row_ + 1; u < ec + 1; u++)
      this.displayed_[u] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (u = this.topRow_; u < this.row_; u++)
      this.displayed_[u] = this.displayed_[u + 1];
    this.displayed_[this.row_] = {
      text: "",
      indent: 0,
      offset: 0
    };
  }, Ot.prototype.paintOn = function(u, m) {
    var y = this.displayed_[this.row_].text;
    y += m, this.displayed_[this.row_].text = y;
  };
  var Pp = {
    CaptionStream: qn,
    Cea608Stream: Ot,
    Cea708Stream: wt
  }, tc = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, $x = n, Fx = 8589934592, zx = 4294967296, Bp = "shared", Md = function(u, m) {
    var y = 1;
    for (u > m && (y = -1); Math.abs(m - u) > zx; )
      u += y * Fx;
    return u;
  }, Od = function(u) {
    var m, y;
    Od.prototype.init.call(this), this.type_ = u || Bp, this.push = function(v) {
      if (v.type === "metadata") {
        this.trigger("data", v);
        return;
      }
      this.type_ !== Bp && v.type !== this.type_ || (y === void 0 && (y = v.dts), v.dts = Md(v.dts, y), v.pts = Md(v.pts, y), m = v.dts, this.trigger("data", v));
    }, this.flush = function() {
      y = m, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      y = void 0, m = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  Od.prototype = new $x();
  var Rp = {
    TimestampRolloverStream: Od,
    handleRollover: Md
  }, Ux = (u, m, y) => {
    if (!u)
      return -1;
    for (var v = y; v < u.length; v++)
      if (u[v] === m)
        return v;
    return -1;
  }, Hx = {
    typedArrayIndexOf: Ux
  }, nc = Hx.typedArrayIndexOf, ac = {
    // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
    Utf8: 3
    // UTF-8 encoded Unicode, terminated with \0
  }, Np = function(u, m, y) {
    var v, T = "";
    for (v = m; v < y; v++)
      T += "%" + ("00" + u[v].toString(16)).slice(-2);
    return T;
  }, vo = function(u, m, y) {
    return decodeURIComponent(Np(u, m, y));
  }, yo = function(u, m, y) {
    return unescape(Np(u, m, y));
  }, _o = function(u) {
    return u[0] << 21 | u[1] << 14 | u[2] << 7 | u[3];
  }, xo = {
    APIC: function(u) {
      var m = 1, y, v, T = "-->";
      u.data[0] === ac.Utf8 && (y = nc(u.data, 0, m), !(y < 0) && (u.mimeType = yo(u.data, m, y), m = y + 1, u.pictureType = u.data[m], m++, v = nc(u.data, 0, m), !(v < 0) && (u.description = vo(u.data, m, v), m = v + 1, u.mimeType === T ? u.url = yo(u.data, m, u.data.length) : u.pictureData = u.data.subarray(m, u.data.length))));
    },
    "T*": function(u) {
      u.data[0] === ac.Utf8 && (u.value = vo(u.data, 1, u.data.length).replace(/\0*$/, ""), u.values = u.value.split("\0"));
    },
    TXXX: function(u) {
      var m;
      u.data[0] === ac.Utf8 && (m = nc(u.data, 0, 1), m !== -1 && (u.description = vo(u.data, 1, m), u.value = vo(u.data, m + 1, u.data.length).replace(/\0*$/, ""), u.data = u.value));
    },
    "W*": function(u) {
      u.url = yo(u.data, 0, u.data.length).replace(/\0.*$/, "");
    },
    WXXX: function(u) {
      var m;
      u.data[0] === ac.Utf8 && (m = nc(u.data, 0, 1), m !== -1 && (u.description = vo(u.data, 1, m), u.url = yo(u.data, m + 1, u.data.length).replace(/\0.*$/, "")));
    },
    PRIV: function(u) {
      var m;
      for (m = 0; m < u.data.length; m++)
        if (u.data[m] === 0) {
          u.owner = yo(u.data, 0, m);
          break;
        }
      u.privateData = u.data.subarray(m + 1), u.data = u.privateData;
    }
  }, Yx = function(u) {
    var m, y, v = 10, T = 0, S = [];
    if (!(u.length < 10 || u[0] !== 73 || u[1] !== 68 || u[2] !== 51)) {
      T = _o(u.subarray(6, 10)), T += 10;
      var N = u[5] & 64;
      N && (v += 4, v += _o(u.subarray(10, 14)), T -= _o(u.subarray(16, 20)));
      do {
        if (m = _o(u.subarray(v + 4, v + 8)), m < 1)
          break;
        y = String.fromCharCode(u[v], u[v + 1], u[v + 2], u[v + 3]);
        var F = {
          id: y,
          data: u.subarray(v + 10, v + m + 10)
        };
        F.key = F.id, xo[F.id] ? xo[F.id](F) : F.id[0] === "T" ? xo["T*"](F) : F.id[0] === "W" && xo["W*"](F), S.push(F), v += 10, v += m;
      } while (v < T);
      return S;
    }
  }, $p = {
    parseId3Frames: Yx,
    parseSyncSafeInteger: _o,
    frameParsers: xo
  }, jx = n, Vx = tc, Mi = $p, ic;
  ic = function(u) {
    var m = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: u && u.descriptor
    }, y = 0, v = [], T = 0, S;
    if (ic.prototype.init.call(this), this.dispatchType = Vx.METADATA_STREAM_TYPE.toString(16), m.descriptor)
      for (S = 0; S < m.descriptor.length; S++)
        this.dispatchType += ("00" + m.descriptor[S].toString(16)).slice(-2);
    this.push = function(N) {
      var F, U, j, ne, fe, Fe;
      if (N.type === "timed-metadata") {
        if (N.dataAlignmentIndicator && (T = 0, v.length = 0), v.length === 0 && (N.data.length < 10 || N.data[0] !== 73 || N.data[1] !== 68 || N.data[2] !== 51)) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (v.push(N), T += N.data.byteLength, v.length === 1 && (y = Mi.parseSyncSafeInteger(N.data.subarray(6, 10)), y += 10), !(T < y)) {
          for (F = {
            data: new Uint8Array(y),
            frames: [],
            pts: v[0].pts,
            dts: v[0].dts
          }, fe = 0; fe < y; )
            F.data.set(v[0].data.subarray(0, y - fe), fe), fe += v[0].data.byteLength, T -= v[0].data.byteLength, v.shift();
          U = 10, F.data[5] & 64 && (U += 4, U += Mi.parseSyncSafeInteger(F.data.subarray(10, 14)), y -= Mi.parseSyncSafeInteger(F.data.subarray(16, 20)));
          do {
            if (j = Mi.parseSyncSafeInteger(F.data.subarray(U + 4, U + 8)), j < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
              });
              break;
            }
            if (Fe = String.fromCharCode(F.data[U], F.data[U + 1], F.data[U + 2], F.data[U + 3]), ne = {
              id: Fe,
              data: F.data.subarray(U + 10, U + j + 10)
            }, ne.key = ne.id, Mi.frameParsers[ne.id] ? Mi.frameParsers[ne.id](ne) : ne.id[0] === "T" ? Mi.frameParsers["T*"](ne) : ne.id[0] === "W" && Mi.frameParsers["W*"](ne), ne.owner === "com.apple.streaming.transportStreamTimestamp") {
              var ke = ne.data, Xe = (ke[3] & 1) << 30 | ke[4] << 22 | ke[5] << 14 | ke[6] << 6 | ke[7] >>> 2;
              Xe *= 4, Xe += ke[7] & 3, ne.timeStamp = Xe, F.pts === void 0 && F.dts === void 0 && (F.pts = ne.timeStamp, F.dts = ne.timeStamp), this.trigger("timestamp", ne);
            }
            F.frames.push(ne), U += 10, U += j;
          } while (U < y);
          this.trigger("data", F);
        }
      }
    };
  }, ic.prototype = new jx();
  var qx = ic, Pd = n, Bd = Pp, wa = tc, Wx = Rp.TimestampRolloverStream, rc, To, sc, Gr = 188, Rd = 71;
  rc = function() {
    var u = new Uint8Array(Gr), m = 0;
    rc.prototype.init.call(this), this.push = function(y) {
      var v = 0, T = Gr, S;
      for (m ? (S = new Uint8Array(y.byteLength + m), S.set(u.subarray(0, m)), S.set(y, m), m = 0) : S = y; T < S.byteLength; ) {
        if (S[v] === Rd && S[T] === Rd) {
          this.trigger("data", S.subarray(v, T)), v += Gr, T += Gr;
          continue;
        }
        v++, T++;
      }
      v < S.byteLength && (u.set(S.subarray(v), 0), m = S.byteLength - v);
    }, this.flush = function() {
      m === Gr && u[0] === Rd && (this.trigger("data", u), m = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      m = 0, this.trigger("reset");
    };
  }, rc.prototype = new Pd(), To = function() {
    var u, m, y, v;
    To.prototype.init.call(this), v = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, u = function(T, S) {
      var N = 0;
      S.payloadUnitStartIndicator && (N += T[N] + 1), S.type === "pat" ? m(T.subarray(N), S) : y(T.subarray(N), S);
    }, m = function(T, S) {
      S.section_number = T[7], S.last_section_number = T[8], v.pmtPid = (T[10] & 31) << 8 | T[11], S.pmtPid = v.pmtPid;
    }, y = function(T, S) {
      var N, F, U, j;
      if (T[5] & 1) {
        for (v.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, N = (T[1] & 15) << 8 | T[2], F = 3 + N - 4, U = (T[10] & 15) << 8 | T[11], j = 12 + U; j < F; ) {
          var ne = T[j], fe = (T[j + 1] & 31) << 8 | T[j + 2];
          ne === wa.H264_STREAM_TYPE && v.programMapTable.video === null ? v.programMapTable.video = fe : ne === wa.ADTS_STREAM_TYPE && v.programMapTable.audio === null ? v.programMapTable.audio = fe : ne === wa.METADATA_STREAM_TYPE && (v.programMapTable["timed-metadata"][fe] = ne), j += ((T[j + 3] & 15) << 8 | T[j + 4]) + 5;
        }
        S.programMapTable = v.programMapTable;
      }
    }, this.push = function(T) {
      var S = {}, N = 4;
      if (S.payloadUnitStartIndicator = !!(T[1] & 64), S.pid = T[1] & 31, S.pid <<= 8, S.pid |= T[2], (T[3] & 48) >>> 4 > 1 && (N += T[N] + 1), S.pid === 0)
        S.type = "pat", u(T.subarray(N), S), this.trigger("data", S);
      else if (S.pid === this.pmtPid)
        for (S.type = "pmt", u(T.subarray(N), S), this.trigger("data", S); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([T, N, S]) : this.processPes_(T, N, S);
    }, this.processPes_ = function(T, S, N) {
      N.pid === this.programMapTable.video ? N.streamType = wa.H264_STREAM_TYPE : N.pid === this.programMapTable.audio ? N.streamType = wa.ADTS_STREAM_TYPE : N.streamType = this.programMapTable["timed-metadata"][N.pid], N.type = "pes", N.data = T.subarray(S), this.trigger("data", N);
    };
  }, To.prototype = new Pd(), To.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, sc = function() {
    var u = this, m = !1, y = {
      data: [],
      size: 0
    }, v = {
      data: [],
      size: 0
    }, T = {
      data: [],
      size: 0
    }, S, N = function(U, j) {
      var ne;
      const fe = U[0] << 16 | U[1] << 8 | U[2];
      j.data = new Uint8Array(), fe === 1 && (j.packetLength = 6 + (U[4] << 8 | U[5]), j.dataAlignmentIndicator = (U[6] & 4) !== 0, ne = U[7], ne & 192 && (j.pts = (U[9] & 14) << 27 | (U[10] & 255) << 20 | (U[11] & 254) << 12 | (U[12] & 255) << 5 | (U[13] & 254) >>> 3, j.pts *= 4, j.pts += (U[13] & 6) >>> 1, j.dts = j.pts, ne & 64 && (j.dts = (U[14] & 14) << 27 | (U[15] & 255) << 20 | (U[16] & 254) << 12 | (U[17] & 255) << 5 | (U[18] & 254) >>> 3, j.dts *= 4, j.dts += (U[18] & 6) >>> 1)), j.data = U.subarray(9 + U[8]));
    }, F = function(U, j, ne) {
      var fe = new Uint8Array(U.size), Fe = {
        type: j
      }, ke = 0, Xe = 0, st = !1, fn;
      if (!(!U.data.length || U.size < 9)) {
        for (Fe.trackId = U.data[0].pid, ke = 0; ke < U.data.length; ke++)
          fn = U.data[ke], fe.set(fn.data, Xe), Xe += fn.data.byteLength;
        N(fe, Fe), st = j === "video" || Fe.packetLength <= U.size, (ne || st) && (U.size = 0, U.data.length = 0), st && u.trigger("data", Fe);
      }
    };
    sc.prototype.init.call(this), this.push = function(U) {
      ({
        pat: function() {
        },
        pes: function() {
          var j, ne;
          switch (U.streamType) {
            case wa.H264_STREAM_TYPE:
              j = y, ne = "video";
              break;
            case wa.ADTS_STREAM_TYPE:
              j = v, ne = "audio";
              break;
            case wa.METADATA_STREAM_TYPE:
              j = T, ne = "timed-metadata";
              break;
            default:
              return;
          }
          U.payloadUnitStartIndicator && F(j, ne, !0), j.data.push(U), j.size += U.data.byteLength;
        },
        pmt: function() {
          var j = {
            type: "metadata",
            tracks: []
          };
          S = U.programMapTable, S.video !== null && j.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +S.video,
            codec: "avc",
            type: "video"
          }), S.audio !== null && j.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +S.audio,
            codec: "adts",
            type: "audio"
          }), m = !0, u.trigger("data", j);
        }
      })[U.type]();
    }, this.reset = function() {
      y.size = 0, y.data.length = 0, v.size = 0, v.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      F(y, "video"), F(v, "audio"), F(T, "timed-metadata");
    }, this.flush = function() {
      if (!m && S) {
        var U = {
          type: "metadata",
          tracks: []
        };
        S.video !== null && U.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +S.video,
          codec: "avc",
          type: "video"
        }), S.audio !== null && U.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +S.audio,
          codec: "adts",
          type: "audio"
        }), u.trigger("data", U);
      }
      m = !1, this.flushStreams_(), this.trigger("done");
    };
  }, sc.prototype = new Pd();
  var Fp = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: Gr,
    TransportPacketStream: rc,
    TransportParseStream: To,
    ElementaryStream: sc,
    TimestampRolloverStream: Wx,
    CaptionStream: Bd.CaptionStream,
    Cea608Stream: Bd.Cea608Stream,
    Cea708Stream: Bd.Cea708Stream,
    MetadataStream: qx
  };
  for (var Nd in wa)
    wa.hasOwnProperty(Nd) && (Fp[Nd] = wa[Nd]);
  var Gx = Fp, Xx = n, Zx = bt.ONE_SECOND_IN_TS, oc, zp = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  oc = function(u) {
    var m, y = 0;
    oc.prototype.init.call(this), this.skipWarn_ = function(v, T) {
      this.trigger("log", {
        level: "warn",
        message: `adts skiping bytes ${v} to ${T} in frame ${y} outside syncword`
      });
    }, this.push = function(v) {
      var T = 0, S, N, F, U, j;
      if (u || (y = 0), v.type === "audio") {
        m && m.length ? (F = m, m = new Uint8Array(F.byteLength + v.data.byteLength), m.set(F), m.set(v.data, F.byteLength)) : m = v.data;
        for (var ne; T + 7 < m.length; ) {
          if (m[T] !== 255 || (m[T + 1] & 246) !== 240) {
            typeof ne != "number" && (ne = T), T++;
            continue;
          }
          if (typeof ne == "number" && (this.skipWarn_(ne, T), ne = null), N = (~m[T + 1] & 1) * 2, S = (m[T + 3] & 3) << 11 | m[T + 4] << 3 | (m[T + 5] & 224) >> 5, U = ((m[T + 6] & 3) + 1) * 1024, j = U * Zx / zp[(m[T + 2] & 60) >>> 2], m.byteLength - T < S)
            break;
          this.trigger("data", {
            pts: v.pts + y * j,
            dts: v.dts + y * j,
            sampleCount: U,
            audioobjecttype: (m[T + 2] >>> 6 & 3) + 1,
            channelcount: (m[T + 2] & 1) << 2 | (m[T + 3] & 192) >>> 6,
            samplerate: zp[(m[T + 2] & 60) >>> 2],
            samplingfrequencyindex: (m[T + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: m.subarray(T + 7 + N, T + S)
          }), y++, T += S;
        }
        typeof ne == "number" && (this.skipWarn_(ne, T), ne = null), m = m.subarray(T);
      }
    }, this.flush = function() {
      y = 0, this.trigger("done");
    }, this.reset = function() {
      m = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      m = void 0, this.trigger("endedtimeline");
    };
  }, oc.prototype = new Xx();
  var Kx = oc, Up;
  Up = function(u) {
    var m = u.byteLength, y = 0, v = 0;
    this.length = function() {
      return 8 * m;
    }, this.bitsAvailable = function() {
      return 8 * m + v;
    }, this.loadWord = function() {
      var T = u.byteLength - m, S = new Uint8Array(4), N = Math.min(4, m);
      if (N === 0)
        throw new Error("no bytes available");
      S.set(u.subarray(T, T + N)), y = new DataView(S.buffer).getUint32(0), v = N * 8, m -= N;
    }, this.skipBits = function(T) {
      var S;
      v > T ? (y <<= T, v -= T) : (T -= v, S = Math.floor(T / 8), T -= S * 8, m -= S, this.loadWord(), y <<= T, v -= T);
    }, this.readBits = function(T) {
      var S = Math.min(v, T), N = y >>> 32 - S;
      return v -= S, v > 0 ? y <<= S : m > 0 && this.loadWord(), S = T - S, S > 0 ? N << S | this.readBits(S) : N;
    }, this.skipLeadingZeros = function() {
      var T;
      for (T = 0; T < v; ++T)
        if (y & 2147483648 >>> T)
          return y <<= T, v -= T, T;
      return this.loadWord(), T + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var T = this.skipLeadingZeros();
      return this.readBits(T + 1) - 1;
    }, this.readExpGolomb = function() {
      var T = this.readUnsignedExpGolomb();
      return 1 & T ? 1 + T >>> 1 : -1 * (T >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var Qx = Up, Hp = n, Jx = Qx, lc, cc, Yp;
  cc = function() {
    var u = 0, m, y;
    cc.prototype.init.call(this), this.push = function(v) {
      var T;
      y ? (T = new Uint8Array(y.byteLength + v.data.byteLength), T.set(y), T.set(v.data, y.byteLength), y = T) : y = v.data;
      for (var S = y.byteLength; u < S - 3; u++)
        if (y[u + 2] === 1) {
          m = u + 5;
          break;
        }
      for (; m < S; )
        switch (y[m]) {
          case 0:
            if (y[m - 1] !== 0) {
              m += 2;
              break;
            } else if (y[m - 2] !== 0) {
              m++;
              break;
            }
            u + 3 !== m - 2 && this.trigger("data", y.subarray(u + 3, m - 2));
            do
              m++;
            while (y[m] !== 1 && m < S);
            u = m - 2, m += 3;
            break;
          case 1:
            if (y[m - 1] !== 0 || y[m - 2] !== 0) {
              m += 3;
              break;
            }
            this.trigger("data", y.subarray(u + 3, m - 2)), u = m - 2, m += 3;
            break;
          default:
            m += 3;
            break;
        }
      y = y.subarray(u), m -= u, u = 0;
    }, this.reset = function() {
      y = null, u = 0, this.trigger("reset");
    }, this.flush = function() {
      y && y.byteLength > 3 && this.trigger("data", y.subarray(u + 3)), y = null, u = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, cc.prototype = new Hp(), Yp = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, lc = function() {
    var u = new cc(), m, y, v, T, S, N, F;
    lc.prototype.init.call(this), m = this, this.push = function(U) {
      U.type === "video" && (y = U.trackId, v = U.pts, T = U.dts, u.push(U));
    }, u.on("data", function(U) {
      var j = {
        trackId: y,
        pts: v,
        dts: T,
        data: U,
        nalUnitTypeCode: U[0] & 31
      };
      switch (j.nalUnitTypeCode) {
        case 5:
          j.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          j.nalUnitType = "sei_rbsp", j.escapedRBSP = S(U.subarray(1));
          break;
        case 7:
          j.nalUnitType = "seq_parameter_set_rbsp", j.escapedRBSP = S(U.subarray(1)), j.config = N(j.escapedRBSP);
          break;
        case 8:
          j.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          j.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      m.trigger("data", j);
    }), u.on("done", function() {
      m.trigger("done");
    }), u.on("partialdone", function() {
      m.trigger("partialdone");
    }), u.on("reset", function() {
      m.trigger("reset");
    }), u.on("endedtimeline", function() {
      m.trigger("endedtimeline");
    }), this.flush = function() {
      u.flush();
    }, this.partialFlush = function() {
      u.partialFlush();
    }, this.reset = function() {
      u.reset();
    }, this.endTimeline = function() {
      u.endTimeline();
    }, F = function(U, j) {
      var ne = 8, fe = 8, Fe, ke;
      for (Fe = 0; Fe < U; Fe++)
        fe !== 0 && (ke = j.readExpGolomb(), fe = (ne + ke + 256) % 256), ne = fe === 0 ? ne : fe;
    }, S = function(U) {
      for (var j = U.byteLength, ne = [], fe = 1, Fe, ke; fe < j - 2; )
        U[fe] === 0 && U[fe + 1] === 0 && U[fe + 2] === 3 ? (ne.push(fe + 2), fe += 2) : fe++;
      if (ne.length === 0)
        return U;
      Fe = j - ne.length, ke = new Uint8Array(Fe);
      var Xe = 0;
      for (fe = 0; fe < Fe; Xe++, fe++)
        Xe === ne[0] && (Xe++, ne.shift()), ke[fe] = U[Xe];
      return ke;
    }, N = function(U) {
      var j = 0, ne = 0, fe = 0, Fe = 0, ke, Xe, st, fn, aa, Pi, Lo, Do, Io, Mo, xc, Et = [1, 1], Oo, Sa;
      if (ke = new Jx(U), Xe = ke.readUnsignedByte(), fn = ke.readUnsignedByte(), st = ke.readUnsignedByte(), ke.skipUnsignedExpGolomb(), Yp[Xe] && (aa = ke.readUnsignedExpGolomb(), aa === 3 && ke.skipBits(1), ke.skipUnsignedExpGolomb(), ke.skipUnsignedExpGolomb(), ke.skipBits(1), ke.readBoolean()))
        for (xc = aa !== 3 ? 8 : 12, Sa = 0; Sa < xc; Sa++)
          ke.readBoolean() && (Sa < 6 ? F(16, ke) : F(64, ke));
      if (ke.skipUnsignedExpGolomb(), Pi = ke.readUnsignedExpGolomb(), Pi === 0)
        ke.readUnsignedExpGolomb();
      else if (Pi === 1)
        for (ke.skipBits(1), ke.skipExpGolomb(), ke.skipExpGolomb(), Lo = ke.readUnsignedExpGolomb(), Sa = 0; Sa < Lo; Sa++)
          ke.skipExpGolomb();
      if (ke.skipUnsignedExpGolomb(), ke.skipBits(1), Do = ke.readUnsignedExpGolomb(), Io = ke.readUnsignedExpGolomb(), Mo = ke.readBits(1), Mo === 0 && ke.skipBits(1), ke.skipBits(1), ke.readBoolean() && (j = ke.readUnsignedExpGolomb(), ne = ke.readUnsignedExpGolomb(), fe = ke.readUnsignedExpGolomb(), Fe = ke.readUnsignedExpGolomb()), ke.readBoolean() && ke.readBoolean()) {
        switch (Oo = ke.readUnsignedByte(), Oo) {
          case 1:
            Et = [1, 1];
            break;
          case 2:
            Et = [12, 11];
            break;
          case 3:
            Et = [10, 11];
            break;
          case 4:
            Et = [16, 11];
            break;
          case 5:
            Et = [40, 33];
            break;
          case 6:
            Et = [24, 11];
            break;
          case 7:
            Et = [20, 11];
            break;
          case 8:
            Et = [32, 11];
            break;
          case 9:
            Et = [80, 33];
            break;
          case 10:
            Et = [18, 11];
            break;
          case 11:
            Et = [15, 11];
            break;
          case 12:
            Et = [64, 33];
            break;
          case 13:
            Et = [160, 99];
            break;
          case 14:
            Et = [4, 3];
            break;
          case 15:
            Et = [3, 2];
            break;
          case 16:
            Et = [2, 1];
            break;
          case 255: {
            Et = [ke.readUnsignedByte() << 8 | ke.readUnsignedByte(), ke.readUnsignedByte() << 8 | ke.readUnsignedByte()];
            break;
          }
        }
        Et && Et[0] / Et[1];
      }
      return {
        profileIdc: Xe,
        levelIdc: st,
        profileCompatibility: fn,
        width: (Do + 1) * 16 - j * 2 - ne * 2,
        height: (2 - Mo) * (Io + 1) * 16 - fe * 2 - Fe * 2,
        // sar is sample aspect ratio
        sarRatio: Et
      };
    };
  }, lc.prototype = new Hp();
  var eT = {
    H264Stream: lc
  }, tT = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], jp = function(u, m) {
    var y = u[m + 6] << 21 | u[m + 7] << 14 | u[m + 8] << 7 | u[m + 9], v = u[m + 5], T = (v & 16) >> 4;
    return y = y >= 0 ? y : 0, T ? y + 20 : y + 10;
  }, Vp = function(u, m) {
    return u.length - m < 10 || u[m] !== 73 || u[m + 1] !== 68 || u[m + 2] !== 51 ? m : (m += jp(u, m), Vp(u, m));
  }, nT = function(u) {
    var m = Vp(u, 0);
    return u.length >= m + 2 && (u[m] & 255) === 255 && (u[m + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (u[m + 1] & 22) === 16;
  }, qp = function(u) {
    return u[0] << 21 | u[1] << 14 | u[2] << 7 | u[3];
  }, aT = function(u, m, y) {
    var v, T = "";
    for (v = m; v < y; v++)
      T += "%" + ("00" + u[v].toString(16)).slice(-2);
    return T;
  }, iT = function(u, m, y) {
    return unescape(aT(u, m, y));
  }, rT = function(u, m) {
    var y = (u[m + 5] & 224) >> 5, v = u[m + 4] << 3, T = u[m + 3] & 6144;
    return T | v | y;
  }, sT = function(u, m) {
    return u[m] === 73 && u[m + 1] === 68 && u[m + 2] === 51 ? "timed-metadata" : u[m] & !0 && (u[m + 1] & 240) === 240 ? "audio" : null;
  }, oT = function(u) {
    for (var m = 0; m + 5 < u.length; ) {
      if (u[m] !== 255 || (u[m + 1] & 246) !== 240) {
        m++;
        continue;
      }
      return tT[(u[m + 2] & 60) >>> 2];
    }
    return null;
  }, lT = function(u) {
    var m, y, v, T;
    m = 10, u[5] & 64 && (m += 4, m += qp(u.subarray(10, 14)));
    do {
      if (y = qp(u.subarray(m + 4, m + 8)), y < 1)
        return null;
      if (T = String.fromCharCode(u[m], u[m + 1], u[m + 2], u[m + 3]), T === "PRIV") {
        v = u.subarray(m + 10, m + y + 10);
        for (var S = 0; S < v.byteLength; S++)
          if (v[S] === 0) {
            var N = iT(v, 0, S);
            if (N === "com.apple.streaming.transportStreamTimestamp") {
              var F = v.subarray(S + 1), U = (F[3] & 1) << 30 | F[4] << 22 | F[5] << 14 | F[6] << 6 | F[7] >>> 2;
              return U *= 4, U += F[7] & 3, U;
            }
            break;
          }
      }
      m += 10, m += y;
    } while (m < u.byteLength);
    return null;
  }, $d = {
    isLikelyAacData: nT,
    parseId3TagSize: jp,
    parseAdtsSize: rT,
    parseType: sT,
    parseSampleRate: oT,
    parseAacTimestamp: lT
  }, cT = n, Wp = $d, uc;
  uc = function() {
    var u = new Uint8Array(), m = 0;
    uc.prototype.init.call(this), this.setTimestamp = function(y) {
      m = y;
    }, this.push = function(y) {
      var v = 0, T = 0, S, N, F, U;
      for (u.length ? (U = u.length, u = new Uint8Array(y.byteLength + U), u.set(u.subarray(0, U)), u.set(y, U)) : u = y; u.length - T >= 3; ) {
        if (u[T] === 73 && u[T + 1] === 68 && u[T + 2] === 51) {
          if (u.length - T < 10 || (v = Wp.parseId3TagSize(u, T), T + v > u.length))
            break;
          N = {
            type: "timed-metadata",
            data: u.subarray(T, T + v)
          }, this.trigger("data", N), T += v;
          continue;
        } else if ((u[T] & 255) === 255 && (u[T + 1] & 240) === 240) {
          if (u.length - T < 7 || (v = Wp.parseAdtsSize(u, T), T + v > u.length))
            break;
          F = {
            type: "audio",
            data: u.subarray(T, T + v),
            pts: m,
            dts: m
          }, this.trigger("data", F), T += v;
          continue;
        }
        T++;
      }
      S = u.length - T, S > 0 ? u = u.subarray(T) : u = new Uint8Array();
    }, this.reset = function() {
      u = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      u = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, uc.prototype = new cT();
  var uT = uc, dT = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], hT = dT, fT = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], pT = fT, dc = n, wo = ee, ko = tt, hc = Be, ka = Wr, hi = Gx, fc = bt, Gp = Kx, mT = eT.H264Stream, gT = uT, bT = $d.isLikelyAacData, vT = bt.ONE_SECOND_IN_TS, Xp = hT, Zp = pT, pc, So, mc, dr, yT = function(u, m) {
    m.stream = u, this.trigger("log", m);
  }, Kp = function(u, m) {
    for (var y = Object.keys(m), v = 0; v < y.length; v++) {
      var T = y[v];
      T === "headOfPipeline" || !m[T].on || m[T].on("log", yT.bind(u, T));
    }
  }, Qp = function(u, m) {
    var y;
    if (u.length !== m.length)
      return !1;
    for (y = 0; y < u.length; y++)
      if (u[y] !== m[y])
        return !1;
    return !0;
  }, Jp = function(u, m, y, v, T, S) {
    var N = y - m, F = v - m, U = T - y;
    return {
      start: {
        dts: u,
        pts: u + N
      },
      end: {
        dts: u + F,
        pts: u + U
      },
      prependedContentDuration: S,
      baseMediaDecodeTime: u
    };
  };
  So = function(u, m) {
    var y = [], v, T = 0, S = 0, N = 1 / 0;
    m = m || {}, v = m.firstSequenceNumber || 0, So.prototype.init.call(this), this.push = function(F) {
      ka.collectDtsInfo(u, F), u && Xp.forEach(function(U) {
        u[U] = F[U];
      }), y.push(F);
    }, this.setEarliestDts = function(F) {
      T = F;
    }, this.setVideoBaseMediaDecodeTime = function(F) {
      N = F;
    }, this.setAudioAppendStart = function(F) {
      S = F;
    }, this.flush = function() {
      var F, U, j, ne, fe, Fe, ke;
      if (y.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      F = hc.trimAdtsFramesByEarliestDts(y, u, T), u.baseMediaDecodeTime = ka.calculateTrackBaseMediaDecodeTime(u, m.keepOriginalTimestamps), ke = hc.prefixWithSilence(u, F, S, N), u.samples = hc.generateSampleTable(F), j = wo.mdat(hc.concatenateFrameData(F)), y = [], U = wo.moof(v, [u]), ne = new Uint8Array(U.byteLength + j.byteLength), v++, ne.set(U), ne.set(j, U.byteLength), ka.clearDtsInfo(u), fe = Math.ceil(vT * 1024 / u.samplerate), F.length && (Fe = F.length * fe, this.trigger("segmentTimingInfo", Jp(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        fc.audioTsToVideoTs(u.baseMediaDecodeTime, u.samplerate),
        // frame times are already in video clock, as is segment duration
        F[0].dts,
        F[0].pts,
        F[0].dts + Fe,
        F[0].pts + Fe,
        ke || 0
      )), this.trigger("timingInfo", {
        start: F[0].pts,
        end: F[0].pts + Fe
      })), this.trigger("data", {
        track: u,
        boxes: ne
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      ka.clearDtsInfo(u), y = [], this.trigger("reset");
    };
  }, So.prototype = new dc(), pc = function(u, m) {
    var y, v = [], T = [], S, N;
    m = m || {}, y = m.firstSequenceNumber || 0, pc.prototype.init.call(this), delete u.minPTS, this.gopCache_ = [], this.push = function(F) {
      ka.collectDtsInfo(u, F), F.nalUnitType === "seq_parameter_set_rbsp" && !S && (S = F.config, u.sps = [F.data], Zp.forEach(function(U) {
        u[U] = S[U];
      }, this)), F.nalUnitType === "pic_parameter_set_rbsp" && !N && (N = F.data, u.pps = [F.data]), v.push(F);
    }, this.flush = function() {
      for (var F, U, j, ne, fe, Fe, ke = 0, Xe, st; v.length && v[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        v.shift();
      if (v.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (F = ko.groupNalsIntoFrames(v), j = ko.groupFramesIntoGops(F), j[0][0].keyFrame || (U = this.getGopForFusion_(v[0], u), U ? (ke = U.duration, j.unshift(U), j.byteLength += U.byteLength, j.nalCount += U.nalCount, j.pts = U.pts, j.dts = U.dts, j.duration += U.duration) : j = ko.extendFirstKeyFrame(j)), T.length) {
        var fn;
        if (m.alignGopsAtEnd ? fn = this.alignGopsAtEnd_(j) : fn = this.alignGopsAtStart_(j), !fn) {
          this.gopCache_.unshift({
            gop: j.pop(),
            pps: u.pps,
            sps: u.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), v = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        ka.clearDtsInfo(u), j = fn;
      }
      ka.collectDtsInfo(u, j), u.samples = ko.generateSampleTable(j), fe = wo.mdat(ko.concatenateNalData(j)), u.baseMediaDecodeTime = ka.calculateTrackBaseMediaDecodeTime(u, m.keepOriginalTimestamps), this.trigger("processedGopsInfo", j.map(function(aa) {
        return {
          pts: aa.pts,
          dts: aa.dts,
          byteLength: aa.byteLength
        };
      })), Xe = j[0], st = j[j.length - 1], this.trigger("segmentTimingInfo", Jp(u.baseMediaDecodeTime, Xe.dts, Xe.pts, st.dts + st.duration, st.pts + st.duration, ke)), this.trigger("timingInfo", {
        start: j[0].pts,
        end: j[j.length - 1].pts + j[j.length - 1].duration
      }), this.gopCache_.unshift({
        gop: j.pop(),
        pps: u.pps,
        sps: u.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), v = [], this.trigger("baseMediaDecodeTime", u.baseMediaDecodeTime), this.trigger("timelineStartInfo", u.timelineStartInfo), ne = wo.moof(y, [u]), Fe = new Uint8Array(ne.byteLength + fe.byteLength), y++, Fe.set(ne), Fe.set(fe, ne.byteLength), this.trigger("data", {
        track: u,
        boxes: Fe
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), v = [], this.gopCache_.length = 0, T.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      ka.clearDtsInfo(u), S = void 0, N = void 0;
    }, this.getGopForFusion_ = function(F) {
      var U = 45e3, j = 1 / 0, ne, fe, Fe, ke, Xe;
      for (Xe = 0; Xe < this.gopCache_.length; Xe++)
        ke = this.gopCache_[Xe], Fe = ke.gop, !(!(u.pps && Qp(u.pps[0], ke.pps[0])) || !(u.sps && Qp(u.sps[0], ke.sps[0]))) && (Fe.dts < u.timelineStartInfo.dts || (ne = F.dts - Fe.dts - Fe.duration, ne >= -1e4 && ne <= U && (!fe || j > ne) && (fe = ke, j = ne)));
      return fe ? fe.gop : null;
    }, this.alignGopsAtStart_ = function(F) {
      var U, j, ne, fe, Fe, ke, Xe, st;
      for (Fe = F.byteLength, ke = F.nalCount, Xe = F.duration, U = j = 0; U < T.length && j < F.length && (ne = T[U], fe = F[j], ne.pts !== fe.pts); ) {
        if (fe.pts > ne.pts) {
          U++;
          continue;
        }
        j++, Fe -= fe.byteLength, ke -= fe.nalCount, Xe -= fe.duration;
      }
      return j === 0 ? F : j === F.length ? null : (st = F.slice(j), st.byteLength = Fe, st.duration = Xe, st.nalCount = ke, st.pts = st[0].pts, st.dts = st[0].dts, st);
    }, this.alignGopsAtEnd_ = function(F) {
      var U, j, ne, fe, Fe, ke;
      for (U = T.length - 1, j = F.length - 1, Fe = null, ke = !1; U >= 0 && j >= 0; ) {
        if (ne = T[U], fe = F[j], ne.pts === fe.pts) {
          ke = !0;
          break;
        }
        if (ne.pts > fe.pts) {
          U--;
          continue;
        }
        U === T.length - 1 && (Fe = j), j--;
      }
      if (!ke && Fe === null)
        return null;
      var Xe;
      if (ke ? Xe = j : Xe = Fe, Xe === 0)
        return F;
      var st = F.slice(Xe), fn = st.reduce(function(aa, Pi) {
        return aa.byteLength += Pi.byteLength, aa.duration += Pi.duration, aa.nalCount += Pi.nalCount, aa;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return st.byteLength = fn.byteLength, st.duration = fn.duration, st.nalCount = fn.nalCount, st.pts = st[0].pts, st.dts = st[0].dts, st;
    }, this.alignGopsWith = function(F) {
      T = F;
    };
  }, pc.prototype = new dc(), dr = function(u, m) {
    this.numberOfTracks = 0, this.metadataStream = m, u = u || {}, typeof u.remux < "u" ? this.remuxTracks = !!u.remux : this.remuxTracks = !0, typeof u.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = u.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, dr.prototype.init.call(this), this.push = function(y) {
      if (y.content || y.text)
        return this.pendingCaptions.push(y);
      if (y.frames)
        return this.pendingMetadata.push(y);
      this.pendingTracks.push(y.track), this.pendingBytes += y.boxes.byteLength, y.track.type === "video" && (this.videoTrack = y.track, this.pendingBoxes.push(y.boxes)), y.track.type === "audio" && (this.audioTrack = y.track, this.pendingBoxes.unshift(y.boxes));
    };
  }, dr.prototype = new dc(), dr.prototype.flush = function(u) {
    var m = 0, y = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, v, T, S, N = 0, F;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (u !== "VideoSegmentStream" && u !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (N = this.videoTrack.timelineStartInfo.pts, Zp.forEach(function(U) {
      y.info[U] = this.videoTrack[U];
    }, this)) : this.audioTrack && (N = this.audioTrack.timelineStartInfo.pts, Xp.forEach(function(U) {
      y.info[U] = this.audioTrack[U];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? y.type = this.pendingTracks[0].type : y.type = "combined", this.emittedTracks += this.pendingTracks.length, S = wo.initSegment(this.pendingTracks), y.initSegment = new Uint8Array(S.byteLength), y.initSegment.set(S), y.data = new Uint8Array(this.pendingBytes), F = 0; F < this.pendingBoxes.length; F++)
        y.data.set(this.pendingBoxes[F], m), m += this.pendingBoxes[F].byteLength;
      for (F = 0; F < this.pendingCaptions.length; F++)
        v = this.pendingCaptions[F], v.startTime = fc.metadataTsToSeconds(v.startPts, N, this.keepOriginalTimestamps), v.endTime = fc.metadataTsToSeconds(v.endPts, N, this.keepOriginalTimestamps), y.captionStreams[v.stream] = !0, y.captions.push(v);
      for (F = 0; F < this.pendingMetadata.length; F++)
        T = this.pendingMetadata[F], T.cueTime = fc.metadataTsToSeconds(T.pts, N, this.keepOriginalTimestamps), y.metadata.push(T);
      for (y.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", y), F = 0; F < y.captions.length; F++)
        v = y.captions[F], this.trigger("caption", v);
      for (F = 0; F < y.metadata.length; F++)
        T = y.metadata[F], this.trigger("id3Frame", T);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, dr.prototype.setRemux = function(u) {
    this.remuxTracks = u;
  }, mc = function(u) {
    var m = this, y = !0, v, T;
    mc.prototype.init.call(this), u = u || {}, this.baseMediaDecodeTime = u.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var S = {};
      this.transmuxPipeline_ = S, S.type = "aac", S.metadataStream = new hi.MetadataStream(), S.aacStream = new gT(), S.audioTimestampRolloverStream = new hi.TimestampRolloverStream("audio"), S.timedMetadataTimestampRolloverStream = new hi.TimestampRolloverStream("timed-metadata"), S.adtsStream = new Gp(), S.coalesceStream = new dr(u, S.metadataStream), S.headOfPipeline = S.aacStream, S.aacStream.pipe(S.audioTimestampRolloverStream).pipe(S.adtsStream), S.aacStream.pipe(S.timedMetadataTimestampRolloverStream).pipe(S.metadataStream).pipe(S.coalesceStream), S.metadataStream.on("timestamp", function(N) {
        S.aacStream.setTimestamp(N.timeStamp);
      }), S.aacStream.on("data", function(N) {
        N.type !== "timed-metadata" && N.type !== "audio" || S.audioSegmentStream || (T = T || {
          timelineStartInfo: {
            baseMediaDecodeTime: m.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, S.coalesceStream.numberOfTracks++, S.audioSegmentStream = new So(T, u), S.audioSegmentStream.on("log", m.getLogTrigger_("audioSegmentStream")), S.audioSegmentStream.on("timingInfo", m.trigger.bind(m, "audioTimingInfo")), S.adtsStream.pipe(S.audioSegmentStream).pipe(S.coalesceStream), m.trigger("trackinfo", {
          hasAudio: !!T,
          hasVideo: !!v
        }));
      }), S.coalesceStream.on("data", this.trigger.bind(this, "data")), S.coalesceStream.on("done", this.trigger.bind(this, "done")), Kp(this, S);
    }, this.setupTsPipeline = function() {
      var S = {};
      this.transmuxPipeline_ = S, S.type = "ts", S.metadataStream = new hi.MetadataStream(), S.packetStream = new hi.TransportPacketStream(), S.parseStream = new hi.TransportParseStream(), S.elementaryStream = new hi.ElementaryStream(), S.timestampRolloverStream = new hi.TimestampRolloverStream(), S.adtsStream = new Gp(), S.h264Stream = new mT(), S.captionStream = new hi.CaptionStream(u), S.coalesceStream = new dr(u, S.metadataStream), S.headOfPipeline = S.packetStream, S.packetStream.pipe(S.parseStream).pipe(S.elementaryStream).pipe(S.timestampRolloverStream), S.timestampRolloverStream.pipe(S.h264Stream), S.timestampRolloverStream.pipe(S.adtsStream), S.timestampRolloverStream.pipe(S.metadataStream).pipe(S.coalesceStream), S.h264Stream.pipe(S.captionStream).pipe(S.coalesceStream), S.elementaryStream.on("data", function(N) {
        var F;
        if (N.type === "metadata") {
          for (F = N.tracks.length; F--; )
            !v && N.tracks[F].type === "video" ? (v = N.tracks[F], v.timelineStartInfo.baseMediaDecodeTime = m.baseMediaDecodeTime) : !T && N.tracks[F].type === "audio" && (T = N.tracks[F], T.timelineStartInfo.baseMediaDecodeTime = m.baseMediaDecodeTime);
          v && !S.videoSegmentStream && (S.coalesceStream.numberOfTracks++, S.videoSegmentStream = new pc(v, u), S.videoSegmentStream.on("log", m.getLogTrigger_("videoSegmentStream")), S.videoSegmentStream.on("timelineStartInfo", function(U) {
            T && !u.keepOriginalTimestamps && (T.timelineStartInfo = U, S.audioSegmentStream.setEarliestDts(U.dts - m.baseMediaDecodeTime));
          }), S.videoSegmentStream.on("processedGopsInfo", m.trigger.bind(m, "gopInfo")), S.videoSegmentStream.on("segmentTimingInfo", m.trigger.bind(m, "videoSegmentTimingInfo")), S.videoSegmentStream.on("baseMediaDecodeTime", function(U) {
            T && S.audioSegmentStream.setVideoBaseMediaDecodeTime(U);
          }), S.videoSegmentStream.on("timingInfo", m.trigger.bind(m, "videoTimingInfo")), S.h264Stream.pipe(S.videoSegmentStream).pipe(S.coalesceStream)), T && !S.audioSegmentStream && (S.coalesceStream.numberOfTracks++, S.audioSegmentStream = new So(T, u), S.audioSegmentStream.on("log", m.getLogTrigger_("audioSegmentStream")), S.audioSegmentStream.on("timingInfo", m.trigger.bind(m, "audioTimingInfo")), S.audioSegmentStream.on("segmentTimingInfo", m.trigger.bind(m, "audioSegmentTimingInfo")), S.adtsStream.pipe(S.audioSegmentStream).pipe(S.coalesceStream)), m.trigger("trackinfo", {
            hasAudio: !!T,
            hasVideo: !!v
          });
        }
      }), S.coalesceStream.on("data", this.trigger.bind(this, "data")), S.coalesceStream.on("id3Frame", function(N) {
        N.dispatchType = S.metadataStream.dispatchType, m.trigger("id3Frame", N);
      }), S.coalesceStream.on("caption", this.trigger.bind(this, "caption")), S.coalesceStream.on("done", this.trigger.bind(this, "done")), Kp(this, S);
    }, this.setBaseMediaDecodeTime = function(S) {
      var N = this.transmuxPipeline_;
      u.keepOriginalTimestamps || (this.baseMediaDecodeTime = S), T && (T.timelineStartInfo.dts = void 0, T.timelineStartInfo.pts = void 0, ka.clearDtsInfo(T), N.audioTimestampRolloverStream && N.audioTimestampRolloverStream.discontinuity()), v && (N.videoSegmentStream && (N.videoSegmentStream.gopCache_ = []), v.timelineStartInfo.dts = void 0, v.timelineStartInfo.pts = void 0, ka.clearDtsInfo(v), N.captionStream.reset()), N.timestampRolloverStream && N.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(S) {
      T && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(S);
    }, this.setRemux = function(S) {
      var N = this.transmuxPipeline_;
      u.remux = S, N && N.coalesceStream && N.coalesceStream.setRemux(S);
    }, this.alignGopsWith = function(S) {
      v && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(S);
    }, this.getLogTrigger_ = function(S) {
      var N = this;
      return function(F) {
        F.stream = S, N.trigger("log", F);
      };
    }, this.push = function(S) {
      if (y) {
        var N = bT(S);
        N && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !N && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), y = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(S);
    }, this.flush = function() {
      y = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, mc.prototype = new dc();
  var _T = {
    Transmuxer: mc
  }, xT = function(u) {
    return u >>> 0;
  }, TT = function(u) {
    return ("00" + u.toString(16)).slice(-2);
  }, gc = {
    toUnsigned: xT,
    toHexString: TT
  }, wT = function(u) {
    var m = "";
    return m += String.fromCharCode(u[0]), m += String.fromCharCode(u[1]), m += String.fromCharCode(u[2]), m += String.fromCharCode(u[3]), m;
  }, em = wT, kT = gc.toUnsigned, ST = em, tm = function(u, m) {
    var y = [], v, T, S, N, F;
    if (!m.length)
      return null;
    for (v = 0; v < u.byteLength; )
      T = kT(u[v] << 24 | u[v + 1] << 16 | u[v + 2] << 8 | u[v + 3]), S = ST(u.subarray(v + 4, v + 8)), N = T > 1 ? v + T : u.byteLength, S === m[0] && (m.length === 1 ? y.push(u.subarray(v + 8, N)) : (F = tm(u.subarray(v + 8, N), m.slice(1)), F.length && (y = y.concat(F)))), v = N;
    return y;
  }, Fd = tm, CT = gc.toUnsigned, AT = r.getUint64, ET = function(u) {
    var m = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4))
    };
    return m.version === 1 ? m.baseMediaDecodeTime = AT(u.subarray(4)) : m.baseMediaDecodeTime = CT(u[4] << 24 | u[5] << 16 | u[6] << 8 | u[7]), m;
  }, zd = ET, LT = function(u) {
    var m = new DataView(u.buffer, u.byteOffset, u.byteLength), y = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4)),
      trackId: m.getUint32(4)
    }, v = y.flags[2] & 1, T = y.flags[2] & 2, S = y.flags[2] & 8, N = y.flags[2] & 16, F = y.flags[2] & 32, U = y.flags[0] & 65536, j = y.flags[0] & 131072, ne;
    return ne = 8, v && (ne += 4, y.baseDataOffset = m.getUint32(12), ne += 4), T && (y.sampleDescriptionIndex = m.getUint32(ne), ne += 4), S && (y.defaultSampleDuration = m.getUint32(ne), ne += 4), N && (y.defaultSampleSize = m.getUint32(ne), ne += 4), F && (y.defaultSampleFlags = m.getUint32(ne)), U && (y.durationIsEmpty = !0), !v && j && (y.baseDataOffsetIsMoof = !0), y;
  }, nm = LT, DT = function(u) {
    return {
      isLeading: (u[0] & 12) >>> 2,
      dependsOn: u[0] & 3,
      isDependedOn: (u[1] & 192) >>> 6,
      hasRedundancy: (u[1] & 48) >>> 4,
      paddingValue: (u[1] & 14) >>> 1,
      isNonSyncSample: u[1] & 1,
      degradationPriority: u[2] << 8 | u[3]
    };
  }, IT = DT, am = IT, MT = function(u) {
    var m = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4)),
      samples: []
    }, y = new DataView(u.buffer, u.byteOffset, u.byteLength), v = m.flags[2] & 1, T = m.flags[2] & 4, S = m.flags[1] & 1, N = m.flags[1] & 2, F = m.flags[1] & 4, U = m.flags[1] & 8, j = y.getUint32(4), ne = 8, fe;
    for (v && (m.dataOffset = y.getInt32(ne), ne += 4), T && j && (fe = {
      flags: am(u.subarray(ne, ne + 4))
    }, ne += 4, S && (fe.duration = y.getUint32(ne), ne += 4), N && (fe.size = y.getUint32(ne), ne += 4), U && (m.version === 1 ? fe.compositionTimeOffset = y.getInt32(ne) : fe.compositionTimeOffset = y.getUint32(ne), ne += 4), m.samples.push(fe), j--); j--; )
      fe = {}, S && (fe.duration = y.getUint32(ne), ne += 4), N && (fe.size = y.getUint32(ne), ne += 4), F && (fe.flags = am(u.subarray(ne, ne + 4)), ne += 4), U && (m.version === 1 ? fe.compositionTimeOffset = y.getInt32(ne) : fe.compositionTimeOffset = y.getUint32(ne), ne += 4), m.samples.push(fe);
    return m;
  }, im = MT, rm = {
    tfdt: zd,
    trun: im
  }, sm = {
    parseTfdt: rm.tfdt,
    parseTrun: rm.trun
  }, OT = function(u) {
    for (var m = 0, y = String.fromCharCode(u[m]), v = ""; y !== "\0"; )
      v += y, m++, y = String.fromCharCode(u[m]);
    return v += y, v;
  }, PT = {
    uint8ToCString: OT
  }, bc = PT.uint8ToCString, BT = r.getUint64, RT = function(u) {
    var m = 4, y = u[0], v, T, S, N, F, U, j, ne;
    if (y === 0) {
      v = bc(u.subarray(m)), m += v.length, T = bc(u.subarray(m)), m += T.length;
      var fe = new DataView(u.buffer);
      S = fe.getUint32(m), m += 4, F = fe.getUint32(m), m += 4, U = fe.getUint32(m), m += 4, j = fe.getUint32(m), m += 4;
    } else if (y === 1) {
      var fe = new DataView(u.buffer);
      S = fe.getUint32(m), m += 4, N = BT(u.subarray(m)), m += 8, U = fe.getUint32(m), m += 4, j = fe.getUint32(m), m += 4, v = bc(u.subarray(m)), m += v.length, T = bc(u.subarray(m)), m += T.length;
    }
    ne = new Uint8Array(u.subarray(m, u.byteLength));
    var Fe = {
      scheme_id_uri: v,
      value: T,
      // if timescale is undefined or 0 set to 1 
      timescale: S || 1,
      presentation_time: N,
      presentation_time_delta: F,
      event_duration: U,
      id: j,
      message_data: ne
    };
    return $T(y, Fe) ? Fe : void 0;
  }, NT = function(u, m, y, v) {
    return u || u === 0 ? u / m : v + y / m;
  }, $T = function(u, m) {
    var y = m.scheme_id_uri !== "\0", v = u === 0 && om(m.presentation_time_delta) && y, T = u === 1 && om(m.presentation_time) && y;
    return !(u > 1) && v || T;
  }, om = function(u) {
    return u !== void 0 || u !== null;
  }, FT = {
    parseEmsgBox: RT,
    scaleTime: NT
  }, Co;
  typeof window < "u" ? Co = window : typeof t < "u" ? Co = t : typeof self < "u" ? Co = self : Co = {};
  var lm = Co, vc = gc.toUnsigned, Ao = gc.toHexString, Gt = Fd, Xr = em, Ud = FT, zT = nm, UT = im, HT = zd, YT = r.getUint64, cm, um, dm, hm, fm, Hd, pm, Yd = lm, jT = $p.parseId3Frames;
  cm = function(u) {
    var m = {}, y = Gt(u, ["moov", "trak"]);
    return y.reduce(function(v, T) {
      var S, N, F, U, j;
      return S = Gt(T, ["tkhd"])[0], !S || (N = S[0], F = N === 0 ? 12 : 20, U = vc(S[F] << 24 | S[F + 1] << 16 | S[F + 2] << 8 | S[F + 3]), j = Gt(T, ["mdia", "mdhd"])[0], !j) ? null : (N = j[0], F = N === 0 ? 12 : 20, v[U] = vc(j[F] << 24 | j[F + 1] << 16 | j[F + 2] << 8 | j[F + 3]), v);
    }, m);
  }, um = function(u, m) {
    var y;
    y = Gt(m, ["moof", "traf"]);
    var v = y.reduce(function(T, S) {
      var N = Gt(S, ["tfhd"])[0], F = vc(N[4] << 24 | N[5] << 16 | N[6] << 8 | N[7]), U = u[F] || 9e4, j = Gt(S, ["tfdt"])[0], ne = new DataView(j.buffer, j.byteOffset, j.byteLength), fe;
      j[0] === 1 ? fe = YT(j.subarray(4, 12)) : fe = ne.getUint32(4);
      let Fe;
      return typeof fe == "bigint" ? Fe = fe / Yd.BigInt(U) : typeof fe == "number" && !isNaN(fe) && (Fe = fe / U), Fe < Number.MAX_SAFE_INTEGER && (Fe = Number(Fe)), Fe < T && (T = Fe), T;
    }, 1 / 0);
    return typeof v == "bigint" || isFinite(v) ? v : 0;
  }, dm = function(u, m) {
    var y = Gt(m, ["moof", "traf"]), v = 0, T = 0, S;
    if (y && y.length) {
      var N = Gt(y[0], ["tfhd"])[0], F = Gt(y[0], ["trun"])[0], U = Gt(y[0], ["tfdt"])[0];
      if (N) {
        var j = zT(N);
        S = j.trackId;
      }
      if (U) {
        var ne = HT(U);
        v = ne.baseMediaDecodeTime;
      }
      if (F) {
        var fe = UT(F);
        fe.samples && fe.samples.length && (T = fe.samples[0].compositionTimeOffset || 0);
      }
    }
    var Fe = u[S] || 9e4;
    typeof v == "bigint" && (T = Yd.BigInt(T), Fe = Yd.BigInt(Fe));
    var ke = (v + T) / Fe;
    return typeof ke == "bigint" && ke < Number.MAX_SAFE_INTEGER && (ke = Number(ke)), ke;
  }, hm = function(u) {
    var m = Gt(u, ["moov", "trak"]), y = [];
    return m.forEach(function(v) {
      var T = Gt(v, ["mdia", "hdlr"]), S = Gt(v, ["tkhd"]);
      T.forEach(function(N, F) {
        var U = Xr(N.subarray(8, 12)), j = S[F], ne, fe, Fe;
        U === "vide" && (ne = new DataView(j.buffer, j.byteOffset, j.byteLength), fe = ne.getUint8(0), Fe = fe === 0 ? ne.getUint32(12) : ne.getUint32(20), y.push(Fe));
      });
    }), y;
  }, Hd = function(u) {
    var m = u[0], y = m === 0 ? 12 : 20;
    return vc(u[y] << 24 | u[y + 1] << 16 | u[y + 2] << 8 | u[y + 3]);
  }, fm = function(u) {
    var m = Gt(u, ["moov", "trak"]), y = [];
    return m.forEach(function(v) {
      var T = {}, S = Gt(v, ["tkhd"])[0], N, F;
      S && (N = new DataView(S.buffer, S.byteOffset, S.byteLength), F = N.getUint8(0), T.id = F === 0 ? N.getUint32(12) : N.getUint32(20));
      var U = Gt(v, ["mdia", "hdlr"])[0];
      if (U) {
        var j = Xr(U.subarray(8, 12));
        j === "vide" ? T.type = "video" : j === "soun" ? T.type = "audio" : T.type = j;
      }
      var ne = Gt(v, ["mdia", "minf", "stbl", "stsd"])[0];
      if (ne) {
        var fe = ne.subarray(8);
        T.codec = Xr(fe.subarray(4, 8));
        var Fe = Gt(fe, [T.codec])[0], ke, Xe;
        Fe && (/^[asm]vc[1-9]$/i.test(T.codec) ? (ke = Fe.subarray(78), Xe = Xr(ke.subarray(4, 8)), Xe === "avcC" && ke.length > 11 ? (T.codec += ".", T.codec += Ao(ke[9]), T.codec += Ao(ke[10]), T.codec += Ao(ke[11])) : T.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(T.codec) ? (ke = Fe.subarray(28), Xe = Xr(ke.subarray(4, 8)), Xe === "esds" && ke.length > 20 && ke[19] !== 0 ? (T.codec += "." + Ao(ke[19]), T.codec += "." + Ao(ke[20] >>> 2 & 63).replace(/^0/, "")) : T.codec = "mp4a.40.2") : T.codec = T.codec.toLowerCase());
      }
      var st = Gt(v, ["mdia", "mdhd"])[0];
      st && (T.timescale = Hd(st)), y.push(T);
    }), y;
  }, pm = function(u, m = 0) {
    var y = Gt(u, ["emsg"]);
    return y.map((v) => {
      var T = Ud.parseEmsgBox(new Uint8Array(v)), S = jT(T.message_data);
      return {
        cueTime: Ud.scaleTime(T.presentation_time, T.timescale, T.presentation_time_delta, m),
        duration: Ud.scaleTime(T.event_duration, T.timescale),
        frames: S
      };
    });
  };
  var Eo = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: Gt,
    parseType: Xr,
    timescale: cm,
    startTime: um,
    compositionStartTime: dm,
    videoTrackIds: hm,
    tracks: fm,
    getTimescaleFromMediaHeader: Hd,
    getEmsgID3: pm
  };
  const {
    parseTrun: VT
  } = sm, {
    findBox: mm
  } = Eo;
  var gm = lm, qT = function(u) {
    var m = mm(u, ["moof", "traf"]), y = mm(u, ["mdat"]), v = [];
    return y.forEach(function(T, S) {
      var N = m[S];
      v.push({
        mdat: T,
        traf: N
      });
    }), v;
  }, WT = function(u, m, y) {
    var v = m, T = y.defaultSampleDuration || 0, S = y.defaultSampleSize || 0, N = y.trackId, F = [];
    return u.forEach(function(U) {
      var j = VT(U), ne = j.samples;
      ne.forEach(function(fe) {
        fe.duration === void 0 && (fe.duration = T), fe.size === void 0 && (fe.size = S), fe.trackId = N, fe.dts = v, fe.compositionTimeOffset === void 0 && (fe.compositionTimeOffset = 0), typeof v == "bigint" ? (fe.pts = v + gm.BigInt(fe.compositionTimeOffset), v += gm.BigInt(fe.duration)) : (fe.pts = v + fe.compositionTimeOffset, v += fe.duration);
      }), F = F.concat(ne);
    }), F;
  }, bm = {
    getMdatTrafPairs: qT,
    parseSamples: WT
  }, GT = Op.discardEmulationPreventionBytes, XT = Pp.CaptionStream, jd = Fd, ZT = zd, KT = nm, {
    getMdatTrafPairs: QT,
    parseSamples: JT
  } = bm, e4 = function(u, m) {
    for (var y = u, v = 0; v < m.length; v++) {
      var T = m[v];
      if (y < T.size)
        return T;
      y -= T.size;
    }
    return null;
  }, t4 = function(u, m, y) {
    var v = new DataView(u.buffer, u.byteOffset, u.byteLength), T = {
      logs: [],
      seiNals: []
    }, S, N, F, U;
    for (N = 0; N + 4 < u.length; N += F)
      if (F = v.getUint32(N), N += 4, !(F <= 0))
        switch (u[N] & 31) {
          case 6:
            var j = u.subarray(N + 1, N + 1 + F), ne = e4(N, m);
            if (S = {
              nalUnitType: "sei_rbsp",
              size: F,
              data: j,
              escapedRBSP: GT(j),
              trackId: y
            }, ne)
              S.pts = ne.pts, S.dts = ne.dts, U = ne;
            else if (U)
              S.pts = U.pts, S.dts = U.dts;
            else {
              T.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + N + " for trackId " + y + ". See mux.js#223."
              });
              break;
            }
            T.seiNals.push(S);
            break;
        }
    return T;
  }, n4 = function(u, m) {
    var y = {}, v = QT(u);
    return v.forEach(function(T) {
      var S = T.mdat, N = T.traf, F = jd(N, ["tfhd"]), U = KT(F[0]), j = U.trackId, ne = jd(N, ["tfdt"]), fe = ne.length > 0 ? ZT(ne[0]).baseMediaDecodeTime : 0, Fe = jd(N, ["trun"]), ke, Xe;
      m === j && Fe.length > 0 && (ke = JT(Fe, fe, U), Xe = t4(S, ke, j), y[j] || (y[j] = {
        seiNals: [],
        logs: []
      }), y[j].seiNals = y[j].seiNals.concat(Xe.seiNals), y[j].logs = y[j].logs.concat(Xe.logs));
    }), y;
  }, a4 = function(u, m, y) {
    var v;
    if (m === null)
      return null;
    v = n4(u, m);
    var T = v[m] || {};
    return {
      seiNals: T.seiNals,
      logs: T.logs,
      timescale: y
    };
  }, i4 = function() {
    var u = !1, m, y, v, T, S, N;
    this.isInitialized = function() {
      return u;
    }, this.init = function(F) {
      m = new XT(), u = !0, N = F ? F.isPartial : !1, m.on("data", function(U) {
        U.startTime = U.startPts / T, U.endTime = U.endPts / T, S.captions.push(U), S.captionStreams[U.stream] = !0;
      }), m.on("log", function(U) {
        S.logs.push(U);
      });
    }, this.isNewInit = function(F, U) {
      return F && F.length === 0 || U && typeof U == "object" && Object.keys(U).length === 0 ? !1 : v !== F[0] || T !== U[v];
    }, this.parse = function(F, U, j) {
      var ne;
      if (this.isInitialized()) {
        if (!U || !j)
          return null;
        if (this.isNewInit(U, j))
          v = U[0], T = j[v];
        else if (v === null || !T)
          return y.push(F), null;
      } else return null;
      for (; y.length > 0; ) {
        var fe = y.shift();
        this.parse(fe, U, j);
      }
      return ne = a4(F, v, T), ne && ne.logs && (S.logs = S.logs.concat(ne.logs)), ne === null || !ne.seiNals ? S.logs.length ? {
        logs: S.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(ne.seiNals), this.flushStream(), S);
    }, this.pushNals = function(F) {
      if (!this.isInitialized() || !F || F.length === 0)
        return null;
      F.forEach(function(U) {
        m.push(U);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      N ? m.partialFlush() : m.flush();
    }, this.clearParsedCaptions = function() {
      S.captions = [], S.captionStreams = {}, S.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      m.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      y = [], v = null, T = null, S ? this.clearParsedCaptions() : S = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, r4 = i4;
  const {
    parseTfdt: s4
  } = sm, Oi = Fd, {
    getTimescaleFromMediaHeader: o4
  } = Eo, {
    parseSamples: l4,
    getMdatTrafPairs: c4
  } = bm;
  var vm = function() {
    let u = 9e4;
    this.init = function(m) {
      const y = Oi(m, ["moov", "trak", "mdia", "mdhd"])[0];
      y && (u = o4(y));
    }, this.parseSegment = function(m) {
      const y = [], v = c4(m);
      let T = 0;
      return v.forEach(function(S) {
        const N = S.mdat, F = S.traf, U = Oi(F, ["tfdt"])[0], j = Oi(F, ["tfhd"])[0], ne = Oi(F, ["trun"]);
        if (U && (T = s4(U).baseMediaDecodeTime), ne.length && j) {
          const fe = l4(ne, T, j);
          let Fe = 0;
          fe.forEach(function(ke) {
            const Xe = "utf-8", st = new TextDecoder(Xe), fn = N.slice(Fe, Fe + ke.size);
            if (Oi(fn, ["vtte"])[0]) {
              Fe += ke.size;
              return;
            }
            Oi(fn, ["vttc"]).forEach(function(Lo) {
              const Do = Oi(Lo, ["payl"])[0], Io = Oi(Lo, ["sttg"])[0], Mo = ke.pts / u, xc = (ke.pts + ke.duration) / u;
              let Et, Oo;
              if (Do)
                try {
                  Et = st.decode(Do);
                } catch (Sa) {
                  console.error(Sa);
                }
              if (Io)
                try {
                  Oo = st.decode(Io);
                } catch (Sa) {
                  console.error(Sa);
                }
              ke.duration && Et && y.push({
                cueText: Et,
                start: Mo,
                end: xc,
                settings: Oo
              });
            }), Fe += ke.size;
          });
        }
      }), y;
    };
  }, Vd = tc, ym = function(u) {
    var m = u[1] & 31;
    return m <<= 8, m |= u[2], m;
  }, yc = function(u) {
    return !!(u[1] & 64);
  }, _c = function(u) {
    var m = 0;
    return (u[3] & 48) >>> 4 > 1 && (m += u[4] + 1), m;
  }, u4 = function(u, m) {
    var y = ym(u);
    return y === 0 ? "pat" : y === m ? "pmt" : m ? "pes" : null;
  }, d4 = function(u) {
    var m = yc(u), y = 4 + _c(u);
    return m && (y += u[y] + 1), (u[y + 10] & 31) << 8 | u[y + 11];
  }, h4 = function(u) {
    var m = {}, y = yc(u), v = 4 + _c(u);
    if (y && (v += u[v] + 1), !!(u[v + 5] & 1)) {
      var T, S, N;
      T = (u[v + 1] & 15) << 8 | u[v + 2], S = 3 + T - 4, N = (u[v + 10] & 15) << 8 | u[v + 11];
      for (var F = 12 + N; F < S; ) {
        var U = v + F;
        m[(u[U + 1] & 31) << 8 | u[U + 2]] = u[U], F += ((u[U + 3] & 15) << 8 | u[U + 4]) + 5;
      }
      return m;
    }
  }, f4 = function(u, m) {
    var y = ym(u), v = m[y];
    switch (v) {
      case Vd.H264_STREAM_TYPE:
        return "video";
      case Vd.ADTS_STREAM_TYPE:
        return "audio";
      case Vd.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, p4 = function(u) {
    var m = yc(u);
    if (!m)
      return null;
    var y = 4 + _c(u);
    if (y >= u.byteLength)
      return null;
    var v = null, T;
    return T = u[y + 7], T & 192 && (v = {}, v.pts = (u[y + 9] & 14) << 27 | (u[y + 10] & 255) << 20 | (u[y + 11] & 254) << 12 | (u[y + 12] & 255) << 5 | (u[y + 13] & 254) >>> 3, v.pts *= 4, v.pts += (u[y + 13] & 6) >>> 1, v.dts = v.pts, T & 64 && (v.dts = (u[y + 14] & 14) << 27 | (u[y + 15] & 255) << 20 | (u[y + 16] & 254) << 12 | (u[y + 17] & 255) << 5 | (u[y + 18] & 254) >>> 3, v.dts *= 4, v.dts += (u[y + 18] & 6) >>> 1)), v;
  }, qd = function(u) {
    switch (u) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, m4 = function(u) {
    for (var m = 4 + _c(u), y = u.subarray(m), v = 0, T = 0, S = !1, N; T < y.byteLength - 3; T++)
      if (y[T + 2] === 1) {
        v = T + 5;
        break;
      }
    for (; v < y.byteLength; )
      switch (y[v]) {
        case 0:
          if (y[v - 1] !== 0) {
            v += 2;
            break;
          } else if (y[v - 2] !== 0) {
            v++;
            break;
          }
          T + 3 !== v - 2 && (N = qd(y[T + 3] & 31), N === "slice_layer_without_partitioning_rbsp_idr" && (S = !0));
          do
            v++;
          while (y[v] !== 1 && v < y.length);
          T = v - 2, v += 3;
          break;
        case 1:
          if (y[v - 1] !== 0 || y[v - 2] !== 0) {
            v += 3;
            break;
          }
          N = qd(y[T + 3] & 31), N === "slice_layer_without_partitioning_rbsp_idr" && (S = !0), T = v - 2, v += 3;
          break;
        default:
          v += 3;
          break;
      }
    return y = y.subarray(T), v -= T, T = 0, y && y.byteLength > 3 && (N = qd(y[T + 3] & 31), N === "slice_layer_without_partitioning_rbsp_idr" && (S = !0)), S;
  }, g4 = {
    parseType: u4,
    parsePat: d4,
    parsePmt: h4,
    parsePayloadUnitStartIndicator: yc,
    parsePesType: f4,
    parsePesTime: p4,
    videoPacketContainsKeyFrame: m4
  }, _m = tc, Zr = Rp.handleRollover, vt = {};
  vt.ts = g4, vt.aac = $d;
  var hr = bt.ONE_SECOND_IN_TS, Mn = 188, Ha = 71, b4 = function(u, m) {
    for (var y = 0, v = Mn, T, S; v < u.byteLength; ) {
      if (u[y] === Ha && u[v] === Ha) {
        switch (T = u.subarray(y, v), S = vt.ts.parseType(T, m.pid), S) {
          case "pat":
            m.pid = vt.ts.parsePat(T);
            break;
          case "pmt":
            var N = vt.ts.parsePmt(T);
            m.table = m.table || {}, Object.keys(N).forEach(function(F) {
              m.table[F] = N[F];
            });
            break;
        }
        y += Mn, v += Mn;
        continue;
      }
      y++, v++;
    }
  }, xm = function(u, m, y) {
    for (var v = 0, T = Mn, S, N, F, U, j, ne = !1; T <= u.byteLength; ) {
      if (u[v] === Ha && (u[T] === Ha || T === u.byteLength)) {
        switch (S = u.subarray(v, T), N = vt.ts.parseType(S, m.pid), N) {
          case "pes":
            F = vt.ts.parsePesType(S, m.table), U = vt.ts.parsePayloadUnitStartIndicator(S), F === "audio" && U && (j = vt.ts.parsePesTime(S), j && (j.type = "audio", y.audio.push(j), ne = !0));
            break;
        }
        if (ne)
          break;
        v += Mn, T += Mn;
        continue;
      }
      v++, T++;
    }
    for (T = u.byteLength, v = T - Mn, ne = !1; v >= 0; ) {
      if (u[v] === Ha && (u[T] === Ha || T === u.byteLength)) {
        switch (S = u.subarray(v, T), N = vt.ts.parseType(S, m.pid), N) {
          case "pes":
            F = vt.ts.parsePesType(S, m.table), U = vt.ts.parsePayloadUnitStartIndicator(S), F === "audio" && U && (j = vt.ts.parsePesTime(S), j && (j.type = "audio", y.audio.push(j), ne = !0));
            break;
        }
        if (ne)
          break;
        v -= Mn, T -= Mn;
        continue;
      }
      v--, T--;
    }
  }, v4 = function(u, m, y) {
    for (var v = 0, T = Mn, S, N, F, U, j, ne, fe, Fe, ke = !1, Xe = {
      data: [],
      size: 0
    }; T < u.byteLength; ) {
      if (u[v] === Ha && u[T] === Ha) {
        switch (S = u.subarray(v, T), N = vt.ts.parseType(S, m.pid), N) {
          case "pes":
            if (F = vt.ts.parsePesType(S, m.table), U = vt.ts.parsePayloadUnitStartIndicator(S), F === "video" && (U && !ke && (j = vt.ts.parsePesTime(S), j && (j.type = "video", y.video.push(j), ke = !0)), !y.firstKeyFrame)) {
              if (U && Xe.size !== 0) {
                for (ne = new Uint8Array(Xe.size), fe = 0; Xe.data.length; )
                  Fe = Xe.data.shift(), ne.set(Fe, fe), fe += Fe.byteLength;
                if (vt.ts.videoPacketContainsKeyFrame(ne)) {
                  var st = vt.ts.parsePesTime(ne);
                  st ? (y.firstKeyFrame = st, y.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                Xe.size = 0;
              }
              Xe.data.push(S), Xe.size += S.byteLength;
            }
            break;
        }
        if (ke && y.firstKeyFrame)
          break;
        v += Mn, T += Mn;
        continue;
      }
      v++, T++;
    }
    for (T = u.byteLength, v = T - Mn, ke = !1; v >= 0; ) {
      if (u[v] === Ha && u[T] === Ha) {
        switch (S = u.subarray(v, T), N = vt.ts.parseType(S, m.pid), N) {
          case "pes":
            F = vt.ts.parsePesType(S, m.table), U = vt.ts.parsePayloadUnitStartIndicator(S), F === "video" && U && (j = vt.ts.parsePesTime(S), j && (j.type = "video", y.video.push(j), ke = !0));
            break;
        }
        if (ke)
          break;
        v -= Mn, T -= Mn;
        continue;
      }
      v--, T--;
    }
  }, y4 = function(u, m) {
    if (u.audio && u.audio.length) {
      var y = m;
      (typeof y > "u" || isNaN(y)) && (y = u.audio[0].dts), u.audio.forEach(function(S) {
        S.dts = Zr(S.dts, y), S.pts = Zr(S.pts, y), S.dtsTime = S.dts / hr, S.ptsTime = S.pts / hr;
      });
    }
    if (u.video && u.video.length) {
      var v = m;
      if ((typeof v > "u" || isNaN(v)) && (v = u.video[0].dts), u.video.forEach(function(S) {
        S.dts = Zr(S.dts, v), S.pts = Zr(S.pts, v), S.dtsTime = S.dts / hr, S.ptsTime = S.pts / hr;
      }), u.firstKeyFrame) {
        var T = u.firstKeyFrame;
        T.dts = Zr(T.dts, v), T.pts = Zr(T.pts, v), T.dtsTime = T.dts / hr, T.ptsTime = T.pts / hr;
      }
    }
  }, _4 = function(u) {
    for (var m = !1, y = 0, v = null, T = null, S = 0, N = 0, F; u.length - N >= 3; ) {
      var U = vt.aac.parseType(u, N);
      switch (U) {
        case "timed-metadata":
          if (u.length - N < 10) {
            m = !0;
            break;
          }
          if (S = vt.aac.parseId3TagSize(u, N), S > u.length) {
            m = !0;
            break;
          }
          T === null && (F = u.subarray(N, N + S), T = vt.aac.parseAacTimestamp(F)), N += S;
          break;
        case "audio":
          if (u.length - N < 7) {
            m = !0;
            break;
          }
          if (S = vt.aac.parseAdtsSize(u, N), S > u.length) {
            m = !0;
            break;
          }
          v === null && (F = u.subarray(N, N + S), v = vt.aac.parseSampleRate(F)), y++, N += S;
          break;
        default:
          N++;
          break;
      }
      if (m)
        return null;
    }
    if (v === null || T === null)
      return null;
    var j = hr / v, ne = {
      audio: [{
        type: "audio",
        dts: T,
        pts: T
      }, {
        type: "audio",
        dts: T + y * 1024 * j,
        pts: T + y * 1024 * j
      }]
    };
    return ne;
  }, x4 = function(u) {
    var m = {
      pid: null,
      table: null
    }, y = {};
    b4(u, m);
    for (var v in m.table)
      if (m.table.hasOwnProperty(v)) {
        var T = m.table[v];
        switch (T) {
          case _m.H264_STREAM_TYPE:
            y.video = [], v4(u, m, y), y.video.length === 0 && delete y.video;
            break;
          case _m.ADTS_STREAM_TYPE:
            y.audio = [], xm(u, m, y), y.audio.length === 0 && delete y.audio;
            break;
        }
      }
    return y;
  }, T4 = function(u, m) {
    var y = vt.aac.isLikelyAacData(u), v;
    return y ? v = _4(u) : v = x4(u), !v || !v.audio && !v.video ? null : (y4(v, m), v);
  }, w4 = {
    inspect: T4,
    parseAudioPes_: xm
  };
  const k4 = function(u, m) {
    m.on("data", function(y) {
      const v = y.initSegment;
      y.initSegment = {
        data: v.buffer,
        byteOffset: v.byteOffset,
        byteLength: v.byteLength
      };
      const T = y.data;
      y.data = T.buffer, u.postMessage({
        action: "data",
        segment: y,
        byteOffset: T.byteOffset,
        byteLength: T.byteLength
      }, [y.data]);
    }), m.on("done", function(y) {
      u.postMessage({
        action: "done"
      });
    }), m.on("gopInfo", function(y) {
      u.postMessage({
        action: "gopInfo",
        gopInfo: y
      });
    }), m.on("videoSegmentTimingInfo", function(y) {
      const v = {
        start: {
          decode: bt.videoTsToSeconds(y.start.dts),
          presentation: bt.videoTsToSeconds(y.start.pts)
        },
        end: {
          decode: bt.videoTsToSeconds(y.end.dts),
          presentation: bt.videoTsToSeconds(y.end.pts)
        },
        baseMediaDecodeTime: bt.videoTsToSeconds(y.baseMediaDecodeTime)
      };
      y.prependedContentDuration && (v.prependedContentDuration = bt.videoTsToSeconds(y.prependedContentDuration)), u.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: v
      });
    }), m.on("audioSegmentTimingInfo", function(y) {
      const v = {
        start: {
          decode: bt.videoTsToSeconds(y.start.dts),
          presentation: bt.videoTsToSeconds(y.start.pts)
        },
        end: {
          decode: bt.videoTsToSeconds(y.end.dts),
          presentation: bt.videoTsToSeconds(y.end.pts)
        },
        baseMediaDecodeTime: bt.videoTsToSeconds(y.baseMediaDecodeTime)
      };
      y.prependedContentDuration && (v.prependedContentDuration = bt.videoTsToSeconds(y.prependedContentDuration)), u.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: v
      });
    }), m.on("id3Frame", function(y) {
      u.postMessage({
        action: "id3Frame",
        id3Frame: y
      });
    }), m.on("caption", function(y) {
      u.postMessage({
        action: "caption",
        caption: y
      });
    }), m.on("trackinfo", function(y) {
      u.postMessage({
        action: "trackinfo",
        trackInfo: y
      });
    }), m.on("audioTimingInfo", function(y) {
      u.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: bt.videoTsToSeconds(y.start),
          end: bt.videoTsToSeconds(y.end)
        }
      });
    }), m.on("videoTimingInfo", function(y) {
      u.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: bt.videoTsToSeconds(y.start),
          end: bt.videoTsToSeconds(y.end)
        }
      });
    }), m.on("log", function(y) {
      u.postMessage({
        action: "log",
        log: y
      });
    });
  };
  class Tm {
    constructor(m, y) {
      this.options = y || {}, this.self = m, this.init();
    }
    /**
     * initialize our web worker and wire all the events.
     */
    init() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new _T.Transmuxer(this.options), k4(this.self, this.transmuxer);
    }
    pushMp4Captions(m) {
      this.captionParser || (this.captionParser = new r4(), this.captionParser.init());
      const y = new Uint8Array(m.data, m.byteOffset, m.byteLength), v = this.captionParser.parse(y, m.trackIds, m.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: v && v.captions || [],
        logs: v && v.logs || [],
        data: y.buffer
      }, [y.buffer]);
    }
    /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */
    initMp4WebVttParser(m) {
      this.webVttParser || (this.webVttParser = new vm());
      const y = new Uint8Array(m.data, m.byteOffset, m.byteLength);
      this.webVttParser.init(y);
    }
    /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */
    getMp4WebVttText(m) {
      this.webVttParser || (this.webVttParser = new vm());
      const y = new Uint8Array(m.data, m.byteOffset, m.byteLength), v = this.webVttParser.parseSegment(y);
      this.self.postMessage({
        action: "getMp4WebVttText",
        mp4VttCues: v || [],
        data: y.buffer
      }, [y.buffer]);
    }
    probeMp4StartTime({
      timescales: m,
      data: y
    }) {
      const v = Eo.startTime(m, y);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: v,
        data: y
      }, [y.buffer]);
    }
    probeMp4Tracks({
      data: m
    }) {
      const y = Eo.tracks(m);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: y,
        data: m
      }, [m.buffer]);
    }
    /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */
    probeEmsgID3({
      data: m,
      offset: y
    }) {
      const v = Eo.getEmsgID3(m, y);
      this.self.postMessage({
        action: "probeEmsgID3",
        id3Frames: v,
        emsgData: m
      }, [m.buffer]);
    }
    /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */
    probeTs({
      data: m,
      baseStartTime: y
    }) {
      const v = typeof y == "number" && !isNaN(y) ? y * bt.ONE_SECOND_IN_TS : void 0, T = w4.inspect(m, v);
      let S = null;
      T && (S = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: T.video && T.video.length === 2 || !1,
        hasAudio: T.audio && T.audio.length === 2 || !1
      }, S.hasVideo && (S.videoStart = T.video[0].ptsTime), S.hasAudio && (S.audioStart = T.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: S,
        data: m
      }, [m.buffer]);
    }
    clearAllMp4Captions() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }
    clearParsedMp4Captions() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }
    /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */
    push(m) {
      const y = new Uint8Array(m.data, m.byteOffset, m.byteLength);
      this.transmuxer.push(y);
    }
    /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */
    reset() {
      this.transmuxer.reset();
    }
    /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */
    setTimestampOffset(m) {
      const y = m.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(bt.secondsToVideoTs(y)));
    }
    setAudioAppendStart(m) {
      this.transmuxer.setAudioAppendStart(Math.ceil(bt.secondsToVideoTs(m.appendStart)));
    }
    setRemux(m) {
      this.transmuxer.setRemux(m.remux);
    }
    /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */
    flush(m) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }
    endTimeline() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }
    alignGopsWith(m) {
      this.transmuxer.alignGopsWith(m.gopsToAlignWith.slice());
    }
  }
  self.onmessage = function(u) {
    if (u.data.action === "init" && u.data.options) {
      this.messageHandlers = new Tm(self, u.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new Tm(self)), u.data && u.data.action && u.data.action !== "init" && this.messageHandlers[u.data.action] && this.messageHandlers[u.data.action](u.data);
  };
}));
var Hae = z_(Uae);
const Yae = (t, e, n) => {
  const {
    type: a,
    initSegment: i,
    captions: r,
    captionStreams: s,
    metadata: o,
    videoFrameDtsTime: l,
    videoFramePtsTime: c
  } = t.data.segment;
  e.buffer.push({
    captions: r,
    captionStreams: s,
    metadata: o
  });
  const d = t.data.segment.boxes || {
    data: t.data.segment.data
  }, f = {
    type: a,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(d.data, d.data.byteOffset, d.data.byteLength),
    initSegment: new Uint8Array(i.data, i.byteOffset, i.byteLength)
  };
  typeof l < "u" && (f.videoFrameDtsTime = l), typeof c < "u" && (f.videoFramePtsTime = c), n(f);
}, jae = ({
  transmuxedData: t,
  callback: e
}) => {
  t.buffer = [], e(t);
}, Vae = (t, e) => {
  e.gopInfo = t.data.gopInfo;
}, Y_ = (t) => {
  const {
    transmuxer: e,
    bytes: n,
    audioAppendStart: a,
    gopsToAlignWith: i,
    remux: r,
    onData: s,
    onTrackInfo: o,
    onAudioTimingInfo: l,
    onVideoTimingInfo: c,
    onVideoSegmentTimingInfo: d,
    onAudioSegmentTimingInfo: f,
    onId3: g,
    onCaptions: _,
    onDone: x,
    onEndedTimeline: p,
    onTransmuxerLog: w,
    isEndOfTimeline: C,
    segment: M,
    triggerSegmentEventFn: A
  } = t, L = {
    buffer: []
  };
  let D = C;
  const B = (z) => {
    e.currentTransmux === t && (z.data.action === "data" && Yae(z, L, s), z.data.action === "trackinfo" && o(z.data.trackInfo), z.data.action === "gopInfo" && Vae(z, L), z.data.action === "audioTimingInfo" && l(z.data.audioTimingInfo), z.data.action === "videoTimingInfo" && c(z.data.videoTimingInfo), z.data.action === "videoSegmentTimingInfo" && d(z.data.videoSegmentTimingInfo), z.data.action === "audioSegmentTimingInfo" && f(z.data.audioSegmentTimingInfo), z.data.action === "id3Frame" && g([z.data.id3Frame], z.data.id3Frame.dispatchType), z.data.action === "caption" && _(z.data.caption), z.data.action === "endedtimeline" && (D = !1, p()), z.data.action === "log" && w(z.data.log), z.data.type === "transmuxed" && (D || (e.onmessage = null, jae({
      transmuxedData: L,
      callback: x
    }), j_(e))));
  }, P = () => {
    const z = {
      message: "Received an error message from the transmuxer worker",
      metadata: {
        errorType: le.Error.StreamingFailedToTransmuxSegment,
        segmentInfo: yr({
          segment: M
        })
      }
    };
    x(null, z);
  };
  if (e.onmessage = B, e.onerror = P, a && e.postMessage({
    action: "setAudioAppendStart",
    appendStart: a
  }), Array.isArray(i) && e.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: i
  }), typeof r < "u" && e.postMessage({
    action: "setRemux",
    remux: r
  }), n.byteLength) {
    const z = n instanceof ArrayBuffer ? n : n.buffer, W = n instanceof ArrayBuffer ? 0 : n.byteOffset;
    A({
      type: "segmenttransmuxingstart",
      segment: M
    }), e.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: z,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: W,
      byteLength: n.byteLength
    }, [z]);
  }
  C && e.postMessage({
    action: "endTimeline"
  }), e.postMessage({
    action: "flush"
  });
}, j_ = (t) => {
  t.currentTransmux = null, t.transmuxQueue.length && (t.currentTransmux = t.transmuxQueue.shift(), typeof t.currentTransmux == "function" ? t.currentTransmux() : Y_(t.currentTransmux));
}, Lb = (t, e) => {
  t.postMessage({
    action: e
  }), j_(t);
}, V_ = (t, e) => {
  if (!e.currentTransmux) {
    e.currentTransmux = t, Lb(e, t);
    return;
  }
  e.transmuxQueue.push(Lb.bind(null, e, t));
}, qae = (t) => {
  V_("reset", t);
}, Wae = (t) => {
  V_("endTimeline", t);
}, q_ = (t) => {
  if (!t.transmuxer.currentTransmux) {
    t.transmuxer.currentTransmux = t, Y_(t);
    return;
  }
  t.transmuxer.transmuxQueue.push(t);
}, Gae = (t) => {
  const e = new Hae();
  e.currentTransmux = null, e.transmuxQueue = [];
  const n = e.terminate;
  return e.terminate = () => (e.currentTransmux = null, e.transmuxQueue.length = 0, n.call(e)), e.postMessage({
    action: "init",
    options: t
  }), e;
};
var R0 = {
  reset: qae,
  endTimeline: Wae,
  transmux: q_,
  createTransmuxer: Gae
};
const ks = function(t) {
  const e = t.transmuxer, n = t.endAction || t.action, a = t.callback, i = Jt({}, t, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), r = (s) => {
    s.data.action === n && (e.removeEventListener("message", r), s.data.data && (s.data.data = new Uint8Array(s.data.data, t.byteOffset || 0, t.byteLength || s.data.data.byteLength), t.data && (t.data = s.data.data)), a(s.data));
  };
  if (e.addEventListener("message", r), t.data) {
    const s = t.data instanceof ArrayBuffer;
    i.byteOffset = s ? 0 : t.data.byteOffset, i.byteLength = t.data.byteLength;
    const o = [s ? t.data : t.data.buffer];
    e.postMessage(i, o);
  } else
    e.postMessage(i);
}, Qa = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, W_ = "wvtt", Mh = (t) => {
  t.forEach((e) => {
    e.abort();
  });
}, Xae = (t) => ({
  bandwidth: t.bandwidth,
  bytesReceived: t.bytesReceived || 0,
  roundTripTime: t.roundTripTime || 0
}), Zae = (t) => {
  const e = t.target, a = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: Date.now() - e.requestTime || 0
  };
  return a.bytesReceived = t.loaded, a.bandwidth = Math.floor(a.bytesReceived / a.roundTripTime * 8 * 1e3), a;
}, Ep = (t, e) => {
  const {
    requestType: n
  } = e, a = Ir({
    requestType: n,
    request: e,
    error: t
  });
  return e.timedout ? {
    status: e.status,
    message: "HLS request timed-out at URL: " + e.uri,
    code: Qa.TIMEOUT,
    xhr: e,
    metadata: a
  } : e.aborted ? {
    status: e.status,
    message: "HLS request aborted at URL: " + e.uri,
    code: Qa.ABORTED,
    xhr: e,
    metadata: a
  } : t ? {
    status: e.status,
    message: "HLS request errored at URL: " + e.uri,
    code: Qa.FAILURE,
    xhr: e,
    metadata: a
  } : e.responseType === "arraybuffer" && e.response.byteLength === 0 ? {
    status: e.status,
    message: "Empty HLS response at URL: " + e.uri,
    code: Qa.FAILURE,
    xhr: e,
    metadata: a
  } : null;
}, Db = (t, e, n, a) => (i, r) => {
  const s = r.response, o = Ep(i, r);
  if (o)
    return n(o, t);
  if (s.byteLength !== 16)
    return n({
      status: r.status,
      message: "Invalid HLS key at URL: " + r.uri,
      code: Qa.FAILURE,
      xhr: r
    }, t);
  const l = new DataView(s), c = new Uint32Array([l.getUint32(0), l.getUint32(4), l.getUint32(8), l.getUint32(12)]);
  for (let f = 0; f < e.length; f++)
    e[f].bytes = c;
  const d = {
    uri: r.uri
  };
  return a({
    type: "segmentkeyloadcomplete",
    segment: t,
    keyInfo: d
  }), n(null, t);
}, Kae = (t, e) => {
  e === W_ && t.transmuxer.postMessage({
    action: "initMp4WebVttParser",
    data: t.map.bytes
  });
}, Qae = (t, e, n) => {
  e === W_ && ks({
    action: "getMp4WebVttText",
    data: t.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      data: a,
      mp4VttCues: i
    }) => {
      t.bytes = a, n(null, t, {
        mp4VttCues: i
      });
    }
  });
}, G_ = (t, e) => {
  const n = Qf(t.map.bytes);
  if (n !== "mp4") {
    const a = t.map.resolvedUri || t.map.uri, i = n || "unknown";
    return e({
      internal: !0,
      message: `Found unsupported ${i} container for initialization segment at URL: ${a}`,
      code: Qa.FAILURE,
      metadata: {
        mediaType: i
      }
    });
  }
  ks({
    action: "probeMp4Tracks",
    data: t.map.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      tracks: a,
      data: i
    }) => (t.map.bytes = i, a.forEach(function(r) {
      t.map.tracks = t.map.tracks || {}, !t.map.tracks[r.type] && (t.map.tracks[r.type] = r, typeof r.id == "number" && r.timescale && (t.map.timescales = t.map.timescales || {}, t.map.timescales[r.id] = r.timescale), r.type === "text" && Kae(t, r.codec));
    }), e(null))
  });
}, Jae = ({
  segment: t,
  finishProcessingFn: e,
  triggerSegmentEventFn: n
}) => (a, i) => {
  const r = Ep(a, i);
  if (r)
    return e(r, t);
  const s = new Uint8Array(i.response);
  if (n({
    type: "segmentloaded",
    segment: t
  }), t.map.key)
    return t.map.encryptedBytes = s, e(null, t);
  t.map.bytes = s, G_(t, function(o) {
    if (o)
      return o.xhr = i, o.status = i.status, e(o, t);
    e(null, t);
  });
}, eie = ({
  segment: t,
  finishProcessingFn: e,
  responseType: n,
  triggerSegmentEventFn: a
}) => (i, r) => {
  const s = Ep(i, r);
  if (s)
    return e(s, t);
  a({
    type: "segmentloaded",
    segment: t
  });
  const o = (
    // although responseText "should" exist, this guard serves to prevent an error being
    // thrown for two primary cases:
    // 1. the mime type override stops working, or is not implemented for a specific
    //    browser
    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
    n === "arraybuffer" || !r.responseText ? r.response : Fae(r.responseText.substring(t.lastReachedChar || 0))
  );
  return t.stats = Xae(r), t.key ? t.encryptedBytes = new Uint8Array(o) : t.bytes = new Uint8Array(o), e(null, t);
}, tie = ({
  segment: t,
  bytes: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: d,
  doneFn: f,
  onTransmuxerLog: g,
  triggerSegmentEventFn: _
}) => {
  const x = t.map && t.map.tracks || {}, p = !!(x.audio && x.video);
  let w = a.bind(null, t, "audio", "start");
  const C = a.bind(null, t, "audio", "end");
  let M = a.bind(null, t, "video", "start");
  const A = a.bind(null, t, "video", "end"), L = () => q_({
    bytes: e,
    transmuxer: t.transmuxer,
    audioAppendStart: t.audioAppendStart,
    gopsToAlignWith: t.gopsToAlignWith,
    remux: p,
    onData: (D) => {
      D.type = D.type === "combined" ? "video" : D.type, d(t, D);
    },
    onTrackInfo: (D) => {
      n && (p && (D.isMuxed = !0), n(t, D));
    },
    onAudioTimingInfo: (D) => {
      w && typeof D.start < "u" && (w(D.start), w = null), C && typeof D.end < "u" && C(D.end);
    },
    onVideoTimingInfo: (D) => {
      M && typeof D.start < "u" && (M(D.start), M = null), A && typeof D.end < "u" && A(D.end);
    },
    onVideoSegmentTimingInfo: (D) => {
      const B = {
        pts: {
          start: D.start.presentation,
          end: D.end.presentation
        },
        dts: {
          start: D.start.decode,
          end: D.end.decode
        }
      };
      _({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: B
      }), i(D);
    },
    onAudioSegmentTimingInfo: (D) => {
      const B = {
        pts: {
          start: D.start.pts,
          end: D.end.pts
        },
        dts: {
          start: D.start.dts,
          end: D.end.dts
        }
      };
      _({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: B
      }), r(D);
    },
    onId3: (D, B) => {
      s(t, D, B);
    },
    onCaptions: (D) => {
      o(t, [D]);
    },
    isEndOfTimeline: l,
    onEndedTimeline: () => {
      c();
    },
    onTransmuxerLog: g,
    onDone: (D, B) => {
      f && (D.type = D.type === "combined" ? "video" : D.type, _({
        type: "segmenttransmuxingcomplete",
        segment: t
      }), f(B, t, D));
    },
    segment: t,
    triggerSegmentEventFn: _
  });
  ks({
    action: "probeTs",
    transmuxer: t.transmuxer,
    data: e,
    baseStartTime: t.baseStartTime,
    callback: (D) => {
      t.bytes = e = D.data;
      const B = D.result;
      B && (n(t, {
        hasAudio: B.hasAudio,
        hasVideo: B.hasVideo,
        isMuxed: p
      }), n = null), L();
    }
  });
}, X_ = ({
  segment: t,
  bytes: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: d,
  doneFn: f,
  onTransmuxerLog: g,
  triggerSegmentEventFn: _
}) => {
  let x = new Uint8Array(e);
  if (wte(x)) {
    t.isFmp4 = !0;
    const {
      tracks: p
    } = t.map;
    if (p.text && (!p.audio || !p.video)) {
      d(t, {
        data: x,
        type: "text"
      }), Qae(t, p.text.codec, f);
      return;
    }
    const C = {
      isFmp4: !0,
      hasVideo: !!p.video,
      hasAudio: !!p.audio
    };
    p.audio && p.audio.codec && p.audio.codec !== "enca" && (C.audioCodec = p.audio.codec), p.video && p.video.codec && p.video.codec !== "encv" && (C.videoCodec = p.video.codec), p.video && p.audio && (C.isMuxed = !0), n(t, C);
    const M = (A, L) => {
      d(t, {
        data: x,
        type: C.hasAudio && !C.isMuxed ? "audio" : "video"
      }), L && L.length && s(t, L), A && A.length && o(t, A), f(null, t, {});
    };
    ks({
      action: "probeMp4StartTime",
      timescales: t.map.timescales,
      data: x,
      transmuxer: t.transmuxer,
      callback: ({
        data: A,
        startTime: L
      }) => {
        e = A.buffer, t.bytes = x = A, C.hasAudio && !C.isMuxed && a(t, "audio", "start", L), C.hasVideo && a(t, "video", "start", L), ks({
          action: "probeEmsgID3",
          data: x,
          transmuxer: t.transmuxer,
          offset: L,
          callback: ({
            emsgData: D,
            id3Frames: B
          }) => {
            if (e = D.buffer, t.bytes = x = D, !p.video || !D.byteLength || !t.transmuxer) {
              M(void 0, B);
              return;
            }
            ks({
              action: "pushMp4Captions",
              endAction: "mp4Captions",
              transmuxer: t.transmuxer,
              data: x,
              timescales: t.map.timescales,
              trackIds: [p.video.id],
              callback: (P) => {
                e = P.data.buffer, t.bytes = x = P.data, P.logs.forEach(function(z) {
                  g(gt(z, {
                    stream: "mp4CaptionParser"
                  }));
                }), M(P.captions, B);
              }
            });
          }
        });
      }
    });
    return;
  }
  if (!t.transmuxer) {
    f(null, t, {});
    return;
  }
  if (typeof t.container > "u" && (t.container = Qf(x)), t.container !== "ts" && t.container !== "aac") {
    n(t, {
      hasAudio: !1,
      hasVideo: !1
    }), f(null, t, {});
    return;
  }
  tie({
    segment: t,
    bytes: e,
    trackInfoFn: n,
    timingInfoFn: a,
    videoSegmentTimingInfoFn: i,
    audioSegmentTimingInfoFn: r,
    id3Fn: s,
    captionsFn: o,
    isEndOfTimeline: l,
    endedTimelineFn: c,
    dataFn: d,
    doneFn: f,
    onTransmuxerLog: g,
    triggerSegmentEventFn: _
  });
}, Z_ = function({
  id: t,
  key: e,
  encryptedBytes: n,
  decryptionWorker: a,
  segment: i,
  doneFn: r
}, s) {
  const o = (c) => {
    if (c.data.source === t) {
      a.removeEventListener("message", o);
      const d = c.data.decrypted;
      s(new Uint8Array(d.bytes, d.byteOffset, d.byteLength));
    }
  };
  a.onerror = () => {
    const c = "An error occurred in the decryption worker", d = yr({
      segment: i
    }), f = {
      message: c,
      metadata: {
        error: new Error(c),
        errorType: le.Error.StreamingFailedToDecryptSegment,
        segmentInfo: d,
        keyInfo: {
          uri: i.key.resolvedUri || i.map.key.resolvedUri
        }
      }
    };
    r(f, i);
  }, a.addEventListener("message", o);
  let l;
  e.bytes.slice ? l = e.bytes.slice() : l = new Uint32Array(Array.prototype.slice.call(e.bytes)), a.postMessage(P_({
    source: t,
    encrypted: n,
    key: l,
    iv: e.iv
  }), [n.buffer, l.buffer]);
}, nie = ({
  decryptionWorker: t,
  segment: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: d,
  doneFn: f,
  onTransmuxerLog: g,
  triggerSegmentEventFn: _
}) => {
  _({
    type: "segmentdecryptionstart"
  }), Z_({
    id: e.requestId,
    key: e.key,
    encryptedBytes: e.encryptedBytes,
    decryptionWorker: t,
    segment: e,
    doneFn: f
  }, (x) => {
    e.bytes = x, _({
      type: "segmentdecryptioncomplete",
      segment: e
    }), X_({
      segment: e,
      bytes: e.bytes,
      trackInfoFn: n,
      timingInfoFn: a,
      videoSegmentTimingInfoFn: i,
      audioSegmentTimingInfoFn: r,
      id3Fn: s,
      captionsFn: o,
      isEndOfTimeline: l,
      endedTimelineFn: c,
      dataFn: d,
      doneFn: f,
      onTransmuxerLog: g,
      triggerSegmentEventFn: _
    });
  });
}, aie = ({
  activeXhrs: t,
  decryptionWorker: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: d,
  doneFn: f,
  onTransmuxerLog: g,
  triggerSegmentEventFn: _
}) => {
  let x = 0, p = !1;
  return (w, C) => {
    if (!p) {
      if (w)
        return p = !0, Mh(t), f(w, C);
      if (x += 1, x === t.length) {
        const M = function() {
          if (C.encryptedBytes)
            return nie({
              decryptionWorker: e,
              segment: C,
              trackInfoFn: n,
              timingInfoFn: a,
              videoSegmentTimingInfoFn: i,
              audioSegmentTimingInfoFn: r,
              id3Fn: s,
              captionsFn: o,
              isEndOfTimeline: l,
              endedTimelineFn: c,
              dataFn: d,
              doneFn: f,
              onTransmuxerLog: g,
              triggerSegmentEventFn: _
            });
          X_({
            segment: C,
            bytes: C.bytes,
            trackInfoFn: n,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: i,
            audioSegmentTimingInfoFn: r,
            id3Fn: s,
            captionsFn: o,
            isEndOfTimeline: l,
            endedTimelineFn: c,
            dataFn: d,
            doneFn: f,
            onTransmuxerLog: g,
            triggerSegmentEventFn: _
          });
        };
        if (C.endOfAllRequests = Date.now(), C.map && C.map.encryptedBytes && !C.map.bytes)
          return _({
            type: "segmentdecryptionstart",
            segment: C
          }), Z_({
            decryptionWorker: e,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: C.requestId + "-init",
            encryptedBytes: C.map.encryptedBytes,
            key: C.map.key,
            segment: C,
            doneFn: f
          }, (A) => {
            C.map.bytes = A, _({
              type: "segmentdecryptioncomplete",
              segment: C
            }), G_(C, (L) => {
              if (L)
                return Mh(t), f(L, C);
              M();
            });
          });
        M();
      }
    }
  };
}, iie = ({
  loadendState: t,
  abortFn: e
}) => (n) => {
  n.target.aborted && e && !t.calledAbortFn && (e(), t.calledAbortFn = !0);
}, rie = ({
  segment: t,
  progressFn: e,
  trackInfoFn: n,
  timingInfoFn: a,
  videoSegmentTimingInfoFn: i,
  audioSegmentTimingInfoFn: r,
  id3Fn: s,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: c,
  dataFn: d
}) => (f) => {
  if (!f.target.aborted)
    return t.stats = gt(t.stats, Zae(f)), !t.stats.firstBytesReceivedAt && t.stats.bytesReceived && (t.stats.firstBytesReceivedAt = Date.now()), e(f, t);
}, sie = ({
  xhr: t,
  xhrOptions: e,
  decryptionWorker: n,
  segment: a,
  abortFn: i,
  progressFn: r,
  trackInfoFn: s,
  timingInfoFn: o,
  videoSegmentTimingInfoFn: l,
  audioSegmentTimingInfoFn: c,
  id3Fn: d,
  captionsFn: f,
  isEndOfTimeline: g,
  endedTimelineFn: _,
  dataFn: x,
  doneFn: p,
  onTransmuxerLog: w,
  triggerSegmentEventFn: C
}) => {
  const M = [], A = aie({
    activeXhrs: M,
    decryptionWorker: n,
    trackInfoFn: s,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: c,
    id3Fn: d,
    captionsFn: f,
    isEndOfTimeline: g,
    endedTimelineFn: _,
    dataFn: x,
    doneFn: p,
    onTransmuxerLog: w,
    triggerSegmentEventFn: C
  });
  if (a.key && !a.key.bytes) {
    const z = [a.key];
    a.map && !a.map.bytes && a.map.key && a.map.key.resolvedUri === a.key.resolvedUri && z.push(a.map.key);
    const W = gt(e, {
      uri: a.key.resolvedUri,
      responseType: "arraybuffer",
      requestType: "segment-key"
    }), q = Db(a, z, A, C), V = {
      uri: a.key.resolvedUri
    };
    C({
      type: "segmentkeyloadstart",
      segment: a,
      keyInfo: V
    });
    const re = t(W, q);
    M.push(re);
  }
  if (a.map && !a.map.bytes) {
    if (a.map.key && (!a.key || a.key.resolvedUri !== a.map.key.resolvedUri)) {
      const re = gt(e, {
        uri: a.map.key.resolvedUri,
        responseType: "arraybuffer",
        requestType: "segment-key"
      }), ie = Db(a, [a.map.key], A, C), K = {
        uri: a.map.key.resolvedUri
      };
      C({
        type: "segmentkeyloadstart",
        segment: a,
        keyInfo: K
      });
      const $ = t(re, ie);
      M.push($);
    }
    const W = gt(e, {
      uri: a.map.resolvedUri,
      responseType: "arraybuffer",
      headers: Dh(a.map),
      requestType: "segment-media-initialization"
    }), q = Jae({
      segment: a,
      finishProcessingFn: A,
      triggerSegmentEventFn: C
    });
    C({
      type: "segmentloadstart",
      segment: a
    });
    const V = t(W, q);
    M.push(V);
  }
  const L = gt(e, {
    uri: a.part && a.part.resolvedUri || a.resolvedUri,
    responseType: "arraybuffer",
    headers: Dh(a),
    requestType: "segment"
  }), D = eie({
    segment: a,
    finishProcessingFn: A,
    responseType: L.responseType,
    triggerSegmentEventFn: C
  });
  C({
    type: "segmentloadstart",
    segment: a
  });
  const B = t(L, D);
  B.addEventListener("progress", rie({
    segment: a,
    progressFn: r,
    trackInfoFn: s,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: c,
    id3Fn: d,
    captionsFn: f,
    isEndOfTimeline: g,
    endedTimelineFn: _,
    dataFn: x
  })), M.push(B);
  const P = {};
  return M.forEach((z) => {
    z.addEventListener("loadend", iie({
      loadendState: P,
      abortFn: i
    }));
  }), () => Mh(M);
}, oie = Ta("CodecUtils"), lie = function(t) {
  const e = t.attributes || {};
  if (e.CODECS)
    return ja(e.CODECS);
}, K_ = (t, e) => {
  const n = e.attributes || {};
  return t && t.mediaGroups && t.mediaGroups.AUDIO && n.AUDIO && t.mediaGroups.AUDIO[n.AUDIO];
}, cie = (t, e) => {
  if (!K_(t, e))
    return !0;
  const n = e.attributes || {}, a = t.mediaGroups.AUDIO[n.AUDIO];
  for (const i in a)
    if (!a[i].uri && !a[i].playlists)
      return !0;
  return !1;
}, Mu = function(t) {
  const e = {};
  return t.forEach(({
    mediaType: n,
    type: a,
    details: i
  }) => {
    e[n] = e[n] || [], e[n].push(l5(`${a}${i}`));
  }), Object.keys(e).forEach(function(n) {
    if (e[n].length > 1) {
      oie(`multiple ${n} codecs found as attributes: ${e[n].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), e[n] = null;
      return;
    }
    e[n] = e[n][0];
  }), e;
}, Ib = function(t) {
  let e = 0;
  return t.audio && e++, t.video && e++, e;
}, fl = function(t, e) {
  const n = e.attributes || {}, a = Mu(lie(e) || []);
  if (K_(t, e) && !a.audio && !cie(t, e)) {
    const i = Mu(kJ(t, n.AUDIO) || []);
    i.audio && (a.audio = i.audio);
  }
  return a;
}, Pc = Ta("PlaylistSelector"), Mb = function(t) {
  if (!t || !t.playlist)
    return;
  const e = t.playlist;
  return JSON.stringify({
    id: e.id,
    bandwidth: t.bandwidth,
    width: t.width,
    height: t.height,
    codecs: e.attributes && e.attributes.CODECS || ""
  });
}, Ou = function(t, e) {
  if (!t)
    return "";
  const n = Y.getComputedStyle(t);
  return n ? n[e] : "";
}, Ss = function(t, e) {
  const n = t.slice();
  t.sort(function(a, i) {
    const r = e(a, i);
    return r === 0 ? n.indexOf(a) - n.indexOf(i) : r;
  });
}, Lp = function(t, e) {
  let n, a;
  return t.attributes.BANDWIDTH && (n = t.attributes.BANDWIDTH), n = n || Y.Number.MAX_VALUE, e.attributes.BANDWIDTH && (a = e.attributes.BANDWIDTH), a = a || Y.Number.MAX_VALUE, n - a;
}, uie = function(t, e) {
  let n, a;
  return t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (n = t.attributes.RESOLUTION.width), n = n || Y.Number.MAX_VALUE, e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (a = e.attributes.RESOLUTION.width), a = a || Y.Number.MAX_VALUE, n === a && t.attributes.BANDWIDTH && e.attributes.BANDWIDTH ? t.attributes.BANDWIDTH - e.attributes.BANDWIDTH : n - a;
};
let Q_ = function(t, e, n, a, i, r) {
  if (!t)
    return;
  const s = {
    bandwidth: e,
    width: n,
    height: a,
    limitRenditionByPlayerDimensions: i
  };
  let o = t.playlists;
  Zn.isAudioOnly(t) && (o = r.getAudioTrackPlaylists_(), s.audioOnly = !0);
  let l = o.map((D) => {
    let B;
    const P = D.attributes && D.attributes.RESOLUTION && D.attributes.RESOLUTION.width, z = D.attributes && D.attributes.RESOLUTION && D.attributes.RESOLUTION.height;
    return B = D.attributes && D.attributes.BANDWIDTH, B = B || Y.Number.MAX_VALUE, {
      bandwidth: B,
      width: P,
      height: z,
      playlist: D
    };
  });
  Ss(l, (D, B) => D.bandwidth - B.bandwidth), l = l.filter((D) => !Zn.isIncompatible(D.playlist));
  let c = l.filter((D) => Zn.isEnabled(D.playlist));
  c.length || (c = l.filter((D) => !Zn.isDisabled(D.playlist)));
  const d = c.filter((D) => D.bandwidth * mn.BANDWIDTH_VARIANCE < e);
  let f = d[d.length - 1];
  const g = d.filter((D) => D.bandwidth === f.bandwidth)[0];
  if (i === !1) {
    const D = g || c[0] || l[0];
    if (D && D.playlist) {
      let B = "sortedPlaylistReps";
      return g && (B = "bandwidthBestRep"), c[0] && (B = "enabledPlaylistReps"), Pc(`choosing ${Mb(D)} using ${B} with options`, s), D.playlist;
    }
    return Pc("could not choose a playlist with options", s), null;
  }
  const _ = d.filter((D) => D.width && D.height);
  Ss(_, (D, B) => D.width - B.width);
  const x = _.filter((D) => D.width === n && D.height === a);
  f = x[x.length - 1];
  const p = x.filter((D) => D.bandwidth === f.bandwidth)[0];
  let w, C, M;
  p || (w = _.filter((D) => D.width > n || D.height > a), C = w.filter((D) => D.width === w[0].width && D.height === w[0].height), f = C[C.length - 1], M = C.filter((D) => D.bandwidth === f.bandwidth)[0]);
  let A;
  if (r.leastPixelDiffSelector) {
    const D = _.map((B) => (B.pixelDiff = Math.abs(B.width - n) + Math.abs(B.height - a), B));
    Ss(D, (B, P) => B.pixelDiff === P.pixelDiff ? P.bandwidth - B.bandwidth : B.pixelDiff - P.pixelDiff), A = D[0];
  }
  const L = A || M || p || g || c[0] || l[0];
  if (L && L.playlist) {
    let D = "sortedPlaylistReps";
    return A ? D = "leastPixelDiffRep" : M ? D = "resolutionPlusOneRep" : p ? D = "resolutionBestRep" : g ? D = "bandwidthBestRep" : c[0] && (D = "enabledPlaylistReps"), Pc(`choosing ${Mb(L)} using ${D} with options`, s), L.playlist;
  }
  return Pc("could not choose a playlist with options", s), null;
};
const Ob = function() {
  let t = this.useDevicePixelRatio && Y.devicePixelRatio || 1;
  return isNaN(this.customPixelRatio) || (t = this.customPixelRatio), Q_(this.playlists.main, this.systemBandwidth, parseInt(Ou(this.tech_.el(), "width"), 10) * t, parseInt(Ou(this.tech_.el(), "height"), 10) * t, this.limitRenditionByPlayerDimensions, this.playlistController_);
}, die = function(t) {
  let e = -1, n = -1;
  if (t < 0 || t > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    let a = this.useDevicePixelRatio && Y.devicePixelRatio || 1;
    return isNaN(this.customPixelRatio) || (a = this.customPixelRatio), e < 0 && (e = this.systemBandwidth, n = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== n && (e = t * this.systemBandwidth + (1 - t) * e, n = this.systemBandwidth), Q_(this.playlists.main, e, parseInt(Ou(this.tech_.el(), "width"), 10) * a, parseInt(Ou(this.tech_.el(), "height"), 10) * a, this.limitRenditionByPlayerDimensions, this.playlistController_);
  };
}, hie = function(t) {
  const {
    main: e,
    currentTime: n,
    bandwidth: a,
    duration: i,
    segmentDuration: r,
    timeUntilRebuffer: s,
    currentTimeline: o,
    syncController: l
  } = t, c = e.playlists.filter((x) => !Zn.isIncompatible(x));
  let d = c.filter(Zn.isEnabled);
  d.length || (d = c.filter((x) => !Zn.isDisabled(x)));
  const g = d.filter(Zn.hasAttribute.bind(null, "BANDWIDTH")).map((x) => {
    const w = l.getSyncPoint(x, i, o, n) ? 1 : 2, M = Zn.estimateSegmentRequestTime(r, a, x) * w - s;
    return {
      playlist: x,
      rebufferingImpact: M
    };
  }), _ = g.filter((x) => x.rebufferingImpact <= 0);
  return Ss(_, (x, p) => Lp(p.playlist, x.playlist)), _.length ? _[0] : (Ss(g, (x, p) => x.rebufferingImpact - p.rebufferingImpact), g[0] || null);
}, fie = function() {
  const t = this.playlists.main.playlists.filter(Zn.isEnabled);
  return Ss(t, (n, a) => Lp(n, a)), t.filter((n) => !!fl(this.playlists.main, n).video)[0] || null;
}, pie = (t) => {
  let e = 0, n;
  return t.bytes && (n = new Uint8Array(t.bytes), t.segments.forEach((a) => {
    n.set(a, e), e += a.byteLength;
  })), n;
};
function J_(t) {
  try {
    return new URL(t).pathname.split("/").slice(-2).join("/");
  } catch {
    return "";
  }
}
const mie = function(t, e, n) {
  if (!t[n]) {
    e.trigger({
      type: "usage",
      name: "vhs-608"
    });
    let a = n;
    /^cc708_/.test(n) && (a = "SERVICE" + n.split("_")[1]);
    const i = e.textTracks().getTrackById(a);
    if (i)
      t[n] = i;
    else {
      const r = e.options_.vhs && e.options_.vhs.captionServices || {};
      let s = n, o = n, l = !1;
      const c = r[a];
      c && (s = c.label, o = c.language, l = c.default), t[n] = e.addRemoteTextTrack({
        kind: "captions",
        id: a,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: l,
        label: s,
        language: o
      }, !1).track;
    }
  }
}, gie = function({
  inbandTextTracks: t,
  captionArray: e,
  timestampOffset: n
}) {
  if (!e)
    return;
  const a = Y.WebKitDataCue || Y.VTTCue;
  e.forEach((i) => {
    const r = i.stream;
    i.content ? i.content.forEach((s) => {
      const o = new a(i.startTime + n, i.endTime + n, s.text);
      o.line = s.line, o.align = "left", o.position = s.position, o.positionAlign = "line-left", t[r].addCue(o);
    }) : t[r].addCue(new a(i.startTime + n, i.endTime + n, i.text));
  });
}, bie = function(t) {
  Object.defineProperties(t.frame, {
    id: {
      get() {
        return le.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), t.value.key;
      }
    },
    value: {
      get() {
        return le.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), t.value.data;
      }
    },
    privateData: {
      get() {
        return le.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), t.value.data;
      }
    }
  });
}, vie = ({
  inbandTextTracks: t,
  metadataArray: e,
  timestampOffset: n,
  videoDuration: a
}) => {
  if (!e)
    return;
  const i = Y.WebKitDataCue || Y.VTTCue, r = t.metadataTrack_;
  if (!r || (e.forEach((d) => {
    const f = d.cueTime + n;
    typeof f != "number" || Y.isNaN(f) || f < 0 || !(f < 1 / 0) || !d.frames || !d.frames.length || d.frames.forEach((g) => {
      const _ = new i(f, f, g.value || g.url || g.data || "");
      _.frame = g, _.value = g, bie(_), r.addCue(_);
    });
  }), !r.cues || !r.cues.length))
    return;
  const s = r.cues, o = [];
  for (let d = 0; d < s.length; d++)
    s[d] && o.push(s[d]);
  const l = o.reduce((d, f) => {
    const g = d[f.startTime] || [];
    return g.push(f), d[f.startTime] = g, d;
  }, {}), c = Object.keys(l).sort((d, f) => Number(d) - Number(f));
  c.forEach((d, f) => {
    const g = l[d], _ = isFinite(a) ? a : d, x = Number(c[f + 1]) || _;
    g.forEach((p) => {
      p.endTime = x;
    });
  });
}, yie = {
  id: "ID",
  class: "CLASS",
  startDate: "START-DATE",
  duration: "DURATION",
  endDate: "END-DATE",
  endOnNext: "END-ON-NEXT",
  plannedDuration: "PLANNED-DURATION",
  scte35Out: "SCTE35-OUT",
  scte35In: "SCTE35-IN"
}, _ie = /* @__PURE__ */ new Set(["id", "class", "startDate", "duration", "endDate", "endOnNext", "startTime", "endTime", "processDateRange"]), xie = ({
  inbandTextTracks: t,
  dateRanges: e
}) => {
  const n = t.metadataTrack_;
  if (!n)
    return;
  const a = Y.WebKitDataCue || Y.VTTCue;
  e.forEach((i) => {
    for (const r of Object.keys(i)) {
      if (_ie.has(r))
        continue;
      const s = new a(i.startTime, i.endTime, "");
      s.id = i.id, s.type = "com.apple.quicktime.HLS", s.value = {
        key: yie[r],
        data: i[r]
      }, (r === "scte35Out" || r === "scte35In") && (s.value.data = new Uint8Array(s.value.data.match(/[\da-f]{2}/gi)).buffer), n.addCue(s);
    }
    i.processDateRange();
  });
}, Pb = (t, e, n) => {
  t.metadataTrack_ || (t.metadataTrack_ = n.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, le.browser.IS_ANY_SAFARI || (t.metadataTrack_.inBandMetadataTrackDispatchType = e));
}, tl = function(t, e, n) {
  let a, i;
  if (n && n.cues)
    for (a = n.cues.length; a--; )
      i = n.cues[a], i.startTime >= t && i.endTime <= e && n.removeCue(i);
}, Tie = function(t) {
  const e = t.cues;
  if (!e)
    return;
  const n = {};
  for (let a = e.length - 1; a >= 0; a--) {
    const i = e[a], r = `${i.startTime}-${i.endTime}-${i.text}`;
    n[r] ? t.removeCue(i) : n[r] = i;
  }
}, wie = (t, e, n) => {
  if (typeof e > "u" || e === null || !t.length)
    return [];
  const a = Math.ceil((e - n + 3) * wr.ONE_SECOND_IN_TS);
  let i;
  for (i = 0; i < t.length && !(t[i].pts > a); i++)
    ;
  return t.slice(i);
}, kie = (t, e, n) => {
  if (!e.length)
    return t;
  if (n)
    return e.slice();
  const a = e[0].pts;
  let i = 0;
  for (i; i < t.length && !(t[i].pts >= a); i++)
    ;
  return t.slice(0, i).concat(e);
}, Sie = (t, e, n, a) => {
  const i = Math.ceil((e - a) * wr.ONE_SECOND_IN_TS), r = Math.ceil((n - a) * wr.ONE_SECOND_IN_TS), s = t.slice();
  let o = t.length;
  for (; o-- && !(t[o].pts <= r); )
    ;
  if (o === -1)
    return s;
  let l = o + 1;
  for (; l-- && !(t[l].pts <= i); )
    ;
  return l = Math.max(l, 0), s.splice(l, o - l + 1), s;
}, Cie = function(t, e) {
  if (!t && !e || !t && e || t && !e)
    return !1;
  if (t === e)
    return !0;
  const n = Object.keys(t).sort(), a = Object.keys(e).sort();
  if (n.length !== a.length)
    return !1;
  for (let i = 0; i < n.length; i++) {
    const r = n[i];
    if (r !== a[i] || t[r] !== e[r])
      return !1;
  }
  return !0;
}, Aie = function(t, e, n) {
  e = e || [];
  const a = [];
  let i = 0;
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    if (t === s.timeline && (a.push(r), i += s.duration, i > n))
      return r;
  }
  return a.length === 0 ? 0 : a[a.length - 1];
}, qo = 1, Eie = 500, Bb = (t) => typeof t == "number" && isFinite(t), Bc = 1 / 60, Lie = (t, e, n) => t !== "main" || !e || !n ? null : !n.hasAudio && !n.hasVideo ? "Neither audio nor video found in segment." : e.hasVideo && !n.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !e.hasVideo && n.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, Die = (t, e, n) => {
  let a = e - mn.BACK_BUFFER_LENGTH;
  t.length && (a = Math.max(a, t.start(0)));
  const i = e - n;
  return Math.min(i, a);
}, os = (t) => {
  const {
    startOfSegment: e,
    duration: n,
    segment: a,
    part: i,
    playlist: {
      mediaSequence: r,
      id: s,
      segments: o = []
    },
    mediaIndex: l,
    partIndex: c,
    timeline: d
  } = t, f = o.length - 1;
  let g = "mediaIndex/partIndex increment";
  t.getMediaInfoForTime ? g = `getMediaInfoForTime (${t.getMediaInfoForTime})` : t.isSyncRequest && (g = "getSyncSegmentCandidate (isSyncRequest)"), t.independent && (g += ` with independent ${t.independent}`);
  const _ = typeof c == "number", x = t.segment.uri ? "segment" : "pre-segment", p = _ ? v_({
    preloadSegment: a
  }) - 1 : 0;
  return `${x} [${r + l}/${r + f}]` + (_ ? ` part [${c}/${p}]` : "") + ` segment start/end [${a.start} => ${a.end}]` + (_ ? ` part start/end [${i.start} => ${i.end}]` : "") + ` startOfSegment [${e}] duration [${n}] timeline [${d}] selected by [${g}] playlist [${s}]`;
}, Rb = (t) => `${t}TimingInfo`, Iie = ({
  segmentTimeline: t,
  currentTimeline: e,
  startOfSegment: n,
  buffered: a,
  overrideCheck: i
}) => !i && t === e ? null : t < e ? n : a.length ? a.end(a.length - 1) : n, Oh = ({
  timelineChangeController: t,
  currentTimeline: e,
  segmentTimeline: n,
  loaderType: a,
  audioDisabled: i
}) => {
  if (e === n)
    return !1;
  if (a === "audio") {
    const r = t.lastTimelineChange({
      type: "main"
    });
    return !r || r.to !== n;
  }
  if (a === "main" && i) {
    const r = t.pendingTimelineChange({
      type: "audio"
    });
    return !(r && r.to === n);
  }
  return !1;
}, Mie = (t) => {
  if (!t)
    return !1;
  const e = t.pendingTimelineChange({
    type: "audio"
  }), n = t.pendingTimelineChange({
    type: "main"
  }), a = e && n, i = a && e.to !== n.to;
  return !!(a && e.from !== -1 && n.from !== -1 && i);
}, Oie = (t) => {
  const e = t.timelineChangeController_.pendingTimelineChange({
    type: "audio"
  }), n = t.timelineChangeController_.pendingTimelineChange({
    type: "main"
  });
  return e && n && e.to < n.to;
}, Ui = (t) => {
  const e = t.pendingSegment_;
  if (!e)
    return;
  if (Oh({
    timelineChangeController: t.timelineChangeController_,
    currentTimeline: t.currentTimeline_,
    segmentTimeline: e.timeline,
    loaderType: t.loaderType_,
    audioDisabled: t.audioDisabled_
  }) && Mie(t.timelineChangeController_)) {
    if (Oie(t)) {
      t.timelineChangeController_.trigger("audioTimelineBehind");
      return;
    }
    t.timelineChangeController_.trigger("fixBadTimelineChange");
  }
}, Pie = (t) => {
  let e = 0;
  return ["video", "audio"].forEach(function(n) {
    const a = t[`${n}TimingInfo`];
    if (!a)
      return;
    const {
      start: i,
      end: r
    } = a;
    let s;
    typeof i == "bigint" || typeof r == "bigint" ? s = Y.BigInt(r) - Y.BigInt(i) : typeof i == "number" && typeof r == "number" && (s = r - i), typeof s < "u" && s > e && (e = s);
  }), typeof e == "bigint" && e < Number.MAX_SAFE_INTEGER && (e = Number(e)), e;
}, Nb = ({
  segmentDuration: t,
  maxDuration: e
}) => t ? Math.round(t) > e + Za : !1, Bie = (t, e) => {
  if (e !== "hls")
    return null;
  const n = Pie({
    audioTimingInfo: t.audioTimingInfo,
    videoTimingInfo: t.videoTimingInfo
  });
  if (!n)
    return null;
  const a = t.playlist.targetDuration, i = Nb({
    segmentDuration: n,
    maxDuration: a * 2
  }), r = Nb({
    segmentDuration: n,
    maxDuration: a
  }), s = `Segment with index ${t.mediaIndex} from playlist ${t.playlist.id} has a duration of ${n} when the reported duration is ${t.duration} and the target duration is ${a}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
  return i || r ? {
    severity: i ? "warn" : "info",
    message: s
  } : null;
}, yr = ({
  type: t,
  segment: e
}) => {
  if (!e)
    return;
  const n = !!(e.key || e.map && e.map.ke), a = !!(e.map && !e.map.bytes), i = e.startOfSegment === void 0 ? e.start : e.startOfSegment;
  return {
    type: t || e.type,
    uri: e.resolvedUri || e.uri,
    start: i,
    duration: e.duration,
    isEncrypted: n,
    isMediaInitialization: a
  };
};
class Ph extends le.EventTarget {
  constructor(e, n = {}) {
    if (super(), !e)
      throw new TypeError("Initialization settings are required");
    if (typeof e.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!e.mediaSource)
      throw new TypeError("No MediaSource specified");
    this.bandwidth = e.bandwidth, this.throughput = {
      rate: 0,
      count: 0
    }, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
      id3: [],
      caption: []
    }, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
      this.isEndOfStream_() || (this.ended_ = !1);
    }), this.fetchAtBuffer_ = !1, this.logger_ = Ta(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
      get() {
        return this.state_;
      },
      set(a) {
        a !== this.state_ && (this.logger_(`${this.state_} -> ${a}`), this.state_ = a, this.trigger("statechange"));
      }
    }), this.sourceUpdater_.on("ready", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : Ui(this);
    }), this.sourceUpdater_.on("codecschange", (a) => {
      this.trigger(Jt({
        type: "codecschange"
      }, a));
    }), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : Ui(this);
    }), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (a) => {
      this.trigger(Jt({
        type: "timelinechange"
      }, a)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : Ui(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : Ui(this);
    });
  }
  /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */
  get mediaSequenceSync_() {
    return this.syncController_.getMediaSequenceSync(this.loaderType_);
  }
  createTransmuxer_() {
    return R0.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }
  /**
   * reset all of our media stats
   *
   * @private
   */
  resetStats_() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }
  /**
   * dispose of the SegmentLoader and reset to the default state
   */
  dispose() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && Y.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }
  setAudio(e) {
    this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }
  /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */
  abort() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null), this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }
  /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */
  abort_() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, Y.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }
  checkForAbort_(e) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
  }
  /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */
  error(e) {
    return typeof e < "u" && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
  }
  endOfStream() {
    this.ended_ = !0, this.transmuxer_ && R0.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    const e = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !e)
      return vn();
    if (this.loaderType_ === "main") {
      const {
        hasAudio: n,
        hasVideo: a,
        isMuxed: i
      } = e;
      if (a && n && !this.audioDisabled_ && !i)
        return this.sourceUpdater_.buffered();
      if (a)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, n = !1) {
    if (!e)
      return null;
    const a = Iu(e);
    let i = this.initSegments_[a];
    return n && !i && e.bytes && (this.initSegments_[a] = i = {
      resolvedUri: e.resolvedUri,
      byterange: e.byterange,
      bytes: e.bytes,
      tracks: e.tracks,
      timescales: e.timescales
    }), i || e;
  }
  /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */
  segmentKey(e, n = !1) {
    if (!e)
      return null;
    const a = B_(e);
    let i = this.keyCache_[a];
    this.cacheEncryptionKeys_ && n && !i && e.bytes && (this.keyCache_[a] = i = {
      resolvedUri: e.resolvedUri,
      bytes: e.bytes
    });
    const r = {
      resolvedUri: (i || e).resolvedUri
    };
    return i && (r.bytes = i.bytes), r;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  }
  /**
   * load a playlist and start to fill the buffer
   */
  load() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */
  playlist(e, n = {}) {
    if (!e || this.playlist_ && this.playlist_.endList && e.endList && this.playlist_.uri === e.uri)
      return;
    const a = this.playlist_, i = this.pendingSegment_;
    this.playlist_ = e, this.xhrOptions_ = n, this.state === "INIT" && (e.syncInfo = {
      mediaSequence: e.mediaSequence,
      time: 0
    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
    let r = null;
    if (a && (a.id ? r = a.id : a.uri && (r = a.uri)), this.logger_(`playlist update [${r} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${P0(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
      return this.init_();
    if (!a || a.uri !== e.uri) {
      this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
      return;
    }
    const s = e.mediaSequence - a.mediaSequence;
    if (this.logger_(`live window shift [${s}]`), this.mediaIndex !== null)
      if (this.mediaIndex -= s, this.mediaIndex < 0)
        this.mediaIndex = null, this.partIndex = null;
      else {
        const o = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!o.parts || !o.parts.length || !o.parts[this.partIndex])) {
          const l = this.mediaIndex;
          this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = l;
        }
      }
    i && (i.mediaIndex -= s, i.mediaIndex < 0 ? (i.mediaIndex = null, i.partIndex = null) : (i.mediaIndex >= 0 && (i.segment = e.segments[i.mediaIndex]), i.partIndex >= 0 && i.segment.parts && (i.part = i.segment.parts[i.partIndex]))), this.syncController_.saveExpiredSegmentInfo(a, e);
  }
  /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */
  pause() {
    this.checkBufferTimeout_ && (Y.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }
  /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */
  paused() {
    return this.checkBufferTimeout_ === null;
  }
  /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */
  resetEverything(e) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, e), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }
  /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */
  resetLoader() {
    this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
  }
  /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */
  resyncLoader() {
    this.transmuxer_ && R0.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
    const e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
    this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */
  remove(e, n, a = () => {
  }, i = !1) {
    if (n === 1 / 0 && (n = this.duration_()), n <= e) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    let r = 1;
    const s = () => {
      r--, r === 0 && a();
    };
    (i || !this.audioDisabled_) && (r++, this.sourceUpdater_.removeAudio(e, n, s)), (i || this.loaderType_ === "main") && (this.gopBuffer_ = Sie(this.gopBuffer_, e, n, this.timeMapping_), r++, this.sourceUpdater_.removeVideo(e, n, s));
    for (const o in this.inbandTextTracks_)
      tl(e, n, this.inbandTextTracks_[o]);
    tl(e, n, this.segmentMetadataTrack_), s();
  }
  /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */
  monitorBuffer_() {
    this.checkBufferTimeout_ && Y.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Y.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }
  /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */
  monitorBufferTick_() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && Y.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Y.setTimeout(this.monitorBufferTick_.bind(this), Eie);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    if (this.sourceUpdater_.updating())
      return;
    const e = this.chooseNextRequest_();
    if (!e)
      return;
    const n = {
      segmentInfo: yr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentselected",
      metadata: n
    }), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    })), this.loadSegment_(e);
  }
  /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */
  isEndOfStream_(e = this.mediaIndex, n = this.playlist_, a = this.partIndex) {
    if (!n || !this.mediaSource_)
      return !1;
    const i = typeof e == "number" && n.segments[e], r = e + 1 === n.segments.length, s = !i || !i.parts || a + 1 === i.parts.length;
    return n.endList && this.mediaSource_.readyState === "open" && r && s;
  }
  /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */
  chooseNextRequest_() {
    const e = this.buffered_(), n = P0(e) || 0, a = kp(e, this.currentTime_()), i = !this.hasPlayed_() && a >= 1, r = a >= this.goalBufferLength_(), s = this.playlist_.segments;
    if (!s.length || i || r)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
    const o = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (o.isSyncRequest)
      o.mediaIndex = Aie(this.currentTimeline_, s, n), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
    else if (this.mediaIndex !== null) {
      const g = s[this.mediaIndex], _ = typeof this.partIndex == "number" ? this.partIndex : -1;
      o.startOfSegment = g.end ? g.end : n, g.parts && g.parts[_ + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = _ + 1) : o.mediaIndex = this.mediaIndex + 1;
    } else {
      let g, _, x;
      const p = this.fetchAtBuffer_ ? n : this.currentTime_();
      if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${p}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${n}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
        const w = this.getSyncInfoFromMediaSequenceSync_(p);
        if (!w) {
          const C = "No sync info found while using media sequence sync";
          return this.error({
            message: C,
            metadata: {
              errorType: le.Error.StreamingFailedToSelectNextSegment,
              error: new Error(C)
            }
          }), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
        }
        this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${w.start} --> ${w.end})`), g = w.segmentIndex, _ = w.partIndex, x = w.start;
      } else {
        this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
        const w = Zn.getMediaInfoForTime({
          exactManifestTimings: this.exactManifestTimings,
          playlist: this.playlist_,
          currentTime: p,
          startingPartIndex: this.syncPoint_.partIndex,
          startingSegmentIndex: this.syncPoint_.segmentIndex,
          startTime: this.syncPoint_.time
        });
        g = w.segmentIndex, _ = w.partIndex, x = w.startTime;
      }
      o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${p}` : `currentTime ${p}`, o.mediaIndex = g, o.startOfSegment = x, o.partIndex = _, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
    }
    const l = s[o.mediaIndex];
    let c = l && typeof o.partIndex == "number" && l.parts && l.parts[o.partIndex];
    if (!l || typeof o.partIndex == "number" && !c)
      return null;
    typeof o.partIndex != "number" && l.parts && (o.partIndex = 0, c = l.parts[0]);
    const d = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
    if (!a && c && !d && !c.independent)
      if (o.partIndex === 0) {
        const g = s[o.mediaIndex - 1], _ = g.parts && g.parts.length && g.parts[g.parts.length - 1];
        _ && _.independent && (o.mediaIndex -= 1, o.partIndex = g.parts.length - 1, o.independent = "previous segment");
      } else l.parts[o.partIndex - 1].independent && (o.partIndex -= 1, o.independent = "previous part");
    const f = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return o.mediaIndex >= s.length - 1 && f && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
  }
  getSyncInfoFromMediaSequenceSync_(e) {
    if (!this.mediaSequenceSync_)
      return null;
    const n = Math.max(e, this.mediaSequenceSync_.start);
    e !== n && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${n}`);
    const a = this.mediaSequenceSync_.getSyncInfoForTime(n);
    if (!a)
      return null;
    if (!a.isAppended)
      return a;
    const i = this.mediaSequenceSync_.getSyncInfoForTime(a.end);
    return i ? (i.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), i) : null;
  }
  generateSegmentInfo_(e) {
    const {
      independent: n,
      playlist: a,
      mediaIndex: i,
      startOfSegment: r,
      isSyncRequest: s,
      partIndex: o,
      forceTimestampOffset: l,
      getMediaInfoForTime: c
    } = e, d = a.segments[i], f = typeof o == "number" && d.parts[o], g = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: f && f.resolvedUri || d.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: i,
      partIndex: f ? o : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: s,
      startOfSegment: r,
      // the segment's playlist
      playlist: a,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: d.timeline,
      // The expected duration of the segment in seconds
      duration: f && f.duration || d.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: d,
      part: f,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: c,
      independent: n
    }, _ = typeof l < "u" ? l : this.isPendingTimestampOffset_;
    g.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: d.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: r,
      buffered: this.buffered_(),
      overrideCheck: _
    });
    const x = P0(this.sourceUpdater_.audioBuffered());
    return typeof x == "number" && (g.audioAppendStart = x - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (g.gopsToAlignWith = wie(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), g;
  }
  // get the timestampoffset for a segment,
  // added so that vtt segment loader can override and prevent
  // adding timestamp offsets.
  timestampOffsetForSegment_(e) {
    return Iie(e);
  }
  /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */
  earlyAbortWhenNeeded_(e) {
    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3)
      return;
    const n = this.currentTime_(), a = e.bandwidth, i = this.pendingSegment_.duration, r = Zn.estimateSegmentRequestTime(i, a, this.playlist_, e.bytesReceived), s = Qne(this.buffered_(), n, this.vhs_.tech_.playbackRate()) - 1;
    if (r <= s)
      return;
    const o = hie({
      main: this.vhs_.playlists.main,
      currentTime: n,
      bandwidth: a,
      duration: this.duration_(),
      segmentDuration: i,
      timeUntilRebuffer: s,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!o)
      return;
    const c = r - s - o.rebufferingImpact;
    let d = 0.5;
    s <= Za && (d = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || c < d) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * mn.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
  }
  handleAbort_(e) {
    this.logger_(`Aborting ${os(e)}`), this.mediaRequestsAborted += 1;
  }
  /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */
  handleProgress_(e, n) {
    this.earlyAbortWhenNeeded_(n.stats), !this.checkForAbort_(n.requestId) && this.trigger("progress");
  }
  handleTrackInfo_(e, n) {
    const {
      hasAudio: a,
      hasVideo: i
    } = n, r = {
      segmentInfo: yr({
        type: this.loaderType_,
        segment: e
      }),
      trackInfo: {
        hasAudio: a,
        hasVideo: i
      }
    };
    this.trigger({
      type: "segmenttransmuxingtrackinfoavailable",
      metadata: r
    }), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(n) || (n = n || {}, Cie(this.currentMediaInfo_, n) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = n, this.currentMediaInfo_ = n, this.logger_("trackinfo update", n), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = n, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : Ui(this))));
  }
  handleTimingInfo_(e, n, a, i) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    const r = this.pendingSegment_, s = Rb(n);
    r[s] = r[s] || {}, r[s][a] = i, this.logger_(`timinginfo: ${n} - ${a} - ${i}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : Ui(this);
  }
  handleCaptions_(e, n) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (n.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, n));
      return;
    }
    const i = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), r = {};
    n.forEach((s) => {
      r[s.stream] = r[s.stream] || {
        // Infinity, as any other value will be less than this
        startTime: 1 / 0,
        captions: [],
        // 0 as an other value will be more than this
        endTime: 0
      };
      const o = r[s.stream];
      o.startTime = Math.min(o.startTime, s.startTime + i), o.endTime = Math.max(o.endTime, s.endTime + i), o.captions.push(s);
    }), Object.keys(r).forEach((s) => {
      const {
        startTime: o,
        endTime: l,
        captions: c
      } = r[s], d = this.inbandTextTracks_;
      this.logger_(`adding cues from ${o} -> ${l} for ${s}`), mie(d, this.vhs_.tech_, s), tl(o, l, d[s]), gie({
        captionArray: c,
        inbandTextTracks: d,
        timestampOffset: i
      });
    }), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  handleId3_(e, n, a) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, n, a));
      return;
    }
    this.addMetadataToTextTrack(a, n, this.duration_());
  }
  processMetadataQueue_() {
    this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }
  processCallQueue_() {
    const e = this.callQueue_;
    this.callQueue_ = [], e.forEach((n) => n());
  }
  processLoadQueue_() {
    const e = this.loadQueue_;
    this.loadQueue_ = [], e.forEach((n) => n());
  }
  /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */
  hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio")
      return !0;
    const e = this.pendingSegment_;
    return e ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !Oh({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: e.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }
  getCurrentMediaInfo_(e = this.pendingSegment_) {
    return e && e.trackInfo || this.currentMediaInfo_;
  }
  getMediaInfo_(e = this.pendingSegment_) {
    return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
  }
  getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }
  hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    const e = this.pendingSegment_, n = this.getCurrentMediaInfo_();
    if (!e || !n)
      return !1;
    const {
      hasAudio: a,
      hasVideo: i,
      isMuxed: r
    } = n;
    return !(i && !e.videoTimingInfo || a && !this.audioDisabled_ && !r && !e.audioTimingInfo || Oh({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: e.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }
  handleData_(e, n) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      Ui(this), this.callQueue_.push(this.handleData_.bind(this, e, n));
      return;
    }
    const a = this.pendingSegment_;
    if (this.setTimeMapping_(a.timeline), this.updateMediaSecondsLoaded_(a.part || a.segment), this.mediaSource_.readyState !== "closed") {
      if (e.map && (e.map = this.initSegmentForMap(e.map, !0), a.segment.map = e.map), e.key && this.segmentKey(e.key, !0), a.isFmp4 = e.isFmp4, a.timingInfo = a.timingInfo || {}, a.isFmp4)
        this.trigger("fmp4"), a.timingInfo.start = a[Rb(n.type)].start;
      else {
        const i = this.getCurrentMediaInfo_(), r = this.loaderType_ === "main" && i && i.hasVideo;
        let s;
        r && (s = a.videoTimingInfo.start), a.timingInfo.start = this.trueSegmentStart_({
          currentStart: a.timingInfo.start,
          playlist: a.playlist,
          mediaIndex: a.mediaIndex,
          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
          useVideoTimingInfo: r,
          firstVideoFrameTimeForData: s,
          videoTimingInfo: a.videoTimingInfo,
          audioTimingInfo: a.audioTimingInfo
        });
      }
      if (this.updateAppendInitSegmentStatus(a, n.type), this.updateSourceBufferTimestampOffset_(a), a.isSyncRequest) {
        this.updateTimingInfoEnd_(a), this.syncController_.saveSegmentTimingInfo({
          segmentInfo: a,
          shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const i = this.chooseNextRequest_();
        if (i.mediaIndex !== a.mediaIndex || i.partIndex !== a.partIndex) {
          this.logger_("sync segment was incorrect, not appending");
          return;
        }
        this.logger_("sync segment was correct, appending");
      }
      a.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(a, n);
    }
  }
  updateAppendInitSegmentStatus(e, n) {
    this.loaderType_ === "main" && typeof e.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !e.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[n] !== e.playlist && (this.appendInitSegment_[n] = !0);
  }
  getInitSegmentAndUpdateState_({
    type: e,
    initSegment: n,
    map: a,
    playlist: i
  }) {
    if (a) {
      const r = Iu(a);
      if (this.activeInitSegmentId_ === r)
        return null;
      n = this.initSegmentForMap(a, !0).bytes, this.activeInitSegmentId_ = r;
    }
    return n && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = i, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, n) : null;
  }
  handleQuotaExceededError_({
    segmentInfo: e,
    type: n,
    bytes: a
  }, i) {
    const r = this.sourceUpdater_.audioBuffered(), s = this.sourceUpdater_.videoBuffered();
    r.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + kr(r).join(", ")), s.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + kr(s).join(", "));
    const o = r.length ? r.start(0) : 0, l = r.length ? r.end(r.length - 1) : 0, c = s.length ? s.start(0) : 0, d = s.length ? s.end(s.length - 1) : 0;
    if (l - o <= qo && d - c <= qo) {
      this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${a.byteLength}, audio buffer: ${kr(r).join(", ")}, video buffer: ${kr(s).join(", ")}, `), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: e,
      type: n,
      bytes: a
    }));
    const g = this.currentTime_() - qo;
    this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${g}`), this.remove(0, g, () => {
      this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${qo}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = Y.setTimeout(() => {
        this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
      }, qo * 1e3);
    }, !0);
  }
  handleAppendError_({
    segmentInfo: e,
    type: n,
    bytes: a
  }, i) {
    if (i) {
      if (i.code === L_) {
        this.handleQuotaExceededError_({
          segmentInfo: e,
          type: n,
          bytes: a
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", i), this.error({
        message: `${n} append of ${a.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
        metadata: {
          errorType: le.Error.StreamingFailedToAppendSegment
        }
      }), this.trigger("appenderror");
    }
  }
  appendToSourceBuffer_({
    segmentInfo: e,
    type: n,
    initSegment: a,
    data: i,
    bytes: r
  }) {
    if (!r) {
      const o = [i];
      let l = i.byteLength;
      a && (o.unshift(a), l += a.byteLength), r = pie({
        bytes: l,
        segments: o
      });
    }
    const s = {
      segmentInfo: yr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentappendstart",
      metadata: s
    }), this.sourceUpdater_.appendBuffer({
      segmentInfo: e,
      type: n,
      bytes: r
    }, this.handleAppendError_.bind(this, {
      segmentInfo: e,
      type: n,
      bytes: r
    }));
  }
  handleSegmentTimingInfo_(e, n, a) {
    if (!this.pendingSegment_ || n !== this.pendingSegment_.requestId)
      return;
    const i = this.pendingSegment_.segment, r = `${e}TimingInfo`;
    i[r] || (i[r] = {}), i[r].transmuxerPrependedSeconds = a.prependedContentDuration || 0, i[r].transmuxedPresentationStart = a.start.presentation, i[r].transmuxedDecodeStart = a.start.decode, i[r].transmuxedPresentationEnd = a.end.presentation, i[r].transmuxedDecodeEnd = a.end.decode, i[r].baseMediaDecodeTime = a.baseMediaDecodeTime;
  }
  appendData_(e, n) {
    const {
      type: a,
      data: i
    } = n;
    if (!i || !i.byteLength || a === "audio" && this.audioDisabled_)
      return;
    const r = this.getInitSegmentAndUpdateState_({
      type: a,
      initSegment: n.initSegment,
      playlist: e.playlist,
      map: e.isFmp4 ? e.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo: e,
      type: a,
      initSegment: r,
      data: i
    });
  }
  /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */
  loadSegment_(e) {
    if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      Ui(this), this.loadQueue_.push(() => {
        const n = Jt({}, e, {
          forceTimestampOffset: !0
        });
        Jt(e, this.generateSegmentInfo_(n)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(e);
  }
  updateTransmuxerAndRequestSegment_(e) {
    this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: e.timestampOffset
    }));
    const n = this.createSimplifiedSegmentObj_(e), a = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), i = this.mediaIndex !== null, r = e.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    e.timeline > 0, s = a || i && r;
    this.logger_(`Requesting
${J_(e.uri)}
${os(e)}`), n.map && !n.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), e.abortRequests = sie({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: n,
      abortFn: this.handleAbort_.bind(this, e),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: s,
      endedTimelineFn: () => {
        this.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: ({
        message: o,
        level: l,
        stream: c
      }) => {
        this.logger_(`${os(e)} logged from transmuxer stream ${c} as a ${l}: ${o}`);
      },
      triggerSegmentEventFn: ({
        type: o,
        segment: l,
        keyInfo: c,
        trackInfo: d,
        timingInfo: f
      }) => {
        const _ = {
          segmentInfo: yr({
            segment: l
          })
        };
        c && (_.keyInfo = c), d && (_.trackInfo = d), f && (_.timingInfo = f), this.trigger({
          type: o,
          metadata: _
        });
      }
    });
  }
  /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */
  trimBackBuffer_(e) {
    const n = Die(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    n > 0 && this.remove(0, n);
  }
  /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */
  createSimplifiedSegmentObj_(e) {
    const n = e.segment, a = e.part, i = e.segment.key || e.segment.map && e.segment.map.key, r = e.segment.map && !e.segment.map.bytes, s = {
      resolvedUri: a ? a.resolvedUri : n.resolvedUri,
      byterange: a ? a.byterange : n.byterange,
      requestId: e.requestId,
      transmuxer: e.transmuxer,
      audioAppendStart: e.audioAppendStart,
      gopsToAlignWith: e.gopsToAlignWith,
      part: e.part,
      type: this.loaderType_,
      start: e.startOfSegment,
      duration: e.duration,
      isEncrypted: i,
      isMediaInitialization: r
    }, o = e.playlist.segments[e.mediaIndex - 1];
    if (o && o.timeline === n.timeline && (o.videoTimingInfo ? s.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (s.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), n.key) {
      const l = n.key.iv || new Uint32Array([0, 0, 0, e.mediaIndex + e.playlist.mediaSequence]);
      s.key = this.segmentKey(n.key), s.key.iv = l;
    }
    return n.map && (s.map = this.initSegmentForMap(n.map)), s;
  }
  saveTransferStats_(e) {
    this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
  }
  saveBandwidthRelatedStats_(e, n) {
    if (this.pendingSegment_.byteLength = n.bytesReceived, e < Bc) {
      this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${Bc}`);
      return;
    }
    const a = {
      bandwidthInfo: {
        from: this.bandwidth,
        to: n.bandwidth
      }
    };
    this.trigger({
      type: "bandwidthupdated",
      metadata: a
    }), this.bandwidth = n.bandwidth, this.roundTrip = n.roundTripTime;
  }
  handleTimeout_() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }
  /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */
  segmentRequestFinished_(e, n, a) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, n, a));
      return;
    }
    if (this.saveTransferStats_(n.stats), !this.pendingSegment_ || n.requestId !== this.pendingSegment_.requestId)
      return;
    if (e) {
      if (this.pendingSegment_ = null, this.state = "READY", e.code === Qa.ABORTED)
        return;
      if (this.pause(), e.code === Qa.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
      return;
    }
    const i = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(i.duration, n.stats), i.endOfAllRequests = n.endOfAllRequests, a.gopInfo && (this.gopBuffer_ = kie(this.gopBuffer_, a.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(i);
  }
  setTimeMapping_(e) {
    const n = this.syncController_.mappingForTimeline(e);
    n !== null && (this.timeMapping_ = n);
  }
  updateMediaSecondsLoaded_(e) {
    typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
  }
  shouldUpdateTransmuxerTimestampOffset_(e) {
    return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
  }
  trueSegmentStart_({
    currentStart: e,
    playlist: n,
    mediaIndex: a,
    firstVideoFrameTimeForData: i,
    currentVideoTimestampOffset: r,
    useVideoTimingInfo: s,
    videoTimingInfo: o,
    audioTimingInfo: l
  }) {
    if (typeof e < "u")
      return e;
    if (!s)
      return l.start;
    const c = n.segments[a - 1];
    return a === 0 || !c || typeof c.start > "u" || c.end !== i + r ? i : o.start;
  }
  waitForAppendsToComplete_(e) {
    const n = this.getCurrentMediaInfo_(e);
    if (!n) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        playlistExclusionDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    const {
      hasAudio: a,
      hasVideo: i,
      isMuxed: r
    } = n, s = this.loaderType_ === "main" && i, o = !this.audioDisabled_ && a && !r;
    if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
      !e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = {
        start: 0
      }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
      return;
    }
    s && e.waitingOnAppends++, o && e.waitingOnAppends++, s && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
  }
  checkAppendsDone_(e) {
    this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
  }
  checkForIllegalMediaSwitch(e) {
    const n = Lie(this.loaderType_, this.getCurrentMediaInfo_(), e);
    return n ? (this.error({
      message: n,
      playlistExclusionDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }
  updateSourceBufferTimestampOffset_(e) {
    if (e.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof e.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    e.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")
      return;
    let n = !1;
    e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: e.segment.videoTimingInfo,
      audioTimingInfo: e.segment.audioTimingInfo,
      timingInfo: e.timingInfo
    }), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), n = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), n = !0), n && this.trigger("timestampoffset");
  }
  getSegmentStartTimeForTimestampOffsetCalculation_({
    videoTimingInfo: e,
    audioTimingInfo: n,
    timingInfo: a
  }) {
    return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : n && typeof n.transmuxedDecodeStart == "number" ? n.transmuxedDecodeStart : a.start : a.start;
  }
  updateTimingInfoEnd_(e) {
    e.timingInfo = e.timingInfo || {};
    const n = this.getMediaInfo_(), i = this.loaderType_ === "main" && n && n.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
    i && (e.timingInfo.end = typeof i.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      i.end
    ) : i.start + e.duration);
  }
  /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */
  handleAppendsDone_() {
    if (this.pendingSegment_) {
      const l = {
        segmentInfo: yr({
          type: this.loaderType_,
          segment: this.pendingSegment_
        })
      };
      this.trigger({
        type: "appendsdone",
        metadata: l
      });
    }
    if (!this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    const e = this.pendingSegment_;
    e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: e,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    const n = Bie(e, this.sourceType_);
    if (n && (n.severity === "warn" ? le.log.warn(n.message) : this.logger_(n.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
      this.logger_(`Throwing away un-appended sync request ${os(e)}`);
      return;
    }
    this.logger_(`Appended ${os(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: e.timeline
    })), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
    const a = e.segment, i = e.part, r = a.end && this.currentTime_() - a.end > e.playlist.targetDuration * 3, s = i && i.end && this.currentTime_() - i.end > e.playlist.partTargetDuration * 3;
    if (r || s) {
      this.logger_(`bad ${r ? "segment" : "part"} ${os(e)}`), this.resetEverything();
      return;
    }
    this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }
  /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */
  recordThroughput_(e) {
    if (e.duration < Bc) {
      this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${Bc}`);
      return;
    }
    const n = this.throughput.rate, a = Date.now() - e.endOfAllRequests + 1, i = Math.floor(e.byteLength / a * 8 * 1e3);
    this.throughput.rate += (i - n) / ++this.throughput.count;
  }
  /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */
  addSegmentMetadataCue_(e) {
    if (!this.segmentMetadataTrack_)
      return;
    const n = e.segment, a = n.start, i = n.end;
    if (!Bb(a) || !Bb(i))
      return;
    tl(a, i, this.segmentMetadataTrack_);
    const r = Y.WebKitDataCue || Y.VTTCue, s = {
      custom: n.custom,
      dateTimeObject: n.dateTimeObject,
      dateTimeString: n.dateTimeString,
      programDateTime: n.programDateTime,
      bandwidth: e.playlist.attributes.BANDWIDTH,
      resolution: e.playlist.attributes.RESOLUTION,
      codecs: e.playlist.attributes.CODECS,
      byteLength: e.byteLength,
      uri: e.uri,
      timeline: e.timeline,
      playlist: e.playlist.id,
      start: a,
      end: i
    }, o = JSON.stringify(s), l = new r(a, i, o);
    l.value = s, this.segmentMetadataTrack_.addCue(l);
  }
}
function gi() {
}
const ex = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, Rie = ["video", "audio"], Bh = (t, e) => {
  const n = e[`${t}Buffer`];
  return n && n.updating || e.queuePending[t];
}, Nie = (t, e) => {
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a.type === "mediaSource")
      return null;
    if (a.type === t)
      return n;
  }
  return null;
}, Cs = (t, e) => {
  if (e.queue.length === 0)
    return;
  let n = 0, a = e.queue[n];
  if (a.type === "mediaSource") {
    !e.updating() && e.mediaSource.readyState !== "closed" && (e.queue.shift(), a.action(e), a.doneFn && a.doneFn(), Cs("audio", e), Cs("video", e));
    return;
  }
  if (t !== "mediaSource" && !(!e.ready() || e.mediaSource.readyState === "closed" || Bh(t, e))) {
    if (a.type !== t) {
      if (n = Nie(t, e.queue), n === null)
        return;
      a = e.queue[n];
    }
    if (e.queue.splice(n, 1), e.queuePending[t] = a, a.action(t, e), !a.doneFn) {
      e.queuePending[t] = null, Cs(t, e);
      return;
    }
  }
}, tx = (t, e) => {
  const n = e[`${t}Buffer`], a = ex(t);
  n && (n.removeEventListener("updateend", e[`on${a}UpdateEnd_`]), n.removeEventListener("error", e[`on${a}Error_`]), e.codecs[t] = null, e[`${t}Buffer`] = null);
}, Va = (t, e) => t && e && Array.prototype.indexOf.call(t.sourceBuffers, e) !== -1, ia = {
  appendBuffer: (t, e, n) => (a, i) => {
    const r = i[`${a}Buffer`];
    if (Va(i.mediaSource, r)) {
      i.logger_(`Appending segment ${e.mediaIndex}'s ${t.length} bytes to ${a}Buffer`);
      try {
        r.appendBuffer(t);
      } catch (s) {
        i.logger_(`Error with code ${s.code} ` + (s.code === L_ ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${e.mediaIndex} to ${a}Buffer`), i.queuePending[a] = null, n(s);
      }
    }
  },
  remove: (t, e) => (n, a) => {
    const i = a[`${n}Buffer`];
    if (Va(a.mediaSource, i)) {
      a.logger_(`Removing ${t} to ${e} from ${n}Buffer`);
      try {
        i.remove(t, e);
      } catch {
        a.logger_(`Remove ${t} to ${e} from ${n}Buffer failed`);
      }
    }
  },
  timestampOffset: (t) => (e, n) => {
    const a = n[`${e}Buffer`];
    Va(n.mediaSource, a) && (n.logger_(`Setting ${e}timestampOffset to ${t}`), a.timestampOffset = t);
  },
  callback: (t) => (e, n) => {
    t();
  },
  endOfStream: (t) => (e) => {
    if (e.mediaSource.readyState === "open") {
      e.logger_(`Calling mediaSource endOfStream(${t || ""})`);
      try {
        e.mediaSource.endOfStream(t);
      } catch (n) {
        le.log.warn("Failed to call media source endOfStream", n);
      }
    }
  },
  duration: (t) => (e) => {
    e.logger_(`Setting mediaSource duration to ${t}`);
    try {
      e.mediaSource.duration = t;
    } catch (n) {
      le.log.warn("Failed to set media source duration", n);
    }
  },
  abort: () => (t, e) => {
    if (e.mediaSource.readyState !== "open")
      return;
    const n = e[`${t}Buffer`];
    if (Va(e.mediaSource, n)) {
      e.logger_(`calling abort on ${t}Buffer`);
      try {
        n.abort();
      } catch (a) {
        le.log.warn(`Failed to abort on ${t}Buffer`, a);
      }
    }
  },
  addSourceBuffer: (t, e) => (n) => {
    const a = ex(t), i = Bs(e);
    n.logger_(`Adding ${t}Buffer with codec ${e} to mediaSource`);
    const r = n.mediaSource.addSourceBuffer(i);
    r.addEventListener("updateend", n[`on${a}UpdateEnd_`]), r.addEventListener("error", n[`on${a}Error_`]), n.codecs[t] = e, n[`${t}Buffer`] = r;
  },
  removeSourceBuffer: (t) => (e) => {
    const n = e[`${t}Buffer`];
    if (tx(t, e), !!Va(e.mediaSource, n)) {
      e.logger_(`Removing ${t}Buffer with codec ${e.codecs[t]} from mediaSource`);
      try {
        e.mediaSource.removeSourceBuffer(n);
      } catch (a) {
        le.log.warn(`Failed to removeSourceBuffer ${t}Buffer`, a);
      }
    }
  },
  changeType: (t) => (e, n) => {
    const a = n[`${e}Buffer`], i = Bs(t);
    if (!Va(n.mediaSource, a))
      return;
    const r = t.substring(0, t.indexOf(".")), s = n.codecs[e];
    if (s.substring(0, s.indexOf(".")) === r)
      return;
    const l = {
      codecsChangeInfo: {
        from: s,
        to: t
      }
    };
    n.trigger({
      type: "codecschange",
      metadata: l
    }), n.logger_(`changing ${e}Buffer codec from ${s} to ${t}`);
    try {
      a.changeType(i), n.codecs[e] = t;
    } catch (c) {
      l.errorType = le.Error.StreamingCodecsChangeError, l.error = c, c.metadata = l, n.error_ = c, n.trigger("error"), le.log.warn(`Failed to changeType on ${e}Buffer`, c);
    }
  }
}, ra = ({
  type: t,
  sourceUpdater: e,
  action: n,
  doneFn: a,
  name: i
}) => {
  e.queue.push({
    type: t,
    action: n,
    doneFn: a,
    name: i
  }), Cs(t, e);
}, $b = (t, e) => (n) => {
  const a = e[`${t}Buffered`](), i = Xne(a);
  if (e.logger_(`received "updateend" event for ${t} Source Buffer: `, i), e.queuePending[t]) {
    const r = e.queuePending[t].doneFn;
    e.queuePending[t] = null, r && r(e[`${t}Error_`]);
  }
  Cs(t, e);
};
class nx extends le.EventTarget {
  constructor(e) {
    super(), this.mediaSource = e, this.sourceopenListener_ = () => Cs("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = Ta("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
      audio: null,
      video: null
    }, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = $b("video", this), this.onAudioUpdateEnd_ = $b("audio", this), this.onVideoError_ = (n) => {
      this.videoError_ = n;
    }, this.onAudioError_ = (n) => {
      this.audioError_ = n;
    }, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
  }
  initializedEme() {
    this.initializedEme_ = !0, this.triggerReady();
  }
  hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  }
  hasInitializedAnyEme() {
    return this.initializedEme_;
  }
  ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }
  createSourceBuffers(e) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }
  triggerReady() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }
  /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */
  addSourceBuffer(e, n) {
    ra({
      type: "mediaSource",
      sourceUpdater: this,
      action: ia.addSourceBuffer(e, n),
      name: "addSourceBuffer"
    });
  }
  /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */
  abort(e) {
    ra({
      type: e,
      sourceUpdater: this,
      action: ia.abort(e),
      name: "abort"
    });
  }
  /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */
  removeSourceBuffer(e) {
    if (!this.canRemoveSourceBuffer()) {
      le.log.error("removeSourceBuffer is not supported!");
      return;
    }
    ra({
      type: "mediaSource",
      sourceUpdater: this,
      action: ia.removeSourceBuffer(e),
      name: "removeSourceBuffer"
    });
  }
  /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */
  canRemoveSourceBuffer() {
    return !le.browser.IS_FIREFOX && Y.MediaSource && Y.MediaSource.prototype && typeof Y.MediaSource.prototype.removeSourceBuffer == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  static canChangeType() {
    return Y.SourceBuffer && Y.SourceBuffer.prototype && typeof Y.SourceBuffer.prototype.changeType == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  canChangeType() {
    return this.constructor.canChangeType();
  }
  /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */
  changeType(e, n) {
    if (!this.canChangeType()) {
      le.log.error("changeType is not supported!");
      return;
    }
    ra({
      type: e,
      sourceUpdater: this,
      action: ia.changeType(n),
      name: "changeType"
    });
  }
  /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */
  addOrChangeSourceBuffers(e) {
    if (!e || typeof e != "object" || Object.keys(e).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(e).forEach((n) => {
      const a = e[n];
      if (!this.hasCreatedSourceBuffers())
        return this.addSourceBuffer(n, a);
      this.canChangeType() && this.changeType(n, a);
    });
  }
  /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */
  appendBuffer(e, n) {
    const {
      segmentInfo: a,
      type: i,
      bytes: r
    } = e;
    if (this.processedAppend_ = !0, i === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([e, n]), this.logger_(`delayed audio append of ${r.length} until video append`);
      return;
    }
    const s = n;
    if (ra({
      type: i,
      sourceUpdater: this,
      action: ia.appendBuffer(r, a || {
        mediaIndex: -1
      }, s),
      doneFn: n,
      name: "appendBuffer"
    }), i === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      const o = this.delayedAudioAppendQueue_.slice();
      this.logger_(`queuing delayed audio ${o.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, o.forEach((l) => {
        this.appendBuffer.apply(this, l);
      });
    }
  }
  /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */
  audioBuffered() {
    return Va(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : vn();
  }
  /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */
  videoBuffered() {
    return Va(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : vn();
  }
  /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */
  buffered() {
    const e = Va(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, n = Va(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return n && !e ? this.audioBuffered() : e && !n ? this.videoBuffered() : Kne(this.audioBuffered(), this.videoBuffered());
  }
  /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */
  setDuration(e, n = gi) {
    ra({
      type: "mediaSource",
      sourceUpdater: this,
      action: ia.duration(e),
      name: "duration",
      doneFn: n
    });
  }
  /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */
  endOfStream(e = null, n = gi) {
    typeof e != "string" && (e = void 0), ra({
      type: "mediaSource",
      sourceUpdater: this,
      action: ia.endOfStream(e),
      name: "endOfStream",
      doneFn: n
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeAudio(e, n, a = gi) {
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      a();
      return;
    }
    ra({
      type: "audio",
      sourceUpdater: this,
      action: ia.remove(e, n),
      doneFn: a,
      name: "remove"
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeVideo(e, n, a = gi) {
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      a();
      return;
    }
    ra({
      type: "video",
      sourceUpdater: this,
      action: ia.remove(e, n),
      doneFn: a,
      name: "remove"
    });
  }
  /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */
  updating() {
    return !!(Bh("audio", this) || Bh("video", this));
  }
  /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  audioTimestampOffset(e) {
    return typeof e < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== e && (ra({
      type: "audio",
      sourceUpdater: this,
      action: ia.timestampOffset(e),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
  }
  /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  videoTimestampOffset(e) {
    return typeof e < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset_ !== e && (ra({
      type: "video",
      sourceUpdater: this,
      action: ia.timestampOffset(e),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  audioQueueCallback(e) {
    this.audioBuffer && ra({
      type: "audio",
      sourceUpdater: this,
      action: ia.callback(e),
      name: "callback"
    });
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  videoQueueCallback(e) {
    this.videoBuffer && ra({
      type: "video",
      sourceUpdater: this,
      action: ia.callback(e),
      name: "callback"
    });
  }
  /**
   * dispose of the source updater and the underlying sourceBuffer
   */
  dispose() {
    this.trigger("dispose"), Rie.forEach((e) => {
      this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => tx(e, this));
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }
}
const Fb = (t) => decodeURIComponent(escape(String.fromCharCode.apply(null, t))), $ie = (t) => {
  const e = new Uint8Array(t);
  return Array.from(e).map((n) => n.toString(16).padStart(2, "0")).join("");
}, zb = new Uint8Array(`

`.split("").map((t) => t.charCodeAt(0)));
class Fie extends Error {
  constructor() {
    super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
  }
}
class zie extends Ph {
  constructor(e, n = {}) {
    super(e, n), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return vn();
    const e = this.subtitlesTrack_.cues, n = e[0].startTime, a = e[e.length - 1].startTime;
    return vn([[n, a]]);
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, n = !1) {
    if (!e)
      return null;
    const a = Iu(e);
    let i = this.initSegments_[a];
    if (n && !i && e.bytes) {
      const r = zb.byteLength + e.bytes.byteLength, s = new Uint8Array(r);
      s.set(e.bytes), s.set(zb, e.bytes.byteLength), this.initSegments_[a] = i = {
        resolvedUri: e.resolvedUri,
        byterange: e.byterange,
        bytes: s
      };
    }
    return i || e;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */
  track(e) {
    return typeof e > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */
  remove(e, n) {
    tl(e, n, this.subtitlesTrack_);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    const e = this.chooseNextRequest_();
    if (e) {
      if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
        const n = () => {
          this.state = "READY", this.paused() || this.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", n), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(e);
    }
  }
  // never set a timestamp offset for vtt segments.
  timestampOffsetForSegment_() {
    return null;
  }
  chooseNextRequest_() {
    return this.skipEmptySegments_(super.chooseNextRequest_());
  }
  /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */
  skipEmptySegments_(e) {
    for (; e && e.segment.empty; ) {
      if (e.mediaIndex + 1 >= e.playlist.segments.length) {
        e = null;
        break;
      }
      e = this.generateSegmentInfo_({
        playlist: e.playlist,
        mediaIndex: e.mediaIndex + 1,
        startOfSegment: e.startOfSegment + e.duration,
        isSyncRequest: e.isSyncRequest
      });
    }
    return e;
  }
  stopForError(e) {
    this.error(e), this.state = "READY", this.pause(), this.trigger("error");
  }
  /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */
  segmentRequestFinished_(e, n, a) {
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(n.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (e) {
      e.code === Qa.TIMEOUT && this.handleTimeout_(), e.code === Qa.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
      return;
    }
    const i = this.pendingSegment_, r = a.mp4VttCues && a.mp4VttCues.length;
    r && (i.mp4VttCues = a.mp4VttCues), this.saveBandwidthRelatedStats_(i.duration, n.stats), n.key && this.segmentKey(n.key, !0), this.state = "APPENDING", this.trigger("appending");
    const s = i.segment;
    if (s.map && (s.map.bytes = n.map.bytes), i.bytes = n.bytes, typeof Y.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, n, a), () => this.stopForError({
        message: "Error loading vtt.js"
      }));
      return;
    }
    s.requested = !0;
    try {
      this.parseVTTCues_(i);
    } catch (o) {
      this.stopForError({
        message: o.message,
        metadata: {
          errorType: le.Error.StreamingVttParserError,
          error: o
        }
      });
      return;
    }
    if (r || this.updateTimeMapping_(i, this.syncController_.timelines[i.timeline], this.playlist_), i.cues.length ? i.timingInfo = {
      start: i.cues[0].startTime,
      end: i.cues[i.cues.length - 1].endTime
    } : i.timingInfo = {
      start: i.startOfSegment,
      end: i.startOfSegment + i.duration
    }, i.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    i.byteLength = i.bytes.byteLength, this.mediaSecondsLoaded += s.duration, i.cues.forEach((o) => {
      this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new Y.VTTCue(o.startTime, o.endTime, o.text) : o);
    }), Tie(this.subtitlesTrack_), this.handleAppendsDone_();
  }
  handleData_(e, n) {
    const a = e && e.type === "vtt", i = n && n.type === "text";
    a && i && super.handleData_(e, n);
  }
  updateTimingInfoEnd_() {
  }
  /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */
  parseMp4VttCues_(e) {
    const n = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    e.mp4VttCues.forEach((a) => {
      const i = a.start + n, r = a.end + n, s = new Y.VTTCue(i, r, a.cueText);
      a.settings && a.settings.split(" ").forEach((o) => {
        const l = o.split(":"), c = l[0], d = l[1];
        s[c] = isNaN(d) ? d : Number(d);
      }), e.cues.push(s);
    });
  }
  /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */
  parseVTTCues_(e) {
    let n, a = !1;
    if (typeof Y.WebVTT != "function")
      throw new Fie();
    if (e.cues = [], e.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, e.mp4VttCues) {
      this.parseMp4VttCues_(e);
      return;
    }
    typeof Y.TextDecoder == "function" ? n = new Y.TextDecoder("utf8") : (n = Y.WebVTT.StringDecoder(), a = !0);
    const i = new Y.WebVTT.Parser(Y, Y.vttjs, n);
    if (i.oncue = e.cues.push.bind(e.cues), i.ontimestampmap = (s) => {
      e.timestampmap = s;
    }, i.onparsingerror = (s) => {
      le.log.warn("Error encountered when parsing cues: " + s.message);
    }, e.segment.map) {
      let s = e.segment.map.bytes;
      a && (s = Fb(s)), i.parse(s);
    }
    let r = e.bytes;
    a && (r = Fb(r)), i.parse(r), i.flush();
  }
  /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */
  updateTimeMapping_(e, n, a) {
    const i = e.segment;
    if (!n)
      return;
    if (!e.cues.length) {
      i.empty = !0;
      return;
    }
    const {
      MPEGTS: r,
      LOCAL: s
    } = e.timestampmap, l = r / wr.ONE_SECOND_IN_TS - s + n.mapping;
    if (e.cues.forEach((c) => {
      const d = c.endTime - c.startTime, f = this.handleRollover_(c.startTime + l, n.time);
      c.startTime = Math.max(f, 0), c.endTime = Math.max(f + d, 0);
    }), !a.syncInfo) {
      const c = e.cues[0].startTime, d = e.cues[e.cues.length - 1].startTime;
      a.syncInfo = {
        mediaSequence: a.mediaSequence + e.mediaIndex,
        time: Math.min(c, d - i.duration)
      };
    }
  }
  /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */
  handleRollover_(e, n) {
    if (n === null)
      return e;
    let a = e * wr.ONE_SECOND_IN_TS;
    const i = n * wr.ONE_SECOND_IN_TS;
    let r;
    for (i < a ? r = -8589934592 : r = 8589934592; Math.abs(a - i) > 4294967296; )
      a += r;
    return a / wr.ONE_SECOND_IN_TS;
  }
}
const Uie = function(t, e) {
  const n = t.cues;
  for (let a = 0; a < n.length; a++) {
    const i = n[a];
    if (e >= i.adStartTime && e <= i.adEndTime)
      return i;
  }
  return null;
}, Hie = function(t, e, n = 0) {
  if (!t.segments)
    return;
  let a = n, i;
  for (let r = 0; r < t.segments.length; r++) {
    const s = t.segments[r];
    if (i || (i = Uie(e, a + s.duration / 2)), i) {
      if ("cueIn" in s) {
        i.endTime = a, i.adEndTime = a, a += s.duration, i = null;
        continue;
      }
      if (a < i.endTime) {
        a += s.duration;
        continue;
      }
      i.endTime += s.duration;
    } else if ("cueOut" in s && (i = new Y.VTTCue(a, a + s.duration, s.cueOut), i.adStartTime = a, i.adEndTime = a + parseFloat(s.cueOut), e.addCue(i)), "cueOutCont" in s) {
      const [o, l] = s.cueOutCont.split("/").map(parseFloat);
      i = new Y.VTTCue(a, a + s.duration, ""), i.adStartTime = a - o, i.adEndTime = i.adStartTime + l, e.addCue(i);
    }
    a += s.duration;
  }
};
class Ub {
  /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */
  constructor({
    start: e,
    end: n,
    segmentIndex: a,
    partIndex: i = null,
    appended: r = !1
  }) {
    this.start_ = e, this.end_ = n, this.segmentIndex_ = a, this.partIndex_ = i, this.appended_ = r;
  }
  isInRange(e) {
    return e >= this.start && e < this.end;
  }
  markAppended() {
    this.appended_ = !0;
  }
  resetAppendedStatus() {
    this.appended_ = !1;
  }
  get isAppended() {
    return this.appended_;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get segmentIndex() {
    return this.segmentIndex_;
  }
  get partIndex() {
    return this.partIndex_;
  }
}
class Yie {
  /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */
  constructor(e, n = []) {
    this.segmentSyncInfo_ = e, this.partsSyncInfo_ = n;
  }
  get segmentSyncInfo() {
    return this.segmentSyncInfo_;
  }
  get partsSyncInfo() {
    return this.partsSyncInfo_;
  }
  get hasPartsSyncInfo() {
    return this.partsSyncInfo_.length > 0;
  }
  resetAppendStatus() {
    this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
  }
}
class ax {
  constructor() {
    this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -1 / 0, this.end_ = 1 / 0;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get diagnostics() {
    return this.diagnostics_;
  }
  get isReliable() {
    return this.isReliable_;
  }
  resetAppendedStatus() {
    this.storage_.forEach((e) => e.resetAppendStatus());
  }
  /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */
  update(e, n) {
    const {
      mediaSequence: a,
      segments: i
    } = e;
    if (this.isReliable_ = this.isReliablePlaylist_(a, i), !!this.isReliable_)
      return this.updateStorage_(i, a, this.calculateBaseTime_(a, i, n));
  }
  /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */
  getSyncInfoForTime(e) {
    for (const {
      segmentSyncInfo: n,
      partsSyncInfo: a
    } of this.storage_.values())
      if (a.length) {
        for (const i of a)
          if (i.isInRange(e))
            return i;
      } else if (n.isInRange(e))
        return n;
    return null;
  }
  getSyncInfoForMediaSequence(e) {
    return this.storage_.get(e);
  }
  updateStorage_(e, n, a) {
    const i = /* @__PURE__ */ new Map();
    let r = `
`, s = a, o = n;
    this.start_ = s, e.forEach((l, c) => {
      const d = this.storage_.get(o), f = s, g = f + l.duration, _ = !!(d && d.segmentSyncInfo && d.segmentSyncInfo.isAppended), x = new Ub({
        start: f,
        end: g,
        appended: _,
        segmentIndex: c
      });
      l.syncInfo = x;
      let p = s;
      const w = (l.parts || []).map((C, M) => {
        const A = p, L = p + C.duration, D = !!(d && d.partsSyncInfo && d.partsSyncInfo[M] && d.partsSyncInfo[M].isAppended), B = new Ub({
          start: A,
          end: L,
          appended: D,
          segmentIndex: c,
          partIndex: M
        });
        return p = L, r += `Media Sequence: ${o}.${M} | Range: ${A} --> ${L} | Appended: ${D}
`, C.syncInfo = B, B;
      });
      i.set(o, new Yie(x, w)), r += `${J_(l.resolvedUri)} | Media Sequence: ${o} | Range: ${f} --> ${g} | Appended: ${_}
`, o++, s = g;
    }), this.end_ = s, this.storage_ = i, this.diagnostics_ = r;
  }
  calculateBaseTime_(e, n, a) {
    if (!this.storage_.size)
      return 0;
    if (this.storage_.has(e))
      return this.storage_.get(e).segmentSyncInfo.start;
    const i = Math.min(...this.storage_.keys());
    if (e < i) {
      const r = i - e;
      let s = this.storage_.get(i).segmentSyncInfo.start;
      for (let o = 0; o < r; o++) {
        const l = n[o];
        s -= l.duration;
      }
      return s;
    }
    return a;
  }
  isReliablePlaylist_(e, n) {
    return e != null && Array.isArray(n) && n.length;
  }
}
class Hb extends ax {
  constructor(e) {
    super(), this.parent_ = e;
  }
  calculateBaseTime_(e, n, a) {
    if (!this.storage_.size) {
      const i = this.parent_.getSyncInfoForMediaSequence(e);
      return i ? i.segmentSyncInfo.start : 0;
    }
    return super.calculateBaseTime_(e, n, a);
  }
}
const jie = 86400, N0 = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: (t, e, n, a, i) => n !== 1 / 0 ? {
      time: 0,
      segmentIndex: 0,
      partIndex: null
    } : null
  },
  {
    name: "MediaSequence",
    /**
     * run media sequence strategy
     *
     * @param {SyncController} syncController
     * @param {Object} playlist
     * @param {number} duration
     * @param {number} currentTimeline
     * @param {number} currentTime
     * @param {string} type
     */
    run: (t, e, n, a, i, r) => {
      const s = t.getMediaSequenceSync(r);
      if (!s || !s.isReliable)
        return null;
      const o = s.getSyncInfoForTime(i);
      return o ? {
        time: o.start,
        partIndex: o.partIndex,
        segmentIndex: o.segmentIndex
      } : null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: (t, e, n, a, i) => {
      if (!Object.keys(t.timelineToDatetimeMappings).length)
        return null;
      let r = null, s = null;
      const o = Sh(e);
      i = i || 0;
      for (let l = 0; l < o.length; l++) {
        const c = e.endList || i === 0 ? l : o.length - (l + 1), d = o[c], f = d.segment, g = t.timelineToDatetimeMappings[f.timeline];
        if (!g || !f.dateTimeObject)
          continue;
        let x = f.dateTimeObject.getTime() / 1e3 + g;
        if (f.parts && typeof d.partIndex == "number")
          for (let w = 0; w < d.partIndex; w++)
            x += f.parts[w].duration;
        const p = Math.abs(i - x);
        if (s !== null && (p === 0 || s < p))
          break;
        s = p, r = {
          time: x,
          segmentIndex: d.segmentIndex,
          partIndex: d.partIndex
        };
      }
      return r;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: (t, e, n, a, i) => {
      let r = null, s = null;
      i = i || 0;
      const o = Sh(e);
      for (let l = 0; l < o.length; l++) {
        const c = e.endList || i === 0 ? l : o.length - (l + 1), d = o[c], f = d.segment, g = d.part && d.part.start || f && f.start;
        if (f.timeline === a && typeof g < "u") {
          const _ = Math.abs(i - g);
          if (s !== null && s < _)
            break;
          (!r || s === null || s >= _) && (s = _, r = {
            time: g,
            segmentIndex: d.segmentIndex,
            partIndex: d.partIndex
          });
        }
      }
      return r;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: (t, e, n, a, i) => {
      let r = null;
      if (i = i || 0, e.discontinuityStarts && e.discontinuityStarts.length) {
        let s = null;
        for (let o = 0; o < e.discontinuityStarts.length; o++) {
          const l = e.discontinuityStarts[o], c = e.discontinuitySequence + o + 1, d = t.discontinuities[c];
          if (d) {
            const f = Math.abs(i - d.time);
            if (s !== null && s < f)
              break;
            (!r || s === null || s >= f) && (s = f, r = {
              time: d.time,
              segmentIndex: l,
              partIndex: null
            });
          }
        }
      }
      return r;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: (t, e, n, a, i) => e.syncInfo ? {
      time: e.syncInfo.time,
      segmentIndex: e.syncInfo.mediaSequence - e.mediaSequence,
      partIndex: null
    } : null
  }
];
class Vie extends le.EventTarget {
  constructor(e = {}) {
    super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
    const n = new ax(), a = new Hb(n), i = new Hb(n);
    this.mediaSequenceStorage_ = {
      main: n,
      audio: a,
      vtt: i
    }, this.logger_ = Ta("SyncController");
  }
  /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */
  getMediaSequenceSync(e) {
    return this.mediaSequenceStorage_[e] || null;
  }
  /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */
  getSyncPoint(e, n, a, i, r) {
    if (n !== 1 / 0)
      return N0.find(({
        name: l
      }) => l === "VOD").run(this, e, n);
    const s = this.runStrategies_(e, n, a, i, r);
    if (!s.length)
      return null;
    for (const o of s) {
      const {
        syncPoint: l,
        strategy: c
      } = o, {
        segmentIndex: d,
        time: f
      } = l;
      if (d < 0)
        continue;
      const g = e.segments[d], _ = f, x = _ + g.duration;
      if (this.logger_(`Strategy: ${c}. Current time: ${i}. selected segment: ${d}. Time: [${_} -> ${x}]}`), i >= _ && i < x)
        return this.logger_("Found sync point with exact match: ", l), l;
    }
    return this.selectSyncPoint_(s, {
      key: "time",
      value: i
    });
  }
  /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */
  getExpiredTime(e, n) {
    if (!e || !e.segments)
      return null;
    const a = this.runStrategies_(e, n, e.discontinuitySequence, 0);
    if (!a.length)
      return null;
    const i = this.selectSyncPoint_(a, {
      key: "segmentIndex",
      value: 0
    });
    return i.segmentIndex > 0 && (i.time *= -1), Math.abs(i.time + hl({
      defaultDuration: e.targetDuration,
      durationList: e.segments,
      startIndex: i.segmentIndex,
      endIndex: 0
    }));
  }
  /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */
  runStrategies_(e, n, a, i, r) {
    const s = [];
    for (let o = 0; o < N0.length; o++) {
      const l = N0[o], c = l.run(this, e, n, a, i, r);
      c && (c.strategy = l.name, s.push({
        strategy: l.name,
        syncPoint: c
      }));
    }
    return s;
  }
  /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */
  selectSyncPoint_(e, n) {
    let a = e[0].syncPoint, i = Math.abs(e[0].syncPoint[n.key] - n.value), r = e[0].strategy;
    for (let s = 1; s < e.length; s++) {
      const o = Math.abs(e[s].syncPoint[n.key] - n.value);
      o < i && (i = o, a = e[s].syncPoint, r = e[s].strategy);
    }
    return this.logger_(`syncPoint for [${n.key}: ${n.value}] chosen with strategy [${r}]: [time:${a.time}, segmentIndex:${a.segmentIndex}` + (typeof a.partIndex == "number" ? `,partIndex:${a.partIndex}` : "") + "]"), a;
  }
  /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */
  saveExpiredSegmentInfo(e, n) {
    const a = n.mediaSequence - e.mediaSequence;
    if (a > jie) {
      le.log.warn(`Not saving expired segment info. Media sequence gap ${a} is too large.`);
      return;
    }
    for (let i = a - 1; i >= 0; i--) {
      const r = e.segments[i];
      if (r && typeof r.start < "u") {
        n.syncInfo = {
          mediaSequence: e.mediaSequence + i,
          time: r.start
        }, this.logger_(`playlist refresh sync: [time:${n.syncInfo.time}, mediaSequence: ${n.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
        break;
      }
    }
  }
  /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */
  setDateTimeMappingForStart(e) {
    if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
      const n = e.segments[0], a = n.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[n.timeline] = -a;
    }
  }
  /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */
  saveSegmentTimingInfo({
    segmentInfo: e,
    shouldSaveTimelineMapping: n
  }) {
    const a = this.calculateSegmentTimeMapping_(e, e.timingInfo, n), i = e.segment;
    a && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
      mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
      time: i.start
    }));
    const r = i.dateTimeObject;
    i.discontinuity && n && r && (this.timelineToDatetimeMappings[i.timeline] = -(r.getTime() / 1e3));
  }
  timestampOffsetForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].time;
  }
  mappingForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].mapping;
  }
  /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */
  calculateSegmentTimeMapping_(e, n, a) {
    const i = e.segment, r = e.part;
    let s = this.timelines[e.timeline], o, l;
    if (typeof e.timestampOffset == "number")
      s = {
        time: e.startOfSegment,
        mapping: e.startOfSegment - n.start
      }, a && (this.timelines[e.timeline] = s, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${s.time}] [mapping: ${s.mapping}]`)), o = e.startOfSegment, l = n.end + s.mapping;
    else if (s)
      o = n.start + s.mapping, l = n.end + s.mapping;
    else
      return !1;
    return r && (r.start = o, r.end = l), (!i.start || o < i.start) && (i.start = o), i.end = l, !0;
  }
  /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */
  saveDiscontinuitySyncInfo_(e) {
    const n = e.playlist, a = e.segment;
    if (a.discontinuity)
      this.discontinuities[a.timeline] = {
        time: a.start,
        accuracy: 0
      };
    else if (n.discontinuityStarts && n.discontinuityStarts.length)
      for (let i = 0; i < n.discontinuityStarts.length; i++) {
        const r = n.discontinuityStarts[i], s = n.discontinuitySequence + i + 1, o = r - e.mediaIndex, l = Math.abs(o);
        if (!this.discontinuities[s] || this.discontinuities[s].accuracy > l) {
          let c;
          o < 0 ? c = a.start - hl({
            defaultDuration: n.targetDuration,
            durationList: n.segments,
            startIndex: e.mediaIndex,
            endIndex: r
          }) : c = a.end + hl({
            defaultDuration: n.targetDuration,
            durationList: n.segments,
            startIndex: e.mediaIndex + 1,
            endIndex: r
          }), this.discontinuities[s] = {
            time: c,
            accuracy: l
          };
        }
      }
  }
  dispose() {
    this.trigger("dispose"), this.off();
  }
}
class qie extends le.EventTarget {
  constructor() {
    super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
  }
  clearPendingTimelineChange(e) {
    this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
  }
  pendingTimelineChange({
    type: e,
    from: n,
    to: a
  }) {
    return typeof n == "number" && typeof a == "number" && (this.pendingTimelineChanges_[e] = {
      type: e,
      from: n,
      to: a
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
  }
  lastTimelineChange({
    type: e,
    from: n,
    to: a
  }) {
    if (typeof n == "number" && typeof a == "number") {
      this.lastTimelineChanges_[e] = {
        type: e,
        from: n,
        to: a
      }, delete this.pendingTimelineChanges_[e];
      const i = {
        timelineChangeInfo: {
          from: n,
          to: a
        }
      };
      this.trigger({
        type: "timelinechange",
        metadata: i
      });
    }
    return this.lastTimelineChanges_[e];
  }
  dispose() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }
}
const Wie = U_(H_(function() {
  var t = /* @__PURE__ */ function() {
    function p() {
      this.listeners = {};
    }
    var w = p.prototype;
    return w.on = function(M, A) {
      this.listeners[M] || (this.listeners[M] = []), this.listeners[M].push(A);
    }, w.off = function(M, A) {
      if (!this.listeners[M])
        return !1;
      var L = this.listeners[M].indexOf(A);
      return this.listeners[M] = this.listeners[M].slice(0), this.listeners[M].splice(L, 1), L > -1;
    }, w.trigger = function(M) {
      var A = this.listeners[M];
      if (A)
        if (arguments.length === 2)
          for (var L = A.length, D = 0; D < L; ++D)
            A[D].call(this, arguments[1]);
        else
          for (var B = Array.prototype.slice.call(arguments, 1), P = A.length, z = 0; z < P; ++z)
            A[z].apply(this, B);
    }, w.dispose = function() {
      this.listeners = {};
    }, w.pipe = function(M) {
      this.on("data", function(A) {
        M.push(A);
      });
    }, p;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function e(p) {
    return p.subarray(0, p.byteLength - p[p.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */
  const n = function() {
    const p = [[[], [], [], [], []], [[], [], [], [], []]], w = p[0], C = p[1], M = w[4], A = C[4];
    let L, D, B;
    const P = [], z = [];
    let W, q, V, re, ie, K;
    for (L = 0; L < 256; L++)
      z[(P[L] = L << 1 ^ (L >> 7) * 283) ^ L] = L;
    for (D = B = 0; !M[D]; D ^= W || 1, B = z[B] || 1)
      for (re = B ^ B << 1 ^ B << 2 ^ B << 3 ^ B << 4, re = re >> 8 ^ re & 255 ^ 99, M[D] = re, A[re] = D, V = P[q = P[W = P[D]]], K = V * 16843009 ^ q * 65537 ^ W * 257 ^ D * 16843008, ie = P[re] * 257 ^ re * 16843008, L = 0; L < 4; L++)
        w[L][D] = ie = ie << 24 ^ ie >>> 8, C[L][re] = K = K << 24 ^ K >>> 8;
    for (L = 0; L < 5; L++)
      w[L] = w[L].slice(0), C[L] = C[L].slice(0);
    return p;
  };
  let a = null;
  class i {
    constructor(w) {
      a || (a = n()), this._tables = [[a[0][0].slice(), a[0][1].slice(), a[0][2].slice(), a[0][3].slice(), a[0][4].slice()], [a[1][0].slice(), a[1][1].slice(), a[1][2].slice(), a[1][3].slice(), a[1][4].slice()]];
      let C, M, A;
      const L = this._tables[0][4], D = this._tables[1], B = w.length;
      let P = 1;
      if (B !== 4 && B !== 6 && B !== 8)
        throw new Error("Invalid aes key size");
      const z = w.slice(0), W = [];
      for (this._key = [z, W], C = B; C < 4 * B + 28; C++)
        A = z[C - 1], (C % B === 0 || B === 8 && C % B === 4) && (A = L[A >>> 24] << 24 ^ L[A >> 16 & 255] << 16 ^ L[A >> 8 & 255] << 8 ^ L[A & 255], C % B === 0 && (A = A << 8 ^ A >>> 24 ^ P << 24, P = P << 1 ^ (P >> 7) * 283)), z[C] = z[C - B] ^ A;
      for (M = 0; C; M++, C--)
        A = z[M & 3 ? C : C - 4], C <= 4 || M < 4 ? W[M] = A : W[M] = D[0][L[A >>> 24]] ^ D[1][L[A >> 16 & 255]] ^ D[2][L[A >> 8 & 255]] ^ D[3][L[A & 255]];
    }
    /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */
    decrypt(w, C, M, A, L, D) {
      const B = this._key[1];
      let P = w ^ B[0], z = A ^ B[1], W = M ^ B[2], q = C ^ B[3], V, re, ie;
      const K = B.length / 4 - 2;
      let $, X = 4;
      const R = this._tables[1], de = R[0], Le = R[1], Ie = R[2], Ve = R[3], te = R[4];
      for ($ = 0; $ < K; $++)
        V = de[P >>> 24] ^ Le[z >> 16 & 255] ^ Ie[W >> 8 & 255] ^ Ve[q & 255] ^ B[X], re = de[z >>> 24] ^ Le[W >> 16 & 255] ^ Ie[q >> 8 & 255] ^ Ve[P & 255] ^ B[X + 1], ie = de[W >>> 24] ^ Le[q >> 16 & 255] ^ Ie[P >> 8 & 255] ^ Ve[z & 255] ^ B[X + 2], q = de[q >>> 24] ^ Le[P >> 16 & 255] ^ Ie[z >> 8 & 255] ^ Ve[W & 255] ^ B[X + 3], X += 4, P = V, z = re, W = ie;
      for ($ = 0; $ < 4; $++)
        L[(3 & -$) + D] = te[P >>> 24] << 24 ^ te[z >> 16 & 255] << 16 ^ te[W >> 8 & 255] << 8 ^ te[q & 255] ^ B[X++], V = P, P = z, z = W, W = q, q = V;
    }
  }
  class r extends t {
    constructor() {
      super(t), this.jobs = [], this.delay = 1, this.timeout_ = null;
    }
    /**
     * process an async job
     *
     * @private
     */
    processJob_() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }
    /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */
    push(w) {
      this.jobs.push(w), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }
  }
  const s = function(p) {
    return p << 24 | (p & 65280) << 8 | (p & 16711680) >> 8 | p >>> 24;
  }, o = function(p, w, C) {
    const M = new Int32Array(p.buffer, p.byteOffset, p.byteLength >> 2), A = new i(Array.prototype.slice.call(w)), L = new Uint8Array(p.byteLength), D = new Int32Array(L.buffer);
    let B, P, z, W, q, V, re, ie, K;
    for (B = C[0], P = C[1], z = C[2], W = C[3], K = 0; K < M.length; K += 4)
      q = s(M[K]), V = s(M[K + 1]), re = s(M[K + 2]), ie = s(M[K + 3]), A.decrypt(q, V, re, ie, D, K), D[K] = s(D[K] ^ B), D[K + 1] = s(D[K + 1] ^ P), D[K + 2] = s(D[K + 2] ^ z), D[K + 3] = s(D[K + 3] ^ W), B = q, P = V, z = re, W = ie;
    return L;
  };
  class l {
    constructor(w, C, M, A) {
      const L = l.STEP, D = new Int32Array(w.buffer), B = new Uint8Array(w.byteLength);
      let P = 0;
      for (this.asyncStream_ = new r(), this.asyncStream_.push(this.decryptChunk_(D.subarray(P, P + L), C, M, B)), P = L; P < D.length; P += L)
        M = new Uint32Array([s(D[P - 4]), s(D[P - 3]), s(D[P - 2]), s(D[P - 1])]), this.asyncStream_.push(this.decryptChunk_(D.subarray(P, P + L), C, M, B));
      this.asyncStream_.push(function() {
        A(null, e(B));
      });
    }
    /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */
    static get STEP() {
      return 32e3;
    }
    /**
     * @private
     */
    decryptChunk_(w, C, M, A) {
      return function() {
        const L = o(w, C, M);
        A.set(L, w.byteOffset);
      };
    }
  }
  var c = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, d;
  typeof window < "u" ? d = window : typeof c < "u" ? d = c : typeof self < "u" ? d = self : d = {};
  var f = d, g = function(w) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(w) : w && w.buffer instanceof ArrayBuffer;
  }, _ = f.BigInt || Number;
  _("0x1"), _("0x100"), _("0x10000"), _("0x1000000"), _("0x100000000"), _("0x10000000000"), _("0x1000000000000"), _("0x100000000000000"), _("0x10000000000000000"), function() {
    var p = new Uint16Array([65484]), w = new Uint8Array(p.buffer, p.byteOffset, p.byteLength);
    return w[0] === 255 ? "big" : w[0] === 204 ? "little" : "unknown";
  }();
  const x = function(p) {
    const w = {};
    return Object.keys(p).forEach((C) => {
      const M = p[C];
      g(M) ? w[C] = {
        bytes: M.buffer,
        byteOffset: M.byteOffset,
        byteLength: M.byteLength
      } : w[C] = M;
    }), w;
  };
  self.onmessage = function(p) {
    const w = p.data, C = new Uint8Array(w.encrypted.bytes, w.encrypted.byteOffset, w.encrypted.byteLength), M = new Uint32Array(w.key.bytes, w.key.byteOffset, w.key.byteLength / 4), A = new Uint32Array(w.iv.bytes, w.iv.byteOffset, w.iv.byteLength / 4);
    new l(C, M, A, function(L, D) {
      self.postMessage(x({
        source: w.source,
        decrypted: D
      }), [D.buffer]);
    });
  };
}));
var Gie = z_(Wie);
const Xie = (t) => {
  let e = t.default ? "main" : "alternative";
  return t.characteristics && t.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (e = "main-desc"), e;
}, ix = (t, e) => {
  t.abort(), t.pause(), e && e.activePlaylistLoader && (e.activePlaylistLoader.pause(), e.activePlaylistLoader = null);
}, Rh = (t, e) => {
  e.activePlaylistLoader = t, t.load();
}, Zie = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: n,
      main: a
    },
    mediaTypes: {
      [t]: i
    }
  } = e, r = i.activeTrack(), s = i.getActiveGroup(), o = i.activePlaylistLoader, l = i.lastGroup_;
  if (!(s && l && s.id === l.id) && (i.lastGroup_ = s, i.lastTrack_ = r, ix(n, i), !(!s || s.isMainPlaylist))) {
    if (!s.playlistLoader) {
      o && a.resetEverything();
      return;
    }
    n.resyncLoader(), Rh(s.playlistLoader, i);
  }
}, Kie = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: n
    },
    mediaTypes: {
      [t]: a
    }
  } = e;
  a.lastGroup_ = null, n.abort(), n.pause();
}, Qie = (t, e) => () => {
  const {
    mainPlaylistLoader: n,
    segmentLoaders: {
      [t]: a,
      main: i
    },
    mediaTypes: {
      [t]: r
    }
  } = e, s = r.activeTrack(), o = r.getActiveGroup(), l = r.activePlaylistLoader, c = r.lastTrack_;
  if (!(c && s && c.id === s.id) && (r.lastGroup_ = o, r.lastTrack_ = s, ix(a, r), !!o)) {
    if (o.isMainPlaylist) {
      if (!s || !c || s.id === c.id)
        return;
      const d = e.vhs.playlistController_, f = d.selectPlaylist();
      if (d.media() === f)
        return;
      r.logger_(`track change. Switching main audio from ${c.id} to ${s.id}`), n.pause(), i.resetEverything(), d.fastQualityChange_(f);
      return;
    }
    if (t === "AUDIO") {
      if (!o.playlistLoader) {
        i.setAudio(!0), i.resetEverything();
        return;
      }
      a.setAudio(!0), i.setAudio(!1);
    }
    if (l === o.playlistLoader) {
      Rh(o.playlistLoader, r);
      return;
    }
    a.track && a.track(s), a.resetEverything(), Rh(o.playlistLoader, r);
  }
}, Pu = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: n
      },
      excludePlaylist: a
    } = e, i = n.activeTrack(), r = n.activeGroup(), s = (r.filter((l) => l.default)[0] || r[0]).id, o = n.tracks[s];
    if (i === o) {
      a({
        error: {
          message: "Problem encountered loading the default audio track."
        }
      });
      return;
    }
    le.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
    for (const l in n.tracks)
      n.tracks[l].enabled = n.tracks[l] === o;
    n.onTrackChanged();
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: n
      }
    } = e;
    le.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
    const a = n.activeTrack();
    a && (a.mode = "disabled"), n.onTrackChanged();
  }
}, Yb = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: (t, e, n) => {
    if (!e)
      return;
    const {
      tech: a,
      requestOptions: i,
      segmentLoaders: {
        [t]: r
      }
    } = n;
    e.on("loadedmetadata", () => {
      const s = e.media();
      r.playlist(s, i), (!a.paused() || s.endList && a.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), i), a.paused() || r.load();
    }), e.on("error", Pu[t](t, n));
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: (t, e, n) => {
    const {
      tech: a,
      requestOptions: i,
      segmentLoaders: {
        [t]: r
      },
      mediaTypes: {
        [t]: s
      }
    } = n;
    e.on("loadedmetadata", () => {
      const o = e.media();
      r.playlist(o, i), r.track(s.activeTrack()), (!a.paused() || o.endList && a.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), i), a.paused() || r.load();
    }), e.on("error", Pu[t](t, n));
  }
}, Jie = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: (t, e) => {
    const {
      vhs: n,
      sourceType: a,
      segmentLoaders: {
        [t]: i
      },
      requestOptions: r,
      main: {
        mediaGroups: s
      },
      mediaTypes: {
        [t]: {
          groups: o,
          tracks: l,
          logger_: c
        }
      },
      mainPlaylistLoader: d
    } = e, f = Xl(d.main);
    (!s[t] || Object.keys(s[t]).length === 0) && (s[t] = {
      main: {
        default: {
          default: !0
        }
      }
    }, f && (s[t].main.default.playlists = d.main.playlists));
    for (const g in s[t]) {
      o[g] || (o[g] = []);
      for (const _ in s[t][g]) {
        let x = s[t][g][_], p;
        if (f ? (c(`AUDIO group '${g}' label '${_}' is a main playlist`), x.isMainPlaylist = !0, p = null) : a === "vhs-json" && x.playlists ? p = new ms(x.playlists[0], n, r) : x.resolvedUri ? p = new ms(x.resolvedUri, n, r) : x.playlists && a === "dash" ? p = new Ih(x.playlists[0], n, r, d) : p = null, x = gt({
          id: _,
          playlistLoader: p
        }, x), Yb[t](t, x.playlistLoader, e), o[g].push(x), typeof l[_] > "u") {
          const w = new le.AudioTrack({
            id: _,
            kind: Xie(x),
            enabled: !1,
            language: x.language,
            default: x.default,
            label: _
          });
          l[_] = w;
        }
      }
    }
    i.on("error", Pu[t](t, e));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: (t, e) => {
    const {
      tech: n,
      vhs: a,
      sourceType: i,
      segmentLoaders: {
        [t]: r
      },
      requestOptions: s,
      main: {
        mediaGroups: o
      },
      mediaTypes: {
        [t]: {
          groups: l,
          tracks: c
        }
      },
      mainPlaylistLoader: d
    } = e;
    for (const f in o[t]) {
      l[f] || (l[f] = []);
      for (const g in o[t][f]) {
        if (!a.options_.useForcedSubtitles && o[t][f][g].forced)
          continue;
        let _ = o[t][f][g], x;
        if (i === "hls")
          x = new ms(_.resolvedUri, a, s);
        else if (i === "dash") {
          if (!_.playlists.filter((w) => w.excludeUntil !== 1 / 0).length)
            return;
          x = new Ih(_.playlists[0], a, s, d);
        } else i === "vhs-json" && (x = new ms(
          // if the vhs-json object included the media playlist, use the media playlist
          // as provided, otherwise use the resolved URI to load the playlist
          _.playlists ? _.playlists[0] : _.resolvedUri,
          a,
          s
        ));
        if (_ = gt({
          id: g,
          playlistLoader: x
        }, _), Yb[t](t, _.playlistLoader, e), l[f].push(_), typeof c[g] > "u") {
          const p = n.addRemoteTextTrack({
            id: g,
            kind: "subtitles",
            default: _.default && _.autoselect,
            language: _.language,
            label: g
          }, !1).track;
          c[g] = p;
        }
      }
    }
    r.on("error", Pu[t](t, e));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": (t, e) => {
    const {
      tech: n,
      main: {
        mediaGroups: a
      },
      mediaTypes: {
        [t]: {
          groups: i,
          tracks: r
        }
      }
    } = e;
    for (const s in a[t]) {
      i[s] || (i[s] = []);
      for (const o in a[t][s]) {
        const l = a[t][s][o];
        if (!/^(?:CC|SERVICE)/.test(l.instreamId))
          continue;
        const c = n.options_.vhs && n.options_.vhs.captionServices || {};
        let d = {
          label: o,
          language: l.language,
          instreamId: l.instreamId,
          default: l.default && l.autoselect
        };
        if (c[d.instreamId] && (d = gt(d, c[d.instreamId])), d.default === void 0 && delete d.default, i[s].push(gt({
          id: o
        }, l)), typeof r[o] > "u") {
          const f = n.addRemoteTextTrack({
            id: d.instreamId,
            kind: "captions",
            default: d.default,
            language: d.language,
            label: d.label
          }, !1).track;
          r[o] = f;
        }
      }
    }
  }
}, rx = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (Ap(e, t[n]) || t[n].playlists && rx(t[n].playlists, e))
      return !0;
  return !1;
}, ere = (t, e) => (n) => {
  const {
    mainPlaylistLoader: a,
    mediaTypes: {
      [t]: {
        groups: i
      }
    }
  } = e, r = a.media();
  if (!r)
    return null;
  let s = null;
  r.attributes[t] && (s = i[r.attributes[t]]);
  const o = Object.keys(i);
  if (!s)
    if (t === "AUDIO" && o.length > 1 && Xl(e.main))
      for (let l = 0; l < o.length; l++) {
        const c = i[o[l]];
        if (rx(c, r)) {
          s = c;
          break;
        }
      }
    else i.main ? s = i.main : o.length === 1 && (s = i[o[0]]);
  return typeof n > "u" ? s : n === null || !s ? null : s.filter((l) => l.id === n.id)[0] || null;
}, tre = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: n
        }
      }
    } = e;
    for (const a in n)
      if (n[a].enabled)
        return n[a];
    return null;
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: n
        }
      }
    } = e;
    for (const a in n)
      if (n[a].mode === "showing" || n[a].mode === "hidden")
        return n[a];
    return null;
  }
}, nre = (t, {
  mediaTypes: e
}) => () => {
  const n = e[t].activeTrack();
  return n ? e[t].activeGroup(n) : null;
}, are = (t) => {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((c) => {
    Jie[c](c, t);
  });
  const {
    mediaTypes: e,
    mainPlaylistLoader: n,
    tech: a,
    vhs: i,
    segmentLoaders: {
      ["AUDIO"]: r,
      main: s
    }
  } = t;
  ["AUDIO", "SUBTITLES"].forEach((c) => {
    e[c].activeGroup = ere(c, t), e[c].activeTrack = tre[c](c, t), e[c].onGroupChanged = Zie(c, t), e[c].onGroupChanging = Kie(c, t), e[c].onTrackChanged = Qie(c, t), e[c].getActiveGroup = nre(c, t);
  });
  const o = e.AUDIO.activeGroup();
  if (o) {
    const c = (o.filter((f) => f.default)[0] || o[0]).id;
    e.AUDIO.tracks[c].enabled = !0, e.AUDIO.onGroupChanged(), e.AUDIO.onTrackChanged(), e.AUDIO.getActiveGroup().playlistLoader ? (s.setAudio(!1), r.setAudio(!0)) : s.setAudio(!0);
  }
  n.on("mediachange", () => {
    ["AUDIO", "SUBTITLES"].forEach((c) => e[c].onGroupChanged());
  }), n.on("mediachanging", () => {
    ["AUDIO", "SUBTITLES"].forEach((c) => e[c].onGroupChanging());
  });
  const l = () => {
    e.AUDIO.onTrackChanged(), a.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
  };
  a.audioTracks().addEventListener("change", l), a.remoteTextTracks().addEventListener("change", e.SUBTITLES.onTrackChanged), i.on("dispose", () => {
    a.audioTracks().removeEventListener("change", l), a.remoteTextTracks().removeEventListener("change", e.SUBTITLES.onTrackChanged);
  }), a.clearTracks("audio");
  for (const c in e.AUDIO.tracks)
    a.audioTracks().addTrack(e.AUDIO.tracks[c]);
}, ire = () => {
  const t = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
    t[e] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: gi,
      activeTrack: gi,
      getActiveGroup: gi,
      onGroupChanged: gi,
      onTrackChanged: gi,
      lastTrack_: null,
      logger_: Ta(`MediaGroups[${e}]`)
    };
  }), t;
};
class jb {
  constructor() {
    this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
  }
  set version(e) {
    e === 1 && (this.version_ = e);
  }
  set ttl(e) {
    this.ttl_ = e || 300;
  }
  set reloadUri(e) {
    e && (this.reloadUri_ = Xn(this.reloadUri_, e));
  }
  set priority(e) {
    e && e.length && (this.priority_ = e);
  }
  set pathwayClones(e) {
    e && e.length && (this.pathwayClones_ = new Map(e.map((n) => [n.ID, n])));
  }
  get version() {
    return this.version_;
  }
  get ttl() {
    return this.ttl_;
  }
  get reloadUri() {
    return this.reloadUri_;
  }
  get priority() {
    return this.priority_;
  }
  get pathwayClones() {
    return this.pathwayClones_;
  }
}
class rre extends le.EventTarget {
  constructor(e, n) {
    super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new jb(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = Ta("Content Steering"), this.xhr_ = e, this.getBandwidth_ = n;
  }
  /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */
  assignTagProperties(e, n) {
    this.manifestType_ = n.serverUri ? "HLS" : "DASH";
    const a = n.serverUri || n.serverURL;
    if (!a) {
      this.logger_(`steering manifest URL is ${a}, cannot request steering manifest.`), this.trigger("error");
      return;
    }
    if (a.startsWith("data:")) {
      this.decodeDataUriManifest_(a.substring(a.indexOf(",") + 1));
      return;
    }
    this.steeringManifest.reloadUri = Xn(e, a), this.defaultPathway = n.pathwayId || n.defaultServiceLocation, this.queryBeforeStart = n.queryBeforeStart, this.proxyServerUrl_ = n.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
  }
  /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */
  requestSteeringManifest(e) {
    const n = this.steeringManifest.reloadUri;
    if (!n)
      return;
    const a = e ? n : this.getRequestURI(n);
    if (!a) {
      this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
      return;
    }
    const i = {
      contentSteeringInfo: {
        uri: a
      }
    };
    this.trigger({
      type: "contentsteeringloadstart",
      metadata: i
    }), this.request_ = this.xhr_({
      uri: a,
      requestType: "content-steering-manifest"
    }, (r, s) => {
      if (r) {
        if (s.status === 410) {
          this.logger_(`manifest request 410 ${r}.`), this.logger_(`There will be no more content steering requests to ${a} this session.`), this.excludedSteeringManifestURLs.add(a);
          return;
        }
        if (s.status === 429) {
          const c = s.responseHeaders["retry-after"];
          this.logger_(`manifest request 429 ${r}.`), this.logger_(`content steering will retry in ${c} seconds.`), this.startTTLTimeout_(parseInt(c, 10));
          return;
        }
        this.logger_(`manifest failed to load ${r}.`), this.startTTLTimeout_();
        return;
      }
      this.trigger({
        type: "contentsteeringloadcomplete",
        metadata: i
      });
      let o;
      try {
        o = JSON.parse(this.request_.responseText);
      } catch (c) {
        const d = {
          errorType: le.Error.StreamingContentSteeringParserError,
          error: c
        };
        this.trigger({
          type: "error",
          metadata: d
        });
      }
      this.assignSteeringProperties_(o);
      const l = {
        contentSteeringInfo: i.contentSteeringInfo,
        contentSteeringManifest: {
          version: this.steeringManifest.version,
          reloadUri: this.steeringManifest.reloadUri,
          priority: this.steeringManifest.priority
        }
      };
      this.trigger({
        type: "contentsteeringparsed",
        metadata: l
      }), this.startTTLTimeout_();
    });
  }
  /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */
  setProxyServerUrl_(e) {
    const n = new Y.URL(e), a = new Y.URL(this.proxyServerUrl_);
    return a.searchParams.set("url", encodeURI(n.toString())), this.setSteeringParams_(a.toString());
  }
  /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */
  decodeDataUriManifest_(e) {
    const n = JSON.parse(Y.atob(e));
    this.assignSteeringProperties_(n);
  }
  /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */
  setSteeringParams_(e) {
    const n = new Y.URL(e), a = this.getPathway(), i = this.getBandwidth_();
    if (a) {
      const r = `_${this.manifestType_}_pathway`;
      n.searchParams.set(r, a);
    }
    if (i) {
      const r = `_${this.manifestType_}_throughput`;
      n.searchParams.set(r, i);
    }
    return n.toString();
  }
  /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */
  assignSteeringProperties_(e) {
    if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
      this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
      return;
    }
    this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
    const a = ((i) => {
      for (const r of i)
        if (this.availablePathways_.has(r))
          return r;
      return [...this.availablePathways_][0];
    })(this.steeringManifest.priority);
    this.currentPathway !== a && (this.currentPathway = a, this.trigger("content-steering"));
  }
  /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */
  getPathway() {
    return this.currentPathway || this.defaultPathway;
  }
  /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */
  getRequestURI(e) {
    if (!e)
      return null;
    const n = (i) => this.excludedSteeringManifestURLs.has(i);
    if (this.proxyServerUrl_) {
      const i = this.setProxyServerUrl_(e);
      if (!n(i))
        return i;
    }
    const a = this.setSteeringParams_(e);
    return n(a) ? null : a;
  }
  /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */
  startTTLTimeout_(e = this.steeringManifest.ttl) {
    const n = e * 1e3;
    this.ttlTimeout_ = Y.setTimeout(() => {
      this.requestSteeringManifest();
    }, n);
  }
  /**
   * Clear the TTL timeout if necessary.
   */
  clearTTLTimeout_() {
    Y.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
  }
  /**
   * aborts any current steering xhr and sets the current request object to null
   */
  abort() {
    this.request_ && this.request_.abort(), this.request_ = null;
  }
  /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */
  dispose() {
    this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new jb();
  }
  /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */
  addAvailablePathway(e) {
    e && this.availablePathways_.add(e);
  }
  /**
   * Clears all pathways from the available pathways set
   */
  clearAvailablePathways() {
    this.availablePathways_.clear();
  }
  /**
   * Removes a pathway from the available pathways set.
   */
  excludePathway(e) {
    return this.availablePathways_.delete(e);
  }
  /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */
  didDASHTagChange(e, n) {
    return !n && this.steeringManifest.reloadUri || n && (Xn(e, n.serverURL) !== this.steeringManifest.reloadUri || n.defaultServiceLocation !== this.defaultPathway || n.queryBeforeStart !== this.queryBeforeStart || n.proxyServerURL !== this.proxyServerUrl_);
  }
  getAvailablePathways() {
    return this.availablePathways_;
  }
}
const sre = (t, e) => {
  let n = null;
  return (...a) => {
    clearTimeout(n), n = setTimeout(() => {
      t.apply(null, a);
    }, e);
  };
}, ore = 10;
let Hi;
const lre = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], cre = function(t) {
  return this.audioSegmentLoader_[t] + this.mainSegmentLoader_[t];
}, ure = function({
  currentPlaylist: t,
  buffered: e,
  currentTime: n,
  nextPlaylist: a,
  bufferLowWaterLine: i,
  bufferHighWaterLine: r,
  duration: s,
  bufferBasedABR: o,
  log: l
}) {
  if (!a)
    return le.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  const c = `allowing switch ${t && t.id || "null"} -> ${a.id}`;
  if (!t)
    return l(`${c} as current playlist is not set`), !0;
  if (a.id === t.id)
    return !1;
  const d = !!ps(e, n).length;
  if (!t.endList)
    return !d && typeof t.partTargetDuration == "number" ? (l(`not ${c} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (l(`${c} as current playlist is live`), !0);
  const f = kp(e, n), g = o ? mn.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : mn.MAX_BUFFER_LOW_WATER_LINE;
  if (s < g)
    return l(`${c} as duration < max low water line (${s} < ${g})`), !0;
  const _ = a.attributes.BANDWIDTH, x = t.attributes.BANDWIDTH;
  if (_ < x && (!o || f < r)) {
    let p = `${c} as next bandwidth < current bandwidth (${_} < ${x})`;
    return o && (p += ` and forwardBuffer < bufferHighWaterLine (${f} < ${r})`), l(p), !0;
  }
  if ((!o || _ > x) && f >= i) {
    let p = `${c} as forwardBuffer >= bufferLowWaterLine (${f} >= ${i})`;
    return o && (p += ` and next bandwidth > current bandwidth (${_} > ${x})`), l(p), !0;
  }
  return l(`not ${c} as no switching criteria met`), !1;
};
class dre extends le.EventTarget {
  constructor(e) {
    super(), this.fastQualityChange_ = sre(this.fastQualityChange_.bind(this), 100);
    const {
      src: n,
      withCredentials: a,
      tech: i,
      bandwidth: r,
      externVhs: s,
      useCueTags: o,
      playlistExclusionDuration: l,
      enableLowInitialPlaylist: c,
      sourceType: d,
      cacheEncryptionKeys: f,
      bufferBasedABR: g,
      leastPixelDiffSelector: _,
      captionServices: x,
      experimentalUseMMS: p
    } = e;
    if (!n)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    let {
      maxPlaylistRetries: w
    } = e;
    (w === null || typeof w > "u") && (w = 1 / 0), Hi = s, this.bufferBasedABR = !!g, this.leastPixelDiffSelector = !!_, this.withCredentials = a, this.tech_ = i, this.vhs_ = i.vhs, this.player_ = e.player_, this.sourceType_ = d, this.useCueTags_ = o, this.playlistExclusionDuration = l, this.maxPlaylistRetries = w, this.enableLowInitialPlaylist = c, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
      withCredentials: a,
      maxPlaylistRetries: w,
      timeout: null
    }, this.on("error", this.pauseLoading), this.mediaTypes_ = ire(), p && Y.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new Y.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, le.log("Using ManagedMediaSource")) : Y.MediaSource && (this.mediaSource = new Y.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = vn(), this.hasPlayed_ = !1, this.syncController_ = new Vie(e), this.segmentMetadataTrack_ = i.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, this.decrypter_ = new Gie(), this.sourceUpdater_ = new nx(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new qie(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
    const C = {
      vhs: this.vhs_,
      parse708captions: e.parse708captions,
      useDtsForTimestampOffset: e.useDtsForTimestampOffset,
      captionServices: x,
      mediaSource: this.mediaSource,
      currentTime: this.tech_.currentTime.bind(this.tech_),
      seekable: () => this.seekable(),
      seeking: () => this.tech_.seeking(),
      duration: () => this.duration(),
      hasPlayed: () => this.hasPlayed_,
      goalBufferLength: () => this.goalBufferLength(),
      bandwidth: r,
      syncController: this.syncController_,
      decrypter: this.decrypter_,
      sourceType: this.sourceType_,
      inbandTextTracks: this.inbandTextTracks_,
      cacheEncryptionKeys: f,
      sourceUpdater: this.sourceUpdater_,
      timelineChangeController: this.timelineChangeController_,
      exactManifestTimings: e.exactManifestTimings,
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    };
    this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new Ih(n, this.vhs_, gt(this.requestOptions_, {
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    })) : new ms(n, this.vhs_, gt(this.requestOptions_, {
      addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
    })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new Ph(gt(C, {
      segmentMetadataTrack: this.segmentMetadataTrack_,
      loaderType: "main"
    }), e), this.audioSegmentLoader_ = new Ph(gt(C, {
      loaderType: "audio"
    }), e), this.subtitleSegmentLoader_ = new zie(gt(C, {
      loaderType: "vtt",
      featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
      loadVttJs: () => new Promise((L, D) => {
        function B() {
          i.off("vttjserror", P), L();
        }
        function P() {
          i.off("vttjsloaded", B), D();
        }
        i.one("vttjsloaded", B), i.one("vttjserror", P), i.addWebVttScript_();
      })
    }), e);
    const M = () => this.mainSegmentLoader_.bandwidth;
    this.contentSteeringController_ = new rre(this.vhs_.xhr, M), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), lre.forEach((L) => {
      this[L + "_"] = cre.bind(this, L);
    }), this.logger_ = Ta("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
      this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
    }, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
    const A = this.tech_.preload() === "none" ? "play" : "loadstart";
    this.tech_.one(A, () => {
      const L = Date.now();
      this.tech_.one("loadeddata", () => {
        this.timeToLoadedData__ = Date.now() - L, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
      });
    });
  }
  mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  }
  audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  }
  appendsToLoadedData_() {
    const e = this.mainAppendsToLoadedData_(), n = this.audioAppendsToLoadedData_();
    return e === -1 || n === -1 ? -1 : e + n;
  }
  timeToLoadedData_() {
    return this.timeToLoadedData__;
  }
  /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */
  checkABR_(e = "abr") {
    const n = this.selectPlaylist();
    n && this.shouldSwitchToMedia_(n) && this.switchMedia_(n, e);
  }
  switchMedia_(e, n, a) {
    const i = this.media(), r = i && (i.id || i.uri), s = e && (e.id || e.uri);
    if (r && r !== s) {
      this.logger_(`switch media ${r} -> ${s} from ${n}`);
      const o = {
        renditionInfo: {
          id: s,
          bandwidth: e.attributes.BANDWIDTH,
          resolution: e.attributes.RESOLUTION,
          codecs: e.attributes.CODECS
        },
        cause: n
      };
      this.trigger({
        type: "renditionselected",
        metadata: o
      }), this.tech_.trigger({
        type: "usage",
        name: `vhs-rendition-change-${n}`
      });
    }
    this.mainPlaylistLoader_.media(e, a);
  }
  /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */
  switchMediaForDASHContentSteering_() {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
      const n = this.mediaTypes_[e], a = n ? n.activeGroup() : null, i = this.contentSteeringController_.getPathway();
      if (a && i) {
        const s = (a.length ? a[0].playlists : a.playlists).filter((o) => o.attributes.serviceLocation === i);
        s.length && this.mediaTypes_[e].activePlaylistLoader.media(s[0]);
      }
    });
  }
  /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */
  startABRTimer_() {
    this.stopABRTimer_(), this.abrTimer_ = Y.setInterval(() => this.checkABR_(), 250);
  }
  /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */
  stopABRTimer_() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (Y.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }
  /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */
  getAudioTrackPlaylists_() {
    const e = this.main(), n = e && e.playlists || [];
    if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO)
      return n;
    const a = e.mediaGroups.AUDIO, i = Object.keys(a);
    let r;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      r = this.mediaTypes_.AUDIO.activeTrack();
    else {
      const o = a.main || i.length && a[i[0]];
      for (const l in o)
        if (o[l].default) {
          r = {
            label: l
          };
          break;
        }
    }
    if (!r)
      return n;
    const s = [];
    for (const o in a)
      if (a[o][r.label]) {
        const l = a[o][r.label];
        if (l.playlists && l.playlists.length)
          s.push.apply(s, l.playlists);
        else if (l.uri)
          s.push(l);
        else if (e.playlists.length)
          for (let c = 0; c < e.playlists.length; c++) {
            const d = e.playlists[c];
            d.attributes && d.attributes.AUDIO && d.attributes.AUDIO === o && s.push(d);
          }
      }
    return s.length ? s : n;
  }
  /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */
  setupMainPlaylistLoaderListeners_() {
    this.mainPlaylistLoader_.on("loadedmetadata", () => {
      const n = this.mainPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
      Ch(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = a, n.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(n, this.requestOptions_), this.mainSegmentLoader_.load()), are({
        sourceType: this.sourceType_,
        segmentLoaders: {
          AUDIO: this.audioSegmentLoader_,
          SUBTITLES: this.subtitleSegmentLoader_,
          main: this.mainSegmentLoader_
        },
        tech: this.tech_,
        requestOptions: this.requestOptions_,
        mainPlaylistLoader: this.mainPlaylistLoader_,
        vhs: this.vhs_,
        main: this.main(),
        mediaTypes: this.mediaTypes_,
        excludePlaylist: this.excludePlaylist.bind(this)
      }), this.triggerPresenceUsage_(this.main(), n), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
        this.trigger("selectedinitialmedia");
      });
    }), this.mainPlaylistLoader_.on("loadedplaylist", () => {
      this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
      let n = this.mainPlaylistLoader_.media();
      if (!n) {
        this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
        let a;
        if (this.enableLowInitialPlaylist && (a = this.selectInitialPlaylist()), a || (a = this.selectPlaylist()), !a || !this.shouldSwitchToMedia_(a) || (this.initialMedia_ = a, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments)))
          return;
        n = this.initialMedia_;
      }
      this.handleUpdatedMediaPlaylist(n);
    }), this.mainPlaylistLoader_.on("error", () => {
      const n = this.mainPlaylistLoader_.error;
      this.excludePlaylist({
        playlistToExclude: n.playlist,
        error: n
      });
    }), this.mainPlaylistLoader_.on("mediachanging", () => {
      this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
    }), this.mainPlaylistLoader_.on("mediachange", () => {
      const n = this.mainPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
      Ch(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = a, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(n, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.mainPlaylistLoader_.on("playlistunchanged", () => {
      const n = this.mainPlaylistLoader_.media();
      if (n.lastExcludeReason_ === "playlist-unchanged")
        return;
      this.stuckAtPlaylistEnd_(n) && (this.excludePlaylist({
        error: {
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }
      }), this.tech_.trigger("playliststuck"));
    }), this.mainPlaylistLoader_.on("renditiondisabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
    }), this.mainPlaylistLoader_.on("renditionenabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
    }), ["manifestrequeststart", "manifestrequestcomplete", "manifestparsestart", "manifestparsecomplete", "playlistrequeststart", "playlistrequestcomplete", "playlistparsestart", "playlistparsecomplete", "renditiondisabled", "renditionenabled"].forEach((n) => {
      this.mainPlaylistLoader_.on(n, (a) => {
        this.player_.trigger(Jt({}, a));
      });
    });
  }
  /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */
  handleUpdatedMediaPlaylist(e) {
    this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }
  /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */
  triggerPresenceUsage_(e, n) {
    const a = e.mediaGroups || {};
    let i = !0;
    const r = Object.keys(a.AUDIO);
    for (const s in a.AUDIO)
      for (const o in a.AUDIO[s])
        a.AUDIO[s][o].uri || (i = !1);
    i && this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), Object.keys(a.SUBTITLES).length && this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), Hi.Playlist.isAes(n) && this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), r.length && Object.keys(a.AUDIO[r[0]]).length > 1 && this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.useCueTags_ && this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    });
  }
  shouldSwitchToMedia_(e) {
    const n = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, a = this.tech_.currentTime(), i = this.bufferLowWaterLine(), r = this.bufferHighWaterLine(), s = this.tech_.buffered();
    return ure({
      buffered: s,
      currentTime: a,
      currentPlaylist: n,
      nextPlaylist: e,
      bufferLowWaterLine: i,
      bufferHighWaterLine: r,
      duration: this.duration(),
      bufferBasedABR: this.bufferBasedABR,
      log: this.logger_
    });
  }
  /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */
  setupSegmentLoaderListeners_() {
    this.mainSegmentLoader_.on("bandwidthupdate", () => {
      this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", () => {
      this.bufferBasedABR && this.mainSegmentLoader_.load();
    }), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
      this.trigger("progress");
    }), this.mainSegmentLoader_.on("error", () => {
      const a = this.mainSegmentLoader_.error();
      this.excludePlaylist({
        playlistToExclude: a.playlist,
        error: a
      });
    }), this.mainSegmentLoader_.on("appenderror", () => {
      this.error = this.mainSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", () => {
      this.error = this.audioSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("ended", () => {
      this.logger_("main segment loader ended"), this.onEndOfStream();
    }), this.timelineChangeController_.on("audioTimelineBehind", () => {
      const a = this.audioSegmentLoader_.pendingSegment_;
      if (!a || !a.segment || !a.segment.syncInfo)
        return;
      const i = a.segment.syncInfo.end + 0.01;
      this.tech_.setCurrentTime(i);
    }), this.timelineChangeController_.on("fixBadTimelineChange", () => {
      this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
    }), this.mainSegmentLoader_.on("earlyabort", (a) => {
      this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
        error: {
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        },
        playlistExclusionDuration: ore
      }));
    });
    const e = () => {
      if (!this.sourceUpdater_.hasCreatedSourceBuffers())
        return this.tryToCreateSourceBuffers_();
      const a = this.getCodecsOrExclude_();
      a && this.sourceUpdater_.addOrChangeSourceBuffers(a);
    };
    this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", () => {
      this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
    }), ["segmentselected", "segmentloadstart", "segmentloaded", "segmentkeyloadstart", "segmentkeyloadcomplete", "segmentdecryptionstart", "segmentdecryptioncomplete", "segmenttransmuxingstart", "segmenttransmuxingcomplete", "segmenttransmuxingtrackinfoavailable", "segmenttransmuxingtiminginfoavailable", "segmentappendstart", "appendsdone", "bandwidthupdated", "timelinechange", "codecschange"].forEach((a) => {
      this.mainSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      }), this.audioSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      }), this.subtitleSegmentLoader_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    });
  }
  mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }
  /**
   * Call load on our SegmentLoaders
   */
  load() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }
  /**
   * Call pause on our SegmentLoaders
   */
  pause() {
    this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
  }
  /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */
  fastQualityChange_(e = this.selectPlaylist()) {
    if (e && e === this.mainPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
  }
  runFastQualitySwitch_() {
    this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * Begin playback.
   */
  play() {
    if (this.setupFirstPlay())
      return;
    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
    const e = this.tech_.seekable();
    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < e.start(0))
      return this.tech_.setCurrentTime(e.end(e.length - 1));
  }
  /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */
  setupFirstPlay() {
    const e = this.mainPlaylistLoader_.media();
    if (!e || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!e.endList || e.start) {
      const n = this.seekable();
      if (!n.length)
        return !1;
      const a = n.end(0);
      let i = a;
      if (e.start) {
        const r = e.start.timeOffset;
        r < 0 ? i = Math.max(a + r, n.start(0)) : i = Math.min(a, r);
      }
      this.trigger("firstplay"), this.tech_.setCurrentTime(i);
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }
  /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */
  handleSourceOpen_() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      const e = this.tech_.play();
      typeof e < "u" && typeof e.then == "function" && e.then(null, (n) => {
      });
    }
    this.trigger("sourceopen");
  }
  /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */
  handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_)
      return;
    const e = this.inbandTextTracks_.metadataTrack_.cues;
    if (!e || !e.length)
      return;
    const n = this.duration();
    e[e.length - 1].endTime = isNaN(n) || Math.abs(n) === 1 / 0 ? Number.MAX_VALUE : n;
  }
  /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */
  handleDurationChange_() {
    this.tech_.trigger("durationchange");
  }
  /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */
  onEndOfStream() {
    let e = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      const n = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !n || n.hasVideo ? e = e && this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
    }
    e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }
  /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */
  stuckAtPlaylistEnd_(e) {
    if (!this.seekable().length)
      return !1;
    const a = this.syncController_.getExpiredTime(e, this.duration());
    if (a === null)
      return !1;
    const i = Hi.Playlist.playlistEnd(e, a), r = this.tech_.currentTime(), s = this.tech_.buffered();
    if (!s.length)
      return i - r <= Ka;
    const o = s.end(s.length - 1);
    return o - r <= Ka && i - o <= Ka;
  }
  /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */
  excludePlaylist({
    playlistToExclude: e = this.mainPlaylistLoader_.media(),
    error: n = {},
    playlistExclusionDuration: a
  }) {
    if (e = e || this.mainPlaylistLoader_.media(), a = a || n.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
      this.error = n, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    e.playlistErrors_++;
    const i = this.mainPlaylistLoader_.main.playlists, r = i.filter(Ad), s = r.length === 1 && r[0] === e;
    if (i.length === 1 && a !== 1 / 0)
      return le.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(s);
    if (s) {
      if (this.main().contentSteering) {
        const x = this.pathwayAttribute_(e), p = this.contentSteeringController_.steeringManifest.ttl * 1e3;
        this.contentSteeringController_.excludePathway(x), this.excludeThenChangePathway_(), setTimeout(() => {
          this.contentSteeringController_.addAvailablePathway(x);
        }, p);
        return;
      }
      let _ = !1;
      i.forEach((x) => {
        if (x === e)
          return;
        const p = x.excludeUntil;
        typeof p < "u" && p !== 1 / 0 && (_ = !0, delete x.excludeUntil);
      }), _ && (le.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    let o;
    e.playlistErrors_ > this.maxPlaylistRetries ? o = 1 / 0 : o = Date.now() + a * 1e3, e.excludeUntil = o, n.reason && (e.lastExcludeReason_ = n.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-excluded"
    });
    const l = this.selectPlaylist();
    if (!l) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    const c = n.internal ? this.logger_ : le.log.warn, d = n.message ? " " + n.message : "";
    c(`${n.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${d} Switching to playlist ${l.id}.`), l.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), l.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    const f = l.targetDuration / 2 * 1e3 || 5 * 1e3, g = typeof l.lastRequest == "number" && Date.now() - l.lastRequest <= f;
    return this.switchMedia_(l, "exclude", s || g);
  }
  /**
   * Pause all segment/playlist loaders
   */
  pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }
  /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */
  delegateLoaders_(e, n) {
    const a = [], i = e === "all";
    (i || e === "main") && a.push(this.mainPlaylistLoader_);
    const r = [];
    (i || e === "audio") && r.push("AUDIO"), (i || e === "subtitle") && (r.push("CLOSED-CAPTIONS"), r.push("SUBTITLES")), r.forEach((s) => {
      const o = this.mediaTypes_[s] && this.mediaTypes_[s].activePlaylistLoader;
      o && a.push(o);
    }), ["main", "audio", "subtitle"].forEach((s) => {
      const o = this[`${s}SegmentLoader_`];
      o && (e === s || e === "all") && a.push(o);
    }), a.forEach((s) => n.forEach((o) => {
      typeof s[o] == "function" && s[o]();
    }));
  }
  /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */
  setCurrentTime(e) {
    const n = ps(this.tech_.buffered(), e);
    if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments)
      return 0;
    if (n && n.length)
      return e;
    this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */
  duration() {
    if (!this.mainPlaylistLoader_)
      return 0;
    const e = this.mainPlaylistLoader_.media();
    return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : Hi.Playlist.duration(e) : 1 / 0 : 0;
  }
  /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */
  seekable() {
    return this.seekable_;
  }
  getSeekableRange_(e, n) {
    const a = e.media();
    if (!a)
      return null;
    const i = this.syncController_.getMediaSequenceSync(n);
    if (i && i.isReliable) {
      const o = i.start, l = i.end;
      if (!isFinite(o) || !isFinite(l))
        return null;
      const c = Hi.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, a), d = Math.max(0, l - c);
      return d < o ? null : vn([[o, d]]);
    }
    const r = this.syncController_.getExpiredTime(a, this.duration());
    if (r === null)
      return null;
    const s = Hi.Playlist.seekable(a, r, Hi.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, a));
    return s.length ? s : null;
  }
  computeFinalSeekable_(e, n) {
    if (!n)
      return e;
    const a = e.start(0), i = e.end(0), r = n.start(0), s = n.end(0);
    return r > i || a > s ? e : vn([[Math.max(a, r), Math.min(i, s)]]);
  }
  onSyncInfoUpdate_() {
    if (!this.mainPlaylistLoader_)
      return;
    const e = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
    if (!e)
      return;
    let n;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader && (n = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !n))
      return;
    const a = this.seekable_;
    if (this.seekable_ = this.computeFinalSeekable_(e, n), !this.seekable_ || a && a.length && this.seekable_.length && a.start(0) === this.seekable_.start(0) && a.end(0) === this.seekable_.end(0))
      return;
    this.logger_(`seekable updated [${g_(this.seekable_)}]`);
    const i = {
      seekableRanges: this.seekable_
    };
    this.trigger({
      type: "seekablerangeschanged",
      metadata: i
    }), this.tech_.trigger("seekablechanged");
  }
  /**
   * Update the player duration
   */
  updateDuration(e) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (e) {
      const i = this.seekable();
      if (!i.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < i.end(i.length - 1)) && this.sourceUpdater_.setDuration(i.end(i.length - 1));
      return;
    }
    const n = this.tech_.buffered();
    let a = Hi.Playlist.duration(this.mainPlaylistLoader_.media());
    n.length > 0 && (a = Math.max(a, n.end(n.length - 1))), this.mediaSource.duration !== a && this.sourceUpdater_.setDuration(a);
  }
  /**
   * dispose of the PlaylistController and everything
   * that it controls
   */
  dispose() {
    this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
      const n = this.mediaTypes_[e].groups;
      for (const a in n)
        n[a].forEach((i) => {
          i.playlistLoader && i.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }
  /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */
  main() {
    return this.mainPlaylistLoader_.main;
  }
  /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */
  media() {
    return this.mainPlaylistLoader_.media() || this.initialMedia_;
  }
  areMediaTypesKnown_() {
    const e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, n = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), a = e ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!n || !a);
  }
  // find from and to for codec switch event
  getCodecsOrExclude_() {
    const e = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, n = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    e.video = e.main;
    const a = fl(this.main(), n), i = {}, r = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (e.main.hasVideo && (i.video = a.video || e.main.videoCodec || CJ), e.main.isMuxed && (i.video += `,${a.audio || e.main.audioCodec || Sg}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || r) && (i.audio = a.audio || e.main.audioCodec || e.audio.audioCodec || Sg, e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !i.audio && !i.video) {
      this.excludePlaylist({
        playlistToExclude: n,
        error: {
          message: "Could not determine codecs for playlist."
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    const s = (c, d) => c ? ll(d, this.usingManagedMediaSource_) : _0(d), o = {};
    let l;
    if (["video", "audio"].forEach(function(c) {
      if (i.hasOwnProperty(c) && !s(e[c].isFmp4, i[c])) {
        const d = e[c].isFmp4 ? "browser" : "muxer";
        o[d] = o[d] || [], o[d].push(i[c]), c === "audio" && (l = d);
      }
    }), r && l && n.attributes.AUDIO) {
      const c = n.attributes.AUDIO;
      this.main().playlists.forEach((d) => {
        (d.attributes && d.attributes.AUDIO) === c && d !== n && (d.excludeUntil = 1 / 0);
      }), this.logger_(`excluding audio group ${c} as ${l} does not support codec(s): "${i.audio}"`);
    }
    if (Object.keys(o).length) {
      const c = Object.keys(o).reduce((d, f) => (d && (d += ", "), d += `${f} does not support codec(s): "${o[f].join(",")}"`, d), "") + ".";
      this.excludePlaylist({
        playlistToExclude: n,
        error: {
          internal: !0,
          message: c
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      const c = [];
      if (["video", "audio"].forEach((d) => {
        const f = (ja(this.sourceUpdater_.codecs[d] || "")[0] || {}).type, g = (ja(i[d] || "")[0] || {}).type;
        f && g && f.toLowerCase() !== g.toLowerCase() && c.push(`"${this.sourceUpdater_.codecs[d]}" -> "${i[d]}"`);
      }), c.length) {
        this.excludePlaylist({
          playlistToExclude: n,
          error: {
            message: `Codec switching not supported: ${c.join(", ")}.`,
            internal: !0
          },
          playlistExclusionDuration: 1 / 0
        });
        return;
      }
    }
    return i;
  }
  /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */
  tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_())
      return;
    const e = this.getCodecsOrExclude_();
    if (!e)
      return;
    this.sourceUpdater_.createSourceBuffers(e);
    const n = [e.video, e.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(n);
  }
  /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */
  excludeUnsupportedVariants_() {
    const e = this.main().playlists, n = [];
    Object.keys(e).forEach((a) => {
      const i = e[a];
      if (n.indexOf(i.id) !== -1)
        return;
      n.push(i.id);
      const r = fl(this.main, i), s = [];
      r.audio && !_0(r.audio) && !ll(r.audio, this.usingManagedMediaSource_) && s.push(`audio codec ${r.audio}`), r.video && !_0(r.video) && !ll(r.video, this.usingManagedMediaSource_) && s.push(`video codec ${r.video}`), r.text && r.text === "stpp.ttml.im1t" && s.push(`text codec ${r.text}`), s.length && (i.excludeUntil = 1 / 0, this.logger_(`excluding ${i.id} for unsupported: ${s.join(", ")}`));
    });
  }
  /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */
  excludeIncompatibleVariants_(e) {
    const n = [], a = this.main().playlists, i = Mu(ja(e)), r = Ib(i), s = i.video && ja(i.video)[0] || null, o = i.audio && ja(i.audio)[0] || null;
    Object.keys(a).forEach((l) => {
      const c = a[l];
      if (n.indexOf(c.id) !== -1 || c.excludeUntil === 1 / 0)
        return;
      n.push(c.id);
      const d = [], f = fl(this.mainPlaylistLoader_.main, c), g = Ib(f);
      if (!(!f.audio && !f.video)) {
        if (g !== r && d.push(`codec count "${g}" !== "${r}"`), !this.sourceUpdater_.canChangeType()) {
          const _ = f.video && ja(f.video)[0] || null, x = f.audio && ja(f.audio)[0] || null;
          _ && s && _.type.toLowerCase() !== s.type.toLowerCase() && d.push(`video codec "${_.type}" !== "${s.type}"`), x && o && x.type.toLowerCase() !== o.type.toLowerCase() && d.push(`audio codec "${x.type}" !== "${o.type}"`);
        }
        d.length && (c.excludeUntil = 1 / 0, this.logger_(`excluding ${c.id}: ${d.join(" && ")}`));
      }
    });
  }
  updateAdCues_(e) {
    let n = 0;
    const a = this.seekable();
    a.length && (n = a.start(0)), Hie(e, this.cueTagsTrack_, n);
  }
  /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */
  goalBufferLength() {
    const e = this.tech_.currentTime(), n = mn.GOAL_BUFFER_LENGTH, a = mn.GOAL_BUFFER_LENGTH_RATE, i = Math.max(n, mn.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(n + e * a, i);
  }
  /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */
  bufferLowWaterLine() {
    const e = this.tech_.currentTime(), n = mn.BUFFER_LOW_WATER_LINE, a = mn.BUFFER_LOW_WATER_LINE_RATE, i = Math.max(n, mn.MAX_BUFFER_LOW_WATER_LINE), r = Math.max(n, mn.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(n + e * a, this.bufferBasedABR ? r : i);
  }
  bufferHighWaterLine() {
    return mn.BUFFER_HIGH_WATER_LINE;
  }
  addDateRangesToTextTrack_(e) {
    Pb(this.inbandTextTracks_, "com.apple.streaming", this.tech_), xie({
      inbandTextTracks: this.inbandTextTracks_,
      dateRanges: e
    });
  }
  addMetadataToTextTrack(e, n, a) {
    const i = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
    Pb(this.inbandTextTracks_, e, this.tech_), vie({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: n,
      timestampOffset: i,
      videoDuration: a
    });
  }
  /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */
  pathwayAttribute_(e) {
    return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
  }
  /**
   * Initialize available pathways and apply the tag properties.
   */
  initContentSteeringController_() {
    const e = this.main();
    if (e.contentSteering) {
      for (const n of e.playlists)
        this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(n));
      if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
        this.contentSteeringController_.requestSteeringManifest(!0);
        return;
      }
      this.tech_.one("canplay", () => {
        this.contentSteeringController_.requestSteeringManifest();
      });
    }
  }
  /**
   * Reset the content steering controller and re-init.
   */
  resetContentSteeringController_() {
    this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
  }
  /**
   * Attaches the listeners for content steering.
   */
  attachContentSteeringListeners_() {
    this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), ["contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"].forEach((n) => {
      this.contentSteeringController_.on(n, (a) => {
        this.trigger(Jt({}, a));
      });
    }), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
      const n = this.main();
      (this.contentSteeringController_.didDASHTagChange(n.uri, n.contentSteering) || (() => {
        const r = this.contentSteeringController_.getAvailablePathways(), s = [];
        for (const o of n.playlists) {
          const l = o.attributes.serviceLocation;
          if (l && (s.push(l), !r.has(l)))
            return !0;
        }
        return !!(!s.length && r.size);
      })()) && this.resetContentSteeringController_();
    });
  }
  /**
   * Simple exclude and change playlist logic for content steering.
   */
  excludeThenChangePathway_() {
    const e = this.contentSteeringController_.getPathway();
    if (!e)
      return;
    this.handlePathwayClones_();
    const a = this.main().playlists, i = /* @__PURE__ */ new Set();
    let r = !1;
    Object.keys(a).forEach((s) => {
      const o = a[s], l = this.pathwayAttribute_(o), c = l && e !== l;
      o.excludeUntil === 1 / 0 && o.lastExcludeReason_ === "content-steering" && !c && (delete o.excludeUntil, delete o.lastExcludeReason_, r = !0);
      const f = !o.excludeUntil && o.excludeUntil !== 1 / 0;
      !i.has(o.id) && c && f && (i.add(o.id), o.excludeUntil = 1 / 0, o.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${o.id} for ${o.lastExcludeReason_}`));
    }), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((s) => {
      const o = this.mediaTypes_[s];
      if (o.activePlaylistLoader) {
        const l = o.activePlaylistLoader.media_;
        l && l.attributes.serviceLocation !== e && (r = !0);
      }
    }), r && this.changeSegmentPathway_();
  }
  /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */
  handlePathwayClones_() {
    const n = this.main().playlists, a = this.contentSteeringController_.currentPathwayClones, i = this.contentSteeringController_.nextPathwayClones;
    if (a && a.size || i && i.size) {
      for (const [s, o] of a.entries())
        i.get(s) || (this.mainPlaylistLoader_.updateOrDeleteClone(o), this.contentSteeringController_.excludePathway(s));
      for (const [s, o] of i.entries()) {
        const l = a.get(s);
        if (!l) {
          n.filter((d) => d.attributes["PATHWAY-ID"] === o["BASE-ID"]).forEach((d) => {
            this.mainPlaylistLoader_.addClonePathway(o, d);
          }), this.contentSteeringController_.addAvailablePathway(s);
          continue;
        }
        this.equalPathwayClones_(l, o) || (this.mainPlaylistLoader_.updateOrDeleteClone(o, !0), this.contentSteeringController_.addAvailablePathway(s));
      }
      this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...i])));
    }
  }
  /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */
  equalPathwayClones_(e, n) {
    if (e["BASE-ID"] !== n["BASE-ID"] || e.ID !== n.ID || e["URI-REPLACEMENT"].HOST !== n["URI-REPLACEMENT"].HOST)
      return !1;
    const a = e["URI-REPLACEMENT"].PARAMS, i = n["URI-REPLACEMENT"].PARAMS;
    for (const r in a)
      if (a[r] !== i[r])
        return !1;
    for (const r in i)
      if (a[r] !== i[r])
        return !1;
    return !0;
  }
  /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */
  changeSegmentPathway_() {
    const e = this.selectPlaylist();
    this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
  }
  /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */
  excludeNonUsablePlaylistsByKeyId_() {
    if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main)
      return;
    let e = 0;
    const n = "non-usable";
    this.mainPlaylistLoader_.main.playlists.forEach((a) => {
      const i = this.mainPlaylistLoader_.getKeyIdSet(a);
      !i || !i.size || i.forEach((r) => {
        const s = "usable", o = this.keyStatusMap_.has(r) && this.keyStatusMap_.get(r) === s, l = a.lastExcludeReason_ === n && a.excludeUntil === 1 / 0;
        o ? o && l && (delete a.excludeUntil, delete a.lastExcludeReason_, this.logger_(`enabling playlist ${a.id} because key ID ${r} is ${s}`)) : (a.excludeUntil !== 1 / 0 && a.lastExcludeReason_ !== n && (a.excludeUntil = 1 / 0, a.lastExcludeReason_ = n, this.logger_(`excluding playlist ${a.id} because the key ID ${r} doesn't exist in the keyStatusMap or is not ${s}`)), e++);
      });
    }), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((a) => {
      const i = a && a.attributes && a.attributes.RESOLUTION && a.attributes.RESOLUTION.height < 720, r = a.excludeUntil === 1 / 0 && a.lastExcludeReason_ === n;
      i && r && (delete a.excludeUntil, le.log.warn(`enabling non-HD playlist ${a.id} because all playlists were excluded due to ${n} key IDs`));
    });
  }
  /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */
  addKeyStatus_(e, n) {
    const r = (typeof e == "string" ? e : $ie(e)).slice(0, 32).toLowerCase();
    this.logger_(`KeyStatus '${n}' with key ID ${r} added to the keyStatusMap`), this.keyStatusMap_.set(r, n);
  }
  /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */
  updatePlaylistByKeyStatus(e, n) {
    this.addKeyStatus_(e, n), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
  }
  excludeNonUsableThenChangePlaylist_() {
    this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
  }
}
const hre = (t, e, n) => (a) => {
  const i = t.main.playlists[e], r = Cp(i), s = Ad(i);
  if (typeof a > "u")
    return s;
  a ? delete i.disabled : i.disabled = !0;
  const o = {
    renditionInfo: {
      id: e,
      bandwidth: i.attributes.BANDWIDTH,
      resolution: i.attributes.RESOLUTION,
      codecs: i.attributes.CODECS
    },
    cause: "fast-quality"
  };
  return a !== s && !r && (a ? (n(i), t.trigger({
    type: "renditionenabled",
    metadata: o
  })) : t.trigger({
    type: "renditiondisabled",
    metadata: o
  })), a;
};
class fre {
  constructor(e, n, a) {
    const {
      playlistController_: i
    } = e, r = i.fastQualityChange_.bind(i);
    if (n.attributes) {
      const s = n.attributes.RESOLUTION;
      this.width = s && s.width, this.height = s && s.height, this.bandwidth = n.attributes.BANDWIDTH, this.frameRate = n.attributes["FRAME-RATE"];
    }
    this.codecs = fl(i.main(), n), this.playlist = n, this.id = a, this.enabled = hre(e.playlists, n.id, r);
  }
}
const pre = function(t) {
  t.representations = () => {
    const e = t.playlistController_.main(), n = Xl(e) ? t.playlistController_.getAudioTrackPlaylists_() : e.playlists;
    return n ? n.filter((a) => !Cp(a)).map((a, i) => new fre(t, a, a.id)) : [];
  };
}, Vb = ["seeking", "seeked", "pause", "playing", "error"];
class mre extends le.EventTarget {
  /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */
  constructor(e) {
    super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Ta("PlaybackWatcher"), this.logger_("initialize");
    const n = () => this.monitorCurrentTime_(), a = () => this.monitorCurrentTime_(), i = () => this.techWaiting_(), r = () => this.resetTimeUpdate_(), s = this.playlistController_, o = ["main", "subtitle", "audio"], l = {};
    o.forEach((d) => {
      l[d] = {
        reset: () => this.resetSegmentDownloads_(d),
        updateend: () => this.checkSegmentDownloads_(d)
      }, s[`${d}SegmentLoader_`].on("appendsdone", l[d].updateend), s[`${d}SegmentLoader_`].on("playlistupdate", l[d].reset), this.tech_.on(["seeked", "seeking"], l[d].reset);
    });
    const c = (d) => {
      ["main", "audio"].forEach((f) => {
        s[`${f}SegmentLoader_`][d]("appended", this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = () => {
      this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), c("off"));
    }, this.clearSeekingAppendCheck_ = () => c("off"), this.watchForBadSeeking_ = () => {
      this.clearSeekingAppendCheck_(), c("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", i), this.tech_.on(Vb, r), this.tech_.on("canplay", a), this.tech_.one("play", n), this.dispose = () => {
      this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", i), this.tech_.off(Vb, r), this.tech_.off("canplay", a), this.tech_.off("play", n), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((d) => {
        s[`${d}SegmentLoader_`].off("appendsdone", l[d].updateend), s[`${d}SegmentLoader_`].off("playlistupdate", l[d].reset), this.tech_.off(["seeked", "seeking"], l[d].reset);
      }), this.checkCurrentTimeTimeout_ && Y.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
    };
  }
  /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */
  monitorCurrentTime_() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && Y.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = Y.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }
  /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */
  resetSegmentDownloads_(e) {
    const n = this.playlistController_[`${e}SegmentLoader_`];
    this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = n.buffered_();
  }
  /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */
  checkSegmentDownloads_(e) {
    const n = this.playlistController_, a = n[`${e}SegmentLoader_`], i = a.buffered_(), r = Jne(this[`${e}Buffered_`], i);
    if (this[`${e}Buffered_`] = i, r) {
      const s = {
        bufferedRanges: i
      };
      n.trigger({
        type: "bufferedrangeschanged",
        metadata: s
      }), this.resetSegmentDownloads_(e);
      return;
    }
    this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
      playlistId: a.playlist_ && a.playlist_.id,
      buffered: kr(i)
    }), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
      type: "usage",
      name: `vhs-${e}-download-exclusion`
    }), e !== "subtitle" && n.excludePlaylist({
      error: {
        message: `Excessive ${e} segment downloading detected.`
      },
      playlistExclusionDuration: 1 / 0
    }));
  }
  /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */
  checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking())
      return;
    const e = this.tech_.currentTime(), n = this.tech_.buffered();
    if (this.lastRecordedTime === e && (!n.length || e + Ka >= n.end(n.length - 1)))
      return this.techWaiting_();
    if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime)
      this.consecutiveUpdates++, this.waiting_();
    else if (e === this.lastRecordedTime)
      this.consecutiveUpdates++;
    else {
      this.playedRanges_.push(vn([this.lastRecordedTime, e]));
      const a = {
        playedRanges: this.playedRanges_
      };
      this.playlistController_.trigger({
        type: "playedrangeschanged",
        metadata: a
      }), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
    }
  }
  /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */
  resetTimeUpdate_() {
    this.consecutiveUpdates = 0;
  }
  /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */
  fixesBadSeeks_() {
    if (!this.tech_.seeking())
      return !1;
    const n = this.seekable(), a = this.tech_.currentTime(), i = this.afterSeekableWindow_(n, a, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    let r;
    if (i && (r = n.end(n.length - 1)), this.beforeSeekableWindow_(n, a)) {
      const x = n.start(0);
      r = x + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (x === n.end(0) ? 0 : Ka);
    }
    if (typeof r < "u")
      return this.logger_(`Trying to seek outside of seekable at time ${a} with seekable range ${g_(n)}. Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0;
    const s = this.playlistController_.sourceUpdater_, o = this.tech_.buffered(), l = s.audioBuffer ? s.audioBuffered() : null, c = s.videoBuffer ? s.videoBuffered() : null, d = this.media(), f = d.partTargetDuration ? d.partTargetDuration : (d.targetDuration - Za) * 2, g = [l, c];
    for (let x = 0; x < g.length; x++) {
      if (!g[x])
        continue;
      if (kp(g[x], a) < f)
        return !1;
    }
    const _ = Oc(o, a);
    return _.length === 0 ? !1 : (r = _.start(0) + Ka, this.logger_(`Buffered region starts (${_.start(0)})  just beyond seek point (${a}). Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0);
  }
  /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */
  waiting_() {
    if (this.techWaiting_())
      return;
    const e = this.tech_.currentTime(), n = this.tech_.buffered(), a = ps(n, e);
    if (a.length && e + 3 <= a.end(0)) {
      this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${a.start(0)} -> ${a.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      return;
    }
  }
  /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */
  techWaiting_() {
    const e = this.seekable(), n = this.tech_.currentTime();
    if (this.tech_.seeking())
      return !0;
    if (this.beforeSeekableWindow_(e, n)) {
      const o = e.end(e.length - 1);
      return this.logger_(`Fell out of live window at time ${n}. Seeking to live point (seekable end) ${o}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(o), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), !0;
    }
    const a = this.tech_.vhs.playlistController_.sourceUpdater_, i = this.tech_.buffered();
    if (this.videoUnderflow_({
      audioBuffered: a.audioBuffered(),
      videoBuffered: a.videoBuffered(),
      currentTime: n
    }))
      return this.resetTimeUpdate_(), this.tech_.setCurrentTime(n), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), !0;
    const s = Oc(i, n);
    return s.length > 0 ? (this.logger_(`Stopped at ${n} and seeking to ${s.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(n), !0) : !1;
  }
  afterSeekableWindow_(e, n, a, i = !1) {
    if (!e.length)
      return !1;
    let r = e.end(e.length - 1) + Ka;
    const s = !a.endList, o = typeof a.partTargetDuration == "number";
    return s && (o || i) && (r = e.end(e.length - 1) + a.targetDuration * 3), n > r;
  }
  beforeSeekableWindow_(e, n) {
    return !!(e.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    e.start(0) > 0 && n < e.start(0) - this.liveRangeSafeTimeDelta);
  }
  videoUnderflow_({
    videoBuffered: e,
    audioBuffered: n,
    currentTime: a
  }) {
    if (!e)
      return;
    let i;
    if (e.length && n.length) {
      const r = ps(e, a - 3), s = ps(e, a), o = ps(n, a);
      o.length && !s.length && r.length && (i = {
        start: r.end(0),
        end: o.end(0)
      });
    } else
      Oc(e, a).length || (i = this.gapFromVideoUnderflow_(e, a));
    return i ? (this.logger_(`Encountered a gap in video from ${i.start} to ${i.end}. Seeking to current time ${a}`), !0) : !1;
  }
  /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */
  skipTheGap_(e) {
    const n = this.tech_.buffered(), a = this.tech_.currentTime(), i = Oc(n, a);
    if (this.resetTimeUpdate_(), i.length === 0 || a !== e)
      return;
    this.logger_("skipTheGap_:", "currentTime:", a, "scheduled currentTime:", e, "nextRange start:", i.start(0)), this.tech_.setCurrentTime(i.start(0) + Za);
    const r = {
      gapInfo: {
        from: a,
        to: i.start(0)
      }
    };
    this.playlistController_.trigger({
      type: "gapjumped",
      metadata: r
    }), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
  }
  gapFromVideoUnderflow_(e, n) {
    const a = Zne(e);
    for (let i = 0; i < a.length; i++) {
      const r = a.start(i), s = a.end(i);
      if (n - r < 4 && n - r > 2)
        return {
          start: r,
          end: s
        };
    }
    return null;
  }
}
const gre = {
  errorInterval: 30,
  getSource(t) {
    const n = this.tech({
      IWillNotUseThisInPlugins: !0
    }).currentSource_ || this.currentSource();
    return t(n);
  }
}, sx = function(t, e) {
  let n = 0, a = 0;
  const i = gt(gre, e);
  t.ready(() => {
    t.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
  });
  const r = function() {
    a && t.currentTime(a);
  }, s = function(d) {
    d != null && (a = t.duration() !== 1 / 0 && t.currentTime() || 0, t.one("loadedmetadata", r), t.src(d), t.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), t.play());
  }, o = function() {
    if (Date.now() - n < i.errorInterval * 1e3) {
      t.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      return;
    }
    if (!i.getSource || typeof i.getSource != "function") {
      le.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return n = Date.now(), i.getSource.call(t, s);
  }, l = function() {
    t.off("loadedmetadata", r), t.off("error", o), t.off("dispose", l);
  }, c = function(d) {
    l(), sx(t, d);
  };
  t.on("error", o), t.on("dispose", l), t.reloadSourceOnError = c;
}, bre = function(t) {
  sx(this, t);
};
var ox = "3.16.2", vre = "7.1.0", yre = "1.3.1", _re = "7.2.0", xre = "4.0.2";
const Ht = {
  PlaylistLoader: ms,
  Playlist: Zn,
  utils: wae,
  STANDARD_PLAYLIST_SELECTOR: Ob,
  INITIAL_PLAYLIST_SELECTOR: fie,
  lastBandwidthSelector: Ob,
  movingAverageBandwidthSelector: die,
  comparePlaylistBandwidth: Lp,
  comparePlaylistResolution: uie,
  xhr: O_()
};
Object.keys(mn).forEach((t) => {
  Object.defineProperty(Ht, t, {
    get() {
      return le.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), mn[t];
    },
    set(e) {
      if (le.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), typeof e != "number" || e < 0) {
        le.log.warn(`value of Vhs.${t} must be greater than or equal to 0`);
        return;
      }
      mn[t] = e;
    }
  });
});
const lx = "videojs-vhs", cx = function(t, e) {
  const n = e.media();
  let a = -1;
  for (let i = 0; i < t.length; i++)
    if (t[i].id === n.id) {
      a = i;
      break;
    }
  t.selectedIndex_ = a, t.trigger({
    selectedIndex: a,
    type: "change"
  });
}, Tre = function(t, e) {
  e.representations().forEach((n) => {
    t.addQualityLevel(n);
  }), cx(t, e.playlists);
};
Ht.canPlaySource = function() {
  return le.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const wre = (t, e, n) => {
  if (!t)
    return t;
  let a = {};
  e && e.attributes && e.attributes.CODECS && (a = Mu(ja(e.attributes.CODECS))), n && n.attributes && n.attributes.CODECS && (a.audio = n.attributes.CODECS);
  const i = Bs(a.video), r = Bs(a.audio), s = {};
  for (const o in t)
    s[o] = {}, r && (s[o].audioContentType = r), i && (s[o].videoContentType = i), e.contentProtection && e.contentProtection[o] && e.contentProtection[o].pssh && (s[o].pssh = e.contentProtection[o].pssh), typeof t[o] == "string" && (s[o].url = t[o]);
  return gt(t, s);
}, kre = (t, e) => t.reduce((n, a) => {
  if (!a.contentProtection)
    return n;
  const i = e.reduce((r, s) => {
    const o = a.contentProtection[s];
    return o && o.pssh && (r[s] = {
      pssh: o.pssh
    }), r;
  }, {});
  return Object.keys(i).length && n.push(i), n;
}, []), Sre = ({
  player: t,
  sourceKeySystems: e,
  audioMedia: n,
  mainPlaylists: a
}) => {
  if (!t.eme.initializeMediaKeys)
    return Promise.resolve();
  const i = n ? a.concat([n]) : a, r = kre(i, Object.keys(e)), s = [], o = [];
  return r.forEach((l) => {
    o.push(new Promise((c, d) => {
      t.tech_.one("keysessioncreated", c);
    })), s.push(new Promise((c, d) => {
      t.eme.initializeMediaKeys({
        keySystems: l
      }, (f) => {
        if (f) {
          d(f);
          return;
        }
        c();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(s),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(o)
  ]);
}, Cre = ({
  player: t,
  sourceKeySystems: e,
  media: n,
  audioMedia: a
}) => {
  const i = wre(e, n, a);
  return i ? (t.currentSource().keySystems = i, i && !t.eme ? (le.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, ux = () => {
  if (!Y.localStorage)
    return null;
  const t = Y.localStorage.getItem(lx);
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, Are = (t) => {
  if (!Y.localStorage)
    return !1;
  let e = ux();
  e = e ? gt(e, t) : t;
  try {
    Y.localStorage.setItem(lx, JSON.stringify(e));
  } catch {
    return !1;
  }
  return e;
}, Ere = (t) => t.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(t.substring(t.indexOf(",") + 1)) : t, dx = (t, e) => {
  t._requestCallbackSet || (t._requestCallbackSet = /* @__PURE__ */ new Set()), t._requestCallbackSet.add(e);
}, hx = (t, e) => {
  t._responseCallbackSet || (t._responseCallbackSet = /* @__PURE__ */ new Set()), t._responseCallbackSet.add(e);
}, fx = (t, e) => {
  t._requestCallbackSet && (t._requestCallbackSet.delete(e), t._requestCallbackSet.size || delete t._requestCallbackSet);
}, px = (t, e) => {
  t._responseCallbackSet && (t._responseCallbackSet.delete(e), t._responseCallbackSet.size || delete t._responseCallbackSet);
};
Ht.supportsNativeHls = function() {
  if (!Me || !Me.createElement)
    return !1;
  const t = Me.createElement("video");
  return le.getTech("Html5").isSupported() ? [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ].some(function(n) {
    return /maybe|probably/i.test(t.canPlayType(n));
  }) : !1;
}();
Ht.supportsNativeDash = function() {
  return !Me || !Me.createElement || !le.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(Me.createElement("video").canPlayType("application/dash+xml"));
}();
Ht.supportsTypeNatively = (t) => t === "hls" ? Ht.supportsNativeHls : t === "dash" ? Ht.supportsNativeDash : !1;
Ht.isSupported = function() {
  return le.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
Ht.xhr.onRequest = function(t) {
  dx(Ht.xhr, t);
};
Ht.xhr.onResponse = function(t) {
  hx(Ht.xhr, t);
};
Ht.xhr.offRequest = function(t) {
  fx(Ht.xhr, t);
};
Ht.xhr.offResponse = function(t) {
  px(Ht.xhr, t);
};
const Lre = le.getComponent("Component");
class mx extends Lre {
  constructor(e, n, a) {
    if (super(n, a.vhs), typeof a.initialBandwidth == "number" && (this.options_.bandwidth = a.initialBandwidth), this.logger_ = Ta("VhsHandler"), n.options_ && n.options_.playerId) {
      const i = le.getPlayer(n.options_.playerId);
      this.player_ = i;
    }
    if (this.tech_ = n, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && n.overrideNativeAudioTracks && n.overrideNativeVideoTracks)
      n.overrideNativeAudioTracks(!0), n.overrideNativeVideoTracks(!0);
    else if (this.options_.overrideNative && (n.featuresNativeVideoTracks || n.featuresNativeAudioTracks))
      throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
    this.on(Me, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], (i) => {
      const r = Me.fullscreenElement || Me.webkitFullscreenElement || Me.mozFullScreenElement || Me.msFullscreenElement;
      r && r.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
    }), this.on(this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), this.on(this.tech_, "error", function() {
      this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
    }), this.on(this.tech_, "play", this.play);
  }
  /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */
  setOptions_(e = {}) {
    if (this.options_ = gt(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      const a = ux();
      a && a.bandwidth && (this.options_.bandwidth = a.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      })), a && a.throughput && (this.options_.throughput = a.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = mn.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === mn.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "customPixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "customTagParsers", "customTagMappers", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "bufferBasedABR", "liveRangeSafeTimeDelta", "llhls", "useForcedSubtitles", "useNetworkInformationApi", "useDtsForTimestampOffset", "exactManifestTimings", "leastPixelDiffSelector"].forEach((a) => {
      typeof this.source_[a] < "u" && (this.options_[a] = this.source_[a]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
    const n = this.options_.customPixelRatio;
    typeof n == "number" && n >= 0 && (this.customPixelRatio = n);
  }
  // alias for public method to set options
  setOptions(e = {}) {
    this.setOptions_(e);
  }
  /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */
  src(e, n) {
    if (!e)
      return;
    this.setOptions_(), this.options_.src = Ere(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = Ht, this.options_.sourceType = u5(n), this.options_.seekTo = (r) => {
      this.tech_.setCurrentTime(r);
    }, this.options_.player_ = this.player_, this.playlistController_ = new dre(this.options_);
    const a = gt({
      liveRangeSafeTimeDelta: Ka
    }, this.options_, {
      seekable: () => this.seekable(),
      media: () => this.playlistController_.media(),
      playlistController: this.playlistController_
    });
    this.playbackWatcher_ = new mre(a), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
      const r = le.players[this.tech_.options_.playerId];
      let s = this.playlistController_.error;
      typeof s == "object" && !s.code ? s.code = 3 : typeof s == "string" && (s = {
        message: s,
        code: 3
      }), r.error(s);
    });
    const i = this.options_.bufferBasedABR ? Ht.movingAverageBandwidthSelector(0.55) : Ht.STANDARD_PLAYLIST_SELECTOR;
    this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : i.bind(this), this.playlistController_.selectInitialPlaylist = Ht.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
      selectPlaylist: {
        get() {
          return this.playlistController_.selectPlaylist;
        },
        set(r) {
          this.playlistController_.selectPlaylist = r.bind(this);
        }
      },
      throughput: {
        get() {
          return this.playlistController_.mainSegmentLoader_.throughput.rate;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.throughput.rate = r, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get() {
          let r = this.playlistController_.mainSegmentLoader_.bandwidth;
          const s = Y.navigator.connection || Y.navigator.mozConnection || Y.navigator.webkitConnection, o = 1e7;
          if (this.options_.useNetworkInformationApi && s) {
            const l = s.downlink * 1e3 * 1e3;
            l >= o && r >= o ? r = Math.max(r, l) : r = l;
          }
          return r;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.bandwidth = r, this.playlistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */
      systemBandwidth: {
        get() {
          const r = 1 / (this.bandwidth || 1);
          let s;
          return this.throughput > 0 ? s = 1 / this.throughput : s = 0, Math.floor(1 / (r + s));
        },
        set() {
          le.log.error('The "systemBandwidth" property is read-only');
        }
      }
    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
      bandwidth: {
        get: () => this.bandwidth || 0,
        enumerable: !0
      },
      mediaRequests: {
        get: () => this.playlistController_.mediaRequests_() || 0,
        enumerable: !0
      },
      mediaRequestsAborted: {
        get: () => this.playlistController_.mediaRequestsAborted_() || 0,
        enumerable: !0
      },
      mediaRequestsTimedout: {
        get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
        enumerable: !0
      },
      mediaRequestsErrored: {
        get: () => this.playlistController_.mediaRequestsErrored_() || 0,
        enumerable: !0
      },
      mediaTransferDuration: {
        get: () => this.playlistController_.mediaTransferDuration_() || 0,
        enumerable: !0
      },
      mediaBytesTransferred: {
        get: () => this.playlistController_.mediaBytesTransferred_() || 0,
        enumerable: !0
      },
      mediaSecondsLoaded: {
        get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
        enumerable: !0
      },
      mediaAppends: {
        get: () => this.playlistController_.mediaAppends_() || 0,
        enumerable: !0
      },
      mainAppendsToLoadedData: {
        get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      audioAppendsToLoadedData: {
        get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      appendsToLoadedData: {
        get: () => this.playlistController_.appendsToLoadedData_() || 0,
        enumerable: !0
      },
      timeToLoadedData: {
        get: () => this.playlistController_.timeToLoadedData_() || 0,
        enumerable: !0
      },
      buffered: {
        get: () => kr(this.tech_.buffered()),
        enumerable: !0
      },
      currentTime: {
        get: () => this.tech_.currentTime(),
        enumerable: !0
      },
      currentSource: {
        get: () => this.tech_.currentSource_,
        enumerable: !0
      },
      currentTech: {
        get: () => this.tech_.name_,
        enumerable: !0
      },
      duration: {
        get: () => this.tech_.duration(),
        enumerable: !0
      },
      main: {
        get: () => this.playlists.main,
        enumerable: !0
      },
      playerDimensions: {
        get: () => this.tech_.currentDimensions(),
        enumerable: !0
      },
      seekable: {
        get: () => kr(this.tech_.seekable()),
        enumerable: !0
      },
      timestamp: {
        get: () => Date.now(),
        enumerable: !0
      },
      videoPlaybackQuality: {
        get: () => this.tech_.getVideoPlaybackQuality(),
        enumerable: !0
      }
    }), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
      this.options_.useBandwidthFromLocalStorage && Are({
        bandwidth: this.bandwidth,
        throughput: Math.round(this.throughput)
      });
    }), this.playlistController_.on("selectedinitialmedia", () => {
      pre(this);
    }), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
      this.setupEme_();
    }), this.on(this.playlistController_, "progress", function() {
      this.tech_.trigger("progress");
    }), this.on(this.playlistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = !0;
    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = Y.URL.createObjectURL(this.playlistController_.mediaSource), (le.browser.IS_ANY_SAFARI || le.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
  }
  createKeySessions_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), Sre({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: e && e.media(),
      mainPlaylists: this.playlists.main.playlists
    }).then(() => {
      this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
    }).catch((n) => {
      this.logger_("error while creating EME key session", n), this.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }
  handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }
  /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */
  setupEme_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, n = Cre({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: e && e.media()
    });
    if (this.player_.tech_.on("keystatuschange", (a) => {
      this.playlistController_.updatePlaylistByKeyStatus(a.keyId, a.status);
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !n) {
      this.playlistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }
  /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */
  setupQualityLevels_() {
    const e = le.players[this.tech_.options_.playerId];
    !e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
      Tre(this.qualityLevels_, this);
    }), this.playlists.on("mediachange", () => {
      cx(this.qualityLevels_, this.playlists);
    }));
  }
  /**
   * return the version
   */
  static version() {
    return {
      "@videojs/http-streaming": ox,
      "mux.js": vre,
      "mpd-parser": yre,
      "m3u8-parser": _re,
      "aes-decrypter": xre
    };
  }
  /**
   * return the version
   */
  version() {
    return this.constructor.version();
  }
  canChangeType() {
    return nx.canChangeType();
  }
  /**
   * Begin playing the video.
   */
  play() {
    this.playlistController_.play();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  setCurrentTime(e) {
    this.playlistController_.setCurrentTime(e);
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  duration() {
    return this.playlistController_.duration();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  seekable() {
    return this.playlistController_.seekable();
  }
  /**
   * Abort all outstanding work and cleanup.
   */
  dispose() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && Y.URL.revokeObjectURL && (Y.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
  }
  convertToProgramTime(e, n) {
    return Dae({
      playlist: this.playlistController_.media(),
      time: e,
      callback: n
    });
  }
  // the player must be playing before calling this
  seekToProgramTime(e, n, a = !0, i = 2) {
    return $_({
      programTime: e,
      playlist: this.playlistController_.media(),
      retryCount: i,
      pauseAfterSeek: a,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: n
    });
  }
  /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */
  setupXhrHooks_() {
    this.xhr.onRequest = (e) => {
      dx(this.xhr, e);
    }, this.xhr.onResponse = (e) => {
      hx(this.xhr, e);
    }, this.xhr.offRequest = (e) => {
      fx(this.xhr, e);
    }, this.xhr.offResponse = (e) => {
      px(this.xhr, e);
    }, this.player_.trigger("xhr-hooks-ready");
  }
  attachStreamingEventListeners_() {
    const e = ["seekablerangeschanged", "bufferedrangeschanged", "contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"], n = ["gapjumped", "playedrangeschanged"];
    e.forEach((a) => {
      this.playlistController_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    }), n.forEach((a) => {
      this.playbackWatcher_.on(a, (i) => {
        this.player_.trigger(Jt({}, i));
      });
    });
  }
}
const Bu = {
  name: "videojs-http-streaming",
  VERSION: ox,
  canHandleSource(t, e = {}) {
    const n = gt(le.options, e);
    return !n.vhs.experimentalUseMMS && !ll("avc1.4d400d,mp4a.40.2", !1) ? !1 : Bu.canPlayType(t.type, n);
  },
  handleSource(t, e, n = {}) {
    const a = gt(le.options, n);
    return e.vhs = new mx(t, e, a), e.vhs.xhr = O_(), e.vhs.setupXhrHooks_(), e.vhs.src(t.src, t.type), e.vhs;
  },
  canPlayType(t, e) {
    const n = u5(t);
    if (!n)
      return "";
    const a = Bu.getOverrideNative(e);
    return !Ht.supportsTypeNatively(n) || a ? "maybe" : "";
  },
  getOverrideNative(t = {}) {
    const {
      vhs: e = {}
    } = t, n = !(le.browser.IS_ANY_SAFARI || le.browser.IS_IOS), {
      overrideNative: a = n
    } = e;
    return a;
  }
}, Dre = () => ll("avc1.4d400d,mp4a.40.2", !0);
Dre() && le.getTech("Html5").registerSourceHandler(Bu, 0);
le.VhsHandler = mx;
le.VhsSourceHandler = Bu;
le.Vhs = Ht;
le.use || le.registerComponent("Vhs", Ht);
le.options.vhs = le.options.vhs || {};
(!le.getPlugin || !le.getPlugin("reloadSourceOnError")) && le.registerPlugin("reloadSourceOnError", bre);
const Ire = {
  name: "VideoJs",
  props: {
    sources: {
      type: Array,
      required: !0
    },
    poster: {
      type: String,
      default: ""
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    fill: {
      type: Boolean,
      default: !0
    },
    audioPosterMode: { type: Boolean, default: !0 },
    loop: { type: Boolean, default: !1 },
    muted: { type: Boolean, default: !1 },
    playsinline: { type: Boolean, default: !0 }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    this.player = le(
      this.$refs.videoPlayer,
      this.$props,
      () => {
      }
    );
  },
  beforeUnmount() {
    this.player && this.player.dispose();
  }
}, Mre = { class: "video-js-container" }, Ore = { class: "video-player" }, Pre = {
  ref: "videoPlayer",
  class: "video-js vjs-big-play-centered"
};
function Bre(t, e, n, a, i, r) {
  return h(), b("div", Mre, [
    k("div", Ore, [
      k("video", Pre, null, 512)
    ])
  ]);
}
const Rre = /* @__PURE__ */ be(Ire, [["render", Bre]]), Nre = { class: "media-item" }, $re = ["innerHTML"], Fre = ["textContent"], zre = /* @__PURE__ */ Ae({
  __name: "Item",
  props: {
    // the image / video / audio / embed
    item: { type: Array, default: () => [] },
    embedCode: { type: String, default: "" },
    coverImage: { type: Array, default: () => [] },
    coverOnly: { type: Boolean, default: !1 },
    // sizing for the container (not the media item itself)
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    aspectRatio: { type: Number, default: 0 },
    // Layout options
    backgroundColor: { type: String, default: "" },
    focalPoint: { type: Array, default: () => [] },
    mode: { type: String, default: "intrinsic-ratio" },
    objectFit: { type: String, default: "contain" },
    // video options
    controls: { type: Boolean, default: !0 },
    autoplay: { type: Boolean, default: !1 },
    loop: { type: Boolean, default: !1 },
    muted: { type: Boolean, default: !1 },
    playsinline: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t, n = I(() => e.item[0] && e.item[0].kind === "audio"), a = I(() => !!(e.embedCode && e.embedCode.length)), i = I(() => e.item[0] && e.item[0].kind === "image"), r = I(() => e.item[0] && e.item[0].kind === "video"), s = I(() => e.coverImage[0] && e.coverImage[0].src), o = I(() => [
      `objectFit: ${e.objectFit}`,
      `objectPosition:
        ${e.item[0] && e.item[0].focalPoint && e.item[0].focalPoint.map((d) => `${d * 100}%`).join(" ")}`
    ]), l = I(() => e.aspectRatio || e.height / e.width * 100 || !e.coverOnly && e.item[0] && e.item[0].height / e.item[0].width * 100 || (e.coverImage[0] && e.coverImage[0].height / e.coverImage[0].width) * 100 || 9 / 16 * 100), c = I(() => [
      `paddingBottom: ${l.value}%`
    ]);
    return (d, f) => (h(), b("div", Nre, [
      a.value ? (h(), b("div", {
        key: 0,
        class: "media media-embed",
        innerHTML: t.embedCode
      }, null, 8, $re)) : i.value ? (h(), b("img", $t({
        key: 1,
        class: "media media-image",
        style: o.value
      }, t.item[0]), null, 16)) : e.coverOnly ? (h(), b("img", $t({
        key: 2,
        class: "media media-image",
        style: o.value
      }, e.coverImage[0]), null, 16)) : r.value || n.value ? (h(), Z(Rre, {
        key: 3,
        class: "media media-video",
        style: bn(o.value),
        sources: e.item,
        poster: s.value,
        controls: e.controls,
        autoplay: e.autoplay,
        loop: e.loop,
        muted: e.muted,
        playsinline: e.playsinline,
        "audio-poster-mode": n.value
      }, null, 8, ["style", "sources", "poster", "controls", "autoplay", "loop", "muted", "playsinline", "audio-poster-mode"])) : (h(), b("p", {
        key: 4,
        class: "media",
        style: { "background-color": "white", padding: "10px" },
        textContent: ae(
          n.value ? "Audio uploads not supported yet" : "Could not identify media type"
        )
      }, null, 8, Fre)),
      k("div", {
        class: "sizer",
        style: bn(c.value)
      }, null, 4),
      xe(d.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Ed = /* @__PURE__ */ be(zre, [["__scopeId", "data-v-7c537112"]]), Ure = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ed
}, Symbol.toStringTag, { value: "Module" })), Hre = {
  key: 0,
  class: "floating-highlight"
}, Yre = { class: "badge-content" }, jre = {
  __name: "MediaBadge",
  setup(t) {
    const e = Ge(), n = I(() => ["media-badge", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: se(n.value)
    }, [
      O(e) !== "ftva" ? (h(), b("div", Hre)) : E("", !0),
      k("div", Yre, [
        xe(a.$slots, "default", { class: "badge-content-item" }, void 0, !0)
      ])
    ], 2));
  }
}, Vre = /* @__PURE__ */ be(jre, [["__scopeId", "data-v-5e631014"]]), qre = { key: 0 }, Wre = {
  key: 0,
  class: "ftva-image-stack-bckgrd"
}, Gre = { key: 0 }, Xre = { key: 0 }, Zre = { key: 1 }, Kre = { key: 1 }, Qre = {
  key: 3,
  class: "glyph-expand"
}, Jre = {
  key: 0,
  y1: "20%",
  x1: "50%",
  y2: "80%",
  x2: "50%",
  "stroke-width": "1.5px"
}, ese = {
  key: 0,
  class: "text-wrapper"
}, tse = ["textContent"], nse = /* @__PURE__ */ Ae({
  __name: "BannerImage",
  props: {
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    },
    embedCode: {
      type: String,
      default: ""
    },
    nItems: {
      type: Number,
      required: !0
    },
    expanded: {
      type: Boolean,
      required: !0
    },
    isHalfWidth: {
      type: String,
      default: ""
    },
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleThumbnails"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = Ge(), r = I(() => [
      "banner-image",
      (i == null ? void 0 : i.value) || "",
      n.isHalfWidth === "halfWidth" ? "half-width-media-item" : ""
    ]);
    return (s, o) => (h(), b("div", {
      class: se(r.value)
    }, [
      Q(Ed, {
        item: t.item,
        "embed-code": t.embedCode,
        "cover-image": t.coverImage,
        "aspect-ratio": 60,
        "object-fit": "cover",
        class: "media-item",
        onClick: o[0] || (o[0] = (l) => a("toggleThumbnails"))
      }, {
        default: ce(() => [
          t.nItems > 1 && !t.expanded ? (h(), b("div", qre, [
            o[1] || (o[1] = k("div", { class: "gradient" }, null, -1)),
            O(i) === "ftva" ? (h(), b("div", Wre, [
              Q(O(Ky), {
                class: "molecule-image-stack",
                "aria-hidden": "true"
              })
            ])) : (h(), Z(O(pQ), {
              key: 1,
              class: "molecule-image-stack",
              "aria-hidden": "true"
            }))
          ])) : E("", !0),
          t.nItems > 1 ? (h(), Z(Vre, {
            key: 1,
            "is-expanded": t.expanded
          }, {
            default: ce(() => [
              O(i) === "ftva" ? (h(), b("span", Gre, [
                t.expanded ? (h(), b("span", Xre, "Collapse Gallery")) : (h(), b("span", Zre, "View all " + ae(t.nItems) + " images", 1))
              ])) : (h(), b("span", Kre, ae(t.nItems) + " images ", 1)),
              O(i) === "ftva" ? (h(), Z(O(Jh), {
                key: 2,
                class: se(["drop-triangle", { "is-expanded": t.expanded }])
              }, null, 8, ["class"])) : (h(), b("svg", Qre, [
                o[2] || (o[2] = k("line", {
                  x1: "20%",
                  y1: "50%",
                  x2: "80%",
                  y2: "50%",
                  "stroke-width": "1.5px"
                }, null, -1)),
                t.expanded ? E("", !0) : (h(), b("line", Jre))
              ]))
            ]),
            _: 1
          }, 8, ["is-expanded"])) : E("", !0)
        ]),
        _: 1
      }, 8, ["item", "embed-code", "cover-image"]),
      t.isHalfWidth ? (h(), b("div", ese, [
        t.sectionTitle ? (h(), b("h3", {
          key: 0,
          class: "title",
          textContent: ae(t.sectionTitle)
        }, null, 8, tse)) : E("", !0),
        t.sectionSummary ? (h(), Z(un, {
          key: 1,
          class: "summary",
          innerHTML: t.sectionSummary
        }, null, 8, ["innerHTML"])) : E("", !0)
      ])) : E("", !0)
    ], 2));
  }
}), ase = /* @__PURE__ */ be(nse, [["__scopeId", "data-v-b4ac3f05"]]), ise = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-circle-left"
};
function rse(t, e) {
  return h(), b("svg", ise, e[0] || (e[0] = [
    k("circle", {
      opacity: "0.2",
      cx: "24",
      cy: "24",
      r: "22",
      fill: "#EAF2FB",
      class: "svg__fill--primary-blue-01"
    }, null, -1),
    k("path", {
      d: "M17 24.1355L16.4697 24.6658C16.1768 24.3729 16.1768 23.8981 16.4697 23.6052L17 24.1355ZM16.4697 23.6052L30.4697 9.60517L31.5303 10.6658L17.5303 24.6658L16.4697 23.6052ZM17.5303 23.6052L31.5303 37.6052L30.4697 38.6658L16.4697 24.6658L17.5303 23.6052Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const sse = { render: rse }, ose = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-circle-right"
};
function lse(t, e) {
  return h(), b("svg", ose, e[0] || (e[0] = [
    k("circle", {
      opacity: "0.2",
      cx: "24",
      cy: "24",
      r: "22",
      fill: "#EAF2FB",
      class: "svg__fill--primary-blue-01"
    }, null, -1),
    k("path", {
      d: "M31 24.1355L31.5303 23.6052C31.8232 23.8981 31.8232 24.3729 31.5303 24.6658L31 24.1355ZM31.5303 24.6658L17.5303 38.6658L16.4697 37.6052L30.4697 23.6052L31.5303 24.6658ZM30.4697 24.6658L16.4697 10.6658L17.5303 9.60517L31.5303 23.6052L30.4697 24.6658Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const cse = { render: lse }, use = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-close-large"
};
function dse(t, e) {
  return h(), b("svg", use, e[0] || (e[0] = [
    k("g", null, [
      k("circle", {
        opacity: "0.2",
        cx: "24",
        cy: "24",
        r: "24",
        fill: "#EAF2FB",
        class: "svg__fill--primary-blue-01"
      }),
      k("path", {
        d: "M36 35.8886L12 12.1099",
        stroke: "#5CD9FF",
        "stroke-width": "1.5",
        "stroke-linejoin": "round",
        class: "svg__stroke--default-cyan-02"
      }),
      k("path", {
        d: "M12.0989 36L35.9023 12",
        stroke: "#5CD9FF",
        "stroke-width": "1.5",
        "stroke-linejoin": "round",
        class: "svg__stroke--default-cyan-02"
      })
    ], -1)
  ]));
}
const gx = { render: dse }, hse = {
  key: 0,
  class: "credit-text"
}, fse = ["textContent"], pse = ["disabled"], mse = ["disabled"], gse = { class: "caption-block" }, bse = {
  key: 0,
  class: "media-counter",
  role: "tablist"
}, vse = ["disabled", "onClick"], yse = { class: "caption-content" }, _se = ["textContent"], xse = ["textContent"], Tse = {
  key: 2,
  class: "media-object-credit"
}, wse = /* @__PURE__ */ Ae({
  __name: "NewLightbox",
  props: {
    items: {
      type: Array,
      default: () => [],
      required: !0
    },
    selectedItem: {
      type: Number,
      default: 0
    },
    // Triggers Lightbox to be overlaid (default) or inline
    inline: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["closeModal"],
  setup(t, { emit: e }) {
    const n = e, a = Ge(), i = ge(
      () => Promise.resolve().then(() => q2)
    ), r = J(t.selectedItem), s = I(() => t.items.map((_) => _.captionTitle)), o = I(() => t.items.map((_) => _.captionText)), l = I(() => ["lightbox", (a == null ? void 0 : a.value) || "", t.inline ? "inline" : ""]), c = I(() => (a == null ? void 0 : a.value) === "ftva" ? "cover" : "contain"), d = J(null);
    ht(() => {
      var _;
      (_ = d.value) == null || _.focus();
    });
    function f() {
      n("closeModal");
    }
    function g(_) {
      r.value = _;
    }
    return (_, x) => (h(), b("div", {
      ref_key: "lightbox",
      ref: d,
      class: se(l.value)
    }, [
      k("button", {
        class: "button-close",
        onClick: f
      }, [
        Q(O(gx), { "aria-label": "Close" })
      ]),
      Q(O(Wy), {
        modelValue: r.value,
        "onUpdate:modelValue": x[0] || (x[0] = (p) => r.value = p),
        class: "media-container"
      }, {
        default: ce(() => [
          (h(!0), b(me, null, Ee(t.items, (p, w) => (h(), Z(O(Gy), {
            key: `media-container-${w}`
          }, {
            default: ce(() => [
              (h(), Z(Ed, {
                key: `${p.captionTitle}-${w}`,
                "object-fit": c.value,
                item: p.item,
                "cover-image": p.coverImage,
                "embed-code": p.embedCode
              }, {
                default: ce(() => [
                  p.credit ? (h(), b("div", hse, [
                    k("span", {
                      textContent: ae(p.credit)
                    }, null, 8, fse)
                  ])) : E("", !0)
                ]),
                _: 2
              }, 1032, ["object-fit", "item", "cover-image", "embed-code"]))
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      t.items.length > 1 ? (h(), b("button", {
        key: 0,
        class: "button-prev",
        disabled: r.value <= 0,
        onClick: x[1] || (x[1] = (p) => r.value -= 1)
      }, [
        Q(O(sse), { "aria-label": "Show previous image" })
      ], 8, pse)) : E("", !0),
      t.items.length > 1 ? (h(), b("button", {
        key: 1,
        class: "button-next",
        disabled: r.value >= t.items.length - 1,
        onClick: x[2] || (x[2] = (p) => r.value += 1)
      }, [
        Q(O(cse), { "aria-label": "Show next image" })
      ], 8, mse)) : E("", !0),
      k("div", gse, [
        t.items.length > 1 ? (h(), b("div", bse, [
          (h(!0), b(me, null, Ee(t.items.length, (p) => (h(), b("button", {
            key: `caption-block-${p}`,
            disabled: p - 1 === r.value,
            class: "media-counter-item",
            onClick: (w) => g(p - 1)
          }, [
            Q(O(Xy))
          ], 8, vse))), 128))
        ])) : E("", !0),
        k("div", yse, [
          xe(_.$slots, "default", { selectionIndex: r.value }, void 0, !0),
          s.value ? (h(), b("h4", {
            key: 0,
            class: "media-object-title",
            textContent: ae(s.value[r.value])
          }, null, 8, _se)) : E("", !0),
          o.value ? (h(), b("p", {
            key: 1,
            class: "media-object-caption",
            textContent: ae(o.value[r.value])
          }, null, 8, xse)) : E("", !0),
          t.items && t.items[r.value] && t.items[r.value].credit ? (h(), b("p", Tse, ae(t.items[r.value].credit), 1)) : E("", !0),
          t.items && t.items[r.value] && t.items[r.value].linkUrl && t.items[r.value].linkText ? (h(), Z(Ke, {
            key: 3,
            class: "media-object-caption-link",
            to: t.items[r.value].linkUrl
          }, {
            default: ce(() => [
              Ye(ae(t.items[r.value].linkText) + " ", 1),
              Q(O(i))
            ]),
            _: 1
          }, 8, ["to"])) : E("", !0)
        ])
      ])
    ], 2));
  }
}), bx = /* @__PURE__ */ be(wse, [["__scopeId", "data-v-255f4f88"]]), kse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bx
}, Symbol.toStringTag, { value: "Module" })), Sse = {
  key: 0,
  class: "caption-text"
}, Cse = /* @__PURE__ */ Ae({
  __name: "ThumbnailCard",
  props: {
    item: {
      type: Array,
      default: () => []
    },
    coverImage: {
      type: Array,
      default: () => []
    },
    embedCode: {
      type: String,
      default: ""
    },
    captionTitle: {
      type: String,
      default: ""
    },
    captionText: {
      type: String,
      default: ""
    },
    credit: {
      type: String,
      default: ""
    },
    linkUrl: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = I(() => (e.coverImage || []).concat(e.item || []).filter((s) => s.kind === "image")), a = I(() => Ki(e.captionText || e.credit || "")), i = Ge(), r = I(() => ["thumbnail-card", (i == null ? void 0 : i.value) || ""]);
    return (s, o) => (h(), Z(sl, {
      class: se(r.value),
      "no-margins": !0
    }, {
      default: ce(() => [
        Q(Ed, {
          item: n.value,
          "aspect-ratio": 60,
          class: "image",
          "object-fit": "cover"
        }, null, 8, ["item"]),
        Q(Mf, {
          class: "caption-title",
          textContent: ae(t.captionTitle)
        }, null, 8, ["textContent"]),
        a.value ? (h(), b("p", Sse, ae(a.value), 1)) : E("", !0),
        t.linkUrl && t.linkText ? (h(), Z(Ke, {
          key: 1,
          to: t.linkUrl,
          class: "caption-link"
        }, {
          default: ce(() => [
            Ye(ae(t.linkText) + " ", 1),
            Q(O(qu))
          ]),
          _: 1
        }, 8, ["to"])) : E("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ase = /* @__PURE__ */ be(Cse, [["__scopeId", "data-v-f59d1bfb"]]), Ese = {
  key: 1,
  class: "gallery-header"
}, Lse = { class: "gallery-title" }, Dse = { class: "selected-image-title" }, Ise = { class: "selected-image-caption" }, Mse = {
  key: 3,
  class: "thumbnails"
}, Ose = /* @__PURE__ */ Ae({
  __name: "MediaGallery",
  props: {
    block: {
      type: Object,
      required: !0
    },
    // Triggers Lightbox to be overlaid (default) or inline
    inline: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = J(!1), n = J(0), a = J(!1), i = I(() => t.block.mediaGallery.length), r = I(() => t.block.sectionTitle), s = I(() => t.block.mediaGalleryStyle === "fullWidth"), o = I(() => t.block.mediaGalleryStyle === "halfWidth"), l = I(() => o.value ? t.block.sectionTitle : ""), c = I(() => o.value ? t.block.richTextSimplified : ""), d = Ge(), f = I(() => ["media-gallery", (d == null ? void 0 : d.value) || ""]);
    function g() {
      a.value = !1;
    }
    function _() {
      e.value = !e.value;
    }
    function x(p) {
      n.value = p, a.value = !0;
    }
    return (p, w) => t.block.mediaGallery && t.block.mediaGallery.length > 0 ? (h(), b("section", {
      key: 0,
      class: se(f.value)
    }, [
      a.value ? (h(), Z(bx, {
        key: 0,
        items: t.block.mediaGallery,
        "selected-item": n.value,
        tabindex: "0",
        inline: t.inline,
        onCloseModal: g,
        onKeydown: $r(g, ["esc"])
      }, null, 8, ["items", "selected-item", "inline"])) : E("", !0),
      O(d) === "ftva" && s.value ? (h(), b("section", Ese, [
        k("h2", Lse, ae(r.value), 1),
        k("h3", Dse, ae(t.block.mediaGallery[n.value].captionTitle), 1),
        k("p", Ise, ae(t.block.mediaGallery[n.value].captionText), 1)
      ])) : E("", !0),
      t.block.mediaGallery && t.block.mediaGallery[n.value].item ? (h(), Z(ase, {
        key: 2,
        item: t.block.mediaGallery[n.value].item,
        "cover-image": t.block.mediaGallery[n.value].coverImage,
        "embed-code": t.block.mediaGallery[n.value].embedCode,
        "n-items": i.value,
        expanded: e.value,
        "is-half-width": t.block.mediaGalleryStyle,
        "section-title": l.value,
        "section-summary": c.value,
        onToggleThumbnails: _
      }, null, 8, ["item", "cover-image", "embed-code", "n-items", "expanded", "is-half-width", "section-title", "section-summary"])) : E("", !0),
      e.value ? (h(), b("div", Mse, [
        (h(!0), b(me, null, Ee(t.block.mediaGallery, (C, M) => (h(), Z(Ase, $t({
          key: C.id,
          ref_for: !0
        }, C, {
          onClick: (A) => x(M)
        }), null, 16, ["onClick"]))), 128))
      ])) : E("", !0)
    ], 2)) : E("", !0);
  }
}), Pse = /* @__PURE__ */ be(Ose, [["__scopeId", "data-v-0e9277f2"]]), Bse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pse
}, Symbol.toStringTag, { value: "Module" })), Rse = { class: "section-media-with-text" }, Nse = { class: "flexible-page-block-container" }, $se = { class: "section-header" }, Fse = ["innerHTML"], zse = ["innerHTML"], Use = /* @__PURE__ */ Ae({
  __name: "MediaWithText",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.mediaWithText.map((a) => ({
      ...a,
      // mediaWithText_mediaEmbed or mediaWithText_mediaUpload
      parsedTitle: a.titleLink ? a.titleLink : a.titleUpload,
      // item: upload
      // item[0].src & buttonUrl can return as null - neither are required
      parsedButtonUrl: a.item && a.typeMedia === "other" ? a.item[0].src : a.buttonUrl
    })));
    return (n, a) => (h(), b("div", Rse, [
      k("div", Nse, [
        a[0] || (a[0] = k("h2", { class: "visually-hidden" }, " Resources ", -1)),
        k("div", $se, [
          t.block.sectionTitle ? (h(), b("h3", {
            key: 0,
            class: "section-title",
            innerHTML: t.block.sectionTitle
          }, null, 8, Fse)) : E("", !0),
          t.block.sectionSummary ? (h(), b("div", {
            key: 1,
            class: "section-summary",
            innerHTML: t.block.sectionSummary
          }, null, 8, zse)) : E("", !0)
        ]),
        (h(!0), b(me, null, Ee(e.value, (i, r) => (h(), b("div", {
          key: `MediaWithTextKey${r}`,
          class: "meta"
        }, [
          Q(UI, {
            "section-header": i.parsedTitle,
            "short-description": i.description,
            item: i.item,
            "cover-image": i.coverImage,
            "button-text": i.buttonText,
            "button-url": i.parsedButtonUrl,
            "embed-code": i.embedCode,
            "type-media": i.typeMedia,
            class: "flexible-media-with-text"
          }, null, 8, ["section-header", "short-description", "item", "cover-image", "button-text", "button-url", "embed-code", "type-media"]),
          Q(eh, { class: "divider" })
        ]))), 128))
      ])
    ]));
  }
}), Hse = /* @__PURE__ */ be(Use, [["__scopeId", "data-v-9cff8a0c"]]), Yse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hse
}, Symbol.toStringTag, { value: "Module" })), jse = {
  key: 1,
  class: "attribution-block"
}, Vse = ["innerHTML"], qse = /* @__PURE__ */ Ae({
  __name: "PullQuote",
  props: {
    text: {
      type: String,
      default: ""
    },
    attribution: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["pull-quote", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("div", {
      class: se(n.value)
    }, [
      t.text ? (h(), Z(un, {
        key: 0,
        class: "quote",
        "rich-text-content": t.text
      }, null, 8, ["rich-text-content"])) : E("", !0),
      t.attribution ? (h(), b("div", jse, [
        i[0] || (i[0] = k("span", { class: "dash" }, "—", -1)),
        t.attribution ? (h(), b("span", {
          key: 0,
          class: "attribution",
          innerHTML: t.attribution
        }, null, 8, Vse)) : E("", !0)
      ])) : E("", !0)
    ], 2));
  }
}), Vc = /* @__PURE__ */ be(qse, [["__scopeId", "data-v-6f731ff0"]]), Wse = /* @__PURE__ */ Ae({
  __name: "PullQuote",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => t.block.pullQuote ? (h(), Z(Vc, {
      key: 0,
      text: t.block.pullQuote[0].text,
      attribution: t.block.pullQuote[0].attribution
    }, null, 8, ["text", "attribution"])) : E("", !0);
  }
}), Gse = /* @__PURE__ */ be(Wse, [["__scopeId", "data-v-b579df03"]]), Xse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gse
}, Symbol.toStringTag, { value: "Module" })), Zse = { class: "rich-text" }, Kse = ["innerHTML"], Qse = /* @__PURE__ */ Ae({
  __name: "RichText",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", Zse, [
      t.block.sectionTitle ? (h(), b("h2", {
        key: 0,
        class: "section-title",
        innerHTML: t.block.sectionTitle
      }, null, 8, Kse)) : E("", !0),
      Q(un, {
        "rich-text-content": t.block.richText
      }, null, 8, ["rich-text-content"])
    ]));
  }
}), Jse = /* @__PURE__ */ be(Qse, [["__scopeId", "data-v-7207e802"]]), eoe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jse
}, Symbol.toStringTag, { value: "Module" })), toe = { class: "section-header" }, noe = ["textContent"], aoe = ["innerHTML"], ioe = { class: "simple-cards-list" }, roe = /* @__PURE__ */ Ae({
  __name: "SimpleCards",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      default: ""
    },
    sectionSummary: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => {
      let i = ["card", "card-small"];
      switch (t.items.length) {
        case 1:
          i = ["card"];
          break;
        case 2:
        case 4:
          i = ["card", "card-large"];
          break;
        case 5:
          i = ["card", "card-five"];
          break;
      }
      return t.items.map((r) => ({
        ...r,
        classes: i
      }));
    }), n = Ge(), a = I(() => ["simple-cards", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: se(a.value)
    }, [
      k("div", toe, [
        t.sectionTitle ? (h(), b("h2", {
          key: 0,
          class: "section-title",
          textContent: ae(t.sectionTitle)
        }, null, 8, noe)) : E("", !0),
        t.sectionSummary ? (h(), b("div", {
          key: 1,
          class: "section-summary",
          innerHTML: t.sectionSummary
        }, null, 8, aoe)) : E("", !0)
      ]),
      k("ul", ioe, [
        (h(!0), b(me, null, Ee(e.value, (s, o) => (h(), Z(QM, {
          key: `SimpleCardsKey${o}`,
          class: se(s.classes),
          to: s.to,
          title: s.title,
          text: s.text
        }, null, 8, ["class", "to", "title", "text"]))), 128))
      ])
    ], 2));
  }
}), soe = /* @__PURE__ */ be(roe, [["__scopeId", "data-v-2fec9aa6"]]), ehe = /* @__PURE__ */ Ae({
  __name: "SimpleCards",
  props: {
    block: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = I(() => t.block.cards.map((i) => (i.typeHandle === "internalResource" || i.typeHandle === "internalServiceOrResource") && i.contentLink[0] ? {
      title: it(i, "contentLink[0].title", ""),
      text: it(i, "contentLink[0].summary", ""),
      to: i.contentLink[0].externalResourceUrl ? i.contentLink[0].externalResourceUrl : $n(
        i.contentLink[0].uri
      )
    } : i.typeHandle === "externalResource" || i.typeHandle === "externalServiceOrResource" ? {
      title: i.title,
      text: i.summary,
      to: i.externalLink
    } : {
      ...i
    })), n = Ge(), a = I(() => ["flexible-simple-cards", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("div", {
      class: se(a.value)
    }, [
      Q(soe, {
        "section-title": t.block.sectionTitle,
        "section-summary": t.block.sectionSummary,
        items: e.value
      }, null, 8, ["section-title", "section-summary", "items"])
    ], 2));
  }
}), ooe = {
  name: "FooterSponsor",
  components: {
    BlockSponsor: uO
  },
  computed: {
    ...$4(to, ["footerSponsor"]),
    parsedFunders() {
      return Object.keys(this.footerSponsor).length !== 0 ? this.footerSponsor.funders : (console.log(
        "Pinia state data for footer sponsor not present if navigation is not setup for the website."
      ), []);
    }
  }
}, loe = { class: "footer-sponsor" }, coe = { class: "sponsor-logos" };
function uoe(t, e, n, a, i, r) {
  const s = ot("BlockSponsor");
  return h(), b("div", loe, [
    e[0] || (e[0] = k("div", { class: "sponsor-text" }, " The UCLA Library Modern Endangered Archives Program is supported by Arcadia. ", -1)),
    k("div", coe, [
      (h(!0), b(me, null, Ee(r.parsedFunders, (o) => (h(), Z(s, {
        key: `footer-sponsor-${o.funderName}`,
        class: "sponsor-item",
        "funder-logo": o.funderLogo,
        "funder-name": o.funderName,
        "funder-url": o.funderUrl
      }, null, 8, ["funder-logo", "funder-name", "funder-url"]))), 128))
    ])
  ]);
}
const doe = /* @__PURE__ */ be(ooe, [["render", uoe], ["__scopeId", "data-v-6c82596b"]]), hoe = {
  width: "115",
  height: "22",
  viewBox: "0 0 115 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__logo-library"
};
function foe(t, e) {
  return h(), b("svg", hoe, e[0] || (e[0] = [
    ri('<path d="M64.2231 6.91406H66.6533V16.8684H72.2837V18.8963H64.2231V6.91406Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M73.1401 6.91406H75.421V8.95857H73.1401V6.91406ZM73.1401 10.3008H75.421V18.8957H73.1401V10.3008Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M79.0763 17.8236H79.0425V18.8963H76.8452V6.91406H79.1261V11.3376H79.1772C79.4275 10.9318 79.7814 10.5999 80.2024 10.3762C80.6234 10.1524 81.0965 10.0448 81.5729 10.0645C83.7349 10.0645 85.2769 11.9237 85.2769 14.6055C85.2769 17.3868 83.8019 19.1466 81.6406 19.1466C81.1342 19.1731 80.6299 19.0645 80.1793 18.832C79.7287 18.5994 79.348 18.2511 79.0763 17.8229V17.8236ZM82.9642 14.6055C82.9642 13.0158 82.327 11.9099 81.0538 11.9099C79.612 11.9099 79.0763 13.0663 79.0763 14.6573C79.0763 16.2332 79.8643 17.2389 81.1374 17.2389C82.3124 17.2389 82.9642 16.2664 82.9642 14.6076" fill="#0F0F0F" class="svg__fill--black"></path><path d="M88.5549 11.6745H88.6054C89.1245 10.7027 89.7113 10.1995 90.7169 10.1995C90.8982 10.1895 91.0798 10.2129 91.2526 10.2687V12.2627H91.2028C89.7113 12.112 88.6385 12.9 88.6385 14.7095V18.8987H86.3577V10.3005H88.5528L88.5549 11.6745Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M97.1455 17.9435H97.1124C96.6762 18.5967 96.0562 19.0998 94.582 19.0998C92.8222 19.0998 91.5815 18.1778 91.5815 16.4685C91.5815 14.5747 93.1236 13.972 95.0374 13.7038C96.4613 13.5027 97.1158 13.3859 97.1158 12.732C97.1158 12.11 96.632 11.7098 95.6747 11.7098C94.602 11.7098 94.085 12.0954 94.0159 12.9159H91.988C92.0571 11.4084 93.1775 10.082 95.6913 10.082C98.2729 10.082 99.3117 11.2391 99.3117 13.2497V17.6235C99.3117 18.2767 99.4119 18.6603 99.613 18.8137V18.8973H97.4179C97.2612 18.6018 97.1697 18.276 97.1497 17.9421L97.1455 17.9435ZM97.1663 15.8637V14.5747C96.6609 14.8117 96.1263 14.9807 95.5766 15.0772C94.387 15.3454 93.8002 15.6142 93.8002 16.4181C93.8002 17.2219 94.3359 17.5074 95.1404 17.5074C96.4481 17.5074 97.1683 16.7035 97.1683 15.8651" fill="#0F0F0F" class="svg__fill--black"></path><path d="M102.914 11.6745H102.965C103.484 10.7027 104.071 10.1995 105.076 10.1995C105.258 10.1895 105.439 10.2129 105.612 10.2687V12.2627H105.562C104.071 12.112 102.998 12.9 102.998 14.7095V18.8987H100.717V10.3005H102.912L102.914 11.6745Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M106.914 19.9198H107.719C108.624 19.9198 108.992 19.4498 108.992 18.7448C108.903 17.9377 108.683 17.1506 108.339 16.4148L106.026 10.2979H108.423L109.696 14.1685C109.964 14.9557 110.249 16.045 110.249 16.045H110.283C110.283 16.045 110.517 14.9557 110.786 14.1685L111.992 10.2979H114.288L111.288 19.1132C110.635 21.0236 109.998 21.7106 108.255 21.7106H106.914V19.9198Z" fill="#0F0F0F" class="svg__fill--black"></path><path d="M0.666559 13.818C0.614596 13.1713 0.600979 12.5221 0.625779 11.8738L1.55127 1.3623H4.99334L4.04919 11.9657C3.84667 14.2611 4.74659 15.8971 7.03785 15.8971C9.37887 15.8971 10.6168 14.2328 10.8207 12.1965L11.7973 1.3623H15.2366L14.2862 12.0611C13.902 16.1798 11.169 19.2652 6.75239 19.2652C3.30686 19.2652 1.08472 17.0383 0.670014 13.818" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M16.029 10.2578C16.4776 5.21216 19.8824 1.02914 25.7622 1.02914C27.3648 1.00627 28.9379 1.46155 30.2805 2.33685L29.8858 6.50466C29.3791 5.81083 28.7048 5.25673 27.926 4.89412C27.1471 4.53151 26.289 4.37222 25.4319 4.43113C21.7727 4.43113 19.7642 6.9719 19.4787 10.1893C19.2023 13.3218 20.8182 15.8681 24.3626 15.8681C25.2866 15.8725 26.2012 15.6822 27.0467 15.3095C27.8922 14.9369 28.6498 14.3903 29.27 13.7054L28.885 17.9858C27.4251 18.8272 25.7744 19.2814 24.0896 19.3053C18.2705 19.3053 15.606 14.9827 16.0242 10.2578" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M33.0275 1.3623H36.4592L35.2061 15.6352H40.1238C40.4694 15.6352 41.6444 15.6172 41.9596 15.5985C41.9416 15.7706 41.6472 18.8961 41.6472 18.8961H31.4709L33.0275 1.3623Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path><path d="M50.9032 7.90896C51.0106 7.67206 51.0955 7.42561 51.1569 7.17286C51.1753 7.17151 51.1937 7.17151 51.2122 7.17286C51.2327 7.42362 51.2767 7.67191 51.3435 7.91449C51.5301 8.71419 52.8641 13.1529 52.8641 13.1529H48.5352C48.5352 13.1529 50.8569 8.02508 50.9032 7.91173V7.90896ZM51.7838 0.561035H51.546L42.1494 18.8966H45.7961L47.1169 16.1126H53.7363L54.5658 18.8939H58.2041L51.7838 0.561035Z" fill="#0B6AB7" class="svg__fill--primary-blue-03"></path>', 11)
  ]));
}
const Gs = { render: foe }, poe = {
  width: "300",
  height: "57",
  viewBox: "0 0 300 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "svg__icon-ftva-footerlogo"
};
function moe(t, e) {
  return h(), b("svg", poe, e[0] || (e[0] = [
    k("rect", {
      y: "0.375",
      width: "300",
      height: "56.25",
      fill: "url(#pattern0_14159_65327)"
    }, null, -1),
    k("defs", null, [
      k("pattern", {
        id: "pattern0_14159_65327",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, [
        k("use", {
          "xlink:href": "#image0_14159_65327",
          transform: "matrix(0.00104167 0 0 0.00555556 0.00208333 0)"
        })
      ]),
      k("image", {
        id: "image0_14159_65327",
        width: "956",
        height: "180",
        "xlink:href": "data:image/png;base64,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"
      })
    ], -1)
  ]));
}
const goe = { render: moe }, boe = {
  width: "225",
  height: "496",
  viewBox: "0 0 225 496",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-half"
};
function voe(t, e) {
  return h(), b("svg", boe, e[0] || (e[0] = [
    k("g", null, [
      k("path", {
        d: "M244.852 445.001L106.511 387.698L71.9262 422.283L244.852 493.911L244.852 445.001Z",
        fill: "#0B6AB7",
        class: "svg__fill-bottom"
      }),
      k("path", {
        d: "M71.9261 76.4322L106.511 111.017L244.852 53.7149L244.851 4.80416L71.9261 76.4322Z",
        fill: "#0B6AB7",
        class: "svg__fill-top"
      }),
      k("path", {
        d: "M0.297249 249.357L71.9254 76.4319L106.511 111.017L49.2081 249.357L49.208 249.357L106.51 387.698L71.9254 422.283L0.297249 249.357Z",
        fill: "#9ECFFA",
        class: "svg__fill-accent"
      })
    ], -1)
  ]));
}
const yoe = { render: voe }, _oe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_yt"
};
function xoe(t, e) {
  return h(), b("svg", _oe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M14.05 18.3L17.8128 16.125L14.05 13.95V18.3ZM22.431 12.6232C22.5253 12.964 22.5905 13.4207 22.634 14.0007C22.6848 14.5807 22.7065 15.081 22.7065 15.516L22.75 16.125C22.75 17.7127 22.634 18.88 22.431 19.6267C22.2498 20.2792 21.8293 20.6997 21.1768 20.881C20.836 20.9752 20.2125 21.0405 19.2555 21.084C18.313 21.1347 17.4503 21.1565 16.6528 21.1565L15.5 21.2C12.4623 21.2 10.57 21.084 9.82325 20.881C9.17075 20.6997 8.75025 20.2792 8.569 19.6267C8.47475 19.286 8.4095 18.8292 8.366 18.2492C8.31525 17.6692 8.2935 17.169 8.2935 16.734L8.25 16.125C8.25 14.5372 8.366 13.37 8.569 12.6232C8.75025 11.9707 9.17075 11.5502 9.82325 11.369C10.164 11.2747 10.7875 11.2095 11.7445 11.166C12.687 11.1152 13.5498 11.0935 14.3473 11.0935L15.5 11.05C18.5378 11.05 20.43 11.166 21.1768 11.369C21.8293 11.5502 22.2498 11.9707 22.431 12.6232Z",
      fill: "white"
    }, null, -1)
  ]));
}
const $0 = { render: xoe }, Toe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_ig"
};
function woe(t, e) {
  return h(), b("svg", Toe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.5 9.125C13.5989 9.125 13.3605 9.13306 12.6139 9.16712C11.8688 9.20111 11.36 9.31945 10.9147 9.4925C10.4544 9.67136 10.0641 9.91072 9.67487 10.2999C9.28572 10.689 9.04636 11.0794 8.8675 11.5397C8.69445 11.985 8.57611 12.4938 8.54213 13.2389C8.50806 13.9855 8.5 14.2239 8.5 16.125C8.5 18.0261 8.50806 18.2645 8.54213 19.0111C8.57611 19.7562 8.69445 20.265 8.8675 20.7103C9.04636 21.1706 9.28572 21.561 9.67487 21.9501C10.0641 22.3393 10.4544 22.5786 10.9147 22.7575C11.36 22.9305 11.8688 23.0489 12.6139 23.0829C13.3605 23.1169 13.5989 23.125 15.5 23.125C17.4011 23.125 17.6395 23.1169 18.3861 23.0829C19.1312 23.0489 19.64 22.9305 20.0853 22.7575C20.5456 22.5786 20.9359 22.3393 21.3251 21.9501C21.7143 21.561 21.9536 21.1706 22.1325 20.7103C22.3055 20.265 22.4239 19.7562 22.4579 19.0111C22.4919 18.2645 22.5 18.0261 22.5 16.125C22.5 14.2239 22.4919 13.9855 22.4579 13.2389C22.4239 12.4938 22.3055 11.985 22.1325 11.5397C21.9536 11.0794 21.7143 10.689 21.3251 10.2999C20.9359 9.91072 20.5456 9.67136 20.0853 9.4925C19.64 9.31945 19.1312 9.20111 18.3861 9.16712C17.6395 9.13306 17.4011 9.125 15.5 9.125ZM15.5 10.3863C17.3691 10.3863 17.5905 10.3934 18.3286 10.4271C19.0111 10.4582 19.3817 10.5722 19.6284 10.6681C19.9551 10.7951 20.1883 10.9468 20.4333 11.1917C20.6782 11.4367 20.8299 11.6699 20.9569 11.9966C21.0528 12.2433 21.1668 12.6139 21.1979 13.2964C21.2316 14.0345 21.2387 14.2559 21.2387 16.125C21.2387 17.9941 21.2316 18.2155 21.1979 18.9536C21.1668 19.6361 21.0528 20.0067 20.9569 20.2534C20.8299 20.5801 20.6782 20.8133 20.4333 21.0583C20.1883 21.3032 19.9551 21.4549 19.6284 21.5819C19.3817 21.6778 19.0111 21.7918 18.3286 21.8229C17.5906 21.8566 17.3692 21.8637 15.5 21.8637C13.6308 21.8637 13.4094 21.8566 12.6714 21.8229C11.9889 21.7918 11.6183 21.6778 11.3716 21.5819C11.0449 21.4549 10.8117 21.3032 10.5667 21.0583C10.3218 20.8133 10.1701 20.5801 10.0431 20.2534C9.94723 20.0067 9.8332 19.6361 9.80208 18.9536C9.7684 18.2155 9.76126 17.9941 9.76126 16.125C9.76126 14.2559 9.7684 14.0345 9.80208 13.2964C9.8332 12.6139 9.94723 12.2433 10.0431 11.9966C10.1701 11.6699 10.3218 11.4367 10.5667 11.1917C10.8117 10.9468 11.0449 10.7951 11.3716 10.6681C11.6183 10.5722 11.9889 10.4582 12.6714 10.4271C13.4095 10.3934 13.6309 10.3863 15.5 10.3863ZM15.5 12.5304C13.5148 12.5304 11.9054 14.1397 11.9054 16.125C11.9054 18.1103 13.5148 19.7196 15.5 19.7196C17.4853 19.7196 19.0946 18.1103 19.0946 16.125C19.0946 14.1397 17.4853 12.5304 15.5 12.5304ZM15.5 18.4583C14.2113 18.4583 13.1667 17.4137 13.1667 16.125C13.1667 14.8363 14.2113 13.7917 15.5 13.7917C16.7887 13.7917 17.8333 14.8363 17.8333 16.125C17.8333 17.4137 16.7887 18.4583 15.5 18.4583ZM20.0766 12.3884C20.0766 12.8523 19.7005 13.2284 19.2366 13.2284C18.7727 13.2284 18.3966 12.8523 18.3966 12.3884C18.3966 11.9245 18.7727 11.5484 19.2366 11.5484C19.7005 11.5484 20.0766 11.9245 20.0766 12.3884Z",
      fill: "white"
    }, null, -1)
  ]));
}
const qb = { render: woe }, koe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_x"
};
function Soe(t, e) {
  return h(), b("svg", koe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M16.7101 15.1296L21.4455 9.625H20.3234L16.2116 14.4046L12.9275 9.625H9.13965L14.1058 16.8526L9.13965 22.625H10.2619L14.6041 17.5776L18.0723 22.625H21.8601L16.7098 15.1296H16.7101ZM15.173 16.9162L14.6698 16.1965L10.6662 10.4698H12.3899L15.6209 15.0915L16.124 15.8112L20.3239 21.8186H18.6002L15.173 16.9165V16.9162Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Rc = { render: Soe }, Coe = {
  width: "31",
  height: "32",
  viewBox: "0 0 31 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-footer_fb"
};
function Aoe(t, e) {
  return h(), b("svg", Coe, e[0] || (e[0] = [
    k("rect", {
      y: "0.625",
      width: "31",
      height: "31",
      rx: "15.5",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M16.6526 16.7389V23.125H13.9194V16.7389H11.6338V14.2501H13.9194V12.4147C13.9194 10.2848 15.3028 9.125 17.3235 9.125C18.2914 9.125 19.1234 9.19275 19.3658 9.22307V11.4491L17.9641 11.4496C16.8654 11.4496 16.6526 11.9407 16.6526 12.6612V14.2501H19.2735L18.9323 16.7389H16.6526Z",
      fill: "white"
    }, null, -1)
  ]));
}
const Wb = { render: Aoe }, Eoe = { class: "footer-links" }, Loe = {
  key: 0,
  href: "https://www.library.ucla.edu",
  target: "_blank",
  class: "logo-ucla"
}, Doe = { class: "socials" }, Ioe = ["href", "target"], Moe = {
  key: 2,
  class: "press-links"
}, Ooe = {
  key: 0,
  id: "mc-embedded-subscribe-form",
  action: "https://ucla.us17.list-manage.com/subscribe/post?u=cb3f880892df52211b236bdee&id=ce2bece15c&f_id=00edc2e1f0",
  method: "post",
  name: "mc-embedded-subscribe-form",
  class: "validate form",
  target: "_blank",
  novalidate: ""
}, Poe = {
  id: "mc_embed_signup_scroll",
  class: "form-header"
}, Boe = { class: "statement" }, Roe = { class: "input-block" }, Noe = {
  id: "mc-embedded-subscribe",
  class: "button-submit",
  name: "subscribe",
  type: "submit"
}, $oe = /* @__PURE__ */ Ae({
  __name: "FooterPrimary",
  props: {
    form: {
      type: Boolean,
      default: !0
    },
    isMicrosite: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, n = {
      arrowRight: bi,
      caretRight: Tl
    }, a = {
      youtube: $0,
      Youtube: $0,
      YouTube: $0,
      // handle edge case
      instagram: qb,
      Instagram: qb,
      twitter: Rc,
      Twitter: Rc,
      x: Rc,
      X: Rc,
      // handle either X or Twitter
      facebook: Wb,
      Facebook: Wb
    }, i = Ge(), r = I(() => ["footer-primary", (i == null ? void 0 : i.value) || ""]), s = I(() => e.form ? ["container"] : ["container no-form"]), o = I(() => (i == null ? void 0 : i.value) === "ftva" ? {
      statement: "Subscribe to receive the latest updates on what's happening at the Film & Television Archive.",
      label: "Submit",
      icon: n.caretRight,
      socialMediaIcons: !0
    } : {
      statement: "Subscribe to get the latest updates on what's happening with UCLA Library.",
      label: "Subscribe",
      icon: n.arrowRight,
      socialMediaIcons: !1
    }), l = to(), c = I(() => Object.keys(l.footerPrimary).length !== 0 ? l.footerPrimary.nodes[0].children : (console.log(
      // @ts-expect-error
      `Pinia state data not present: is it client side:${process.client}`
    ), [])), d = I(() => Object.keys(l.footerPrimary).length !== 0 ? l.footerPrimary.nodes[1].children : (console.log(
      // @ts-expect-error
      `Pinia state data not present: is it client side:${process.client}`
    ), [])), f = I(() => (i == null ? void 0 : i.value) === "ftva" ? goe : Gs);
    function g(_) {
      return o2(_);
    }
    return (_, x) => (h(), b("div", {
      class: se(r.value)
    }, [
      O(i) ? E("", !0) : (h(), Z(O(yoe), {
        key: 0,
        class: "molecule-half-svg",
        "aria-hidden": "true"
      })),
      k("div", {
        class: se(s.value)
      }, [
        k("div", Eoe, [
          t.isMicrosite ? (h(), b("a", Loe, [
            (h(), Z(ut(f.value), { class: "logo-svg" })),
            x[0] || (x[0] = k("span", { class: "visually-hidden" }, "UCLA Library Home", -1))
          ])) : (h(), Z(Ke, {
            key: 1,
            to: "/",
            class: "logo-ucla"
          }, {
            default: ce(() => [
              (h(), Z(ut(f.value), { class: "logo-svg" })),
              x[1] || (x[1] = k("span", { class: "visually-hidden" }, "UCLA Library Home", -1))
            ]),
            _: 1
          })),
          k("ul", Doe, [
            (h(!0), b(me, null, Ee(c.value, (p) => {
              var w;
              return h(), b("li", {
                key: p.id,
                class: "social-item"
              }, [
                k("a", {
                  href: p.to,
                  target: g(p.target)
                }, [
                  (w = o.value) != null && w.socialMediaIcons ? (h(), Z(ut(a[p.name]), { key: 0 })) : (h(), b(me, { key: 1 }, [
                    Ye(ae(p.name), 1)
                  ], 64))
                ], 8, Ioe)
              ]);
            }), 128))
          ]),
          d.value ? (h(), b("ul", Moe, [
            (h(!0), b(me, null, Ee(d.value, (p) => (h(), b("li", {
              key: p.id,
              class: "press-item"
            }, [
              Q(Ke, {
                to: p.to,
                "link-target": p.target
              }, {
                default: ce(() => [
                  Ye(ae(p.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "link-target"])
            ]))), 128))
          ])) : E("", !0)
        ]),
        t.form ? (h(), b("form", Ooe, [
          k("div", Poe, [
            x[2] || (x[2] = k("h2", { class: "title" }, " Stay updated ", -1)),
            k("p", Boe, ae(o.value.statement), 1)
          ]),
          k("div", Roe, [
            x[3] || (x[3] = ri('<div class="field mc-field-group" data-v-37462b31><input id="mce-EMAIL" name="EMAIL" type="email" value="" placeholder="email@ucla.edu" class="input-email" required data-v-37462b31><label for="mce-EMAIL" class="label" data-v-37462b31> Email Address </label></div><div id="mce-responses" class="clear" data-v-37462b31><div id="mce-error-response" class="response" style="display:none;" data-v-37462b31></div><div id="mce-success-response" class="response" style="display:none;" data-v-37462b31></div></div><div style="position:absolute;left:-5000px;" aria-hidden="true" data-v-37462b31><input type="text" name="b_31248d1f341b8eede1b46cb33_40fdd1db46" tabindex="-1" value="" data-v-37462b31></div>', 3)),
            k("button", Noe, [
              Ye(ae(o.value.label) + " ", 1),
              (h(), Z(ut(o.value.icon), { class: "arrow-svg" }))
            ])
          ])
        ])) : E("", !0)
      ], 2)
    ], 2));
  }
}), Foe = /* @__PURE__ */ be($oe, [["__scopeId", "data-v-37462b31"]]), zoe = { class: "container" }, Uoe = { class: "regents" }, Hoe = { class: "links" }, Yoe = {
  __name: "FooterSock",
  setup(t) {
    const e = to(), n = I(() => Object.keys(e.footerSock).length !== 0 ? e.footerSock.nodes : (console.log(
      `Pinia state data for footer sock not present if navigation is not setup for the website: is it client side:${process.client}`
    ), [])), a = Ge(), i = I(() => ["footer-sock", (a == null ? void 0 : a.value) || ""]), r = I(() => (/* @__PURE__ */ new Date()).getFullYear());
    return (s, o) => (h(), b("div", {
      class: se(i.value)
    }, [
      k("div", zoe, [
        k("div", Uoe, " © " + ae(r.value) + " Regents of the University of California ", 1),
        k("ul", Hoe, [
          (h(!0), b(me, null, Ee(n.value, (l) => (h(), b("li", {
            key: l.id,
            class: "item"
          }, [
            Q(Ke, {
              class: "link",
              to: l.to,
              "link-target": l.target
            }, {
              default: ce(() => [
                Ye(ae(l.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "link-target"])
          ]))), 128))
        ])
      ])
    ], 2));
  }
}, joe = /* @__PURE__ */ be(Yoe, [["__scopeId", "data-v-b34d5314"]]), Voe = { class: "link-wrapper" }, qoe = { class: "link-list-label" }, Woe = /* @__PURE__ */ Ae({
  __name: "FooterLinks",
  setup(t) {
    const e = to(), n = I(() => Object.keys(e.footerLinks).length !== 0 ? e.footerLinks.nodes : (console.log(
      "Pinia state data for footer links not present"
    ), [])), a = Ge(), i = I(() => ["footer-links", (a == null ? void 0 : a.value) || ""]);
    return (r, s) => (h(), b("div", {
      class: se(i.value)
    }, [
      k("div", Voe, [
        (h(!0), b(me, null, Ee(n.value, (o, l) => (h(), b("div", {
          key: o.category,
          class: "link-list"
        }, [
          k("h4", qoe, ae(o.category), 1),
          k("ul", null, [
            (h(!0), b(me, null, Ee(n.value[l].children, (c) => (h(), b("li", {
              key: c.name,
              class: "link-item"
            }, [
              Q(Ke, {
                id: "banner-featured",
                to: c.to,
                class: "title title-linked"
              }, {
                default: ce(() => [
                  Ye(ae(c.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))), 128))
          ])
        ]))), 128))
      ])
    ], 2));
  }
}), Goe = /* @__PURE__ */ be(Woe, [["__scopeId", "data-v-f4091c1e"]]), Xoe = /* @__PURE__ */ Ae({
  __name: "FooterMain",
  setup(t) {
    const e = Ge(), n = I(() => ["footer-main", (e == null ? void 0 : e.value) || ""]), a = I(() => (e == null ? void 0 : e.value) === void 0), i = I(() => (e == null ? void 0 : e.value) !== void 0), r = I(() => (e == null ? void 0 : e.value) === "ftva");
    return (s, o) => (h(), b("footer", {
      class: se(n.value)
    }, [
      a.value ? (h(), Z(doe, {
        key: 0,
        class: "sponsor"
      })) : E("", !0),
      Q(Foe, {
        form: r.value,
        class: "primary",
        "is-microsite": !0
      }, null, 8, ["form"]),
      i.value ? (h(), Z(Goe, {
        key: 1,
        class: "links"
      })) : E("", !0),
      Q(joe, { class: "sock" })
    ], 2));
  }
}), the = /* @__PURE__ */ be(Xoe, [["__scopeId", "data-v-88d30df1"]]), Zoe = {
  __name: "HeadingArrow",
  props: {
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    section: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => t.section || ha(t.to)), n = I(() => ["heading-arrow", `color-${e.value}`]), a = I(() => {
      let r = "div";
      return t.to && (r = Ke), r;
    }), i = I(() => ["heading", `color-${a.value}`]);
    return (r, s) => (h(), Z(ut(a.value), {
      to: t.to,
      class: se(n.value)
    }, {
      default: ce(() => [
        Q(O(Ol), {
          class: "svg",
          "aria-hidden": "true"
        }),
        k("h2", {
          class: se(i.value)
        }, ae(t.text), 3)
      ]),
      _: 1
    }, 8, ["to", "class"]));
  }
}, nhe = /* @__PURE__ */ be(Zoe, [["__scopeId", "data-v-57471d15"]]), Koe = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-search"
};
function Qoe(t, e) {
  return h(), b("svg", Koe, e[0] || (e[0] = [
    k("path", {
      d: "M12.1498 10.6918H11.3819L11.1098 10.4294C12.0952 9.28636 12.6369 7.82709 12.6358 6.3179C12.6358 5.06834 12.2653 3.84684 11.571 2.80786C10.8768 1.76889 9.89009 0.95911 8.73565 0.480924C7.58121 0.00273745 6.31089 -0.122378 5.08534 0.121399C3.85979 0.365177 2.73404 0.966898 1.85047 1.85047C0.966898 2.73404 0.365177 3.85979 0.121399 5.08534C-0.122378 6.31089 0.00273745 7.58121 0.480924 8.73565C0.95911 9.89009 1.76889 10.8768 2.80786 11.571C3.84684 12.2653 5.06834 12.6358 6.3179 12.6358C7.88279 12.6358 9.32133 12.0623 10.4294 11.1098L10.6918 11.3819V12.1498L15.5517 17L17 15.5517L12.1498 10.6918ZM6.3179 10.6918C3.89766 10.6918 1.94397 8.73814 1.94397 6.3179C1.94397 3.89766 3.89766 1.94397 6.3179 1.94397C8.73814 1.94397 10.6918 3.89766 10.6918 6.3179C10.6918 8.73814 8.73814 10.6918 6.3179 10.6918Z",
      fill: "#132941",
      class: "svg__fill--dark-navy"
    }, null, -1)
  ]));
}
const vx = { render: Qoe }, Joe = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-menu"
};
function ele(t, e) {
  return h(), b("svg", Joe, e[0] || (e[0] = [
    k("path", {
      d: "M11 15.3376h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11 24.1147h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11 32.8921h26",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const yx = { render: ele }, tle = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-circle-x"
};
function nle(t, e) {
  return h(), b("svg", tle, e[0] || (e[0] = [
    k("rect", {
      width: "23",
      height: "23",
      rx: "11.5",
      fill: "#41648C"
    }, null, -1),
    k("path", {
      d: "M15.5753 16.4242L15.5753 16.4242C15.631 16.4799 15.6972 16.5241 15.77 16.5543C15.8429 16.5845 15.9209 16.6 15.9997 16.6C16.0786 16.6 16.1566 16.5845 16.2295 16.5543C16.3023 16.5241 16.3685 16.4799 16.4242 16.4242C16.4799 16.3685 16.5241 16.3023 16.5543 16.2295C16.5845 16.1566 16.6 16.0786 16.6 15.9997C16.6 15.9209 16.5845 15.8429 16.5543 15.77C16.5241 15.6972 16.4799 15.631 16.4242 15.5753L16.4242 15.5753L12.3483 11.5L16.4242 7.4247L16.4242 7.42469C16.5368 7.31212 16.6 7.15945 16.6 7.00025C16.6 6.84105 16.5368 6.68838 16.4242 6.57581L16.3537 6.64632L16.4242 6.57581C16.3116 6.46324 16.1589 6.4 15.9997 6.4C15.8406 6.4 15.6879 6.46324 15.5753 6.57581L15.5753 6.57581L11.5 10.6517L7.4247 6.57581L7.42469 6.57581C7.31212 6.46324 7.15945 6.4 7.00025 6.4C6.84105 6.4 6.68838 6.46324 6.57581 6.57581C6.46324 6.68838 6.4 6.84105 6.4 7.00025C6.4 7.15945 6.46324 7.31212 6.57581 7.42469L6.57581 7.4247L10.6517 11.5L6.57581 15.5753L6.57581 15.5753C6.46324 15.6879 6.4 15.8406 6.4 15.9997C6.4 16.1589 6.46324 16.3116 6.57581 16.4242C6.68838 16.5368 6.84105 16.6 7.00025 16.6C7.15945 16.6 7.31212 16.5368 7.42469 16.4242L7.4247 16.4242L11.5 12.3483L15.5753 16.4242Z",
      fill: "#F1F1F1",
      stroke: "#F1F1F1",
      "stroke-width": "0.2"
    }, null, -1)
  ]));
}
const ale = { render: nle }, ile = {
  width: "32",
  height: "33",
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-caret-down"
};
function rle(t, e) {
  return h(), b("svg", ile, e[0] || (e[0] = [
    k("path", {
      d: "m10 14.729 6 6 6-6",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Ld = { render: rle }, sle = {
  name: "NavMenuItem",
  components: {
    SmartLink: Ke
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    isOpened: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    return {
      theme: Ge()
    };
  },
  computed: {
    classes() {
      return [
        this.item.classes,
        "nav-menu-item",
        { "is-active": this.isActive },
        { "is-opened": this.isOpened },
        this.theme || ""
      ];
    },
    parsedChildren() {
      return this.item.children.map((t) => ({
        ...t,
        classes: `sub-menu-link ${t.classes || ""}`
      }));
    }
  }
}, ole = ["innerHTML"], lle = { class: "sub-menu" };
function cle(t, e, n, a, i, r) {
  const s = ot("SmartLink");
  return h(), b("li", {
    class: se(r.classes)
  }, [
    k("button", {
      class: "section-name",
      innerHTML: n.item.name
    }, null, 8, ole),
    xe(t.$slots, "default", {}, void 0, !0),
    k("ul", lle, [
      (h(!0), b(me, null, Ee(r.parsedChildren, (o) => (h(), b("li", {
        key: o.id,
        class: "sub-menu-item"
      }, [
        Q(s, {
          class: se(o.classes),
          to: o.to,
          "link-target": o.target
        }, {
          default: ce(() => [
            Ye(ae(o.name), 1)
          ]),
          _: 2
        }, 1032, ["class", "to", "link-target"])
      ]))), 128))
    ])
  ], 2);
}
const ule = /* @__PURE__ */ be(sle, [["render", cle], ["__scopeId", "data-v-8f090b1f"]]), dle = {
  key: 0,
  class: "item-top"
}, hle = {
  key: 0,
  class: "title"
}, fle = { class: "full-title" }, ple = {
  key: 0,
  class: "acronym"
}, mle = ["aria-label"], gle = {
  key: 0,
  class: "title"
}, ble = { class: "full-title" }, vle = {
  key: 0,
  class: "acronym"
}, yle = {
  key: 1,
  class: "item-top-mobile"
}, _le = {
  key: 2,
  class: "more-menu"
}, xle = { class: "chevron" }, Tle = {
  key: 3,
  class: "support-links"
}, wle = {
  key: 4,
  class: "mobile-menu-slot"
}, kle = /* @__PURE__ */ Ae({
  __name: "NavPrimary",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currentPath: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    acronym: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, { items: n, currentPath: a, title: i, acronym: r } = $h(e), s = J(n.value || []), o = J(a.value), l = J(i.value), c = J(r.value), d = $a(), f = J(!1), g = J(!1), _ = J(!1), x = J(-1), p = Ge(), w = I(() => [
      "nav-primary",
      { "is-opened": f.value || g.value },
      { "slot-is-opened": g.value },
      // sometimes we need to style different depending on which menu is open
      { "not-hovered": x.value === -1 },
      { "has-title": l.value },
      { "has-acronym": c.value },
      { "is-opened-mobile": _.value },
      (p == null ? void 0 : p.value) || ""
    ]), C = I(() => {
      switch (p == null ? void 0 : p.value) {
        case "ftva":
          return {
            renderItemTop: !1,
            showSearch: !0,
            horizontalMobileMenu: !0,
            headerText: "UCLA Film & Television Archive"
          };
        default:
          return {
            renderItemTop: !0,
            showSearch: !1,
            horizontalMobileMenu: !1
          };
      }
    }), M = I(() => l.value || c.value), A = I(() => l.value ? s.value.filter((X) => !X.children || !X.children.length) : []), L = I(() => s.value.filter((X) => !X.children || !X.children.length)), D = I(() => {
      const X = o.value || (d == null ? void 0 : d.path);
      return s.value.findIndex((R) => R.url && X.includes(R.url));
    }), B = I(
      () => s.value.filter((X) => X.children && X.children.length).map((X, R) => ({
        ...X,
        isActive: R === x.value
      }))
    );
    function P() {
      g.value && (g.value = !1), f.value = !f.value, f.value || (document.body.setAttribute("tabindex", "-1"), document.body.focus(), document.body.removeAttribute("tabindex"));
    }
    function z() {
      q(), f.value ? (f.value = !1, setTimeout(() => {
        g.value = !g.value;
      }, 400)) : g.value = !g.value;
    }
    function W(X) {
      x.value = X;
    }
    function q() {
      x.value = D.value;
    }
    const { width: V } = Ei(), re = I(() => V.value <= 750);
    function ie() {
      g.value = !1, f.value = !1, _.value = !_.value;
    }
    function K(X) {
      var R;
      (R = C.value) != null && R.horizontalMobileMenu && re.value === !0 ? X === x.value ? q() : (q(), W(X)) : P();
    }
    at(re, (X, R) => {
      R !== X && (f.value = !1, g.value = !1, _.value = !1);
    });
    function $() {
      re.value === !0 ? ie() : z();
    }
    return ht(() => {
      at(
        [n, a, i, r],
        ([X, R, de, Le]) => {
          console.log("NavPrimary data updated from nuxt layout or app.vue when working with craft draft previews", X, R, de, Le), s.value = X || [], o.value = R, l.value = de, c.value = Le;
        },
        { deep: !0 }
      ), x.value = D.value;
    }), (X, R) => (h(), b("nav", {
      "aria-label": "Primary Navigation",
      class: se(w.value)
    }, [
      C.value.renderItemTop ? (h(), b("div", dle, [
        M.value ? (h(), Z(Ke, {
          key: 0,
          to: "/",
          "aria-label": l.value ? "" : "UCLA Library home page"
        }, {
          default: ce(() => [
            l.value ? (h(), b("div", hle, [
              k("span", fle, ae(l.value), 1),
              c.value ? (h(), b("span", ple, ae(c.value), 1)) : E("", !0)
            ])) : (h(), Z(O(Gs), {
              key: 1,
              class: "svg logo-ucla",
              alt: "UCLA Library logo blue"
            }))
          ]),
          _: 1
        }, 8, ["aria-label"])) : (h(), b("a", {
          key: 1,
          href: "/",
          "aria-label": l.value ? "" : "UCLA Library home page"
        }, [
          l.value ? (h(), b("div", gle, [
            k("span", ble, ae(l.value), 1),
            c.value ? (h(), b("span", vle, ae(c.value), 1)) : E("", !0)
          ])) : (h(), Z(O(Gs), {
            key: 1,
            class: "svg logo-ucla",
            alt: "UCLA Library logo blue"
          }))
        ], 8, mle))
      ])) : re.value && C.value.headerText ? (h(), b("div", yle, ae(C.value.headerText), 1)) : E("", !0),
      R[1] || (R[1] = k("div", { class: "nav-background-fill" }, null, -1)),
      C.value.showSearch ? (h(), b("div", _le, [
        _.value ? E("", !0) : (h(), Z(cn, {
          key: 0,
          class: "search-button",
          "icon-name": "none",
          "aria-label": "Search",
          onClick: $
        }, {
          default: ce(() => [
            Q(O(vx), { class: "icon-search" })
          ]),
          _: 1
        })),
        !_.value || !re.value ? (h(), Z(cn, {
          key: 1,
          class: "more-menu-button mobile-only",
          "icon-name": "none",
          "aria-label": "open menu",
          onClick: ie
        }, {
          default: ce(() => [
            Q(O(yx), { class: "icon-menu" })
          ]),
          _: 1
        })) : E("", !0),
        _.value ? (h(), Z(cn, {
          key: 2,
          class: "close-button mobile-only",
          "icon-name": "none",
          "aria-label": "close menu",
          onClick: ie
        }, {
          default: ce(() => [
            Q(O(ale), { class: "icon-menu-close" })
          ]),
          _: 1
        })) : E("", !0),
        k("div", {
          class: se(["slot-container", [{ "is-opened": g.value, "is-opened-mobile": _.value }]])
        }, [
          xe(X.$slots, "additional-menu", {}, void 0, !0)
        ], 2)
      ])) : E("", !0),
      k("ul", {
        class: se(["menu", [{ "is-opened-mobile": _.value }]])
      }, [
        (h(!0), b(me, null, Ee(B.value, (de, Le) => (h(), Z(ule, {
          key: `NavMenuItem-${de.name}`,
          item: de,
          "is-active": de.isActive,
          "is-opened": f.value,
          onClick: () => K(Le),
          onMouseover: (Ie) => re.value ? "" : W(Le),
          onMouseleave: R[0] || (R[0] = (Ie) => re.value ? "" : q)
        }, {
          default: ce(() => [
            C.value.horizontalMobileMenu && re.value ? (h(), b("span", {
              key: 0,
              class: se(["caret", { "is-active": de.isActive }])
            }, [
              k("span", xle, [
                Q(O(Ld), { class: "caret-down-svg" })
              ])
            ], 2)) : E("", !0)
          ]),
          _: 2
        }, 1032, ["item", "is-active", "is-opened", "onClick", "onMouseover"]))), 128)),
        (h(!0), b(me, null, Ee(A.value, (de) => (h(), b("li", {
          key: `nav-primary-${de.name}`,
          class: "nochildren-links"
        }, [
          Q(Ke, {
            class: "nochildren-link underline-hover",
            to: de.to,
            "link-target": de.target
          }, {
            default: ce(() => [
              Ye(ae(de.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "link-target"])
        ]))), 128))
      ], 2),
      l.value ? E("", !0) : (h(), b("div", Tle, [
        (h(!0), b(me, null, Ee(L.value, (de) => (h(), b("div", {
          key: `nav-primary-support-${de.name}`,
          class: "item-top"
        }, [
          Q(Ke, {
            class: "support-link underline-hover",
            to: de.to
          }, {
            default: ce(() => [
              Ye(ae(de.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))), 128))
      ])),
      re.value && _.value ? (h(), b("div", wle, [
        xe(X.$slots, "additional-mobile-menu-items", {}, void 0, !0)
      ])) : E("", !0),
      R[2] || (R[2] = k("div", { class: "background-white" }, null, -1)),
      f.value || g.value ? (h(), b("div", {
        key: 5,
        class: "background-blue",
        onClick: P
      })) : E("", !0),
      f.value ? (h(), b("div", {
        key: 6,
        class: "click-blocker",
        onClick: P
      })) : E("", !0)
    ], 2));
  }
}), _x = /* @__PURE__ */ be(kle, [["__scopeId", "data-v-8612c381"]]), Sle = {
  "aria-label": "Secondary Navigation",
  class: "nav-secondary"
}, Cle = {
  key: 0,
  href: "https://www.library.ucla.edu",
  target: "_blank",
  "aria-label": "UCLA Library home page"
}, Ale = { class: "navigation-list" }, Ele = {
  key: 0,
  class: "list"
}, Lle = {
  key: 2,
  class: "link-list"
}, Dle = /* @__PURE__ */ Ae({
  __name: "NavSecondary",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isMicrosite: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, { items: n, isMicrosite: a } = $h(e), i = J(n.value || []), r = J(a.value);
    ht(() => {
      at(
        [n, a],
        ([d, f]) => {
          console.log("NavSecondary updated from nuxt layout or nuxt app.vue", d, f), i.value = d || [], r.value = f;
        },
        { deep: !0 }
      );
    });
    const s = I(() => [
      "flex-container",
      { "flex-container-not-microsite": !r.value },
      { "flex-container-microsite": r.value }
    ]), o = I(() => (i.value || []).map((d) => {
      let f = "list-item";
      return d != null && d.classes && (f = `${f} ${d == null ? void 0 : d.classes}`), {
        ...d,
        classes: f
      };
    })), l = I(() => {
      var d;
      return (d = o == null ? void 0 : o.value) == null ? void 0 : d.slice(0, -1);
    }), c = I(() => {
      var d;
      return o.value && o.value.length > 0 ? o == null ? void 0 : o.value[((d = o == null ? void 0 : o.value) == null ? void 0 : d.length) - 1] : null;
    });
    return (d, f) => {
      var g, _, x;
      return h(), b("nav", Sle, [
        k("div", {
          class: se(s.value)
        }, [
          r.value ? (h(), b("a", Cle, [
            Q(O(Gs), {
              class: "svg logo-ucla",
              alt: "UCLA Library logo blue"
            })
          ])) : E("", !0),
          k("div", Ale, [
            r.value ? E("", !0) : (h(), b("ul", Ele, [
              (h(!0), b(me, null, Ee(l.value, (p) => (h(), b("li", {
                key: `nav-secondary-${p.name}`,
                class: se(p.classes)
              }, [
                Q(Ke, {
                  class: "link underline-hover",
                  to: p.to,
                  "link-target": p.target
                }, {
                  default: ce(() => [
                    Ye(ae(p.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"])
              ], 2))), 128))
            ])),
            !r.value && c.value ? (h(), Z(cn, {
              key: 1,
              label: (g = c.value) == null ? void 0 : g.name,
              class: "account-button",
              "link-target": (_ = c.value) == null ? void 0 : _.target,
              to: (x = c.value) == null ? void 0 : x.to,
              "is-secondary": !0
            }, null, 8, ["label", "link-target", "to"])) : E("", !0),
            r.value ? (h(), b("ul", Lle, [
              (h(!0), b(me, null, Ee(o.value, (p) => (h(), b("li", {
                key: `nav-secondary-${p.name}`,
                class: se(p.classes)
              }, [
                Q(Ke, {
                  class: "link underline-hover",
                  to: p.to,
                  "link-target": p.target
                }, {
                  default: ce(() => [
                    Ye(ae(p.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "link-target"])
              ], 2))), 128))
            ])) : E("", !0)
          ])
        ], 2)
      ]);
    };
  }
}), xx = /* @__PURE__ */ be(Dle, [["__scopeId", "data-v-ae37baf7"]]), Ile = { class: "header-main" }, Mle = /* @__PURE__ */ Ae({
  __name: "HeaderMain",
  props: {
    primaryNav: {
      type: Array,
      default: () => []
    },
    secondaryNav: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, { primaryNav: n, secondaryNav: a, title: i } = $h(e), r = J(n.value), s = J(a.value), o = J(i.value);
    ht(() => {
      at(
        [n, a, i],
        ([c, d, f]) => {
          r.value = c, s.value = d, o.value = f;
        },
        { deep: !0 }
      );
    });
    const l = I(() => !!o.value);
    return (c, d) => (h(), b("header", Ile, [
      Q(xx, {
        items: s.value,
        "is-microsite": l.value
      }, null, 8, ["items", "is-microsite"]),
      Q(_x, {
        class: "primary",
        items: r.value,
        title: o.value
      }, null, 8, ["items", "title"])
    ]));
  }
}), Gb = /* @__PURE__ */ be(Mle, [["__scopeId", "data-v-af0335ca"]]), Ole = {
  width: "249",
  height: "247",
  viewBox: "0 0 249 247",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__molecule-3d"
};
function Ple(t, e) {
  return h(), b("svg", Ole, e[0] || (e[0] = [
    k("path", {
      d: "M124.566 245.393L209.606 211.206L209.746 210.881M124.566 245.393L37.1772 211.206M124.566 245.393L190.343 191.802M124.566 245.393L57.38 191.802M247.193 123.89L209.606 40.2692M247.193 123.89L209.746 210.881M247.193 123.89L124.566 57.3629M247.193 123.89L190.343 191.802M209.606 40.2692L124.566 0.999955M209.606 40.2692L124.566 57.3629M124.566 0.999955L37.1772 40.2692M124.566 0.999955V57.3629M37.1772 40.2692L1 123.89M37.1772 40.2692L124.566 57.3629M1 123.89L37.1772 211.206M1 123.89L57.38 191.802M1 123.89L124.566 57.3629M37.1772 211.206L57.38 191.802M57.38 191.802H190.343M57.38 191.802L124.566 57.3629M190.343 191.802L209.746 210.881M190.343 191.802L124.566 57.3629",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const Ble = { render: Ple }, Rle = { class: "nav-menu-item" }, Nle = ["data-sub-menu-title-id"], $le = ["data-sub-menu-item-id"], Fle = {
  __name: "NavMenuItemResponsive",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    goBack: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["shouldOpen", "itemOpenedColor", "closeMainMenu"],
  setup(t, { emit: e }) {
    const n = e, a = I(() => t.item.children.map((l) => ({
      ...l,
      classes: `sub-menu-link ${l.classes || ""}`
    })));
    function i(l) {
      const c = document.querySelectorAll(
        `[data-sub-menu-item-id="${l}"]`
      )[0], d = document.querySelectorAll(
        `ul:not([data-sub-menu-item-id="${l}"])`
      ), f = document.querySelectorAll(
        `li span:not([data-sub-menu-title-id="${l}"])`
      );
      if (c.classList.contains("block")) {
        c.classList.remove("block"), c.classList.add("hidden");
        for (const g of f)
          g.classList.add("block");
      } else {
        c.classList.remove("hidden"), c.classList.add("block");
        for (const g of f)
          g.classList.remove("block");
        for (const g of d)
          g.classList.remove("block"), g.classList.add("hidden");
      }
      n("shouldOpen"), n("itemOpenedColor", l);
    }
    function r() {
      const l = document.querySelectorAll(
        "[data-sub-menu-title-id]"
      );
      for (const d of l)
        d.classList.remove("hidden"), d.classList.add("block");
      const c = document.querySelectorAll(
        "[data-sub-menu-item-id]"
      );
      for (const d of c)
        d.classList.remove("block"), d.classList.add("hidden");
    }
    function s() {
      n("closeMainMenu");
    }
    const o = J(t.goBack);
    return at(o, (l) => {
      l && r();
    }), (l, c) => (h(), b("li", Rle, [
      k("button", {
        class: "section-name block",
        "data-sub-menu-title-id": t.index,
        onClick: c[0] || (c[0] = (d) => i(t.index))
      }, ae(t.item.name), 9, Nle),
      k("ul", {
        "data-sub-menu-item-id": t.index,
        class: "sub-menu hidden"
      }, [
        (h(!0), b(me, null, Ee(a.value, (d) => (h(), b("li", {
          key: d.id,
          class: "sub-menu-item",
          onClick: s
        }, [
          Q(Ke, {
            class: se(d.classes),
            to: d.to,
            "link-target": d.target
          }, {
            default: ce(() => [
              Ye(ae(d.name), 1)
            ]),
            _: 2
          }, 1032, ["class", "to", "link-target"])
        ]))), 128))
      ], 8, $le)
    ]));
  }
}, zle = /* @__PURE__ */ be(Fle, [["__scopeId", "data-v-21e4b46f"]]), Ule = { class: "collapsed-menu" }, Hle = {
  key: 0,
  class: "title"
}, Yle = { class: "full-title" }, jle = {
  key: 0,
  class: "acronym"
}, Vle = ["is-opened"], qle = { class: "expanded-menu-container" }, Wle = { class: "expanded-menu" }, Gle = {
  key: 0,
  class: "title opened-title"
}, Xle = { class: "full-title" }, Zle = {
  key: 0,
  class: "acronym"
}, Kle = { class: "nav-menu-primary" }, Qle = {
  key: 0,
  class: "nav-menu-secondary"
}, Jle = { class: "list" }, ece = {
  key: 1,
  class: "support-us-container"
}, tce = /* @__PURE__ */ Ae({
  __name: "HeaderMainResponsive",
  props: {
    primaryNav: {
      // This is an array of objects, with each object shaped like {name, url, items:[{text, to, target}]}
      type: Array,
      default: () => []
    },
    secondaryNav: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    acronym: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, n = J(!1), a = J(!1), i = J(!1), r = J("cyan"), s = I(() => [
      "header-main-responsive",
      n.value ? "fullHeight" : "collapsedHeight",
      { "has-title": e.title },
      { "has-acronym": e.acronym }
    ]), o = I(() => e.title ? e.title : "UCLA Library home page"), l = I(() => gx), c = I(() => e.primaryNav.filter((C) => C.children && C.children.length)), d = I(() => e.secondaryNav), f = I(() => e.title ? e.primaryNav.filter((C) => !C.children || !C.children.length) : []), g = I(() => e.primaryNav.filter((C) => !C.children || !C.children.length));
    function _() {
      a.value = !a.value, i.value = !1;
    }
    function x() {
      i.value = !i.value, r.value = "cyan", n.value = !1;
    }
    function p(C) {
      C === 0 ? r.value = "green" : C === 1 ? r.value = "pink" : C === 2 && (r.value = "purple"), a.value === !1 && (r.value = "cyan");
    }
    function w() {
      n.value = !n.value, i.value = !i.value;
    }
    return (C, M) => (h(), b("nav", {
      role: "navigation",
      "aria-label": "Menu",
      class: se(s.value)
    }, [
      kt(k("div", Ule, [
        Q(Ke, {
          class: "clickable-parent",
          to: "/",
          "aria-label": o.value
        }, {
          default: ce(() => [
            t.title ? (h(), b("div", Hle, [
              k("span", Yle, ae(t.title), 1),
              t.acronym ? (h(), b("span", jle, ae(t.acronym), 1)) : E("", !0)
            ])) : (h(), Z(ut(O(Gs)), {
              key: 1,
              width: "155",
              height: "55",
              class: "logo-ucla",
              role: "button"
            }))
          ]),
          _: 1
        }, 8, ["aria-label"]),
        k("button", {
          role: "button",
          class: "open-menu",
          "aria-label": "Open menu",
          "is-opened": n.value,
          onClick: w
        }, [
          (h(), Z(ut(O(yx)), { class: "hamburguer" }))
        ], 8, Vle)
      ], 512), [
        [ga, !n.value]
      ]),
      kt(k("div", qle, [
        k("div", Wle, [
          Q(Ke, {
            class: "clickable-parent",
            to: "/",
            "aria-label": o.value,
            onClick: w
          }, {
            default: ce(() => [
              t.title ? (h(), b("div", Gle, [
                k("span", Xle, ae(t.title), 1),
                t.acronym ? (h(), b("span", Zle, ae(t.acronym), 1)) : E("", !0)
              ])) : (h(), Z(ut(O(Gs)), {
                key: 1,
                width: "155",
                height: "55",
                class: "expanded-logo",
                onClick: w
              }))
            ]),
            _: 1
          }, 8, ["aria-label"]),
          k("button", {
            role: "button",
            class: "close-menu",
            "aria-label": "Close menu",
            onClick: x
          }, [
            (h(), Z(ut(l.value), { class: "close-svg" }))
          ])
        ]),
        k("ul", Kle, [
          (h(!0), b(me, null, Ee(c.value, (A, L) => (h(), Z(zle, {
            key: A.name,
            item: A,
            index: L,
            "go-back": i.value,
            onShouldOpen: _,
            onItemOpenedColor: p,
            onCloseMainMenu: w
          }, null, 8, ["item", "index", "go-back"]))), 128)),
          (h(!0), b(me, null, Ee(f.value, (A) => (h(), b("li", {
            key: `nochildren-${A.name}`,
            class: "nochildren-links"
          }, [
            Q(Ke, {
              class: "nochildren-link",
              to: A.to
            }, {
              default: ce(() => [
                Ye(ae(A.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))), 128))
        ]),
        n.value && !t.title ? (h(), b("div", Qle, [
          k("ul", Jle, [
            (h(!0), b(me, null, Ee(d.value, (A) => (h(), b("li", {
              key: A.name,
              class: "list-item",
              onClick: w
            }, [
              Q(Ke, {
                class: "link underline-hover",
                to: A.to,
                "link-target": A.target
              }, {
                default: ce(() => [
                  Ye(ae(A.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "link-target"])
            ]))), 128))
          ])
        ])) : E("", !0),
        t.title ? E("", !0) : (h(), b("div", ece, [
          g.value.length ? (h(), Z(cn, {
            key: 0,
            label: g.value[0].name,
            "is-secondary": !0,
            class: "button",
            to: g.value[0].to,
            "icon-name": "none",
            onClick: w
          }, null, 8, ["label", "to"])) : E("", !0)
        ])),
        (h(), Z(ut(O(Ble)), {
          width: "150",
          height: "247",
          viewBox: "50 57 50 250",
          class: se(["molecule", r.value])
        }, null, 8, ["class"]))
      ], 512), [
        [ga, n.value]
      ])
    ], 2));
  }
}), nce = /* @__PURE__ */ be(tce, [["__scopeId", "data-v-2e252d5b"]]), ace = {
  width: "58",
  height: "20",
  viewBox: "0 0 58 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__logo-ucla"
};
function ice(t, e) {
  return h(), b("svg", ace, e[0] || (e[0] = [
    k("path", {
      d: "M0.257623 13.8849C0.205661 13.2382 0.192044 12.589 0.216843 11.9407L1.14233 1.4292H4.58441L3.64025 12.0326C3.43774 14.328 4.33765 15.964 6.62891 15.964C8.96994 15.964 10.2078 14.2997 10.4117 12.2634L11.3884 1.4292H14.8277L13.8773 12.128C13.493 16.2467 10.7601 19.3321 6.34346 19.3321C2.89793 19.3321 0.675786 17.1051 0.261078 13.8849",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M15.6201 10.3247C16.0687 5.27905 19.4734 1.09604 25.3533 1.09604C26.9559 1.07317 28.5289 1.52845 29.8715 2.40375L29.4769 6.57156C28.9702 5.87772 28.2959 5.32363 27.517 4.96102C26.7381 4.59841 25.88 4.43912 25.0229 4.49802C21.3638 4.49802 19.3552 7.0388 19.0698 10.2562C18.7933 13.3887 20.4093 15.935 23.9537 15.935C24.8777 15.9394 25.7922 15.7491 26.6378 15.3764C27.4833 15.0038 28.2408 14.4572 28.861 13.7723L28.4761 18.0527C27.0162 18.8941 25.3655 19.3483 23.6806 19.3722C17.8616 19.3722 15.1971 15.0496 15.6153 10.3247",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M32.6185 1.4292H36.0503L34.7971 15.7021H39.7149C40.0605 15.7021 41.2355 15.6841 41.5507 15.6654C41.5327 15.8375 41.2382 18.963 41.2382 18.963H31.062L32.6185 1.4292Z",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1),
    k("path", {
      d: "M50.4943 7.97586C50.6016 7.73895 50.6865 7.4925 50.7479 7.23975C50.7663 7.23841 50.7848 7.23841 50.8032 7.23975C50.8238 7.49051 50.8678 7.7388 50.9345 7.98139C51.1212 8.78108 52.4551 13.2198 52.4551 13.2198H48.1263C48.1263 13.2198 50.448 8.09198 50.4943 7.97862V7.97586ZM51.3748 0.62793H51.1371L41.7405 18.9635H45.3871L46.708 16.1795H53.3274L54.1568 18.9608H57.7952L51.3748 0.62793Z",
      fill: "#FFFFFF",
      class: "svg__fill--white"
    }, null, -1)
  ]));
}
const rce = { render: ice }, sce = {
  href: "https://www.ucla.edu",
  target: "_blank"
}, oce = {
  key: 0,
  class: "ucla-text"
}, lce = {
  key: 0,
  class: "button-container"
}, cce = /* @__PURE__ */ Ae({
  __name: "SiteBrandBar",
  setup(t) {
    const e = Ge(), n = I(() => ["site-brand-bar", (e == null ? void 0 : e.value) || ""]), a = I(() => (e == null ? void 0 : e.value) === "ftva" ? {
      useLogo: !1,
      headerText: "UCLA Film & Television Archive",
      buttonText: "Donate",
      buttonLink: "/donate"
    } : {});
    return (i, r) => {
      var s;
      return h(), b("div", {
        class: se(n.value)
      }, [
        k("a", sce, [
          !((s = a.value) != null && s.useLogo) && a.value.headerText ? (h(), b("span", oce, ae(a.value.headerText), 1)) : (h(), Z(O(rce), {
            key: 1,
            class: "svg ucla-logo"
          })),
          r[0] || (r[0] = k("span", { class: "visually-hidden" }, "UCLA Home", -1))
        ]),
        a.value.buttonLink && a.value.buttonText ? (h(), b("span", lce, [
          Q(cn, {
            label: a.value.buttonText,
            "icon-name": "none",
            to: a.value.buttonLink,
            class: "button"
          }, null, 8, ["label", "to"])
        ])) : E("", !0)
      ], 2);
    };
  }
}), uce = /* @__PURE__ */ be(cce, [["__scopeId", "data-v-328c8ad5"]]), dce = { class: "header-smart" }, hce = {
  __name: "HeaderSmart",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = to(), { header: n } = F4(e), a = J(n.value.primary || []), i = J(n.value.secondary || []), r = J(Am(Gb)), s = J(!1);
    return ht(() => {
      const { width: o } = Ei();
      at(
        o,
        (l) => {
          s.value = l <= 1200, r.value = Am(s.value ? nce : Gb);
        },
        { immediate: !0 }
      ), at(
        n,
        (l, c) => {
          a.value = l.primary, i.value = l.secondary;
        },
        { deep: !0 }
      );
    }), (o, l) => (h(), b("header", dce, [
      Q(O(uce), { class: "brand-bar" }),
      (h(), Z(ut(r.value), {
        class: se(s.value ? "mobile-header" : "desktop-header"),
        "primary-nav": a.value,
        "secondary-nav": i.value,
        title: t.title
      }, null, 8, ["class", "primary-nav", "secondary-nav", "title"]))
    ]));
  }
}, ahe = /* @__PURE__ */ be(hce, [["__scopeId", "data-v-918b4522"]]), fce = /* @__PURE__ */ Object.assign({
  inheritAttrs: !0
}, {
  __name: "SearchInput",
  props: {
    type: {
      type: String,
      default: "search"
    },
    modelValue: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: "search-input-wrapper"
    },
    clearIcon: {
      type: Boolean,
      default: !0
    },
    clearOnEsc: {
      type: Boolean,
      default: !0
    },
    blurOnEsc: {
      type: Boolean,
      default: !0
    },
    selectOnFocus: {
      type: Boolean,
      default: !0
    },
    shortcutKey: {
      type: String,
      default: "/"
    }
  },
  emits: ["update:modelValue", "clear"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = B4(), r = J(!1), s = J(null), o = J(n.modelValue);
    function l(w, C, M = !0) {
      const A = {};
      return C && C.length > 0 && Object.keys(w).forEach((L) => {
        (M ? !C.includes(L) : C.includes(L)) && (A[L] = w[L]);
      }), A;
    }
    const c = I(() => l(i, ["class", "style"])), d = I(() => {
      const w = l(i, ["class", "style"]);
      return w.class || (w.class = n.wrapperClass), w;
    }), f = I(() => n.clearIcon && o.value.length > 0);
    ht(() => {
      window.document.addEventListener("keydown", p);
    }), R4(() => {
      window.document.removeEventListener("keydown", p);
    });
    function g() {
      o.value = "", a("update:modelValue", ""), a("clear");
    }
    function _(w) {
      o.value = w.target.value, a("update:modelValue", w.target.value);
    }
    function x(w) {
      if (w.key === "Escape" && (n.clearOnEsc && g(), n.blurOnEsc)) {
        const C = s.value;
        C && C.blur();
      }
    }
    function p(w) {
      if (w.key === n.shortcutKey && w.target !== s.value && window.document.activeElement !== s.value && !(w.target instanceof HTMLInputElement) && !(w.target instanceof HTMLSelectElement) && !(w.target instanceof HTMLTextAreaElement)) {
        w.preventDefault();
        const C = [].slice.call(
          document.querySelectorAll(
            '[data-search-input="true"]:not([data-shortcut-enabled="false"])'
          )
        ).filter((A) => !!(A.offsetWidth || A.offsetHeight || A.getClientRects().length)), M = C.length > 1 ? C[0] : s.value;
        M && (M.focus(), n.selectOnFocus && M.select());
      }
    }
    return (w, C) => (h(), b("div", ln(Un(d.value)), [
      kt(k("input", $t({
        ref_key: "inputRef",
        ref: s,
        "onUpdate:modelValue": C[0] || (C[0] = (M) => o.value = M),
        type: "search",
        "data-search-input": "true"
      }, c.value, {
        onInput: _,
        onFocus: C[1] || (C[1] = (M) => r.value = !0),
        onBlur: C[2] || (C[2] = (M) => r.value = !1),
        onKeydown: x
      }), null, 16), [
        [Wo, o.value]
      ]),
      kt(k("button", {
        class: "clear-icon clear",
        "aria-label": "Clear",
        onMousedown: g,
        onKeydown: $r(g, ["space", "enter"])
      }, null, 544), [
        [ga, f.value]
      ])
    ], 16));
  }
}), Dp = /* @__PURE__ */ be(fce, [["__scopeId", "data-v-660feded"]]), pce = { class: "top-row" }, mce = { class: "bottom-row" }, gce = "Looking for something else? Search the Film & Television Archive Catalog at ", bce = /* @__PURE__ */ Ae({
  __name: "NavSearch",
  props: {
    placeholder: {
      type: String,
      default: "Enter keywords to search this website"
    }
  },
  setup(t) {
    const e = Ge(), n = Ru(), a = {
      label: "UC LIBRARY SEARCH >",
      to: "https://search.library.ucla.edu/discovery/search?vid=01UCS_LAL:UCLA&tab=Articles_books_more_slot&search_scope=ArticlesBooksMore&lang=en&query=any,contains,"
    }, i = I(() => ["nav-search", (e == null ? void 0 : e.value) || ""]), r = J("");
    function s() {
      n.push({
        path: "/search-site",
        query: { q: r.value }
      });
    }
    return (o, l) => (h(), b("div", {
      class: se(i.value)
    }, [
      k("span", pce, [
        Q(O(vx), { class: "icon" }),
        Q(Dp, {
          modelValue: r.value,
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.value = c),
          class: "search-input",
          placeholder: t.placeholder,
          onClear: s,
          onKeyup: $r(s, ["enter"])
        }, null, 8, ["modelValue", "placeholder"]),
        Q(cn, {
          label: "Search Site",
          "icon-name": "none",
          class: "button-link",
          onClick: s
        })
      ]),
      k("span", mce, [
        Ye(ae(gce) + " "),
        Q(Ke, {
          id: "search-link",
          to: a.to,
          class: "bottom-link"
        }, {
          default: ce(() => [
            Ye(ae(a.label), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 2));
  }
}), vce = /* @__PURE__ */ be(bce, [["__scopeId", "data-v-65517f85"]]), yce = /* @__PURE__ */ Ae({
  __name: "HeaderSticky",
  props: {
    primaryItems: {
      type: Array,
      default: () => []
    },
    secondaryItems: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["header-sticky", (e == null ? void 0 : e.value) || ""]), a = I(() => {
      switch (e == null ? void 0 : e.value) {
        case "ftva":
          return {
            showSearch: !0,
            showDonate: !0
          };
        default:
          return {
            showSearch: !1,
            showDonate: !1
          };
      }
    });
    return (i, r) => (h(), b("header", {
      class: se(n.value)
    }, [
      Q(_x, {
        items: t.primaryItems,
        class: "primary"
      }, rn({
        "additional-menu": ce(() => [
          a.value.showSearch ? (h(), Z(vce, { key: 0 })) : E("", !0)
        ]),
        _: 2
      }, [
        a.value.showDonate ? {
          name: "additional-mobile-menu-items",
          fn: ce(() => [
            Q(cn, {
              label: "DONATE",
              "icon-name": "none",
              to: "/donate",
              class: "donate-button"
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items"]),
      t.secondaryItems.length !== 0 ? (h(), Z(xx, {
        key: 0,
        items: t.secondaryItems,
        class: "secondary"
      }, null, 8, ["items"])) : E("", !0)
    ], 2));
  }
}), ihe = /* @__PURE__ */ be(yce, [["__scopeId", "data-v-8823424d"]]), _ce = { class: "rich-text" }, xce = ["innerHTML"], Tce = ["innerHTML"], wce = {
  key: 3,
  class: "image-block"
}, kce = ["innerHTML"], Sce = ["innerHTML"], Cce = ["innerHTML"], Ace = {
  key: 7,
  class: "image-block"
}, Ece = ["innerHTML"], Lce = ["innerHTML"], Dce = ["innerHTML"], Ice = ["innerHTML"], Mce = {
  key: 12,
  class: "image-block"
}, Oce = ["innerHTML"], Pce = ["innerHTML"], F0 = 60, Bce = /* @__PURE__ */ Ae({
  __name: "ImpactRichText",
  props: {
    images: {
      type: Array,
      default: () => []
    },
    pullQuote: {
      type: Array,
      default: () => []
    },
    textBlocks: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", _ce, [
      t.textBlocks[0] ? (h(), b("div", {
        key: 0,
        class: "text",
        innerHTML: t.textBlocks[0]
      }, null, 8, xce)) : E("", !0),
      t.pullQuote[0] ? (h(), Z(Vc, {
        key: 1,
        class: "pull-quote",
        text: t.pullQuote[0].text,
        attribution: t.pullQuote[0].attribution
      }, null, 8, ["text", "attribution"])) : E("", !0),
      t.textBlocks[1] ? (h(), b("div", {
        key: 2,
        class: "text",
        innerHTML: t.textBlocks[1]
      }, null, 8, Tce)) : E("", !0),
      t.images[0] ? (h(), b("div", wce, [
        t.images[0] ? (h(), Z(dn, {
          key: 0,
          class: "image",
          media: t.images[0],
          "aspect-ratio": F0
        }, null, 8, ["media"])) : E("", !0),
        t.images[0].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[0].caption
        }, null, 8, kce)) : E("", !0)
      ])) : E("", !0),
      t.textBlocks[2] ? (h(), b("div", {
        key: 4,
        class: "text",
        innerHTML: t.textBlocks[2]
      }, null, 8, Sce)) : E("", !0),
      t.pullQuote[1] ? (h(), Z(Vc, {
        key: 5,
        class: "pull-quote",
        text: t.pullQuote[1].text,
        attribution: t.pullQuote[1].attribution
      }, null, 8, ["text", "attribution"])) : E("", !0),
      t.textBlocks[3] ? (h(), b("div", {
        key: 6,
        class: "text",
        innerHTML: t.textBlocks[3]
      }, null, 8, Cce)) : E("", !0),
      t.images[1] ? (h(), b("div", Ace, [
        t.images[1] ? (h(), Z(dn, {
          key: 0,
          class: "image",
          media: t.images[1],
          "aspect-ratio": F0
        }, null, 8, ["media"])) : E("", !0),
        t.images[1].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[1].caption
        }, null, 8, Ece)) : E("", !0)
      ])) : E("", !0),
      t.textBlocks[4] ? (h(), b("div", {
        key: 8,
        class: "text",
        innerHTML: t.textBlocks[4]
      }, null, 8, Lce)) : E("", !0),
      t.textBlocks[5] ? (h(), b("div", {
        key: 9,
        class: "text",
        innerHTML: t.textBlocks[5]
      }, null, 8, Dce)) : E("", !0),
      t.pullQuote[2] ? (h(), Z(Vc, {
        key: 10,
        class: "pull-quote",
        text: t.pullQuote[2].text,
        attribution: t.pullQuote[2].attribution
      }, null, 8, ["text", "attribution"])) : E("", !0),
      t.textBlocks[6] ? (h(), b("div", {
        key: 11,
        class: "text",
        innerHTML: t.textBlocks[6]
      }, null, 8, Ice)) : E("", !0),
      t.images[2] ? (h(), b("div", Mce, [
        t.images[2] ? (h(), Z(dn, {
          key: 0,
          class: "image",
          media: t.images[2],
          "aspect-ratio": F0
        }, null, 8, ["media"])) : E("", !0),
        t.images[2].caption ? (h(), b("div", {
          key: 1,
          class: "caption",
          innerHTML: t.images[2].caption
        }, null, 8, Oce)) : E("", !0)
      ])) : E("", !0),
      t.textBlocks[7] ? (h(), b("div", {
        key: 13,
        class: "text",
        innerHTML: t.textBlocks[7]
      }, null, 8, Pce)) : E("", !0)
    ]));
  }
}), rhe = /* @__PURE__ */ be(Bce, [["__scopeId", "data-v-684a366f"]]), Rce = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-search"
};
function Tx(t, e) {
  return h(), b("svg", Rce, e[0] || (e[0] = [
    k("path", {
      d: "M20.9713 19.7959L20.441 19.2655L19.3802 20.3261L19.9105 20.8565L20.9713 19.7959ZM25.9486 26.8954L26.4789 27.4258L27.5397 26.3652L27.0094 25.8349L25.9486 26.8954ZM17.9233 22.9143C22.827 20.8303 25.1128 15.1656 23.0288 10.2619L21.6483 10.8486C23.4083 14.9899 21.4779 19.7738 17.3366 21.5338L17.9233 22.9143ZM23.0288 10.2619C20.9448 5.35815 15.2801 3.07234 10.3764 5.15637L10.9631 6.53687C15.1044 4.77687 19.8883 6.70728 21.6483 10.8486L23.0288 10.2619ZM10.3764 5.15637C5.47265 7.2404 3.18684 12.9051 5.27087 17.8088L6.65137 17.2221C4.89137 13.0808 6.82178 8.29688 10.9631 6.53687L10.3764 5.15637ZM5.27087 17.8088C7.3549 22.7125 13.0196 24.9983 17.9233 22.9143L17.3366 21.5338C13.1953 23.2938 8.41138 21.3634 6.65137 17.2221L5.27087 17.8088ZM19.9105 20.8565L25.9486 26.8954L27.0094 25.8349L20.9713 19.7959L19.9105 20.8565Z",
      fill: "#0B6AB7",
      class: "svg__fill--primary-blue-03"
    }, null, -1)
  ]));
}
const Ip = { render: Tx }, Nce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ip,
  render: Tx
}, Symbol.toStringTag, { value: "Module" })), $ce = { class: "search-home" }, Fce = {
  key: 0,
  class: "tabs"
}, zce = ["onClick", "textContent"], Uce = { class: "box" }, Hce = ["action"], Yce = { class: "input-container" }, jce = {
  key: 0,
  class: "links"
}, Vce = {
  key: 0,
  class: "regular-links"
}, qce = {
  key: 1,
  class: "advanced-links"
}, Wce = /* @__PURE__ */ Ae({
  __name: "SearchHome",
  props: {
    linkItems: {
      type: Array,
      default: () => []
    },
    advancedSearchLink: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = [
      {
        title: "Site Search",
        actionURL: "/search-site",
        queryParam: "q",
        placeholder: "Search the library website"
      },
      {
        title: "UC Library Search",
        actionURL: "https://search.library.ucla.edu/discovery/search?vid=01UCS_LAL:UCLA&tab=Articles_books_more_slot&search_scope=ArticlesBooksMore&lang=en&query=any,contains,",
        placeholder: "Search articles, books and more"
      }
    ], n = Ru(), a = J(null), i = J(""), r = J(1), s = I(() => e.map((x, p) => {
      let w = "tab";
      return p === r.value && (w = "tab is-active"), {
        ...x,
        classes: w
      };
    })), o = I(() => r.value === 0), l = I(() => e[r.value].actionURL), c = I(() => e[r.value].placeholder), d = I(() => e[r.value].queryParam), f = I(() => i.value.split(" ").join("+"));
    function g() {
      o.value ? n.push({
        path: l.value,
        query: { [d.value]: i.value }
      }) : window.location.href = `${l.value}${f.value}`;
    }
    function _(x) {
      r.value = x;
    }
    return (x, p) => (h(), b("div", $ce, [
      s.value.length ? (h(), b("div", Fce, [
        (h(!0), b(me, null, Ee(s.value, (w, C) => (h(), b("button", {
          key: w.title,
          ref_for: !0,
          ref_key: "searchtab",
          ref: a,
          class: se(w.classes),
          onClick: (M) => _(C),
          textContent: ae(w.title)
        }, null, 10, zce))), 128))
      ])) : E("", !0),
      k("div", Uce, [
        k("form", {
          name: "searchHome",
          action: l.value,
          onSubmit: p[1] || (p[1] = Ba(() => {
          }, ["prevent"]))
        }, [
          k("div", Yce, [
            Q(Dp, {
              "model-value": i.value,
              "onUpdate:modelValue": p[0] || (p[0] = (w) => i.value = w),
              class: "search-input",
              placeholder: c.value,
              onKeyup: $r(g, ["enter"])
            }, null, 8, ["model-value", "placeholder"]),
            k("button", {
              class: "button-submit",
              onClick: g
            }, [
              Q(O(Ip), { class: "icon" })
            ])
          ])
        ], 40, Hce),
        p[2] || (p[2] = k("div", { class: "divider" }, null, -1)),
        t.linkItems.length || t.advancedSearchLink ? (h(), b("nav", jce, [
          t.linkItems.length ? (h(), b("div", Vce, [
            (h(!0), b(me, null, Ee(t.linkItems, (w) => (h(), Z(Ke, {
              key: w.url,
              class: "link",
              to: w.url,
              textContent: ae(w.text)
            }, null, 8, ["to", "textContent"]))), 128))
          ])) : E("", !0),
          t.advancedSearchLink ? (h(), b("div", qce, [
            Q(Ke, {
              to: t.advancedSearchLink.url,
              textContent: ae(t.advancedSearchLink.text)
            }, null, 8, ["to", "textContent"])
          ])) : E("", !0)
        ])) : E("", !0)
      ])
    ]));
  }
}), Gce = /* @__PURE__ */ be(Wce, [["__scopeId", "data-v-5a386882"]]), Xce = { class: "masthead-primary" }, Zce = { class: "container" }, Kce = { class: "logo" }, Qce = /* @__PURE__ */ Ae({
  __name: "MastheadPrimary",
  props: {
    linkItems: {
      type: Array,
      default: () => []
    },
    advancedSearchLink: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = ge(
      () => import("./logo-ucla-library-underline-CA5hKDhK.js")
    );
    return (n, a) => (h(), b("div", Xce, [
      k("div", Zce, [
        k("div", Kce, [
          Q(O(e), { class: "svg" })
        ]),
        Q(Gce, {
          "link-items": t.linkItems,
          "advanced-search-link": t.advancedSearchLink
        }, null, 8, ["link-items", "advanced-search-link"])
      ])
    ]));
  }
}), she = /* @__PURE__ */ be(Qce, [["__scopeId", "data-v-b63430f9"]]);
var Jce = My, eue = nd, tue = xf, nue = ar, aue = wf, iue = Tf, rue = td, sue = Ly, oue = "[object Map]", lue = "[object Set]", cue = Object.prototype, uue = cue.hasOwnProperty;
function due(t) {
  if (t == null)
    return !0;
  if (aue(t) && (nue(t) || typeof t == "string" || typeof t.splice == "function" || iue(t) || sue(t) || tue(t)))
    return !t.length;
  var e = eue(t);
  if (e == oue || e == lue)
    return !t.size;
  if (rue(t))
    return !Jce(t).length;
  for (var n in t)
    if (uue.call(t, n))
      return !1;
  return !0;
}
var hue = due;
const fue = /* @__PURE__ */ xa(hue), pue = { class: "container" }, mue = { class: "meta" }, gue = ["innerHTML"], bue = /* @__PURE__ */ Ae({
  __name: "MastheadSecondary",
  props: {
    hasMolecules: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: ""
    },
    heroImage: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(t) {
    const e = t, n = J(null), a = I(() => n.value !== null), i = I(() => !fue(e.heroImage)), r = I(() => [
      "masthead-secondary",
      {
        "has-molecule": e.hasMolecules && !i.value
      },
      {
        "has-slot": a.value
      },
      {
        "theme-meap": e.theme.toLowerCase() === "meap"
      }
    ]);
    return (s, o) => (h(), b("div", {
      class: se(r.value)
    }, [
      i.value ? (h(), Z(dn, {
        key: 0,
        class: "hero-image",
        media: t.heroImage
      }, null, 8, ["media"])) : E("", !0),
      k("div", pue, [
        k("div", mue, [
          k("h1", {
            class: "title",
            innerHTML: t.title
          }, null, 8, gue),
          t.text ? (h(), Z(un, {
            key: 0,
            class: "text",
            "rich-text-content": t.text
          }, null, 8, ["rich-text-content"])) : E("", !0)
        ])
      ])
    ], 2));
  }
}), ohe = /* @__PURE__ */ be(bue, [["__scopeId", "data-v-80b8e2a7"]]), vue = ["textContent"], yue = ["textContent"], _ue = ["textContent"], xue = ["textContent"], Tue = {
  __name: "NavBreadcrumb",
  props: {
    to: {
      type: String,
      default: ""
    },
    parentTitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = $a(), n = J(!1), a = J(!1), i = J(!1), r = J(), s = J(!1);
    ht(() => {
      const { width: C } = Ei();
      at(C, (M) => {
        a.value = M <= 1200;
      }, { immediate: !0 });
    });
    const o = I(() => {
      let C = e.path;
      C.indexOf("/") === 0 && (C = C.slice(1)), C.lastIndexOf("/") === C.length - 1 && (C = C.slice(0, C.length - 1));
      const M = decodeURI(C);
      return x(M).split("/");
    }), l = I(() => {
      const C = o.value, M = C.length;
      if (M > 4 && g(), a.value)
        return c(C).slice(-2).splice(0, 1);
      if (!a.value && M > 4 && !n.value) {
        f();
        const A = C.toSpliced(
          1,
          M - 3,
          "..."
        );
        return c(A);
      }
      return c(C);
    });
    function c(C) {
      const M = [];
      return t.to && t.parentTitle && t.title ? (M.push({
        to: t.to,
        title: t.parentTitle,
        isLastItem: !1,
        isTruncatedGroup: !1
      }), M.push({
        to: "",
        title: t.title,
        isLastItem: !0,
        isTruncatedGroup: !1
      }), M) : (C.forEach((A, L) => {
        const D = A.length, B = e.path.indexOf(A), P = e.path.substring(0, D + B), z = A.replaceAll("-", " ");
        let W;
        L === C.length - 1 ? W = !0 : W = !1;
        let q;
        i.value && (n.value === !1 && L === 1 ? q = !0 : q = !1), M.push({
          to: P,
          title: z,
          isTruncatedGroup: q,
          isLastItem: W
        });
      }), M);
    }
    function d() {
      s.value = !0;
    }
    function f() {
      n.value = !1;
    }
    function g() {
      i.value = !0;
    }
    function _() {
      n.value = !n.value, r.value[0].classList.remove("collapsed-url");
    }
    function x(C) {
      const M = /([0-9][0-9])-([0-9][0-9])-([0-9][0-9])(?!.\w)/;
      return M.test(C) ? C.replace(M, "").trim() : C;
    }
    const p = Ge(), w = I(() => ["nav-breadcrumb", "subtitle", (p == null ? void 0 : p.value) || ""]);
    return (C, M) => (h(), b("div", {
      class: se(w.value)
    }, [
      (h(!0), b(me, null, Ee(l.value, (A) => (h(), b("span", {
        key: A.title,
        class: "breadcrumb-wrapper"
      }, [
        !A.isLastItem && !A.isTruncatedGroup ? (h(), Z(Ke, {
          key: 0,
          to: A.to,
          class: "parent-page-url",
          onClick: M[0] || (M[0] = (L) => d()),
          textContent: ae(A.title)
        }, null, 8, ["to", "textContent"])) : !A.isLastItem && A.isTruncatedGroup ? (h(), b("button", {
          key: 1,
          ref_for: !0,
          ref_key: "collapsedBreadcrumbsBtn",
          ref: r,
          class: "parent-page-url collapsed-url",
          tabindex: "0",
          onClick: M[1] || (M[1] = (L) => _()),
          textContent: ae(A.title)
        }, null, 8, vue)) : E("", !0),
        A.isLastItem ? E("", !0) : (h(), Z(O(Tl), {
          key: 2,
          "aria-hidden": "true"
        })),
        A.isLastItem && s.value ? (h(), b("span", {
          key: 3,
          class: "parent-page-url",
          textContent: ae(A.title)
        }, null, 8, yue)) : E("", !0),
        A.isLastItem && s.value ? (h(), Z(O(Tl), {
          key: 4,
          "aria-hidden": "true"
        })) : A.isLastItem && t.title ? (h(), b("span", {
          key: 5,
          class: "current-page-title",
          textContent: ae(t.title)
        }, null, 8, _ue)) : A.isLastItem ? (h(), b("span", {
          key: 6,
          class: "current-page-title",
          textContent: ae(A.title)
        }, null, 8, xue)) : E("", !0)
      ]))), 128))
    ], 2));
  }
}, lhe = /* @__PURE__ */ be(Tue, [["__scopeId", "data-v-c5336b55"]]), wue = { class: "page-anchor-content" }, kue = { class: "chevron" }, Sue = {
  key: 0,
  class: "dropdown-menu page-anchor-list"
}, Cue = ["href"], Aue = ["href"], Eue = /* @__PURE__ */ Ae({
  __name: "PageAnchor",
  props: {
    sectionTitles: {
      type: Array,
      required: !0
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = $a(), n = J(!1), a = J(window.innerWidth), i = I(() => t.color || ha(e == null ? void 0 : e.path)), r = I(() => ["link", `color-${i.value}`]), s = I(() => t.sectionTitles.map((f) => f.replace("&", "").replace(/\s+/g, " ").trim().toLowerCase().replace(/ /g, "-"))), o = I(() => a.value > 1024);
    function l() {
      n.value = !n.value;
    }
    const c = Ge(), d = I(() => ["page-anchor", (c == null ? void 0 : c.value) || ""]);
    return (f, g) => (h(), b("div", {
      class: se(d.value)
    }, [
      k("div", wue, [
        k("button", {
          class: "dropdown-button",
          onClick: l
        }, [
          g[0] || (g[0] = Ye(" On this page ")),
          k("span", {
            class: se(["caret", { "is-active": n.value }])
          }, [
            k("span", kue, [
              Q(O(Ld), { class: "caret-down-svg" })
            ])
          ], 2)
        ]),
        n.value && o.value ? (h(), b("ul", Sue, [
          (h(!0), b(me, null, Ee(t.sectionTitles, (_, x) => (h(), b("li", {
            key: `${_}-${x}`,
            class: se(r.value)
          }, [
            k("a", {
              href: `#${s.value[x]}`
            }, ae(_), 9, Cue)
          ], 2))), 128)),
          k("li", {
            class: se(r.value)
          }, g[1] || (g[1] = [
            k("a", { href: "#" }, "Back to Top", -1)
          ]), 2)
        ])) : E("", !0),
        n.value && !o.value ? (h(), b("ul", {
          key: 1,
          class: "dropdown-menu page-anchor-list",
          onClick: l
        }, [
          (h(!0), b(me, null, Ee(t.sectionTitles, (_, x) => (h(), b("li", {
            key: `${_}-${x}`,
            class: se(r.value)
          }, [
            k("a", {
              href: `#${s.value[x]}`
            }, ae(_), 9, Aue)
          ], 2))), 128)),
          k("li", {
            class: se(r.value)
          }, g[2] || (g[2] = [
            k("a", { href: "#" }, "Back to Top", -1)
          ]), 2)
        ])) : E("", !0)
      ])
    ], 2));
  }
}), che = /* @__PURE__ */ be(Eue, [["__scopeId", "data-v-74d033ab"]]), Lue = /* @__PURE__ */ Ae({
  __name: "ScrollWrapper",
  setup(t) {
    const e = Ge(), n = I(() => ["scroll-wrapper", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => {
      const r = ot("v-slide-group-item"), s = ot("v-slide-group"), o = ot("v-sheet");
      return h(), b("div", {
        class: se(n.value)
      }, [
        Q(o, { class: "mx-auto" }, {
          default: ce(() => [
            Q(s, { "show-arrows": !0 }, {
              default: ce(() => [
                Q(r, null, {
                  default: ce(() => [
                    xe(a.$slots, "default", {}, void 0, !0)
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ], 2);
    };
  }
}), Due = /* @__PURE__ */ be(Lue, [["__scopeId", "data-v-46d4bbbb"]]), Iue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Due
}, Symbol.toStringTag, { value: "Module" })), Mue = { class: "single-checkbox" }, Oue = {
  __name: "SingleCheckbox",
  props: {
    label: String,
    selected: Boolean
  },
  emits: ["update:selected", "input-selected"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J(n.selected);
    at(() => n.selected, (o) => {
      i.value = o;
    });
    const r = I(() => ["label", i.value ? "checked" : ""]);
    function s() {
      a("update:selected", i.value), a("input-selected");
    }
    return (o, l) => (h(), b("div", Mue, [
      k("label", {
        class: se(r.value)
      }, [
        Ye(ae(t.label) + " ", 1),
        kt(k("input", {
          "onUpdate:modelValue": l[0] || (l[0] = (c) => i.value = c),
          type: "checkbox",
          class: "input",
          onChange: s
        }, null, 544), [
          [Nh, i.value]
        ]),
        Q(O(_2), { class: "svg" })
      ], 2)
    ]));
  }
}, Pue = /* @__PURE__ */ be(Oue, [["__scopeId", "data-v-32fe410c"]]), Bue = { class: "search-generic-filter-buttons" }, Rue = ["onClick"], Nue = { class: "title" }, $ue = { class: "chevron" }, Fue = /* @__PURE__ */ Ae({
  __name: "SearchGenericFilterButtons",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    singleCheckboxState: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggle", "update:single-checkbox-state", "single-checkbox-checked"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J(n.singleCheckboxState);
    at(() => n.singleCheckboxState, (f) => {
      i.value = f;
    });
    const r = I(() => {
      const f = n.items.find((g) => g.inputType === "single-checkbox");
      return f ? f.label : "";
    }), s = I(() => {
      const f = n.items.find((g) => g.inputType === "single-checkbox");
      return f ? f.esFieldName : "";
    }), o = I(() => {
      var f;
      return (f = n.items) == null ? void 0 : f.some((g) => g.inputType === "single-checkbox");
    });
    function l() {
      a("update:single-checkbox-state", i.value), a("single-checkbox-checked", s.value);
    }
    const c = I(() => n.items.map((f) => {
      if (f.inputType !== "single-checkbox") {
        const g = `button${f.isVisible ? " is-active" : ""}`;
        return {
          ...f,
          class: g
        };
      } else
        return null;
    }).filter((f) => f != null));
    function d(f) {
      a("toggle", f);
    }
    return (f, g) => (h(), b("div", Bue, [
      (h(!0), b(me, null, Ee(c.value, (_, x) => (h(), b("button", {
        key: _ == null ? void 0 : _.label,
        class: se(_ == null ? void 0 : _.class),
        type: "button",
        onClick: Ba((p) => d(x), ["prevent"])
      }, [
        k("span", Nue, ae(_ == null ? void 0 : _.label), 1),
        k("div", $ue, [
          Q(O(Ld), { class: "caret-down-svg" })
        ])
      ], 10, Rue))), 128)),
      o.value ? (h(), Z(Pue, {
        key: 0,
        selected: i.value,
        "onUpdate:selected": g[0] || (g[0] = (_) => i.value = _),
        label: r.value,
        onInputSelected: l
      }, null, 8, ["selected", "label"])) : E("", !0)
    ]));
  }
}), zue = /* @__PURE__ */ be(Fue, [["__scopeId", "data-v-98a6c18b"]]), Uue = { class: "section-remove-search-filter" }, Hue = /* @__PURE__ */ Ae({
  __name: "SectionRemoveSearchFilter",
  props: {
    filters: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["update:filters", "remove-selected"],
  setup(t, { emit: e }) {
    const n = e, a = Ge(), i = J({});
    at(() => t.filters, (l) => {
      Object.entries(l).forEach(([c, d]) => {
        i.value[c] = d;
      });
    }, { deep: !0, immediate: !0 });
    const r = I(() => Object.entries(i.value).flatMap(([c, d]) => (Array.isArray(d) ? d : []).map((g) => ({ name: c, value: g }))));
    function s(l) {
      return l === "subjectLibrarian.keyword" ? "Subject Librarian" : "Past Events";
    }
    function o(l, c) {
      i.value[l] = i.value[l].filter((d) => d !== c), n("update:filters", i.value), n("remove-selected");
    }
    return (l, c) => kt((h(), b("div", Uue, [
      (h(!0), b(me, null, Ee(r.value, (d) => (h(), b("div", {
        key: `filter-${d.value}`
      }, [
        Q(XI, {
          "is-selected": O(a) === "ftva",
          title: d.value === "yes" ? s(d.name) : d.value,
          onRemoveBlockFilter: (f) => o(
            d.name,
            d.value
          )
        }, null, 8, ["is-selected", "title", "onRemoveBlockFilter"])
      ]))), 128))
    ], 512)), [
      [ga, i.value]
    ]);
  }
}), Yue = /* @__PURE__ */ be(Hue, [["__scopeId", "data-v-ddf9d852"]]), jue = {
  key: 0,
  class: "container"
}, Vue = /* @__PURE__ */ Ae({
  __name: "SearchGenericFilters",
  props: {
    filters: {
      type: Array,
      // array of objects that contain the filter objects
      default: () => []
    },
    queryFilters: {
      type: Object,
      // objects that contain the selected query filter from url [{name, value}]
      default: () => {
      }
    }
  },
  emits: ["update:queryFilters", "filters-selection-action"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J({});
    function r(x, p) {
      console.log("Search Generic Filters updateSelected: ", x, JSON.stringify(p)), i.value[x] = p;
    }
    const s = J(n.filters.some((x) => {
      var p;
      return x.inputType === "single-checkbox" && ((p = n.queryFilters[x.esFieldName]) == null ? void 0 : p.includes("yes"));
    })), o = J(-1);
    at(() => n.queryFilters, (x) => {
      console.log("In watch function props.queryFilters updated", JSON.stringify(x), JSON.stringify(n.filters)), Object.entries(x).forEach(([p, w]) => {
        i.value[p] = w;
      }), console.log("queryFilterButtonDropDownStates.value", JSON.stringify(i.value)), console.log("In watch function props.queryFilters checkedState.value", s.value, JSON.stringify(n.filters));
    }, { deep: !0, immediate: !0 }), at(() => n.filters, (x) => {
      console.log("In watch function props.filters updated", JSON.stringify(n.filters), JSON.stringify(x)), console.log("In watch funciton props.filters heello query filters props.queryFilters", n.queryFilters), console.log("In watch fucntion props.filters queryFilterButtonDropDownStates", i.value), s.value = x == null ? void 0 : x.some((p) => {
        var w;
        return p.inputType === "single-checkbox" && ((w = i.value[p.esFieldName]) == null ? void 0 : w.includes("yes"));
      });
    }, { deep: !0, immediate: !0 });
    const l = I(() => n.filters.map((x, p) => {
      let w = Fm;
      switch (x.inputType) {
        case "radio":
          w = QC;
          break;
        case "checkbox":
          w = Fm;
          break;
      }
      return {
        ...x,
        componentName: w,
        isVisible: p === o.value
      };
    }));
    function c(x) {
      o.value = o.value === x ? -1 : x;
    }
    function d(x) {
      console.log("emit event to parent if checkbox is selected"), i.value[x] = s.value ? ["yes"] : [], a("update:queryFilters", i.value), a("filters-selection-action");
    }
    function f(x) {
      i.value = { ...x }, console.log("Updated Filters:", i.value);
    }
    function g() {
      console.log("doSearch function called to emit update:queryFilters and filters-selection-action events to the parent component", i.value), a("update:queryFilters", i.value), a("filters-selection-action");
    }
    at(i, () => {
      console.log("Update checked state"), s.value = n.filters.some((x) => {
        var p;
        return x.inputType === "single-checkbox" && ((p = i.value[x.esFieldName]) == null ? void 0 : p.includes("yes"));
      });
    });
    const _ = J(null);
    return BB(
      _,
      () => {
        o.value = -1;
      }
    ), (x, p) => (h(), b("div", {
      ref_key: "clickOutsideTarget",
      ref: _,
      class: "search-generic-filters"
    }, [
      t.filters.length > 0 ? (h(), b("div", jue, [
        Q(zue, {
          "single-checkbox-state": s.value,
          "onUpdate:singleCheckboxState": p[0] || (p[0] = (w) => s.value = w),
          items: l.value,
          class: "search-generic-filter-buttons",
          onToggle: c,
          onSingleCheckboxChecked: d
        }, null, 8, ["single-checkbox-state", "items"])
      ])) : E("", !0),
      (h(!0), b(me, null, Ee(l.value, (w) => (h(), b("div", {
        key: w.esFieldName
      }, [
        Q(Fr, {
          name: "slide-toggle",
          mode: "out-in"
        }, {
          default: ce(() => [
            w.isVisible ? (h(), Z(ut(w.componentName), {
              key: 0,
              selected: i.value[w.esFieldName],
              "onUpdate:selected": [(C) => i.value[w.esFieldName] = C, (C) => r(w.esFieldName, C)],
              items: w.items,
              class: "filter-group",
              onInputSelected: g
            }, null, 40, ["selected", "onUpdate:selected", "items"])) : E("", !0)
          ]),
          _: 2
        }, 1024)
      ]))), 128)),
      Q(Yue, {
        filters: i.value,
        class: "section-remove-container",
        "onUpdate:filters": f,
        onRemoveSelected: g
      }, null, 8, ["filters"])
    ], 512));
  }
}), que = /* @__PURE__ */ be(Vue, [["__scopeId", "data-v-4e79b9df"]]), Wue = { class: "search-generic" }, Gue = { class: "input-container" }, Xue = /* @__PURE__ */ Ae({
  __name: "SearchGeneric",
  props: {
    filters: {
      type: Array,
      // array of objects that contain the filter objects
      default: () => []
    },
    /* searchType: {
      type: String,
      default: '',
    }, */
    /* views: {
        type: Array,
        default: () => [],
    }, */
    searchGenericQuery: {
      type: Object,
      default: () => {
      }
    },
    placeholder: {
      type: String,
      default: ""
    }
    /* queryView: {
        type: String,
        default: "list",
    }, */
  },
  emits: ["search-ready"],
  setup(t, { emit: e }) {
    const n = e, a = J(t.searchGenericQuery ? t.searchGenericQuery.queryText : ""), i = J(t.searchGenericQuery ? t.searchGenericQuery.queryFilters : {});
    at(() => t.searchGenericQuery, (o) => {
      i.value = o.queryFilters, a.value = o.queryText;
    }, { deep: !0, immediate: !0 });
    function r(o) {
      console.log("In updateQueryFilters", o), i.value = o;
    }
    function s() {
      console.log("dosearch called"), console.log(
        `selected filters in component are: ${JSON.stringify(i.value)}`
      ), console.log(
        `search text in component are: ${JSON.stringify(a.value)}`
      ), n("search-ready", {
        filters: i.value,
        text: a.value
      });
    }
    return (o, l) => (h(), b("div", Wue, [
      k("form", {
        name: "searchHome",
        onSubmit: l[1] || (l[1] = Ba(() => {
        }, ["prevent"]))
      }, [
        k("div", Gue, [
          Q(Dp, {
            modelValue: a.value,
            "onUpdate:modelValue": l[0] || (l[0] = (c) => a.value = c),
            class: "search-input",
            placeholder: t.placeholder,
            onClear: s,
            onKeyup: $r(s, ["enter"])
          }, null, 8, ["modelValue", "placeholder"]),
          k("button", {
            class: "button-submit",
            type: "submit",
            onClick: s
          }, [
            Q(O(Ip), { class: "icon" })
          ])
        ])
      ], 32),
      l[2] || (l[2] = k("div", { class: "search-generic-filters-container" }, null, -1)),
      Q(que, {
        filters: t.filters,
        "query-filters": i.value,
        "onUpdate:queryFilters": r,
        onFiltersSelectionAction: s
      }, null, 8, ["filters", "query-filters"])
    ]));
  }
}), uhe = /* @__PURE__ */ be(Xue, [["__scopeId", "data-v-9688b6c6"]]), Zue = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-calendar"
};
function wx(t, e) {
  return h(), b("svg", Zue, e[0] || (e[0] = [
    k("path", {
      d: "M26.9902 25.9316C26.9902 26.2589 26.7248 26.5243 26.3975 26.5243C19.4626 26.5243 12.5277 26.5243 5.59274 26.5243C5.26538 26.5243 5 26.2589 5 25.9316V12.9113V8.26828C5 7.94092 5.26538 7.67554 5.59274 7.67554H26.3975C26.7248 7.67554 26.9902 7.94092 26.9902 8.26828V12.9113V25.9316Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M11.8063 10.283L11.8063 4.00004",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M20.1835 10.283L20.1835 4.00004",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M7.8147 13.9585H15.9953H24.1759",
      stroke: "#0AA5FF",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--default-cyan-03"
    }, null, -1)
  ]));
}
const kx = { render: wx }, Mp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kx,
  render: wx
}, Symbol.toStringTag, { value: "Module" })), Kue = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-card"
};
function Sx(t, e) {
  return h(), b("svg", Kue, e[0] || (e[0] = [
    ri('<rect x="7.22302" y="7" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="17.9305" y="7" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="7.22302" y="17.6917" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><rect x="17.9305" y="17.6917" width="7.0895" height="7.0737" rx="0.389099" stroke="#0B6AB7" stroke-width="1.5" class="svg__stroke--primary-blue-03"></rect><path d="M28 19.7427L28 24.7652" stroke="#0AA5FF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--default-cyan-03"></path><path d="M4 7L4 12.0225" stroke="#0AA5FF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--default-cyan-03"></path>', 6)
  ]));
}
const Cx = { render: Sx }, Que = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cx,
  render: Sx
}, Symbol.toStringTag, { value: "Module" })), Jue = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-list"
};
function Ax(t, e) {
  return h(), b("svg", Jue, e[0] || (e[0] = [
    ri('<rect x="6" y="8" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25" class="svg__stroke--default-cyan-03"></rect><path d="M12.4575 9.49634H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path><rect x="6" y="14.4509" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25"></rect><path d="M12.4575 15.9473H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path><rect x="6" y="20.9016" width="2.99937" height="2.99269" rx="0.371905" stroke="#0AA5FF" stroke-width="1.25" class="svg__stroke--default-cyan-03"></rect><path d="M12.4575 22.3979H26.2901" stroke="#0B6AB7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="svg__stroke--primary-blue-03"></path>', 6)
  ]));
}
const Ex = { render: Ax }, Lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ex,
  render: Ax
}, Symbol.toStringTag, { value: "Module" })), ede = { class: "view-btn" }, tde = { class: "selected" }, nde = { key: 0 }, ade = { class: "chevron" }, ide = { class: "view-list" }, rde = ["onClick"], sde = ["innerHTML"], ode = {
  __name: "SearchGenericViewModes",
  props: {
    isOpened: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: ""
    }
  },
  emits: ["update:isOpened", "update:selected", "view-changed"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = J(n.isOpened), r = I(() => ["search-generic-view-modes", { "is-opened": i.value }]), s = I(() => n.items.find((g) => g.slug === n.selected) || {}), o = I(() => n.items.map((g) => {
      let _ = "list-item";
      return g.slug === n.selected && (_ += " is-active"), { ...g, classes: _ };
    })), l = /* @__PURE__ */ new Map([
      ["icon-calendar", kx],
      ["icon-list", Ex],
      ["icon-card", Cx]
    ]);
    function c(g) {
      return l.get(g);
    }
    function d() {
      i.value = !i.value, a("update:isOpened", i.value);
    }
    function f(g) {
      a("update:selected", g), a("view-changed", g);
    }
    return (g, _) => (h(), b("div", {
      class: se(r.value),
      onClick: d
    }, [
      k("button", ede, [
        k("div", tde, [
          t.selected ? E("", !0) : (h(), b("span", nde, "View")),
          (h(), Z(ut(c(s.value.iconName)), { class: "svg" }))
        ]),
        k("div", ade, [
          Q(O(Ld), { class: "svg" })
        ])
      ]),
      k("ul", ide, [
        (h(!0), b(me, null, Ee(o.value, (x) => (h(), b("li", {
          key: x.slug,
          class: se(x.classes),
          onClick: Ba((p) => f(x.slug), ["stop"])
        }, [
          (h(), Z(ut(c(x.iconName)), { class: "svg" })),
          k("div", {
            innerHTML: x.title
          }, null, 8, sde)
        ], 10, rde))), 128))
      ])
    ], 2));
  }
}, dhe = /* @__PURE__ */ be(ode, [["__scopeId", "data-v-cf30205d"]]), lde = { class: "search-result-item" }, cde = ["textContent"], ude = {
  key: 0,
  class: "summary"
}, dde = {
  __name: "SearchResult",
  props: {
    to: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    summary: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = I(() => t.summary ? Ki(t.summary, 250) : "");
    return (n, a) => (h(), b("li", lde, [
      xe(n.$slots, "top", {}, () => [
        k("div", {
          class: "category",
          textContent: ae(t.category)
        }, null, 8, cde),
        Q(Ke, {
          class: "title",
          to: t.to,
          innerHTML: t.title
        }, null, 8, ["to", "innerHTML"])
      ], !0),
      n.$slots.mid ? xe(n.$slots, "mid", { key: 0 }, void 0, !0) : E("", !0),
      xe(n.$slots, "bottom", {}, () => [
        t.summary ? (h(), b("div", ude, ae(e.value), 1)) : E("", !0)
      ], !0)
    ]));
  }
}, hhe = /* @__PURE__ */ be(dde, [["__scopeId", "data-v-a274858c"]]), hde = { class: "section-dual-masonry" }, fde = { class: "masonry" }, pde = /* @__PURE__ */ Ae({
  __name: "SectionDualMasonry",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: "See More"
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", hde, [
      k("div", fde, [
        (h(!0), b(me, null, Ee(t.items, (a) => (h(), Z(HD, {
          key: a.to,
          title: a.title,
          category: a.category,
          "start-date": a.startDate,
          "end-date": a.endDate,
          prompt: a.prompt,
          to: a.to,
          "section-handle": a.sectionHandle,
          class: "brick"
        }, null, 8, ["title", "category", "start-date", "end-date", "prompt", "to", "section-handle"]))), 128)),
        (h(!0), b(me, null, Ee(t.items, (a) => (h(), Z(Ke, {
          key: `image-${a.to}`,
          to: a.to,
          class: "brick brick-image"
        }, {
          default: ce(() => [
            Q(dn, {
              media: a.image,
              "aspect-ratio": 100
            }, null, 8, ["media"])
          ]),
          _: 2
        }, 1032, ["to"]))), 128))
      ]),
      Q(Ke, {
        class: "more",
        to: t.to
      }, {
        default: ce(() => [
          Q(tf, { text: t.text }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["to"])
    ]));
  }
}), fhe = /* @__PURE__ */ be(pde, [["__scopeId", "data-v-5544244d"]]), mde = { class: "section-block-generic-list" }, gde = { class: "block-generic-list" }, bde = /* @__PURE__ */ Ae({
  __name: "SectionGenericList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", mde, [
      k("ul", gde, [
        (h(!0), b(me, null, Ee(t.items, (a, i) => (h(), Z(aI, {
          key: `${a.title}-${i}`,
          "section-title": "Academic Librarian Jobs",
          title: a.title,
          "alternative-full-name": a.alternativeFullName,
          language: a.language,
          text: a.summary,
          "job-requisition-number": a.jobRequisitionNumber,
          "job-posting-u-r-l": a.jobPostingURL,
          departments: a.department,
          "pay-rate": a.payRate,
          "associated-locations": a.associatedLocations
        }, null, 8, ["title", "alternative-full-name", "language", "text", "job-requisition-number", "job-posting-u-r-l", "departments", "pay-rate", "associated-locations"]))), 128))
      ])
    ]));
  }
}), phe = /* @__PURE__ */ be(bde, [["__scopeId", "data-v-b0a0dcc0"]]), vde = { class: "section-location-list" }, yde = /* @__PURE__ */ Ae({
  __name: "SectionLocationList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("ul", vde, [
      (h(!0), b(me, null, Ee(t.items, (a) => (h(), Z(kI, {
        key: a.to,
        image: a.image,
        "location-type": a.locationType,
        title: a.title,
        to: a.to,
        "affiliate-library-url": a.affiliateLibraryUrl,
        address: a.address,
        "address-link": a.addressLink,
        amenities: a.amenities,
        "reserve-seat": a.reserveSeat,
        "is-ucla-library": a.isUclaLibrary,
        "libcal-location-id-for-hours": a.libcalLocationIdForHours,
        class: "block-location-list-item"
      }, null, 8, ["image", "location-type", "title", "to", "affiliate-library-url", "address", "address-link", "amenities", "reserve-seat", "is-ucla-library", "libcal-location-id-for-hours"]))), 128))
    ]));
  }
}), mhe = /* @__PURE__ */ be(yde, [["__scopeId", "data-v-bacb8491"]]), _de = {
  key: 2,
  class: "pagination-numbers-container"
}, xde = { class: "pagination-numbers" }, Tde = {
  key: 0,
  class: "page-list-first"
}, wde = {
  key: 1,
  class: "page-list-truncate"
}, kde = {
  key: 2,
  class: "page-list-truncate"
}, Sde = {
  key: 3,
  class: "page-list-right"
}, Cde = /* @__PURE__ */ Ae({
  __name: "SectionPagination",
  props: {
    nextTo: {
      type: String,
      required: !1
    },
    previousTo: {
      type: String,
      required: !1
    },
    pages: {
      type: Number,
      required: !1
    },
    initialCurrentPage: {
      type: Number,
      required: !1
    },
    // callback function to generate link for each page
    // if not provided, will generate a link based on FTVA Elastic Search pattern
    generateLinkCallback: {
      type: Function,
      required: !1
    }
  },
  emits: ["changePage"],
  setup(t, { emit: e }) {
    const n = e, a = $a(), i = I(() => ({ ...a.query })), r = Ge(), s = J(10), o = J([33]), l = J(1), c = J(null);
    function d(A) {
      t.initialCurrentPage && t.pages && l.value !== A && (l.value = A, g(), n("changePage", A));
    }
    function f(A) {
      let L = new URLSearchParams({ ...i.value });
      return t.generateLinkCallback ? L ? t.generateLinkCallback(A, L) : t.generateLinkCallback(A) : (L = new URLSearchParams({ ...i.value, page: A.toString() }), `${a.path}?${L.toString()}`);
    }
    function g() {
      if (t.pages && s) {
        let A = 1, L = Math.min(s.value, t.pages);
        if (l.value > s.value) {
          let D = s.value - 4;
          A = Math.max(1, l.value - Math.floor(D / 2)), L = A + D, L > t.pages && (D = D + 1, l.value === t.pages && (D = D + 1), L = t.pages, A = Math.max(1, L - D));
        }
        l.value === 1 && (L = Math.min(L + 2, t.pages)), o.value = [];
        for (let D = A; D <= L; D++)
          o.value.push(D);
      }
    }
    function _(A) {
      if (!t.initialCurrentPage || !t.pages)
        return 10;
      const L = document.getElementsByClassName("pButton")[0], D = Math.ceil(L.getBoundingClientRect().width), B = getComputedStyle(L).marginRight, P = Math.ceil(D + Number.parseInt(B) * 2 + 1), z = Math.ceil(document.getElementsByClassName("previous")[0].getBoundingClientRect().width + 10), W = Math.ceil(document.getElementsByClassName("next")[0].getBoundingClientRect().width + 10);
      return Math.max(0, Math.floor(+((A - (z + W + P * 2)) / P).toFixed(2)));
    }
    const x = I(() => ["section-pagination", (r == null ? void 0 : r.value) || "", t.previousTo === "" ? "first-page" : "", t.nextTo === "" ? "last-page" : ""]), p = I(() => l.value - 1), w = I(() => l.value + 1), C = I(() => t.initialCurrentPage && t.pages && (l == null ? void 0 : l.value) !== 1), M = I(() => t.initialCurrentPage && t.pages && (l == null ? void 0 : l.value) !== t.pages);
    return at(() => t.pages, () => {
      g();
    }, { immediate: !0 }), at(() => t.initialCurrentPage, (A) => {
      l.value = A;
    }, { immediate: !0 }), ht(() => {
      if (!t.initialCurrentPage || !t.pages)
        return;
      l.value = t.initialCurrentPage;
      const { width: A } = Ei();
      Dn(() => {
        at([A], () => {
          const L = c.value.clientWidth;
          s.value = _(L), g();
        }, { immediate: !0 });
      });
    }), (A, L) => (h(), b("div", {
      ref_key: "pageButtons",
      ref: c,
      class: se(x.value),
      role: "navigation",
      "aria-label": "page list navigation"
    }, [
      t.previousTo ? (h(), Z(Ke, {
        key: 0,
        to: t.previousTo,
        class: "previous"
      }, {
        default: ce(() => [
          Q(O(bi), { class: "previous-svg" }),
          L[4] || (L[4] = k("div", { class: "underline-hover" }, " Previous ", -1))
        ]),
        _: 1
      }, 8, ["to"])) : C.value ? (h(), Z(Ke, {
        key: 1,
        class: "previous",
        to: f(p.value),
        onClick: L[0] || (L[0] = (D) => d(p.value))
      }, {
        default: ce(() => [
          Q(O(bi), { class: "previous-svg" }),
          L[5] || (L[5] = k("div", { class: "underline-hover" }, " Previous ", -1))
        ]),
        _: 1
      }, 8, ["to"])) : E("", !0),
      t.initialCurrentPage && t.pages ? (h(), b("div", _de, [
        k("div", xde, [
          l.value > s.value ? (h(), b("span", Tde, [
            Q(Ke, {
              class: se(`pButton${l.value === 1 ? " pButton-selected" : ""}`),
              active: l.value === 1,
              to: f(1),
              onClick: L[1] || (L[1] = (D) => d(1))
            }, {
              default: ce(() => L[6] || (L[6] = [
                Ye(ae(1))
              ])),
              _: 1
            }, 8, ["class", "active", "to"])
          ])) : E("", !0),
          l.value > s.value ? (h(), b("span", wde, "...")) : E("", !0),
          (h(!0), b(me, null, Ee(o.value, (D) => (h(), Z(Ke, {
            key: D,
            class: se(`pButton${D === l.value ? " pButton-selected" : ""}`),
            active: l.value === D,
            to: f(D),
            onClick: (B) => d(D)
          }, {
            default: ce(() => [
              Ye(ae(D), 1)
            ]),
            _: 2
          }, 1032, ["class", "active", "to", "onClick"]))), 128)),
          o.value.length < t.pages && o.value.indexOf(t.pages) === -1 ? (h(), b("span", kde, "...")) : E("", !0),
          o.value.length < t.pages && o.value.indexOf(t.pages) === -1 ? (h(), b("span", Sde, [
            Q(Ke, {
              class: se(`pButton${t.pages === l.value ? " pButton-selected" : ""}`),
              active: l.value === t.pages,
              to: f(t.pages),
              onClick: L[2] || (L[2] = (D) => d(t.pages))
            }, {
              default: ce(() => [
                Ye(ae(t.pages), 1)
              ]),
              _: 1
            }, 8, ["class", "active", "to"])
          ])) : E("", !0)
        ])
      ])) : E("", !0),
      t.nextTo ? (h(), Z(Ke, {
        key: 3,
        to: t.nextTo,
        class: "next"
      }, {
        default: ce(() => [
          L[7] || (L[7] = k("div", { class: "underline-hover" }, " Next ", -1)),
          Q(O(bi), { class: "next-svg" })
        ]),
        _: 1
      }, 8, ["to"])) : M.value ? (h(), Z(Ke, {
        key: 4,
        class: "next",
        to: f(w.value),
        onClick: L[3] || (L[3] = (D) => d(w.value))
      }, {
        default: ce(() => [
          L[8] || (L[8] = k("div", { class: "underline-hover" }, " Next ", -1)),
          Q(O(bi), { class: "next-svg" })
        ]),
        _: 1
      }, 8, ["to"])) : E("", !0)
    ], 2));
  }
}), ghe = /* @__PURE__ */ be(Cde, [["__scopeId", "data-v-25b89ebe"]]), Ade = { class: "section-post-small" }, Ede = { class: "grid" }, Lde = /* @__PURE__ */ Ae({
  __name: "SectionPostSmall",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    to: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, n) => {
      const a = ot("smart-link");
      return h(), b("section", Ade, [
        k("div", Ede, [
          (h(!0), b(me, null, Ee(t.items, (i) => (h(), Z(WI, {
            key: `block-post-${i.title}`,
            "category-name": i.categoryName,
            author: i.author,
            title: i.title,
            image: i.image,
            to: i.to,
            class: "block"
          }, null, 8, ["category-name", "author", "title", "image", "to"]))), 128))
        ]),
        t.to ? (h(), Z(a, {
          key: 0,
          class: "more",
          to: t.to
        }, {
          default: ce(() => [
            Q(tf)
          ]),
          _: 1
        }, 8, ["to"])) : E("", !0)
      ]);
    };
  }
}), bhe = /* @__PURE__ */ be(Lde, [["__scopeId", "data-v-c12346c8"]]), Dde = { class: "container" }, Ide = ["innerHTML"], Mde = { class: "block-staff-article-list" }, Ode = /* @__PURE__ */ Ae({
  __name: "SectionStaffArticleList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["section-staff-article-list", (e == null ? void 0 : e.value) || ""]);
    return (a, i) => (h(), b("section", {
      class: se(n.value)
    }, [
      k("div", Dde, [
        t.sectionTitle ? (h(), b("div", {
          key: 0,
          class: "section-title",
          innerHTML: t.sectionTitle
        }, null, 8, Ide)) : E("", !0),
        k("ul", Mde, [
          (h(!0), b(me, null, Ee(t.items, (r, s) => (h(), Z(kO, {
            key: s,
            class: "block-staff-article-item",
            image: r.image,
            to: r.to,
            category: r.category,
            title: r.title,
            date: r.date,
            authors: r.authors,
            description: r.description,
            "external-resource-url": r.externalResourceUrl,
            "start-date": r.startDate,
            "end-date": r.endDate,
            ongoing: r.ongoing
          }, null, 8, ["image", "to", "category", "title", "date", "authors", "description", "external-resource-url", "start-date", "end-date", "ongoing"]))), 128))
        ])
      ])
    ], 2));
  }
}), vhe = /* @__PURE__ */ be(Ode, [["__scopeId", "data-v-f9202ebc"]]), Pde = {
  name: "SectionStaffOrcidPublications",
  components: {
    RichText: un,
    SmartLink: Ke
  },
  props: {
    orcid: {
      type: String,
      default: ""
    },
    publications: {
      type: String,
      default: ""
    }
  }
}, Bde = {
  key: 0,
  class: "section-staff-orcid-publications"
}, Rde = {
  key: 0,
  class: "orcid-key"
};
function Nde(t, e, n, a, i, r) {
  const s = ot("SmartLink"), o = ot("RichText");
  return n.orcid || n.publications ? (h(), b("section", Bde, [
    e[1] || (e[1] = k("h2", { class: "secondary-header" }, " Publications ", -1)),
    n.orcid ? (h(), b("div", Rde, [
      e[0] || (e[0] = Ye(" ORCID: ")),
      Q(s, {
        to: n.orcid,
        class: "orcid-value"
      }, {
        default: ce(() => [
          Ye(ae(n.orcid), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])) : E("", !0),
    n.publications ? (h(), Z(o, {
      key: 1,
      class: "publications",
      "rich-text-content": n.publications
    }, null, 8, ["rich-text-content"])) : E("", !0)
  ])) : E("", !0);
}
const yhe = /* @__PURE__ */ be(Pde, [["render", Nde], ["__scopeId", "data-v-5e4d5449"]]), $de = { class: "section-screening-details" }, _he = /* @__PURE__ */ Ae({
  __name: "SectionScreeningDetails",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("section", $de, [
      (h(!0), b(me, null, Ee(t.items, (a, i) => (h(), b("div", {
        key: `block-screening-detail-${a.title}`
      }, [
        (h(), Z(xM, {
          key: `block-screening-detail-${a.title}`,
          count: t.items.length,
          "screening-count": `Screening ${i + 1} of ${t.items.length}`,
          title: a.title,
          "alternate-title": a.alternateTitle,
          language: a.language,
          year: a.year,
          country: a.country,
          "language-info": a.languageInfo,
          runtime: a.runtime,
          "tag-labels": a.tagLabels,
          text: a.text,
          trailer: a.trailer,
          image: a.image,
          class: "block"
        }, null, 8, ["count", "screening-count", "title", "alternate-title", "language", "year", "country", "language-info", "runtime", "tag-labels", "text", "trailer", "image"])),
        i !== t.items.length - 1 ? (h(), Z(pl, {
          key: 0,
          class: "divider"
        })) : E("", !0)
      ]))), 128))
    ]));
  }
}), Fde = { class: "section-spaces" }, zde = { class: "section-spaces-list" }, Ude = /* @__PURE__ */ Ae({
  __name: "SectionSpacesList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    nShown: {
      type: String,
      default: "4"
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", Fde, [
      n[0] || (n[0] = k("h3", {
        id: "spaces",
        class: "spaces-title"
      }, " Spaces ", -1)),
      Q(j2, {
        disable: t.items.length <= Number(t.nShown)
      }, {
        default: ce(() => [
          k("ul", zde, [
            (h(!0), b(me, null, Ee(t.items, (a, i) => (h(), Z(sO, {
              key: `BlockSpace${i}`,
              class: se([i >= Number(t.nShown) ? "show-hide-hideable" : null, "block"]),
              to: a.to,
              title: a.title,
              "is-online": a.isOnline,
              location: a.location,
              text: a.text,
              "button-text": a.buttonText,
              "button-url": a.buttonUrl
            }, null, 8, ["class", "to", "title", "is-online", "location", "text", "button-text", "button-url"]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["disable"])
    ]));
  }
}), xhe = /* @__PURE__ */ be(Ude, [["__scopeId", "data-v-41464f61"]]), Hde = { class: "section-staff-list" }, Yde = /* @__PURE__ */ Ae({
  __name: "SectionStaffList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", null, [
      k("ul", Hde, [
        (h(!0), b(me, null, Ee(t.items, (a) => (h(), Z(cP, {
          key: `ucla-staff-${a.to}`,
          image: a.image,
          to: a.to,
          "staff-name": a.staffName,
          "alternative-full-name": a.alternativeFullName,
          language: a.language,
          "job-title": a.jobTitle,
          locations: a.locations,
          email: a.email,
          phone: a.phone,
          departments: a.departments,
          consultation: a.consultation,
          class: "block-staff-list-item"
        }, null, 8, ["image", "to", "staff-name", "alternative-full-name", "language", "job-title", "locations", "email", "phone", "departments", "consultation"]))), 128))
      ])
    ]));
  }
}), The = /* @__PURE__ */ be(Yde, [["__scopeId", "data-v-7317bbb2"]]), jde = {
  width: "90",
  height: "32",
  viewBox: "0 0 90 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-video"
};
function Vde(t, e) {
  return h(), b("svg", jde, e[0] || (e[0] = [
    k("rect", {
      width: "90",
      height: "32",
      rx: "16",
      fill: "#115DAF"
    }, null, -1),
    k("path", {
      d: "M26.6279 14.3262L23.1663 11.9626C23.0794 11.9032 22.9784 11.8691 22.8741 11.8639C22.7697 11.8588 22.666 11.8827 22.5739 11.9332C22.4818 11.9837 22.4048 12.0589 22.3511 12.1507C22.2975 12.2425 22.2692 12.3475 22.2692 12.4545V17.1818C22.2692 17.2888 22.2975 17.3938 22.3511 17.4857C22.4048 17.5775 22.4818 17.6526 22.5739 17.7032C22.666 17.7537 22.7697 17.7776 22.8741 17.7724C22.9784 17.7672 23.0794 17.7331 23.1663 17.6737L26.6279 15.3101C26.707 15.2562 26.7719 15.183 26.8168 15.0972C26.8617 15.0114 26.8852 14.9155 26.8852 14.8182C26.8852 14.7208 26.8617 14.625 26.8168 14.5391C26.7719 14.4533 26.707 14.3802 26.6279 14.3262ZM23.4231 16.0776V13.5625L25.2678 14.8182L23.4231 16.0776ZM30.3462 9.5H17.6538C17.3478 9.5 17.0543 9.62451 16.838 9.84615C16.6216 10.0678 16.5 10.3684 16.5 10.6818V18.9545C16.5 19.268 16.6216 19.5686 16.838 19.7902C17.0543 20.0119 17.3478 20.1364 17.6538 20.1364H30.3462C30.6522 20.1364 30.9457 20.0119 31.162 19.7902C31.3784 19.5686 31.5 19.268 31.5 18.9545V10.6818C31.5 10.3684 31.3784 10.0678 31.162 9.84615C30.9457 9.62451 30.6522 9.5 30.3462 9.5ZM30.3462 18.9545H17.6538V10.6818H30.3462V18.9545ZM31.5 21.9091C31.5 22.0658 31.4392 22.2161 31.331 22.3269C31.2228 22.4377 31.0761 22.5 30.9231 22.5H17.0769C16.9239 22.5 16.7772 22.4377 16.669 22.3269C16.5608 22.2161 16.5 22.0658 16.5 21.9091C16.5 21.7524 16.5608 21.6021 16.669 21.4913C16.7772 21.3804 16.9239 21.3182 17.0769 21.3182H30.9231C31.0761 21.3182 31.2228 21.3804 31.331 21.4913C31.4392 21.6021 31.5 21.7524 31.5 21.9091Z",
      fill: "white"
    }, null, -1),
    k("path", {
      d: "M41.465 21L38.075 12.09H39.74L42.41 19.455L45.065 12.09H46.7L43.31 21H41.465ZM49.2794 21H47.7944V14.355H49.2794V21ZM48.5444 13.26C48.2844 13.26 48.0594 13.17 47.8694 12.99C47.6894 12.81 47.5994 12.59 47.5994 12.33C47.5994 12.07 47.6894 11.855 47.8694 11.685C48.0594 11.505 48.2844 11.415 48.5444 11.415C48.7944 11.415 49.0094 11.505 49.1894 11.685C49.3794 11.855 49.4744 12.07 49.4744 12.33C49.4744 12.59 49.3794 12.81 49.1894 12.99C49.0094 13.17 48.7944 13.26 48.5444 13.26ZM57.1747 20.865C56.7947 20.965 56.3847 21.035 55.9447 21.075C55.5147 21.125 55.0897 21.15 54.6697 21.15C54.0897 21.15 53.5647 21.075 53.0947 20.925C52.6247 20.775 52.2197 20.555 51.8797 20.265C51.5497 19.965 51.2897 19.6 51.0997 19.17C50.9197 18.74 50.8297 18.245 50.8297 17.685C50.8297 17.145 50.9197 16.66 51.0997 16.23C51.2797 15.8 51.5247 15.435 51.8347 15.135C52.1547 14.835 52.5297 14.605 52.9597 14.445C53.3997 14.285 53.8747 14.205 54.3847 14.205C54.6247 14.205 54.8647 14.23 55.1047 14.28C55.3447 14.32 55.5447 14.38 55.7047 14.46V10.8H57.1747V20.865ZM55.7047 15.765C55.3947 15.595 54.9847 15.51 54.4747 15.51C53.8447 15.51 53.3297 15.695 52.9297 16.065C52.5297 16.435 52.3297 16.965 52.3297 17.655C52.3297 18.375 52.5447 18.925 52.9747 19.305C53.4047 19.685 53.9797 19.875 54.6997 19.875C54.8497 19.875 55.0097 19.87 55.1797 19.86C55.3597 19.85 55.5347 19.835 55.7047 19.815V15.765ZM60.1652 18.015V18.045C60.1852 18.345 60.2602 18.61 60.3902 18.84C60.5202 19.06 60.6852 19.25 60.8852 19.41C61.0852 19.56 61.3052 19.675 61.5452 19.755C61.7952 19.835 62.0502 19.875 62.3102 19.875C62.7702 19.875 63.1752 19.825 63.5252 19.725C63.8752 19.615 64.2152 19.45 64.5452 19.23V20.535C64.2452 20.745 63.8852 20.9 63.4652 21C63.0552 21.1 62.6352 21.15 62.2052 21.15C61.6852 21.15 61.2102 21.07 60.7802 20.91C60.3602 20.75 59.9952 20.525 59.6852 20.235C59.3852 19.935 59.1502 19.575 58.9802 19.155C58.8102 18.735 58.7252 18.26 58.7252 17.73C58.7252 17.2 58.8052 16.72 58.9652 16.29C59.1352 15.85 59.3602 15.48 59.6402 15.18C59.9302 14.87 60.2702 14.63 60.6602 14.46C61.0502 14.29 61.4752 14.205 61.9352 14.205C62.4152 14.205 62.8352 14.28 63.1952 14.43C63.5552 14.58 63.8502 14.79 64.0802 15.06C64.3202 15.33 64.4952 15.655 64.6052 16.035C64.7252 16.405 64.7852 16.815 64.7852 17.265V18.015H60.1652ZM61.8902 15.45C61.4602 15.45 61.0952 15.59 60.7952 15.87C60.5052 16.15 60.3102 16.545 60.2102 17.055H63.3902C63.3702 16.535 63.2352 16.14 62.9852 15.87C62.7352 15.59 62.3702 15.45 61.8902 15.45ZM65.9469 17.685C65.9469 17.165 66.0319 16.695 66.2019 16.275C66.3719 15.845 66.6069 15.48 66.9069 15.18C67.2169 14.87 67.5769 14.63 67.9869 14.46C68.4069 14.29 68.8669 14.205 69.3669 14.205C69.8669 14.205 70.3269 14.29 70.7469 14.46C71.1669 14.63 71.5269 14.87 71.8269 15.18C72.1369 15.48 72.3769 15.845 72.5469 16.275C72.7169 16.695 72.8019 17.165 72.8019 17.685C72.8019 18.195 72.7169 18.665 72.5469 19.095C72.3769 19.515 72.1369 19.88 71.8269 20.19C71.5269 20.49 71.1669 20.725 70.7469 20.895C70.3269 21.065 69.8669 21.15 69.3669 21.15C68.8669 21.15 68.4069 21.065 67.9869 20.895C67.5769 20.725 67.2169 20.49 66.9069 20.19C66.6069 19.88 66.3719 19.515 66.2019 19.095C66.0319 18.665 65.9469 18.195 65.9469 17.685ZM71.3019 17.685C71.3019 17.005 71.1219 16.47 70.7619 16.08C70.4019 15.68 69.9369 15.48 69.3669 15.48C68.8069 15.48 68.3469 15.68 67.9869 16.08C67.6269 16.47 67.4469 17.005 67.4469 17.685C67.4469 18.355 67.6269 18.89 67.9869 19.29C68.3469 19.68 68.8069 19.875 69.3669 19.875C69.9369 19.875 70.4019 19.68 70.7619 19.29C71.1219 18.89 71.3019 18.355 71.3019 17.685Z",
      fill: "white"
    }, null, -1)
  ]));
}
const qde = { render: Vde }, Wde = ["data-header"], Gde = /* @__PURE__ */ Ae({
  __name: "SectionTeaserCard",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    sectionTitle: {
      type: String,
      required: !1
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["section-teaser-card", (e == null ? void 0 : e.value) || ""]), a = I(() => t.items[0].sectionHandle === "ftvaItemInCollection" ? 75 : 60), i = I(() => (e == null ? void 0 : e.value) || "");
    return (r, s) => (h(), b("ul", {
      class: se(n.value),
      "data-header": t.sectionTitle ? t.sectionTitle : null
    }, [
      (h(!0), b(me, null, Ee(t.items, (o, l) => (h(), Z(Yh, {
        key: `Card${l}`,
        image: o.image,
        to: o.to,
        category: o.category,
        title: o.title,
        "alternative-full-name": o.alternativeFullName,
        language: o.language,
        "start-date": o.startDate,
        "end-date": o.endDate,
        text: o.text,
        "image-aspect-ratio": a.value,
        "is-vertical": !0,
        "byline-one": o.bylineOne,
        "byline-two": o.bylineTwo,
        "section-handle": o.sectionHandle,
        ongoing: o.ongoing,
        "date-created": i.value === "ftva" ? o.postDate : "",
        class: "card"
      }, rn({ _: 2 }, [
        o.videoEmbed && o.videoEmbed !== null ? {
          name: "toptext",
          fn: ce(() => [
            Q(Ks, null, {
              default: ce(() => [
                Q(O(qde), { class: "white-icon" })
              ]),
              _: 1
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["image", "to", "category", "title", "alternative-full-name", "language", "start-date", "end-date", "text", "image-aspect-ratio", "byline-one", "byline-two", "section-handle", "ongoing", "date-created"]))), 128))
    ], 10, Wde));
  }
}), whe = /* @__PURE__ */ be(Gde, [["__scopeId", "data-v-6eb2c122"]]), Xde = { class: "section-teaser-highlight" }, Zde = /* @__PURE__ */ Ae({
  __name: "SectionTeaserHighlight",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    return (e, n) => (h(), b("ul", Xde, [
      (h(!0), b(me, null, Ee(t.items, (a) => (h(), Z(Y2, {
        key: a.to,
        image: a.image,
        to: a.to,
        category: a.category,
        title: a.title,
        "start-date": a.startDate,
        "end-date": a.endDate,
        text: a.text,
        locations: a.locations,
        "alternative-full-name": a.alternativeFullName,
        language: a.language,
        "section-handle": a.sectionHandle,
        "byline-one": a.bylineOne,
        "byline-two": a.bylineTwo,
        "has-triangle": !0,
        "is-vertical": !0,
        ongoing: a.ongoing,
        class: "block"
      }, null, 8, ["image", "to", "category", "title", "start-date", "end-date", "text", "locations", "alternative-full-name", "language", "section-handle", "byline-one", "byline-two", "ongoing"]))), 128))
    ]));
  }
}), khe = /* @__PURE__ */ be(Zde, [["__scopeId", "data-v-9b37a033"]]), Kde = { class: "list" }, Qde = /* @__PURE__ */ Ae({
  __name: "SectionTeaserList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    nShown: {
      type: Number,
      default: 3
    },
    // TO SWITCH BETWEEN
    // BlockCardThreeColumn OR BlockClippedDate
    componentName: {
      type: String,
      default: "BlockClippedDate"
    }
  },
  setup(t) {
    const e = Ge(), n = ge(
      () => Promise.resolve().then(() => FA)
    ), a = I(() => t.componentName === "BlockCardThreeColumn" ? n : CD), i = I(() => t.items.length <= t.nShown || (e == null ? void 0 : e.value) === "ftva" && t.componentName !== "BlockClippedDate"), r = I(() => ["section-teaser-list", (e == null ? void 0 : e.value) || ""]);
    return (s, o) => (h(), b("section", {
      class: se(r.value)
    }, [
      Q(j2, { disable: i.value }, {
        default: ce(() => [
          k("ul", Kde, [
            (h(!0), b(me, null, Ee(t.items, (l, c) => (h(), Z(ut(a.value), {
              key: c,
              class: se([c >= t.nShown ? "show-hide-hideable" : null, "list-item block"]),
              image: l.image,
              to: l.to,
              category: l.category,
              title: l.title,
              "start-date": l.startDate,
              "end-date": l.endDate,
              text: l.text,
              locations: l.locations,
              "section-handle": l.sectionHandle,
              ongoing: l.ongoing,
              "tag-labels": l.tagLabels
            }, null, 8, ["class", "image", "to", "category", "title", "start-date", "end-date", "text", "locations", "section-handle", "ongoing", "tag-labels"]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["disable"])
    ], 2));
  }
}), She = /* @__PURE__ */ be(Qde, [["__scopeId", "data-v-e2a20a34"]]), Jde = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-alert"
};
function Dx(t, e) {
  return h(), b("svg", Jde, e[0] || (e[0] = [
    k("path", {
      d: "M16 25C20.9706 25 25 20.9706 25 16C25 11.0294 20.9706 7 16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25Z",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M16 12V17",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "square",
      "stroke-linejoin": "bevel",
      class: "svg__stroke--primary-blue-03"
    }, null, -1),
    k("path", {
      d: "M16 20H16.01",
      stroke: "#0B6AB7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "svg__stroke--primary-blue-03"
    }, null, -1)
  ]));
}
const Ix = { render: Dx }, e0e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ix,
  render: Dx
}, Symbol.toStringTag, { value: "Module" })), t0e = {
  name: "SiteNotificationAlert",
  components: {
    ButtonLink: cn,
    RichText: un,
    SvgAlertCircle: Ix
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    time: {
      type: Number,
      default: 13500
    }
  },
  data() {
    return {
      isOpened: !0
    };
  },
  computed: {
    classes() {
      return [
        "site-notification-alert",
        this.isOpened ? "is-opened" : "is-closed"
      ];
    }
  },
  mounted() {
    this.delayedClose();
  },
  methods: {
    toggleAlert() {
      this.isOpened = !this.isOpened;
    },
    delayedClose() {
      setTimeout(() => {
        this.isOpened = !1;
      }, this.time);
    }
  }
}, n0e = { class: "alert-box-icon" }, a0e = ["innerHTML"], i0e = { class: "message" };
function r0e(t, e, n, a, i, r) {
  const s = ot("SvgAlertCircle"), o = ot("RichText"), l = ot("ButtonLink");
  return h(), b("section", {
    class: se(r.classes),
    role: "alert"
  }, [
    k("button", {
      class: "alert",
      onClick: e[0] || (e[0] = (c) => r.toggleAlert())
    }, [
      k("div", n0e, [
        Q(s, { class: "svg-alert-circle" })
      ]),
      k("div", {
        class: "alert-text",
        innerHTML: n.title
      }, null, 8, a0e)
    ]),
    k("div", i0e, [
      n.text ? (h(), Z(o, {
        key: 0,
        class: "message-text",
        "rich-text-content": n.text
      }, null, 8, ["rich-text-content"])) : E("", !0),
      Q(l, {
        class: "button-dismiss",
        label: "Dismiss",
        "icon-name": "icon-close",
        "is-quaternary": "",
        onClick: r.toggleAlert
      }, null, 8, ["onClick"])
    ])
  ], 2);
}
const Che = /* @__PURE__ */ be(t0e, [["render", r0e], ["__scopeId", "data-v-e71e447b"]]), s0e = { class: "story-with-image" }, o0e = {
  key: 0,
  class: "image-block"
}, l0e = ["textContent"], c0e = { class: "meta" }, u0e = {
  key: 0,
  class: "title"
}, d0e = ["innerHTML"], h0e = ["innerHTML"], f0e = { class: "calltoaction" }, p0e = { key: 0 }, m0e = 60, g0e = /* @__PURE__ */ Ae({
  __name: "StoryWithImage",
  props: {
    image: {
      type: Object,
      default: () => {
      }
    },
    caption: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    footnote: {
      type: String,
      default: ""
    },
    calltoaction: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, n) => (h(), b("div", s0e, [
      t.image ? (h(), b("div", o0e, [
        Q(dn, {
          class: "image",
          media: t.image,
          "aspect-ratio": m0e
        }, {
          default: ce(() => n[0] || (n[0] = [
            k("div", { class: "gradient" }, null, -1)
          ])),
          _: 1
        }, 8, ["media"]),
        t.caption ? (h(), b("div", {
          key: 0,
          class: "caption",
          textContent: ae(t.caption)
        }, null, 8, l0e)) : E("", !0),
        k("div", c0e, [
          t.title ? (h(), b("h2", u0e, ae(t.title), 1)) : E("", !0),
          t.text ? (h(), b("div", {
            key: 1,
            class: "text",
            innerHTML: t.text
          }, null, 8, d0e)) : E("", !0),
          Q(eh, { class: "divider-general" }),
          t.footnote ? (h(), b("div", {
            key: 2,
            class: "footnote",
            innerHTML: t.footnote
          }, null, 8, h0e)) : E("", !0),
          Q(eh, { class: "divider-general" }),
          k("div", f0e, [
            t.calltoaction ? (h(), b("span", p0e, ae(t.calltoaction), 1)) : E("", !0),
            Q(O(qu), { class: "svg" })
          ])
        ])
      ])) : E("", !0)
    ]));
  }
}), Ahe = /* @__PURE__ */ be(g0e, [["__scopeId", "data-v-f3974e51"]]), b0e = ["textContent"], v0e = {
  __name: "TabItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = wn("activeTabTitle"), n = Ge(), a = I(() => ["tab-item", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => kt((h(), b("div", {
      class: se(a.value)
    }, [
      k("div", {
        textContent: ae(t.content)
      }, null, 8, b0e),
      xe(i.$slots, "default", {}, void 0, !0)
    ], 2)), [
      [ga, t.title === O(e)]
    ]);
  }
}, Ehe = /* @__PURE__ */ be(v0e, [["__scopeId", "data-v-786a4c59"]]), y0e = /* @__PURE__ */ Ae({
  __name: "TableComponent",
  props: {
    // Tableheaders will be used to infer the number of columns
    // Therefore, if you do not want header text in a column, pass an empty string instead
    tableHeaders: {
      type: Array,
      default: () => [""]
    },
    tableCaption: {
      type: String,
      default: "Table data"
    },
    // if a theme needs more than 1 style for tables,
    // use color-scheme prop to specify further
    colorScheme: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = Ge(), n = I(() => ["table-component", (e == null ? void 0 : e.value) || "", t.colorScheme]);
    return (a, i) => (h(), b("table", {
      class: se(n.value)
    }, [
      k("caption", null, ae(t.tableCaption), 1),
      k("thead", null, [
        k("tr", null, [
          (h(!0), b(me, null, Ee(t.tableHeaders, (r, s) => (h(), b("th", { key: s }, ae(r), 1))), 128))
        ])
      ]),
      k("tbody", null, [
        xe(a.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), Lhe = /* @__PURE__ */ be(y0e, [["__scopeId", "data-v-4657c34b"]]), _0e = /* @__PURE__ */ Ae({
  __name: "TableRow",
  props: {
    // The number of columns to create for data
    // Each column has the structure:
    // <td class="column-#"><slot name="column#" /></td>
    numCells: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    const e = t, n = Ge(), a = I(() => ["table-row", (n == null ? void 0 : n.value) || ""]);
    return (i, r) => (h(), b("tr", {
      class: se(a.value)
    }, [
      e.numCells !== 0 ? (h(!0), b(me, { key: 0 }, Ee(e.numCells, (s) => (h(), b("td", {
        key: s,
        class: se(`column-${s}`)
      }, [
        xe(i.$slots, `column${s}`, {}, void 0, !0)
      ], 2))), 128)) : E("", !0)
    ], 2));
  }
}), Dhe = /* @__PURE__ */ be(_0e, [["__scopeId", "data-v-4e8ecb6c"]]), x0e = {
  key: 0,
  class: "filters"
}, T0e = {
  class: "tab-list-header",
  role: "tablist"
}, w0e = ["id", "tabindex", "aria-controls", "aria-selected", "onClick"], k0e = ["id", "aria-labelledby", "hidden"], S0e = /* @__PURE__ */ Ae({
  __name: "TabList",
  props: {
    alignment: {
      type: String,
      default: "left"
    },
    initialTab: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    var B, P, z;
    const e = ge(
      () => Promise.resolve().then(() => Mp)
    ), n = ge(
      () => Promise.resolve().then(() => Lx)
    ), i = ((P = (B = nr()) == null ? void 0 : B.default) == null ? void 0 : P.call(B)).map((W) => W.props), r = J(i), s = J([]), o = J(0), l = J((z = r.value[0]) == null ? void 0 : z.title), c = J(), d = $a(), f = Ru();
    ma("activeTabTitle", l);
    const g = {
      "icon-calendar": {
        icon: e,
        label: "Calendar"
      },
      "icon-list": {
        icon: n,
        label: "List"
      }
    };
    ht(() => {
      var ie, K;
      const W = d.query.view, q = r.value.findIndex(
        ($) => ($ == null ? void 0 : $.title.toLowerCase()) === W
      );
      q !== -1 ? (o.value = q, l.value = (ie = r.value[q]) == null ? void 0 : ie.title) : (o.value = t.initialTab, l.value = (K = r.value[t.initialTab]) == null ? void 0 : K.title);
      const V = s.value[o.value];
      D(V, !1);
      const { width: re } = Ei();
      at(re, ($) => {
        const X = s.value[o.value];
        D(X, !0);
      });
    });
    const _ = I(() => `panel-${M(l.value)}`), x = Ge(), p = I(() => ["tab-list", (x == null ? void 0 : x.value) || ""]);
    function w(W) {
      return `tab-${M(W)}`;
    }
    function C(W) {
      return `panel-${M(W)}`;
    }
    function M(W) {
      return W.toLowerCase().replace(/\s/g, "-");
    }
    function A(W) {
      const q = r.value.map((ie) => ie == null ? void 0 : ie.title), V = q.indexOf(l.value);
      let re;
      switch (W.key) {
        case "ArrowLeft":
          V - 1 < 0 ? re = q[q.length - 1] : re = q[V - 1], L(re);
          break;
        case "ArrowRight":
          V + 1 > q.length - 1 ? re = q[0] : re = q[V + 1], L(re);
          break;
      }
    }
    function L(W) {
      const q = r.value.findIndex((re) => (re == null ? void 0 : re.title) === W);
      l.value = W, o.value = q, f.push({
        query: {
          ...d.query,
          view: W.split(" ")[0].toLowerCase(),
          page: 1
        }
      });
      const V = s.value[q];
      V && V.focus(), V.classList.contains("active") || D(V, !0);
    }
    function D(W, q) {
      const V = c.value, re = W.getBoundingClientRect();
      V.style.height = `${re.height}px`, q ? (V.style.width = `${re.width}px`, W.style.background = "none") : V.style.width = "0", V.style.setProperty("--move_glider", `${W.offsetLeft}px`);
    }
    return (W, q) => (h(), b(me, null, [
      k("div", $t({
        class: [p.value, t.alignment],
        role: "tabs"
      }, W.$attrs), [
        W.$slots.filters ? (h(), b("div", x0e, [
          xe(W.$slots, "filters", {}, void 0, !0)
        ])) : E("", !0),
        k("div", T0e, [
          k("span", {
            ref_key: "tabGliderRef",
            ref: c,
            class: "tab-glider"
          }, null, 512),
          (h(!0), b(me, null, Ee(r.value, (V, re) => (h(), b("button", {
            id: w(V == null ? void 0 : V.title),
            ref_for: !0,
            ref: (ie) => s.value[re] = ie,
            key: V == null ? void 0 : V.title,
            class: se(["tab-list-item", { active: l.value === (V == null ? void 0 : V.title) }]),
            role: "tab",
            tabindex: l.value === (V == null ? void 0 : V.title) ? 0 : -1,
            "aria-controls": C(V == null ? void 0 : V.title),
            "aria-selected": l.value === (V == null ? void 0 : V.title),
            onKeydown: A,
            onClick: (ie) => L(V == null ? void 0 : V.title)
          }, [
            V != null && V.icon ? (h(), Z(ut(g[V.icon].icon), {
              key: 0,
              class: "svg",
              "aria-hidden": "true"
            })) : E("", !0),
            Ye(" " + ae(V == null ? void 0 : V.title), 1)
          ], 42, w0e))), 128))
        ])
      ], 16),
      k("div", {
        id: _.value,
        class: "tab-list-body",
        role: "tabpanel",
        "aria-labelledby": _.value,
        hidden: !l.value
      }, [
        xe(W.$slots, "default", {}, void 0, !0)
      ], 8, k0e)
    ], 64));
  }
}), Ihe = /* @__PURE__ */ be(S0e, [["__scopeId", "data-v-0e3d7ee5"]]), C0e = { class: "two-column" }, A0e = {
  key: 0,
  class: "sidebar-mobile-top"
}, E0e = {
  key: 1,
  class: "sidebar-mobile-bottom"
}, L0e = { class: "sidebar-column" }, D0e = /* @__PURE__ */ Ae({
  __name: "TwoColLayoutWStickySideBar",
  setup(t) {
    const e = J(!1), n = J(null), a = J(null);
    function i() {
      a.value.style.minHeight = `${n.value.clientHeight + 125}px`;
    }
    return ht(() => {
      const { width: r } = Ei();
      at([r, n], ([s]) => {
        e.value = s <= 899, e.value === !0 ? a.value.style.minHeight = "auto" : i();
      }, { immediate: !0 });
    }), (r, s) => (h(), b("div", C0e, [
      k("div", {
        ref_key: "primaryCol",
        ref: a,
        class: "primary-column top"
      }, [
        Q(sl, { class: "primary-section-wrapper" }, {
          default: ce(() => [
            xe(r.$slots, "primaryTop", {}, void 0, !0),
            e.value ? (h(), b("div", A0e, [
              xe(r.$slots, "sidebarTop", {}, void 0, !0)
            ])) : E("", !0),
            xe(r.$slots, "primaryMid", {}, void 0, !0),
            e.value ? (h(), b("div", E0e, [
              xe(r.$slots, "sidebarBottom", {}, void 0, !0)
            ])) : E("", !0),
            xe(r.$slots, "primaryBottom", {}, void 0, !0)
          ]),
          _: 3
        })
      ], 512),
      k("div", L0e, [
        k("div", {
          ref_key: "sidebar",
          ref: n,
          class: "sidebar-content-wrapper"
        }, [
          e.value ? E("", !0) : xe(r.$slots, "sidebarTop", { key: 0 }, void 0, !0),
          e.value ? E("", !0) : xe(r.$slots, "sidebarBottom", { key: 1 }, void 0, !0)
        ], 512)
      ])
    ]));
  }
}), Mhe = /* @__PURE__ */ be(D0e, [["__scopeId", "data-v-bdefca4a"]]);
export {
  R0e as AlphabeticalBrowseBy,
  Mm as BannerFeatured,
  N0e as BannerHeader,
  $0e as BannerText,
  F0e as BaseCalendar,
  Fm as BaseCheckboxGroup,
  QC as BaseRadioGroup,
  z0e as BlockAmenities,
  qh as BlockCallToAction,
  H0e as BlockCallToActionTwoUp,
  U0e as BlockCampusMap,
  $A as BlockCardThreeColumn,
  bD as BlockCardWithIllustration,
  Yh as BlockCardWithImage,
  CD as BlockClippedDate,
  Y0e as BlockDate,
  HD as BlockEvent,
  r6 as BlockEventDetail,
  Y2 as BlockFloatingHighlight,
  Uh as BlockForm,
  aI as BlockGenericList,
  j0e as BlockHours,
  hI as BlockInfo,
  kI as BlockLocationListItem,
  UI as BlockMediaWithText,
  WI as BlockPostSmall,
  XI as BlockRemoveSearchFilter,
  xM as BlockScreeningDetail,
  j2 as BlockShowHide,
  QM as BlockSimpleCard,
  sO as BlockSpaces,
  uO as BlockSponsor,
  kO as BlockStaffArticleList,
  V0e as BlockStaffDetail,
  cP as BlockStaffList,
  Ks as BlockTag,
  q0e as ButtonDropdown,
  MM as ButtonHide,
  cn as ButtonLink,
  tf as ButtonMore,
  UM as ButtonShow,
  $u as CardMeta,
  G0e as DateFilter,
  X0e as DefinitionList,
  eh as DividerGeneral,
  pl as DividerWayFinder,
  Z0e as FiltersDropdown,
  LH as FlexibleAssociatedTopicCards,
  OH as FlexibleBannerFeatured,
  K0e as FlexibleBlocks,
  Q0e as FlexibleCallToAction,
  RZ as FlexibleCardWithImage,
  jZ as FlexibleForm,
  oK as FlexibleGridGalleryCards,
  mK as FlexibleHighlight,
  J0e as FlexibleHorizontalDivider,
  EK as FlexibleImpactNumberCards,
  rQ as FlexibleImpactNumbersCarousel,
  uQ as FlexibleInfo,
  Pse as FlexibleMediaGallery,
  ase as FlexibleMediaGalleryBannerImage,
  bx as FlexibleMediaGalleryNewLightbox,
  Ase as FlexibleMediaGalleryThumbnailCard,
  Hse as FlexibleMediaWithText,
  Gse as FlexiblePullQuote,
  Jse as FlexibleRichText,
  ehe as FlexibleSimpleCards,
  Goe as FooterLinks,
  the as FooterMain,
  Foe as FooterPrimary,
  joe as FooterSock,
  doe as FooterSponsor,
  tK as GridGallery,
  Gb as HeaderMain,
  nce as HeaderMainResponsive,
  ahe as HeaderSmart,
  ihe as HeaderSticky,
  nhe as HeadingArrow,
  en as IconWithLink,
  TK as ImpactNumberCard,
  JK as ImpactNumbersCarousel,
  rhe as ImpactRichText,
  she as MastheadPrimary,
  ohe as MastheadSecondary,
  Vre as MediaBadge,
  Ed as MediaItem,
  lhe as NavBreadcrumb,
  ule as NavMenuItem,
  zle as NavMenuItemResponsive,
  _x as NavPrimary,
  xx as NavSecondary,
  che as PageAnchor,
  Vc as PullQuote,
  dn as ResponsiveImage,
  zh as ResponsiveVideo,
  un as RichText,
  Due as ScrollWrapper,
  uhe as SearchGeneric,
  zue as SearchGenericFilterButtons,
  que as SearchGenericFilters,
  dhe as SearchGenericViewModes,
  Gce as SearchHome,
  Dp as SearchInput,
  hhe as SearchResult,
  AH as SectionCardsWithIllustrations,
  fhe as SectionDualMasonry,
  phe as SectionGenericList,
  Mf as SectionHeader,
  mhe as SectionLocationList,
  ghe as SectionPagination,
  bhe as SectionPostSmall,
  Yue as SectionRemoveSearchFilter,
  _he as SectionScreeningDetails,
  xhe as SectionSpacesList,
  vhe as SectionStaffArticleList,
  The as SectionStaffList,
  yhe as SectionStaffOrcidPublications,
  whe as SectionTeaserCard,
  khe as SectionTeaserHighlight,
  She as SectionTeaserList,
  sl as SectionWrapper,
  soe as SimpleCards,
  Pue as SingleCheckbox,
  uce as SiteBrandBar,
  Che as SiteNotificationAlert,
  Ke as SmartLink,
  Ahe as StoryWithImage,
  Ehe as TabItem,
  Ihe as TabList,
  Lhe as TableComponent,
  Dhe as TableRow,
  Mhe as TwoColLayoutWStickySideBar,
  iM as VideoEmbed
};
